/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
__webpack_require__(2);
__webpack_require__(3);
__webpack_require__(4);
__webpack_require__(5);
__webpack_require__(6);
__webpack_require__(7);
__webpack_require__(8);
__webpack_require__(9);
__webpack_require__(10);
__webpack_require__(11);
__webpack_require__(12);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(15);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(24);
__webpack_require__(25);
__webpack_require__(26);
__webpack_require__(27);
__webpack_require__(28);
__webpack_require__(29);
__webpack_require__(30);
__webpack_require__(31);
__webpack_require__(32);
__webpack_require__(33);
__webpack_require__(34);
__webpack_require__(35);
__webpack_require__(36);
__webpack_require__(37);
__webpack_require__(38);
__webpack_require__(39);
__webpack_require__(40);
__webpack_require__(41);
__webpack_require__(42);
__webpack_require__(43);
__webpack_require__(44);
__webpack_require__(45);
__webpack_require__(46);
__webpack_require__(47);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(50);
__webpack_require__(51);
__webpack_require__(52);
__webpack_require__(53);
__webpack_require__(54);
__webpack_require__(55);
__webpack_require__(56);
__webpack_require__(57);
__webpack_require__(58);
__webpack_require__(59);
__webpack_require__(60);
__webpack_require__(61);
__webpack_require__(62);
__webpack_require__(63);
__webpack_require__(64);
__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(67);
__webpack_require__(68);
__webpack_require__(69);
__webpack_require__(70);
__webpack_require__(71);
__webpack_require__(72);
__webpack_require__(73);
__webpack_require__(74);
__webpack_require__(75);
__webpack_require__(76);
__webpack_require__(77);
__webpack_require__(78);
__webpack_require__(79);
__webpack_require__(80);
__webpack_require__(81);
__webpack_require__(82);
__webpack_require__(83);
__webpack_require__(84);
__webpack_require__(85);
__webpack_require__(86);
__webpack_require__(87);
__webpack_require__(88);
__webpack_require__(89);
__webpack_require__(90);
__webpack_require__(91);
__webpack_require__(92);
__webpack_require__(93);
__webpack_require__(94);
__webpack_require__(95);
__webpack_require__(96);
__webpack_require__(97);
__webpack_require__(98);
__webpack_require__(99);
__webpack_require__(100);
__webpack_require__(101);
__webpack_require__(102);
__webpack_require__(103);
__webpack_require__(104);
__webpack_require__(105);
__webpack_require__(106);
__webpack_require__(107);
__webpack_require__(108);
__webpack_require__(109);
__webpack_require__(110);
__webpack_require__(111);
__webpack_require__(112);
__webpack_require__(113);
__webpack_require__(114);
__webpack_require__(115);
__webpack_require__(116);
__webpack_require__(117);
__webpack_require__(118);
__webpack_require__(119);
__webpack_require__(120);
__webpack_require__(121);
__webpack_require__(122);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(128);
__webpack_require__(129);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(132);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(138);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(144);
__webpack_require__(145);
__webpack_require__(146);
__webpack_require__(147);
__webpack_require__(148);
__webpack_require__(149);
__webpack_require__(150);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
module.exports = __webpack_require__(253);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Joshalytics = ( function()
{
    "use strict";

    Joshalytics.Type = Object.freeze
    ({
        ANALYTICS : "ANAL",
        KEY_PRESS : "KEY",
        SCREEN    : "SCREEN"
    });

    var socket, onClose, onError, onMessage, onOpen;

    /**
     * Constructor
     * @memberof Joshalytics
     * @param   {Object}    params
     * @param   {String}    params.server     - target server
     * @param   {Function} [params.onClose  ] - function to be called if the socket closes
     * @param   {Function} [params.onError  ] - function to be called when an error occurs
     * @param   {Function} [params.onMessage] - function to be called when a message is received
     * @param   {Function} [params.onOpen   ] - function to be called when the socket is opened
     * @returns {Joshalytics}
     */
    function Joshalytics( params )
    {
        onClose   = params.onClose;
        onError   = params.onError;
        onMessage = params.onMessage;
        onOpen    = params.onOpen;

        socket = new WebSocket( params.server );

        socket.onclose = function( event )
        {
            if( onClose )
                onClose( event );
        };

        socket.onerror = function( event )
        {
            console.error( event );

            if( onError )
                onError( event );
        };

        socket.onmessage = function( event )
        {
            console.log( event );

            if( onMessage )
                onMessage( JSON.parse( event.data ) );
        };

        socket.onopen = function( event )
        {
            if( onOpen )
                onOpen( event );
        };
    }

    Joshalytics.prototype.close = function()
    {
        if( socket.readyState === WebSocket.OPEN )
            socket.close();
    };

    Joshalytics.prototype.send = function( type, data )
    {
        if( socket.readyState === WebSocket.OPEN )
            socket.send( JSON.stringify( { type:type, data:data } ) );
    };

    return Joshalytics;

})();


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



window.Cima = (function()
{
    function Cima( onHasSession, onNeedsCredentials )
    {
        this._onNeedsCredentials = onNeedsCredentials;

        var token = Host.getLocalStorage( "cimaToken" );

        if( token )
        {
            _x2._config._token = token;
            _x2._config._tokenType =  'cima-token';
            onHasSession();
        }
        else
            setTimeout( function() { onNeedsCredentials(); }, 1 );
    }

    Cima.prototype.logout = function()
    {
        _x2._config._host.removeLocalStorage( "cimaToken" );
        _x2._config._token = undefined;
    };

    Cima.prototype.sendCredentials = function( username, password, onSuccess, onError )
    {
        var params = {
            type     : "GET",
            url      : _x2._config._authEndpoint,
            headers  : [{ name: "Authorization", value: "Basic " + btoa( username + ":" + password ) }]
        };

        var success = function ( response ) {

            var data = JSON.parse( response.data );
            console.log( data );

            var status, statusSummary, token;
            var xs    = new XMLSerializer();
            var s     = xs.serializeToString(data);
            var parse = function( entry )
            {
                switch( entry.attr( "key" ) )
                {
                    case "client:authnToken":
                        token = btoa( s );
                        break;

                    case "message:status":
                        status = entry.text();
                        break;

                    case "message:statusSummary":
                        statusSummary = entry.text();
                        break;
                }
            };

            //NOTE: this is now the only use of jQuery in coamX2, since we've stopped using $.ajax.
            $(s).find('attribute').each( function(){ parse( $(this) ); } );

            if( status == "0" ) //TODO: status is never set (assume undefined == 0 evals to true?)
            {
                console.log( token );

                _x2._config._host.setLocalStorage( "cimaToken", token );
                _x2._config._token = token;
                _x2._config._tokenType =  'cima-token';

                if( onSuccess )
                    onSuccess( token );
            }
            else
            {
                console.error( "ERROR -> status = " + status + ", " + statusSummary );
                onError( status, statusSummary );
            }
        };

        var error = function (error) {
            console.log( "CIMA object error: ", error );
            onError();
        };

        _x2._network.ajax( params ).then( success ).catch( error );
    };

    return Cima;

})();


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2013 Comcast Corporation, All Rights Reserved



window.CiscoSaml = (function()
{
    function CiscoSaml( onHasSession, onNeedsCredentials )
    {
        this._onNeedsCredentials = onNeedsCredentials;

        var token = Host.getLocalStorage( "coxSaml" );

        if( token )
        {
            _x2._config._token = token;
            _x2._config._tokenType = "cisco-saml";
            onHasSession();
        }
        else
            setTimeout( function() { onNeedsCredentials(); }, 1 );
    }

    CiscoSaml.prototype.logout = function()
    {
        _x2._config._host.removeLocalStorage( "coxSaml" );
        _x2._config._token = undefined;
    };

    CiscoSaml.prototype.sendCredentials = function( username, password, onSuccess, onError )
    {
        var params = {
            type     : "GET",
            url      : _x2._config._authEndpoint,
            headers  : [{ name: "Authorization", value: "Basic " + btoa( username + ":" + password ) }]
        };

        var success = function( response )
        {
            var data = JSON.parse( response.data );
            console.log( data );

            var token = data.samlResponse;

            _x2._config._host.setLocalStorage( "coxSaml", token );
            _x2._config._token = token;
            _x2._config._tokenType = "cisco-saml";

            onSuccess();
        };

        var error = function( e ) {
            console.log( "Cisco SAML object error: ", e);
            onError();
        };

        _x2._network.ajax( params ).then( success ).catch( error );
    };

    return CiscoSaml;

})();


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.Oauth = (function()
{
    "use strict";

    var cid  = "xfinity-partner-program";
    var sec  = "fb4f234a3ddd437d6f3800533ecf01679b426061";
//    var root = "https://login.comcast.net";
    var root = "https://login-st.comcast.net";
    var deviceCode;

    function Oauth( onHasSession, onNeedsCredentials )
    {
        _x2._config.debugAddClass( Config.CLASS_OAUTH, 9 );

        var token = Host.getLocalStorage( "OauthToken" ), self = this;

        _x2._config.log( Config.CLASS_OAUTH, 5 ) ?  console.log( token ) : Config.NOP();

        if( !token )
            this.getAuthCode( onNeedsCredentials );
        else
            onHasSession();
    }

    Oauth.prototype.getAuthCode = function( onNeedsCredentials )
    {
        var params = {}, success, error, self = this;

        params.type = "POST";
        params.url  = root + "/oauth/device/code?response_type=device_code&client_id=" + cid;

        error = function( e )
        {
            console.log( e.toString() );
        };

        success = function( response )
        {
            console.log( ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> SUCCESS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<" );
            console.log( response.data );

            var parsed = JSON.parse( response.data );
            var obj    = {};

            console.log( parsed );

            self._interval = parsed.interval;

            deviceCode = parsed.device_code;

            console.log( "USER URL  = " + parsed.verification_uri );
            console.log( "USER CODE = " + parsed.user_code        );

            obj.url            = parsed.verification_uri;
            obj.code           = parsed.user_code;
            obj.pollFunc       = function( onSuccess, onError ) { self.pollForToken( onSuccess, onError ); };
            obj.getNewCodeFunc = function( func ) { self.getNewCode( func ); };

            setTimeout( function() { onNeedsCredentials( obj ); }, 1 );
        };

        _x2._network.ajax( params ).then( success ).catch( error );

    };

    Oauth.prototype.logout = function()
    {
        _x2._config._host.removeAllTokenLocalStorage();
        _x2._config._token = undefined;
    };

    Oauth.prototype.pollForToken = function( onSuccess, onError )
    {
        var params = {}, error, success, self = this;

        params.type      = "POST";
        params.url       = root + "/oauth/token?grant_type=device_code&code=" + deviceCode + "&client_id=" + cid + "&client_secret=" + sec;

        error = function( e )
        {
            var errStr;

            self._delay = undefined;

            errStr = e.getError() ? e.getError() : e.getHttpStatusText();
            console.log( e.toString() );

            switch( errStr )
            {
                case "authorization_pending":
                    self._delay = setTimeout( function() { _x2._network.ajax( params ).then( success ).catch( error ); }, self._interval * 1000 );
                    break;

                case "invalid_grant":
                    if( onError )
                        onError();
                    break;

                case "abort":
                    break;

                default:
                    console.log( "ERROR -> unknown response to oauth poll = " + errStr );
                    console.log( e );
                    break;
            }
        };

        success = function( response )
        {
            console.log( response.data );

            self._delay = undefined;

            if( response.data )
                _x2._config._host.setLocalStorage( "OauthToken", response.data );

            if( onSuccess )
                onSuccess();
        };

        _x2._network.ajax( params ).then( success ).catch( error );
    };

    Oauth.prototype.getNewCode = function( onNeedsCredentials )
    {
        if( this._delay )
        {
            clearTimeout( this._delay );
            this._delay = undefined;
        }

        this.getAuthCode( onNeedsCredentials );
    };

    Oauth.prototype.sendCredentials = function( username, password, onSuccess, onError )
    {
    };

    return Oauth;

})();


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.XtvAuth = (function()
{
    "use strict";

    function XtvAuth( onHasSession, onNeedsCredentials )
    {
        _x2._config.debugAddClass( Config.CLASS_XTV_AUTH, 1 );

        var tokenAuth = Host.getLocalStorage( "XtvAuthToken" );
        var tokenXsct = Host.getLocalStorage( "XsctToken"    );

        _x2._config.log( Config.CLASS_XTV_AUTH, 9 ) ?  console.log( tokenAuth ) : Config.NOP();

        if( !tokenAuth || !tokenXsct )
            this.getAuthCode( onNeedsCredentials );
        else
            onHasSession();
    }

    XtvAuth.prototype.getAuthCode = function( onNeedsCredentials )
    {
        var params  = {}, success, error, self = this;

        params.type = "GET";
if( _x2._config._partner === "Rogers" )
    params.url  = _x2._config._xtvAuthRoot + "activationCode/?partner=Comcast";
else
        params.url  = _x2._config._xtvAuthRoot + "activationCode/?partner=" + _x2._config._partner;

        error = function( e )
        {
            console.log( e.toString() );
        };

        success = function( response )
        {
            console.log( ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> SUCCESS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<" );
            console.log( response.data );

            var parsed = JSON.parse( response.data );
            var obj    = {};

            _x2._config.log( Config.CLASS_XTV_AUTH, 5 ) ?  console.log( parsed ) : Config.NOP();

            self._interval = parsed.pollInSeconds;
            self._pollUrl  = _x2._config._xtvAuthRoot + parsed._links.poll.href.slice(3);

            _x2._config.log( Config.CLASS_XTV_AUTH, 1 ) ?  console.log( "USER URL  = " + parsed.activationUrl  ) : Config.NOP();
            _x2._config.log( Config.CLASS_XTV_AUTH, 1 ) ?  console.log( "USER CODE = " + parsed.activationCode ) : Config.NOP();

            obj.url            = parsed.activationUrl;
            obj.code           = parsed.activationCode;
            obj.pollFunc       = function( onSuccess, onError ) { self.pollForToken( onSuccess, onError ); };
            obj.getNewCodeFunc = function( func ) { self.getNewCode( func ); };

            setTimeout( function() { onNeedsCredentials( obj ); }, 1 );
        };

        _x2._network.ajax( params ).then( success ).catch( error );
    };

    XtvAuth.prototype.logout = function()
    {
        _x2._data.deleteDevice();
        _x2._config._host.resetLocalStorage();
        _x2._config._host.setLocalStorage   ( "logoutTimestamp", Date.now() );
        _x2._config._token = undefined;
    };

    XtvAuth.prototype.pollForToken = function( onSuccess, onError )
    {
        var params = {}, error, success, self = this, status, response;

        params.type = "GET";
        params.url  = this._pollUrl;

        error = function( e )
        {
            status = e.getHttpStatus();

            switch( status )
            {
                case 404:
                    response = JSON.parse( e.getHttpResponse() );
                    self._interval = response.pollInSeconds;
                    self._delay = setTimeout( function() { _x2._network.ajax( params ).then( success ).catch( error ); }, self._interval * 1000 );
                    break;

                case 500:
                    if( onError )
                        onError();
                    break;

                default:
                    console.log( "ERROR -> unknown response to XtvAuth poll = " + status );
                    console.log( e );
                    break;
            }
        };

        success = function( response )
        {
            _x2._config.log( Config.CLASS_XTV_AUTH, 9 ) ?  console.log( response      ) : Config.NOP();
            _x2._config.log( Config.CLASS_XTV_AUTH, 9 ) ?  console.log( response.data ) : Config.NOP();

            var parsed = JSON.parse( response.data );

            _x2._config.log( Config.CLASS_XTV_AUTH, 9 ) ?  console.log( parsed ) : Config.NOP();

            self._delay = undefined;
            _x2._config._host.setLocalStorage( "XtvAuthToken", response.data );

            if( onSuccess )
                onSuccess();
        };

        self._delay = setTimeout( function() { _x2._network.ajax( params ).then( success ).catch( error ); }, self._interval * 1000 );
    };

    XtvAuth.prototype.getNewCode = function( onNeedsCredentials )
    {
        if( this._delay )
        {
            clearTimeout( this._delay );
            this._delay = undefined;
        }

        this.getAuthCode( onNeedsCredentials );
    };

    return XtvAuth;

})();


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Features = (function()
{
    "use strict";

    Features.Key = Object.freeze
    ({
        TRANSACTIONS : "transactions",
    });

    Features.Entitlement = Object.freeze
    ({
        EST        : "est",
        C_VOD      : "cvod",
        C_DVR      : "cdvr",
        C_LINEAR   : "clinear",
        TVE_VOD    : "tve-vod",
        TVE_LINEAR : "tve-linear"
    });

    var LOCAL_STORAGE_KEY = "features";

    function Features()
    {
        var jsonString = Host.getLocalStorage( LOCAL_STORAGE_KEY );
        if( jsonString )
            this._data = JSON.parse( jsonString )
    }

    /**
     * Return true if we have features data.
     * @return {boolean}
     */
    Features.prototype.isDefined = function()
    {
        return this._data !== undefined;
    };

    Features.prototype.setData = function( data )
    {
        this._data = data;
    };

    Features.prototype.getFeature = function( key )
    {
        var data   = this._data,
            retval = data && data.features && data.features[ key ];

        return retval;
    };

    Features.prototype.getUserType = function()
    {
        return this._data['userType'];
    };

    Features.prototype.hasEntitlement = function( entitlement )
    {
        var data   = this._data,
            retval = data && data.entitlements && data.entitlements.indexOf( entitlement );

        return retval >= 0;
    };

    Features.prototype.saveToLocalStorage = function()
    {
        _x2._config._host.setLocalStorage( LOCAL_STORAGE_KEY, JSON.stringify( this._data ) );
    };

    return Features;
})();


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LastWatched = (function()
{
    "use strict";

    function LastWatched(){}

    var LOCAL_STORAGE_KEY = "lastWatched";

    function createEntity( obj, type )
    {
        var retval;

        if( type === "Channel" )
            retval = new Channel().init( obj );
        else if( type === "Entity" )
            retval = new Entity().init( obj );
        else if( type === "Recording" )
            retval = new Recording().init( obj );
        else if( type === "VodShowing" )
            retval = new VodShowing().init( obj );
        else
            console.error( "Need to support data type = " + type );

        return retval;
    }

    LastWatched.prototype.getEntries = function()
    {
        var self = this;

        var foo = function( resolve )
        {
            var setEntries = function()
            {
                var struct = self.read();
                var array  = struct.entries;
                var retval = [];

                for( var i = 0; i < array.length; i++ )
                {
                    var foo = createEntity( array[i].data, array[i].dataType );

                    if( foo )
                    {
                        var rentalTime = foo.get("rentalDateTime");
                        if( rentalTime )
                        {
                            var expires = new Date( rentalTime ).getTime() + ( foo.getInteger("rentalPeriod") * 60000 );
                            if( Date.now() < expires )
                                retval.push( { entity:foo, data:array[i] } );
                        }
                        else
                            retval.push( { entity:foo, data:array[i] } );
                    }
                }

                for( i = retval.length - 1; i >= 0; i-- )
                {
                    if( retval[i].entity instanceof Channel )
                    {
                        retval[i].entity = _x2._channelCollection.getChannel( retval[i].entity.getSelfLink() );

                        if( retval[i].entity === undefined )
                        {
                            console.error( "NO MATCH: DELETE ENTRY" );
                            retval.splice( i, 1 );
                        }
                    }
                }

                resolve( retval );
            };

            _x2._channelCollection && _x2._channelCollection.fetch().then( setEntries );
        };

        return new Promise( foo );
    };

    LastWatched.prototype.read = function()
    {
        var retval = { version:1, entries:[] }, parsed;
        var json   = Host.getLocalStorage( LOCAL_STORAGE_KEY );

        if( json )
        {
            parsed = JSON.parse( json );

            var version = parsed.version;

            if( version === undefined )
            {
                console.error( "Unsupported version of last watched = " + version + ". Resetting." );
                this.write( retval );
            }
            else
                retval = parsed;
        }
        else
            this.write( retval );

        return retval;
    };

    LastWatched.prototype.write = function( obj )
    {
        _x2._config._host.setLocalStorage( LOCAL_STORAGE_KEY, JSON.stringify( obj ) );
    };

    return LastWatched;

})();


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



window.Network = ( function()
{
    Network.Accepts = {
        all : "*",
        text: "text/plain",
        html: "text/html",
        xml : "application/xml, text/xml",
        json: "application/json, text/javascript",
        xtv : "application/comcast+hal+json, application/json, */*;"
    };

    /**
     * Initialize network
     * @constructor
     */
    function Network()
    {
        _x2._config.debugAddClass( Config.CLASS_NETWORK, 0 );
        this._globalCacheInc = 0;
        this._urlCacheTimestamps = [];
        this._pendingRequests = [];
    }

    /**
     * Convenience method for ajax get
     * @param url - string - network url to call
     * @returns Promise
     */
    Network.prototype.get = function( url, timeout )
    {
        return this.ajax( { type:"GET", url:url, timeout:timeout } );
    };

    /**
     * Convenience method for ajax put
     * @param url
     * @param data
     * @returns Promise
     */
    Network.prototype.put = function( url, data )
    {
        return this.ajax( { type:"PUT", url:url, data:data } );
    };

    Network.prototype.resetGlobalCache = function()
    {
        this._globalCacheInc++
    };

    /**
     * Make an AJAX call
     * @param {*}        params
     * @param {string}   params.url           - resource URL
     * @param {[*]}     [params.headers]      - array of key:value pair objects to set headers
     * @param {string}  [params.type]         - call type (GET, PUT, POST)
     * @param {string}  [params.accepts]      - set 'Accept' header with this value (see Network.Accepts above)
     * @param {*}       [params.responseType] - set http req responseType
     * @param {string}  [params.contentType]  - set 'Content-Type' header with this value
     * @param {*}       [params.data]         - data to send
     * @param {*}       [params.api]          - api name. useful for mapping errors to a url pattern (for example when following links). XtvApi method calls normally have api set in XtvApi.get()
     * @param {boolean} [params.bustCache]    - increment the cache version for this url and force a network fetch
     * @returns Promise
     */
    Network.prototype.ajax = function( params )
    {
        if( ! this._xClientInfo )
            this._xClientInfo = _x2._config._host.getClientInfo();

        if( !params || !params.url )
            return Promise.reject( new ApiError().init( { local:"Network.ajax: Url is required"} ) );
        else
        {
            var self = this;
            var type = params.type ? params.type : 'GET';
            var promise = new Promise(function (resolve, reject)
            {
                var token;
                var req = new XMLHttpRequest();

                var load = function ()
                {
                    if( req.status < 400 )
                        resolve( { data:req.response, path:req.responseURL, statusCode:req.status, responseTimeNetwork:Date.now() - self._responseTimeStart } );
                    else
                    {
                        var error = new ApiError().init( { http:req, api:params.api } );

                        error.path                = req.responseURL;
                        error.statusCode          = req.status;
                        error.responseTimeNetwork = Date.now() - self._responseTimeStart;

                        if( error.getMajor() === "403" && error.getMinor() === "103" ) //403-103 = Bad Cloud DVR Token
                        {
                            console.log( "TOKEN REFRESH" );
                            self._pendingRequests.forEach( function (pendingRequest){
                                pendingRequest.abort();
                            });
                            var onSession = function( response )
                            {
                                self._refreshPromise = undefined;

                                console.log( response );
                                console.log( params );

                                if( response )
                                {
                                    _x2._config._host.setLocalStorage( "XsctToken", response );
                                    _x2._data.setAuthHeader();
                                }
                                token = response && JSON.parse( response )['xsct'];
                                //If there is pending cancelled request, then we need to call all api again, instead of wait for api response one by one & resend it
                                if( self._pendingRequests.length ) {
                                    _x2.sessionCreated();
                                    self._pendingRequests = [];
                                } else {
                                    _x2._data.getParentalControls().then( function( pc ) { console.log( pc ); _x2._pc = pc; } );
                                    if( params.headers && token )
                                    {
                                        for( var i = 0; i < params.headers.length; i++ )
                                            if( params.headers[i].name === "Authorization" )
                                            {
                                                params.headers[i].value = "CCP " + token;
                                                break;
                                            }
                                    }
    
                                    self.ajax( params ).then( resolve, reject );
                                }
                            };

                            var onSessionError = function( e )
                            {
                                console.log( e.toString() );
                                reject( new ApiError().init( { http:e } ) );
                            };

                            if( self._refreshPromise )
                                self._refreshPromise.then( onSession, onSessionError );
                            else
                                self._refreshPromise = _x2.provision().then( onSession, onSessionError );
                        }
                        else
                            reject( error );
                    }
                };

                var error = function ()
                {
                    reject( new ApiError().init( { local:"Network.ajax: Network Error" } ) );
                };

                var onTimeout = function () {
                    console.log("Network timeout", params.url );
                    reject({ data: null, url: params.url , msg: "Network timeout"});
                }

                var isXtvApiCall = params.url.indexOf( "xtvapi" ) !== -1;

                //set universal cache-busting parameter for all xtvapi "GET" calls if _globalCacheInc has been set.
                if( self._globalCacheInc > 0 && isXtvApiCall === true && params.type === "GET" ) {
                    if( params.url.indexOf('cirrusCacheBust=') > -1 ) { //if url already has cirrusCacheBust, then we need to replace value instead of append it
                        params.url = params.url.replace(/cirrusCacheBust=\d{1,3}/, 'cirrusCacheBust=' + self._globalCacheInc );
                    } else {
                        params.url += (params.url.indexOf( "?" ) !== -1 ? "&" : "?") + "cirrusCacheBust=" + self._globalCacheInc;
                    }
                }

                var timestamp = self._urlCacheTimestamps[params.url];

                //if bustCache parameter is set then set a new timestamp for this url to force a server round trip
                if( params.bustCache )
                {
                    timestamp = Date.now();
                    self._urlCacheTimestamps[params.url] = timestamp;
                }

                //if there is a timestamp for this url always set the url param so we get the most recent version.
                if( timestamp )
                    params.url += (params.url.indexOf( "?" ) !== -1 ? "&" : "?") + "time=" + timestamp;

                req.addEventListener( "load", load );
                req.addEventListener( "error", error );
                req.addEventListener( "timeout", onTimeout );
                req.open(type, params.url);

                if( params.url.indexOf("xtvapi") > 0 )
                {
                    var clientPlatform;

                    if( _x2._config._itv )
                        clientPlatform = "web; linear-tve";
                    else if( _x2._config._xocPartner )
                        clientPlatform = "roku; linear-ftm; standard-sports-images; session";  // HACK using roku until html5 specific tag available
                    else
                        clientPlatform = "html5; linear-ftm; standard-sports-images; session";

                    if( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) )
                        clientPlatform += "; est";
                    if( _x2._config._appendHeaders ) {
                        clientPlatform += "; " + _x2._config._appendHeaders;
                    }
                    req.setRequestHeader("Client-Platform", clientPlatform);
                }

                if( params.responseType )
                    req.responseType = params.responseType;

                if( params.contentType )
                    req.setRequestHeader('Content-Type', params.contentType );

                if( params.accepts )
                    req.setRequestHeader( 'Accept', params.accepts );

                if( params.timeout !== undefined )
                    req.timeout = params.timeout;

                if( isXtvApiCall )
                    req.setRequestHeader( 'X-Finity-Client-Info', self._xClientInfo );

                if( params.headers && params.headers.length )
                {
                    for( var i=0; i<params.headers.length; i++ )
                        req.setRequestHeader(params.headers[i].name, params.headers[i].value);
                }

                self._responseTimeStart = Date.now();
                if( params.cancelOnDemand ) {
                    self._pendingRequests.push(req);
                }
                if( params.data && params.data.length )
                    req.send(params.data);
                else
                    req.send();
            });
        }

        return promise;
    };

    return Network;

})();


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.Settings = (function()
{
    "use strict";

    Settings.Key = Object.freeze
    ({
        CC_ENABLED     : "ccEnabled",
        CC_STYLING     : "ccStyling",
        DV_ENABLED     : "dvEnabled",
        FILTERS        : "filters",
        FORMAT         : "format",
        LAST_CHAN      : "lastChannel",
        PURCHASES      : "purchases",
        SAP_ENABLED    : "sapEnabled",
        SAP_LANG       : "sapLang",
        TERMS          : "terms"
    });

    Settings.StyleDefaults = Object.freeze
    ({
        fontStyle             : "default",
        penSize               : "standard",
        textBackgroundColor   : "black",
        textBackgroundOpacity : "solid",
        textEdgeColor         : "white",
        textEdgeStyle         : "none",
        textForegroundColor   : "white",
        textForegroundOpacity : "solid"
    });

    Settings.Default = Object.freeze
    ({
        ccEnabled     : false,
        ccStyling     : Settings.StyleDefaults,
        dvEnabled     : false,
        filters       : { hd:false, cc:false, sap:false, dvs:false },
        format        : "hd",
        sapEnabled    : false,
        sapLang       : "en",
        terms         : 0
    });

    Settings.TERMS_VERSION = 2;

    var LOCAL_STORAGE_KEY = "settings";

    function Settings()
    {
        var json = localStorage[LOCAL_STORAGE_KEY], key;

        if( json )
        {
            this._data = JSON.parse( json );

            if( typeof this._data[Settings.Key.LAST_CHAN] !== "object" )  // changed from string to object
                this._data[Settings.Key.LAST_CHAN] = undefined;

            for( key in Settings.Key )
            {
                key = Settings.Key[key];

                if( this._data[key] === undefined )
                {
                    console.warn( "Missing settings for: " + key );
                    this._data[key] = Settings.Default[key];
                    this.write();
                }
            }
        }
        else
        {
            this._data = {};
            this.setDefaults();
            this.write();
        }
    }

    Settings.prototype.getValue = function( key )
    {
        return this._data[key];
    };

    Settings.prototype.setDefaults = function()
    {
        for( var key in Settings.Key )
        {
            key = Settings.Key[key];
            this._data[key] = Settings.Default[key];
        }
    };

    Settings.prototype.setValue = function( key, value )
    {
        if( key !== undefined )
        {
            this._data[key] = value;
            this.write();
        }
        else
            console.error( "Trying to set a setting using an undefined key." );
    };

    Settings.prototype.write = function()
    {
        localStorage.setItem( LOCAL_STORAGE_KEY, JSON.stringify(this._data) );
    };

    return Settings;

})();


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.ThePlatformApi = (function ()
{
    function ThePlatformApi( vodEndpoint )
    {
        this._vodEndpoint = vodEndpoint;
        this._xtvApi      = new XtvApi( _x2._config._xtvApiRoot, Config.AUTH_OAUTH );
    }

    ThePlatformApi.prototype.getVodFolder = function()
    {
        var url = this._vodEndpoint;

        var remap = function (object)
        {
            return {
                name          : object.title,
                description   : object.description,
                partOfSeason  : { seasonNumber: object['fourk$seasonnumber'] },
                episodeNumber : object['fourk$episodeid']
            };
        };

        var resolver = function( resolve, reject )
        {
            var success = function (data)
            {
                var vodEntities = [];
                var vodData = JSON.parse(data);

                if( vodData && vodData.entries )
                {
                    for( var i=0; i<vodData.entries.length; i++ )
                        vodEntities.push( new Entity( remap( vodData.entries[i] ) ) );
                }

                resolve(vodEntities);
            };

            var error = function (error)
            {
                reject(error);
            };

            _x2._network.ajax( { type: "GET", url: url } ).then(success).catch(error);
        };

        return new Promise(resolver);
    };

    ThePlatformApi.prototype.getParentalControls = function(cancelOnDemand)
    {
        return this._xtvApi.getParentalControls( cancelOnDemand );
    };

    ThePlatformApi.prototype.getResumePoints = function()
    {
        return {};
    };

    ThePlatformApi.prototype.getSettings = function()
    {
        return {};
    };

    return ThePlatformApi;

})();


/***/ }),
/* 11 */
/***/ (function(module, exports) {

//Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * XtvApi is an API abstraction layer for the XTV API backend. This class exposes a subset of XTV APIs and
 * creates a clear interaction model for utilizing the backend services by:<br>
 *  ~ Exposing and documenting only the APIs used by coamX2<br>
 *  ~ Wrapping XTV API-returned data in a set of types/classes that expose their capabilities<br>
 *  ~ Manipulating XTV API data to make consumption easier<br>
 *  ~ Abstract away HAL (Hypermedia Application Language) semantics.<br>
 *  ~ Breaking the HTTP cache when required.<br>
 */

window.XtvApi = (function ()
{
    "use strict";

    /**
     * @enum {String} EntityType
     * @memberOf XtvApi
     */
    XtvApi.EntityType =
    {
        MOVIE   : "Movie",
        PROGRAM : "Program",
        SERIES  : "SeriesMaster",
        EPISODE : "Episode",
        SPORTS  : "Sports",
        TEAM    : "Team",
        OTHER   : "Other"
    };

    /**
     * Defines the screen layout
     * @enum {String} CollectionRenderStyle
     * @memberOf XtvApi
     */
    XtvApi.CollectionRenderStyle =
    {
        GALLERY_ROWS   : "GALLERY_ROWS",
        NETWORK_ENTITY : "NETWORK_ENTITY", //NOTE: not sure we will have a specific network view
        BROWSE         : "BROWSE"
    };

    /**
     * Defines the entity style/layout
     * @enum {String} EntityRenderStyle
     * @memberOf XtvApi
     */
    XtvApi.EntityRenderStyle =
    {
        "POSTER"             : "POSTER",
        "PROMO"              : "PROMO",
        "NETWORK"            : "NETWORK",
        "SMALL_PROMO"        : "SMALL_PROMO",
        "4X3_PROGRAM_LINEAR" : "4X3_PROGRAM_LINEAR",
        "3X4_PROGRAM_LINEAR" : "3X4_PROGRAM_LINEAR",
        "16X9_PROGRAM"       : "16X9_PROGRAM"
    };

    /**
     * This class is intended to be instantiated once, and accessed via a globally accessible variable
     * @param {String} host - The URL of the XTV API HAL
     * @param {Number} authType - From Config.AUTH
     * @constructor
     */
    function XtvApi( host, authType )
    {
        var onSuccess, onError, self = this;

        this._host = host;

        this.setAuthHeader( authType );

        onSuccess = function( response )
        {
            self._root = JSON.parse( response.data );
        };

        onError = function( error )
        {
            console.log( "ERROR -> Unable to load XTV API root [" + error + "]");
        };

        //keep a reference to the promise so we can use it to defer API calls before this (root) query resolves
        this._rootPromise = _x2._network.get( host ).then( onSuccess ).catch( onError );
    }

    /**
     * Add (non-channel) items to favorites.
     * @memberOf XtvApi
     * @param {String} selfLink - Object's _links.self.href
     * @return {Promise}
     */
    XtvApi.prototype.addFavoriteItem = function( selfLink )
    {
        return this.sendForm( "addFavoriteItems", { itemSelfLinks: '["' + selfLink + '"]' }, true );
    };

    /**
     * Add favorite channel
     * @memberOf XtvApi
     * @param {String} channelLink - Channel's _links.self.href
     * @return {Promise}
     */
    XtvApi.prototype.addFavoriteChannel = function( channelLink )
    {
        return this.sendForm( "addFavoriteChannels", { channelSelfLinks: '["' + channelLink + '"]' }, true );
    };

    /**
     * Setup the value of the "Authorization" header according to authType
     * @memberOf XtvApi
     * @param {Number} authType - Config.AUTH
     */
    XtvApi.prototype.setAuthHeader = function( authType )
    {
        var token;

        if( authType )
            this._authType = authType;

        if( this._authType === Config.AUTH_OAUTH )
        {
            token = Host.getLocalStorage( "OauthToken" );
            token = token && JSON.parse( token ).access_token;

            this._deviceHeader = { name:"X-FINITY-DEVICE-ID", value:"x1.cvp2" };
            this._authHeader   = { name:"Authorization", value:"Bearer " + token };
        }
        else
        {
            token = Host.getLocalStorage( "XsctToken" );

            if( token )
            {
                token = JSON.parse( token );

                if( token.tokenSummary.partnerId !== "comcast" )
                    _x2._config._xocPartner = token.tokenSummary.partnerId;

                token = token.xsct;
            }

            this._authHeader = { name:"Authorization", value:"CCP " + token };
        }
    };

    /**
     * Check in/return downloads for the given device
     * @memberOf XtvApi
     * @param {String} deviceId
     * @return {Promise}
     */
    XtvApi.prototype.checkInDownloadsForDevice = function( deviceId )
    {
        return _x2._network.ajax( { type: "POST", url: this._host + 'devices/' + deviceId + '/checkInAll/', headers:[this._authHeader] } );
    };

    /**
     * Translates a XACT token to DRM data including XSCT token
     * @memberOf XtvApi
     * @param   {String}  xact - XACT token string
     * @param   {String}  partnerId - Partner id
     * @return  {Promise} Promise resolves with a JSON structure containing DRM information including XSCT token.
     */
    XtvApi.prototype.createDrmSession = function( xact, partnerId )
    {
        var self = this;

        //NOTE: this extra promise layer is only needed because the callers of this function are expecting response.data instead of response. If we fix the callers we can eliminate it.
        var resolver = function( resolve, reject )
        {
            var success = function( response )
            {
                //follow the features link if available
                var drmSession = JSON.parse( response.data );
                if(drmSession.tokenSummary) {
                    _x2._splunk.sendProvisionSuccess({
                        accountId: drmSession.tokenSummary.xboAccountId,
                        deviceId: drmSession.tokenSummary.deviceId,
                        inHomeStatus: drmSession.tokenSummary.inHomeStatus,
                        isVideoEntitled: drmSession.tokenSummary.isLinearEntitled && drmSession.tokenSummary.isVODEntitled 
                    });
                }
                if( drmSession._links && drmSession._links.features )
                {
                    var onFeatures = function( featuresResponse )
                    {
                        //update the features object and resolve with response from the createDrmSession call
                        _x2._features.setData( JSON.parse( featuresResponse.data ) );
                        _x2._features.saveToLocalStorage();
                        window.sessionCreatedAt = new Date();
                        console.log("DRM session was created at ", new Date());
                        if( window.sessionStartCreatingAt ) {
                            console.log("Time taken to create DRM session & features is ", ( window.sessionCreatedAt - window.sessionStartCreatingAt) / 1000);
                        }
                        resolve( response.data );
                    };

                    var onFeaturesError = function( error )
                    {
                        console.log( error ); //TODO: what do we do about this?
                        resolve( response.data );
                    };

                    var link = drmSession._links.features.href;
                    var url  = self._host + XtvApi.trimPath( link );

                    var authHeader = { name:"Authorization", value:"CCP " + drmSession.xsct };
                    _x2._network.ajax( { url:url, type:"GET", headers:[authHeader], accepts:Network.Accepts.xtv } ).then(onFeatures).catch(onFeaturesError);
                }
                else {
                    window.sessionCreatedAt = new Date();
                    console.log("DRM session was created at ", new Date());
                    if( window.sessionStartCreatingAt ) {
                        console.log("Time taken to create DRM session is ", ( window.sessionCreatedAt - window.sessionStartCreatingAt) / 1000);
                    }
                    resolve( response.data );
                }
                    
            };
            var error   = function( error )
            {
                console.log("DRM session got failed at ", new Date() );
                reject( error );
            };

            self.sendForm( "createDrmSession", { xact:encodeURIComponent( xact ), partnerId:partnerId, hardAcquisition:"true" }, false ).then( success ).catch( error );
        };

        return new Promise( resolver );
    };

    /**
     * Delete all devices associated with the drmId in the XACT, or sets device to PendingDelete with XSCT
     * @memberOf XtvApi
     * @returns {Promise}
     */
    XtvApi.prototype.deleteDevice = function()
    {
        var tact = Host.getLocalStorage( "XactToken" );
        var tsct = Host.getLocalStorage( "XsctToken" );
        var xact = tact ? encodeURIComponent( JSON.parse( tact ).deviceToken ) : undefined;
        var xsct = tsct ? encodeURIComponent( JSON.parse( tsct ).xsct        ) : undefined;

        return this.sendForm( "deleteDevice", { xact:xact, xsct:xsct }, false );
    };

    /**
     * Call any arbitrary XTV API.
     * @memberOf XtvApi
     * @param   {String}    api           - The name of the API. Example: "getResumePoints"
     * @param   {Object}    params        - A JSON object containing parameters. Example: {maxDaysOld:30,someOtherParam:'abc'}
     * @param   {function}  [transform]   - A function to call to transform data before Promise resolves.
     * @param   {Boolean}   [bustCache]   - Force the query to bypass the local cache
     * @returns {Promise <Object,*>}  Promise resolves with results of transform or raw JSON structure from XTV API
     */
    XtvApi.prototype.get = function( api, params, transform, bustCache )
    {
        var self = this;
        var exec = function( api, params, transform )
        {
            if( self._root )
            {
                var node = self._root._links[api];

                if( node )
                {
                    var url = self._host + ( node.templated ? XtvApi.replaceUrlParams( node.href, params ) : node.href );

                    var resolver = function( resolve, reject )
                    {
                        var success, error;

                        success = function (response)
                        {
                            //transform if we have a function then resolve.
                            response.responseTimeXtvApi = Date.now() - self._responseTimeStart;
                            var transformed = transform ? transform( response ) : response.data;

                            if( _x2._splunk && api )
                                _x2._splunk.onXtvApi( true, api, response, params, transformed );

                            resolve( transformed );
                        };

                        error = function (error)
                        {
                            if( error.setApi )
                                error.setApi( api ); //record the api that triggered the failure

                            error.responseTimeXtvApi = Date.now() - self._responseTimeStart;

                            if( _x2._splunk && api )
                                _x2._splunk.onXtvApi( false, api, error, params, undefined );

                            reject( error );
                        };

                        _x2._network.ajax({type: "GET", url: url, headers:self.getAuthHeader(), accepts:Network.Accepts.xtv, bustCache:bustCache, cancelOnDemand: params.cancelOnDemand || false }).then(success).catch(error);
                    };

                    return new Promise( resolver );
                }
                else
                {
                    return Promise.reject( new ApiError().init( { local:"XtApi.get: There is no API matching '" + api + "'"} ) );
                }
            }
            else
            {
                return Promise.reject( new ApiError().init( { local:"XtvApi.get: XTV API was not initialized. Clear browser cache and retry"} ) );
            }
        };

        this._responseTimeStart = Date.now();

        if( this._root )
            return exec( api, params, transform );
        else // defer this call until root is loaded
        {
            return this._rootPromise.then( function()
            {
                return exec( api, params, transform );
            } );
        }
    };

    /**
     * Get the Authorization headers
     * @memberOf XtvApi
     * @return {Object[]}
     */
    XtvApi.prototype.getAuthHeader = function()
    {
        return ( this._authType === Config.AUTH_OAUTH ) ? [this._authHeader, this._deviceHeader] : [this._authHeader];
    };

    /**
     * Get a list of all deleted recordings
     * @memberOf XtvApi
     * @return {Promise <Recording[]>}
     */
    XtvApi.prototype.getDeletedRecordings = function()
    {
        var transform = function( response )
        {
            var i, recordings = [], data = JSON.parse( response.data );

            if( data._embedded && data._embedded.recordings )
            {
                for( i=0; i<data._embedded.recordings.length; i++ )
                    recordings.push( new Recording().init(data._embedded.recordings[i]));
            }

            return recordings;
        };

        return this.get("getDeletedRecordings", {}, transform )
    };

    /**
     * Get the TokenSummary object from XTVAPI
     * @memberOf XtvApi
     * @return {Promise <Object>}
     */
    XtvApi.prototype.getTokenSummary = function()
    {
        return this.get( "getTokenSummary", {}, function( response ) { return JSON.parse( response.data ); } );
    };

    /**
     * Get a ChannelCollection object initialized with all channels + a schedules block for the current time.
     * @memberOf XtvApi
     * @return {Promise <ChannelCollection>}
     */
    XtvApi.prototype.getChannelCollection = function(cancelOnDemand)
    {
        var p = [], self = this;
        cancelOnDemand  = cancelOnDemand || false;
        var resolver = function( resolve, reject )
        {
            var blockTime = ChannelCollection.getUniformBlockTime( _x2._config._host.getCurrentDateTime(true) );

            var success = function( response )
            {
                var cc = new ChannelCollection().init( response );
                resolve( cc );
                self._getCcPromise = undefined;
            };

            var error = function( error )
            {
                reject( error );
            };

            p.push(self.getChannels(cancelOnDemand));
            p.push(self.getScheduleBlock( blockTime, ChannelCollection.blockHours, cancelOnDemand ));
            Promise.all(p).then( success ).catch( error );
        };

        //handle simultaneous calls with one network call.
        if( this._getCcPromise === undefined )
            this._getCcPromise = new Promise( resolver );

        return this._getCcPromise;
    };

    /**
     * Get an array of all channels for current user
     * @memberOf XtvApi
     * @return {Promise <Channel[]>}
     */
    XtvApi.prototype.getChannels = function( cancelOnDemand )
    {
        function transform( response )
        {
            var i, objects, channel, hdChannelNumber, hdMap = [], sdChannels = [], channels = [];

            objects = JSON.parse( response.data )._embedded.channels;

            for( i = 0; i < objects.length; i++ )
            {
                channel = new Channel().init( objects[i] );

                if( channel.isHD() )
                    hdMap[channel.getNumber()] = channel;
                else
                    sdChannels.push( channel );

                channels.push( channel );
            }

            // try to find an HD complement for all SD channels
            for( i = 0; i < sdChannels.length; i++ )
            {
                hdChannelNumber = sdChannels[i].getAssocChannelNumber();

                if( hdChannelNumber !== undefined && hdMap[hdChannelNumber] )
                    sdChannels[i].setHdComplement( hdMap[hdChannelNumber] )
            }

            return channels;
        }

        return this.get( "getChannelMap", {cancelOnDemand: cancelOnDemand}, transform );
    };

    /**
     * Get the list of all devices associated with this account
     * @memberOf XtvApi
     * @return {Promise <Object[]>}
     */
    XtvApi.prototype.getAllDeviceList = function(cancelOnDemand)
    {
        var transform = function( response )
        {
            var list = [], obj = JSON.parse( response.data );

            if( obj && obj._embedded )
                list = obj._embedded.devices;

            return list;
        };

        return this.get( "getAllDevicesList", { cancelOnDemand: cancelOnDemand }, transform, true );
    };

    /**
     * Get a collection of favorite IDs (self links) by type
     * @memberOf XtvApi
     * @return {Promise <Favorites>}
     */
    XtvApi.prototype.getFavorites = function( cancelOnDemand )
    {
        var transform = function( response )
        {
            return new Favorites().init( JSON.parse( response.data ) );
        };

        return this.get( "getAllFavorites", { cancelOnDemand: cancelOnDemand || false}, transform, true );
    };

    /**
     * Get a collection of favorite entities TODO: why are we cache busting here?
     * @memberOf XtvApi
     * @return {Promise}
     */
    XtvApi.prototype.getFavoritesBrowse = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            return new BrowseCollection().init( JSON.parse( response.data ) );
        };

        return this.get("browseFavorites", { depth:2, maxPrograms:12, cancelOnDemand: cancelOnDemand }, transform,true);
    };

    /**
     * Get the "featured" collection for "for you"
     * @memberOf XtvApi
     * @return {Promise} Resolves to BrowseCollection
     */
    XtvApi.prototype.getForYouFeaturedMenu = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var embedded, collection, data = JSON.parse( response.data );

            embedded = data._embedded.browseItems;

            if( embedded && embedded.length )
                collection = new BrowseCollection().init( embedded[0] );

            return collection;
        };

        return this.get("getForYouFeaturedMenu", { depth:2, maxPrograms:12, cancelOnDemand: cancelOnDemand }, transform );
    };

    /**
     * Get the "For You" root (Collection of Collections)
     * @memberOf XtvApi
     * @return {Promise} Resolves to BrowseCollection[]
     */
    XtvApi.prototype.getForYouMenu = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var i, embedded, items, data, root, collection = [];

            data = JSON.parse( response.data );
            root = new BrowseCollection().init( data );

            embedded = data._embedded;
            if( embedded )
            {
                items = embedded.browseItems;
                if( items )
                {
                    for( i=0; i<items.length; i++ )
                        collection.push( new BrowseCollection().init( items[i], root ) );
                }
            }
            return collection;
        };

        return this.get("getForYouMenu", { depth:2, maxPrograms:12, cancelOnDemand: cancelOnDemand }, transform );
    };

    /**
     * Get a collection by the node alias (deep link)
     * @memberOf XtvApi
     * @see https://etwiki.sys.comcast.net/display/AAE/Xfinity+Stream+App+Deeplinks+for+Collections+and+VOD+Playback
     * @param {String} alias
     * @param {String} [filters] - Comma separated list of filters. Full set from XTVAPI docs: [closedcaption,hd,downloadable,tve,sap]
     * @returns {Promise}
     */
    XtvApi.prototype.getNodeByAlias = function( alias, filters )
    {
        var params = {
            aliasName   : alias,
            depth       : 2,
            maxPrograms : 12,
            filters     : filters };

        var transform = function( response )
        {
            return new BrowseCollection().init( JSON.parse( response.data ) );
        };

        return this.get( "browseNodeByAlias", params, transform );
    };

    /**
     * Get the entity detail data for a program
     * @memberOf XtvApi
     * @param {String}   id         - Program ID
     * @param {Boolean} [tve]       - Include TVE showings in result
     * @param {Boolean} [tveLinear] - Include TVE linear showings in result
     * @returns {Promise}
     */
    XtvApi.prototype.getProgram = function( id, tve, tveLinear )
    {
        var params = {
            programId        : id,
            includeTve       : tve||false,
            includeTveLinear : tveLinear||false };

        var transform = function( response )
        {
            return new Entity().init( JSON.parse( response.data ) );
        };

        return this.get( "getProgramEntity", params, transform );
    };

    /**
     * Get the detail for a grid listing
     * @memberOf XtvApi
     * @param {LinearShowing} listing - Listing object to pull deatil for
     * @returns {Promise} Promise resolves with the same {@link LinearShowing} object pass as param, with detail added.
     *
     * TODO: shouldn't this be in LinearShowing?
     */
    XtvApi.prototype.getListingDetail = function ( listing )
    {
        var self = this;

        //Take a listing object, extract and call the embedded query, return promise and callback with detail
        var resolver = function (resolve, reject)
        {
            var success = function (response)
            {
                listing.init(JSON.parse(response.data));
                resolve( listing );
            };
            var error = function (error)
            {
                reject( error );
            };

            _x2._network.ajax({type: "GET", url: self._host + listing.getSelfLink(), api:"getTvListingDetail", headers: [self._authHeader], accepts:Network.Accepts.xtv}).then(success).catch(error);
        };

        return new Promise(resolver);
    };

    /**
     * Find recommendations by entity
     * @memberOf XtvApi
     * @param {String} entityId - The ID of the entity to find related content for.
     * @returns {Promise <SearchEntity[]>}
     */
    XtvApi.prototype.getMoreLikeThis = function( entityId )
    {
        return this.get( "recommendMoreLikeThis", { entityId: entityId },
            function( response )
            {
                var i, entities = [], data = JSON.parse( response.data )._embedded.results;

                for( i = 0; i < data.length; i++ )
                    entities.push( new SearchEntity().init(data[i]) );

                return entities;
            }
        );
    };

    /**
     * Get parental controls settings
     * @memberOf XtvApi
     * @returns {Promise <ParentalControls>}
     */
    XtvApi.prototype.getParentalControls = function(cancelOnDemand)
    {
        var transform = function( response )
        {
            return new ParentalControls( JSON.parse(response.data) );
        };

        return this.get( "getParentalControls2Settings", { cancelOnDemand: cancelOnDemand, cache: false }, transform );
    };

    /**
     * Get a list of purchases and rentals for For You.
     * @memberOf XtvApi
     * @returns {Promise <PurchaseCollection>}
     */
    XtvApi.prototype.getForYouPurchases = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var data = JSON.parse( response.data );
            var entities = [];

            if( data && data._embedded )
            {
                var programs = data._embedded.programs;
                if( programs && programs.length )
                {
                    for( var i=0; i<programs.length; i++ )
                        entities.push( new Entity().init( programs[i] ) )
                }
            }

            return new Collection().init( entities, "Recent Purchases" );
        };

        return this.get( "getForYouPurchases", { cancelOnDemand: cancelOnDemand }, transform );
    };


    /**
     * Get a list of purchases for this account
     * @memberOf XtvApi
     * @returns {Promise <PurchaseCollection>}
     */
    XtvApi.prototype.getPurchases = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            return new PurchaseCollection().init( JSON.parse( response.data ), "Purchases" );
        };

        return this.get( "getPurchases", { cancelOnDemand: cancelOnDemand }, transform );
    };

    /**
     * Get a PurchasePin object
     * @memberOf XtvApi
     * @returns {Promise <PurchasePin>}
     */
    XtvApi.prototype.getPurchasePin = function()
    {
        var transform = function( response )
        {
            return new PurchasePin().init( JSON.parse( response.data ) );
        };

        return this.get( "getPurchasePinSettings", {}, transform );
    };

    /**
     * Get the result of the first 302 redirect associated with an xtvapi CDVR DASH url.
     * @memberOf XtvApi
     * @returns {Promise <Object>} Promise resolve with the url of the first redirect.
     */
    XtvApi.prototype.getRecordingRedirect = function( recordingId )
    {
        return this.get( "getStreamPlaybackUrl", { recordingId:recordingId }, function( response ) { return response.data; } );
    };

    /**
     * Get a list of rented VOD items.
     * @memberOf XtvApi
     * @return {Promise<Collection>}
     */
    XtvApi.prototype.getRentals = function( force , cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var data = JSON.parse(response.data);
            var vodItems = ( data && data._embedded ) ? data._embedded.watchedVodList : undefined;
            var list = [];

            if( vodItems )
            {
                for( var i=0; i<vodItems.length; i++ )
                    list.push( new Rental().init( vodItems[i] ) )
            }

            return new Collection().init(list,"Rentals", XtvApi.EntityRenderStyle.POSTER);
        };

        return this.get( "getVodWatched", { cancelOnDemand: cancelOnDemand }, transform, force );
    };

    /**
     * Get a list of resume points for this account
     * @memberOf XtvApi
     * @param {Number} [maxDaysOld] - Max number of days old. Defaults to 60.
     * @returns {Promise <ResumePoint[]>}
     */
    XtvApi.prototype.getResumePoints = function( maxDaysOld , cancelOnDemand)
    {
        var transform = function( response )
        {
            var resumePoints = [];
            var obj = JSON.parse( response.data );

            if( obj && obj._embedded )
            {
                var groups = obj._embedded.resumePointGroups;
                if( groups )
                {
                    for( var i = 0; i < groups.length; i++ )
                    {
                        var rp = groups[i]._embedded.lastUpdatedResumePoint;
                        if( rp )
                            resumePoints.push(new ResumePoint().init( rp ));
                    }
                }
            }

            return resumePoints;
        };

        return this.get( "getResumePoints", { maxDaysOld: maxDaysOld || 60, cancelOnDemand: cancelOnDemand || false }, transform );
    };

    /**
     * Get a list of recordings for this account
     * @memberOf XtvApi
     * @returns {Promise <RecordingCollection>}
     *
     * TODO: only bust cache after setting a recording?
     */
    XtvApi.prototype.getRecordings = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            return new RecordingCollection().init( JSON.parse( response.data ), "All Recordings" ); //TODO: not good for i18n - pass in the title? Or just put a setTitle on RecordingCollection
        };

        return this.get( "getRecordings", { cancelOnDemand : cancelOnDemand }, transform,true );
    };

    /**
     * Get a list of recent recordings. Max days is not configurable.
     * @memberOf XtvApi
     * @returns {Promise <RecordingCollection>}
     */
    XtvApi.prototype.getRecentRecordings = function()
    {
        var transform = function( response )
        {
            return new RecordingCollection().init( JSON.parse( response.data ), "Just Recorded", XtvApi.EntityRenderStyle.POSTER );
        };

        return this.get( "recentRecordings", {}, transform );
    };

    /**
     * Get a list of recently watched programs
     * @memberOf XtvApi
     * @returns {Promise <Collection>} Collection contains Recordings and/or VodShowings
     */
    XtvApi.prototype.getRecentlyWatched = function(limit, cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var result   = JSON.parse( response.data );
            var entities = [];

            if( result && result._embedded )
            {
                var list = result._embedded.recentlyWatchedAssets;

                for( var i = 0; i < list.length; i++ )
                {
                    if( list[i]._type === "s:VideoObject/Recording" )
                        entities.push( new Recording().init( list[i] ) );
                    else
                    {
                        var type = ( ( list[i]._embedded && list[i]._embedded.transactionDetails ) ? list[i]._embedded.transactionDetails.type : "" );
                        switch( type )
                        {
                            case( TransactionDetails.Type.RENTAL ) :
                                entities.push( new Rental().init( list[i] ) );
                                break;
                            case( TransactionDetails.Type.PURCHASE ) :
                                entities.push( new Purchase().init( list[i] ) );
                                break;
                            default:
                                entities.push( new VodShowing().init( list[i] ) );
                                break;
                        }
                    }
                }
            }

            return new Collection().init(entities,"Recently Watched", XtvApi.EntityRenderStyle.POSTER);
        };

        return this.get( "getRecentlyWatched", {limit:limit || 12, cancelOnDemand: cancelOnDemand }, transform );
    };

    /**
     * Get Recorder summary data for this account (% free, etc)
     * @memberOf XtvApi
     * @return {Promise <RecorderSummary>}
     */
    XtvApi.prototype.getRecorderSummary = function( force )
    {
        var transform = function( response )
        {
            return new RecorderSummary().init( JSON.parse( response.data ) );
        };

        return this.get( "getRecorderSummary", {}, transform, !!force );
    };

    /**
     * Get a block of linear schedules.
     * @memberOf XtvApi
     * @param {Number} startTime - Block start time as epoch datetime stamp.
     * @param hours
     * @returns {Promise <Object>} Returns channel array + block id
     */
    XtvApi.prototype.getScheduleBlock = function( startTime, hours , cancelOnDemand)
    {
        var transform = function( response )
        {
            var channels = [];
            var data     = JSON.parse( response.data );
            if( data && data._embedded )
            {
                var channelData = data._embedded.channels;
                if( channelData && channelData.length )
                {
                    for( var i = 0; i < channelData.length; i++ )
                        channels.push( new Channel().init( channelData[i], response.path ) )
                }
            }
            return { data:channels, blockId:startTime };
        };

        return this.get( "getTvGridChunk", { startTime: startTime, hours: hours , cancelOnDemand: cancelOnDemand}, transform );
    };

    /**
     * Get the linear showing for the given channel and time
     * @memberOf XtvApi
     * @param {string} channelId
     * @param {number} time
     * @returns {Promise <LinearShowing>}
     *
     * TODO: why not use the transform pattern here?
     */
    XtvApi.prototype.getLinearScheduleByTime = function( channelId, time )
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( response )
            {
                var data = JSON.parse( response );
                if( data && data._embedded )
                {
                    var channelData = data._embedded.channels[0];
                    if( channelData )
                    {
                        var listings = channelData._embedded.listings;
                        if( listings && listings.length )
                        {
                            for( var i=0; i<listings.length; i++ )
                            {
                                if( listings[i].startTime <= time && listings[i].endTime > time )
                                {
                                    new LinearShowing().init( listings[i] ).getDetail().then( resolve ).catch( reject );
                                    break;
                                }
                            }
                        }
                    }
                }
            };

            var error = function( error )
            {
                reject( error );
            };

            self.get( "getTvGridChunk", { startTime: ChannelCollection.getUniformBlockTime(time), hours: 4, channelIds:channelId } ).then( success ).catch( error );
        };

        return new Promise( resolver );
    };

    /**
     * Get a household's scheduled recordings
     * @memberOf XtvApi
     * @returns {Promise <Recording[]>}
     */
    XtvApi.prototype.getScheduledRecordings = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var transform = function( response )
        {
            var i, s, sid, entity, recording;

            var data       = JSON.parse( response.data );
            var recordings = data._embedded.recordings;
            var series     = data._embedded.entities;
            var recArray   = [];
            var seriesMap  = {};

            if( series.length )
            {
                for( i=0; i<series.length; i++ )
                {
                    s = new Entity().init(series[i]);
                    sid = s.getEntityId();
                    seriesMap[sid] = s;
                }
            }

            if( recordings.length )
            {
                for( i = 0; i < recordings.length; i++ )
                {
                    recording = new Recording().init( recordings[i] );
                    entity    = recording.getEntity();
                    sid       = recording.getSeriesId();

                    if( entity && sid && seriesMap[sid] )
                        entity.setSeries( seriesMap[sid] );

                    recArray.push( recording );
                }
            }

            return recArray;
        };

        return this.get( "getScheduledRecordingsWithEntities", { cancelOnDemand: cancelOnDemand }, transform );
    };

    /**
     * Get the global scheduled recordings data. NOTE: only available after asyc call to fetchRecordingMetadata completes.
     * @memberOf XtvApi
     * @return {ScheduledRecordings}
     */
    XtvApi.prototype.getScheduledRecordingMetadata = function()
    {
        return this._scheduledRecordings;
    };

    /**
     * Get the contents of a VOD folder with variable depth and number of programs.
     * @memberOf XtvApi
     * @param {BrowseCollection} folder       - The root folder for this query
     * @param {Number}          [depth]       - Number of child folder levels to retrieve. Defaults to 2.
     * @param {Number}          [maxPrograms] - Number of entities to retrieve for each folder. Defaults to 10.
     * @param {String}          [filters]     - Comma separated list of filters. Full set from XTVAPI docs: [closedcaption,hd,downloadable,tve,sap]
     * @param {Boolean}         [bustCache]   - Force new (non-cached) query
     * @returns {Promise} Promise resolves with the same {@BrowseCollection} with folder data populated.
     */
    XtvApi.prototype.getVodFolder = function( folder, depth, maxPrograms, filters, bustCache , cancelOnDemand)
    {
        cancelOnDemand = cancelOnDemand || false;

        var self = this;

        var resolver = function( resolve, reject )
        {
            var params = {};

            var success = function( response )
            {
                resolve( folder.init( JSON.parse( response.data ) ) );
            };

            var error = function( error )
            {
                reject( error );
            };

            params.depth       = depth || 2;
            params.maxPrograms = maxPrograms || 10;
            params.perPage     = maxPrograms || 50;
            params.filters     = filters;
            params.freetome    = ( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) ) ? "off" : "on";

            var url = XtvApi.replaceUrlParams( folder._data._links.browse.href, params );
            url = self._host + XtvApi.trimPath( url );

            if( bustCache )
                url += "&time=" + Date.now();

            _x2._network.ajax( { type: "GET", url: url, api:"browseNode", headers: [self._authHeader], accepts:Network.Accepts.xtv, cancelOnDemand: cancelOnDemand } ).then( success ).catch( error );
        };

        return new Promise( resolver );
    };

    /**
     * Get a SportsTeam entity
     * @memberOf XtvApi
     * @param teamId
     * @return {Promise}
     */
    XtvApi.prototype.getSportsTeamEntity = function( teamId )
    {
        return this.get( "getSportsTeamEntity", { teamId:teamId } )
    };

    /**
     * Get the root VOD folder
     * @memberOf XtvApi
     * @param {Number} [depth]       - Number of child folder levels to retrieve. Defaults to 2.
     * @param {Number} [maxPrograms] - Number of entities to retrieve for each folder. Defaults to 10.
     * @param {String} [filters]     - Comma separated list of filters. Full set from XTVAPI docs: [closedcaption,hd,downloadable,tve,sap]
     * @returns {Promise} Promise resolves with a {@link BrowseCollection} object
     */
    XtvApi.prototype.getVodRoot = function( depth, maxPrograms, filters , cancelOnDemand)
    {
        var params         = {};
        params.depth       = depth || 2;
        params.maxPrograms = ( isNaN( maxPrograms ) ? 7 : maxPrograms );
        params.filters     = filters;
        params.cancelOnDemand = cancelOnDemand || false;
        if( _x2._config._previewRoot === true )
            params.aliasName = "xtv-preview-root";

        var transform = function( response )
        {
            return new BrowseCollection().init( JSON.parse( response.data ) );
        };

        return this.get( "getBrowseRoot", params, transform );
    };

    /**
     * Remove a channel from favorites.
     * @memberOf XtvApi
     * @param selfLink
     * @return {Promise}
     */
    XtvApi.prototype.removeFavoriteChannel = function( selfLink )
    {
        return this.sendForm( "deleteFavoriteItems", { itemSelfLinks: '["' + selfLink + '"]' }, true );
    };

    /**
     * Remove any a program or sports team from favorites.
     * @memberOf XtvApi
     * @param selfLink
     * @return {Promise}
     */
    XtvApi.prototype.removeFavoriteItem = function( selfLink )
    {
        return this.sendForm( "deleteFavoriteItems", { itemSelfLinks: '["' + selfLink + '"]' }, true );
    };

    /**
     * Load recording data
     * @memberOf XtvApi
     * @return {Promise}
     */
    XtvApi.prototype.fetchScheduledRecordingMetadata = function( force )
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( result )
            {
                self._scheduledRecordings = new ScheduledRecordings().init( JSON.parse( result ) );
                resolve();
            };

            self.get( "getScheduledRecordingCandidates", {}, undefined, force ).then( success ).catch( reject );
        };

        return new Promise( resolver );
    };

    /**
     * Search by term
     * @memberOf XtvApi
     * @param {String} term - The character or string to search for
     * @param {Number} limit - The number of programs to return
     * @returns {Promise <SearchEntity[]>}
     */
    XtvApi.prototype.search = function( term, limit )
    {
        var transform = function( response )
        {
            var searchEntities = [];
            var resultObjects  = JSON.parse( response.data )._embedded.results;

            for( var i = 0; i < resultObjects.length; i++ )
                searchEntities.push( new SearchEntity().init( resultObjects[i] ) );

            return searchEntities;
        };

        var params = {};
        params.query    = encodeURIComponent( term );
        params.limit    = limit;
        params.freetome = ( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) ) ? "off" : "on";

        return this.get( "searchByTerm", params, transform );
    };

    /**
     * Set the name of the device;
     * @memberOf XtvApi
     * @param {String} name
     */
    XtvApi.prototype.setDeviceName = function( name )
    {
        return this.sendForm( "setDeviceName", { deviceName:name }, true );
    };

    /**
     * Set Parental Controls data
     * Use setParentalControlsSettings() or setParentalControlsRatings()
     * @memberOf XtvApi
     * @private
     * @param {ParentalControls} pcObject - Object wrapping PCs.
     * @param {String}           action   - The HAL link name
     * @returns {Promise}
     */
    XtvApi.prototype.setParentalControls = function( pcObject, action )
    {
        var node   = this._root._forms[action];
        var url    = this._host + node.action;
        var method = node.method;
        var data   = JSON.stringify(pcObject._data);
        var cType  = { name:'Content-Type', value:'application/json' };

        //remove the 'links' object from the settings before posting it back.
        var settings = JSON.parse(data);
        delete settings._links;
        data = JSON.stringify(settings);

        return _x2._network.ajax( { type:method, url:url, api:action, data:data, headers: [this._authHeader, cType] } );
    };

    /**
     * Set the parental controls ratings
     * @memberOf XtvApi
     * @param {ParentalControls} pcObject - Object wrapping PCs.
     * @returns {Promise} Success or fail callback only; no data.
     */
    XtvApi.prototype.setParentalControlsRatings = function( pcObject )
    {
        return this.setParentalControls( pcObject, "updateParentalControls2Ratings" );
    };

    /**
     * Set the parental controls settings (everything other than ratings)
     * @memberOf XtvApi
     * @param {ParentalControls} pcObject - Object wrapping PCs.
     * @returns {Promise} Success or fail callback only; no data.
     */
    XtvApi.prototype.setParentalControlsSettings = function( pcObject )
    {
        return this.setParentalControls( pcObject, "updateParentalControls2Settings" );
    };

    /**
     * Set a resume point
     * @memberOf XtvApi
     * @param {string} mediaId   - example: "mediaId:comcast:dvr:schedule:V4121208831986220730L200118670205123018"
     * @param {number} programId - example: 5696787302847616112
     * @param {number} progress  - elapsed time in milliseconds
     * @return {Promise}
     */
    XtvApi.prototype.setResumePoint = function ( mediaId, programId, progress )
    {
        return this.sendForm( "updateResumePoint", { mediaId:mediaId, programId:programId, progress:parseInt(progress) }, true );
    };

    /**
     * Submit a XTV API form, sending params as data key-value pairs.
     * @memberOf XtvApi
     * @param  {string}  api    - the name of the form (matches _root._forms[api])
     * @param  {Object}  params - A JSON object containing parameters. Example: {maxDaysOld:30,someOtherParam:'abc'}
     * @param  {boolean} auth   - Send the auth header
     * @return {Promise}
     */
    XtvApi.prototype.sendForm = function(api, params, auth)
    {
        var exec, self = this;

        exec = function( api, params )
        {
            var node, obj = {};

            if( self._root )
            {
                node = self._root._forms[api];

                if( node )
                {
                    var url, method, param, data = "";

                    url    = self._host + node.action;
                    method = node.method;

                    if( params )
                    {
                        for( param in params )
                        {
                            if( params.hasOwnProperty( param ) )
                            {
                                if( data.length > 0 )
                                    data += '&';

                                data += param + "=" + params[param];
                            }
                        }
                    }

                    obj.type = method;
                    obj.url  = url;
                    obj.data = data;
                    obj.contentType = 'application/x-www-form-urlencoded';

                    if( auth )
                        obj.headers = self.getAuthHeader();

                    //intercept the error so that on failure we can set the triggering API call.
                    var resolver = function( resolve, reject )
                    {
                        var error = function( error )
                        {
                            error.setApi( api );
                            reject( error );
                        };

                        _x2._network.ajax( obj ).then( resolve ).catch( error );
                    };

                    return new Promise( resolver );
                }
                else
                    return Promise.reject( new ApiError().init( { local:"XtvApi.sendForm: There is no API matching '" + api + "'"} ) );
            }
        };

        if( this._root )
            return exec( api, params );
        else // defer this call until root is loaded
            return this._rootPromise.then( function() { return exec( api, params ); } );
    };

    /**
     * Send recording playback heartbeat message
     * @memberOf XtvApi
     * @param recordingId
     */
    XtvApi.prototype.playbackRecordingHeartbeat = function( recordingId )
    {
        this.sendForm( "recordingHeartbeat", { recordingId: recordingId }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send recording playback stop message
     * @memberOf XtvApi
     * @param recordingId
     */
    XtvApi.prototype.playbackRecordingStopWatching = function( recordingId )
    {
        this.sendForm( "stopWatchingRecording", { recordingId: recordingId }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send recording playback finish messsage
     * @memberOf XtvApi
     * @param recordingId
     */
    XtvApi.prototype.playbackRecordingFinishWatching = function( recordingId )
    {
        this.sendForm( "finishWatchingRecording", { recordingId: recordingId }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send VOD playback heartbeat message
     * @memberOf XtvApi
     * @param paid
     */
    XtvApi.prototype.playbackVodHeartbeat = function( paid )
    {
        this.sendForm( "vodStreamHeartbeat", { paid: paid }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send VOD playback stop message
     * @memberOf XtvApi
     * @param paid
     */
    XtvApi.prototype.playbackVodStopWatching = function( paid )
    {
        this.sendForm( "stopWatchingVod", { paid: paid }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send VOD playback finish message
     * @memberOf XtvApi
     * @param paid
     */
    XtvApi.prototype.playbackVodFinishWatching = function( paid )
    {
        this.sendForm( "finishWatchingVod", { paid: paid }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send Linear playback heartbeat message
     * @memberOf XtvApi
     * @param streamId
     */
    XtvApi.prototype.playbackLinearHeartbeat = function( streamId )
    {
        this.sendForm( "linearStreamHeartbeat", { streamId: streamId }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Send linear playback stop message
     * @memberOf XtvApi
     * @param streamId
     */
    XtvApi.prototype.playbackLinearStopWatching = function( streamId )
    {
        this.sendForm( "stopWatchingLinearStream", { streamId: streamId }, true ).catch( function( error ){ console.log( error ) } );
    };

    /**
     * Provision Partner Device
     * @memberOf XtvApi
     * @param xact
     * @param saml
     * @param partnerId
     * @return {Promise<any>}
     */
    XtvApi.prototype.provisionPartnerDevice = function( xact, saml, partnerId )
    {
        return this.sendForm( "provisionPartnerDevice", { xact:encodeURIComponent( xact ), saml:saml, partnerId:partnerId }, false );
    };

    /**
     * Provision partner device and create session
     * @param xact
     * @param saml
     * @param partnerId
     * @param hardAcquisition
     * @return {Promise}
     */
    XtvApi.prototype.provisionPartnerDeviceAndCreateSession = function( xact, saml, partnerId, hardAcquisition )
    {
        return this.sendForm( "provisionAndCreateSession", { xact:encodeURIComponent( xact ), saml:saml, partnerId:partnerId, hardAcquisition:hardAcquisition }, false );
    };
    
    /**
     * Cancel all pending requests, which are block to load the current tab
     * 
     */

    XtvApi.prototype.cancelAllPendingRequests = function() 
    {
        _x2._network._pendingRequests.forEach( function(pendingRequest) {
            if( pendingRequest.status != 200 ) {
                pendingRequest.abort();
            }
        });
        _x2._network._pendingRequests = [];
    }

    return XtvApi;

})();

/**
 * Replaces values in url with corresponding property values from params. For example,
 * given url:
 * ```
 * "browse/node/{nodeId}/{menuId}/{?page,perPage,sort,filters,embedPlayNowDetail}"
 * ```
 * and params:
 * ```
 * { nodeId:123456, menuId:7891011, page:1, perPage:10, sort:name }
 * ```
 * this function will return:
 * ```
 * "browse/node/123456/7891011/?page=1&perPage=10&sort=name"
 * ```
 * Note that any url parameters without a corresponding param values will be dropped from
 * the url.
 * @global
 * @param url
 * @param params
 * @returns {string}
 */
XtvApi.replaceUrlParams = function( url, params )
{
    var tokens, start, props, prop, retval = '';

    if( typeof url === 'string' || url instanceof String )
    {
        tokens = url.split( /[\{\}]+/ ); //split the string on '{' and '}'

        if( tokens && tokens.length )
        {
            retval += tokens[0];

            for( var i = 1; i < tokens.length; i++ )
            {
                if( tokens[i].charAt( 0 ) === '?' || tokens[i].charAt( 0 ) === '&' ) // begins the query portion of url
                {
                    start = tokens[i].charAt( 0 ) === '?'; // take note if this is the beginning of the query
                    props = tokens[i].replace( /[\?\&]/, '' ).split( ',' );

                    if( props && props.length )
                    {
                        for( var j = 0; j < props.length; j++ )
                        {
                            prop = undefined;

                            if( params[props[j]] !== undefined ) //we were passed a value for this property
                                prop = props[j] + '=' + params[props[j]];
                            else if( props[j].indexOf('=') > 0 ) //this is a self-contained (key-value pair) url parameter
                                prop = props[j];

                            if( prop )
                            {
                                retval += ( start ? '?' : '&' ) + prop;
                                start = false;
                            }
                        }
                    }
                }
                else if( tokens[i].charAt( 0 ) === '/' )
                    retval += tokens[i];
                else if( params[tokens[i]] !== undefined )
                    retval += params[tokens[i]];
            }
        }
    }
    else
        console.log( "ERROR -> invalid parameter (url) passed to XtvApi.replaceUrlParams. Expecting String" );

    return retval;
}

/**
 * Trim all '../' paths from url.
 * @param {string} url
 * @return {string}
 */
XtvApi.trimPath = function( url )
{
    if( url )
        return url.replace( /(\.\.\/)/g, '' );
}




/***/ }),
/* 12 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Base class for all types which represent XTVAPI data.
 */
window.DataObject = (function()
{
    "use strict";

    function DataObject(){}

    DataObject.prototype.init = function( data )
    {
        this._data = data;
    };

    DataObject.prototype.addPath = function( keys, object )
    {
        var i, path, key;

        if( this._data )
        {
            path = this._data;

            for( i=0; i<keys.length; i++ )
            {
                key = keys[i];

                if( i === keys.length - 1 )
                    path[key] = object;
                else
                {
                    if( ! path[key] )
                        path[key] = {};
                    path = path[key];
                }
            }
        }
    };

    DataObject.prototype.get = function( key )
    {
        if( this._data )
            return this._data[key];
    };

    DataObject.prototype.getDate = function( key )
    {
        var data = this.get(key);
        var value = !isNaN(data) ? parseInt(data) : data; //handle both "1559050403302" and 1559050403302

        if( value )
            return new Date(value);
    };

    DataObject.prototype.getMeta = function()
    {
        return this._meta || {};
    };

    DataObject.prototype.getPath = function( keys, object )
    {
        var i, value, root = object ? object : this._data;

        if( root )
        {
            value = root;
            for( i=0; i<keys.length; i++ )
            {
                value = value[ keys[i] ];
                if( value === undefined )
                    break;
            }
        }

        return value;
    };

    DataObject.prototype.getLink = function( key, params )
    {
        var link;

        if( this._data && this._data._links )
        {
            if( this._data._links[key] )
            {
                link = this._data._links[key].href;

                if( params )
                    link = XtvApi.replaceUrlParams( link, params );
            }
        }

        return link;
    };

    DataObject.prototype.getLinkObject = function( key )
    {
        if( this._data && this._data._links )
            if( this._data._links[key] )
                return new Link().init( this._data._links[key] );
    };

    DataObject.prototype.getEmbedded = function( key )
    {
        if( this._data && this._data._embedded )
            return this._data._embedded[key];
    };

    DataObject.prototype.getForm = function( key )
    {
        var form;

        if( this._data && this._data._forms )
        {
            if( this._data._forms[key] )
                form = new Form().init(this._data._forms[key], key);
        }

        return form;
    };

    DataObject.prototype.getBoolean = function( key )
    {
        return !!this.get( key );
    };

    DataObject.prototype.getInteger = function( key )
    {
        var value = -1;

        if( this._data )
        {
            value = this._data[key];

            if( value && !isNaN( value ) )
                value = parseInt( value );
        }

        return value;
    };

    DataObject.prototype.getByPriority = function( a, b, c )
    {
        var value = this._data[a];

        if( value === undefined && b )
            value = this._data[b];

        if( value === undefined && c )
            value = this._data[c];

        return value;
    };

    DataObject.prototype.getData = function()
    {
        return this._data;
    };

    DataObject.prototype.removePath = function( keys )
    {
        var i, key, path;

        if( this._data )
        {
            path = this._data;
            for( i=0; i<keys.length; i++ )
            {
                key = keys[i];
                if( path[key] === undefined )
                    break;
                else
                {
                    if( i === keys.length - 1 )
                        path[key] = undefined;
                    else
                        path = path[key];
                }
            }
        }
    };

    DataObject.prototype.setMeta = function( meta )
    {
        this._meta = meta;
    };

    return DataObject;
})();


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ThumbnailEntity = (function()
{
    "use strict";

    function ThumbnailEntity(){}

    ThumbnailEntity.prototype = new DataObject();

    ThumbnailEntity.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    return ThumbnailEntity;
})();


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Aggregates entity-related data and provides convenience methods for extracting them. The point of this
 * object is to consolidate all async Entity calls into one. It can also take advantage of some
 * redundancy in entityOptions and upcomingListings calls to provide some durability if one call fails.
 */
window.EntityOptions = (function()
{
    "use strict";

    EntityOptions.prototype = new DataObject();

    EntityOptions.programsPerPage = 25;

    function EntityOptions(){}

    EntityOptions.prototype.init = function( entity )
    {
        this._entity = entity;

        this._episodes    = [];
        this._seasons     = [];
        this._vodShowings = [];
        this._recordings  = [];
        this._upcoming    = [];
        this._offers      = [];

        return this;
    };

    EntityOptions.prototype.fetch = function( force )
    {
        var p = [];
        p.push( this.fetchUpcoming() );
        p.push( this.fetchWatchOptions( force ) );
        return Promise.all( p );
    };

    /**
     * @private
     */
    EntityOptions.prototype.fetchWatchOptions = function( force )
    {
        var self = this;
        var parameters = {};
        parameters.freetome                = ( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) ) ? "off" : "on";
        parameters.embedSeasonWatchOptions = "none";
        parameters.embedWatchNow           = true;
        parameters.programsPerPage         = EntityOptions.programsPerPage;

        var resolver = function(resolve, reject)
        {
            var success = function( response )
            {
                var watchOptions = JSON.parse( response.data );
                self.setWatchOptions( watchOptions._embedded );

                resolve()
            };

            var fail = function(error)
            {
                reject( error );
            };

            var link = self._entity.getLinkObject("watchOptions");

            if( link )
                link.resolve( parameters, {}, force ).then(success).catch(fail);
            else
                resolve();
        };

        return new Promise(resolver);
    };

    EntityOptions.prototype.getSeriesRecordingForm = function()
    {
        if( this._upcoming ) //NOTE: every episode should have the same series recording form
            if( this._upcoming.length )
                return this._upcoming[0].getSeriesRecordingForm();
    };

    /**
     * @private
     */
    EntityOptions.prototype.fetchUpcoming = function()
    {
        var self = this;
        var parameters = {};
        parameters.freetome = ( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) ) ? "off" : "on";

        this._upcoming = [];

        var resolver = function(resolve, reject)
        {
            var success = function( response )
            {
                var upcoming = JSON.parse( response.data );
                self.setUpcoming( upcoming._embedded );

                resolve()
            };

            var fail = function(error)
            {
                console.log( error );
                reject( error );
            };

            var link = self._entity.getLinkObject("upcomingListings");

            if( link )
                link.resolve( parameters ).then( success ).catch( fail );
            else
                resolve();
        };

        return new Promise(resolver);
    };

    EntityOptions.prototype.getOnNowListings = function()
    {
        var upcoming, i, listing, onNow = [], now = Date.now();

        upcoming = this.getUpcomingListings();
        for( i = 0; i < upcoming.length; i++ )
        {
            listing = upcoming[i];
            if( listing.getStartTime() < now && listing.getEndTime() > now )
                onNow.push( listing );
        }

        return onNow;
    };

    EntityOptions.prototype.getContentProvider = function()
    {
        return this._contentProvider;
    };

    EntityOptions.prototype.getEpisodes = function()
    {
        return this._episodes;
    };

    EntityOptions.prototype.getRecordings = function()
    {
        return this._recordings;
    };

    EntityOptions.prototype.getSeasons = function()
    {
        return this._seasons;
    };

    EntityOptions.prototype.getTransactionOffers = function()
    {
        return this._offers;
    };

    EntityOptions.prototype.getUpcomingListings = function()
    {
        if( this._upcoming.length === 0 )
        {
            //For some entities (sporting events) the upcoming listings are embedded rather than linked
            if( this._entity )
            {
                var listings = this.getPath(["_embedded", "upcomingListings", "_embedded", "listings"], this._entity._data );

                if( listings && listings.length )
                {
                    for( var i=0; i<listings.length; i++ )
                        this._upcoming.push( new LinearShowing().init(listings[i]) );
                }
            }
        }

        return this._upcoming;
    };

    EntityOptions.prototype.getVodShowings = function()
    {
        return this._vodShowings;
    };

    /**
     * Return true if this entity has a transactional BUY option
     * @return {boolean}
     */
    EntityOptions.prototype.hasBuyOption = function()
    {
        var i, buyOption = false;

        for( i=0; i<this._offers.length; i++ )
        {
            if( this._offers[i].getPurchaseType() === "Buy" )
            {
                buyOption = true;
                break;
            }
        }

        return buyOption;
    };

    /**
     * Return true if this entity has a transactional RENT option
     * @return {boolean}
     */
    EntityOptions.prototype.hasRentOption = function()
    {
        var i, rentOption = false;

        for( i=0; i<this._offers.length; i++ )
        {
            if( this._offers[i].getPurchaseType() === "Rent" )
            {
                rentOption = true;
                break;
            }
        }

        return rentOption;
    };

    /**
     * Return true if this entity has a transactional SUBSCRIBE option
     * @return {boolean}
     */
    EntityOptions.prototype.hasSubscribeOption = function()
    {
        return this._subscribeOffer !== undefined;
    };

    EntityOptions.prototype.isWatchable = function()
    {
        var watchable = false;

        if( this._entity.getType() !== XtvApi.EntityType.SERIES )
        {
            watchable = this._vodShowings.length > 0 || this._recordings.length > 0;

            if( watchable !== true )
            {
                if( this._upcoming.length > 0 )
                {
                    for( var i=0; i<this._upcoming.length; i++ )
                    {
                        if( this._upcoming[i].isWatchable() )
                        {
                            watchable = true;
                            break;
                        }
                    }
                }
            }

            return watchable;
        }
    };

    EntityOptions.prototype.getEpisodeCount = function()
    {
        return this._episodes.length;
    };

    EntityOptions.prototype.getSeasonCount = function()
    {
        return this._seasons.length;
    };

    EntityOptions.prototype.getResumePoint = function()
    {
        var i, j, rpMediaId, sMediaId, showing, resumePoint, showings = [];

        if( _x2._resume && _x2._resume.length )
        {
            showings = showings.concat( this.getRecordings() );
            showings = showings.concat( this.getVodShowings() );

            for( i=0; i<_x2._resume.length; i++ )
            {
                rpMediaId = _x2._resume[i].getMediaId();

                for( j=0; j<showings.length; j++ )
                {
                    showing = showings[j];
                    sMediaId = showing.getMediaId();

                    if( sMediaId )
                    {
                        if( rpMediaId === sMediaId )
                        {
                            showing.setEntity( this._entity ); //add the entity reference to the resume point. needed by watch()
                            resumePoint = _x2._resume[i];
                            resumePoint.setShowing( showing );
                            break;
                        }
                    }
                }
                if( resumePoint )
                    break;
            }
        }

        return resumePoint;
    };

    EntityOptions.prototype.getMinsRemaining = function()
    {
        var remaining = 0, showing, rp = this.getResumePoint();
        if( rp )
        {
            showing = rp.getShowing();
            if( showing )
                remaining = showing.getMinsRemaining();
        }

        return remaining;
    };

    EntityOptions.prototype.getSubscribeOffer = function()
    {
        return this._subscribeOffer;
    };

    EntityOptions.prototype.hasShowingWithProperty = function( property )
    {
        var i, showings = this.getVodShowings();
        if( showings )
            for( i=0; i<showings.length; i++ )
                if( showings[i].get(property) === true )
                    return true;
    };

    EntityOptions.prototype.hasCcShowing = function()
    {
        return this.hasShowingWithProperty( "closedCaption" );
    };

    EntityOptions.prototype.hasDvsShowing = function()
    {
        return this.hasShowingWithProperty( "hasDVS" );
    };

    EntityOptions.prototype.hasHdShowing = function()
    {
        return this.hasShowingWithProperty( "isHD" );
    };

    EntityOptions.prototype.hasSapShowing = function()
    {
        return this.hasShowingWithProperty( "isSAP" );
    };

    /**
     * Set upcoming listings data
     * @param upcoming
     */
    EntityOptions.prototype.setUpcoming = function( upcoming )
    {
        var i, j, program, listing, listings, programs;

        listings = upcoming["listings"];
        if( listings ) //Grid > Series Info
        {
            for( i=0; i<listings.length; i++ )
                this._upcoming.push( new LinearShowing().init( listings[i]) );
        }

        programs = upcoming["programs"];
        if( programs )
        {
            for( i=0; i<programs.length; i++  )
            {
                program = new Entity().init(programs[i]);

                //if this is episode, add a series reference
                if( program.getType() === XtvApi.EntityType.EPISODE )
                    program.setSeries( this._entity );

                listings = program.getPath(["_embedded", "upcomingListings", "_embedded","listings"]);

                for( j=0; j<listings.length; j++ )
                {
                    listing = new LinearShowing().init( listings[j] );

                    //add the program reference to each showing
                    listing.setEntity( program );

                    this._upcoming.push( listing );
                }
            }
        }
    };

    /**
     * Set watch options data
     * @param watchOptions
     */
    EntityOptions.prototype.setWatchOptions = function( watchOptions )
    {
        this._episodes    = [];
        this._seasons     = [];
        this._vodShowings = [];
        this._recordings  = [];
        this._offers      = [];

        if( watchOptions )
        {
            //get content provider
            this._contentProvider = new ContentProvider().init( watchOptions["contentProvider"] );

            //parse VOD showings
            var i, transaction, vodShowings = watchOptions["vodItems"];
            if( vodShowings )
            {
                for( i=0; i<vodShowings.length; i++ )
                {
                    transaction = this.getPath( ["_embedded","transactionDetails"], vodShowings[i] );
                    if( transaction )
                    {
                        if( transaction.type === TransactionDetails.Type.RENTAL )
                            this._vodShowings.push( new Rental().init( vodShowings[i]) );
                        else
                            this._vodShowings.push( new Purchase().init( vodShowings[i]) );
                    }
                    else
                        this._vodShowings.push( new VodShowing().init( vodShowings[i]) );
                }

                if( this._vodShowings.length > 1 )
                    this._vodShowings.sort( function( a, b ) { return a.isHD() ? -1 : 1 } );
            }

            //parse recordings
            var recording, recordings = watchOptions["recordings"];
            if( recordings )
            {
                for( i=0; i<recordings.length; i++ )
                {
                    recording = new Recording().init(recordings[i]);
                    if( recording.isCheckedOut() !== true )
                        this._recordings.push( new Recording().init( recordings[i]) );
                }
            }

            //parse rent/buy offers
            var offer, offers = watchOptions["offers"];
            if( offers )
            {
                for( i=0; i<offers.length; i++ )
                {
                    offer = new TransactionOffer().init( offers[i] );

                    //NOTE: a subscribe offer can have the type "unsupportedUpsell", since we're only pushing an info overlay for Subscribe, don't consider if the offer is supported.
                    if( offer.getPurchaseType() === TransactionOffer.PurchaseType.SUBSCRIBE )
                        this._subscribeOffer = offer;
                    else if( offer.isSupported() )
                        this._offers.push( offer );
                }

                if( this._offers.length > 1 )
                {
                    var offerSort = function( a, b )
                    {
                        //order by HD>SD then Rent>Buy then Episode>Season
                        if( a.getVideoQuality() !== b.getVideoQuality() )
                            return ( a.getVideoQuality() === "HD"     ? -1 : 1 );
                        else if( a.getPurchaseType() !== b.getPurchaseType() )
                            return ( a.getPurchaseType() === "Rent"   ? -1 : 1 );
                        else
                            return ( a.getOfferType()    === "Single" ? -1 : 1 );
                    };

                    this._offers.sort( offerSort );
                }
            }

            //parse seasons
            var seasonList = watchOptions["tvSeasons"];
            if( seasonList )
            {
                for( i = 0; i < seasonList.length; i++ )
                    this._seasons.push( new Season().init( seasonList[i] ) );
            }
        }
    };

    return EntityOptions;
})();


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Maps to a XTV "creativeWorkEntity" object
 * Represents a Movie, Series, Episode or other program.
 */
window.Entity = (function()
{
    "use strict";

    Entity.prototype = new DataObject();

    function Entity(){}

    /**
     * Initialize the object
     * @param {Object} data - XTV derived JSON object
     * @return {Entity}
     */
    Entity.prototype.init = function(data)
    {
        DataObject.prototype.init.call( this, data );

        return this;
    };

    /**
     * Get the 'away' SportsTeam for entity where _type === SportingEvent
     * @return {SportsTeam}
     */
    Entity.prototype.getAwayTeam = function()
    {
        if( ! this._awayTeam )
        {
            var team = this.getEmbedded("awayTeam");
            if( team )
                this._awayTeam = new SportsTeam().init(team);
        }

        return this._awayTeam;
    };

    /**
     * Get the 'home' SportsTeam for entity where _type === SportingEvent
     * @return {SportsTeam}
     */
    Entity.prototype.getHomeTeam = function()
    {
        if( ! this._homeTeam )
        {
            var team = this.getEmbedded("homeTeam");
            if( team )
                this._homeTeam = new SportsTeam().init(team);
        }

        return this._homeTeam;
    };

    /**
     * Get a list of credits
     * @memberOf Entity
     * @return {Array} List of names (String)
     */
    Entity.prototype.getCredits = function()
    {
        return this.get( "credits" )
    };

    /**
     * Get the program description
     * @memberOf Entity
     * @return {String}
     */
    Entity.prototype.getDescription = function()
    {
        return this.getByPriority( "description", "derivedDescription" );
    };

    /**
     * Get the program duration (NOTE: Showing may contain more accurate duration)
     * @memberOf Entity
     * @return {Number} Duration in minutes
     */
    Entity.prototype.getDuration = function()
    {
        return this.getInteger( "duration" ) / 60000;
    };

    /**
     * Get the entity id
     * @return {String} Entity's program id
     */
    Entity.prototype.getEntityId = function()
    {
        return this.get( "programId" );
    };

    /**
     * Get the program's episode number. Applies when this.getType() === XtvApi.EntityType.EPISODE
     * @memberOf Entity
     * @return {Number}
     */
    Entity.prototype.getEpisodeNumber = function()
    {
        return this.get( "episodeNumber" );
    };

    /**
     * Return the episode number or -1 if undefined
     * @memberOf Entity
     * @return {Number}
     */
    Entity.prototype.getEpisodeSortNumber = function()
    {
        return this.getEpisodeNumber() || -1;
    };

    /**
     * Get the secondary/fallback image URL for this program
     * @param width
     * @param height
     * @memberOf Entity
     * @return {String}
     */
    Entity.prototype.getFallbackImageLink = function(width, height)
    {
        var link = this.getLink( "fallbackImage" );

        if( link )
            link = XtvApi.replaceUrlParams( link, { width:width, height:height } );

        return link;
    };

    /**
     * Get the the primary image URL for this program
     * @memberOf Entity
     * @param {Number} width - Image width
     * @param {Number} height - Image height
     * @return {String}
     */
    Entity.prototype.getImageLink = function(width, height)
    {
        var link, image = this.getLink( "image" );

        //TODO: do we really need this + a getFallbackImageLink function?
        if( image === undefined )
            image = this.getLink( "fallbackImage" );

        if( image )
        {
            link = XtvApi.replaceUrlParams( image, { width:width, height:height } );
            link = link.replace( /&default=force/, "" ); // HACK: Removing the default=force is a temporary hack to prevent getting just the background image.
        }

        return link;
    };

    Entity.prototype.getRating = function()
    {
        return this.getPath( [ "contentRating/detailed", "name" ] );
    };

    /**
     * Get the year this program was release. Can contain range i.e. "2006-"
     * @memberOf Entity
     * @return {String}
     */
    Entity.prototype.getYear = function()
    {
        return this.get( "releaseYear" );
    };

    /**
     * Get a list of reviews (i.e. Rotten Tomatoes) for this program
     * @memberOf Entity
     * @return {Array} of {@link Review} objects
     */
    Entity.prototype.getReviews = function()
    {
        if( ! this._reviews )
        {
            var i, reviews = this.getEmbedded( "programReviews" );

            this._reviews = [];

            if( reviews && reviews.length )
            {
                for( i = 0; i < reviews.length; i++ )
                    this._reviews.push( new Review().init( reviews[i] ) );
            }
        }

        return this._reviews;
    };

    /**
     * Get the Rotten Tomato review for this program
     * @member Entity;
     * @return {Review}
     */
    Entity.prototype.getReview = function( type )
    {
        var i, review, reviews = this.getReviews();

        if( reviews && reviews.length )
        {
            for( i=0; i<reviews.length; i++ )
            {
                if( reviews[i].getProvider() === type )
                {
                    review = reviews[i];
                    break;
                }
            }
        }

        return review;
    };

    /**
     * Get the Rotten Tomato review for this program
     * @member Entity;
     * @return {Review}
     */
    Entity.prototype.getRottenTomatoReview = function()
    {
        return this.getReview( "RT" );
    };

    /**
     * Get the Common Sense Media review for this program
     * @member Entity;
     * @return {Review}
     */
    Entity.prototype.getCommonSenseMediaReview = function()
    {
        return this.getReview( "CSM" );
    };

    /**
     * Get the program's season number. Applies when this.getType() === XtvApi.EntityType.EPISODE.
     * @memberOf Entity
     * @returns {Number}
     */
    Entity.prototype.getSeasonNumber = function()
    {
        return this.getPath( [ "partOfSeason", "seasonNumber" ] );
    };

    /**
     * Get the objects self link
     * @return {String}
     */
    Entity.prototype.getSelfLink = function()
    {
        return this.getLink("self");
    };

    /**
     * Get the link/URL to query for the program's series. Applies when this.getType() === XtvApi.EntityType.EPISODE.
     * @memberOf Entity
     * @returns {String}
     */
    Entity.prototype.getTvSeriesLink = function()
    {
        return this.getLink( "partOfTvSeries" );
    };

    /**
     * Get the series associated with this episode.
     * @return {Entity|*}
     */
    Entity.prototype.getSeries = function()
    {
        if( ! this._series )
        {
            var series = this.getEmbedded("partOfTvSeries");

            if( series )
                this._series = new Entity().init( series )
        }
        return this._series;
    };

    /**
     * Return the series id extracted from _links
     */
    Entity.prototype.getSeriesId = function()
    {
        var id, series, link;

        series = this.getSeries();

        if( series )
            id = series.getEntityId();

        if( ! id )
        {
            link = this.getLink("partOfTvSeries");
            if( link )
            {
                var tokens = link.split('/');
                if( tokens && tokens.length )
                    id = tokens[tokens.length-2];
            }
        }

        return id;
    };

    /**
     * Get the title of this program
     * @memberOf Entity
     * @returns {string}
     */
    Entity.prototype.getTitle = function()
    {
        return this.get( "name" );
    };

    /**
     * Get this program's type
     * @memberOf Entity
     * @returns {XtvApi.EntityType}
     */
    Entity.prototype.getType = function()
    {
        var type, programType = this.getByPriority( "type", "_type" );

        switch( programType )
        {
            case "s:Movie":
                type = XtvApi.EntityType.MOVIE;
                break;
            case "s:TvSeries":
                type = XtvApi.EntityType.SERIES;
                break;
            case "s:TVEpisode":
                type = XtvApi.EntityType.EPISODE;
                break;
            case "s:SportsEvent":
                type = XtvApi.EntityType.SPORTS;
                break;
            default:
                type = XtvApi.EntityType.OTHER;
        }

        return type;
    };

    /**
     * Get the entity watch options. NOTE: ASYNC METHOD! Callers should make this call once and do all work when the promise resolves.
     * A new EntityOptions object will be returned on each call.
     */
    Entity.prototype.fetchEntityOptions = function( force )
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function() { resolve( self._options ) };

            self._options = new EntityOptions().init( self );
            self._options.fetch( force ).then( success ).catch( reject );
        };

        return new Promise(resolver);
    };

    /**
     * Follow entityRecording link.
     * @return {Promise}
     */
    Entity.prototype.fetchEntityRecording = function(force)
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( result )
            {
                self._entityRecording = new EntityRecording().init( JSON.parse(result.data) );
                resolve();
            };

            var link = self.getLinkObject( "entityRecording" );

            if( link )
                link.resolve({},"getEntityRecording",force).then( success ).catch( reject );
            else
                resolve();
        };

         return new Promise( resolver );
    };

    /**
     * Get the watch options for this entity. These may have been created from a call to fetchEntityOptions
     * or they may be embedded in the entity data. If fetch was not called create the options from internal
     * data.
     */
    Entity.prototype.getEntityOptions = function()
    {
        if( ! this._options )
        {
            this._options = new EntityOptions().init( this );
            this._options.setWatchOptions( this.getPath(["_embedded", "watchOptions","_embedded"]) );
        }

        return this._options; //TODO: warn if options were not set, but always return the object
    };

    /**
     * Get the entity (series) recording. NOTE: only available after async fetchEntityRecording resolves
     * @return {Recording}
     */
    Entity.prototype.getEntityRecording = function()
    {
        return this._entityRecording;
    };

    /**
     * Return true if this program is marked as adult content
     * @memberOf Entity
     * @returns {Boolean}
     */
    Entity.prototype.isAdult = function()
    {
        return this.get( "isAdult" );
    };

    /**
     * Set the series for this entity (episode). Some XTVAPI result sets require us to manually merge data (i.e. Recording lists)
     * @param series
     */
    Entity.prototype.setSeries = function( series )
    {
        this._series = series;
    };

    return Entity;

})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved
/*
    This class wraps/normalizes errors from API calls. There are two error response signatures
    possible for errors received in the AJAX response.

    This is also used to wrap errors thrown internally (params.local), for example when we receive a
    valid http response (200) with invalid data.

    example xtvapi.cloudtv.comcast.net response:
    {
        "reason": "Bad CloudDvr Token",
        "statusCode": 403,
        "statusSubCode": "403-103"
    }
*/

/**
 * @class
 */
window.ApiError = ( function()
{
    "use strict";

    function ApiError(){}

    /**
     * Initialize the object with either and http object or error/description
     * @param {Object} params
     * @param {XMLHttpRequest} [params.http]  - error coming from http request (XMLHttpRequest) call
     * @param {Object}         [params.flash] - provisioning/drm/media error returned from a 3rd party library (security client or player platform)
     * @param {string}         [params.local] - string describing error triggered by the app.
     * @return {ApiError}
     */
    ApiError.prototype.init = function( params )
    {
        var response, responseObj;

        if( params.http )
        {
            response = params.http.response;
            if( response )
            {
                try //try to parse out properties from known JSON responses
                {
                    responseObj = JSON.parse( response );

                    if( responseObj.statusCode ) //xtvapi
                    {
                        this._major       = responseObj.statusCode;
                        this._description = responseObj.reason;

                        if( responseObj.statusSubCode )
                            this._minor = responseObj.statusSubCode.split('-')[1];
                    }
                    else if( responseObj.error ) //login.comcast.net
                    {
                        this._major       = params.http.status;
                        this._minor       = responseObj.error;
                        this._description = responseObj.description;
                    }
                }
                catch(e)
                {
                    console.log( "WARNING -- Unexpected error payload:" + response );
                }
            }

            //default to http status if the error metadata was not found.
            if( this._major === undefined )
                this._major = params.http.status;

            if( params.api )
                this._api = params.api;

            this._httpStatus   = params.http.status;
            this._httpResponse = params.http.response;
        }
        else if( params.flash )
        {
            var error = params.flash;

            if( error.major )
            {
                if( error.major.indexOf && error.major.indexOf('.') !== -1 )
                {
                    var tokens = error.major.split('.');
                    this._major = tokens[0];
                    this._minor = tokens[1];
                }
                else
                {
                    this._major = error.major;
                    this._minor = error.minor;
                }
            }

            this._description = error.description;
        }
        else
            this._description = params.local;

        return this;
    };

    ApiError.prototype.getMajor = function()
    {
        var retval = (this._major === null) ? undefined : this._major;

        if( isNaN(retval) === false )
            retval = retval.toString();

        return retval;
    };

    ApiError.prototype.getMinor = function()
    {
        var retval = (this._minor === null) ? undefined : this._minor;

        if( isNaN(retval) === false )
            retval = retval.toString();

        return retval;
    };

    ApiError.prototype.getHttpResponse = function()
    {
        return this._httpResponse;
    };

    ApiError.prototype.getHttpStatus = function()
    {
        return this._httpStatus;
    };

    ApiError.prototype.getDescription = function()
    {
        return this._description;
    };

    ApiError.prototype.toString = function()
    {
        return "ERROR (ApiError) >> api:" + this._api + " major:" + this._major + " minor:" + this._minor + " description:" + this._description;
    };

    ApiError.prototype.setApi = function( api )
    {
        this._api = api;
    };

    ApiError.prototype.getApi = function()
    {
        return this._api;
    };

    return ApiError;
})();


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Represents  a collection of {@link BrowseEntity} and/or other (@link BrowseCollection} objects.
 * Synonymous with VodFolder, but can contain objects other than VOD entities. Also Contains style
 * information for the collection.
 *
 * Maps to a XTV "BrowseCollection" (node._type = "BrowseCollection").
 *
 */

window.BrowseCollection = ( function()
{
    "use strict";

    BrowseCollection.prototype = new DataObject();

    function BrowseCollection(){}

    /**
     * Initialize the object
     * @memberOf BrowseCollection
     * @param {Object} data - XTV derived JSON object
     * @param {BrowseCollection} [collection] - collection which contains this collection (parent)
     * @return {BrowseCollection}
     */
    BrowseCollection.prototype.init = function( data, collection )
    {
        DataObject.prototype.init.call( this, data );

        this._embedded = undefined;

        if( collection ) //NOTE: don't overwrite parent we re-init this folder.
            this._parent = collection;

        return this;
    };

    /**
     * Get the rendering style for embedded content
     * @memberOf BrowseCollection
     * @return {String}
     * @todo we should probably return a constant
     */
    BrowseCollection.prototype.getChildRenderStyle = function()
    {
        var retval;

        if( this.getCollectionRenderStyle() === XtvApi.CollectionRenderStyle.NETWORK_ENTITY )
            retval = XtvApi.EntityRenderStyle.NETWORK; //NOTE: NETWORK_ENTITY collections are missing childTileRenderStyle, presumably b/c it's implied.
        else
            retval = this.get("childTileRenderStyle");

        return retval;
    };

    /**
     * Get the rendering style for this collection
     * @memberOf BrowseCollection
     * @return {String}
     * @todo we should probably return a constant
     */
    BrowseCollection.prototype.getCollectionRenderStyle = function()
    {
        return this.get("collectionRenderStyle");
    };

    /**
     * Shortcut to getEmbeddedBrowseItems to support (implicit) Collection interface
     * @memberOf BrowseCollection
     * @return {Array} Collection of {@link BrowseEntity} and/or {@link BrowseCollection} objects
     */
    BrowseCollection.prototype.getEntities = function()
    {
        return this.getEmbeddedBrowseItems();
    };

    /**
     * Get the fallback URL for the poster image
     * @memberOf BrowseCollection
     * @param {Number} width  - Image width
     * @param {Number} height - Image height
     * @return {String}
     */
    BrowseCollection.prototype.getFallbackImageLink = function( width, height )
    {
        var link = this.getProgramFallbackImageLink();
        return XtvApi.replaceUrlParams( link.href, { entityId: this.getId(), width: width, height: height } );
    };

    /**
     * Get the collection ID.
     * @memberOf BrowseCollection
     * @return {String}
     */
    BrowseCollection.prototype.getId = function()
    {
        return this.get("slug");
    };

    /**
     * Get the URL for the poster image
     * @memberOf BrowseCollection
     * @param {Number} width  - Image width
     * @param {Number} height - Image height
     * @return {String}
     */
    BrowseCollection.prototype.getImageLink = function( width, height )
    {
        var link;

        if( this.getCollectionRenderStyle() === XtvApi.CollectionRenderStyle.NETWORK_ENTITY )
            link = this.getNetworkImageLink( width, height );
        else
        {
            link = this.getProgramImageLink();
            if( link )
                link = XtvApi.replaceUrlParams( link, { entityId: this.getId(), width: width, height: height } );
        }

        return link;
    };

    /**
     * Get all embedded (child) objects for this collection.
     * @memberOf BrowseCollection
     * @return {Array} Collection of {@link BrowseEntity} and/or {@link BrowseCollection} objects
     */
    BrowseCollection.prototype.getEmbeddedBrowseItems = function()
    {
        if( !this._embedded )
        {
            var i, items, entity, itemCount;

            this._embedded = [];

            items = this.getEmbedded("browseItems");

            if( items && items.length )
            {
                itemCount = this.get("totalBrowseItems") ? this.get("totalBrowseItems") : items.length;

                //Add a "View All" entity the collection render style is BROWSE and there are more than 12 items.
                if( this.getCollectionRenderStyle() === XtvApi.CollectionRenderStyle.BROWSE && itemCount > 12 )
                {
                    if( this.getChildRenderStyle() !== "4X3_PROGRAM_LINEAR" && this.getChildRenderStyle() !== "3X4_PROGRAM_LINEAR" )
                    {
                        var all = new BrowseCollection().init( this._data );
                        all.setMeta( { all: true } );
                        this._embedded.push( all );
                    }
                }

                for( i = 0; i < items.length; i++ )
                {
                    entity = this.initObject( items[i] );
                    if( entity )
                        this._embedded.push( entity );
                }
            }
        }

        return this._embedded;
    };

    /**
     * Get the fallback image URL used to get program images for this and contained entities.
     * @memberOf BrowseCollection
     * @return {String} URL
     */
    BrowseCollection.prototype.getProgramFallbackImageLink = function()
    {
        var link = this.getLink("programFallbackImageLink");

        if( !link )
            link = this._parent.getProgramFallbackImageLink();

        return link;
    };

    /**
     * Get the network logo URL
     * @memberOf BrowseCollection
     * @param {Number} width
     * @param {Number} height
     * @return {String} URL
     */
    BrowseCollection.prototype.getNetworkImageLink = function( width, height )
    {
        var link, provider = this.getEmbedded("contentProvider");

        if( provider )
        {
            link = this.getPath(["_links", "logo", "href"], provider);
            if( link )
                link = XtvApi.replaceUrlParams( link, { width: width, height: height } );
        }
        else
            console.log( "Warning: No network image." );

        return link;
    };

    /**
     * Get the primary image URL used to get program images for this and contained entities.
     * @memberOf BrowseCollection
     * @return {String} URL
     */
    BrowseCollection.prototype.getProgramImageLink = function()
    {
        var link = this.getLink("programImageLink");

        if( !link && this._parent )
            link = this._parent.getProgramImageLink();

        return link;
    };

    /**
     * Get the (4:3) promo image link. For a collection it will be the same as the image link,
     * but this method is required for interface consistency
     * @param {Number} width
     * @param {Number} height
     * @return {String|undefined}
     */
    BrowseCollection.prototype.getPromoImageLink = function( width, height )
    {
        var link = this.getLink("image" );
        if( link )
            return XtvApi.replaceUrlParams( link, { width: width, height: height } );

        return undefined;
    };

    /**
     * Get the number of browse items (children) in this collection
     * @memberOf BrowseCollection
     * @return {Number}
     */
    BrowseCollection.prototype.getTotalEntityCount = function()
    {
        return this.get("totalBrowseItems");
    };

    /**
     * Get the title of this collection
     * @memberOf BrowseCollection
     * @return {String}
     */
    BrowseCollection.prototype.getTitle = function()
    {
        return this.get("title");
    };

    /**
     * Get the value of a property in meta
     * @memberOf BrowseCollection
     * @param {String} property
     * @return {Object|*}
     */
    BrowseCollection.prototype.getMetaValue = function( property )
    {
        var value;

        if( this._meta )
            value = this._meta[property];

        return value;
    };

    /**
     * Load the next page of entities
     * @return {Promise}
     */
    BrowseCollection.prototype.loadNextPage = function()
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( obj )
            {
                var collection, entity, embedded, entities = [];

                collection = JSON.parse( obj.data );
                embedded   = self.getPath(["_embedded", "browseItems"], collection);

                //re-init this object with the the query result (we need the new 'next' link)
                self.init( collection );

                if( embedded && embedded.length )
                {
                    for( var i = 0; i < embedded.length; i++ )
                    {
                        entity = self.initObject( embedded[i] );
                        if( entity )
                            entities.push( entity )
                    }
                }

                if( entities.length )
                    self._embedded = (self._embedded ) ? self._embedded.concat( entities ) : entities;

                resolve( entities );
            };

            var error = function( error )
            {
                reject( error );
            };

            var link = self.getLinkObject("next");

            if( link )
                link.resolve().then( success ).catch( error );
        };

        return new Promise( resolver );
    };

    /**
     * @memberOf BrowseCollection
     * @return {boolean}
     */
    BrowseCollection.prototype.isFavoriteCollection = function()
    {
        var retval = false;
        var slug   = this.get("slug");

        if( slug )
            if( slug.indexOf('favorite') === 0 )
                retval = true;

        return retval;
    };

    /**
     * Initialize and return an the appropriate object according to type of data
     * @param {Object} data
     * @return {BrowseEntity|BrowseCollection}
     */
    BrowseCollection.prototype.initObject = function( data )
    {
        var retval, obj, tStyle, cStyle;

        if( data._type === "BrowseEntity" )
        {
            obj = new BrowseEntity().init( data, this );

            //make sure this entity has a recognized tile style, otherwise exclude it.
            tStyle = obj.getTileRenderStyle();

            if( tStyle && XtvApi.EntityRenderStyle[tStyle] )
                retval = obj;
        }
        else if( data._type === "BrowseCollection" )
        {
            obj = new BrowseCollection().init( data, this );

            //make sure this collection has a recognized render and tile style, otherwise exclude it. default to true if data does not define a style
            tStyle = obj.getChildRenderStyle();
            cStyle = obj.getCollectionRenderStyle();

            if( tStyle && XtvApi.EntityRenderStyle[tStyle] && cStyle && XtvApi.CollectionRenderStyle[cStyle] )
                retval = obj;
        }

        return retval;
    };

    /**
     * Reload the data in this collection using the source object's self link.
     * @returns {Promise}
     */
    BrowseCollection.prototype.refresh = function()
    {
        var promise, url, self = this;

        if( this._data._links && this.getLink("self") )
        {
            url = XtvApi.trimPath( this.getLink("self") );

            var success = function( result )
            {
                self._embedded = undefined;
                self._data = JSON.parse( result.data );
            };

            promise = _x2._network.ajax({type: "GET", url: _x2._data._host + url, headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv}).then( success );
        }
        else
            promise = Promise.reject( "Collection does not contain a self link" );

        return promise;
    };

    return BrowseCollection;

})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Represents an entity retrieved from a browse query with the basic/limited data required to
 * display the entity in some list or grid view.
 *
 * A BrowseEntity is different from a ProgramEntity (in addition to source) by virtue of the detail available. A
 * BrowseEntity has minimal information (as used by a browse screen) whereas a ProgramEntity has full entity detail.
 *
 * Maps to a XTV "BrowseEntity" (_type = "BrowseEntity").
 */

window.BrowseEntity = (function()
{
    "use strict";

    function BrowseEntity(){}

    BrowseEntity.prototype = new ThumbnailEntity();

    /**
     * Initialize this object
     * @memberOf BrowseEntity
     * @param {Object}            data       - XTV derived JSON object
     * @param {BrowseCollection}  [collection] - collection which contains this entity (parent)
     * @return {BrowseEntity}
     */
    BrowseEntity.prototype.init = function( data, collection )
    {
        ThumbnailEntity.prototype.init.call( this, data );
        this._collection = collection;
        return this;
    };

    /**
     * Returns channel call sign end time if this is a linear entity
     * @return {string}
     */
    BrowseEntity.prototype.getCallSign = function()
    {
        var callSign, linearInfo = this.getEmbedded('linearInfo');

        if( linearInfo )
            callSign = linearInfo["callsign"];

        return callSign;
    };

    /**
     * Return network logo URL
     * @return {string}
     */
    BrowseEntity.prototype.getNetworkImageLink = function()
    {
        var linearInfo, links, stationImage, imageUrl;

        linearInfo = this.getEmbedded("linearInfo");

        if( linearInfo )
        {
            links = linearInfo._links;
            if( links )
            {
                stationImage = links["stationImage"];
                if( stationImage )
                    imageUrl = stationImage.href;
            }
        }

        if( imageUrl )
            imageUrl = XtvApi.replaceUrlParams( imageUrl, { width:50, height:35, extent:"true", gravity:"SouthWest" } );

        return imageUrl;
    };

    /**
     * Return the collection this entity belongs to
     * @returns {BrowseCollection|*}
     */
    BrowseEntity.prototype.getCollection = function()
    {
        return this._collection;
    };

    /**
     * Returns program end time if this is a linear entity
     * @return {number}
     */
    BrowseEntity.prototype.getEndTime = function()
    {
        var time, linearInfo = this.getEmbedded("linearInfo");

        if( linearInfo )
            time = linearInfo['endTime'] && parseInt( linearInfo['endTime'] );

        return time;
    };

    /**
     * Get this entity's ID. ID can be used for get<Type>Entity XTV queries.
     * @memberOf BrowseEntity
     * @return {String}
     */
    BrowseEntity.prototype.getEntityId = function()
    {
        return this.get("entityId");
    };

    /**
     * Returns episode number if this is a episode
     * @return {number}
     */
    BrowseEntity.prototype.getEpisodeNumber = function()
    {
        return this.get("episodeNumber");
    };

    /**
     * Get the fallback URL of the poster image (if main fails)
     * @param width
     * @param height
     * @return {String|undefined}
     */
    BrowseEntity.prototype.getFallbackImageLink = function( width, height )
    {
        if( this._collection )
        {
            var link = this._collection.getProgramFallbackImageLink();
            return XtvApi.replaceUrlParams( link, { entityId: this.getEntityId(), width: width, height: height } );
        }

        return undefined;
    };

    /**
     * Get the URL of the poster image
     * @param width
     * @param height
     * @return {string}
     */
    BrowseEntity.prototype.getImageLink = function( width, height )
    {
        // https://etwiki.sys.comcast.net/pages/viewpage.action?spaceKey=AAE&title=XTVAPI+Browse+Interface+Client+Usage+Guide#XTVAPIBrowseInterfaceClientUsageGuide-BrowseCollectionImages
        var link = this.getLink("programImageLink") || this.getLink("programFallbackImageLink");
        if( ! link )
        {
            if( this._collection && this._collection.getProgramImageLink() )
                link = this._collection.getProgramImageLink();
        }

        if( link )
            link = XtvApi.replaceUrlParams( link, { entityId: this.getEntityId(), width: width, height: height } );

        return link;
    };

    /**
     * Returns the program type
     * @returns {String}
     */
    BrowseEntity.prototype.getProgramType = function()
    {
        return this.get("programType");
    };

    /**
     * Get the URL for a promo
     * @param width
     * @param height
     * @return {*}
     */
    BrowseEntity.prototype.getPromoImageLink = function( width, height )
    {
        var id   = this.getByPriority("seriesProgramId", "entityId"); //try for the seriesProgramId first

        var link = this.getLink("image");
        if( ! link )
            link = this.getLink("programFallbackImageLink");
        if( ! link )
            link = this._collection.getProgramImageLink();

        if( link )
            return XtvApi.replaceUrlParams( link, { entityId: id, width: width, height: height } );
    };

    /**
     * Returns program start time if this is a linear entity
     * @return {number}
     */
    BrowseEntity.prototype.getStartTime = function()
    {
        var time, linearInfo = this.getEmbedded("linearInfo");

        if( linearInfo )
            time = linearInfo['startTime'] && parseInt( linearInfo['startTime'] );

        return time;
    };

    /**
     * Get the entities tile render style. See (@link XtvApi.EntityRenderStyle)
     * @return {String}
     */
    BrowseEntity.prototype.getTileRenderStyle = function()
    {
        var renderStyle = this.get("tileRenderStyle");

        if( renderStyle === undefined && this._collection )
            renderStyle = this._collection.getChildRenderStyle();

        return renderStyle;
    };

    BrowseEntity.prototype.getRottenTomatoReview = function()
    {
        var review, data, criticScore, fanScore, criticRotten, fanRotten;

        data = this.get("ordering");
        if( data )
        {
             criticScore  = Math.floor(data["criticScore"]);
             fanScore     = Math.floor(data["fanScore"]);
             fanRotten    = fanScore    < 60;
             criticRotten = criticScore < 60;
             review = new Review().init( { attributes: { criticSummaryRotten:criticRotten, criticSummaryScore:criticScore, fanSummaryRotten:fanRotten, fanSummaryScore:fanScore } } )
        }

        return review;
    };

    /**
     * Returns season number if this is a episode
     * @return {number}
     */
    BrowseEntity.prototype.getSeasonNumber = function()
    {
        return this.get("seasonNumber");
    };

    /**
     * Returns the series program id
     * @returns {String}
     */
    BrowseEntity.prototype.getSeriesId = function()
    {
        return this.get("seriesProgramId");
    };

    /**
     * Get the title of this entity
     * @memberOf BrowseEntity
     * @returns {String}
     */
    BrowseEntity.prototype.getTitle = function()
    {
        return this.get("title");
    };

    /**
     * Get the year of this entity
     * @memberOf BrowseEntity
     * @returns {String}
     */
    BrowseEntity.prototype.getYear = function()
    {
        return this.get("releaseYear");
    };

    /**
     * Get the rating of this entity
     * @memberOf BrowseEntity
     * @returns {String}
     */
    BrowseEntity.prototype.getRating = function()
    {
        return this.get("contentRating");
    };

    /**
     * Get the number of episodes for this series
     * @memberOf BrowseEntity
     * @returns {Number}
     */
    BrowseEntity.prototype.getEpisodeCount = function()
    {
        return this.getInteger("numberOfEpisodes");
    };

    /**
     * Get the series title. NOTE: Relates to promo entities, not to series/episode entities
     * @returns {*}
     */
    BrowseEntity.prototype.getSeriesTitle = function()
    {
        return this.get("seriesTitle");
    };

    /**
     * Returns true if this entity is marked as adult content
     * @memberOf BrowseEntity
     * @return {boolean}
     */
    BrowseEntity.prototype.isAdult = function()
    {
        return this.getBoolean("isAdult");
    };

    /**
     * Fetches the TV Listing object if this entity is a linear showing (has embedded.linearInfo)
     * @memberOf BrowseEntity
     * @return {Promise} - Returns LinearShowing.
     */
    BrowseEntity.prototype.getLinearTvListing = function()
    {
        var url, listing;

        var linearInfo = this.getEmbedded("linearInfo");


        if( linearInfo )
        {
            listing = linearInfo._links["tvListing"];
            if( listing )
            {
                url = listing.href;

                var resolver = function( resolve, reject )
                {
                    var success = function( response )
                    {
                        var listing = new LinearShowing().init( JSON.parse( response.data ) );
                        resolve( listing );
                    };

                    var error = function( error )
                    {
                        reject( error );
                    };

                    url = _x2._data._host + XtvApi.trimPath( url );
                    _x2._network.ajax( { url: url,  headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv } ).then( success ).catch( error );
                };

                return new Promise( resolver )
            }
        }

        // if( !url )
        return Promise.reject( new ApiError().init( { local:"BrowseEntity.getLinearTvListing: Linear data not available"} ) );
    };

    BrowseEntity.prototype.getSubtitle = function()
    {
        return this.get("subtitle");
    };

    BrowseEntity.prototype.getType = function()
    {
        return this.get("entityType");
    };

    return BrowseEntity;

})();



/***/ }),
/* 19 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Channel is just what you think it is. Maps to a XTV "TelevisionStation/Channel"
 */
window.Channel = (function()
{
    "use strict";

    Channel.prototype = new DataObject();

    function Channel(){}

    /**
     * Initialize this object
     * @memberOf Channel
     * @param {Object} data - XTV derived JSON object
     * @return {Channel}
     */
    Channel.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );

        this._schedules = [];
        return this;
    };

    /**
     * Get the channel number for the 'associated' channel. If this is a SD channel it will return the corresponding HD channel number.
     * If this is an HD channel it will return the SD channel number.
     * @return {string} channel number
     */
    Channel.prototype.getAssocChannelNumber = function()
    {
        var channelNumber, index, keys;

        var string = this.getPath(["_links", "associated", "href" ]);

        if( string )
            keys = string.split(":");

        if( keys && keys.length )
        {
            index = keys.indexOf('chNum');
            if( index >= 0 && keys.length > index )
                channelNumber = keys[index+1];
        }

        return channelNumber;
    };

    /**
     * Get the channels callsign. Example: "KCNC" (NOT "CBS").
     * @memberOf Channel
     * @return {String}
     */
    Channel.prototype.getCallSign = function()
    {
        return this.get("callSign");
    };

    /**
     * Get the currently airing showing on this channel
     * @returns {Promise} LinearShowing
     */
    Channel.prototype.getCurrentlyAiring = function()
    {
        var promise, self = this, now = Date.now();
        if( self._onNow )
        {
            if( self._onNow.getStartTime() <= now && self._onNow.getEndTime() > now )
                promise = Promise.resolve( self._onNow );
        }

        if( ! promise )
        {
            var resolver = function( resolve )
            {
                _x2._data.getLinearScheduleByTime( self.getId(), now ).then(
                    function( showing )
                    {
                        showing.setChannel( self );
                        self._onNow = showing;
                        resolve( showing );
                    }
                );
            };

            promise = new Promise( resolver );
        }

        return promise;
    };

    /**
     * Return the HD version of this channel
     * @return {Channel}
     */
    Channel.prototype.getHdComplement = function()
    {
        return this._hdComplment;
    };

    /**
     * Get the ID for this channel (Merlin? ID)
     * @return {String}
     */
    Channel.prototype.getId = function()
    {
        return this.get("channelId");
    };

    /**
     * Get the channel number
     * @memberOf Channel
     * @return {Number}
     */
    Channel.prototype.getNumber = function()
    {
        return this.get("number");
    };

    /**
     * Get all loaded schedules for this channel
     * @memberOf Channel
     * @return {Array}
     */
    Channel.prototype.getSchedules = function()
    {
        return this._schedules;
    };

    /**
     * Get the name of the company (network) for this channel. Example: CBS
     * @memberOf Channel
     * @return {String}
     */
    Channel.prototype.getCompany = function()
    {
        return this.get("branchOf/company/callSign");
    };

    /**
     * Get the company logo for this channel
     * @memberOf Channel
     * @param {Number} [width] - Image width. Defaults to 50
     * @param {Number} [height] - Image height. Defaults to 30
     * @return {String|undefined}
     */
    Channel.prototype.getLogoUrl = function( width, height )
    {
        var link = this.getLink("logo");
        if( link )
            return XtvApi.replaceUrlParams( link, { width: width || 50, height: height || 30 } );

        return undefined;
    };

    /**
     * Get the station id. Example: "7644483893567419117"
     * @memberOf Channel
     * @return {String}
     */
    Channel.prototype.getStationId = function()
    {
        return this.get("stationId");
    };

    Channel.prototype.getSelfLink = function()
    {
        return this.getLink("self");
    };

    Channel.prototype.getStreamId = function()
    {
        return this.get("streamId");
    };

    Channel.prototype.getStreamUrl = function()
    {
        var url, streams = this.getEmbedded("stream");

        if( streams )
            for( var i = 0; i < streams.length; i++ )
            {
                if( streams[i]["encodingFormat"] === "HLS" )
                {
                    url = this.getPath( ["_links","contentUrl","href"], streams[i] );
                    break;
                }
            }

        return url;
    };

    /**
     * Get the name of the voice hint for this channel. Example: Home Box Office
     * @memberOf Channel
     * @return {String}
     */
    Channel.prototype.getVoiceHint = function()
    {
        return this.get("callSignVoiceOverHint");
    };

    /**
     * Return true if this channel can be recorded
     * @memberOf Channel
     * @return {Boolean}
     */
    Channel.prototype.isRecordable = function()
    {
        return this.getBoolean("isRecordable");
    };

    /**
     * Return true if this channel is HD
     * @memberOf Channel
     * @return {Boolean}
     */
    Channel.prototype.isHD = function()
    {
        return this.getBoolean("isHD");
    };

    /**
     * Return true if this is a TV Everywhere channel
     * @memberOf Channel
     * @return {Boolean}
     */
    Channel.prototype.isTve = function()
    {
        return this.getBoolean("isTve");
    };

    /**
     * Return true if the user is entitled to this channel
     * @memberOf Channel
     * @return {Boolean}
     */
    Channel.prototype.isEntitled = function()
    {
        return this.getBoolean("entitled");
    };

    /**
     * Set the HD version of the channel
     * @param {Channel} channel
     */
    Channel.prototype.setHdComplement = function( channel )
    {
        this._hdComplment = channel;
    };

    /**
     * Copy the schedules from the given channel into this one.
     * @param channel
     * @param blockId
     */
    Channel.prototype.setSchedules = function( channel, blockId )
    {
        var i, listings, wasNotEmpty = ( this._schedules.length > 0 );

        listings = this.getPath( ["_data","_embedded","listings"], channel);

        if( listings )
        {
            for( i = 0; i < listings.length; i++ )
                this._schedules.push( new LinearShowing().init( listings[i], this, blockId ) );
        }

        if( this._schedules.length && wasNotEmpty )
        {
            this._schedules.sort( function( a, b )
            {
                return a.getStartTime() - b.getStartTime()
            } );

            for( i = 0; i < this._schedules.length; i++ )
            {
                if( i < this._schedules.length - 1 )
                {
                    if( this._schedules[i].getStartTime() === this._schedules[i+1].getStartTime() )
                        this._schedules.splice(i,1);
                }
            }
        }
    };

    return Channel;
})();


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 */
window.ChannelCollection = (function()
{
    "use strict";

    function ChannelCollection(){}

    ChannelCollection.blockHours = 4;

    /**
     * Initialize
     * @memberOf ChannelCollection
     * @param data
     * @return {ChannelCollection}
     */
    ChannelCollection.prototype.init = function( data )
    {
        var channels     = data[0];
        var schedulesObj = data[1];

        var schedules = schedulesObj.data;
        var blockId   = schedulesObj.blockId;

        this._loadedBlocks = {};
        this._channelMap   = [];
        this._channels     = channels;

        //create a hash map of channels
        for( var i=0; i<this._channels.length; i++ )
            this._channelMap[this._channels[i].getSelfLink()] = this._channels[i];

        this.assignSchedules( schedules );
        this.validate( [blockId] );

        this._loadedBlocks[blockId] = true;

        return this;
    };

    /**
     * Assign schedules to channels
     * @private
     * @param schedules
     * @param blockId
     */
    ChannelCollection.prototype.assignSchedules = function( schedules, blockId )
    {
        var i, j;

        for( i=0; i<schedules.length; i++ )
        {
            for( j=0; j<this._channels.length; j++ )
            {
                if( schedules[i].getSelfLink() === this._channels[j].getSelfLink() )
                {
                    this._channels[j].setSchedules( schedules[i], blockId ); //track which block the schedule belongs to, for the purpose of purging.
                    break;
                }
            }
        }
    };

    /**
     * Fetch any missing schedule data. Called before accessing schedule data. If start/end are
     * omitted, only validate that we have schedule data for the current time (on now).
     *
     * TODO: validate that start and end resolve to contiguous blocks.
     *
     * @param {Number} (start) - start time for which coverage is needed
     * @param {Number} (end)   - end time for which coverage is needed
     * @return {Promise<void>}
     */
    ChannelCollection.prototype.fetch = function( start, end )
    {
        var i, self = this;
        var requestBlocks = [];
        var fetchBlocks   = [];
        var uniformStart, uniformEnd;

        if( start === undefined && end === undefined )
            requestBlocks.push( ChannelCollection.getUniformBlockTime( _x2._config._host.getCurrentDateTime(true) ) );
        else
        {
            if( start !== undefined )
                uniformStart = ChannelCollection.getUniformBlockTime( start );
            if( end !== undefined )
                uniformEnd = ChannelCollection.getUniformBlockTime( end );

            if( uniformStart )
                requestBlocks.push( uniformStart );
            if( uniformEnd && uniformEnd !== uniformStart )
                requestBlocks.push( uniformEnd );
        }

        for( i=0; i<requestBlocks.length; i++ )
        {
            if( self._loadedBlocks[requestBlocks[i]] !== true && self._loadedBlocks[requestBlocks[i]] !== 'Loading' ) {
                self._loadedBlocks[requestBlocks[i]] = 'Loading';
                fetchBlocks.push( requestBlocks[i] );
            }
        }
        if( fetchBlocks.length > 2 ) { //always there will be one or two fetchBlocks, but at peak hour, there are more than 2 requests sent.
            console.log("Warning --- it fetchs more than two requests", fetchBlocks);
        }
        if( fetchBlocks.length > 0 )
        {
            var resolver = function( resolve )
            {
                var p = [];

                var assignSchedules = function( schedulesObj )
                {
                    self.assignSchedules( schedulesObj.data, schedulesObj.blockId );
                    self._loadedBlocks[schedulesObj.blockId] = true;
                };

                var ready = function()
                {
                    self.validate( fetchBlocks );
                    resolve();
                };

                for( i=0; i<fetchBlocks.length; i++ )
                    p.push( _x2._data.getScheduleBlock( fetchBlocks[i], ChannelCollection.blockHours ).then( assignSchedules ) );

                Promise.all( p ).then( ready );
            };

            return new Promise( resolver );
        }
        else
            return Promise.resolve();
    };

    ChannelCollection.prototype.getChannel = function( link )
    {
        return this._channelMap[link];
    };

    ChannelCollection.prototype.getChannels = function()
    {
        return this._channels;
    };

    /**
     * Fill any schedule gaps with 'TBD' blocks and report gaps to console.log
     * @memberOf ChannelCollection
     * @param blocks - array of block start times
     */
    ChannelCollection.prototype.validate = function( blocks )
    {
        var i, j, channel, schedules, lSchedule, rSchedule, lEnd, rStart, gap, startCheck, elapsed;

        var blockStart = blocks[0];
        var blockEnd   = blocks[blocks.length-1] + ChannelCollection.blockHours * 3600000;

        startCheck = Date.now();
        console.log("######### Checking schedules... #########");

        var getTbd = function( start, end )
        {
            console.log( "----- schedule gap detected -----");
            console.log( "Channel   : " + channel.getNumber()               );
            console.log( "Gap start : " + ( new Date(start)).toTimeString() );
            console.log( "Gap end   : " + ( new Date(end)).toTimeString()   );

            return new LinearShowing().init( { startTime:start, endTime:end, title:"TBD...", isTbd:true } )
        };

        for( i=0; i<this._channels.length; i++ )
        {
            channel   = this._channels[i];
            schedules = channel.getSchedules();
            lSchedule = schedules[0];

            //if there are no schedules for this channel insert a TBD to fill the entire schedule block
            if( schedules.length === 0 )
                schedules.push( getTbd( blockStart, blockEnd ) );
            else
            {
                //if the first schedule begins after block start add a TBD to fill the gap
                if( schedules[0].getStartTime() > blockStart )
                    schedules.unshift( getTbd( blockStart, schedules[0].getStartTime() ) );

                //if the last schedule ends before the end of the block add a TBD to fill the gap
                if( schedules[schedules.length-1].getEndTime() < blockEnd )
                    schedules.push( getTbd( schedules[schedules.length-1].getEndTime(), blockEnd ) );

                //fill any gaps between schedules
                for( j=1; j<schedules.length; j++ )
                {
                    rSchedule = schedules[j];
                    lEnd      = lSchedule.getEndTime();
                    rStart    = rSchedule.getStartTime();
                    gap       = ( rStart - lEnd ) / (60 * 1000);

                    if( gap > 0 )
                        schedules.splice( j, 0, getTbd( lEnd, rStart ) );

                    lSchedule = rSchedule;
                }
            }
        }
        elapsed = Date.now() - startCheck;
        console.log("######### Check complete. (" + elapsed + "ms) #########");
    };

    /**
     * Return the uniform block start time, considering that we'll only pull blocks for 0:00,4:00,... (GMT),
     * according to ChannelCollection.blockHours. We're adjusting to GMT so that all clients pull the same
     * blocks
     * @param time
     * @return {number}
     */
    ChannelCollection.getUniformBlockTime = function( time )
    {
        if( _x2._config.skipBlockTimeCheck == true ) {
            return time;
        }
        var blockStart = new Date(time);
        blockStart.setMinutes(0);
        blockStart.setSeconds(0);
        blockStart.setMilliseconds(0);

        //Adjust the timezone offset to whole hours and compensate by adjusting the time

        var zoneOffset = blockStart.getTimezoneOffset();
        var offset = zoneOffset % 60;

        if( offset !== 0 )
        {
            zoneOffset = zoneOffset - offset;
            blockStart = new Date( blockStart.getTime() + ( offset * 60 * 1000 ) );//offset will be in minutes
        }

        while( ( blockStart.getHours() + ( zoneOffset / 60 ) ) % ChannelCollection.blockHours !== 0 )
            blockStart.setTime( blockStart.getTime() - ( 60 * 60 * 1000 ) );

        return blockStart.getTime();
    };

    return ChannelCollection;
})();


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * This class functions as a container for generic collections of entities. Whereas a
 * BrowseCollection wraps a corresponding XTVAPI data object returned, this class wraps
 * a simple array of entities
 *
 */
window.Collection = (function()
{
    "use strict";

    Collection.prototype = new DataObject();

    function Collection(){}

    /**
     * Initialize the object
     * @memberOf Collection
     * @param {Object[]}                 entities           - The collection of entities
     * @param {String}                   title              - The title of this collection i.e. "Recently Watched"
     * @param {XtvApi.EntityRenderStyle} [childRenderStyle] - set the render style of this collection
     * @return {Collection}
     */
    Collection.prototype.init = function( entities, title, childRenderStyle )
    {
        this._entities         = entities;
        this._title            = title;
        this._childRenderStyle = childRenderStyle;

        return this;
    };

    /**
     * Get the entity render style. Default to poster for mixed collection
     * @return {XtvApi.EntityRenderStyle|String}
     */
    Collection.prototype.getChildRenderStyle = function()
    {
        return this._childRenderStyle || XtvApi.EntityRenderStyle.POSTER;
    };

    /**
     * Get entities (align method with BrowseCollection)
     * @return {Object[]}
     */
    Collection.prototype.getEmbeddedBrowseItems = function()
    {
        return this.getEntities();
    };

    /**
     * Get the entities collection
     * @param {Number} [max] - Maximum number of entities to return
     * @return {Object[]}
     */
    Collection.prototype.getEntities = function( max )
    {
        var entities;

        if( this._entities.length > 12 )
        {
            if( ( this._entities[0] instanceof Collection ) === false )
            {
                var all = new Collection().init( this._entities, this._title );
                all.setMeta({ all:true });
                this._entities.unshift( all );
            }

            max++ //adjust for 'all' at [0] and return one more.
        }

        if( max )
            entities = this._entities.slice(0,max);
        else
            entities = this._entities;

        return entities;
    };

    /**
     * Get the number of entities in the collection
     * @return {Number}
     */
    Collection.prototype.getTotalEntityCount = function()
    {
        var count = this._entities.length;

        if( this._entities.length > 12 )
        {
            if( this._entities[0].getMeta().all )
                count--;
        }

        return count;
    };

    /**
     * Get the title of the collection
     * @return {String}
     */
    Collection.prototype.getTitle = function()
    {
        return this._title;
    };

    return Collection;
})();


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



/**
 * @class
 *
 * Conceptually related to {@link Channel}, but with distinct properties. Maps to XTV "ContentProvider".
 */
window.ContentProvider = (function()
{
    ContentProvider.DEFAULT_LOGO_W = 90;
    ContentProvider.DEFAULT_LOGO_H = 90;

    ContentProvider.prototype = new DataObject();

    function ContentProvider(){}

    /**
     * Initialize this object with data
     * @memberOf ContentProvider
     * @param {Object} data - XTV derived JSON object
     * @return {ContentProvider}
     */
    ContentProvider.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    /**
     * Get the ID of this provider
     * @memberOf ContentProvider
     * @return {String}
     */
    ContentProvider.prototype.getCompanyId = function()
    {
        return this.get("companyId");
    };

    /**
     * Get the URL of the image representing this provider
     * @memberOf ContentProvider
     * @param {Number} width  - Image width
     * @param {Number} height - Image height
     * @return {String}
     */
    ContentProvider.prototype.getLogoUrl = function( width, height )
    {
        var w = width  ? width  : ContentProvider.DEFAULT_LOGO_W;
        var h = height ? height : ContentProvider.DEFAULT_LOGO_H;
        return this.getLink("logo", { width:w, height:h } );
    };

    /**
     * Get the name of this provider. Example: "STARZ"
     * @memberOf ContentProvider
     * @return {String}
     */
    ContentProvider.prototype.getName = function()
    {
        return this.get("name");
    };

    return ContentProvider;
})();


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * A EntityRecording is synonymous with a "Series Recording". It represents a recurring recording.
 * This can be a series recording, or a recording associated with some other entity such as sports
 * team or personality.
 *
 * Maps to XTV type: s:VideoObject/Recording
 *
 * This XTV data structure is embedded within XTV type "TVListing" (LinearShowing) or "CreativeWorkEntity" (ProgramEntity)
 */
window.EntityRecording = (function()
{
    "use strict";

    EntityRecording.prototype = new DataObject();

    function EntityRecording(){}

    /**
     * Initialize this object with data
     * @memberOf EntityRecording
     * @param {Object} data - XTV derived JSON object
     */
    EntityRecording.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    EntityRecording.prototype.getDurationMs = function()
    {
        var ms = 0, duration = this.getInteger("duration");

        if( duration )
            ms = parseInt( duration );

        return ms;
    };

    EntityRecording.prototype.getModifyForm = function()
    {
        if( ! this._modifyForm )
            this._modifyForm = this.getForm("modify");

        return this._modifyForm;
    };

    EntityRecording.prototype.getRecordedOnDate = function()
    {
        return this.getDate("dateRecorded");
    };

    EntityRecording.prototype.getRecordingStatus = function()
    {
        return this.getByPriority("status", "recordingStatus");
    };

    // EntityRecording.prototype.getRecordingType = function()
    // {
    //     return this._data.recordingType;
    // };

    EntityRecording.prototype.getScheduleForm = function()
    {
        if( ! this._scheduleForm )
            this._scheduleForm = this.getForm("schedule");

        return this._scheduleForm;
    };

    EntityRecording.prototype.getCancelForm = function()
    {
        //look first for a 'cancel' form then 'delete' form.
        if( ! this._cancelForm )
            this._cancelForm = this.getForm("cancel");

        if( ! this._cancelForm )
            this._cancelForm = this.getForm("delete");

        return this._cancelForm;
    };

    EntityRecording.prototype.isScheduled = function()
    {
        var scheduled = false, status = this.get("status") || this.get("recordingStatus");

        if( status === 'scheduled' || status === 'STARTED' || status === 'NOTSTARTED' )
            scheduled = true;

        return scheduled;
    };

    return EntityRecording

})();


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * This class encapsulates data from XTVAPI getAllFavorites which is a list of object IDs the user has favorite-ed.
 * Not be be confused with a browse favorites collection which contains a list of favorite-ed objects.
 */
window.Favorites = ( function()
{
    "use strict";

    function Favorites(){}

    /**
     * Initializer
     * @memberof Favorites
     * @param   {Object}        data
     * @param   {Object}        data._links
     * @returns {Favorites}
     */
    Favorites.prototype.init = function( data )
    {
        var i, programs, channels, teams;

        this._programs = [];
        this._channels = [];
        this._teams    = [];

        programs = data._links['programs'];
        channels = data._links['channels'];
        teams    = data._links['sportsTeams'];

        //NOTE: data can contain an array OR an object in the case of a single entity. Convert to array so we'll catch it below.

        if( programs && programs.href )
            programs = [{href:programs.href}];

        if( channels && channels.href )
            channels = [{href:channels.href}];

        if( teams && teams.href )
            teams = [{href:teams.href}];

        if( programs && programs.length )
            for( i=0; i<programs.length; i++ )
                this._programs.push( XtvApi.trimPath( programs[i].href ) );

        if( channels && channels.length )
            for( i=0; i<channels.length; i++ )
                this._channels.push( channels[i].href );

        if( teams && teams.length )
            for( i=0; i<teams.length; i++ )
                this._teams.push( XtvApi.trimPath( teams[i].href ) );

        return this;
    };

    Favorites.prototype.addFavorite = function( object )
    {
        return this.setFavorite( object, true );
    };

    Favorites.prototype.removeFavorite = function( object )
    {
        return this.setFavorite( object, false );
    };

    Favorites.prototype.setFavorite = function( object, add )
    {
        var link, promise, program;

        if( object.getProgram )
        {
            program = object.getProgram();

            if( program )
                link = program.getSelfLink();
        }

        if( link === undefined )
            link = object.getSelfLink();

        if( link )
        {
            link = XtvApi.trimPath( link );
            link = XtvApi.replaceUrlParams(link, {});

            if( object instanceof Channel )
                promise = ( add ? _x2._data.addFavoriteChannel( link ) : _x2._data.removeFavoriteChannel( link ) );
            else
                promise = ( add ? _x2._data.addFavoriteItem( link ) : _x2._data.removeFavoriteItem( link ) ) ;
        }
        else
            promise = Promise.reject("Failed to set favorite (no self link)");

        return promise;
    };

    Favorites.prototype.hasChannelFavorites = function()
    {
        return this._channels && this._channels.length > 0;
    };

    Favorites.prototype.isFavorite = function( object )
    {
        var i, id, group=[];

        if( object instanceof Entity )
        {
            group = this._programs;
            id    = object.getSelfLink();
        }
        else if( object instanceof Channel )
        {
            group = this._channels;
            id    = object.getSelfLink();

        }
        else if( object instanceof SportsTeam )
        {
            group = this._teams;
            id    = object.getSelfLink();
        }

        if( id && group && group.length )
        {
            id = XtvApi.trimPath( id );

            for( i=0; i<group.length; i++ )
                if( id === group[i] )
                    return true;
        }

        return false;
    };

    return Favorites;

})();


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Encapsulates HAL forms for updating objects
 */
window.Form = (function()
{
    "use strict";

    function Form(){}

    /**
     * Initialize this object with data
     * @memberOf Form
     * @param {Object} data - XTV derived JSON object
     * @param {String} data - name of the form / API name used for logging and error handling
     */
    Form.prototype.init = function( data, name )
    {
        this._data = data;
        this._name = name;

        return this;
    };

    /**
     * Get all field for this form
     * @memberOf Form
     * @returns {Array} array of key-value pairs
     */
    Form.prototype.getFields = function()
    {
        if( ! this._fields )
        {
            var field, fieldObj;
            this._fields = [];
            this._fieldArray = [];

            for( field in this._data.fields )
            {
                if( this._data.fields.hasOwnProperty( field ) )
                {
                    fieldObj = new FormField().init( field, this._data.fields[field]);
                    this._fieldArray.push( fieldObj );
                    this._fields[field] = fieldObj
                }
            }
        }

        return this._fieldArray;
    };

    /**
     * Return the form title
     * @return {String}
     */
    Form.prototype.getTitle = function()
    {
        return this._data.title;
    };

    /**
     * Set the value of a form field
     * @memberOf Form
     * @param {String} key
     * @param {String|Number|Boolean} value
     */
    Form.prototype.setFieldValue = function( key, value )
    {
        this._fields[key].setValue(value);
    };

    /**
     * Submit the form
     * @memberOf Form
     * @param {Object} queryStringParams - replacement values as key value pairs
     * @return {Promise}
     */
    Form.prototype.submit = function( queryStringParams )
    {
        var payload = "";
        var method  = this._data.method;
        var url     = _x2._data._host + XtvApi.trimPath( this._data.action );
        var param;

        if( queryStringParams !== undefined )
        {
            for( param in queryStringParams )
            {
                if( queryStringParams.hasOwnProperty( param ) )
                    url = url.replace( '{' + param + '}', queryStringParams[param] );
            }
        }

        if( this._fieldArray )
        {
            for( var i=0; i<this._fieldArray.length; i++ )
            {
                if( payload.length )
                    payload += '&';

                if( this._fieldArray[i].getValue() !== undefined )
                    payload += this._fieldArray[i].getName() + '=' + this._fieldArray[i].getValue();
            }
        }

        return _x2._network.ajax( { type:method, url:url, data:payload, api:this._name, headers:_x2._data.getAuthHeader(), contentType:'application/x-www-form-urlencoded' } )
    };

    return Form;
})();


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.FormField = (function()
{
    "use strict";
    
    function FormField(){}
    
    FormField.prototype.init = function( name, data )
    {
        this._name = name;
        this._data = data;  
        
        return this;
    };
    
    FormField.prototype.getName = function()
    {
        return this._name;
    };
    
    FormField.prototype.getLabel = function()
    {
        return this._data.label;
    };
    
    FormField.prototype.getValue = function()
    {
        var retval;
        
        if( this._value !== undefined )
            retval = this._value;
        else 
            retval = this._data.default;
        
        return retval;
    };

    FormField.prototype.getType = function()
    {
        return this._data.fieldType;
    };
    
    FormField.prototype.setValue = function( value )
    {
        this._value = value;
    };
    
    FormField.prototype.getOptions = function()
    {
        if( ! this._options )
        {
            var option;
            this._options = [];

            for( option in this._data.options )
            {
                if( this._data.options.hasOwnProperty( option ) )
                    this._options.push( new FormFieldOption().init(option, this._data.options[option]) );
            }
        }
        
        return this._options;
    };
    
    return FormField;
})();


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2017 Comcast Corporation, All Rights Reserved



window.FormFieldOption = (function()
{
    function FormFieldOption(){}
    
    FormFieldOption.prototype.init = function( name, data )
    {
        this._name = name;
        this._data = data;
        
        return this;
    };
    
    FormFieldOption.prototype.getName = function()
    {
        return this._name;
    };
    
    FormFieldOption.prototype.getLabel = function()
    {
        return this._data.label;   
    };
    
    FormFieldOption.prototype.getOrder = function()
    {
        return this._data.order;
    };
    
    return FormFieldOption;
})();


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GuideViewEntity = (function()
{
    "use strict";

    function GuideViewEntity( title, entries, emptyString )
    {
        this._title       = title;
        this._entries     = entries;
        this._emptyString = emptyString;
    }

    GuideViewEntity.prototype.getEmptyString = function()
    {
        return this._emptyString;
    };

    GuideViewEntity.prototype.getEntities = function()
    {
        return this._entries;
    };

    GuideViewEntity.prototype.getTitle = function()
    {
        return this._title;
    };

    return GuideViewEntity;

})();


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 * @type {Link}
 *
 * Use this class for all data fetching operations from links. Cleans
 */
window.Link = (function()
{
    "use strict";

    function Link(){}

    Link.prototype.init = function( data )
    {
        this._data = data;
        return this;
    };

    /**
     * Follow the link and fetch the data
     */
    Link.prototype.resolve = function( parameters, api, force )
    {
        var self = this;

        var resolver = function(resolve, reject)
        {
            var success = function( data )  { resolve( data  ) };
            var fail    = function( error ) { reject ( error ) };

            if( self._data && self._data.href )
            {
                var url = self._data.href;
                url = XtvApi.replaceUrlParams( url, parameters );
                url = XtvApi.trimPath( url );
                url = _x2._data._host + url.replace( /#/g, '' );

                _x2._network.ajax( { type: "GET", url: url, api:api, headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv, bustCache:force } ).then( success ).catch( fail );
            }
            else
            {
                console.log( "WARNING: unresolved link");
                resolve();
            }
        };

        return new Promise(resolver);
    };

    return Link;
})();


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.Organization = (function()
{
    "use strict";

    function Organization(){}
    
    Organization.prototype.init = function( params )
    {
        this._name = params.name; 
        this._searchEntity = params.searchEntity;
        
        return this;
    };
    
    Organization.prototype.loadData = function()
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( response )
            {
                self._data = JSON.parse(response.data);
                resolve( self );
            };

            var error = function( error )
            {
                reject( error );
            };

            var entity = self._searchEntity.getEntity();
            if( entity )
            {
                var url = entity._links.search.href.replace( /(\.\.\/)/g, '' );
                _x2._network.ajax({type: "GET", url: _x2._data._host + url, headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv}).then(success).catch(error);
            }
            else
                return Promise.reject( new ApiError().init( { local:"Organization.loadData: Missing entity"} ) );
        };

        return new Promise( resolver );
    };
    
    Organization.prototype.getChannels = function()
    {
        if( ! this._objects )
        {
            var list = this._data._embedded.results;

            if( list && list.length )
            {
                this._objects = [];
                //use SearchEntity (that's what the data is) and think about how to make this cleaner later.
                for( var i=0; i<list.length; i++ )
                {
                    this._objects.push( new SearchEntity().init(list[i]) );
                }
            }
        }

        return this._objects;
    };
    
    Organization.prototype.getTitle = function()
    {
        if( this._searchEntity )
        {
            return this._searchEntity.getTitle();
        }
    };
    
    return Organization;
})();


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ParentalControls = (function()
{
    "use strict";

    ParentalControls.SafeBrowse = {
        OFF   : { level: 0, key: "OFF" },
        MEDIUM: { level: 1, key: "MEDIUM" },
        HIGH  : { level: 2, key: "HIGH" }
    };

    /* Defines canonical XtvApi TV rating strings */
    ParentalControls.TvRatings = Object.freeze
    ({
        TVY : { key: 'TV-Y' , val:0 },
        TVY7: { key: 'TV-Y7', val:1 },
        TVG : { key: 'TV-G' , val:2 },
        TVPG: { key: 'TV-PG', val:3 },
        TV14: { key: 'TV-14', val:4 },
        TVMA: { key: 'TV-MA', val:5 }
    });

    /* Defines canonical XtvApi MPAA rating strings */
    ParentalControls.MpaaRatings = Object.freeze
    ({
        G    : { key: 'G'    , val:0 },
        PG   : { key: 'PG'   , val:1 },
        PG13 : { key: 'PG-13', val:2 },
        R    : { key: 'R'    , val:3 },
        NC17 : { key: 'NC-17', val:4 },
        ADULT: { key: 'ADULT', val:5 }
    });

    /* Defines canonical XtvApi rating advisories */
    ParentalControls.Advisories = {
        D : 'D',
        L : 'L',
        S : 'S',
        V : 'V',
        FV: 'FV'
    };

    ParentalControls.MOVIE_LOCK_KEY = 'mpaa';
    ParentalControls.TV_LOCK_KEY    = 'v-chip';

    function ParentalControls( data )
    {
        this._data = data;
    }

    /**
     * Return true if pin matches saved pin
     * @param pin {String}
     * @returns {Boolean}
     */
    ParentalControls.prototype.checkPin = function( pin )
    {
        return ( pin === this._data.pin );
    };

    /**
     * Get the current safe browse level
     * @param {ParentalControls.SafeBrowse} level
     * @returns {Boolean}
     */
    ParentalControls.prototype.checkSafeBrowse = function( level )
    {
        var safeBrowse = false;

        switch( this._data.safeBrowse )
        {
            case "MEDIUM":
                safeBrowse = ( ParentalControls.SafeBrowse.MEDIUM.level >= level );
                break;

            case "HIGH":
                safeBrowse = ( ParentalControls.SafeBrowse.HIGH.level >= level );
                break;
        }

        return safeBrowse;
    };

    ParentalControls.prototype.getSafeBrowse = function()
    {
        return this._data.safeBrowse;
    };

    /**
     * Return true if the channel is marked as locked
     * @param {Number} channelId
     * @returns {Boolean}
     */
    ParentalControls.prototype.isChannelLocked = function( channelId )
    {
        return ( this._data.enabled === true && this._data.channelLocks[channelId] === true );
    };

    /**
     * Return true if parental controls are enabled
     * @returns {Boolean}
     */
    ParentalControls.prototype.isEnabled = function()
    {
        return this._data.enabled;
    };

    /**
     * Return true if the mpaa rating level is locked
     * @param {ParentalControls.MpaaRatings | String} rating object or string (i.e. "PG")
     * @returns {Boolean}
     */
    ParentalControls.prototype.isMovieRatingLocked = function( rating )
    {
        var key = ( typeof rating === "object" ? rating.key : rating );
        var mpaaLock = this._data.ratingLocks[ParentalControls.MOVIE_LOCK_KEY][key];

        if( mpaaLock )
            return this._data.enabled === true && mpaaLock.locked;
        else
            return false;
    };

    /**
     * Return true if the network is locked
     * @param {Number} networkId
     * @returns {boolean}
     */
    ParentalControls.prototype.isNetworkLocked = function( networkId )
    {
        return ( this._data.enabled === true && this._data.networkLocks[networkId] === true );
    };

    /**
     * Return true if the TV rating or MPAA rating is locked
     * @param {ParentalControls.MpaaRatings|ParentalControls.TvRatings} rating
     * @param {ParentalControls.Advisories} advisories
     * @returns {Boolean}
     */
    ParentalControls.prototype.isRatingLocked = function( rating, advisories )
    {
        return this._data.enabled === true && ( this.isTvRatingLocked( rating, advisories ) || this.isMovieRatingLocked( rating ) );
    };

    /**
     * Return true if there is a matching title lock set
     * @param {Number} programId
     * @returns {Boolean}
     */
    ParentalControls.prototype.isTitleLocked = function( programId )
    {
        var lock = this._data.titleLocks[programId];

        if( lock )
            return this._data.enabled === true && lock.locked;
        else
            return false;
    };

    /**
     * Return true if the TV rating lock is set
     * @param {ParentalControls.TvRatings | String} rating object or string (i.e. "TV-MA")
     * @param {ParentalControls.Advisories} advisories
     * @returns {Boolean}
     */
    ParentalControls.prototype.isTvRatingLocked = function( rating, advisories )
    {
        var key = ( typeof rating === "object" ? rating.key : rating );
        var tvLock = this._data.ratingLocks[ParentalControls.TV_LOCK_KEY][key];

        if( this._data.enabled === true && tvLock )
        {
            if( tvLock.locked )
                return true;
            else if( advisories )
            {
                for( var i = 0; i < advisories.length; i++ )
                {
                    if( tvLock.advisories[advisories[i]] )
                        return true;
                }
            }
        }

        return false;
    };

    /**
     * Lock a channel
     * @param {Number} channelId
     * @param {Boolean} locked
     */
    ParentalControls.prototype.setChannelLocks = function( channelId, locked )
    {
        this._data.channelLocks[channelId] = locked;
    };

    /**
     * Turn on parental controls
     * @param {Boolean} enabled
     */
    ParentalControls.prototype.setEnabled = function( enabled )
    {
        this._data.enabled = enabled;
    };

    /**
     * Set a MPAA rating lock
     * @param {ParentalControls.MpaaRatings.key} rating
     * @param {Boolean} locked
     */
    ParentalControls.prototype.setMovieRatingLock = function( rating, locked )
    {
        var prop, valid = false;

        // validate rating string against ParentalControls.MpaaRatings
        for( prop in ParentalControls.MpaaRatings )
        {
            if( ParentalControls.MpaaRatings[prop]._key === rating._key )
                valid = true;
        }

        if( valid )
            this._data.ratingLocks[ParentalControls.MOVIE_LOCK_KEY][rating.key].locked = locked;
        else
            console.log( "Error: Cannot set movie rating lock. Invalid rating string: " + rating );
    };

    /**
     * Set a network lock
     * @param {Number} networkId
     * @param {Boolean} locked
     */
    ParentalControls.prototype.setNetworkLocks = function( networkId, locked )
    {
        this._data.networkLocks[networkId] = locked;
    };

    ParentalControls.prototype.setPin = function( pin )
    {
        this._data.pin = pin;
    };

    /**
     * Set the safe browse level
     * @param {ParentalControls.SafeBrowse} level
     */
    ParentalControls.prototype.setSafeBrowse = function( level )
    {
        _x2._network.resetGlobalCache();
        this._data.safeBrowse = level.key;
    };

    /**
     * Set a title lock
     * @param {Number} programId
     * @param {String} programTitle
     * @param {Boolean} locked
     */
    ParentalControls.prototype.setTitleLock = function( programId, programTitle, locked )
    {
        this._data.titleLocks[programId] = { locked: locked, title: programTitle };
    };

    /**
     * Set a TV ratings lock
     * @param {ParentalControls.TvRatings.key} rating
     * @param {Boolean} locked
     */
    ParentalControls.prototype.setTvRatingLocks = function( rating, locked )
    {
        var prop, valid = false, locks;

        // validate rating string against ParentalControls.TvRatings
        for( prop in ParentalControls.TvRatings )
            if( ParentalControls.TvRatings[prop] === rating )
                valid = true;

        if( valid )
        {
            locks        = this._data.ratingLocks[ParentalControls.TV_LOCK_KEY][rating.key];
            locks.locked = locked;

            for( prop in locks.advisories )
                locks.advisories[prop].locked = locked;
        }
        else
            console.log( "Error: Cannot set TV rating lock. Invalid rating string: " + rating );
    };

    return ParentalControls;

})();


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * PurchaseCollection is the top-level object which contains PurchaseGroup, Series and Purchase objects.
 * Maps to XTVAPI s:Enumeration/Purchases
 */
window.PurchaseCollection = (function()
{
    "use strict";

    function PurchaseCollection(){}

    PurchaseCollection.prototype.init = function( data )
    {
        this._data = data;

        return this;
    };

    PurchaseCollection.prototype.getMovies = function()
    {
        var i, movies = [], groups = this.getPurchaseGroups();

        for( i=0; i<groups.length; i++ )
        {
            if( groups[i].getEntityType() === XtvApi.EntityType.MOVIE )
                movies.push( groups[i] );
        }

        return new Collection().init( movies, "Purchased Movies" )
    };

    PurchaseCollection.prototype.getTvSeries = function()
    {
        var i, series = [], groups = this.getPurchaseGroups();

        for( i=0; i<groups.length; i++ )
        {
            if( groups[i].getEntityType() === XtvApi.EntityType.EPISODE )
                series.push( groups[i] );
        }

        return new Collection().init( series, "Purchased TV Shows" )
    };

    PurchaseCollection.prototype.getPurchaseGroups = function( sort )
    {
        if( ! this._groups )
        {
            this._groups = [];

            var i, j, k, s, ids, group, purchase, program, link, tokens, sid, sortedGroups;
            var purchasesAry = [];
            var seriesMap     = {};
            var purchases     = this._data._embedded.purchases;
            var groups        = this._data._embedded.purchaseGroups;
            var series        = this._data._embedded.series;

            //create a hashmap of series
            for( i=0; i<series.length; i++ )
            {
                s = new Entity().init( series[i] );
                sid = s.getEntityId();
                seriesMap[sid] = s;
            }

            //create the purchase (ProgramEntity) object, assoc w/series and add to collection
            for( i = 0; i < purchases.length; i++ )
            {
                purchase = new Purchase().init( purchases[i] );
                program  = purchase.getEntity();

                if( program )
                {
                    if( program.getType() === XtvApi.EntityType.EPISODE )
                    {
                        link = program.getTvSeriesLink();
                        if( link )
                            tokens = link.split('/');

                        if( tokens && tokens.length )
                            sid = tokens[tokens.length-2];

                        if( sid && seriesMap[sid] )
                            purchase.setSeries( seriesMap[sid] );
                    }
                }

                purchasesAry.push( purchase );
            }

            //add purchases to the correct group
            for( i = 0; i < groups.length; i++ )
            {
                group = new PurchaseGroup().init( groups[i] );
                ids   = group.getPurchaseIds();

                if( ids.length )
                {
                    for( j = 0; j < ids.length; j++ )
                    {
                        for( k = 0; k < purchasesAry.length; k++ )
                        {
                            if( ids[j] === purchasesAry[k].getId() )
                            {
                                purchase = purchasesAry.splice( k, 1 )[0];
                                purchase.setGroup( group );
                                group.addPurchase( purchase );
                                break;
                            }
                        }
                    }
                }

                if( group.getPurchaseCount() > 0 )
                    this._groups.push( group );
            }
        }

        if( sort )
        {
            var sortMap, sortGroups = this._groups;

            if( sort === 'recent' )
            {
                sortMap = sortGroups.map( function( group, i )
                {
                    return ( { index:i, value:group.getPurchasedOnDate().getTime() } );
                });

                sortMap.sort( function( a, b )
                {
                    return a.value > b.value ? -1 : 1;
                });
            }
            else if( sort === 'a-z' )
            {
                sortMap = sortGroups.map( function( group, i )
                {
                    return ( { index:i, value:group.getTitle().toLowerCase() } );
                });

                sortMap.sort( function( a, b )
                {
                    return a.value > b.value ?  1 : -1;
                });
            }

            sortedGroups = sortMap.map( function( element )
            {
                return sortGroups[element.index]
            });
        }

        return sortedGroups ? sortedGroups : this._groups;
    };

    PurchaseCollection.prototype.getTitle = function()
    {
        return this._data.name;
    };

    return PurchaseCollection;
})();


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Maps to XTVAPI s:PurchaseGroup. Contains purchase data and aggregates groups of purchased entities.
 */
window.PurchaseGroup = (function()
{
    "use strict";

    PurchaseGroup.prototype = new DataObject();

    function PurchaseGroup(){}

    PurchaseGroup.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    /**
     * Add the purchase Object to this group.
     * @param {ProgramEntity} purchase
     */
    PurchaseGroup.prototype.addPurchase = function( purchase )
    {
        if( !this._purchases )
            this._purchases = [];

        this._purchases.push( purchase );
    };

    PurchaseGroup.prototype.getPurchases = function()
    {
        return this._purchases;
    };

    PurchaseGroup.prototype.getPurchaseCount = function()
    {
        return this._purchases.length;
    };

    PurchaseGroup.prototype.getPurchaseIds = function()
    {
        if( !this._purchaseIds )
        {
            var i, purchases = this.getPath(["_links", "purchases"]);

            this._purchaseIds = [];

            if( purchases )
            {
                if( purchases instanceof Array )
                {
                    for( i = 0; i < purchases.length; i++ )
                        this._purchaseIds.push( purchases[i].href );
                }
                else
                    this._purchaseIds.push( purchases.href );
            }
        }

        return this._purchaseIds;
    };

    PurchaseGroup.prototype.getEpisodeCount = function()
    {
        return this._purchases.length;
    };

    PurchaseGroup.prototype.getPurchasedOnDate = function()
    {
        return this.getDate("purchased" );
    };

    PurchaseGroup.prototype.getRottenTomatoReview = function()
    {
        var review, program;

        if( this.getPurchaseCount() === 1 )
        {
            program = this.getPurchases()[0].getEntity();
            if( program )
                review = program.getRottenTomatoReview();
        }

        return review;
    };

    PurchaseGroup.prototype.getImageLink = function( width, height )
    {
        var link, purchase = this._purchases[0];

        if( purchase )
            link = purchase.getEntity().getImageLink( width, height );

        return link;
    };

    PurchaseGroup.prototype.getFallbackImageLink = function()
    {
        var link, purchase = this._purchases[0];

        if( purchase )
            link = purchase.getEntity().getFallbackImageLink( width, height );

        return link;
    };

    PurchaseGroup.prototype.getTitle = function()
    {
        return this.get("name");
    };

    PurchaseGroup.prototype.getEntityType = function()
    {
        if( this._purchases )
        {
            if( this._purchases[0] )
                return this._purchases[0].getEntityType();
        }
    };

    PurchaseGroup.prototype.isWatched = function()
    {
        if( this._purchases && this._purchases.length === 1 )
            return this._purchases[0].isWatched();
    };

    return PurchaseGroup;
})();


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchasePin = (function()
{
    "use strict";

    PurchasePin.prototype = new DataObject();

    function PurchasePin(){}

    /**
     * Initialize PurchasePin object
     * @param data
     * @return {PurchasePin}
     */
    PurchasePin.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );

        return this;
    };

    /**
     * Set the purchase Pin
     * @param {string} currentPin
     * @param {string} newPin
     * @return {Promise}
     */
    PurchasePin.prototype.setPin = function( currentPin, newPin )
    {
        var form = this.getForm("setPurchasePin");

        form.getFields();

        if( currentPin )
            form.setFieldValue( "currentPin", currentPin );

        form.setFieldValue( "newPin", newPin );

        return form.submit();
    };

    /**
     * Return true if the purchase pin is enabled for stream
     * @return {boolean}
     */
    PurchasePin.prototype.isEnabled = function()
    {
        return ( this.get("enabled") === "stream" );
    };

    /**
     * Disable purchase pin
     * @param {string} pin - current pin
     * @return {Promise}
     */
    PurchasePin.prototype.disablePin = function( pin )
    {
        var form = this.getForm("disablePurchasePin");
        return form.submit( { currentPin:pin } );
    };

    /**
     * Verify purchase pin
     * @param {string} pin - current pin
     * @return {Promise} - valid pin on success callback, invalid pin on error callback.
     */
    PurchasePin.prototype.verifyPin = function( pin )
    {
        var form = this.getForm("verifyPurchasePin");

        form.getFields();
        form.setFieldValue("currentPin", pin);

        return form.submit();
    };

    return PurchasePin;
})();


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Represents a rating (i.e. MPAA). Maps to XTV "contentRating/detailed" object
 */
window.Rating = (function()
{
    "use strict";

    function Rating(){}

    /**
     * Initialize the object
     * @memberOf Rating
     * @param {Object} data - XTV derived JSON object
     * @returns {Rating}
     */
    Rating.prototype.init = function( data )
    {
        this._data = data;
        return this;
    };

    /**
     * Get the rating name/lable i.e. "TV-Y"
     * @memberOf Rating
     * @return {String}
     */
    Rating.prototype.getName = function()
    {
        return this._data.name;
    };

    /**
     * Get the sub ratings
     * @memberOf Rating
     * @return {Array} 
     */
    Rating.prototype.getSubRatings = function()
    {
        return this._data.subRating;
    };

    /**
     * Get the rating type (i.e. MPAA)
     * @memberOf Rating
     * @return {String}
     */
    Rating.prototype.getType = function()
    {
        return this._data._type; //TODO: use constants
    };
    
    return Rating;
})();


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RecorderSummary = (function()
{
    "use strict";

    RecorderSummary.prototype = new DataObject();

    function RecorderSummary(){}

    /**
     * Initialize this object
     * @param {Object} data - XTV derived JSON object
     * @memberOf RecorderSummary
     * @return {RecorderSummary}
     */
    RecorderSummary.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    /**
     * Get the percent used
     * @memberOf RecorderSummary
     * @return {number}
     */
    RecorderSummary.prototype.getPercentUsed = function()
    {
        return this.get("percentUsed");
    };

    /**
     * Get the number of programs recorded
     * @memberOf RecorderSummary
     * @return {number}
     */
    RecorderSummary.prototype.getTotalRecorded = function()
    {
        return this.get("totalRecorded");
    };

    /**
     * Get number of recordings scheduled
     * @memberOf RecorderSummary
     * @return {number}
     */
    RecorderSummary.prototype.getTotalScheduled = function()
    {
        return this.get("totalScheduled");
    };

    return RecorderSummary;
})();


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * A RecordingCollection aggregates RecordingGroups, EntityRecordings (series recordings),
 * Programs (series) and SportsTeams.
 *
 * Every Recording object should contain a reference to its RecordingCollection so that
 * any of the associated EntityRecordings, Programs and SportsTeams can be found.
 *
 * We maintain this reference instead of iterating all of the Recordings up front, and
 * instead rely on a lazy initialization pattern.
 *
 */

window.RecordingCollection = (function()
{
    "use strict";

    function RecordingCollection(){}

    /**
     * Get the entity render style - default to POSTER.
     * @return {XtvApi.EntityRenderStyle|String}
     */
    RecordingCollection.prototype.getChildRenderStyle = function()
    {
        return this._childRenderStyle || XtvApi.EntityRenderStyle.POSTER;
    };

    /**
     * Get all entities in this collection.
     * @memberOf RecordingCollection
     * @return {Recording[]}
     */
    RecordingCollection.prototype.getEntities = function()
    {
        return this.getRecordings();
    };

    /**
     * Initialize this object
     * @memberOf RecordingCollection
     * @param {Object} data - XTV derived JSON object
     * @param {String} title - Title of this collection. i.e. "Recent Recordings"
     * @param {XtvApi.EntityRenderStyle} [childRenderStyle] - set the render style of this collection
     * @return {RecordingCollection}
     */
    RecordingCollection.prototype.init = function( data, title, childRenderStyle )
    {
        this._data = data;
        this._title = title;
        this._childRenderStyle = childRenderStyle;

        return this;
    };

    /**
     * Get all recordings in the collection
     * @memberOf RecordingCollection
     * @return {Recording[]} Array
     */
    RecordingCollection.prototype.getRecordings = function()
    {
        if( !this._recordings )
        {
            var i, recordings, entity, recording, series, seriesId,  seriesObjs = {};

            series = this._data._embedded.series;

            for( i=0; i<series.length; i++ )
                seriesObjs[series[i].merlinId] = new Entity().init(series[i]);

            this._recordings = [];
            recordings = this._data._embedded.recordings;

            for( i = 0; i < recordings.length; i++ )
            {
                recording = new Recording().init( recordings[i] );
                entity    = recording.getEntity();

                if( entity )
                {
                    seriesId = entity.getSeriesId();
                    if( seriesObjs[seriesId] )
                        entity.setSeries( seriesObjs[seriesId] );
                }

                this._recordings.push( recording );
            }
        }

        return this._recordings;
    };

    /**
     * Get All recordings organized by group
     * @memberOf RecordingCollection
     * @return {Array} {@link RecordingGroup} Array
     */
    RecordingCollection.prototype.getRecordingsByGroup = function()
    {
        if( !this._groups )
        {
            this._groups = [];

            var i, j, k, s, ids, group, recording, sid, entity;
            var recordingsAry = [];
            var seriesMap     = {};
            var recordings    = this._data._embedded.recordings;
            var groups        = this._data._embedded.recordingGroups;
            var series        = this._data._embedded.series;

            for( i=0; i<series.length; i++ )
            {
                s = new Entity().init(series[i]);
                sid = s.getEntityId();
                seriesMap[sid] = s;
            }

            for( i = 0; i < recordings.length; i++ )
            {
                recording = new Recording().init( recordings[i] );
                entity    = recording.getEntity();
                sid       = recording.getSeriesId();

                if( entity && sid && seriesMap[sid] )
                    entity.setSeries( seriesMap[sid]);

                recordingsAry.push( recording );
            }

            for( i = 0; i < groups.length; i++ )
            {
                group = new RecordingGroup().init( groups[i] );
                ids   = group.getRecordingIds();

                if( ids.length )
                {
                    for( j = 0; j < ids.length; j++ )
                    {
                        for( k = 0; k < recordingsAry.length; k++ )
                        {
                            if( ids[j] === recordingsAry[k].getId() )
                            {
                                recording = recordingsAry.splice( k, 1 )[0];
                                // recording.setGroup(group); //group is never used
                                group.addRecording(recording);
                                break;
                            }
                        }
                    }
                }
                else
                {
                    if( ! group._data._embedded || ! group._data._embedded.entity )
                        group._empty = true;
                }

                if( !group._empty )
                    this._groups.push( group );
            }
        }

        return this._groups;
    };

    /**
     * Get the title of this collection
     * @memberOf RecordingCollection
     * @return {String}
     */
    RecordingCollection.prototype.getTitle = function()
    {
        return this._title;
    };

    /**
     * Get the number of entities in this collection
     * @memberOf RecordingCollection
     * @return {Number}
     */
    RecordingCollection.prototype.getTotalEntityCount = function()
    {
        var recordings = this.getRecordings();
        return recordings ? recordings.length : 0;
    };

    return RecordingCollection;

})();




/***/ }),
/* 38 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * RecordingGroup aggregates a set of related recordings and associates them with a name.
 * A RecordingGroup is contained by a RecordingCollection, which in addition to RecordingGroups,
 * aggregates other structures including EntityRecordings (series recordings), Programs (series)
 * and SportsTeams, which have a 1:* relationship with the Recordings contained within.
 *
 */

window.RecordingGroup = (function()
{
    "use strict";

    var RecordingGroup = function(){};

    /**
     * Initialize this object
     * @param {Object} data - XTV derived JSON object
     * @return {RecordingGroup}
     */
    RecordingGroup.prototype.init = function( data )
    {
        this._data = data || {};

        return this;
    };

    /**
     * Add a recording to this group
     * @memberOf RecordingGroup
     * @param {Recording} recording
     */
    RecordingGroup.prototype.addRecording = function( recording )
    {
        if( !this._recordings )
            this._recordings = [];

        this._recordings.push( recording );
    };

    RecordingGroup.prototype.getLastRecordingDate = function()
    {
        var retval;

        if( this._data.lastRecorded )
            retval = new Date(this._data.lastRecorded);

        return retval;
    };

    /**
     * Get the name of this group
     * @memberOf RecordingGroup
     * @return {String}
     */
    RecordingGroup.prototype.getName = function()
    {
        return this._data.name;
    };

    /**
     * Get all recordings in this group
     * @memberOf RecordingGroup
     * @return {Array} {@link Recording} Array
     */
    RecordingGroup.prototype.getRecordings = function()
    {
        return this._recordings;
    };

    /**
     * Get the number of recordings in this group
     * @return {Number}
     */
    RecordingGroup.prototype.getRecordingsCount = function()
    {
        if( this._recordings )
            return this._recordings.length;
        else
            return this._data.numRecordings;
    };

    /**
     * Get the details of the recording in this group at given index
     * @memberOf RecordingGroup
     * @param {Number} index
     * @return {Promise}
     */
    RecordingGroup.prototype.getRecording = function( index )
    {
        var promise, self = this;

        if( ! this._data._recordings )
            this._data._recordings = [];

        if( this._data._recordings[index] )
            promise = Promise.resolve( this._data._recordings[index] );
        else
        {
            var resolver = function( resolve, reject )
            {
                var success = function( response )
                {
                    var recording = new Recording().init( JSON.parse( response.data ) );
                    self._data._recordings[index] = recording;
                    resolve( recording );
                };

                var error = function( error )
                {
                    reject( error );
                };

                var recordings = self._data._links.recordings;
                var url = recordings.length ? recordings[index].href : recordings.href ;

                url = XtvApi.trimPath( url );
                url = url.replace( /\#/g, '' );

                _x2._network.ajax({type: "GET", url: _x2._data._host + url, headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv}).then(success).catch(error);
            };

            promise = new Promise( resolver );
        }

        return promise;
    };

    /**
     * Get a list of all IDs for recordings in this group
     * @memberOf RecordingGroup
     * @return {Array} {String} Array
     */
    RecordingGroup.prototype.getRecordingIds = function()
    {
        var recordings, tokens, i;

        if( !this._recordingIds )
        {
            this._recordingIds = [];

            if( this._data._links && this._data._links.recordings )
            {
                recordings = this._data._links.recordings;

                if( recordings instanceof Array )
                {
                    for( i = 0; i < recordings.length; i++ )
                    {
                        tokens = recordings[i].href.split( '/' );  //TODO: a cleaner source of IDs?

                        if( tokens && tokens.length > 2 )
                            this._recordingIds.push( tokens[tokens.length - 2] )
                    }
                }
                else
                {
                    tokens = recordings.href.split( '/' );  //TODO: a cleaner source of IDs?

                    if( tokens && tokens.length > 2 )
                        this._recordingIds.push( tokens[tokens.length - 2] )
                }
            }
        }

        return this._recordingIds;
    };

    /**
     * Get the program associated with this recording.
     * @return {Promise.<Program>}
     */
    RecordingGroup.prototype.getProgram = function()
    {
        var promise, self = this;

        if( this._program )
            promise = Promise.resolve( this._program );
        else if( this._data._embedded && this._data._embedded.entity )
        {
            this._program = new Entity().init( this._data._embedded.entity );
            promise = Promise.resolve( this._program)
        }
        else
        {
            var resolver = function( resolve, reject )
            {
                var success = function( response )
                {
                    self._program = new Entity().init( JSON.parse( response.data ) );
                    resolve( self._program );
                };

                var error = function( error )
                {
                    reject( error );
                };

                var url, links = self._data._links;
                if( links )
                {
                    url = self._data._links.entity;
                    if( url )
                    {
                        if( url.href )
                        {
                            url = XtvApi.trimPath( url.href );
                            url = url.replace( /\#/g, '' );
                            _x2._network.ajax( { type: "GET", url: _x2._data._host + url, headers: [_x2._data._authHeader], accepts: Network.Accepts.xtv } ).then( success ).catch( error );
                        }
                    }
                }
            };

            promise = new Promise( resolver );
        }

        return promise;
    };

    RecordingGroup.prototype.removeRecording = function( recording )
    {
        var i, id = recording.getId();

        for( i = 0; i < this._recordings.length; i++ )
        {
            if( this._recordings[i].getId() === id )
            {
                this._recordings.splice(i,1);
                break;
            }
        }
    };

    RecordingGroup.prototype.getType = function()
    {
        return this._data.groupType;
    };

    return RecordingGroup;
})();


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * 
 * Maps to XTV "ResumePoint"
 */
window.ResumePoint = (function()
{
    "use strict";
    
    function ResumePoint(){}

    /**
     * Initialize this object
     * @param {Object} data - XTV derived JSON object
     * @memberOf ResumePoint
     * @return {ResumePoint}
     */
    ResumePoint.prototype.init = function( data )
    {
        this._data = data;
        
        return this;
    };

    /**
     * Get the id of the media asset related to this resume point
     * @memberOf ResumePoint
     * @return {String}
     */
    ResumePoint.prototype.getMediaId = function()
    {
        return this._data.mediaId;
    };

    /**
     * Get the the resume point position
     * @memberOf ResumePoint
     * @return {Number} Millisecond offset
     */
    ResumePoint.prototype.getPosition = function()
    {
        var position = 0;

        if( !isNaN( this._data.position ) )
            position = parseInt(this._data.position);

        return position;
    };

    ResumePoint.prototype.getShowing = function()
    {
        return this._showing;
    };

    ResumePoint.prototype.setPosition = function( position )
    {
        this._data.position = position;
    };

    ResumePoint.prototype.setShowing = function( showing )
    {
        this._showing = showing;
    };
    
    return ResumePoint;
})();



/***/ }),
/* 40 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * 
 * Maps to XTV "Review"
 */
window.Review = (function()
{
    "use strict";

    function Review(){}

    /**
     * Initialize this object
     * @memberOf Review
     * @param {Object} data - XTV derived JSON object
     * @return {Review}
     */
    Review.prototype.init = function( data )
    {
        this._data = data;
        return this;
    };

    /**
     * Return true if the critic summary is marked as certified
     * @memberOf Review
     * @return {Boolean}
     */
    Review.prototype.getCriticSummaryCertified = function()
    {
        return this._data.attributes.criticSummaryCertified;
    };

    /**
     * Get the number of critic reviews
     * @memberOf Review
     * @return {Number}
     */
    Review.prototype.getCriticSummaryCount = function()
    {
        return this._data.attributes.criticSummaryCount;
    };

    /**
     * Return true if the critic score is 'rotten'
     * @memberOf Review
     * @return {Boolean}
     */
    Review.prototype.getCriticSummaryRotten = function()
    {
        return this._data.attributes.criticSummaryRotten;
    };

    /**
     * Get the critic score
     * @memberOf Review
     * @return {Number}
     */
    Review.prototype.getCriticSummaryScore = function()
    {
        return this._data.attributes.criticSummaryScore;
    };

    /**
     * Get the Common Sense Media score
     */
    Review.prototype.getCommonSenseMediaScore = function()
    {
        return this._data.attributes.value;
    };

    /**
     * Return true if the fan summary is marked as certified
     * @memberOf Review
     * @return {Boolean}
     */
    Review.prototype.getFanSummaryCertified = function()
    {
        return this._data.attributes.fanSummaryCertified;
    };

    /**
     * Get the number of fan reviews
     * @memberOf Review
     * @return {Number}
     */
    Review.prototype.getFanSummaryCount = function()
    {
        return this._data.attributes.fanSummaryCount;
    };

    /**
     * Return true if the fan score is 'rotten'
     * @memberOf Review
     * @return {Boolean}
     */
    Review.prototype.getFanSummaryRotten = function()
    {
        return this._data.attributes.fanSummaryRotten;
    };

    /**
     * Get the fan summary score
     * @memberOf Review
     * @return {Number}
     */
    Review.prototype.getFanSummaryScore = function()
    {
        return this._data.attributes.fanSummaryScore;
    };

    /**
     * Get the review type
     * @memberOf Review
     * @returns {String}
     */
    Review.prototype.getProvider = function()
    {
        return this._data.provider;
    };

    /**
     * Return true if there are valid ratings in this review
     * @return {boolean}
     */
    Review.prototype.isValid = function()
    {
        var retval = true;
        
        if( isNaN( this.getCriticSummaryScore() ) )
            retval = false;
        else if( isNaN( this.getFanSummaryScore() ))
            retval = false;
        
        return retval;
    };
    
    return Review;
    
})();


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * @class
 */
window.ScheduledRecordings = (function()
{
    "use strict";

    ScheduledRecordings.prototype = new DataObject();

    function ScheduledRecordings(){}

    ScheduledRecordings.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );

        this._recordings = [];

        var i, recCollection, key, object;

        recCollection = this.getEmbedded("recordings");
        if( recCollection )
        {
            for( i=0; i<recCollection.length; i++ )
            {
                object = new Recording().init( recCollection[i] );
                key = object.getListingId();
                this._recordings[key] = object;
            }
        }

        return this;
    };

    ScheduledRecordings.prototype.getRecording = function( listingId )
    {
        if( this._recordings )
            return this._recordings[ listingId ];
    };

    return ScheduledRecordings;
})();


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Maps to XTV "SearchResult"
 */
window.SearchEntity = (function()
{
    "use strict";
    function SearchEntity(){}

    SearchEntity.prototype = new ThumbnailEntity();

    /**
     * Initialize this object
     * @param {Object} data - XTV derived JSON object
     * @return {SearchEntity}
     */
    SearchEntity.prototype.init = function( data )
    {
        ThumbnailEntity.prototype.init.call( this, data );

        return this;
    };

    /**
     * Get the linear asset's end time
     * @return {Date}
     */
    SearchEntity.prototype.getEndTime = function()
    {
        var time, endTime = this.getInteger("endTime");

        if( endTime )
            time = new Date( endTime );

        return time;
    };

    /**
     * Get the embedded entity
     * @return {String}
     */
    SearchEntity.prototype.getEntity = function()
    {
        return this.getEmbedded("entity");
    };

    /**
     *
     * @return {*|String}
     */
    SearchEntity.prototype.getEntityId = function()
    {
        var id, entity = this.getEntity();

        if( entity )
        {
            id = entity['programId'];

            if( ! id )
                id = entity['merlinId'];
        }

       return id;
    };

    /**
     *
     * @param width
     * @param height
     * @returns {string}
     */
    SearchEntity.prototype.getFallbackImageLink = function( width, height )
    {
        var link = this.getPath(["_embedded","entity","_links","fallbackImage"]);

        if( link )
            link = XtvApi.replaceUrlParams( link.href, { width: width, height: height } );
        else
        {
            link = this.getImageLink( width, height );
            if( link )
                link = link + "&default=force";
        }

        return link;
    };

    /**
     *
     * @param width
     * @param height
     * @return {string}
     */
    SearchEntity.prototype.getImageLink = function( width, height )
    {
        var link;
        var w    = width  || 180;
        var h    = height || 240;
        var type = this.getPath(["_embedded","entity","_type"]);

        if( type === "s:Organization" )
            link = _x2._config._imageRoot + "channel_collection_bg.png";
        else
        {
            link = this.getPath(["_embedded","entity","_embedded","channel","_links","logo"]);

            if( ! link )
                link = this.getPath(["_embedded","entity","_links","image"]);

            if( link )
                link = XtvApi.replaceUrlParams( link.href, { width: w, height: h } );
        }

        return link;
    };

    SearchEntity.prototype.getChannel = function()
    {
        if( ! this._channel )
        {
            var channel = this.getPath(["_embedded","entity","_embedded","channel"]);

            if( channel )
                this._channel = new Channel().init(channel);
        }

        return this._channel;
    };


    SearchEntity.prototype.getProgramType = function()
    {
        return this.getPath(["_embedded","entity","_type"]);
    };

    /**
     * Get the entity subtitle (description)
     * @memberOf SearchEntity
     * @return {String}
     */
    SearchEntity.prototype.getSubtitle = function()
    {
        return this.get("subtitle");
    };

    /**
     * Get the HLS stream for this entity
     * @return {String} url
     */
    SearchEntity.prototype.getStreamUrl = function()
    {
        var i, url, stream, streams = this.getPath(["_embedded","entity","_embedded","channel","_embedded","stream"]);

        if( streams )
        {
            for( i=0; i<streams.length; i++ )
            {
                stream = streams[i];
                if( stream["encodingFormat"] === 'HLS' )
                    url = this.getPath(["_links","contentUrl","href"], stream );
            }
        }

        return url;
    };

    /**
     * Get the linear asset's start time
     * @return {Date}
     */
    SearchEntity.prototype.getStartTime = function()
    {
        var time, startTime = this.getInteger("startTime");

        if( startTime )
            time = new Date( startTime );

        return time;
    };

    /**
     * Get the entity title
     * @memberOf SearchEntity
     * @return {String}
     */
    SearchEntity.prototype.getTitle = function()
    {
        return this.get("name");
    };

    SearchEntity.prototype.getType = function()
    {
        return this.getPath(["_embedded","entity","_type"]);
    };

    return SearchEntity;

})();


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 *
 * @class
 */
window.Season = (function()
{
    "use strict";

    Season.prototype = new DataObject();

    function Season(){}

    Season.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    Season.prototype.addEpisode = function( episode )
    {
        if( ! this._episodes )
            this._episodes = [];

        this._episodes.push( episode );
    };

    Season.prototype.getNumber = function()
    {
        return this.get("seasonNumber");
    };

    Season.prototype.getEpisodeCount = function()
    {
        var count = this.getInteger("totalPrograms");

        if( ! count && this._episodes )
            count = this._episodes.length;

        return count;
    };

    Season.prototype.getEpisodes = function( page )
    {
        var embedded, episodes = [];

        if( ! this._episodes )
        {
            this._episodes = [];
            embedded = this.getPath(["_embedded","watchOptions","_embedded","programs"] );
            if( embedded )
            {
                for( var i=0; i<embedded.length; i++ )
                    this._episodes.push( new Entity().init(embedded[i]));
            }
        }

        if( page !== undefined )
        {
            if( this._episodes.length > 0 )
            {
                var start = page  * EntityOptions.programsPerPage;
                var end   = start + EntityOptions.programsPerPage;
                episodes = this._episodes.slice( start, end )
            }
        }
        else
            episodes = this._episodes;

        return episodes;
    };

    Season.prototype.fetchEpisodes = function( page, perPage )
    {
        var setEpisodes, params, link, i, promise;
        var self         = this;
        var episodeCount = this._episodes ? this._episodes.length : 0;

        setEpisodes = function( response )
        {
            var data     = JSON.parse(response.data);
            var episodes = self.getPath(["_embedded", "programs"], data );

            if( self._episodes === undefined )
                self._episodes = [];

            for( i=0; i<episodes.length; i++ )
                self._episodes.push( new Entity().init(episodes[i]));
        };

        link = this.getLinkObject("watchOptions");

        if( link )
        {
            params = {};
            params.programPage     = page;
            params.programsPerPage = perPage;
            params.programsSortDir = 'desc';
            params.freetome        = ( _x2._config._purchases && _x2._features.hasEntitlement( Features.Entitlement.EST ) ) ? "off" : "on";

            if( episodeCount < ( page * perPage ) )
                promise = link.resolve( params ).then( setEpisodes );
            else
                promise = Promise.resolve();
        }
        else //if there is no watchOptions link, there are no additional episodes to fetch
            promise = Promise.resolve();

        return promise;
    };

    return Season;
})();


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



/**
 * @class
 *
 */
window.SportsTeam = (function()
{
    SportsTeam.prototype = new DataObject();

    function SportsTeam(){}

    /**
     * Initialize this object
     * @memberOf SportsTeam
     * @param {Object} data - XTV derived JSON object
     */
    SportsTeam.prototype.init = function(data)
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    SportsTeam.prototype.getCoach = function()
    {
        return this.get("coach");
    };

    SportsTeam.prototype.getConference = function()
    {
        return this.get("conference");
    };

    SportsTeam.prototype.getDetail = function()
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var entityLoaded = function( response )
            {
                self._data = JSON.parse(response);
                self._options = new EntityOptions().init( self );
                self._options.fetch().then( function(){ resolve( self ) } ).catch( reject );
            };

            var id = self.get("entityId") || self.get("merlinId");

            _x2._data.getSportsTeamEntity(id).then(entityLoaded).catch(reject);
        };

        return new Promise( resolver );
    };

    SportsTeam.prototype.getEntityId = function()
    {
        return this.get("merlinId");
    };

    SportsTeam.prototype.getEpisodes = function()
    {
        var episodes = [];

        if( this._options )
            episodes = this._options.getEpisodes();
        else
            console.log("WARNING -> SportsTeam.EntityOptions not initialized" );

        return episodes;
    };

    SportsTeam.prototype.getFallbackImageLink = function( w, h )
    {
        return this.getLink( "fallbackImage", { width: w, height: h } );
    };

    SportsTeam.prototype.getGames = function()
    {
        var games = [];

        if( this._options )
            games = this._options.getUpcomingListings();
        else
            console.log("WARNING -> SportsTeam.EntityOptions not initialized" );

        return games;
    };

    SportsTeam.prototype.getImageLink = function( w, h )
    {
        return this.getLink( "image", { width: w, height: h } );
    };

    SportsTeam.prototype.getLeague = function()
    {
        return this.get("league");
    };

    SportsTeam.prototype.getLocation = function()
    {
        var strings = [];
        var locality = this.getPath(["location","addressLocality"]);
        var region   = this.getPath(["location","addressRegion"]);

        if( locality )
            strings.push( locality );

        if( region )
            strings.push( region );

        return strings.join( ', ' );
    };

    SportsTeam.prototype.getName = function()
    {
        var strings = [];

        if( this.get("representingName") )
            strings.push( this.get("representingName") );

        if( this.get("name") )
            strings.push( this.get("name") );

        return strings.join(' ');
    };

    SportsTeam.prototype.getProgram = function()
    {
        return this;
    };

    SportsTeam.prototype.getSelfLink = function()
    {
        return this.getLink("self");
    };

    SportsTeam.prototype.getTitle = function()
    {
        return this.getName();
    };

    SportsTeam.prototype.getType = function()
    {
        return XtvApi.EntityType.TEAM;
    };

    SportsTeam.prototype.getUpcomingListings = function()
    {
        return this._games;
    };

    SportsTeam.prototype.getVenue = function()
    {
        return this.get("venue");
    };

    return SportsTeam;
})();


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 */
window.Showing = (function()
{
    "use strict";

    Showing.prototype = new DataObject();

    /**
     * @enum AudioType
     * @property {Number} DOLBY_5_1 Dolby 5.1
     * @property {Number} UNKNOWN
     */
    Showing.AudioType = Object.freeze
    ({
        DOLBY_5_1 : 0,
        UNKNOWN   : 9
    });

    function Showing(){}

    /**
     * Initialize this object
     * @memberOf Showing
     * @param {Object} data - XTV derived JSON object
     * @return {Showing}
     */
    Showing.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    /**
     *
     * @return {Promise<any>}
     */
    Showing.prototype.fetchProgram = function()
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( obj )
            {
                //TODO: replace getProgram with getEntity and fix this.
                self._entity = new Entity().init( JSON.parse(obj.data));
                resolve();
            };

            self.getLinkObject("encodesCreativeWork").resolve({}).then(success).catch(reject);
        };

        return new Promise( resolver );
    };

    /**
     * Get the content provider
     * @return {ContentProvider}
     */
    Showing.prototype.getContentProvider = function()
    {
        if( ! this._contentProvider )
        {
            var data = this.getEmbedded("contentProvider");

            if( ! data )
                data = this.getEmbedded("provider/channel"); //TODO: (MATT) exercise both paths. Are they really the same data

            this._contentProvider = new ContentProvider().init( data );
        }
        return this._contentProvider;
    };

    /**
     * Get the showing duration in minutes
     * @return {Number} duration in minutes;
     */
    Showing.prototype.getDuration = function()
    {
        var duration = 0, durationMs = this.getDurationMs();

        if( durationMs )
            duration = Math.round(durationMs/60000);

        return duration;
    };

    /**
     * Get embedded entity
     * @return {Entity}
     */
    Showing.prototype.getEntity = function()
    {
        if( ! this._entity )
        {
            var data = this.getEmbedded("encodesCreativeWork");
            if( data )
                this._entity = new Entity().init( data );
        }

        return this._entity;
    };

    /**
     * Return true if this showing has been watched
     * @memberOf Recording
     * @return {Boolean}
     */
    Showing.prototype.isWatched = function()
    {
        return this.get("watched");
    };


    /**
     * Get the showing entity id
     * @memberOf Showing
     * @return {String}
     */
    Showing.prototype.getEntityId = function()
    {
        return this.get("entityId");
    };

    /**
     * Get the episode sort number
     * @return {Number}
     */
    Showing.prototype.getEpisodeSortNumber = function()
    {
        return ( this._entity ? this._entity.getEpisodeSortNumber() : -1 );
    };

    Showing.prototype.getEntityImageLink = function(width, height, fallback)
    {
        var link;
        var entity = this.getEntity();

        var w = width  ? width  : 240;
        var h = height ? height : 320;

        if( entity )
            link = ( fallback ? entity.getFallbackImageLink(w, h) : entity.getImageLink(w,h) );

        if( link === undefined )
            link = "https://edge.myriad-gn-xcr.xcr.comcast.net/select/image?priority=true&entityId=" + this.getProgramId() + "&width=" + w + "&height=" + h + (fallback ? "&default=force" : "");

        return link;
    };

    Showing.prototype.getFallbackImageLink = function(width, height)
    {
        return this.getEntityImageLink( width, height, true );
    };

    Showing.prototype.getImageLink = function(width, height)
    {
        return this.getEntityImageLink( width, height, false );
    };

    /**
     *
     * @return {XtvApi.EntityType}
     */
    Showing.prototype.getType = function()
    {
        var type, program = this.getEntity();

        if( program )
            type = program.getType();

        if( ! type )
            type = this.get("type");

        return type;
    };

    /**
     * TODO: replace all calls to getProgram() with getEntity() and remove this
     * @return {Entity}
     */
    Showing.prototype.getProgram = function()
    {
        return this.getEntity();
    };

    Showing.prototype.getProgramType = function()
    {
        var type, program = this.getEntity();

        if( program )
            type = program.getType();
        else
            type = this.get("type");

        return type;
    };

    /**
     * Get the showing media id
     * @memberOf Showing
     * @return {String}
     */
    Showing.prototype.getMediaId = function()
    {
        return this.get("mediaId");
    };

    /**
     *
     * @return {number}
     */
    Showing.prototype.getMinsRemaining = function()
    {
        var remaining = 0, resumePoint = this.getResumePoint();

        if( resumePoint )
        {
            var pos = resumePoint.getPosition();
            var duration = this.getDurationMs();

            if( !isNaN( duration ) && pos > 0 )
                remaining = Math.round( ( parseInt( duration ) - parseInt( pos ) ) / ( 60000 ) );
        }

        return remaining;
    };

    /**
     * Get the showing paid
     * @memberOf Showing
     * @return {String}
     */
    Showing.prototype.getPaid = function()
    {
        return this.get("paid");
    };

    /**
     * Get the showing program id
     * @memberOf Showing
     * @return {String}
     */
    Showing.prototype.getProgramId = function()
    {
        //TODO: (Entity Refactor) should we override this in child classes? Check if VOD showing has "programId" and linear showing has "entityId"
        return this.getByPriority("programId", "entityId");
    };

    /**
     * Get the program rating string
     * @return {String}
     */
    Showing.prototype.getRating = function()
    {
        var rating, object = this.get("contentRating/detailed");

        if( object )
            rating = object.name;
        else
        {
            var entity = this.getEntity();
            if( entity )
                rating = entity.getRating()
        }
        return rating;
    };

    /**
     *
     * @return {*}
     */
    Showing.prototype.getResumePoint = function()
    {
        var i, resumePoint;
        if( _x2._resume && _x2._resume.length )
        {
            for( i = 0; i < _x2._resume.length; i++ )
            {
                if( this._data.mediaId === _x2._resume[i].getMediaId() )
                {
                    resumePoint = _x2._resume[i];
                    resumePoint.setShowing( this );
                    break;
                }
            }
        }
        return resumePoint;
    };

    /**
     * Get the m3u8 streaming content url
     * @return {String}
     */
    Showing.prototype.getStreamUrl = function()
    {
        var url, streams = this.getEmbedded("streams");

        if( streams )
        {
            for( var i=0; i<streams.length; i++ )
            {
                if( streams[i]['encodingFormat'] === 'M3U' )
                {
                    url = streams[i]._links['contentUrl'].href;
                    break;
                }
            }
        }
        return url;
    };

    /**
     * Get the showing title (program title)
     * @memberOf Showing
     * @return {String}
     */
    Showing.prototype.getTitle = function()
    {
        return this.getByPriority("title","derivedTitle")
    };

    /**
     * Return true if this showing has closed captions
     * @memberOf Showing
     * @return {Boolean}
     */
    Showing.prototype.isClosedCaptioned = function()
    {
        return this.get("closedCaption");
    };

    /**
     * Return true if this showing is DVS
     * @memberOf Showing
     * @return {Boolean}
     */
    Showing.prototype.isDvs = function()
    {
        return this.get("hasDVS");
    };

    /**
     * Return true if this showing is HD
     * @memberOf Showing
     * @return {Boolean}
     */
    Showing.prototype.isHD = function()
    {
        return this.get("isHD");
    };

    /**
     * Return true if this showing has a SAP
     * @memberOf Showing
     * @return {Boolean}
     */
    Showing.prototype.isSap = function()
    {
        return this.get("isSAP");
    };

    /**
     * Return true if this showing is HD
     * @memberOf Showing
     * @return {Boolean}
     */
    Showing.prototype.isThreeD = function()
    {
        return this.get("isThreeD");
    };

    /**
     * Returns true. By default assume a showing is watchable. Intended to be overridden in the case add'l logic is required.
     * @return {boolean}
     */
    Showing.prototype.isWatchable = function()
    {
        return true;
    };

    /**
     * Set the entity for this showing.
     */
    Showing.prototype.setEntity = function( entity )
    {
        this._entity = entity;
    };

    return Showing;

})();



/***/ }),
/* 46 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Maps to XTV _type "s:VodItem"
 */
window.VodShowing = (function()
{
    "use strict";

    VodShowing.prototype = new Showing();

    function VodShowing(){}

    /**
     * Initialize this object
     * @param {Object} data - XTV derived JSON object
     * @return {VodShowing}
     */
    VodShowing.prototype.init = function( data )
    {
        Showing.prototype.init.call( this, data );
        return this;
    };

    /**
     * Get the asset ID
     * @memberOf Showing
     * @return {String}
     */
    VodShowing.prototype.getAssetId = function()
    {
        return this.get("assetId");
    };

    /**
     * Get duration in milliseconds
     * @return {number}
     */
    VodShowing.prototype.getDurationMs = function()
    {
        var durationMs = 0, duration = this.get("duration");

        if( duration && !isNaN( duration ) )
            durationMs = parseInt( duration );

        return durationMs;
    };

    /**
     * Get the showing's media GUID
     * @memberOf VodShowing
     * @return {String}
     */
    VodShowing.prototype.getMediaGuid = function()
    {
        return this.get("mediaGuid");
    };

    /**
     * Get the provider ID
     * @memberOf Showing
     * @return {String}
     */
    VodShowing.prototype.getProviderId = function()
    {
        return this.get("providerId");
    };

    /**
     * Get the the showing window expiration time.
     * @return {Date}
     */
    VodShowing.prototype.getVodWindowExpireTime = function()
    {
        var ends, val = this.get("vodWindowExpireTime");

        if( val )
            ends = new Date( parseInt(val) );

        return ends;
    };

    /**
     * Return true if this showing is marked as adult content
     * @memberOf VodShowing
     * @returns {Boolean}
     */
    VodShowing.prototype.isAdult = function()
    {
        return this.get("isAdult");
    };

    /**
     * Return true if trick mode is restricted
     * @memberOf VodShowing
     * @returns {Boolean}
     */
    VodShowing.prototype.isTrickModeRestricted = function()
    {
        return this.getBoolean("isTrickModeRestricted" );
    };

    /**
     * Returns the release year of the entity.
     * @return {*}
     */
    VodShowing.prototype.getYear = function()
    {
        return this.get("year");
    };

    return VodShowing;
})();



/***/ }),
/* 47 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TransactionDetails = (function()
{
    "use strict";

    TransactionDetails.Type = {
        RENTAL   : 'rented',
        PURCHASE : 'purchased'
    };

    TransactionDetails.prototype = new DataObject();

    function TransactionDetails(){}

    TransactionDetails.prototype.init = function( data )
    {
        DataObject.prototype.init.call( this, data );
        return this;
    };

    TransactionDetails.prototype.getPrice = function()
    {
        return this.get("price");
    };

    TransactionDetails.prototype.getType = function()
    {
        return this.get("type");
    };

    TransactionDetails.prototype.getPurchasedOnDate = function()
    {
        return this.getDate("date");
    };

    return TransactionDetails;
})();


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 * Reference: https://etwiki.sys.comcast.net/display/AAE/Offer+Resources
 */
window.TransactionOffer = (function()
{
    "use strict";

    var PURCHASE_TYPES = [ "Buy", "Rent", "Subscribe" ];
    var OFFER_TYPES    = [ "Single", "SeasonBundle", "SimpleUpsell" ];
    var BILLING_TYPE   = [ "OneTime", "Monthly"];

    TransactionOffer.PurchaseType = Object.freeze({
        BUY      : PURCHASE_TYPES[0],
        RENT     : PURCHASE_TYPES[1],
        SUBSCRIBE: PURCHASE_TYPES[2]
    });

    TransactionOffer.OfferType = Object.freeze({
        SINGLE       : OFFER_TYPES[0],
        SEASON_BUNDLE: OFFER_TYPES[1],
        SIMPLE_UPSELL: OFFER_TYPES[2]
    });

    TransactionOffer.prototype = new Showing();

    function TransactionOffer(){}

    TransactionOffer.prototype.init = function( data )
    {
        Showing.prototype.init.call( this, data );

        return this;
    };

    TransactionOffer.prototype.executeTransaction = function( pin )
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var form = self.getForm("transact");

            if( form )
            {
                form.getFields(); //init the form fields

                if( pin !== undefined )
                    form.setFieldValue( "purchasePin", pin );

                form.submit().then( resolve ).catch( reject );
            }
            else
                reject("Transaction offer not available");
        };

        return new Promise( resolver );
    };

    /**
     * Return common properties used by various transactional Localytics events.
     *  * finalAction - "buy now", "rent now"
     *  * programType - "Movie", "Series", "Other"
     *  * option - <subscribe | <<buy | rent> <SD | HD> <movie | episode | season>>
     * @param {XtvApi.EntityType} entityType - EPISODE, MOVIE, etc.
     * @returns {Object}
     */
    TransactionOffer.prototype.getLocalyticsCommonTransactional = function( entityType )
    {
        var retval   = {},
            purchase = this.getPurchaseType(),
            programType,
            optionsType,
            option;

        if( entityType === XtvApi.EntityType.MOVIE )
        {
            programType = "Movie";
            optionsType = "movie";
        }
        else if( entityType === XtvApi.EntityType.EPISODE || entityType === XtvApi.EntityType.SERIES )
        {
            if( this.getOfferType() === TransactionOffer.OfferType.SEASON_BUNDLE )
            {
                programType = "Series";
                optionsType = "season";
            }
            else
            {
                programType = "Series";
                optionsType = "episode";
            }
        }
        else if( entityType === XtvApi.EntityType.SPORTS || entityType === XtvApi.EntityType.TEAM ) // TODO: Team included?
        {
            programType = "Sporting Event";
            optionsType = "sporting event";
        }
        else
        {
            programType = "Other";
            optionsType = "other";
        }

        if( purchase === TransactionOffer.PurchaseType.SUBSCRIBE )
        {
            option = "subscribe";

            retval.transaction = option;
            retval.finalAction = "subscribe"; // TODO: Not documented
        }
        else
        {
            if( purchase === TransactionOffer.PurchaseType.BUY )
                option = "buy ";
            else if( purchase === TransactionOffer.PurchaseType.RENT )
                option = "rent ";

            retval.transaction = option;
            retval.finalAction = option + "now";

            if( this.isHD() )
                option += "HD - ";
            else
                option += "SD - ";


            option += optionsType;
        }

        retval.programType = programType;
        retval.option      = option;

        return retval;
    };

    TransactionOffer.prototype.isHD = function()
    {
        return this.get("videoQuality") === "HD";
    };

    TransactionOffer.prototype.isSap = function()
    {
        return this.get("isSap");
    };

    /**
     * Use to filter out unsupported offers. XTVAPI requirement.
     * @return {boolean}
     */
    TransactionOffer.prototype.isSupported = function()
    {
        var isValid = true;

        if( PURCHASE_TYPES.indexOf( this.getPurchaseType() ) < 0 )
            isValid = false;

        if( OFFER_TYPES.indexOf( this.getOfferType() ) < 0 )
            isValid = false;

        if( BILLING_TYPE.indexOf( this.getBillingType() ) < 0 )
            isValid = false;

        return isValid
    };

    TransactionOffer.prototype.isSeasonBundle = function()
    {
        return ( this.getOfferType() === "SeasonBundle" );
    };

    TransactionOffer.prototype.getBillingType = function()
    {
        return this.get("billingType");
    };

    TransactionOffer.prototype.getContentProvider = function()
    {
        if( this._contentProvider === undefined )
        {
            var cp = this.getEmbedded("contentProvider");

            if( cp )
                this._contentProvider = new ContentProvider().init( cp );
        }

        return this._contentProvider;
    };

    TransactionOffer.prototype.getDuration = function()
    {
        var durationMin = 0, duration = this.get("duration");

        if( duration && !isNaN( duration ) )
            durationMin = parseInt( duration / 60 );

        return durationMin;
    };

    TransactionOffer.prototype.getNumberOfFeatures = function()
    {
        return this.get( "numberOfFeatures" );
    };

    TransactionOffer.prototype.getOfferType = function()
    {
        return this.get("offerType");
    };

    TransactionOffer.prototype.getPrice = function()
    {
        return this.get("price");
    };

    TransactionOffer.prototype.getPurchaseType = function()
    {
        return this.get("purchaseType");
    };

    TransactionOffer.prototype.getRating = function()
    {
        return this.getPath( [ "contentRating/detailed", "name" ] );
    };

    TransactionOffer.prototype.getRentalWindowInHours = function()
    {
        var hours = 0, seconds = this.getInteger("rentalWindow");

        if( seconds )
            hours = Math.round( seconds / 3600 );

        return hours
    };

    TransactionOffer.prototype.getVideoQuality = function()
    {
        return this.get("videoQuality");
    };

    return TransactionOffer;
})();


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Represents the showing for a linear program.
 *
 * Maps to XTV "TVListing" objects.
 */
window.LinearShowing = (function()
{
    "use strict";

    LinearShowing.prototype = new Showing();

    function LinearShowing(){}

    /**
     * Initialize the object
     * @memberOf LinearShowing
     * @param {Object} data - XTV derived JSON object
     * @param {Object} [channel] - Reference to the channel this showing belongs to
     * @param {Number} [blockId] - Reference to the schedule block this belongs to.
     * @return {LinearShowing}
     */
    LinearShowing.prototype.init = function( data, channel, blockId )
    {
        Showing.prototype.init.call( this, data );

        this._channel   = channel;
        this._gridTitle = data.title; //work-around for detail query stepping on title.
        this._blockId   = blockId;

        return this;
    };

    /**
     * Return true if this episode or series it belongs to can be recorded
     * NOTE: Must call getDetail() first.
     * @memberOf {LinearShowing}
     * @return {boolean}
     */
    LinearShowing.prototype.isRecordable = function()
    {
        var recordable = false;

        var now = _x2._config._startTime ? new Date( _x2._config._startTime ).getTime()+1 : Date.now();
        var end = this.getInteger("endTime" );

        if( end && end > now )
            recordable = ( this.getEpisodeRecordingForm() !== undefined ); //NOTE: we're only concerned with the showings recordable status

        return recordable;
    };

    /**
     * Return true if this episode or series it belongs to is recorded.
     * NOTE: Must call getDetail() first.
     * NOTE: This will return true for a future recording.
     * @memberOf {LinearShowing}
     * @return {boolean}
     */
    LinearShowing.prototype.isRecorded = function()
    {
        return this.isSeriesRecorded() || this.isEpisodeRecorded();
    };

    /**
     * Return true if this episode is recorded
     * @memberOf LinearShowing
     * @return {boolean}
     */
    LinearShowing.prototype.isEpisodeRecorded = function()
    {
        var isRecorded = false, recording = this.getEpisodeRecording();

        if( recording )
            isRecorded = recording.isScheduled();

        return isRecorded;
    };

    /**
     * Return true if this series is recorded
     * @memberOf LinearShowing
     * @return {boolean}
     */
    LinearShowing.prototype.isSeriesRecorded = function()
    {
        var isRecorded = false, recording = this.getSeriesRecording();

        if( recording )
            isRecorded = recording.isScheduled();

        return isRecorded;
    };

    /**
     * Get the embedded entity recording object.
     * @return {EntityRecording}
     */
    LinearShowing.prototype.getEntityRecording = function()
    {
        var entityRecording, embedded = this.getEmbedded("entityRecording");

        if( embedded )
            entityRecording = new EntityRecording().init(embedded);

        return entityRecording;
    };

    /**
     * Return the Recording object for this episode
     * @memberOf LinearShowing
     * @return {Recording}
     */
    LinearShowing.prototype.getEpisodeRecording = function()
    {
        var recordingsMeta = _x2._data.getScheduledRecordingMetadata();
        if( recordingsMeta )
            return recordingsMeta.getRecording(this.getLink("self"));
    };

    /**
     * Return the modify form if the recording is set, the schedule form if available or undefined if there are no available forms.
     * @memberOf LinearShowing
     * @return {Form}
     */
    LinearShowing.prototype.getEpisodeRecordingForm = function()
    {
        var form = this.getForm("schedule");

        if( ! form )
            form = this.getForm("scheduleDateTime");

        return form;
    };

    /**
     * Get the series recording object for the series this program belongs to
     * @memberOf LinearShowing
     * @return {EntityRecording}
     */
    LinearShowing.prototype.getSeriesRecording = function()
    {
        if( ! this._seriesRecording )
        {
            var recording = this.getEmbedded("entityRecording");
            if( recording )
                this._seriesRecording = new EntityRecording().init( recording );
        }

        return this._seriesRecording;
    };

    /**
     * The the series recording form for the series this program belongs to
     * @memberOf LinearShowing
     * @return {Form}
     */
    LinearShowing.prototype.getSeriesRecordingForm = function()
    {
        return this.getForm("scheduleSeries");
    };

    /**
     *
     * @return {number}
     */
    LinearShowing.prototype.getDurationMs = function()
    {
        var durationMs = 0;
        var start = this.get("startTime");
        var end   = this.get("endTime");

        if( start && end )
            durationMs = end - start;

        if( durationMs && !isNaN( durationMs ) )
            durationMs = parseInt( durationMs );

        return durationMs;
    };

    LinearShowing.prototype.getAirDateAsString = function()
    {
        return this.get("derivedAirDate");
    };

    LinearShowing.prototype.getChannel = function()
    {
        if( this._channel === undefined )
        {
            var channelLink = this.getLink('channel');
            if( channelLink !== undefined )
                this._channel = _x2._channelCollection.getChannel( channelLink.replace('#','') );
        }

        return this._channel;
    };

    LinearShowing.prototype.getBlockId = function()
    {
        return this._blockId;
    };

    LinearShowing.prototype.getChannelLink = function()
    {
        return this.getLink("channel");
    };

    LinearShowing.prototype.getDetail = function( force )
    {
        var promise, self = this;

        if( this._hasDetail && !force )
            promise = Promise.resolve(self);
        else
        {
            var resolver = function( resolve, reject )
            {
                var success = function( response )
                {
                    self._hasDetail = true;
                    self._data = JSON.parse(response.data);

                    if( force === true )
                    {
                        //reset stored properties.
                        self._program             = undefined;
                        self._recording           = undefined;
                        self._episodeRecording    = undefined;
                        self._epRecordingForm     = undefined;
                        self._seriesRecording     = undefined;
                        self._seriesRecordingForm = undefined;
                    }

                    resolve( self );
                };

                var error = function( error )
                {
                    reject( error );
                };
                //TODO: (Entity Refactor) use link.resolve
                var url = self.getSelfLink();
                url = XtvApi.trimPath( url );
                url = url.replace( /#/g, '' );

                _x2._network.ajax({type: "GET", url: _x2._data._host + url, headers: [_x2._data._authHeader], accepts:Network.Accepts.xtv, api:"getTvListingDetail" }).then(success).catch(error);
            };

            promise = new Promise( resolver );
        }

        return promise;
    };

    /**
     * Get the showing end time
     * @memberOf LinearShowing
     * @return {Number} Time in epoch timestamp
     */
    LinearShowing.prototype.getEndTime = function()
    {
        return this.getInteger("endTime");
    };

    LinearShowing.prototype.getFilters = function()
    {
        return this.get("filters") !== undefined ? this.get("filters") : [];
    };

    /**
     * The title provided from a "grid chunk" query, which is different from the title returned from a query for showing details.
     */
    LinearShowing.prototype.getGridTitle = function()
    {
        return this._gridTitle;
    };

    LinearShowing.prototype.getListingId = function()
    {
        return this.get("listingId");
    };

    LinearShowing.prototype.getRecording = function()
    {
        var recording, embedded = this.getEmbedded("recording");

        if( embedded )
            recording = new Recording().init(embedded);

        return recording;
    };

    /**
     * Get the HAL link used to pull details of this showing
     * @memberOf LinearShowing
     * @return {String}
     */
    LinearShowing.prototype.getSelfLink = function()
    {
        var link = this.getLink("self");

        if( link )
            link = XtvApi.trimPath( link );

        return link;
    };

    LinearShowing.prototype.getSeriesId = function()
    {
        return this.get("seriesId");
    };

    LinearShowing.prototype.getStationId = function()
    {
        return this.get("stationId");
    };

    /**
     * Get the showing start time
     * @memberOf LinearShowing
     * @return {Number} Time in epoch timestamp
     */
    LinearShowing.prototype.getStartTime = function()
    {
        return this.getInteger("startTime");
    };

    LinearShowing.prototype.hasFilter = function( filter )
    {
        var filterMatch  = false;
        var filters = this.getFilters();

        for( var i = 0; i < filters.length; i++ )
            if( filters[i] === filter )
            {
                filterMatch = true;
                break;
            }

        return filterMatch;
    };

    /**
     * Return true if this showing has subtitles
     * @memberOf LinearShowing
     * @return {Boolean}
     */
    LinearShowing.prototype.isSubtitled = function()
    {
        return this.getBoolean( "isSubtitled");
    };

    /**
     * Return true if this is a placeholder schedule.
     * @returns {boolean}
     */
    LinearShowing.prototype.isTbd = function()
    {
        return this.getBoolean( "isTbd" );
    };

    /**
     * Return true if the showing is live. Overrides Showing.isWatchable();
     * @return {boolean}
     */
    LinearShowing.prototype.isWatchable = function()
    {
        var retval = false;
        var now    = _x2._config._startTime ? new Date(_x2._config._startTime).getTime()+1 : Date.now();
        var start  = this._data.startTime   ? parseInt(this._data.startTime)               : 0;
        var end    = this._data.endTime     ? parseInt(this._data.endTime)                 : 0;

        if( start < now && end > now )
            retval = true;

        return retval;
    };

    LinearShowing.prototype.fetchSeriesRecording = function( force )
    {
        return this.getDetail( force );
    };

    LinearShowing.prototype.fetchEpisodeRecording = function( force )
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var onMetaLoaded = function()
            {
                var path      = ["_embedded", "recording"];
                var recording = _x2._data.getScheduledRecordingMetadata().getRecording( self.getListingId() );

                if( recording && recording.getWontRecordReason() === undefined )
                    self.addPath( path, recording.getData() );
                else if ( self.getPath( path ) )
                    self.removePath( path );

                resolve();
            };

            // only fetch recording meta if user is entitled to cDVR.
            if( _x2._features.hasEntitlement( Features.Entitlement.C_DVR ) )
                _x2._data.fetchScheduledRecordingMetadata( force ).then( onMetaLoaded ).catch( reject );
            else
                resolve()
        };

        return new Promise(resolver);
    };

    LinearShowing.prototype.setChannel = function( channel )
    {
        this._channel = channel;
    };

    return LinearShowing;

})();



/***/ }),
/* 50 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Maps to the version of s:VodItem returned from the XTVAPI getPurchases query.
 */
window.Purchase = (function()
{
    "use strict";

    Purchase.prototype = new VodShowing();

    function Purchase(){}

    /**
     * Get the group this purchase belongs to
     * @return {PurchaseGroup}
     */
    Purchase.prototype.getGroup = function()
    {
        return this._group;
    };

    /**
     * Get the the series associated with this asset
     * @return {Entity}
     */
    Purchase.prototype.getSeries = function()
    {
        return this._series;
    };

    /**
     * Get identifier
     * @return {string}
     */
    Purchase.prototype.getId = function()
    {
        return this.getLink("self");
    };

    Purchase.prototype.getEntityType = function()
    {
        var entity = this.getEntity();
        if( entity )
            return entity.getType();
    };

    Purchase.prototype.getTransactionDetails = function()
    {
        if( this._transactionDetails === undefined )
        {
            var data = this.getEmbedded("transactionDetails");
            this._transactionDetails = new TransactionDetails().init( data );
        }

        return this._transactionDetails;
    };

    /**
     * Set the group for this purchase.
     * @param {PurchaseGroup} group
     */
    Purchase.prototype.setGroup = function( group )
    {
        this._group = group;
    };

    /**
     * Set the series for this asset
     * @param series
     */
    Purchase.prototype.setSeries = function( series )
    {
        this._series = series;
    };

    /**
     * Override from ProgramEntity - user cannot mark purchases as favorite.
     * @return {boolean}
     */
    Purchase.prototype.isFavoriteable = function()
    {
        return false;
    };

    return Purchase;
})();


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 *
 * Represents a recorded instance of a {@link LinearShowing}.
 *
 * Maps to XTV "s:VideoObject/Recording"
 */
window.Recording = (function()
{
    "use strict";

    Recording.prototype = new LinearShowing();

    function Recording(){}

    /**
     * Initialize the object
     * @param {Object} data - XTV derived JSON object
     * @return {Recording}
     */
    Recording.prototype.init = function( data )
    {
        LinearShowing.prototype.init.call( this, data );
        return this;
    };

    /**
     * Delete the recording.
     * @memberOf Recording
     * @return {Promise}
     */
    Recording.prototype.delete = function()
    {
        var deleteForm = this.getForm("delete");

        if( deleteForm )
            return deleteForm.submit();
        else
            return Promise.reject( new ApiError().init( { local:"Recording.delete: There is no delete form for this entity"} ) );
    };

    Recording.prototype.getCancelForm = function()
    {
        if( ! this._cancelForm )
            this._cancelForm = this.getForm("cancel");

        return this._cancelForm;
    };

    /**
     * Get the channel associated with the recording
     * @memberOf Recording
     * @return {Channel}
     */
    Recording.prototype.getChannel = function()
    {
        if( !this._channel )
            this._channel = new Channel().init( this.getEmbedded("provider/channel" ) );

        return this._channel;
    };

    Recording.prototype.getCheckedOutDeviceName = function()
    {
        return this.getPath(["checkoutStatus","byDeviceName"]);
    };

    Recording.prototype.getDeleteForm = function()
    {
        if( ! this._deleteForm )
            this._deleteForm = this.getForm("delete");

        return this._deleteForm;
    };

    Recording.prototype.getDurationMs = function()
    {
        var entity, duration = this.getInteger("duration");

        if( !duration )
        {
            entity = this.getEntity();
            if( entity )
                duration = entity.getDuration() * 60000;
        }

        return duration;
    };

    Recording.prototype.getEraseForm = function()
    {
        if( ! this._eraseForm )
            this._eraseForm = this.getForm("erase");

        return this._eraseForm;
    };

    /**
     * Get the fallback image link from the program or series
     * @param width
     * @param height
     * @return {*}
     */
    Recording.prototype.getFallbackImageLink = function(width, height)
    {
        if( this._series )
            return this._series.getFallbackImageLink(width, height);
        else if( this.getProgram() )
            return this.getProgram().getFallbackImageLink(width, height);
    };

    /**
     * Get the recording ID
     * @memberOf Recording
     * @return {String}
     */
    Recording.prototype.getId = function()
    {
        return this.get("id");
    };

    /**
     * Get the image link for this Recording from the program or series
     * @memberOf Recording
     * @param width
     * @param height
     * @return {*}
     */
    Recording.prototype.getImageLink = function(width, height)
    {
        if( this._series && this._series.getImageLink )
            return this._series.getImageLink(width, height);
        else if( this.getProgram() )
            return this.getProgram().getImageLink(width, height);
        else //Note: some recordings come back from XTVAPI without a entity embedded.
            return "https://edge.myriad-gn-xcr.xcr.comcast.net/select/image?priority=true&entityId=" + this.getEntityId() + "&width=" + width + "&height=" + height;
    };

    Recording.prototype.getModifyForm = function()
    {
        if( ! this._modForm )
            this._modForm = this.getForm("modify");

        return this._modForm;
    };

    Recording.prototype.getUndeleteForm = function()
    {
        if( ! this._undeleteForm )
            this._undeleteForm = this.getForm("undeleteForm");

        return this._undeleteForm;
    };

    /**
     * Get the date of the recording
     * @memberOf Recording
     * @return {Date|undefined}
     */
    Recording.prototype.getRecordedOnDate = function()
    {
        var date = this.getByPriority( "dateRecorded", "lastRecorded");
        if( date )
            return new Date(date);

        return undefined;
    };

    /**
     * Returns the recording progress as an integer (0-100)
     * @return {number}
     */
    Recording.prototype.getRecordingProgress = function()
    {
        var duration,
            progress  = -1,
            startedOn = this.getDate("dateRecorded");
            status    = this.getRecordingStatus();

        if( status === 'STARTED' )
        {
            if( startedOn )
            {
                duration = this.getDurationMs();
                progress = Math.round( ( ( Date.now() - startedOn.getTime() ) / duration ) * 100 ) ;
            }
        }

        progress = ( progress < 100 ? progress  : 100      );
        progress = ( progress < 0   ? undefined : progress );

        return progress;
    };

    /**
     * Get the recording status
     * @memberOf Recording
     * @return {String}
     */
    Recording.prototype.getRecordingStatus = function()
    {
        //TODO: constants
        return this.get("recordingStatus");
    };

    /**
     * Get the recording type
     * @memberOf Recording
     * @return {String}
     */
    Recording.prototype.getRecordingType = function()
    {
        return this.get("recordingType");
    };

    /**
     * Get the season number assoc'd with this program.
     * @return {Number|undefined}
     */
    Recording.prototype.getSeasonNumber = function()
    {
        if( this.getProgram() )
            return this.getProgram().getSeasonNumber();

        return undefined;
    };

    Recording.prototype.getScheduleForm = function()
    {
        if( ! this._scheduleForm )
            this._scheduleForm = this.getForm("schedule");

        return this._scheduleForm;
    };

    /**
     * Get the series id for this program
     * @return {String}
     */
    Recording.prototype.getSeriesId = function()
    {
        var seriesId, program, seriesLink, tokens;

        seriesId = this.get("entityId");

        if( ! seriesId )
        {
            program = this.getProgram();
            if( program )
            {
                seriesLink = program.getTvSeriesLink();
                if( seriesLink )
                {
                    tokens = seriesLink.split(/\//g);
                    if( tokens && tokens.length )
                        seriesId = tokens[tokens.length-2];
                }
            }
        }

        if( ! seriesId )
            seriesId = this.get("programId");

        return seriesId;
    };

    /**
     * Get the playable stream URL
     * @return {String}
     */
    Recording.prototype.getStreamUrl = function()
    {
        var url, link = this.getLink("stream");

        if( link )
            url = XtvApi.trimPath( link );

        url = _x2._data._host + url;

        return url;
    };

    Recording.prototype.getSeries = function()
    {
        var program, series;

        if( this._series )
            series = this._series;

        if( ! series )
        {
            program = this.getProgram();
            if( program )
                series = program.getSeries();
        }

        return series;
    };

    Recording.prototype.getSeriesTitle = function()
    {
        var series, title;

        series = this.getSeries();

        if( series )
            title = series.getTitle();

        return title;
    };

    Recording.prototype.getWontRecordReason = function()
    {
        return this.get("wontRecordReason");
    };

    Recording.prototype.isCheckedOut = function()
    {
        return this.getPath(["checkoutStatus", "checkedOut"]);
    };

    Recording.prototype.erase = function()
    {
        var retval, form = this.getEraseForm();

        if( form )
            retval = form.submit();
        else
            retval = Promise.reject( new ApiError().init( { local:"Recording.erase: There is no erase form for this entity"} ) );

        return retval;
    };

    /**
     * Return true if this recording is HD.
     * @return {boolean}
     */
    Recording.prototype.isHD = function()
    {
        return this.get("videoQuality") === 'hd';
    };

    /**
     * Return true if this recording has DVS
     * @memberOf Recording
     * @return {Boolean}
     */
    Recording.prototype.isDvs = function()
    {
        return this.get("dvs");
    };

    /**
     * Return true if this recording has SAP
     * @memberOf Recording
     * @return {Boolean}
     */
    Recording.prototype.isSap = function()
    {
        return this.get("sap");
    };

    /**
     * Return true if this is a future, scheduled recording.
     * @return {boolean}
     */
    Recording.prototype.isScheduled = function()
    {
        var scheduled = false, status = this.get("recordingStatus");

        if( status === 'scheduled' || status === 'STARTED' || status === 'NOTSTARTED' )
            scheduled = true;

        return scheduled;
    };

    /**
     * Return true if this recording is started or complete
     * @return {boolean}
     */
    Recording.prototype.isWatchable = function()
    {
        var watcahble = false;
        var status = this.getRecordingStatus();

        if( status === 'STARTED' || status === 'COMPLETE' )
            watcahble = true;

        return watcahble;
    };

    Recording.prototype.setSeries = function( series )
    {
        this._series = series;
    };

    Recording.prototype.reload = function()
    {
        var self = this;

        var resolver = function( resolve, reject )
        {
            var success = function( result )
            {
                resolve( self.init( JSON.parse(result.data) ) );
            };

            var link = self.getLinkObject( "self" );
            link.resolve().then(success).catch(reject);
        };

        return new Promise( resolver );
    };

    // Recording.prototype.setGroup = function(group)
    // {
    //     this._group = group;
    // };

    Recording.prototype.undelete = function()
    {
        var retval, form = this.getUndeleteForm();

        if( form )
            retval = form.submit();
        else
            retval = Promise.reject( new ApiError().init( { local:"Recording.undelete: There is no undelete form for this entity"} ) );

        return retval;
    };

    return Recording;
})();


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * @class
 */
window.Rental = (function()
{
    Rental.prototype = new VodShowing();

    function Rental(){}

    Rental.prototype.init = function( data )
    {
        VodShowing.prototype.init.call( this, data );
        return this;
    };

    Rental.prototype.getExpires = function()
    {
        return new Date(this.getRentedOn().getTime() + ( this.getRentalPeriod() * 60000 ) );
    };

    Rental.prototype.getPrice = function()
    {
        return this.get("price");
    };

    Rental.prototype.getRentalPeriod = function()
    {
        return this.get("rentalPeriod");
    };

    Rental.prototype.getRentedOn = function()
    {
        return this.getDate("rentalDateTime");
    };

    Rental.prototype.isWatchable = function()
    {
        return ( Date.now() < this.getExpires().getTime() );
    };


    return Rental;
})();


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// Copyright (C) 2020 Comcast Corporation, All Rights Reserved

window.DevicesList = (function()
{
    "use strict";

    function DevicesList( data )
    {
        
        this._data = [];
        this._currentDevice = null;
        this._isDataLoaded = false;
        if( data ) {
            this._data = data;

            _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( "########## ACCOUNT DEVICES ##########" ) : Config.NOP();

            for( var i = 0; i < this._data.length; i++ )
            {
                _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( this._data[i] ) : Config.NOP();

                if( this._data[i].isCurrent === true || ( _x2._metricsSocket._deviceId && this._data[i].deviceId === _x2._metricsSocket._deviceId ) )
                {
                    this._currentDevice = this._data[i];
                    break;
                }
            }
            this._isDataLoaded = true;
            _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( "=====================================" ) : Config.NOP();
            _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( "Total Devices: ", this._data.length          ) : Config.NOP();

        }
    }

    DevicesList.prototype.getCurrentDevice = function( )
    {
        return this._currentDevice || null;
    };

    DevicesList.prototype.isDataLoaded = function() {
        return this._isDataLoaded;
    }

    return DevicesList;

})();


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Callbacks = (function()
{
    "use strict";

    function Callbacks(){}

    /**
     * @memberof Callbacks
     * @param {Function} callback - function to trigger when item has changed
     * @see Callbacks.callbackSignalChange()
     */
    Callbacks.prototype.addChangeCallback = function( callback )
    {
        if( this._changeCallbacks === undefined )
            this._changeCallbacks = [];

        this._changeCallbacks.push( callback );
    };

    /**
     * @memberof Callbacks
     * @param {Function} callback - function to trigger when item is ready
     * @see Callbacks.callbackSignalReady()
     */
    Callbacks.prototype.addReadyCallback = function( callback )
    {
        if( this._callbackSignaled )
        {
            callback();
        }
        else
        {
            if( this._readyCallbacks === undefined )
                this._readyCallbacks = [];

            this._readyCallbacks.push( callback );
        }
    };

    /** Call all the changed callbacks registered
     * @memberof Callbacks
     * @see Callbacks.addChangeCallback()
     */
    Callbacks.prototype.callbackSignalChange = function()
    {
        if( this._changeCallbacks )
            for( var i = 0; i < this._changeCallbacks.length; i++ )
                this._changeCallbacks[i]();
    };

    /** Call all the ready callbacks registered
     * @memberof Callbacks
     * @see Callbacks.addReadyCallback()
     */
    Callbacks.prototype.callbackSignalReady = function()
    {
        var callback;

        this._callbackSignaled = true;

        if( this._readyCallbacks )
            while( callback = this._readyCallbacks.shift() )
                callback();
    };

    /**
     * @memberof Callbacks
     * @param {Function} callback - remove the function from the changed callbacks if it exists
     */
    Callbacks.prototype.removeChangeCallback = function( callback )
    {
        if( this._changeCallbacks && callback )
            for( var i = 0; i < this._changeCallbacks.length; i++ )
                if( this._changeCallbacks[i] === callback )
                {
                    this._changeCallbacks.splice( i, 1 );
                    break;
                }
    };

    return Callbacks;

})();


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.CirrusVideo = ( function()
{
    "use strict";

    function CirrusVideo( url, listener, resume, lang, contentOptions, videoEas )
    {
        var self = this, onLoad;

        this._listener = listener;

//         _x2._config.debugAddClass( Config.CLASS_VIPER, 5 );
//
        onLoad = function()
        {
            console.log( "CirrusVideo LOADED" );

            var onMediaProgress, onPlayStateChanged;

//             var obj, onBitRateChanged, onBufferComplete, onBufferStart, onEasComplete, onEasFailure, onEasStarted, onMediaEnded, onMediaOpened, onPlaybackSpeedChanged;
//
//             onBitRateChanged = function( event )
//             {
//                 self._listener.onBitRateChanged( event.bitRate, self._playerPlatform.getVideoWidth(), self._playerPlatform.getVideoHeight() );
//             };
//
//             onBufferComplete = function()
//             {
//                 self._listener.onBufferComplete();
//             };
//
//             onBufferStart = function()
//             {
//                 self._listener.onBufferStart();
//             };
//
//             onEasComplete = function()
//             {
//                 console.log( "Emergency Alert Complete" );
//                 self._listener.onEmergencyAlertComplete();
//             };
//
//             onEasFailure = function()
//             {
//                 console.error( "Emergency Alert Failure" );
//             };
//
//             onEasStarted = function()
//             {
//                 console.log( "Emergency Alert Started" );
//                 self._listener.onEmergencyAlertStarted();
//             };
//
//             onMediaEnded = function()
//             {
//                 self._listener.onMediaEnded();
//             };
//
//             var onMediaFailed = function( event )
//             {
//                 console.log( event );
//                 self._listener.onMediaFailed( event );
//             };
//
//             onMediaOpened = function( event )
//             {
//                 _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();
//                 self._listener.onMediaOpened();
//
//                 if( self._resume )
//                 {
//                     self._playerPlatform.setPosition( self._resume );
//                     self._resume = undefined;
//                 }
//
//                 console.log( "PlayerPlatform Version: " + self._playerPlatform.getVersion() );
//             };

            onMediaProgress = function( event )
            {
//                _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();
                self._listener.onMediaProgress( event.time * 1000, 0, (event.time + event.timeToEnd) * 1000 );
            };

//             var onMediaRetry = function( event )
//             {
//                 console.log( event );
// //                self._listener.onMediaEnded();
//             };
//
//             onPlaybackSpeedChanged = function( event )
//             {
//                 self._listener.onPlaybackSpeedChanged( event.playbackSpeed );
//             };

            onPlayStateChanged = function( event )
            {
                console.log( event );

//                 _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();
//
//                 switch( event.playState )
//                 {
//                     case "buffering":
//                     case "complete":
//                         break;
//
//                     case "error":
//                         self._listener.onError( event );
//                         break;
//
//                     case "idle":
//                     case "initializing":
//                     case "prepared":
//                     case "preparing":
//                     case "ready":
//                     case "released":
//                         break;
//
//                     case "seeking":
//                         break;
//
//                     case "initialized":
//                         self._volume = self._playerPlatform.getVolume();
//                         self._playerPlatform.setCurrentTimeUpdateInterval( 2000 );  // not working
// // self._playerPlatform.setVolume( 0 );
// // self._volume = 0;
//
// self._listener.onInitialized( self._playerPlatform.getSupportedPlaybackSpeeds() );
//
// // var speeds    = self._playerPlatform.getSupportedPlaybackSpeeds();
// // var newSpeeds = [];
// //
// // console.log( speeds );
// //
// // for( var i = 0; i < speeds.length; i++ )
// //     if( speeds[i] > 1 )
// //         newSpeeds.push( speeds[i] );
// //
// // self._listener.onInitialized( newSpeeds );
//                         break;
//
//                     case "paused":
//                         self._state = VideoScreen.State.PAUSED;
//                         self._listener.onPaused();
//                         break;
//
//                     case "playing":
//                         self._state = VideoScreen.State.PLAY;
//                         self._listener.onPlay();
//                         break;
//
//                     default:
//                         console.error( "ERROR -> unknown PlayStateChanged event:" );
//                         console.error( event );
//                         break;
//                 }
            };

            var onHaveSecClient = function()
            {
console.log( "&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&" );
console.log( _x2._config._secClient );

// var payload =
// {
//             serviceHostUrl: this.licenseServerURL,
//             licenseRequest: challenge,
//             keySystem: keySystem,
//             mediaUsage: "stream",
//             accessToken: this.sandbox.asset.authToken || this.sandbox.asset.drmKey,
//             deviceAuthenticationResult: this.sandbox.asset.deviceAuthenticationResult,
//             contentMetadata: contentMetaData,
//             requestMetadata: {
//                 "X-MoneyTrace": SessionManager_1.SessionManager.instance.moneyTrace.createTraceMessage(),
//             }
// };

var liceneObj =
{
    serviceHostUrl: _x2._config._licenseServer,
//    licenseRequest: challenge,
    keySystem     : "com.widevine.alpha",  //com.microsoft.playready
    mediaUsage    : "stream",
    accessToken   : JSON.parse( Host.getLocalStorage( "XsctToken" ) ),
//    deviceAuthenticationResult: this.sandbox.asset.deviceAuthenticationResult,
//    contentMetadata: contentMetaData,
};


//                 var serviceHostUrl             = _x2._config._licenseServer;
//                 var requestMetadata            //= ;
//                 var keySystem                  = "com.widevine.alpha";  //com.microsoft.playready
//                 var licenseRequest             //= ;
//                 var contentMetadata            //= ;
//                 var mediaUsage                 = "stream";
//                 var accessToken                = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
//                 var accessAttributes           //= ;
//                 var deviceAuthenticationResult //= ;

var ret = _x2._config._secClient.acquireLicense( liceneObj );

console.log( ret );


                var video = document.createElement( "video" );

                video.style.width  = "1280px";
                video.style.height =  "720px";

//            data-dashjs-player
//            video.autoplay           = true;
//            video.preload = "auto";
//            video.src     = "http://assets.player.xcal.tv/super8sapcc/index.mpd"; //"https://dash.akamaized.net/envivio/EnvivioDash3/manifest.mpd";
//            video.controls = true;

                _x2._videoRoot.appendChild( video );

                console.log( video );

                var player = self._player = dashjs.MediaPlayer().create();
                var url    = "https://dash.akamaized.net/envivio/EnvivioDash3/manifest.mpd";
    //            var url    = "http://assets.player.xcal.tv/super8sapcc/index.mpd";

                console.log( player );
                console.log( dashjs );

//             player.initialize( video, url, true );
//
//             console.log( player.events );

                player.on( dashjs.MediaPlayer.events.PLAYBACK_PLAYING     , onPlayStateChanged );
                player.on( dashjs.MediaPlayer.events.PLAYBACK_TIME_UPDATED, onMediaProgress    );

                player.initialize( video, url, true );



//                 obj =
//                 {
//                     videoElement : _x2._videoRoot,
//                     secClient    : _x2._config._secClient,
//                     configuration:  {
//                                         analyticsDeviceType :"x2-html",
//                                         licenseServerUrl   : _x2._config._licenseServer,
//     //                                 retryOnMediaFailed: "true",
//     //                                 defaultAsset: { initialBitrate: 0, initialBufferTime: 2000 },
//     //                                 logstashEndpoint: "http://96.118.37.206:8080/helio/js/"
//                                         zipToFipsEndPoint   :"https://easip-client.ccp.xcal.tv/easws/api/fips/zip/",
//                                         alertServiceEndPoint:"https://easip-client.ccp.xcal.tv/easws/api/alert/active/fipscode/",
//                                         easTextOverlay      :( videoEas !== true ) ? pp.ConfigurationManager.EAS_TEXT_OVERLAY : undefined,
//                                         audioLanguage       :lang,
//                                         helioEas            :true,
//
//                                         defaultAsset:
//                                         {
//                                             "cdnRedundant"   : true,
//                                             forceHttps       : (_x2._config._host.getType() !== Host.Type.PC),
//                                             easEnabled       : true,
//                                             initialBitrate   : 5000000,
//                                             initialBufferTime: 2000
//                                         },
//
//                                         easAsset:
//                                         {
//                                             forceHttps: true
//                                         }
//                                     }
//                 };
//
//                 // events not currently considered interesting
//                 // AD_BREAK_COMPLETE
//                 // AD_BREAK_EXITED
//                 // AD_BREAK_START
//                 // AD_BREAK_UPCOMING
//                 // AD_COMPLETE
//                 // AD_ERROR
//                 // AD_EXITED
//                 // AD_PROGRESS
//                 // AD_SEEK
//                 // AD_START
//                 // AD_SKIPPED
//                 // ADS_SKIPPED
//                 // EMERGENCY_ALERT_IDENTIFIED
//                 // EMERGENCY_ALERT_EXEMPTED
//                 // EMERGENCY_ALERT_ERRORED
//
//                 // events under consideration
//                 // DROPPED_FPS_CHANGED
//                 // DURATION_CHANGED
//                 // FPS_CHANGED
//                 // FRAGMENT_INFO
//                 // MEDIA_FALLBACK
//                 // MEDIA_RETRY
//                 // MEDIA_WARNING
//                 // MISSING_DRM_TOKEN
//                 // NUMBER_OF_ALTERNATIVE_AUDIO_STREAMS_CHANGED
//                 // NUMBER_OF_CLOSED_CAPTIONS_STREAMS_CHANGED
//                 // PLAYBACK_SPEEDS_CHANGED
//                 // PLAYBACK_STARTED
//                 // SEEK_COMPLETE
//                 // SEEK_START
//                 // DRM_METADATA
//                 // VPAID_AD_EVENT
//                 // STREAM_SWITCH
//
//                 self._playerPlatform = new pp.PlayerPlatformAPI( obj );
//
// // console.log( self._playerPlatform.getSupportedClosedCaptionsOptions() );
// //
// //self._playerPlatform.setClosedCaptionsStyle( { textForegroundColor:"red" } );
//
//                 // configure events to be handled
//
//                 self._playerPlatform.on( pp.Events.BITRATE_CHANGED         , onBitRateChanged       );
//                 self._playerPlatform.on( pp.Events.BUFFER_COMPLETE         , onBufferComplete       );
//                 self._playerPlatform.on( pp.Events.BUFFER_START            , onBufferStart          );
//                 self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_COMPLETE, onEasComplete          );
//                 self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_FAILURE , onEasFailure           );
//                 self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_STARTED , onEasStarted           );
//                 self._playerPlatform.on( pp.Events.MEDIA_ENDED             , onMediaEnded           );
//                 self._playerPlatform.on( pp.Events.MEDIA_FAILED            , onMediaFailed          );
//                 self._playerPlatform.on( pp.Events.MEDIA_OPENED            , onMediaOpened          );
//                 self._playerPlatform.on( pp.Events.MEDIA_PROGRESS          , onMediaProgress        );
// //                self._playerPlatform.on( pp.Events.MEDIA_RETRY           , onMediaRetry           );
//                 self._playerPlatform.on( pp.Events.PLAYBACK_SPEED_CHANGED  , onPlaybackSpeedChanged );
//                 self._playerPlatform.on( pp.Events.PLAY_STATE_CHANGED      , onPlayStateChanged     );
// //              self._playerPlatform.on( pp.Events.DURATION_CHANGED        , onDurationChanged      ); // Not valid until video is ended: event.target.duration
//
//                 var xsct = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
//
//                 self._playerPlatform.configureAnalytics( xsct, AboutOverlay.version );
//                 self._playerPlatform.configureEmergencyAlerts( xsct.xsct );
//
//                 _x2._config.log( Config.CLASS_VIPER, 1 ) ? console.log( "PlayerPlatform Version: " + self._playerPlatform.getVersion() ) : Config.NOP();
//
//                 if( url )
//                     self.play( url, listener, resume, contentOptions );
            };

            var onSecClientLoad = function()
            {
console.log( "LOADING SEC CLIENT" );
                var secClientConfig =
                {
                    crypto:
                    {
                        type:"dh"
                    },
                    timeout: 10000,
                    deviceType: _x2._config._host.getSecClientDeviceType()
                };

                _x2._config._secClient = new secclient.SecClient();
                _x2._config._secClient.load( secClientConfig ).then( onHaveSecClient );
            };

            var onSecClientLoadError = function( e )
            {
                console.error( e )
            };

            if( _x2._config._secClient === undefined )
                _x2.getScript( "lib/secclient.js", onSecClientLoad, onSecClientLoadError );
            else
                onHaveSecClient();
        };

        _x2.getScript( "https://cdn.dashjs.org/latest/dash.all.min.js", onLoad );
    }

    CirrusVideo.prototype.destroy = function()
    {
        var children = _x2._videoRoot.childNodes;

        for( var i = 0; i < children.length; i++ )
            _x2._videoRoot.removeChild( children[i] );
    };

//     CirrusVideo.prototype.getCaptions = function()
//     {
//         return this._playerPlatform.getAvailableClosedCaptionTracks();
//     };
//
//     CirrusVideo.prototype.getCurrentLanguage = function()
//     {
//         return this._playerPlatform.getCurrentAudioLanguage();
//     };
//
//     CirrusVideo.prototype.getCurrentPosition = function()
//     {
//         return this._playerPlatform.getCurrentPosition();
//     };
//
// //     CirrusVideo.prototype.getCurrentSpeed = function()
// //     {
// //         return this._playerPlatform.getCurrentPlaybackSpeed();
// //     };
//
//     CirrusVideo.prototype.getDuration = function()
//     {
//         return this._playerPlatform.getDuration();
//     };
//
//     CirrusVideo.prototype.getLanguages = function()
//     {
//         return this._playerPlatform.getAvailableAudioLanguages();
//     };
//
//     CirrusVideo.prototype.getPlaySpeed = function()
//     {
//         return this._playerPlatform.getCurrentPlaybackSpeed();
//     };

    CirrusVideo.prototype.getState = function()
    {
        return this._state;
    };

    CirrusVideo.prototype.getVersion = function()
    {
        return this._player.getVersion();
    };

    CirrusVideo.prototype.mute = function()
    {
        if( this._player.isMuted() === true )
            this._player.setMute( false );
        else
            this._player.setMute( true );
    };

    CirrusVideo.prototype.pause = function()
    {
        console.log( "PAUSE" );
//        this._playerPlatform.pause();
    };

//     CirrusVideo.prototype.setPcBlock = function( bool )
//     {
// //        this._playerPlatform.setBlock( bool );  // should be using this, but was not implemented
//
//         if( bool === true )
//         {
//             _x2._videoRoot.style.display = "none";
//             this._playerPlatform.setVolume( 0 );
//         }
//         else
//         {
//             _x2._videoRoot.style.display = "initial";
//             this._playerPlatform.setVolume( 1 );
//         }
//     };
//
//     CirrusVideo.prototype.play = function( url, listener, resume, contentOptions )
//     {
//         if( url !== undefined )
//         {
// console.log( this._playerPlatform.eas );
// this._playerPlatform.eas.start();
//
//             this._listener = listener;
//             this._resume   = resume;
//
//             var token   = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
//             var xact    = JSON.parse( Host.getLocalStorage( "XactToken" ) );
//             var options =
//             {
//                 authToken                 : token.xsct,
//                 deviceAuthenticationResult: xact,
//                 assetEngine               : "helio",
//                 keySystem                 : _x2._config._host.getDrmType(),
//                 streamId                  : contentOptions.streamId,
//                 recordingId               : contentOptions.recordingId,
//                 assetId                   : contentOptions.assetId,
//                 providerId                : contentOptions.providerId,
//                 mediaGuid                 : contentOptions.mediaGuid
//             };
//
//             this._playerPlatform.setAsset( pp.Asset.create( url, options ) );
//             pp.setLogLevel( (_x2._config._ppLog === true) ? pp.LogLevel.ALL : pp.LogLevel.NONE );
//         }
//         else
//             this._playerPlatform.play();
//     };
//
//     CirrusVideo.prototype.setCaption = function( track )
//     {
//         this._playerPlatform.setClosedCaptionsTrack( track );
//     };
//
//     CirrusVideo.prototype.setCaptionsEnabled = function( bool )
//     {
//         this._playerPlatform.setClosedCaptionsEnabled( bool );
//     };
//
//     CirrusVideo.prototype.setLanguage = function( lang )
//     {
//         this._playerPlatform.setPreferredAudioLanguage( lang );
//     };
//
//     CirrusVideo.prototype.setPosition = function( msec )
//     {
//         this._playerPlatform.setPosition( msec )
//     };
//
//     CirrusVideo.prototype.setSpeed = function( speed )
//     {
//         this._playerPlatform.setSpeed( speed )
//     };
//
//     CirrusVideo.prototype.skipBackward = function( msec )
//     {
//         this._playerPlatform.setPositionRelative( -msec );
//     };
//
//     CirrusVideo.prototype.skipForward = function( msec )
//     {
//         this._playerPlatform.setPositionRelative( msec );
//     };
//
    CirrusVideo.prototype.stop = function()
    {
        this._player.reset();

//         this._playerPlatform.eas.stop();
//         this._playerPlatform.stop();
    };

//     CirrusVideo.prototype.volumeDown = function()
//     {
//         if( this._volume > 0 )
//         {
//             this._volume -= 0.05;
//
//             if( this._volume < 0 )
//                 this._volume = 0;
//
//             this._playerPlatform.setVolume( this._volume );
//             _x2._config.log( Config.CLASS_VIPER, 3 ) ? console.log( "VOLUME = " + this._volume ) : Config.NOP();
//         }
//     };
//
//     CirrusVideo.prototype.volumeUp = function()
//     {
//         if( this._volume < 1 )
//         {
//             this._volume += 0.05;
//
//             if( this._volume > 1 )
//                 this._volume = 1;
//
//             this._playerPlatform.setVolume( this._volume );
//             _x2._config.log( Config.CLASS_VIPER, 3 ) ? console.log( "VOLUME = " + this._volume ) : Config.NOP();
//         }
//     };

    return CirrusVideo;

})();


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Config = (function()
{
    "use strict";

    var defaultConfigServer = 'https://config.xpp.tv.xfinity.com/';

    Config.ANI_TIME_HORIZ_MENU  = 300;

    Config.AUTH_CIMA            = 0;
    Config.AUTH_CISCO_SAML      = 1;
    Config.AUTH_NONE            = 2;
    Config.AUTH_OAUTH           = 3;
    Config.AUTH_XTV             = 4;

    Config.CLASS_CONFIG         = 0;
    Config.CLASS_GRID           = 1;
    Config.CLASS_LOCALYTICS     = 2;
    Config.CLASS_NETWORK        = 3;
    Config.CLASS_OAUTH          = 4;
    Config.CLASS_SPLUNK         = 5;
    Config.CLASS_TELEMETRY      = 6;
    Config.CLASS_VIDEO_SCREEN   = 7;
    Config.CLASS_VIPER          = 8;
    Config.CLASS_WEBGL          = 9;
    Config.CLASS_X2             = 10;
    Config.CLASS_XTV_AUTH       = 11;

    Config.MODE_CLOUD           = 0;
    Config.MODE_RUI             = 1;
    Config.MODE_TEST            = 2;
    Config.MODE_UHD             = 3;

    Config.NOP                  = function(){};

    Config.RENDER_DOM           = 0;
    Config.RENDER_WEBGL         = 1;

    Config.RES_480              = 0;
    Config.RES_540              = 1;
    Config.RES_720              = 2;
    Config.RES_1080             = 3;

    Config.default    = {
                            accessibility    : [ "captions", "captionOptions", "videoDesc" ],
                            authEndpoint     : "https://clientservices.rialto.ccp.xcal.tv/clientservices/cima",
//                            authType       : Config.AUTH_OAUTH,
                            authType         : Config.AUTH_XTV,
//                            authType       : Config.AUTH_NONE,
                            guideMenu        : [ "all", "favs", "kids", "sports", "movies" ],
                            imageRootMso     : "resources/images/comcast/",
                            initialScreen    : "mainMenu",
                            localyticsKey    : environment.ENV === 'prod' ? 'ea1410fa675877c8e810f1d-98573a50-0a5d-11e7-24d6-002a25e53804' : '06de8712cae5f02bb138080-6cc7ff96-0a5d-11e7-eaa4-004ca8463ac9',
                            parentalControls : [ "enable", "modify", "safeBrowse", "movieRatings", "tvRatings", "reset" ],
                            sapLanguages     : [ "en", "es", "french", "cafrench", "german", "italian", "portuguese" ],
                            mainMenu         : [ "guide", "saved", "onDemand", "search", "settings" ],
                            manage           : [ "deviceName", "deviceDownloads", "deviceStreams" ],
                            purchasePin      : [ "enable", "modify" ],
                            savedMenu        : [ "forYou", "recordings", "scheduled", "favorites", "purchases" ],
//                            settings       : [ "account", "preferences", "device", "language", "parental", "accessibility", "help", "notices", "about" ],
//                            settings       : [ "language", "parental", "accessibility", "manage", "help", "terms", "about", "signOut" ],
                            settings       : [ "format", "language", "parental", "accessibility", "help", "terms", "privacy", "about", "signOut" ],
                            parent         : undefined
                        };

    Config.ruiCox     = {
                            imageRootMso   : "resources/images/cox/"
                        };

    Config.rui        = {
                            authEndpoint   : "https://clientservices.rialto.ccp.xcal.tv/clientservices/cima",
                            authType       : Config.AUTH_CIMA,
                            initialScreen  : "mainMenu",
                            mainMenu       : [ "saved", "guide", "settings", "search" ],
                            parent         : Config.default
                        };

    Config.ruiCox     = {
                            authEndpoint   : "https://lb01-cox-prod-int.cisco.com/mobileactivationservice/accounts/users/login/saml",
                            authType       : Config.AUTH_CISCO_SAML,
                            imageRootMso   : "resources/images/cox/",
                            parent         : Config.rui,
                            usernameSuffix : "@cox.net"
                        };

    Config.ruiCoxDev  = {
                            authEndpoint   : "https://x1-cox-int.cisco.com/mobileactivationservice/accounts/users/login/saml",
                            parent         : Config.ruiCox,
                            usernameSuffix : "@dev.cox.net"
                        };

    Config.test       = {
                            authType       : Config.AUTH_NONE,
                            initialScreen  : "test",
                            parent         : Config.default

                        };

    Config.uhd        = {
                            authEndpoint   : "https://clientservices.rialto.ccp.xcal.tv/clientservices/cima",
//                            authType       : Config.AUTH_CIMA,
//                            authType       : Config.AUTH_XTV,
                            authType       : Config.AUTH_OAUTH,
                            initialScreen  : "mainMenu",
                            mainMenu       : [ "onDemand", "settings" ],
                            parent         : Config.default
                        };
    //To check where app is running in simulator instead of smart tv.
    Config.isTizenSimulator = false;
    Config.isWebOsSimulator = false;

    /**
     * @constructor
     * Use _x2._config._screenW and _x2._config._screenH to get the screen dimensions
     */
    function Config( debugEnabled )
    {
        // default config values

        this.setSize( "720" );

        this._enabled = debugEnabled;
        this._classes = [];

        // language files

        this._english = "resources/languages/English.json";
        this._spanish = "resources/languages/Spanish.json";

        // metadata sources

        this._thePlatformRoot = "http://feed.theplatform.com/f/tyO8VC/Samsung?form=json";
//        this._xtvApiRoot      = "https://xtvapi-staging.cloudtv.comcast.net/";
        this._xtvApiRoot      = "https://xtvapi.cloudtv.comcast.net/";
        this._xtvAuthRoot     = "https://xtvapi.cloudtv.comcast.net/";

        this.debugAddClass( Config.CLASS_CONFIG, 0 );
    }

    Config.prototype.debugAddClass = function( classVal, level )
    {
        this._classes[classVal] = level;
    };

    Config.prototype.debugEnable = function( val )
    {
        this._enabled = val;
    };

    /**
     * @memberof Config
     */
    Config.prototype.getValue = function( primaryConfig, fieldName )
    {
        var config = primaryConfig;
        var retval = primaryConfig[fieldName];

        while( retval === undefined && config["parent"]  )
        {
            config = config["parent"];
            retval = config[fieldName];
        }

        return retval;
    };

    /**
     * @memberof Config
     */
    Config.prototype.load = function( onLoaded )
    {
        var self         = this;
        var configServer = this._configServer ? this._configServer : defaultConfigServer;

        function onConfig( response )
        {
            var data = JSON.parse( response.data );

            console.log( data );

            /**
             * @property {object}  data
             * @property {string} [data.authHost]
             * @property {string} [data.licenseServer]
             * @property {string} [data.provHost]
             * @property {string} [data.xtvApi]
             * @property {string} [data.testVideo]
             */

            if( data.authHost )
                self._authHost = data.authHost;

            if( data.licenseServer )
                self._licenseServer = data.licenseServer;

            if( data.provHost )
                self._provHost = data.provHost;

            console.log( self._authHost, self._provHost, self._licenseServer );

            if( data.xtvApi )
            {
                self._xtvApiRoot  = data.xtvApi;
                self._xtvAuthRoot = data.xtvApi;
            }

            if( data.testVideo )
                self._testVideo = data.testVideo;

            onLoaded();
        }

        function onError( error )
        {
             console.error( "ERROR -> Unable to load config from server [" + error.message + "]. Using defaults.");
             onLoaded();
        }

        function onMapping( response )
        {
            if( response )
            {
                var data   = JSON.parse( response.data );
                var mac    = self._mac;
                var record = data[mac];

                if( record === undefined )
                    record = data[_x2._config._host.getPlatformString()];
                if(_x2._config._loadConfigId) {
                    record = data[_x2._config._loadConfigId];
                }
                if( record )
                {
                    console.log( "Found a device mapping -> " + record );

                    if( record.substr( 0, 4 ) === "http" )
                        _x2._network.get( record ).then( onConfig ).catch( onError );
                    else
                        _x2._network.get( configServer + record ).then( onConfig ).catch( onError );
                }
                else
                {
                    console.log( "No mapping found" );
                    onNoDeviceConfig.call(this);
                }
            }
            else
                onNoDeviceConfig.call(this);
        }

        function onNoDeviceConfig()
        {
          var configServer = this._configServer ? this._configServer : defaultConfigServer,
              type = _x2._config._host.getType(),
              configUrl;

          switch(type) {
            case Host.Type.ANDROID:
              onError(new Error('No remote config for ANDROID host type'));
              return;
            case Host.Type.LG:
              configUrl = configServer + 'jenkins/prod-lg.json';
              break;
            case Host.Type.TIZEN:
              configUrl = configServer + 'jenkins/prod-samsung.json';
              break;
            case Host.Type.PC:
              onError(new Error('No remote config for PC host type'));
              return;
          }
          _x2._network.get(configUrl).then( onConfig ).catch( onError );
        }
        var hostType = _x2._config._host.getType();
        if( (hostType === Host.Type.PC || hostType == Host.Type.ANDROID) && !_x2._config._loadConfigId ) {
            onError(new Error('No remote config for PC host type'));
        } else {
            _x2._network.get( configServer + "mapping.json", 5000 ).then( onMapping ).catch( onNoDeviceConfig.bind(this) );
        }//if it is PC or android, then we avoid delay of around 5 seconds on waiting for mapping.json
    };

    Config.prototype.log = function( classVal, level )
    {
        var retval = false;

        if( this._enabled === true )
        {
            if( classVal === undefined )
            {
                console.error( "ERROR -> Using a debug class that was not defined in Config (Config.CLASS_???)" );
                console.trace();
            }
            else
            {
                if( this._classes[classVal] === undefined )
                {
                    console.error( "ERROR -> debugAddClass() was not set for debug class id = " + classVal );
                    console.trace();
                }
                else if( this._classes[classVal] >= level )
                    retval = true;
            }
        }

        return retval; //( this._enabled === true && this._classes[classVal] && this._classes[classVal] >= level ) ? true : false;
    };

    /**
     * @memberof Config
     */
    Config.prototype.setAppMode = function( mode, partner )
    {
        this._mode    = mode;
        this._partner = partner ? partner : "Comcast";

        this._localyticsKey = this.getValue(Config.default, 'localyticsKey');
        switch( mode )
        {
            case Config.MODE_CLOUD:
                this._accessibilityMenu    = this.getValue( Config.default, "accessibility"    );
                this._authEndpoint         = this.getValue( Config.default, "authEndpoint"     );
                this._authHost             = "https://xacs.ccp.xcal.tv";
                this._authMode             = Config.default.authType;
                this._guideMenu            = this.getValue( Config.default, "guideMenu"        );
                this._imageRootMso         = this.getValue( Config.default, "imageRootMso"     ) + this._screenH + "/";
                this._initialScreen        = this.getValue( Config.default, "initialScreen"    );
                this._licenseServer        = "https://mds.ccp.xcal.tv";
                this._manageDevicesMenu    = this.getValue( Config.default, "manage"           );
                this._parentalControlsMenu = this.getValue( Config.default, "parentalControls" );
                this._provHost             = "https://xacsa.ccp.xcal.tv";
                this._purchasePinMenu      = this.getValue( Config.default, "purchasePin"      );
                this._sapLanguages         = this.getValue( Config.default, "sapLanguages"     );
                this._mainMenu             = this.getValue( Config.default, "mainMenu"         );
                this._savedMenu            = this.getValue( Config.default, "savedMenu"        );
                this._settingsMenu         = this.getValue( Config.default, "settings"         );
                this._xcalEndPoints        = {
                    authenticationActivationUrl: 'https://xacs-activation-prod.cs.xcal.tv',
                    authenticationRenewalUrl: 'https://xacs-renewal-prod.cs.xcal.tv',
                    deviceProvisionUrl: 'https://xacsa.ccp.xcal.tv',
                    licenseAcquisitionUrl: 'https://mds.ccp.xcal.tv'
                };

                switch( partner )
                {
                    case "Cox":
                        this._imageRootMso = this.getValue( Config.ruiCox, "imageRootMso" ) + this._screenH + "/";
                        break;

                    case "Rogers":
                        this._imageRootMso = "resources/images/rogers/" + this._screenH + "/";
                        break;

                    case "Shaw":
                        this._imageRootMso = "resources/images/shaw/" + this._screenH + "/";
                        break;

                    default:
                        console.error( "Unknown partner = " + partner );
                        break;
                }
                break;

            case Config.MODE_RUI:
                switch( partner )
                {
                    case "cox":
                        this._authEndpoint   = this.getValue( Config.ruiCox, "authEndpoint"   );
                        this._authMode       = this.getValue( Config.ruiCox, "authType"       );
                        this._imageRootMso   = this.getValue( Config.ruiCox, "imageRootMso"   ) + this._screenH + "/";
                        this._initialScreen  = this.getValue( Config.ruiCox, "initialScreen"  );
                        this._usernameSuffix = this.getValue( Config.ruiCox, "usernameSuffix" );
                        break;

                    case "cox-dev":
                        this._authEndpoint   = this.getValue( Config.ruiCoxDev, "authEndpoint"   );
                        this._authMode       = this.getValue( Config.ruiCoxDev, "authType"       );
                        this._imageRootMso   = this.getValue( Config.ruiCoxDev, "imageRootMso"   ) + this._screenH + "/";
                        this._initialScreen  = this.getValue( Config.ruiCoxDev, "initialScreen"  );
                        this._usernameSuffix = this.getValue( Config.ruiCoxDev, "usernameSuffix" );
                        break;

                    default:
                        this._authEndpoint   = this.getValue( Config.rui, "authEndpoint"   );
                        this._authMode       = this.getValue( Config.rui, "authType"       );
                        this._imageRootMso   = this.getValue( Config.rui, "imageRootMso"   ) + this._screenH + "/";
                        this._initialScreen  = this.getValue( Config.uhd, "initialScreen"  );
                        this._usernameSuffix = this.getValue( Config.rui, "usernameSuffix" );
                        break;
                }
                break;

            case Config.MODE_TEST:
//                this._authEndpoint  = this.getValue( Config.test, "authEndpoint"  );
                this._authMode      = this.getValue( Config.test, "authType"      );
                this._imageRootMso  = this.getValue( Config.test, "imageRootMso"  ) + this._screenH + "/";
                this._initialScreen = this.getValue( Config.test, "initialScreen" );
                break;

            case Config.MODE_UHD:
                this._authEndpoint  = this.getValue( Config.uhd, "authEndpoint"  );
                this._authMode      = this.getValue( Config.uhd, "authType"      );
                this._imageRootMso  = this.getValue( Config.uhd, "imageRootMso"  ) + this._screenH + "/";
                this._initialScreen = this.getValue( Config.uhd, "initialScreen" );
                this._mainMenu      = this.getValue( Config.uhd, "mainMenu"      );
                break;

            default:
                console.error( "ERROR -> setting app mode to unrecognized value = " + mode );
                break;
        }
    };

    Config.prototype.setSize = function( size )
    {
        switch( size )
        {
            case "480":
            case "sd":
                this._screenW       = 640;
                this._screenH       = 480;
                this._layout        = Config.RES_480;
                this._imageRoot     = "resources/images/480/";
                this._imageRootTest = "resources/images/test/480/";
                break;

            case "540":
            case "lhd":
                this._screenW       = 960;
                this._screenH       = 540;
                this._layout        = Config.RES_540;
                this._imageRoot     = "resources/images/540/";
                this._imageRootTest = "resources/images/test/480/";
                break;

            case "720":
            case "hd":
                this._screenW       = 1280;
                this._screenH       =  720;
                this._layout        = Config.RES_720;
                this._imageRoot     = "resources/images/720/";
//                this._imageRootMso  = this.getValue( Config.default, "imageRootMso"  ) + "720/";
                this._imageRootTest = "resources/images/test/480/";
                break;

            case "1080":
            case "hhd":
                this._screenW       = 1920;
                this._screenH       = 1080;
                this._layout        = Config.RES_1080;
                this._imageRoot     = "resources/images/1080/";
//                this._imageRootMso  = this.getValue( Config.default, "imageRootMso"  ) + "1080/";
                this._imageRootTest = "resources/images/test/480/";
                break;

            default:
                console.log( "ERROR -> unrecognized size = " + size );
                break;
        }

        if( this._mode !== undefined )
            this.setAppMode( this._mode, this._partner );
    };

    return Config;

})();


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * WebGL Font Rendering
 */
window.GlFont = (function()
{
    "use strict";

    GlFont.ALPHA_SCALE    = 16384; // normalized alpha = alpha / 16384
    GlFont.ALPHA_MAX      = 32768; // normalized alpha allowed to go up to 2.0 in fragment shader

    function GlFont( name )
    {
        this._file = 'resources/fonts/webgl/XfinityStandard-' + name;
        if( name === "Medium" || name === "Regular" )
            this._file = 'resources/fonts/webgl/XStandard02_' +  name;
        this._url  = this._file + '.png';
        this._json = this._file + '.json';
    }

    GlFont.prototype.load = function()
    {
        var self = this, paramsMetrics = {}, onSuccessMetrics, onErrorMetrics, onImageLoad, onImageFail;

        onSuccessMetrics = function( response )
        {
            self._metrics = JSON.parse( response.data );

            var a, b, u, v, w, h, i;
            var gl        = Widget.gl;
            var version   = self._metrics.ver;
            var aMetrics  = self._metrics.metrics;
            var srcGlyph  = 1; // skip first dummy array due to trailing comma being first for subsequent array elements
            var numGlyph  = aMetrics.length;
            var dstGlyph  = 1; // first glpyph slot is unicode 0032
            var nGlyph    = numGlyph;
            var SCALE_A   = 1.0/64.0;
            var SCALE_W   = 32768 / self._metrics.w;
            var SCALE_H   = 32768 / self._metrics.h;
            var uvOffset  = 0;

            self._xyBuffer = gl.createBuffer(); // position
            self._uvBuffer = gl.createBuffer(); // texture
            self._ijBuffer = gl.createBuffer(); // index

            self._aWidth   = new Float32Array( nGlyph   );
            self._aHeight  = new Float32Array( nGlyph   );
            self._advanceX = new Float32Array( nGlyph   );
            self._bearingX = new Float32Array( nGlyph   );
            self._aU       = new Float32Array( nGlyph*2 ); // 2 texcoord u per vertex - prescaled by 32768
            self._aV       = new Float32Array( nGlyph*2 ); // 2 texcoord v per vertex - prescaled by 32768
            self._unicode  = [];

            self._w               = self._metrics.w;
            self._h               = self._metrics.h;
            self._fontSize        = self._metrics.fontSize; // native 1:1 font glyph size -- SDF scalable font metrics
            self._maxAscent       = self._metrics.ascent;
            self._maxDescent      = self._metrics.descent;
            self._oneOverFontSize = 1 / self._fontSize;     // render font size = fontsize * ooFontSize

            for( ; srcGlyph < numGlyph; srcGlyph++, dstGlyph++ )
            {
                i = aMetrics[ srcGlyph ][ 0 ];
                a = aMetrics[ srcGlyph ][ 1 ] * SCALE_A;
                b = aMetrics[ srcGlyph ][ 2 ] * SCALE_A;
                u = aMetrics[ srcGlyph ][ 3 ];
                v = aMetrics[ srcGlyph ][ 4 ];
                w = aMetrics[ srcGlyph ][ 5 ];
                h = aMetrics[ srcGlyph ][ 6 ];

                self._advanceX[ dstGlyph ] = a;
                self._bearingX[ dstGlyph ] =(b < 0) ? 0 : b;
                self._aWidth  [ dstGlyph ] = w;
                self._aHeight [ dstGlyph ] = h;

                uvOffset = dstGlyph << 1;
                self._aU[ uvOffset   ] = (u    ) * SCALE_W;
                self._aU[ uvOffset+1 ] = (u + w) * SCALE_W;

                self._aV[ uvOffset   ] = (v    ) * SCALE_H;
                self._aV[ uvOffset+1 ] = (v + h) * SCALE_H;

                self._unicode[ i ] = dstGlyph; // map unicode to glyph slot
            }

            onImageLoad = function()
            {
                self._texture = self._image._texture; // WebGLTexture
            };

            onImageFail = function()
            {
                return Promise.reject( "ERROR: Couldn't load WebGL Font Texture" );
            };

            self._image = new ImageWidget().init( { url:self._url, onLoad:onImageLoad, onError:onImageFail } );
            self._image.resourcesLoad();
        };

        onErrorMetrics = function()
        {
            return Promise.reject( "ERROR: Couldn't load WebGL Font Metrics" );
        };

        paramsMetrics.type         = "GET";
        paramsMetrics.url          = self._json;
        paramsMetrics.responseType = "text";

        return _x2._network.ajax( paramsMetrics ).then( onSuccessMetrics ).catch( onErrorMetrics );
    };

    /** Font metrics: returns the font line height (ascent + descent) in pixels
     * @memberof GlFont
     * @param   {Number} fontSize in pixels
     * @returns {Number} Height in pixels
     * NOTE: Line height is NOT the same as leading even though Photoshop mislabels it.
     * @see https://www.w3.org/Talks/2008/0911-CSS-Amsterdam/line-height.png
     * @see http://jeffyam.com/node/189
     */
    GlFont.prototype.getLineHeight = function( fontSize )
    {
        return (this._maxAscent + this._maxDescent) * (fontSize * this._oneOverFontSize); // SDF scalable font metrics
    };

    /** Font metrics -- return text width in pixels
     * @memberof GlFont
     * @param   {Object}  params
     * @param   {Number}  params.fontSize - Font size in pixels
     * @param   {Number} [params.length]  - Number of characters in string to render
     * @param   {Number} [params.offset]  - Index of first character; defaults to 0
     * @param   {Number}  params.text     - String to render
     * @param   {Number} [params.width]   - Maximum width in pixels before clipping; defaults to full width
     * @returns {Object}  metric          - Width and Offset that would overflow
     * @returns {Number}  metric.width    - Width in pixels
     * @returns {Number}  metric.offset   - Index of first character that would overflow if any; defaults to -1 if none
     */
    GlFont.prototype.getLineWidth = function( params )
    {
        var retval = { offset: -1 };
        var length = params.length ? params.length : params.text.length;
        var scale  = params.fontSize * this._oneOverFontSize;
        var start  = params.offset | 0;
        var text   = params.text;
        var width  = params.width;

        var glyph;
        var end = start + length;

        var w       = 0;
        var advance = this._advanceX; // Note: must be scaled

        if( length < 1 )
            return 0;

        for( ; start < end; ++start )
        {
            glyph = this._unicode[ text.charCodeAt( start ) ]; // Note: Since we support Unicode there is no: & 0xFF

            w += (advance[ glyph ] * scale); // NOTE: Keep in sync: getLineWidth() render()

            // Fits on line?
            if( (width > 0) && (w >= width) ) // common case: no max width specified
            {
                retval.offset = start;
                break;
            }
        }

        retval.width = w+1; // TODO: Math.ceil() ?
        return retval;
    };

    /** Draw string
     * @memberof GlFont
     * @param  {Object}  params
     * @param  {Number}  params.fontSize - Font size in pixels
     * @param  {Number} [params.length]  - Number of characters in string to render
     * @param  {Number} [params.offset]  - Index of first character; defaults to zero
     * @param  {Number}  params.text     - Text
     * @param  {Number}  params.width    - Maximum width in pixels before clipping; defaults to full width
     * @param  {Number}  params.r        - Normalized Red
     * @param  {Number}  params.g        - Normalized Green
     * @param  {Number}  params.b        - Normalized Blue
     * @param  {Number}  params.a        - Normalized Alpha
     */
    GlFont.prototype.render = function( params )
    {
        var gl = Widget.gl, shader = Widget.glShaderThis;

        var length = params.length ? params.length : params.text.length;
        var scale  = params.fontSize * this._oneOverFontSize;
        var start  = params.offset | 0;
        var text   = params.text;
        var width  = params.width  ? params.width          : -1;
        var italic = params.italic ? params.fontSize * 0.4 : 0.0;

        var glyph, coord; // coord = index texture coord U and V for glyph
        var end = start + length;

        var w  = 0;
        var x  = 0;
        var x0 = 0;
        var x1 = 0;
        var y1;

        //array.length, alias
        var nxy   = -1, xya = new Uint16Array( length * 12 ); // Vertices 4*xya = 12
        var nuv   = -1, uvs = new Uint16Array( length *  8 ); // TexCoord 4*uv  = 8
        var nij   = -1, ijk = new Int16Array ( length *  6 ); // VerIndex 2*ijk = 6 // 2 triangles/glyph = top-tri & bot-tri
        var verts = -1;

        var dX;
        var advance = this._advanceX; // glyph advance width
        var bearing = this._bearingX; // where left edge begins from origin
        var renderW = this._aWidth  ; // glyph render width  -- must be scaled
        var renderH = this._aHeight ; // glyph render height -- must be scaled
        var renderU = this._aU      ; // glyph texture coord u[]
        var renderV = this._aV      ; // glyph texture coord v[]
        var unicode = this._unicode ;

        var alphaLeft  = GlFont.ALPHA_SCALE;
        var alphaRight = GlFont.ALPHA_SCALE;

        /*
              p0,q0      p1,q1
                +----------+...|      xya      uvs          ijk
                |/////A////|...|        0, 0   26944, 128   0
                |////A/A///|...|       24, 0   27992, 128   1
                |///A///A//|...|        0,49   26944,2248   2
                |//AAAAAAA/|...|       24,49   27992,2248   3
                |//A/////A/|...|                            2
                |//A/////A/|...|                            1
                |//A/////A/|...|
                +----------+   |
                x0        x1   w
              p2,q2      p3,q3

                |<-render->|
                |<--advancex-->|
        */
        if( length < 1 )
            return;

        for( ; start < end; ++start )
        {
            glyph = unicode[ text.charCodeAt( start ) ]; // Note: Since we support Unicode there is no: & 0xFF
            coord = glyph << 1; // 2 uv per glyph

            // https://www.freetype.org/freetype2/docs/glyphs/glyphs-3.html
            x0 = x  + (bearing[ glyph ] * scale);
            x1 = x0 + (renderW[ glyph ] * scale); // render width
            y1 =      (renderH[ glyph ] * scale);

            dX =      (advance[ glyph ] * scale); // advance width
            w +=       dX;

            if( (width > 0) && (w > width) )
                break;

            // Vertex Position
            xya[ ++nxy ] = x0 + italic; // p0
            xya[ ++nxy ] = 0;           // q0
            xya[ ++nxy ] = alphaLeft;

            xya[ ++nxy ] = x1 + italic; // p1
            xya[ ++nxy ] = 0          ; // q1
            xya[ ++nxy ] = alphaRight;

            xya[ ++nxy ] = x0         ; // p2
            xya[ ++nxy ] = y1         ; // q2
            xya[ ++nxy ] = alphaLeft;

            xya[ ++nxy ] = x1         ; // p3
            xya[ ++nxy ] = y1         ; // q3
            xya[ ++nxy ] = alphaRight;

            // Vertex Texture Coordinates
            uvs[ ++nuv ] = renderU[   coord ]; // u0
            uvs[ ++nuv ] = renderV[   coord ]; // v0

            uvs[ ++nuv ] = renderU[ 1+coord ]; // u1
            uvs[ ++nuv ] = renderV[   coord ]; // v1

            uvs[ ++nuv ] = renderU[   coord ]; // u2
            uvs[ ++nuv ] = renderV[ ++coord ]; // v2

            uvs[ ++nuv ] = renderU[   coord ]; // u3
            uvs[ ++nuv ] = renderV[   coord ]; // v3

            // Vertex Index
            ijk[ ++nij ] = ++verts; // i0
            ijk[ ++nij ] = ++verts; // i1
            ijk[ ++nij ] = ++verts; // i2

            ijk[ ++nij ] = ++verts; // i3
            ijk[ ++nij ] = verts-1; // i2
            ijk[ ++nij ] = verts-2; // i1

            x += dX;
        }

        ++nij;

        gl.bindBuffer( gl.ARRAY_BUFFER, this._uvBuffer );
        gl.vertexAttribPointer( shader.avTexCoord, 2, gl.UNSIGNED_SHORT, false, 0, 0 ); // stride 0
        gl.enableVertexAttribArray( shader.avTexCoord );
        gl.bufferData( gl.ARRAY_BUFFER, uvs, gl.STATIC_DRAW );

        gl.activeTexture( gl.TEXTURE0 );
        gl.bindTexture( gl.TEXTURE_2D, this._texture );
        gl.uniform1i( shader.utDiffuse1, 0 );
        gl.uniform1f( shader.unHeight, this._h );
        gl.uniform4f( shader.uvColor, params.r, params.g, params.b, params.a );
        gl.uniform1f( shader.unWeight, params.bold ? 0.5 : 0.0 ); // see Widget FLAG_W

        gl.bindBuffer( gl.ARRAY_BUFFER, this._xyBuffer );
        gl.vertexAttribPointer( shader.avPosition, 3, gl.UNSIGNED_SHORT, false, 0, 0 ); // 3 = xyz = x y alpha
        gl.enableVertexAttribArray( shader.avPosition );
        gl.bufferData( gl.ARRAY_BUFFER, xya, gl.STATIC_DRAW );

        gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, this._ijBuffer );
        gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, ijk, gl.STATIC_DRAW );

        gl.drawElements( gl.TRIANGLES, nij, gl.UNSIGNED_SHORT, 0 ); // 6 vertices per 2 triangles
    };

    return GlFont;

})();


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Host = (function()
{
    "use strict";

    Host.NetworkType = Object.freeze
    ({
        NONE    : 0,
        UNKNOWN : 1,
        WIFI    : 2,
        WIRED   : 3
    });

    /**
     * @enum Type
     * @property {Number} PC Default
     * @property {Number} TIZEN Samsung Tizen Smart TV
     */
    Host.Type = Object.freeze
    ({
        ANDROID: 0,
        LG     : 1,
        PC     : 2,
        TIZEN  : 3
    });

    // Type
    Host.KEY_PRESSED        =    0;
    Host.KEY_RELEASED       =    1;
    Host.KEY_REPEAT         =    2;

    // Val
    Host.KEY_DELETE         =    8;
    Host.KEY_TAB            =    9;
    Host.KEY_ENTER          =   13;
    Host.KEY_ESC            =   27;
    Host.KEY_SPACE          =   32;
    Host.KEY_PAGE_UP        =   33;
    Host.KEY_PAGE_DN        =   34;
    Host.KEY_LEFT           =   37;
    Host.KEY_UP             =   38;
    Host.KEY_RIGHT          =   39;
    Host.KEY_DOWN           =   40;
    Host.KEY_DOT            =   46;
    Host.KEY_0              =   48;
    Host.KEY_1              =   49;
    Host.KEY_2              =   50;
    Host.KEY_3              =   51;
    Host.KEY_4              =   52;
    Host.KEY_5              =   53;
    Host.KEY_6              =   54;
    Host.KEY_7              =   55;
    Host.KEY_8              =   56;
    Host.KEY_9              =   57;
    Host.KEY_A              =   65;
    Host.KEY_B              =   66;
    Host.KEY_C              =   67;
    Host.KEY_D              =   68;
    Host.KEY_E              =   69;
    Host.KEY_F              =   70;
    Host.KEY_G              =   71;
    Host.KEY_H              =   72;
    Host.KEY_I              =   73;
    Host.KEY_J              =   74;
    Host.KEY_K              =   75;
    Host.KEY_L              =   76;
    Host.KEY_M              =   77;
    Host.KEY_N              =   78;
    Host.KEY_O              =   79;
    Host.KEY_P              =   80;
    Host.KEY_Q              =   81;
    Host.KEY_R              =   82;
    Host.KEY_S              =   83;
    Host.KEY_T              =   84;
    Host.KEY_U              =   85;
    Host.KEY_V              =   86;
    Host.KEY_W              =   87;
    Host.KEY_X              =   88;
    Host.KEY_Y              =   89;
    Host.KEY_Z              =   90;
    Host.KEY_F1             =  112;
    Host.KEY_F2             =  113;
    Host.KEY_F3             =  114;
    Host.KEY_F4             =  115;
    Host.KEY_F5             =  116;
    Host.KEY_F6             =  117;
    Host.KEY_F7             =  118;
    Host.KEY_F8             =  119;
    Host.KEY_F9             =  120;
    Host.KEY_F10            =  121;
    Host.KEY_F11            =  122;
    Host.KEY_F12            =  123;
    Host.KEY_F13            =  124;
    Host.KEY_F14            =  125;
    Host.KEY_F15            =  126;
    Host.KEY_F16            =  127;
    Host.KEY_F17            =  128;
    Host.KEY_F18            =  129;
    Host.KEY_F19            =  130;
    Host.KEY_EQUAL          =  187;
    Host.KEY_MINUS          =  189;
    Host.KEY_SLASH          =  191;
    Host.KEY_BRACKET_LEFT   =  219;
    Host.KEY_BACK_SLASH     =  220;
    Host.KEY_BRACKET_RIGHT  =  221;

    Host.KEY_BLUE           = 2000;
    Host.KEY_GREEN          = 2001;
    Host.KEY_RED            = 2002;
    Host.KEY_YELLOW         = 2003;
    Host.KEY_ON_DEMAND      = 2004;
    Host.KEY_INFO           = 2005;
    Host.KEY_SOFT_A         = 2006;
    Host.KEY_SOFT_B         = 2007;
    Host.KEY_SOFT_C         = 2008;
    Host.KEY_SOFT_D         = 2009;
    Host.KEY_MENU           = 2010;
    Host.KEY_EXIT           = 2011;
    Host.KEY_HELP           = 2012;
    Host.KEY_FAV            = 2013;
    Host.KEY_PLAY           = 2014;
    Host.KEY_PAUSE          = 2015;
    Host.KEY_FF             = 2016;
    Host.KEY_RW             = 2017;
    Host.KEY_STOP           = 2018;
    Host.KEY_RECORD         = 2019;
    Host.KEY_LAST           = 2020;
    Host.KEY_SEARCH         = 2021;
    Host.KEY_GUIDE          = 2022;
    Host.KEY_APP            = 2023;
    Host.KEY_CLEAR          = 2024;
    Host.KEY_POUND          = 2025;
    Host.KEY_STAR           = 2026;
    Host.KEY_BANG           = 2027;
    Host.KEY_AT             = 2028;
    Host.KEY_DOLR           = 2029;
    Host.KEY_PRCT           = 2030;
    Host.KEY_MUTE           = 2031;
    Host.KEY_VOL_DOWN       = 2032;
    Host.KEY_VOL_UP         = 2033;
    Host.KEY_CH_DOWN        = 2044;
    Host.KEY_CH_UP          = 2045;
    Host.KEY_CARET          = 2046;
    Host.KEY_AMP            = 2047;
    Host.KEY_LPAREN         = 2048;
    Host.KEY_RPAREN         = 2049;
    Host.KEY_USAGE          = 2050;
    Host.KEY_QUIT           = 2051;
    Host.KEY_QUIT_NOW       = 2052;
    Host.KEY_HUD            = 2053;
    Host.KEY_CC             = 2054;
    Host.KEY_SAP            = 2055;
    Host.KEY_PLAY_PAUSE     = 2056;


//     Host.BORDER_IMAGE        =  0;
//     Host.BORDER_IMAGE_WEBKIT =  1;

    function Host(){}

//     Host.prototype.checkMinVersion = function()
//     {
//     };
//
//     Host.prototype.checkNetworkConnection = function( interval )
//     {
//         console.log( "WARNING -> Network check not implemented." );
//     };

    Host.prototype.exitApp = function()
    {
        console.log( "########## EXIT APP NOT SUPPORTED ##########" );
    };

    Host.prototype.getCurrentDateTime = function( convertToTimeStamp ) 
    {
        convertToTimeStamp = convertToTimeStamp || false;
        return (convertToTimeStamp == true )? Date.now() : new Date();
    };

//     Host.prototype.getBorderImageType = function()
//     {
//         return Host.BORDER_IMAGE;
//     };
//
//     Host.prototype.getDate = function()
//     {
//         return (new Date());
//     };
//
//     Host.prototype.getImageSoftA = function()
//     {
//         return "softKeys/SoftKey_A.png";
//     };
//
//     Host.prototype.getImageSoftB = function()
//     {
//         return "softKeys/SoftKey_B.png";
//     };
//
//     Host.prototype.getImageSoftC = function()
//     {
//         return "softKeys/SoftKey_C.png";
//     };
//
//     Host.prototype.getImageSoftD = function()
//     {
//         return "softKeys/SoftKey_D.png";
//     };

    Host.prototype.getClientInfo = function()
    {
        return "app_name=\"Stream\";app_version=\"" + AboutOverlay.version +
               "\";os_name=\"" + _x2._config._host._osName +
               "\";os_version=\"" + _x2._config._host._osVersion +
               "\";device_model=\"" + _x2._config._host._product +
               "\"";
    };

    Host.prototype.getCryptoType = function()
    {
        return "dh";
    };

    Host.prototype.getDrmType = function()
    {
        return "com.widevine.alpha";
    };

    Host.getLocalStorage = function( key )
    {
        var retval;

        if( typeof(Storage) !== "undefined" && localStorage !== undefined )
            retval = localStorage.getItem( key );
        else
            console.error( "ERROR -> local storage is not supported" );

        return retval;
    };

    Host.prototype.getNetworkType = function()
    {
        var retval = "Unknown";

        switch( this._networkType )
        {
            case Host.NetworkType.NONE:
                retval = "None";
                break;

            case Host.NetworkType.WIFI:
                retval = "WiFi";
                break;

            case Host.NetworkType.WIRED:
                retval = "Wired";
                break;
        }

        return retval;
    };

    Host.prototype.getSsid = function()
    {
        return this._ssid;
    };
    Host.prototype.getPlatformInfo = function()
    {
        var modelInfo = ' ', productInfo = '';
        if( this._make ) {
            productInfo = this._make;
        } else {
            productInfo = this._product;
        }
        if (productInfo) {
            modelInfo += productInfo + '_';
        }
        if( this._model ) {
            modelInfo += this._model + ' ';
        }
        if( this._product ) {
            modelInfo += this._product + ' ';
        }
        return { "product" : productInfo, "model" : modelInfo.trim() };
    };

    Host.prototype.getPlatformString = function()
    {
        return "pc";
    };

    Host.prototype.getSecClientDeviceType = function()
    {
       return undefined;
    };

//     Host.prototype.getType = function()
//     {
//         return this._type;
//     };
//
//     Host.prototype.getVideoPlayerClass = function( ext )
//     {
//         var retval;
//
//         switch( ext )
//         {
//             case "dvr":
//             case "mp4":
//             case "ocap":
//                 retval = VideoTagPlayer;
//                 break;
//
//             case "f4m":
//             case "m3u8":
//                 retval = ViperFlashPlayer;
//                 break;
//
//             default:
//                 console.log( "ERROR -> no player type for ext = " + ext );
//                 break;
//         }
//
//         return retval;
//     };

    /**
     * Get the host type
     * @memberOf Host
     * @return {Host.Type}
     */
    Host.prototype.getType = function()
    {
        return this._type;
    };

    Host.prototype.init = function( callback )
    {
        this._type = Host.Type.PC;

        _x2._config._authHost = "https://xacs.ccp.xcal.tv";
        _x2._config._provHost = "https://xacsa.ccp.xcal.tv";  // TODO should be moved to xacs

        var device  = "Unknown", nameOffset, verOffset, ix;
        var browser = navigator.appName;
        var ua      = navigator.userAgent;
        var av      = navigator.appVersion;
        var version = parseFloat( av );

        if( av.indexOf( "Win" ) !== -1 )
            device="Windows";
        else if( av.indexOf( "Mac" ) !== -1 )
            device="Macintosh";
        else if( av.indexOf( "Linux" ) !== -1 )
            device="Linux";

        if( (verOffset=ua.indexOf( "OPR/" )) !== -1 )
        {
            browser = "Opera";
            version = ua.substring( verOffset + 4 );
        }
        else if( (verOffset=ua.indexOf( "MSIE" )) !== -1 )
        {
            browser = "Microsoft Internet Explorer";
            version = ua.substring( verOffset + 5 );
        }
        else if( (verOffset=ua.indexOf( "Chrome" )) !== -1 )
        {
            browser = "Chrome";
            version = ua.substring( verOffset + 7 );
        }
        else if( (verOffset=ua.indexOf( "Safari" )) !== -1 )
        {
            browser = "Safari";
            version = ua.substring( verOffset + 7 );

            if( (verOffset=ua.indexOf( "Version" )) !== -1 )
                version = ua.substring( verOffset + 8 );
        }
        else if( (verOffset=ua.indexOf( "Firefox" )) !== -1 )
        {
            browser = "Firefox";
            version = ua.substring( verOffset + 8 );
        }
        else if( (nameOffset=ua.lastIndexOf( " " ) + 1) < (verOffset=ua.lastIndexOf( "/" )) )
        {
            browser = ua.substring( nameOffset, verOffset );
            version = ua.substring( verOffset + 1 );

            if( browser.toLowerCase() === browser.toUpperCase() )
                browser = navigator.appName;
        }

        if( (ix=version.indexOf(";")) !== -1 )
           version = version.substring( 0, ix );
        if( (ix=version.indexOf(" ")) !== -1 )
           version = version.substring( 0, ix );

        _x2._config._host._make      = undefined;
        _x2._config._host._product   = device;
        _x2._config._host._osName    = browser;
        _x2._config._host._osVersion = version;

//         this._macAddress = _mac;
//
// //        this._videoTag = { _transMode: VideoPlayer.TRANS_SCRUB, _speeds:[-128,-64,-16,-4,-2,1,2,4,16,64,128] };
//         this._videoTag = { _transMode: VideoPlayer.TRANS_LIVE, _speeds:[-60,-30,-15,1,15,30,60] };

        setTimeout( function() { callback() }, 1 );
    };

    // The which field of the KeyboardEvent is read only. If the Host class is extended, the which field will contain
    // the remapped value. Otherwise, the which field can be excluded and it will be extracted from the event.

    Host.prototype.mapKey = function( event, which )
    {
        var val;

        if( which === undefined )
        {
            val = Host.mapKeyStr( event.key );

            if( val === undefined )
                val = event.which;
        }
        else
            val = which;

        val = Host.mapKeyVal( val );

        return val;
    };

    Host.mapKeyStr = function( str )
    {
        var retval;

        switch( str )
        {
            case "l":
                retval = Host.KEY_L;
                break;

            case "ArrowDown":
                retval = Host.KEY_DOWN;
                break;

            case "ArrowLeft":
                retval = Host.KEY_LEFT;
                break;

            case "ArrowRight":
                retval = Host.KEY_RIGHT;
                break;

            case "ArrowUp":
                retval = Host.KEY_UP;
                break;

            case "Backspace":
                retval = Host.KEY_LAST;
                break;

            case "ChannelDown":
                retval = Host.KEY_CH_DOWN;
                break;

            case "ChannelUp":
                retval = Host.KEY_CH_UP;
                break;

            case "ClosedCaptionToggle":
                retval = Host.KEY_CC;
                break;

            case "ColorF0Red":
                retval = Host.KEY_SOFT_A;
                break;

            case "ColorF1Green":
                retval = Host.KEY_SOFT_B;
                break;

            case "ColorF2Yellow":
                retval = Host.KEY_SOFT_C;
                break;

            case "ColorF3Blue":
                retval = Host.KEY_SOFT_D;
                break;

//                 case "ContextMenu":
//                     retval = ;
//                     break;

            case "Digit0":
            case "0":  // Samsung CVP-2 Bug
                retval = Host.KEY_0;
                break;

            case "Digit1":
            case "1":  // Samsung CVP-2 Bug
                retval = Host.KEY_1;
                break;

            case "Digit2":
            case "2":  // Samsung CVP-2 Bug
                retval =Host.KEY_2;
                break;

            case "Digit3":
            case "3":  // Samsung CVP-2 Bug
                retval = Host.KEY_3;
                break;

            case "Digit4":
            case "4":  // Samsung CVP-2 Bug
                retval = Host.KEY_4;
                break;

            case "Digit5":
            case "5":  // Samsung CVP-2 Bug
                retval = Host.KEY_5;
                break;

            case "Digit6":
            case "6":  // Samsung CVP-2 Bug
                retval = Host.KEY_6;
                break;

            case "Digit7":
            case "7":  // Samsung CVP-2 Bug
                retval = Host.KEY_7;
                break;

            case "Digit8":
            case "8":  // Samsung CVP-2 Bug
                retval = Host.KEY_8;
                break;

            case "Digit9":
            case "9":  // Samsung CVP-2 Bug
                retval = Host.KEY_9;
                break;

            case "Enter":
                retval = Host.KEY_ENTER;
                break;

            case "Exit":
                retval = Host.KEY_EXIT;
                break;

            case "Guide":
                retval = Host.KEY_GUIDE;
                break;

            case "Info":
                retval = Host.KEY_INFO;
                break;

            case "MediaFastForward":
                retval = Host.KEY_FF;
                break;

//                 case "MediaLast":
//                     retval = ;
//                     break;

            case "MediaPause":
                retval = Host.KEY_PAUSE;
                break;

            case "MediaPlay":
                retval = Host.KEY_PLAY;
                break;

            case "MediaPlayPause":
                retval = Host.KEY_PLAY_PAUSE;
                break;

            case "MediaRecord":
                retval = Host.KEY_RECORD;
                break;

            case "MediaRewind":
                retval = Host.KEY_RW;
                break;

//                 case "MediaSelect":
//                     retval = ;
//                     break;

            case "MediaStop":
                retval = Host.KEY_STOP;
                break;

//                 case "MediaTrackNext":
//                     retval = ;
//                     break;

//                 case "MediaTrackPrevious":
//                     retval = ;
//                     break;

            case "OnDemand":
                retval = Host.KEY_ON_DEMAND;
                break;

            case "PageDown":
                retval = Host.KEY_PAGE_DN;
                break;

            case "PageUp":
                retval = Host.KEY_PAGE_UP;
                break;

            case "U+005A":
                retval = Host.KEY_CH_DOWN;
                break;

            case "U+007B":  // Samsung HACK
                retval = Host.KEY_CH_UP;
                break;

            case "U+00BD":  // Samsung HACK
                retval = Host.KEY_HUD;
                break;
        }

        return retval;
    };

    Host.mapKeyVal = function( val )
    {
        var retval = val;

        switch( val )
        {
            case Host.KEY_A:
                retval = Host.KEY_SOFT_A;
                break;

            case Host.KEY_B:
                retval = Host.KEY_SOFT_B;
                break;

            case Host.KEY_BRACKET_LEFT:
                retval = Host.KEY_VOL_DOWN;
                break;

            case Host.KEY_BRACKET_RIGHT:
                retval = Host.KEY_VOL_UP;
                break;

            case Host.KEY_C:
                retval = Host.KEY_SOFT_C;
                break;

            case Host.KEY_D:
                retval = Host.KEY_SOFT_D;
                break;

            case Host.KEY_DELETE:
                retval = Host.KEY_LAST;
                break;

            case Host.KEY_E:
                retval = Host.KEY_EXIT;
                break;

            case Host.KEY_EQUAL:
                retval = Host.KEY_CH_UP;
                break;

            case Host.KEY_ESC:
                retval = Host.KEY_LAST;
                break;

            case Host.KEY_F:
                retval = Host.KEY_FF;
                break;

            case Host.KEY_F1:
                retval = Host.KEY_SOFT_A;
                break;

            case Host.KEY_F2:
                retval = Host.KEY_SOFT_B;
                break;

            case Host.KEY_F3:
                retval = Host.KEY_SOFT_C;
                break;

            case Host.KEY_F4:
                retval = Host.KEY_SOFT_D;
                break;

            case Host.KEY_G:
                retval = Host.KEY_GUIDE;
                break;

            case Host.KEY_H:
                retval = Host.KEY_HUD;
                break;

            case Host.KEY_I:
                retval = Host.KEY_INFO;
                break;

            case Host.KEY_J:
                break;

            case Host.KEY_K:
                retval = Host.KEY_CC;
                break;

            case Host.KEY_L:
                retval = Host.KEY_LAST;
                break;

            case Host.KEY_M:
                retval = Host.KEY_MENU;
                break;

            case Host.KEY_MINUS:
                retval = Host.KEY_CH_DOWN;
                break;

            case Host.KEY_N:
                break;

            case Host.KEY_O:
                retval = Host.KEY_ON_DEMAND;
                break;

            case Host.KEY_P:
                retval = Host.KEY_PLAY;
                break;

            case Host.KEY_Q:
                break;

            case Host.KEY_R:
                retval = Host.KEY_RW;
                break;

            case Host.KEY_S:
                retval = Host.KEY_STOP;
                break;

            case Host.KEY_SLASH:
                retval = Host.KEY_USAGE;
                break;

            case Host.KEY_T:
                retval = Host.KEY_MUTE;
                break;

            case Host.KEY_U:
                retval = Host.KEY_PAUSE;
                break;

            case Host.KEY_V:
                break;

            case Host.KEY_W:
                break;

            case Host.KEY_X:
                break;

            case Host.KEY_Y:
                break;

            case Host.KEY_Z:
                break;

            case Host.KEY_BACK_SLASH:
                retval = Host.KEY_MUTE;
                break;

            case 190:  // HACK: Sony CVP-2
                retval = Host.KEY_HUD;
                break;

            case 403:  // HACK: Sony CVP-2
                retval = Host.KEY_SOFT_C;
                break;

            case 404:  // HACK: Sony CVP-2
                retval = Host.KEY_SOFT_D;
                break;

            case 405:  // HACK: Sony CVP-2
                retval = Host.KEY_SOFT_A;
                break;

            case 406:  // HACK: Sony CVP-2
                retval = Host.KEY_SOFT_B;
                break;

            case 412:  // HACK: Sony CVP-2
                retval = Host.KEY_RW;
                break;

            case 413:  // HACK: Sony CVP-2
                retval = Host.KEY_STOP;
                break;

            case 415:  // HACK: Sony CVP-2
                retval = Host.KEY_PLAY;
                break;

            case 417:  // HACK: Sony CVP-2
                retval = Host.KEY_FF;
                break;

//             case 424:  // prev  // HACK: Sony CVP-2
//                 retval = Host.KEY_;
//                 break;

//             case 425:  // next  // HACK: Sony CVP-2
//                 retval = Host.KEY_;
//                 break;

            case 427:  // HACK: Sony CVP-2
                retval = Host.KEY_CH_UP;
                break;

            case 428:  // HACK: Sony CVP-2
                retval = Host.KEY_CH_DOWN;
                break;

            case 463:  // HACK: Sony CVP-2
                retval = Host.KEY_PAUSE;
                break;

            case 480:  // HACK: Sony CVP-2
                retval = Host.KEY_CC;
                break;
        }

        return retval;
    };

//     Host.prototype.onLoad = function()
//     {
//     };
    Host.prototype.removeAllTokenLocalStorage = function() {
        if( typeof(Storage) !== "undefined" && localStorage !== undefined ) {
            localStorage.removeItem( "OauthToken" );
            localStorage.removeItem( "XsctToken"  );   
            localStorage.removeItem( "XactToken"  );
        }
        else
            console.log( "ERROR -> local storage is not supported" );
    };
    Host.prototype.removeLocalStorage = function( key )
    {
        if( typeof(Storage) !== "undefined" && localStorage !== undefined )
            localStorage.removeItem( key );
        else
            console.log( "ERROR -> local storage is not supported" );
    };

    Host.prototype.resetLocalStorage = function()
    {
        if( typeof(Storage) !== "undefined" && localStorage !== undefined )
            localStorage.clear();
        else
            console.log( "ERROR -> local storage is not supported" );
    };

    Host.prototype.setLocalStorage = function( key, data )
    {
        if( typeof(Storage) !== "undefined" && localStorage !== undefined )
            localStorage.setItem( key, data );
        else
            console.log( "ERROR -> local storage is not supported" );
    };

    Host.prototype.setNetworkType = function( type )
    {
        this._networkType = type;
    };

    Host.prototype.setSsid = function( name )
    {
        this._ssid = name;
    };

//     Host.prototype.setScreenSaverActive = function( active )
//     {
//         if( active === true )
//         {
//             console.log( "##### ENABLE SCREEN SAVER #########################################" );
//         }
//         else if( active === false )
//         {
//             console.log( "##### DISABLE SCREEN SAVER #########################################" );
//         }
//         else
//             console.log( "ERROR -> invalid parameter for setScreenSaverActive = " + active );
//     };

    return Host;

})();


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Android = (function()
{
    "use strict";

    Android.prototype = new Host();

    function Android(){}

    Android.prototype.exitApp = function()
    {
        if( android )
            android.onExit();
    };

    Android.prototype.getCryptoType = function()
    {
        return "webcrypto";
    };

    Android.prototype.getPlatformString = function()
    {
       return "android";
    };

    Android.prototype.getSecClientDeviceType = function()
    {
       return "SONY2018";
    };

    Android.prototype.init = function( callback )
    {
        this._type = Host.Type.ANDROID;

        document.body.style.backgroundColor = "#000000";

        var mac = android.getDeviceId();

        _x2._config._mac = mac;

        console.log( "MAC ADDRESS = " + mac );

        if( _x2._config._host !== undefined )
        {
            _x2._config._host._make  = undefined;
            _x2._config._host._model = "Android";
            _x2._config._host._product = "Android";
        }

        setTimeout( callback(), 1 );
    };

    return Android;

})();



/***/ }),
/* 60 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Lg = (function()
{
    "use strict";

    Lg.prototype = new Host();

    function Lg()
    {
        if( window.innerHeight === 1080 )
            _x2._config.setSize( "1080" );
        else if( window.innerHeight === 720 )
            _x2._config.setSize( "720" );
    }

//     Lg.prototype.checkMinVersion = function()
//     {
//     };
//
//     Lg.prototype.checkNetworkConnection = function( interval )
//     {
//         console.log( "WARNING -> Network check not implemented." );
//     };

    Lg.prototype.exitApp = function( viaLastKey )
    {
        webOS.platformBack();
        window.close();
    };

    Lg.prototype.getCryptoType = function()
    {
        var retval = ( _x2._config._loadWebcrypto ) ? "webcrypto": "ecdh";
        var agent  = navigator.userAgent;

        if( agent.indexOf( "Chrome/38.0.2125.122" ) !== -1 )
        {
            console.log( "LG 2017 TV detetected." );
            retval = "ecdh";
        }
        else if( agent.indexOf( "Chrome/53.0.2785.34" ) !== -1 )
        {
            console.log( "LG 2018 TV detetected." );
            retval = ( _x2._config._loadWebcrypto ) ? "webcrypto" : "ecdh";
        }
        else
            console.error( "Unable to detect the LG model year, dafaulting to WebCrypto." );

        return retval;
    };

    Lg.prototype.getDrmType = function()
    {
        return "com.widevine.alpha";
    };

//     Lg.prototype.getBorderImageType = function()
//     {
//         return Lg.BORDER_IMAGE;
//     };
//
//     Lg.prototype.getDate = function()
//     {
//         return (new Date());
//     };
//
//     Lg.prototype.getImageSoftA = function()
//     {
//         return "softKeys/SoftKey_A.png";
//     };
//
//     Lg.prototype.getImageSoftB = function()
//     {
//         return "softKeys/SoftKey_B.png";
//     };
//
//     Lg.prototype.getImageSoftC = function()
//     {
//         return "softKeys/SoftKey_C.png";
//     };
//
//     Lg.prototype.getImageSoftD = function()
//     {
//         return "softKeys/SoftKey_D.png";
//     };

//     Lg.prototype.getType = function()
//     {
//         return this._type;
//     };

    Lg.prototype.getPlatformString = function()
    {
       return "lg";
    };

    Lg.prototype.getSecClientDeviceType = function()
    {
       return "LG2017";
    };

    Lg.prototype.getVideoPlayerClass = function( ext )
    {
        var retval;

        switch( ext )
        {
           case "mpd":
//                retval = LgPlayer;
                break;

            default:
                console.log( "ERROR -> no player type for ext = " + ext );
                break;
        }

        return retval;
    };

    Lg.prototype.init = function( callback )
    {
        this._type = Host.Type.LG;

console.log( "window.screen.availWidth  = " + window.screen.availWidth );
console.log( "window.screen.availHeight = " + window.screen.availHeight );
console.log( "window.innerWidth = " + window.innerWidth );
console.log( "window.innerHeight = " + window.innerHeight );
console.log( "document.body.clientWidth = " + document.body.clientWidth );
console.log( "document.body.clientHeight = " + document.body.clientHeight );

        document.body.style.backgroundColor = "#000000";



//         Lg.tvinputdevice.registerKey( "0"                  );
//         Lg.tvinputdevice.registerKey( "1"                  );
//         Lg.tvinputdevice.registerKey( "2"                  );
//         Lg.tvinputdevice.registerKey( "3"                  );
//         Lg.tvinputdevice.registerKey( "4"                  );
//         Lg.tvinputdevice.registerKey( "5"                  );
//         Lg.tvinputdevice.registerKey( "6"                  );
//         Lg.tvinputdevice.registerKey( "7"                  );
//         Lg.tvinputdevice.registerKey( "8"                  );
//         Lg.tvinputdevice.registerKey( "9"                  );
//         Lg.tvinputdevice.registerKey( "ChannelUp"          );
//         Lg.tvinputdevice.registerKey( "ChannelDown"        );
//         Lg.tvinputdevice.registerKey( "ColorF0Red"         );
//         Lg.tvinputdevice.registerKey( "ColorF1Green"       );
//         Lg.tvinputdevice.registerKey( "ColorF2Yellow"      );
//         Lg.tvinputdevice.registerKey( "ColorF3Blue"        );
//         Lg.tvinputdevice.registerKey( "Exit"               );
//         Lg.tvinputdevice.registerKey( "Info"               );
//         Lg.tvinputdevice.registerKey( "MediaFastForward"   );
//         Lg.tvinputdevice.registerKey( "MediaPause"         );
//         Lg.tvinputdevice.registerKey( "MediaPlay"          );
//         Lg.tvinputdevice.registerKey( "MediaPlayPause"     );
//         Lg.tvinputdevice.registerKey( "MediaRecord"        );
//         Lg.tvinputdevice.registerKey( "MediaRewind"        );
//         Lg.tvinputdevice.registerKey( "MediaStop"          );
//         Lg.tvinputdevice.registerKey( "MediaTrackNext"     );
//         Lg.tvinputdevice.registerKey( "MediaTrackPrevious" );
//         Lg.tvinputdevice.registerKey( "Minus"              );
//
//         console.log( "################################################################################################" );
//
//
        var onScriptLoaded  = function()
        {
            var numReady    = 0;
            var onCallbacks = function()
            {
                if( ++numReady === 3 )
                {
                    console.log( "LGDUID   = " + _x2._config._mac );
                    console.log( "FIRMWARE = " + _x2._config._host._osVersion );
                    console.log( "NETWORK  = " + _x2._config._host.getNetworkType() + ", " + _x2._config._host.getSsid() );
                    console.log( "PRODUCT  = " + _x2._config._host._product );

                    callback();
                }
            };

            var onId  = function( inResponse )
            {
                var list = inResponse.idList;

                for( var i = 0; i < list.length; i++ )
                    if( list[i].idType === "LGUDID" )
                        {
                            _x2._config._mac = list[i].idValue;
                            break;
                        }

                onCallbacks();
            };

            var onIdError  = function( inError )
            {
                console.error( inError );
                onCallbacks();
            };

            var idObj =
            {
                method     : "deviceid/getIDs",
                parameters : { "idType": ["LGUDID"] },
                onSuccess  : onId,
                onFailure  : onIdError
            };

            webOS.service.request( "luna://com.webos.service.sm", idObj );

            var onDeviceInfo = function( info )
            {
                _x2._config._host._make      = "LG";
                _x2._config._host._product   = info.modelName;
                _x2._config._host._osName    = "webOS";
                _x2._config._host._osVersion = info.version;

                onCallbacks();
            };

            webOS.deviceInfo( onDeviceInfo );

            var onNetwork = function( data )
            {
                var type;

                if( data )
                {
                    if( data.wired.state === "connected" )
                        type = Host.NetworkType.WIRED;

                    if( data.wifi.state === "connected" )
                    {
                        type = Host.NetworkType.WIFI;
                        _x2._config._host.setSsid( data.wifi.ssid );
                    }
                }

                _x2._config._host.setNetworkType( type );

                onCallbacks();
            };

            var onNetworkError = function( e )
            {
                console.error( e );

                onCallbacks();
            };

            var networkObj =
            {
                method    : "getStatus",
                onSuccess : onNetwork,
                onFailure : onNetworkError
            };

            webOS.service.request( "luna://com.palm.connectionmanager", networkObj );
        };

        _x2.getScript( "lib/webOSTVjs-1.0.0/webOSTV.js", function(){ onScriptLoaded(); } );

// //             // see if this is the first run of the application or if it has been deleted
// //
// //             var beenRun = _host.getLocalStorage( FILE_HAS_RUN );
// //
// //             console.log( beenRun );
// //
// //             _beenRun = beenRun["beenRun"];
// //
// //             console.log( "=========>>>>>>>>>>>>>>>>> beenRun = " + _beenRun )
// //
// //             if( val === undefined )
// //             {
// //                 beenRun["beenRun"] = true;
// //                 _host.setLocalStorage( FILE_HAS_RUN, beenRun );
// //             }
//
    };

    Lg.prototype.mapKey = function( event, which )
    {
        var val = event.which;

        switch( val )
        {
            case 13:
                val = Host.KEY_ENTER;
                break;

            case 19:
                val = Host.KEY_PAUSE;
                break;

            case 33:
                val = Host.KEY_PAGE_UP;
                break;

            case 34:
                val = Host.KEY_PAGE_DN;
                break;

            case 37:
                val = Host.KEY_LEFT;
                break;

            case 38:
                val = Host.KEY_UP;
                break;

            case 39:
                val = Host.KEY_RIGHT;
                break;

            case 40:
                val = Host.KEY_DOWN;
                break;

            case 48:
                val = Host.KEY_0;
                break;

            case 49:
                val = Host.KEY_1;
                break;

            case 50:
                val = Host.KEY_2;
                break;

            case 51:
                val = Host.KEY_3;
                break;

            case 52:
                val = Host.KEY_4;
                break;

            case 53:
                val = Host.KEY_5;
                break;

            case 54:
                val = Host.KEY_6;
                break;

            case 55:
                val = Host.KEY_7;
                break;

            case 56:
                val = Host.KEY_8;
                break;

            case 57:
                val = Host.KEY_9;
                break;

            case 189:
                val = Host.KEY_HUD;
                break;

            case 403:
                val = Host.KEY_SOFT_A;
                break;

            case 404:
                val = Host.KEY_SOFT_B;
                break;

            case 405:
                val = Host.KEY_SOFT_C;
                break;

            case 406:
                val = Host.KEY_SOFT_D;
                break;

            case 412:
                val = Host.KEY_RW;
                break;

            case 413:
                val = Host.KEY_STOP;
                break;

            case 415:
                val = Host.KEY_PLAY;
                break;

//             case 416:
//                 val = Host.KEY_RECORD;
//                 break;

            case 417:
                val = Host.KEY_FF;
                break;

//             case 427:
//                 val = Host.KEY_CH_UP;
//                 break;
//
//             case 428:
//                 val = Host.KEY_CH_DOWN;
//                 break;

            case 457:
                val = Host.KEY_INFO;
                break;

            case 461:
                val = Host.KEY_LAST;
                break;

            case 1008:  // CC
                val = Host.KEY_CC;
                break;

            case 1028:  // SAP
                val = Host.KEY_SAP;
                break;

            case 2016:  // Ch Up
                val = Host.KEY_CH_UP;
                break;

            case 2022:  // Ch Down
                val = Host.KEY_CH_DOWN;
                break;

//             case 10009:
//                 val = Host.KEY_LAST;
//                 break;
//
//             case 10182:
//                 val = Host.KEY_QUIT;
//                 break;
//
//             case 10252:  // play/pause
//                 val = Host.KEY_PLAY_PAUSE;
//                 break;

//             case 10232: // prev track
//                 val = ;
//                 break;

//             case 10233: // next track
//                 val = ;
//                 break;
        }

        return Host.prototype.mapKey.call( this, event, val );
    };

//     Lg.prototype.setScreenSaverActive = function( active )
//     {
//         if( active === true )
//         {
//             console.log( "##### ENABLE SCREEN SAVER #########################################" );
//             webapis.appcommon.setScreenSaver( webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_ON );
//         }
//         else if( active === false )
//         {
//             console.log( "##### DISABLE SCREEN SAVER #########################################" );
//             webapis.appcommon.setScreenSaver( webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_OFF );
//         }
//         else
//             console.log( "ERROR -> invalid parameter for setScreenSaverActive = " + active );
//     };

    return Lg;

})();


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Tizen = (function()
{
    "use strict";

    Tizen.prototype = new Host();

    function Tizen()
    {
//         console.log( "SCREEN HEIGHT = " + screen.availHeight );
//         console.log( screen );
//         console.log( "window.innerWidth = " + window.innerWidth );
//         console.log( "window.innerHeight = " + window.innerHeight );

        _x2._useListitem = true;

        if( window.innerHeight === 1080 )
            _x2._config.setSize( "1080" );
        else if( window.innerHeight === 720 )
            _x2._config.setSize( "720" );
    }

//     Tizen.prototype.checkMinVersion = function()
//     {
//     };
//
//     Tizen.prototype.checkNetworkConnection = function( interval )
//     {
//         console.log( "WARNING -> Network check not implemented." );
//     };

    Tizen.prototype.exitApp = function( viaExit )
    {
        tizen.application.getCurrentApplication().exit();

//         if( viaExit === true )
//             tizen.application.getCurrentApplication().exit();
//         else
//             tizen.application.getCurrentApplication().hide();
    };

    Tizen.prototype.getDrmType = function()
    {
        return "com.widevine.alpha";
    };

    Tizen.prototype.getCurrentDateTime = function(convertToTimeStamp) 
    {
        convertToTimeStamp = convertToTimeStamp || false;
        if( _x2._config.useJSTime === true ) {
            return Host.prototype.getCurrentDateTime( convertToTimeStamp );
        } else {
            var tzDateTime = tizen.time.getCurrentDateTime();
            var jsDateTime = new Date( tzDateTime.getFullYear(), tzDateTime.getMonth(), 
                                       tzDateTime.getDate(), tzDateTime.getHours(), 
                                       tzDateTime.getMinutes(), tzDateTime.getSeconds() );
            return (convertToTimeStamp == true )? jsDateTime.getTime() : jsDateTime;
        }
    };

//     Tizen.prototype.getBorderImageType = function()
//     {
//         return Tizen.BORDER_IMAGE;
//     };
//
//     Tizen.prototype.getDate = function()
//     {
//         return (new Date());
//     };
//
//     Tizen.prototype.getImageSoftA = function()
//     {
//         return "softKeys/SoftKey_A.png";
//     };
//
//     Tizen.prototype.getImageSoftB = function()
//     {
//         return "softKeys/SoftKey_B.png";
//     };
//
//     Tizen.prototype.getImageSoftC = function()
//     {
//         return "softKeys/SoftKey_C.png";
//     };
//
//     Tizen.prototype.getImageSoftD = function()
//     {
//         return "softKeys/SoftKey_D.png";
//     };

//     Tizen.prototype.getType = function()
//     {
//         return this._type;
//     };

    Tizen.prototype.getPlatformString = function()
    {
       return "tizen";
    };

    Tizen.prototype.getSecClientDeviceType = function()
    {
       return "Samsung2017";
    };

    Tizen.prototype.getVideoPlayerClass = function( ext )
    {
        var retval;

        switch( ext )
        {
           case "mpd":
//                retval = TizenPlayer;
                break;

            default:
                console.log( "ERROR -> no player type for ext = " + ext );
                break;
        }

        return retval;
    };

    Tizen.prototype.init = function( callback )
    {
        this._type = Host.Type.TIZEN;
        var self = this;

        document.body.style.backgroundColor = "#000000";

        var onDeepLink = function( atLaunch )
        {
            console.log( "========== ON DEEP LINK ==========", JSON.stringify( atLaunch ) );

            var appControlData, actionData, actionId;
            
            var tokenAuth = Host.getLocalStorage( "XtvAuthToken" );
            var tokenXsct = Host.getLocalStorage( "XsctToken"    );
            var currentApplication = null;
            try {
                currentApplication = tizen.application.getCurrentApplication();
            } catch ( error ) {
                console.log("No active app in tizen simulator", error );
                if( atLaunch === true || !tokenAuth || !tokenXsct )
                    _x2._tempDefaultScreen = actionId;
                else {
                    //Check authenticate, before the transition screen
                    self.authenticateBeforeTransitionScreen( _x2._config._initialScreen );
                }
            }// if there is no current application, then simulator throws an error and on catch we need to transit the screen
            if ( currentApplication ) {
                console.log("Active app is ", currentApplication.appInfo && currentApplication.appInfo.id );   
                var requestedAppControl = currentApplication.getRequestedAppControl();
                var metrics;
                if( requestedAppControl )
                {
                    appControlData = requestedAppControl.appControl.data;

                    console.log( appControlData );

                    for( var i = 0; i < appControlData.length; i++ )
                    {
                        if( appControlData[i].key == "PAYLOAD" )
                        {
                            actionData = JSON.parse( appControlData[i].value[0] ).values;

                            console.log( actionData );

                            actionId = JSON.parse( actionData ).actionId;

                            if( atLaunch === true || !tokenAuth || !tokenXsct )
                                _x2._tempDefaultScreen = actionId;
                            else
                                switch( actionId )
                                {
                                    case "browse":
                                        _x2.setScreen( new VodRootScreen().init() );
                                        break;

                                    case "live":
                                        _x2.setScreen( new GuideScreen().init() );
                                        break;

                                    case "saved":
                                        _x2.setScreen( new SavedScreen().init() );
                                        break;

                                    case "search":
                                        _x2.setScreen( new SearchScreen().init() );
                                        break;

                                    case "settings":
                                        setTimeout( function() { _x2.setScreen( new SettingsScreen().init() ) }, 100 );
                                        break;

                                    default:
                                        self.authenticateBeforeTransitionScreen( actionId );//Check authenticate, before the transition screen
                                        break;
                                };
                            break;
                        }
                    }
                }
                else
                    console.error( "Could not get app control." );   
            }
        };

        window.addEventListener( "appcontrol", onDeepLink );
        onDeepLink( true );

        tizen.tvinputdevice.registerKey( "0"                  );
        tizen.tvinputdevice.registerKey( "1"                  );
        tizen.tvinputdevice.registerKey( "2"                  );
        tizen.tvinputdevice.registerKey( "3"                  );
        tizen.tvinputdevice.registerKey( "4"                  );
        tizen.tvinputdevice.registerKey( "5"                  );
        tizen.tvinputdevice.registerKey( "6"                  );
        tizen.tvinputdevice.registerKey( "7"                  );
        tizen.tvinputdevice.registerKey( "8"                  );
        tizen.tvinputdevice.registerKey( "9"                  );
        tizen.tvinputdevice.registerKey( "ChannelUp"          );
        tizen.tvinputdevice.registerKey( "ChannelDown"        );
        tizen.tvinputdevice.registerKey( "ColorF0Red"         );
        tizen.tvinputdevice.registerKey( "ColorF1Green"       );
        tizen.tvinputdevice.registerKey( "ColorF2Yellow"      );
        tizen.tvinputdevice.registerKey( "ColorF3Blue"        );
        tizen.tvinputdevice.registerKey( "Exit"               );
        tizen.tvinputdevice.registerKey( "Info"               );
        tizen.tvinputdevice.registerKey( "MediaFastForward"   );
        tizen.tvinputdevice.registerKey( "MediaPause"         );
        tizen.tvinputdevice.registerKey( "MediaPlay"          );
        tizen.tvinputdevice.registerKey( "MediaPlayPause"     );
        tizen.tvinputdevice.registerKey( "MediaRecord"        );
        tizen.tvinputdevice.registerKey( "MediaRewind"        );
        tizen.tvinputdevice.registerKey( "MediaStop"          );
        tizen.tvinputdevice.registerKey( "MediaTrackNext"     );
        tizen.tvinputdevice.registerKey( "MediaTrackPrevious" );
        tizen.tvinputdevice.registerKey( "Minus"              );

        var loadFunction = function()
        {
//            console.log( "WEBAPIS LOADED" );

            var mac = webapis.network.getMac();

//            console.log( "MAC ADDRESS = " + mac );

            mac = (mac)? mac.replace( /:/g, "" ) : '';

//            console.log( "MAC ADDRESS = " + mac );

            _x2._config._mac             = mac;
            _x2._config._host._make      = "Samsung";
            _x2._config._host._model     = webapis.productinfo.getModelCode();
            _x2._config._host._product   = webapis.productinfo.getRealModel();
            _x2._config._host._osName    = "Tizen";
            _x2._config._host._osVersion = webapis.productinfo.getFirmware();

            try
            {
                var connectionType = webapis.network.getActiveConnectionType();
                var type;

                switch( connectionType )
                {
                    case webapis.network.NetworkActiveConnectionType.CELLULAR:
                        type = Host.NetworkType.UNKNOWN;
                        break;

                    case webapis.network.NetworkActiveConnectionType.DISCONNECTED:
                        type = Host.NetworkType.NONE;
                        break;

                    case webapis.network.NetworkActiveConnectionType.ETHERNET:
                        type = Host.NetworkType.WIRED;
                        break;

                    case webapis.network.NetworkActiveConnectionType.WIFI:
                        type = Host.NetworkType.WIFI;

                        try
                        {
                            _x2._config._host.setSsid( webapis.network.getWiFiSsid() );
                        }
                        catch( e )
                        {
                            console.error( e );
                        }
                        break;

                    default:
                        type = Host.NetworkType.UNKNOWN;
                        break;
                }

                _x2._config._host.setNetworkType( type );
            }
            catch( e )
            {
                console.error( e );
            }

            console.log( "FIRMWARE = " + _x2._config._host._osVersion );
            console.log( "NETWORK  = " + _x2._config._host.getNetworkType() + ", " + _x2._config._host.getSsid() );
            console.log( "MODEL    = " + _x2._config._host._model );
            console.log( "PRODUCT  = " + _x2._config._host._product );

            var modelYear = _x2._config._host._model.substring( 0, 2 );

            if( modelYear === "17" )
                _x2._modSpeech = true;

            callback();
        };
        if( window.webapis && _x2._config.isTizenSimulator === true ) {
            loadFunction(); //in tizen simulator, webapis will be available in window variable, so no need to fetch webapis.js
        } else {
            _x2.getScript( "$WEBAPIS/webapis/webapis.js", function(){ loadFunction(); }, function() {
                if( window.webapis ) {
                    loadFunction();
                }
            } );//through smarthub workflow, webapis will be available in window variable
        }
    };

    Tizen.prototype.mapKey = function( event, which )
    {
        var val = event.which;

        switch( val )
        {
            case 13:
                val = Host.KEY_ENTER;
                break;

            case 19:
                val = Host.KEY_PAUSE;
                break;

            case 37:
                val = Host.KEY_LEFT;
                break;

            case 38:
                val = Host.KEY_UP;
                break;

            case 39:
                val = Host.KEY_RIGHT;
                break;

            case 40:
                val = Host.KEY_DOWN;
                break;

            case 48:
                val = Host.KEY_0;
                break;

            case 49:
                val = Host.KEY_1;
                break;

            case 50:
                val = Host.KEY_2;
                break;

            case 51:
                val = Host.KEY_3;
                break;

            case 52:
                val = Host.KEY_4;
                break;

            case 53:
                val = Host.KEY_5;
                break;

            case 54:
                val = Host.KEY_6;
                break;

            case 55:
                val = Host.KEY_7;
                break;

            case 56:
                val = Host.KEY_8;
                break;

            case 57:
                val = Host.KEY_9;
                break;

            case 189:
                val = Host.KEY_HUD;
                break;

            case 403:
                val = Host.KEY_SOFT_A;
                break;

            case 404:
                val = Host.KEY_SOFT_B;
                break;

            case 405:
                val = Host.KEY_SOFT_C;
                break;

            case 406:
                val = Host.KEY_SOFT_D;
                break;

            case 412:
                val = Host.KEY_RW;
                break;

            case 413:
                val = Host.KEY_STOP;
                break;

            case 415:
                val = Host.KEY_PLAY;
                break;

            case 416:
                val = Host.KEY_RECORD;
                break;

            case 417:
                val = Host.KEY_FF;
                break;

            case 427:
                val = Host.KEY_CH_UP;
                break;

            case 428:
                val = Host.KEY_CH_DOWN;
                break;

            case 457:
                val = Host.KEY_INFO;
                break;

            case 10009:
                val = Host.KEY_LAST;
                break;

            case 10182:
                val = Host.KEY_QUIT;
                break;

            case 10252:  // play/pause
                val = Host.KEY_PLAY_PAUSE;
                break;

//             case 10232: // prev track
//                 val = ;
//                 break;

//             case 10233: // next track
//                 val = ;
//                 break;
        }

        return Host.prototype.mapKey.call( this, event, val );
    };

    Tizen.prototype.setScreenSaverActive = function( active )
    {
        if( active === true )
        {
            console.log( "##### ENABLE SCREEN SAVER #########################################" );
            webapis.appcommon.setScreenSaver( webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_ON );
        }
        else if( active === false )
        {
            console.log( "##### DISABLE SCREEN SAVER #########################################" );
            webapis.appcommon.setScreenSaver( webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_OFF );
        }
        else
            console.log( "ERROR -> invalid parameter for setScreenSaverActive = " + active );
    };

    Tizen.prototype.authenticateBeforeTransitionScreen = function( entityId ) {
        entityId = entityId || null;
        if( !_x2._data ) { //wait for few seconds and then transit to screen
            console.log("No data found from api, wait for few seconds");
            window.setTimeout( function() {
                this.transitToScreen( entityId );
            }.bind(this), 3000 );
        } else {
            this.transitToScreen( entityId );
        }
    }

    Tizen.prototype.transitToScreen = function( entityId ) {
        console.log("Transition screen has initiated with entity id - ", entityId, " on ", _x2.getTopScreen()._className );
        if( _x2.getTopScreen() instanceof WelcomeScreen || 
            ( entityId == 'mainMenu' && ( _x2.getTopScreen() instanceof LoadingScreen ) )) {
            return false;
        } else if( entityId == 'mainMenu' ) {
            _x2.setScreen( new MainMenuScreen().init() );
        } else if( entityId ) {
            console.log("Smarthub preview workflow started with entity id", entityId );
            _x2.setScreen( new TransitionScreen().init( {entityId: entityId }));
        }
    }

    return Tizen;

})();


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LruCache = (function()
{
    "use strict";

    function LruCache( maxSize )
    {
console.log( "******************** LruCache CREATED - " + maxSize + " ********************" );
        this._maxSize = maxSize;
        this._size    = 0;
        this._map     = {};
    }

    LruCache.prototype.dump = function()
    {
        console.log( this._map );
        console.log( this._size + " of " + this._maxSize );

        var str = "", curr = this._head;

        str += "head => ";

        while( curr )
        {
            str += curr.obj + " ";

            if( curr._next && curr._next._prev && curr._next._prev === curr )
                str += "<";

            if( curr._next )
                str += "=> ";

            curr = (this._head !== curr._next) ? curr._next : undefined;
        }

        console.log( str );
    };

    LruCache.prototype.get = function( key )
    {
        var retval, entry;

        entry = this.remove( key );

        if( entry )
        {
            retval = entry.obj;

            this.put( key, entry.obj, entry.size );
        }

        return retval;
    };

    LruCache.prototype.put = function( key, obj, size )
    {
        var retval;
        var entry = this._map[key];

        if( entry )
        {
            retval = entry.obj;
            this.remove( key );

            entry.obj  = obj;
            entry.size = size;
        }

console.log( "this._size = " + this._size + ", size = " + size + ", this._maxSize = " + this._maxSize );

        while( (this._size + size > this._maxSize) && this._head )
            this.remove( this._head._prev.key );

        if( entry === undefined )
            entry = { key:key, obj:obj, size:size };

        this._size     += size;
        this._map[key]  = entry;

        if( this._head === undefined )
        {
            this._head = entry;

            entry._prev = entry;
            entry._next = entry;
        }
        else
        {
            entry._next = this._head;
            entry._prev = this._head._prev;

            this._head._prev._next = entry;
            this._head._prev = entry;

            this._head = entry;
        }

        return retval;
    };

    LruCache.prototype.remove = function( key )
    {
        var retval, entry = this._map[key];

        if( entry )
        {
            retval = entry;
            this._size -= entry.size;
            delete this._map[key];

            // single entry remove

            if( entry === entry._next )
            {
                this._head  = undefined;
                entry._prev = undefined;
                entry._next = undefined;
            }
            else
            {
                entry._prev._next = entry._next;
                entry._next._prev = entry._prev;

                if( entry === this._head )
                    this._head = entry._next;
            }
        }
        else
            console.log( "No entry found for - " + key );

        return retval;
    };

    LruCache.prototype.size = function()
    {

    };

    return LruCache;

})();


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

window.MetricsSocket = ( function()
{
    "use strict";

    /**
     * @param {Object} [token                      ] - XSCT token
     * @param {String} [token.tokenSummary.deviceId] -
     * @param {String} [token.serviceAccessToken   ] -
     */
    function MetricsSocket( token )
    {
        this._deviceId = token && token.tokenSummary.deviceId;
        this._protocol = token && token.serviceAccessToken;
        this._queue    = [];
    }

    /**
     * Used for Request Id
     * @returns {number}
     */
    MetricsSocket.prototype.getRandomInt = function()
    {
        return Math.round( Math.random() * 0xffffffff );
    };

    /**
     * @param {Object} obj
     */
    MetricsSocket.prototype.send = function( obj )
    {
        var self = this, data, url;

        var onClose = function(evt)
        {
            console.error( "Metrics Socket: Closed", evt );

            self._socket = undefined;
        };

        var onError = function( evt )
        {
            console.error( "Socket error - " ,  evt );

            self._socket = undefined;
        };

        var onMessage = function( evt )
        {
            console.warn( "Metrics Socket: Unexpected mesage received: " , evt );
        };

        var onOpen = function()
        {
            console.log( "Metrics Socket: Open" );

            self._socket.send( data );
            obj.requestId = undefined;

            while( self._queue.length > 0 )
                self._socket.send( self._queue.shift() );
        };

        if( obj )
        {
            if( obj.requestId === undefined )
                obj.requestId = "requestId" + this.getRandomInt();

            if( obj.ts === undefined )
                obj.ts = Date.now(); // timestamp

            data = JSON.stringify( obj );

            if( !this._socket )
            {
//              url  = "wss://echo.websocket.org";                           // debug
                url  = "wss://metricscollector.lp.xcal.tv:18082";            // prod
//              url  = "wss://metricscollector-ci.lp.xcal.tv:18082";         // dev
                url += "/metrics?client=xstream&deviceId=" + this._deviceId; // common to all
                try {
                    this._socket            = new WebSocket( url, this._protocol );  // dev
                    console.log(this._socket);
                    this._socket.binaryType = "blob";
                    this._socket.onclose    = onClose;
                    this._socket.onerror    = onError;
                    this._socket.onmessage  = onMessage;
                    this._socket.onopen     = onOpen;
                    this._queue.push( data );
                } catch(e) {
                    console.log(e);
                }
            }
            else if( this._socket.readyState === WebSocket.OPEN )
            {
                this._socket.send( data );
                obj.requestId = undefined;
            }
            else if( this._socket.readyState === WebSocket.CONNECTING )
            {
                console.log( "Metrics Socket: STILL CONNECTING" );

                this._queue.push( data );
            }
            else if( this._socket.readyState === WebSocket.CLOSING )
            {
                console.error( "Metrics Socket: Closing!" );
            }
            else
            {
                console.error( "Metrics Socket: In a weird state" );
                console.log( this._socket );
            }
        }
    };

    return MetricsSocket;

})();


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * Usage:
 *     sendGeneralError()
 *     sendVideoAttempt()
 *     sendVideoError()
 *     sendVideoStart()
 *
 * NOTE: Video Player Version is string in this format:
 *     BUILD_TYPE=prod VIPER_VERSION=##.##.## undefined
 *     BUILD_TYPE=prod VIPER_VERSION=##.##.## ##.##.##
 */
window.Splunk = ( function()
{
    "use strict";

    /**
     * Convert a string log message to an object.
     * Example: Converts 'key.1="val1" key2="val2"' to object { "key_1":"val1", "key2":"val2" }
     */
    Splunk.logMessageToObject = function( text )
    {
        var retval = {};
        var beg = 0, mid = text.indexOf( '=' ), end;
        var key, val;

        while( mid > 0 )
        {
            key = text.substring( beg  , mid   );
            end = text.indexOf  ( '"'  , mid+2 );
            val = text.substring( mid+2, end   );
            mid = text.indexOf  ( '='  , end+2 );
            beg = end + 2;
            retval[ key.replace( /\./g, '_' ) ] = val;
        }

        return retval;
    };

    function Splunk( token )
    {
        if( _x2._config )
            _x2._config.debugAddClass( Config.CLASS_SPLUNK, 0 );

        this._ua       = this.userAgentSplit();
        this._browser  = this.userAgentParse( this._ua );

        if( token === undefined )
            this._tokenSum = "";
        else
            this._tokenSum =
            [
                'user.analyticsId="'   + token.tokenSummary.analyticsId             + '"',
                'user.deviceId="'      + token.tokenSummary.deviceId                + '"',
                'user.mso="'           + token.tokenSummary.mso                     + '"',
                'user.partnerId="'     + token.tokenSummary.partnerId               + '"',
                'user.userType="'      + token.tokenSummary.userType                + '"',
                'user.xboAccountId="'  + token.tokenSummary.xboAccountId            + '"',
                'user.account_state="' + token.tokenSummary.accountState            + '"',
                'user.entitlements="'  + token.tokenSummary.entitlements.join(', ') + '"',
                'in_home="'  + (token.tokenSummary.inHomeStatus === 'in-home') + '"'
            ].join( " " );

//      _x2._config.log( Config.CLASS_SPLUNK, 1 ) ? console.log( "Protocol = " + this._protocol ) : Config.NOP();
//      _x2._config.log( Config.CLASS_SPLUNK, 1 ) ? console.log( "inHome = "   + this._inHome   ) : Config.NOP();
    }

    /**
     * @param {Object} entity - LinearShowing, ProgramEntity, Purchase, Recording, etc.
     * @param {Object} mode   - VideoScreen.Mode
     * @returns {String}      - one of Telemetry.VideoType
     */
    Splunk.prototype.getAssetType = function( entity, mode )
    {
        var retval = "Unknown";

        if( entity instanceof Purchase )
            retval = Telemetry.VideoType.PURCHASE;
        else
        {
            switch( mode ) // TVE not yet supported
            {
                case VideoScreen.Mode.DVR : retval = Telemetry.VideoType.RECORDING; break;
                case VideoScreen.Mode.LIVE: retval = Telemetry.VideoType.T6_LINEAR; break;
                case VideoScreen.Mode.VOD : retval = Telemetry.VideoType.T6_VOD   ; break;
            }
        }

        return retval;
    };

    /**
     * @param  {String} module          - "Video", "test"
     * @param  {String} type            - "Attempt", "Start", "Error"
     * @param  {String} [playerVersion] - Video player version, see note above
     * @return {String}                 - Flattened array of strings (key="val") separated by a space each
     */
    Splunk.prototype.getCommonLogMessage = function( module, type, playerVersion )
    {
        var playerVer = playerVersion ? playerVersion.indexOf( "VIPER_VERSION") : 0;
        var retval    =
        [
            'appname="stream-smart_tv"',
            'env="'                + environment.ENV               + '"',
            'user.appVersion="'    + AboutOverlay.version                       + '"',
            'user.userAgent.ua="'  + navigator.userAgent                        + '"'
        ];

        var featureStr = Host.getLocalStorage( "features" );
        var featureObj = featureStr && JSON.parse( featureStr );
        if( featureObj && featureObj.features )
        {
            var aKeys = Object.keys( featureObj.features );
            var nKeys = aKeys.length;
            var iKey;

            for( iKey = 0; iKey < nKeys; iKey++ )
            {
//console.log( "" + iKey + "): " + aKeys[ iKey ] + ": " + featureObj.features[ aKeys[ iKey ] ] );
                retval.push( 'user.features.' + aKeys[ iKey ] + '="' + featureObj.features[ aKeys[ iKey ] ] + '"' );
            }
        }

        if( module )
            retval.push( 'module="' + module + '"' );

        if( type )
            retval.push( 'type="' + type + '"' );

        if( this._browser.browserName && this._browser.browserVers )
        {
            retval.push( 'user.userAgent.browser.name="'    + this._browser.browserName       + '"' );
            retval.push( 'user.userAgent.browser.version="' + this._browser.browserVers       + '"' );
        }

        if( this._browser.browserMaj )
            retval.push( 'user.userAgent.browser.major="'   + this._browser.browserMaj        + '"' );

        if( this._browser.osName )
            retval.push( 'user.userAgent.os.name="'         + this._browser.osName            + '"' );

        if( this._browser.osVers )
            retval.push( 'user.userAgent.os.version="'      + this._browser.osVers            + '"' );

        if( this._browser.browserEngineName )
            retval.push( 'user.userAgent.engine.name="'     + this._browser.browserEngineName + '"' );

        if( this._browser.browserEngineVers )
            retval.push( 'user.userAgent.engine.version="'  + this._browser.browserEngineVers + '"' );
        if( _x2._config._host._product ) {
            var platformInfo = _x2._config._host.getPlatformInfo();
            retval.push( 'user.productInfo="'  + platformInfo.product  +  '"' );
            retval.push( 'user.devicePlatform="'  + platformInfo.product.toLowerCase()  +  '"' );
            retval.push( 'user.modelInfo="'  + platformInfo.model  +  '"' );
        }
        if( playerVer > 0 )
            retval.push( 'user.playerVersion="' + playerVersion.substring( playerVer + 14 ) + '"' ); // NOTE: #.#.# not the full build version description

        return retval.join( " " ) + ' ' + this._tokenSum;
    };

    /**
      * @param {Boolean}          success
      * @param {Entity}           entity
      * @param {TransactionOffer} offer
      * @param {Error}            error - or response
      * @param {Showing}         [showing]
      */
    Splunk.prototype.getTransactLogMessage = function( success, entity, offer, error, showing )
    {
        var purchase  = offer.getPurchaseType(),
            offerType = offer.getOfferType(),
            buyOrRent = (purchase === TransactionOffer.PurchaseType.BUY ? "buy" : "rent"),
            option    = buyOrRent + (offer.isHD() ? " HD" : " SD"),
            isSeason  = (offerType === TransactionOffer.OfferType.SEASON_BUNDLE ),
            series    = isSeason && entity.getSeries && entity.getSeries(),
            progType  = (entity.getType() === XtvApi.EntityType.MOVIE)
                      ? "Single Movie"    // *sigh* Someday this will be standardized across Localytics, Telemetry, and Splunk
                      : isSeason
                          ? "Season Bundle"
                          : "Single Episode",
            title     = isSeason
                          ? series.getTitle()
                          : entity.getTitle(),
            type      = isSeason
                          ? "Series"          // showing.getType() -> "Episode", series.getType() -> "SeriesMaster"
                          : entity.getType(),
            retval    =
            [
                'action="transact"'                              ,
                'transact.button="'      + buyOrRent        + '"',
                'transact.programType="' + progType         + '"',
                'transact.option="'      + option           + '"',
                'transact.price="'       + offer.getPrice() + '"',
                'asset.title="'          + title            + '"',
                'asset.type="'           + type             + '"'
            ];

        if( showing )
        {
            var mediaId = showing.getMediaId   && showing.getMediaId(),
                progId  = showing.getProgramId && showing.getProgramId(),
                stream  = showing.getStreamUrl && showing.getStreamUrl();

            if( mediaId ) retval.push( 'asset.mediaId="'           + showing.getMediaId()   + '"' );
            if( progId  ) retval.push( 'asset.programId="'         + showing.getProgramId() + '"' );
            if( stream  ) retval.push( 'asset.resolvedStreamUrl="' + showing.getStreamUrl() + '"' );
        }

        return retval.join( " " );
    };

    /** Union of Common and Video fields
     * @param {String} [module]           - Defaults to "Video" if not specified
     * @param {String}  type              - "Attempt", "Start", or over-ridden "Error"
     * @param {Object}  entity            - LinearShowing, ProgramEntity, Purchase, Recording, etc.
     * @param {Object}  mode              - VideoScreen.Mode
     * @param {String}  url               - URL of video asset
     * @param {String} [playerVersion]    - Video player version, see note above
     * @param {Number} [msAttemptToStart] - Time from Video Attempt to Video Start
     * @param {number} [duration]         - Video player duration of asset (not required for Linear)
     * @returns {String}                  - Flattened array of strings (key="val") separated by a spaces
     */
    Splunk.prototype.getVideoLogMessage = function( module, type, entity, mode, url, playerVersion, msAttemptToStart, duration )
    {
        var asType = this.getAssetType( entity, mode );
        var format = url
                   ? (url.indexOf( '.m3u8' ) > 0 ? "M3U" : "Unknown")
                   : "Unknown";
        var linear = mode === VideoScreen.Mode.LIVE;
        var retval = this.getCommonLogMessage( module ? module : 'Video', type, playerVersion );
        var stream = entity._data && entity._data._embedded && entity._data._embedded.encodesCreativeWork ? entity._data._embedded.encodesCreativeWork._type : undefined;

        var video  =
        [
            'vsid="'                        + this._vsid        + '"',
            'playerVersion="'               + playerVersion     + '"',
            'asset.type="'                  + asType            + '"',
            'asset.title="'                 + this.getTitleByType(entity) + '"',
            'asset.resolvedStreamUrl="'     + url               + '"',
            'asset.stream.encodingFormat="' + format            + '"',
            'isDownload="false"'
        ];
        if( entity.getChannel && entity.getChannel() && entity.getChannel().getStreamId() ) // linear
            video.push( 'asset.stream.streamId="' + entity.getChannel().getStreamId() + '"' );

        if( !stream ) // TODO: Always use???
            stream = entity._data && entity._data._type;

        if( stream )
            video.push( 'asset.stream._type="' + stream + '"' );

        if( entity.getMediaId && entity.getMediaId() )
            video.push( 'asset.mediaId="' + entity.getMediaId() + '"' );

        if( msAttemptToStart !== undefined )
            video.push( 'videoStartTime="' + msAttemptToStart + '"' );

        if( !linear )
        {
            var entityDuration = entity.getDurationMs && entity.getDurationMs();
            if( entityDuration && (duration > entityDuration) )
                duration = entityDuration;

            if( entityDuration !== undefined ) video.push( 'asset.totalDuration="'    + Math.floor(entityDuration / 1000) + '"' );
            if( duration                     ) video.push( 'asset.timelineDuration="' + Math.floor(duration       / 1000) + '"' );
        }

        retval += ' ' + video.join( " " );

//console.log( retval );
        return retval;
    };

    /*** This is unique per playback attempt
     * @return {String}
     */
    Splunk.prototype.getVSID = function()
    {
        var now       = Date.now(), rnd, dig;
        var onReplace = function( c )
        {
            rnd = (now + Math.random() * 16) % 16 | 0;
            now = Math.floor( now / 16 );
            dig = (c === 'x') ? rnd : (rnd & 0x3 | 0x8);

            return dig.toString( 16 );
        };

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, onReplace );
    };

    /**
     * @param {Boolean}         success
     * @param {String}          api - such as "getChannelMap", "transact", etc.
     * @param {Object|ApiError} response
     */
    Splunk.prototype.getXtvApiLogMessage = function( success, api, response )
    {
        var retval = this.getCommonLogMessage( "XTVAPI", success ? "Success" : "Error", undefined ) + " " +
            [
                'serviceName="'    + api                          + '"',
                'httpStatusCode="' + response.statusCode          + '"',
                'responseTime="'   + response.responseTimeNetwork + '"',
                'endpoint="'       + response.path                + '"'
            ].join(" ");

        return retval;
    };

    /** Make a Splunk object ready for send()
     * @param {String} logMessage - syntax is '<key>="<val1>" <key2>="<val2>" ...'
     * @return {Object}
     */
    Splunk.prototype.makeEvent = function( logMessage )
    {
        var retval =
        {
            "splunkEvent": // subSourceType and logLevel will be added when send() is called
            {
                "logMessage": logMessage
            }
        };

        return retval;
    };

    /**
     * Normally called by XtvApi.get() when the promise if resolved or rejected
     * @param {Boolean}  success
     * @param {String}   api
     * @param {Object}   responseOrError  - Network.ajax response or ApiError: must have fields 'path', 'responseTimeMS', and 'statusCode'
     * @param {Object}  [params]          - passed when called by sendTransact
     * @param {Object}  [transformedData] - used by getChannelMap
     */
    Splunk.prototype.onXtvApi = function( success, api, responseOrError, params, transformedData )
    {
        var log;

        if( api === undefined || responseOrError === undefined )
            return;

        if( api === "getChannelMap" )
        {
/*
            var channel = 0, entitled = 0, total = 0, valid = (transformedData !== undefined) && Array.isArray( transformedData );
            log = this.getXtvApiLogMessage( success, api, responseOrError );

            if( valid )
            {
                total = transformedData.length;
                for( ; channel < transformedData.length; channel++ )
                    entitled += (transformedData[channel].isEntitled() | 0);
            }

            log += " " +
            [
                'channels.total="'      + total              + '"',
                'channels.entitled="'   + entitled           + '"',
                'channels.unentitled="' + (total - entitled) + '"',
                'channels.diff="0"'
            ].join(" ");

            this.send( this.makeEvent( log ) )
*/;
        }
        else if( api === "transact" )
        {
            log = this.getXtvApiLogMessage( success, api, responseOrError ) + " "
                + this.getTransactLogMessage( success, params.entity, params.offer, responseOrError, params.showing );

            this.send( this.makeEvent( log ) );
        }
    };

    Splunk.prototype.parseOSVersion = function( offset )
    {
        var retval;
        var text = this._ua.comment_0;
        var i, n = text && text.length;
        var state = 0;

        for( i = offset; i < n; i++ )
        {
            switch( state )
            {
                case 0: // while( !digit )
                    if( (text[ i ] >= '0') && (text[ i ] <= '9') )
                    {
                        retval = text[ i ];
                        state  = 1; // found digit
                    }
                    else if( text[i] === ')' ) // couldn't find version
                        state = 2;
                    break;
                case 1: // while( digit )
                    if( (text[ i ] >= '0') && (text[ i ] <= '9') )
                        retval += text[ i ];
                    else if( (text[ i ] === '.') || (text[ i ] === '_') )
                        retval += '.';
                    else
                        state = 2; // end of version
                    break;
                case 2:
                    i = n;
                    break;
            }
        }

        return retval;
    };

    Splunk.prototype.send = function( obj )
    {
        if( _x2._isSplunkLogging && obj )
        {
            if( obj.lType === undefined )
                obj.lType = "SPLUNK";

            if( obj.mType === undefined )
                obj.mType = "xstream.SPLUNK_LOG";

            if( obj.splunkEvent === undefined )
                obj.splunkEvent = {};

            if( obj.splunkEvent && obj.splunkEvent.subSourceType === undefined )
                obj.splunkEvent.subSourceType = "xstream-smart_tv";

            if( obj.splunkEvent && obj.splunkEvent.logLevel === undefined )
                obj.splunkEvent.logLevel = "WARN"; // Note: needs to be WARN or higher

            if( obj.splunkEvent && obj.splunkEvent.logMessage === undefined )
                obj.splunkEvent.logMessage = "ERROR: Missing Log Message";
            _x2._metricsSocket.send( obj );
        }
    };

    /**
     * Log a general error to Splunk
     * @param {String}  errorDesc  - description of the error
     * @param {String} [errorCode] - TVAPP-###### such as TVAPP-00100
     */
    Splunk.prototype.sendGeneralError = function( errorDesc, errorCode )
    {
        var screen = _x2.findScreen( VideoScreen );
        var common = screen && screen._entity
                   ? this.getVideoLogMessage( "Diagnostic", "VideoPlayer", screen._entity, screen._mode, screen._url, undefined, undefined, undefined )
                   : this.getCommonLogMessage( "General", "Error", undefined )
                   ;
        var extra  =
        [
            'error.level="' + (screen === undefined ? 'fatal' : 'warn') + '"',
            'error.msg="'   + errorDesc                                 + '"'
        ];

        if( errorCode )
            extra.push( 'error.code="' + errorCode + '"' );

        if( screen )
        {
            extra.push( 'traceMessage="Video Exception"' );
            extra.push( 'videoCurrentPosition="' + screen._current  + '"' ); // Don't typecast to number as undefined is valid -- stream hasn't started
            extra.push( 'videoAttempts="'        + screen._attempts + '"' ); // Ditto.
        }

        var multiLine = errorDesc.indexOf( '\n' ); // Stack trace has multiple lines
        if( multiLine > 0 )
        {
            var summary = errorDesc.substr( 0, multiLine );
            extra.push( 'error.reason="' + summary + '"' );
        }

        extra.push( 'error.appurl="' + window.location.href + '"' );

        var log = common + ' ' + extra.join(" ");

        this.send( this.makeEvent( log ) );
    };

    /**
     * Send on the result of an XTVAPI 'transact'
     * @see TransactionOffer.executeTransaction()
     * @param {Boolean}          success - whether the XTV API transact call was successful or not
     * @param {Entity}           entity
     * @param {TransactionOffer} offer
     * @param {Object}          [responseOrError] - ApiError or response
     */
    Splunk.prototype.sendTransact = function( success, entity, offer, responseOrError )
    {
        var self = this,
            onShowing = function( response )
            {
                var showing = new VodShowing().init( JSON.parse( response.data ) );
                self.onXtvApi( success, "transact", responseOrError, { entity:entity, offer:offer, showing:showing }, undefined );
            };

        if( offer )
            offer.getLinkObject("featureAsset").resolve().then( onShowing );
    };

    /**
     * Generates VSID and sends Video Attempt
     * @param {Object}  entity         - LinearShowing, ProgramEntity, Purchase, Recording, etc.
     * @param {Object}  mode           - VideoScreen.Mode
     * @param {String}  url            - URL of asset
     * @param {String} [playerVersion] - Video player version, see note above
     * @param {number} [duration]      - Video player duration of asset (not required for Linear)
     */
    Splunk.prototype.sendVideoAttempt = function( entity, mode, url, playerVersion, duration )
    {
        this._vsid = this.getVSID();

        var log = this.getVideoLogMessage( 'Video', 'Attempt', entity, mode, url, playerVersion, undefined, duration );
        this.send( this.makeEvent( log ) );
    };

    /**
     * @param {Object}  entity            - LinearShowing, ProgramEntity, Purchase, Recording, etc.
     * @param {Object}  mode              - VideoScreen.Mode
     * @param {String}  url               - URL of asset
     * @param {String} [playerVersion]    - Video player version, see note above
     * @param {number} [msAttemptToStart] - Time from Video Attempt to Video Start
     * @param {number} [duration]         - Video player duration of asset (not required for Linear)
     */
    Splunk.prototype.sendVideoStart = function( entity, mode, url, playerVersion, msAttemptToStart, duration )
    {
        var log = this.getVideoLogMessage( 'Video', 'Start', entity, mode, url, playerVersion, msAttemptToStart, duration );
        this.send( this.makeEvent( log ) );
    };

    /**
     * @param {Object}  entity         - LinearShowing, ProgramEntity, Purchase, Recording, etc.
     * @param {String}  errorCode      - "TVAPP-#####"
     * @param {String}  errorDesc      - Description of the error
     * @param {String}  errorMajor     - major code for the error
     * @param {String}  errorMinor     - minor code for the error
     * @param {Object}  mode           - VideoScreen.Mode
     * @param {String}  url            - URL of asset
     * @param {String} [playerVersion] - Video player version, see note above
     * @param {number} [duration]      - Video player duration of asset (not required for Linear)
     */
    Splunk.prototype.sendVideoError = function( entity, errorCode, errorDesc, errorMajor, errorMinor, mode, url, playerVersion, duration )
    {
        if( typeof errorMajor === "number" )
            errorMajor = errorMajor.toString();

        var video = this.getVideoLogMessage( 'Video', 'Error', entity, mode, url, playerVersion, undefined, duration );
        var split = errorMajor ? errorMajor.indexOf( '.' ) : 0; // VideoScreen.onMediaFailed() can call us without a valid major error code
        var major = split > 0 ? errorMajor.substring(       0, split             )                                        : errorMajor;
        var minor = split > 0 ? errorMajor.substring( split+1, errorMajor.length ) + (errorMinor ? "." + errorMinor : '') : errorMinor ? errorMinor : "0";
        // 'TVAPP-00417' - notEntitledToVOD
        // 'TVAPP-00401' -  notEntitledToStation
        errorCode = (errorCode === 'TVAPP-00401')? 'TVAPP-00417' : errorCode;
        var errorLevel = (errorCode === 'TVAPP-00417') ? 'warn' : 'fatal';
        var error =
        [
            'error.level="' + errorLevel + '"',
            'error.code="'  + errorCode  + '"',
            'error.msg="'   + errorDesc  + '"'
        ];

        if( errorMajor !== undefined )
        {
            error.push( 'error.major="' + major + '"' );
            error.push( 'error.minor="' + minor + '"' );
        }

        var log = video + ' ' + error.join(" ");
        this.send( this.makeEvent( log ) );
    };
    /**
     * Splunk log to send provision failure error
     * @param {*} traceObj 
     * @param {*} errorCode
     */
    Splunk.prototype.sendProvisionError = function( errorCode, traceObj ) {
        var common = this.getCommonLogMessage( "Diagnostic", "ProvisionError", undefined );
        var extra  =
        [
            'error.level="warn"',
            'error.msg="Provision not completed."'
        ];

        if( errorCode )
            extra.push( 'error.code="' + errorCode + '"' );
        if( traceObj )
            extra.push( 'error.traceObj="' + JSON.stringify(traceObj) + '"')

        extra.push( 'error.appurl="' + window.location.href + '"' );

        var log = common + ' ' + extra.join(" ");

        this.send( this.makeEvent( log ) );
    }
    /**
     * Splunk log to send provision success
     * @param {*} userObj
     */
    Splunk.prototype.sendProvisionSuccess = function(userInfo) {
        var common = this.getCommonLogMessage( "Diagnostic", "ProvisionSuccess", undefined );
        var extra  =
        [
            'user.accountInfo="'+ JSON.stringify(userInfo) + '"',
            'in_home="' + (userInfo.inHomeStatus === 'in-home') + '"'
        ];

        var log = common + ' ' + extra.join(" ");

        this.send( this.makeEvent( log ) );
    }
    /**
     * Splunk log for head up messages in 2017 models
     */
    Splunk.prototype.sendScreenViewedEvent = function(screenName) {
        var common = this.getCommonLogMessage( "AppMetrics", "screen_viewed", undefined );
        var extra  =
        [
            'screen="'+ screenName + '"',
            'appUrl="' + window.location.href + '"'
        ];

        var log = common + ' ' + extra.join(" ");

        this.send( this.makeEvent( log ) );
    }
    /**
     * Map the Browser's User Agent object into an Splunk format friendly object
     * @param {Object} ua - Object of key/val's from the user agent
     * @returns {Object}
     * @see userAgentParse() userAgentSplit()
     */
    Splunk.prototype.userAgentParse = function( ua )
    {
        var retval = {}, i;

        if( ua )
        {
            if( ua.Chrome )
            {
                retval.browserName = 'Chrome';
                retval.browserVers = ua.Chrome;
            }
            else if( ua.Firefox )
            {
                retval.browserName = 'Firefox';
                retval.browserVers = ua.Firefox;
            }
            else if( ua.Safari )
            {
                retval.browserName = 'Safari';
                retval.browserVers = ua.Safari;
            }

            if( retval.browserVers )
                retval.browserMaj = parseInt( retval.browserVers );

            if( ua.comment_0 )
            {
                if(      (i = ua.comment_0.indexOf( 'Mac OS X' )) !== -1 ) retval.osName = 'Mac OS';
                else if( (i = ua.comment_0.indexOf( 'Android'  )) !== -1 ) retval.osName = 'Android';
                else if( (i = ua.comment_0.indexOf( 'iPhone'   )) !== -1 ) retval.osName = 'iOS';
                else if( (i = ua.comment_0.indexOf( 'Windows'  )) !== -1 ) retval.osName = 'Windows';

                if( retval.osName )
                    retval.osVers = this.parseOSVersion( i );
            }

            if( ua.AppleWebKit )
            {
                retval.browserEngineName = 'WebKit';
                retval.browserEngineVers = ua.AppleWebKit;
            }
            else
            if( ua.Gecko )
            {
                retval.browserEngineName = 'Gecko';
                retval.browserEngineVers = ua.Gecko;
            }
        }

        return retval;
    };

    /**
     * Split a Browser's User Agent string (navigator.userAgent) into an object.
     * The UA string is in the form:
     *     "key1/val1 (optional) key2/val2 (optional2) ..."
     * The resultant object may include fields as:
     * {
     *    Chrome: "#.#.#.#"
     *    Mozilla: "#.#"
     *    _comments: n
     *    comment_1: "(Macintosh; Intel Mac OS X 10_13_4)"
     *     :
     *    comment_n: "(KHTML, like Gecko)"
     * }
     * @returns {Object}
     * @see userAgentParse() userAgentSplit()
     */
    Splunk.prototype.userAgentSplit = function()
    {
        // RFC2616 Spec
        //   https://www.ietf.org/rfc/rfc2616.txt
        // Examples:
        //   https://deviceatlas.com/blog/list-of-user-agent-strings
        // TL:DR;
        //   key/val: <text>/<text>
        //   comment: ( ... )
        //
        //     sep             end
        //     v               v
        // key1/val1 (optional) key2...
        //           ^        ^
        //           idx      end
        var retval = {};
        var ua = navigator ? navigator.userAgent : "";
        var idx, end, sep, key, val, len = ua.length, comment = 0;

        for( idx = 0; idx < len; idx++ )
        {
            key = undefined;

            if( ua[ idx ] === '(' )
            {
                end = ua.indexOf( ')', idx+1 ) + 1;
                key = 'comment_' + comment++;
                val = ua.substring( idx, end );
            }
            else
            {
                sep = ua.indexOf( '/', idx );
                end = ua.indexOf( ' ', idx );

                if( end < 0 )
                    end = len;

                key = ua.substring( idx  , sep );
                val = ua.substring( sep+1, end );
            }

            if( end > 0 )
            {
                idx = end;
                if( key )
                    retval[key] = val;
            }
        }

        retval._comments = comment;
        return retval;
    };
    /**
     *  In splunk log the title for episode should be sent in below format
     *  - "Outlander S5 Ep8 - Famous Last Words" (TV Show name + Sesson # Episode # + - + Episode name)
     *  - For other video type, this should sent as it from getTitle()
     */
    Splunk.prototype.getTitleByType = function(entity) {
        var title = '';
        if( entity.getType() == 'Episode' ) {
            var program = entity.getProgram();
            if( program ) {
                var series = program.getSeries();
                title += series.getTitle();
                title += ' S' + program.getSeasonNumber();
                title += ' Ep' + program.getEpisodeNumber();
                title += ' - ' + entity.getTitle();
            }
        }
        if( title == '') {
            title = entity.getTitle();
        }
        return title;
    }

    return Splunk;

})();



/***/ }),
/* 65 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * Language Strings
 */
window.Strings = (function()
{
    "use strict";

    Strings.Language =
    {
        ENGLISH : 0,
        SPANISH : 1
    };

    Strings.Glyphs = Object.freeze
    ({
        "ALERT"         : "\uf035",
        "CC"            : "\uf028",
        "CHECK"         : "\uf031",
        "CHEV_LEFT"     : "\uf069",
        "CHEV_RIGHT"    : "\uf06a",
        "DOLBY"         : "\uf02c",
        "DOLBY51"       : "\uf02d",
        "DOLBYA"        : "\uf02e",
        "DOWNLOAD"      : "\uf03a",
        "DV"            : "\uf02b",
        "ESP"           : "\uf02a",
        "G"             : "\uf007",
        "HD"            : "\uf024",
        "HEART"         : "\uf033",
        "KEY"           : "\uf032",
        "LOCKED"        : "\uf030",
        "NC-17"         : "\uf00b",
        "NR"            : "\uf00c",
        "PG"            : "\uf008",
        "PG-13"         : "\uf009",
        "R"             : "\uf00a",
        "RECORD"        : "\uf03d",
        "RECORD_CANCEL" : "\uf03f",
        "SAP"           : "\uf029",
        "SD"            : "\uf023",
        "SERIES"        : "\uf03e",
        "SERIES_CANCEL" : "\uf040",
        "STAR"          : "\uf034",
        "TV-14"         : "\uf004",
        "TV-G"          : "\uf002",
        "TV-MA"         : "\uf005",
        "TV-NR"         : "\uf006",
        "TV-PG"         : "\uf003",
        "TV-Y"          : "\uf000",
        "TV-Y7"         : "\uf001",
        "UHD"           : "\uf025",
        "UNLOCKED"      : "\uf02f"
    });

    function Strings(){}

    /**
     * @memberof Strings
     * @param {String} language
     * @returns {Promise}
     */
    Strings.prototype.load = function( language )
    {
        var params = {}, resolver, loading = Strings.Language.ENGLISH, loaded, key;

        resolver = function( resolve, reject )
        {
            var success, error;

            success = function( response )
            {
                var data = JSON.parse( response.data ), keys, val, partner, i;

                if( language === loading )
                {
                    if( loaded )
                    {
                        keys = Object.keys(data);

                        for( i = 0; i < keys.length; i++ )
                        {
                            key = keys[i];
                            loaded[key] = data[key];
                        }

                        data = loaded;
                    }

                    // strings that are partner specific have an object of partner mappings instead of a string in the string table
                    // reduce to a string using the partner as a the key to the object

                    partner = _x2._config._partner;
                    keys    = Object.keys(data);

                    for( i = 0; i < keys.length; i++ )
                    {
                        val = data[keys[i]];

                        if( typeof( val ) === "object" )
                            data[keys[i]] = val[partner] ? val[partner] : val["Comcast"];
                    }

                    resolve( data );
                }
                else
                {
                    loaded     = data;
                    loading    = language;
                    params.url = mapUrl( language );

                    _x2._network.ajax( params ).then( success ).catch( error );
                }
            };

            error = function( error )
            {
                reject( { error:error, data:loaded } );
            };

            // always load english as a base

            params.type    = "GET";
            params.url     = _x2._config._english;
            params.accepts = Network.Accepts.json;

            _x2._network.ajax( params ).then( success ).catch( error );
        };

        return new Promise( resolver );
    };

    function mapUrl( language )
    {
        var retval;

        switch( language )
        {
            case Strings.Language.ENGLISH:
                retval = _x2._config._english;
                break;

            case Strings.Language.SPANISH:
                retval = _x2._config._spanish;
                break;

            default:
                console.log( "ERROR -> unable to map language to a data file, language = " + language );
                break;
        }

        return retval;
    }

    return Strings;

})();


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * StringWidget text properties
 */
window.Style = (function()
{
    "use strict";

    function Style( object )
    {
        this._object = (object !== undefined) ? object : {};
    }

    /**
     * @memberof Style
     * @param {Number} res - Vertical resolution: 480, 540, 720, or 1080
     */
    Style.initClassVariables = function( res )
    {
        Style._safeBottom = [  17,  19,  45,  68 ][res];
        Style._safeLeft   = [  35,  53,  70, 105 ][res];
        Style._safeRight  = [  35,  53,  70, 105 ][res];
        Style._safeTop    = [  17,  19,  45,  68 ][res];
        Style._pad        = [   4,   4,   6,   9 ][res];

        Style._pillFile   = [ "", "", "pill_28_28_28_28.png"  , "pill_42_42_42_42"       ][res];
        Style._pillHiFile = [ "", "", "pillHi_30_30_28_28.png", "pillHi_45_45_42_42.png" ][res];
    };

    /**
     * @memberof Style
     * @param {Widget} target
     */
    Style.prototype.apply = function( target )
    {
        var key, keys, i, val;

        if( this._object )
        {
            keys = Object.keys(this._object);

            for( i = 0; i < keys.length; i++ )
            {
                key = keys[i];
                val = this._object[key];

                switch( key )
                {
                    case "a":
                    case "alpha":
                        target.setVal( Widget.ALPHA, val );
                        break;

                    case "color":
                        target.setVal( Widget.FONT_COLOR, val );
                        break;

                    case "colorHi":
                        target.setVal( Widget.FONT_COLOR_HI, val );
                        break;

                    case "font":
                        target.setVal( Widget.FONT, val );
                        break;

                    case "fontSize":
                        val = parseInt( val * _x2._config._text );
                        target.setVal( Widget.FONT_SIZE, val );
                        break;

                    case "overflow":
                        target._overflow = val;
                        break;

                    case "textAlign":
                        target.setVal( Widget.TEXT_ALIGN, val );
                        break;

                    case "textOverflow":
                        target._textOverflow = val;
                        break;

                    case "whiteSpace":
                        target.setVal( Widget.TEXT_WHITE_SPACE, val );
                        break;

                    case "width":
//                            target.style.width = val + "px";
                        break;

                    default:
                        console.log( "ERROR -> unknown style type = " + key );
                        break;
                }
            }
        }
    };

    return Style;

})();


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.Telemetry = ( function()
{
    "use strict";

    Telemetry.VideoType = Object.freeze
    ({
        CBS       :"CBS",
        DISNEY    :"Disney",
        ESPN      :"ESPN",
        HULU      :"Hulu",
        NBC       :"nbc",
        PURCHASE  :"PURCHASE",
        RECORDING :"RECORDING",
        T6_LINEAR :"T6 LINEAR",
        T6_VOD    :"T6 VOD",
        TVE_LINEAR:"TVE LINEAR",
        TVE_VOD   :"TVE VOD",
        NONE      :"Non Player", // ACTIVE_SESSION
        NA        :"NA"          // ERRORS_METRIC
    });

    /**
     * @param {String} inHome = token.tokenSummary.inHomeStatus
     */
    function Telemetry( inHome )
    {
        var self = this;

        _x2._config.debugAddClass( Config.CLASS_TELEMETRY, 0 );

        var metricsTimer = function()
        {
            if( self._metricsLastScreen )
            {
//              self._metricsLastScreen.ts = Date.now();
                self.send( self._metricsLastScreen );
            }
        };

        this._inHome = inHome;

        this.setVideoType();
        this.watchPathReset();

        _x2.addChangeCallback( metricsTimer );
    }

    Telemetry.prototype.errorPlayerVersion = function( functionName )
    {
        console.error( functionName + " player version not specified" );
    };

    Telemetry.prototype.errorVideoType = function( functionName )
    {
        console.error( functionName + " player video type not specified" );
    };

    Telemetry.prototype.getWatchButtonFullPath = function()
    {
        var retval = this._watchButtonSource;

        if( this._watchButtonPath && this._watchButtonPath.length )
        {
            retval = this._watchButtonPath.join( ": " );

            if( this._watchButtonSource )
                retval += ": " + this._watchButtonSource;
        }

        return retval;
    };

    /**
     * @see sendWatchButtonClicked(), setWatchButtonSource()
     */
    Telemetry.prototype.getWatchButtonSource = function()
    {
        return this._watchButtonSource;
    };

    Telemetry.prototype.send = function( obj )
    {
        if( obj )
        {
            if( obj.lType === undefined )
                obj.lType = "SMART";

            // Every obj should have smartEvent.parameters set
            if( obj.smartEvent.subSourceType === undefined )
                obj.smartEvent.subSourceType =
                [
                    "subSourceType",
                    "smart-tv"
                ];

            _x2._metricsSocket.send( obj );
        }
    };

    /**
     * @param {Widget}  widget
     * NOTE: setVideoType() must be called prior
     */
    Telemetry.prototype.sendActiveSession = function( widget )
    {
        var name = widget._telemetryName;

        if( name )
        {
            this._metricsLastScreen =
            {
                mType     : "xstream.ACTIVE_SESSION",
                smartEvent:
                {
                    parameters:
                    [
                        this._inHome,        // Key: inHomeStatus: "in-home" "out-of-home"
                        this._videoType,     // Key: playerVideoType: See Telemetry.VideoType
                        AboutOverlay.version // Key: appVersion: x.y.z.w
                    ]
                },
                ts: Date.now()
            };

            _x2._config.log( Config.CLASS_TELEMETRY, 9 ) ? console.log( this._metricsLastScreen ) : Config.NOP();
        }
        else
        {
            var whitelist = [ "Screen" ], warn = widget._className.indexOf( "TestScreen" ) < 0, i = 0;

            for( ; i < whitelist.length; i++ )
                if( warn && widget && widget._className && (widget._className === whitelist[ i ]))
                    warn = false;
            if( warn )
                console.warn( "Missing telemetry name for " + (widget && widget._className) );
        }
        _x2.localyticsSetAppVersionAndDeviceModel();
    };

    /**
     * @param {String             } category        -- AUTHENTICATION, VIDEO, XTVAPI
     * @param {String             } errorCode
     * @param {Boolean            } isUserFacing
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, etc.
     * NOTE: If no video is playing `NA`
     */
     Telemetry.prototype.sendErrorsMetric = function( category, errorCode, isUserFacing, playerVideoType )
     {
         if( playerVideoType === undefined )
            return;

         if( playerVideoType === Telemetry.VideoType.NONE )
             playerVideoType = Telemetry.VideoType.NA;

         var obj =
         {
             mType     : "xstream.ERRORS_METRIC",
             smartEvent:
             {
                 parameters:
                 [
                     category,
                     errorCode,
                     isUserFacing,
                     playerVideoType
                 ]
             }
         };

         this.send( obj )
     };

    /*
     * @param {Number} seconds -- how long provisioning took
     * @param {String} type    -- "Silent" or "New Login"
     */
    Telemetry.prototype.sendProvisioning = function( seconds, type )
    {
        if( seconds === undefined )
            return;

        if( type === undefined )
            return;

        var obj =
        {
            mType     : "xstream.PROVISIONING",
            smartEvent:
            {
                parameters:
                [
                    seconds, // Key: seconds
                    type     // key: provisionType
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry PROVISIONING: %o", obj ) : Config.NOP();
        this.send( obj );
    };

    /**
     * @param {Number }  milliseconds -- Time taken to load
     * @param {String }  source       -- "Live TV: All Channels", etc.
     * @param {Boolean} [cached]
     */
    Telemetry.prototype.sendScreenLoadTime = function( milliseconds, source, cached )
    {
        if( milliseconds === undefined )
            return;

        if( source === undefined )
            return;

        if( cached === undefined )
            cached = false;

        var obj =
        {
            mType     : "xstream.SCREEN_LOAD_TIME",
            smartEvent:
            {
                parameters:
                [
                    milliseconds, // Key: Milliseconds
                    source,       // key: Screen
                    cached        // key: Cached
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry SCREEN_LOAD_TIME: %o", obj ) : Config.NOP();

        this.send( obj );
    };

    /*
     * @param {String} source -- "Live TV: All Channels", etc.
     */
    Telemetry.prototype.sendScreenViewed = function( source )
    {
        if( source === undefined )
            return;

        var obj =
        {
            mType     : "xstream.SCREEN_VIEWED",
            smartEvent:
            {
                parameters:
                [
                    source // key: Screen Name
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry SCREEN_VIEWED: %o", obj ) : Config.NOP();

        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType
     */
    Telemetry.prototype.sendVideoAttempt = function( playerVideoType, playerVersion )
    {
        if( playerVideoType === undefined )
        {
            console.error( "sendVideoAttempt() player video type was not specified" );
            return;
        }

        if( playerVersion === undefined )
        {
            console.error( "sendVideoAttempt() player version unknown" );
            return;
        }

        var obj =
        {
            mType    : "xstream.VIDEO_ATTEMPT",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType, // Key: playerVideoType
                    playerVersion    // Key: playerVersion
//                  streamProvider   // Key: streamProvider
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 6 ) ? console.log( "Telemetry VIDEO_ATTEMPT: %o", obj ) : Config.NOP();
        this.send( obj );
    };

    /**
     * @param {Boolean            } success         -- false = DENOMINATOR, true = NUMERATOR
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * NOTE: You MUST send the DENOMINATOR first, before sending a NUMERATOR in order to keep the fraction values <= 1
     */
    Telemetry.prototype.sendVideoAttemptSuccess = function( success, playerVideoType )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoAttemptSuccess()" );

        var obj =
        {
            mType     : "xstream.VIDEO_ATTEMPT_SUCCESS_PERCENT", // dev: VASP_COAM_TEST
            smartEvent:
            {
                parameters: []
            },
            ts: Date.now()
        };

        obj.smartEvent.parameters[1] = "retired"; // isMidstream is deprecated
        obj.smartEvent.parameters[2] = playerVideoType;
        obj.smartEvent.parameters[3] = false;     // linearFreewheelsAds
        obj.smartEvent.parameters[4] = "NONE";    // adTypeServer is Android only

        if( success )
        {
            obj.requestId                = this._lastRequestId;
            obj.smartEvent.parameters[0] = "NUMERATOR";
            obj.ts                       = this._lastVaspTimestamp;
        }
        else
        {
            obj.requestId                = this._lastRequestId = "requestId" + _x2._metricsSocket.getRandomInt();
            obj.smartEvent.parameters[0] = "DENOMINATOR";
            this._lastVaspTimestamp      = obj.ts; // NOTE: Denominator is always sent first.  We cache and re-use the same timestamp so that the Numerator ends up in correct bucket
        }

        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {Boolean            } isRetry
     * @param {Boolean            } isMidstream
     */
    Telemetry.prototype.sendVideoBufferComplete = function( playerVideoType, isRetry, isMidstream, isUserControlled )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoBufferComplete()" );

        var obj =
        {
            mType     : "xstream.VIDEO_BUFFER_COMPLETE",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType,
                    isRetry,
                    isMidstream,
                    isUserControlled
                ]
            }
        };

        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {Boolean            } isRetry
     * @param {Boolean            } isMidstream
     */
    Telemetry.prototype.sendVideoBufferStart = function( playerVideoType, isRetry, isMidstream, isUserControlled )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoBufferStart()" );

        var obj =
        {
            mType     : "xstream.VIDEO_BUFFER_START",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType,
                    isRetry,
                    isMidstream,
                    isUserControlled
                ]
            }
        };

        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     */
    Telemetry.prototype.sendVideoEnd = function( playerVideoType, playerVersion )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoEnd()" );

        if( playerVersion === undefined )
            return this.errorPlayerVersion( "sendVideoEnd()" );

        var obj =
        {
            mType     : "xstream.VIDEO_END",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType, // Key: playerVideoType
                    playerVersion    // Key: playerVersion
//                  streamProvider   // Key: streamProvider
                ]
            }
        };

        this.send( obj );
    };

    /**
     * @param {String} errorCodeMajor   -- i.e. "10.1" or "NA"
     * @param {String} errorCodeMinor   -- i.e. "412"
     * @param {String} errorDescription --
     * @param {Telemetry.VideoType} playerVideoType  -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {Boolean} isUserFacing
     */
    Telemetry.prototype.sendVideoError = function( errorCodeMajor, errorCodeMinor, errorDescription, playerVideoType, isUserFacing )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoError()" );

        var obj  =
        {
            mType     : "xstream.VIDEO_ERROR",
            smartEvent:
            {
                parameters:
                [
                    errorCodeMajor,
                    errorCodeMinor,
                    errorDescription,
                    playerVideoType,
                    isUserFacing
                ]
            }
        };

        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType  -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {Boolean            } isRetry
     * @param {Boolean            } isMidstream
     * @param {Boolean            } isUserControlled
     * @param {Boolean            } toBeginning
     */
    Telemetry.prototype.sendVideoJumpback = function( playerVideoType, isRetry, isMidstream, isUserControlled, toBeginning )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoJumpback()" );

        var obj  =
        {
            mType     : "xstream.VIDEO_JUMPBACK",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType,
                    isRetry,
                    isMidstream,
                    isUserControlled,
                    toBeginning
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry VIDEO_JUMPBACK: %o", obj ) : Config.NOP();
        this.send( obj );
    };

    /* Time from VIDEO_ATTEMPT to VIDEO_START
     * @param {Number             } milliseconds
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {String             } playerVersion   -- see ViperPlayerPlatform getVersion()
     */
    Telemetry.prototype.sendVideoLatency = function( milliseconds, playerVideoType, playerVersion )
    {
        if( milliseconds === undefined )
            return console.error( "sendVideoLatency() milliseconds not specified" );

        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoLatency()" );

        if( playerVersion === undefined )
            return this.errorPlayerVersion( "sendVideoLatency()" );

        var obj  =
        {
            mType     : "xstream.VIDEO_LATENCY",
            smartEvent:
            {
                parameters:
                [
                    milliseconds,
                    playerVideoType,
                    playerVersion
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry VIDEO_LATENCY: %o", obj ) : Config.NOP();
        this.send( obj );
    };

    /*
     * @param {Telemetry.VideoType} playerVideoType  -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {Number             } manifestDuration -- The player duration in seconds
     * @param {Number             } metaDataDuration -- The recording duration in seconds
     */
    Telemetry.prototype.sendVideoPlaybackAvailableBucket = function( playerVideoType, manifestDuration, metaDataDuration, recordingManagerId )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoPlaybackAvailableBucket()" );

        if( metaDataDuration === undefined )
        {
            console.error( "sendVideoPlaybackAvailableBucket() recording duration not specified" );
            return;
        }

        if( metaDataDuration && manifestDuration )
        {
            if( manifestDuration > metaDataDuration )
                manifestDuration = metaDataDuration;

            var percent = 100 * manifestDuration / metaDataDuration;
            if( percent > 100 )
            {
console.error( "Warning: VPAB > 100%. Capping" );
                percent = 100;
            }
            else if( percent < 0 )
            {
console.error( "Warning: VPAB < 0%. Capping" );
                percent = 0;
            }

            var obj =
            {
                mType     : "xstream.VIDEO_PLAYBACK_AVAILABLE_BUCKET",
                smartEvent:
                {
                    parameters:
                    [
                        percent,
                        playerVideoType,
                        recordingManagerId
                    ]
                }
            };

            _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry VIDEO_PLAYBACK_AVAILABLE_BUCKET: %o", obj ) : Config.NOP();
            this.send( obj );
        }
    };

    /*
     * Sends the manifest and metadata durations
     * @param {Boolean            } isSuccess -- true = manifest & meta-data duration is sent, false = only meta-data duration is sent
     * @param {Number             } manifestDuration -- The player duration in seconds
     * @param {Number             } metaDataDuration -- The recording duration in seconds
     * @param {Telemetry.VideoType} playerVideoType  -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {}
     */
    Telemetry.prototype.sendVideoPlaybackAvailablePercent = function( isSuccess, manifestDuration, metaDataDuration, playerVideoType, recordingManagerId )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoPlaybackAvailablePercent()" );

        if( manifestDuration === undefined )
        {
            console.error( "sendVideoPlaybackAvailablePercent() manifest duration not specified" );
            return;
        }

        if( recordingManagerId === undefined )
        {
            console.error( "sendVideoPlaybackAvailablePercent() recording manager id not specified" );
            return;
        }

        if( (manifestDuration !== undefined) && (metaDataDuration !== undefined) )
        {
            if( manifestDuration > metaDataDuration ) // AAEWT-826
                manifestDuration = metaDataDuration;  // Numerator
        }

        if( manifestDuration < 0 )
            manifestDuration = 0;

        if( metaDataDuration < 1 )
            metaDataDuration = 1; // Don't use zero to prevent div-by-zero

        var num = // NUMERATOR: manifest (player) duration in seconds
        {
            mType     : "xstream.VIDEO_PLAYBACK_AVAILABLE_PERCENT",
            smartEvent:
            {
                eventCount: manifestDuration,
                parameters:
                [
                    "NUMERATOR",       // Key:
                    playerVideoType,   // Key: playerVideoType
                    recordingManagerId // Key: recordingManagerId
                ]
            }
        };

        var den = // DENOMINATOR: metadata (recording) duration in seconds
        {
            mType     : "xstream.VIDEO_PLAYBACK_AVAILABLE_PERCENT",
            smartEvent:
            {
                eventCount: metaDataDuration,
                parameters:
                [
                    "DENOMINATOR",     // Key:
                    playerVideoType,   // Key: playerVideoType
                    recordingManagerId // Key: recordingManagerId
                ]
            }
        };

        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry VIDEO_PLAYBACK_AVAILABLE_PERCENT numer: %o", num ) : Config.NOP();
        _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry VIDEO_PLAYBACK_AVAILABLE_PERCENT denom: %o", den ) : Config.NOP();

        // XC-18068
        var id = "requestId" + _x2._metricsSocket.getRandomInt();
        num.requestId = id;
        den.requestId = id;

        var ts = Date.now();
        num.ts = ts;
        den.ts = ts;

        if( isSuccess )
            this.send( num );

        this.send( den );
    };

    /** Sent once per streaming session.
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, T6 LINEAR, T6 VOD, etc.
     * @param {String             } playerVersion   -- see ViperPlayerPlatform getVersion()
     * @param {Boolean            } isRetry
     */
    Telemetry.prototype.sendVideoStart = function( playerVideoType, playerVersion, isRetry )
    {
        if( playerVideoType === undefined )
            return this.errorVideoType( "sendVideoStart()" );

        if( playerVersion === undefined )
            return this.errorPlayerVersion( "sendVideoStart()" );

        if( isRetry === undefined )
            isRetry = false;

        var obj =
        {
            mType     : "xstream.VIDEO_START",
            smartEvent:
            {
                parameters:
                [
                    playerVideoType, // Key: playerVideoType
                    playerVersion,   // Key: playerVersion
                    "NA",            // Key: streamProvider
                    isRetry
                ]
            }
        };

        this.send( obj );
    };

    /** ACTIVE_SESSION requires the video type.
     *  When a user enters/exit video playback we need to update the current type.
     * @param {Telemetry.VideoType} [videoType] -- Valid to leave undefined
     */
    Telemetry.prototype.setVideoType = function( videoType )
    {
        this._videoType = videoType ? videoType : Telemetry.VideoType.NONE;
    };

    /**
     * @param {String             } source          -- "Browse Free", etc, see setWatchButton()
     * @param {Telemetry.VideoType} playerVideoType -- RECORDING, TVE LINEAR, etc.
     * @param {String             } playerVersion   -- see VideoStream ViperPlayerPlatform getVersion()
     * NOTE: Use setWatchButton() / getWatchButton() to save/get the source prior to VideoPlayer
     */
    Telemetry.prototype.sendWatchButtonClicked = function( source, playerVideoType, playerVersion )
    {
        if( source === undefined )
            return console.error( "sendWatchButtonClicked() invalid source" );

        if( playerVideoType === undefined )
            return this.errorVideoType( "sendWatchButtonClicked()" );

        if( playerVersion === undefined )
            return this.errorPlayerVersion( "sendWatchButtonClicked()" );

        var obj =
        {
            mType     : "xstream.WATCH_BUTTON_CLICKED",
            smartEvent:
            {
                parameters:
                [
                    source,
                    playerVideoType,
                    playerVersion
                ]
            }
        };

        if( source )
        {
            _x2._config.log( Config.CLASS_TELEMETRY, 8 ) ? console.log( "Telemetry WATCH_BUTTON_CLICKED: %o", obj ) : Config.NOP();
            this.send( obj );
        }
    };

    /* Save the category of the entity so video video player can send it when the entity video is played
     * @param {String} source -- Browse Free, Browse Kids, etc.
     * See: getWatchButtonSource(), sendWatchButtonClicked()
     */
    Telemetry.prototype.setWatchButton = function( source )
    {
        this._watchButtonSource = source;
    };

    Telemetry.prototype.watchPathDepth = function()
    {
        return this._watchButtonPath.length;
    };

    Telemetry.prototype.watchPathReset = function()
    {
        this._watchButtonPath = [];
    };

    Telemetry.prototype.watchPathPush = function( path )
    {
        if( path === undefined )
            console.error( "Invalid watch path" );
        else
            this._watchButtonPath.push( path );
    };

    Telemetry.prototype.watchPathPop = function()
    {
        this._watchButtonPath.pop();
    };

    /**
     * @param {Showing} - showing. One of LinearShowing, VodShowing, etc.
     */
    Telemetry.prototype.watchSourceClassify = function( showing )
    {
        var self          = this;
        var entity        = showing.getEntity();
        var promise;

        var onHaveProgram = function()
        {
            entity = showing.getEntity();
            onHaveEntity( entity );
        };

        var onFailProgram = function()
        {
            console.error( "Failed to get Entity: " + (self._showing.getTitle ? self._showing.getTitle() : "Unknown!") );
        };

        var onHaveEntity  = function( entity )
        {
            var type = entity.getType(), programType;

            switch( type )
            {
                case "Movie":
                case "s:Movie":
                    self.setWatchButton( "Entity Movie Info" );
                    break;
                case "Episode":
                case "s:TvSeries":
                case "SeriesMaster":
                    self.setWatchButton( "Entity Episodes" );
                    break;
                case "s:CreativeWork":
                    // intentional fall into default
                default: // "Other", "MusicVideo", "Sports"
                    programType = entity.getProgramType && entity.getProgramType(); // VOD: getType() == "Program" but getProgramType() -> "Movie"
                    if( programType && programType === "Movie"  )
                        self.setWatchButton( "Entity Movie Info" );
                    else
                        self.setWatchButton( "Entity Info" );
                    break;
            }
        };

        this._showing = showing;
        if( entity )
            onHaveEntity( entity );
        else
        {
            self.setWatchButton( "Entity Info" );

            if( showing instanceof LinearShowing )
                promise = showing.getDetail( false );
            else
                promise = showing.fetchProgram();

            promise.then( onHaveProgram ).catch( onFailProgram );
        }
    };

    return Telemetry;

})();


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ViperPlayerPlatform = ( function()
{
    "use strict";

    function ViperPlayerPlatform( url, listener, resume, lang, contentOptions, videoEas )
    {
        var self = this, obj, onBitRateChanged, onBufferComplete, onBufferStart, onEasComplete, onEasFailure, onEasStarted, onMediaEnded, onMediaOpened, onMediaProgress, onPlaybackSpeedChanged, onPlayStateChanged;

        this._listener = listener;

        _x2._config.debugAddClass( Config.CLASS_VIPER, 5 );

        onBitRateChanged = function( event )
        {
            self._listener.onBitRateChanged( event.bitRate, self._playerPlatform.getVideoWidth(), self._playerPlatform.getVideoHeight() );
        };

        onBufferComplete = function()
        {
            self._listener.onBufferComplete();
        };

        onBufferStart = function()
        {
            self._listener.onBufferStart();
        };

        onEasComplete = function()
        {
            console.log( "Emergency Alert Complete" );
            self._listener.onEmergencyAlertComplete();
        };

        onEasFailure = function()
        {
            console.error( "Emergency Alert Failure" );
        };

        onEasStarted = function()
        {
            console.log( "Emergency Alert Started" );
            self._listener.onEmergencyAlertStarted();
        };

        onMediaEnded = function()
        {
            self._listener.onMediaEnded();
        };

        var onMediaFailed = function( event )
        {
            console.log( event );
            self._listener.onMediaFailed( event );
        };

        onMediaOpened = function( event )
        {
            _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();
            self._listener.onMediaOpened();

            console.log( "PlayerPlatform Version: " + self._playerPlatform.getVersion() );
        };

        onMediaProgress = function( event )
        {
            _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();
            self._listener.onMediaProgress( event.position, event.startposition, event.endposition );
        };

//         var onMediaRetry = function( event )
//         {
//             console.log( event );
// //                self._listener.onMediaEnded();
//         };

        onPlaybackSpeedChanged = function( event )
        {
            self._listener.onPlaybackSpeedChanged( event.playbackSpeed );
        };

        onPlayStateChanged = function( event )
        {
            _x2._config.log( Config.CLASS_VIPER, 9 ) ? console.log( event ) : Config.NOP();

            switch( event.playState )
            {
                case "buffering":
                case "complete":
                    break;

                case "error":
                    self._listener.onError( event );
                    break;

                case "idle":
                case "initializing":
                case "prepared":
                case "preparing":
                case "ready":
                case "released":
                    break;

                case "seeking":
                    break;

                case "initialized":
                    self._volume = self._playerPlatform.getVolume();
                    self._playerPlatform.setCurrentTimeUpdateInterval( 2000 );  // not working
// self._playerPlatform.setVolume( 0 );
// self._volume = 0;

self._listener.onInitialized( self._playerPlatform.getSupportedPlaybackSpeeds() );

// var speeds    = self._playerPlatform.getSupportedPlaybackSpeeds();
// var newSpeeds = [];
//
// console.log( speeds );
//
// for( var i = 0; i < speeds.length; i++ )
//     if( speeds[i] > 1 )
//         newSpeeds.push( speeds[i] );
//
// self._listener.onInitialized( newSpeeds );
                    break;

                case "paused":
                    self._state = VideoScreen.State.PAUSED;
                    self._listener.onPaused();
                    break;

                case "playing":
                    self._state = VideoScreen.State.PLAY;
                    self._listener.onPlay();
                    break;

                default:
                    console.error( "ERROR -> unknown PlayStateChanged event:" );
                    console.error( event );
                    break;
            }
        };

        var onHaveSecClient = function()
        {
            obj =
            {
                videoElement : _x2._videoRoot,
                secClient    : _x2._config._secClientV2,
                configuration:  {
                                    analyticsDeviceType   :"x2-html",
                                    licenseServerUrl      : _x2._config._licenseServer,
//                                 retryOnMediaFailed: "true",
//                                 defaultAsset: { initialBitrate: 0, initialBufferTime: 2000 },
//                                 logstashEndpoint: "http://96.118.37.206:8080/helio/js/"
                                    zipToFipsEndPoint     :"https://easip-client.ccp.xcal.tv/eas/api/fips/zip/",
                                    alertServiceEndPoint  :"https://easip-client.ccp.xcal.tv/eas/api/alert/active/fipscode/",
                                    easTextOverlay        :( videoEas !== true ) ? pp.ConfigurationManager.EAS_TEXT_OVERLAY : undefined,
                                    audioLanguage         :lang,
                                    helioEas              :true,

                                    defaultAsset:
                                    {
                                        "cdnRedundant"         : true,
                                        forceHttps             : (_x2._config._host.getType() !== Host.Type.PC && _x2._config._host.getType() !== Host.Type.ANDROID),
                                        easEnabled             : true,
                                        initialBitrate         : 5000000,
                                        initialBufferTime      : 6100,
                                        playingVODBufferTime   : 30000,
                                        playingLinearBufferTime: 6000,
                                        intersegmentDelay      : 300,
                                        playbackStalledEnabled : true
                                    },

                                    easAsset:
                                    {
                                        forceHttps: true
                                    }
                                }
            };

            // events not currently considered interesting
            // AD_BREAK_COMPLETE
            // AD_BREAK_EXITED
            // AD_BREAK_START
            // AD_BREAK_UPCOMING
            // AD_COMPLETE
            // AD_ERROR
            // AD_EXITED
            // AD_PROGRESS
            // AD_SEEK
            // AD_START
            // AD_SKIPPED
            // ADS_SKIPPED
            // EMERGENCY_ALERT_IDENTIFIED
            // EMERGENCY_ALERT_EXEMPTED
            // EMERGENCY_ALERT_ERRORED

            // events under consideration
            // DROPPED_FPS_CHANGED
            // DURATION_CHANGED
            // FPS_CHANGED
            // FRAGMENT_INFO
            // MEDIA_FALLBACK
            // MEDIA_RETRY
            // MEDIA_WARNING
            // MISSING_DRM_TOKEN
            // NUMBER_OF_ALTERNATIVE_AUDIO_STREAMS_CHANGED
            // NUMBER_OF_CLOSED_CAPTIONS_STREAMS_CHANGED
            // PLAYBACK_SPEEDS_CHANGED
            // PLAYBACK_STARTED
            // SEEK_COMPLETE
            // SEEK_START
            // DRM_METADATA
            // VPAID_AD_EVENT
            // STREAM_SWITCH

            self._playerPlatform = new pp.PlayerPlatformAPI( obj );

// console.log( self._playerPlatform.getSupportedClosedCaptionsOptions() );
//
//self._playerPlatform.setClosedCaptionsStyle( { textForegroundColor:"red" } );

            // configure events to be handled

            self._playerPlatform.on( pp.Events.BITRATE_CHANGED         , onBitRateChanged       );
            self._playerPlatform.on( pp.Events.BUFFER_COMPLETE         , onBufferComplete       );
            self._playerPlatform.on( pp.Events.BUFFER_START            , onBufferStart          );
            self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_COMPLETE, onEasComplete          );
            self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_FAILURE , onEasFailure           );
            self._playerPlatform.on( pp.Events.EMERGENCY_ALERT_STARTED , onEasStarted           );
            self._playerPlatform.on( pp.Events.MEDIA_ENDED             , onMediaEnded           );
            self._playerPlatform.on( pp.Events.MEDIA_FAILED            , onMediaFailed          );
            self._playerPlatform.on( pp.Events.MEDIA_OPENED            , onMediaOpened          );
            self._playerPlatform.on( pp.Events.MEDIA_PROGRESS          , onMediaProgress        );
//                self._playerPlatform.on( pp.Events.MEDIA_RETRY           , onMediaRetry           );
            self._playerPlatform.on( pp.Events.PLAYBACK_SPEED_CHANGED  , onPlaybackSpeedChanged );
            self._playerPlatform.on( pp.Events.PLAY_STATE_CHANGED      , onPlayStateChanged     );
//              self._playerPlatform.on( pp.Events.DURATION_CHANGED        , onDurationChanged      ); // Not valid until video is ended: event.target.duration

            var xsct = JSON.parse( Host.getLocalStorage( "XsctToken" ) );

            self._playerPlatform.configureAnalytics( xsct, AboutOverlay.version );
            self._playerPlatform.configureEmergencyAlerts( xsct.xsct );

            _x2._config.log( Config.CLASS_VIPER, 1 ) ? console.log( "PlayerPlatform Version: " + self._playerPlatform.getVersion() ) : Config.NOP();

            if( url )
                self.play( url, listener, resume, contentOptions );
        };

        if( _x2._config._secClientV2 === undefined )
        {
            var cryptoType = _x2._config._host.getCryptoType();
            var deviceType = _x2._config._host.getSecClientDeviceType();

            var secClientConfig =
            {
                crypto:
                {
                    type: cryptoType
                },
                timeout: 10000
            };

            if( deviceType )
                secClientConfig.deviceType = deviceType;

            _x2._config._secClientV2 = new window[ _x2._config._secClientV2Var ].SecClient();
            _x2._config._secClientV2.load( secClientConfig ).then( onHaveSecClient );
        }
        else
            onHaveSecClient();
    }

    ViperPlayerPlatform.prototype.destroy = function()
    {
        var children = _x2._videoRoot.childNodes;

        for( var i = 0; i < children.length; i++ )
            _x2._videoRoot.removeChild( children[i] );
    };

    ViperPlayerPlatform.prototype.getCaptions = function()
    {
        return this._playerPlatform.getAvailableClosedCaptionTracks();
    };

    ViperPlayerPlatform.prototype.getCurrentLanguage = function()
    {
        return this._playerPlatform.getCurrentAudioLanguage();
    };

    ViperPlayerPlatform.prototype.getCurrentPosition = function()
    {
        return this._playerPlatform.getCurrentPosition();
    };

//     ViperPlayerPlatform.prototype.getCurrentSpeed = function()
//     {
//         return this._playerPlatform.getCurrentPlaybackSpeed();
//     };

    ViperPlayerPlatform.prototype.getDuration = function()
    {
        return this._playerPlatform.getDuration();
    };

    ViperPlayerPlatform.prototype.getLanguages = function()
    {
        return this._playerPlatform.getAvailableAudioLanguages();
    };

    ViperPlayerPlatform.prototype.getPlaySpeed = function()
    {
        return this._playerPlatform.getCurrentPlaybackSpeed();
    };

    ViperPlayerPlatform.prototype.getState = function()
    {
        return this._state;
    };

    ViperPlayerPlatform.prototype.getVersion = function()
    {
        return this._playerPlatform.getVersion();
    };

    ViperPlayerPlatform.prototype.mute = function()
    {
        if( this._playerPlatform.getVolume() === 0 )
            this._playerPlatform.setVolume( this._volume );
        else
            this._playerPlatform.setVolume( 0 );
    };

    ViperPlayerPlatform.prototype.pause = function()
    {
        this._playerPlatform.pause();
    };

    ViperPlayerPlatform.prototype.setPcBlock = function( bool )
    {
//        this._playerPlatform.setBlock( bool );  // should be using this, but was not implemented

        if( bool === true )
        {
            _x2._videoRoot.style.display = "none";
            this._playerPlatform.setVolume( 0 );
        }
        else
        {
            _x2._videoRoot.style.display = "initial";
            this._playerPlatform.setVolume( 1 );
        }
    };

    ViperPlayerPlatform.prototype.play = function( url, listener, resume, contentOptions )
    {
        if( url !== undefined )
        {
            if( this._playerPlatform )
{
    console.log( this._playerPlatform.eas );
    this._playerPlatform.eas.start();
}
            this._listener = listener;

            var assetType;

            if( contentOptions.recordingId )
                assetType = "CDVR";
            else if( contentOptions.streamId )
                assetType = "T6_LINEAR";
            else
                assetType = "T6_VOD";

            var token   = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
            var xact    = JSON.parse( Host.getLocalStorage( "XactToken" ) );
            var options =
            {
                authToken                 : token.xsct,
                deviceAuthenticationResult: xact,
                assetEngine               : "helio",
                keySystem                 : _x2._config._host.getDrmType(),
                streamId                  : contentOptions.streamId,
                recordingId               : contentOptions.recordingId,
                assetId                   : contentOptions.assetId,
                providerId                : contentOptions.providerId,
                mediaGuid                 : contentOptions.mediaGuid,
//                assetType                 : assetType
            };

            if( resume )
                options.resumePosition = resume;

            console.log("Playing url : ", url, " with options: ", options , options.resumePosition );
            this._playerPlatform.setAsset( pp.Asset.create( url, options ) );
            pp.setLogLevel( (_x2._config._ppLog === true) ? pp.LogLevel.ALL : pp.LogLevel.NONE );
        }
        else
            this._playerPlatform.play();
    };

    ViperPlayerPlatform.prototype.setCaption = function( track )
    {
        this._playerPlatform.setClosedCaptionsTrack( track );
    };

    ViperPlayerPlatform.prototype.setCaptionsEnabled = function( bool )
    {
        this._playerPlatform.setClosedCaptionsEnabled( bool );
    };

    ViperPlayerPlatform.prototype.setLanguage = function( lang )
    {
        this._playerPlatform.setPreferredAudioLanguage( lang );
    };

    ViperPlayerPlatform.prototype.setPosition = function( msec )
    {
        this._playerPlatform.setPosition( msec )
    };

    ViperPlayerPlatform.prototype.setSpeed = function( speed )
    {
        this._playerPlatform.setSpeed( speed )
    };

    ViperPlayerPlatform.prototype.skipBackward = function( msec )
    {
        this._playerPlatform.setPositionRelative( -msec );
    };

    ViperPlayerPlatform.prototype.skipForward = function( msec )
    {
        this._playerPlatform.setPositionRelative( msec );
    };

    ViperPlayerPlatform.prototype.stop = function()
    {
        this._playerPlatform.eas.stop();
        this._playerPlatform.stop();
    };

    ViperPlayerPlatform.prototype.volumeDown = function()
    {
        if( this._volume > 0 )
        {
            this._volume -= 0.05;

            if( this._volume < 0 )
                this._volume = 0;

            this._playerPlatform.setVolume( this._volume );
            _x2._config.log( Config.CLASS_VIPER, 3 ) ? console.log( "VOLUME = " + this._volume ) : Config.NOP();
        }
    };

    ViperPlayerPlatform.prototype.volumeUp = function()
    {
        if( this._volume < 1 )
        {
            this._volume += 0.05;

            if( this._volume > 1 )
                this._volume = 1;

            this._playerPlatform.setVolume( this._volume );
            _x2._config.log( Config.CLASS_VIPER, 3 ) ? console.log( "VOLUME = " + this._volume ) : Config.NOP();
        }
    };

    return ViperPlayerPlatform;

})();


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Widget = ( function()
{
    "use strict";

    Widget.prototype = new Callbacks();

    // Independent animation axis
    /**
     * @namespace     Axis
     * @enum {Number} Axis
     * @type {Number}
     * @property {Number}               Widget.ALPHA            - Normalized percentage opacity. 0.0 = invisible, 1.0 = visible.
     * @property {Number}               Widget.W                - width
     * @property {Number}               Widget.H                - height
     * @property {Number}               Widget.X                - offset from left edge
     * @property {Number}               Widget.Y                - offset from top edge
     * @property {Number}               Widget.Z                - Force widget to be on top or behind
     * @property {Number}               Widget.X_SCALE          - Scale factor. 1 = original size
     * @property {Number}               Widget.Y_SCALE          - Scale factor. 1 = original size
     * @property {String}               Widget.FONT             - "light", "medium", "bold"
     * @property {String}               Widget.FONT_COLOR       - 7 character HTML 6 hex digit color. '#FF0000'
     * @property {String}               Widget.FONT_COLOR_HI    - 7 character HTML 6 hex digit color  '#00FF00'
     * @property {Number}               Widget.FONT_SIZE        - Font size in pixels (Doesn't include ascenders nor descenders)
     * @property {('nowrap'|'normal')}  Widget.TEXT_WHITE_SPACE - If text should wrap or not. Default: normal. {@link http://www.w3schools.com/jsref/prop_style_whitespace.asp}
     * @property {('left'|'center')}    Widget.TEXT_ALIGN       - Alignment. Default: left.                    {@link http://www.w3schools.com/jsref/prop_style_textalign.asp}
     * @property {('visible'|'hidden')} Widget.OVERFLOW         - If contents should extend past the region    {@link http://www.w3schools.com/jsref/prop_style_overflow.asp}
     */
    Widget.ALPHA               =  0;
    Widget.W                   =  1;
    Widget.H                   =  2;
    Widget.X                   =  3;
    Widget.Y                   =  4;
    Widget.Z                   =  5;
    Widget.X_SCALE             =  6;
    Widget.Y_SCALE             =  7;
    Widget.Z_SCALE             =  8;
    Widget.X_ROT               =  9;
    Widget.Y_ROT               = 10;
    Widget.Z_ROT               = 11;
    Widget.FONT                = 12;
    Widget.FONT_COLOR          = 13;
    Widget.FONT_COLOR_HI       = 14;
    Widget.FONT_SIZE           = 15;
    Widget.TEXT_WHITE_SPACE    = 16;
    Widget.TEXT_ALIGN          = 17;
    Widget.OVERFLOW            = 18;
    Widget.NUM_VALS            = 19;

    Widget.Axis = Object.freeze  // This will eventually replace the above constants
    ({
        A            :  0,
        W            :  1,
        H            :  2,
        X            :  3,
        Y            :  4,
        Z            :  5,
        X_SCALE      :  6,
        Y_SCALE      :  7,
        Z_SCALE      :  8,
        X_ROT        :  9,
        Y_ROT        : 10,
        Z_ROT        : 11,
        FONT_COLOR   : 13,
        FONT_COLOR_HI: 14,
        FONT_SIZE    : 15,
        NUM_VALS     : 19,

        Str:
        {
             0: "alpha",
             1: "w",
             2: "h",
             3: "x",
             4: "y",
             5: "z",
             6: "xScale",
             7: "yScale",
             8: "zScale",
             9: "xRot",
            10: "yRot",
            11: "zRot",
            12: "DEPRECATED",
            13: "fontColor",
            14: "fontColorHi",
            15: "fontSize",
            16: "DEPRECATED",
            17: "DEPRECATED",
            18: "DEPRECATED"
        }
    });

    /**
     * @namespace         Easing
     * @enum     {Number} Easing
     * @property {Number} Widget.Easing.LINEAR
     * @property {Number} Widget.Easing.QUAD_IN_OUT
     * @property {Number} Widget.Easing.QUAD_OUT
     */

    Widget.Easing = Object.freeze // This will eventually replace the above constants
    ({
        BACK_IN        :  1,
        BACK_IN_OUT    :  2,
        BACK_OUT       :  3,
        BOUNCE_IN      :  4,
        BOUNCE_IN_OUT  :  5,
        BOUNCE_OUT     :  6,
        CIRC_IN        :  7, // circle
        CIRC_IN_OUT    :  8,
        CIRC_OUT       :  9,
        CUBIC_IN       : 10, // t^3
        CUBIC_IN_OUT   : 11,
        CUBIC_OUT      : 12,
        ELASTIC_IN     : 13, // elastic
        ELASTIC_IN_OUT : 14,
        ELASTIC_OUT    : 15,
        EXPO_IN        : 16, // See note about canonical Robert's 'expo' and jQuery UI mis-labeling 'sextic'
        EXPO_IN_OUT    : 17,
        EXPO_OUT       : 18,
        LINEAR         : 19, // t^1 Note: in = out = inout
        OCTIC_IN       : 20, // t^8
        OCTIC_IN_OUT   : 21,
        OCTIC_OUT      : 22,
        QUAD_IN        : 23, // t^2
        QUAD_IN_OUT    : 24,
        QUAD_OUT       : 25,
        QUART_IN       : 26, // t^4
        QUART_IN_OUT   : 27,
        QUART_OUT      : 28,
        QUINT_IN       : 29, // t^5
        QUINT_IN_OUT   : 30,
        QUINT_OUT      : 31,
        SEPTIC_IN      : 32, // t^7
        SEPTIC_IN_OUT  : 33,
        SEPTIC_OUT     : 34,
        SEXTIC_IN      : 35, // t^6
        SEXTIC_IN_OUT  : 36,
        SEXTIC_OUT     : 37,
        SINE_IN        : 38, // sin
        SINE_IN_OUT    : 39,
        SINE_OUT       : 40,
    });

    function Widget(){}

    function easeBounceIn( p ) // https://github.com/nicolasgramlich/AndEngine/blob/GLES2/src/org/andengine/util/modifier/ease/EaseBounceIn.java
    {
        return 1 - easeBounceOut( 1-p );
    }

    function easeBounceOut( p )  // 3 bounces (not including initial position)
    {
        var k1 = 1   / 2.75; // 36.36% // reciprocal
        var k2 = 2     * k1; // 72.72%
        var k3 = 1.5   * k1; // 54.54%
        var k4 = 2.5   * k1; // 90.90%
        var k5 = 2.25  * k1; // 81.81%
        var k6 = 2.625 * k1; // 95.45%
        var k0 = 7.5625, t;

        if     ( p < k1 ) {             return k0 * p*p;            }
        else if( p < k2 ) { t = p - k3; return k0 * t*t + 0.75;     } // 48/64
        else if( p < k4 ) { t = p - k5; return k0 * t*t + 0.9375;   } // 60/64
        else              { t = p - k6; return k0 * t*t + 0.984375; } // 63/64
    }

    function easeElasticIn( p )  // Unoptimized Reference: http://code.google.com/p/andengine/source/browse/src/org/anddev/andengine/util/modifier/ease/EaseElasticIn.java
    {                            // Moved to: https://github.com/nicolasgramlich/AndEngine/blob/GLES2/src/org/andengine/util/modifier/ease/EaseElasticIn.java
        var m = p-1;
        return -Math.pow( 2, 10*m ) * Math.sin( (m*40 - 3) * Math.PI/6 );
    }

    function easeElasticOut( p )  // Unoptimized Reference: http://code.google.com/p/andengine/source/browse/src/org/anddev/andengine/util/modifier/ease/EaseElasticOut.java
    {                             // Optimized reference  : http://www.joshondesign.com/2013/03/01/improvedEasingEquations
        // Alt.. return 1 - easeElasticIn( 1 - p );
        if( p <= 0 ) return 0;
        if( p >= 1 ) return 1;
        return 1+(Math.pow( 2,10*-p ) * Math.sin( (-p*40 - 3) * Math.PI/6 ));
    }

/*
    Widget.ID  = 0; // DEBUG Widget Animation Trace & WebGL Debug Widget Inspector
    Widget.OBJ = [];

    // DEBUG Widget Animation Trace
    Widget._animTrace = {};

    Widget.animTraceAdd = function( widget )
    {
        Widget._animTrace[ widget._uid ] = true;
    }

    Widget.animTraceClear = function ()
    {
        Widget._animTrace = {};
    }

    Widget.animTraceKids = function( widget )
    {
        Widget.animTraceAdd( widget );

        for( var iChild = 0; iChild < widget._children.length; iChild++ )
            Widget.animTraceKids( widget._children[ iChild ] );
    }

    Widget.animTraceLog = function( widget, axis, val, isEnd, time )
    {
        if( Widget._animTrace[ widget._uid ] )
            if( isEnd )
                console.log( "%s.onEnd()  _[ %d ].set%s( %o ) //       @ %o" , widget._className, widget._uid, Widget.Axis.Str[axis], val,                      time );
            else
                console.log( "%s.onInc()  _[ %d ].set%s( %o ) // <- %o @ %o", widget._className, widget._uid, Widget.Axis.Str[axis], val, widget._curVal[axis], time );
    }

    Widget.animTraceSet = function( widget, axis, val )
    {
        if( Widget._animTrace[ widget._uid ] )
            console.log( "%s.setVal()  _[ %d ].set%s( %o ) // <- %o", widget._className, widget._uid, Widget.Axis.Str[axis], val, widget._curVal[axis] );
    }

// */

    Widget.ShaderType = Object.freeze
    ({
        CKV                 : 0, // Vertex Color Mesh -- technically nothing to do with gradients. Mesh manually enlarged to cover all 4 corners
        KV                  : 1, // Constant Color, Vertex coordinates
        KVT                 : 2, // Constant Color, Vertex coordinates, Texture coordinates & sampler
        FONT                : 3, // Signed Distance Field Font in fixed-point
        GRADIENT_LINEAR_2AA : 4, // 2 colors, Primary/Principal X or Y axis-aligned, angle = 0, 90, 180, 270
        GRADIENT_LINEAR_4ROT: 5, // max 4 colors @ any stop, Gradient on Line centered
        GRADIENT_RADIAL_2   : 5, // 2 colors @ 0% and 100%, Ellipse at Center
        GRADIENT_RADIAL_4   : 6, // max 4 colors @ any stop, Ellipse at Center
        NUM_SHADERS         : 7
    });

    Widget.SHADER_CKV                  = 0;
    Widget.SHADER_KV                   = 1;
    Widget.SHADER_KVT                  = 2;
    Widget.SHADER_FONT                 = 3;
    Widget.SHADER_GRADIENT_LINEAR_2AA  = 4; // 2 colors, Primary/Principal X or Y axis-aligned, angle = 0, 90, 180, 270
    Widget.SHADER_GRADIENT_LINEAR_4ROT = 5; // max 4 colors @ any stop, Gradient on Line centered
    Widget.SHADER_GRADIENT_RADIAL_2    = 6; // 2 colors @ 0% and 100%, Ellipse at Center
    Widget.SHADER_GRADIENT_RADIAL_4    = 7; // max 4 colors @ any stop, Ellipse at Center

    Widget.NUM_SHADERS = 8;

    function glOrtho( left, right, bottom, top, near, far )
    {
        var dst = Widget.glProjMatrix[ Widget.glProjDepth ];

        var dx = right - left;
        var dy = top   - bottom;
        var dz = far   - near;

        var sx = right + left;
        var sy = top   + bottom;
        var sz = far   + near;

        dst[ 0] =  2. / dx; dst[ 4] =  0.     ; dst[ 8] =  0.     ; dst[12] = -sx / dx;
        dst[ 1] =  0.     ; dst[ 5] =  2. / dy; dst[ 9] =  0.     ; dst[13] = -sy / dy;
        dst[ 2] =  0.     ; dst[ 6] =  0.     ; dst[10] = -2. / dz; dst[14] = -sz / dz;
        dst[ 3] =  0.     ; dst[ 7] =  0.     ; dst[11] =  0.     ; dst[15] =  1.     ;
    }

    function glShadersInit()
    {
        var iShader, gl = Widget.gl, flags, shader, program;

        var ShaderLocation = Object.freeze
        ({
            FLAG_A  : 1 << 0, // unAngle - in radians
            FLAG_C  : 1 << 1, // avVertColor: vertex.rgba
            FLAG_D  : 1 << 2, // uvDimension, vvCoord - normalized pixel coordinates from vertex coordinate
            FLAG_G2 : 1 << 3, // uvGrad0..1
            FLAG_G4 : 1 << 4, // uvGrad0..3
            FLAG_GS : 1 << 5, // uvStops for Gradient
            FLAG_H  : 1 << 6, // unHeight -- in pixels
            FLAG_K  : 1 << 7, // uvColor
            FLAG_OAR: 1 << 8, // unooAspectRatio = one over aspect ratio = h/w
            FLAG_V  : 1 << 9, // avPosition: vertex.xyz
            FLAG_T  : 1 <<10, // avTexCoord, utDiffuse1
            FLAG_W  : 1 <<11, // unWeight -- font thickness/sharpness
        });

        var INC_FRAG_GRADIENT =
                    //    uvStop.x  uvStop.y  uvStop.z  uvStop.w
                    //      0.0 |---------|---------|---------| 1.0  Alpha Location
                    //      0.0 |---------|---------|---------| 1.0  Color Location
                    //          ^         ^         ^         ^
                    //        uvGrad0   uvGrad1   uvGrad2   uvGrad3  Colors (rgba)
                    //
                    // width1   |->d
                    // width2   <---w2--->
                    // width1             |------>d
                    // width2             <---w2--->
                    // width1                       |->d
                    // width2                       <---w2--->
                    "uniform lowp vec4  uvColor;                              \n"+ // FLAG_K
                    "uniform lowp vec4  uvGrad0;                              \n"+ // FLAG_G4 color at  0 %
                    "uniform lowp vec4  uvGrad1;                              \n"+ // FLAG_G4 color at x1 %
                    "uniform lowp vec4  uvGrad2;                              \n"+ // FLAG_G4 color at x2 %
                    "uniform lowp vec4  uvGrad3;                              \n"+ // FLAG_G4 color at 100%
                    "uniform lowp vec4  uvStops;                              \n"+ // FLAG_GS Location of 4 gradient stops
                    "lowp vec4 getGradientOnLine( lowp float d )              \n"+
                    "{                                                        \n"+
                    "    lowp vec4  color1;                                   \n"+
                    "    lowp vec4  color2;                                   \n"+
                    "    lowp float width1;                                   \n"+
                    "    lowp float width2;                                   \n"+ // See above diagram
                    "    lowp float t;                                        \n"+
                  //"if (d > 1.0) return vec4( 1.0, 0.0, 1.0, 1.0 );          \n"+ // DEBUG: HOT PINK
                    "    if( d >= uvStops.z ) {                               \n"+ // ** 4 Gradients **
                    "        color1 = uvGrad2;                                \n"+
                    "        color2 = uvGrad3;                                \n"+
                    "        width1 = d         - uvStops.z;                  \n"+
                    "        width2 = 1.0       - uvStops.z;                  \n"+ // OPTIMIZATION: uvStops.w=1.0 - uvStops.z
                    "    } else                                               \n"+
                    "    if( (d >= uvStops.y) && (d < uvStops.z ) ) {         \n"+ // ** 3 Gradients **
                    "        color1 = uvGrad1;                                \n"+
                    "        color2 = uvGrad2;                                \n"+
                    "        width1 = d         - uvStops.y;                  \n"+
                    "        width2 = uvStops.z - uvStops.y;                  \n"+
                    "    } else {                                             \n"+ // ** 2 Gradients ** d < uvStops.y
                    "        color1 = uvGrad0;                                \n"+
                    "        color2 = uvGrad1;                                \n"+
                    "        width1 = d;                                      \n"+ // OPTIMIZATION: d         - uvStops.x=0.0
                    "        width2 = uvStops.y;                              \n"+ // OPTIMIZATION: uvStops.y - uvStops.x=0.0
                    "    }                                                    \n"+
                    "    t = min( width1 / width2, 1.0 );                     \n"+ // Clamp radius to 1.0
                    "    return mix( color1, color2, t );                     \n"+
                    "}                                                        \n";

        var SHADER_SOURCE =
        [
            {
                flag: 0 // SHADER_CKV
                    | ShaderLocation.FLAG_C  // Vertex Color
                    | ShaderLocation.FLAG_K  // Constant Color
                    | ShaderLocation.FLAG_V, // Vertex Position
                vert:
                    "attribute     vec3 avVertColor;                          \n"+ // FLAG_C
                    "attribute     vec3 avPosition;                           \n"+ // FLAG_V

                    "uniform       mat4 umProj;                               \n"+
                    "uniform       mat4 umView;                               \n"+

                    "varying lowp  vec3 vvColor;                              \n"+ // FLAG_C
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);\n"+
                    "    vvColor = avVertColor;                               \n"+ // FLAG_C Pass color from vertex to fragment shader
                    "}",
                frag:
                    "uniform lowp vec4 uvColor;                               \n"+ // FLAG_K

                    "varying lowp vec3 vvColor;                               \n"+ // FLAG_C Vertex Color
                    "varying lowp vec2 vvCoord;                               \n"+ // FLAG_D
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_FragColor = vec4( vvColor, uvColor.a ) * uvColor; \n"+
                    "}"
            },
            {
                flag: 0 // SHADER_KV
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V,
                vert:
                    "attribute vec3 avPosition;"+ // FLAG_V

                    "uniform   mat4 umProj;    "+
                    "uniform   mat4 umView;    "+

                    "void main() {             "+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);"+
                    "}",
                frag:
                    "uniform lowp vec4 uvColor; "+ // FLAG_K

                    "void main() {              "+
                    "    gl_FragColor = uvColor;"+
                    "}"
            },
            {
                flag: 0 // SHADER_KVT
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V
                    | ShaderLocation.FLAG_T,
                vert:
                    "attribute vec3 avPosition;  "+ // FLAG_V
                    "attribute vec2 avTexCoord;  "+ // FLAG_T vertex
                    "uniform   mat4 umProj;      "+
                    "uniform   mat4 umView;      "+
                    "varying   vec2 vvTexCoord;  "+ // FLAG_T vertex -> fragment

                    "void main() {               "+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);"+
                    "    vvTexCoord = avTexCoord;"+
                    "}",
                frag:
                    "uniform lowp vec4 uvColor;                                "+
                    "uniform sampler2D utDiffuse1;                             "+
                    "varying lowp vec2 vvTexCoord;                             "+ // FLAG_T
                    "void main() {                                             "+
                    "    lowp vec4 color = texture2D( utDiffuse1, vvTexCoord );"+
                    "    color.xyz *= color.w;                                 "+ // premultiplied alpha: remove halo fringe in "xfinity_logo.png" at MainMenuScreen
                    "    gl_FragColor = uvColor * color;                       "+ // needs premultiplied alpha: gl.blendFunc( gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
                    "}"
            },
            {
                flag: 0 // SHADER_FONT
                    | ShaderLocation.FLAG_H
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V
                    | ShaderLocation.FLAG_T
                    | ShaderLocation.FLAG_W,
                vert:
                    "attribute mediump vec3 avPosition;                    "+ // FLAG_V vertex: fixed-point  fragment: float
                    "attribute mediump vec2 avTexCoord;                    "+ // FLAG_T vertex: fixed-point  fragment: float
                    "uniform           mat4 umProj    ;                    "+
                    "uniform           mat4 umView    ;                    "+
                    "varying   mediump vec3 vvTexCoord;                    "+ // FLAG_T vertex: fixed-point  fragment: float
                    "void main() {                                         "+
                    "    mediump vec4 nvPosition    = vec4( avPosition.xy, 0.0, 1.0 ); "+ // fonts always at <x,y,0>
                    "                 vvTexCoord.xy = avTexCoord.xy / 32768.0;         "+ // convert from fixed point 1.15 to float
                    "                 vvTexCoord.z  = min( 1.0, avPosition.z/16384.0 );"+ // pass vertex alpha to fragment shader via normally unused 3rd texture coordinate
                    "                 gl_Position   = umProj * umView * nvPosition;    "+
                    "}",
                frag:
                    // https://github.com/KhronosGroup/WebGL/blob/master/extensions/OES_standard_derivatives/extension.xml
                    // https://github.com/KhronosGroup/WebGL/blob/master/sdk/tests/conformance/extensions/oes-standard-derivatives.html
                    "#ifdef GL_OES_standard_derivatives                           \n"+
                    "    #extension GL_OES_standard_derivatives : enable          \n"+
                    "#endif                                                       \n"+
                    "                                                             \n"+
                    "precision mediump float;                                     \n"+ // http://stackoverflow.com/questions/13780609/what-does-precision-mediump-float-mean
                    "uniform lowp    vec4      uvColor    ;                       \n"+
                    "uniform         sampler2D utDiffuse1 ;                       \n"+
                    "varying mediump vec3      vvTexCoord ;                       \n"+ // vertex: fixed-point  fragment: float
                    "uniform         float     unHeight;                          \n"+
                    "uniform         float     unWeight;                          \n"+ // 0.0 = Normal, 0.5 = Bold
                    "                                                             \n"+
                    /*
                    https://github.com/Chlumsky/msdfgen/issues/22
                        vec3 sample = texture( uTex0, TexCoord ).rgb;
                        ivec2 sz = textureSize( uTex0, 0 );
                        float dx = dFdx( TexCoord.x ) * sz.x;
                        float dy = dFdy( TexCoord.y ) * sz.y;
                        float toPixels = 8.0 * inversesqrt( dx * dx + dy * dy );
                        float sigDist = median( sample.r, sample.g, sample.b ) - 0.5;
                        float opacity = clamp( sigDist * toPixels + 0.5, 0.0, 1.0 );
                    */
                    "void main() {                                                \n"+
                    "    mediump vec2  st    = vec2( vvTexCoord.x, vvTexCoord.y );\n"+ // needs GL_LINEAR
                    "    mediump float dist  = texture2D( utDiffuse1, st ).r;     \n"+ // gl.ALPHA texture // or .r for .jpg
                    "    mediump float fade  = vvTexCoord.z;                      \n"+
                    "    mediump vec2  dim   = vec2( 1024.0, unHeight );          \n"+ // GLSL 1.3: textureSize( utDiffuse1, 0 ) -- NOT supported on GL ES 2.x
                    "    mediump float dx    = dFdx( vvTexCoord.x ) * dim.x;      \n"+ // convert gradient to screen space
                    "    mediump float dy    = dFdy( vvTexCoord.y ) * dim.y;      \n"+
                    "    mediump float scale = 8.0 * inversesqrt( dx*dx + dy*dy );\n"+ // 8 is sharpness: 0 = blurry, 16 = sharp
                    "    mediump float d     = (dist-0.5)*scale + 0.5 + unWeight; \n"+ // For 3 channel SDF median = max(min(a,b), min(max(a,b),c));
                    "    mediump float alpha = clamp( d, 0.0, 1.0 );              \n"+
                    "    gl_FragColor = uvColor * fade * uvColor.a * alpha;       \n"+ // needs premultiplied alpha: gl.blendFunc( gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

                    "}"
            },
            {
                flag: 0 // GRADIENT_LINEAR_2AA // 2 Color, Principal X or Y Axis-Aligned -- Horizontal or Vertical
                    | ShaderLocation.FLAG_D
                    | ShaderLocation.FLAG_G4
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V,
                vert:
                    "attribute     vec3 avPosition;                           \n"+ // FLAG_V

                    "uniform lowp  vec2 uvDimension;                          \n"+ // FLAG_D
                    "uniform       mat4 umProj;                               \n"+
                    "uniform       mat4 umView;                               \n"+

                    "varying lowp  vec2 vvCoord;                              \n"+ // FLAG_D
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);\n"+
                    "    vvCoord = avPosition.xy / uvDimension;               \n"+ // FLAG_D
                    "}",
                frag:
                    "uniform lowp vec4 uvColor;                            \n"+ // FLAG_K
                    "uniform lowp vec4 uvGrad0;                            \n"+ // FLAG_G4 x0y0 Bottom Left
                    "uniform lowp vec4 uvGrad1;                            \n"+ // FLAG_G4 x1y0 Bottom Right
                    "uniform lowp vec4 uvGrad2;                            \n"+ // FLAG_G4 x0y1 Top Left
                    "uniform lowp vec4 uvGrad3;                            \n"+ // FLAG_G4 x1y1 Top Right

                    "varying lowp vec2 vvCoord;                            \n"+ // FLAG_D
                    "                                                      \n"+
                    "void main() {                                         \n"+
                    "    lowp vec4 x0 = mix( uvGrad0, uvGrad1, vvCoord.x );\n"+
                    "    lowp vec4 x1 = mix( uvGrad2, uvGrad3, vvCoord.x );\n"+
                    "    lowp vec4 y  = mix( x0     , x1     , vvCoord.y );\n"+
                    "    gl_FragColor = y * uvColor.a;                     \n"+ // FLAG_
                    "}"
            },
            {
                flag: 0 // GRADIENT_LINEAR_4ROT
                    | ShaderLocation.FLAG_A
                    | ShaderLocation.FLAG_D
                    | ShaderLocation.FLAG_G4
                    | ShaderLocation.FLAG_GS
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_OAR
                    | ShaderLocation.FLAG_V,
                vert:
                    "attribute    vec3 avPosition;                            \n"+ // FLAG_V

                    "uniform lowp vec2 uvDimension;                           \n"+ // FLAG_D
                    "uniform      mat4 umProj;                                \n"+
                    "uniform      mat4 umView;                                \n"+

                    "varying lowp vec2 vvCoord;                               \n"+ // FLAG_D
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);\n"+
                    "    vvCoord = avPosition.xy / uvDimension;               \n"+ // FLAG_D
                    "}",
                frag:
                    "uniform lowp float unAngle;                              \n"+ // FLAG_A radians
                    "uniform lowp vec2  uvDimension;                          \n"+ // FLAG_D
                    "uniform lowp float unooAspectRatio;                      \n"+ // FLAG_OAR
                    "varying lowp vec2  vvCoord;                              \n"+ // FLAG_D

                    INC_FRAG_GRADIENT +

                    "void main() {                                                  \n"+
                    "    lowp vec2  vG    = vec2( cos( unAngle ), sin( unAngle ) ); \n"+ // sc.x = Cos, sc.y = Sin
                    "    lowp mat2  mZ    = mat2( vG.x, vG.y, -vG.y, vG.x );        \n"+ // mRotateZ in Column Major
                    "    lowp vec2  q     = 2.0*vvCoord - 1.0;                      \n"+ // FLAG_D Trans -= <0.5,0.5> = Remap 0.0 .. 1.0 -> -1.0 ... +1.0
                    "               q.y  *= unooAspectRatio;                        \n"+ // Compensate for aspect ratio
                    "    lowp vec2  r     = mZ * q;                                 \n"+ // Rotate around <0.5>
                    "               r.x  /= (abs(vG.x) + unooAspectRatio*abs(vG.y));\n"+ // mRotZ * <1,iar> = 1*abs(cos(GradAngle)) + iar*abs(sin(GradAngle))
                    "               r.x  += 1.0;                                    \n"+ // -1 .. +1 -> 0 .. 2
                    "               r.x  *= 0.5;                                    \n"+ //  0 ..  2 -> 0 .. 1
                    "    lowp vec4  c     = getGradientOnLine( r.x );               \n"+ // DEBUG: vvCoord.x
                    "    gl_FragColor     = c * uvColor.a;                          \n"+ // FLAG_K
                    "}"
            },
            {
                flag: 0 // SHADER_GRADIENT_RADIAL_2 // 2 Color Ellipse at center
                    | ShaderLocation.FLAG_D
                    | ShaderLocation.FLAG_G2
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V,
                vert:
                    "attribute     vec3 avPosition;                           \n"+ // FLAG_V

                    "uniform lowp  vec2 uvDimension;                          \n"+ // FLAG_D
                    "uniform       mat4 umProj;                               \n"+
                    "uniform       mat4 umView;                               \n"+

                    "varying lowp  vec2 vvCoord;                              \n"+ // FLAG_D
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);\n"+
                    "    vvCoord = avPosition.xy / uvDimension;               \n"+ // FLAG_V FLAG_D normalize in object space
                    "}",
                frag:
                    "uniform lowp vec4 uvColor;                    \n"+ // FLAG_K
                    "uniform lowp vec4 uvGrad0;                    \n"+ // FLAG_G2 color @ 0%
                    "uniform lowp vec4 uvGrad1;                    \n"+ // FLAG_G2 color @ 100%

                    "varying lowp vec2 vvCoord;                    \n"+ // FLAG_D

                    "void main() {                                 \n"+
                    "    lowp vec2  d = 2.0*vvCoord - 1.0;         \n"+ // FLAG_D Remap 0.0 .. 1.0 -> -1.0 ... +1.0
                    "    lowp float r = sqrt( dot( d, d ) );       \n"+ // abs( distance )
                    "    lowp vec4  c = mix( uvGrad0, uvGrad1, r );\n"+
                    "    gl_FragColor = c * uvColor.a;             \n"+ // FLAG_K
                    "}"
            },
            {
                flag: 0 // SHADER_GRADIENT_RADIAL_4 // max 4 colors @ any stop, Ellipse at Center
                    | ShaderLocation.FLAG_D
                    | ShaderLocation.FLAG_G4
                    | ShaderLocation.FLAG_GS
                    | ShaderLocation.FLAG_K
                    | ShaderLocation.FLAG_V,
                vert:
                    "attribute     vec3 avPosition;                           \n"+ // FLAG_V

                    "uniform lowp  vec2 uvDimension;                          \n"+ // FLAG_D
                    "uniform       mat4 umProj;                               \n"+
                    "uniform       mat4 umView;                               \n"+

                    "varying lowp  vec2 vvCoord;                              \n"+ // FLAG_D
                    "                                                         \n"+
                    "void main() {                                            \n"+
                    "    gl_Position = umProj * umView * vec4(avPosition,1.0);\n"+
                    "    vvCoord = avPosition.xy / uvDimension;               \n"+ // FLAG_V FLAG_D normalize in object space: <w,h> -> 0 .. 1
                    "}",
                frag:
                    "varying lowp vec2  vvCoord;                              \n"+ // FLAG_D

                    INC_FRAG_GRADIENT +

                    "void main() {                                            \n"+
                    "    lowp vec2  d = 2.0*vvCoord - 1.0;                    \n"+ // FLAG_D Remap 0.0 .. 1.0 -> -1.0 ... +1.0
                    "               d*= 0.70710678118655;                     \n"+ // replicate DOM behavior: inversesqrt(2.0) = 1.0/sqrt(2.0) = 0.70710678118655 = we want the radius to be 1.0 at the (diagonal) corner not at principal x or y axis edge
                    "    lowp float r = sqrt( dot( d, d ));                   \n"+ // abs( distance )
                    "    lowp vec4  c = getGradientOnLine( r );               \n"+
                    "    gl_FragColor = c * uvColor.a;                        \n"+ // FLAG_K
                    "}"
            }
        ];

        Widget.glShaders    = [];
        Widget.glShaderThis = null; // active shader
        Widget.glShaderNext = -1; // enum of next
        Widget.glShaderPrev = -1; // enum of last

        var shaderCompile = function( shaderSource, shaderType )
        {
            shader = gl.createShader( shaderType );

            gl.shaderSource( shader, shaderSource );
            gl.compileShader( shader );

//console.info( "WebGL COMPILE: " + gl.getShaderInfoLog( shader ) );

            if( !gl.getShaderParameter( shader, gl.COMPILE_STATUS ) )
            {
                console.error( "WebGL ERROR -> Failed to compile shader: \n'" + shaderSource + "'\n  OpenGL: '" + gl.getShaderInfoLog( shader ) + "'" );

                switch( shaderType )
                {
                    case gl.FRAGMENT_SHADER: console.log( "  WebGL Shader Type: 'FRAGMENT_SHADER' :" + shaderSource ); break;
                    case gl.VERTEX_SHADER  : console.log( "  WebGL Shader Type: 'VERTEX_SHADER'   :" + shaderSource ); break;
                    default                : console.log( "  WebGL UNKNOWN shader type! '" + shaderType + "'" ); break;
                }

                gl.deleteShader( shader );
            }

            return shader;
        };

        var assertLocation = function( name, type ) // @params {String},{String}
        {
            if( (shader[ name ] === null) || (shader[ name ] === undefined) )
                console.info( "WebGL INFO -> Shader " + iShader + "/" + (Widget.NUM_SHADERS-1) + ", type: " + type + ", var: `" + name + "`, variable couldn't be bound -- not used?" )
        };

        var getAttribute = function( name ) // @param {String}
        {
            shader[ name ] = gl.getAttribLocation ( program, name );
            assertLocation( name, "Attribute" ); // DEBUG only
        };

        var getUniform = function( name ) // @param {String}
        {
            shader[ name ] = gl.getUniformLocation ( program, name );
            assertLocation( name, "Uniform" ); // DEBUG only
        };

        for( iShader = 0; iShader < Widget.NUM_SHADERS; ++iShader )
        {
            flags  = SHADER_SOURCE[ iShader ].flag;
            shader =
            {
                vert: shaderCompile( SHADER_SOURCE[ iShader ].vert, gl.VERTEX_SHADER   ),
                frag: shaderCompile( SHADER_SOURCE[ iShader ].frag, gl.FRAGMENT_SHADER )
            };

            program = gl.createProgram();

            gl.attachShader( program, shader.vert );
            gl.attachShader( program, shader.frag );

            gl.linkProgram( program );
            gl.useProgram ( program );

//console.log( "Shader: " + iShader + " Flags: 0x" + flags.toString(16) );
//console.info( "WebGL LINK: " + gl.getProgramInfoLog( program ) );

            if( flags & ShaderLocation.FLAG_A )
            {
                getUniform( "unAngle" );
            }

            if( flags & ShaderLocation.FLAG_C )
            {
                getAttribute( "avVertColor" );
            }

            if( flags & ShaderLocation.FLAG_D )
            {
                getUniform( "uvDimension" );
            }

            if( flags & ShaderLocation.FLAG_G2 )
            {
                getUniform( "uvGrad0" );
                getUniform( "uvGrad1" );
            }

            if( flags & ShaderLocation.FLAG_G4 )
            {
                getUniform( "uvGrad0" );
                getUniform( "uvGrad1" );
                getUniform( "uvGrad2" );
                getUniform( "uvGrad3" );
            }

            if( flags & ShaderLocation.FLAG_GS )
            {
                getUniform( "uvStops" );
            }

            if( flags & ShaderLocation.FLAG_H )
            {
                getUniform( "unHeight" );
            }

            if( flags & ShaderLocation.FLAG_K )
            {
                getUniform( "uvColor" );
            }

            if( flags & ShaderLocation.FLAG_OAR )
            {
                getUniform( "unooAspectRatio");
            }

            if( flags & ShaderLocation.FLAG_V )
            {
                getAttribute( "avPosition" );
            }

            if( flags & ShaderLocation.FLAG_T )
            {
                getAttribute( "avTexCoord" );
                getUniform  ( "utDiffuse1" );
            }

            if( flags & ShaderLocation.FLAG_W )
            {
                getUniform( "unWeight" );
            }

            // Common to all shaders
            shader.umProj  = gl.getUniformLocation( program, "umProj" );
            shader.umView  = gl.getUniformLocation( program, "umView" );
            shader.program = program;

            Widget.glShaders[ iShader ] = shader;
        }
    }

    /**
     * @memberof Widget
     * @param {String} hexColor - '#rrggbb' or '#rgb'
     * @returns Float[4]
     */
    Widget.glColorHexToFloat = function( hexColor )
    {
        var retval = [1, 1, 1, 1], len = hexColor && hexColor.length || 0;

        if( ((len === 7) || (len === 4)) && hexColor[0] === '#' )
        {
            var log2base  = ( len === 7 ) ? 8 : 4;
            var base      = 1 << log2base;
            var num       = parseInt( hexColor.substring( 1 ), 16 );
            var normalize = 1 / (base - 1);

            for( var i = 2; i >= 0; i-- )
            {
                retval[i] = (num % base) * normalize;
                num     >>= log2base;
            }
        }
        else
            console.log( "ERROR -> did not receive a well formed hex color = " + hexColor );

        return retval;
    };

    Widget.glInit = function()
    {
        var canvas, gl, i, resolver;

        resolver = function( resolve, reject )
        {
            if( _x2._config._render !== Config.RENDER_WEBGL )
                return reject(); // "silent error" -- DOM already active

            canvas                       = document.createElement( 'canvas' );
            canvas.id                    = "WebGLroot";
            canvas.width                 = _x2._config._screenW; // canvas.clientWidth
            canvas.height                = _x2._config._screenH; // canvas.clientHeight
            canvas.style.left            = "0px";
            canvas.style.top             = "0px";
            canvas.style.position        = "absolute";
            document.body.appendChild( canvas );
            Widget.glCanvas              = canvas; // x2.init() needs to remove if WebGL fails

            // https://www.khronos.org/registry/webgl/specs/1.0/#5.2.1
            gl = canvas.getContext( "webgl", { stencil:true } );

            if( !gl )
                return reject( 'Unable to create WebGL context' ); // fallback to DOM

            // SHADER_FONT needs partial derivative fwidth() for sharpness at scale > 1.0
            gl.getExtension( "OES_standard_derivatives" );

            Widget.gl    = gl;
            Widget.glW   = canvas.width;
            Widget.glH   = canvas.height;
            Widget.glOOH = 1 / Widget.glH;

            Widget.glStencilId = 0;

            Widget.glClearR = 0;
            Widget.glClearG = 0;
            Widget.glClearB = 0;
            Widget.glClearA = 0;

            Widget.glProjDepth = 0;
            Widget.glViewDepth = 0;

            Widget.glProjMatrix = [];
            Widget.glViewMatrix = [];

            Widget.glProjMatrix[0] = new Float32Array( [ 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1 ] );

            for( i = 0; i < 32; ++i ) // pre-allocate matrix stack
                Widget.glViewMatrix[ i ] = new Float32Array( [ 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1 ] );

            glShadersInit();

            gl.disable( gl.DEPTH_TEST );
            gl.disable( gl.STENCIL_TEST ); // ScrollPane will enable/disable as needed

            gl.enable( gl.BLEND );
            gl.blendFunc( gl.ONE, gl.ONE_MINUS_SRC_ALPHA ); // premultiplied alpha

            // https://www.opengl.org/wiki/Face_Culling
            gl.frontFace( gl.CCW ); // Default: GL_CCW
            gl.disable( gl.CULL_FACE ); // Default: disable

            gl.clearColor( Widget.glClearR, Widget.glClearG, Widget.glClearB, Widget.glClearA );
            gl.clearStencil( 0 );

            gl.viewport( 0, 0, Widget.glW, Widget.glH );
            glOrtho( 0, Widget.glW, Widget.glH, 0, -100, +100 );

            gl.clear( gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT );
            gl.flush();

            Widget.glFonts         = {};
            Widget.glFonts.bold    = new GlFont( "Bold"    );
            Widget.glFonts.light   = new GlFont( "Light"   );
            Widget.glFonts.medium  = new GlFont( "Medium"  );
            Widget.glFonts.regular = new GlFont( "Regular" );
            Widget.glFonts.thin    = new GlFont( "Thin"    );

            Promise.all([
                Widget.glFonts.light  .load(),
                Widget.glFonts.medium .load(),
                Widget.glFonts.bold   .load(),
                Widget.glFonts.regular.load(),
                Widget.glFonts.thin   .load()
            ]).then( resolve ).catch( reject );
        };

        return new Promise( resolver );
    };

    /** Create an WebGL texture with clamp to edge and bilinear filtering
     * @memberof Widget
     * @param   {Number}      w       - width in pixels
     * @param   {Number}      h       - height in pixels
     * @param   {Uint8Array} [texels] - pixels to initialize texture with
     * @param   {Number}     [type]   - gl.ALPHA
     * @returns {WebGLTexture}
     * Note: Widget.glInit() must be called first
     */
    Widget.glMakeTexture = function( w, h, texels, type )
    {
        var gl = Widget.gl;
        var texture = gl.createTexture();

        if( type === undefined )
            console.error( "ERROR: WebGL unknown texture type" );

        gl.bindTexture( gl.TEXTURE_2D, texture );
        gl.pixelStorei( gl.UNPACK_ALIGNMENT, 1 );

        if( texels )
        {
            if( type === gl.RGBA ) // texels === new Image()
                gl.texImage2D( gl.TEXTURE_2D, 0, type, type, gl.UNSIGNED_BYTE, texels );
            else // texels === new Uint8Array()
                gl.texImage2D( gl.TEXTURE_2D, 0, type, w, h, 0, type, gl.UNSIGNED_BYTE, texels );
        }

        // http://www.khronos.org/registry/webgl/specs/latest/
        // http://www.khronos.org/webgl/wiki/WebGL_and_OpenGL_Differences
        // non-power-of-2 textures ARE supported IF no mipmaps and clamp to edge are used
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR        );
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR        );
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S    , gl.CLAMP_TO_EDGE );
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T    , gl.CLAMP_TO_EDGE );

        gl.bindTexture( gl.TEXTURE_2D, null );

        return texture;
    };

    /**
     * Add child widget to parent
     * @memberof Widget
     * @param {Widget}  widget - Child widget
     * @param {Number} [x]     - Offset from left. Defaults to 0 px.
     * @param {Number} [y]     - Offset from top.  Defaults to 0 px.
     * @memberof Widget
     */
    Widget.prototype.addWidget = function( widget, x, y )
    {
        widget._parent = this;

        if( !x )
            x = 0;

        if( !y )
            y = 0;

        widget._curVal[Widget.X] = x;
        widget._curVal[Widget.Y] = y;

        widget._endVal[Widget.X] = x;
        widget._endVal[Widget.Y] = y;

        this._children.push( widget );
    };

    /** Starts an animation on the specified axis.
     * @param {Object}    params
     * @param {Number}   [params.a]         - Opacity; 0.0 = invisible, 1.0 = visible
     * @param {Number}   [params.alpha]     - Opacity; 0.0 = invisible, 1.0 = visible
     * @param {String}   [params.color]     - HTML 6 hex digit color
     * @param {Number}   [params.duration]  - Length of animation in milliseconds. Default is 0 ms.
     * @param {Easing}   [params.easing]    - Type of easing between start and end. Don't use Easing.LINEAR; default is Easing.QUAD_OUT if not specified
     * @param {Number}   [params.fontSize]  - Size of font in pixels
     * @param {Function} [params.onEnd]     - Callback to trigger when animation is complete
     * @param {Axis}     [params.onEndAxis] - Which axis the callback should be triggered on
     * @param {Function} [params.onInc]     - Callback to trigger while animation is active
     * @param {Number}   [params.x]         - Offset from left edge
     * @param {Number}   [params.y]         - Offset from top edge
     * @param {Number}   [params.w]         - Width
     * @param {Number}   [params.h]         - Height
     * @param {Number}   [params.xScale]    - 1.0 no scaling
     * @param {Number}   [params.yScale]    - 1.0 no scaling
     * @memberof Widget
     */
    Widget.prototype.animate = function( params )
    {
        if( params.duration === undefined || params.duration === 0 )
        {
            if( params.a !== undefined )
                this.setVal( Widget.ALPHA, params.a );

            if( params.alpha !== undefined )
                this.setVal( Widget.ALPHA, params.alpha );

            if( params.color !== undefined )
                this.setVal( Widget.FONT_COLOR, params.color );

            if( params.fontSize !== undefined )
                this.setVal( Widget.FONT_SIZE, params.fontSize );

            if( params.h !== undefined )
                this.setVal( Widget.H, params.h );

            if( params.w !== undefined )
                this.setVal( Widget.W, params.w );

            if( params.x !== undefined )
                this.setVal( Widget.X, params.x );

            if( params.xScale !== undefined )
                this.setVal( Widget.X_SCALE, params.xScale );

            if( params.y !== undefined )
                this.setVal( Widget.Y, params.y );

            if( params.yScale !== undefined )
                this.setVal( Widget.Y_SCALE, params.yScale );

            if( params.onEnd !== undefined )
                params.onEnd();
        }
        else
        {
            this._aniParams.push( params );
        }
    };

    /**
     * @memberof Widget
     */
    Widget.prototype.containsWidget = function( widget )
    {
        var retval = false;

        if( widget !== this )
        {
            for( var i = 0; i < this._children.length; i++ )
            {
                if( this._children[i].containsWidget( widget ) === true )
                {
                    retval = true;
                    break;
                }
            }
        }
        else
            retval = true;

        return retval;
    };

    Widget.prototype.destroy = function()
    {
        for( var i = 0; i < this._children.length; i++ )
            if( this._children[i].destroy )
                this._children[i].destroy();
    };

    Widget.prototype.enableMouseDownListener = function( bool )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseDownListenerEnabled = bool;

            if( this._div )
            {
                this._div.style.pointerEvents = ( bool === true )? "auto" : "none";
            }
            else {
                window.setTimeout( function() {
                    this._div.style.pointerEvents = ( bool === true )? "auto" : "none";
                }.bind(this), 500 );
            }
        }
    };

    Widget.prototype.forceUpdate = function( bool )
    {
        this._forceUpdate = bool;
    };

    /**
     * Gets the absolute x and y position of a widget
     * @memberof Widget
     * @return {Object} { x: Number, y: Number }
     * @see getX(), getY()
     */
    Widget.prototype.getGlobalPos = function()
    {
        var retval = { x: 0, y: 0 };
        var widget = this;

        while( widget )
        {
            retval.x += widget.getVal( Widget.X );
            retval.y += widget.getVal( Widget.Y );
            widget    = widget._parent;
        }

        return retval;
    };

    Widget.prototype.getHostScreen = function()
    {
        var screen, widget = this._parent;

        while( widget )
        {
            if( widget instanceof Screen )
            {
                screen = widget;
                break;
            }
            widget = widget._parent;
        }

        return screen;
    };

    Widget.prototype.getA = function()
    {
        return this.getVal( Widget.ALPHA );
    };

    Widget.prototype.getEndA = function()
    {
        return this._endVal[Widget.Axis.A];
    };

    Widget.prototype.getH = function()
    {
        return this.getVal( Widget.H );
    };

    function getRoleStr( speakRole )
    {
        var retval;

        switch( speakRole )
        {
            case "button":
                retval = "Button";
                break;

            case "listitem":
            case "_filter":
            case "_radio":
                break;

            default:
                if( speakRole )
                    console.warn( "Need to do something for speakRole = " + speakRole );
                break;
        }

        return retval;
    }

    Widget.prototype.getSpeechCustomRole = function()
    {
        return this._customSpeakRole;
    };

    Widget.prototype.getVal = function( axis )
    {
        var retval = this._endVal[axis];  // only return end value, not intermediate value???

        if( _x2._config._render === Config.RENDER_DOM )
        {
            if( this._div ) // && (_css == true || retval == undefined) )
                switch( axis )
                {
                    case Widget.ALPHA:
                        retval = parseFloat( this._div.style.opacity );
                        break;

                    case Widget.FONT_COLOR:
                        if( this._div.color )
                            retval = this._div.color;
                        break;

                    case Widget.FONT_SIZE:
                        if( this._div.style.fontSize )
                            retval = parseInt( this._div.style.fontSize );
                        break;

                    case Widget.H:
                        retval = parseFloat( this._div.offsetHeight );
                        break;

                    case Widget.OVERFLOW:
                        retval = this._div.style.overflow;
                        break;

                    case Widget.W:
                        retval = parseFloat( this._div.offsetWidth );
                        break;

                    case Widget.X:
                        retval = parseFloat( this._div.style.left );
                        break;

                    case Widget.Y:
                        retval = parseFloat( this._div.style.top );
                        break;
                }
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            retval = this._curVal[axis];  // intermediate value
        }

        return retval;
    };

    Widget.prototype.getW = function()
    {
        return this.getVal( Widget.W );
    };

    Widget.prototype.getWhiteSpace = function()
    {
        return this.getVal( Widget.TEXT_WHITE_SPACE );
    };

    Widget.prototype.getX = function()
    {
        return this.getVal( Widget.X );
    };

    Widget.prototype.getY = function()
    {
        return this.getVal( Widget.Y );
    };

    Widget.prototype.gotFocus = function( losingFocus )
    {
        if( this._onGotFocus )
            this._onGotFocus( losingFocus );
    };

    Widget.prototype.hasFocusListener = function()
    {
        return this._onGotFocus !== undefined;
    };

    /**
     * Initializer
     * @memberof Widget
     * @param {Object} [params]
     * @param {String} [params.name] - Class name over-ride
     * @returns {Widget}
     */
    Widget.prototype.init = function( params ) //TODO: get rid of params. we only need a onEnter callback.
    {
        if( params && params.name )
            this._className = params.name;

        if( this._className === undefined )
            this._className = "Widget";

//      Widget.OBJ[ this._uid = Widget.ID++ ] = this; // DEBUG Widget Animation Trace & WebGL Debug Widget Inspector

        this._selectable = false;
        this._children   = [];
        this._aniParams  = [];
        this._startTime  = new Array( Widget.NUM_VALS );
        this._startVal   = new Array( Widget.NUM_VALS );
        this._duration   = new Array( Widget.NUM_VALS );
        this._easing     = new Array( Widget.NUM_VALS );
        this._endVal     = new Array( Widget.NUM_VALS );
        this._onEnd      = new Array( Widget.NUM_VALS );
        this._onInc      = new Array( Widget.NUM_VALS );

        this._endVal[Widget.ALPHA]   = 1;
        this._endVal[Widget.X]       = 0;
        this._endVal[Widget.X_SCALE] = 1;
        this._endVal[Widget.Y]       = 0;
        this._endVal[Widget.Y_SCALE] = 1;

        this._curVal = this._endVal.slice(); // Note: WebGL only as DOM uses _div for current values

        if( params )
        {
            if( params.onEnter )
                this._onEnter = params.onEnter;
        }

        return this;
    };

    Widget.prototype.isAnimating = function( axis )
    {
        var i, retval = false;

        if( axis !== undefined )
        {
            if( this._startTime[axis] !== undefined )
                retval = true;
        }
        else
        {
            for( i = 0; i < Widget.NUM_VALS; i++ )
                if( this._startTime[i] !== undefined )
                {
                    retval = true;
                    break;
                }
        }

        return retval;
    };

    Widget.prototype.lostFocus = function( gettingFocus )
    {
        if( this._onLostFocus )
            this._onLostFocus( gettingFocus );
    };

    Widget.prototype.onEnter = function()
    {
        if( this._onEnter )
            this._onEnter();
    };

    Widget.prototype.patchWidget = function()
    {
        this.resourcesLoad();
        this.resourcesLoaded();
    };

    Widget.prototype.processEvent = function( val, type )
    {
        var retval = false;  // default

//         switch( val )
//         {
//             case KEY_DOWN:
//                 if( this._downListener && type === KEY_PRESSED )
//                 {
//                     retval = true;
//                     _x2.requestFocus( this._downListener, val );
//
//                 }
//
//                 //NOTE: _downListenerFn should be independent of _downListener. there are situations where we want to call a function but don't have a focus listener
//                 if( this._downListenerFn && type === KEY_PRESSED )
//                     this._downListenerFn();
//
//                 break;
//
//             case KEY_LEFT:
//                 if( this._leftListener && type === KEY_PRESSED )
//                 {
//                     retval = true;
//                     _x2.requestFocus( this._leftListener, val );
//
//                     if( this._leftListenerFn )
//                         this._leftListenerFn();
//                 }
//                 break;
//
//             case KEY_RIGHT:
//                 if( this._rightListener && type === KEY_PRESSED )
//                 {
//                     retval = true;
//                     _x2.requestFocus( this._rightListener, val );
//
//                     if( this._rightListenerFn )
//                         this._rightListenerFn();
//                 }
//                 break;
//
//             case KEY_UP:
//                 if( this._upListener && type === KEY_PRESSED )
//                 {
//                     retval = true;
//                     _x2.requestFocus( this._upListener, val );
//
//                 }
//
//                 if( this._upListenerFn && type === KEY_PRESSED )
//                     this._upListenerFn();
//
//                 break;
//         }

        return retval;
    };

    Widget.prototype.removeAllWidgets = function()
    {
        this._children = [];

        if( _x2._config._render === Config.RENDER_DOM )
        {
            if( this._div )
                while( this._div.childNodes.length > 0 )
                    this._div.removeChild( this._div.childNodes[0] );
        }
    };

    Widget.prototype.removeWidget = function( child )
    {
        var index = -1;
        var type  = typeof( child );
        var widget;

        if( this._children.length > 0 )
        {
            if( type === "object" )
            {
                for( var i = 0; i < this._children.length; i++ )
                    if( this._children[i] === child )
                    {
                        index  = i;
                        widget = this._children[i];
                        break;
                    }
            }
            else if( type === "number" )
            {
                index  = child;
                widget = this._children[index];
            }
            else
                console.error( "ERROR -> don't know how to remove type = " + type );

            if( index >= 0 && index < this._children.length )
                this._children.splice( index, 1 );
            else
                console.error( "ERROR -> attempting to remove an invalid index = " + index + ", num children = " + this._children.length );

            if( widget )
            {
                if( _x2._config._render === Config.RENDER_DOM )
                    if( widget._div )
                        this._div.removeChild( widget._div );

                widget.destroy();
            }
        }
        else
            console.error( "ERROR -> trying to remove from a widget with no children, child = " + child );
    };

    Widget.prototype.resourcesLoad = function()
    {
        if( _x2._config._render === Config.RENDER_DOM )
        {
            if( this._div === undefined )
                this._div = document.createElement( 'div' );

            if( this._className )
                this._div.id = this._className;

            this._curVal[Widget.ALPHA] = this._endVal[Widget.ALPHA];

            this._div.style.position  = 'absolute';
            this._div.style.opacity   = this._endVal[Widget.ALPHA];
            this._div.style.left      = this._endVal[Widget.X] + "px";
            this._div.style.top       = this._endVal[Widget.Y] + "px";
            this._div.style.transform = "scale(" + this._endVal[Widget.X_SCALE] + "," + this._endVal[Widget.Y_SCALE] + ")";

            if( this._endVal[Widget.W] !== undefined )
                this._div.style.width = this._endVal[Widget.W] + "px";

            if( this._endVal[Widget.H] !== undefined )
                this._div.style.height = this._endVal[Widget.H] + "px";

            if( this._endVal[Widget.OVERFLOW] !== undefined )
                this._div.style.overflow = this._endVal[Widget.OVERFLOW];

            if( _x2._config._cursorEnabled === true )
            {
                if( this._clickListener )
                    this._div.onclick = this._clickListener;

                if( this._mouseDownListener )
                    this._div.onmousedown = this._mouseDownListener;

                if( this._mouseMoveListener )
                    this._div.onmousemove = this._mouseMoveListener;

                if( this._mouseOutListener )
                    this._div.onmouseout = this._mouseOutListener;

                if( this._mouseOverListener )
                    this._div.onmouseover = this._mouseOverListener;

                if( this._mouseEnterListener )
                    this._div.onmouseenter = this._mouseEnterListener;

                if( this._mouseUpListener )
                    this._div.onmouseup = this._mouseUpListener;

                if( this._mouseWheelListener )
                    this._div.onmousewheel = this._mouseWheelListener;

                if( (this._clickListener || this._mouseDownListener || this._mouseMoveListener || this._mouseUpListener || this._mouseWheelListener || this._mouseEnterListener ) && this._mouseDownListenerEnabled )
                    this._div.style.pointerEvents = "auto";
                else
                    this._div.style.pointerEvents = "none";
            }

            if( this._onClickEvent ) {
                this._div.classList.add('customClickEvent');
                this._div.customClickEvent = this._onClickEvent;
            }
            this._div.style.WebkitUserSelect = "none";
            this._div.style.UserSelect       = "none";
            this._div.style.cursor           = "default";

            for( var i = 0; i < this._children.length; i++ )
                this._children[i].resourcesLoad( this._div );

            if( this._parent )
                this._parent._div.appendChild( this._div );
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            for( i = 0; i < this._children.length; ++i )
                this._children[i].resourcesLoad( this );
        }
    };

    Widget.prototype.resourcesLoaded = function()
    {
        for( var i = 0; i < this._children.length; i++ )
            if( this._children[i].resourcesLoaded )
                this._children[i].resourcesLoaded();
    };

    Widget.prototype.resourcesUnload = function()
    {
        for( var i = 0; i < this._children.length; i++ )
            if( this._children[i].resourcesUnload )
                this._children[i].resourcesUnload();
    };

    Widget.prototype.setA = function( val )
    {
//      Widget.animTraceSet( this, Widget.ALPHA, val ); // DEBUG Widget Animation Trace
        this.setVal( Widget.ALPHA, val );
        return this;
    };

    Widget.prototype.setClickListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._clickListener = listener;

            if( this._div )
                this._div.onclick = listener;
            else {
                window.setTimeout( function() {
                    this._div.onclick = listener;
                }.bind(this), 500 );
            }

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setFocusListeners = function( onGotFocus, onLostFocus )
    {
        this._onGotFocus  = onGotFocus;
        this._onLostFocus = onLostFocus;
    };

    Widget.prototype.setH = function( val )
    {
//      Widget.animTraceSet( this, Widget.H, val ); // DEBUG Widget Animation Trace
        this.setVal( Widget.H, val );
        return this;
    };

    Widget.prototype.setMouseDownListener = function( listener )
    {
        if( listener ) {
            this._onClickEvent = listener;
        }

        if( _x2._config._cursorEnabled === true )
        {
            this._mouseDownListener = listener;

            if( this._div )
                this._div.onmousedown = listener;

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseMoveListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseMoveListener = listener;

            if( this._div )
                this._div.onmousemove = listener;
            else {
                window.setTimeout( function() {
                    this._div.onmousemove = listener;
                }.bind(this), 500);
            }

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseOutListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseOutListener = listener;

            if( this._div )
                this._div.onmouseout = listener;
            else {
                window.setTimeout( function() {
                    this._div.onmouseout = listener;
                }.bind(this), 500);
            }

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseOverListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseOverListener = listener;

            if( this._div )
                this._div.onmouseover = listener;
            else {
                window.setTimeout( function() {
                    this._div.onmouseover = listener;
                }.bind(this), 500);
            }

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseEnterListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseEnterListener = listener;

            if( this._div )
                this._div.onmouseenter = listener;
            else {
                window.setTimeout( function() {
                    this._div.onmouseenter = listener;
                }.bind(this), 500);
            }

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseUpListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseUpListener = listener;

            if( this._div )
                this._div.onmouseup = listener;

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setMouseWheelListener = function( listener )
    {
        if( _x2._config._cursorEnabled === true )
        {
            this._mouseWheelListener = listener;

            if( this._div )
                this._div.onwheel = listener;

            this.enableMouseDownListener( true );
        }
    };

    Widget.prototype.setScale = function( val )
    {
        this.setVal( Widget.X_SCALE, val );
        this.setVal( Widget.Y_SCALE, val );
    };

    Widget.prototype.setScaleX = function( val )
    {
        this.setVal( Widget.X_SCALE, val );
    };

    Widget.prototype.setScaleY = function( val )
    {
        this.setVal( Widget.Y_SCALE, val );
    };

    Widget.prototype.setSpeechCustomRole = function( speakRole )
    {
        this._customSpeakRole = speakRole;
    };

    Widget.prototype.setSpeechParams = function( speakLabel, speakRole, focusTarget, noFocus, selected )
    {
        if( this._div && _x2._config._speech === true )
        {
            var role  = getRoleStr( speakRole );
            var isStr = this instanceof StringWidget;

            if( speakRole === "_filter" )
            {
                speakLabel = "Filter. Selected";
                speakRole  = "listitem";
            }
            else if( speakRole === "_radio" )
            {
                speakLabel = "Button. " + (selected === true ? "Selected" : "Unselected");
                speakRole  = "listitem";
            }

            focusTarget._speakRole = speakRole;
            this._div.removeAttribute( "aria-label" );

            if( isStr === true && this.getText() )
                focusTarget._speakStr = this.getText().replace( /(<([^>]+)>)/ig, "" );
            else
                focusTarget._speakStr = undefined;

            if( speakLabel !== undefined )
            {
                if( focusTarget._speakStr )
                    focusTarget._speakStr += ". " + speakLabel;
                else
                    focusTarget._speakStr = speakLabel;

                if( _x2._modSpeech !== true && isStr === true && this.getText() )
                {
                    var str = this.getText().replace( /(<([^>]+)>)/ig, "" ) + " ";

                    if( role )
                        str += role + ". ";

                    this._div.setAttribute( "aria-label", str + speakLabel );
                }
                else
                    this._div.setAttribute( "aria-label", speakLabel );
            }

            if( _x2._modSpeech !== true && isStr === true && speakLabel !== undefined )
                this._div.setAttribute( "role", _x2._useListitem === true? "listItem" : undefined );
            else if( speakRole === undefined && _x2._useListitem === true )
                this._div.setAttribute( "role", "listitem" );
            else
                this._div.setAttribute( "role", speakRole );

            this._div.setAttribute( 'tabindex', '0' );
            this._div.style.outline = "none";

            if( noFocus !== true )
            {
                if( document.activeElement === this._div )
                    this._div.blur();

                this._div.focus();
            }
        }
    };

    Widget.prototype.setVal = function( axis, val )
    {
        this._endVal[axis] = val;

        if( _x2._config._render === Config.RENDER_DOM )
        {
            if( this._div )
            {
                switch( axis )
                {
                    case Widget.ALPHA:
                        this._div.style.opacity = val;
                        this._curVal[axis]      = val;
                        break;

                    case Widget.FONT_COLOR:
                        this._div.style.color = val;
                        break;

                    case Widget.FONT_SIZE:
                        this._div.style.fontSize = val + "px";
                        break;

                    case Widget.H:
                        this._div.style.height =  ( val === undefined ) ? "" : val + "px";
                        break;

                    case Widget.TEXT_WHITE_SPACE:
                        this._div.style.whiteSpace = val;
                        break;

                    case Widget.OVERFLOW:
                        this._div.style.overflow = val;
                        break;

                    case Widget.W:
                        this._div.style.width = ( val === undefined ) ? "" : val + "px";
                        break;

                    case Widget.X:
                        this._div.style.left = val + "px";
                        break;

                    case Widget.X_SCALE:
                        this._div.style.transform = "scale(" + val + "," + this._endVal[Widget.Y_SCALE] + ")";
                        break;

                    case Widget.Y:
                        this._div.style.top = val + "px";
                        break;

                    case Widget.Y_SCALE:
                        this._div.style.transform = "scale(" + this._endVal[Widget.X_SCALE] + "," + val + ")";
                        break;
                }
            }
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._startVal[axis] = val;
            this._curVal  [axis] = val;
        }
    };

    Widget.prototype.setW = function( val )
    {
//      Widget.animTraceSet( this, Widget.W, val ); // DEBUG Widget Animation Trace
        this.setVal( Widget.W, val );
        return this;
    };

    Widget.prototype.setWhiteSpace = function( val )
    {
        this.setVal( Widget.TEXT_WHITE_SPACE, val );
        return this;
    };

    Widget.prototype.setX = function( val )
    {
//      Widget.animTraceSet( this, Widget.X, val ); // DEBUG Widget Animation Trace
        this.setVal( Widget.X, val );
        return this;
    };

    Widget.prototype.setY = function( val )
    {
//      Widget.animTraceSet( this, Widget.Y, val ); // DEBUG Widget Animation Trace
        this.setVal( Widget.Y, val );
        return this;
    };

    /**
     * @memberof Widget
     * @param {Number}  [axis]         - Which axis to stop animating, or all of them if undefined
     * @param {Boolean} [callEnd=true] - If the axis has an end callback, should we call it
     */
    Widget.prototype.stopAnimation = function( axis, callEnd )
    {
        var i;

        if( axis !== undefined )
        {
            for( i = 0; i < this._aniParams.length; i++ )
                delete this._aniParams[i][Widget.Axis.Str[axis]];

            this._startTime[axis] = undefined;

            if( callEnd === true || callEnd === undefined )
            {
                if( this._onEnd[axis] )
                    this._onEnd[axis]();

                this._onEnd[axis] = undefined;
            }
        }
        else
        {
            this._aniParams = [];

            for( i = 0; i < Widget.Axis.NUM_VALS; i++ )
            {
                this._startTime[i] = undefined;

                if( callEnd === true || callEnd === undefined )
                {
                    if( this._onEnd[i] )
                        this._onEnd[i]();

                    this._onEnd[i] = undefined;
                }
            }
        }
    };

    Widget.prototype.interpolateColor = function( fraction, start, finish )
    {
        var retval;

        if( start && finish )
        {
            var startNum  = parseInt( start.substring ( 1 ), 16 );
            var finishNum = parseInt( finish.substring( 1 ), 16 );
            var r         = (((startNum & 0xff0000) + fraction * ((finishNum & 0xff0000) - (startNum & 0xff0000))) & 0xff0000) >> 16;
            var g         = (((startNum & 0x00ff00) + fraction * ((finishNum & 0x00ff00) - (startNum & 0x00ff00))) & 0x00ff00) >>  8;
            var b         = (((startNum & 0x0000ff) + fraction * ((finishNum & 0x0000ff) - (startNum & 0x0000ff))) & 0x0000ff);
            var rStr      = (r < 16) ? "0" + r.toString( 16 ) : r.toString( 16 );
            var gStr      = (g < 16) ? "0" + g.toString( 16 ) : g.toString( 16 );
            var bStr      = (b < 16) ? "0" + b.toString( 16 ) : b.toString( 16 );

            retval = "#" + rStr + gStr + bStr;
        }

        return retval;
    };

    Widget.prototype.update = function( step )
    {
        var child, axis, val, params, xScale, yScale, w, h, curVal;
        var p, v, t, m, k;

        while( params = this._aniParams.shift() )
        {
            for( var key in params )
            {
                val = params[key];

                switch( key )
                {
                    case "a":
                    case "alpha":
                        axis = Widget.ALPHA;
                        break;

                    case "color":
                        axis = Widget.FONT_COLOR;
                        break;

                    case "fontSize":
                        axis = Widget.FONT_SIZE;
                        break;

                    case "h":
                        axis = Widget.H;
                        break;

                    case "w":
                        axis = Widget.W;
                        break;

                    case "x":
                        axis = Widget.X;
                        break;

                    case "xScale":
                        axis = Widget.X_SCALE;
                        break;

                    case "y":
                        axis = Widget.Y;
                        break;

                    case "yScale":
                        axis = Widget.Y_SCALE;
                        break;
                }

                if( axis !== undefined )
                {
                    this._startTime[axis] = params.start ? step + params.start : step;
                    this._startVal [axis] = this._endVal[axis];
                    this._duration [axis] = params.duration;
                    this._easing   [axis] = params.easing;
                    this._endVal   [axis] = val;
                    this._onEnd    [axis] = params.onEndAxis !== undefined ? ( axis === params.onEndAxis ? params.onEnd : undefined ) : params.onEnd;
                    this._onInc    [axis] = params.onInc;

                    // TODO: Decide if this is the bast place to set a valid start value for an animation of a widget axis.
                    // Don't like Widget having to be aware of ImageWidget or any other future widgets that can have a valid
                    // value of undefined. Should be cleaner.

                    if( this._startVal[axis] === undefined )
                    {
                        if( this instanceof ImageWidget )
                        {
                            if( axis === Widget.W )
                                this._startVal[axis] = this.getW();
                            else if( axis === Widget.H )
                                this._startVal[axis] = this.getH();
                            else
                            {
                                console.error( "ERROR -> animation initiated without a valid start value on axis = " + axis );
                                console.log( this );
                            }
                        }
                        else
                        {
                            console.error( "ERROR -> animation initiated without a valid start value on axis = " + axis );
                            console.log( this );
                        }
                    }
                }

                axis = undefined;
            }

            params = undefined;
        }

        for( axis = 0; axis < Widget.NUM_VALS; ++axis )
        {
            if( step > this._startTime[axis] )
            {
                if( step < (this._startTime[axis] + this._duration[axis]) )
                {
                    // In   : function(p) { return ...          }
                    // Out  : function(p) { return 1 - In(1-p); } // flipped Y - mirrored X
                    // InOut: function(p) { if (t < 1) return Left ;
                    //                      else       return Right; }
                    //        Left : remap p=[0,0.5] to p=[0,1] =       {1/2 * In (2*p)  } =       (0.5 * In (t  ));
                    //        Right: remap p=[0.5,1] to p=[0,1] = 1/2 + {1/2 * Out(2*p-1)} = 0.5 + (0.5 * Out(t-1));
                    //        Left and Right are joined together so they are continuous at p=0.5 -> v=0.5 (Exception is Elastic InOut)
                    // NOTE: Reference: cirrusTools/easing_verification/easing.js for original jQuery and optimized single-argument verification
                    p = (step - this._startTime[axis]) / this._duration [axis]; // normalized percent (usually named standard 't' blend param)
                    v =     0; // calculated blend value based on elapsed percentage: In(p), Out(p), InOut(p) -> In(2*p) or Out(2*p-1)
                    t = p * 2; // Times2 = EaseInOut: In(t) or Out(t-1); (t<1) = Left half, (t>1) = Right half
                    m = p - 1; // Minus  = shift x offset: p=<0,1> -> <-1,0>; common refactor term for 1+(1-p)^# and 1-(p-1)^#

                    // TODO: FIXME: Clamp (p<=0) v=0 (p>=1) v=1 ??
                    // if( p <= 0 ) v = 0;
                    // else
                    // if( p >= 1 ) v = 1;
                    // else
                    switch( this._easing[axis] || Widget.Easing.QUAD_OUT )
                    {
                        // NOTE: jQuery UI defines a non-standard 'Back' using "constants swapped" smoothstep via K=2: function Back( p ) { return p*p*(3*p - 2); },
                        // The magic Number K = 1.70158 is chosen where minimum of f(x) is -10%
                        case Widget.Easing.BACK_IN       : k = 1.70158        ;             v = p*p*(p*(k+1) - k);                                     break;
                        case Widget.Easing.BACK_IN_OUT   : k = 1.70158 * 1.525; if( t < 1 ) v = p*t*(t*(k+1) - k); else v = 1 + 2*m*m*(2*m*(k+1) + k); break; // Factored 0.5 out
                        case Widget.Easing.BACK_OUT      : k = 1.70158        ;                                         v = 1 +   m*m*(  m*(k+1) + k); break;

                        case Widget.Easing.BOUNCE_IN     :             v =     easeBounceIn( p );                                          break;
                        case Widget.Easing.BOUNCE_IN_OUT : if( t < 1 ) v = 0.5*easeBounceIn( t ); else v = 0.5 + 0.5*easeBounceOut( t-1 ); break;
                        case Widget.Easing.BOUNCE_OUT    :                                             v =           easeBounceOut(  p  ); break;

                        case Widget.Easing.CIRC_IN       :             v = 1-Math.sqrt( 1 - p*p   );                                              break;
                        case Widget.Easing.CIRC_IN_OUT   : if( t < 1 ) v = 1-Math.sqrt( 1 - t*t ); else v = Math.sqrt( 1 - 4*m*m ) + 1; v *= 0.5; break;  // Factored 0.5 out
                        case Widget.Easing.CIRC_OUT      :                                              v = Math.sqrt( 1 - m*m );                 break;

                        case Widget.Easing.ELASTIC_IN    : k = (40*m    - 3) * Math.PI/6 ; if( p <= 0 ) v = 0; else if( p >= 1 ) v = 1; else             v =       -Math.pow( 2, 10*m    ) * Math.sin( k );                                                           break;
                        case Widget.Easing.ELASTIC_IN_OUT: k = (80*(t-1)- 9) * Math.PI/18; if( p <= 0 ) v = 0; else if( p >= 1 ) v = 1; else if( t < 1 ) v = -0.5 * Math.pow( 2, 10*(t-1)) * Math.sin( k ); else v = 1 + 0.5*Math.pow( 2,-10*(t-1)) * Math.sin( k );  break;
                        case Widget.Easing.ELASTIC_OUT   : k = (40*-p   - 3) * Math.PI/6 ; if( p <= 0 ) v = 0; else if( p >= 1 ) v = 1; else                                                                     v = 1     +(Math.pow( 2, 10*-p   ) * Math.sin( k )); break;

                        // NOTE: jQuery UI mislabels 'sextic' as 'expo' which is different from Robert Penner's original 'expo'
                        case Widget.Easing.EXPO_IN       : if( p <= 0 ) v = 0; else             v = Math.pow( 2, 10*m );                                            break;
                        case Widget.Easing.EXPO_IN_OUT   : if( p <= 0 ) v = 0; else
                                                         if( p >= 1 ) v = 1; else if( t < 1 ) v = Math.pow( 2, 10*(t-1)-1); else v = 1-Math.pow( 2, -10*(t-1)-1); break; // Factored 0.5 out
                        case Widget.Easing.EXPO_OUT      : if( p >= 1 ) v = 1; else                                                v = 1-Math.pow( 2, -10*p );      break;

                        case Widget.Easing.LINEAR        : v = p;               break; // v=p^1
                        case Widget.Easing.QUAD_IN       : v = p*p;             break; // v=p^2 = Math.pow(p,2)
                        case Widget.Easing.CUBIC_IN      : v = p*p*p;           break; // v=p^3 = Math.pow(p,3)
                        case Widget.Easing.QUART_IN      : v = p*p*p*p;         break; // v=p^4 = Math.pow(p,4)
                        case Widget.Easing.QUINT_IN      : v = p*p*p*p*p;       break; // v=p^5 = Math.pow(p,5)
                        case Widget.Easing.SEXTIC_IN     : v = p*p*p*p*p*p;     break; // v=p^6 = Math.pow(p,6)
                        case Widget.Easing.SEPTIC_IN     : v = p*p*p*p*p*p*p;   break; // v=p^7 = Math.pow(p,7)
                        case Widget.Easing.OCTIC_IN      : v = p*p*p*p*p*p*p*p; break; // v=p^8 = Math.pow(p,8)

                        case Widget.Easing.QUAD_OUT      : v = 1-m*m;             break; // 1-(1-p)^2 = 1-(1-2p+p^2) = 1-(p-1)^2 = 1-m*m    Alternate:. p*(2-p)
                        case Widget.Easing.CUBIC_OUT     : v = 1+m*m*m;           break; // 1-(1-p)^3 = 1-(1-...p^3) = 1-(p-1)^3 = 1+m*m*m
                        case Widget.Easing.QUART_OUT     : v = 1-m*m*m*m;         break;
                        case Widget.Easing.QUINT_OUT     : v = 1+m*m*m*m*m;       break;
                        case Widget.Easing.SEXTIC_OUT    : v = 1-m*m*m*m*m*m;     break;
                        case Widget.Easing.SEPTIC_OUT    : v = 1+m*m*m*m*m*m*m;   break;
                        case Widget.Easing.OCTIC_OUT     : v = 1-m*m*m*m*m*m*m*m; break;

                        case Widget.Easing.QUAD_IN_OUT   : if( t < 1 ) v = p*t;             else v = 1-m*m            *  2; break;
                        case Widget.Easing.CUBIC_IN_OUT  : if( t < 1 ) v = p*t*t;           else v = 1+m*m*m          *  4; break;
                        case Widget.Easing.QUART_IN_OUT  : if( t < 1 ) v = p*t*t*t;         else v = 1-m*m*m*m        *  8; break;
                        case Widget.Easing.QUINT_IN_OUT  : if( t < 1 ) v = p*t*t*t*t;       else v = 1+m*m*m*m*m      * 16; break;
                        case Widget.Easing.SEXTIC_IN_OUT : if( t < 1 ) v = p*t*t*t*t*t;     else v = 1-m*m*m*m*m*m    * 32; break;
                        case Widget.Easing.SEPTIC_IN_OUT : if( t < 1 ) v = p*t*t*t*t*t*t;   else v = 1+m*m*m*m*m*m*m  * 64; break;
                        case Widget.Easing.OCTIC_IN_OUT  : if( t < 1 ) v = p*t*t*t*t*t*t*t; else v = 1-m*m*m*m*m*m*m*m*128; break;

                        case Widget.Easing.SINE_IN       : v =        1 - Math.cos( p * Math.PI*0.5 ) ; break;
                        case Widget.Easing.SINE_IN_OUT   : v = 0.5 * (1 - Math.cos( p * Math.PI     )); break;
                        case Widget.Easing.SINE_OUT      : v =            Math.sin( p * Math.PI*0.5 ) ; break;
                    }

                    val = this._startVal[axis] + v * (this._endVal[axis] - this._startVal[axis]);

/* // WebGL Animation Inspector
                    if( X2.SingleStep ) {
                        console.log( "#%d  @%d  $%d.Widget: %s  Axis: %s  Start: %o  End: %o  Delta: %o  v: %o  val: %o"
                            , X2.SingleStepFrame
                            , X2.SingleStepStartTime
                            , this._uid
                            , this._className
                            , Widget.Axis.Str[axis]
                            , this._startVal[axis]
                            , this._endVal[axis]
                            ,(this._endVal[axis] - this._startVal[axis])
                            , v
                            , val
                        );
                    }
// */
//                  Widget.animTraceLog( this, axis, val, false, step ); // DEBUG Widget Animation Trace

                    if( _x2._config._render === Config.RENDER_DOM  && this._div )
                    {
                        switch( axis )
                        {
                            case Widget.ALPHA:
                                curVal                  = this._curVal[Widget.ALPHA];
                                this._div.style.opacity = val;
                                this._curVal[axis]      = val;

                                if( this._deepHide === true )
                                {
                                    if( curVal !== 0 && val === 0 )
                                        this._div.style.display = "none";
                                    else if( curVal === 0 && val !== 0 )
                                        this._div.style.display = "";
                                }
                                break;

                            case Widget.FONT_COLOR:
                                this._div.style.color = this.interpolateColor( v, this._startVal[axis], this._endVal[axis] );
                                break;

                            case Widget.FONT_SIZE:
                                this._div.style.fontSize = val + "px";
                                break;

                            case Widget.H:
                                this._div.style.height = val + "px";
                                break;

                            case Widget.W:
                                this._div.style.width = val + "px";
                                break;

                            case Widget.X:
                                this._div.style.left = val + "px";
                                break;

                            case Widget.X_SCALE:
                                xScale = val;
                                break;

                            case Widget.Y:
                                this._div.style.top = val + "px";
                                break;

                             case Widget.Y_SCALE:
                                yScale = val;
                                break;
                        }
                    }
                    else if( _x2._config._render === Config.RENDER_WEBGL )
                    {
                        if( axis === Widget.FONT_COLOR )
                            this._curVal[axis] = this.interpolateColor( v, this._startVal[axis], this._endVal[axis] );
                        else
                            this._curVal[axis] = val; // Do NOT use setVal() as that sets endVal
                    }

                    if( this._onInc[axis] )
                        this._onInc[axis]( v );
                }
                else
                {
                    val = this._endVal[axis];

//                  Widget.animTraceLog( this, axis, val, true, step ); // DEBUG Widget Animation Trace

                    if( _x2._config._render === Config.RENDER_DOM && this._div )
                    {
                        switch( axis )
                        {
                            case Widget.ALPHA:
                                curVal                  = this._curVal[Widget.ALPHA];
                                this._div.style.opacity = val;
                                this._curVal[axis]      = val;

                                if( this._deepHide === true )
                                {
                                    if( curVal !== 0 && val === 0 )
                                        this._div.style.display = "none";
                                    else if( curVal === 0 && val !== 0 )
                                        this._div.style.display = "";
                                }
                                break;

                            case Widget.FONT_COLOR:
                                this._div.style.color = val;
                                break;

                            case Widget.FONT_SIZE:
                                this._div.style.fontSize = val + "px";
                                break;

                            case Widget.H:
                                this._div.style.height = val + "px";
                                break;

                            case Widget.W:
                                this._div.style.width = val + "px";
                                break;

                            case Widget.X:
                                this._div.style.left = val + "px";
                                break;

                            case Widget.X_SCALE:
                                xScale = val;
                                break;

                            case Widget.Y:
                                this._div.style.top = val + "px";
                                break;

                            case Widget.Y_SCALE:
                                yScale = val;
                                break;
                        }
                    }
                    else if( _x2._config._render === Config.RENDER_WEBGL )
                    {
                        this._curVal[axis] = val;
                    }

                    this._startTime[axis] = undefined;

                    if( this._onEnd[axis] )
                        this._onEnd[axis]();

                    this._onEnd[axis] = undefined;
                }

                if( xScale !== undefined || yScale !== undefined )
                {
                    if( xScale === undefined )
                        xScale = 1;

                    if( yScale === undefined )
                        yScale = 1;

                    if( _x2._config._render === Config.RENDER_DOM )
                        this._div.style.transform = "scale(" + xScale + "," + yScale + ")";
                }
            }
        }

        for( child = 0; child < this._children.length; child++ )
            if( _x2._config._minDraw !== true || this._children[child]._forceUpdate === true || this._children[child]._curVal[0] > 0 || this._children[child]._endVal[0] > 0 || this._children[child]._aniParams.length > 0 )
                this._children[child].update( step );
    };

    Widget.prototype.glRender = function( alphaParent )
    {
        var child, val = this._curVal[ Widget.ALPHA ] * alphaParent, xScale, yScale, w, h;

        Widget.glViewMatrix[ Widget.glViewDepth + 1 ]  = Widget.glViewMatrix[ Widget.glViewDepth++ ].slice();
        Widget.glViewMatrix[ Widget.glViewDepth ][12] += this._curVal[ Widget.X ]; // current interpolated values, not end vals
        Widget.glViewMatrix[ Widget.glViewDepth ][13] += this._curVal[ Widget.Y ];

        xScale = this._curVal[Widget.X_SCALE];
        yScale = this._curVal[Widget.Y_SCALE];

        if( xScale !== 1 )
        {
            w = this._curVal[ Widget.W ] || 0;
            Widget.glViewMatrix[ Widget.glViewDepth ][ 0] *= xScale;
            Widget.glViewMatrix[ Widget.glViewDepth ][12] -= (xScale-1)*w*0.5;
        }

        if( yScale !== 1 )
        {
            h = this._curVal[ Widget.H ] || 0;
            Widget.glViewMatrix[ Widget.glViewDepth ][ 5] *= yScale;
            Widget.glViewMatrix[ Widget.glViewDepth ][13] -= (yScale-1)*h*0.5;
        }

/* WebGL Debug Widget Inspector
            if( _x2._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector: ALT, [, ]
            {
                if( Widget.glDebugIdx === Widget.glDebugInspect )
                {
                    w = this.getW(); // _curVal[ Widget.W ];
                    h = this.getH(); // _curVal[ Widget.H ];

                    if( !w ) w = _x2._config._screenW;
                    if( !h ) h = _x2._config._screenH;

                    w--;
                    h--;

                    xScale = Widget.glViewMatrix[ Widget.glViewDepth ][12];
                    yScale = Widget.glViewMatrix[ Widget.glViewDepth ][13];

                    Widget.glDebugOutline[0].setX( xScale ); // Top
                    Widget.glDebugOutline[0].setY( yScale );
                    Widget.glDebugOutline[0].setW( w );

                    Widget.glDebugOutline[1].setX( xScale     ); // Bot
                    Widget.glDebugOutline[1].setY( yScale + h );
                    Widget.glDebugOutline[1].setW( w );

                    Widget.glDebugOutline[2].setX( xScale ); // Left
                    Widget.glDebugOutline[2].setY( yScale );
                    Widget.glDebugOutline[2].setH( h );

                    Widget.glDebugOutline[3].setX( xScale + w ); // Right
                    Widget.glDebugOutline[3].setY( yScale );
                    Widget.glDebugOutline[3].setH( h );
                }

                if( Widget.glWidgetCapture )
                    Widget.glWidgetsRendered.push( this );

                Widget.glDebugIdx++;
            }
// */
        // Note: Every Widget that has a render() also has Widget.prototype.constructor.SHADER
        // except for ScrollWidget which has a dummy ScrollWidget.prototype.constructor.SHADER
        if( this.render && (val > 0) )
        {
            Widget.glShaderPrev  = Widget.glShaderNext;
            Widget.glShaderNext  = this.constructor.SHADER;
            if( Widget.glShaderNext != Widget.glShaderPrev )
            {
                Widget.glShaderThis = Widget.glShaders[ Widget.glShaderNext ];
                Widget.gl.useProgram( Widget.glShaderThis.program );
            }

            Widget.gl.uniformMatrix4fv( Widget.glShaderThis.umProj, false, Widget.glProjMatrix[ Widget.glProjDepth ] );
            Widget.gl.uniformMatrix4fv( Widget.glShaderThis.umView, false, Widget.glViewMatrix[ Widget.glViewDepth ] );

            this.render( val );
        }

        for( child = 0; child < this._children.length; child++ )
            this._children[child].glRender( val ); // val = current alpha --> parent's alpha of child

        if( this.postRender && (val > 0) )
            this.postRender( val );

        --Widget.glViewDepth;
    };

    return Widget;

})();


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.FavoritesWidget = (function()
{
    "use strict";

    FavoritesWidget.prototype = new Widget();

    function FavoritesWidget(){}

    FavoritesWidget.prototype.gotFocus = function()
    {
        if( this._list && this._list.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._list, true ) );
        else
            this.speak( this );
    };

    FavoritesWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className  = "FavoritesWidget";
        this._path       = params.path;
        this._selectable = true;

        this.setW( _x2._config._screenW );

        this._distractor = new DistractorWidget().init();

        var self = this;

        this._emptyMessage = new EmptyMessageWidget().init( EmptyMessageWidget.Key.FAVORITES );
        this.addWidget( this._emptyMessage, Style._safeLeft );

        var setDistractor = function()
        {
            setTimeout( function()
            {
                self._distractor.centerOnWidget( self );
                self._distractor.show();
            },1);
        };

        this._distractor.addReadyCallback( setDistractor );
        this.addWidget( this._distractor );

        return this;
    };

    FavoritesWidget.prototype.loadData = function( listIndex )
    {
        var fail, self = this, rows = [], types = [], success, hasFocus;

        if( this._list )
        {
            this._list.setA( 0 );
            this._list._selectable = false;
        }

        this._distractor.show();

        success = function( response )
        {
            self._distractor.hide();

            var i, type, row, data = response.getEmbeddedBrowseItems();

            for( i=0; i<data.length; i++ )
            {
                row = data[i];

                switch( row.getChildRenderStyle() )
                {
                    case XtvApi.EntityRenderStyle.POSTER:
                        type = GalleryRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.PROMO:
                        type = PromoRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.NETWORK:
                        type = NetworkRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.SMALL_PROMO:
                        type = SmallPromoRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle["4X3_PROGRAM_LINEAR"]:
                        type = LinearPromoRowWidget;
                        break;

                    default:
                        type = undefined;
                        console.log( "WARNING -> Excluding unknown render style: " + row.getChildRenderStyle() )
                }

                if( type )
                {
                    rows [i] = row;
                    types[i] = type;
                }
            }

            if( rows.length > 0 )
            {
                for( i=0; i<rows.length; i++ )
                {
                    if( ! rows[i] || rows[i].getEntities().length === 0 )
                    {
                        rows.splice(i, 1);
                        types.splice(i, 1);
                        i--;
                    }
                }

                var listParams   = {};
                listParams.w     = _x2._config._screenW;
                listParams.h     = _x2._config._screenH;
                listParams.rows  = rows;
                listParams.types = types;

                if( self._list )
                {
                    hasFocus = self._list.containsWidget( _x2._focus );
                    self.removeWidget( self._list );
                }

                self._list = new StaticListWidget().init( listParams );
                self.addWidget( self._list, 0 );
                self._list.patchWidget();

                if( listIndex >= rows.length - 1 )
                    listIndex = rows.length - 1;

                if( listIndex > 0 )
                    self._list.setJumpToIndex( listIndex );

                if( _x2._focus === self || hasFocus )
                    _x2.requestFocus( self._list, true );
            }

            //recheck rows.length (rows may have been pruned)
            if( rows.length > 0 )
            {
                self._emptyMessage.hide();

                if( _x2._focus === self )
                    self.speak( _x2.requestFocus( self._list, true ) );
            }
            else
            {
                self._emptyMessage.show();

                if( _x2._focus === self )
                    self.speak( self );
            }
        };

        fail = function( error )
        {
            console.log( error )
        };
        
        _x2._data.cancelAllPendingRequests();
        _x2._data.getFavoritesBrowse( true ).then( success ).catch( fail );
    };

    FavoritesWidget.prototype.refresh = function( screen )
    {
        _x2._hi.fadeOut();

        if( this._list.containsWidget( screen._lastFocus ) === true )
            screen._lastFocus = this;

        this.loadData( this._list.getSelectedIndex() );
    };

    FavoritesWidget.prototype.speak = function( focus )
    {
        var str;

        if( focus === this || focus === undefined )
        {
            if( this._emptyMessage.isShowing() === true )
                str = this._emptyMessage.getSpeechText();
            else
                str = "Loading, please wait. ";

            this._distractor.setSpeechParams( str, undefined, this, false );
        }
        else
        {
            str = this._path + ". " +
                  focus._speakStr +
                  "Press up or down to review items. Press OK for options. ";

            this._distractor.setSpeechParams( str, focus._speakRole, this, false );
        }
    };

    return FavoritesWidget;

})();


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ForYouWidget = (function()
{
    "use strict";

    ForYouWidget.prototype = new Widget();

    function ForYouWidget(){}

    ForYouWidget.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list, true );

        if( focus )
            this._title.setSpeechParams( focus._speakStr, focus._speakRole, this, false );
        else
            this._title.setSpeechParams( undefined, undefined, this, false );
    };

    /**
     * Initializer
     * @memberof ForYouWidget
     * @param   {Object} params
     * @returns {ForYouWidget}
     */
    ForYouWidget.prototype.init = function( params )
    {
        var self = this;

        Widget.prototype.init.call( this, params );
        this._className  = "ForYouWidget";
        this._selectable = true;

        this.setW( _x2._config._screenW );

        this._distractor = new DistractorWidget().init();

        var setDistractor = function()
        {
            setTimeout( function()
            {
                self._distractor.centerOnWidget( self );
                self._distractor.show();
            },1);
        };

        this._distractor.addReadyCallback( setDistractor );
        this.addWidget( this._distractor );

        this._title = new StringWidget().init( { text:params.path, style:new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(32) } ) } );
        this._title.setA( 0 );
        this.addWidget( this._title );

        return this;
    };

    ForYouWidget.prototype.loadData = function( hasFocus )
    {
        var fail, self = this, rows = [], types = [], errorCallback, readyCallback, featuredCallback, menuCallback, recentCallback, purchaseCallback;

        errorCallback = function( error )
        {
            var onRetry = function()
            {
                self._distractor.show();
                setTimeout( function (){ self.loadData( hasFocus ) }, 3000 );
            };

            var e = error instanceof ApiError ? error : new ApiError( { local:"Unknown Error" } );
            _x2.pushOverlay( new ErrorOverlay().init({ error:e, context:ErrorOverlay.Context.SAVED, onRetry:onRetry } ) );
        };

        readyCallback = function()
        {
            self._distractor.hide();

            var millisecondsLoadDuration = new Date() - self._timestampPageLoad;
            var whichTab = "For You";

            _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.info( "Watch source: " + _x2._telemetry._watchButtonSource ) : Config.NOP();
            _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.warn( "Telemetry: " + whichTab + ", Load Time: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();
            _x2._telemetry.sendScreenLoadTime( millisecondsLoadDuration, whichTab );

            for( var i=0; i<rows.length; i++ )
            {
                if( ! rows[i] || rows[i].getEntities().length === 0 )
                {
                    rows.splice(i, 1);
                    types.splice(i, 1);
                    i--;
                }
            }

            if( rows.length )
            {
                var listParams   = {};
                listParams.w     = _x2._config._screenW;
                listParams.h     = _x2._config._screenH;
                listParams.rows  = rows;
                listParams.types = types;
                listParams.indexListener = function( index ){ self._listIndex = index };

                self._list = new StaticListWidget().init( listParams );
                self.addWidget( self._list, 0 );
                self._list.patchWidget();

                if( _x2._focus === self || hasFocus === true )
                {
                    if( self._listIndex > 0 )
                        self._list.setJumpToIndex( self._listIndex );

                    if( self._horizListIndex )
                    {
                        var listObj = self._list.getSelectedWidget();
                        if( listObj && listObj.setListPosition )
                            listObj.setListPosition( self._horizListIndex );
                    }

                    _x2.requestFocus( self._list );
                }
            }
            else
                errorCallback( self._error );
        };

        menuCallback = function( data )
        {
            var i, type, row;

            for( i=0; i<data.length; i++ )
            {
                row = data[i];

                switch( row.getChildRenderStyle() )
                {
                    case XtvApi.EntityRenderStyle.POSTER:
                        type = GalleryRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.PROMO:
                        type = PromoRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.NETWORK:
                        type = NetworkRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle.SMALL_PROMO:
                        type = SmallPromoRowWidget;
                        break;

                    case XtvApi.EntityRenderStyle["4X3_PROGRAM_LINEAR"]:
                        type = LinearPromoRowWidget;
                        break;
                    default:
                        type = undefined;
                }

                if( type )
                {
                    rows [i+4] = row;
                    types[i+4] = type;
                }
                else
                    console.log( "WARNING -> Excluding unknown type: " + type )
            }
        };

        featuredCallback = function( data )
        {
            rows[0] = data;
            types[0] = SmallPromoRowWidget;
        };

        recentCallback = function( data, index )
        {
            rows[index] = data;
            types[index] = GalleryRowWidget;
        };

        purchaseCallback = function( data )
        {
            rows[3]  = data;
            types[3] = GalleryRowWidget;
        };

        fail = function( error )
        {
            self._error = error;
            console.log( error )
        };

        if( ! this._list )
        {
            var p = [];
            this._timestampPageLoad = new Date();
            _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.warn( "Telemetry: starting load time: For You" ) : Config.NOP();

            this._distractor.show();
            _x2._data.cancelAllPendingRequests();
            p.push( _x2.refreshResumePoints( true ) );
            p.push( _x2._data.getForYouMenu( true ).then( menuCallback ).catch( fail ) );
            p.push( _x2._data.getForYouFeaturedMenu( true ).then( featuredCallback ).catch( fail ) ) ;
            p.push( _x2._data.getRecentlyWatched( null, true ).then( function(data){ recentCallback(data,2) } ).catch( fail ) );
            p.push( _x2._data.getForYouPurchases( true ).then( function(data){ purchaseCallback(data) } ).catch( fail ) );

            if( _x2._config._isCdvr === true )
                p.push( _x2._data.getRecentRecordings().then( function(data){ recentCallback(data,1) } ).catch( fail ) );

            //Since there is a 'catch' on all above promises a failure on any/all will still result in us calling the 'then' case.
            //errorCallback will only be called in the case of error triggered in the readyCallback.
            Promise.all( p ).then( readyCallback ).catch( errorCallback );
        }
    };

    ForYouWidget.prototype.refresh = function( screen )
    {
        var hasFocus = false;

        if( this._list )
        {
            hasFocus = ( this._list.containsWidget( _x2._focus ) === true );
            if( hasFocus )
                _x2._hi.fadeOut(0);

            if( this._list.containsWidget( screen._lastFocus ) === true )
                screen._lastFocus = this;

            var listObj = this._list.getSelectedWidget();
            if( listObj )
                this._horizListIndex = listObj.getListPosition ? listObj.getListPosition() : 0;

            this.removeWidget( this._list );
            this._list = undefined;
        }

        this.loadData( hasFocus );
    };

    return ForYouWidget;

})();


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GridListingsWidget = (function()
{
    "use strict";

    GridListingsWidget.prototype = new Widget();

    function GridListingsWidget(){}

    GridListingsWidget.prototype.filtersChanged = function()
    {
        this._grid.filtersChanged();
    };

    GridListingsWidget.prototype.getLocalyticsTabName = function()
    {
        return "Live TV: All Channels";
    };

    GridListingsWidget.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._grid );
    };

    /**
     * Initializer
     * @memberof GridListingsWidget
     * @returns {GridListingsWidget}
     */
    GridListingsWidget.prototype.init = function()
    {
        Widget.prototype.init.call( this );
        this._className  = "GridListingsWidget";
        this._selectable = true;

        this.setW( _x2._config._screenW );

        this._grid = new GridWidget().init( { w:_x2._config._screenW - Style._safeLeft, h:_x2._config._screenH, hasInfo:true } );
        this.addWidget( this._grid, Style._safeLeft );

        return this;
    };

    GridListingsWidget.prototype.loadData = function()
    {
        this._grid.refresh( screen );
    };

    GridListingsWidget.prototype.refresh = function( screen )
    {
        this._grid.refresh( screen );
    };

    GridListingsWidget.prototype.setJumpToChannel = function( channel )
    {
        this._grid.setJumpToChannel( channel );
    };

    // Common code:
    //    GridListingsWidget.prototype.startViewTimestamp
    //    GuideViewFilterWidget.prototype.startViewTimestamp
    GridListingsWidget.prototype.startViewTimestamp = function()
    {
        this._timestampPageView = new Date();
    };

    GridListingsWidget.prototype.stopViewTimestamp = function()
    {
        // Back Button while in gallery view, and view duration
        var whichTab = this.getLocalyticsTabName();
        this._durationPageView = new Date() - this._timestampPageView;
        window.ll( "tagEvent", "Back Button " + whichTab, { "Duration": this._durationPageView } );
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Back Button: " +  whichTab + ", duration: " + this._durationPageView ) : Config.NOP();
    };

    return GridListingsWidget;

})();


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GridListingsFavoritesWidget = (function()
{
    "use strict";

    GridListingsFavoritesWidget.prototype = new Widget();

    function GridListingsFavoritesWidget(){}

    GridListingsFavoritesWidget.prototype.filtersChanged = function()
    {
        this._grid.filtersChanged();
    };

    GridListingsFavoritesWidget.prototype.getLocalyticsTabName = function()
    {
        return "Live TV: Favorites";
    };

    GridListingsFavoritesWidget.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._grid );
    };

    /**
     * Initializer
     * @memberof GridListingsFavoritesWidget
     * @returns {GridListingsFavoritesWidget}
     */
    GridListingsFavoritesWidget.prototype.init = function()
    {
        Widget.prototype.init.call( this );
        this._className  = "GridListingsFavoritesWidget";
        this._selectable = true;

        this.setW( _x2._config._screenW );

        this._grid = new GridWidget().init( { w:_x2._config._screenW - Style._safeLeft, h:_x2._config._screenH, hasInfo:true, view:"favs" } );
        this.addWidget( this._grid, Style._safeLeft );

        return this;
    };

    GridListingsFavoritesWidget.prototype.loadData = function()
    {
        this._grid.refresh( screen );
    };

    GridListingsFavoritesWidget.prototype.refresh = function( screen )
    {
        this._grid.refresh( screen );
    };

    GridListingsFavoritesWidget.prototype.setJumpToChannel = function( channel )
    {
        this._grid.setJumpToChannel( channel );
    };

    GridListingsFavoritesWidget.prototype.startViewTimestamp = function()
    {
        this._timestampPageView = new Date();
    };

    GridListingsFavoritesWidget.prototype.stopViewTimestamp = function()
    {
        // Back Button while in gallery view, and view duration
        var whichTab = this.getLocalyticsTabName();
        this._durationPageView = new Date() - this._timestampPageView;
        window.ll( "tagEvent", "Back Button " + whichTab, { "Duration": this._durationPageView } );
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Back Button: " +  whichTab + ", duration: " + this._durationPageView ) : Config.NOP();
    };

    return GridListingsFavoritesWidget;

})();


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GuideViewFilterWidget = (function()
{
    "use strict";

    GuideViewFilterWidget.prototype = new Widget();

    GuideViewFilterWidget.Filter = Object.freeze
    ({
        KIDS   : "Kids",
        MOVIE  : "Movie",
        SPORTS : "Sports"
    });

    function GuideViewFilterWidget(){}

    GuideViewFilterWidget.prototype.filterChannels = function()
    {
        var channels = this._cc.getChannels(), i;
        var filters  = _x2._settings.getValue( Settings.Key.FILTERS );

        if( filters.hd )
        {
            var result = [];

            for( i = 0; i < channels.length; i++ )
                if( channels[i].isHD() === true )
                    result.push( channels[i] );

            channels = result;
        }

        return channels;
    };

    GuideViewFilterWidget.prototype.getLocalyticsTabName = function()
    {
        var retval;

        switch( this._filter )
        {
            case GuideViewFilterWidget.Filter.KIDS  : retval = "Live TV: Kids"  ; break; // TODO: Is this correct?
            case GuideViewFilterWidget.Filter.MOVIE : retval = "Live TV: Movies"; break; // TODO: Is this correct?
            case GuideViewFilterWidget.Filter.SPORTS: retval = "Live TV: Sports"; break; // TODO: Is this correct?
        }

        return retval;
    };

    GuideViewFilterWidget.prototype.gotFocus = function()
    {
        if( this._dataLoaded === true && this._list.getA() > 0 )
            _x2.requestFocus( this._list );
    };

    /**
     * Initializer
     * @memberof GuideViewFilterWidget
     * @param   {Object}                        params
     * @param   {GuideViewFilterWidget.Filter} [params.filter]     - Which filter to apply to the metadata
     * @param   {DistractorWidget}             [params.distractor] - Distractor to display during load
     * @returns {GuideViewFilterWidget}
     */
    GuideViewFilterWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className         = "GuideViewFilterWidget";
        this._selectable        = true;
        this._filter            = params.filter;
        this._distractor        = params.distractor;
        this._durationPageView  = 0; // Localytics
        this._timestampPageView = 0; // Localytics
        this._timestampPageLoad = 0; // Localytics

        this.setW( _x2._config._screenW );

        this.addWidget( new RectWidget().init( { w:_x2._config._screenW - Style._safeLeft - Style._safeRight, h:ListRowWidget.DIVIDER_H, color:"#303030" } ), Style._safeLeft, -ListRowWidget.DIVIDER_H );

        this._list = this.getDefaultWidget();
        
        this._gvfwEmpty = new EmptyMessageWidget().init( EmptyMessageWidget.Key.GRID_FILTER );
        this.addWidget( this._gvfwEmpty, Style._safeLeft );

        return this;
    };

    GuideViewFilterWidget.prototype.loadData = function()
    {
        var date = new Date(), self = this, onChannelsLoaded, onChannelsFailed, onLingerComplete, time, blocks;

        this._timestampPageLoad = new Date(); // Localytics
        this._list.setData();

        date.setMilliseconds( 0 );
        date.setSeconds( 0 );
        date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

        time   = date.getTime();
        blocks = [ [], [], [], [], [], [], [] ];

        var createEmptyString = function()
        {
            var retval;

            if( self._filter === GuideViewFilterWidget.Filter.KIDS )
                retval = "Kids";
            else if( self._filter === GuideViewFilterWidget.Filter.MOVIE )
                retval = "Movies";
            else if( self._filter === GuideViewFilterWidget.Filter.SPORTS )
                retval = "Sports";

            return retval;
        };

        var createTitle = function( index )
        {
            var retval, millis, start, stop;

            if( self._filter === GuideViewFilterWidget.Filter.KIDS )
                retval = "Kids On Now";
            else if( self._filter === GuideViewFilterWidget.Filter.MOVIE )
                retval = "Movies On Now";
            else if( self._filter === GuideViewFilterWidget.Filter.SPORTS )
                retval = "Sports On Now";

            if( index > 0 )
            {
                millis = time + index * 1800000;
                start  = new Date( millis );
                stop   = new Date( millis + 1800000 );
                retval = _x2.createTimeRange( start, stop );
            }

            return retval;
        };

        onChannelsLoaded = function()
        {
            var chanColl = _x2._channelCollection;
            self._cc = chanColl;

            var onScheduleBlock = function()
            {
                var channels                 = self.filterChannels(), i, j, scheds, delta, index, entities = [];
                var whichTab                 = self.getLocalyticsTabName();
                var millisecondsLoadDuration = new Date() - self._timestampPageLoad;
                var filters                  = _x2._settings.getValue( Settings.Key.FILTERS );
                var now                      = new Date().getTime(), end = now + 6 * 30 * 60 * 1000;

                for( i = 0; i < channels.length; i++ )
                {
                    scheds = channels[i].getSchedules();

                    for( j = 0; j < scheds.length; j++ )
                    {
                        if( scheds[j].getStartTime() > end )
                            break;

                        if( scheds[j].hasFilter( self._filter ) === true && (filters.cc === false || scheds[j].isClosedCaptioned() === true) && (filters.sap === false || scheds[j].isSap() === true) && (filters.dvs === false || scheds[j].isDvs() === true) )
                        {
                            scheds[j].setChannel( channels[i] );

                            delta = (scheds[j].getStartTime() - time) / 1800000;
                            index = (delta < 0 ) ? -1 : parseInt( delta );

                            if( delta < 0 )
                            {
                                if( scheds[j].getEndTime() > time )
                                    blocks[0].push( scheds[j] );
                            }
                            else if( index < 7 )
                                blocks[index].push( scheds[j] );
                        }
                    }
                }

                self.showEmptyMessage();
                self._list.setA( 0 );

                for( i = 0; i < blocks.length; i++ )
                {
                    if( blocks[i].length > 0 )
                    {
                        self._gvfwEmpty.hide();
                        self._list.setA( 1 );
                    }

                    entities[i] = new GuideViewEntity( createTitle(i), blocks[i], "No " + createEmptyString() + " programs are available, adjust filters to view more titles." );
                }

                self._list.setData( entities );
                self._dataLoaded = true;

                if( _x2._focus === self && self._list.getA() > 0 )
                    _x2.requestFocus( self._list );

                if( self.getEndA() === 1 )
                    self._distractor.hide();

                if( whichTab )
                {
                    window.ll( "tagEvent", whichTab + " Load Time", { "Duration": millisecondsLoadDuration } );
                    _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: " + whichTab + ", Load Time: duration: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();

                    _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.info( "Telemetry: " + whichTab + ", Load Time: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();
                    _x2._telemetry.sendScreenLoadTime( millisecondsLoadDuration, whichTab );
                }
            };

            chanColl.fetch( time, time + 3 * 60 * 60 * 1000, time ).then( onScheduleBlock );
        };

        onChannelsFailed = function( error )
        {
            self._distractor.hide();
            self.showEmptyMessage( true );
            console.error( error );
        };

        onLingerComplete = function()
        {
            if( self.getEndA() === 1 )
            {
                var whichTab = self.getLocalyticsTabName();

                if( whichTab )
                {
                    window.ll( "tagEvent", "Linger", { "Source": whichTab } );
                    _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytlics: Live TV: Linger: " + whichTab ) : Config.NOP();
                }

                console.log( "LOAD " + self._filter );

                _x2._channelCollection.fetch( time ).then( onChannelsLoaded, onChannelsFailed );
            }
        };

        setTimeout( onLingerComplete, 1000 );
    };

    GuideViewFilterWidget.prototype.showEmptyMessage = function( isError )
    {
        var messageKey;

        if( isError )
            messageKey = EmptyMessageWidget.Key.GRID_ERROR;
        else
        {
            var filters = _x2._settings.getValue( Settings.Key.FILTERS );

            if( filters.hd === true || filters.cc === true || filters.dvs === true || filters.sap === true )
                messageKey = EmptyMessageWidget.Key.GRID_FILTER;
            else
                messageKey = EmptyMessageWidget.Key.GRID_EMPTY;
        }

        this._gvfwEmpty.setMessage( messageKey );
        this._gvfwEmpty.show();
    };

    GuideViewFilterWidget.prototype.startViewTimestamp = function()
    {
        this._timestampPageView = new Date();
    };

    GuideViewFilterWidget.prototype.stopViewTimestamp = function()
    {
        // Back Button while in gallery view, and view duration
        var whichTab = this.getLocalyticsTabName();
        this._durationPageView = new Date() - this._timestampPageView;
        window.ll( "tagEvent", "Back Button " + whichTab, { "Duration": this._durationPageView } );
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Back Button: " +  whichTab + ", duration: " + this._durationPageView ) : Config.NOP();
    };

    GuideViewFilterWidget.prototype.getDefaultWidget = function() {
        var listParams = {};
        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 0;
        listParams.type     = GuideViewRowWidget;
        listParams.hide     = true;

        return new ListWidget().init( listParams );
    }

    return GuideViewFilterWidget;

})();


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LastWatchedWidget = (function()
{
    "use strict";

    LastWatchedWidget.prototype = new Widget();

    var LOCAL_STORAGE_KEY = "lastWatched";
    var MAX_ENTRIES       = 7;

    function LastWatchedWidget(){}

    LastWatchedWidget.prototype.addEntry = function( obj )
    {
console.log( "***************************************************************************" );
console.log( "***************************************************************************" );
console.log( "***************************************************************************" );
        var struct = this.read();
        var array  = struct.entries;
        var newObj = {};

        for( var key in obj )
        {
            console.log( key );

            if( key === "entity" )
            {
                var entity = obj[key];

                if( entity instanceof Channel )
                {
                    newObj.dataType = "Channel";
                    newObj.data = entity._data;
                }
                else if( entity instanceof Recording )
                {
                    newObj.dataType = "Recording";
                    newObj.data     = entity._data;
                }
                else if( entity instanceof LinearShowing )
                {
                    var channel = entity._channel;

                    if( channel )
                    {
                        newObj.dataType = "Channel";
                        newObj.data = channel._data;
                    }
                    else
                        console.error( "LinearShowing does not contain a channel" );
                }
                else if( entity instanceof Entity )
                {
                    newObj.dataType    = "Entity";
                    newObj.data        = entity._data;
                }
                else if( entity instanceof VodShowing )
                {
                    newObj.dataType    = "VodShowing";
                    newObj.data        = entity._data;
                }
                else
                {
                    console.error( "Need to support entity type of " );
                    console.error( entity );
                }
            }
            else
                newObj[key] = obj[key];
        }

        // Remove duplicates

        var newEntity = createEntity( newObj.data, newObj.dataType ), tmp;

        console.log( newEntity );
        console.log( newObj, newObj.dataType);
        delete newObj.resume; //delete resume from localStorage, it should be fetch from resumePoint api.
        if( newEntity )
        {
            for( var i = array.length - 1; i >= 0; i-- )
            {
                if( newObj.dataType === array[i].dataType )
                {
                    tmp = createEntity( array[i].data, array[i].dataType );
                    if( newObj.dataType === "Channel" )
                    {
                        //Last watched channel should be focus on LiveTV next time.
                        _x2._settings.setValue( Settings.Key.LAST_CHAN, { id:newEntity.getStationId(), num:newEntity.getNumber() } );
                        if( tmp.getId() === newEntity.getId() )
                            array.splice( i, 1 );
                    }
                    else if( newObj.dataType === "Entity" )
                    {
                        if( tmp.getEntityId() === newEntity.getEntityId() )
                            array.splice( i, 1 );
                    }
                    else if( newObj.dataType === "Recording" )
                    {
                        if( tmp.getId() === newEntity.getId() )
                            array.splice( i, 1 );
                    }
                    else if( newObj.dataType === "VodShowing" )
                    {
console.log( tmp.getAssetId() + " ==> " + newEntity.getAssetId() );
                        if( tmp.getAssetId() === newEntity.getAssetId() )
                            array.splice( i, 1 );
                    }
                    else
                        console.error( "Need to support entity type of " + newObj.dataType );
                }
            }
        }

        if( newObj.dataType )
            array.unshift( newObj );

        if( array.length > MAX_ENTRIES )
            array.splice( MAX_ENTRIES, array.length - MAX_ENTRIES );

        this.write( struct );
    };

    function createEntity( obj, type )
    {
        var retval;

        if( type === "Channel" )
            retval = new Channel().init( obj );
        else if( type === "Entity" )
            retval = new Entity().init( obj );
        else if( type === "Recording" )
            retval = new Recording().init( obj );
        else if( type === "VodShowing" )
            retval = new VodShowing().init( obj );
        else
            console.error( "Need to support data type = " + type );

        return retval;
    }

    LastWatchedWidget.prototype.gotFocus = function()
    {
//         var entries = this.read().entries;
//
//         if( entries.length > 0 )
//             _x2.requestFocus( this._list );
    };

    LastWatchedWidget.prototype.hide = function()
    {
        this.animate( { a:0, duration:500 } );
    };

    /**
     * Initializer
     * @memberof LastWatchedWidget
     * @param   {Object} params
     * @returns {LastWatchedWidget}
     */
    LastWatchedWidget.prototype.init = function( params )
    {
        var self           = this, layout;
        var buttonStyle    = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000" } );
        var noneTitleStyle = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var noneBodyStyle  = new Style( { font:"medium" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), textAlign:"center"  } );
        var noneTitle      = "Nothing new here.";
        var noneBody       = "Keep track of your previously watched programs and channels, start watching and check back soon.";
        var button         = new StringWidget().init( { text:"Clear History", style:buttonStyle, onEnter:function() { console.log( "CLEAR CLEAR" ); self._onHide(); _x2._config._host.removeLocalStorage( LOCAL_STORAGE_KEY ); } } );

        Widget.prototype.init.call( this, params );
        this._className   = "LastWatchedWidget";
        this._selectable  = true;
        this._onHide      = params.onHide;
        this._numReady    = 0;

        layout = function()
        {
            self._numReady++;

            if( self._numReady === 2 )
            {
                var vGap = _x2.scaleValInt(32);
                var y    = Math.round( (_x2._config._screenH - self._noneTitleStr.getH() - self._noneBodyStr.getH() - vGap) / 2 );

                self._noneTitleStr.setX( (_x2._config._screenW - self._noneTitleStr.getW()) / 2 );
                self._noneTitleStr.setY( y );
                self._noneBodyStr.setY( y + self._noneTitleStr.getH() + vGap );

                self._list.setY( (_x2._config._screenH - self._list.getH()) / 2 );

                self._button.setY( self._list.getY() + self._list.getH() );
                self._button.setX( (_x2._config._screenW - self._button.getW()) / 2 );
            }
        };

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this._bg.setA( 0.8 );
        this.addWidget( this._bg );

        this._list = new LastWatchedRowWidget().init( { w: _x2._config._screenW - Style._safeLeft - Style._safeRight, sep: false, obj:params.videoScreen } );
        this.addWidget( this._list, Style._safeLeft );

        this._button = new HorizPillButtonsWidget().init( { entries:[button], spacing:_x2.scaleValInt(60) } );
        this._button.addReadyCallback( layout );
        this.addWidget( this._button );

        this._noneTitleStr = new StringWidget   ().init( { text:noneTitle, style:noneTitleStyle } );
        this._noneBodyStr  = new TextBlockWidget().init( { text:noneBody , style:noneBodyStyle, w:Math.round( 0.42 * _x2._config._screenW ) } );
        this._noneTitleStr.setA( 0 );
        this._noneBodyStr.setA( 0 );
        this._noneBodyStr.addReadyCallback( layout );
        this.addWidget( this._noneTitleStr );
        this.addWidget( this._noneBodyStr, (_x2._config._screenW - this._noneBodyStr.getW()) / 2 );

        if( params.params )
            this.addEntry( params.params );

        this.setW( _x2._config._screenW );
        this.setH( _x2._config._screenH );
        this.setA( 0 );

        return this;
    };

    LastWatchedWidget.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED && this._list.containsWidget( _x2._focus ) === true )
                    _x2.requestFocus( this._button );
                break;

            case Host.KEY_LAST:
                if( type === Host.KEY_PRESSED )
                {
                    this._onHide();
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && _x2._focus === this._button )
                    _x2.requestFocus( this._list );
                break;
        }

        return retval;
    };

    LastWatchedWidget.prototype.read = function()
    {
        var retval = { version:1, entries:[] }, parsed;
        var json   = Host.getLocalStorage( LOCAL_STORAGE_KEY );

        if( json )
        {
            parsed = JSON.parse( json );

            var version = parsed.version;

            if( version === undefined )
            {
                console.error( "Unsupported version of last watched = " + version + ". Resetting." );
                this.write( retval );
            }
            else
                retval = parsed;
        }
        else
            this.write( retval );

        return retval;
    };

    LastWatchedWidget.prototype.removeEntry = function( array, entity )
    {
        var id     = entity.getEntityId(); // ProgramEntity

        for( var i = 0; i < array.length; i++ )
        {
            if( array[i].id === id )
            {
                array.splice( i, 1 );
                break;
            }
        }
    };

    LastWatchedWidget.prototype.show = function()
    {
        var self    = this, i, date, onChannelsLoaded, onChannelsFailed;
        var struct  = this.read();
        var entries = struct.entries;

        if( entries.length === 0 )
        {
            this._list.setData();
            this._noneTitleStr.setA( 1 );
            this._noneBodyStr.setA( 1 );
        }
        else
        {
            this._noneTitleStr.setA( 0 );
            this._noneBodyStr.setA( 0 );

            var data = [];

            for( i = 0 ; i < entries.length; i++ )
            {
                if( entries[i].dataType === "Channel" )
                {
                    data.push( { entity:new Channel().init( entries[i].data ), data:entries[i] } );
                }
                else if( entries[i].dataType === "Entity" )
                {
                    data.push( { entity:new Entity().init( entries[i].data ), data:entries[i] } );
                }
                else if( entries[i].dataType === "Recording" )
                {
                    data.push( { entity:new Recording().init( entries[i].data ), data:entries[i] } );
                }
                else if( entries[i].dataType === "VodShowing" )
                {
                    var entity = new VodShowing().init( entries[i].data );

                    var rentalTime = entity.get("rentalDateTime");
                    if( rentalTime )
                    {
                        var expires = new Date( rentalTime ).getTime() + ( entity.getInteger("rentalPeriod") * 60000 );
                        if( Date.now() < expires )
                            data.push( { entity:entity, data:entries[i] } );
                    }
                    else
                        data.push( { entity:entity, data:entries[i] } );
                }
                else
                {
                    console.error( "Need to support data type = " + entries[i].dataType + ", index =  " + i );
                    console.log( entries );
                }
            }

            onChannelsLoaded = function()
            {
                var chanColl = _x2._channelCollection;

                for( i = data.length - 1; i >= 0; i-- )
                {
                    console.log( data[i] );

                    if( data[i].entity instanceof Channel )
                    {
                        console.error( "Found channel at index = " + i );

                        var found    = false;
                        var channel  = data[i].entity;
                        var channels = chanColl ? chanColl.getChannels() : [];

                        for( var j = 0; j < channels.length; j++ )
                        {
                            if( channel.getNumber() === channels[j].getNumber() )
                            {
                                console.error( channels[j] );
                                found = true;
                                data[i].entity = channels[j];
                                break;
                            }
                        }

                        if( found === false )
                        {
                            console.error( "NO MATCH: DELETE ENTRY" );
                            data.splice( i, 1 );
                        }
                    }
                }

                self._list.setData( { getTitle:function() { return "Last Watched"; }, getEntities:function() { return data; } } );

                if( _x2._focus === self && entries.length > 0 )
                    _x2.requestFocus( self._list );
            };

            onChannelsFailed = function( error )
            {
                console.error( "Unable to load channels: " + error );

                onChannelsLoaded();



            //     var onDismiss = function()
            //     {
            //         _x2.popScreen( self );
            //     };
            //
            //     var onRetry = function()
            //     {
            //         var retry = function()
            //         {
            //             _x2._data.getChannelCollection( date.getTime() ).then( onChannelsLoaded, onChannelsFailed );
            //         };
            //
            //         _x2.popOverlay( self._errorOverlay, retry );
            //     };
            //
            //     self._errorOverlay = _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.GUIDE, onDismiss:onDismiss, onRetry:onRetry } ) );
            };

            // get the list of channels
            _x2._channelCollection && _x2._channelCollection.fetch().then( onChannelsLoaded, onChannelsFailed );
        }

        this._button.setA( entries.length > 0 ? 1 : 0 );
        this.animate( { a:1, duration:500 } );
    };

    LastWatchedWidget.prototype.write = function( obj )
    {
        _x2._config._host.setLocalStorage( LOCAL_STORAGE_KEY, JSON.stringify( obj ) );
    };

    return LastWatchedWidget;

})();


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ProgressBarAndTextWidget = ( function()
{
    "use strict";

    ProgressBarAndTextWidget.prototype = new Widget();

    function ProgressBarAndTextWidget(){}

    ProgressBarAndTextWidget.prototype.getTextStatus = function()
    {
        return this._progressStr.getText();
    };

    /**
     * @param {Object} params
     * @param {String} params.type - "recordings", "scheduled", or undefined
     * @memberof ProgressBarAndTextWidget
     */
    ProgressBarAndTextWidget.prototype.init = function( params )
    {
        var self         = this;
        var percentStyle = new Style( { font:"regular", color:"#a3a3a3", fontSize:_x2.scaleValInt(20), whiteSpace:"nowrap" } );
        var h            = _x2.scaleValInt( 31 + 12 + 29 ); // padAbove + heightProgress + padBelow

        Widget.prototype.init.call( this, params );
        this._className  = "ProgressBarAndTextWidget";
        this._type       = params.type;

        this._progressBar = new ProgressBarWidget().init( { w: _x2.scaleValInt(150), h: _x2.scaleValInt(12), style:"full", percent:0 } );
        this.addWidget( this._progressBar, 0, _x2.scaleValInt( 31 ) );

        this._progressStr = new StringWidget().init( { text:"", style:percentStyle } );
        this.addWidget( this._progressStr );

        this.setH( h );
        this.setA( 0 );

        _x2._data.getRecorderSummary().then( function( result ){ self.onData( result ) } );

        return this;
    };

    /**
     * Start a new query and update the UI when ready
     * @memberof ProgressBarAndTextWidget
     * @param force - break caching
     */
    ProgressBarAndTextWidget.prototype.loadData = function( force )
    {
        var self = this;
        _x2._data.getRecorderSummary( force ).then( function( result ){ self.onData( result ) } );
    };

    /**
     * @memberof ProgressBarAndTextWidget
     * @param {RecorderSummary} summary
     */
    ProgressBarAndTextWidget.prototype.onData = function( summary )
    {
/*
        console.log( "*** Summary: %o", summary );
        console.table(
            [
                [ "Free %:"    , summary.getPercentFree()    ],
                [ "Used %:"    , summary.getPercentUsed()    ],
                [ "Recorded: " , summary.getTotalRecorded()  ],
                [ "Scheduled: ", summary.getTotalScheduled() ]
            ]
        );
// */
        this._summary = summary;

        var percent = 0;
        var total   = 0;

        switch( this._type )
        {
            case "recordings":
                percent = summary.getPercentUsed();
                total   = summary.getTotalRecorded();

                this.setProgress( percent, total + " Recordings" );
                break;

            case "scheduled":
                percent = summary.getPercentUsed();
                total   = summary.getTotalScheduled();

                this.setProgress( percent, total + " Scheduled" );
                break;

            default:
                break;
        }
    };


    /**
     * @memberof ProgressBarAndTextWidget
     * @param {Number} percent
     * @param {String} total along with description - i.e. "1 Scheduled", "2 Recordings"

     */
    ProgressBarAndTextWidget.prototype.setProgress = function( percent, total )
    {
        this._progressBar.setProgress( percent );
        this._progressStr.setText( "" + percent + "% Full | " + total );

        var w1 = this._progressBar.getW();
        var w2 = _x2.scaleValInt(18);
        var w3 = this._progressStr.getW();
        var x  = (_x2._config._screenW - (w1 + w2 + w3)) * 0.5;
        var y  = (this.getH() - this._progressStr.getH()) * 0.5;

        this._progressBar.setX( x           );
        this._progressStr.setX( x + w1 + w2 );

        this._progressStr.setY( y );

        this.animate( { a:1, duration:500 } );
    };

    return ProgressBarAndTextWidget;

})();



/***/ }),
/* 77 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchasesWidget = (function()
{
    "use strict";

    PurchasesWidget.prototype = new Widget();

    function PurchasesWidget(){}

    PurchasesWidget.prototype.getColumnCount = function()
    {
        return this._columnCount;
    };

    PurchasesWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var focus;

        if( this._dataLoaded  )
        {
            if( this._list )
                focus = this.speak( _x2.requestFocus( this._list, newScreen ), newScreen );
            else
                focus = this.speak( _x2.requestFocus( this._buttons, newScreen ), newScreen );
        }
        else
            this.speak();

        return focus;
    };

    PurchasesWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );

        var self = this;

        Widget.prototype.init.call( this );
        this._className   = "PurchasesWidget";
        this._path        = params && params.path;
        this._selectable  = true;

        this.setW( _x2._config._screenW );

        if( _x2._config._purchases === true )
        {
            var browse = function()
            {
                _x2.setScreen( new VodRootScreen ().init( { intialItem:"Movies" } ) );
            };

            var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
            var browseStr   = new StringWidget().init( { text:"Browse", style:buttonStyle, onEnter:browse } );
            this._buttons   = new HorizPillButtonsWidget().init( { entries:[browseStr], spacing:_x2.scaleValInt(41) } );
        }

        this._emptyMessage = new EmptyMessageWidget().init( _x2._config._purchases ? EmptyMessageWidget.Key.PURCHASES_ON : EmptyMessageWidget.Key.PURCHASES_OFF, this._buttons );
        this.addWidget( this._emptyMessage, Style._safeLeft );

        var listParams          = {};
        listParams.w            = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h            = _x2._config._screenH - 180;
        listParams.hide         = true;
        listParams.maxIndex     = 0;
        listParams.type         = VodGridRowWidget;
        listParams.obj          = this;
        listParams.sep          = false;
        listParams.renderStyle  = XtvApi.EntityRenderStyle.POSTER;

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function(){ setTimeout( function() { self._distractor.centerOnWidget( self ) },1) } ); // TODO clean up
        this.addWidget( this._distractor );

        return this;
    };

    PurchasesWidget.prototype.loadData = function( listIndex, refresh )
    {
        var onPurchases, onRentals, ready, fail, hasFocus, self = this;

        if( this._list )
        {
            this._list.setA( 0 );
            this._list._selectable = false;
        }

        onPurchases = function( purchaseGroup )
        {
            self._tvSeries = purchaseGroup.getTvSeries();
            self._movies   = purchaseGroup.getMovies();
        };

        onRentals = function( response )
        {
            self._rentals = response;
        };

        ready = function()
        {
            var rows = [], types = [];

            if( self._rentals && self._rentals.getTotalEntityCount() )
            {
                rows.push( self._rentals );
                types.push( GalleryRowWidget );
            }

            if( self._movies && self._movies.getTotalEntityCount() )
            {
                rows.push( self._movies );
                types.push( GalleryRowWidget );
            }

            if( self._tvSeries && self._tvSeries.getTotalEntityCount() )
            {
                rows.push( self._tvSeries );
                types.push( GalleryRowWidget );
            }

            if( rows.length === 0 )
            {
                self._emptyMessage.show();
            }
            else
            {
                var listParams   = {};
                listParams.w     = _x2._config._screenW;
                listParams.h     = _x2._config._screenH;
                listParams.rows  = rows;
                listParams.types = types;
                listParams.max   = 12;
                listParams.indexListener = function( index ){ self._listIndex = index };

                if( self._list )
                {
                    hasFocus = self._list.containsWidget( _x2._focus );
                    self.removeWidget( self._list );
                }

                self._list = new StaticListWidget().init( listParams );
                self.addWidget( self._list, 0 );
                self._list.patchWidget();

                self._emptyMessage.hide();
            }

            self._dataLoaded = true;
            self.callbackSignalReady();
            self._distractor.hide();

            if( listIndex !== undefined )
            {
                if( listIndex >= rows.length - 1 )
                    listIndex = rows.length - 1;

                if( listIndex > 0 )
                    self._list.setJumpToIndex( listIndex );
            }

            if( self._list && ( _x2._focus === self || hasFocus ) ) {
                if( self._horizListIndex )
                {
                    var listObj = self._list.getSelectedWidget();
                    if( listObj && listObj.setListPosition )
                        listObj.setListPosition( self._horizListIndex );
                } //set focus of the widget, if it was selected in previous page
                self.speak( _x2.requestFocus( self._list ) );
            }

        };

        fail = function( error )
        {
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.SAVED } ) );
            self._distractor.hide();
        };

        this._distractor.show();

        _x2._data.cancelAllPendingRequests();

        var p = [];
        p.push( _x2._data.getRentals( refresh, true ).then( onRentals ).catch( fail ) );
        p.push( _x2._data.getPurchases().then( onPurchases ).catch( fail ) );
        Promise.all(p).then( ready );
    };

    PurchasesWidget.prototype.refresh = function( screen )
    {
        _x2._hi.fadeOut();

        if( this._list.containsWidget( screen._lastFocus ) === true )
            screen._lastFocus = this;

        var lastSelectedWidget = this._list.getSelectedWidget();
        if( lastSelectedWidget )
            this._horizListIndex = lastSelectedWidget.getListPosition ? lastSelectedWidget.getListPosition() : 0;

        this.loadData( this._list.getSelectedIndex(), true );
    };

    PurchasesWidget.prototype.speak = function( focus, newScreen )
    {
        var str;

        if( focus )
        {
            if( newScreen !== true )
            {
                if( this._list === undefined || this._list.getMaxIndex() === 0 )
                {
                    str = this._path      + ". " +
                          focus._speakStr + ". Button. " +
                          this._emptyMessage.getSpeechText();
                }
                else
                {
                    str = this._path      + ". " +
                          focus._speakStr + ". " +
                          "Press left, right, or down to browse content. Press OK to select. ";
                }

                this._distractor.setSpeechParams( str, undefined, this._distractor, false );
            }
        }
        else
        {
            if( this._dataLoaded === true )
                this._distractor.setSpeechParams( this._emptyMessage.getSpeechText(), undefined, this, false );
            else
                this._distractor.setSpeechParams( "Loading, please wait. ", undefined, this, false );
        }

        return focus;
    };

    return PurchasesWidget;

})();


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RecordingsWidget = ( function()
{
    "use strict";

    RecordingsWidget.prototype = new Widget();

    function RecordingsWidget(){}

    RecordingsWidget.prototype.gotFocus = function()
    {
        if( this._list.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._list, true ) );
        else
            this.speak( this );
    };

    /**
     * Initializer
     * @memberof RecordingsWidget
     * @param   {Object} params
     * @returns {RecordingsWidget}
     */
    RecordingsWidget.prototype.init = function( params )
    {
        var self = this, listParams = {};
        var w    = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var x    = Style._safeLeft;

        Widget.prototype.init.call( this, params );
        this._className = "RecordingsWidget";
        this._path      = params.path;

        this.setW( _x2._config._screenW );

        this._progress = new ProgressBarAndTextWidget().init( { type:"recordings" } );
        this.addWidget( this._progress );
        var h = this._progress.getH();

        this._sep = new RectWidget().init( { w:w, h:ListRowWidget.DIVIDER_H, color:"#262626" } );
        this.addWidget( this._sep, x, h );

        this._selectable    = true;
        listParams.w        = w;
        listParams.h        = _x2._config._screenH - h;
        listParams.maxIndex = 1;
        listParams.type     = RecordingRowWidget;
        this._list          = new ListWidget().init( listParams );

        this.addWidget( this._list, x, h+ListRowWidget.DIVIDER_H );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self._list ); } );
        this._list.addWidget( this._distractor );

        this._emptyMessage = new EmptyMessageWidget().init( EmptyMessageWidget.Key.RECORDINGS );
        this.addWidget( this._emptyMessage, Style._safeLeft );

        return this;
    };

    RecordingsWidget.prototype.loadData = function( hasFocus )
    {
        var success, fail, self = this;

        this._distractor.show();
        this._progress.loadData();
        this._list.setData();
        this._emptyMessage.hide();

        success = function( recordings )
        {
            self._distractor.hide();

            var groups = recordings.getRecordingsByGroup();
            groups.push( new RecordingGroup().init( { groupType:"deleted", name:"Deleted Recordings" } ) );
            self._list.setData( groups );

            if( groups.length > 1 )
            {
                self._emptyMessage.hide();

                if( _x2._focus === self || hasFocus === true )
                    self.speak( _x2.requestFocus( self._list, true ) );
            }
            else
            {
                self._emptyMessage.show();

                if( _x2._focus === self || hasFocus === true )
                    self.speak( self );
            }

            if( self._listIndex > 0 )
                self._list.setJumpToIndex( self._listIndex );
        };

        fail = function( error )
        {
            var onRetry = function()
            {
                self._distractor.show();
                setTimeout( function (){ self.loadData( hasFocus ) }, 3000 );
            };

            self._distractor.hide();
            console.error( error.toString() );
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.SAVED, onRetry:onRetry } ) );
        };
        _x2._data.cancelAllPendingRequests();
        _x2._data.getRecordings( true ).then( success ).catch( fail );
    };

    RecordingsWidget.prototype.refresh = function( screen )
    {
        var hasFocus = ( this._list.containsWidget( _x2._focus ) === true );
        if( hasFocus )
            _x2._hi.fadeOut(0);

        this._listIndex = this._list.getCurrentAndMaxIndex().current;

        if( this._list.containsWidget( screen._lastFocus ) === true )
            screen._lastFocus = this._list;

        this.loadData( hasFocus );
    };

    RecordingsWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );
        this._list.setH( val );
    };

    RecordingsWidget.prototype.speak = function( focus )
    {
        var str;

        if( focus === this || focus === undefined )
        {
            if( this._emptyMessage.isShowing() === true )
                str = this._emptyMessage.getSpeechText();
            else
                str = "Loading, please wait. ";

            this._sep.setSpeechParams( str, undefined, this, false );
        }
        else
        {
            str = this._path + ". " +
                  this._progress.getTextStatus() + ". " +
                  focus._speakStr + ". " +
                  "Press up or down to review items. Press OK for options. " +
                  ( this._emptyMessage.isShowing() === true ? this._emptyMessage.getSpeechText() : "" );

            this._sep.setSpeechParams( str, focus._speakRole, this, false );
        }
    };

    return RecordingsWidget;

})();


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ScheduledWidget = ( function()
{
    "use strict";

    ScheduledWidget.prototype = new Widget();

    ScheduledWidget.MONTHS = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
    ScheduledWidget.DAYS   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];

    function ScheduledWidget(){}

    ScheduledWidget.prototype.gotFocus = function()
    {
        var focus;

        if( this._jumpToIndex !== undefined )
        {
            if( this._jumpToIndex !== -1 )
            {
                this._entityList.setJumpToIndex( this._jumpToIndex );
                focus = _x2.requestFocus( this._entityList, true );
            }
            else
            {
                this._list._expanded = false;
                focus = _x2.requestFocus( this._list, true );
            }
        }
        else
            focus = _x2.requestFocus( this._list, true );

        if( focus )
            this.speak( _x2.requestFocus( focus, true ) );
        else
            this.speak( this );
    };

    /**
     * Initializer
     * @memberof ScheduledWidget
     * @param   {Object} params
     * @returns {ScheduledWidget}
     */
    ScheduledWidget.prototype.init = function( params )
    {
        var self = this, listParams = {}, entityListParams = {};
        var w    = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var x    = Style._safeLeft;

        Widget.prototype.init.call( this, params );
        this._className = "ScheduledWidget";
        this._path      = params.path;

        this.setW( _x2._config._screenW );

        this._progress  = new ProgressBarAndTextWidget().init( { type:"scheduled" } );
        this.addWidget( this._progress );
        var h = this._progress.getH();

        this._sep = new RectWidget().init( { w:w, h:ListRowWidget.DIVIDER_H, color:"#262626" } );
        this.addWidget( this._sep, x, h );

        this._selectable          = true;
        entityListParams.w        = w;
        entityListParams.h        = _x2._config._screenH - h;
        entityListParams.maxIndex = 1;
        entityListParams.type     = ScheduledRowWidget;
        this._entityList          = new ListWidget().init( entityListParams );

        listParams.w        = w;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 0;
        listParams.type     = ExpandingListRowWidget;
        listParams.obj      = { list:this._entityList, baseWidget:this };
        this._list          = new ListWidget().init( listParams );

        this.addWidget( this._list, x, h+ListRowWidget.DIVIDER_H );
        this._list.addWidget( this._entityList );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self._list ); } );
        this._list.addWidget( this._distractor );

        this._emptyMessage = new EmptyMessageWidget().init( EmptyMessageWidget.Key.UPCOMING );
        this.addWidget( this._emptyMessage, Style._safeLeft );

        return this;
    };

    ScheduledWidget.prototype.removeRecording = function( recording )
    {
        var i, j, spliced, doBreak, id = recording.getId();

        this._progress.loadData( true );

        for( i = 0; i < this._entries.length; i++ )
        {
            var recordings = this._entries[i].entries;

            for( j = 0; j < recordings.length; j++ )
            {
                if( id === recordings[j].getId() )
                {
                    recordings.splice( j, 1 );

                    if( recordings.length === 0 )
                    {
                        this._entries.splice( i, 1 );
                        spliced = true;
                    }

                    if( this._entries.length > 1 || spliced )
                    {
                        //hide the episode list if there is more than one group (day), or we just deleted the selected season.
                        this._jumpToIndex = -1;
                        this._entityList.setA(0);
                    }
                    else
                    {
                        //send focus back to the group (day) if there is only one.
                        this._jumpToIndex = ( j > 0 ? j-1 : 0 );
                        this._entityList.setData( recordings );
                    }

                    this._list.setData( this._entries );

                    if( this._entries.length > 0 )
                        this._parent._lastFocus = this;
                    else
                    {
                        this._parent._lastFocus = this._parent._menu;
                        this._list._selectable = false;
                        this._list.setA(0);
                        this._emptyMessage.show();
                    }

                    doBreak = true;
                    break;
                }
            }
            if( doBreak )
                break;
        }
    };

    ScheduledWidget.prototype.loadData = function()
    {
        var success, fail, self = this;

        this._progress.loadData();

        if( this._entries === undefined )
        {
            success = function( entities )
            {
                self._distractor.hide();

                var entries = [], date, key, title, index = 0;

                self._entries = [];

                for( var i = 0; i < entities.length; i++ )
                {
                    date = entities[i].getRecordedOnDate();
                    date.setMilliseconds( 0 );
                    date.setSeconds( 0 );
                    date.setMinutes( 0 );
                    date.setHours( 0 );

                    key = date.getTime();

                    if( entries[key] === undefined )
                    {
                        title = ScheduledWidget.DAYS[date.getDay()] + ", " + ScheduledWidget.MONTHS[date.getMonth()] + " " + date.getDate();
                        self._entries[index++] = entries[key] = { title:title, entries:[] };
                    }

                    if( ! entities[i]._deleteListener )
                        entities[i]._deleteListener = function(episode){ self.removeRecording( episode ); return false };

                    entries[key].entries.push( entities[i] );
                }

                if( entities.length > 0 )
                    self._emptyMessage.hide();
                else
                    self._emptyMessage.show();

                if( entities.length > 0 )
                    self._list.setData( self._entries );
                else
                    self._list.setA(0);
            };

            fail = function( error )
            {
                var onRetry = function()
                {
                    self._distractor.show();
                    setTimeout( function (){ self.loadData() }, 3000 );
                };

                self._distractor.hide();
                console.error( error.toString() );
                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.SAVED, onRetry:onRetry } ) );
            };

            this._distractor.show();
            _x2._data.cancelAllPendingRequests();
            _x2._data.getScheduledRecordings( true ).then( success ).catch( fail );
        }
    };

    ScheduledWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );
        this._list.setH( val );
    };

    ScheduledWidget.prototype.speak = function( focus )
    {
        var str;

        if( focus === this || focus === undefined )
        {
            if( this._emptyMessage.isShowing() === true )
                str = this._emptyMessage.getSpeechText();
            else
                str = "Loading, please wait. ";

            this._sep.setSpeechParams( str, undefined, this, false );
        }
        else
        {
            str = this._path + ". " +
                  this._progress.getTextStatus() + ". " +
                  focus._speakStr +
                  "Press up or down to review items. Press OK for options. ";

            this._sep.setSpeechParams( str, focus._speakRole, this, false );
        }
    };

    return ScheduledWidget;

})();


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodBrowseWidget = (function()
{
    "use strict";

    VodBrowseWidget.prototype = new Widget();

    function VodBrowseWidget(){}

    VodBrowseWidget.prototype.activate = function()
    {
        var self = this, delayPatch, success, fail;

        success = function( data )
        {
            var imageY, menuY, listY = 0;
            var millisecondsLoadDuration = new Date() - self._timestampPageLoad;
            var whichTab = self._folder ? "Browse: " + self._folder.getTitle() : undefined;

            if( self._active === true )
            {
                if( whichTab )
                {
                    _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.warn( "Telemetry: " + whichTab + ", Load Time: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();
                    _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.log( "Previous Watch source: " + _x2._telemetry._watchButtonSource ) : Config.NOP();

                    _x2._telemetry.setWatchButton( whichTab );
                    if( _x2._telemetry.watchPathDepth() <= 1 )
                    {
                        _x2._telemetry.watchPathReset();
                        _x2._telemetry.watchPathPush( whichTab ); // First time enter Browse
                    }

                    _x2._telemetry.sendScreenLoadTime( millisecondsLoadDuration, whichTab );
                }

                var listData = data.getEmbeddedBrowseItems(), entries = [], types = [], type;

                for( var i = 0; i < listData.length; i++ )
                {
                    if( listData[i].getEmbeddedBrowseItems )
                    {
                        if( listData[i].getEmbeddedBrowseItems().length )
                        {
                            switch( listData[i].getChildRenderStyle() )
                            {
                                case XtvApi.EntityRenderStyle.POSTER:
                                case XtvApi.EntityRenderStyle["3X4_PROGRAM_LINEAR"]:
                                    type = GalleryRowWidget;
                                    break;

                                case XtvApi.EntityRenderStyle.PROMO:
                                    type = PromoRowWidget;
                                    break;

                                case XtvApi.EntityRenderStyle.NETWORK:
                                    type = NetworkRowWidget;
                                    break;

                                case XtvApi.EntityRenderStyle.SMALL_PROMO:
                                    type = SmallPromoRowWidget;
                                    break;

                                case XtvApi.EntityRenderStyle["16X9_PROGRAM"]:
                                    type = ProgramPromoRowWidget;
                                    break;

                                case XtvApi.EntityRenderStyle["4X3_PROGRAM_LINEAR"]:
                                    type = LinearPromoRowWidget;
                                    break;

                                default:
                                    type = undefined;
                                    console.error( "ERROR -> unsupported render style = " + listData[i].getChildRenderStyle() );
                                    break;
                            }

                            if( type )
                            {
                                entries.push( listData[i] );
                                types.push( type );
                            }
                        }
                    }
                }

                if( data.getCollectionRenderStyle() === XtvApi.CollectionRenderStyle.NETWORK_ENTITY )
                {
                    var onIconLoaded = function()
                    {
                        self._networkIcon.setH( _x2.scaleValInt( 200 ) );
                        self._networkIcon.setX( self.getW() / 2 - self._networkIcon.getW() / 2 );
                        self._networkIcon.setA( 1 );
                    };

                    imageY = _x2.scaleValInt(77);
                    listY  = _x2.scaleValInt(280);

                    self._networkIcon = new ImageWidget().init( { url:data.getImageLink(304,228), onLoad:onIconLoaded } );
                    self.addWidget( self._networkIcon, 0, imageY );
                    self._networkIcon.patchWidget();
                    self._networkIcon.setA(0);

                    if( _x2._pc.isEnabled() )
                    {
                        menuY = _x2.scaleValInt(327);
                        listY = _x2.scaleValInt(400);

                        var toggleLock = function( lock )
                        {
                            var overlay, lastFocus, params = {};

                            var validatePin = function( validatePinStr )
                            {
                                var activate, deactivate;

                                if( _x2._pc.checkPin( validatePinStr ) === true )
                                {

                                    _x2._pc.setNetworkLocks(data.getId(), lock);
                                    _x2._data.setParentalControlsSettings(_x2._pc);

                                    if( lock )
                                    {
                                        activate = self._unlockButton;
                                        deactivate = self._lockButton;
                                    }
                                    else
                                    {
                                        activate = self._lockButton;
                                        deactivate = self._unlockButton;
                                    }

                                    activate.setA(1);
                                    deactivate.setA(0);
                                    self._menu = activate;

                                    lastFocus = _x2.getOverlayRootLastFocus();

                                    if( lastFocus === self._lockButton )
                                        _x2.setOverlayRootLastFocus( self._unlockButton );
                                    else if( lastFocus === self._unlockButton )
                                        _x2.setOverlayRootLastFocus( self._lockButton );

                                    _x2.popOverlay();
                                }
                                else
                                {
                                    params.type = PinOverlay.Type.PC_VALIDATE_FAIL;
                                    _x2.pushOverlay( new PinOverlay().init( params ) );
                                    _x2.popOverlay( overlay );
                                }
                            };

                            params.type      = PinOverlay.Type.PC_VALIDATE;
                            params.onCapture = validatePin;

                            _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                        };

                        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
                        self._lockButton   = new HorizPillButtonsWidget().init( { entries:[new StringWidget().init( { text:"Lock"  , style:buttonStyle, onEnter:function(){ toggleLock(true ) } } )], spacing:0 } );
                        self._unlockButton = new HorizPillButtonsWidget().init( { entries:[new StringWidget().init( { text:"Unlock", style:buttonStyle, onEnter:function(){ toggleLock(false) } } )], spacing:0 } );

                        self.addWidget(self._lockButton, 0, menuY);
                        self._lockButton.patchWidget();
                        self._lockButton.addReadyCallback( function() { self._lockButton.setX( self.getW() / 2 - self._lockButton.getW() / 2 ) });
                        self._lockButton.setA(0);

                        self.addWidget(self._unlockButton, 0, menuY);
                        self._unlockButton.patchWidget();
                        self._unlockButton.addReadyCallback( function() { self._unlockButton.setX( self.getW() / 2 - self._unlockButton.getW() / 2 ) });
                        self._unlockButton.setA(0);

                        if( _x2._pc.isNetworkLocked(data.getId()) )
                            self._menu = self._unlockButton;
                        else
                            self._menu = self._lockButton;

                        self._menu.setA(1);
                    }
                }

                self._offsetY = listY;

                delayPatch = function()
                {
                    if( self._active === true )
                    {
                        var listParams = {}, focus;

                        self._distractor.hide();

                        if( entries === undefined || entries.length === 0 )
                        {
                            var alertTitle = 'Oops, something went wrong. Please try again later.', 
                            alertMessage = 'This folder is empty.';
                            if( _x2.getBrowseFilterString() ) {
                                alertTitle = 'Adjust filters to see more titles.';
                                alertMessage = '';
                            } 
                            _x2.pushOverlay(new AlertOverlay().init( { title: alertTitle, message: alertMessage} ) );
                            _x2._hi.fadeOut();
                        }
                        else
                        {
                            listParams.w     = _x2._config._screenW;
                            listParams.h     = _x2._config._screenH;
                            listParams.rows  = entries;
                            listParams.types = types;

                            //if this widget already contains a list, remove it now so that we don't end up with two.
                            if( self._list )
                                self.removeWidget( self._list );

                            self._list = new StaticListWidget().init( listParams );
                            self.addWidget( self._list, 0, listY );
                            self._list.patchWidget();

                            if( _x2._focus === self )
                            {
                                if( self._menu )
                                    focus = _x2.requestFocus( self._menu, false );
                                else if( self._list )
                                    focus = _x2.requestFocus( self._list, false );
                            }
                        }
                    }
                };

                setTimeout( delayPatch, 1000 );
            }
        };

        fail = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.BROWSE_SEARCH } ) );
            console.log( error.toString() )
        };

        this._timestampPageLoad = new Date();
        this._active = true;

        //fetch this on every activate and allow http caching to decide when it's stale **EXCEPT** in the case of a deep link - transition screen handles query
        if( this._folder.getMetaValue('deepLink') === true )
            success( this._folder );
        else
        {
            _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.warn( "Telemetry: starting load time for: " + this._folder.getTitle() ) : Config.NOP();
            this._distractor.show();

            _x2._data.cancelAllPendingRequests();
            var filters = _x2.getBrowseFilterString();
            _x2._data.getVodFolder( this._folder, 2, 12, filters, null, true ).then( success ).catch( fail );
        }
    };

    VodBrowseWidget.prototype.deactivate = function()
    {
        this._active = false;
        this._distractor.hide();

        if( this._list )
        {
            this.removeWidget( this._list );
            this._list = undefined;
        }
    };

    VodBrowseWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var focus;

        _x2._hi.fadeOut(0);

        if( this._menu )
            focus = _x2.requestFocus( this._menu, newScreen );
        else if( this._list )
            focus = _x2.requestFocus( this._list, newScreen );

        return focus;
    };

    VodBrowseWidget.prototype.init = function( folder )
    {
        Widget.prototype.init.call( this );
        this._className  = "VodBrowseWidget";
        this._selectable = true;
        this._folder     = folder;

        this.setW( _x2._config._screenW );
        this.setH( _x2._config._screenH - _x2.scaleValInt(150) );

        var self = this;
        this._distractor = new DistractorWidget().init();
        this._distractor.hide();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget(self); } );
        this.addWidget( this._distractor );

        return this;
    };

    VodBrowseWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;
        var self = this;

        if( type === Host.KEY_PRESSED )
        {
            if( val === Host.KEY_DOWN )
            {
                if( this._menu && _x2._focus === this._menu )
                {
                    _x2._hi.fadeOut(0);

                    this._menu.setA(0);
                    this._networkIcon.setA(0);
                    this._list.animate({y:0, duration:300, onEnd:function(){ _x2.requestFocus(self._list) }});

                    retval = true;
                }
            }
            else if( val === Host.KEY_UP )
            {
                if( this._menu && _x2._focus !== this._menu )
                {
                    _x2._hi.fadeOut(0);
                    _x2.requestFocus(this._menu);

                    this._menu.setA(1);
                    this._networkIcon.setA(1);
                    this._list.animate({y:this._offsetY, duration:300});

                    retval = true;
                }
            }
        }
        return retval;
    };

    return VodBrowseWidget;

})();


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodGridWidget = (function()
{
    "use strict";

    VodGridWidget.prototype = new Widget();

    function VodGridWidget(){}

    /**
     * @memberof VodGridWidget
     * @param {BrowseCollection} folder
     * @returns {VodGridWidget}
     */
    VodGridWidget.prototype.init = function( folder )
    {
        Widget.prototype.init.call( this );

        this._className       = "VodGridWidget";
        this._selectable      = true;

        if( folder instanceof Collection )
            this._rowsPerDataPage = Number.MAX_SAFE_INTEGER; //note: there is no paging on Collection types
        else
        {
            this._rowsPerDataPage = 10;
            this._isFavoriteGrid  = folder.isFavoriteCollection();
        }

        this._folder      = folder;
        this._loadedPages = [];
        this._rows        = [];
        this._columnCount = folder.getChildRenderStyle() === XtvApi.EntityRenderStyle["16X9_PROGRAM"] ? 4 : 5;

        var self  = this;
        var listH = _x2._config._screenH - 180;
        var listW = _x2._config._screenW - Style._safeLeft;
        var type  = folder.getChildRenderStyle() === XtvApi.EntityRenderStyle["16X9_PROGRAM"] ? SixteenNineGridRowWidget : VodGridRowWidget;

        var params          = {};
        params.w            = listW;
        params.h            = listH;
        params.hide         = true;
        params.maxIndex     = 0;
        params.type         = type;
        params.obj          = this;
        params.sep          = false;
        params.stepListener = function(val){ self.rowSelected(val) };
        params.renderStyle  = this._folder.getChildRenderStyle();

        this._distractor = new DistractorWidget().init();
        this._distractor.hide();
        this._distractor.addReadyCallback( function()
        {
            self._distractor.centerOnWidget( self._grid );
            if( !self._ready )
                self._distractor.show();
        } );
        this.addWidget( this._distractor );

        this._grid = new ListWidget().init( params );
        this.addWidget( this._grid, 0, 0 );
        this.loadData( this._isFavoriteGrid ); //always break caching when loading the favorites here. can be stale if returning here after setting favorite elsewhere.

        return this;
    };

    VodGridWidget.prototype.loadData = function( bustCache, index )
    {
        var success, fail, self = this;

        if( this._list )
        {
            this._list.setA( 0 );
            this._list._selectable = false;
        }

        success = function( data )
        {
            self._browseFolder = data;

            var embedded = data.getEmbeddedBrowseItems();

            if( embedded.length )
            {
                //trim the "all" folder
                if( embedded[0].getMeta().all === true )
                    embedded.splice( 0, 1 );

                //if this is a 'favorite' collection append a change callback to each entity to signal when we need to update the data based on change of favorite status
                if( self._isFavoriteGrid )
                    for( var n=0; n < embedded.length; n++ )
                        embedded[n]._changeCallback = function() { self._needsUpdate = true };

                //repack data into arrays of ROW_SIZE before calling set data.
                for( var i = 0; i < embedded.length; i += self._columnCount )
                {
                    var last = ( embedded.length > i + self._columnCount ) ? i + self._columnCount : embedded.length;
                    self._rows.push( embedded.slice( i, last ) );
                }

                //reset data
                self._grid.setData( self._rows );
                self._grid.setA(1);

                if( index )
                    self._grid.setJumpToIndex( index );

                self._ready = true;

                if( _x2._focus === self )
                    _x2.requestFocus( self._parent );

                self._loadedPages.push( 0 );
            }
            else
            {
                var alertTitle = 'Oops, something went wrong. Please try again later.', 
                alertMessage = 'This folder is empty.';
                if( _x2.getBrowseFilterString() ) {
                    alertTitle = 'Adjust filters to see more titles.';
                    alertMessage = '';
                }
                _x2.pushOverlay(new AlertOverlay().init( { title: alertTitle, message: alertMessage } ) );
                _x2._hi.fadeOut();
            }

            self._distractor.hide();
        };

        fail = function( error )
        {
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.BROWSE_SEARCH } ) );
            console.log( error.toString() );
        };

        var filters = _x2.getBrowseFilterString();

        if( this._folder instanceof BrowseCollection )
            _x2._data.getVodFolder( this._folder, 1, this._columnCount * this._rowsPerDataPage, filters, bustCache ).then( success ).catch( fail );
        else
            success( this._folder );
    };

    VodGridWidget.prototype.gotFocus = function()
    {
        var focus;

        _x2._hi.fadeOut(0);

        if( this._ready )
            focus = _x2.requestFocus( this._grid );

        return focus;
    };

    VodGridWidget.prototype.getColumnCount = function()
    {
        return this._columnCount;
    };

    VodGridWidget.prototype.nextPageLoaded = function( data )
    {
        var rows = [];
        for( var i = 0; i < data.length; i += this._columnCount )
        {
            var last = ( data.length > i + this._columnCount ) ? i + this._columnCount : data.length;
            rows.push( data.slice( i, last ) );
        }

        this._grid.appendData( rows );
        this._grid.setBlockingOnData( false );
        this._distractor.hide();
    };

    VodGridWidget.prototype.rowSelected = function( val )
    {
        var self = this;
        var page = 0;
        var row  = Math.floor( Math.round( val ) ) + 4; //NOTE: look ahead by 4 rows to trigger the next data page.

        if( row % this._rowsPerDataPage === 0 )
        {
            page = row / this._rowsPerDataPage;

            if( this._browseFolder.getTotalEntityCount() > ( page * this._rowsPerDataPage * this._columnCount ) )
            {
                if( page && this._loadedPages.indexOf( page ) === -1 )
                {
                    this._distractor.show();
                    this._grid.setBlockingOnData( true );
                    this._loadedPages.push( page );
                    this._browseFolder.loadNextPage().then( function(data){ self.nextPageLoaded(data) } );
                }
            }
        }
    };

    VodGridWidget.prototype.refresh = function()
    {
        if( this._needsUpdate )
        {
            var index = this._grid ? this._grid.getCurrentAndMaxIndex().current : 0;

            this._ready = false;
            this._rows = [];
            this._loadedPages = [];

            _x2._hi.fadeOut(0);

            this._grid.setA(0);
            this._distractor.show();

            this.loadData( true, index );
        }
    };

    return VodGridWidget;

})();


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GradientWidget = ( function()
{
    "use strict";

    GradientWidget.prototype             = new Widget();
    GradientWidget.prototype.constructor = GradientWidget;
    GradientWidget.SHADER                = Widget.SHADER_GRADIENT_LINEAR_2AA; // place-holder value; proper shader will be selected at render() time

    GradientWidget.Type = Object.freeze
    ({
        Linear: 0,
        Radial: 1
    });

    function GradientWidget(){}

    /**
     * @memberof GradientWidget
     * @param {Object}               params
     * @param {Object[]}            [params.alphas]      - array of 2+ { opacity: percentage, location: percentage }
     * @param {Number}              [params.angle=0]     - Angle in degrees for Linear style
     * @param {Object[]}            [params.colors]      - array of 2+ { color: HTML hex color string, location: percentage }
     * @param {String}              [params.name]        - Class name override
     * @param {Number}              [params.w]           - width in pixels
     * @param {Number}              [params.h]           - height in pixels
     * @param {GradientWidget.Type} [params.type=Linear] - Linear or Radial
     * @returns {GradientWidget}
     */
    GradientWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className = (params && params.name) ? params.name : "GradientWidget";

        if( params )
        {
            this.setW( params.w );
            this.setH( params.h );

            this._angle = params.angle || 0;
            this._type  = params.type || GradientWidget.Type.Linear;
            this.getGradients( params.alphas, params.colors );

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                this._paramW = params.w;
                this._paramH = params.h;
            }
        }

        return this;
    };

    GradientWidget.prototype.render = function( alphaParent )
    {
        var gl = Widget.gl, shader = Widget.glShaders[ this._shader ], a = this._curVal[Widget.ALPHA] * alphaParent;
        var rgba, n = this._gradients.length, aColors = this._aColors, w, h, xScale, yScale;

        // Over-ride place-holder GradientWidget.SHADER
        Widget.glShaderThis = shader;
        Widget.glShaderNext = this._shader;
        Widget.gl.useProgram( Widget.glShaderThis.program );

        Widget.gl.uniformMatrix4fv( Widget.glShaderThis.umProj, false, Widget.glProjMatrix[ Widget.glProjDepth ] );
        Widget.gl.uniformMatrix4fv( Widget.glShaderThis.umView, false, Widget.glViewMatrix[ Widget.glViewDepth ] );

        rgba = aColors[0]; gl.uniform4f( shader.uvGrad0, rgba[0], rgba[1], rgba[2], rgba[3] );
        rgba = aColors[1]; gl.uniform4f( shader.uvGrad1, rgba[0], rgba[1], rgba[2], rgba[3] );
        rgba = aColors[2]; gl.uniform4f( shader.uvGrad2, rgba[0], rgba[1], rgba[2], rgba[3] );
        rgba = aColors[3]; gl.uniform4f( shader.uvGrad3, rgba[0], rgba[1], rgba[2], rgba[3] );

        gl.uniform4f( shader.uvColor, 1, 1, 1, a );

        w      = this._curVal[ Widget.W ] || 1; // prevent divide-by-zero
        h      = this._curVal[ Widget.H ] || 0;
        xScale = this._curVal[Widget.X_SCALE];
        yScale = this._curVal[Widget.Y_SCALE];

        if( xScale !== 1 )
        {
            w *= xScale;
        }

        if( yScale !== 1 )
        {
            h *= yScale;
        }

        gl.uniform2f( shader.uvDimension, w, h );

        // Widget.SHADER_GRADIENT_RADIAL_2   // nothing extra to do
        // Widget.SHADER_GRADIENT_LINEAR_2AA // nothing extra to do for "Fast" Path - 2 colors axis aligned
        if( this._shader === Widget.SHADER_GRADIENT_LINEAR_4ROT ) // "Medium" Path - upto 4 colors any angle
        {
            if( n > 1 )
                gl.uniform4f( shader.uvStops, 0.0, this._gradients[1].x, this._gradients[n-2].x, 1.0 );

            gl.uniform1f( shader.unAngle, this._angleRad );
            gl.uniform1f( shader.unooAspectRatio, h / w );
        }
        else if( this._shader === Widget.SHADER_GRADIENT_RADIAL_4 ) // Radial
        {
            if( n > 1 )
                gl.uniform4f( shader.uvStops, 0.0, this._gradients[1].x, this._gradients[n-2].x, 1.0 );
        }

        gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
        gl.vertexAttribPointer( shader.avPosition, 2, gl.FLOAT, false, this._dataPosition, 0 ); // index, size, type, bNormalized, stride, offset
        gl.enableVertexAttribArray( shader.avPosition );
        gl.drawArrays( gl.TRIANGLE_STRIP, 0, 4 );
    };

    GradientWidget.prototype.resourcesLoad = function()
    {
        var gl, w, h, verts;

        Widget.prototype.resourcesLoad.call( this );

        if(  _x2._config._render === Config.RENDER_WEBGL )
        {
            gl = Widget.gl;
            w  = this._curVal[Widget.W];
            h  = this._curVal[Widget.H];

            verts =
            [
                0, 0,
                w, 0,
                0, h,
                w, h
            ];

            this._dataPosition = new Float32Array( verts );
            this._buffPosition = gl.createBuffer();

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
            gl.bufferData( gl.ARRAY_BUFFER, this._dataPosition, gl.DYNAMIC_DRAW ); // Dynamic
        }

        this.setAngle( this._angle );
    }

    GradientWidget.prototype.layout = function()
    {
        var i, n = this._gradients.length, grad = this._gradients;

        var obj, loc;
        var color;
        var r,g,b,a;

        if( _x2._config._render === Config.RENDER_DOM )
        {
            var bg = "";

            switch( this._type )
            {
                case GradientWidget.Type.Linear:
                    bg = "linear-gradient(" + this._angle + "deg";
                    break;

                case GradientWidget.Type.Radial:
                    bg = "radial-gradient(ellipse at center";
                    break;

                default:
                    console.error( "ERROR -> Invalid gradient fill style" );
                    n = 0;
                    break;
            }

            for( i = 0; i < n; i++ )
            {
                obj   = this._gradients[i];
                color = obj.color;
                loc   = obj.x;

                r = parseInt( color.substring( 1,3 ), 16 );
                g = parseInt( color.substring( 3,5 ), 16 );
                b = parseInt( color.substring( 5,7 ), 16 );
                a = obj.alpha;
                bg += ", rgba(" + r + "," + g + "," + b + "," + a + ") " + loc + "%";
            }
            bg += ")"; // NOTE: Do NOT include semi-colon after 'gradient()' !

//console.info( bg );

            this._div.style.background = bg;
        }
        else if(  _x2._config._render === Config.RENDER_WEBGL )
        {
            if( this._type === GradientWidget.Type.Linear )
            {
                if( (n === 2) && ((this._angle % 90) === 0) )
                {
                    this._shader = Widget.SHADER_GRADIENT_LINEAR_2AA;
                    switch( this._angle ) // "Fast" Path - only 2 colors and axis aligned -- 0, 90, 180, 270 -> setup corner colors
                    {
                        case 0:
                            this._aColors[0] = grad[  0].rgba; // Bottom Left
                            this._aColors[1] = grad[n-1].rgba; // Bottom Right
                            this._aColors[2] = grad[  0].rgba; // Top Left
                            this._aColors[3] = grad[n-1].rgba; // Top Right
                            break;

                        case 90:
                            this._aColors[0] = grad[n-1].rgba; // Bottom Left
                            this._aColors[1] = grad[n-1].rgba; // Bottom Right
                            this._aColors[2] = grad[  0].rgba; // Top Left
                            this._aColors[3] = grad[  0].rgba; // Top Right
                            break;

                        case 180:
                            this._aColors[0] = grad[n-1].rgba; // Bottom Left
                            this._aColors[1] = grad[  0].rgba; // Bottom Right
                            this._aColors[2] = grad[n-1].rgba; // Top Left
                            this._aColors[3] = grad[  0].rgba; // Top Right
                            break;

                        case 270:
                            this._aColors[0] = grad[  0].rgba; // Bottom Left
                            this._aColors[1] = grad[  0].rgba; // Bottom Right
                            this._aColors[2] = grad[n-1].rgba; // Top Left
                            this._aColors[3] = grad[n-1].rgba; // Top Right
                            break;
                    }
                }
                else if( n < 5 )
                {
                    this._shader = Widget.SHADER_GRADIENT_LINEAR_4ROT;

                    this._aColors[0] = grad[  0].rgba; // color at  0 %
                    this._aColors[1] = grad[  1].rgba; // color at x1 %
                    this._aColors[2] = grad[n-2].rgba; // color at x2 %
                    this._aColors[3] = grad[n-1].rgba; // color at 100%
                }
                else
                    console.error( "WebGL ERROR: Implement Linear Gradient > 4 stops!" );

            }
            else
            {
                // n < 2 already verifed in getGradients()
                if( n === 2 )
                    this._shader = Widget.SHADER_GRADIENT_RADIAL_2;
                else if( n < 5 )
                    this._shader = Widget.SHADER_GRADIENT_RADIAL_4;
                else
                    console.error( "WebGL ERROR: Implement Radial Gradient > 4 stops!" );
                /*
                    n   stop0    stop1    stop2    stop3   n-2  n-1
                    2   grad[0]  grad[1]  n/a      n/a       0    1
                    3   grad[0]  grad[1]  grad[2]  n/a       1    2
                    4   grad[0]  grad[1]  grad[2]  grad[3]   2    3

                    NOTE:
                        grad[  0] =   0%
                        grad[n-1] = 100%
                */

                this._aColors[0] = grad[  0].rgba; // 1st stop @ 0%
                this._aColors[1] = grad[  1].rgba; // 2nd stop
                this._aColors[2] = grad[n-2].rgba; // 3rd stop
                this._aColors[3] = grad[n-1].rgba; // 4th stop @ 100%
            }
        }
    };

    // Internal Use Only
    // @param {Object[]} alphas
    // @param {Object[]} colors
    // @param {Boolean}  normalizeLocation - true if locations are 0% ... 100%, false if locations already normalized
    // this._gradients[] // DOM & WebGL
    GradientWidget.prototype.getGradients = function( alphas, colors )
    {
        var locNormalizeInverse = Widget.gl
            ? 1.0 / 100.0
            : 1.0
            ;

        // Linearly Interpolate, aka 'mix' or 'lerp'
        // NOTE: Non-standard argument order to be consistent with Widget.interpolateColor()
        // @param {Number} t - normalized percentage to mix between 'a' and 'b', 0.0 = a, 1.0 = b
        // @param {Number} a - min value
        // @param {Number} b - max value
        var lerp = function( t, a, b ) // NOTE: TODO: Should be in Math Utility or Widget.Easing
        {
            return a + (b-a)*t;
        };

        // @param {Number} alpha    - normalized percentage
        // @param {Number} location - percentage
        var makeAlphaLocationObject = function( alpha, location )
        {
            return {
                alpha: alpha,
                x    : location
            };
        };

        // @param {String} color    - 7 character HTML hex color string in format "#RRGGBB"
        // @param {Number} location - percentage
        var makeColorLocationObject = function( color, location )
        {
            return {
                color: color,
                x    : location
            };
        };

        var alphaIdx = 0, alphaLen = alphas.length;
        var colorIdx = 0, colorLen = colors.length;

        var alphaObj = alphas[0];
        var colorObj = colors[0];

        var alphaLoc = alphaObj.location * locNormalizeInverse;
        var colorLoc = colorObj.location * locNormalizeInverse;

        var alphaVal = alphaObj.opacity / 100;
        var colorVal = colorObj.color;

        var alphaPrevIdx = alphaIdx;
        var colorPrevIdx = colorIdx;

        var iStop, nStop;
        var obj, prev;

        var aAlpha = [];
        var aColor = [];
        var grad   = [];

        var x0, w1, w2, t;
        var a, c;


        if( !Array.isArray( alphas ) || alphaLen < 2 )
            return console.error( "ERROR -> Gradient alphas[] must be 2+ elements" );

        if( !Array.isArray( colors ) || colorLen < 2 )
            return console.error( "ERROR -> Gradient colors[] must be 2+ elements" );

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._aColors = [];
        }

        // Deep Copy: Add Alpha Locations: Start @ 0% and End @ 100% if missing
        if( alphaLoc !== 0 )
            aAlpha.push( makeAlphaLocationObject( alphaVal, 0 ) );

        for( ; alphaIdx < alphaLen; alphaIdx++ )
            aAlpha.push( makeAlphaLocationObject( alphas[ alphaIdx ].opacity / 100, alphas[ alphaIdx ].location * locNormalizeInverse) );

        if( alphas[ alphaLen - 1 ].location !== 100 )
            aAlpha.push( makeAlphaLocationObject( alphas[ alphaLen - 1 ].opacity / 100, 100 * locNormalizeInverse ) );

        // Deep Copy: Add Color Locations: Start @ 0% and End @ 100% if missing
        if( colorLoc !== 0 )
            aColor.push( makeColorLocationObject( colorVal, 0 ) );

        for( ; colorIdx < colorLen; colorIdx++ )
            aColor.push( makeColorLocationObject( colors[ colorIdx ].color, colors[ colorIdx ].location * locNormalizeInverse ) );

        if( colors[ colorLen - 1 ].location !== 100 )
            aColor.push( makeColorLocationObject( colors[ colorLen - 1 ].color, 100 * locNormalizeInverse ) );


        // Duplicate last alpha/color to keep "next index" in bounds for interpolation
        alphaIdx = 0; alphaLoc = 0; alphaLen = aAlpha.length;
        colorIdx = 0; colorLoc = 0; colorLen = aColor.length;

        aAlpha.push( aAlpha[ alphaLen - 1 ] );
        aColor.push( aColor[ colorLen - 1 ] );

        nStop = alphaLen + colorLen; // maximum number of stops -- some of these may get collapsed if colorLoc and AlphaLoc are at same location
        prev =
        {
            alpha: alphaVal,
            color: colorVal,
            x    : 0
        };

        for( iStop = 0; iStop < nStop; )
        {
            if( (alphaIdx < alphaLen) && (alphaLoc < colorLoc) ) // interpolate color
            {
                /*        x0         x1        x2
                   0.0 --------------|------------- 1.0 Alpha Location
                   0.0 ---|--------------------|--- 1.0 Color Location
                          ^          ^         ^
                          colorLeft  alphaLoc  colorLoc
                          <----w1---->
                          <----w2-------------->
                */
                x0   = aColor[ colorPrevIdx ].x;
                w1   = alphaLoc - x0;
                w2   = colorLoc - x0;
                t    = w1 / w2;
                c    = this.interpolateColor( t, prev.color, colorVal ); // aColor[ colorPrevIdx ].color

                obj =
                {
                    alpha: alphaVal,
                    color: c,
                    x    : alphaLoc
                };
                alphaPrevIdx = alphaIdx++;
                iStop++;
            }
            else if( (colorIdx < colorLen) && (alphaLoc > colorLoc) ) // interpolate alpha
            {
                /*        x0         x1        x2
                   0.0 ---|--------------------|--- 1.0 Alpha Location
                   0.0 --------------|------------- 1.0 Color Location
                          ^          ^         ^
                          alphaLeft  colorLoc  alphaLoc
                          <----w1---->
                          <----w2-------------->
                */
                x0  = aAlpha[ alphaPrevIdx ].x;
                w1  = colorLoc - x0;
                w2  = alphaLoc - x0;
                t   = w1 / w2;
                a   = lerp( t, prev.alpha, alphaVal ); // aAlpha[ alphaPrevIdx ].opacity/100

                obj =
                {
                    alpha: a,
                    color: colorVal,
                    x    : colorLoc
                };
                colorPrevIdx = colorIdx++;
                iStop++;
            }
            else // collapse down into 1 entry, no interpolation needed
            {
                obj =
                {
                    alpha: alphaVal,
                    color: colorVal,
                    x    : colorLoc
                };

                alphaPrevIdx = alphaIdx++;
                colorPrevIdx = colorIdx++;
                iStop += 2;
            }

            if( alphaIdx < alphaLen ) alphaObj = aAlpha[ alphaIdx ];
            if( colorIdx < colorLen ) colorObj = aColor[ colorIdx ];

            alphaVal = alphaObj.alpha; alphaLoc = alphaObj.x;
            colorVal = colorObj.color; colorLoc = colorObj.x;


            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                var rgba = Widget.glColorHexToFloat( obj.color );
                rgba[3]  = obj.alpha;

                // https://www.w3.org/TR/css3-images/#color-stop-syntax
                // Between two color-stops, the line's color is linearly interpolated
                // between the colors of the two color-stops,
                // with the interpolation taking place in premultiplied RGBA space.
                rgba[0] *= obj.alpha;
                rgba[1] *= obj.alpha;
                rgba[2] *= obj.alpha;

                obj.rgba = rgba;
            }

//console.info( obj ); // DEBUG only

            grad.push( obj );
            prev = obj;
        }

        this._gradients = grad;
    };

    GradientWidget.prototype.setAngle = function( angle )
    {
        if( _x2._config._render === Config.RENDER_DOM )
        {
            /*
                Who designed this "standard" ???

                    1) Ignore _standard_ trigonometric angle conventions (0 degrees = left-to-right)
                    2) Uses positive clock-wise angles !?

                DOM          <- Trigonometric angle

                315   0   45    135   90   45
                   <  ^  >         <  ^  >
                    \ | /           \ | /
                     \|/             \|/
                270<--+--> 90   180<--+-->  0
                     /|\             /|\
                    / | \           / | \
                   <  v  >         <  v  >
                225  180  135   225  270  315

                Reference:

                    https://www.w3.org/TR/css3-images/#linear-gradients
                    For the purpose of this argument, ‘0deg’ points upward, and positive angles represent clockwise rotation, so ‘90deg’ point toward the right.
            */
            this._angle = (360 - ((angle || 0) - 90)); // *sigh*
//console.info( "Gradient Angle: " + params.angle + " --DOM-> " + this._angle );
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._angle  = (angle || 0);
        }

        this._angle %= 360;
        if( this._angle < 0 ) // mod doesn't convert negative to positive
            this._angle += 360;

        this._angleRad = this._angle * Math.PI / 180.0; // DEG2RAD()

        this.layout();

    }

    return GradientWidget;

})();


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ImageWidget = ( function()
{
    "use strict";

    ImageWidget.prototype             = new Widget();
    ImageWidget.prototype.constructor = ImageWidget;
    ImageWidget.SHADER                = Widget.SHADER_KVT;

    function ImageWidget(){}

    ImageWidget.prototype.getUrl = function()
    {
        return this._url;
    };

    /**
     * @memberof ImageWidget
     * @param {Object}   [params]
     * @param {String}   [params.name]     - Class name override
     * @param {String}   [params.url]      - image URL
     * @param {Number}   [params.xScale]   - x-axis scale factor
     * @param {Number}   [params.yScale]   - y-axis scale factor
     * @param {Number}   [params.w]        - width in pixels
     * @param {Number}   [params.h]        - height in pixels
     * @param {Function} [params.onChange] - Callback
     * @param {Function} [params.onError]  - Callback
     * @param {Function} [params.onFocus]  - Callback
     * @param {Function} [params.onLoad]   - Callback
     * @returns {ImageWidget}
     */
    ImageWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className = (params && params.name) ? params.name : "ImageWidget";

        if( params )
        {
            if( params.xScale !== undefined )
                this.setScaleX( params.xScale );

            if( params.yScale !== undefined )
                this.setScaleY( params.yScale );

            this.setW( params.w );
            this.setH( params.h );

            this._url     = params.url;
            this._onError = params.onError;

            if( params.onChange )
                this.addChangeCallback( params.onChange );

            if( params.onLoad )
                this.addReadyCallback( params.onLoad );

            if( params.onFocus )
                this.setFocusListeners( params.onFocus );

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                this._paramW = params.w;
                this._paramH = params.h;
            }
        }

        return this;
    };

    ImageWidget.prototype.layoutVertices = function()
    {
        var iw   = this._image.width;
        var ih   = this._image.height;
        var w    = this._paramW || iw;
        var h    = this._paramH || ih;
        var hasW = this._paramW !== undefined;
        var hasH = this._paramH !== undefined;

        // mimic DOM behavior such that if only one axis is specified, proportions are constrained

        if( hasW && !hasH )
            h = h * w/iw;
        else if( !hasW && hasH )
            w = w * h/ih;

        // need to make sure values are rounded to float 32
        // prevent fractional dimensions from false positive of this._dataPosition[2] !== getW()
        w |= 0;
        h |= 0;

        if( this._dataPosition )
        {
            this._dataPosition[2] = this._dataPosition[6] = w;
            this._dataPosition[5] = this._dataPosition[7] = h;
        }

        this._curVal[ Widget.W ] = w;
        this._curVal[ Widget.H ] = h;
    };

    ImageWidget.prototype.render = function( alphaParent )
    {
        var gl = Widget.gl, shader = Widget.glShaderThis, w, h, wChanged, hChanged;

        if( this._texture )
        {
            w        = this.getW();
            h        = this.getH();
            wChanged = this._dataPosition[2] != w;
            hChanged = this._dataPosition[5] != h;

            if( wChanged )
                this._paramW = w;

            if( hChanged )
                this._paramH = h;

            if( wChanged || hChanged )
                this.layoutVertices();

            gl.uniform4f( shader.uvColor, alphaParent, alphaParent, alphaParent, alphaParent );

            gl.activeTexture( gl.TEXTURE0 );
            gl.bindTexture( gl.TEXTURE_2D, this._texture );
            gl.uniform1i( shader.utDiffuse1, 0 );

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffTexCoord );
            gl.vertexAttribPointer( shader.avTexCoord, 2, gl.FLOAT, false, this._dataTexCoord, 0 );
            gl.enableVertexAttribArray( shader.avTexCoord );

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
            gl.bufferData( gl.ARRAY_BUFFER, this._dataPosition, gl.STATIC_DRAW );
            gl.vertexAttribPointer( shader.avPosition, 2, gl.FLOAT, false, this._dataPosition, 0 ); // index, size, type, bNormalized, stride, offset
            gl.enableVertexAttribArray( shader.avPosition );

            gl.drawArrays( gl.TRIANGLE_STRIP, 0, 4 );
        }
    };

    ImageWidget.prototype.resourcesLoad = function()
    {
        var self = this, img, onError, onLoad;

        onError = function()
        {
            self._failed = true;

            if( self._onError )
                self._onError();
        };

        onLoad = function()
        {
            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                var gl = Widget.gl;

                self._dataPosition = new Float32Array( [ 0, 0, 0, 0, 0, 0, 0, 0 ] );
                self._dataTexCoord = new Float32Array( [ 0, 0, 1, 0, 0, 1, 1, 1 ] );

                self.setW( self._paramW );
                self.setH( self._paramH );

                self._texture = gl.createTexture();
                self._buffPosition = gl.createBuffer();
                self._buffTexCoord = gl.createBuffer();  // texture

                gl.bindBuffer( gl.ARRAY_BUFFER, self._buffPosition );
                gl.bufferData( gl.ARRAY_BUFFER, self._dataPosition, gl.STATIC_DRAW );

                gl.bindBuffer( gl.ARRAY_BUFFER, self._buffTexCoord );
                gl.bufferData( gl.ARRAY_BUFFER, self._dataTexCoord, gl.STATIC_DRAW );

                gl.bindTexture( gl.TEXTURE_2D, self._texture );
                gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, self._image );

                // non-power-of-2 textures ARE supported IF no mipmaps and clamp to edge
                gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR        );
                gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR        );
                gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S    , gl.CLAMP_TO_EDGE );
                gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T    , gl.CLAMP_TO_EDGE );
                gl.bindTexture( gl.TEXTURE_2D, null );
            }

            self.callbackSignalReady();
            self.callbackSignalChange();
        };

        img         = document.createElement( 'img' );
        img.crossOrigin = "";
        img.onload  = onLoad;
        img.onerror = onError;

        if( _x2._config._render === Config.RENDER_DOM )
            this._div = img;
        else if( _x2._config._render === Config.RENDER_WEBGL )
            this._image = img;

        if( this._url )
            img.src = this._url;

        Widget.prototype.resourcesLoad.call( this );
    };

    ImageWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._paramH = val;

            if( this._image && this._image.complete )
                this.layoutVertices();
        }
    };

    ImageWidget.prototype.setOnError = function( funct )
    {
        this._onError = funct;
    }

    /**
     * Set the URL of the image to display
     * @memberof ImageWidget
     * @param {String} [url] - image URL, if not defined image will be cleared
     */
    ImageWidget.prototype.setUrl = function( url )
    {
        var img;

        this._url = url;

        if( _x2._config._render === Config.RENDER_DOM )
            img = this._div;
        else if( _x2._config._render === Config.RENDER_WEBGL )
            img = this._image;

        if( img )
        {
            if( img.src === url )
            {
                if( ! this._failed )
                {
                    this.callbackSignalReady();
                    this.callbackSignalChange();
                }
            }
            else
            {
                this._failed = false;

                img.src = url ? url : "";
            }
        }
    };

    ImageWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._paramW = val;

            if( this._image && this._image.complete )
                this.layoutVertices();
        }
    };
    /**
     * This will replace the height and weight for an image url with regexp
     */
    ImageWidget.prototype.setUrlWithDimension = function( w, h ) {
        var url = this.getUrl();
        if( url && w && h ) {
            var newUrl = url.replace(/width=\d{1,3}&height=\d{1,3}/g,'width=' + w +'&height=' + h);
            if( newUrl ) {
                this.setUrl( newUrl );
            }
        }
    }

    return ImageWidget;

})();


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.NineSliceWidget = ( function()
{
    "use strict";

    NineSliceWidget.prototype             = new Widget();
    NineSliceWidget.prototype.constructor = NineSliceWidget;
    NineSliceWidget.SHADER                = Widget.SHADER_KVT;

    function NineSliceWidget(){}

    NineSliceWidget.prototype.getInsetX = function()
    {
        return this._left;
    };

    NineSliceWidget.prototype.getInsetY = function()
    {
        return this._top;
    };

    /**
     * @memberof NineSliceWidget
     * @param {Axis} axis
     * @returns {number}
     */
    NineSliceWidget.prototype.getVal = function( axis )
    {
        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            if( axis === Widget.W )
                return (this._curVal[ Widget.W ] + this._left + this._right) | 0;
            if( axis === Widget.H )
                return (this._curVal[ Widget.H ] + this._top  + this._bottom) | 0;
        }

        return Widget.prototype.getVal.call( this, axis );
    };

    /**
     * Initializer
     * @memberof NineSliceWidget
     * @param {Object}  params
     * @param {String}  params.url   - URL or local filename
     * @param {Number} [params.w=0]  - Width in pixels
     * @param {Number} [params.h=0]  - Height in pixels
     * @param {String} [params.name] - Class name over-ride
     * @param {Boolean}[params.pma]  - Set this to false for special circumstances when pre-multiplied alpha is blending as white instead of transparency.
     * @returns {NineSliceWidget}
     */
    NineSliceWidget.prototype.init = function( params )
    {
        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "NineSliceWidget";

        Widget.prototype.init.call( this );

        var dims = (params.url.split( "." )[0]).split( "_");  // top right bottom left

        dims.splice( 0, 1 );

        this._left   = parseInt( dims[0] );
        this._right  = parseInt( dims[1] );
        this._top    = parseInt( dims[2] );
        this._bottom = parseInt( dims[3] );
        this._url    = params.url;
        this._pma    = !!params.pma;

        this.setW( params.w ? params.w : 0 );
        this.setH( params.h ? params.h : 0 );

        return this;
    };

    /**
     * WebGL only: draw image
     * <p>
     * NOTE: Vertex colors are hard-coded to RGBA = &lt;a,a,a,a&gt; where a is alphaParent
     * @memberof NineSliceWidget
     * @param {Number} alphaParent - parent's alpha * current alpha
     */
    NineSliceWidget.prototype.render = function( alphaParent )
    {
        var gl = Widget.gl, shader = Widget.glShaderThis;

        if( this._pending )
            return;

        var w = (this._curVal[ Widget.W ] + this._left + this._right ) | 0;
        var h = (this._curVal[ Widget.H ] + this._top  + this._bottom) | 0;

        var hasW = (w !== this._width );
        var hasH = (h !== this._height);

        if( hasW || hasH )
        {
            var i, verts = this._dataPosition;

            if( hasW )
            {
                var cw = this._curVal[ Widget.W ];
                var x2 = this._left + ((cw < 0) ? w : cw);
                var x3 = x2 + this._right;

                // [16, 20, 24, 28, 32, 36, 40] = x2
                for( i = 16; i < 44; i += 4 )
                    verts[ i ] = x2;

                // [30, 34, 38, 42] = x3
                for( i = 30; i < 44; i += 4 )
                    verts[ i ] = x3;

                this._width = w;
            }

            if( hasH )
            {
                var ch = this._curVal[ Widget.H ];
                var y2 = this._top + ((ch < 0) ? h : ch);
                var y3 = y2 + this._bottom;

                // [9, 11, 19, 21, 37, 39] = y2
                for( i = 9; i < 20; i += 10 )
                {
                    verts[ i   ] = y2;
                    verts[ i+2 ] = y2;
                }

                verts[37] = y2;
                verts[39] = y2;

                // [13, 15, 17, 41, 43] = y3
                for( i = 13; i < 44; i += 28 )
                {
                    verts[ i   ] = y3;
                    verts[ i+2 ] = y3;
                }

                verts[17] = y3;

                this._height = h;
            }

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
            gl.bufferData( gl.ARRAY_BUFFER, this._dataPosition, gl.STATIC_DRAW );
        }

        gl.activeTexture( gl.TEXTURE0 );
        gl.bindTexture( gl.TEXTURE_2D, this._texture );
        gl.uniform1i( shader.utDiffuse1, 0 );

        gl.bindBuffer( gl.ARRAY_BUFFER, this._buffTexCoord );
        gl.vertexAttribPointer( shader.avTexCoord, 2, gl.FLOAT, false, this._dataTexCoord, 0 );
        gl.enableVertexAttribArray( shader.avTexCoord );

        gl.uniform4f( shader.uvColor, alphaParent, alphaParent, alphaParent, alphaParent );

        gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
        gl.vertexAttribPointer( shader.avPosition, 2, gl.FLOAT, false, this._dataPosition, 0 ); // index, size, type, bNormalized, stride, offset
        gl.enableVertexAttribArray( shader.avPosition );

        if( this._pma === false )
            gl.blendFunc( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA );

        gl.drawArrays( gl.TRIANGLE_STRIP, 0, 22 );

        if( this._pma === false )
            gl.blendFunc( gl.ONE, gl.ONE_MINUS_SRC_ALPHA ); // always leave premultiplied alpha on; see glInit()
    };

    NineSliceWidget.prototype.resourcesLoad = function()
    {
        var self, gl;

        Widget.prototype.resourcesLoad.call( this );

        if( _x2._config._render === Config.RENDER_DOM )
        {
            this._div.style.border      = "solid transparent";
            this._div.style.borderImage = "url(" + this._url + ") " + this._top + " " + this._right + " " + this._bottom + " " + this._left + " fill";
            this._div.style.borderWidth = this._top + "px " + this._right + "px " + this._bottom + "px " + this._left + "px";
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            self = this;
            gl   = Widget.gl;

            this._pending = true;

            var w = this._curVal[Widget.W] | 0;
            var h = this._curVal[Widget.H] | 0;

            var x1 =     this._left;
            var x2 = w + this._left;
            var x3 = w + this._left + this._right;

            var y1 =     this._top;
            var y2 = h + this._top;
            var y3 = h + this._top + this._bottom;

            this._dataPosition = new Float32Array([ // 44 vertices
                 0, 0,  x1, 0,   0,y1,  x1,y1,   0,y2,  x1,y2,   0,y3,  x1,y3,
                x2,y3,  x1,y2,  x2,y2,  x1,y1,  x2,y1,  x1, 0,  x2, 0,
                x3, 0,  x2,y1,  x3,y1,  x2,y2,  x3,y2,  x2,y3,  x3,y3
            ]);

            this._buffPosition = gl.createBuffer();
            this._buffTexCoord = gl.createBuffer();

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
            gl.bufferData( gl.ARRAY_BUFFER, this._dataPosition, gl.STATIC_DRAW );

            this._image = new Image();

            this._image.onload = function()
            {
                var imgW = self._image.width;
                var imgH = self._image.height;

                var rW = 1 / imgW;
                var rH = 1 / imgH;

                var s1 = self._left           * rW;
                var s2 = (imgW - self._right) * rW;

                var t1 = self._top             * rH;
                var t2 = (imgH - self._bottom) * rH;

/*
              0, 0                    0, 1
             s0,t0   s1,t0   s2,t0   s3,t0

         s0,t0 A-------B-------L-------M s3,t0
               |...../.|.\.....|...../.|
               |.1../..|..\.13.|.15./..|
               |.../...|...\...|.../...|
               |../..2.|.12.\..|../.16.|
               |./.....|.....\.|./.....|
         s0,t1 C/______D______\K/______N s3,t1
               |...../.|.\.....|...../.|
               |.3../..|..\.11.|.17./..|
               |.../...|...\...|.../...|
               |../..4.|.10.\..|../.18.|
               |./.....|.....\.|./.....|
         s0,t2 E/______F______\J/______O s3,t2
               |...../.|.\.....|...../.|
               |.5../..|..\..9.|.19./..|
               |.../...|...\...|.../...|
               |../..6.|.8..\..|../.20.|
               |./.....|.....\.|./.....|
         s0,t3 G/______H______\I/______P s3,t3

             s0,t3   s1,t3   s2,t3   s3,t3
              0, 1                    1, 1
*/

                self._dataTexCoord = new Float32Array(
                [ // 44 = 22 vertices
                     0, 0,  s1, 0,   0,t1, // A B C
                    s1,t1,   0,t2,  s1,t2, // D E F
                    0 , 1,  s1, 1,  s2, 1, // G H I
                    s1,t2,  s2,t2,  s1,t1, // F J D
                    s2,t1,  s1, 0,  s2, 0, // K B L
                     1, 0,  s2,t1,   1,t1, // M K N
                    s2,t2,   1,t2,  s2, 1, // J O I
                     1, 1                  // P
                ]);

                gl.bindBuffer( gl.ARRAY_BUFFER, self._buffTexCoord );
                gl.bufferData( gl.ARRAY_BUFFER, self._dataTexCoord, gl.DYNAMIC_DRAW );

                self._texture = Widget.glMakeTexture( imgW, imgH,  self._image, gl.RGBA );

                self._pending = false;
            };

            this._image.src = this._url;
        }
    };

    /**
     * @memberof NineSliceWidget
     * @param {Object}             params
     * @param {Boolean|Undefined} [params.inner] - true if dimensions need to be inset for all four borders
     * @param {Number|Undefined}  [params.w]     - Only if inner
     * @param {Number|Undefined}  [params.h]     - Only if inner
     * @param {Number|Undefined}  [params.x]     - Only if not inner
     * @param {Number|Undefined}  [params.y]     - Only if not inner
     */
    NineSliceWidget.prototype.setPosition = function( params )
    {
        if( params.inner === true )
        {
            if( params.w !== undefined )
                params.w = params.w - this._left - this._right;

            if( params.h !== undefined )
                params.h = params.h - this._top  - this._bottom;
        }
        else
        {
            if( params.x !== undefined )
                params.x = params.x - this._left;

            if( params.y !== undefined )
                params.y = params.y - this._top;
        }

        this.animate( params );
    };

    return NineSliceWidget;

})();



/***/ }),
/* 85 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RectWidget = ( function()
{
    "use strict";

    RectWidget.prototype             = new Widget();
    RectWidget.prototype.constructor = RectWidget;
    RectWidget.SHADER                = Widget.SHADER_KV;

    function RectWidget(){}

    /** Over-ride to include border thickness for width and height
     * @memberof RectWidget
     * @param {Axis} axis - Widget.H or Widget.W
     */
    RectWidget.prototype.getVal = function( axis )
    {
        var retval = Widget.prototype.getVal.call( this, axis );

        if( this._bThickness )
        {
            switch( axis )
            {
                case Widget.H:
                    switch( typeof( this._bThickness ) )
                    {
                        case "number":
                            retval -= 2 * this._bThickness;
                            break;

                        case "object":
                            retval -= this._bThickness[0] + this._bThickness[2];
                            break;
                    }
                    break;

                case Widget.W:
                    switch( typeof( this._bThickness ) )
                    {
                        case "number":
                            retval -= 2 * this._bThickness;
                            break;

                        case "object":
                            retval -= this._bThickness[1] + this._bThickness[3];
                            break;
                    }
                    break;
            }
        }

        return retval;
    };

    /**
     * Get border as valid array
     * <p>
     * Note: Only used by WebGL but is render agnostic
     * @memberof RectWidget
     * @returns {Number[]} - [ top, left, bottom, right ]
     */
    RectWidget.prototype.getBorderArray = function()
    {
        return Array.isArray( this._bThickness )
            ?                 this._bThickness        // border = [top,left,bottom,right]
            :  Array(4).fill( this._bThickness | 0 ); // border = #
    };

    /**
     * Initializer
     * <p>
     * Three types of rectangles are supported:
     * <p>
     * 1. Inside only via `params.color`
     * 2. Border only via `params.borderColor`
     * 3. Border and Inside via `params.color` and `params.borderColor`
     * @memberof RectWidget
     * @param {Object}  params                    - parameters to define how the rectangle should be displayed
     * @param {Number}  params.w                  - Width in pixels
     * @param {Number}  params.h                  - Height in pixels
     * @param {String} [params.color]             - HTML 6 hex digit color; e.g. '#000000'
     * @param {Number} [params.borderThickness]   - Border thickness in pixels
     * @param {Number} [params.borderThickness[]] - Border thickness [top,left,bottom,right]
     * @param {String} [params.borderColor]       - HTML 6 hex digit color; e.g. '#000000'
     * @param {String} [params.name]              - Class name over-ride
     * @note: params.borderColor must be specified if params.borderThickness is
     */
    RectWidget.prototype.init = function( params )
    {
        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "RectWidget";

        Widget.prototype.init.call( this );

        // create instance variables here

        this.setW( params.w );
        this.setH( params.h );

        this._color      = params.color;
        this._bThickness = params.borderThickness;
        this._bColor     = params.borderColor;

        return this;
    };

    /**
     * WebGL only: draw rectangle either inside only, border only, or inside + border
     * @memberof RectWidget
     * @param {Number} alphaParent - parent's alpha * current alpha
     */
    RectWidget.prototype.render = function( alphaParent )
    {
        var gl = Widget.gl, shader = Widget.glShaderThis;

        var w  = this._curVal[Widget.W];
        var h  = this._curVal[Widget.H];

        var border;
        var x2, x3;
        var y2, y3;

        gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );

        if( (this._lastW !== w) || (this._lastH !== h) )
        {
            this._lastW = w;
            this._lastH = h;

            border = this.getBorderArray();

            x2 = w + border[3];
            x3 = w + border[3] + border[1];

            y2 = h + border[0];
            y3 = h + border[0] + border[2];

            if( this._bThickness )
            {
                this._dataPosition[26] = x2;
                this._dataPosition[30] = x2;
                this._dataPosition[32] = x2;
                this._dataPosition[34] = x2;

                this._dataPosition[20] = x3;
                this._dataPosition[22] = x3;
                this._dataPosition[24] = x3;
                this._dataPosition[28] = x3;

                this._dataPosition[19] = y2;
                this._dataPosition[23] = y2;
                this._dataPosition[25] = y2;
                this._dataPosition[27] = y2;

                this._dataPosition[13] = y3;
                this._dataPosition[15] = y3;
                this._dataPosition[17] = y3;
                this._dataPosition[21] = y3;
            }

            // Common to with-border and without-border
            this._dataPosition[2] = x2;
            this._dataPosition[6] = x2;

            this._dataPosition[5] = y2;
            this._dataPosition[7] = y2;

            // Update vertices
            gl.bufferSubData( gl.ARRAY_BUFFER, 0, this._dataPosition );
        }

        gl.vertexAttribPointer( shader.avPosition, 2, gl.FLOAT, false, this._dataPosition, 0 ); // index, size, type, bNormalized, stride, offset
        gl.enableVertexAttribArray( shader.avPosition );

        if( this._bThickness )
        {
            gl.uniform4f( shader.uvColor, this._borderRGBA[0] * alphaParent, this._borderRGBA[1] * alphaParent, this._borderRGBA[2] * alphaParent, this._borderRGBA[3] * alphaParent );
            gl.drawArrays( gl.TRIANGLE_STRIP, 4, 16 ); // outside border starts at 4
        }

        if( this._color )
        {
            var r = this._colorsRGBA[0] * alphaParent;
            var g = this._colorsRGBA[1] * alphaParent;
            var b = this._colorsRGBA[2] * alphaParent;
            var a = this._colorsRGBA[3] * alphaParent;

            gl.uniform4f( shader.uvColor, r, g, b, a );
            gl.drawArrays( gl.TRIANGLE_STRIP, 0, 4 ); // common inside border starts at 0
        }
    };

    RectWidget.prototype.resourcesLoad = function()
    {
        var i, str;
        var gl, w, h, verts, border;

        Widget.prototype.resourcesLoad.call( this );

        if( _x2._config._render === Config.RENDER_DOM )
        {
            this._div.style.backgroundColor = this._color;

            if( this._bThickness )
            {
                switch( typeof( this._bThickness ) )
                {
                    case "number":
                        this._div.style.border = this._bThickness + "px solid " + this._bColor;
                        break;

                    case "object":
                        str = "";

                        for( i = 0; i < this._bThickness.length; i++ )
                            str += this._bThickness[i] + "px ";

                        this._div.style.borderWidth = str;
                        this._div.style.borderColor = this._bColor;
                        this._div.style.borderStyle = "solid";
                        break;
                }
            }
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            gl = Widget.gl;
            w  = this._curVal[Widget.W];
            h  = this._curVal[Widget.H];

            /*
                Three cases:

                1) Inside only
                2) Border only
                3) Border and Inside

                Regions common to all cases:

                       +-------+-----------------+-----+
                       |.......|\\\\\\\ T \\\\\\\|!!!!!|
                       +.......+-----------------+!!!!!+
                       |.......|/////////////////|! S !|
                       |...Q...|/////// U ///////|!!!!!| U    = inside
                       |.......|/////////////////|!!!!!| QRST = border
                       +.......+-----------------+-----+
                       |.......|============ R ========|
                       +-------+-----------------+-----+

                 x0,y0       x1,y0             x2,y0  x3,y0

                       A-------B\----------------J-----I y0  ^
                       |      /|        \        |    /|     border top
                 x0,y1 |     / L________________\K   / | y1  v
                       |    /  |                /|  /  |     ^
                       |   /   :        /        | /   |     height
                       |  /    |/                |/    |     v
                 x0,y2 | /     E\----------------H-----G y2  ^
                       |/      |             \         |     border bottom
                       C_______D______________________\F y3  v

                 x0,y3       x1,y3             x2,y3  x3,y3

                      |<border>|<------ w ------>|<-b->|
                      x0     x1                x2     x3
                      Left Border Thickness      Right Border Thickness
            */
            if( this._bThickness ) // Cases 2) Border Only & 3) Border and Inside
            {
                this._dataPosition = new Float32Array( 40 );

                border = this.getBorderArray();

                var x0 = 0;
                var x1 =     border[3];
                var x2 = w + border[3];
                var x3 = w + border[3] + border[1];
                var y0 = 0;
                var y1 =     border[0];
                var y2 = h + border[0];
                var y3 = h + border[0] + border[2];

                // Case 2) Border only
                // Case 3) Border and Inside
                // NOTE: Vertex order of first 8 match the non-border
                //       as the inside rect is common for all 3 cases
                // For case 2) we don't draw the inside region
                verts =
                [
                    x1, y1, // [ 0] L \
                    x2, y1, // [ 1] K  \ U inside rect
                    x1, y2, // [ 2] E  /
                    x2, y2, // [ 3] H /

                    x0, y0, // [ 4] A \
                    x1, y0, // [ 5] B  \
                    x0, y3, // [ 6] C  / Q
                    x1, y3, // [ 7] D /
                    x1, y3, // [ 8] D \
                    x1, y2, // [ 9] E  \
                    x3, y3, // [10] F  / R
                    x3, y2, // [11] G /
                    x3, y2, // [12] G \
                    x2, y2, // [13] H  \
                    x3, y0, // [14] I  / S
                    x2, y0, // [15] J /
                    x2, y0, // [16] J \
                    x2, y1, // [17] K  \
                    x1, y0, // [18] B  / T
                    x1, y1  // [19] L /
                ];          // =16 outside rect
            }
            else // Case 1
            {
                // if thickness === undefined or thickness === 0
                verts =
                [
                    0, 0, // A
                    w, 0, // I
                    0, h, // C
                    w, h  // F
                ];
            }

            this._dataPosition = new Float32Array( verts );
            this._buffPosition = gl.createBuffer();

            gl.bindBuffer( gl.ARRAY_BUFFER, this._buffPosition );
            gl.bufferData( gl.ARRAY_BUFFER, this._dataPosition, gl.DYNAMIC_DRAW ); // Dynamic

            if( this._color ) // Case 1 & 3
                this._colorsRGBA = Widget.glColorHexToFloat( this._color );

            if( this._bColor ) // Case 2 & 3
                this._borderRGBA = Widget.glColorHexToFloat( this._bColor );
        }
    };

    RectWidget.prototype.setColor = function( color )
    {
        this._color = color;

        if( _x2._config._render === Config.RENDER_DOM )
            this._div.style.backgroundColor = color;
        else if( _x2._config._render === Config.RENDER_WEBGL )
            this._colorsRGBA = Widget.glColorHexToFloat( color );
    };

    return RectWidget;

})();


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ScrollWidget = ( function()
{
    "use strict";

    ScrollWidget.prototype             = new Widget();
    ScrollWidget.prototype.constructor = ScrollWidget;
    ScrollWidget.SHADER                = Widget.SHADER_KVT; // Dummy shader -- not used but checked in Widget.update() if widget has render()

    function ScrollWidget(){}

    // TODO: FIXME: safeLeft, safeRight, safeTop, safeBottom, callback, onProgress
    /**
     * Initializer
     * @param {Object}  params
     * @param {Number} [params.h]      - Height in pixels
     * @param {Number} [params.w]      - Width in pixels
     * @param {Widget} [params.widget] - child of the scroll container, the widget that scrolls
     * @memberof ScrollWidget
     */
    ScrollWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className = "ScrollWidget";

        this._widget     = params.widget;
        this._selectable = true;

        if( this._widget )
            this.addWidget( this._widget );

        this.setVal( Widget.W, params.w );
        this.setVal( Widget.H, params.h );
        this.setVal( Widget.OVERFLOW, "hidden" );

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            // Note: color doesn't matter -- we don't write to the color framebuffer
            this._stencilRect = new RectWidget().init( { w:params.w, h:params.h, color: "#FFFFFF" } );
            this._stencilRect.resourcesLoad(); // We are NOT added as a child
        }

        return this;
    };

    /** WebGL only: decrement the stencil mask after all children are rendered
     * @memberof ScrollWidget
     */
    ScrollWidget.prototype.postRender = function( /* alphaParent */ )
    {
        var gl = Widget.gl;

                // ... Post-draw children

                Widget.stencilId--;
                Widget.stencilMask >>= 1;

                // 3) Decrement stencil depth -- will be zero if we are back at the original parent
                // That way we don't have to clear the entire stencil buffer in the initial !stencilOn
                gl.stencilOp( gl.KEEP, gl.KEEP, gl.DECR );
                gl.stencilFunc( gl.ALWAYS, Widget.stencilId, Widget.stencilMask );
                gl.colorMask( false, false, false, false );
                gl.depthMask( false );

                this._stencilRect.glRender( 1 ); // render mask

                // 4) Render remaining heirarchy using parent's stencil
                gl.stencilOp( gl.KEEP, gl.KEEP, gl.KEEP );
                gl.stencilFunc( gl.EQUAL, Widget.stencilId, Widget.stencilMask );
                gl.colorMask( true, true, true, true );
                gl.depthMask( true );

        // Only turn stencil off for original parent
        if( this._stencilOn === undefined )
            console.error(
                "Scroll.postRender() turned off the stencil due to Scroll.render() never being called to save the initial stencil state!\n" +
                "Check alpha / alphaParent -- are you trying to render a transparent nested Scroll??"
             );

        if( !this._stencilOn )
            gl.disable( gl.STENCIL_TEST );
    };

    /**
     * WebGL only: set or increment stencil mask before all children are rendered
     * @memberof ScrollWidget
     */
    ScrollWidget.prototype.render = function( /* alphaParent */ )
    {
        var gl = Widget.gl;

        this._stencilOn = gl.isEnabled( gl.STENCIL_TEST );
        if( !this._stencilOn )
        {
            // We track the number of stencil layers and use that as a mask
            // stencil passes IF (ref_val & mask) COMPARE (stencil & mask)
            // NOTE: There is no need to clear the stencil everytime it is turned on via:
            //   gl.clearStencil(0);
            //   gl.clear( gl.STENCIL_BUFFER_BIT );
            // Since X2.nextFrame() does an initial clear per frame
            gl.enable( gl.STENCIL_TEST );
                Widget.stencilId   = 1;
                Widget.stencilMask = 0;
        } else {
                Widget.stencilId++;
        }
                Widget.stencilMask <<= 1;
                Widget.stencilMask |=  1;

                // 1) Increment stencil depth by rendering the mask
                gl.stencilOp( gl.KEEP, gl.KEEP, gl.INCR );  // fail, zfail, zpass
                gl.stencilFunc( gl.ALWAYS, Widget.stencilId, Widget.stencilMask ); // compare, ref_val, mask
                gl.colorMask( false, false, false, false );
                gl.depthMask( false );

                this._stencilRect.glRender( 1 ); // Render mask only into the stencil buffer

                // 2) Render child objects only allowing drawing that pass: parentStencil & childStencil
                gl.stencilOp( gl.KEEP, gl.KEEP, gl.KEEP );
                gl.stencilFunc( gl.EQUAL, Widget.stencilId, Widget.stencilMask );
                gl.colorMask( true, true, true, true );
                gl.depthMask( true );

                // Pre-draw children ...
    };

    // Needed by WebGL to keep stencil mask dimensions in sync
    ScrollWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        if( this._stencilRect )
            this._stencilRect.setH( val );
    };

    /**
     * @memberof ScrollWidget
     * @param {Number}   [params.x]        - Target x offset to scroll to
     * @param {Number}   [params.y]        - Target y offset to scroll to
     * @param {Number}   [params.duration] - In milliseconds
     * @param {Function} [params.onEnd]    - Callback to trigger when animation is complete
     * @see Widget.animate()
     */
    ScrollWidget.prototype.setScroll = function( params )
    {
        if( params.duration === undefined )
            this._widget.setY( params.y );
        else
            this._widget.animate( params );
    };

    // Needed by WebGL to keep stencil mask dimensions in sync
    ScrollWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );

        if( this._stencilRect )
            this._stencilRect.setW( val );
    };

    return ScrollWidget;

})();


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.StringWidget = ( function()
{
    "use strict";

    StringWidget.prototype             = new Widget();
    StringWidget.prototype.constructor = StringWidget;
    StringWidget.SHADER                = Widget.SHADER_FONT;

    function StringWidget(){}

    /**
     * @memberof StringWidget
     * @returns {String}
     */
    StringWidget.prototype.getText = function()
    {
        return this._text;
    };

    // OUT: _tags has the number of discrete HTML tags or text lines
    StringWidget.prototype.glGetTags = function( text )
    {
        var tags = [];
        var tail = 0;
        var head = 0;

        var delimLT;
        var delimGT;
        var length;

        var subStr;
        var tagStr;
        var iParam;
        var eParam;
        var key;
        var val;
        var obj;

        while( head >= 0 && head < text.length )
        {
            delimLT = text.indexOf( "<", head      );
            delimGT = text.indexOf( ">", delimLT+1 );

            if( delimLT >= 0 )
            {
                // Handle case of plain text preceeding tag
                if( tail !== delimLT )
                {
                    tags.push({
                        name: 'text',
                        text: text.substr( tail, delimLT - tail )
                    });
                }

                head = delimGT;
                tail = head + 1;
                obj  = {};

                subStr  = text.substring( delimLT+1, delimGT );
                length  = delimGT - delimLT - 1;
                iParam  = subStr.indexOf( ' ' );
                tagStr  = iParam >= 0
                        ? subStr.substring( 0, iParam ).toLowerCase()
                        : subStr
                        ;
                eParam  = subStr.indexOf( '=' );
                key     = iParam >= 0 && eParam >= 0
                        ? subStr.substring( iParam+1, eParam )
                        : undefined
                        ;
                val     = iParam >= 0
                        ? subStr.substring( eParam+1 )
                        : undefined
                        ;

                if( val && val[0] === "'" )
                    val = subStr.substring( eParam+2, subStr.length - 1 );

                switch( tagStr )
                {
                    case '/font': // NOTE: val will be undefined for /font
                    case  'font': obj = { 'color' : val }; break;
                    case '/b':
                    case  'b':    obj = { 'bold'  : 1   }; break;
                    case '/i':
                    case  'i':    obj = { 'italic': 1   }; break;
                    case 'br':    obj = { 'break' : 1   }; break;
                    default:
                        console.warn( "*** WARNING: Defaulting HTML tag to text: " + tagStr );
                        tags.push({
                            name: 'text',
                            text: tagStr
                        });

                        head = tagStr.length; // force while() exit
                        break;
                }

                if( Object.keys( obj ).length > 0 )
                {
                    obj.open = tagStr.charAt( 0 ) !== '/';
                    obj.name = obj.open
                             ? tagStr
                             : tagStr.substr( 1, tagStr.length ) // strip '/' off of close tag
                             ;
                    tags.push( obj );
                }
            }
            else // handle remaining plain text
            {
                subStr = text.substr( head );
                tags.push({
                    name: 'text',
                    text: subStr
                });
                head += subStr.length;
            }

            head++;
        }

        this._tags = tags;
    };

    // OUT: Each child in the _container is a renderable text object
    StringWidget.prototype.glMakeLines = function( tags )
    {
        var child;
        var text;

        var nKids = 0;
        var dy    = this._font.getLineHeight( this._curVal[ Widget.FONT_SIZE ] );
        var x     = 0;
        var y     = 0;
        var color = this.getVal( Widget.FONT_COLOR );

        var x0      =   x;
        var aColors = [ color ];

        var head;
        var tag;

        var isBold   = false;
        var isItalic = false;

        for( head = 0; head < tags.length; head++ )
        {
            tag = tags[ head ];
            if( tag.name === 'text' )
            {
                text = this.glRemoveAmpTags( tag.text );

                // measure text
                var params  =
                {
                    text    : text,
                    offset  : 0,
                    length  : text.length,
                    fontSize: this._curVal[ Widget.FONT_SIZE ]
                };
                var metrics = this._font.getLineWidth( params );
                var width   = metrics.width;

                if( isNaN( width ) ) // Glyph not found
                    width = 0;

                child         = new Widget().init(); // { text:text, style:this._style } );
                child._text   = text;
                child._italic = isItalic;
                child._bold   = isBold;

                child.setW( width );
                child.animate( { 'color' : color } );
                child.resourcesLoad();

                this._container.addWidget( child, 0, 0 );
                x += width;
            }
            else
            {
                switch( tag.name )
                {
                    case 'font':
                        if( tag.open )
                            aColors.push( color = tag.color );
                        else
                        {
                            aColors.pop();
                            color = aColors[ aColors.length-1 ];
                        }
                        break;
                    case 'i'   :
                        isItalic = tag.open;
                        break;
                    case 'b'   :
                        isBold = tag.open;
                        break;
                    case 'br'  :
                        nKids = this._container._children.length;
                        if( nKids > 1 ) // Must match render() last child has relative coords
                        {
                            child = this._container._children[ nKids - 1 ];
                            child.setX( x0 - x );
                            child.setY( dy );
                        }

                        x  = x0;
                        y += dy;

                        break;
                    default:
                        console.error( "*** ERROR: Unhandled HTML tag: " + tag.name );
                }
            }
        }
    };

    /* Look for HTML tags: < >
        &lt;
        &gt;
       And convert to characters
    */
    StringWidget.prototype.glRemoveAmpTags = function( str )
    {
        var    div = document.createElement( 'div' );
               div.innerHTML = str;
        return div.innerText;
    };

    StringWidget.prototype.glRemoveChildColor = function()
    {
        var iLine = 0, nLine = this._container._children.length, child;

        // propogate no color to all children; render will use current color
        for( ; iLine < nLine; iLine++ )
            this._container._children[ iLine ]._curVal[ Widget.FONT_COLOR ] = undefined;
    };

    StringWidget.prototype.glSetChildrenWidth = function( width )
    {
        var iLine = 0, nLine = this._container._children.length;

        for( ; iLine < nLine; iLine++ )
            this._container._children[ iLine ].setW( width );
    };

    StringWidget.prototype.gotFocus = function()
    {
        Widget.prototype.gotFocus.call( this );

        if( this._selectSize === undefined )
            this._selectSize = this._baseSize;

        this.animate( { color:this._hiColor, fontSize:this._selectSize, duration:this._focusTime } );

        if( _x2._config._render === Config.RENDER_WEBGL )
            this.glRemoveChildColor();
    };

    StringWidget.prototype.hasText = function()
    {
        return this._text !== undefined;
    };

    /**
     * Initializer
     * @memberof StringWidget
     * @param {Object}    params                   - Parameters to define how the string should be displayed
     * @param {Number}   [params.focusTime=0]      - Duration (milliseconds) of animation scaling from not selected to selected.
     * @param {Number}   [params.lostFocusScale=1] - Normalized percentage scale of font size when widget is not selected.
     * @param {String}   [params.name]             - Class name
     * @param {Function} [params.onEnter]          - Callback when Enter is pressed
     * @param {Number}   [params.selectSize]       - Font size when string widget is selected
     * @param {Style}    [params.style]            - Alignment, Color, Font Type, Font Size, Whitespace
     * @param {String}   [params.text]             - Text to display; if setting later with setText() undefined is valid
     * @see HTMLStringWidget
     */
    StringWidget.prototype.init = function( params )
    {
        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "StringWidget";

        Widget.prototype.init.call( this );

        if( params.style )
            params.style.apply( this );

        if( params.onEnter )
            this._onEnter = params.onEnter;

        if( params.selectSize )
            this._selectSize = parseInt( params.selectSize * _x2._config._text );

        this._focusTime      = ( params.focusTime      !== undefined ) ? params.focusTime      : 0;
        this._lostFocusScale = ( params.lostFocusScale !== undefined ) ? params.lostFocusScale : 1;

        this._text      = params.text;
        this._baseColor = this.getVal( Widget.FONT_COLOR );
        this._baseSize  = this.getVal( Widget.FONT_SIZE  );
        this._hiColor   = this.getVal( Widget.FONT_COLOR_HI );

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._container = new Widget().init();
            this.addWidget( this._container );
        }

        return this;
    };

    StringWidget.prototype.layoutGL = function()
    {
        var params, align, right, width = this.getW() || 0, sLine, iLine, nLine, child, metric;
        var h, w, dx;
        var end, text;

        this._container.removeAllWidgets();

        // Note: setText() can be called before resourcesLoad() has finished
        if( !this._font || !this._text || !this._container._children )
            return;

        // Text may contain HTML
        this.glGetTags  ( this._text );
        this.glMakeLines( this._tags );

        nLine  = this._container._children.length;
        sLine  = this._container._children[0]._text;
        metric =
        {
            offset  : 0,
            fontSize: this._curVal[ Widget.FONT_SIZE ]
        };
        params =
        {
            text    : "",
            offset  : 0,
            length  : 0,
            fontSize: this._curVal[ Widget.FONT_SIZE ]
        };

        h = this._font.getLineHeight( this._curVal[ Widget.FONT_SIZE ] );
        w = 0;

        for( iLine = 0; iLine < nLine; iLine++ )
        {
            child         = this._container._children[ iLine ];
            metric.text   = child._text;
            metric.length = child._text.length;
            dx            = this._font.getLineWidth( metric ).width;

            if( isNaN( dx ) ) // Glyph not found
            {
                console.info( "Glyph not found: " + metric.text + ", char: " + metric.text.charCodeAt( 0 ).toString( 16 ) );
                dx = 0;
            }
            w += dx;
        }

        if( this._textOverflow === "ellipsis" ) // textOverflow: 'ellipsis' takes precedence over overflow: 'hidden' but in practice both should be set
        {
            if( width && (w > width) ) // If width undefined, then nothing to truncate
            {
                end = sLine.length;
                do
                {
                    end           = sLine.lastIndexOf( " ", end-1 );
                    params.text   = sLine.substring( 0, end ) + "...";
                    params.length = params.text.length;
                    text          = params.text;
                    w             = this._font.getLineWidth( params ).width;
                } while( w > width && (end >= 0) );

                if( w > width && (end < 0) ) // Handle edge case when ellipsis text still doesn't fit.
                    text = "";

                this._text = text;

                if( nLine === 1 )
                    this._container._children[0]._text = text;
            }
        }
        else
        {
            right = this.getX();
            align = this.getVal( Widget.TEXT_ALIGN );

            if( align === "right" && width )
                right += (width - w);
            else if( align === "center" && width )
                right += (width - w) * 0.5;

            Widget.prototype.setW.call( this, w ); // must not call StringWidget.setW() but base class

            // TODO: glSetChildrenWidth() ?

            this.setX( right );
        }

        this.setH( h );
    };

    StringWidget.prototype.lostFocus = function()
    {
        Widget.prototype.lostFocus.call( this );
        this.animate( { color:this._baseColor, fontSize:this._baseSize, duration:this._focusTime } );

        if( _x2._config._render === Config.RENDER_WEBGL )
            this.glRemoveChildColor();
    };

    /**
     * WebGL only: draw text
     * @StringWidget ImageWidget
     * @param {Number} alphaParent - parent's alpha * current alpha
     */
    StringWidget.prototype.render = function( alphaParent )
    {
        var fc, color, params, iLine = 0, nLine = this._container._children.length, child, width;

        if( !this._font || !nLine )
            return;

        for( ; iLine < nLine; iLine++ )
        {
            child = this._container._children[ iLine ];
            fc    = child._curVal[ Widget.FONT_COLOR ];
            color = Widget.glColorHexToFloat( fc || this._curVal[ Widget.FONT_COLOR ] );

            params =
            {
                text    : child._text,
                offset  : 0,
                length  : child._text.length,
                width   : child.getW(), // _curVal[ Widget.W ],
                fontSize: this._curVal[ Widget.FONT_SIZE ],
                r       : color[0],
                g       : color[1],
                b       : color[2],
                a       : color[3] * alphaParent,
                italic  : child._italic,
                bold    : child._bold
            };

            this._font.render( params );

            // Update uniform shader matrix -- must match glMakeLines()
            if( nLine > 1 )
            {
                Widget.glViewMatrix[ Widget.glViewDepth ][12] += child.getX() + child.getW();
                Widget.glViewMatrix[ Widget.glViewDepth ][13] += child.getY();
                Widget.gl.uniformMatrix4fv( Widget.glShaderThis.umView, false, Widget.glViewMatrix[ Widget.glViewDepth ] );
            }
        }
    };

    StringWidget.prototype.resourcesLoad = function()
    {
        Widget.prototype.resourcesLoad.call( this );

        if( _x2._config._render === Config.RENDER_DOM )
        {
            this._div.innerHTML        = this._text ? this._text : "";
            this._div.style.textAlign  = this.getVal( Widget.TEXT_ALIGN );
            this._div.style.color      = this.getVal( Widget.FONT_COLOR );
            this._div.style.fontFamily = this.getVal( Widget.FONT );
            this._div.style.fontSize   = this.getVal( Widget.FONT_SIZE ) + "px";
            this._div.style.whiteSpace = this.getVal( Widget.TEXT_WHITE_SPACE );

            if( this._textOverflow )
                this._div.style.textOverflow = this._textOverflow;

            if( this._overflow )
                this._div.style.overflow = this._overflow;
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this._font = Widget.glFonts[ this.getVal( Widget.FONT ) ];
            this.layoutGL();
        }
    };

    StringWidget.prototype.resourcesLoaded = function()
    {
        var self = this;

        Widget.prototype.resourcesLoaded.call( this );
        setTimeout( function() { self.callbackSignalReady(); }, 1 );
    };

    /** Update text
     * @memberof StringWidget
     * @param {String} str - New text
     */
    StringWidget.prototype.setText = function( str )
    {
        this._text = (str !== undefined) ? '' + str : "";

        if( _x2._config._render === Config.RENDER_DOM )
        {
            if( this._div )
                this._div.innerHTML = this._text;
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this.layoutGL();
        }
    };

    StringWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );

        if( _x2._config._render === Config.RENDER_WEBGL ) // && axis === Widget.W)
        {
            var align = this.getVal( Widget.TEXT_ALIGN );
            if( align === "center" || align === "right" )
                this.layoutGL();
            else
                this.glSetChildrenWidth( val );
        }
    };

    return StringWidget;

})();


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChannelInfoWidget = (function()
{
    "use strict";

    ChannelInfoWidget.prototype = new Widget();

    function ChannelInfoWidget(){}

    ChannelInfoWidget.prototype.getSpeechStr = function()
    {
        return this._speechStr;
    };

    ChannelInfoWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className = "ChannelInfoWidget";

        var self = this;
        var titleStyle, subTitleStyle, titleX, titleSize, layout, onNetworkLoaded;

        layout = function()
        {
            self._subTitleStr.setY( self._titleStr.getY() + self._titleStr.getH() + _x2.scaleValInt( 32 ) );
            self._layoutDone = true;

            if( self._onNowShowing )
                self.setData( self._onNowShowing, self._channel );
        };

        onNetworkLoaded = function()
        {
            var dw, dh, scale;
            var w = self._networkImage.getW();
            var h = self._networkImage.getH();

            if( w > 0 && h > 0 )
            {
                dw    = _x2.scaleValInt( 145 ) / w;
                dh    = _x2.scaleValInt(  87 ) / h;
                scale = ( dh < dw ) ? dh : dw;

                self._networkImage.setX( (self._networkBg.getW() - self._networkImage.getW()) / 2 );
                self._networkImage.setY( (self._networkBg.getH() - self._networkImage.getH()) / 2 );
                self._networkImage.setScale( scale );

                self._networkImage.setA( 1 );
            }
        };

        this.setW( _x2.scaleValInt( 1576 - 2 * 80 ) );
        titleX        = _x2.scaleValInt( 280 );
        titleSize     = _x2.scaleValInt( 48 );
        titleStyle    = new Style( { font: "light"  , color: "#e8e8e8", fontSize: titleSize, whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        subTitleStyle = new Style( { font: "regular", color: "#e8e8e8", fontSize: _x2.scaleValInt( 27 ), whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );

        this.setA( 0 );

        //widgets
        this._titleStr          = new StringWidget().init( { style: titleStyle, text:"?????" } );
        this._subTitleStr       = new StringWidget().init( { style: subTitleStyle, text:"?????" } );
        this._networkImage      = new ImageWidget().init( { onChange: onNetworkLoaded, onError: function(){ self._networkImage.setA(0) } } );
        this._networkBg         = new RectWidget().init( { w: _x2.scaleValInt(240), h:_x2.scaleValInt(320), color:"#151515" } );

        this._titleStr.setW( this.getW() - titleX );
        this._subTitleStr.setW( this.getW() - titleX );
        this._titleStr.addReadyCallback( layout );

        this.addWidget( this._titleStr     , titleX, -parseInt( .3 * titleSize ) );
        this.addWidget( this._subTitleStr  , titleX                                 );
        this.addWidget( this._networkBg                                             );
        this.addWidget( this._networkImage                                          );

        return this;
    };

    ChannelInfoWidget.prototype.setData = function( onNowShowing, channel )
    {
        this._onNowShowing  = onNowShowing;
        this._channel       = channel;
        this._speechStr     = "";

        if( this._layoutDone )
        {
            var titleString, titles = [], entity = onNowShowing.getEntity();

            titles.push( onNowShowing.getTitle() );

            if( entity && entity.getType() === XtvApi.EntityType.EPISODE )
            {
                var series = entity.getSeries();
                if( series )
                {
                    if( titles.indexOf( series.getTitle() ) < 0 ) //avoid duplicates
                        titles.unshift( series.getTitle() );
                }
            }

            titleString = titles.join( " - ");

            this._titleStr.setText( channel.getNumber() + " " + channel.getCallSign() );
            this._subTitleStr.setText( "On Now: " + titleString );
            this._networkImage.setUrl();
            this._networkImage.setUrl( channel.getLogoUrl( _x2.scaleValInt( 145 ), _x2.scaleValInt( 87 ) ) );

            this._speechStr += "Channel " + channel.getNumber() + ", " + channel.getCallSign() + ". ";
            this._speechStr += this._subTitleStr.getText();

            if( this._speechDescStr !== undefined )
                this._speechStr += this._speechDescStr;

            this.animate( { a:1, duration:500 } );
        }
    };

    return ChannelInfoWidget;

})();


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.EntityInfoWidget = (function()
{
    "use strict";

    EntityInfoWidget.prototype = new Widget();

    function EntityInfoWidget(){}

    EntityInfoWidget.prototype.getSpeechStr = function()
    {
        return this._speechStr;
    };

    /**
     * Initializer
     * @memberof EntityInfoWidget
     * @param   {Object}   params
     * @param   {Boolean} [params.grid=false] - render using grid info layout
     * @returns {EntityInfoWidget}
     */
    EntityInfoWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className = "EntityInfoWidget";
        this._numLoaded = 0;
        this._grid      = params ? params.grid : false;

        var self = this;
        var titleStyle, subTitleStyle, descStyle, detailStyle, infoStyle;
        var titleX, titleSize, divX, layout, onPosterError, onPosterLoad, detailX;

        layout = function()
        {
            self._numLoaded++;

            if( self._numLoaded === 3 || self._readyToDisplay === true )
            {
                self._readyToDisplay = true;

                var y              = self._titleStr.getY() + self._titleStr.getH() + _x2.scaleValInt( 32 );
                var descY          = y + self._subTitleStr.getH() + _x2.scaleValInt( 14 );
                var subTitleString = self._subTitleStr.getText();

                self._subTitleStr.setY( y );
                self._descrStr.setY( descY );
                self._descrStr.setH( self._posterH - descY );
                self._vertDiv.setY( y );
                self._vertDiv.setH( self._posterH - y );
                self._progressWidget.setY( y );
                self._recProgressWidget.setY( y );
                self._detailStr.setY( y );
                self._infoStr.setY( y + self._detailStr.getH() + _x2.scaleValInt( 18 ) );

                if( self._progressStr )
                {
                    var offset = self._progressStr.getH() / 2 - self._progressWidget.getH() / 2;
                    self._progressStr.setY( y - offset );
                    self._progressStr.setX( self._progressWidget.getX() + self._progressWidget.getW() + Style._pad * 2 );
                }

                self._descY = descY;

                if( self._hasTitleStr === true )
                    self._titleStr.setA( 1 );
                else
                    self._titleStr.setA( 0 );

                if( self._hasSubTitleStr === true )
                    self._subTitleStr.setA( 1 );
                else
                    self._subTitleStr.setA( 0 );

                if( subTitleString === undefined || subTitleString.length === 0 )
                    self._descrStr.setY( self._subTitleStr.getY() );
                else
                    self._descrStr.setY( self._descY );

                if( self._hasProgressWidget === true )
                {
                    self._detailStr.setY( self._descY );
                    self._progressWidget.setA( 1 );
                }
                else
                    self._progressWidget.setA( 0 );

                if( self._hasRecProgressWidget === true )
                {
                    self._detailStr.setY( self._descY );
                    self._recProgressWidget.setA( 1 );
                }
                else
                    self._recProgressWidget.setA( 0 );

                if( self._progressStr )
                    if( self._hasProgressStr === true )
                        self._progressStr.setA( 1 );
                    else
                        self._progressStr.setA( 0 );

                y = self._detailStr.getY() + self._detailStr.getH() + _x2.scaleValInt( 13 );

                if( self._hasInfoStr === true )
                {
                    self._infoStr.setY( y );
                    y += self._infoStr.getH();
                    self._infoStr.setA( 1 );
                }
                else
                    self._infoStr.setA( 0 );

                if( self._hasInfoGlyphs === true )
                {
                    self._infoGlyphs.setY( y );
                    y += self._infoGlyphs.getH() + _x2.scaleValInt( 6 );
                    self._infoGlyphs.setA( 1 );
                }
                else
                    self._infoGlyphs.setA( 0 );

                if( self._hasCsmRating === true )
                {
                    self._csmContainer.setY( y );
                    y += self._csmIcon.getH() + _x2.scaleValInt( 12 );
                    self._csmContainer.setA( 1 );
                }
                else
                    self._csmContainer.setA( 0 );

                if( self._hasTomatoWidget === true )
                {
                    self._tomatoWidget.setY( y );
                    y += self._tomatoWidget.getH() + _x2.scaleValInt( 12 );
                    self._tomatoWidget.setA( 1 );
                }
                else
                    self._tomatoWidget.setA( 0 );

                if( self._grid !== true )
                    self._netIconImage.setY( y );

                self.animate( { a:1, duration:500 } );
            }
        };

        this._layout = layout;

        onPosterError = function()
        {
            if( self._posterImage.getUrl() !== self._fallbackImage )
                self._posterImage.setUrl( self._fallbackImage );
        };

        onPosterLoad = function()
        {
            self._posterImage.animate( { a:1, duration:250 } );
        };

        if( this._grid )
        {
            this.setW( _x2.scaleValInt( 1576 - 2 * 80 ) );
            this._posterW = _x2.scaleValInt( 240 );
            this._posterH = _x2.scaleValInt( 320 );
            titleX        = _x2.scaleValInt( 280 );
            divX          = _x2.scaleValInt( 1165 );
            detailX       = divX + _x2.scaleValInt( 32 );
            titleSize     = _x2.scaleValInt( 48 );
            titleStyle    = new Style( { font: "light"  , color: "#e8e8e8", fontSize: titleSize, whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
            subTitleStyle = new Style( { font: "regular", color: "#e8e8e8", fontSize: _x2.scaleValInt( 27 ), whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
            descStyle     = new Style( { font: "light"  , color: "#e8e8e8", fontSize: _x2.scaleValInt( 27 ), overflow:"hidden", textOverflow:"ellipsis" } );
            detailStyle   = new Style( { font: "medium" , color: "#8b8b8b", fontSize: _x2.scaleValInt( 24 ), whiteSpace: "nowrap" } );
            infoStyle     = new Style( { font: "medium" , color: "#a3a3a3", fontSize: _x2.scaleValInt( 24 ), whiteSpace: "nowrap" } );
        }
        else
        {
            this.setW( _x2._config._screenW - Style._safeLeft - Style._safeRight );
            this._posterW = _x2.scaleValInt( 303 );
            this._posterH = _x2.scaleValInt( 404 );
            titleX        = this._posterW + _x2.scaleValInt( 52 );
            divX          = _x2.scaleValInt( 1386 );
            detailX       = divX + _x2.scaleValInt( 32 );
            titleSize     = _x2.scaleValInt( 60 );
            titleStyle    = new Style( { font: "light"  , color: "#e8e8e8", fontSize: titleSize, whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
            subTitleStyle = new Style( { font: "regular", color: "#a3a3a3", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );
            descStyle     = new Style( { font: "light"  , color: "#e8e8e8", fontSize: _x2.scaleValInt( 30 ), overflow:"hidden", textOverflow:"ellipsis" } );
            detailStyle   = new Style( { font: "medium" , color: "#8b8b8b", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );
            infoStyle     = new Style( { font: "medium" , color: "#a3a3a3", fontSize: _x2.scaleValInt( 24 ), whiteSpace: "nowrap" } );
        }

        this.setA( 0 );

        //widgets
        this._posterImage       = new ImageWidget().init( { w:this._posterW, h:this._posterH, onError:onPosterError, onChange:onPosterLoad } );
        this._titleStr          = new StringWidget().init( { style: titleStyle, text:"?????" } );
        this._subTitleStr       = new StringWidget().init( { style: subTitleStyle, text:"?????" } );
        this._descrStr          = new TextBlockWidget().init( { style: descStyle, w: divX - titleX - _x2.scaleValInt( 32 ), h:100, ellipsis: true } );
        this._vertDiv           = new RectWidget().init( { w: 2, h:_x2.scaleValInt(234), color:"#5e5e5e" } );
        this._recProgressWidget = new ProgressBarWidget().init( { w:this.getW() - divX, h:_x2.scaleValInt(14), style:"recording" } );
        this._detailStr         = new StringWidget().init( { style: detailStyle, text: "DETAILS" } );
        this._infoStr           = new StringWidget().init( { style: infoStyle } );
        this._infoGlyphs        = new StringWidget().init( { style: infoStyle } );
        this._tomatoWidget      = new TomatoWidget().init();
        this._netIconImage      = new ImageWidget().init( { onChange: function(){ self.netIconLoaded() }, onError: function(){ self._netIconImage.setA(0) } } );
        this._csmRating         = new StringWidget().init( { style: subTitleStyle } );
        this._csmIcon           = new ImageWidget().init ( { url:_x2._config._imageRoot + "common_sense_icon.png" } );
        this._csmContainer      = new ContainerWidget().init( { widgets:[this._csmIcon, this._csmRating], spacing:_x2.scaleValInt(10), ready:true } );

        if( this._grid )
            this._progressWidget = new ProgressBarWidget().init( { w:this.getW() - divX, h:_x2.scaleValInt(14), style:"watched" } );
        else
        {
            this._progressWidget = new ProgressBarWidget().init( { w:this.getW() - divX -_x2.scaleValInt(180), h:_x2.scaleValInt(14), style:"watched" } );
            this._progressStr    = new StringWidget().init( { style: infoStyle, text:"?" } );
            this._progressStr.setA( 0 );
        }

        this._titleStr.setW( this.getW() - titleX );
        this._subTitleStr.setW( this.getW() - titleX );
        this._titleStr.addReadyCallback( layout );
        this._tomatoWidget.addReadyCallback( layout );
        this._csmIcon.addReadyCallback( layout );

        this._posterImage.setA      ( 0 );
        this._titleStr.setA         ( 0 );
        this._subTitleStr.setA      ( 0 );
        this._recProgressWidget.setA( 0 );
        this._progressWidget.setA   ( 0 );
        this._infoStr.setA          ( 0 );
        this._infoGlyphs.setA       ( 0 );
        this._csmContainer.setA     ( 0 );
        this._tomatoWidget.setA     ( 0 );

        this.addWidget( this._posterImage                                                       );
        this.addWidget( this._titleStr         , titleX, -parseInt( .3 * titleSize )            );
        this.addWidget( this._subTitleStr      , titleX                                         );
        this.addWidget( this._descrStr         , titleX                                         );
        this.addWidget( this._vertDiv          , divX                                           );
        this.addWidget( this._progressWidget   , detailX                                        );
        this.addWidget( this._recProgressWidget, detailX                                        );
        this.addWidget( this._detailStr        , detailX                                        );
        this.addWidget( this._infoStr          , detailX                                        );
        this.addWidget( this._infoGlyphs       , detailX                                        );
        this.addWidget( this._tomatoWidget     , detailX                                        );
        this.addWidget( this._csmContainer     , detailX                                        );
        this.addWidget( this._netIconImage     , detailX, this._posterH + _x2.scaleValInt( 20 ) );

        if( this._progressStr )
            this.addWidget( this._progressStr );

        return this;
    };

    /**
     * Set and display data
     * @param {Entity, LinearShowing, Recording} data
     */
    EntityInfoWidget.prototype.setData = function( data )
    {
        this._speechStr = "";
        this._data = data;

        this._hasTitleStr          = false;
        this._hasSubTitleStr       = false;
        this._hasProgressWidget    = false;
        this._hasRecProgressWidget = false;
        this._hasProgressStr       = false;
        this._hasInfoStr           = false;
        this._hasInfoGlyphs        = false;
        this._hasCsmRating         = false;
        this._hasTomatoWidget      = false;

        var entity = data; //NOTE: data can be the Entity or the Entity may be embedded in data, in which case it's extracted below.

        //showing properties
        var start, end, duration, isHd, isSAP, isCC, isDVS, minRemaining, provider, showings;

        //recording properties
        var isRecording, recordedOn, percentRecorded, recordingStatus, isSeriesRecording, isCheckedOut, checkedOutToDevice, recordingEndTime, seriesRecording, episodeRecording;

        //other properties
        var pctComplete, locked=false, glyphs="", subTitleString="", subSpeechStr="", infoString, recording, now, networkLogoUrl, entityOptions, rentalExpires, purchasedOn, expires;

        if( data instanceof Entity )
        {
            seriesRecording = data.getEntityRecording();
            if( seriesRecording && seriesRecording.getRecordingStatus() === "scheduled" )
                isRecording = isSeriesRecording = true;

            entityOptions = data.getEntityOptions();
            if( entityOptions )
            {
                provider = entityOptions.getContentProvider();

                if( data.getType() === XtvApi.EntityType.EPISODE )
                {
                    recording = entityOptions.getRecordings()[0];
                    isRecording = ( recording !== undefined );
                }

                isHd         = entityOptions.hasHdShowing();
                isSAP        = entityOptions.hasSapShowing();
                isCC         = entityOptions.hasCcShowing();
                isDVS        = entityOptions.hasDvsShowing();
                minRemaining = entityOptions.getMinsRemaining();
                showings     = entityOptions.getVodShowings();

                for( var i=0; i<showings.length; i++ )
                {
                   if( showings[i] instanceof Purchase )
                   {
                       if( showings[i].getTransactionDetails() )
                            purchasedOn = "Purchased " + ( showings[i].isHD() ? "HD" : "SD" ) + " " + _x2.createDateStr( showings[i].getTransactionDetails().getPurchasedOnDate(), true );
                       break;
                   }
                   else if( showings[i] instanceof Rental )
                   {
                       if( showings[i].getExpires() )
                       {
                           expires = _x2.createExpiresString( showings[i].getExpires() );

                           if( expires.length > 0 )
                               rentalExpires = "Rental " + expires;
                       }
                       break;
                   }
                }
            }
        }
        else
        {
            if( data instanceof Showing )
            {
                entity       = data.getProgram();
                duration     = data.getDuration();
                isHd         = data.isHD();
                isSAP        = data.isSap();
                isCC         = data.isClosedCaptioned();
                isDVS        = data.isDvs();
                minRemaining = data.getMinsRemaining();
                provider     = data.getContentProvider();
            }

            if( data instanceof LinearShowing )
            {
                start     = data.getStartTime();
                end       = data.getEndTime();
                recording = data.getRecording();
                provider  = data.getChannel();

                if( recording )
                {
                    if( recording.getWontRecordReason() === undefined )
                    {
                        isRecording = true;
                        isSeriesRecording = ( recording.getRecordingType() === "Series" );
                    }
                }
            }

            if( data instanceof Purchase )
            {
                var date;

                if( data.getGroup() )
                    date = data.getGroup().getPurchasedOnDate();
                else if( data.getTransactionDetails() )
                    date = data.getTransactionDetails().getPurchasedOnDate();

                if( date )
                    purchasedOn = "Purchased " + ( data.isHD() ? "HD " : "SD " ) + _x2.createDateStr( date, true );
            }

            if( data instanceof Rental )
            {
                expires = _x2.createExpiresString( data.getExpires() );

                if( expires.length > 0 )
                    rentalExpires = "Rental " + expires;
            }

            if( data instanceof Recording )
            {
                isRecording       = true;
                recording         = data;
                isSeriesRecording = data.isSeriesRecorded();
                isCheckedOut      = data.isCheckedOut();

                if( isCheckedOut )
                    checkedOutToDevice = data.getCheckedOutDeviceName();
            }
        }

        if( recording )
        {
            provider          = recording.getChannel();
            duration          = recording.getDuration();
            recordedOn        = recording.getRecordedOnDate();
            percentRecorded   = recording.getRecordingProgress();
            recordingStatus   = recording.getRecordingStatus();
            recordingEndTime  = new Date( recordedOn.getTime() + ( duration * 60000 ) );
        }

        var type        = entity.getType();
        var title       = entity.getTitle();
        var credits     = entity.getCredits();
        var year        = entity.getYear();
        var description = entity.getDescription();
        var rtReview    = entity.getRottenTomatoReview();
        var csmReview   = entity.getCommonSenseMediaReview();
        var series      = entity.getSeries();
        var rating      = entity.getRating();

        var url         = this._grid === true ? entity.getImageLink( 240, 320 ) : entity.getImageLink( 303, 404 );
        var fallbackUrl = this._grid === true ? entity.getFallbackImageLink( 240, 320 ) : entity.getFallbackImageLink( 303, 404 );

        if( ! duration && type !== XtvApi.EntityType.SERIES ) //priority to showing or recording duration. don't show duration for series.
            duration = entity.getDuration();

        //TODO: check entity title for TV Series while recording (Merge conflict bc988e2a)

        if( series && series.getTitle() )
            title = series.getTitle() + " - " + title;

        if( rating )
            locked = _x2._pc.isRatingLocked( rating );

        if( locked === false )
            locked = _x2._pc.isTitleLocked( entity.getEntityId() );

        if( locked === false )
        {
            if( entity.getSeries() )
            {
                series = entity.getSeries();

                if( series )
                    locked = _x2._pc.isTitleLocked( series.getEntityId() );
            }
        }

        if( provider )
        {
            networkLogoUrl = provider.getLogoUrl( _x2.scaleValInt( 156 ), _x2.scaleValInt( 117 ) );

            if( networkLogoUrl )
            {
                networkLogoUrl = networkLogoUrl.replace( /&extent=true/, "" );
                networkLogoUrl = networkLogoUrl.replace( /&gravity/, "" );
            }
        }

        //move logic up here and set elements below.

        this._progressWidget.setA( 0 );
        this._recProgressWidget.setA( 0 );
        this._descrStr.setA( 1 );
        this._detailStr.setA( 1 );
        this._vertDiv.setA( 1 );
        this._netIconImage.setA( 1 );

        // *** image & fallback ***
        if( this._posterImage.getUrl() !== url ) //avoid flashing image on secondary call to setData()
        {
            this._posterImage.setA( 0 );
            this._posterImage.setUrl( url );
            this._fallbackImage = fallbackUrl;
        }

        // *** title ***
        if( title )
        {
            this._hasTitleStr = true;
            this._speechStr += title + ". ";
            this._titleStr.setText( title );
        }
        else
            this._hasTitleStr = false;

        // *** description ***
        if( ! recording  && ( type === XtvApi.EntityType.MOVIE || type === XtvApi.EntityType.SERIES ) )
        {
            if( year )
            {
                if( description !== undefined )
                    description = "(" + year + ") " + description;
                else
                    description = "(" + year + ")";
            }
        }

        if( description )
            this._speechDescStr = description;

        if( credits && credits.length )
        {
            this._speechDescStr = credits.join( ", " ) + ". " + description;
            description = "<font color='#a3a3a3'>" + credits.join( ", " ) + "</font><br>" + description;
        }

        this._descrStr.setText( description );

        // *** subtitle ***
        if( isCheckedOut )
        {
            subTitleString  = "<font color='#77993e'>" + Strings.Glyphs.DOWNLOAD + "</font> Downloaded to " + checkedOutToDevice;
            subSpeechStr   += "Downloaded to " + checkedOutToDevice + ". ";
        }
        else if( rentalExpires )
        {
            subTitleString  = rentalExpires;
            subSpeechStr   += rentalExpires;
        }
        else if( purchasedOn )
        {
            subTitleString  = purchasedOn;
            subSpeechStr   += purchasedOn;
        }
        else
        {
            if( isRecording )
            {
                if( isSeriesRecording )
                    subTitleString = "<font color='#c90318'>" + Strings.Glyphs.SERIES + "</font>";
                else
                    subTitleString = "<font color='#c90318'>" + Strings.Glyphs.RECORD + "</font>";

                if( recordingStatus === "STARTED" )
                {
                    subTitleString   = " Recording Now " + _x2.createTimeRange( recordedOn, recordingEndTime );
                    subSpeechStr    += _x2.createTimeSpeechStr( subTitleString );
                }
                else if( recordingStatus === "COMPLETE" || recordingStatus === "DELETED" )
                {
                    subTitleString = " Recorded " + ( recordedOn.getMonth() + 1 ) + "/" + recordedOn.getDate() + " " + _x2.createTimeStr( recordedOn ); // XC-14205: Don't show Red recording dots if recording has completed
                    subSpeechStr  += " Recorded " + ( recordedOn.getMonth() + 1 ) + "/" + recordedOn.getDate() + " at " + _x2.createTimeSpeechStr( _x2.createTimeStr( recordedOn ) );
                }
                else
                {
                    if( isSeriesRecording )
                    {
                        subTitleString += " Series Recording Scheduled";
                        subSpeechStr   += " Series Recording Scheduled";
                    }
                    else
                    {
                        subTitleString += " Recording Scheduled";
                        subSpeechStr   += " Recording Scheduled";
                    }
                }

                if( provider )
                {
                    if( provider instanceof Channel )
                    {
                        var chNumber = provider.getNumber();
                        var callSign = provider.getCallSign();

                        if( chNumber && callSign )
                        {
                            subTitleString += " on "         + chNumber + " "  + callSign;
                            subSpeechStr   += " on channel " + chNumber + ", " + callSign;
                        }
                    }
                }
            }
            else if( start && end )
            {
                subTitleString = _x2.createTimeRange( new Date( start ), new Date( end ) );
                subSpeechStr   = _x2.createTimeSpeechStr( subTitleString );
            }
        }

        this._hasSubTitleStr = (subTitleString !== undefined);
        this._subTitleStr.setText( subTitleString );
        this._speechStr += subSpeechStr;

        // *** progress ***
        if( percentRecorded !== undefined )
        {
            if ( percentRecorded < 100 )
            {
                this._hasRecProgressWidget = true;
                this._recProgressWidget.setProgress( percentRecorded === 0 ? 1 : percentRecorded ); //always show at least 1% of a recording is in progress (may be < 1 immediately after being set)
            }

            if( this._progressStr )
                this._hasProgressStr = false;
        }
        else
        {
            if( minRemaining )
            {
                var pct = Math.max( 1, Math.round( 100 * ( 1 - minRemaining / duration ) ) );
                pctComplete = pct <= 100 ? pct : 100;
            }
            else if( start && end ) //show progress if entity is currently airing
            {
                now = Date.now();

                if( start < now && end > now )
                {
                    pctComplete  = Math.max( 1, Math.round( ( ( now - start ) / ( end - start ) ) * 100 ) );
                    minRemaining = Math.round( ( end - now ) / 60000 );
                }
            }

            if( pctComplete && pctComplete < 100 )
            {
                this._hasProgressWidget = true;
                this._progressWidget.setProgress( pctComplete );

                if( this._progressStr && minRemaining )
                {
                    this._hasProgressStr = true;
                    this._progressStr.setText( minRemaining + " min left" );
                }
            }
            else
            {
                this._hasProgressWidget = false;

                if( this._progressStr )
                    this._hasProgressStr = false;
            }
        }
        
        infoString = "";
        if( provider instanceof Channel ) {
            infoString += provider.getNumber() + ' ' + provider.getCallSign() + ', ';
        }
        // *** infoString ***
        if( duration )
        {
            infoString += duration + " mins";
            this._speechStr += infoString.replace( "mins", "minutes. " );
        }


        this._infoStr.setText( infoString );

        this._hasInfoStr = infoString && infoString.length > 0;

        // *** info glyphs ***
        if( locked )
        {
            glyphs += Strings.Glyphs.LOCKED + " ";
            this._speechStr += "Locked by rating. ";
        }

        if( rating )
        {
            glyphs += Strings.Glyphs[rating] + " ";
            this._speechStr += "Rating " + rating + ". ";
        }
        if( isHd )
        {
            glyphs += Strings.Glyphs.HD + " ";
            this._speechStr += "HD available . ";
        }

        if( isSAP )
        {
            glyphs += Strings.Glyphs.SAP + " ";
            this._speechStr += "Secondary audio available. ";
        }

        if( isCC )
        {
            glyphs += Strings.Glyphs.CC + " ";
            this._speechStr += "Closed captioning available. ";
        }

        if( isDVS )
        {
            glyphs += Strings.Glyphs.DV + " ";
            this._speechStr += "Video description available. ";
        }

        this._infoGlyphs.setText( glyphs );

        this._hasInfoGlyphs = glyphs.length > 0;

        //*** reviews ***

        if( csmReview )
        {
            this._hasCsmRating = true;
            this._csmRating.setText( csmReview.getCommonSenseMediaScore() );
        }
        else
            this._hasCsmRating = false;

        if( rtReview && ( rtReview.getFanSummaryScore() > 0 || rtReview.getCriticSummaryScore() > 0 ) )
        {
            this._hasTomatoWidget = true;
            this._tomatoWidget.setData( rtReview );

            this._speechStr += this._tomatoWidget.getSpeechStr();
        }
        else
            this._hasTomatoWidget = false;

        this._netIconImage.setUrl();

        //*** network image ***

        if( networkLogoUrl )
            this._netIconImage.setUrl( networkLogoUrl );

        if( this._speechDescStr !== undefined )
            this._speechStr += this._speechDescStr;

        if( this._readyToDisplay === true )
            this._layout();
    };

    EntityInfoWidget.prototype.netIconLoaded = function()
    {
        if( this._grid !== true )
        {
            this._netIconImage.setH( undefined );

            var fullH   = this._netIconImage.getH();
            var scaledH = this._posterH - this._netIconImage.getY();
            scaledH = (scaledH < 78 ) ? 78 : scaledH; //minimum height should be 78, else logo get shrunk
            if( fullH > scaledH )
                this._netIconImage.setH( scaledH );
        }
        else
            this._netIconImage.setX( (this._posterW - this._netIconImage.getW()) / 2 );

        this._netIconImage.animate( { a:1, duration:500 } );
    };

    return EntityInfoWidget;

})();


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ListRowWidget = ( function()
{
    "use strict";

    ListRowWidget.prototype = new Widget();

    ListRowWidget.DIVIDER_H = 2;

    function ListRowWidget(){}

    /** Abstract Base Class - get the unfocused height of the row
     * @memberof ListRowWidget
     */
    ListRowWidget.prototype.getHeightUnfocused = function()
    {
        console.log( "ERROR -> a derived class of a ListRowWidget must override getHeightUnfocused()" );
    };

    ListRowWidget.prototype.gotFocus = function()
    {
        Widget.prototype.gotFocus.call( this );
        this.setHighlight();
    };

    /** Get the separator height
     * @memberof ListRowWidget
     * @returns {number}
     */
    ListRowWidget.prototype.getSepH = function()
    {
        return this._sep ? this._sep.getVal( Widget.H ) : 0;
    };

    /**
     * Initializer
     * Creates a vertical, selectable list
     * Note: Divider is at the bottom only.
     * @memberof ListRowWidget
     * @param {Object}  params            - Parameters to define how the string should be displayed
     * @param {boolean} [params.sep=true] - show a separator line
     * @param {boolean} [params.chevron]  - show a right (more indicator) chevron
     * @param {Number}  params.w          - Width in pixels
     * @returns {ListRowWidget}
     */
    ListRowWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className  = "ListRowWidget";
        this._selectable = true;

        if( params.chevron === true )
        {
            var chevStyle = new Style( { color:"#8b8b8b", font:"regular", fontSize:_x2.scaleValInt(36) } );
            var chevX     = params.w - _x2.scaleValInt(20);
            var chevY     = this.getHeightUnfocused() / 2 -  _x2.scaleValInt(26);
            this.addWidget( new StringWidget().init( { style: chevStyle, text:Strings.Glyphs.CHEV_RIGHT } ), chevX, chevY );
        }

        this._sep = new RectWidget().init( { w:params.w, h:ListRowWidget.DIVIDER_H, color:"#262626" } );
        this.addWidget( this._sep, 0, this.getHeightUnfocused() - this._sep.getVal( Widget.H ) );

        if( params.sep === false )  // _sep is needed for TTS, but should not always be visible
            this._sep.setA( 0 );

        this.setVal( Widget.W, params.w                  );
        this.setVal( Widget.H, this.getHeightUnfocused() );

        return this;
    };

    /**
     * Is the list to which this row belongs currently blocked during an animation.
     * @memberof ListRowWidget
     * @returns {Boolean}
     */
    ListRowWidget.prototype.isListBlocking = function()
    {
        var retval = false, widget = this;

        while( widget )
        {
            var parent = widget._parent;

            if( parent instanceof ListWidget )
            {
                if( parent._blocked === true )
                    retval = true;
                break;
            }
            else
                widget = parent;
        }

        return retval;
    };

    /**
     * Set the row to be highlighted
     * @memberof ListRowWidget
     * @param {Number} [time] - TODO:
     * @param {Number} [h   ] - default to Unfocused Height - Divider Height
     */
    ListRowWidget.prototype.setHighlight = function( time, h )
    {
        var obj = this.getGlobalPos();

        obj.w        = this.getVal( Widget.W );
        obj.h        = (h === undefined) ? this.getHeightUnfocused() - ListRowWidget.DIVIDER_H : h;
        obj.inner    = false;
        obj.duration = (time === undefined) ? ListWidget.SCROLL_TIME_STEP : time;

        _x2._hi.setPosition( obj );
    };

    return ListRowWidget;

})();


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChannelRowWidget = (function(){

    "use strict";

    ChannelRowWidget.prototype = new ListRowWidget();

    function ChannelRowWidget(){}

    ChannelRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 162 );
    };

    ChannelRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var remain, str, channel, callSign;

        ListRowWidget.prototype.gotFocus.call( this );
        this._title.gotFocus();
        this._channel.gotFocus();

        channel = this._entity.getChannel();

        if( channel )
            callSign = channel.getCallSign();

        remain  = Math.floor( (this._entity.getEndTime() - new Date().getTime()) / (60 * 1000) );
        str     = (isNaN(remain) === false) ? remain + " minutes remaining. " : "";
        str    += "Channel " + this._channel.getText() + ". ";

        if( callSign )
            str += callSign + ". ";

        this._title.setSpeechParams( str, undefined, this, newScreen );

        return this;
    };

    ChannelRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className = "ChannelRowWidget";
        this._imageW    = _x2.scaleValInt(135);
        this._imageH    = _x2.scaleValInt(101);

        var self          = this, layout;
        var titleStyle    = new Style( { color:"#e8e8e8", font:"regular", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2b9cd8" } );
        var subTitleStyle = new Style( { color:"#a3a3a3", font:"medium" , fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var imageY        = (this.getHeightUnfocused() - this._imageH) / 2;

        layout = function()
        {
            var rowH = self.getHeightUnfocused();
            var vPad = _x2.scaleValInt( 8 );
            var h    = self._title.getH() + vPad + self._subTitle.getH();

            self._channel.setY( (rowH - self._channel.getH()) / 2 );
            self._title.setY( (rowH - h) / 2 );
            self._subTitle.setY( self._title.getY() + self._title.getH() + vPad );
        };

        this._image = new ImageWidget().init();
        this.addWidget( this._image, 0, imageY );

        this._channel = new StringWidget().init({ text:"?", style:titleStyle });
        this.addWidget( this._channel, this._imageW + _x2.scaleValInt(40), _x2.scaleValInt(45) );

        this._title = new StringWidget().init({ text:"?", style:titleStyle });
        this.addWidget( this._title, this._imageW + _x2.scaleValInt(176), _x2.scaleValInt(30) );

        this._subTitle = new StringWidget().init({ text:"?", style:subTitleStyle });
        this._subTitle.addReadyCallback( layout );
        this.addWidget( this._subTitle, this._title.getX(), _x2.scaleValInt(75) );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ); } );
        this.addWidget( this._distractor );

        return this;
    };

    ChannelRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
        this._channel.lostFocus();
    };

    ChannelRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            var self      = this;
            var url       = this._entity.getStreamUrl();
            var channel   = this._entity.getChannel();
            var streamId  = channel.getStreamId();
            var channelId = channel.getId();

            var onError = function( error )
            {
                self._distractor.hide();
                self._inProgress = false;
                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.LINEAR } ) );
            };

            var onReady = function( schedule )
            {
                self._distractor.hide();
                self._inProgress = false;

                var playVideo = function()
                {
                    _x2.pushScreen( new VideoScreen().init( { url:url, mode:VideoScreen.Mode.LIVE, entity:schedule, streamId:streamId } ) );
                };

                if( schedule )
                {
                    //the ChannelCollection has channels with HD complements assigned. look for a complement so that VideoScreen can tune correctly based on auto-tune HD settings
                    var channelObj = _x2._channelCollection.getChannel( channel.getLink('self') );

                    schedule.setChannel( channelObj ? channelObj : channel );

                    var program = schedule.getProgram();

                    if( _x2._pc.isEnabled() === true )
                        _x2.checkParentalControls( schedule, program ).then( playVideo );
                    else
                        playVideo();
                }
            };

            if( ! this._inProgress )
            {
                this._distractor.show();
                this._inProgress = true;
                _x2._data.getLinearScheduleByTime( channelId, Date.now() ).then( onReady ).catch( onError );
            }

            retval = true;
        }

        return retval;
    };

    ChannelRowWidget.prototype.setData = function(data)
    {
        if( data )
        {
            this._entity = data;

            var channel = data.getChannel();
            var onNow   = data.getSubtitle();
            var start   = data.getStartTime();
            var end     = data.getEndTime();
            var range   = _x2.createTimeRange(start, end);

            if( onNow )
                onNow = onNow.replace('On Now:', '');
            else
                onNow = '';

            this._image.setUrl( data.getImageLink( this._imageW, this._imageH ) );
            this._channel.setText( channel.getNumber() );
            this._title.setText( onNow );
            this._subTitle.setText( range );

            this.setA(1);
        }
        else
            this.setA(0);
    };

    return ChannelRowWidget;

})();


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.CheckBoxRowWidget = ( function()
{
    "use strict";

    CheckBoxRowWidget.prototype = new ListRowWidget();

    function CheckBoxRowWidget(){}

    /**
     * Initializer
     * @memberof CheckBoxRowWidget
     * @param   {Object}   params
     * @param   {String}   params.title    - String to be displayed in the entry
     * @param   {Number}   params.w        - Display width of the row
     * @returns {CheckBoxRowWidget}
     * @see ListRowWidget
     */
    CheckBoxRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "CheckBoxRowWidget";
        this._selectable = true;

        var self       = this;
        var titleStyle = new Style( { color:"#b8b8b8", colorHi:"#2ea0dd", font:"light" , fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );
        var glyphStyle = new Style( { color:"#b8b8b8", colorHi:"#2ea0dd", font:"medium", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        this._numElements = 0;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._title );

        this._glyph = new StringWidget().init( { style:glyphStyle } );
        this.addWidget( this._glyph );

        this._check = new DualImageWidget().init( { url:_x2._config._imageRoot + "check_white.png", urlHi:_x2._config._imageRoot + "check.png" } );
        this._check.setA( 0 );
        this._check.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._check );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    CheckBoxRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 * _x2._config._text );
    };

    CheckBoxRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this, losingFocus );
        this._glyph.gotFocus();
        this._title.gotFocus();
        this._check.gotFocus();
        this._title.setSpeechParams( undefined, "_radio", this, newScreen, this._data.selected );

        return this;
    };

    CheckBoxRowWidget.prototype.layout = function()
    {
        if( this._numElements === 2 )
        {
            this._title.setX( 2 * this._check.getW() );
            this._title.setY( (this.getHeightUnfocused() - this._title.getH()) / 2 );
            this._glyph.setX( this.getW() - this._glyph.getW() );
            this._glyph.setY( (this.getHeightUnfocused() - this._glyph.getH()) / 2 );
            this._check.setY( (this.getHeightUnfocused() - this.getSepH() - this._check.getH()) / 2 );
        }
    };

    CheckBoxRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._glyph.lostFocus();
        this._title.lostFocus();
        this._check.lostFocus();
    };

    CheckBoxRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    retval = true;

                    this.setSelected( !this._data.selected, true );
                    this._title.setSpeechParams( undefined, "_radio", this, false, this._data.selected );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    CheckBoxRowWidget.prototype.setData = function( data )
    {
        var self = this;
        this._data = data;

        if( data !== undefined )
        {
            this._title.setText( data.title );
            this._glyph.setText( data.glyph );
            this.setSelected( data.selected );
            this.setA( 1 );
            this.setMouseDownListener( function( event ) { event.stopPropagation(); self.processEvent( Host.KEY_ENTER, Host.KEY_PRESSED ); } );
        }
        else
        {
            this.setA( 0 );
            this.enableMouseDownListener( false );
        }
    };

    CheckBoxRowWidget.prototype.setSelected = function( val, animate )
    {
        this._data.selected = val;

        var alpha = val ? 1 : 0 ;

        if( animate )
            this._check.animate( { a:alpha, duration:300 } );
        else
            this._check.setA( alpha );
    };

    return CheckBoxRowWidget;

})();


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChoiceRowWidget = ( function()
{
    "use strict";

    ChoiceRowWidget.prototype = new ListRowWidget();

    function ChoiceRowWidget(){}

    ChoiceRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 * _x2._config._text );
    };

    ChoiceRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._title.gotFocus();
        this._icon.gotFocus();
        this._title.setSpeechParams( undefined, "_radio", this, newScreen, this._data.selected );
        this._parent._parent._parent._currentFocusIndex = this._currentRowIndex;
        return this;
    };

    /**
     * Initializer
     * @memberof ChoiceRowWidget
     * @param   {Object}    params
     * @param   {Number}   [params.focusTime=0] - TODO
     * @param   {Function} [params.onEnter]     - Function to execute on selection
     * @param   {String}    params.title        - TODO
     * @param   {Number}    params.w            - TODO
     * @returns {ChoiceRowWidget}
     * @see ListRowWidget
     */
    ChoiceRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "ChoiceRowWidget";
        this._selectable = true;

        var self       = this;
        var titleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );

        var onLoad = function()
        {
            self._numLoaded++;

            if( self._numLoaded === 2 )
            {
                var h = self.getHeightUnfocused();
                var iconY = (h - self._icon.getH()) / 2;

                self._icon.setY( iconY );

                if( self._title.getText() === undefined )  // make sure string widget has a valid height
                    self._title.setText( "????" );

                self._titleBaseY = (h - self._title.getH()) / 2;
                self._title.setY( self._titleBaseY );
                self._title.setX( self._icon.getW() + 3 * Style._pad );
            }
        };

        this._numLoaded = 0;
        this._onEnter   = params.onEnter;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.addReadyCallback( onLoad );
        this.addWidget( this._title );

        this._icon = new DualImageWidget().init( { url:_x2._config._imageRoot + "check_white.png", urlHi:_x2._config._imageRoot + "check.png" } );
        this._icon.setA( 0 );
        this._icon.addReadyCallback( onLoad );
        this.addWidget( this._icon );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._currentRowIndex = params.rowIndex;

        return this;
    };

    ChoiceRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
        this._icon.lostFocus();
        this._parent._parent._parent._lastFocusIndex = this._currentRowIndex;
    };

    ChoiceRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED && this._onEnter )
                {
                    retval = true;
                    this._onEnter( this );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    /**
     * @memberof ChoiceRowWidget
     * @param {Object}   [data]
     * @param {Function}  data.onEnter  - callback
     * @param {Boolean}   data.selected - Should this row show as selected
     * @param {String}    data.title    - Title to display in the row
     * @param {Object}   [data.value]   - TODO
     */
    ChoiceRowWidget.prototype.setData = function( data )
    {
        var self = this;
        this._data = data;

        if( data !== undefined )
        {
            if( data.selected === true )
                this._icon.setA( 1 );

            this._title.setText( data.title );
            this._onEnter = data.onEnter;

            this.setA( 1 );
            this.setMouseDownListener( function( event ) { event.stopPropagation(); self.processEvent( Host.KEY_ENTER, Host.KEY_PRESSED ); } );
            this.setMouseEnterListener( function() { 
                this._parent._parent._parent.moveCursorToRow( this._currentRowIndex );
             } );
        }
        else
        {
            this.setA( 0 );
            this.enableMouseDownListener( false );
        }
    };

    return ChoiceRowWidget;

})();


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.CollectionCellWidget = ( function()
{
    "use strict";

    CollectionCellWidget.prototype = new ListRowWidget();

    function CollectionCellWidget(){}

    CollectionCellWidget.prototype.gotFocus = function()
    {
        var obj;

        ListRowWidget.prototype.gotFocus.call( this );

        obj          = this.getGlobalPos();
        obj.w        = this._focusW;
        obj.h        = this._focusH;
        obj.duration = 0;

        _x2._shadow.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );

        if( this._background && this._background.getA() )
            this._background.animate( { xScale:this._backgroundScale, yScale:this._backgroundScale, duration:ListWidget.SCROLL_TIME_STEP } );

        return this;
    };

    /**
     * @memberof CollectionCellWidget
     * @param {Object}  params
     * @param {Boolean} params.background - whether to render a background
     * @param {Number}  params.bgW        - Width in pixels
     * @param {Number}  params.bgH        - Height in pixels
     * @param {Number}  params.bgScale    - Scale factor
     * @param {Number}  params.bgX        - left offset in pixels
     * @param {Number}  params.bgY        - top offset in pixels
     * @param {Number}  params.h          - height
     * @param {Number}  params.obj        - Widget
     * @param {Number}  params.bgTextSize - Font size of background text
     * @returns {CollectionCellWidget}
     */
    CollectionCellWidget.prototype.init = function( params )
    {
        var self = this;

        ListRowWidget.prototype.init.call( this, params );
        this._className  = "CollectionCellWidget";
        this._selectable = true;
        this._listObj    = params.obj;

        if( params.background === true )
        {
            var textStyle = new Style( { color:"#e8e8e8", font:"light", fontSize:params.bgTextSize, textAlign :"center" } );

            var gradientParams    = {};
            gradientParams.w      = params.bgW;
            gradientParams.h      = params.bgH;
            gradientParams.type   = GradientWidget.Type.Linear;
            gradientParams.angle  = -224;
            gradientParams.alphas = [ { opacity:100    , location:0 }, { opacity:100    ,location: 100 } ];
            gradientParams.colors = [ { color:"#1C262F", location:0 }, { color:"#130917", location:100 } ];

            this._backgroundScale = params.bgScale;

            this._background = new GradientWidget().init( gradientParams );
            this.addWidget( this._background, params.bgX, params.bgY );

            this._defaultImage = new ImageWidget().init({w:params.bgW, h:params.bgH});
            this._defaultImage.setA(0);
            this.addWidget( this._defaultImage, params.bgX, params.bgY );

            this._backgroundText = new TextBlockWidget().init({style:textStyle, w:params.bgW, h:params.bgH});
            this.addWidget( this._backgroundText, params.bgX, params.bgY + params.bgH - ( params.bgTextSize * 4 ) );
        }

        this.setA( 0 );
        this.setW( this.getHeightUnfocused() );
        this.setH( params.h );

        this.setMouseDownListener( function() { self.processEvent( Host.KEY_ENTER, Host.KEY_PRESSED ); self.processEvent( Host.KEY_ENTER, Host.KEY_RELEASED ); } );

        return this;
    };

    CollectionCellWidget.prototype.hideBackground = function()
    {
        if( this._background )
        {
            this._background.setA(0);
            this._backgroundText.setA(0);
        }
    };

    CollectionCellWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        _x2._shadow.stopAnimation( Widget.ALPHA );
        _x2._shadow.setA( 0 );

        if( this._background && this._background.getA() )
        {
            this._background.stopAnimation( Widget.X_SCALE );
            this._background.stopAnimation( Widget.Y_SCALE );
            this._background.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }
    };

    CollectionCellWidget.prototype.processEvent = function( val, type )
    {
        var retval, next, url, streamId, screen, self = this, localytics;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this.isListBlocking() === false && this._data )
                    {
                        if( this._data instanceof Collection )
                        {
                            _x2._telemetry.watchPathPush( this._data.getTitle() );

                            next = new VodLeafScreen().init( { folder:this._data, path:_x2.getTopScreen().getBreadCrumb() } );
                        }
                        else if( this._data instanceof BrowseCollection )
                        {
                            _x2._telemetry.watchPathPush( this._data.getTitle() );

                            if( this._data.getCollectionRenderStyle() === "BROWSE" )
                                next = new VodLeafScreen().init( { folder:this._data, path:_x2.getTopScreen().getBreadCrumb() } );
                            else
                            {
                                screen = _x2.getTopScreen();
                                next   = new VodBranchScreen().init( this._data, screen ? screen.getBreadCrumb() : undefined );
                            }
                        }
                        else if( this._data instanceof ThumbnailEntity || this._data instanceof Entity )
                        {
                            switch( this._data.getType() )
                            {
                                case "Network":
                                    console.error( "If you find a way to hit this path, let Tony know how." );
                                    url = this._data.getStreamUrl();
                                    next = new VideoScreen().init( { url:url, mode:VideoScreen.Mode.LIVE, entity:this._data } );
                                    break;
                                case "s:Organization":
                                    localytics = "Channel Collection";
                                    _x2._telemetry.setWatchButton( "Search" ); // Search > Channel Collection
                                    var org = new Organization().init( { searchEntity:this._data } );
                                    next = new ChannelCollectionScreen().init( org );
                                    break;
                                case "SportsTeam":
                                case "s:SportsTeam":
                                    localytics = "Sports Team";
                                    next = new SportsTeamScreen().init( this._data );
                                    break;
                                case "s:Movie":
                                    localytics = "Movie";
                                    _x2._telemetry.setWatchButton( "Entity Movie Info" ); // Search > Entity Page > Movie Info
                                    next = new EntityScreen().init( { entity: this._data } );
                                    break;
                                case "s:TvSeries":
                                    localytics = "TV Show";
                                    _x2._telemetry.setWatchButton( "Entity Episodes" ); // Search > Entity Page > Episodes Tab
                                    next = new EntityScreen().init( { entity: this._data } );
                                    break;
                                case "s:CreativeWork": // Search > HBO > HBO Films
                                    // intentional fall into default
                                default: // "Program"
                                    var pt = this._data.getProgramType && this._data.getProgramType(); // VOD: getType() == "Program" but getProgramType() -> "Movie"
                                    if( pt && pt === "Movie"  )
                                    {
                                        localytics = "Movie";
                                        _x2._telemetry.setWatchButton( "Entity Movie Info" );
                                    }
                                    else // "MusicVideo", "Other", "SeriesMaster"
                                    {
                                        localytics = "TV Program";
                                        _x2._telemetry.setWatchButton( "Entity Info" );
                                    }
                                    next = new EntityScreen().init( { entity: this._data } );
                                    break;
                            }

                            if( this._data instanceof SearchEntity && localytics )
                                this._data._localyticsSearchType = localytics; // Localytics: Search.2

                            if( this._listObj && this._listObj.onSelected )
                                this._listObj.onSelected( this._data );
                        }
                        else if( this._data instanceof PurchaseGroup )
                        {
                            if( this._data.getEpisodeCount() === 1 )
                                next = new EntityScreen().init( { entity: this._data.getPurchases()[0] } );
                            else
                                next = new EpisodesScreen().init( { entity: this._data } );
                        }
                        else if( this._data instanceof Recording )
                        {
                            next = new EntityScreen().init( { entity: this._data } );

                            if( this._listObj && this._listObj.onSelected )
                                this._listObj.onSelected( this._data );
                        }
                        else if( this._data instanceof LinearShowing )
                        {
                            console.log( this._data );

                            var tabName;
                            var parent   = this;
                            var showing  = this._data;
                            var title    = showing.getTitle();
                            var start    = showing.getStartTime();
                            var end      = showing.getEndTime();
                            var duration = end - start;
                            var metrics  =
                            {
                                "Channel"  : showing._channel.getNumber(), // TODO: Do we always have one?
                                "Title"    : title,
                                "Start"    : start,
                                "End"      : end,
                                "Duration" : duration,
                                "Scheduled": showing.isRecorded() ? 'yes' : 'no'
                            };

                            // In order to find which Live TV tab we are in (Kids, Sports, Movies)
                            // We need to traverse up the hierarchy until we find a GuideViewFilterWidget
                            // e.g.
                            //     this._parent._parent._parent._parent._parent._parent._parent._parent._filter
                            while( parent )
                            {
                                parent = parent._parent;
                                if( parent instanceof GuideViewFilterWidget )
                                {
                                    tabName = parent.getLocalyticsTabName();
                                    break;
                                }
                            }

                            if( tabName )
                            {
                                window.ll( "tagEvent", "Gallery View: " +  tabName, metrics ); // Localytics 2.3.5
                                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Gallery View Info: " + tabName + ": %o", metrics ) : Config.NOP();
                            }
                            else
                                console.error( "Unknown Live TV tab" );

                            if( this._data.isWatchable() === true )
                            {
                                url      = this._data._channel.getStreamUrl();
                                streamId = this._data._channel.getStreamId();

                                console.log( "URL = " + url );

                                if( url )
                                {
                                    var playVideo = function()
                                    {
                                        _x2._telemetry.watchSourceClassify( self._data );

                                        _x2.pushScreen( new VideoScreen().init( { url:url, mode:VideoScreen.Mode.LIVE, entity:self._data, streamId:streamId } ) );
                                    };

                                    if( _x2._pc.isEnabled() === true )
                                        _x2.checkParentalControls( this._data, undefined, this._data._channel ).then( playVideo );
                                    else
                                        playVideo();
                                }
                            }
                            else
                            {
                                _x2._telemetry.watchSourceClassify( this._data );

                                _x2.pushScreen( new EntityScreen().init( { entity:this._data } ));
                            }
                        }
                        else if( this._data instanceof VodShowing )
                        {
                            next = new EntityScreen().init( { entity: this._data } );

                            if( this._listObj && this._listObj.onSelected )
                                this._listObj.onSelected( this._data );
                        }
                        else if( this._data instanceof SportsTeam )
                        {
                            next = new SportsTeamScreen().init( this._data );
                        }
                        else
                        {
                            console.log( "Error: unknown entity type in CollectionCellWidget.processEvent" );
                            console.log( this._data );
                        }

                        if( next )
                            _x2.pushScreen( next );
                    }

                    retval = true;
                }
                break;

            case Host.KEY_LAST:
                if( _x2._telemetry.watchPathDepth() >= 2 )
                    _x2._telemetry.watchPathPop();
                // Intentional fall into default

            default:
                retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    CollectionCellWidget.prototype.setBackgroundText = function( val )
    {
        this._backgroundText.setText( val );
    };

    CollectionCellWidget.prototype.setHighlight = function( time )
    {
        var obj;

        obj          = this.getGlobalPos();
        obj.w        = this._focusW;
        obj.h        = this._focusH;
        obj.inner    = false;
        obj.duration = (time === undefined) ? ListWidget.SCROLL_TIME_STEP : time;

        _x2._hi.setPosition( obj );
    };

    CollectionCellWidget.prototype.showBackground = function()
    {
        if( this._background )
        {
            this._background.setA(1);
            this._backgroundText.setA(1);
        }
    };

    CollectionCellWidget.prototype.showDefaultImage = function( url )
    {
        this._defaultImage.setUrl( url );
        this._background.setA(0);
        this._defaultImage.setA(1);
        this._backgroundText.setA(1);
    };

    return CollectionCellWidget;

})();


/***/ }),
/* 95 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.CollectionRowWidget = ( function()
{
    "use strict";

    CollectionRowWidget.prototype = new ListRowWidget();

    function CollectionRowWidget(){}

    /**
     * @param {Object}  params
     * @param {Number}  params.w     - Width in pixels
     * @param {Number}  params.h     - Height in pixels
     * @param {Widget}  params.type  - Widget
     * @param {Number}  params.y     - Offset of list
     * @param {Number} [params.max]  - Max number of items to display in the row
     * @param {Object} [params.data] - Collection such as BrowseCollection
     * @param {Object} [params.obj]  - Object past to the list cell
     */
    CollectionRowWidget.prototype.init = function( params )
    {
        var listParams = {};
        var titleStyle = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var instance   = new params.type();

        ListRowWidget.prototype.init.call( this, params );
        this._className  = "CollectionRowWidget";
        this._selectable = true;

        this._title = new StringWidget().init( { style:titleStyle } );
        this.addWidget( this._title, 0, _x2.scaleVal( 50 ) );

        this._speakTarget = new StringWidget().init( { style:titleStyle } );
        this._speakTarget.setA( 0 );
        this.addWidget( this._speakTarget );

        listParams.w        = params.w;
        listParams.h        = params.h;
        listParams.maxIndex = 1;
        listParams.axis     = ListWidget.Axis.X;
        listParams.stepTime = 250;
        listParams.type     = params.type;
        listParams.obj      = params.obj;
        listParams.touchH   = instance.getTouchDim ? instance.getTouchDim() : instance.getHeightUnfocused();
        listParams.touchW   = Math.floor( Style._safeLeft * 2 / 3 );

        this._list          = new ListWidget().init( listParams );
        this.addWidget( this._list, 0, params.y );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        if( params.data )
            this.setData( params.data, params.max );

        return this;
    };

    /**
     * @memberof CollectionRowWidget
     * @returns Number
     */
    CollectionRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 100 );
    };

    /**
     * @memberOf CollectionRowWidget
     * @return {number}
     */
    CollectionRowWidget.prototype.getListPosition = function()
    {
        return this._list ? this._list.getCurrentAndMaxIndex().current : 0;
    };

    /**
     * @memberOf CollectionRowWidget
     * @param index
     */
    CollectionRowWidget.prototype.setListPosition = function( index )
    {
        if( this._list )
            this._list.setJumpToIndex( index );
    };

    CollectionRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var focus = _x2.requestFocus( this._list, true );

        if( focus )
        {
            var title  = this._data.getTitle();
            var parsed = title ? title.match( /\d?\d:\d\d[ap]?\s?-\s?\d?\d:\d\d[ap]/i ) : "";

            if( parsed )
                title = _x2.createTimeSpeechStr( parsed[0] );

            this._speakTarget.setText( title + ". " );
            this._speakTarget.setSpeechParams( focus._speakStr + ". Press left or right to review items. Press OK to select.", focus._speakRole, this, newScreen );
        }

        return newScreen === true ? this : focus;
    };

    /**
     * @memberof CollectionRowWidget
     * @param {Object} data - Collection such as BrowseCollection
     * @param {Number} max  - Cap the number of items in the row
     */
    CollectionRowWidget.prototype.setData = function( data, max )
    {
        if( data !== undefined )
        {
            this._data = data;
            this._title.setText( data.getTitle() );
            this._list.setData( data.getEntities( max ) );

            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return CollectionRowWidget;

})();


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * This is a simple horizontal or vertical layout container which arranges/positions
 * widgets with a consistent spacing.
 * @class
 */
window.ContainerWidget = (function()
{
    "use strict";

    function ContainerWidget(){}

    ContainerWidget.prototype = new Widget();

    /**
     * Initialize the widget
     * @memberOf ContainerWidget
     * @param {Object}   params
     * @param {Widget[]} [params.widgets]  - collection of widgets in container.
     * @param {Number}   [params.spacing]  - widget layout spacing.
     * @param {function} [params.onReady]  - callback when all are loaded.
     * @param {Boolean}  [params.ready]    - indicates all widgets are added - no intention to call addWidget()
     * @param {Boolean}  [params.vertical] - use vertical layout. horizontal is the default.
     * @param {Boolean}  [params.center]   - center align widgets
     * @return {ContainerWidget}
     */
    ContainerWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className = "ContainerWidget";

        var i;

        this._vertical      = params.vertical;
        this._spaceing      = params.spacing || 0;
        this._onReady       = params.onReady;
        this._center        = params.center;
        this._widgets       = [];
        this._callbackCount = 0;

        if( params.widgets )
        {
            for( i = 0; i < params.widgets.length; i++ )
                this.addWidget( params.widgets[i] )
        }

        if( params.ready )
            this.ready();

        this.setA( 0 );

        return this;
    };

    /**
     * Layout contained widgets
     * @private
     */
    ContainerWidget.prototype.layout = function()
    {
        var i, widget, offset = 0, maxW = this.getWidth();

        for( i = 0; i < this._widgets.length; i++ )
        {
            widget = this._widgets[i];

            if( this._vertical )
            {
                widget.setY( offset );
                offset += widget.getH() + this._spaceing;

                if( this._center === true )
                {
                    if( widget.getW() < maxW )
                        this._widgets[i].setX( maxW/2 - widget.getW()/2 );
                }
            }
            else
            {
                widget.setX( offset );
                offset += widget.getW() + this._spaceing;
            }
        }

        if( this._onReady )
            this._onReady();
    };

    /**
     * Add a widget to the container.
     * @memberOf ContainerWidget
     * @param {Widget} widget - Any Widget type that implements addReadyCallback
     */
    ContainerWidget.prototype.addWidget = function( widget )
    {
        var self = this;

        this._widgets.push( widget );

        if( widget.addReadyCallback )
            widget.addReadyCallback( function(){ self.widgetReady(); } );
        else
            console.log( "Error: Parameter to ContainerWidget.addWidget must implement addReadyCallback()" );

        Widget.prototype.addWidget.call( this, widget );
    };

    /**
     * Get the width of this container (NOTE: assumes vertical layout)
     * @return {number}
     */
    ContainerWidget.prototype.getWidth = function()
    {
        var i, maxW = 0;

        for( i=0; i<this._widgets.length; i++ )
            maxW = this._widgets[i].getW() > maxW ? this._widgets[i].getW() : maxW;

        return maxW;
    };

    /**
     * Get the height of this container (NOTE: assumes vertical layout)
     * @return {number}
     */
    ContainerWidget.prototype.getHeight = function()
    {
        var lastWidget = this._widgets[this._widgets.length-1];

        return lastWidget.getY() + lastWidget.getH();
    };

    /**
     * Mark this container as ready to render. i.e. all widgets have been added. NOTE: we could
     * also layout as stuff is ready, but could lead to "jumpy" behavior
     * @memberOf ContainerWidget
     */
    ContainerWidget.prototype.ready = function()
    {
        this._ready = true;

        if( this._pending )
        {
            if( this._callbackCount === this._widgets.length )
                this.layout();
        }
    };

    /**
     * Callback fires for each contained widget.
     */
    ContainerWidget.prototype.widgetReady = function()
    {
        this._callbackCount++;

        if( this._callbackCount === this._children.length )
        {
            if( this._ready )
                this.layout();
            else
                this._pending = true;
        }
    };

    return ContainerWidget;

})();


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DevicesRowWidget = ( function()
{
    "use strict";

    DevicesRowWidget.prototype = new ListRowWidget();

    function DevicesRowWidget(){}

    DevicesRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 122 * _x2._config._text );
    };

    DevicesRowWidget.prototype.gotFocus = function()
    {
        if( this._data )
        {
            ListRowWidget.prototype.gotFocus.call( this );
            this._title.gotFocus();
        }
        else
            this._obj.onRowLostFocus();
    };

    /**
     * Initializer
     * @memberof DevicesRowWidget
     * @param   {Object}    params
     * @param   {Number|undefined}   [params.focusTime=0] - TODO
     * @param   {Object}              params.obj          - Object that manages the lists contents
     * @param   {Function}           [params.onEnter]     - Function to execute on selection
     * @param   {String}             [params.title]       - Title to display in the cell
     * @param   {String}             [params.subTitle]    - Sub-title to display in the cell
     * @param   {Number}              params.w            - width of cell
     * @returns {DevicesRowWidget}
     * @see ListRowWidget
     */
    DevicesRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "DevicesRowWidget";
        this._selectable = true;

        var self        = this;
        var fontSize    = 42;
        var titleStyle  = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(       fontSize), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var valueStyle  = new Style( { color:"#a3a3a3", font:"light", fontSize:_x2.scaleValInt(0.74 * fontSize), whiteSpace:"nowrap" } );
        var removeStyle = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(0.74 * fontSize), whiteSpace:"nowrap" } );

        this._obj       = params.obj;
        this._onEnter   = params.onEnter;
        this._focusTime = ( params.focusTime !== undefined ) ? params.focusTime : 0;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this.addWidget( this._title );

        this._subTitle = new StringWidget().init( { text:params.subTitle, style:valueStyle } );
        this._subTitle.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._subTitle );

        this._image = new NineSliceWidget().init( { url:_x2._config._imageRoot + [ "", "", "remove_20_20_20_20.png", "remove_30_30_30_30.png" ][_x2._config._layout] } );
        this.addWidget( this._image );

        this._remove = new StringWidget().init( { text:"Remove", style:removeStyle } );
        this.addWidget( this._remove );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    DevicesRowWidget.prototype.layout = function()
    {
        var pad;

        if( this._title.getText() === undefined )  // make sure string widget has a valid height
            this._title.setText( "????" );

        if( this._subTitle.getText() === undefined )  // make sure string widget has a valid height
            this._subTitle.setText( "????" );

        pad = (this.getHeightUnfocused() - ListRowWidget.DIVIDER_H - this._title.getH() - this._subTitle.getH()) / 2;

        this._title.setY( pad );
        this._subTitle.setY( this._title.getY() + this._title.getH() );

        this._image.setW( this._remove.getW() );
        this._image.setX( this.getW() - this._image.getW() );
        this._image.setY( (this.getH() - this._image.getH() - ListRowWidget.DIVIDER_H) / 2 );

        this._remove.setX( this._image.getX() + (this._image.getW() - this._remove.getW()) / 2 );
        this._remove.setY( this._image.getY() + (this._image.getH() - this._remove.getH()) / 2 );
    };

    DevicesRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
    };

    DevicesRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    retval = true;

                    if( this._onEnter )
                        this._onEnter( this );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    /**
     * @memberof DevicesRowWidget
     * @param {Object}   [data]
     * @param {Function}  data.onEnter   - Callback
     * @param {String}   [data.title]    - Title to display in the cell
     * @param {String}   [data.subTitle] - Sub-title to display in the cell
     */
    DevicesRowWidget.prototype.setData = function( data )
    {
        this._data = data;

        if( data !== undefined )
        {
            this._title.setText   ( data.title    );
            this._subTitle.setText( data.subTitle );
            this._onEnter = data.onEnter;

            if( this._onEnter )
            {
                this._remove.setA( 1 );
                this._image.setA ( 1 );
            }
            else
            {
                this._remove.setA( 0 );
                this._image.setA ( 0 );
            }

            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return DevicesRowWidget;

})();


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Visual to show when loading/waiting for data
 * @class
 */
window.DistractorWidget = ( function()
{
    "use strict";

    DistractorWidget.prototype = new Widget();

    function DistractorWidget(){}

    /**
     * @memberof DistractorWidget
     * @param {Widget} widget - which widget to center on
     */
    DistractorWidget.prototype.centerOnWidget = function( widget )
    {
        if( widget )
        {
            this.setX( (widget.getW() - this.getW()) / 2 );
            this.setY( (widget.getH() - this.getH()) / 2 );
        }
    };

    /**
     * @memberof DistractorWidget
     */
    DistractorWidget.prototype.centerOnScreen = function()
    {
        var pos = this.getGlobalPos();
        this.setX( _x2._config._screenW / 2 - pos.x - this.getW() / 2 );
        this.setY( _x2._config._screenH / 2 - pos.y - this.getH() / 2 );
    };

    /** Hide the distractor
     * @memberof DistractorWidget
     */
    DistractorWidget.prototype.hide = function()
    {
        if( this._showing === true )
        {
            this._showing = false;
            this._repeat  = false;

            if( this.getA() === 0 )
                this.stopAnimation();
            else
                this.animate( { a:0, duration:500 } );
        }
    };

    /**
     * Initializer
     * @memberof DistractorWidget
     * @returns {DistractorWidget}
     * @see RingDistractorWidget
     */
    DistractorWidget.prototype.init = function( params )
    {
        var self = this, imageLoaded;

        Widget.prototype.init.call( this );
        this._className = "DistractorWidget";
        this._numLoaded = 0;
        this._showing   = false;

        imageLoaded = function()
        {
            self._numLoaded++;
            self.layout();
        };

        this._dotScale = 0.6666667;
        this._fadeTime = 500;
        this._offset   = 250;
        this._repeat   = true;

        if( params === undefined || params.hideBg !== true )
        {
            this._bg   = new ImageWidget().init( { url:_x2._config._imageRoot + "loaderBg.png", onLoad:imageLoaded } );
            this.addWidget( this._bg   );
        }


        this._dot0 = new ImageWidget().init( { url: _x2._config._imageRoot + "loaderDot.png", onLoad:imageLoaded } );
        this._dot1 = new ImageWidget().init( { url: _x2._config._imageRoot + "loaderDot.png", onLoad:imageLoaded } );
        this._dot2 = new ImageWidget().init( { url: _x2._config._imageRoot + "loaderDot.png", xScale:0.2, yScale:0.2, onLoad:imageLoaded } );

        this._dot0.setA( 0 );
        this._dot1.setA( 0 );
        this._dot2.setA( 0 );

        this._dot0.setScale( this._dotScale );
        this._dot1.setScale( this._dotScale );
        this._dot2.setScale( this._dotScale );

        this.addWidget( this._dot0 );
        this.addWidget( this._dot1 );
        this.addWidget( this._dot2 );

        this.setA( 0 );

        return this;
    };

    DistractorWidget.prototype.layout = function()
    {
        if( this._numLoaded === (this._bg ? 4 : 3) )
        {
            var y = ( this._bg ) ? (this._bg.getH() - this._dot1.getH()) / 2 : 0;
            var x = ( this._bg ) ? (this._bg.getW() - this._dot1.getW()) / 2 : (3 * this._dot1.getW() + _x2.scaleVal( 6 )) / 2;

            this._dot1.setX( x );
            this._dot0.setX( this._dot1.getX() - this._dot0.getW() - _x2.scaleVal( 6 ) );
            this._dot2.setX( this._dot1.getX() + this._dot0.getW() + _x2.scaleVal( 6 ) );

            this._dot0.setY( y );
            this._dot1.setY( y );
            this._dot2.setY( y );

            this.setW( this._bg ? this._bg.getW() : this._dot2.getX() + this._dot2.getW() );
            this.setH( this._bg ? this._bg.getH() : this._dot2.getY() + this._dot2.getH() );

            this._ready = true;

            if( this._showing === true )
            {
                this._showing = false;
                this.show( this._isStatic );
            }

            this.callbackSignalReady();
        }
    };

    /**
     * Show the distractor
     * @memberof DistractorWidget
     */
    DistractorWidget.prototype.show = function( isStatic )
    {
        this._isStatic = isStatic;

        if( this._showing === false )
        {
            this._showing = true;

            if( this._ready === true )
            {
                if( isStatic !== true )
                {
                    var self    = this, sequence, fadeOutRestart;
                    var fadeOut = { a:0, xScale:this._dotScale, yScale:this._dotScale, duration:this._fadeTime, easing:Widget.Easing.QUAD_IN };

                    this._showing = true;
                    this._repeat = true;

                    sequence = function()
                    {
                        fadeOutRestart.onEnd = (self._repeat === true) ? sequence : undefined;

                        self._dot0.animate( { a:1, xScale:1.0, yScale:1.0, duration:self._fadeTime, easing:Widget.Easing.QUAD_OUT, onEnd:function() { self._dot0.animate( fadeOut ); } } );
                        self._dot1.animate( { a:1, xScale:1.0, yScale:1.0, duration:self._fadeTime, easing:Widget.Easing.QUAD_OUT, onEnd:function() { self._dot1.animate( fadeOut ); }, start:self._offset } );
                        self._dot2.animate( { a:1, xScale:1.0, yScale:1.0, duration:self._fadeTime, easing:Widget.Easing.QUAD_OUT, onEnd:function() { self._dot2.animate( fadeOutRestart ); }, onEndAxis:Widget.ALPHA, start:2*self._offset } );
                    };

                    fadeOutRestart = { a:0, xScale:this._dotScale, yScale:this._dotScale, duration:this._fadeTime, easing:Widget.Easing.QUAD_OUT, onEnd:sequence, onEndAxis:Widget.ALPHA };

                    this.animate( { a:1, duration:500, onEnd:sequence } );
                }
                else
                {
                    this._dot0.setA( 0.33 );
                    this._dot1.setA( 0.66 );
                    this._dot2.setA( 1.00 );
                    this.setA( 1 );
                }
            }
        }
    };

    return DistractorWidget;

})();


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Show the highlighted image when it has focus, else show the unfocused image.
 * @class
 */
window.DualImageWidget = ( function()
{
    "use strict";

    DualImageWidget.prototype = new Widget();

    function DualImageWidget(){}

    DualImageWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        Widget.prototype.gotFocus.call( this );
        this._image.animate  ( { duration:this._focusTime, xScale:1.0, yScale:1.0          } );
        this._imageHi.animate( { duration:this._focusTime, xScale:1.0, yScale:1.0, alpha:1 } );

        if( this._str )
            this._str.setSpeechParams( undefined, "button", this, newScreen );
    };

    DualImageWidget.prototype.imageLoaded = function()
    {
        this.setVal( Widget.W, this._image.getVal( Widget.W ) );
        this.setVal( Widget.H, this._image.getVal( Widget.H ) );

        this.callbackSignalReady();
    };

    /**
     * Initializer
     * @memberof DualImageWidget
     * @param   {Object}    params
     * @param   {Number}   [params.focusTime=0     ] - time in milliseconds
     * @param   {Number}   [params.lostFocusScale=1] - scale value when focus is lost
     * @param   {Function} [params.onEnter         ] - function to cll on enter
     * @param   {Function} [params.onFocus         ] - function to call on focus
     * @param   {String}   [params.speechName      ] - string to speak when using text-to-speech
     * @param   {String}    params.url               - URL of image when not focused
     * @param   {String}    params.urlHi             - URL of image when has focus
     * @returns {DualImageWidget}
     */
    DualImageWidget.prototype.init = function( params )
    {
        var self = this;

        Widget.prototype.init.call( this );
        this._className  = "DualImageWidget";
        this._selectable = true;

        if( params.onEnter )
        {
            this._onEnter = params.onEnter;
            this.setMouseDownListener( params.onEnter );
            this.setMouseEnterListener( function() {
                this._parent._children.forEach( function(siblingsWidget) {
                    siblingsWidget._imageHi.setA(0);
                });//only one image widget should get highlight at a time
                this._imageHi.setA( 1 );
            });

            this.setMouseOutListener( function() {
                this._imageHi.setA( 0 );
            });
        }

        if( params.onFocus )
            this.setFocusListeners( params.onFocus );

        this._focusTime      = ( params.focusTime      !== undefined ) ? params.focusTime      : 0;
        this._lostFocusScale = ( params.lostFocusScale !== undefined ) ? params.lostFocusScale : 1;

        this._image = new ImageWidget().init( { url:params.url, xScale:this._lostFocusScale, yScale:this._lostFocusScale, onLoad:function() { self.imageLoaded(); } } );
        this.addWidget( this._image );

        this._imageHi = new ImageWidget().init( { url:params.urlHi, xScale:this._lostFocusScale, yScale:this._lostFocusScale } );
        this._imageHi.setVal( Widget.ALPHA, 0 );
        this.addWidget( this._imageHi );

        if( params.speechName )
        {
            this._str = new StringWidget().init( { text:params.speechName, style:new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(18) } ) } );
            this._str.setA( 0 );
            this.addWidget( this._str );
        }

        return this;
    };

    DualImageWidget.prototype.lostFocus = function()
    {
        Widget.prototype.lostFocus.call( this );
        this._image.animate  ( { duration:this._focusTime, xScale:this._lostFocusScale, yScale:this._lostFocusScale          } );
        this._imageHi.animate( { duration:this._focusTime, xScale:this._lostFocusScale, yScale:this._lostFocusScale, alpha:0 } );
    };

    DualImageWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED && this._onEnter )
        {
            this._onEnter();
            retval = true;
        }
        else
            retval = Widget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    return DualImageWidget;

})();


/***/ }),
/* 100 */
/***/ (function(module, exports) {

/**
 * @class
 */
window.EmptyMessageWidget = (function()
{
    "use strict";

    EmptyMessageWidget.prototype = new Widget();

    function EmptyMessageWidget(){}

    EmptyMessageWidget.Key = Object.freeze
    ({
          PURCHASES_ON   : 0,
          PURCHASES_OFF  : 1,
          RECORDINGS     : 2,
          UPCOMING       : 3,
          FAVORITES      : 4,
          GRID_FILTER    : 5,
          GRID_EMPTY     : 6,
          GRID_ERROR     : 7,
    });

    EmptyMessageWidget.prototype.getSpeechText = function()
    {
        var retval = this._line1.getText() + " " + this._line2.getText();

        return retval.replace( /xfinity/gi, "x finity" );
    };

    EmptyMessageWidget.prototype.hide = function()
    {
        this._line1.setA(0);
        this._line2.setA(0);
        if( this._widget )
            this._widget.setA( 0 );
        this._isShowing = false;
    };

    /**
     * @memberOf EmptyMessageWidget
     * @param  {Number} key
     * @param  {Widget} widget
     * @return {EmptyMessageWidget}
     */
    EmptyMessageWidget.prototype.init = function( key, widget )
    {
        Widget.prototype.init.call( this );
        this._className = "EmptyMessageWidget";

        var self   = this;
        var style1 = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(60), textAlign:"center", whiteSpace:"nowrap" } );
        var style2 = new Style( { font:"regular", color:"#a3a3a3", fontSize:_x2.scaleValInt(32), textAlign:"center" } );

        var onReady = function()
        {
            self._readyCount ++;
            self._ready = ( self._readyCount === (widget ? 3 : 2) );

            if( self._ready )
                self.layout();
        };

        this.setW( _x2._config._screenW - Style._safeLeft - Style._safeRight );
        this.setH( _x2._config._screenH );

        var blockW = this.getW() * 2/3;
        var blockH = this.getH() * 1/3;

        this._line1 = new StringWidget().init( { style:style1 } );
        this._line2 = new TextBlockWidget().init( { style:style2, w:blockW, h:blockH } );

        this.setMessage( key );

        this.addWidget( this._line1 );
        this.addWidget( this._line2 );

        if( widget )
        {
            this._widget = widget;
            widget.setA( 0 );
            widget.addReadyCallback( onReady );
            this.addWidget( widget );
        }

        this._line1.setA(0);
        this._line2.setA(0);

        this._readyCount = 0;
        this._line1.addReadyCallback( onReady );
        this._line2.addReadyCallback( onReady );

        return this;
    };

    EmptyMessageWidget.prototype.isShowing = function()
    {
        return this._isShowing;
    };

    EmptyMessageWidget.prototype.layout = function()
    {
        this.setH( _x2._config._screenH - this.getGlobalPos().y );

        var pad = Style._pad * 2;
        var w   = this.getW();
        var h   = this.getH();

        var w1 = this._line1.getW();
        var w2 = this._line2.getW();

        var h1 = this._line1.getH();
        var h2 = this._line2.getH();

        var totalH = h1 + h2 + pad + ( this._widget? this._widget.getH() + 2 * pad : 0 );

        this._line1.setX( w/2 - w1/2 );
        this._line2.setX( w/2 - w2/2 );

        this._line1.setY( h/2 - totalH/2 );
        this._line2.setY( h/2 - totalH/2 + h1 + pad );

        if( this._widget )
        {
            this._widget.setX( (this.getW() - this._widget.getW()) / 2 );
            this._widget.setY( this._line2.getY() + this._line2.getH() + 2 * pad );
        }

        this.callbackSignalReady();
    };

    EmptyMessageWidget.prototype.setMessage = function( messageKey )
    {
        var text1, text2;

        switch( messageKey )
        {
            case EmptyMessageWidget.Key.PURCHASES_ON:
                text1 = "No purchases found.";
                text2 = "When you purchase or rent something, it will be available to watch here.";
                break;
            case EmptyMessageWidget.Key.PURCHASES_OFF:
                text1 = "You haven't purchased anything yet.";
                text2 = "Unfortunately, you can’t buy shows or movies using this app. But, if you rent or buy through the XFINITY Stream website or your TV, you can watch here.";
                break;
            case EmptyMessageWidget.Key.RECORDINGS:
                text1 = "You have no completed recordings yet.";
                text2 = "Tip: Visit Saved > Scheduled to see your recording schedule.";
                break;
            case EmptyMessageWidget.Key.UPCOMING:
                text1 = "Your schedule is empty.";
                text2 = "Nothing is scheduled for the next 14 days.";
                break;
            case EmptyMessageWidget.Key.FAVORITES:
                text1 = "No Favorites...yet.";
                text2 = "Getting started is easy. Just select \"Favorite\" on the Info screen for any TV show, movie, or team.";
                break;
            case EmptyMessageWidget.Key.GRID_FILTER:
                text1 = "We didn’t find a match.";
                text2 = "Expand your search by adjusting or removing your filters.";
                break;
            case EmptyMessageWidget.Key.GRID_EMPTY:
                text1 = "Get more of what you’re looking for.";
                text2 = "It looks like your plan doesn’t include any channels. Luckily, there’s an easy fix. Xfinity Stream delivers hundreds of channels that you can watch just about anywhere. Learn more at the Xfinity website.";
                break;
            case EmptyMessageWidget.Key.GRID_ERROR:
                text1 = "Sorry, we’re having some trouble.";
                text2 = "We can’t load your Guide right now. Please give us a few minutes and try again.";
                break;
        }

        this._line1.setText( text1 );
        this._line2.setText( text2 );

        if( this._ready )
            this.layout();
    };

    EmptyMessageWidget.prototype.show = function()
    {
        this._line1.setA(1);
        this._line2.setA(1);
        if( this._widget )
            this._widget.setA( 1 );
        this._isShowing = true;
    };

    return EmptyMessageWidget;

})();


/***/ }),
/* 101 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * This widget encapsulates the Watch, Resume, Record, Episodes, Recording Options, Upcoming, Movie Info, Series Info buttons
 * @class
 */
window.EntityActionButtonsWidget = (function()
{
    "use strict";

    function EntityActionButtonsWidget(){}

    EntityActionButtonsWidget.prototype = new Widget();

    EntityActionButtonsWidget.prototype.gotFocus = function()
    {
        return _x2.requestFocus( this._menuWidget );
    };

    EntityActionButtonsWidget.prototype.getRecordingRefreshParams = function( form )
    {
        var params = {};
        params.hideDistractor = true;

        if( [ this._setSerRecForm, this._modSerRecForm, this._cancelSerRecForm ].indexOf( form ) !== -1 )
        {
            if( this._entity instanceof LinearShowing )
                params.linearEntityRecording = { force:true };
            else
                params.entityRecording = { force:true };
        }
        else
        {
            if( this._entity instanceof Recording )
                params.entity = true;
            else
                params.linearRecording = { force:true };
        }

        return params;
    };

    EntityActionButtonsWidget.prototype.init = function( entity, w )
    {
        Widget.prototype.init.call( this );

        var self     = this;
        var numReady = 0;

        var onGotFocus = function()
        {
            var refreshOptions = self._pendingRefreshParams;

            if( self._refreshResumePointsOnFocus === true )
            {
                // if there is a pending refresh, piggy back on it
                if( refreshOptions !== undefined )
                {
                    refreshOptions.resumePoints = true;
                    refreshOptions.distractor = true;
                }
                else
                {
                    refreshOptions = {
                        distractor : true,
                        resumePoints : true,
                        showDistractor : true
                    }
                }

                self._refreshResumePointsOnFocus = false;
            }

            if( refreshOptions )
            {
                if( refreshOptions.delay === true )
                    refreshOptions.delay = false; //wait for the next refresh call
                else
                {
                    refreshOptions.waitOnFocus = false;
                    self.refresh( refreshOptions );
                    self._pendingRefreshParams = undefined;
                }
            }
        };

        var placeDistractor = function()
        {
            if( ++numReady === 2 )
            {
                self._distractor.centerOnScreen();
                self.setH( self._menuWidget.getH() );
            }
        };

        this._className  = "EntityActionButtonsWidget";
        this._selectable = true;
        this._menuWidget = new HorizPillButtonsWidget().init( { spacing: _x2.scaleValInt( 45 - Style._pad ), bypassDown: true, scrollW:w } );
        this._menuWidget.addReadyCallback( placeDistractor );
        this._menuWidget.setFocusListeners( onGotFocus );
        this.setW( w );

        this.addWidget( this._menuWidget );

        if( entity )
            setTimeout( function() { self.setData({entity:entity}) }, 1 );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( placeDistractor );
        this.addWidget(this._distractor);

        return this;
    };

    EntityActionButtonsWidget.prototype.refresh = function( params )
    {
        var self = this;

        var exec = function()
        {
            var onComplete = function()
            {
                if( self._refreshListener )
                    self._refreshListener( self._entity );

                self.setData();
                self._menuWidget.setDisabled(false);

                if( params.hideDistractor || params.showDistractor )
                    self._distractor.hide();
            };

            var p = [];

            if( params.entity )
                p.push( self._entity.reload() );
            if( params.entityOptions )
                p.push( self._entity.fetchEntityOptions( params.entityOptions.force ) );
            if( params.entityRecording )
                p.push( self._entity.fetchEntityRecording( params.entityRecording.force ) );
            if( params.linearRecording )
                p.push( self._entity.fetchEpisodeRecording( params.linearRecording.force ) );
            if( params.linearEntityRecording )
                p.push( self._entity.fetchSeriesRecording( params.linearEntityRecording.force ) );
            if( params.resumePoints )
                p.push( _x2.refreshResumePoints() );

            if( params.showDistractor )
                self._distractor.show();

            self._menuWidget.setA(0);
            self._menuWidget.setDisabled(true);

            Promise.all( p ).then( onComplete );
        };

        if( params.waitOnFocus )
            this._pendingRefreshParams = params;
        else
            exec( params )
    };

    EntityActionButtonsWidget.prototype.selectBuyRent = function()
    {
        var self = this;

        var onBuyCompleted = function( watched )
        {
            var params = {};
            params.waitOnFocus    = true;
            params.showDistractor = true;
            params.entityOptions  = { force: true };

            if( watched )
            {
                params.resumePoints = true;
                params.delay        = true; //this is a hack to delay the refresh until the second gotFocus call to work around the way focus transitions when playing purchased content.
            }

            self.refresh( params );
        };

        _x2.pushOverlay( new PurchaseOptionsOverlay().init( this._entity, onBuyCompleted ) );
    };

    EntityActionButtonsWidget.prototype.selectWatch = function( resumePoint )
    {
        //TODO: 'entity' is confusing here. 'entity' should the Entity instance and 'showing' should be the VOD/Linear/Recording showing. We should also mod VideoScreen to accept entity and showing.
        var program, url, mode, position, mediaId, programId, paid, hasSap, hasDvs, streamId, assetId, providerId, mediaGuid, recordingId, options, vodShowings, linearShowings, recordings;
        var self   = this;
        var entity = this._entity;

        this._refreshResumePointsOnFocus = true;

        var playVideo = function()
        {
            var play = function()
            {
                var obj =
                {
                    url:url,
                    mediaId:mediaId,
                    programId:programId,
                    paid:paid,
                    mode:mode,
                    entity:entity,
                    resume:position,
                    hasSap:hasSap,
                    hasDvs:hasDvs,
                    streamId:streamId,
                    assetId:assetId,
                    providerId:providerId,
                    mediaGuid:mediaGuid,
                    recordingId:recordingId
                };

                self._refreshResumePointsOnFocus = true;
                _x2.pushScreen( new VideoScreen().init( obj ) );
            };

            if( _x2._pc.isEnabled() === true )
                _x2.checkParentalControls( entity, program, self._channel ).then( play );
            else
                play();
        };

        //use the resume point's showing if we have one.
        if( resumePoint )
        {
            entity   = resumePoint.getShowing();
            position = resumePoint.getPosition();
        }

        //extract a showing from Entity or push options screen if > 1 showing.
        if( entity instanceof Entity )
        {
            program        = entity;
            programId      = entity.getEntityId();
            options        = entity.getEntityOptions();
            vodShowings    = options.getVodShowings();
            linearShowings = options.getOnNowListings();
            recordings     = options.getRecordings();

            if( ( vodShowings.length + linearShowings.length + recordings.length ) > 1 )
                _x2.pushScreen( new ShowingsScreen().init( { entity:entity } ) );
            else
            {
                if( vodShowings.length > 0 )
                    entity = vodShowings[0];
                else if( linearShowings.length > 0 )
                    entity = linearShowings[0];
                else if( recordings.length > 0 )
                    entity = recordings[0];

                //add entity reference to showing if not already set so that VideoScreen will have access to Entity data.
                if( entity.getEntity() === undefined )
                    entity.setEntity( program );
            }
        }

        //get common properties from showing
        if( entity instanceof Showing )
        {
            if( ! program )
                program = entity.getEntity();

            url       = entity.getStreamUrl();
            mediaId   = entity.getMediaId();
            programId = entity.getProgramId();
            paid      = entity.getPaid();
            hasSap    = entity.isSap();
        }

        //set mode for each type and get type-specific properties
        if( entity instanceof Recording )
        {
            mode        = VideoScreen.Mode.DVR;
            recordingId = entity.getId();
            hasDvs      = entity.isDvs();
        }
        else if( entity instanceof VodShowing )
        {
            mode       = VideoScreen.Mode.VOD;
            assetId    = entity.getAssetId();
            providerId = entity.getProviderId();
            mediaGuid  = entity.getMediaGuid();
            hasDvs     = false;
        }
        else if( entity instanceof LinearShowing )
        {
            mode     = VideoScreen.Mode.LIVE;
            url      = this._channel.getStreamUrl();
            streamId = this._channel.getStreamId();
            hasDvs   = entity.isDvs();
        }

        if( url )
            playVideo();
    };

    EntityActionButtonsWidget.prototype.selectRecord = function( form )
    {
        var entity,
            setRecording,
            pushSeriesOptions,
            optCallback,
            optParams,
            optOverlay,
            self = this;

        if( this._entity instanceof Showing )
            entity = this._entity.getEntity();
        else if( this._entity instanceof Entity )
            entity = this._entity;
        else
            console.log( "ERROR: Unexpected type passed to EntityActionButtonsWidget.record");

        setRecording = function( form, overlay )
        {
            var success,
                error;

            success = function( response )
            {
                _x2._hi.fadeOut(0);

                self._distractor.hide();

                var responseObj = JSON.parse( response.data );

                if( responseObj['conflictingRecordingIds'] )
                    _x2.pushOverlay( new AlertOverlay().init( { title:"There's a conflict", message:"There are too many recordings scheduled. Please cancel a few of your recordings and try again." } ) );
                else
                {
                    self.refresh( self.getRecordingRefreshParams( form ) );
                    _x2.pushOverlay( new MessageOverlay().init( { message:"Your Recording is Set" } ) );
                }
            };

            error = function( error )
            {
                _x2._hi.fadeOut(0);

                self._distractor.hide();

                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.DVR } ) );
            };

            if( overlay )
                _x2.popOverlay( overlay );

            self._distractor.show();
            form.submit().then( success ).catch( error );
        };

        pushSeriesOptions = function( form, overlay )
        {
            var formOverlay,
                formParams;

            formParams = {
                entity   : entity,
                form     : form,
                callback : function( form ){ setRecording( form, formOverlay ) }
            };

            formOverlay = new RecordingOptionsOverlay().init( formParams );

            _x2.pushOverlay( formOverlay );

            if( overlay )
                _x2.popOverlay( overlay );
        };

        if( form !== undefined )
        {
            if( form === this._setEpRecForm )
                setRecording( this._setEpRecForm );
            else
                pushSeriesOptions( this._setSerRecForm );
        }
        else
        {
            if( this._setSerRecForm && this._setEpRecForm )
            {
                optCallback = function( option, overlay )
                {
                    if( option === 'series' )
                        pushSeriesOptions( self._setSerRecForm, overlay );
                    else
                        setRecording( self._setEpRecForm , overlay );
                };

                optParams = {
                    title    : "Recording Options",
                    button1  : { text:"Just This Episode", key:'episode' },
                    button2  : { text:"All Episodes"     , key:'series'  },
                    callback : function(option){ optCallback(option, optOverlay) }
                };

                optOverlay = new TwoOptionsOverlay().init( optParams );
                _x2.pushOverlay( optOverlay );
            }
            else if( this._setEpRecForm )
                setRecording( this._setEpRecForm );
            else if( this._setSerRecForm )
                pushSeriesOptions( this._setSerRecForm );
            else
                console.log( "ERROR - there are no recording options. Recording button should not appear.")
        }
    };

    EntityActionButtonsWidget.prototype.selectRecordingOptions = function()
    {
        var self   = this,
            entity = ( this._entity instanceof Showing ? this._entity.getEntity() : this._entity ),

            canModEp  = ( undefined !== ( this._modEpRecForm  || this._delEpRecForm     ) ),
            canModSer = ( undefined !== ( this._modSerRecForm || this._cancelSerRecForm ) ),
            canSetEp  = ( undefined !== this._setEpRecForm && canModEp === false ),
            canSetSer = ( undefined !== this._setSerRecForm ),

            hasEpisodeOption = ( canSetEp  || canModEp  ),
            hasSeriesOption  = ( canSetSer || canModSer ),

            setEpisodeButton    = this._setEpRecForm     ? { text:this._setEpRecForm.getTitle()    , key:{ type:'episode' , op:'set'    , form:this._setEpRecForm     } } : undefined,
            modEpisodeButton    = this._modEpRecForm     ? { text:this._modEpRecForm.getTitle()    , key:{ type:'episode' , op:'mod'    , form:this._modEpRecForm     } } : undefined,
            deleteEpisodeButton = this._delEpRecForm     ? { text:this._delEpRecForm.getTitle()    , key:{ type:'episode' , op:'delete' , form:this._delEpRecForm     } } : undefined,
            cancelEpisodeButton = this._cancelEpRecForm  ? { text:this._cancelEpRecForm.getTitle() , key:{ type:'episode' , op:'cancel' , form:this._cancelEpRecForm  } } : undefined,
            setSeriesButton     = this._setSerRecForm    ? { text:this._setSerRecForm.getTitle()   , key:{ type:'series'  , op:'set'    , form:this._setSerRecForm    } } : undefined,
            modSeriesButton     = this._modSerRecForm    ? { text:this._modSerRecForm.getTitle()   , key:{ type:'series'  , op:'mod'    , form:this._modSerRecForm    } } : undefined,
            cancelSeriesButton  = this._cancelSerRecForm ? { text:this._cancelSerRecForm.getTitle(), key:{ type:'series'  , op:'cancel' , form:this._cancelSerRecForm } } : undefined;

        //show a recording options overlay and submit form with choices.
        var presentOptionsForm = function( form )
        {
            var submitOptionsForm = function()
            {
                var success = function()
                {
                    _x2._hi.fadeOut(0);
                    self.refresh( self.getRecordingRefreshParams( form ) );
                    _x2.pushOverlay( new MessageOverlay().init( { message:"Recording Updated" } ) );

                    if( formOverlay )
                        _x2.popOverlay( formOverlay );
                };

                var error = function( error )
                {
                    _x2._hi.fadeOut(0);
                    self._distractor.hide();
                    _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.DVR } ) );

                    if( formOverlay )
                        _x2.popOverlay( formOverlay );
                };

                self._distractor.show();
                form.submit().then(success).catch(error);
            };

            var formParams = {
                entity   : entity,
                form     : form,
                callback : submitOptionsForm
            };

            var formOverlay = new RecordingOptionsOverlay().init( formParams );
            _x2.pushOverlay( formOverlay );
        };

        //delete or cancel a recording
        var removeRecording = function( option )
        {
            var form = option.form,
                successMessage = ( option.op === 'delete' ? "Recording Deleted" : "Recording Cancelled" );

            var onSuccess = function()
            {
                self.refresh( self.getRecordingRefreshParams( form ) );
                _x2.pushOverlay( new MessageOverlay().init( { message:successMessage } ) );
            };

            var onError = function( error )
            {
                self._distractor.hide();
                _x2.pushOverlay( new ErrorOverlay().init( { context:ErrorOverlay.Context.DVR, error:error } ) );
            };

            self._distractor.show();
            form.submit().then( onSuccess ).catch( onError );
        };

        //handle presenting one of the 6 forms
        var onOptionSelected = function( option, popOverlay )
        {
            switch(  option.op )
            {
                case 'set':
                    self.selectRecord( option.form );
                    break;
                case 'mod':
                    presentOptionsForm( option.form );
                    break;
                case 'cancel':
                case 'delete':
                    removeRecording( option );
            }

            if( popOverlay )
                _x2.popOverlay( popOverlay );
        };

        //handle choosing between mod and delete
        var onTypeSelected = function( type, popOverlay )
        {
            var optionParams,
                optionOverlay,
                entityRemoveButton = ( self._cancelEpRecForm ? cancelEpisodeButton : deleteEpisodeButton ),
                option1 = ( type === 'series') ? cancelSeriesButton : entityRemoveButton,
                option2 = ( type === 'series') ? modSeriesButton    : modEpisodeButton,
                optionsTitle;

            if( type === 'series' )
                optionsTitle = "Modify Series Recording";
            else
                optionsTitle = "Modify Recording";

            optionParams = {
                title    : optionsTitle,
                button1  : option1,
                button2  : option2,
                callback : function( option ){ onOptionSelected( option, optionOverlay ) }
            };
            optionOverlay = new TwoOptionsOverlay().init( optionParams );

            _x2.pushOverlay( optionOverlay );

            if( popOverlay )
                _x2.popOverlay( popOverlay )
        };

        //begin option (set/mod/delete) and type (episode/series) decision
        if( hasEpisodeOption && hasSeriesOption )
        {
            var typeSelector,
                typeOverlay,
                typeParams,
                type1 = ( canSetEp  ? setEpisodeButton : modEpisodeButton ),
                type2 = ( canSetSer ? setSeriesButton  : modSeriesButton  );

            typeSelector = function( option )
            {
                if( option.op === 'set' )
                    onOptionSelected( option, typeOverlay );
                else
                    onTypeSelected( option.type, typeOverlay );
            };

            typeParams = {
                title    : "Record Options",
                button1  : type1,
                button2  : type2,
                callback : typeSelector
            };
            typeOverlay = new TwoOptionsOverlay().init( typeParams );

            _x2.pushOverlay( typeOverlay );
        }
        else if( canModEp )
            onTypeSelected( 'episode' );
        else if( canModSer )
            onTypeSelected( 'series' );
    };

    EntityActionButtonsWidget.prototype.selectEpisodes = function()
    {
        _x2.pushScreen( new EpisodesScreen().init( { entity: this._entity } ) );
    };

    EntityActionButtonsWidget.prototype.selectInfo = function()
    {
        var entity = this._entity instanceof Showing ? this._entity.getEntity() : this._entity;
        _x2.pushScreen( new EntityScreen().init( { entity:entity } ) );
    };

    EntityActionButtonsWidget.prototype.selectResume = function()
    {
        var rp;

        if( this._entity instanceof Entity )
            rp = this._entity.getEntityOptions().getResumePoint();
        else
            rp = this._entity.getResumePoint();

        this.selectWatch( rp );
    };

    EntityActionButtonsWidget.prototype.selectSeriesInfo = function( seriesId )
    {
        this._refreshResumePointsOnFocus = true;
        var browseEntity = new BrowseEntity().init( { entityId:seriesId } );
        _x2.pushScreen( new EntityScreen().init( { entity:browseEntity } ) );
    };

    EntityActionButtonsWidget.prototype.selectStartOver = function()
    {
        //NOTE: we want to play the showing associated with the resume point, so pass that resume point (with embedded showing) after setting position to 0
        var resumePoint;

        if( this._entity instanceof Entity )
            resumePoint = this._entity.getEntityOptions().getResumePoint();
        else
            resumePoint = this._entity.getResumePoint();

        if( resumePoint )
            resumePoint.setPosition(0);

        this.selectWatch( resumePoint );
    };

    EntityActionButtonsWidget.prototype.selectUpcoming = function()
    {
        _x2.pushScreen( new UpcomingScreen().init( { entity:this._entity } ) );
    };

    EntityActionButtonsWidget.prototype.selectErase = function()
    {
        var self = this;
        var success = function()
        {
            self._distractor.hide();
            _x2.pushOverlay( new MessageOverlay().init( { message:"Recording was erased", onDismiss:function(){ _x2.popScreen() } } ) );
        };

        var error = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.DVR } ) );
        };

        this._distractor.show();
        this._menuWidget.setDisabled( true );
        this._entity.erase().then( success ).catch( error )
    };

    EntityActionButtonsWidget.prototype.selectRecover = function()
    {
        var self = this;
        var success = function()
        {
            self._distractor.hide();
            _x2.pushOverlay( new MessageOverlay().init( { message:"Recording was recovered", onDismiss:function(){ _x2.popScreen() } } ) );
        };

        var error = function(error)
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.DVR } ) );
        };

        this._distractor.show();
        this._menuWidget.setDisabled( true );
        this._entity.undelete().then( success ).catch( error );
    };

    EntityActionButtonsWidget.prototype.selectSubscribe = function()
    {
        var offer = this._entity.getEntityOptions().getSubscribeOffer();
        _x2.pushOverlay( new SubscribeOverlay().init( offer ) )
    };

    EntityActionButtonsWidget.prototype.onFavoriteChanged = function(changedStatus)
    {
        var self = this;

        var onRefresh = function()
        {
            self._distractor.hide();
            if( self._isChannel ) {
                self._entity._channel.isFavorite = changedStatus;
                self.setData( { entity: self._entity, isChannel: true });
            } else {
                self.setData();
            }
            
            if( self._refreshListener ) {
                self._refreshListener( self._entity );
            }
        };

        _x2.refreshFavorites().then( onRefresh );
    };

    EntityActionButtonsWidget.prototype.setFavorite = function()
    {
        var self   = this;
        var object = this._isChannel ? this._channel : this._entity;

        var fail = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON } ) );
        };

        this._distractor.show();

        _x2._favorites.addFavorite( object ).then( function () { _x2.localyticsSendFavoriteEntityOrViewed( self._entity, "Add" ); self.onFavoriteChanged(1) } ).catch( fail );
    };

    EntityActionButtonsWidget.prototype.removeFavorite = function()
    {
        var self = this;
        var object = this._isChannel ? this._channel : this._entity;

        var fail = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON } ) );
        };

        var success = function()
        {
            self.onFavoriteChanged(0);

            _x2.localyticsSendFavoriteEntityOrViewed( self._entity, "Remove" );
        };

        this._distractor.show();

        _x2._favorites.removeFavorite( object ).then( success ).catch( fail );
    };

    /**
     * @param [params]
     * @param [params.entity]     {Entity | Showing} - Pass either a Entity or a Showing type [LinearShowing, VodShowing, Recording]
     * @param [params.channel]    {Channel}
     * @param [params.infoButton] {Boolean} - Include "Movie Info" or "Series Info" button.
     * @param [params.isChannel]  {Boolean} - Are the buttons associated with a channel
     */
    EntityActionButtonsWidget.prototype.setData = function( params )
    {
        var self        =  this,
            buttonStyle = new Style( { font:"light", color:"#e8e8e8", fontSize:_x2.scaleValInt( 30 ), whiteSpace:"nowrap", colorHi:"#000000" } ),
            buttons     = [],
            entity,
            options,
            showing,
            type,
            isWatchable,
            isCheckedOut,
            hasResumePoint,
            hasMultipleShowings,
            hasUpcomingListings,
            hasBuyOption,
            hasRentOption,
            hasSubscribeOption,
            isFavorite,
            isFavoriteable,
            seriesId,
            episodeRecording,
            seriesRecording;

        this._setEpRecForm     = undefined;
        this._modEpRecForm     = undefined;
        this._delEpRecForm     = undefined;
        this._cancelEpRecForm  = undefined;
        this._eraseEpRecForm   = undefined;
        this._undelEpRecForm   = undefined;
        this._setSerRecForm    = undefined;
        this._modSerRecForm    = undefined;
        this._cancelSerRecForm = undefined;

        if( params )
        {
            this._entity     = params.entity;
            this._channel    = params.channel || params.entity._channel || ( params.entity && params.entity.getChannel && params.entity.getChannel() );
            this._infoButton = params.infoButton;
            this._isChannel  = params.isChannel;
        }
        if( this._entity instanceof Recording )
        {
            isCheckedOut  = this._entity.isCheckedOut();
            this._eraseEpRecForm = this._entity.getEraseForm();
            this._undelEpRecForm = this._entity.getUndeleteForm();
        }

        if( this._entity instanceof Showing )
        {
            showing = this._entity;
            entity  = this._entity.getEntity();

            hasResumePoint = showing.getMinsRemaining() > 0;
            isWatchable    = showing.isWatchable();

            if( showing instanceof LinearShowing )
            {
                seriesRecording = showing.getSeriesRecording();

                if( showing instanceof Recording )
                    episodeRecording = showing;
                else
                    episodeRecording = showing.getRecording();

                if( episodeRecording )
                {
                    this._modEpRecForm = episodeRecording.getModifyForm();
                    this._delEpRecForm = episodeRecording.getDeleteForm();
                    this._cancelEpRecForm = episodeRecording.getCancelForm();
                }
                else
                    this._setEpRecForm = showing.getEpisodeRecordingForm();

                if( seriesRecording )
                {
                    this._setSerRecForm    = seriesRecording.getScheduleForm();
                    this._modSerRecForm    = seriesRecording.getModifyForm();
                    this._cancelSerRecForm = seriesRecording.getCancelForm();
                }
            }
        }
        else if( this._entity instanceof Entity )
        {
            entity              = this._entity;
            options             = entity.getEntityOptions();
            seriesRecording     = entity.getEntityRecording();
            hasResumePoint      = options.getMinsRemaining() > 0;
            hasMultipleShowings = options.getVodShowings().length > 1;
            hasUpcomingListings = options.getUpcomingListings().length > 0;
            hasBuyOption        = options.hasBuyOption();
            hasRentOption       = options.hasRentOption();
            hasSubscribeOption  = options.hasSubscribeOption();
            isWatchable         = options.isWatchable();

            if( seriesRecording )
            {
                this._modSerRecForm    = seriesRecording.getModifyForm();
                this._cancelSerRecForm = seriesRecording.getCancelForm();
            }

            this._setSerRecForm = options.getSeriesRecordingForm();
        }

        var hasRecordingOptions      = ( undefined !== ( this._setEpRecForm || this._setSerRecForm ) );
        var hasModRecordingOptions   = ( undefined !== ( this._modEpRecForm || this._modSerRecForm || this._delEpRecForm || this._cancelEpRecForm || this._cancelSerRecForm ) );
        var hasEraseRecordingOptions = ( undefined !== this._eraseEpRecForm );

        type     = entity && entity.getType();
        seriesId = entity && entity.getSeriesId();

        if( type === XtvApi.EntityType.SERIES && options )
        {
            if( options.getEpisodeCount() > 0 || options.getSeasonCount() > 0 )
                buttons.push( new StringWidget().init( { text: "Episodes", style: buttonStyle, onEnter: function() { self.selectEpisodes() } } ) );
        }

        if( _x2._config._isChurned === true )
        {
            isFavorite     = false;
            isFavoriteable = false;

        }
        else if( this._isChannel )
        {
            //Update favorite from local cache, since user might open channel info immediately, after change the favorite status
            isFavorite = this._channel.isFavorite > -1 ? !!this._channel.isFavorite : _x2._favorites.isFavorite( this._channel );
            isFavoriteable = true;
        }
        else
        {
            if( this._entity instanceof LinearShowing === false &&
                this._entity instanceof Purchase      === false &&
                this._entity instanceof Rental        === false   )
            {
                isFavorite = _x2._favorites.isFavorite( entity );
                isFavoriteable = ( type === XtvApi.EntityType.SERIES || type === XtvApi.EntityType.MOVIE ); // || type === XtvApi.EntityType.OTHER );
                // NOTE: not sure what 'OTHER' is supposed to cover here but it's causing sporting events to incorrectly be favorite-able.
                // Considering that favorites are segmented into TV Shows, Movies and Teams, we should be covered. (SportsTeamScreen does not use this)
            }
        }

        if( ! isCheckedOut )
        {
            if( isWatchable )
            {
                if( hasResumePoint )
                {
                    buttons.push( new StringWidget().init( { text: "Resume", style: buttonStyle, onEnter: function(){ self.selectResume() } } ) );
                    buttons.push( new StringWidget().init( { text: "Start Over", style: buttonStyle, onEnter: function(){ self.selectStartOver() } } ) );

                    if( hasMultipleShowings )
                        buttons.push( new StringWidget().init( { text: "Watch Options", style: buttonStyle, onEnter: function() { self.selectWatch(); } } ) );
                }
                else
                    buttons.push( new StringWidget().init( { text: "Watch", style: buttonStyle, onEnter: function() { self.selectWatch(); } } ) );
            }
        }

        if( hasBuyOption || hasRentOption )
        {
            var hasBuyAndRent = hasBuyOption && hasRentOption;
            var label = hasBuyAndRent ? "Rent/Buy" : ( hasBuyOption ? "Buy" : "Rent" );
            var metricsTransactionalButtonClicked =
            {
                "Initial Button Clicked": hasBuyAndRent ? "rent/buy" : (hasBuyOption ? "buy" : "rent"),
                "Initial Source"        : "Entity Button",
                "Program Type"          : (type === XtvApi.EntityType.EPISODE || type === XtvApi.EntityType.SERIES)
                                            ? "Series"
                                            : (type === XtvApi.EntityType.MOVIE)
                                                ? "Movie"
                                                : (type === XtvApi.EntityType.SPORTS || type === XtvApi.EntityType.TEAM)
                                                    ? "Sporting Event"
                                                    : "Other"
            };

            buttons.push( new StringWidget().init( { text: label, style: buttonStyle, onEnter: function() { window.ll( "tagEvent", "Transactional Button Clicked", metricsTransactionalButtonClicked ); self.selectBuyRent(); } } ) ); }

        if( hasSubscribeOption )
            buttons.push( new StringWidget().init( { text: "Subscribe", style: buttonStyle, onEnter: function() { self.selectSubscribe() } } ) );

        if( this._eraseEpRecForm !== undefined )
            buttons.push( new StringWidget().init( { text: "Erase", style: buttonStyle, onEnter: function() { self.selectErase() } } ) );

        if( this._undelEpRecForm !== undefined )
            buttons.push( new StringWidget().init( { text: "Recover", style: buttonStyle, onEnter: function() { self.selectRecover() } } ) );

        if( ! hasEraseRecordingOptions )
        {
            if( hasModRecordingOptions )
                buttons.push( new StringWidget().init( { text: "Recording Options", style: buttonStyle, onEnter: function(){ self.selectRecordingOptions() } } ) );
            else if( hasRecordingOptions )
                buttons.push( new StringWidget().init( { text: "Record", style: buttonStyle, onEnter: function(){ self.selectRecord() } } ) );

            if( hasUpcomingListings )
                buttons.push( new StringWidget().init( { text: "Upcoming", style: buttonStyle, onEnter: function(){ self.selectUpcoming() } } ) );

            if( this._infoButton === true && this._isChannel !== true && _x2._config._isChurned !== true )  // TODO: blocking channel info, need to add support for it
            {
                if( type === XtvApi.EntityType.EPISODE )
                {
                    if( seriesId )
                        buttons.push( new StringWidget().init( { text: "Series Info", style: buttonStyle, onEnter: function(){ self.selectSeriesInfo(seriesId) } } ) );
                }
                else if( type === XtvApi.EntityType.MOVIE )
                    buttons.push( new StringWidget().init( { text: "Movie Info", style: buttonStyle, onEnter: function(){ self.selectInfo() } } ) );
                else
                    buttons.push( new StringWidget().init( { text: "More Info", style: buttonStyle, onEnter: function(){ self.selectInfo() } } ) );
            }
        }
        if( isFavoriteable )
        {
            if( isFavorite )
            {
                if( !_x2._telemetry._watchButtonPath.length && !this._sentViewed ) // Any location aside from favorites will have an first entry "Browse: TV", "Search", etc.
                {
                    _x2.localyticsSendFavoriteEntityOrViewed( this._entity, "Viewed" );
                    this._sentViewed = true;
                }

                buttons.push( new StringWidget().init( { text: "Remove Favorite", style: buttonStyle, onEnter: function(){ self.removeFavorite() } } ) );
            }
            else
                buttons.push( new StringWidget().init( { text: "Favorite", style: buttonStyle, onEnter: function(){ self.setFavorite() } } ) );
        }

        if( _x2._pc.isEnabled() )
        {
            var isLocked, channelId, entityId, title, toggleLock;

            toggleLock = function()
            {
                var params = {}, onValidatePin, overlay, toPop, onSet, onError;

                onValidatePin = function( validatePinStr )
                {
                    if( _x2._pc.checkPin( validatePinStr ) === true )
                    {
                        onSet = function()
                        {
                            self._lockButton.setText( isLocked ? "Unlock" : "Lock" );
                            self._menuWidget.layout();

                            if( self._refreshListener )
                                self._refreshListener( self._entity );
                        };

                        onError = function(error)
                        {
                            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON } ) );
                        };

                        isLocked = !isLocked;

                        _x2.popOverlay( overlay );

                        if( self._isChannel === true )
                             _x2._pc.setChannelLocks( channelId, isLocked );
                        else
                            _x2._pc.setTitleLock( entityId, title, isLocked );

                        _x2._data.setParentalControlsSettings( _x2._pc ).then( onSet ).catch( onError );
                    }
                    else
                    {
                        toPop       = overlay;
                        params.type = PinOverlay.Type.PC_VALIDATE_FAIL;
                        _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                        _x2.popOverlay( toPop );
                    }
                };

                params.type      = PinOverlay.Type.PC_VALIDATE;
                params.onCapture = onValidatePin;
                _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
            };

            if( this._isChannel === true )
            {
                channelId = this._channel.getId();
                isLocked  = _x2._pc.isChannelLocked( channelId );
            }
            else
            {
                entityId = entity.getEntityId();
                title    = entity.getTitle();
                isLocked = _x2._pc.isTitleLocked( entityId );
            }

            this._lockButton = new StringWidget().init({ text:isLocked ? "Unlock" : "Lock", style:buttonStyle, onEnter:toggleLock } );
            buttons.push( this._lockButton );
        }

        if( buttons.length )
        {
            this._menuWidget.setButtons( buttons );
            this._menuWidget.setA(1);
//            this._menuReady = true;
        }
    };

    /**
     * Register a callback to receive an updated entity when some action (setting/deleting a recording)
     * triggers a change to the entity state.
     * @param callback - passes the updated entity
     */
    EntityActionButtonsWidget.prototype.setRefreshListener = function( callback )
    {
        this._refreshListener = callback;
    };

    return EntityActionButtonsWidget;

})();


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.EpisodeRowWidget = ( function()
{
    "use strict";

    EpisodeRowWidget.prototype = new ListRowWidget();

    function EpisodeRowWidget(){}

    EpisodeRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );

        this._title.gotFocus();
        this._sep.setSpeechParams( this._title.getText().replace( /^Ep([\d])/, "Episode $1" ) + ". Press OK to select. ", undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof EpisodeRowWidget
     * @param   {Object} params
     * @param   {Number} params.w - Width
     * @returns {EpisodeRowWidget}
     * @see ListRowWidget
     */
    EpisodeRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );

        this._className = "EpisodeRowWidget";

        var self = this;
        var titleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );

        this._numElements = 0;
        this._selectable  = true;
        this._maxH        = Math.floor( this.getHeightUnfocused() / 2 );
        this._maxW        = Math.floor( this._maxH * 5 / 3 );

        this._title = new StringWidget().init( { text:"?", style:titleStyle } );
        this._title.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._title );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    EpisodeRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 132 );
    };

    EpisodeRowWidget.prototype.layout = function()
    {
        this._title.setY( (this.getHeightUnfocused() - this._title.getH()) / 2 );
    };

    EpisodeRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._title.lostFocus();
    };

    EpisodeRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            _x2.pushScreen( new EpisodeScreen().init( { entity: this._entity } ) );
            retval = true;
        }

        return retval;
    };

    /**
     * @memberof EpisodeRowWidget
     * @param {Entity | Recording} data
     */
    EpisodeRowWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._entity = data;

            var title = "";
            var program = data instanceof Entity ? data : data.getProgram();

            if( program )
            {
                var epNumber = program.getEpisodeNumber();
                if( epNumber !== undefined )
                    title += "Ep" + epNumber + " - ";

                //don't duplicate if the series and episode titles are the same (common with news/talk shows)
                if( title.indexOf(program.getTitle()) === -1 )
                    title += program.getTitle();
            }
            else
                title = data.getTitle();

            this._title.setText(title);
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return EpisodeRowWidget;

})();


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.FindChannelRowWidget = ( function()
{
    "use strict";

    FindChannelRowWidget.prototype = new ListRowWidget();

    function FindChannelRowWidget(){}

    FindChannelRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 129 * _x2._config._text );
    };

    FindChannelRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        if( losingFocus instanceof FindChannelRowWidget )
            this._leftFocus = losingFocus._leftFocus;

        Widget.prototype.gotFocus.call( this );
        this.setHighlight();

        if( this._leftFocus === false )
            this._playIcon.gotFocus();
        else
            this._chanStr.gotFocus();
//             this._name.gotFocus();

        this.speak( newScreen);

        return this;
    };

    /**
     * Initializer
     * @memberof FindChannelRowWidget
     * @param   {Object}    params
     * @param   {Object}    params.obj - The guide screen that led this overlay so the selection cn be returned
     * @param   {Number}    params.w   - Width of the list
     * @returns {FindChannelRowWidget}
     * @see ListRowWidget
     */
    FindChannelRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className   = "FindChannelRowWidget";
        this._selectable  = true;
        this._numElements = 0;
//         this._maxLogoH    = parseInt( this.getHeightUnfocused() / 2 );
//         this._maxLogoW    = parseInt( this._maxLogoH * 5 / 3 );
        this._maxLogoH    = _x2.scaleValInt( 72 );
        this._maxLogoW    = _x2.scaleValInt( 72 );
        this._leftFocus   = true;
        this._controller  = params.obj;

        var self      = this, layout, onLogoLoaded;
//        var nameStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var chanStyle = new Style( { color:"#a3a3a3", font:"medium"  , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var onReady   = function() { self._numElements++; layout(); };

        layout = function()
        {
            if( self._numElements === 2 )
            {
//                var x = self._chanStr.getX() + self._chanStr.getW() + 3 * Style._pad;

//                self._sep.setX( x );
//                self._name.setX( x + self._sep.getW() + 3 * Style._pad );
                self._playIcon.setX( params.w - self._playIcon.getW() - _x2.scaleValInt( 36 ) );
                self._sep.setX( self._playIcon.getX() - _x2.scaleValInt( 36 ) );

                self._chanStr.setY( (self.getHeightUnfocused() - self._chanStr.getH()) / 2 );
//                self._name.setY( (self.getHeightUnfocused() - self._name.getH()) / 2 );
                self._playIcon.setY( (self.getHeightUnfocused() - self._playIcon.getH()) / 2 );

                self._focusSplit = self._sep.getX();
            }
        };

        onLogoLoaded = function()
        {
            var dw, dh, scale;
            var w = self._logo.getW();
            var h = self._logo.getH();

            if( w > 0 && h > 0 )
            {
                dw    = self._maxLogoW / w;
                dh    = self._maxLogoH / h;
                scale = ( dh < dw ) ? dh : dw;

                self._logo.setX( (self._maxLogoW            - self._logo.getW()) / 2 );
                self._logo.setY( (self.getHeightUnfocused() - self._logo.getH()) / 2 );
                self._logo.setScale( scale );
                self._logo.setA( 1 );
            }
        };

        this._logo = new ImageWidget().init( { onChange:onLogoLoaded } );
        this.addWidget( this._logo );

        this._chanStr = new StringWidget().init( { text:"0000", style:chanStyle } );
        this._chanStr.addReadyCallback( onReady );
        this.addWidget( this._chanStr, this._maxLogoW + _x2.scaleValInt( 62 ) );

        this._sep = new RectWidget().init( { w:ListRowWidget.DIVIDER_H, h:this.getHeightUnfocused(), color:"#262626" } );
        this.addWidget( this._sep );

//         this._name = new StringWidget().init( { text:"???????", style:nameStyle } );
//         this._name.addReadyCallback( onReady );
//         this.addWidget( this._name );

        this._playIcon = new DualImageWidget().init( { url:_x2._config._imageRoot + "Play-icon-min.png", urlHi:_x2._config._imageRoot + "Play-focus-state-icon-min.png" } );
        this._playIcon.addReadyCallback( onReady );
        this.addWidget( this._playIcon );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    FindChannelRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );

        if( this._leftFocus === false )
            this._playIcon.lostFocus();
        else
            this._chanStr.lostFocus();
//             this._name.lostFocus();
    };

    FindChannelRowWidget.prototype.processEvent = function( val, type )
    {
        var retval, self = this;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._leftFocus === true )
                        this._controller.setJumpToChannel( this._data );
                    else
                    {
                        var doTune = function()
                        {
                            self._controller.setTuneToChannel( self._data );
                        };

                        var i, schedules = this._data.getSchedules(), now = new Date().getTime();

                        if( schedules )
                                for( i = 0; i < schedules.length; i++ )
                                    if( schedules[i].getEndTime() > now )
                                        break;

                        if( _x2._pc.isEnabled() === true )
                            _x2.checkParentalControls( schedules ? schedules[i] : undefined, undefined, this._data ).then( function() { doTune( self._data, schedules[i] ); } );
                        else
                            doTune( this._data, schedules[i] );
                    }

                    retval = true;
                }
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED && this._leftFocus === false )
                {
                    this._leftFocus = true;
                    this._playIcon.lostFocus();
                    this._chanStr.gotFocus();
//                    this._name.gotFocus();
                    this.setHighlight();
                    this.speak();
                    retval = true;
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED && this._leftFocus === true )
                {
                    this._leftFocus = false;
                    this._playIcon.gotFocus();
                    this._chanStr.lostFocus();
//                    this._name.lostFocus();
                    this.setHighlight();
                    this.speak();
                    retval = true;
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    /**
     * @memberof FindChannelRowWidget
     * @param {Channel} [data]
     */
    FindChannelRowWidget.prototype.setData = function( data )
    {
        this._data = data;

        if( data !== undefined )
        {
            this._chanStr.setText( data.getNumber() );
//            this._name.setText( data.getCallSign() );
            this._logo.setA( 0 );
            this._logo.setW();
            this._logo.setH();
            this._logo.setUrl( data.getLogoUrl(50,30) );  // TODO what is the right size???
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    FindChannelRowWidget.prototype.setHighlight = function( time, h )
    {
        var obj = this.getGlobalPos();

        if( this._leftFocus !== true )
            obj.x += this._focusSplit;

        obj.w        = (this._leftFocus === true) ? this._focusSplit : this.getVal( Widget.W ) - this._focusSplit;
        obj.h        = (h === undefined) ? this.getHeightUnfocused() - ListRowWidget.DIVIDER_H : h;
        obj.inner    = false;
        obj.duration = (time === undefined) ? ListWidget.SCROLL_TIME_STEP : time;

        _x2._hi.setPosition( obj );
    };

    FindChannelRowWidget.prototype.speak = function( newScreen )
    {
        if( this._leftFocus === false )
            this._chanStr.setSpeechParams( "Press OK to tune.", undefined, this, newScreen );
        else
            this._chanStr.setSpeechParams( "Press OK to go to in the grid.", undefined, this, newScreen );
    };

    return FindChannelRowWidget;

})();


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GalleryCellWidget = ( function()
{
    "use strict";

    GalleryCellWidget.prototype = new CollectionCellWidget();

    function GalleryCellWidget(){}

    /*
     * @params {Object} params TODO:
     */
    GalleryCellWidget.prototype.init = function( params )
    {
        var self = this;
        var titleStyle          = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var subTitleStyle       = new Style( { color:"#a3a3a3", font:"regular", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
        var posterTitleStyle    = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"center" } );
        var posterSubTitleStyle = new Style( { color:"#a3a3a3", font:"regular", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } );

        if( params.style === XtvApi.EntityRenderStyle["16X9_PROGRAM"] )
        {
            this._srcImageW = _x2.scaleValInt( 480 );
            this._srcImageH = _x2.scaleValInt( 270 );

            this._imageW = params.bgW = this._srcImageW * 0.85;
            this._imageH = params.bgH = this._srcImageH * 0.85;
        }
        else
        {
            this._srcImageW = _x2.scaleValInt( 270 );
            this._srcImageH = _x2.scaleValInt( 360 );

            if( params.collectionType === 'grid' )
            {
                this._imageW = params.bgW = _x2.scaleValInt( 324 );
                this._imageH = params.bgH = _x2.scaleValInt( 432 );
            }
            else
            {
                this._imageW = params.bgW = this._srcImageW;
                this._imageH = params.bgH = this._srcImageH;
            }
        }

        this._imageX = params.bgX     = _x2.scaleValInt( 18 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY     = (this._scale - 1) * this._imageH / 2;

        this._focusW = this._scale * this._imageW;
        this._focusH = this._scale * this._imageH;

        params.background = true;
        params.bgTextSize = _x2.scaleValInt(28);

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "GalleryCellWidget";

        var onImageChanged = function()
        {
            self._image.setA(1);
            self.hideBackground();
        };

        var onImageError = function()
        {
            if( self._data )
            {
                var fallback = self._data.getFallbackImageLink( self._imageW, self._imageH );

                if( self._image.getUrl() === fallback )
                    self._image.setA( 0 ); //fallback already tried. hide image.
                else
                    self._image.setUrl( fallback );
            }

            // AAECH-59
            //    Where   Screen        self =
            // 1. Search  SearchScreen  SearchEntity.
            // 2. LiveTV  GuideScreen   LinearShowing.getFallbackImageLink() -> getProgram().getFallbackImageLink()
            // self._image.setUrl( self._image.getUrl() + "&default=force" );
        };

        this._image = new ImageWidget().init( { w:this._imageW, h:this._imageH, onError:onImageError, onChange:onImageChanged } );
        this.addWidget( this._image, this._imageX, this._imageY );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._title.setA( 0 );

        this._subTitle = new StringWidget().init( { style:subTitleStyle } );
        this._subTitle.setA( 0 );

        this._posterText = new StringWidget().init( { style:posterTitleStyle } );
        this._posterText.setW( this._image.getW() );

        this._posterSubText = new StringWidget().init( { style:posterSubTitleStyle } );
        this._posterSubText.setW( this._image.getW() );

        this._tomatoWidget = new TomatoWidget().init( { noTitle:true, style:subTitleStyle } );
        this._tomatoWidget.setA( 0 );

        this.addWidget( this._title        , 0                  , this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 20 ) );
        this.addWidget( this._subTitle     , 0                  , this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 60 ) );
        this.addWidget( this._tomatoWidget , 0                  , this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 60 ) );
        this.addWidget( this._posterText   , this._imageX       , this._image.getH() * 2 / 3 );
        this.addWidget( this._posterSubText, this._imageX       , this._image.getH() * 2 / 3 + _x2.scaleValInt(38) );

        this._speakTarget = new StringWidget().init( { style:titleStyle } );
        this._speakTarget.setA( 0 );
        this.addWidget( this._speakTarget );

        return this;
    };

    GalleryCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 270 ) + _x2.scaleValInt( 18 );
    };

    GalleryCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 360 ) * (_x2.scaleValInt( 270 ) + 2 * _x2.scaleValInt( 18 )) / _x2.scaleValInt( 270 );
    };

    GalleryCellWidget.prototype.getIndex = function()
    {
        return this._index;
    };

    GalleryCellWidget.prototype.getPosAndDimUnfocused = function()
    {
        return { pos:this._imageY, dim:this._imageH };
    };

    GalleryCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        if( this._data )
        {
            this._speakTarget.setSpeechParams( undefined, undefined, this, newScreen );

            CollectionCellWidget.prototype.gotFocus.call( this );

            var poster = ( this._image._failed ? this._defaultImage : this._image );
            if( poster )
                poster.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

            if( this._posterText.getText() )
            {
                this._posterText.stopAnimation( Widget.X_SCALE );
                this._posterText.stopAnimation( Widget.Y_SCALE );
                this._posterText.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

                this._posterSubText.stopAnimation( Widget.X_SCALE );
                this._posterSubText.stopAnimation( Widget.Y_SCALE );
                this._posterSubText.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );
            }

            this._title.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
            this._subTitle.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );

            if( this._showTomatos )
                this._tomatoWidget.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        return this;
    };

    GalleryCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );

        this._title.stopAnimation( Widget.ALPHA );
        this._subTitle.stopAnimation( Widget.ALPHA );
        this._tomatoWidget.stopAnimation( Widget.ALPHA );

        var poster = ( this._image._failed ? this._defaultImage : this._image );
        if( poster )
        {
            poster.stopAnimation( Widget.X_SCALE );
            poster.stopAnimation( Widget.Y_SCALE );
            poster.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        if( this._posterText.getText() )
        {
            this._posterText.stopAnimation( Widget.X_SCALE );
            this._posterText.stopAnimation( Widget.Y_SCALE );
            this._posterText.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );

            this._posterSubText.stopAnimation( Widget.X_SCALE );
            this._posterSubText.stopAnimation( Widget.Y_SCALE );
            this._posterSubText.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        this._title.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
        this._subTitle.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
        this._tomatoWidget.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
    };

    //TODO (Entity Refactor) Document. What types can we pass here?
    GalleryCellWidget.prototype.setData = function( data, index )
    {
        this._showTomatos = false;
        this._background.setA(1);
        this._image.setA(0);

        var start, end, channel, separator = ", ", speechTitle, speechSubTitle = "", speechStr, timeStr, review, self = this, count, title;

        this._data = data;

        if( data !== undefined )
        {
            this._index = index;

            if( data.getMeta && data.getMeta().all === true )
            {
                this._image.setUrl( _x2._config._imageRoot + "view_all_tile.png" );

                this._title.setText("");
                this._subTitle.setText("");
                this._backgroundText.setText("");
                this._tomatoWidget.setA( 0 );

                this._posterText.setText( "View All" );
                this._posterSubText.setText( data.getTotalEntityCount() + " available" );

                speechTitle    = this._posterText.getText();
                speechSubTitle = data.getTotalEntityCount() + " available";
            }
            else
            {
                var remaining, subTitleElements = [];

                var setRemaining = function( comma )
                {
                    if( remaining )
                    {
                        //clear "Watched" when adding remaining (entity can be watched AND have min remaining)
                        subTitleElements = [];
                        speechSubTitle = "";

                        subTitleElements.push( remaining + " min left" + (comma ? ", " : "") );
                        speechSubTitle += remaining + " minutes left, ";
                    }
                };

                //try to get a Entity from the showing, but default back to data if not available
                var entity = ( data instanceof Showing ? data.getEntity() : data );
                if( ! entity )
                    entity = data;

                if( data.getMinsRemaining )
                    remaining = data.getMinsRemaining() > 0 ? data.getMinsRemaining() : undefined;

                if( data.isWatched && data.isWatched() )
                {
                    subTitleElements.push( "Watched, " );
                    speechSubTitle += subTitleElements[subTitleElements.length-1];
                }

                title = data.getTitle();

                if( entity.getType && entity.getType() === XtvApi.EntityType.EPISODE )
                {
                    var series = ( entity.getSeries ? entity.getSeries() : undefined );
                    if( series )
                    {
                        var ep = entity.getEpisodeNumber();
                        var se = entity.getSeasonNumber();

                        if( ep !== undefined && se !== undefined )
                            title = "S" + se + " Ep" + ep + " - " + entity.getTitle();
                    }
                }

                if( data instanceof Rental )
                {
                    separator = " ";
                    setRemaining( true );

                    subTitleElements.push( _x2.createExpiresString( data.getExpires() ) );
                    speechSubTitle += _x2.createExpiresSpeechString( data.getExpires() );
                }
                else if( data instanceof PurchaseGroup )
                {
                    if( data.getEpisodeCount() > 1 )
                    {
                        count = data.getEpisodeCount();

                        subTitleElements.push( count + ( count === 1 ? " Episode" : " Episodes" ) );
                        speechSubTitle += subTitleElements[subTitleElements.length-1];
                    }
                    else
                    {
                        separator = " ";
                        var purchase      = data.getPurchases()[0];
                        var purchasedDate = _x2.createDateStr( data.getPurchasedOnDate() );
                        var purchasedOn   = "Purchased " + ( purchase.isHD() ? " HD " : " SD " );

                        if( purchase.getMinsRemaining )
                            remaining = purchase.getMinsRemaining() > 0 ? purchase.getMinsRemaining() : undefined;

                        setRemaining( true );

                        if( purchasedDate.indexOf('/') > 0 )
                            purchasedOn += " on ";

                        purchasedOn += purchasedDate;

                        subTitleElements.push( purchasedOn );
                        speechSubTitle += subTitleElements[subTitleElements.length-1];

                        if( purchase.getYear() && purchase.getType() === "Movie" )
                            subTitleElements.push("(" + purchase.getYear() + ")");

                        review = data.getRottenTomatoReview();
                        if( review )
                        {
                            if( review.isValid() )
                            {
                                if( review.getFanSummaryScore() > 0 || review.getCriticSummaryScore() > 0 )
                                    subTitleElements.push("|");

                                this._tomatoWidget.setData( review );
                                this._tomatoWidget.setX( _x2.scaleValInt(278) );
                                this._showTomatos = true;

                                speechSubTitle += ", " + this._tomatoWidget.getSpeechStr();
                            }
                        }
                    }
                }
                else if( data instanceof Recording )
                {
                    setRemaining();

                    switch (data.getRecordingStatus())
                    {
                        case "COMPLETE":
                            start   = data.getRecordedOnDate();
                            end     = new Date( start.getTime() + data.getDurationMs() );
                            timeStr = _x2.createTimeRange( start, end );

                            subTitleElements.push( "Recorded " + _x2.createDateStr(start) + " " + timeStr );
                            speechSubTitle += "Recorded " + _x2.createDateStr(start) + ", " + _x2.createTimeSpeechStr( timeStr );
                            break;

                        case "STARTED":
                            channel = data.getChannel();

                            if( channel )
                            {
                                subTitleElements.push( "Recording Now on " + channel.getNumber() + " " + channel.getCallSign() );
                                speechSubTitle += "Recording Now on channel " + channel.getNumber() + ", " + channel.getCallSign();
                            }
                            else
                            {
                                subTitleElements.push( "Recording Now" );
                                speechSubTitle += subTitleElements[subTitleElements.length-1];
                            }

                            break;
                    }
                }
                else if( data.getStartTime && data.getStartTime() ) //else if( data instanceof LinearShowing ) //NOTE: in the case of a deep linked folder a browse entity can also represent a linear showing.
                {
                    var now, when, rating;

                    separator = " ";

                    now   = new Date();
                    start = new Date( parseInt( data.getStartTime() ));
                    end   = new Date( parseInt( data.getEndTime() ));

                    channel = data.getChannel ? data.getChannel() : undefined;
                    rating  = data.getRating  ? data.getRating()  : undefined;

                    if( start.getTime() < now.getTime() && end.getTime() > now.getTime() )
                    {
                        when = "On now";
                        speechSubTitle += when + " ";
                    }
                    else if( now.getDate() === start.getDate() )
                    {
                        when = "Airs today";
                        speechSubTitle += when + " ";
                    }
                    else
                    {
                        when = _x2.createDateStr(start);
                        speechSubTitle += when + " ";
                    }

                    subTitleElements.push( when );
                    subTitleElements.push( _x2.createTimeRange( start, end ) );
                    speechSubTitle += _x2.createTimeSpeechStr( subTitleElements[subTitleElements.length-1] );

                    if( channel )
                    {
                        subTitleElements.push( "on");
                        subTitleElements.push( channel.getNumber() );
                        subTitleElements.push( channel.getCallSign() );
                        speechSubTitle += " on channel " + channel.getNumber() + ", " + channel.getCallSign();
                    }
                    else if( data.getCallSign && data.getCallSign() )
                    {
                        subTitleElements.push( "on");
                        subTitleElements.push( data.getCallSign() );
                        speechSubTitle += " on " + data.getCallSign();
                    }

                    speechSubTitle += ". ";

                    if( rating )
                    {
                        subTitleElements.push( Strings.Glyphs[rating] );
                        speechSubTitle += "Rating " + rating + ". ";
                    }

                    if( channel && channel.isHD() )
                    {
                        subTitleElements.push( Strings.Glyphs.HD );
                        speechSubTitle += "HD available . ";
                    }

                    if( data.isSap && data.isSap() )
                    {
                        subTitleElements.push( Strings.Glyphs.SAP );
                        speechSubTitle += "Secondary audio available. ";
                    }

                    if( data.isClosedCaptioned && data.isClosedCaptioned() )
                    {
                        subTitleElements.push( Strings.Glyphs.CC );
                        speechSubTitle += "Closed captioning available. ";
                    }

                    if( data.isDvs && data.isDvs() )
                    {
                        subTitleElements.push( Strings.Glyphs.DV );
                        speechSubTitle += "Video description available. ";
                    }
                }
                else if( data instanceof SearchEntity )
                {
                    subTitleElements.push( data.getSubtitle() );
                    speechSubTitle += subTitleElements[subTitleElements.length-1];
                }
                else
                {
                    if( data.getEpisodeCount && data.getEpisodeCount() )
                    {
                        count = data.getEpisodeCount();

                        subTitleElements.push( count + ( count === 1 ? " Episode" : " Episodes" ) );
                        speechSubTitle += subTitleElements[subTitleElements.length-1];
                    }
                    else
                    {
                        if( entity.getType() !== XtvApi.EntityType.EPISODE )
                        {
                            if( data.getSubtitle && data.getSubtitle())
                            {
                                subTitleElements.push(data.getSubtitle());
                                speechSubTitle += subTitleElements[subTitleElements.length-1] + " ";
                            }
                            else if( data.getYear && data.getYear())
                            {
                                subTitleElements.push(data.getYear());
                                speechSubTitle += subTitleElements[subTitleElements.length-1];
                            }
                        }

                        setRemaining();

                        if( entity.getRottenTomatoReview )
                        {
                            review = entity.getRottenTomatoReview();
                            if( review )
                            {
                                if( review.isValid() )
                                {
                                    separator = " ";

                                    if( review.getFanSummaryScore() > 0 || review.getCriticSummaryScore() > 0 )
                                        subTitleElements.push("|");

                                    this._tomatoWidget.setData( review );
                                    this._showTomatos = true;

                                    speechSubTitle += ", " + this._tomatoWidget.getSpeechStr();
                                }
                            }
                        }
                    }
                }

                this._posterText.setText("");
                this._posterSubText.setText("");
                this._tomatoWidget.setA(0);

                this._title.setText( title );
                this._subTitle.setText( subTitleElements.join(separator) );

                if( this._showTomatos )
                    this._subTitle.addReadyCallback( function(){ self._tomatoWidget.setX( self._subTitle.getW() + Style._pad ) } );

                this.setBackgroundText( data.getTitle() );

                if( entity )
                    this._image.setUrl( entity.getImageLink( this._srcImageW, this._srcImageH ) );

                speechTitle = title;
            }

            speechStr = speechTitle + ". ";

            if( speechSubTitle )
                speechStr += speechSubTitle + ". ";

            this._speakTarget.setText( speechStr );

            this.setA( 1 );
        }
        else
        {
            this.setA( 0 );
            this._image.setUrl();
        }
    };

    return GalleryCellWidget;

})();


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GalleryRowWidget = ( function()
{
    "use strict";

    GalleryRowWidget.prototype = new CollectionRowWidget();

    function GalleryRowWidget(){}

    /**
     * @memberof GalleryRowWidget
     * @param params
     * @returns {GalleryRowWidget}
     * @see CollectionRowWidget
     */
    GalleryRowWidget.prototype.init = function( params )
    {
        params.type = GalleryCellWidget;
        params.y    = _x2.scaleVal( 160 ) - _x2.scaleVal( 12 );
        params.h    = _x2.scaleValInt( 530 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "GalleryRowWidget";

        return this;
    };

    GalleryRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 690 );
    };

    return GalleryRowWidget;

})();


/***/ }),
/* 106 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GridInfoWidget = (function()
{
    "use strict";

    GridInfoWidget.prototype = new Widget();

    function GridInfoWidget(){}

    GridInfoWidget.prototype.getChannel = function()
    {
        return this._channel;
    };

    GridInfoWidget.prototype.getIsChannel = function()
    {
        return this._isChannel;
    };

    GridInfoWidget.prototype.getShowing = function()
    {
        return this._showing;
    };

    GridInfoWidget.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut( 0 );
    };

    /**
     * Initializer
     * @memberof GridInfoWidget
     * @returns {GridInfoWidget}
     */
    GridInfoWidget.prototype.init = function()
    {
        var self      = this, insetX, insetY, w, h;
        var backStyle = new Style( { font:"medium" , color:"#8c8c8c", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var onLoad    = function() { self._numLoaded++; self.layout() };

        Widget.prototype.init.call( this );
        this._className  = "GridInfoWidget";
        this._selectable = true;
        this._numLoaded  = 0;

        this.setW( _x2._config._screenW );
        this.setH( _x2._config._screenH );
        this.setA( 0 );

        this._dim = new RectWidget().init( { name: "Dimming", w:_x2._config._screenW, h:_x2._config._screenH, color:"#303030" } );
        this._dim.setVal( Widget.ALPHA, 0.8 );
        this.addWidget( this._dim );

        insetX = _x2.scaleValInt( 172 );
        insetY = _x2.scaleValInt( 155 );

        w = _x2._config._screenW - 2 * insetX;
        h = _x2._config._screenH - 2 * insetY;

        this._bg = new RectWidget().init( { w:w, h:h, color:"#000000" } );
        this.addWidget( this._bg, insetX, insetY );

        this._detail = new EntityInfoWidget().init( { grid:true } );
        this.addWidget( this._detail, insetX + _x2.scaleValInt(80), insetY + _x2.scaleValInt(180) );

        this._channelDetail = new ChannelInfoWidget().init( { grid:true } );
        this.addWidget( this._channelDetail, insetX + _x2.scaleValInt(80), insetY + _x2.scaleValInt(180) );

        this._back = new StringWidget().init( { text:"Press [Back] to exit", style:backStyle } );
        this._back.addReadyCallback( onLoad );
        this._bg.addWidget( this._back, 0, _x2.scaleValInt(34) );

        this._speakTarget = new StringWidget().init( { style:backStyle } );
        this._speakTarget.setA( 0 );
        this._bg.addWidget( this._speakTarget );

        this._actionButtons = new EntityActionButtonsWidget().init();
        this.addWidget( this._actionButtons, _x2.scaleValInt(530), _x2.scaleValInt(683) );

        this._actionButtons.setRefreshListener( function( entity ){ 
            var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );       
            if( entity.getChannel().getNumber() == lastChannel.num ) {
                self.refresh( entity );
            } else {
                self._parent._parent.setChannels();
            }//If last channel is not equals to last grid entity, then it was changed in mini-guide, so we need to refresh the grid
        } );

        this._prev = new ImageWidget().init( { url: _x2._config._imageRoot + "channelUp.png" } );
        this._next = new ImageWidget().init( { url: _x2._config._imageRoot + "channelDown.png" } );

        this._prev.setA( 0 );
        this._next.setA( 0 );

        this._prev.addReadyCallback( onLoad );
        this._next.addReadyCallback( onLoad );

        this.addWidget( this._prev, insetX, insetY +     _x2.scaleValInt(63) );
        this.addWidget( this._next, insetX, insetY + h - _x2.scaleValInt(63) );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ); } );
        this.addWidget( this._distractor );

       return this;
    };

    GridInfoWidget.prototype.layout = function()
    {
        if( this._numLoaded === 3 )
        {
            this._back.setX( this._bg.getW() - this._back.getW() - _x2.scaleValInt(34) );

            this._prev.setX( (_x2._config._screenW - this._prev.getW()) * 0.5 );
            this._next.setX( (_x2._config._screenW - this._next.getW()) * 0.5 );
        }
    };

    GridInfoWidget.prototype.processEvent = function( val )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
            case Host.KEY_LAST:
            case Host.KEY_UP:
                retval = false;
                break;
        }

        return retval;
    };

    GridInfoWidget.prototype.refresh = function( entity )
    {
        if( entity )
        {
            if( this._isChannel ) {       
                this._channelDetail.setData( entity, this._channel );
            }
            else {
                this._detail.setData( entity, this._channel );
            }
        }
    };

    GridInfoWidget.prototype.setEntity = function( showing, channel, indexCurMax, isChannel )
    {
        this._distractor.hide();
        this._showing   = showing;
        this._isChannel = isChannel;

        if( channel )
            this._channel = channel;

        this._prev.setA( (indexCurMax.current !==                    0 ) ? 1 : 0 );
        this._next.setA( (indexCurMax.current !== (indexCurMax.max - 1)) ? 1 : 0 );

        if( isChannel )
        {
            this._channelDetail.setData(showing, channel);
            this._channelDetail.setA(1);
            this._detail.setA(0);
        }
        else
        {
            this._detail.setData(showing, channel);
            this._detail.setA(1);
            this._channelDetail.setA(0);
        }

        this._actionButtons.setData( { entity:showing, channel:channel, infoButton:true, isChannel:isChannel } );
        this._actionButtons.setA(1);

        this._menuReady = true;

        if( _x2._focus === this )
            this.speak( _x2.requestFocus( this._actionButtons, true ) );
        else if( this._actionButtons.containsWidget( _x2._focus ) === true )
            this.speak( _x2._focus );
    };

    GridInfoWidget.prototype.speak = function( focus )
    {
        var detail = this._isChannel ? this._channelDetail : this._detail;
        var str    = detail.getSpeechStr();
        this._speakTarget.setText( focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( str + ". Press right or left to review program options. Press OK to select. Press up or down to move between channels. Press back to exit. ", focus._speakRole, this, false );
    };

    GridInfoWidget.prototype.unsetEntity = function(isUpdate)
    {
        this._channelDetail.setA(0);
        this._detail.setA(0);
        this._distractor.show();

        if( this._actionButtons )
            this._actionButtons.setA(0);

        var lastScreen = _x2._screenRoot.getTop();
        if( isUpdate && !(lastScreen instanceof VideoScreen) )
            this.updateParentRow();
        else if( isUpdate && lastScreen instanceof VideoScreen ) {
            window.setTimeout( function() {
                this.updateParentRow();
            }.bind(this), 500);//if last screen is not destroy, wait for another 700 ms
        }
    };
    GridInfoWidget.prototype.updateParentRow = function() 
    {
        //if it is channel, then we need to update that channel row through cells
        if( this._parent ) {
            var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );//this._channelDetail._channel || ( this._detail._data && this._detail._data.getChannel() );
            for( var i = 0; i < this._parent._cells.length; i++ ) {
                if( this._parent._cells[i]._channel && lastChannel &&
                    (this._parent._cells[i]._channel.getNumber() == lastChannel.num ) ) {
                    this._channel.setFocus = true;
                    this._parent._cells[i].refreshChannelInfo( true );
                    break;
                }
            }
        }
    };

    return GridInfoWidget;

})();


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

// TODO still needed features
// - flush and unlock the event queue if nothing happening
// - behavior when up at right edge of time window

/**
 * @class
 */
window.GridRowWidget = ( function()
{
    "use strict";

    GridRowWidget.prototype = new ListRowWidget();

    var pixPerMs;

    function GridRowWidget(){}

    GridRowWidget.prototype.createCell = function()
    {
        var retval = {};

//        retval.sep   = new RectWidget().init( { w:2, h:this.getHeightUnfocused(), color:"#303030" } );
        retval.sep   = new ImageWidget().init( { url:_x2._config._imageRoot + "textFade.png", w:this._sepW, h:this._sepH } );
        retval.title = new StringWidget().init( { text:"????", style:this._titleStyle } );
        retval.sep.setA( 0 );
        retval.title.setA( 0 );
        this.addWidget( retval.title, 0, this._titleY );
        this.addWidget( retval.sep );
        retval.title.patchWidget();
        retval.sep.patchWidget();

        return retval;
    };

    GridRowWidget.prototype.getPosAndDimUnfocused = function( repeating )
    {
        var x = 0, w;

        var gX  = this.getGlobalPos().x;
        var hiX = _x2._hi.getX();

        if( gX === hiX + this._favColOffset )
        {
            x = -this._favColOffset;
            w = this._chanColX;
        }
        else if( gX + this._chanColX === hiX )
        {
            x = this._chanColX;
            w = this._chanColW;
        }
        else if( repeating === true )
        {
            x = 0;
            w = this.getW();
        }
        else
        {
            var maxTime    = this._driver._gridTime + 7200000, cell, listing, startTime, endTime;
            var now        = new Date().getTime();
            var inFirstCol = false;

            if( this._driver._focusColTime < this._driver._gridTime )
                this._driver._focusColTime = this._driver._gridTime;
            else if( this._driver._focusColTime > maxTime )
                this._driver._focusColTime = maxTime;

            this._focusIndex = -1;

            if( now >= this._driver._focusColTime )
                inFirstCol = true;

            for( var i = 0; i < this._cells.length; i++ )
            {
                if( inFirstCol === true )
                {
                    if( now < this._cells[i].listing.getEndTime() && now >= this._cells[i].listing.getStartTime() )
                    {
                        this._focusIndex = i;
                        break;
                    }
                }
                else
                {
                    if( this._cells[i].listing.getEndTime() > this._driver._focusColTime )
                    {
                        this._focusIndex = i;
                        break;
                    }
                }
            }

            cell = this._cells[this._focusIndex];

            if( cell )
            {
                listing   = cell.listing;
                startTime = listing.getStartTime();
                endTime   = listing.getEndTime();
                x         = this._minX + (startTime - this._lastGridTime) * pixPerMs;

                if( x < this._minX )
                    x = this._minX;

                w = this._minX + (endTime - this._lastGridTime) * pixPerMs - x - ListRowWidget.DIVIDER_H;
            }
            else
            {
                x = 0;
                w = this.getW();
            }
        }

        return { pos:x, dim:w };
    };

    /**
     * @memberof GridRowWidget
     */
    GridRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 );
    };

    GridRowWidget.prototype.getIndex = function( time )
    {
        var i, retval = -1;

        for( i = 0; i < this._listings.length; i++ )  // TODO binary search
        {
            if( this._listings[i].getEndTime() > time )
            {
                if( this._listings[i].getStartTime() <= time )
                    retval = i;

                break;
            }
        }

        return retval;
    };

    /**
     * @memberof GridRowWidget
     */
    GridRowWidget.prototype.gotFocus = function( lostFocus, newScreen )
    {
        var lastScreen = _x2._screenRoot.getTop();
        if( lastScreen instanceof VideoScreen ) {
            return this;
        } //if still lastScreen is not destroy, we should not higlight the row
        var maxTime    = this._driver._gridTime + 7200000;
        var now        = new Date().getTime();
        var inFirstCol = false;
        var obj        = this.getGlobalPos();
        if( _x2._telemetry.getWatchButtonSource() === "Channel Finder" ) // NOTE: Keep in sync with GuideScreen, GridWidget, and GridRowWidget
        {
            if( _x2._telemetry.lastChannel !== this._channel.getNumber() )
                _x2._telemetry.setWatchButton( "Live TV: All Channels" );
        }

        _x2._telemetry.lastChannel = this._channel.getNumber();

        //setting the last channel, so that we can focus to that channel while scrolling left or right
        _x2._settings.setValue( Settings.Key.LAST_CHAN, { id: this._channel.getStationId(), num: this._channel.getNumber() } );

        if( obj.x === _x2._hi.getX() + this._favColOffset && this._chanColX === _x2._hi.getW() )
            this._favFocus = true;
        else if( obj.x + this._chanColX === _x2._hi.getX() && this._chanColW === _x2._hi.getW() )
            this._channelFocus = true;

        if( this._driver._focusColTime < this._driver._gridTime )
            this._driver._focusColTime = this._driver._gridTime;
        else if( this._driver._focusColTime > maxTime )
            this._driver._focusColTime = maxTime;

        this._focusIndex = -1;

        if( now >= this._driver._focusColTime )
            inFirstCol = true;

        for( var i = 0; i < this._cells.length; i++ )
        {
            if( inFirstCol === true )
            {
                if( now < this._cells[i].listing.getEndTime() && now >= this._cells[i].listing.getStartTime() )
                {
                    this._focusIndex = i;
                    break;
                }
            }
            else
            {
                if( this._cells[i].listing.getEndTime() > this._driver._focusColTime )
                {
                    this._focusIndex = i;
                    break;
                }
            }
        }

        if( this._focusIndex >= 0 && this._cells.length > 0)
            if( this._driver.onUpdateInfo( this._cells[this._focusIndex].listing, this._channel, this._channelFocus ) === true )
                this.setHighlight( 0, undefined, undefined, true, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof GridRowWidget
     * @param   {Object} params
     * @param   {Object} params.obj - the grid that is using the this row
     * @param   {Number} params.w   - Width in pixels
     * @returns {GridRowWidget}
     */
    GridRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className = "GridRowWidget";

        var self      = this;
        var chanStyle = new Style( { color:"#a3a3a3", font:"medium"  , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2b9cd8" } );
        var onReady   = function() { self._numElements++; self.layout(); };

        this._titleStyle   = new Style( { color:"#e8e8e8", font:"regular", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", overflow:"hidden", colorHi:"#2b9cd8" } );
        this._driver       = params.obj;
        this._lastGridTime = this._driver._gridTime;
        this._numElements  = 0;
        this._selectable   = true;
        this._queue        = [];
        this._blocked      = false;
        this._maxH         = Math.floor( this.getHeightUnfocused() / 2 );
        this._maxW         = Math.floor( this._maxH * 5 / 3 );
        this._strPad       = _x2.scaleValInt( 42 );
        this._focusIndex   = 0;

        // add the widgets for the channel information

        var starParams =
        {
            initial:0,
            onEnter:function() { console.log( "TOGGLE" ); },
            images :[ _x2._config._imageRoot + "starEmpty.png", _x2._config._imageRoot + "starEmptyHi.png", _x2._config._imageRoot + "star.png", _x2._config._imageRoot + "starHi.png" ]
        };

        this._chanImage   = new ImageWidget().init( { onError:function(){ self.onChanImageFail() }, onChange:function() { self.onChanImageLoad(); } } );
        this._callSignStr = new StringWidget().init( { style:chanStyle } );
        this._chanStr     = new StringWidget().init( { text:"0000", style:chanStyle } );
        this._chanSep     = new RectWidget().init( { w:ListRowWidget.DIVIDER_H, h:this.getHeightUnfocused(), color:"#262626" } );
        this._star        = new MultiStateButtonWidget().init( starParams );

        this._star.addReadyCallback( onReady );
        this._chanStr.addReadyCallback( onReady );

        this.addWidget( this._star );
        this.addWidget( this._chanImage );
        this.addWidget( this._callSignStr );
        this.addWidget( this._chanStr );
        this.addWidget( this._chanSep );

        // add the widgets for the programs information

        this._scroll = new ScrollWidget().init( { h:this.getHeightUnfocused()-ListRowWidget.DIVIDER_H } );
        this.addWidget( this._scroll );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._cells = [];
        this._pool  = new Array( 3 );

        for( var i = 0; i < this._pool.length; i++ )
        {
            this._pool[i]       = {};
//            this._pool[i].sep   = new RectWidget().init( { w:2, h:this.getHeightUnfocused(), color:"#303030" } );

            if( i === 0 )
                this._pool[i].sep = new ImageWidget().init( { url:_x2._config._imageRoot + "textFade.png", onLoad:onReady } );
            else
                this._pool[i].sep = new ImageWidget().init( { url:_x2._config._imageRoot + "textFade.png" } );

            this._pool[i].title = new StringWidget().init( { text:"????", style:this._titleStyle } );
            this._pool[i].sep.setA( 0 );
            this._pool[i].title.setA( 0 );
            this.addWidget( this._pool[i].title );
            this.addWidget( this._pool[i].sep, -100, 0 );

            if( i > 0 )
                this._pool[i-1].next = this._pool[i];
        }

        return this;
    };

    GridRowWidget.prototype.layout = function()
    {
        var i;

        if( this._numElements === 3 )
        {
            this._sepW = this._pool.length > 0 ? this._pool[0].sep.getW() : this._cells[0].sep.getW();
            this._sepH = this.getHeightUnfocused() - ListRowWidget.DIVIDER_H;
            this._titleY = (this.getHeightUnfocused() - this._chanStr.getH()) / 2;
            this._star.setY( (this.getHeightUnfocused() - ListRowWidget.DIVIDER_H - this._star.getH()) / 2 );
            this._chanColX = this._star.getW() + 3 * Style._pad;
            this._favColOffset = 3 * Style._pad / 2;
            this._chanStr.setX( this._chanColX + this._maxW + 3 * Style._pad );
            this._chanStr.setY( this._titleY );
            this._callSignStr.setX( this._chanColX );
            this._callSignStr.setY( this._titleY );
            this._chanColW = this._chanStr.getX() + this._chanStr.getW() + Style._pad - this._chanColX;
            this._minX     = this._chanColX + this._chanColW + ListRowWidget.DIVIDER_H;
            this._chanSep.setX( this._chanColX + this._chanColW );
            this._scroll.setX( this._chanColX + this._chanColW + this._chanSep.getW() );
            this._scroll.setW( this.getW() - this._scroll.getX() );

            for( i = 0; i < this._cells.length; i++ )
            {
                this._cells[i].title.setY( this._titleY );
                this._cells[i].sep.setW( this._sepW );
                this._cells[i].sep.setH( this._sepH );
            }

            for( i = 0; i < this._pool.length; i++ )
            {
                this._pool[i].title.setY( this._titleY );
                this._pool[i].sep.setW( this._sepW );
                this._pool[i].sep.setH( this._sepH );
            }

            this._layoutReady = true;
            this.callbackSignalReady();

            if( this._channel )
                this.setData( this._channel );
        }
    };

    GridRowWidget.prototype.lostFocus = function( gettingFocus )
    {
        ListRowWidget.prototype.lostFocus.call( this, gettingFocus );

        this._favFocus     = false;
        this._channelFocus = false;

        this._chanStr.lostFocus();

        if( this._star.inFocusState() === true )
            this._star.lostFocus();

        if( this._cells[this._focusIndex] )
            this._cells[this._focusIndex].title.lostFocus( gettingFocus );
    };


    GridRowWidget.prototype.onChanImageFail = function()
    {
        this._callSignStr.setText( this._channel.getCallSign() );
        this._callSignStr.setA( 1 );
    };

    /**
     * @memberof GridRowWidget
     */
    GridRowWidget.prototype.onChanImageLoad = function()
    {
        var dw, dh, scale;
        var w = this._chanImage.getW();
        var h = this._chanImage.getH();

        if( w > 0 && h > 0 )
        {
            dw    = this._maxW / w;
            dh    = this._maxH / h;
            scale = ( dh < dw ) ? dh : dw;

            this._chanImage.setX( (this._maxW                - this._chanImage.getW()) / 2 + this._chanColX );
            this._chanImage.setY( (this.getHeightUnfocused() - this._chanImage.getH()) / 2 );
            this._chanImage.setScale( scale );

            this._chanImage.setA( 1 );
        }
//         else if( this._channel ) // failed to load an image, use label instead.
//             this.setCallSignText();
    };

    GridRowWidget.prototype.positionCell = function( cell )
    {
        var sepX, titleX, w;
        var start = cell.listing.getStartTime();
        var end   = cell.listing.getEndTime();

        if( end > this._lastGridTime )
        {
            sepX = this._chanColX + this._chanColW + (end - this._lastGridTime) * pixPerMs;

            cell.sep.setX( sepX - this._sepW );
            cell.sep.setA( 1 );

            titleX = this._chanColX + this._chanColW + this._strPad + (start - this._lastGridTime) * pixPerMs;

            if( titleX < (this._chanColX + this._chanColW + this._strPad) )
                titleX = this._chanColX + this._chanColW + this._strPad;

            cell.title.setText( cell.listing.getGridTitle() );
            cell.title.setX( titleX );
            cell.title.setA( 1 );

            w = sepX - titleX;

            cell.title.setW( w );

            if( w < this._strPad )
                cell.title.setA( 0 );
            else
                cell.title.setA( 1 );
        }
    };

    /*
     * @suppress {suspiciousCode}
     */
    GridRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = true, nextSep, metrics;

        if( this._driver._infoShowing ) {
            return retval;
        } // if grid info widget open, then we should focus the key for grid

        switch( val )
        {
            case Host.KEY_ENTER:
                if( this._blocked === false )
                {
                    if( type === Host.KEY_PRESSED )
                    {
                        retval = true;

                        if( this._favFocus === true )
                        {
                            this._star.processEvent( val, type );

                            metrics =
                            {
                                "Channel"    : this._channel.getCallSign(),
                                "Network"    : this._channel.getCompany(),
                                "Rights Type": "T6"
                            };

                            if( this._star.getState() === 0 )
                            {
                                _x2._favorites.removeFavorite( this._channel ).then( function() {
                                    this._star.setState( 0 ); 
                                });
                                this._chanSep.setSpeechParams( "Favorite unselected. ", undefined, this, false );
                                metrics["Action"] = "Remove";
                                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: -Favorite Channel: %o:", metrics ) : Config.NOP();
                                window.ll( "tagEvent", "Favorite Channel", metrics );
                            }
                            else
                            {
                                _x2._favorites.addFavorite( this._channel ).then( function() {
                                    this._star.setState( 1 ); 
                                });
                                this._chanSep.setSpeechParams( "Favorite selected. ", undefined, this, false );
                                metrics["Action"] = "Add";
                                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.warn( "Localytics: +Favorite Channel: %o", metrics ) :  Config.NOP();
                                window.ll( "tagEvent", "Favorite Channel", metrics );
                            }

                            _x2.refreshFavorites();
                        }
                        else
                        {
                            //allow user to select channel cell (so they can tune) even if current listing is TBD.
                            if( this._channelFocus === true ) {
                                this._channel.isFavorite = this._star.getState();
                                this._driver.onShowInfo( this._cells[this._focusIndex].listing, this._channel, true );
                            }
                            else if( this._focusIndex >= 0 )
                            {
                                if( this._cells[this._focusIndex].listing.isTbd() === false )
                                    this._driver.onShowInfo( this._cells[this._focusIndex].listing, this._channel );
                                else{
                                    this._driver.onShowInfo( this._cells[this._focusIndex].listing, this._channel, true );
                                }//if schedule not available, user are allow to watch the current live programs
                            }
                        }
                    }

                    this.processQueue();
                }
                else
                {
                    this._queue.push( [ val, type ] );
                    retval = true;
                }
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_RELEASED )
                {
                    if( this._repeating === true )
                    {
                        this._repeatEnded = true;
                    }

                    retval = false;
                }
                else if( this._blocked === false )
                {
                    this._blocked = true;
                    if( type === Host.KEY_PRESSED )
                    {
_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "grid time = " + new Date( this._driver._gridTime ) + " > " + new Date( this._driver._datum ) + " datum" ) : Config.NOP();

                        if( this._channelFocus === true )
                        {
                            this._favFocus = true;
                            this.setHighlight();
                        }
                        else if( this._focusIndex > 0 )
                        {
                            var sep = (this._cells[this._focusIndex].listing.getStartTime() - this._lastGridTime);

//                            if( sep < 300000 && this._driver._gridTime > this._driver._datum )
                            if( sep < 300000 && this._driver._gridTime > this._driver._minTime )
                            {
                                this._focusIndex--;
                                this.setHighlight( undefined, 1800000 * pixPerMs );
                                this._driver._focusColTime -= 1800000;
_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                                retval = false;
                            }
                            else
                            {
                                this._cells[this._focusIndex] && this._cells[this._focusIndex].title.lostFocus();
                                this._focusIndex--;
                                this.setHighlight();
                                this._driver._focusColTime = Math.floor( this._cells[this._focusIndex].listing.getStartTime() / 1800000 ) * 1800000;

                                if( this._driver._focusColTime < this._driver._gridTime )
                                    this._driver._focusColTime = this._driver._gridTime;

_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                                retval = true;
                            }
                        }
//                        else if( this._driver._gridTime > this._driver._datum )
                        else if( this._driver._gridTime > this._driver._minTime )
                        {
                            if( this._focusIndex >= 0 )
                            {
                                nextSep = (this._cells[this._focusIndex].listing.getStartTime() - this._lastGridTime);

                                _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "NEXT SEP = " + nextSep ) : Config.NOP();

                                if( nextSep < 0 )
                                {
                                    this.setHighlight( undefined, 1800000 * pixPerMs );
                                    this._driver._focusColTime -= 1800000;
_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                                }
                                else
                                {
                                    this._cells[this._focusIndex].title.lostFocus();

                                    for( var i = 0; i < this._listings.length; i++ )
                                    {
                                        if( this._listings[i] === this._cells[0].listing )
                                        {
                                            _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "FOUND MATCH AT LISTING INDEX = " + i + ", FOCUS INDEX = " + this._focusIndex ) : Config.NOP();

                                            var prev = this._listings[i-1];

                                            if( i > 0 && prev.getEndTime() >= (this._listings[i].getStartTime() - 1800000) )
                                            {
                                                var cell = this._pool.pop() || this.createCell();
                                                cell.listing = this._listings[i-1];
                                                this._cells.unshift( cell );
                                                this.positionCell( cell );
                                                this.setHighlight( undefined, 1800000 * pixPerMs );
                                                if( this._focusIndex === 0 ) {
                                                    this._driver._focusColTime = this._driver._datum;    
                                                } else {
                                                    this._driver._focusColTime -= 1800000;
                                                }//If focusIndex is zero, that first cell should get highlighted
                                                _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            else
                                this._blocked = false;

                            retval = false;
                        }
                        else
                        {
                            _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "SELECT THE CHANNEL CELL - retval = " + retval ) : Config.NOP();

                            this._channelFocus = true;
                            this._blocked      = false;
                            if( this._cells[this._focusIndex] )
                                this._cells[this._focusIndex].title.lostFocus();
                            this.setHighlight();
                        }
                    }
                    else if( type === Host.KEY_REPEAT )
                    {
                        this._cells[this._focusIndex] && this._cells[this._focusIndex].title.lostFocus();
                        retval           = false;
                        this._blocked    = false;
                        this._repeating  = true;
                        this._focusIndex = -1;
                        this._selectable = false;
                        _x2._hi.fadeOut();
                    }
                }
                else
                {
                    this._queue.push( [ val, type ] );
                    retval = true;
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_RELEASED )
                {
                    if( this._repeating === true )
                    {
                        this._repeatEnded = true;
                    }

                    retval = false;
                }
                else if( this._blocked === false )
                {
                    this._blocked = true;

                    if( type === Host.KEY_PRESSED )
                    {
                        if( this._favFocus === true )
                        {
                            this._favFocus     = false;
                            this._channelFocus = true;
                            this.setHighlight( undefined, undefined );
                        }
                        else if( this._channelFocus === true )
                        {
                            this._channelFocus = false;
                            this.setHighlight( undefined, undefined, true );
                        }
                        else
                        {
                            if( this._focusIndex < 0 )
                                nextSep = 0;
                            else
                                nextSep = (this._cells[this._focusIndex].listing.getEndTime() - this._lastGridTime);

                            if( nextSep <= 7200000 )
                            {
                                if( this._focusIndex < (this._cells.length - 1) )
                                {
if( this._cells[this._focusIndex] === undefined )
{
    console.error( "This should not be undefined for index = " + this._focusIndex );
    console.log( this._cells );
}
else
                                    this._cells[this._focusIndex].title.lostFocus();
                                    this._focusIndex++;
                                    this.setHighlight();
                                    retval = true;
                                }
                                else
                                {
                                    nextSep -= 1800000;

                                    if( nextSep < 1800000 )
                                        nextSep = 1800000;

                                    this.setHighlight( undefined, -1800000 * pixPerMs );
                                    retval = false;
                                }

                                this._driver._focusColTime = Math.floor( nextSep / 1800000 ) * 1800000 + this._lastGridTime;
_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                            }
                            else
                            {
                                if( this._cells[this._focusIndex+1] !== undefined )
                                {
                                    this._cells[this._focusIndex].title.lostFocus();
                                    this._focusIndex++;
                                    this._driver._focusColTime = Math.floor( nextSep / 1800000 ) * 1800000 + this._lastGridTime;
                                }

                                this.setHighlight( undefined, -1800000 * pixPerMs );
_x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "================> " + new Date( this._driver._focusColTime ) ) : Config.NOP();
                                retval = false;
                            }
                        }
                    }
                    else if( type === Host.KEY_REPEAT )
                    {
                        this._cells[this._focusIndex] && this._cells[this._focusIndex].title.lostFocus();
                        retval           = false;
                        this._blocked    = false;
                        this._repeating  = true;
                        this._focusIndex = -1;
                        this._selectable = false;
                        _x2._hi.fadeOut();
                    }
                }
                else
                {
                    this._queue.push( [ val, type ] );
                    retval = true;
                }
                break;

            default:
                retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    GridRowWidget.prototype.processQueue = function()
    {
        var self = this;

        var key = this._queue.shift();

        _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "##### PROCESS QUEUE #####, key = " + key ) : Config.NOP();

        if( key !== undefined )
            setTimeout( function() { self._blocked = false; _x2.routeKey( key[0], key[1] ); }, 1 );
        else
            this._blocked = false;
    };

    GridRowWidget.prototype.refresh = function()
    {
        var index = -1, cell, ii;

        // validate any cells currently allocated

        if( this._cells.length > 0 )
        {
            ii = index = this.getIndex( this._cells[0].listing.getStartTime() );

            for( var i = 0; i < this._cells.length; i++ )
            {
                if( this._cells[i].listing.getStartTime() !== this._listings[ii].getStartTime() || this._cells[i].listing.getEndTime() !== this._listings[ii].getEndTime() )
                {
                    if( _x2._focus === this )
                    {
                        console.error( "data did not match what was already being displayed, flushing existing cells" );
                        for( var j = 0; j < this._cells.length; j++ ) {
                            console.log( "==> " + j + " - " + new Date( this._cells[j].listing.getStartTime() ) );
                            if( this._cells[j].listing.isTbd() ) {
                                this._cells[j].sep.setA( 0 );
                                this._cells[j].title.setA( 0 );
                                this._cells.splice(j, 1);
                            } //remove tbd cell, if it is out of current grid window
                        }
                    }

                    while( this._cells.length > 0 )
                    {
                        cell = this._cells.pop();
                        cell.sep.setA( 0 );
                        cell.title.setA( 0 );
                        cell.title.setVal( Widget.FONT_COLOR, "#e8e8e8" );
                        this._pool.push( cell );
                    }

                    ii = this.getIndex( this._lastGridTime );

                    break;
                }
                else
                {
                    this._cells[i].listing = this._listings[ii];
                    ii++;
                }
            }
        }
        else
        {
            ii = this.getIndex( this._lastGridTime );
        }

        // add cells that needed to the right

        var maxTime = this._lastGridTime + 6 * 30 * 60 * 1000;

        while( this._listings[ii] && this._listings[ii].getStartTime() < maxTime )
        {
            cell         = this._pool.pop() || this.createCell();
            cell.listing = this._listings[ii];
            this.positionCell( cell );
            this._cells.push( cell );    
            ii++;
        }

        // add cells that are needed to the left

        var minIndex = this.getIndex( this._lastGridTime );

        for( i = index - 1; i >= minIndex; i-- )
        {
            if( this._listings[i] )
            {
                cell         = this._pool.pop() || this.createCell();
                cell.listing = this._listings[i];
                this.positionCell( cell );
                this._cells.unshift( cell );
            }
        }
        //After adding all cells, we need check again whether first block is TBD and
        //for which data are update from api, if so we need to hide that cell
        if( this._cells[0] && this._cells[0].listing.isTbd() ) {
            var lastUpdateGridTime = this._driver._gridTime;
            var gapStartTime = this._cells[0].listing.getStartTime();
            var gapEndTime = this._cells[0].listing.getEndTime();
            if(  gapStartTime <= lastUpdateGridTime || gapEndTime <= lastUpdateGridTime ) {
                this._cells[0].sep.setA( 0 );
                this._cells[0].title.setA( 0 );
                this._cells.shift();
            }
        }
        if( this._channel && _x2._focus._channel 
            && this._channel.getNumber() == _x2._focus._channel.getNumber() 
            && this._repeating !== true )
        {
            _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "FOCUS INDEX = " + this._focusIndex ) : Config.NOP();
            this.gotFocus();
        }
    };

    GridRowWidget.prototype.refreshCell = function()
    {
        _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "REFESH A GRID ROW" ) : Config.NOP();
        _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( this )                : Config.NOP();

        this._lastGridTime = this._driver._gridTime;

        if( _x2._focus === this )
            this.lostFocus();

        if( this._channel )
            this.setData( this._channel );

        if( _x2._focus === this )
        {
            this._focusIndex = -1;

            for( var i = 0; i < this._cells.length; i++ )
            {
                if( this._cells[i].listing.getEndTime() > this._driver._focusColTime )
                {
                    this._focusIndex = i;
                    break;
                }
            }

            this.setHighlight();
        }
    };

    /**
     * @memberof GridRowWidget
     * @param {Channel} data - Must support: getLogoUrl() getNumber()
     */
    GridRowWidget.prototype.setData = function( data )
    {
        this._channel = data;

        if( data !== undefined && this._layoutReady === true )
        {
            var i, cell;

            this._chanImage.setA( 0 );
            this._chanImage.setW();
            this._chanImage.setH();
            this._chanImage.setUrl();
            this._chanImage.setUrl( data.getLogoUrl(50,30) );
            this._callSignStr.setA( 0 );

            if( _x2._favorites.isFavorite( this._channel ) === true )
                this._star.setState( 1 );
            else
                this._star.setState( 0 );

            this._chanStr.setText( data.getNumber() );
            this.setA( 1 );

            // reset all the listing cells

            while( this._cells.length > 0 )
            {
                cell = this._cells.shift();
                cell.sep.setA( 0 );
                cell.title.setA( 0 );
                cell.title.setVal( Widget.FONT_COLOR, "#e8e8e8" );
                this._pool.push( cell )
            }

            // set the listings

            this._listings     = data.getSchedules();
            this._lastGridTime = this._driver._gridTime;

            // find first record visible

            var index;

            for( i = 0; i < this._listings.length; i++ )
            {
                if( this._listings[i].getEndTime() > this._lastGridTime )
                {
                    index = i;
                    break;
                }
            }

            var maxTime = this._lastGridTime + 6 * 30 * 60 * 1000;

            if( pixPerMs === undefined )
                pixPerMs = _x2.scaleValInt( 291 ) / (30 * 60 * 1000);

            i = 0;

            while( this._listings[index] && this._listings[index].getStartTime() < maxTime )
            {
                this._cells[i]         = this._pool.pop() || this.createCell();
                this._cells[i].listing = this._listings[index];
                this.positionCell( this._cells[i] );
                
                if( i > 0 )
                    this._cells[i-1].next = this._cells[i];

                index++;
                i++;
            }

            this._needRefresh = true;
        }
        else
            this.setA( 0 );
    };

    GridRowWidget.prototype.refreshChannelInfo = function( setLastChannelFocus ) {

        if( setLastChannelFocus ) {
            _x2._hi.setA(1);
            this._channel.setFocus = false;
        }
        if( this._channel ) {
            if( _x2._favorites.isFavorite( this._channel ) === true )
                this._star.setState( 1 );
            else
                this._star.setState( 0 );
        }
        var isFocusContainsRow = _x2._focus.containsWidget( this );
        if( _x2._focus instanceof ListWidget ) {
            _x2._focus._rows = _x2._focus._rows || [];
            for( var i = 0; i < _x2._focus._rows.length; i++ ) {
                if( _x2._focus._rows[i].getNumber() == this._channel.getNumber() ) {
                    isFocusContainsRow = true;
                    break;
                }
            }
        }
        if( isFocusContainsRow ) {
            _x2.requestFocus(this);//for moving cursor to current cell
        }
    }

    GridRowWidget.prototype.setHighlight = function( time, offset, notChanCol, sayChannel, newScreen )
    {
        var self    = this;
        var obj     = this.getGlobalPos();
        var onHiEnd = function()
        {
            if( _x2._hi._onEnd[Widget.Axis.X] === onHiEnd )
            {
                _x2._hi._onEnd[Widget.Axis.X] = undefined;
                self.processQueue();
            }
        };

        if( this._favFocus === true )
        {
            this._star.gotFocus();
            this._chanStr.lostFocus();

            obj.x         -= this._favColOffset;
            obj.w          = this._chanColX; //this._chanColW;
            obj.h          = this.getHeightUnfocused() - ListRowWidget.DIVIDER_H;
            obj.duration   = (time === undefined) ? this._driver._stepTime : time;
            obj.easing     = Widget.Easing.LINEAR;
            obj.onEnd      = onHiEnd;
            obj.onEndAxis  = Widget.Axis.X;

            _x2._hi.setPosition( obj );

            if( this._star.getState() === 0 )
                this._chanSep.setSpeechParams( "Favorite unselected. Press OK to select. ", undefined, this, false );
            else
                this._chanSep.setSpeechParams( "Favorite selected. Press OK to unselect. ", undefined, this, false );
        }
        else if( notChanCol !== true && this._channelFocus === true )
        {
            this._channelFocus = true;

            this._chanStr.gotFocus();

            if( this._star.inFocusState() === true )
                this._star.lostFocus();

            obj.x         += this._chanColX;
            obj.w          = this._chanColW;
            obj.h          = this.getHeightUnfocused() - ListRowWidget.DIVIDER_H;
            obj.duration   = (time === undefined) ? this._driver._stepTime : time;
            obj.easing     = Widget.Easing.LINEAR;
            obj.onEnd      = onHiEnd;
            obj.onEndAxis  = Widget.Axis.X;

            _x2._hi.setPosition( obj );

            this._chanSep.setSpeechParams( "Channel " + this._chanStr.getText() + ". " + this._channel.getCallSign() + ". Press OK to view channel options. ", undefined, this, false );
        }
        else if( this._focusIndex >= 0 && this._cells.length > 0)
        {
            this._chanStr.lostFocus();

            if( this._star.inFocusState() === true )
                this._star.lostFocus();
            this._cells[this._focusIndex].title.gotFocus();

            offset = (offset === undefined) ? 0 : offset;

            var listing   = this._cells[this._focusIndex].listing;
            var startTime = listing.getStartTime();
            var endTime   = listing.getEndTime();
            var x         = this._minX + (startTime - this._lastGridTime) * pixPerMs + offset;

            if( x < this._minX )
                x = this._minX;

            obj.x         += x;
            obj.w          = this._minX + (endTime - this._lastGridTime) * pixPerMs + offset - x - ListRowWidget.DIVIDER_H;
            obj.h          = this.getHeightUnfocused() - ListRowWidget.DIVIDER_H;
            obj.duration   = (time === undefined) ? this._driver._stepTime : time;
            obj.easing     = Widget.Easing.LINEAR;
            obj.onEnd      = onHiEnd;
            obj.onEndAxis  = Widget.Axis.X;

            _x2._hi.setPosition( obj );

            this.speak( sayChannel, newScreen );
        }
        else
            self.processQueue();
    };

    GridRowWidget.prototype.speak = function( sayChannel, newScreen )
    {
        var obj     = this._cells[this._focusIndex];
        var now     = new Date().getTime();
        var str     = "";
        var start   = obj.listing.getStartTime();
        var end     = obj.listing.getEndTime();
        var timeStr = X2.prototype.createTimeStr( new Date( start ) );
        var hint;

        str += _x2.createTimeSpeechStr( timeStr ); //timeStr;
        str += obj.title.getText() + ". ";

        if( obj.listing )
        {
            if( now >= start && now < end )
            {
                str  += Math.floor((end - now) / 60000) + " minutes remaining. ";
                hint  = "Press OK for program details. "
            }
            else
            {
                str  += Math.floor((end - start) / 60000) + " minutes. ";
                hint  = "Press OK for program options. "
            }
        }

        if( sayChannel )
            str += "Channel " + this._chanStr.getText() + ". " + this._channel.getCallSign() + ". ";

        if( newScreen !== true )
            str += hint;

        this._chanSep.setSpeechParams( str, undefined, this, false );
    };

    GridRowWidget.prototype.update = function( step, alphaParent )
    {
        ListRowWidget.prototype.update.call( this, step, alphaParent );

        if( this._lastGridTime !== this._driver._gridTime )
        {
            var start, end, cell, toShift = 0, toPop = 0;
            var dir = this._driver._gridTime - this._lastGridTime;

            this._lastGridTime = this._driver._gridTime;

            var windowStart = this._driver._gridTime;
            var windowEnd   = this._driver._gridTime + 6 * 30 * 60 * 1000;

            for( var i = 0; i < this._cells.length; i++ )
            {
                if( this._cells[i].listing )
                {
                    start = this._cells[i].listing.getStartTime();
                    end   = this._cells[i].listing.getEndTime();

                    if( dir > 0 )
                    {
                        if( end > windowStart )
                            this.positionCell( this._cells[i] );
                        else
                            toShift++;
                    }
                    else
                    {
                        if( start < windowEnd )
                            this.positionCell( this._cells[i] );
                        else
                            toPop++;
                    }
                }
                else
                {
                    console.error( "======================>>>>>>>>>>>>>> Why is there no listing????" );
                    break;
                }
            }

            // shift off the cells that are off the left hand side

            while( toShift > 0 )
            {
                cell = this._cells.shift();
                cell.sep.setA( 0 );
                cell.title.setA( 0 );
                cell.title.setVal( Widget.FONT_COLOR, "#e8e8e8" );
                this._pool.push( cell );
                this._focusIndex--;
                toShift--;
            }

            // pop off the cells that are off the right hand side

            while( toPop > 0 )
            {
                cell = this._cells.pop();
                cell.sep.setA( 0 );
                cell.title.setA( 0 );
                cell.title.setVal( Widget.FONT_COLOR, "#e8e8e8" );
                this._pool.push( cell );

                toPop--;
            }

            // add any new cell that are needed on the left or the right

            if( dir > 0 )
            {
                var lastIndex = this._cells.length - 1;

                if( lastIndex > -1 && this._cells[lastIndex].listing.getEndTime() < windowEnd )
                {
                    // find listing

                    for( i = 0; i < this._listings.length; i++ )
                    {
                        if( this._listings[i].getStartTime() >= this._cells[lastIndex].listing.getEndTime() )
                        {
                            cell         = this._pool.pop() || this.createCell();
                            cell.listing = this._listings[i];
                            this._cells.push( cell );
                            this.positionCell( cell );

                            if( this._cells[this._cells.length - 1].listing.getEndTime() >= windowEnd )
                                break;
                        }
                    }

                    // if the listings did not get filled, then mark for refresh
                    if( this._needRefresh !== true )
                        this._needRefresh = true;
                }
            }
            else
            {
                if( this._cells.length > 0 && this._cells[0].listing.getStartTime() > windowStart )
                {
                    var index = this.getIndex( windowStart );

                    if( index >= 0 )
                    {
                        cell         = this._pool.pop() || this.createCell();
                        cell.listing = this._listings[index];
                        this._cells.unshift( cell );
                        this.positionCell( cell );
                        this._focusIndex++;
                        // if the listings did not get filled, then mark for refresh
                        if( this._needRefresh !== true )
                            this._needRefresh = true;
                    }
                } else if( this._cells[0] && this._cells[0].listing.isTbd() && this._needRefresh !== true ) {
                        this._needRefresh = true;
                }
            }
        }
        else
        {
            if( this._needRefresh === true && this._driver._dataReady === true )
            {
                this._needRefresh = false;
                this.refresh();
            }

            if( this._repeatEnded === true )
            {
                this._repeating   = false;
                this._repeatEnded = false;
                _x2._config.log( Config.CLASS_GRID, 1 ) ? console.log( "REPEAT MODE ENDED - " + this._focusIndex ) : Config.NOP();
                this._driver._focusColTime = this._lastGridTime || new Date().getTime(); //While focus should be moved to current grid time
                this._selectable = true;
                this.gotFocus();
            }
        }
    };

    return GridRowWidget;

})();


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GridWidget = ( function()
{
    "use strict";

    GridWidget.prototype = new Widget();

    function GridWidget(){}

    GridWidget.prototype.destroy = function()
    {
        Widget.prototype.destroy.call( this );
        _x2.removeChangeCallback( this._tickWrapper );
    };

    GridWidget.prototype.filterChannels = function()
    {
        var channels, filters, i, j;

        if( _x2._channelCollection )
        {
            channels = _x2._channelCollection.getChannels();
            filters  = _x2._settings.getValue( Settings.Key.FILTERS );

            if( filters.hd || filters.cc || filters.sap || filters.dvs || this._view )
            {
                var result = [], schedules, first, last;
                var now    = new Date().getTime(), end = now + 5 * 30 * 60 * 1000;

                for( i = 0; i < channels.length; i++ )
                {
                    if( (filters.hd === false || channels[i].isHD() === true) && (this._view !== "favs" || _x2._favorites.isFavorite( channels[i] )) )
                    {
                        schedules = channels[i].getSchedules();
                        first     = -1;
                        last      = schedules.length - 1;

                        // find current schedule

                        for( j = 0; j < schedules.length; j++ )
                        {
                            if( now >= schedules[j].getStartTime() )
                                first = j;

                            if( first > -1 && end < schedules[j].getStartTime() )
                            {
                                last = j;
                                break;
                            }
                        }

                        for( j = first; j < last; j++ )
                        {
                            if( schedules[j] )
                            {
                                if( (filters.cc === false || schedules[j].isClosedCaptioned() === true) && (filters.sap === false || schedules[j].isSap() === true) && (filters.dvs === false || schedules[j].isDvs() === true) )
                                {
                                    result.push( channels[i] );
                                    break;
                                }
                            }
                        }
                    }
                }

                channels = result;
            }
        }

        return channels;
    };

    GridWidget.prototype.filtersChanged = function()
    {
        var currentId, currentCh;
        var obj      = this._list.getCurrentAndMaxIndex();
        var index    = obj.current;
        var channels = obj.rows;

        if( channels && channels.length > 0 )
        {
            currentId = channels[index].getStationId();
            currentCh = channels[index].getNumber();
        }
        else
        {
            var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );

            if( lastChannel )
            {
                currentId = lastChannel.id;
                currentCh = lastChannel.num;
            }
        }

        channels = this.filterChannels();

        this._list.setData( channels );

        if( channels && channels.length > 0 )
        {
            this._emptyMessage.hide();

            for( var i = 0; i < channels.length; i++ )
                if( channels[i].getStationId() === currentId && channels[i].getNumber() === currentCh )
                {
                    this._list.setJumpToIndex( i );
                    break;
                }
        }
        else
            this.showEmptyMessage();
    };

    GridWidget.prototype.gotFocus = function()
    {
        if( this._dataReady === true )
            this.speak( _x2.requestFocus( this._list, true ) );

        this.positionInfoWidget();
    };

    GridWidget.prototype.positionInfoWidget = function () {
        if( this._positioned !== true )
        {
            var pos = this._info.getGlobalPos();
            this._info.setX( -pos.x );
            this._info.setY( -pos.y );
            this._positioned = true;
        }
    }

    /**
     * Initializer
     * @memberof GridWidget
     * @param   {Object}  params
     * @param   {Number}  params.h       - Height in pixels
     * @param   {Boolean} params.hasInfo - Instantiate and show the program info
     * @param   {String}  params.view    - Grid view to display
     * @param   {Number}  params.w       - Width in pixels
     * @returns {GridWidget}
     */
    GridWidget.prototype.init = function( params )
    {
        var self       = this, timeParams = {}, listParams = {}, date, numCells, strs, onChannelRowReady, onChannelsLoaded, onChannelsFailed;
        var sepParams  = { w:params.w, h:ListRowWidget.DIVIDER_H, color:"#303030" };
        var dateStyle  = new Style( { color:"#8c8c8c", font:"medium", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", colorHi:"#e8e8e8" } );
        var y          = _x2.scaleValInt(66);

        Widget.prototype.init.call( this );
        this._className  = "GridWidget";
        this._selectable = true;
        this._info       = (params.hasInfo === true) ? new GridInfoWidget().init() : undefined;
        this._view       = params.view;

        this.setW( params.w );
        this.setH( params.h );

        // find the current grid start time and round down to the half hour boundry
        if( _x2._config._startTime ) // DEBUG: No CLASS_GRID ?
            date = new Date( _x2._config._startTime );
        else
            date = new Date();

        date.setMilliseconds( 0 );
        date.setSeconds( 0 );
        date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

        this._datum         = date.getTime();
        this._gridTime      = this._datum;
        this._focusColTime  = this._datum;
        this._minTime       = this._datum;
        this._refreshAt     = this._minTime + 1800 * Math.random() * 1000
        this._stepTime      = 300;
        this._index         = 0;
        console.log('REFRESH AT:', new Date(this._refreshAt));

        // create the time strings

        numCells = 480;
        strs     = new Array( numCells );

        for( var i = 0; i < numCells; i++ )
        {
            strs[i] = _x2.createTimeStr( date );
            date.setTime( date.getTime() + 30 * 60 * 1000 );
        }
        // create time list along the top of the grid

        this._dateStr = new StringWidget().init( { style:dateStyle, text:"FPO" } );
        this._dateStr.setA( 0 );
        this.setDateString( new Date(), new Date());//Set today date as default, at intial loading
        this._dateStr.addReadyCallback( function() { 
            self._dateStr.setY( (y - self._dateStr.getH()) / 2 );
            self._dateStr.setA( 1 );
        } );
        this.addWidget( this._dateStr, 3 * Style._pad );

        var requestSchedules = function( val )
        {
            if( val === undefined )
                val = 0;

            var startTime  = self._gridTime + val * 30 * 60 * 1000;
            var stopTime   = startTime + 3 * 60 * 60 * 1000;
            var nowDate    = new Date();
            var startDate  = new Date( startTime );

            self.setDateString( nowDate, startDate );

            self.requestSchedules( startTime, stopTime, nowDate.getTime() );
        };

        // put lines above and below the time bar

        this._upperTimeSep = new RectWidget().init( sepParams );
        this._lowerTimeSep = new RectWidget().init( sepParams );
        this.addWidget( this._upperTimeSep );
        this.addWidget( this._lowerTimeSep, 0, y - ListRowWidget.DIVIDER_H );

        timeParams.w                 = _x2._config._screenW;
        timeParams.h                 = _x2.scaleValInt( 60 );
        timeParams.maxIndex          = 0;
        timeParams.axis              = ListWidget.Axis.X;
        timeParams.rows              = strs;
        timeParams.stepListener      = function( val ) { self.onStepListener( val ); };
        timeParams.stepStartListener = requestSchedules;
        timeParams.stepStopListener  = requestSchedules;
        timeParams.stepTime          = this._stepTime;
        timeParams.type              = TimeCellWidget;
        this._timeList               = new ListWidget().init( timeParams );
        this.addWidget( this._timeList, 0, ListRowWidget.DIVIDER_H );
        this._timeList.suppressSelection( true );
        this._timeList.setX( _x2.scaleValInt(210) );//Add space for date string to avoid overlapping
        
        // create the list for the channel rows

        listParams.w        = params.w;
        listParams.h        = params.h - timeParams.h;
        listParams.maxIndex = Math.floor( listParams.h / new GridRowWidget().getHeightUnfocused() / 2 ) - 1;
        listParams.obj      = this;
        listParams.type     = GridRowWidget;
        listParams.inner    = true;
        listParams.stepTime = 150;
        this._list          = new ListWidget().init( listParams );
        this.addWidget( this._list, 0, y );

        if( this._info )
            this._list.addWidget( this._info );

        // when the row lays out, shift the time bar past the channel column

        onChannelRowReady = function()
        {
            self._timeList.setX( self._list._cells[0]._chanColW );
            self._timeList.setW( _x2._config._screenW - self._timeList.getGlobalPos().x );
        };

        this._list._cells[0].addReadyCallback( onChannelRowReady );

        this._emptyMessage = new EmptyMessageWidget().init( EmptyMessageWidget.Key.GRID_FILTER );
        this.addWidget( this._emptyMessage );

        if( this._view === "favs" )
        {
            var noFavsStyle = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(62), whiteSpace:"nowrap", textAlign:"center" } );
            var titleStyle  = new Style( { font:"medium" , color:"#d1d1d1", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
            var stepStyle   = new Style( { font:"bold"   , color:"#d1d1d1", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
            var textStyle   = new Style( { font:"regular", color:"#8c8c8c", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
            var w           = params.w - Style._safeRight;

            var layoutNoFavs = function()
            {
                self._favsImage.setX( _x2.scaleValInt( 675 ) - self._favsImage.getW() );
                self._favsImage.setY( _x2.scaleValInt(  40 ) + self._noFavs.getH() );

                var x = self._favsImage.getX() + self._favsImage.getW() + _x2.scaleValInt( 180 );

                self._title.setX   ( x );
                self._step1Str.setX( x );
                self._text1Str.setX( x );
                self._step2Str.setX( x );
                self._text2Str.setX( x );

                self._title.setY   ( _x2.scaleValInt( 190 ) );
                self._step1Str.setY( self._title.getY   () + self._title.getH   () + _x2.scaleValInt( 34 ) );
                self._text1Str.setY( self._step1Str.getY() + self._step1Str.getH() + _x2.scaleValInt( 13 ) );
                self._step2Str.setY( self._text1Str.getY() + self._text1Str.getH() + _x2.scaleValInt( 34 ) );
                self._text2Str.setY( self._step2Str.getY() + self._step2Str.getH() + _x2.scaleValInt( 13 ) );

                self._container.setH( self._favsImage.getY() + self._favsImage.getH() );
            };

            this._container = new Widget().init();
            this._favsImage = new ImageWidget().init( { url:_x2._config._imageRoot + "favorite.jpg", onLoad:layoutNoFavs } );
            this._noFavs    = new StringWidget().init( { style:noFavsStyle, text:"You haven't favorited any channels ..." } );
            this._title     = new StringWidget().init( { text:"How to Add Favorite Channels", style:titleStyle } );
            this._step1Str  = new StringWidget().init( { text:"STEP 1", style:stepStyle } );
            this._text1Str  = new StringWidget().init( { text:"Press the left arrow to go to the channel column.", style:textStyle } );
            this._step2Str  = new StringWidget().init( { text:"STEP 2", style:stepStyle } );
            this._text2Str  = new StringWidget().init( { text:"Select a channel, then add it as a Favorite.", style:textStyle } );

            this._noFavs.setW( w );
            this._container.setW( w );
            this._container.setA( 0 );

            this._container.addWidget( this._favsImage );
            this._container.addWidget( this._noFavs );
            this._container.addWidget( this._title );
            this._container.addWidget( this._step1Str );
            this._container.addWidget( this._text1Str );
            this._container.addWidget( this._step2Str );
            this._container.addWidget( this._text2Str );
            this.addWidget( this._container, 0, _x2.scaleValInt( 90 ) );
        }

        // create the distractor used while data is loading

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnScreen(self); } );
        this.addWidget( this._distractor );

        // get a global tick every minute to check when the grid needs to advance at the half hour

        this._tickWrapper = function() { self.tick(); };
        _x2.addChangeCallback( this._tickWrapper );

        // get the grid channel data

        onChannelsLoaded = function()
        {
            if( !_x2._channelCollection.getChannels().length )
            {
                console.error( "No channels loaded!?" );
                self.setElementVisibility();
            }

            var onScheduleBlock = function()
            {
                self.setChannels();
                self._dataReady = true;

                self.setDateString( new Date(), new Date( self._gridTime ) );// date should be set after element get visibility

                var whichTab = "Live TV: All Channels";
                var millisecondsLoadDuration = new Date() - self._timePageLoadStart; // Localytics
                window.ll( "tagEvent", "LiveTV Load Time", { "Duration": millisecondsLoadDuration } );
                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "LiveTV All, Page Load duration: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();

                _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.info( "Telemetry: Load Time:" + whichTab + ", Load Time: " + millisecondsLoadDuration + " (ms)" ) : Config.NOP();
                _x2._telemetry.sendScreenLoadTime( millisecondsLoadDuration, whichTab );

                self._distractor.hide();

                if( _x2._focus === self )
                    self.speak( _x2.requestFocus( self._list, true ) );
            };

            _x2._channelCollection.fetch( self._gridTime, self._gridTime + 3 * 60 * 60 * 1000).then( onScheduleBlock ).catch( onChannelsFailed );
        };

        onChannelsFailed = function( error )
        {
            self._list.setA(0);
            self._distractor.hide();
            self._emptyMessage.setMessage( EmptyMessageWidget.Key.GRID_ERROR );
            self._emptyMessage.show();

            console.error( error.toString() );
        };

        
        self._distractor.show();
        if( self._gridTime > this._refreshAt ) {
            _x2.refreshFavorites(); //.then( onRefresh );
        }
        _x2._channelCollection && _x2._channelCollection.fetch( self._gridTime ).then( onChannelsLoaded, onChannelsFailed );
        this._timePageLoadStart = new Date(); // Localytics

        return this;
    };

    GridWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        if( this._list )
            this._list.setH( val );
    };

    GridWidget.prototype.onHideInfo = function( requestFocus )
    {
        var self = this;
        this._localyticsFirstTimeCellInfo = false;

        if( this._info )
        {
            this._infoShowing = false;
            this._list.suppressSelection( false );

            if( requestFocus === true )
            {
                this._info.animate( { a:0, duration:500, onEnd: function() { self._info.unsetEntity(requestFocus) } } );
                var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );
                var gridHasLastChannel = false;
                for( var i = 0; i < this._list._cells.length; i++ ) {
                    if( this._list._cells[i]._channel && lastChannel &&
                        (this._list._cells[i]._channel.getNumber() == lastChannel.num ) ) {
                            gridHasLastChannel = true;
                        break;
                    }
                }
                if( !gridHasLastChannel ) {
                    this.setChannels();
                }
                _x2.requestFocus( this );
            }
            else
            {
                this._info.setA( 0 );
                this._info.unsetEntity( requestFocus );
            }
        }
    };

    GridWidget.prototype.setElementVisibility = function( channels )
    {
        if( channels === undefined || channels.length === 0 )
        {
            if( _x2._favorites.hasChannelFavorites() === false )
            {
                this._timeList.setA( 0 );
                this._upperTimeSep.setA( 0 );
                this._lowerTimeSep.setA( 0 );
                this._dateStr.setA( 0 );

                if( this._container )
                {
                    this._container.setA( 1 );
                    this._emptyMessage.hide();
                }
                else
                    this.showEmptyMessage();
            }
            else
            {
                this.showEmptyMessage();

                if( this._container )
                    this._container.setA( 0 );
            }
        }
        else
        {
            this._emptyMessage.hide();
            this._timeList.setA( 1 );
            this._upperTimeSep.setA( 1 );
            this._lowerTimeSep.setA( 1 );
            this._dateStr.setA( 1 );
            if( this._container )
                this._container.setA( 0 );
        }
    };

    GridWidget.prototype.setProgramInfo = function( showing, channel, isChannel )
    {
        var self = this, success, error;
        var onMetrics = function()
        {
            // Normally this would reside in `onShowInfo()` but since w don't have the recording information
            // we would need to use `showing.getDetail().then( onDetails )` -- however this introduces
            // an extra network trip.
            // In `setProgramInfo()` we have the data to tell if this program is/has a scheduled recording
            // but one minor caveat is that the user can press up/down in the program modal dialog
            // re-triggering sending the metrics data.
            if( !self._localyticsFirstTimeCellInfo )
            {
                var title    = showing.getTitle();
                var start    = showing.getStartTime();
                var end      = showing.getEndTime();
                var duration = end - start;
                var metrics  =
                {
                    "Channel"  : channel.getNumber(),
                    "Title"    : title,
                    "Start"    : start,
                    "End"      : end,
                    "Duration" : duration,
                    "Scheduled": showing.isRecorded() ? 'yes' : 'no'
                };

                self._localyticsFirstTimeCellInfo = true;
                window.ll( "tagEvent", "Cell Info LiveTV", metrics ); // Localytics 2.3.3
                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Cell Info: %o", metrics ) : Config.NOP();
            }
        };

        this._info.unsetEntity(false);

        success = function( data )
        {
            onMetrics();
            self._info.setEntity( data, channel, self._list.getCurrentAndMaxIndex(), isChannel );
        };

        error = function( error )
        {
            onMetrics();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.GUIDE } ) );
        };

        if( showing.isTbd() )
            success( showing );
        else
            showing.getDetail().then( success ).catch( error );
    };

    // @param {LinearShowing} showing
    // @param {Channel} channel
    GridWidget.prototype.onShowInfo = function( showing, channel, isChannel )
    {
        this.positionInfoWidget();
        
        if( this._info && this._infoShowing !== true )
        {
            this._infoShowing = true;
            this._list.suppressSelection( true );
            this._info.animate( { a:1, duration:500 } );
            _x2.requestFocus( this._info );

            this.setProgramInfo( showing, channel, isChannel );
        }
    };

    GridWidget.prototype.onStepListener = function( val )
    {
        this._gridTime = this._datum + val * 30 * 60 * 1000;
        var nextStepDate = new Date(this._gridTime);
        // we should not update date for every step, it should be update near 23:58 to 00:03
        if( ( nextStepDate.getHours() == 0 && nextStepDate.getMinutes() < 3 ) || (nextStepDate.getHours() == 23 && nextStepDate.getMinutes() > 58 ) ) {
            if( nextStepDate.getHours() == 0 && nextStepDate.getMinutes() == 0 ) {
                this.setDateString( new Date(), nextStepDate );        
            }
        } else { //if it continue scrolling, then so we need to update after 200 ms to avoid date str get jump back and forth
            window.setTimeout( function() {
                var nextStepDate = new Date(this._gridTime);
                if( this._dateStr ) {
                    var displayDate = new Date(this._dateStr._timeStamp);
                    if( displayDate.getDate() != nextStepDate.getDate() ) {
                        this.setDateString(new Date(), nextStepDate);
                    }
                }
            }.bind(this), 500);
        }
    };

    GridWidget.prototype.onUpdateInfo = function( showing, channel, isChannel )
    {
        if( this._infoShowing )
            this.setProgramInfo( showing, channel, isChannel );

        return !this._infoShowing;
    };

    GridWidget.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LAST:
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && this._infoShowing === true )
                    this.onHideInfo( true );
                else
                    retval = Screen.prototype.processEvent.call( this, val, type );
                break;

            case Host.KEY_LEFT:
                if( this._gridTime > this._minTime )
                    this._timeList.processEvent( val, type );
                break;

            case Host.KEY_RIGHT:
                this._timeList.processEvent( val, type );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    GridWidget.prototype.setChannels = function()
    {
        var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );
        var channels = this.filterChannels();

        this._list.setData( channels );

        if( lastChannel && channels )
            for( var i = 0; i < channels.length; i++ )
                if( channels[i].getStationId() === lastChannel.id && channels[i].getNumber() === lastChannel.num )
                {
                    this._list.setJumpToIndex( i );
                    break;
                }

        this.setElementVisibility( channels );
    };

    GridWidget.prototype.refresh = function( screen )
    {
        var lastOverlayScreen = _x2._overlayRoot.getTop();
        var lastScreen = _x2._screenRoot.getTop();
        if( lastOverlayScreen instanceof PinOverlay || lastScreen instanceof VideoScreen ) {
            if( lastScreen instanceof VideoScreen ) {
                var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );
                var entity = ( this._info._detail && this._info._detail._data );
                if( entity && (entity.getChannel().getNumber() !== lastChannel.num) ) {
                    this.onHideInfo( false );
                }
                this.setChannels();
            }
            return false;
        }//pin overlay screen is display, then we should not hide the grid info widget and set data for grid
        this.onHideInfo( false );
        this._list.setData();

        if( screen && this._info._actionButtons.containsWidget( screen._lastFocus ) )
            screen._lastFocus = this;

        var date = new Date();
        date.setMilliseconds( 0 );
        date.setSeconds( 0 );
        date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

        if( date.getTime() > this._gridTime )
        {
            this._datum         = date.getTime();
            this._gridTime      = this._datum;
            this._focusColTime  = this._datum;
            this._minTime       = this._datum;

            this.setTimeList( date );
            this.setDateString( date, date );
            this.requestSchedules( this._gridTime, this._gridTime + 3 * 60 * 60 * 1000 );
        }

        this.setChannels();
    };

    GridWidget.prototype.requestSchedules = function( startTime, endTime )
    {
        var self = this;
        var resetChannels = ( _x2._channelCollection === undefined );

        if( this._distractorCount === undefined )
            this._distractorCount = 0;

        var onScheduleBlock = function()
        {
            self._distractorCount--;
            var loadedBlocked = _x2._channelCollection._loadedBlocks;
            if( self._distractorCount < 1 )
            {
                self._distractor.hide();
                self._dataReady = true;
                if( resetChannels )
                    self.setChannels();
            }
        };

        this._distractorCount++;

        if( this._distractorCount < 2 )
        {
            this._dataReady = false;
            this._distractor.show();
        }

        _x2.fetchChannelCollection().then( function() {
            _x2._channelCollection.fetch( startTime, endTime ).then( onScheduleBlock );
        } );
    };

    GridWidget.prototype.setDateString = function( nowDate, startDate )
    {
        var startMonth = startDate.getMonth() + 1;
        var startDay   = startDate.getDate();
        var str        = ( (startMonth === (nowDate.getMonth()+1) && startDay === nowDate.getDate()) ? "Today " : "" ) + startMonth + "/" + startDay;
        this._dateStr._timeStamp = startDate; 
        this._dateStr.setText( str );
    };

    GridWidget.prototype.showEmptyMessage = function()
    {
        var filters = _x2._settings.getValue( Settings.Key.FILTERS );

        if( filters.hd === true || filters.cc === true || filters.dvs === true || filters.sap === true )
            this._emptyMessage.setMessage( EmptyMessageWidget.Key.GRID_FILTER );
        else
            this._emptyMessage.setMessage( EmptyMessageWidget.Key.GRID_EMPTY );

        this._emptyMessage.show();
    };

    GridWidget.prototype.setJumpToChannel = function( channel )
    {
        var currentId = channel.getStationId();
        var currentCh = channel.getNumber();
        var channels  = this.filterChannels();
        var jumpSet   = false;

        if( channels && channels.length > 0 )
        {
            this._emptyMessage.hide();

            for( var i = 0; i < channels.length; i++ )
                if( channels[i].getStationId() === currentId && channels[i].getNumber() === currentCh )
                {
                    this._list.setJumpToIndex( i );
                    jumpSet = true;
                    _x2._telemetry.setWatchButton( "Live TV: All Channels" );
                    break;
                }

            if( jumpSet === false )
                this._list.setJumpToIndex( 0 );
        }
        else
            this.showEmptyMessage();
    };

    GridWidget.prototype.setTimeList = function( date )
    {
        var numCells = 480;
        var strs     = new Array( numCells );
        var millis   = date.getTime();

        for( var i = 0; i < numCells; i++ )
        {
            strs[i] = _x2.createTimeStr( date );
            date.setTime( millis + (i+1) * 30 * 60 * 1000 );
        }
        this._timeList.setData( strs );
    };

    GridWidget.prototype.speak = function( focus )
    {
        if( focus )
        {
            var hint = "Press arrows to review listings. Press OK for program details. Press back to return to Live TV menu.";
            this._distractor.setSpeechParams( focus._speakStr + hint, focus._speakRole, this, false );
        }
        else
            this._distractor.setSpeechParams( this._emptyMessage.getSpeechText(), undefined, this, false );
    };

    /**
     * @memberof GridWidget
     */
    GridWidget.prototype.tick = function()
    {
        var current, now, refreshTime;
        var date  = new Date();
        var time  = date.getTime();
        var index = this._list.getCurrentAndMaxIndex().current;

        if( time > this._refreshAt )
        {
            date.setMilliseconds( 0 );
            date.setSeconds( 0 );
            date.setHours(date.getMinutes() < 30 ? date.getHours() : date.getHours() + 1);
            date.setMinutes(date.getMinutes() < 30 ? 30 : 0 );

            refreshTime = date.getTime();
            this.requestSchedulesWithDelay(refreshTime);
            this._refreshAt = refreshTime + 1800 * Math.random() * 1000
            console.log('REFRESH AT:', new Date(this._refreshAt));
        }

        if( time > this._minTime + 1800000 )
        {
            date.setMilliseconds( 0 );
            date.setSeconds( 0 );
            date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

            now = date.getTime();

            if( this._gridTime < now )
            {
                this._datum        = now;
                this._gridTime     = this._datum;
                this._focusColTime = this._datum;
                this._minTime      = this._datum;

                this.setDateString( date, date );
                this.setTimeList( date );
                this.requestSchedulesWithDelay(this._gridTime);

                var channels = this.filterChannels();

                this._list.setA( 1 );
                this._list.setData( channels );
                this._list.setJumpToIndex( index );

                if( channels && channels.length > 0 )
                    this._emptyMessage.hide();
                else
                    this.showEmptyMessage();
            }
        }

        if( this._infoShowing )
        {
            var showing   = this._info.getShowing();
            var channel   = this._info.getChannel();
            var isChannel = this._info.getIsChannel();

            if( channel ) //TODO: we're hitting this path where showing/channel are undefined. Guard for now and investigate.
            {
                var schedules = channel.getSchedules();

                date = new Date();
                date.setMilliseconds( 0 );
                date.setSeconds( 0 );

                now = date.getTime();

                if( showing.getStartTime() < now )
                {
                    for( var i = 0; i < schedules.length; i++ )
                        if( schedules[i].getEndTime() > now )
                        {
                            current = schedules[i];
                            break;
                        }

                    if( current && ( current.getEntityId() !== showing.getEntityId() ) )
                        this.setProgramInfo( current, channel, isChannel );
                }
                else if( showing.getStartTime() === now )
                    this.setProgramInfo( showing, channel, isChannel );
            }
        }
    };
    /* 
    * Before requesting the tvgrid/chunks api, check the current screen
    * if it is not all channels or favourite page, then request tvgrids with delay
    * if it is in all channels page, then request tvgrids for favourite page after 2.5 seconds
    * if it is favourite channels page, then request tvgrids for all channel page after 2.5 seconds
    */
    GridWidget.prototype.requestSchedulesWithDelay = function(startTime) {
        var guideScreen = _x2._screenRoot._children.filter( function(child){
            return (child instanceof GuideScreen);
        });
        var isAllChannelsGrid = (guideScreen[0] && guideScreen[0]._activeWidget instanceof GridListingsWidget);
        var isFavouriteChannelsGrid = (guideScreen[0] && guideScreen[0]._activeWidget instanceof GridListingsFavoritesWidget);
        if( (!isAllChannelsGrid && !isFavouriteChannelsGrid) || 
            (isAllChannelsGrid && this._parent instanceof GridListingsFavoritesWidget) || 
            (isFavouriteChannelsGrid && this._parent instanceof GridListingsWidget)) {
            window.setTimeout( function(){
                this.requestSchedules(startTime, startTime + 3 * 60 * 60 * 1000 );
            }.bind(this), 2500); 
        }  else {
            this.requestSchedules(startTime, startTime + 3 * 60 * 60 * 1000 );
        }
    }
    return GridWidget;

})();


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GuideViewRowWidget = ( function()
{
    "use strict";

    GuideViewRowWidget.prototype = new CollectionRowWidget();

    function GuideViewRowWidget(){}

    GuideViewRowWidget.prototype.init = function( params )
    {
        params.type = GalleryCellWidget;
        params.y    = _x2.scaleVal( 160 ) - _x2.scaleVal( 12 );
        params.h    = _x2.scaleValInt( 530 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "GuideViewRowWidget";

        var style = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        this._gvrwEmpty = new StringWidget().init( { style:style } );
        this._gvrwEmpty.setA( 0 );
        this.addWidget( this._gvrwEmpty );

        return this;
    };

    GuideViewRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 690 );
    };

    GuideViewRowWidget.prototype.setData = function( data )
    {
        CollectionRowWidget.prototype.setData.call( this, data );

        if( data )
        {
            if( data.getEntities().length === 0 )
            {
                this._gvrwEmpty.setText( data.getEmptyString() );
                this._gvrwEmpty.setY( this._title.getY() + this._title.getH() + 3 * Style._pad );
                this._gvrwEmpty.setA( 1 );
            }
            else
                this._gvrwEmpty.setA( 0 );
        }
    };

    return GuideViewRowWidget;

})();


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Menu with round buttons. Always visible.
 * @class
 * @see HorizMenuWidget
 * @see TabbedPillButtonsWidget
 */
window.HorizPillButtonsWidget = ( function()
{
    "use strict";

    HorizPillButtonsWidget.prototype = new Widget();

    function HorizPillButtonsWidget(){}

    HorizPillButtonsWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        Widget.prototype.gotFocus.call( this, losingFocus );

        var customSpeakRole = this.getSpeechCustomRole();

        if( this._entries )
        {
            this._entries[this._index].gotFocus();
            this._entries[this._index].setSpeechParams( undefined, customSpeakRole ? customSpeakRole : "button", this, newScreen );
        }

        _x2._hi.fadeOut();

        if( this._layoutDone )
            this.setHighlight( 0 );

        return this;
    };

    /**
     * Initializer.
     * <p>
     * Handles LEFT, RIGHT, ENTER, DOWN navigation keypresses
     * <p>
     * @memberof HorizPillButtonsWidget
     * @param   {Object}    params
     * @param   {Number}   [params.index]   - initial index to receive focus
     * @param   {Widget[]} (params.entries) - must support `onEnter`
     * @param   {Number}    params.spacing
     * @param   {Number}    params.scrollW - width at which the buttons will start to scroll left
     * @returns {HorizPillButtonsWidget}
     * @example
     *
     * var doEnter = function() { .. };
     * var text1   = new StringWidget().init( ..., onEnter:doEnter );
     * var text2   = new StringWidget().init( ..., onEnter:doEnter );
     * var items   = [ text1, text2 ];
     * var menu    = new HorizPillButtonsWidget().init( { entries: items, spacing: _x2.scaleValInt(#) } );
     */
    HorizPillButtonsWidget.prototype.init = function( params )
    {
        var i, onClick, self = this;

        Widget.prototype.init.call( this, params );
        this._className  = "HorizPillButtonsWidget";
        this._selectable = true;

        this._panel = new Widget().init();
        this.addWidget( this._panel );
        this._numReady   = 0;
        this._entries    = params.entries;
        this._spacing    = params.spacing ? params.spacing : 0;
        this._scrollW    = params.scrollW;
        this._index      = params.index ? params.index : 0;
        this._showing    = false;

        if( this._entries )
            this._entries[0].addReadyCallback( function() { self.layout(); } );

        this._hi = new SelectionWidget().init( { url:_x2._config._imageRoot + Style._pillHiFile } );
        this._hi.setA( 0 );
        this._panel.addWidget( this._hi );
        this._xInset = this._hi.getInsetX();

        if( this._entries )
        {
            for( i = 0; i < this._entries.length; i++ ) {
                this._entries[i].setA(0);
                this._panel.addWidget( this._entries[i] );
            }
        }

        onClick = function( evt )
        {
            var i, x = evt.offsetX;

            evt.stopPropagation();

            for( i = 0; i < self._entries.length; i++ )
            {
                if( x >= self._mouseStart[i] && x <= self._mouseStop[i] )
                {
                    console.log( self._entries[i] );

                    if( self._entries[i].hasFocusListener() === true )
                    {
                        if( _x2._focus === self )
                        {
                            if( i === self._index )
                            {
                                if( !self._isDisabled )
                                    self._entries[i].onEnter();
                            }
                            else
                            {
                                self._entries[self._index].lostFocus();
                                self._index = i;
                                self._entries[i].gotFocus();
                                self.setHighlight();
                            }
                        }
                        else
                        {
                            console.error( "DOES NOT HAVE FOCUS" );  // don't think we have this case anywhere
                        }
                    }
                    else
                    {
                        if( !self._isDisabled )
                            self._entries[i].onEnter();
                    }
                    break;
                }
            }
        };

        this.setMouseDownListener( onClick );

        return this;
    };

    HorizPillButtonsWidget.prototype.layout = function()
    {
        var i, x, w, h, delta;

        this._mouseStart = [];
        this._mouseStop  = [];

        x     = this._xInset + Style._pad / 2;
        delta = this._xInset + this._spacing + Style._pad;

        for( i = 0; i < this._entries.length; i++ )
        {
            this._entries[i].setA(1);
            this._entries[i].setX( x );
            this._entries[i].setY( this._hi.getY() + (this._hi.getH() - this._entries[i].getH()) / 2 );
            this._mouseStart[i] = x - delta / 3;
            x += this._entries[i].getW() + delta;
            this._mouseStop[i] = x - delta * 2 / 3;
        }

        w = x - this._spacing - Style._pad / 2;
        h = this._hi.getH();

        this._panel.setW( w );
        this._panel.setH( h );
        this.setW( w );
        this.setH( h );

        //if we've patched new buttons, don't try to select an out of range index
        if( this._index > this._entries.length - 1 )
        {
            this._index = this._entries.length - 1;
            this.setHighlight();
        }
        else if( _x2._focus === this )
            this.setHighlight( 0, true );

        this._hi.setW( this._entries[this._index].getW() + Style._pad );

        this.callbackSignalReady();

        this._layoutDone = true;
    };

    HorizPillButtonsWidget.prototype.lostFocus = function( gettingFocus )
    {
        Widget.prototype.lostFocus.call( this, gettingFocus );

        this._hi.stopAnimation( Widget.ALPHA );
        this._hi.animate( { alpha:0, duration:300 } );

        if( this._entries )
            this._entries[this._index].lostFocus();
    };

    HorizPillButtonsWidget.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( ! this._isDisabled && this._entries )
                        this._entries[this._index].onEnter();
                }
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index > 0 )
                    {
                        this._entries[this._index--].lostFocus();
                        this._entries[this._index].gotFocus();
                        this.setHighlight();
                    }
                    else
                        retval = Widget.prototype.processEvent.call( this, val, type );
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._entries && this._index < this._entries.length - 1 )
                    {
                        this._entries[this._index++].lostFocus();
                        this._entries[this._index].gotFocus();
                        this.setHighlight();
                    }
                    else
                        retval = Widget.prototype.processEvent.call( this, val, type );
                }
                break;

            default:
                retval = Widget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    HorizPillButtonsWidget.prototype.setButtons = function( buttons )
    {
        var i;
        var customSpeakRole = this.getSpeechCustomRole();

        if( this._entries )
        {
            for( i=0; i<this._entries.length; i++ )
                this._panel.removeWidget( this._entries[i] )
        }

        this._entries = buttons;
        this._index   = 0;

        for( i=0; i<this._entries.length; i++ )
            this._panel.addWidget( this._entries[i] );

        this._panel.patchWidget();
        this.layout();

        if( _x2._focus === this )
        {
            this.setHighlight( 0 );
            this._entries[this._index].gotFocus();
            this._entries[this._index].setSpeechParams( undefined, customSpeakRole ? customSpeakRole : "button", this, false );
        }
    };

    HorizPillButtonsWidget.prototype.setDisabled = function( isDisabled )
    {
        this._isDisabled = isDisabled;
    };

    HorizPillButtonsWidget.prototype.setHighlight = function( duration, newScreen )
    {
        var self = this;

        var onEnd = function()
        {
            if( self._scrollW )
                onInc();

            var customSpeakRole = self.getSpeechCustomRole();
            self._entries[self._index].setSpeechParams( undefined, customSpeakRole ? customSpeakRole : "button", self, newScreen );
        };

        var onInc = function()
        {
            var xx = self._scrollW - self._hi.getX() - self._hi.getW();
            self.setX( xx < 0 ? xx : 0 );
        };

        var obj =
        {
            x         : this._entries[this._index].getX() - this._xInset - Style._pad / 2,
            w         : this._entries[this._index].getW() + Style._pad,
            duration  : duration!==undefined?duration:300,
            onEnd     : onEnd,
            onEndAxis : Widget.Axis.X
        };

        if( _x2._focus === this )
        {
            this._hi.stopAnimation( Widget.ALPHA );
            obj.a = 1;
        }

        if( this._scrollW )
            obj.onInc = onInc;

        if( this._entries )
            this._hi.animate( obj );
    };

    return HorizPillButtonsWidget;

})();


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

// TODO
// - remove and insert entries, all entries must be in init function
// - repeat scrolling

/**
 * Horizontal Menu Bar with optional '<' and '>' if more items can fit that are visible
 * @class
 * @see HorizPillButtonsWidget
 * @see TabbedPillButtonsWidget
 */
window.HorizMenuWidget = ( function()
{
    "use strict";

    HorizMenuWidget.prototype = new Widget();

    function HorizMenuWidget(){}

    HorizMenuWidget.prototype.gotFocus = function()
    {
        this.setHighlight();
    };

    /**
     * Initializer
     * <p>
     * Handles LEFT, RIGHT, ENTER, navigation keypresses
     * @memberof HorizMenuWidget
     * @param   {Object}    params
     * @param   {Widget[]}  params.entries        - Widgets to display
     * @param   {Number}    params.spacing        - Spacing between menu items in pixels
     * @param   {Boolean}  [params.flex=0]        - true if we should nudge the menu items spacing to fit
     * @param   {Function}  params.onEntryChanged - Callback
     * @param   {Number}    params.w              - Total width all menu items need to fit within
     * @param   {Number}    params.h              - Total height of menu bar
     * @returns {HorizMenuWidget}
     */
    HorizMenuWidget.prototype.init = function( params )
    {
        var self = this, i, onPointDown;
        var entryLoaded = function() { self._numLoaded++; self.layout(); };

        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "HorizMenuWidget";

        Widget.prototype.init.call( this, params );

        this._entries = params.entries;
        this._spacing = params.spacing;
        this._flex    = params.flex;
        this._onEntryChanged = params.onEntryChanged;

        this._rect = new RectWidget().init( { w:params.w, h:0, borderColor:"#363636", borderThickness:[ 2, 0, 2, 0] } );
        this.addWidget( this._rect );

        this._strip = new Widget().init( { name:"Strip" } );

        this._scroll = new ScrollWidget().init( { widget:this._strip, w:params.w, h:params.h } );
        this._rect.addWidget( this._scroll );

        this._moreLeft  = new ImageWidget().init( { url:_x2._config._imageRoot + "moreLeft.png" , onLoad:entryLoaded } );
        this._moreRight = new ImageWidget().init( { url:_x2._config._imageRoot + "moreRight.png", onLoad:entryLoaded } );

        this._moreLeft.setVal ( Widget.ALPHA, 0 );
        this._moreRight.setVal( Widget.ALPHA, 0 );

        this.addWidget( this._moreLeft  );
        this.addWidget( this._moreRight );

        if( _x2._config._cursorEnabled === true )
        {
            onPointDown = function( index )
            {
                return function( event )
                {
                    event.stopPropagation();

                    if( self._onEntryChanged && index !== self._index )  // has a change listener
                    {
                        if( _x2._focus === self )
                            self._entries[self._index].lostFocus();

                        self._index = index;

                        var deltaX = self._maxHiX - self._entries[self._index].getVal( Widget.X );

                        if( deltaX > 0 )
                            deltaX = 0;

                        if( deltaX === 0 )
                            self._moreLeft.animate( { alpha:0, duration:Config.ANI_TIME_HORIZ_MENU } );
                        else
                            self._moreLeft.animate( { alpha:1, duration:Config.ANI_TIME_HORIZ_MENU } );

                        if( (self._strip.getVal( Widget.W ) + deltaX) > self.getVal( Widget.W ) )
                            self._moreRight.animate( { alpha:1, duration:Config.ANI_TIME_HORIZ_MENU } );
                        else
                            self._moreRight.animate( { alpha:0, duration:Config.ANI_TIME_HORIZ_MENU } );

                        self._scroll.setScroll( { x:deltaX, duration:Config.ANI_TIME_HORIZ_MENU } );

                        if( _x2._focus === self )
                        {
                            self._entries[self._index].gotFocus();
                            self.setHighlight();
                        }
                        else
                            _x2.requestFocus( self );
                    }
                    else  // call select
                    {
                        if( self._entries[index].onEnter() )
                            self._entries[index].onEnter();
                    }
                };
            };
        }

        this._numLoaded = 0;

        for( i = 0; i < this._entries.length; i++ )
        {
            this._entries[i].addReadyCallback( entryLoaded );
            this._entries[i].setVal( Widget.ALPHA, 0 );
            this._strip.addWidget( this._entries[i] );

            if( _x2._config._cursorEnabled === true )
                this._entries[i].setMouseDownListener( onPointDown( i ) );
        }

        this._index      = 0;
        this._selectable = true;

        this.setVal( Widget.W, params.w );

        return this;
    };

    HorizMenuWidget.prototype.layout = function()
    {
        var onExpanded, i, maxH = 0, x = 0, self = this, actW, maxW, spaceDelta, ratio, widget;

        if( this._numLoaded === (this._entries.length + 2) )
        {
            for( i = 0; i < this._entries.length; i++ )
                if( this._entries[i].getVal( Widget.H ) > maxH )
                    maxH = this._entries[i].getVal( Widget.H );

            maxH += 4 * Style._pad;

            this.setVal( Widget.H, maxH );

            for( i = 0; i < this._entries.length; i++ )
            {
                this._entries[i].setVal( Widget.X, x );
                this._entries[i].setVal( Widget.Y, (maxH - this._entries[i].getVal( Widget.H )) / 2 );

                x += this._entries[i].getVal( Widget.W ) + this._spacing;
            }

            this._moreLeft.setVal ( Widget.X, -this._moreLeft.getVal( Widget.W ) - Style._pad );
            this._moreLeft.setVal ( Widget.Y, (maxH - this._moreLeft.getVal ( Widget.H )) / 2 );
            this._moreRight.setVal( Widget.X, this.getVal( Widget.W ) + Style._pad );
            this._moreRight.setVal( Widget.Y, (maxH - this._moreRight.getVal( Widget.H )) / 2 );

            if( this._flex !== undefined )
            {
                maxW = this.getVal( Widget.W );
                actW = x - this._spacing;

                ratio = actW / maxW;

                if( ratio >= (1 - this._flex) && ratio <= (1 + this._flex ) )
                {
                    spaceDelta = (this.getVal( Widget.W ) - x + this._spacing) / (this._entries.length - 1);
                    x          = 0;

                    for( i = 0; i < this._entries.length - 1; i++ )
                    {
                        this._entries[i].setVal( Widget.X, x );
                        x += this._entries[i].getVal( Widget.W ) + this._spacing + spaceDelta;
                    }

                    this._entries[i].setVal( Widget.X, this.getVal( Widget.W ) - this._entries[this._entries.length-1].getVal( Widget.W ) );
                }
            }

            widget = this._entries[this._entries.length-1];

            this._strip.setVal( Widget.W, widget.getVal( Widget.X) + widget.getVal( Widget.W ) );
            this._strip.setVal( Widget.H, maxH );
            this._scroll.setVal( Widget.H, maxH );

            if( this._strip.getVal( Widget.W ) > this.getVal( Widget.W ) )
                this._moreRight.setVal( Widget.ALPHA, 1.0 );

            if( this._strip.getVal( Widget.W ) === this.getVal( Widget.W ) )
                this._maxHiX = this.getVal( Widget.W );
            else if( this._entries.length > 2 )
                this._maxHiX = this._entries[2].getVal( Widget.X );

            onExpanded = function ()
            {
                for( i = 0; i < self._entries.length; i++ )
                    self._entries[i].animate( { alpha:1, start:i*50, duration:500 } );

                if( _x2._focus === self )
                {
                    self._entries[self._index].animate( { color:"#2ea0dd", duration:500 } );
                    self.setHighlight( 0 );
                }
            };

            this._rect.animate( { h:maxH, duration:300, onEnd:onExpanded } );
        }
    };

    HorizMenuWidget.prototype.processEvent = function( val, type )
    {
        var retval = true;
        var deltaX;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                    this._entries[this._index].onEnter();
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index > 0 )
                    {
                        deltaX = this._maxHiX - this._entries[this._index-1].getVal( Widget.X );

                        if( deltaX > 0 )
                            deltaX = 0;

                        if( deltaX <= 0 )
                            this._scroll.setScroll( { x:deltaX, duration:Config.ANI_TIME_HORIZ_MENU } );

                        if( deltaX === 0 )
                            this._moreLeft.animate( { alpha:0, duration:Config.ANI_TIME_HORIZ_MENU } );

                        if( (this._strip.getVal( Widget.W ) + deltaX) > this.getVal( Widget.W ) )
                            this._moreRight.animate( { alpha:1, duration:Config.ANI_TIME_HORIZ_MENU } );

                        this._entries[this._index--].lostFocus();
                        this._entries[this._index].gotFocus();
                        this.setHighlight();
                    }
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index < this._entries.length - 1 )
                    {
                        deltaX = this._maxHiX - this._entries[this._index+1].getVal( Widget.X );

                        if( deltaX < 0 )
                        {
                            this._scroll.setScroll( { x:deltaX, duration:Config.ANI_TIME_HORIZ_MENU } );
                            this._moreLeft.animate( { alpha:1, duration:Config.ANI_TIME_HORIZ_MENU } );
                        }

                        if( (this._strip.getVal( Widget.W ) + deltaX) <= this.getVal( Widget.W ) )
                            this._moreRight.animate( { alpha:0, duration:Config.ANI_TIME_HORIZ_MENU } );

                        this._entries[this._index++].lostFocus();
                        this._entries[this._index].gotFocus();
                        this.setHighlight();
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    HorizMenuWidget.prototype.setHighlight = function( time )
    {
        var obj    = this.getGlobalPos();
        var entryX = this._entries[this._index].getVal( Widget.X );

        obj.x       += ((entryX > this._maxHiX) ? this._maxHiX : entryX);
        obj.y       += 2;
        obj.w        = this._entries[this._index].getVal( Widget.W );
        obj.h        = this.getVal( Widget.H );
        obj.inner    = false;
        obj.duration = (time === undefined) ? 300 : 0;

        _x2._hi.setPosition( obj );
    };

    return HorizMenuWidget;

})();


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.HorizSelectionWidget = (function()
{
    "use strict";

    HorizSelectionWidget.prototype = new Widget();

    function HorizSelectionWidget(){}

    HorizSelectionWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        for( var i=0; i<this._strings.length; i++ )
            this._strings[i].gotFocus();

        if( this._index < this._strings.length-1 )
            this._chevronRight.animate({alpha:1, duration:600});

        if( this._index > 0 )
            this._chevronLeft.animate({alpha:1, duration:600});

        this.setHighlight();
        this._strings[this._index].setSpeechParams( undefined, undefined, this, newScreen );

        return this;
    };

    /**
     * Initialize the widget. Note that there are two ways to set the selected option: (1) the 'default' parameter
     * passing the index of the selected entry, and (2) adding the selected:true pair to any of the entries
     * @param {Object}    params
     * @param {Number}    params.width         - widget width.
     * @param {Number}   [params.height]       - widget height.
     * @param {Array<{}>} params.entries       - the collection of objects to present
     * @param {*}         params.entries.key   - the key value of the entry
     * @param {String}    params.entries.label - the entry label to be displayed
     * @param {*}        [params.entries.obj]  - the object that will be passed in the callback when a change occurs. If omitted, key will be passed to callback.
     * @param {Number}   [params.defaultIndex] - set the default selected index
     * @param {*}        [params.defaultValue] - set the value of default selected entry
     * @param {Function}  params.onChange      - callback called passing selected 'key' (from param.entries) when the selection changes
     */
    HorizSelectionWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );

        this._className = "HorizSelectionWidget";
        this._fontSize  = _x2.scaleValInt(30);

        this.setW( params.width );
        this.setH( params.height ? params.height : _x2.scaleValInt(110) );

        var self  = this;
        var style = new Style( { font:"medium" , color:"#d0d0d0", colorHi:"#2b9cd8", fontSize:this._fontSize, whiteSpace:"nowrap"} );
        var obj, key, label, defaultVal;

        this._index      = 0;
        this._onChange   = params.onChange;
        this._selectable = true;

        this._objs         = [];
        this._strings      = [];
        this._scrollWidget = new Widget().init();

        if( params.defaultIndex >= 0 )
            this._index = params.defaultIndex;
        else if( params.defaultValue !== undefined )
            defaultVal = params.defaultValue;

        for( var i=0; i<params.entries.length; i++ )
        {
            key   = params.entries[i].key;
            label = params.entries[i].label;
            obj   = ( params.entries[i].obj ? params.entries[i].obj : key);

            this._objs[i]    = obj;
            this._strings[i] = new StringWidget().init({ style:style, text:label });
            this._scrollWidget.addWidget( this._strings[i] );

            if( params.entries[i].selected || ( defaultVal && defaultVal === key ) )
                this._index = i;
        }

        this._optionsScroll = new ScrollWidget().init( { h:0, w:0, widget:this._scrollWidget } );
        this._chevronLeft   = new ImageWidget().init( { url: _x2._config._imageRoot + "moreLeft.png", onLoad:function(){ self.layout() }});
        this._chevronRight  = new ImageWidget().init( { url: _x2._config._imageRoot + "moreRight.png" } );

        this._chevronRight.setA(0);
        this._chevronLeft.setA(0);

        this.addWidget( this._chevronLeft );
        this.addWidget( this._chevronRight );
        this.addWidget( this._optionsScroll );

        return this;
    };

    HorizSelectionWidget.prototype.layout = function()
    {
        var w  = this.getW();
        var h  = this.getH();
        var cw = this._chevronLeft.getW();
        var ch = this._chevronLeft.getH();
        var cy = h/2 - ch/2;
        var sx = cw + Style._pad;
        var sh = this._fontSize * 1.2;

        //position chevrons
        this._chevronLeft.setY( cy );
        this._chevronRight.setY( cy );
        this._chevronRight.setX( w - cw );

        //dimension and position scroll container
        this._optionsScroll.setW( w - 2 * sx );
        this._optionsScroll.setH( sh );
        this._optionsScroll.setX( sx );
        this._optionsScroll.setY( h/2 - sh/2 );

        //layout options strings within scroll widget
        for( var i=0; i<this._strings.length; i++ )
        {
            var sw = this._strings[i].getW();
            var pos = w * i + w / 2 - sw / 2 - sx;
            this._strings[i].setX( pos );
        }

        this.setScroll(0);
    };

    HorizSelectionWidget.prototype.setHighlight = function()
    {
        var obj;
        obj          = this.getGlobalPos();
        obj.w        = this.getW();
        obj.h        = this.getH();
        obj.inner    = true;
        obj.duration = 300;

        _x2._hi.setPosition( obj );
    };

    HorizSelectionWidget.prototype.onChange = function(direction)
    {
        if( this._onChange && direction !== 0 )
        {
            this._onChange( this._objs[this._index] );
            this._strings[this._index].setSpeechParams( undefined, undefined, this, false );
        }
    };

    HorizSelectionWidget.prototype.lostFocus = function()
    {
        for( var i=0; i<this._strings.length; i++ )
            this._strings[i].lostFocus();

        this._chevronRight.setA(0);
        this._chevronLeft.setA(0);
    };

    HorizSelectionWidget.prototype.setScroll = function( direction )
    {
        var self = this;
        var duration = ( direction === 0 ? 0 : 300 );

        this._index += direction;

        var offset = (-1 * this._index * this.getW());

        this._optionsScroll.setScroll( { x:offset, duration:duration, onEnd:function(){ self.onChange(direction) } } );

        if( _x2._focus === this )
        {
            this._chevronRight.setA( this._index < this._strings.length-1 ? 1 : 0 );
            this._chevronLeft.setA( this._index > 0 ? 1 : 0);
        }
    };

    HorizSelectionWidget.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index < this._strings.length - 1)
                        this.setScroll(1);
                }
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index > 0 )
                        this.setScroll(-1);
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;

    };

    return HorizSelectionWidget;
})();


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.KeyboardWidget = ( function()
{
    "use strict";

    KeyboardWidget.prototype = new Widget();

    function KeyboardWidget(){}

    KeyboardWidget.prototype.createSpeechStr = function()
    {
        var str  = this._widgets[this._index].getText && this._widgets[this._index].getText();
        var hint = this._speachLabels[this._pageNum][this._index];

        return hint ? hint : str;
    };

    KeyboardWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        this._widgets[this._index].gotFocus();
        this._hi.animate( { a:1, duration:300 } );
        _x2._hi.fadeOut();
        this._hi.setSpeechParams( this.createSpeechStr() + ". Press arrow keys to review characters. Press OK to select. ", undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof KeyboardWidget
     * @param   {Object}        params
     * @param   {Function}     [params.onEnter] - Callback when Enter is pressed
     * @param   {Function}     [params.onReady] - Callback when have loaded
     * @returns {KeyboardWidget}
     */
    KeyboardWidget.prototype.init = function( params )
    {
        var charsStyle, i, j, rect, onMouseDown, self = this;
        var onLoad = function() { self._numLoaded++; self.layoutKeyboardWidget() };

        Widget.prototype.init.call( this );
        this._className = "KeyboardWidget";

        if( params.onEnter )
            this._onEnter = params.onEnter;

        if( params.onReady )
             this.addReadyCallback( params.onReady );

        this._selectable = true;
        this._numLoaded  = 0;
        this._index      = 0;
        this._perRow     = 10;
        this._stepW      = _x2.scaleValInt(90);
        this._stepH      = _x2.scaleValInt(84);
        this._gap        = _x2.scaleValInt( 3);
        this._pageNum    = 0;
        this._pages      =
        [
            [ "A", "B", "C", "D", "E", "F", "G", "H", "I", "del", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "tr", "S", "T", "U", "V", "W", "X", "Y", "Z", "&12", "sp"  ],
            [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "del", "9", "$", "_", ".", "'", ":", ";", "?", "!", "tr", "#", "@", "%", "-", "" , "" , "" , "" , "ABC", "sp"  ]
        ];

        this._numRows      = parseInt( (this._pages[0].length + this._perRow - 1) / this._perRow );
        this._widgets      = [];
        this._speachLabels = [[],[]];

        charsStyle  = new Style( { font:"regular" , color:"#e8e8e8", colorHi:"#000000", fontSize:_x2.scaleValInt(32), textAlign:"center" } );
        onMouseDown = function( index ) { return function() { self.onMouseDown( index ); } };

        for( i = 0; i < this._perRow * this._numRows; i++ )
        {
            rect = new RectWidget().init( { w:this._stepW-this._gap, h:this._stepH-this._gap, color:"#191919" } );
            this.addWidget( rect, this._stepW * (i % this._perRow), this._stepH * parseInt(i / this._perRow) );
            rect.setMouseDownListener( onMouseDown( i ) );
        }

        this._hi = new RectWidget().init( { w:this._stepW - this._gap, h:this._stepH - this._gap, color:"#e8e8e8" } );
        this._hi.setA( 0 );
        this.addWidget( this._hi );

        this._clear  = new DualImageWidget().init( { url:_x2._config._imageRoot + "clearIcon.png" , urlHi:_x2._config._imageRoot + "clearIconHi.png"  } );
        this._delete = new DualImageWidget().init( { url:_x2._config._imageRoot + "deleteIcon.png", urlHi:_x2._config._imageRoot + "deleteIconHi.png" } );
        this._space  = new DualImageWidget().init( { url:_x2._config._imageRoot + "spaceIcon.png" , urlHi:_x2._config._imageRoot + "spaceIconHi.png"  } );
        this._clear.addReadyCallback ( onLoad );
        this._delete.addReadyCallback( onLoad );
        this._space.addReadyCallback ( onLoad );

        for( i = 0; i < this._pages[0].length; i++ )
        {
            switch( this._pages[0][i] )
            {
                case "del":
                    this._widgets[i] = this._delete;
                    this._speachLabels[0][i] = this._speachLabels[1][i] = "delete";
                    break;

                case "sp":
                    this._widgets[i] = this._space;
                    this._speachLabels[0][i] = this._speachLabels[1][i] = "space";
                    break;

                case "tr":
                    this._widgets[i] = this._clear;
                    this._speachLabels[0][i] = this._speachLabels[1][i] = "clear";
                    break;

                default:
                    this._widgets[i] = new StringWidget().init( { text:this._pages[0][i], style:charsStyle, focusTime:250 } );
                    this._widgets[i].setW( this._stepW - this._gap );
                    break;
            }

            this.addWidget( this._widgets[i], this._stepW * (i % this._perRow), this._stepH * parseInt(i / this._perRow) );
        }

        var index;
        var toMap = [ "A" , "&12"                         , "ABC"             , "_"         , "."     , "\'"        , ":"    , ";"        , "?"            , "!"               , "-"      ];
        var strs  = [ "Ay", "numbers and symbols keyboard", "letters keyboard", "underscore", "period", "apostrophe", "colon", "semicolon", "question mark", "exclamation mark", "hyphen" ];

        if( _x2._config._host.getPlatformString() === "lg" )
            strs[0] = "Capital A";

        for( i = 0; i < this._pages.length; i++ )
        {
            for( j = 0; j < toMap.length; j++ )
            {
                index = this._pages[i].indexOf( toMap[j] );

                if( index >= 0 )
                    this._speachLabels[i][index] = strs[j];
            }
        }

        this._widgets[0].addReadyCallback( onLoad );

        this.setW( this._stepW * this._perRow  - this._gap );
        this.setH( this._stepH * this._numRows - this._gap );

        return this;
    };

    KeyboardWidget.prototype.layoutKeyboardWidget = function()
    {
        if( this._numLoaded === 4 )
        {
            for( var i = 0; i < this._widgets.length; i++ )
            {
                this._widgets[i].setY( this._widgets[i].getY() + (this._stepH - this._widgets[i].getH() - this._gap) / 2 );

                if( this._widgets[i] instanceof DualImageWidget )
                    this._widgets[i].setX( this._widgets[i].getX() + (this._stepW - this._widgets[i].getW() - this._gap) / 2 );
            }

            this.callbackSignalReady();
        }
    };

    KeyboardWidget.prototype.lostFocus = function()
    {
        this._widgets[this._index].lostFocus();
        this._hi.animate( { a:0, duration:300 } );
    };

    KeyboardWidget.prototype.onMouseDown = function( index )
    {
        var i, page, str = this._pages[this._pageNum][index];

        switch( str )
        {
            case "&12":
            case "ABC":
                this._pageNum = (this._pageNum + 1) % this._pages.length;
                page          = this._pages[this._pageNum];

                for( i = 0; i < this._widgets.length; i++ )
                    if( this._widgets[i].setText )
                        this._widgets[i].setText( page[i] );
                break;

            default:
                if( this._onEnter )
                    this._onEnter( str );
        }
    };

    KeyboardWidget.prototype.processEvent = function( val, type )
    {
        var retval = false, col, row, index;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                {
                    row = parseInt( this._index / this._perRow );

                    if( row < this._numRows - 1 )
                    {
                        this._widgets[this._index].lostFocus();
                        this._index += this._perRow;

                        index = this._index;
                        col   = index % this._perRow;

                        while( this._pages[this._pageNum][index] === "" && (col < this._perRow - 1) )
                            col = ++index % this._perRow;

                        this._index = index;

                        this._widgets[this._index].gotFocus();
                        this._hi.setSpeechParams( this.createSpeechStr(), undefined, this, false );
                        this._hi.animate( { x:col * this._stepW, y:(row+1) * this._stepH, duration:300 } );
                        retval = true;
                    }
                }
                break;

            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    this._hi.setSpeechParams( this.createSpeechStr(), undefined, this, false );
                    this.onMouseDown( this._index );
                }
                retval = true;
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    col = this._index % this._perRow;

                    if( col > 0 )
                    {
                        index = this._index - 1;

                        while( this._pages[this._pageNum][index] === "" && col > 0 )
                            col = --index % this._perRow;

                        this._widgets[this._index].lostFocus();
                        col         = index % this._perRow;
                        this._index = index;
                        this._widgets[this._index].gotFocus();
                        this._hi.setSpeechParams( this.createSpeechStr(), undefined, this, false );
                        this._hi.animate( { x:(col) * this._stepW, duration:300 } );
                        retval = true;
                    }
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    col = this._index % this._perRow;

                    if( col < this._perRow - 1 )
                    {
                        index = this._index + 1;

                        while( this._pages[this._pageNum][index] === "" && (col < this._perRow - 1) )
                            col = ++index % this._perRow;

                        this._widgets[this._index].lostFocus();
                        col         = index % this._perRow;
                        this._index = index;
                        this._widgets[this._index].gotFocus();
                        this._hi.setSpeechParams( this.createSpeechStr(), undefined, this, false );
                        this._hi.animate( { x:(col) * this._stepW, duration:300 } );
                        retval = true;
                    }
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    row = parseInt( this._index / this._perRow );

                    if( row > 0 )
                    {
                        this._widgets[this._index].lostFocus();
                        this._index -= this._perRow;
                        this._widgets[this._index].gotFocus();
                        this._hi.setSpeechParams( this.createSpeechStr(), undefined, this, false );
                        this._hi.animate( { y:(row-1) * this._stepH, duration:300 } );
                        retval = true;
                    }
                }
                break;
        }

        if( retval === false )
            retval = Widget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    return KeyboardWidget;

})();


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LastWatchedCellWidget = ( function()
{
    "use strict";

    LastWatchedCellWidget.prototype = new Widget();

    function LastWatchedCellWidget(){}

    LastWatchedCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 414 ) + _x2.scaleValInt( 19 );
    };

    LastWatchedCellWidget.prototype.getPosAndDimUnfocused = function()
    {
        return { pos:0, dim:this._focusH };
    };

    LastWatchedCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 360 ) * (_x2.scaleValInt( 270 ) + 2 * _x2.scaleValInt( 18 )) / _x2.scaleValInt( 270 );
    };

    LastWatchedCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var obj;

        if( this._data )
        {
            this._title.setSpeechParams( undefined, undefined, this, newScreen );

            Widget.prototype.gotFocus.call( this );

            this._bg.animate   ( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );
            this._title.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );

            obj          = this.getGlobalPos();
            obj.w        = this._focusW;
            obj.h        = this._focusH;
            obj.inner    = false;
            obj.duration = ListWidget.SCROLL_TIME_STEP;

            _x2._hi.setPosition( obj );
            _x2._shadow.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        return this;
    };

    /*
     * @params {Object} params TODO:
     */
    LastWatchedCellWidget.prototype.init = function( params )
    {
        var self       = this;
        var titleStyle = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var chStyle    = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );

        Widget.prototype.init.call( this, params );
        this._className   = "LastWatchedCellWidget";
        this._selectable  = true;
        this._videoScreen = params.obj;
        this._imageX      = _x2.scaleValInt( 19 );
        this._srcImageW   = _x2.scaleValInt( 414 );
        this._srcImageH   = _x2.scaleValInt( 276 );
        this._actualImageW = 416;
        this._actualImageH = 312;
        this._logoImageW = _x2.scaleValInt( 180 );
        this._logoImageH = _x2.scaleValInt( 120 );
        this._imageCallbackDimensions = {
            'first': { width: 375, height: 500}, //3:4 ratio
            'second': { width: 414, height: 276}, //3:2 ratio
            'defaultImageUrl': '/select/default/image?width=416&height=312&entityType=Program&entitySubType=Other' //4:3 ratio
        }
        this._scale       = (this._srcImageW + 2 * this._imageX) / this._srcImageW;
        this._focusW      = this._scale * this._srcImageW;
        this._focusH      = this._scale * this._srcImageH;

        var onImageChanged = function()
        {
            var entity = self._data.entity;

            if( entity instanceof Recording || entity instanceof VodShowing || entity instanceof Entity )
            {
                self._image.setX( 0 );
                self._image.setY( 0 );
            }
            else if( entity instanceof Channel || entity instanceof LinearShowing )
            {
                self._image.setX( (self._bg.getW() - self._image.getW()) / 2 );
                self._image.setY( (self._bg.getH() - self._image.getH()) / 2 );
            }
            else
            {
                console.error( "Need to support entity type of " );
                console.error( entity );
            }
            var imageUrl = self._image.getUrl();
            if( imageUrl && imageUrl.indexOf('logo') > -1 ) { //if it is logo image, then we should not inherit from parent, because it will be of small size.
                self._image._div.style.width = 'unset';
                self._image._div.style.height =  'unset';
                self._image._div.style.top = _x2.scaleValInt( 59 ) + 'px';
                self._image._div.style.left = _x2.scaleValInt( 118 ) + 'px';//depends on screen size it get adjust
                if( self._image._div.width !== self._logoImageW ) {
                    self._image._div.style.left =  Math.ceil( (self._bg._div.clientWidth - self._image._div.clientWidth)/2 ) + 'px';
                }//if width is not match with request width, then we need to center it in vertical 
                if( self._image._div.height !== self._logoImageH ) {
                    self._image._div.style.top =  Math.ceil( (self._bg._div.clientHeight - self._image._div.clientHeight - 26 )/2 ) + 'px';
                }//if height is not match with request height, then we need to center it in horizontal
            } else {
                self._image._div.style.width = 'inherit';
                self._image._div.style.height = 'inherit';
                self._image._div.style.top = '0';
                self._image._div.style.left = '0';
            }
            self._image.setA(1);
        };

        //Last watch cell was changed to 3:2 ratio (300 X 200), 
        //so we request for 4:3 image for first time with _actualImageW X _actualImageH,
        //if 4:3 image not found, then we should request image with _imageCallBackDimensions['first'],
        //if 3:4 image not found, then we should request image with _imageCallBackDimensions['second'],
        //3:2 image not found, then we should request default image
        var onImageError = function()
        {
            var imageUrl = self._image.getUrl();

            if( !imageUrl || imageUrl.indexOf('default') > -1 ) {
                self._image.setA( 0 );//hide image, if image is not found  or not match last callback dimension
            } else if( imageUrl.indexOf('height=' + self._actualImageH ) > -1 ) {
                self._image.setUrlWithDimension( self._imageCallbackDimensions['first'].width, self._imageCallbackDimensions['first'].height );
            } else if( imageUrl.indexOf('height=' + self._imageCallbackDimensions['first'].height ) > -1 ) {
                self._image.setUrlWithDimension( self._imageCallbackDimensions['second'].width, self._imageCallbackDimensions['second'].height );
            } else {
                var callbackUrl = imageUrl.replace(/\/select(.*)/g, self._imageCallbackDimensions.defaultImageUrl );
                self._image.setUrl(  callbackUrl );
            }
        };

        this._bg = new RectWidget().init( { w:this._srcImageW, h:this._srcImageH, color:"#303030" } );
        this.addWidget( this._bg, this._imageX, (this._scale - 1) * this._srcImageH / 2 );

        this._image = new ImageWidget().init( { onError:onImageError, onChange:onImageChanged } );
        this._bg.addWidget( this._image );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._title.setA( 0 );
        this.addWidget( this._title, 0, this._srcImageH + 2 * this._bg.getY() + _x2.scaleValInt( 20 ) );

        this._chNum = new StringWidget().init( { text:"?", style:chStyle } );
        this._chNum.setA( 0 );
        this._chNum.setW( this._srcImageW );
        this._chNum.addReadyCallback( function() { self._chNum.setY( self._srcImageH - self._chNum.getH() - 2 * Style._pad ); } );
        this._bg.addWidget( this._chNum );

//         var onImageError = function()
//         {
//             var fallback = self._data.getFallbackImageLink( self._imageW, self._imageH );
//             if( self._image.getUrl() === fallback )
//                 self._image.setA( 0 ); //fallback already tried. hide image.
//             else
//                 self._image.setUrl( fallback );
//
//             // AAECH-59
//             //    Where   Screen        self =
//             // 1. Search  SearchScreen  SearchEntity.
//             // 2. LiveTV  GuideScreen   LinearShowing.getFallbackImageLink() -> getProgram().getFallbackImageLink()
//             // self._image.setUrl( self._image.getUrl() + "&default=force" );
//         };

        this.setW( this.getHeightUnfocused() );
        this.setH( params.h );

        return this;
    };

    LastWatchedCellWidget.prototype.isListBlocking = function()
    {
        var retval = false, widget = this;

        while( widget )
        {
            var parent = widget._parent;

            if( parent instanceof ListWidget )
            {
                if( parent._blocked === true )
                    retval = true;
                break;
            }
            else
                widget = parent;
        }

        return retval;
    };

    LastWatchedCellWidget.prototype.lostFocus = function()
    {
        Widget.prototype.lostFocus.call( this );

        _x2._shadow.stopAnimation( Widget.ALPHA );
        _x2._shadow.setA( 0 );

        this._bg.stopAnimation( Widget.X_SCALE );
        this._bg.stopAnimation( Widget.Y_SCALE );
        this._bg.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );

        this._title.stopAnimation( Widget.ALPHA );
        this._title.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
    };

    LastWatchedCellWidget.prototype.processEvent = function( val, type )
    {
        var retval, self = this;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this.isListBlocking() === false && this._data )
                    {
                        var entity = null;
                        if( this._data.entity instanceof Channel ) {
                            entity = ( !this._sched )? this._data.entity._schedules[0] : this._sched;
                        } else {
                            entity = this._data.entity;
                        }

                        var data = this._data.data;
                        var rp   = entity.getResumePoint && entity.getResumePoint();
                        var play = function()
                        {
                            var obj =
                            {
                                url        :data.url,
                                mediaId    :data.mediaId,
                                programId  :data.programId,
                                paid       :data.paid,
                                mode       :data.mode,
                                entity     :entity,
                                resume     : rp ? rp.getPosition() : 0,
                                hasSap     :data.hasSap,
                                hasDvs     :data.hasDvs,
                                streamId   :data.streamId,
                                assetId    :data.assetId,
                                providerId :data.providerId,
                                mediaGuid  :data.mediaGuid,
                                recordingId:data.recordingId
                            };

                            if( self._videoScreen instanceof VideoScreen ) // If currently watching from video player
                                self._videoScreen.sendVideoPlayedLocalytics();

                            _x2._telemetry.watchPathReset();
                            _x2._telemetry.setWatchButton( "Player: Last Watched" ); // Can switch from Linear to Last Watched inside player

                            self._videoScreen.play( obj );
                        };

                        if( self._videoScreen instanceof VideoScreen && data.url === self._videoScreen._url )
                        {
                            self._videoScreen.hideLastWatched();
                        }
                        else
                        {
                            if( _x2._pc.isEnabled() === true )
                                _x2.checkParentalControls( entity, undefined, undefined ).then( play );
                            else
                                play();
                        }
                    }

                    retval = true;
                }
                break;

            default:
                retval = Widget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    LastWatchedCellWidget.prototype.setData = function( data )
    {
        var entity, self = this;

        this._sched = undefined;
        this._data = data;

        if( data !== undefined )
        {
            entity = data.entity;

            this._chNum.setA( 0 );
            this._image.setUrl('');//Set empty for clear existing image
            if( entity instanceof Recording )
            {
                this._image.setUrl( entity.getImageLink( this._actualImageW, this._actualImageH ) );
                this._title.setText( entity.getTitle() );
            }
            else if( entity instanceof Channel )
            {
                var now       = new Date().getTime(), sched;
                var schedules = entity.getSchedules();

                if( schedules )
                    for( var i = 0; i < schedules.length; i++ )
                        if( schedules[i].getEndTime() > now )
                        {
                            this._sched = sched = schedules[i];
                            break;
                        }
                
                if( sched ) {
                    data.url      = sched._channel.getStreamUrl();
                    data.mode     = VideoScreen.Mode.LIVE;
                    data.streamId = sched._channel.getStreamId();
                }
                var imageLogoUrl = entity.getLogoUrl( self._logoImageW, self._logoImageH );
                imageLogoUrl = imageLogoUrl.replace('&extent=true', '');//Remove extent=true
                this._image.setUrl( imageLogoUrl );
                this._title.setText( "On Now: " +  (sched ? sched.getGridTitle() : "TBD") );
                this._chNum.setText( entity.getNumber() );
                this._chNum.setA( 1 );
            }
            else if( entity instanceof Entity )
            {
                this._image.setUrl( entity.getImageLink( this._actualImageW, this._actualImageH ) );
                this._title.setText( entity.getTitle() );
            }
            else if( entity instanceof VodShowing )
            {
                var onFetchProgram = function()
                {
                    self._image.setUrl( entity.getImageLink( self._actualImageW, self._actualImageH ) );
                    self._title.setText( entity.getTitle() );
                    if( _x2._config._showResumePoint ) {
                        var resumePoint = entity.getResumePoint && entity.getResumePoint();
                        var lastPosition = resumePoint && resumePoint.getPosition() || 0;
                        lastPosition = Math.floor( lastPosition / 1000 );
                        self._title.setText( "Resume from " + self.getLastDuration(lastPosition) + " - " + self._title.getText() );
                    }
                };

                var onFetchProgramFail = function( error )
                {
                    console.error( error );
                    self._title.setText( "" );
                };

                if( entity.getProgram() )
                    onFetchProgram();
                else
                    entity.fetchProgram().then( onFetchProgram, onFetchProgramFail );
            }
            else
            {
                console.error( "Need to support entity type of " );
                console.error( entity );
            }

            if( _x2._config._showResumePoint && !(entity instanceof VodShowing) ) {
                var resumePoint = entity.getResumePoint && entity.getResumePoint();
                var lastPosition = resumePoint && resumePoint.getPosition() || 0;
                lastPosition = Math.floor( lastPosition / 1000 );
                this._title.setText( "Resume from " + this.getLastDuration(lastPosition) + " - " + this._title.getText() );
            }
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    LastWatchedCellWidget.prototype.getLastDuration = function(totalSeconds) {
        var hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        return hours + ":" + minutes + ":" + seconds ;
    }
    return LastWatchedCellWidget;

})();


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LastWatchedRowWidget = ( function()
{
    "use strict";

    LastWatchedRowWidget.prototype = new CollectionRowWidget();

    function LastWatchedRowWidget(){}

    /**
     * @memberof LastWatchedRowWidget
     * @param params
     * @returns {LastWatchedRowWidget}
     * @see CollectionRowWidget
     */
    LastWatchedRowWidget.prototype.init = function( params )
    {
        params.type = LastWatchedCellWidget;
        params.y    = _x2.scaleVal( 160 ) - _x2.scaleVal( 12 );
        params.h    = _x2.scaleValInt( 376 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "LastWatchedRowWidget";

        return this;
    };

    LastWatchedRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 540 );
    };

    return LastWatchedRowWidget;

})();


/***/ }),
/* 116 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LinearPromoCellWidget = ( function()
{
    "use strict";

    LinearPromoCellWidget.prototype = new CollectionCellWidget();

    function LinearPromoCellWidget(){}

    /**
     * Initializer
     * @memberof LinearPromoCellWidget
     * @param {Object} params - @see CollectionCellWidget
     * @returns {LinearPromoCellWidget}
     */
    LinearPromoCellWidget.prototype.init = function( params )
    {
        var self = this;
        var titleStyle    = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var subTitleStyle = new Style( { color:"#a3a3a3", font:"regular", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );

        this._imageX = params.bgX     = _x2.scaleValInt( 19 );
        this._imageW = params.bgW     = _x2.scaleValInt( 558 );
        this._imageH = params.bgH     = _x2.scaleValInt( 372 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY     = (this._scale - 1) * this._imageH / 2;

        this._logoW = _x2.scaleValInt(75);
        this._logoH = _x2.scaleValInt(53);

        this._focusW = this._scale * this._imageW;
        this._focusH = this._scale * this._imageH;

        params.background = true;
        params.bgTextSize = _x2.scaleValInt(36);

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "LinearPromoCellWidget";

        var imageChanged = function()
        {
            self._image.setA(1);
            self.hideBackground();
        };

        var imageError = function()
        {
            var fallback = self._data.getFallbackImageLink( 320, 240 );
            if( self._image.getUrl() === fallback )
            {
                self._image.setA( 0 );
                self.showBackground();
            }
            else
                self._image.setUrl( fallback );
        };

        var logoLoaded = function()
        {
            self._networkLogo.setX( self._imageW - ( self._networkLogo.getW() * 1.5 ) );
            self._networkLogo.setY( self._imageH - ( self._networkLogo.getH() * 1.5 ) );
        };

        this._image = new ImageWidget().init( { w:this._imageW, h:this._imageH, onError:imageError, onChange:imageChanged } );
        this.addWidget( this._image, this._imageX, this._imageY );

        var alphas    = [ { opacity:40     , location:0 }, { opacity:0      , location:100 } ];
        var colors    = [ { color:"#000000", location:0 }, { color:"#000000", location:100 } ];

        this._gradient = new GradientWidget().init( { alphas:alphas, angle:90, colors:colors, w:this._imageW, h:this._imageH, type:GradientWidget.Type.Linear } );
        this.addWidget( this._gradient, this._imageX, this._imageY );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._title.setA( 0 );

        // this._subTitle = new TextBlockWidget().init( { w:500, h:30, style:subTitleStyle } );
        this._subTitle = new StringWidget().init( { style:subTitleStyle } );
        this._subTitle.setA( 0 );

        this.addWidget( this._title   , 0, this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 20 ) );
        this.addWidget( this._subTitle, 0, this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 60 ) );

        this._speakTarget = new StringWidget().init( { style:titleStyle } );
        this._speakTarget.setA( 0 );
        this.addWidget( this._speakTarget );

        this._networkLogo = new ImageWidget().init( { w:this._logoW, h:this._logoH, onLoad:logoLoaded } );
        this._networkLogo.setA( 0 );
        this._gradient.addWidget( this._networkLogo );

        return this;
    };

    LinearPromoCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 558 ) + _x2.scaleValInt( 19 );
    };

    LinearPromoCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 372 ) * (_x2.scaleValInt( 558 ) + 2 * _x2.scaleValInt( 19 )) / _x2.scaleValInt( 558 );
    };

    LinearPromoCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        this._speakTarget.setSpeechParams( undefined, undefined, this, newScreen );

        CollectionCellWidget.prototype.gotFocus.call( this );

        // if( this._image.getA() ) //The image is not always loaded by the time we get focus. What is the harm in setting the size while alpha==0?
        this._image.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );
        this._gradient.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

        this._title.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        this._subTitle.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );

        return this;
    };

    LinearPromoCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );

        if( this._image.getA() )
        {
            this._image.stopAnimation( Widget.X_SCALE );
            this._image.stopAnimation( Widget.Y_SCALE );
            this._image.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );

            this._gradient.stopAnimation( Widget.X_SCALE );
            this._gradient.stopAnimation( Widget.Y_SCALE );
            this._gradient.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        this._title.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
        this._subTitle.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
    };

    /**
     * Override default (CollectionCellWidget) ENTER key handling (pushing info screen) and tune the
     * linear program when a user selects ENTER
     * @param {number} val
     * @param {number} type
     */
    LinearPromoCellWidget.prototype.processEvent = function( val, type )
    {
        var self = this;

        if( type === Host.KEY_PRESSED && val === Host.KEY_ENTER )
        {
            var onEntityLoaded = function( showing )
            {
                if( showing !== undefined )
                {
                    if( showing.getChannel() )
                    {
                        var channel = _x2._channelCollection.getChannel( showing.getChannel().getSelfLink() );
                        var program = showing.getEntity();

                        var playVideo = function()
                        {
                            _x2.pushScreen( new VideoScreen().init( { url:channel.getStreamUrl(), mode:VideoScreen.Mode.LIVE, entity:showing, streamId:channel.getStreamId() } ) );
                        };

                        if( channel )
                        {
                            if( _x2._pc.isEnabled() === true )
                                _x2.checkParentalControls( showing, program ).then( playVideo );
                            else
                                playVideo();
                        }
                    }
                    self.getHostScreen().hideDistractor();
                }
            };

            var onError = function( error )
            {
                console.log( error.toString() );
                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.BROWSE_SEARCH } ) );
                self.getHostScreen().hideDistractor();
            };

            this._data.getLinearTvListing().then( onEntityLoaded ).catch( onError );

            this.getHostScreen().showDistractor();
        }
        else
            return CollectionCellWidget.prototype.processEvent.call( this );
    };

    LinearPromoCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            var now, start, end, title, season, episode, time, channel, logoUrl, titleText="", subTitleText="", speakStr = "";

            this._data = data;
            this._image.setA( 0 );
            this._image.setUrl( data.getPromoImageLink( 320, 240 ) );

            now     = new Date();
            start   = new Date( parseInt(data.getStartTime()) );
            end     = new Date( parseInt(data.getEndTime()) );
            title   = data.getTitle();
            season  = data.getSeasonNumber();
            episode = data.getEpisodeNumber();
            logoUrl = data.getNetworkImageLink();

            if( logoUrl )
            {
                this._networkLogo.setUrl( logoUrl );
                this._networkLogo.setA( 1 );
            }
            else
                this._networkLogo.setA( 0 );

            if( season && episode )
            {
                titleText = "S" + season + " Ep" + episode + " - " + title;
                speakStr  = "Season " + season + ", Episode" + episode + ", " + title + ". ";
            }
            else
            {
                titleText = title;
                speakStr  = title + ". ";
            }

            if( start.getTime() < now.getTime() && end.getTime() > now.getTime() )
            {
                channel = data.getCallSign();
                time = _x2.createTimeRange( start, end );
                subTitleText = "On now " + time + " on " + channel;
                speakStr += "On now " + _x2.createTimeSpeechStr( time ) + " on " + channel + ". ";
            }

            this.setBackgroundText( title );
            this._title.setText( titleText );
            this._subTitle.setText( subTitleText );

            this.setA( 1 );

            this._speakTarget.setText( speakStr );
        }
        else
            this.setA( 0.0 );
    };

    return LinearPromoCellWidget;

})();


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LinearPromoRowWidget = ( function()
{
    "use strict";

    LinearPromoRowWidget.prototype = new CollectionRowWidget();

    function LinearPromoRowWidget(){}

    LinearPromoRowWidget.prototype.tick = function()
    {
        var i, entities, hasOutOfWindowEntities, now = Date.now(), self = this;

        var reload = function()
        {
            var i, entities, filtered=[], now = Date.now(), collection = self._data;

            self._list.setData( filtered );

            //The refresh query appears to return out-of-window entities for a few minutes after the entity is no longer airing. Filter them out.
            entities = collection.getEmbeddedBrowseItems();
            for( i=0; i<entities.length; i++ )
            {
                if( entities[i].getStartTime() <= now && entities[i].getEndTime() > now )
                    filtered.push( entities[i] );
            }

            self._filteredList = filtered;
            self._list.setData( filtered );
            if( self._list.containsWidget( _x2._focus ) )
                _x2.requestFocus( self._list );
        };

        //Refresh the data ONLY if there are any out-of-window entities.
        entities = ( this._filteredList ? this._filteredList : this._data.getEmbeddedBrowseItems() );
        for( i=0; i<entities.length; i++ )
        {
            if( ! ( entities[i].getStartTime() <= now && entities[i].getEndTime() > now ) )
            {
                hasOutOfWindowEntities = true;
                break;
            }
        }

        if( hasOutOfWindowEntities )
            this._data.refresh().then( reload , function(error) {
                if( error.getMajor() == 404 ) {
                    if( this._filteredList ) {
                        this._filteredList = [];
                    }
                    this._data._embedded = [];
                }// if the browsenode is not found, then we need to empty the embedded list, so that it will not retry the request
            }.bind(this));
    };

    LinearPromoRowWidget.prototype.init = function( params )
    {
        var self = this;

        params.type = LinearPromoCellWidget;
        params.y    = _x2.scaleVal( 152 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 560 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "LinearPromoRowWidget";

        _x2.addChangeCallback( function() { self.tick() } );

        return this;
    };

    LinearPromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 660 );
    };

    return LinearPromoRowWidget;

})();


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ListWidget = ( function()
{
    "use strict";

    ListWidget.prototype = new Widget();

    /**
     * @enum Axis
     * @property {Number} X - Horizontal List
     * @property {Number} Y - Vertical List
     */
    ListWidget.Axis = Object.freeze
    ({
        X : 0,
        Y : 1
    });

    ListWidget.SCROLL_TIME_STEP = 300;

    var SCROLL = Object.freeze
    ({
        BACK     : 0,
        BACK_STOP: 1,
        FWD      : 2,
        FWD_STOP : 3
    });

    function ListWidget(){}

    ListWidget.prototype.appendData = function( rows )
    {
        var lastDataIndex = this._rows.length - 1;

        this._rows = this._rows.concat( rows );

        for( var i = 0; i < this._cells.length; i++ )
            if( this._cells[i]._dataIndex > lastDataIndex )
                this._cells[i].setData( this._rows[this._cells[i]._dataIndex] );
    };

    ListWidget.prototype.doFocusTransition = function( index, repeating )
    {
        if( this._cells[0].getPosAndDimUnfocused )
        {
            if( index === undefined )
                index = 0;

            var posAndDim = this._cells[index].getPosAndDimUnfocused( repeating );

            if( this._axis === ListWidget.Axis.X )
            {
                var y = this._cells[index].getGlobalPos().y + posAndDim.pos - _x2._hi._top;
                var h = posAndDim.dim;

                _x2._hi.stopAnimation( Widget.Y );
                _x2._hi.stopAnimation( Widget.H );
                _x2._hi.animate( { y:y, h:h, duration:this._stepTime, inner:false, easing:Widget.Easing.LINEAR } );
            }
            else
            {
                var x = this._cells[index].getGlobalPos().x + posAndDim.pos;
                var w = posAndDim.dim;

                _x2._hi.stopAnimation( Widget.X );
                _x2._hi.stopAnimation( Widget.W );
                _x2._hi.animate( { x:x, w:w, duration:this._stepTime, inner:false, easing:Widget.Easing.LINEAR } );
            }
        }
    };

    ListWidget.prototype.getCurrentAndMaxIndex = function()
    {
        var retval;

        if( this._cells && this._rows )
            retval = { current:this._cells[(this._cellOffset + this._index) % this._cells.length]._dataIndex, max:this._rows.length, rows:this._rows };
        else
            retval = { current:0, max:0 };

        return retval;
    };

    ListWidget.prototype.getMaxIndex = function()
    {
        return this._rows !== undefined ? this._rows.length : 0;
    };

    ListWidget.prototype.getVisibleRowCount = function()
    {
        return this._numVis;
    };

    ListWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var retval;

        if( this._rows && this._rows.length && this._blocked !== true )
            retval = _x2.requestFocus( this._cells[(this._cellOffset + this._index) % this._cells.length], newScreen );

        return retval;
    };

    /**
     * Initializer
     * @memberof ListWidget
     * @param   {Object}        params
     * @param   {Number}        params.axis               - Orientation of list
     * @param   {Number}        params.h                  - Height of the list
     * @param   {Boolean}       params.hide               - Hide the selection widget on transition between cells
     * @param   {Number}        params.maxIndex           - Max index in the list to which the selection box will move before scrolling list
     * @param   {Object}        [params.obj]              - Object that is passed though to the list cells
     * @param   {Number}        [params.rows]             - Array of data abjects to display
     * @param   {Function}      [params.stepListener]     - Function called on each animation step of the list with the current index combined with percentage to the next
     * @param   {Function}      [params.stepStartListener]- Function called at the beginning of a single step
     * @param   {Function}      [params.stepStopListener] - Function called at the end on scroll
     * @param   {Number}        [params.stepTime=300]     - Number of milliseconds to move one cell
     * @param   {Number}        [params.touchH=0]         - Height of the more items touch area
     * @param   {Number}        [params.touchW=0]         - Width of the more items touch area
     * @param   {ListRowWidget} params.type               - The specific type of ListRowWidget this list contains
     * @param   {Number}        params.w                  - Width of the list
     * @returns {ListWidget}
     */
    ListWidget.prototype.init = function( params )
    {
        var i, numCells, dimension, self = this;

        Widget.prototype.init.call( this );
        this._className = "ListWidget";

        this.setW( params.w );
        this.setH( params.h );
        this._stepTime          = (params.stepTime !== undefined) ? params.stepTime : ListWidget.SCROLL_TIME_STEP;
        this._stepListener      = params.stepListener;
        this._stepStartListener = params.stepStartListener;
        this._stepStopListener  = params.stepStopListener;
        this._rows              = params.rows;
        this._axis              = (params.axis === ListWidget.Axis.X) ? ListWidget.Axis.X : ListWidget.Axis.Y;
        this._selectable        = true;
        this._cellOffset        = 0;
        this._blocked           = false;
        this._hide              = params.hide;
        this._queue             = [];
        this._cells             = [];
        this._focusObj          = { inner:false, duration:0 };
        this._maxFocusIndex     = params.maxIndex;
        this._index             = this._maxFocusIndex;
        this._cellH             = new params.type().getHeightUnfocused();
        this._widgetType        = params.type && params.type.name;
        this._container         = new Widget().init();
        this._scroll            = new ScrollWidget().init( { widget:this._container, w:params.w, h:params.h } );
        this.addWidget( this._scroll );

        dimension    = ( this._axis === ListWidget.Axis.X ) ? params.w : params.h;
        this._numVis = Math.floor( dimension / this._cellH ) + ((dimension % this._cellH > 0) ? 1 : 0);
        numCells     = this._numVis + this._maxFocusIndex + 2;

        for( i = 0; i < numCells; i++ )
        {
            if( this._axis === ListWidget.Axis.X )
            {
                this._cells.push( new params.type().init( { h:params.h, obj:params.obj, rowIndex:i } ) );
                this._cells[i].setH( params.h );
                this._container.addWidget( this._cells[i], i * this._cellH );
            }
            else
            {
                this._cells.push( new params.type().init( { w:params.w, obj:params.obj, rowIndex:i } ) );
                this._cells[i].setW( params.w );
                this._container.addWidget( this._cells[i], 0, i * this._cellH );
            }

            this._cells[i]._dataIndex = i - this._index;
            this._cells[i].forceUpdate( true );

            if( !this._rows )
                this._cells[i].setA( 0 );
        }

        this._cells[this._cells.length-1]._dataIndex -= this._cells.length;

        if( this._axis === ListWidget.Axis.X )
        {
            this._scroll.setScroll( { x:-this._index*this._cellH, duration:0 } );

            if( params.touchH >= 0 && params.touchW >= 0 )
            {
                this._moreLeft  = new MoreTargetWidget().init( { dir:MoreTargetWidget.Dir.LEFT , h:params.touchH, w:params.touchW } );
                this._moreRight = new MoreTargetWidget().init( { dir:MoreTargetWidget.Dir.RIGHT, h:params.touchH, w:params.touchW } );
                this._moreLeft.setA( 0 );
                this._moreRight.setA( 0 );
                this.addWidget( this._moreLeft, -params.touchW );
                this.addWidget( this._moreRight, params.w );
                this._moreLeft.setMouseDownListener ( function() { self.processEvent( Host.KEY_LEFT , Host.KEY_PRESSED ); self.processEvent( Host.KEY_LEFT , Host.KEY_RELEASED ); } );
                this._moreRight.setMouseDownListener( function() { self.processEvent( Host.KEY_RIGHT, Host.KEY_PRESSED ); self.processEvent( Host.KEY_RIGHT, Host.KEY_RELEASED ); } );
            }
        }
        else
            this._scroll.setScroll( { y:-this._index*this._cellH, duration:0 } );

        this.setPosition( this._cells[this._cells.length-1], -this._cellH );

        this.setMouseWheelListener( function( event ) { if( self._blocked === false ) self.processEvent( ( event.deltaY > 0 ) ? Host.KEY_DOWN : Host.KEY_UP, Host.KEY_PRESSED ); } );

        if( params.rows )
            this.setData( params.rows );
        return this;
    };

    ListWidget.prototype.getPosition = function( obj )
    {
        return ( this._axis === ListWidget.Axis.X ) ? obj.getX() : obj.getY();
    };

    ListWidget.prototype.processEvent = function( val, type )
    {
        var retval, onDownEnd, onDownInc, onUpEnd, onUpInc, numVis, updateIndex, nextDataIndex, self = this, aListener, hListener, startBack, startFwd, collapse, currIndex;

        onDownEnd = function()
        {
            if( self._currentFocusIndex ) {
                if( self._cellOffset != self._currentFocusIndex ) {
                    self._cells[ self._currentFocusIndex ].lostFocus();
                }
                self._currentFocusIndex -= 1;
            }
            onDownInc( 1 );
            self._cellOffset = (self._cellOffset + self._cells.length - 1) % self._cells.length;
            if( self._supressSelection !== true )
                _x2.requestFocus( self._cells[(self._cellOffset + self._index) % self._cells.length] );
            else
                self._cells[(self._cellOffset + self._index) % self._cells.length].gotFocus();
            self.processQueue();
        };

        onDownInc = function( inc )
        {
            var start, end, i, gPos;
            var dataIndex = self._cells[(self._cellOffset + self._index) % self._cells.length]._dataIndex;
            var delta     = self.getPosition( self._cells[self._cellOffset] );
            var offset    = (dataIndex - self._maxFocusIndex) * self._cellH - delta;

            if( self._stepListener )
                self._stepListener( dataIndex - inc );

            start = (self._cellOffset + 1) % self._cells.length;
            end   = start + self._cells.length - 3;  // exclude _cellOffset cell, very bottom and very top cells

            for( i = start; i < end; i++ )
                self.setPosition( self._cells[i % self._cells.length], self.getPosition( self._cells[self._cellOffset] ) + (i - start + 1) * self._cellH );

            start = end;
            end   = start + 2;

            for( i = start; i < end; i++ )
                self.setPosition( self._cells[i % self._cells.length], self.getPosition( self._cells[self._cellOffset] ) - (start + 2 - i) * self._cellH );

            if( dataIndex <= self._maxFocusIndex )
            {
                gPos = self.getGlobalPos();

                if( self._axis === ListWidget.Axis.X )
                    self._focusObj.x = gPos.x - self.getPosition( self._cells[self._maxFocusIndex] ) + self._cellH * self._maxFocusIndex;
                else
                    self._focusObj.y = gPos.y - self.getPosition( self._cells[self._maxFocusIndex] ) + self._cellH * self._maxFocusIndex;

                self.setPosition( self._container, offset );
                if( self._supressSelection !== true )
                    _x2._hi.setPosition( self._focusObj );
            }
        };

        onUpEnd = function()
        {
            if( self._currentFocusIndex ) {
                if( self._cellOffset != self._currentFocusIndex ) {
                    self._cells[ self._currentFocusIndex ].lostFocus();
                }
                
                self._currentFocusIndex += 1;
            }
            onUpInc( 1 );
            self._cellOffset = (self._cellOffset + 1) % self._cells.length;
            if( self._supressSelection !== true )
                _x2.requestFocus( self._cells[(self._cellOffset + self._index) % self._cells.length] );
            else
                self._cells[(self._cellOffset + self._index) % self._cells.length].gotFocus();
            self.processQueue();
        };

        onUpInc = function( inc )
        {
            var index, i, gPos;
            var dataIndex = self._cells[(self._cellOffset + self._index) % self._cells.length]._dataIndex;
            var delta     = self.getPosition( self._cells[self._cellOffset] );
            var offset    = (dataIndex - self._maxFocusIndex) * self._cellH - delta;

            if( self._stepListener )
                self._stepListener( dataIndex + inc );

            for( i = 0; i < self._cells.length; i++ )
                if( i !== self._cellOffset )
                {
                    index = (i-self._cellOffset+self._cells.length) % self._cells.length;
                    self.setPosition( self._cells[i], index * self._cellH + self.getPosition( self._cells[self._cellOffset] ) );
                }

            if( dataIndex < self._maxFocusIndex )
            {
                gPos = self.getGlobalPos();

                if( self._axis === ListWidget.Axis.X )
                    self._focusObj.x = gPos.x - self.getPosition( self._cells[self._maxFocusIndex] ) + self._cellH * self._maxFocusIndex;
                else
                    self._focusObj.y = gPos.y - self.getPosition( self._cells[self._maxFocusIndex] ) + self._cellH * self._maxFocusIndex;

                self.setPosition( self._container, offset );

                if( self._supressSelection !== true )
                    _x2._hi.setPosition( self._focusObj );
            }
        };

        startBack = function( type, val )
        {
            var obj, retval = true;

            if( type === Host.KEY_PRESSED )
            {
                if( self._blocked === false && self._cellOffset > -1 )
                {
                    currIndex   = self._cells[self._cellOffset]._dataIndex;
                    updateIndex = (self._cellOffset + self._cells.length - 2) % self._cells.length;
                    numVis      = self._rows.length - 1 - self._cells[self._cellOffset]._dataIndex;

                    if( self._moreLeft && currIndex === 1 )
                        self._moreLeft.animate( { a:0, duration:500 } );

                    if( self._moreRight && (currIndex + self._numVis) === self._rows.length )
                        self._moreRight.animate( { a:1, duration:500 } );

                    if( self._cells[updateIndex]._dataIndex >= 0 )
                        nextDataIndex = self._cells[updateIndex]._dataIndex - self._cells.length;
                    else
                        nextDataIndex = self._cells[updateIndex]._dataIndex;

                    if( nextDataIndex >= -1 - self._maxFocusIndex )
                    {
                        if( self._hide === true )
                            _x2._hi.fadeOut( 0 );
                        else
                            self.doFocusTransition( (self._cellOffset + self._index + self._cells.length - 1) % self._cells.length );

                        self._cells[(self._cellOffset + self._index) % self._cells.length].lostFocus();
                        self._cells[updateIndex].setData( self._rows[nextDataIndex] );
                        self._cells[updateIndex]._dataIndex = nextDataIndex;
                        self._blocked = true;

                        obj = { duration:self._stepTime, easing:Widget.Easing.LINEAR, onInc:onDownInc, onEnd:onDownEnd };

                        if( self._axis === ListWidget.Axis.X )
                            obj.x = self._cellH;
                        else
                            obj.y = self._cellH;

                        self._cells[self._cellOffset].animate( obj );

                        if( self._stepStartListener )
                            self._stepStartListener( -1 );

                        if( self._supressSelection !== true )
                            _x2.requestFocus( self );
                    }
                    else
                        retval = false;
                }
                else
                    self._queue.push( [ val, type ] );
            }
            else if( type === Host.KEY_RELEASED )
            {
                if( self._queue.length > 0 )
                {
                    if( self._queue[self._queue.length-1][1] === Host.KEY_REPEAT )
                        self._queue.pop();
                }
                else if( self._scrollMode !== undefined ) // && self._stop === undefined )
                {
                    if( self._stop === undefined )
                    {
                        if( self._datum === undefined )
                            self._datum = 1;

                        self._scrollMode = SCROLL.BACK_STOP;
                    }
                    else
                        console.error( "_STOP is defined, IGNORE" );
                }
            }
            else if( type === Host.KEY_REPEAT )
            {
                if( self._blocked === false )
                {
                    if( self._queue.length > 0 )
                    {
                        self._queue.push( [ val, type ] );
                    }
                    else
                    {
                        if( self._hide === true )
                            _x2._hi.fadeOut( 0 );
                        else
                            self.doFocusTransition( 0, true );

                        self._cells[(self._cellOffset + self._index) % self._cells.length].lostFocus();
                        self._blocked    = true;
                        self._scrollMode = SCROLL.BACK;

                        if( self._supressSelection !== true )
                            _x2.requestFocus( self );
                    }
                }
                else
                    self._queue.push( [ val, type ] );
            }

            return retval;
        };

        startFwd = function( type, val )
        {
            var obj, retval = true;

            if( type === Host.KEY_PRESSED )
            {
                if( self._blocked === false && ! self._dataBlocking )
                {
                    currIndex     = self._cells[self._cellOffset]._dataIndex;
                    updateIndex   = (self._cellOffset + self._cells.length - 1) % self._cells.length;
                    nextDataIndex = self._cells[updateIndex]._dataIndex + self._cells.length;
                    numVis        = self._rows.length - 1 - currIndex;

                    if( self._moreLeft && currIndex === 0 )
                        self._moreLeft.animate( { a:1, duration:500 } );

                    if( self._moreRight && (currIndex + self._maxFocusIndex + self._numVis) === self._rows.length )
                        self._moreRight.animate( { a:0, duration:500 } );

                    if( numVis >= self._maxFocusIndex + 1 )
                    {
                        if( self._hide === true )
                            _x2._hi.fadeOut( 0 );
                        else
                            self.doFocusTransition( (self._cellOffset + self._index + 1) % self._cells.length );

                        self._cells[(self._cellOffset + self._index) % self._cells.length].lostFocus();
                        self._cells[updateIndex].setData( (nextDataIndex < self._rows.length) ? self._rows[nextDataIndex] : undefined );
                        self._cells[updateIndex]._dataIndex = nextDataIndex;
                        self._blocked = true;

                        obj = { duration:self._stepTime, easing:Widget.Easing.LINEAR, onInc:onUpInc, onEnd:onUpEnd };

                        if( self._axis === ListWidget.Axis.X )
                            obj.x = -self._cellH;
                        else
                            obj.y = -self._cellH;

                        self._cells[self._cellOffset].animate( obj );

                        if( self._stepStartListener )
                            self._stepStartListener( 1 );

                        if( self._supressSelection !== true )
                            _x2.requestFocus( self );
                    }
                    else
                        retval = false;
                }
                else
                    self._queue.push( [ val, type ] );
            }
            else if( type === Host.KEY_RELEASED )
            {
                if( self._queue.length > 0 )
                {
                    if( self._queue[self._queue.length-1][1] === Host.KEY_REPEAT )
                        self._queue.pop();
                }
                else if( self._scrollMode !== undefined ) // && self._stop === undefined )
                {
                    if( self._stop === undefined )
                    {
                        if( self._datum === undefined )
                            self._datum = 1;

                        self._scrollMode = SCROLL.FWD_STOP;
                    }
                    else
                        console.error( "_STOP is defined, IGNORE" );
                }
            }
            else if( type === Host.KEY_REPEAT )
            {
                if( self._blocked === false )
                {
                    if( self._queue.length > 0 )
                    {
                        self._queue.push( [ val, type ] );
                    }
                    else
                    {
                        if( self._hide === true )
                            _x2._hi.fadeOut( 0 );
                        else
                            self.doFocusTransition( 0, true );

                        self._cells[(self._cellOffset + self._index) % self._cells.length].lostFocus();
                        self._blocked    = true;
                        self._scrollMode = SCROLL.FWD;

                        if( self._supressSelection !== true )
                            _x2.requestFocus( self );
                    }
                }
                else
                    self._queue.push( [ val, type ] );
            }

            return retval;
        };

        collapse = function()
        {
            aListener = function( a )
            {
                for( var i = 0; i < self._cells.length; i++ )
                {
                    if( self._cells[i]._dataIndex < self._rows.length && i !== self._cellOffset  )
                        self._cells[i].setA( a );
                }
            };

            hListener = function( h )
            {
                var focusY = _x2._focus.getY();

                for( var i = 0; i < self._cells.length; i++ )
                {
                    if( self._cells[i]._baseY > focusY )
                        self._cells[i].setY( self._cells[i]._baseY + h - self._cellH );
                }
            };

            self._expanded = false;

            if( self._cells[self._cellOffset + self._index].contract )
                self._cells[self._cellOffset + self._index].contract( hListener, aListener );

            if( _x2._focus !== self._cells[self._cellOffset + self._index] )
                _x2.requestFocus( self );
        };

        switch( val )
        {
            case Host.KEY_DOWN:
                if( this._rows && this._expanded !== true && this._axis === ListWidget.Axis.Y )
                    retval = startFwd( type, Host.KEY_DOWN );
                else
                    retval = Widget.prototype.processEvent.call( this, val, type );
                break;

            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._expanded !== true && _x2._focus !== this )
                    {
                        aListener = function( a )
                        {
                            for( var i = 0; i < self._cells.length; i++ )
                            {
                                if( self._cells[i] !== _x2._focus && self._cells[i].getA() > 0 )
                                    self._cells[i].setA( a );
                            }
                        };

                        hListener = function( h )
                        {
                            var focusY = _x2._focus.getY();

                            for( var i = 0; i < self._cells.length; i++ )
                            {
                                if( self._cells[i]._baseY > focusY )
                                    self._cells[i].setY( self._cells[i]._baseY + h - self._cellH );
                            }
                        };

                        this._expanded = true;

                        for( var i = 0; i < this._cells.length; i++ )
                            this._cells[i]._baseY = this._cells[i].getY();

                        if( _x2._focus.expand )
                            _x2._focus.expand( hListener, aListener );
                    }
                }
                else
                    retval = Widget.prototype.processEvent.call( this, val, type );
                break;

            case Host.KEY_LAST:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._expanded === true )
                        collapse();
                    else
                        retval = Widget.prototype.processEvent.call( this, val, type );
                }
                break;

            case Host.KEY_LEFT:
                if( this._rows && this._expanded !== true && this._axis === ListWidget.Axis.X )
                    startBack( type, Host.KEY_LEFT );
                else {
                    retval = Widget.prototype.processEvent.call( this, val, type );
                } 
                break;

            case Host.KEY_RIGHT:
                if( this._rows && this._expanded !== true && this._axis === ListWidget.Axis.X )
                    startFwd( type, Host.KEY_RIGHT );
                else
                    retval = Widget.prototype.processEvent.call( this, val, type );
                break;

            case Host.KEY_UP:
                if( this._expanded === true )
                {
                    if( type === Host.KEY_PRESSED )
                        collapse();
                }
                else if( this._rows && this._expanded !== true && this._axis === ListWidget.Axis.Y && (this._cells[this._cellOffset]._dataIndex + this._maxFocusIndex) > 0 )
                    startBack( type, Host.KEY_UP );
                else
                    retval = Widget.prototype.processEvent.call( this, val, type );
                break;

            default:
                retval = Widget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    ListWidget.prototype.processQueue = function()
    {
        var key = this._queue.shift();

        this._blocked = false;

        if( key !== undefined )
            this.processEvent( key[0], key[1] );
    };

    ListWidget.prototype.refreshCells = function()
    {
        for( var i = 0; i < this._cells.length; i++ )
            if( this._cells[i].refreshCell )
                this._cells[i].refreshCell();
    };

    ListWidget.prototype.setBlockingOnData = function( blocking )
    {
        this._dataBlocking = blocking;
    };

    ListWidget.prototype.setData = function( rows )
    {
        this._rows       = rows;
        this._cellOffset = 0;
        this._index      = this._maxFocusIndex;

        for( var i = 0; i < this._cells.length; i++ )
        {
            this._cells[i]._dataIndex = i-this._index;
            this._cells[i].setData( rows ? rows[this._cells[i]._dataIndex] : undefined );

            this.setPosition( this._cells[i], i * this._cellH );
        }

        this._cells[this._cells.length-1]._dataIndex -= this._cells.length;

        if( this._axis === ListWidget.Axis.X )
            this._scroll.setScroll( { x:-this._index*this._cellH, duration:0 } );
        else
            this._scroll.setScroll( { y:-this._index*this._cellH, duration:0 } );

        this.setPosition( this._cells[this._cells.length-1], -this._cellH );

        if( this._moreLeft )
            this._moreLeft.animate( { a:0, duration:500 } );

        if( this._moreRight )
            if( rows && rows.length > this._numVis )
                this._moreRight.animate( { a:1, duration:500 } );
            else
                this._moreRight.animate( { a:0, duration:500 } );

        if( _x2._focus === this )
            this.gotFocus();
    };

    ListWidget.prototype.setEntry = function( tag, val, newRow )
    {
        var row, whichCell;

        if( this._rows )
            for( var i = 0; i < this._rows.length; i++ )
            {
                row = this._rows[i];

                if( row[tag] === val )
                {
                    this._rows[i] = newRow;
                    whichCell     = (this._maxFocusIndex + i) % this._cells.length;

                    if( this._cells[whichCell]._dataIndex === i )
                        this._cells[whichCell].setData( newRow );

                    break;
                }
            }
    };

    ListWidget.prototype.setJumpToIndex = function( dataIndex )
    {
        if( dataIndex > this._rows.length - 1 )
            dataIndex = this._rows.length - 1;

        var index, i, start, pos;
        var cellIndex = (dataIndex + this._maxFocusIndex) % this._cells.length;
        var shifts    = (dataIndex < this._maxFocusIndex) ? this._maxFocusIndex - dataIndex : 0;

        this.setPosition( this._container, -shifts * this._cellH );

        for( i = 0; i < this._cells.length; i++ )
        {
            index = (cellIndex + i + this._cells.length) % this._cells.length;

            this._cells[index]._dataIndex = dataIndex + i;
            this._cells[index].setData( this._rows ? this._rows[this._cells[index]._dataIndex] : undefined );
            this.setPosition( this._cells[index], (i + this._maxFocusIndex + shifts) * this._cellH + this.getPosition( this._container ) );
        }

        start = cellIndex + this._cells.length - 1;
        pos   = this.getPosition( this._cells[cellIndex] );

        for( i = start; i > start - this._maxFocusIndex - 1; i-- )
        {
            index = i % this._cells.length;

            this._cells[index]._dataIndex -= this._cells.length;
            this._cells[index].setData( this._rows ? this._rows[this._cells[index]._dataIndex] : undefined );
            this.setPosition( this._cells[index], pos - (start - i + 1) * this._cellH );
        }

        this._cellOffset = dataIndex % this._cells.length;

        if( this.containsWidget( _x2._focus ) === true )
            _x2.requestFocus( this );
    };
    
    ListWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        if( this._scroll )
            this._scroll.setH( val );
    };

    ListWidget.prototype.setPosition = function( obj, val )
    {
        return ( this._axis === ListWidget.Axis.X ) ? obj.setX( val ) : obj.setY( val );
    };

    ListWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );

        if( this._scroll )
            this._scroll.setW( val );

        if( this._moreRight )
            this._moreRight.setX( val );
    };

    ListWidget.prototype.suppressSelection = function( bool )
    {
        this._supressSelection = bool;
    };

    ListWidget.prototype.update = function( step, alphaParent )
    {
        var intervals, delta, h, y, i, yNow, nextDataIndex, currIndex, incs, index, dataIndex, gPos, round;

        switch( this._scrollMode )
        {
            case SCROLL.BACK_STOP:
                if( this._stop === undefined && this._datum !== undefined )
                {
                    intervals = Math.floor( (step - this._datum) / this._stepTime ) + 1;
                    this._stop = this._datum + intervals * this._stepTime;
                    this._scrollMode = SCROLL.BACK;
                    this.update( step );
                }
                break;

            case SCROLL.BACK:
                if( this._datum !== undefined )
                {
                    if( (this._stop !== undefined && step > this._stop) || step >= this._maxTime )
                    {
                        if( this._stop > this._maxTime )
                            this._stop = this._maxTime;

                        step             = this._stop || this._maxTime;
                        this._blocked    = false;
                        this._scrollMode = undefined;
                        this._stop       = undefined;
                        this._maxTime    = undefined;
                    }

                    delta = (step - this._datum) * this._cellH / this._stepTime;
                    h     = this._cellH * this._cells.length;

                    if( this._stepListener )
                        this._stepListener( this._repeatIndex - (step - this._repeatDatum) / this._stepTime );

                    for( i = 0; i < this._cells.length; i++ )
                    {
                        yNow = this.getPosition( this._cells[i] );
                        y    = (delta + this._cellH * ( i + 2 )) % h - 2 * this._cellH;

                        if( yNow > y )
                        {
                            nextDataIndex = this._cells[i]._dataIndex - this._cells.length;
                            this._cells[i]._dataIndex = nextDataIndex;
                            this._cells[i].setData( (nextDataIndex >= 0) ? this._rows[nextDataIndex] : undefined );
                        }

                        this.setPosition( this._cells[i], y );

                        if( (this._cells[i]._dataIndex === 0) && (this.getPosition( this._cells[i] ) >= 0) )
                        {
                            gPos = this.getGlobalPos();

                            this.setPosition( this._container, -this.getPosition( this._cells[i] ) );

                            if( this._axis === ListWidget.Axis.X )
                                this._focusObj.x = gPos.x + this._maxFocusIndex * this._cellH - this.getPosition( this._cells[i] );
                            else
                                this._focusObj.y = gPos.y + this._maxFocusIndex * this._cellH - this.getPosition( this._cells[i] );

                            if( this._cells[i]._selectable === true && this._supressSelection !== true )
                                _x2._hi.setPosition( this._focusObj );
                        }
                    }

                    if( this._scrollMode === undefined )
                    {
                        this._datum      = undefined;
                        this._cellOffset = (this._cells.length - ((h + this.getPosition( this._cells[0] )) % h) / this._cellH) % this._cells.length;
                        round            = Math.round( this._cellOffset );

                        if( this._cellOffset !== round )
                        {
                            console.error( "CELL OFFSET IS NOT AN INTEGER" + this._cellOffset );
                            this._cellOffset = round;
                        }

                        index            = (this._cellOffset + this._cells.length - 2) % this._cells.length;
                        dataIndex        = this._cells[index]._dataIndex + this._cells.length;

                        this.setPosition( this._cells[index], (this._cells.length - 2) * this._cellH );
                        this._cells[index]._dataIndex = dataIndex;
                        this._cells[index].setData( this._rows[dataIndex] );

                        if( this._stepStopListener )
                            this._stepStopListener();

                        if( this._supressSelection !== true )
                            _x2.requestFocus( this._cells[(this._cellOffset + this._index) % this._cells.length] );
                        else
                            this._cells[(this._cellOffset + this._index) % this._cells.length].gotFocus();

                        if( this._moreRight && (this._cells[this._cellOffset]._dataIndex + this._numVis) < this._rows.length  )
                            this._moreRight.animate( { a:1, duration:500 } );

                        if( this._moreLeft && this._cells[this._cellOffset]._dataIndex <= this._maxFocusIndex )
                            this._moreLeft.animate( { a:0, duration:500 } );
                    }
                }
                else
                {
                    currIndex         = this._cells[(this._cellOffset+this._maxFocusIndex) % this._cells.length]._dataIndex;
                    incs              = currIndex + this._cells.length - this._cellOffset;
                    this._datum       = step - (this._cells.length - this._cellOffset) * this._stepTime;
                    this._repeatDatum = step;
                    this._repeatIndex = this._cells[this._cellOffset]._dataIndex;
                    this._maxTime     = this._datum + this._stepTime * incs;
                }
                break;

            case SCROLL.FWD_STOP:
                if( this._stop === undefined && this._datum !== undefined )
                {
                    intervals = Math.floor( (step - this._datum) / this._stepTime ) + 1;
                    this._stop = this._datum + intervals * this._stepTime;
                    this._scrollMode = SCROLL.FWD;
                    this.update( step );
                }
                break;

            case SCROLL.FWD:
                if( this._datum !== undefined )
                {
                    if( (this._stop !== undefined && step > this._stop) || step >= this._maxTime )
                    {
                        if( this._stop > this._maxTime )
                            this._stop = this._maxTime;

                        step             = this._stop || this._maxTime;
                        this._blocked    = false;
                        this._scrollMode = undefined;
                        this._stop       = undefined;
                        this._maxTime    = undefined;
                    }

                    delta = (step - this._datum) * this._cellH / this._stepTime;
                    h     = this._cellH * this._cells.length;

                    if( this._stepListener )
                        this._stepListener( this._repeatIndex + (step - this._repeatDatum) / this._stepTime );

                    for( i = 0; i < this._cells.length; i++ )
                    {
                        yNow = this.getPosition( this._cells[i] );
                        y    = this._cellH * (this._cells.length - 1) - (delta + this._cellH * (this._cells.length - 1 - i)) % h;

                        if( yNow < y )
                        {
                            nextDataIndex = this._cells[i]._dataIndex + this._cells.length;
                            this._cells[i]._dataIndex = nextDataIndex;
                            this._cells[i].setData( (nextDataIndex < this._rows.length) ? this._rows[nextDataIndex] : undefined );
                        }

                        this.setPosition( this._cells[i], y );

                        if( this._cells[i]._dataIndex === 0 )
                        {
                            if( this.getPosition( this._cells[i] ) >= 0 )
                            {
                                gPos = this.getGlobalPos();

                                this.setPosition( this._container, -this.getPosition( this._cells[i] ) );

                                if( this._axis === ListWidget.Axis.X )
                                    this._focusObj.x = gPos.x + this._maxFocusIndex * this._cellH - this.getPosition( this._cells[i] );
                                else
                                    this._focusObj.y = gPos.y + this._maxFocusIndex * this._cellH - this.getPosition( this._cells[i] );

                                if( this._supressSelection !== true )
                                    _x2._hi.setPosition( this._focusObj );
                            }
                            else
                                this.setPosition( this._container, 0 );
                        }
                    }

                    if( this._scrollMode === undefined )
                    {
                        this._datum      = undefined;
                        this._cellOffset = (this._cells.length - this.getPosition( this._cells[0] ) / this._cellH) % this._cells.length;
                        round            = Math.round( this._cellOffset );

                        if( this._cellOffset !== round )
                        {
                            console.error( "CELL OFFSET IS NOT AN INTEGER " + this._cellOffset );
                            this._cellOffset = round;
                        }

                        index            = (this._cells.length + this._cellOffset - 1) % this._cells.length;
                        dataIndex        = this._cells[index]._dataIndex - this._cells.length;

                        this.setPosition( this._cells[index], -this._cellH );
                        this._cells[index]._dataIndex = dataIndex;
                        this._cells[index].setData( this._rows[dataIndex] );

                        if( this._stepStopListener )
                            this._stepStopListener();

                        if( this._supressSelection !== true )
                            _x2.requestFocus( this._cells[(this._cellOffset + this._index) % this._cells.length] );
                        else
                            this._cells[(this._cellOffset + this._index) % this._cells.length].gotFocus();

                        if( this._moreRight && (dataIndex + this._maxFocusIndex + this._numVis) >= this._rows.length  )
                            this._moreRight.animate( { a:0, duration:500 } );

                        if( this._moreLeft && this._cells[this._cellOffset]._dataIndex > this._maxFocusIndex && this._moreLeft.getA() < 1 )
                            this._moreLeft.animate( { a:1, duration:500 } );
                    }
                }
                else
                {
                    currIndex         = this._cells[(this._cellOffset+this._maxFocusIndex) % this._cells.length]._dataIndex;
                    incs              = this._rows.length - 1 - currIndex;
                    this._datum       = step - this._cellOffset * this._stepTime;
                    this._repeatDatum = step;
                    this._repeatIndex = this._cells[this._cellOffset]._dataIndex;
                    this._maxTime     = step + this._stepTime * incs;
                }
                break;

            default:
                if( this._blocked === false )
                    this.processQueue();
                break;
        }

        Widget.prototype.update.call( this, step, alphaParent );
    };

    ListWidget.prototype.moveCursorToRow = function( rowIndex ) {
        var lastRowIndex = this._currentFocusIndex;
        var currentRowIndex = rowIndex;
        var totalRows = this._cells.length;
        if( currentRowIndex !== lastRowIndex ) {
            var focusToIndex = (currentRowIndex) % totalRows;
            var y = this._cells[focusToIndex].getGlobalPos().y - _x2._hi._top;
            var h = this._cells[focusToIndex].getH();
            _x2._hi.setY( y );
            _x2._hi.setH( h );
            this._cells[lastRowIndex] && this._cells[lastRowIndex].lostFocus();
            this._cells[focusToIndex].gotFocus();
        }
    }

    return ListWidget;

})();


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MenuRowWidget = ( function()
{
    "use strict";

    MenuRowWidget.prototype = new ListRowWidget();

    function MenuRowWidget(){}

    MenuRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 * _x2._config._text );
    };

    MenuRowWidget.prototype.getTitle = function()
    {
        return this._title.getText();
    };

    MenuRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._title.gotFocus();
        this._subIcon.gotFocus();

        var str = (this._data && this._data.showIcon === true && newScreen !== true) ? "Press OK for options. " : "";

        if( this._data && this._data.value )
            str = this._data.value + ". " + str;
        this._parent._parent._parent._currentFocusIndex = this._currentRowIndex;
        this._title.setSpeechParams( str, undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof MenuRowWidget
     * @param   {Object}    params
     * @param   {Number}   [params.focusTime=0] - Time to animate the focus action
     * @param   {Function} [params.onEnter]     - Function to execute on selection
     * @param   {Boolean}  [params.showIcon]    - Show the sub-menu icon
     * @param   {String}    params.title        - Title of the row
     * @param   {String}   [params.value]       - Value to show next to the title
     * @param   {Number}    params.w            - Width of the row
     * @returns {MenuRowWidget}
     * @see ListRowWidget
     */
    MenuRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "MenuRowWidget";
        this._selectable = true;

        var self       = this;
        var titleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var valueStyle = new Style( { color:"#2ea0dd", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        this._numElements = 0;
        this._onEnter     = params.onEnter;
        this._focusTime   = ( params.focusTime !== undefined ) ? params.focusTime : 0;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._title );

        this._value = new StringWidget().init( { text:params.value, style:valueStyle } );
        this.addWidget( this._value );

        this._subIcon = new DualImageWidget().init( { url:_x2._config._imageRoot + "menuRowSub.png", urlHi:_x2._config._imageRoot + "menuRowSubHi.png" } );
        this._subIcon.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._subIcon );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._currentRowIndex = params.rowIndex;

        return this;
    };

    MenuRowWidget.prototype.layout = function()
    {
        if( this._numElements === 2 )
        {
            this._subIcon.setX( this.getW() - this._subIcon.getW() );
            this._subIcon.setY( (this.getHeightUnfocused() - this.getSepH() - this._subIcon.getH()) / 2 );

            if( this._title.getText() === undefined )  // make sure string widget has a valid height
                this._title.setText( "????" );

            this._titleBaseY = (this.getHeightUnfocused() - this._title.getH()) / 2;
            this._title.setY( this._titleBaseY );
            this._value.setX( this._title.getX() + this._title.getW() + Style._pad );
            this._value.setY( this._titleBaseY );
        }
    };

    MenuRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
        this._subIcon.lostFocus();
        this._parent._parent._parent._lastFocusIndex = this._currentRowIndex;
    };

    MenuRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED && this._onEnter )
                {
                    retval = true;
                    this._onEnter( this );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    MenuRowWidget.prototype.refreshCell = function()
    {
        if( this._data && this._data.value !== this._value.getText() ) {
            this._value.setText( this._data.value );
        }
    };

    /**
     * @memberof MenuRowWidget
     * @param {Object}   [data]
     * @param {Function}  data.onEnter   - callback
     * @param {Boolean}  [data.showIcon] -
     * @param {String}    data.title     - Row title
     * @param {Object}   [data.value]    - Value to show next to the title
     */
    MenuRowWidget.prototype.setData = function( data )
    {
        var self = this;
        this._data = data;

        if( data !== undefined )
        {
            this._title.setText( data.title );
            this._onEnter = data.onEnter;

            if( data.showIcon === true )
                this._subIcon.setA( 1 );
            else
                this._subIcon.setA( 0 );

            if( data.value !== undefined )
            {
                this._value.setText( data.value );
                this._value.setX( this._title.getX() + this._title.getW() + Style._pad );
                this._value.setA( 1 );
            }
            else
                this._value.setA( 0 );

            this.setA( 1 );
            this.setMouseDownListener( function() { self._onEnter( self ); } );
            this.setMouseEnterListener( function() { 
                this._parent._parent._parent.moveCursorToRow( this._currentRowIndex );
             } );
        }
        else
        {
            this.setA( 0 );
            this.enableMouseDownListener( false );
        }
    };

    MenuRowWidget.prototype.setValue = function( str )
    {
        if( this._data )
        {
            this._data.value = str;
            this._value.setText( str );
        }
    };

    return MenuRowWidget;

})();


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MiniGridRowWidget = ( function()
{
    "use strict";

    MiniGridRowWidget.prototype = new ListRowWidget();

    function MiniGridRowWidget(){}

    MiniGridRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 121 * _x2._config._text );
    };

    MiniGridRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        Widget.prototype.gotFocus.call( this );
        this.setHighlight();
        this._chanStr.gotFocus();
        this._title.gotFocus();
        this._title.setSpeechParams( ". " + _x2.createTimeSpeechStr( this._time.getText() ) + ". Channel " + this._chanStr.getText()+ ". " + this._data.getCallSign() + ". " , undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof MiniGridRowWidget
     * @param   {Object}    params
     * @param   {Object}    params.obj - The guide screen that led this overlay so the selection cn be returned
     * @param   {Number}    params.w   - Width of the list
     * @returns {MiniGridRowWidget}
     * @see ListRowWidget
     */
    MiniGridRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className   = "MiniGridRowWidget";
        this._selectable  = true;
        this._numElements = 0;
        this._maxLogoH    = _x2.scaleValInt( 72 );
        this._maxLogoW    = _x2.scaleValInt( 72 );
        this._controller  = params.obj;

        var self       = this, layout, onFadeLoaded, onLogoLoaded, onLogoFailed;
        var chanStyle  = new Style( { color:"#a3a3a3", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2b9cd8" } );
        var titleStyle = new Style( { color:"#e8e8e8", font:"regular", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2b9cd8", overflow:"hidden" } );
        var timeStyle  = new Style( { color:"#a3a3a3", font:"medium" , fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", colorHi:"#2b9cd8" } );
        var onReady    = function() { self._numElements++; layout(); };

        layout = function()
        {
            self._chanColW = self._chanStr.getX() + self._chanStr.getW() + Style._pad;

            self._sep.setX( self._chanColW );

            self._chanStr.setY( (self.getHeightUnfocused() - self._chanStr.getH()) / 2 );
            self._name.setY( (self.getHeightUnfocused() - self._name.getH()) / 2 );

            self._title.setX( self._chanColW + _x2.scaleValInt( 36 ) );
            self._title.setY( (self.getHeightUnfocused() - ListRowWidget.DIVIDER_H - self._title.getH() - self._time.getH() - Style._pad) / 2 );

            self._time.setX( self._title.getX() );
            self._time.setY( self._title.getY() + self._title.getH() + Style._pad );
        };

        onFadeLoaded = function()
        {
            self._fade.setX( params.w - self._fade.getW() );
            self._fade.setW( self._fade.getW() );
            self._fade.setH( self.getHeightUnfocused() );
        };

        onLogoLoaded = function()
        {
            var dw, dh, scale;
            var w = self._logo.getW();
            var h = self._logo.getH();

            if( w > 0 && h > 0 )
            {
                dw    = self._maxLogoW / w;
                dh    = self._maxLogoH / h;
                scale = ( dh < dw ) ? dh : dw;

                self._logo.setX( (self._maxLogoW            - self._logo.getW()) / 2 );
                self._logo.setY( (self.getHeightUnfocused() - self._logo.getH()) / 2 );
                self._logo.setScale( scale );
                self._logo.setA( 1 );
            }
        };

        onLogoFailed = function()
        {
            self._name.setA( 1 );
        };

        this._logo = new ImageWidget().init( { onChange:onLogoLoaded, onError:onLogoFailed } );
        this.addWidget( this._logo );

        this._chanStr = new StringWidget().init( { text:"0000", style:chanStyle } );
        this._chanStr.addReadyCallback( onReady );
        this.addWidget( this._chanStr, this._maxLogoW + _x2.scaleValInt( 62 ) );

        this._sep = new RectWidget().init( { w:ListRowWidget.DIVIDER_H, h:this.getHeightUnfocused(), color:"#262626" } );
        this.addWidget( this._sep );

        this._title = new StringWidget().init( { text:"????", style:titleStyle } );
        this.addWidget( this._title );

        this._time = new StringWidget().init( { text:"????", style:timeStyle } );
        this.addWidget( this._time );

        this._fade = new ImageWidget().init( { url:_x2._config._imageRoot + "textFade2.png", onLoad:onFadeLoaded } );
        this.addWidget( this._fade );

        this._name = new StringWidget().init( { text:"???????", style:chanStyle } );
        this.addWidget( this._name );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    MiniGridRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );

        this._chanStr.lostFocus();
        this._title.lostFocus();
    };

    MiniGridRowWidget.prototype.processEvent = function( val, type )
    {
        var retval, self = this;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    var doTune = function( chan, sched )
                    {
                        self._controller.setTuneToChannel( self._data, sched );
                    };

                    var i, schedules = this._data.getSchedules(), now = new Date().getTime();

                    if( schedules )
                        for( i = 0; i < schedules.length; i++ )
                            if( schedules[i].getEndTime() > now )
                                break;


                    if( _x2._pc.isEnabled() === true )
                        _x2.checkParentalControls( schedules ? schedules[i] : undefined, undefined, this._data ).then( function() { doTune( self._data, schedules[i] ); } );
                    else
                        doTune( self._data, schedules[i] );

                    retval = true;
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    MiniGridRowWidget.prototype.setData = function( data )
    {
        this._data = data;

        if( data !== undefined )
        {
            var now       = new Date().getTime();
            var schedules = data.getSchedules(), sched;

            for( var i = 0; i < schedules.length; i++ )
            {
                if( schedules[i].getEndTime() > now )
                {
                    this._sched = sched = schedules[i];
                    break;
                }
            }

            this._chanStr.setText( data.getNumber() );
            this._name.setText( data.getCallSign() );
            this._name.setA( 0 );

            if( sched )
            {
                this._title.setText( sched.getGridTitle() );
                this._time.setText( _x2.createTimeRange( new Date( sched.getStartTime() ), new Date( sched.getEndTime() ) ) );
            }
            else
                console.log( data );

            this._logo.setA( 0 );
            this._logo.setW();
            this._logo.setH();
            this._logo.setUrl( data.getLogoUrl(50,30) );
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    MiniGridRowWidget.prototype.setHighlight = function( time, h )
    {
        var obj = this.getGlobalPos();

        obj.w        = this.getW();
        obj.h        = (h === undefined) ? this.getHeightUnfocused() - ListRowWidget.DIVIDER_H : h;
        obj.inner    = false;
        obj.duration = (time === undefined) ? ListWidget.SCROLL_TIME_STEP : time;

        _x2._hi.setPosition( obj );
    };

    return MiniGridRowWidget;

})();


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MoreTargetWidget = ( function()
{
    "use strict";

    MoreTargetWidget.prototype = new Widget();

    /**
     * @enum Dir
     * @property {Number} DOWN  - Down Arrow
     * @property {Number} LEFT  - Left Arrow
     * @property {Number} RIGHT - Right Arrow
     * @property {Number} UP    - Up Arrow
     */
    MoreTargetWidget.Dir = Object.freeze
    ({
        DOWN  : 0,
        LEFT  : 1,
        RIGHT : 2,
        UP    : 3
    });

    MoreTargetWidget.Size = Object.freeze
    ({
        GALLERY : 0,
        SMALL   : 1
    });

    function MoreTargetWidget(){}

    /**
     * Initializer
     * @memberof MoreTargetWidget
     * @param   {Object}  params
     * @param   {Number}  params.dir   - arrow direction
     * @param   {Number}  params.h     - height of target area
     * @param   {Number} [params.size] - size of arrow to use, default is GALLERY
     * @param   {Number}  params.w     - width of target area
     * @returns {MoreTargetWidget}
     */
    MoreTargetWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className = "MoreTargetWidget";

        this._notScale = 1;
        this._scale    = 8 / 9;

        var self     = this;
        var imName   = [ "moreDownGallery.png", "moreLeftGallery.png", "moreRightGallery.png", "moreUpGallery.png"];
        var imNameSm = [ "moreDownSm.png"     , "moreLeftSm.png"     , "moreRightSm.png"     , "moreUpSm.png"     ];
        var fileName = _x2._config._imageRoot + ((params.size === MoreTargetWidget.Size.SMALL) ? imNameSm[params.dir] : imName[params.dir]);

        this._image = new ImageWidget().init( { url:fileName, onLoad:function() { self.layoutMoreTargetWidget(); } } );
        this._image.setA( 0.6 );
        this._image.setScale( this._scale );
        this.addWidget( this._image );

        this.setW( params.w );
        this.setH( params.h );

        this.setMouseOutListener ( function() { self._image.animate( { duration:250, xScale:self._scale   , yScale:self._scale   , a:0.6 } ); } );
        this.setMouseOverListener( function() { self._image.animate( { duration:250, xScale:self._notScale, yScale:self._notScale, a:1.0 } ); } );

        return this;
    };

    MoreTargetWidget.prototype.layoutMoreTargetWidget = function()
    {
        this._image.setX( (this.getW() - this._image.getW()) / 2 );
        this._image.setY( (this.getH() - this._image.getH()) / 2 );
    };

    MoreTargetWidget.prototype.setArrowH = function( val )
    {
        this._notScale = val / this._image.getH();
        this._scale    = this._notScale * 8 / 9;
        this._image.setScale( this._scale );

        this.layoutMoreTargetWidget();
    };

    MoreTargetWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );
        this.layoutMoreTargetWidget();
    };

    return MoreTargetWidget;

})();


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MultiStateButtonWidget = ( function()
{
    "use strict";

    MultiStateButtonWidget.prototype = new Widget();

    function MultiStateButtonWidget(){}

    MultiStateButtonWidget.prototype.getState = function()
    {
        return Math.floor( this._index / 2 );
    };

    MultiStateButtonWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        Widget.prototype.gotFocus.call( this );

        if( this._index % 2 === 0 )
            this._images[++this._index].animate( { duration:250, alpha:1 } );
        this._label.animate( { duration:250, alpha:1 } );

        if( this._label.getText() )
            this._label.setSpeechParams( (this._index < this._images.length / 2)? "Unselected. " : "Selected. ", "button", this, newScreen );
    };

    MultiStateButtonWidget.prototype.inFocusState = function()
    {
        return this._index % 2 === 1;
    };

    /**
     * Initializer
     * @memberof MultiStateButtonWidget
     * @param   {Object}    params
     * @param   {Array}     params.images   - array of images, non-highlighted and highlighted images for each state
     * @param   {Number}    params.initial  - initial state of button
     * @param   {String}   [params.label]   - string to display below the button
     * @param   {Function}  params.onEnter  - Callback when button state is changed
     * @returns {MultiStateButtonWidget}
     */
    MultiStateButtonWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className  = "MultiStateButtonWidget";
        this._selectable = true;

        var self  = this, numLoaded = 0, w = _x2._config._screenW / 4;
        var style = new Style( { font:"medium", color:"#e8e8e8", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } );

        var imagesLoaded = function()
        {
            if( ++numLoaded === self._images.length )
            {
                self.setW( self._images[0].getW() );
                self.setH( self._images[0].getH() );
                self._label.setX( (self._images[0].getW() - w) / 2 );
                self._label.setY( self._images[0].getY() + self._images[0].getH() + _x2.scaleValInt( 10 ) );
                self.callbackSignalReady();
            }
        };

        this._index  = params.initial * 2;
        this._images = [];

        for( var i = 0; i < params.images.length; i++ )
        {
            this._images[i] = new ImageWidget().init( { url:params.images[i], onLoad:imagesLoaded } );
            this._images[i].setA( 0 );
            this.addWidget( this._images[i] );
        }

        this._images[this._index].setA( 1 );

        this._label = new StringWidget().init( { text:params.label, style:style } );
        this._label.setA( 0 );
        this._label.setW( w );
        this.addWidget( this._label );

        if( params.onEnter )
        {
            this._onEnter = params.onEnter;
            this.setMouseDownListener( params.onEnter );
        }

        return this;
    };

    MultiStateButtonWidget.prototype.lostFocus = function()
    {
        Widget.prototype.lostFocus.call( this );

        this._images[this._index--].animate( { duration:250, alpha:0 } );
        this._label.animate( { duration:250, alpha:0 } );
    };

    MultiStateButtonWidget.prototype.processEvent = function( val, type )
    {
        var retval, self = this, currentIndex = this._index;

        var onEnd = function()
        {
            self._images[currentIndex - 1].setA( 0 ) ;
            self._images[currentIndex].setA( 0 ) ;
            if( self._index > 0 ) {
                self._images[self._index - 1].setA( 1 ) ;
            }
        };

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            if( this._index % 2 === 0 )  // must be in a focus state to be toggling
                this._index++;

            this._index = (this._index + 2) % this._images.length;

            if( this._index < currentIndex )
            {
                this._images[this._index - 1].setA( 1 );
                this._images[this._index].setA( 1 );
                this._images[currentIndex - 1].setA( 0 );
                this._images[currentIndex].animate( { duration:250, a:0 } );
            }
            else
                this._images[this._index].animate( { duration:250, a:1, onEnd:onEnd } );

            if( this._onEnter )
                this._onEnter( Math.floor( this._index / 2 ) );

            if( this._label.getText() )
                this._label.setSpeechParams( (this._index < this._images.length / 2)? "Unselected. " : "Selected. ", "button", this, false );

            retval = true;
        }
        else
            retval = Widget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    MultiStateButtonWidget.prototype.setLabel = function( str )
    {
        this._label.setText( str );
    };

    MultiStateButtonWidget.prototype.setState = function( index )
    {
        this._index  = index * 2;

        for( var i = 0; i < this._images.length; i++ )
            this._images[i].setA( 0 );

        this._images[this._index].setA( 1 );
    };

    return MultiStateButtonWidget;

})();


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.NetworkCellWidget = ( function()
{
    "use strict";

    NetworkCellWidget.prototype = new CollectionCellWidget();

    function NetworkCellWidget(){}

    NetworkCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        CollectionCellWidget.prototype.gotFocus.call( this );
        this._bg.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );
        this._title.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        this._title.setSpeechParams( undefined, undefined, this, newScreen );

        return this;
    };

    /**
     * @memberof NetworkCellWidget
     * @param {Object} params - @see CollectionCellWidget
     * @returns {NetworkCellWidget}
     * @see CollectionCellWidget
     */
    NetworkCellWidget.prototype.init = function( params )
    {
        var self      = this;
        var spacing   = _x2.scaleValInt( 19 );
        var textSize  = _x2.scaleValInt( 48 );
        var titleSize = _x2.scaleValInt( 32 );
        var textStyle = new Style( { color:"#e8e8e8", font:"light", fontSize:textSize, textAlign :"center" } );
        var titleStyle= new Style( { color:"#e8e8e8", font:"light", fontSize:titleSize, whiteSpace:"nowrap" } );
        var alphas    = [ { opacity:100    , location:0 }, { opacity:100    ,location: 100 } ];
        var colors    = [ { color:"#1C262F", location:0 }, { color:"#130917", location:100 } ];

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "NetworkCellWidget";

        this._bgW    = _x2.scaleValInt( 412 );
        this._bgH    = _x2.scaleValInt( 309 );
        this._scale  = (this._bgW + 2 * spacing) / this._bgW;
        this._focusW = this._scale * this._bgW;
        this._focusH = this._scale * this._bgH;

        this._bg = new GradientWidget().init( { alphas:alphas, angle:-135, colors:colors, w:this._bgW, h:this._bgH, type:GradientWidget.Type.Linear } );
        this.addWidget( this._bg, spacing, (this._scale - 1) * this._bgH / 2 );

        this._defaultText = new TextBlockWidget().init( { style:textStyle, w:this._bgW, h:this._bgH } );
        this.addWidget( this._defaultText, spacing, ( this._bgH / 2 - textSize / 2 ) );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._bg.addWidget( this._title, 0, this._bgH + Style._pad );
        this._title.setA(0);

        this._image = new ImageWidget().init( { onError:function(){ self.imageError()}, onChange:function(){ self.imageLoaded() } } );
        this._bg.addWidget( this._image );
        this._image.setA(0);

        return this;
    };

    NetworkCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 412 ) + _x2.scaleValInt( 19 );
    };

    NetworkCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 309 ) * (_x2.scaleValInt( 412 ) + 2 * _x2.scaleValInt( 19 )) / _x2.scaleValInt( 412 );
    };

    NetworkCellWidget.prototype.imageError = function()
    {
        this._image.setA(0);
    };

    NetworkCellWidget.prototype.imageLoaded = function()
    {
        this._image.setW( undefined );
        this._image.setH( undefined );

        var maxW   = _x2.scaleValInt( 156 );
        var maxH   = _x2.scaleValInt( 117 );
        var aspect = maxW / maxH;

        if( aspect > this._image.getW() / this._image.getH() )
            this._image.setH( maxH );
        else
            this._image.setW( maxW );

        this._image.setX( (this._bgW - this._image.getW()) / 2 );
        this._image.setY( (this._bgH - this._image.getH()) / 2 );

        this._image.setA( 1 );
        this._defaultText.setA( 0 );
    };

    NetworkCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );
        this._bg.stopAnimation( Widget.X_SCALE );
        this._bg.stopAnimation( Widget.Y_SCALE );
        this._bg.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        this._title.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );

    };

    NetworkCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;

            this._image.setA( 0 );
            this._defaultText.setA( 1 );

            this._image.setUrl( data.getNetworkImageLink( 206, 92 ) );  //??? where did these numbers come from
            this._defaultText.setText( data.getTitle() );
            this._title.setText( data.getTitle() );

            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

   return NetworkCellWidget;

})();


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.NetworkRowWidget = ( function()
{
    "use strict";

    NetworkRowWidget.prototype = new CollectionRowWidget();

    function NetworkRowWidget(){}

    NetworkRowWidget.prototype.init = function( params )
    {
        params.type = NetworkCellWidget;
        params.y    = _x2.scaleVal( 150 ) - _x2.scaleVal( 14 );
        params.h    = _x2.scaleValInt( 389 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "NetworkRowWidget";

        return this;
    };

    NetworkRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 539 );
    };

    return NetworkRowWidget;

})();


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PinPadWidget = ( function()
{
    "use strict";

    PinPadWidget.prototype = new Widget();

    function PinPadWidget(){}

    PinPadWidget.prototype.clear = function()
    {
        this._index = 0;

        for( var i = 0; i < this._pinChars.length; i++ )
            this._pinChars[i].setA( 0 );
    };

    PinPadWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var index = this._yIndex * 3 + this._xIndex;

        _x2._hi.fadeOut();
        this._hi.animate( { a:1, duration:250 } );
        this._chars[index].gotFocus();
        this._chars[index].setSpeechParams( "Press arrow keys to review characters. Press OK to select. Press back to exit. ", undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof PinPadWidget
     * @param   {Object}   params
     * @param   {Function} params.onCapture - Called when the pin has been captured
     * @returns {PinPadWidget}
     */
    PinPadWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className  = "PinPadWidget";
        this._selectable = true;

        var self      = this, i;
        var cellW     = _x2.scaleValInt( 183 );
        var cellH     = _x2.scaleValInt(  84 );
        var spacing   = Style._pad / 3;
        var charStyle = new Style( { font:"light", color:"#e8e8e8", colorHi:"#000000", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );
        var pinStyle  = new Style( { font:"light", color:"#e8e8e8", colorHi:"#000000", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap", textAlign:"center" } );

        this._numReady  = 0;
        this._onCapture = params.onCapture;
        this._index     = 0;
        this._xIndex    = 0;
        this._yIndex    = 0;
        this._pinChars  = new Array(  4 );
        this._digits    = new Array(  4 );
        this._rects     = new Array( 12 );
        this._chars     = new Array( 12 );

        this._pin = new RectWidget().init( { w:3 * cellW + 2 * spacing, h:_x2.scaleValInt( 80 ), color:"#262626" } );
        this.addWidget( this._pin );

        for( i = 0; i < this._pinChars.length; i++ )
        {
            this._pinChars[i] = new StringWidget().init( { text:"*", style:pinStyle } );
            this._pinChars[i].setA( 0 );
            this.addWidget( this._pinChars[i] );
        }

        this._instStr = new StringWidget().init( { text:"Enter PIN", style:new Style( { font:"light", color:"#a3a3a3", fontSize:_x2.scaleValInt(32) } ) } );
        this.addWidget( this._instStr, _x2.scaleValInt(16) );

        for( i = 0; i < this._rects.length; i++ )
        {
            this._rects[i] = new RectWidget().init( { w:cellW, h:cellH, color:"#191919" } );
            this.addWidget( this._rects[i], (i % 3) * (cellW + spacing), Math.floor(i / 3) * (cellH + spacing) + this._pin.getH() + _x2.scaleValInt( 24 ) );
        }

        this._hi = new RectWidget().init( { w:cellW, h:cellH, color:"#e8e8e8" } );
        this._hi.setA( 0 );
        this.addWidget( this._hi, this._rects[0].getX(), this._rects[0].getY() );

        for( i = 0; i < this._chars.length; i++ )
        {
            if( i === 9 )
                this._chars[i] = new DualImageWidget().init( { url:_x2._config._imageRoot + "clearIcon.png" , urlHi:_x2._config._imageRoot + "clearIconHi.png"  } );
            else if( i === 11 )
                this._chars[i] = new DualImageWidget().init( { url:_x2._config._imageRoot + "deleteIcon.png", urlHi:_x2._config._imageRoot + "deleteIconHi.png" } );
            else
            {
                this._chars[i] = new StringWidget().init( { style:charStyle, focusTime:250 } );
                this._chars[i].setW( cellW );
            }

            this.addWidget( this._chars[i], this._rects[i].getX() );
        }

        this._chars[ 0].addReadyCallback( function() { self.layout() } );
        this._chars[ 9].addReadyCallback( function() { self.layout() } );
        this._chars[11].addReadyCallback( function() { self.layout() } );

        this._chars[ 0].setText( "1" );
        this._chars[ 1].setText( "2" );
        this._chars[ 2].setText( "3" );
        this._chars[ 3].setText( "4" );
        this._chars[ 4].setText( "5" );
        this._chars[ 5].setText( "6" );
        this._chars[ 6].setText( "7" );
        this._chars[ 7].setText( "8" );
        this._chars[ 8].setText( "9" );
        this._chars[10].setText( "0" );

        this.setW( 3 * cellW + 2 * spacing );
        this.setH( this._rects[11].getY() + this._rects[11].getH() );

        this._speechStr = [];
        this._speechStr[ 9] = "Clear. ";
        this._speechStr[11] = "Delete. ";

        return this;
    };

    PinPadWidget.prototype.layout = function()
    {
        if( ++this._numReady === 3 )
        {
            var i;
            var start = (this._pin.getW() - 4 * this._pinChars[0].getW() - 12 * Style._pad) / 2;
            var step  = this._pinChars[0].getW() + 4 * Style._pad;
            var self = this;

            for( i = 0; i < this._pinChars.length; i++ )
            {
                this._pinChars[i].setX( start + i * step );
                this._pinChars[i].setY( (this._pin.getH() - this._pinChars[i].getH()) / 1.1 );
            }

            this._instStr.setY( (this._pin.getH() - this._instStr.getH()) / 2 );

            for( i = 0; i < this._chars.length; i++ )
            {
                if( i === 9 || i === 11 )
                    this._chars[i].setX( this._rects[i].getX() + (this._rects[i].getW() - this._chars[i].getW()) / 2 );

                this._rects[i]._div.setAttribute("data-index", i );
                this._chars[i].setY( this._rects[i].getY() + (this._rects[i].getH() - this._chars[i].getH()) / 2 );
                this._rects[i].setMouseDownListener( function( event ) { 
                    event.stopPropagation(); 
                    var currentIndex = parseInt(event.target.getAttribute('data-index'));
                    self._yIndex = Math.floor( currentIndex / 3 );
                    self._xIndex = Math.floor( currentIndex % 3 );
                    self.processEvent( Host.KEY_ENTER, Host.KEY_PRESSED ); 
                } );
                this._rects[i].setMouseEnterListener( function( event, i) { 
                    for( var i = 0; i < self._chars.length; i++ )
                        self._chars[i].lostFocus();
                    
                    var pinPadIndex = parseInt(event.target.getAttribute('data-index'));
                    self._hi.animate( { x: self._rects[pinPadIndex].getX(), y: self._rects[pinPadIndex].getY(), duration:250 } );
                    self._chars[pinPadIndex].gotFocus();
                } );
            }

            this.callbackSignalReady();
        }
    };

    PinPadWidget.prototype.processEvent = function( val, type )
    {
        var retval = true, keyVal, startIndex;
        var index  = this._yIndex * 3 + this._xIndex;
        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    startIndex = this._index;

                    if( index === 9 )
                    {
                        this._chars[index].setSpeechParams( "Cleared. ", undefined, this, false );

                        this._index = 0;

                        for( var i = 0; i < this._pinChars.length; i++ )
                            this._pinChars[i].setA( 0 );
                    }
                    else if( index === 11 )
                    {
                        this._chars[index].setSpeechParams( "Deleted. ", undefined, this, false );

                        if( this._index > 0 )
                        {
                            this._index--;
                            this._pinChars[this._index].setA( 0 );
                        }
                    }
                    else
                    {
                        keyVal = (index < 9) ? index+1 : 0;
                        this._pinChars[this._index].setA( 1 );
                        this._pinChars[this._index].setSpeechParams( "Star", undefined, this, false );
                        this._digits[this._index++] = keyVal;

                        if( this._index >= 4 ) {
                            console.log( this._digits );
                            this._onCapture( this._digits.join( "" ) );
                        }
                    }

                    console.log( "this._index = " + this._index );

                    if( startIndex > 0 && this._index === 0 )
                        this._instStr.animate( { a:1, duration:500 } );
                    else if( startIndex === 0 && this._index > 0 )
                        this._instStr.animate( { a:0, duration:500 } );
                }
                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._yIndex < 3 )
                    {
                        this._chars[index].lostFocus();
                        this._yIndex++;
                        this._hi.animate( { y:this._rects[this._yIndex * 3].getY(), duration:250 } );
                        index  = this._yIndex * 3 + this._xIndex;
                        this._chars[index].gotFocus();
                        this._chars[index].setSpeechParams( this._speechStr[index], undefined, this, false );
                    }
                }
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._xIndex > 0 )
                    {
                        this._chars[index].lostFocus();
                        this._xIndex--;
                        this._hi.animate( { x:this._rects[this._xIndex].getX(), duration:250 } );
                        index  = this._yIndex * 3 + this._xIndex;
                        this._chars[index].gotFocus();
                        this._chars[index].setSpeechParams( this._speechStr[index], undefined, this, false );
                    }
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._xIndex < 2 )
                    {
                        this._chars[index].lostFocus();
                        this._xIndex++;
                        this._hi.animate( { x:this._rects[this._xIndex].getX(), duration:250 } );
                        index  = this._yIndex * 3 + this._xIndex;
                        this._chars[index].gotFocus();
                        this._chars[index].setSpeechParams( this._speechStr[index], undefined, this, false );
                    }
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._yIndex > 0 )
                    {
                        this._chars[index].lostFocus();
                        this._yIndex--;
                        this._hi.animate( { y:this._rects[this._yIndex * 3].getY(), duration:250 } );
                        index  = this._yIndex * 3 + this._xIndex;
                        this._chars[this._yIndex * 3 + this._xIndex].gotFocus();
                        this._chars[index].setSpeechParams( this._speechStr[index], undefined, this, false );
                    }
                }
                break;

            default:
                retval = Widget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval
    };

    return PinPadWidget;

})();


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ProgramPromoCellWidget = ( function()
{
    "use strict";

    ProgramPromoCellWidget.prototype = new CollectionCellWidget();

    function ProgramPromoCellWidget(){}

    ProgramPromoCellWidget.prototype.init = function( params )
    {
        var self = this;

        var titleStyle    = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var subTitleStyle = new Style( { color:"#a3a3a3", font:"regular", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );

        var posterTitleStyle    = new Style( { color:"#e8e8e8", font:"medium" , fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"center" } );
        var posterSubTitleStyle = new Style( { color:"#a3a3a3", font:"regular", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } );

        this._imageX = params.bgX     = _x2.scaleValInt( 19 );
        this._imageW = params.bgW     = _x2.scaleValInt( 480 );
        this._imageH = params.bgH     = _x2.scaleValInt( 270 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY     = (this._scale - 1) * this._imageH / 2;

        this._focusW = this._scale * this._imageW;
        this._focusH = this._scale * this._imageH;

        params.background = true;
        params.bgTextSize = _x2.scaleValInt(32);

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "ProgramPromoCellWidget";

        var imageError = function()
        {
            self._image.setA(0);
            self.showBackground();
        };

        var imageChanged = function()
        {
            self._image.setA(1);
            self.hideBackground();
        };

        this._image = new ImageWidget().init( { w:this._imageW, h:this._imageH, onError:imageError, onChange:imageChanged } );
        this.addWidget( this._image, this._imageX, this._imageY );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._title.setA( 0 );

        this._subTitle = new StringWidget().init( { style:subTitleStyle } );
        this._subTitle.setA( 0 );

        this._posterText = new StringWidget().init( { style:posterTitleStyle } );
        this._posterText.setW( this._image.getW() );

        this._posterSubText = new StringWidget().init( { style:posterSubTitleStyle } );
        this._posterSubText.setW( this._image.getW() );

        this.addWidget( this._title   , 0, this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 20 ) );
        this.addWidget( this._subTitle, 0, this._image.getH() + 2 * this._imageY + _x2.scaleValInt( 60 ) );
        this.addWidget( this._posterText   , this._imageX       , this._image.getH() * 2 / 3 );
        this.addWidget( this._posterSubText, this._imageX       , this._image.getH() * 2 / 3 + _x2.scaleValInt(38) );

        return this;
    };

    ProgramPromoCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 480 ) + _x2.scaleValInt( 19 );
    };

    ProgramPromoCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 270 ) * (_x2.scaleValInt( 480 ) + 2 * _x2.scaleValInt( 19 )) / _x2.scaleValInt( 480 );
    };

    ProgramPromoCellWidget.prototype.gotFocus = function()
    {
        CollectionCellWidget.prototype.gotFocus.call( this );

        if( this._image.getA() )
            this._image.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

        if( this._posterText.getText() )
        {
            this._posterText.stopAnimation( Widget.X_SCALE );
            this._posterText.stopAnimation( Widget.Y_SCALE );
            this._posterText.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

            this._posterSubText.stopAnimation( Widget.X_SCALE );
            this._posterSubText.stopAnimation( Widget.Y_SCALE );
            this._posterSubText.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        this._title.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        this._subTitle.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );

        return this;
    };

    ProgramPromoCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );

        if( this._image.getA() )
        {
            this._image.stopAnimation( Widget.X_SCALE );
            this._image.stopAnimation( Widget.Y_SCALE );
            this._image.animate( { xScale: 1, yScale: 1, duration: ListWidget.SCROLL_TIME_STEP } );
        }

        if( this._posterText.getText() )
        {
            this._posterText.stopAnimation( Widget.X_SCALE );
            this._posterText.stopAnimation( Widget.Y_SCALE );
            this._posterText.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );

            this._posterSubText.stopAnimation( Widget.X_SCALE );
            this._posterSubText.stopAnimation( Widget.Y_SCALE );
            this._posterSubText.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }

        this._title.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
        this._subTitle.animate( { alpha:0, duration:ListWidget.SCROLL_TIME_STEP } );
    };

    ProgramPromoCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;

            var link, url;

            if( this._data instanceof BrowseCollection )
            {
                this._image.setUrl( _x2._config._imageRoot + "view_all_wide.png" );

                this._title.setText("");
                this._subTitle.setText("");
                this._backgroundText.setText("");

                this._posterText.setText( "View All" );
                this._posterSubText.setText( data.getTotalEntityCount() + " available" );
            }
            else
            {
                link = this._data.getCollection().getProgramImageLink();

                if( link )
                    url  = XtvApi.replaceUrlParams( link, { entityId: data.getEntityId(), width: 320, height: 180 } );

                this._image.setUrl( url );
                this._title.setText( "" );
                this._subTitle.setText( "" );
                this._posterText.setText( "" );
                this._posterSubText.setText( "" );

                var title = this._data.getTitle();
                var subTitle = this._data.getSubtitle();

                if( title && subTitle )
                {
                    this._title.setText( title );
                    this._subTitle.setText( subTitle );
                }
                else if( title )
                    this._title.setText( title );
                else if( subTitle )
                    this._title.setText( subTitle );

                this.setBackgroundText( title );
            }

            this.setA( 1 );
        }
        else
            this.setA( 0.0 );
    };

    return ProgramPromoCellWidget;

})();


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ProgramPromoRowWidget = ( function()
{
    "use strict";

    ProgramPromoRowWidget.prototype = new CollectionRowWidget();

    function ProgramPromoRowWidget(){}

    ProgramPromoRowWidget.prototype.init = function( params )
    {
        params.type = ProgramPromoCellWidget;
        params.y    = _x2.scaleVal( 150 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 450 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "ProgramPromoRowWidget";

        return this;
    };

    ProgramPromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 560 );
    };

    return ProgramPromoRowWidget;

})();


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PromoCellWidget = ( function()
{
    "use strict";

    PromoCellWidget.prototype = new CollectionCellWidget();

    function PromoCellWidget(){}

    PromoCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 558 ) + _x2.scaleValInt( 19 );
    };

    PromoCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        this._image.setSpeechParams( this._data.getTitle(), undefined, this, newScreen );

        CollectionCellWidget.prototype.gotFocus.call( this );

        if( this._image.getA() )
            this._image.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

        return this;
    };

    /**
     * Initializer
     * @memberof PromoCellWidget
     * @param {Object} params - @see CollectionCellWidget
     * @returns {PromoCellWidget}
     */
    PromoCellWidget.prototype.init = function( params )
    {
        var self = this;

        this._imageX = params.bgX     = _x2.scaleValInt( 19 );
        this._imageW = params.bgW     = _x2.scaleValInt( 558 );
        this._imageH = params.bgH     = _x2.scaleValInt( 372 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY     = (this._scale - 1) * this._imageH / 2;

        this._focusW = this._scale * this._imageW;
        this._focusH = this._scale * this._imageH;

        params.background = true;
        params.bgTextSize = _x2.scaleValInt(36);

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "PromoCellWidget";

        var imageChanged = function()
        {
            self._image.setA(1);
            self.hideBackground();
        };

        var imageError = function()
        {
            self._image.setA(0);
            self.showBackground();
        };

        this._image = new ImageWidget().init( { w:this._imageW, h:this._imageH, onError:imageError, onChange:imageChanged } );
        this.addWidget( this._image, this._imageX, this._imageY );

        return this;
    };

    PromoCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );

        if( this._image.getA() )
        {
            this._image.stopAnimation( Widget.X_SCALE );
            this._image.stopAnimation( Widget.Y_SCALE );
            this._image.animate( { xScale:1, yScale:1, duration:ListWidget.SCROLL_TIME_STEP } );
        }
    };

    PromoCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;
            this._image.setUrl( data.getPromoImageLink( 600, 400 ) );
            this.setBackgroundText( data.getTitle() );
            this.setA( 1 );
        }
        else
            this.setA( 0.0 );
    };

    return PromoCellWidget;

})();


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2017 Comcast Corporation, All Rights Reserved



/**
 * @class
 */
window.ProgressBarWidget = ( function()
{
    ProgressBarWidget.prototype = new Widget();

    function ProgressBarWidget(){}

    /**
     * Initialize the widget
     * @memberOf ProgressBarWidget
     * @param {Object} params
     * @param {Number} params.w         - bar width
     * @param {Number} params.h         - bar height
     * @param {string} params.style     - ["recording", "watched", "full"]
     * @param {Number} [params.percent] - "full" integer percent (0-100 inclusive)
     * @return {ProgressBarWidget}
     */
    ProgressBarWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this );
        this._className = "ProgressBarWidget";
        this._style     = params.style;
        this._percent   = params.percent;

        var fgColor = this.getFgColor(), bgColor = "#303030";

        var w = params.w ? params.w : 150; // TODO: _x2.scaleValInt(150)
        var h = params.h ? params.h : 14;  // TODO: _x2.scaleValInt(12) // Saved-HTML-Specs.pdf

        this._background = new RectWidget().init( {w:w, h:h, color:bgColor} ); // TODO: This should be 9-slice image
        this._foreground = new RectWidget().init( {w:0, h:h, color:fgColor} ); // TODO: This should be 9-slice gradient

        this.addWidget(this._background);
        this.addWidget(this._foreground);

        this._baseW = w;
        this.setW( w );
        this.setH( h );

        return this;
    };

    /**
     * Set the position of the progress bar.
     * @memberOf ProgressBarWidget
     * @param {Number} percent - integer percent (0-100 inclusive)
     */
    ProgressBarWidget.prototype.setProgress = function( percent )
    {
        this._percent = percent;
        this._foreground.setW( percent / 100 * this._baseW );

        var fgColor = this.getFgColor();
        this._foreground.setColor( fgColor ); // may need to update rect color post init()
    };

    /**
     * @return {String} - 7 character HTML color string
     */
    ProgressBarWidget.prototype.getFgColor = function()
    {
        var fgColor;

        switch( this._style )
        {
            // https://etwiki.sys.comcast.net/pages/viewpage.action?spaceKey=XTV&title=Progress+bar
            case "full":
                if( this._percent < 80 )
                    fgColor ="#5BC942"; // Green  #19A926 #5BC942
                else if( this._percent < 90 )
                    fgColor ="#FECD00"; // Yellow #FFA700 #FECD00
                else
                    fgColor ="#FA523E"; // Red    #C90318 #FA523E
                break;
            case "watched":
                fgColor ="#2ea0dd";     // Blue   #1A6992 #2B9CD8
                break;
            case "recording":
                fgColor ="#dd1a1a";     // Red    #C90318 #FA523E
                break;
        }

        return fgColor;
    };

    return ProgressBarWidget;

})();


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PromoRowWidget = ( function()
{
    "use strict";

    PromoRowWidget.prototype = new CollectionRowWidget();

    function PromoRowWidget(){}

    PromoRowWidget.prototype.init = function( params )
    {
        params.type = PromoCellWidget;
        params.y    = _x2.scaleVal( 152 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 398 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "PromoRowWidget";

        return this;
    };

    PromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 600 );
    };

    return PromoRowWidget;

})();


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchaseOfferRowWidget = (function()
{
    "use strict";

    PurchaseOfferRowWidget.prototype = new ListRowWidget();

    function PurchaseOfferRowWidget(){}

    PurchaseOfferRowWidget.prototype.init = function( data )
    {
        ListRowWidget.prototype.init.call( this, data );
        this._className = "PurchaseOfferRowWidget";

        this._entity         = data.obj.entity;
        this._optionsOverlay = data.obj.overlay;
        this._onBuy          = data.obj.onBuy;
        this._metricsBuyOptionClicked =
        {
            "Program Type": "",
            "Option"      : "",
            "Modal Type"  : "Transactional",
            "Tab Clicked" : "No" // Web has tabbed UI for HD and SD; we have a unified single list
        };

        var titleStyle    = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#2b9cd8" } );
        var subTitleStyle = new Style( { color:"#bababa", font:"light", fontSize:_x2.scaleValInt(20), whiteSpace:"nowrap" } );

        this._vertOffsets = [_x2.scaleValInt(18), _x2.scaleValInt(35), _x2.scaleValInt(60)];

        this._title    = new StringWidget().init({ style:titleStyle, text:"" });
        this._subTitle = new StringWidget().init({ style:subTitleStyle, text:"" });

        this.addWidget( this._title   , 0, 0 );
        this.addWidget( this._subTitle, 0, 0 );

        return this;
    };

    PurchaseOfferRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 110 );
    };

    PurchaseOfferRowWidget.prototype.gotFocus = function( lostFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this, lostFocus );

        var entity    = this._entity,
            offer     = this._offer,
            infoStr   = "",
            speechStr = "",
            rating    = offer.getRating(),
            year      = entity.getYear(),
            isHd      = offer.isHD(),
            isSap     = offer.isSap(),
            isCc      = offer.isClosedCaptioned(),
            duration  = offer.getDuration(),
            subTitle  = this._subTitle.getText(),
            isSeason  = offer.isSeasonBundle(),
            type      = entity.getType(),
            metrics   = offer.getLocalyticsCommonTransactional( type );

        if( subTitle )
            speechStr += subTitle + ". ";

        this._metricsBuyOptionClicked["Program Type"] = metrics.programType;
        this._metricsBuyOptionClicked.Option          = metrics.option;

        if( type === XtvApi.EntityType.EPISODE )
        {
            var season  = entity.getSeasonNumber(),
                episode = entity.getEpisodeNumber(),
                title   = entity.getTitle();

            if( isSeason === true )
            {
                infoStr   += "Season " + entity.getSeasonNumber() + " (" + offer.getNumberOfFeatures() + " Episodes) ";
                speechStr += "Season " + entity.getSeasonNumber() + ". " + offer.getNumberOfFeatures() + " Episodes. ";
            }
            else
            {
                if( season !== undefined && episode !== undefined )
                {
                    infoStr   += "S" + season + " Ep" + episode;
                    speechStr += "season " + season + ". episode " + episode + ". ";
                }

                if( title )
                {
                    if( infoStr.length > 0 )
                        infoStr += " - ";

                    infoStr   += title + ", ";
                    speechStr += " " + title + ". ";
                }
            }
        }
        else
        {
            if( year !== undefined )
            {
                infoStr   += "(" + year + ") ";
                speechStr += year + ". ";
            }
        }

        if( duration > 0 )
        {
            infoStr   += duration + "min ";
            speechStr += duration + " minutes. ";
        }

        if( rating )
        {
            infoStr   += Strings.Glyphs[rating] + " ";
            speechStr += "Rating " + rating + ". ";
        }
        if( isHd )
        {
            infoStr   += Strings.Glyphs.HD + " ";
            speechStr += "HD available . ";
        }
        if( isSap )
        {
            infoStr   += Strings.Glyphs.SAP + " ";
            speechStr += "Secondary audio available. ";
        }
        if( isCc )
        {
            infoStr   += Strings.Glyphs.CC + " ";
            speechStr += "Closed captioning available. ";
        }

        this._optionsOverlay.setInfo( infoStr );

        this._title.gotFocus();
        this._title.setSpeechParams( speechStr, undefined, this, newScreen );
        return this;
    };

    PurchaseOfferRowWidget.prototype.localyticsSend = function()
    {
//console.log( "LOCALYTICS: Buy Option Clicked: %o", this._metricsBuyOptionClicked );
        window.ll( "tagEvent", "Buy Option Clicked", this._metricsBuyOptionClicked );
    };

    PurchaseOfferRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus()
    };

    PurchaseOfferRowWidget.prototype.processEvent = function(val, type)
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    var params = {
                        offer          : this._offer,
                        entity         : this._entity,
                        optionsOverlay : this._optionsOverlay,
                        onBuy          : this._onBuy
                    };

                    this.localyticsSend();

                    _x2.pushOverlay( new PurchaseOverlay().init( params ) );
                }
                break;

            case Host.KEY_LAST:
                if( type === Host.KEY_PRESSED )
                {
                    this._metricsBuyOptionClicked.Option = "[Unfinished]";
                    this.localyticsSend();
                    retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                }
                break;

            default:
                retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    PurchaseOfferRowWidget.prototype.setData = function( offer )
    {
        if( offer !== undefined )
        {
            this._offer = offer;

            var season   = offer.isSeasonBundle() ? " Season " : " ";
            var titleStr = offer.getPurchaseType() + season + "$" + offer.getPrice() + " " + offer.getVideoQuality();

            this._title.setText(titleStr);
            this._subTitle.setText();

            var window = offer.getRentalWindowInHours();
            if( window > 0 )
            {
                this._subTitle.setText( "<i>" + window + " Hour Rental</i>");

                this._title.setY( this._vertOffsets[0] );
                this._subTitle.setY( this._vertOffsets[2] )
            }
            else
                this._title.setY( this._vertOffsets[1] );

            this.setA(1);
        }
        else
            this.setA(0);

    };

    return PurchaseOfferRowWidget;

})();


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RadioButtonRowWidget = ( function()
{
    "use strict";

    RadioButtonRowWidget.prototype = new ListRowWidget();

    function RadioButtonRowWidget(){}

    /**
     * Initializer
     * @memberof RadioButtonRowWidget
     * @param   {Object}                params
     * @param   {RadioButtonController} params.obj   - Object that manages to the collection of rows
     * @param   {String}                params.title - String to be displayed in the entry
     * @param   {Number}                params.w     - Display width of the row
     * @returns {RadioButtonRowWidget}
     * @see ListRowWidget
     */
    RadioButtonRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "RadioButtonRowWidget";
        this._selectable = true;

        var self       = this;
        var titleStyle = new Style( { color:"#b8b8b8", colorHi:"#2ea0dd", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        this._numElements = 0;
        this._driver      = params.obj;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._title );

        this._check = new DualImageWidget().init( { url:_x2._config._imageRoot + "check_white.png", urlHi:_x2._config._imageRoot + "check.png" } );
        this._check.setA( 0 );
        this._check.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._check );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._driver.registerEntry( this );

        this._currentRowIndex = params.rowIndex;

        return this;
    };

    RadioButtonRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 * _x2._config._text );
    };

    RadioButtonRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this, losingFocus );
        this._title.gotFocus();
        this._check.gotFocus();
        this._title.setSpeechParams( undefined, "_radio", this, newScreen, this._selected );
        this._parent._parent._parent._currentFocusIndex = this._currentRowIndex;

        return this;
    };

    RadioButtonRowWidget.prototype.layout = function()
    {
        if( this._numElements === 2 )
        {
            this._title.setX( 2 * this._check.getW() );
            this._title.setY( (this.getHeightUnfocused() - this._title.getH()) / 2 );
            this._check.setY( (this.getHeightUnfocused() - this.getSepH() - this._check.getH()) / 2 );
        }
    };

    RadioButtonRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
        this._check.lostFocus();
        this._parent._parent._parent._lastFocusIndex = this._currentRowIndex;
    };

    RadioButtonRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    retval = true;
                    this._driver.entrySelected( this._key );

                    if( this._selected === false )
                        this.setSelected( true, true );

                    this._title.setSpeechParams( undefined, "_radio", this, false, this._selected );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    RadioButtonRowWidget.prototype.setData = function( data )
    {
        var self = this;

        if( data !== undefined )
        {
            this._title.setText( data.title );
            this._key = data.key;

            if( this._key === this._driver._key )
                this.setSelected( true );

            this.setA( 1 );
            this.setMouseDownListener( function() { self.processEvent( Host.KEY_ENTER, Host.KEY_PRESSED ); } );
            this.setMouseEnterListener( function() { 
                this._parent._parent._parent.moveCursorToRow( this._currentRowIndex );
             } );
        }
        else
        {
            this.setA( 0 );
            this.enableMouseDownListener( false );
        }
    };

    RadioButtonRowWidget.prototype.setSelected = function( val, animate )
    {
        this._selected = val;

        var alpha = val ? 1 : 0 ;

        if( animate )
            this._check.animate( { a:alpha, duration:300 } );
        else
            this._check.setA( alpha );

    };

    return RadioButtonRowWidget;

})();


/**
 * @class
 */
window.RadioButtonController = ( function()
{
    "use strict";

    /**
     * Constructor
     * @memberof RadioButtonController
     * @param   {String}   selectedKey     - Key of currently selected entry
     * @param   {Function} onEntrySelected - Called when an entry is selected
     * @returns {RadioButtonController}
     */

    function RadioButtonController( selectedKey, onEntrySelected )
    {
        this._key             = selectedKey;
        this._onEntrySelected = onEntrySelected;
        this._entries         = [];
    }

    RadioButtonController.prototype.entrySelected = function( key )
    {
        this._onEntrySelected( key );

        for( var i = 0; i < this._entries.length; i++ )
            this._entries[i].setSelected( false );
    };

    RadioButtonController.prototype.registerEntry = function( entry )
    {
        this._entries.push( entry );
    };

    return RadioButtonController;

})();


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RatingsRowWidget = ( function()
{
    "use strict";

    RatingsRowWidget.prototype = new ListRowWidget();

    /**
     * @namespace     RatingsRowWidget.Type
     * @enum {Number} Type
     * @type {Number}
     * @property {Number}   RatingsRowWidget.MOVIE -
     * @property {Number}   RatingsRowWidget.TV    -
     */
    RatingsRowWidget.Type = Object.freeze
    ({
        MOVIE : 0,
        TV    : 1
    });

    function RatingsRowWidget(){}

    RatingsRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 114 * _x2._config._text );
    };

    RatingsRowWidget.prototype.gotFocus = function( lostFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this, lostFocus );
        this._title.gotFocus();
        this._locked.gotFocus();
        this._unlocked.gotFocus();
        this._title.setSpeechParams( this._isLocked === true ? "Locked." : "Not Locked.", undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof RatingsRowWidget
     * @param   {Object}            params
     * @param   {RatingsController} params.obj   - Object that manages to the collection of rows
     * @param   {String}            params.title - String to be displayed in the entry
     * @param   {Number}            params.w     - Display width of the row
     * @returns {RatingsRowWidget}
     * @see ListRowWidget
     */
    RatingsRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className  = "RatingsRowWidget";
        this._selectable = true;

        var self       = this;
        var titleStyle = new Style( { color:"#b8b8b8", colorHi:"#2ea0dd", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        this._numElements = 0;
        this._driver      = params.obj;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._title );

        this._locked = new DualImageWidget().init( { url:_x2._config._imageRoot + "lockClosedGrey.png", urlHi:_x2._config._imageRoot + "lockClosedBlue.png" } );
        this._locked.setA( 0 );
        this._locked.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._locked );

        this._unlocked = new DualImageWidget().init( { url:_x2._config._imageRoot + "lockOpenGrey.png", urlHi:_x2._config._imageRoot + "lockOpenBlue.png" } );
        this._unlocked.addReadyCallback( function() { self._numElements++; self.layout(); } );
        this.addWidget( this._unlocked );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        this._driver.registerEntry( this );

        return this;
    };

    RatingsRowWidget.prototype.layout = function()
    {
        if( this._numElements === 3 )
        {
            this._title.setX( 2 * this._locked.getW() );
            this._title.setY( (this.getHeightUnfocused() - this._title.getH()) / 2 );
            this._locked.setY( (this.getHeightUnfocused() - this.getSepH() - this._locked.getH()) / 2 );
            this._unlocked.setY( (this.getHeightUnfocused() - this.getSepH() - this._unlocked.getH()) / 2 );
        }
    };

    RatingsRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
        this._locked.lostFocus();
        this._unlocked.lostFocus();
    };

    RatingsRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    retval = true;
                    this._driver.entrySelected( this._key );
                }
                break;
        }

        if( retval === undefined )
            retval = ListRowWidget.prototype.processEvent.call( this, val, type );

        return retval;
    };

    RatingsRowWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._title.setText( data.title );
            this._key = data.rating;
            this.setSelected();
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    RatingsRowWidget.prototype.setSelected = function()
    {
        if( this._key )
        {
            if( this._driver._val <= this._key.val )
            {
                this._isLocked = true;
                this._locked.animate( { a:1, duration:250 } );
                this._unlocked.animate( { a:0, duration:250 } );

                if( _x2._focus === this )
                    this._title.setSpeechParams( this._isLocked === true ? "Locked." : "Not Locked.", undefined, this, false );
            }
            else
            {
                this._isLocked = false;
                this._locked.animate( { a:0, duration:250 } );
                this._unlocked.animate( { a:1, duration:250 } );

                if( _x2._focus === this )
                    this._title.setSpeechParams( this._isLocked === true ? "Locked." : "Not Locked.", undefined, this, false );
            }
        }
    };

    return RatingsRowWidget;

})();


/**
 * @class
 */
window.RatingsController = ( function()
{
    "use strict";

    /**
     * Constructor
     * @memberof RatingsController
     * @param   {RatingsRowWidget.Type} type - MOVIE, TV
     * @returns {RatingsController}
     */

    function RatingsController( type )
    {
        var prop;

        this._type    = type;
        this._entries = [];

        // find which rating is locked

        if( type === RatingsRowWidget.Type.MOVIE )
        {
            for( prop in ParentalControls.MpaaRatings )
            {
                if( _x2._pc.isMovieRatingLocked( ParentalControls.MpaaRatings[prop] ) === true )
                {
                    this._val = ParentalControls.MpaaRatings[prop].val;
                    break;
                }
            }
        }
        else if( type === RatingsRowWidget.Type.TV )
        {
            for( prop in ParentalControls.TvRatings )
            {
                if( _x2._pc.isTvRatingLocked( ParentalControls.TvRatings[prop] ) === true )
                {
                    this._val = ParentalControls.TvRatings[prop].val;
                    break;
                }
            }
        }
        else
            console.error( "ERROR -> unknown rating type = " + type );
    }

    RatingsController.prototype.entrySelected = function( rating )
    {
        this._val = (this._val <= rating.val) ? rating.val + 1: rating.val;

        for( var i = 0; i < this._entries.length; i++ )
        {
            this._entries[i].setSelected( this._val );

            if( this._entries[i]._key )
            {
                if( this._type === RatingsRowWidget.Type.MOVIE )
                    _x2._pc.setMovieRatingLock( this._entries[i]._key, (this._entries[i]._key.val >= this._val) );
                else if( this._type === RatingsRowWidget.Type.TV )
                    _x2._pc.setTvRatingLocks( this._entries[i]._key, (this._entries[i]._key.val >= this._val) );
                else
                    console.error( "ERROR -> unknown rating type = " + this._type );
            }
        }

        _x2._data.setParentalControlsRatings( _x2._pc );
    };

    RatingsController.prototype.registerEntry = function( entry )
    {
        this._entries.push( entry );
    };

    return RatingsController;

})();


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RecordingRowWidget = ( function()
{
    "use strict";

    RecordingRowWidget.prototype = new ListRowWidget();

    var rawImW = 102;
    var rawImH = 136;
    var imGap  =  11;

    function RecordingRowWidget(){}

    /**
     * @memberof RecordingRowWidget
     * @returns {Number}
     */
    RecordingRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 2 * imGap + rawImH );
    };

    RecordingRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var str, count = this._data.getRecordingsCount ? this._data.getRecordingsCount() : 1;

        //reset data. (count) may have changed if episodes were deleted.
        if( this._data )
            this.setData(this._data);

        ListRowWidget.prototype.gotFocus.call(this);

        if( this._isDeletedRow )
        {
            this._deleted.gotFocus();
            this._deleted.setSpeechParams( newScreen !== true ? "Press OK for options. " : undefined, undefined, this, newScreen );
        }
        else
        {
            str  = ((count > 1 ) ? " recordings. " : "") + this._subSpeechStr + ". " + ((newScreen !== true) ? ". Press OK for options. " : "");
            this._title.gotFocus();
            this._title.setSpeechParams( str, undefined, this, newScreen );
        }

        return this;
    };

    /**
     * Initializer
     * @memberof RecordingRowWidget
     * @param   params
     * @param   {Number} params.w - Width in pixels of row
     * @returns {RecordingRowWidget}
     * @see ListRowWidget
     */
    RecordingRowWidget.prototype.init = function( params )
    {
        params.chevron = true;
        ListRowWidget.prototype.init.call( this, params );

        this._className = "RecordingRowWidget";

        var self = this;
        var titleStyle    = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var deletedStyle  = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(40), whiteSpace:"nowrap", colorHi:"#2ea0dd"  } );
        var subTitleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var imW           = _x2.scaleValInt( rawImW );
        var imH           = _x2.scaleValInt( rawImH );
        var inset         = imW + _x2.scaleValInt( 24 );

        this._progressW   = _x2.scaleValInt(300);
        this._progressH   = _x2.scaleValInt(14);
        this._selectable  = true;

        this._title = new StringWidget().init( { text:"?", style:titleStyle } );
        this._title.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._title, inset );

        this._subTitle = new StringWidget().init( { text:"?", style:subTitleStyle } );
        this.addWidget( this._subTitle, inset );

        this._deleted = new StringWidget().init( { text:"Deleted Recordings", style:deletedStyle } );
        this.addWidget( this._deleted, inset );

        this._image = new ImageWidget().init( { w:imW, h:imH, onChange:function(){ self._image.setA( 1 ) } } );
        this.addWidget( this._image, 0, _x2.scaleValInt(imGap) );

        this._progressWidget = new ProgressBarWidget().init( { w:this._progressW, h:this._progressH, style:"recording" } );
        this._progressWidget.setA( 0 );
        this.addWidget( this._progressWidget );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    RecordingRowWidget.prototype.layout = function()
    {
        var cellW  = this.getW();
        var cellH  = this.getHeightUnfocused();
        var titleH = this._title.getH();
        var deletedH = this._deleted.getH();

        this._title.setY   ( cellH/2 - titleH );
        this._subTitle.setY( cellH/2 + Style._pad/2 );
        this._deleted.setY ( cellH/2 - deletedH/2 );

        this._progressWidget.setX( cellW - this._progressW * 1.33);
        this._progressWidget.setY( cellH / 2 - this._progressH / 2 );
    };

    RecordingRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );

        if( this._isDeletedRow )
            this._deleted.lostFocus();
        else
            this._title.lostFocus();
    };

    RecordingRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            var group = this._data; //can be Recording or RecordingGroup

            if( group.getType && group.getType() === 'deleted' )
                _x2.pushScreen( new DeletedRecordingsScreen().init() );
            else if( group.getRecordingsCount && group.getRecordingsCount() === 1 )
                _x2.pushScreen( new EntityScreen().init( { entity:group.getRecordings()[0] } ) );
            else if( group instanceof Recording )
                _x2.pushScreen( new EntityScreen().init( { entity:group } ) );
            else
                _x2.pushScreen( new EpisodesScreen().init( { entity: group } ) );

            retval = true;
        }

        return retval;
    };

    /**
     * @memberof RecordingRowWidget
     * @param {Object} data - TODO: types?
     */
    RecordingRowWidget.prototype.setData = function( data )
    {
        var self = this, setPoster, recordings, count, title, date, progress;

        if( data !== undefined )
        {
            this._data             = data;
            this._isRecordingGroup = ( data instanceof RecordingGroup );
            this._isDeletedRow     = ( this._isRecordingGroup && data.getType() === 'deleted' );

            this._progressWidget.setA( 0 );
            this._image.setA( 0 );

            if( ! this._isDeletedRow )
            {
                recordings = data.getRecordings        ? data.getRecordings()        : undefined;
                count      = data.getRecordingsCount   ? data.getRecordingsCount()   : 1;
                title      = data.getName              ? data.getName()              : data.getTitle();
                date       = data.getLastRecordingDate ? data.getLastRecordingDate() : data.getRecordedOnDate();

                if( data instanceof RecordingGroup )
                {
                    setPoster = function( program )
                    {
                        if( self._data === data )
                        {
                            var onError = function()
                            {
                                self._image.setUrl( program.getFallbackImageLink( rawImW, rawImH ) );
                            };

                            self._image.setOnError( onError );
                            self._image.setUrl( program.getImageLink( rawImW, rawImH ) );
                        }
                    };
                    data.getProgram().then( setPoster );
                }
                else if( data instanceof Recording )
                {
                    var seriesTitle, season, episode, program, fullTitle = "";

                    seriesTitle = data.getSeriesTitle();
                    program = data.getProgram();

                    if( seriesTitle )
                        fullTitle = seriesTitle;

                    if( program )
                    {
                        season = program.getSeasonNumber();
                        episode = program.getEpisodeNumber();

                        if( season && episode )
                        {
                            if( fullTitle.length > 0 )
                                fullTitle += " - ";
                            fullTitle += "S" + season + " Ep" + episode;
                        }
                    }

                    if( seriesTitle !== title ) //NOTE: some entity types return the same string for series and episode.
                    {
                        if( fullTitle.length > 0 )
                            fullTitle += " - ";
                        fullTitle += title;
                    }

                    title = fullTitle;

                    this._image.setUrl( data.getImageLink( rawImW, rawImH ) );
                    this._image.setA(1);
                }

                if( count > 1 )
                    title += " (" + count + ")";

                this._title.setText( title );

                // var date = data.getLastRecordingDate();
                var dateString = "";

                if( date )
                {
                    dateString         = 'Recording added ' + _x2.createDateTimeStr( date );
                    this._subSpeechStr = "Recording added " + _x2.createDateStr( date ) + ", " + _x2.createTimeSpeechStr( _x2.createTimeStr( date ) );
                }

                this._subTitle.setText( dateString );

                //show recording progress if this is a group of 1 and recording is in progress.
                if( recordings && recordings.length === 1 )
                {
                    progress = recordings[0].getRecordingProgress();

                    if( progress && progress < 100 )
                    {
                        this._progressWidget.setProgress( progress );
                        this._progressWidget.setA( 1 )
                    }
                }
            }

            this._deleted.setA ( this._isDeletedRow ? 1 : 0 );
            this._title.setA   ( this._isDeletedRow ? 0 : 1 );
            this._subTitle.setA( this._isDeletedRow ? 0 : 1 );

            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return RecordingRowWidget;

})();


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Animated circular distractor
 * @class
 */
window.RingDistractorWidget = ( function()
{
    "use strict";

    RingDistractorWidget.prototype = new Widget();

    function RingDistractorWidget(){}

    /**
     * Stop the spinning animation
     */
    RingDistractorWidget.prototype.clear = function()
    {
        this._aniWidget.stopAnimation( Widget.ALPHA, false );
        this._aniWidget.setA( 0 );

        this._blScroll.setW( 0 );
        this._blScroll.setH( 0 );
        this._brScroll.setW( 0 );
        this._brScroll.setH( 0 );
        this._tlScroll.setW( 0 );
        this._tlScroll.setH( 0 );
        this._trScroll.setW( 0 );
        this._trScroll.setH( 0 );

        this._tlFinished = false;
        this._trFinished = false;
        this._brFinished = false;
        this._blFinished = false;
    };

    /**
     * Initializer
     * @memberof RingDistractorWidget
     * @param {Object} params
     * @param {Number} params.period - time in ms how long a spin cycle is
     * @see DistractorWidget
     */
    RingDistractorWidget.prototype.init = function( params )
    {
        var self = this, imageLoaded;

        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "RingDistractorWidget";

        Widget.prototype.init.call( this );

        this._numLoaded = 0;
        this._period    = params.period;

        imageLoaded = function()
        {
            self._numLoaded++;
            self.layout();
        };

        this._bg   = new ImageWidget().init( { url: _x2._config._imageRoot    + "ring1.png"   , onLoad:imageLoaded } );
        this._logo = new ImageWidget().init( { url: _x2._config._imageRootMso + "ringLogo.png", onLoad:imageLoaded } );
        this._bl   = new ImageWidget().init( { url: _x2._config._imageRoot    + "ring2_BL.png", onLoad:imageLoaded } );
        this._br   = new ImageWidget().init( { url: _x2._config._imageRoot    + "ring2_BR.png", onLoad:imageLoaded } );
        this._tl   = new ImageWidget().init( { url: _x2._config._imageRoot    + "ring2_TL.png", onLoad:imageLoaded } );
        this._tr   = new ImageWidget().init( { url: _x2._config._imageRoot    + "ring2_TR.png", onLoad:imageLoaded } );

        this._blScroll = new ScrollWidget().init( { widget:this._bl } );
        this._brScroll = new ScrollWidget().init( { widget:this._br } );
        this._tlScroll = new ScrollWidget().init( { widget:this._tl } );
        this._trScroll = new ScrollWidget().init( { widget:this._tr } );

        this.addWidget( this._bg       );
        this.addWidget( this._logo     );
        this.addWidget( this._blScroll );
        this.addWidget( this._brScroll );
        this.addWidget( this._tlScroll );
        this.addWidget( this._trScroll );

        this._aniWidget = new Widget().init(); // Animation Controller
        this.addWidget( this._aniWidget );

        return this;
    };

    RingDistractorWidget.prototype.isAnimating = function()
    {
        return (this._aniWidget.getA() > 0) && !this._tlFinished;
    };

    RingDistractorWidget.prototype.layout = function()
    {
        if( this._numLoaded === 6 )
        {
            this._radius = this._tr.getVal( Widget.W );

            this.setW( this._bg.getW() );
            this.setH( this._bg.getH() );

            this._logo.setX( (this._bg.getW() - this._logo.getW()) / 2 );
            this._logo.setY( (this._bg.getH() - this._logo.getH()) / 2 );

            this._blScroll.setY( this._radius );
            this._blScroll.setW( this._radius );
            this._blScroll.setH( this._radius );

            this._brScroll.setX( this._radius );
            this._brScroll.setY( this._radius );
            this._brScroll.setW( this._radius );
            this._brScroll.setH( this._radius );

            this._tlScroll.setW( this._radius );
            this._tlScroll.setH( this._radius );

            this._trScroll.setX( this._radius );
            this._trScroll.setW( this._radius );
            this._trScroll.setH( this._radius );

            this.clear();
            this.callbackSignalReady();
        }
    };

    RingDistractorWidget.prototype.spin = function()
    {
        var self = this, onEnd, onInc;

        onEnd = function()
        {
            // See nota bene when a ~== 0.99
            // If there was a delay between restarting then
            // the '++cos' offset can be removed and these should be enabled
            //self._tlScroll.setW( self._radius );
            //self._tlScroll.setH( self._radius );
            //self._tlScroll.setY( 0 );
            //self._tlScroll.setScroll( { y:0, duration:0 } );
            self._tlFinished = true;

            self.clear();
            self.spin();
        };

        onInc = function()
        {
            var a   = self._aniWidget.getA();
            var rad = a * 2 * Math.PI;
            var sin = (self._radius * Math.sin( rad )) | 0; // Bugfix: Weird DOM pixel gap in TR/BR and TL/TR
            var cos = (self._radius * Math.cos( rad )) | 0; // NOTE: Math.floor() also works but is slower

            if( a <= 0.25 )
            {
                self._trScroll.setW(                sin );
                self._trScroll.setH( self._radius - cos );
            }
            else if( a <= 0.5 )
            {
                if( self._trFinished === false )
                {
                    self._trScroll.setW( self._radius );
                    self._trScroll.setH( self._radius );
                    self._trFinished = true;
                }

                self._brScroll.setScroll( { x:-sin, duration:0 } );
                self._brScroll.setX( self._radius + sin );
                self._brScroll.setW( self._radius - sin );
                self._brScroll.setH(              - cos );
            }
            else if( a <= 0.75 )
            {
                if( self._brFinished === false )
                {
                    self._brScroll.setScroll( { x:0, duration:0 } );
                    self._brScroll.setX( self._radius );
                    self._brScroll.setW( self._radius );
                    self._brScroll.setH( self._radius );
                    self._brFinished = true;
                }

                self._blScroll.setScroll( { x:-self._radius - sin, duration:0 } );
                self._blScroll.setScroll( { y:cos                , duration:0 } );
                self._blScroll.setX( self._radius + sin );
                self._blScroll.setW(              - sin );
                self._blScroll.setY( self._radius - cos );
                self._blScroll.setH( self._radius + cos );
            }
            else // a > 0.75
            {
                if( self._blFinished === false )
                {
                    self._blScroll.setScroll( { x:0, duration:0 } );
                    self._blScroll.setScroll( { y:0, duration:0 } );
                    self._blScroll.setX( 0 );
                    self._blScroll.setW( self._radius );
                    self._blScroll.setY( self._radius );
                    self._blScroll.setH( self._radius );
                    self._blFinished = true;
                }
                // N.B. Technically these +/-1 offsets are incorrect when a ~== 0.99
                // But since the animation is instantly reapplied
                // it looks bad when the end isn't reached before restarting
                // ergo we fudge an effective a=1
                ++cos;

                self._tlScroll.setScroll( { y:-self._radius + cos, duration:0 } );
                self._tlScroll.setW( self._radius + sin );
                self._tlScroll.setY( self._radius - cos );
                self._tlScroll.setH(                cos );
            }
        };

        this._aniWidget.animate( { a:1, duration:this._period, easing:Widget.Easing.QUAD_IN_OUT, onEnd:onEnd, onInc:onInc } );
    };

    return RingDistractorWidget;

})();


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ExpandingListRowWidget = ( function()
{
    "use strict";

    ExpandingListRowWidget.prototype = new ListRowWidget();

    function ExpandingListRowWidget(){}

    ExpandingListRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._title.gotFocus();

        var count = ( this._data.entityCount !== undefined ? this._data.entityCount : this._data.entries.length );
        var title = this._title.getText().replace( /\(([\d]+)\)/, count === 1 ? ", $1 item. "  : ", $1 items. " );

        this._sep.setSpeechParams( title + (newScreen !== true ? "Press OK to select." : ""), undefined, this, newScreen );

        return this;
    };

    ExpandingListRowWidget.prototype.contract = function( hListener, aListener )
    {
        var onEnd, self = this;

        onEnd = function()
        {
            var onStep;

            onStep = function()
            {
                aListener( self._aniWidget.getA() );
            };

            if( aListener )
                self._aniWidget.animate( { a:1, duration:500, onInc:onStep, onEnd:onStep } );
        };

        this._listObj.list.animate( { a:0, duration:500, onEnd:onEnd } );
    };

    /**
     * @memberof ExpandingListRowWidget
     * @param hListener TODO:
     * @param aListener TODO:
     */
    ExpandingListRowWidget.prototype.expand = function( hListener, aListener )
    {
        var onInc, onEnd, self = this;

        onEnd = function()
        {
            self._listObj.list.setY( self.getH() );
            self._listObj.list.animate( { a:1, duration:500 } );

            if( self._data.entries )
                self._listObj.list.setData( self._data.entries );

            if( self._listObj.onExpand )
                self._listObj.onExpand( self._data );

            _x2.requestFocus( self._listObj.list );
        };

        onInc = function()
        {
            if( aListener )
                aListener( self._aniWidget.getA() );
        };

        this._aniWidget.setA(1); //alpha can be 0 here resulting in onInc/onEnd never called. Example: return after deleting episode from season list
        this._aniWidget.animate( { a:0, duration:500, onInc:onInc, onEnd:onEnd } );
    };

    ExpandingListRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 100 );
    };

    /**
     * Initializer
     * @memberof ExpandingListRowWidget
     * @param   {Object} params
     * @param   {Widget} [params.obj] - TODO
     * @param   {Number} [params.w]
     * @returns {ExpandingListRowWidget}
     */
    ExpandingListRowWidget.prototype.init = function( params )
    {
        params.chevron = true;
        ListRowWidget.prototype.init.call( this, params );

        this._className = "ExpandingListRowWidget";

        if( params.obj )
            this._listObj = params.obj;

        var self = this;
        var titleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );

        this._numElements = 0;
        this._selectable  = true;
        this._maxH        = parseInt( this.getHeightUnfocused() / 2 );
        this._maxW        = parseInt( this._maxH * 5 / 3 );

        this._focusTime = ( params.focusTime !== undefined ) ? params.focusTime : 0;

        this._title = new StringWidget().init( { text:"?", style:titleStyle } );
        this._title.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._title );

        this._aniWidget = new Widget().init();
        this.addWidget( this._aniWidget );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    ExpandingListRowWidget.prototype.layout = function()
    {
        this._title.setY( (this.getHeightUnfocused() - this._title.getH()) / 2 );
    };

    ExpandingListRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
    };

    ExpandingListRowWidget.prototype.refreshCell = function()
    {
        if( this._data )
            this._listObj.list.setData( this._data.entries );
    };

    ExpandingListRowWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;
            this._title.setText( data.title );
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return ExpandingListRowWidget;

})();


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ScheduledRowWidget = ( function()
{
    "use strict";

    ScheduledRowWidget.prototype = new ListRowWidget();
    ScheduledRowWidget.DAYS   = [ "Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat" ];

    var rawImW = 102;
    var rawImH = 136;
    var imGap  =  11;

    function ScheduledRowWidget(){}

    ScheduledRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._title.gotFocus();
        this._sep.setSpeechParams( this._title.getText().replace( /[\s]Ep([\d])/, "Episode $1" ) + ". " + this._subTitle.getText() + ". Press OK to select. ", undefined, this, newScreen );

        return this;
    };

    /**
     * Initializer
     * @memberof ScheduledRowWidget
     * @param   {Object}   params
     * @param   {Number}   params.w - Width
     * @returns {ScheduledRowWidget}
     * @see ListRowWidget
     */
    ScheduledRowWidget.prototype.init = function( params )
    {
        params.chevron = true;
        ListRowWidget.prototype.init.call( this, params );
        this._className = "ScheduledRowWidget";

        var self          = this;
        var titleStyle    = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd", overflow:"hidden", textOverflow:"ellipsis" } );
        var subTitleStyle = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var imW           = _x2.scaleValInt( rawImW );
        var imH           = _x2.scaleValInt( rawImH );

        this._progressW   = _x2.scaleValInt(300);
        this._progressH   = _x2.scaleValInt(14);
        this._numElements = 0;
        this._selectable  = true;
        this._maxH        = parseInt( this.getHeightUnfocused() / 2 );
        this._maxW        = parseInt( this._maxH * 5 / 3 );

        this._time  = new StringWidget().init( { text:"12:00pm", style:subTitleStyle } );
        this.addWidget( this._time );

        this._title = new StringWidget().init( { text:"?", style:titleStyle } );
        this.addWidget( this._title );

        this._subTitle = new StringWidget().init( { text:"?????????", style:subTitleStyle } );
        this._subTitle.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._subTitle );

        // AAECH-74
        var onLoad = function()
        {
            self._image.setA(1);
        };

        this._image = new ImageWidget().init( { w:imW, h:imH, onLoad:onLoad, onChange:onLoad } );
        this._image.setA(0);
        this.addWidget( this._image, 0, _x2.scaleValInt(imGap) );

        this._progressWidget = new ProgressBarWidget().init( { w:this._progressW, h:this._progressH, style:"recording" } );
        this._progressWidget.setA( 0 );
        this.addWidget( this._progressWidget );

        this.setW( params.w );
        this.setH( this.getHeightUnfocused() );

        return this;
    };

    ScheduledRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 2 * imGap + rawImH );
    };

    ScheduledRowWidget.prototype.layout = function()
    {
        var    h = this.getHeightUnfocused();
        var gapX = _x2.scaleValInt( 24 );
        var gapY = _x2.scaleValInt( 12 );

        this._time.setY( (h - this._time.getH()) / 2 );
        this._image.setX( this._time.getX() + this._time.getW() + gapX );
        this._title.setX( this._image.getX() + this._image.getW() + gapX );
        this._title.setY( (h - this._title.getH() - this._subTitle.getH() - gapY) / 2 );
        this._subTitle.setX( this._title.getX() );
        this._subTitle.setY( this._title.getY() + this._title.getH() + gapY );

        this._progressWidget.setX( this.getW() - this._progressW * 1.33 );
        this._progressWidget.setY( this.getHeightUnfocused() / 2 - this._progressH / 2 );
    };

    ScheduledRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._title.lostFocus();
    };

    ScheduledRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            _x2.pushScreen( new EpisodeScreen().init( { entity: this._entity, infoButton:true } ) );
            retval = true;
        }

        return retval;
    };

    /**
     * @memberof ScheduledRowWidget
     * @param {ProgramEntity | Recording} data
     */
    ScheduledRowWidget.prototype.setData = function( data )
    {
        var self = this, url, title, subTitle, timeStr, date, now, daysOffset, channel, onError, program, sNumber, epNumber, onErrorFallback, progress;

        if( data !== undefined )
        {
            this._entity = data;
            this._progressWidget.setA( 0 );

            title    = "";
            subTitle = "Recording ";

            if( data instanceof Recording ) //TODO: what else can this be in "ScheduledRowWidget" !?!?
            {
                timeStr = data.getRecordedOnDate();
                date    = new Date( timeStr );

                this._time.setText( _x2.createTimeStr( date ) );

                if( data.getSeriesTitle() )
                    title = data.getSeriesTitle(); // XC-13301: Example: "CBS4 This Morning - 530A"
                else
                    title = data.getTitle();

                now         = new Date();
                daysOffset  = date.getDate() - now.getDate();

                if( daysOffset < 0 )
                    daysOffset += new Date( now.getFullYear(), now.getMonth() + 1, 0).getDate();

                if( daysOffset === 0 )
                    subTitle += "today, ";
                else if( daysOffset === 1 )
                    subTitle += "tommorow, ";
                else if( daysOffset < 7 )
                    subTitle += ScheduledRowWidget.DAYS[date.getDay()] + ", ";
                else
                    subTitle += (date.getMonth()+1) + "/" + date.getDate() + ", ";

                subTitle += _x2.createTimeRange( date, new Date( date.getTime() + data.getDurationMs() ) );

                channel = data.getChannel();

                subTitle += " on " + channel.getNumber() + " " + channel.getCallSign();

                this._subTitle.setText( subTitle );

                // AAECH-74
                onErrorFallback = function()
                {
                    self._image.setA( 0 );
                };

                onError = function()
                {
                    self._image.setOnError( onErrorFallback );
                    self._image.setUrl( data.getFallbackImageLink( rawImW, rawImH ) );
                };

                this._image.setUrl();
                this._image.setOnError( onError );

                url = data.getImageLink( rawImW, rawImH );
                this._image.setUrl( url );

                progress = data.getRecordingProgress();
                if( progress > 0 && progress < 100 )
                {
                    this._progressWidget.setProgress( data.getRecordingProgress() );
                    this._progressWidget.setA( 1 );
                    this._title.setW( _x2.scaleValInt(1050) );
                }
                else
                    this._title.setW( _x2.scaleValInt(1345) );
            }

            program = data.getProgram();

            if( program )
            {
                sNumber  = program.getSeasonNumber();
                epNumber = program.getEpisodeNumber();

                if( sNumber !== undefined || epNumber !== undefined )
                    title += " -";

                if( sNumber !== undefined )
                    title += " S" + sNumber;

                if( epNumber !== undefined )
                    title += " Ep" + epNumber + " "; // XC-13301

                //don't duplicate if the series and episode titles are the same (common with news/talk shows)
                if( title.indexOf(program.getTitle()) === -1 )
                    title += program.getTitle();
            }

            this._title.setText(title);
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return ScheduledRowWidget;

})();


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Highlight over which widget currently has focus
 * @class
 */
window.SelectionWidget = ( function()
{
    "use strict";

    SelectionWidget.prototype = new NineSliceWidget();

    SelectionWidget.FADE_IN_TIME  = 400;
    SelectionWidget.FADE_OUT_TIME = 100;

    function SelectionWidget(){}

    /**
     * Initializer
     * @param   {Object} param
     * @returns {SelectionWidget}
     * @see NineSliceWidget.init()
     */
    SelectionWidget.prototype.init = function( params )
    {
        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "SelectionWidget";

        NineSliceWidget.prototype.init.call( this, params );

        this._fadingIn = false;

        return this;
    };

    /**
     * @memberof SelectionWidget
     */
    SelectionWidget.prototype.fadeIn = function()
    {
        this._fadingIn = true;
        this.animate( { alpha:1.0, duration:SelectionWidget.FADE_IN_TIME } );
    };

    /**
     * @memberof SelectionWidget
     */
    SelectionWidget.prototype.fadeOut = function( time )
    {
        this._fadingIn = false;

        if( this.getVal( Widget.ALPHA ) === 1.0 )
            this.setVal( Widget.ALPHA, 0.99 );

        this.animate( { alpha:0.0, duration:(time === undefined) ? SelectionWidget.FADE_OUT_TIME : time } );
    };

    /**
     * @memberof SelectionWidget
     * @param {Object} params
     * @see NineSliceWidget
     */
    SelectionWidget.prototype.setPosition = function( params )
    {
        var self = this;

        if( this.getA() < 1.0 )
        {
            if( this._fadingIn === false )
            {
                params.onEnd = function() { self.fadeIn(); };
                params.duration = 0;
            }
        }

        NineSliceWidget.prototype.setPosition.call( this, params );
        _x2._shadow.setPosition( { w:params.w, h:params.h } );
    };

    return SelectionWidget;

})();


/***/ }),
/* 139 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ShowingRowWidget = (function()
{
    "use strict";

    ShowingRowWidget.prototype = new ListRowWidget();

    function ShowingRowWidget(){}

    ShowingRowWidget.prototype.gotFocus = function( lostFocus, newScreen )
    {
        var str;

        ListRowWidget.prototype.gotFocus.call( this, lostFocus );
        this._playIcon.setA(0);
        this._playIconFocus.setA(1);
        this._hasFocus = true;

        str = this._subTitle.getText();
        str = str ? str + ". " : "";
        str = this._speakGlyphStr ? str + this._speakGlyphStr : str;

        if( newScreen !== true )
            str += "Press OK to play. ";

        this._title.setSpeechParams( str, undefined, this, newScreen );

        return this;
    };

    ShowingRowWidget.prototype.init = function(params)
    {
        ListRowWidget.prototype.init.call( this, params );

        this._className = "ShowingRowWidget";

        var self = this;
        var titleStyle    = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var subTitleStyle = new Style( { color:"#a3a3a3", font:"light", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var infoStyle     = new Style( { color:"#a3a3a3", font: "medium" ,  fontSize: _x2.scaleValInt( 24 ), whiteSpace: "nowrap" } );

        var xCords = [ _x2.scaleValInt(128) ];
        var yCords = [ _x2.scaleValInt(14), _x2.scaleValInt(30), _x2.scaleValInt(54), _x2.scaleValInt(90) ];

        this._networkIcon   = new ImageWidget().init({ onError:function(){ self.imageError()}, onChange:function(){ self.imageLoaded() }});
        this._playIcon      = new ImageWidget().init({ url:_x2._config._imageRoot + "Play-icon-min.png", onChange:function(){ self.playIconLoaded() }});
        this._playIconFocus = new ImageWidget().init({ url:_x2._config._imageRoot + "Play-focus-state-icon-min.png" });
        this._title         = new StringWidget().init({ style:titleStyle, text:"" });
        this._subTitle      = new StringWidget().init({ style:subTitleStyle, text:"" });
        this._infoGlyphs    = new StringWidget().init( { style: infoStyle } );

        this.addWidget( this._networkIcon, 0, yCords[1] );
        this.addWidget( this._playIcon );
        this.addWidget( this._playIconFocus );
        this.addWidget( this._title     , xCords[0], yCords[0] );
        this.addWidget( this._subTitle  , xCords[0], yCords[2] );
        this.addWidget( this._infoGlyphs, xCords[0], yCords[3] );

        this._playIcon.setA(0);
        this._playIconFocus.setA(0);
        this._hasFocus = false;

        return this;
    };

    ShowingRowWidget.prototype.imageLoaded = function()
    {
        this._networkIcon.setW( undefined );
        this._networkIcon.setH( undefined );

        var maxW   = _x2.scaleValInt( 96 );
        var maxH   = _x2.scaleValInt( 72 );
        var aspect = maxW / maxH;

        if( aspect > this._networkIcon.getW() / this._networkIcon.getH() )
            this._networkIcon.setH( maxH );
        else
            this._networkIcon.setW( maxW );

        //center the image in the cell
        this._networkIcon.setY( this.getHeightUnfocused()/ 2 - this._networkIcon.getH() / 2 );
        this._networkIcon.setA( 1 );
    };

    ShowingRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 140 );
    };

    ShowingRowWidget.prototype.imageError = function()
    {
        this._networkIcon.setA(0);
    };

    ShowingRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._playIcon.setA(1);
        this._playIconFocus.setA(0);
        this._hasFocus = false;
    };

    ShowingRowWidget.prototype.playIconLoaded = function()
    {
        var y = this.getHeightUnfocused() / 2 - this._playIcon.getH() / 2;
        var x = this.getW() - this._playIcon.getW();

        this._playIcon.setY(y);
        this._playIcon.setX(x);
        this._playIconFocus.setY(y);
        this._playIconFocus.setX(x);

        if( ! this._hasFocus ) //NOTE: alpha already manipulated in gotFocus
            this._playIcon.setA(1);
    };

    ShowingRowWidget.prototype.processEvent = function(val, type)
    {
        var retval, url, mediaId, paid, programId, hasSap, hasDvs, streamId, assetId, providerId, mediaGuid, playVideo, mode, self = this;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    var showing = this._data.showing;

                    if( showing instanceof Recording )
                    {
                        mode      = VideoScreen.Mode.DVR;
                        url       = this._data.showing.getStreamUrl();
                        mediaId   = this._data.showing.getMediaId();
                        programId = this._data.showing.getProgramId();
                        hasSap    = this._data.showing.isSap();
                        hasDvs    = this._data.showing.isDvs();
                    }
                    else if( showing instanceof LinearShowing )
                    {
                        mode     = VideoScreen.Mode.LIVE;
                        url      = this._data.showing.getChannel().getStreamUrl();
                        streamId = this._data.showing.getChannel().getStreamId();
                        hasSap   = this._data.showing.isSap();
                        hasDvs   = this._data.showing.isDvs();
                    }
                    else if( showing.getStreamUrl )
                    {
                        mode       = VideoScreen.Mode.VOD;
                        url        = this._data.showing.getStreamUrl();
                        assetId    = this._data.showing.getAssetId();
                        providerId = this._data.showing.getProviderId();
                        mediaGuid  = this._data.showing.getMediaGuid();
                        mediaId    = this._data.showing.getMediaId();
                        programId  = this._data.showing.getProgramId();
                        paid       = this._data.showing.getPaid();
                        hasSap     = this._data.showing.isSap();
                        hasDvs     = false;  // TODO: not supported, nedd API when it is
                    }

                    //add entity reference to showing if not already set so that VideoScreen will have access to Entity data.
                    if( showing.getEntity() === undefined )
                        showing.setEntity( this._data.entity );

                    if( url )
                    {
                        playVideo = function()
                        {
                            var obj =
                            {
                                url:url,
                                mediaId:mediaId,
                                programId:programId,
                                mode:mode,
                                entity:showing,
                                paid:paid,
                                hasSap:hasSap,
                                hasDvs:hasDvs,
                                streamId:streamId,
                                assetId:assetId,
                                providerId:providerId,
                                mediaGuid:mediaGuid
                            };

                            _x2.pushScreen( new VideoScreen().init( obj ) );
                        };

                        if( _x2._pc.isEnabled() === true )
                            _x2.checkParentalControls( this._data.showing, this._data.entity ).then( playVideo );
                        else
                            playVideo();
                    }
                    else
                    {
                        var error = new ApiError( { local:"No stream available" } );
                        _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.ENTITY } ) );
                        console.error( error.toString() );
                    }

                    retval = true;
                }
                break;

            default:
                retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    ShowingRowWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data          = data;
            this._speakGlyphStr = "";

            var rating, locked, info, glyphs = "";

            var showing  = data.showing;
            var len      = showing.getDuration();
            var ends     = showing.getVodWindowExpireTime ? showing.getVodWindowExpireTime() : 0;
            var provider = ( showing instanceof LinearShowing ) ? showing.getChannel() : showing.getContentProvider();

            if( showing instanceof Recording )
            {
                this._title.setText( "DVR" );

                info = "Recording added " + _x2.createDateTimeStr( showing.getRecordedOnDate() );
            }
            else if( showing instanceof LinearShowing )
            {
                this._title.setText( "On Now" );

                var channel = showing.getChannel();
                if( channel )
                    info = channel.getNumber() + " " + channel.getCallSign()
            }
            else if( showing instanceof Purchase )
            {
                var transaction = showing.getTransactionDetails();
                var purchasedOn = transaction.getPurchasedOnDate();

                this._title.setText( "Purchased" );

                if( len )
                    info = len + "min";

                if( purchasedOn )
                {
                    if( info.length )
                        info += ", ";
                    info += "Purchased " + _x2.createDateStr( purchasedOn );
                }
            }
            else if( showing instanceof Rental )
            {
                var expires = showing.getExpires();

                this._title.setText( "Rented" );

                if( len )
                    info = len + "min";

                if( expires )
                {
                    if( info.length )
                        info += ", ";
                    info += "Rental " + _x2.createExpiresString( expires );
                }
            }
            else
            {
                this._title.setText( "On Demand" );

                if( len )
                    info = len + "min";

                if( ends )
                {
                    if( info )
                        info += ", ";
                    info += "Ends " + ( ends.getMonth() + 1 ) + '/' + ends.getDate();
                }
            }

            if( info )
                this._subTitle.setText( info );

            if( provider )
                this._networkIcon.setUrl( provider.getLogoUrl() );

            if( showing.getRating() )
                rating = showing.getRating();

            locked = _x2._pc.isRatingLocked( rating );

            if( locked === false )
                locked = _x2._pc.isTitleLocked( showing.getEntityId() );

            if( locked )
            {
                glyphs += Strings.Glyphs.LOCKED + " ";
                this._speakGlyphStr += "Locked. ";
            }

            if( showing.isHD() )
            {
                glyphs += Strings.Glyphs.HD + " ";
                this._speakGlyphStr += "HD. ";
            }

            if( showing.isClosedCaptioned() )
            {
                glyphs += Strings.Glyphs.CC + " ";
                this._speakGlyphStr += "Closed captioning available. ";
            }

            if( showing.isSap() )
            {
                glyphs += Strings.Glyphs.SAP + " ";
                this._speakGlyphStr += "Secondary audio available. ";
            }

            if( rating )
            {
                glyphs += Strings.Glyphs[rating];
                this._speakGlyphStr += "Rating " + rating + ". ";
            }

            this._infoGlyphs.setText( glyphs );

            this.setA(1);
        }
        else
            this.setA(0);
    };

    return ShowingRowWidget;
})();


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SmallPromoCellWidget = ( function()
{
    "use strict";

    SmallPromoCellWidget.prototype = new CollectionCellWidget();

    function SmallPromoCellWidget(){}

    SmallPromoCellWidget.prototype.init = function( params )
    {
        var self = this;

        this._imageX = params.bgX     = _x2.scaleValInt( 19 );
        this._imageW = params.bgW     = _x2.scaleValInt( 414 );
        this._imageH = params.bgH     = _x2.scaleValInt( 276 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY     = (this._scale - 1) * this._imageH / 2;

        this._focusW = this._scale * this._imageW;
        this._focusH = this._scale * this._imageH;

        params.background = true;
        params.bgTextSize = _x2.scaleValInt(32);

        CollectionCellWidget.prototype.init.call( this, params );
        this._className  = "SmallPromoCellWidget";

        var imageError = function()
        {
            self._image.setA(0);
            self.showBackground();
        };

        var imageChanged = function()
        {
            self._image.setA(1);
            self.hideBackground();
        };

        this._image = new ImageWidget().init( { w:this._imageW, h:this._imageH, onError:imageError, onChange:imageChanged } );
        this.addWidget( this._image, this._imageX, this._imageY );

        return this;
    };

    SmallPromoCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 414 ) + _x2.scaleValInt( 19 );
    };

    SmallPromoCellWidget.prototype.getTouchDim = function()
    {
        return _x2.scaleValInt( 276 ) * (_x2.scaleValInt( 414 ) + 2 * _x2.scaleValInt( 19 )) / _x2.scaleValInt( 414 );
    };

    SmallPromoCellWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        this._image.setSpeechParams( this._data.getTitle().replace( /([\w])-([\w])/i, '$1 to $2' ), undefined, this, newScreen );

        CollectionCellWidget.prototype.gotFocus.call( this );

        if( this._image.getA() )
            this._image.animate( { xScale:this._scale, yScale:this._scale, duration:ListWidget.SCROLL_TIME_STEP } );

        return this;
    };

    SmallPromoCellWidget.prototype.lostFocus = function()
    {
        CollectionCellWidget.prototype.lostFocus.call( this );

        if( this._image.getA() )
        {
            this._image.stopAnimation( Widget.X_SCALE );
            this._image.stopAnimation( Widget.Y_SCALE );
            this._image.animate( { xScale: 1, yScale: 1, duration: ListWidget.SCROLL_TIME_STEP } );
        }
    };

    SmallPromoCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;
            this._image.setUrl( data.getPromoImageLink( 270, 180 ) );
            this.setBackgroundText( data.getTitle() );
            this.setA( 1 );
        }
        else
            this.setA( 0.0 );
    };

    return SmallPromoCellWidget;

})();


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SmallPromoRowWidget = ( function()
{
    "use strict";

    SmallPromoRowWidget.prototype = new CollectionRowWidget();

    function SmallPromoRowWidget(){}

    SmallPromoRowWidget.prototype.init = function( params )
    {
        params.type = SmallPromoCellWidget;
        params.y    = _x2.scaleVal( 150 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 376 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "SmallPromoRowWidget";

        return this;
    };

    SmallPromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 506 );
    };

    return SmallPromoRowWidget;

})();


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.StaticListWidget = ( function()
{
    "use strict";

    StaticListWidget.prototype = new Widget();

    StaticListWidget.SCROLL_RATE = 1500 / 1000;

    function StaticListWidget(){}

    StaticListWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        return _x2.requestFocus( this._widgets[this._index], newScreen );
    };

    /**
     * Initializer
     * @memberof StaticListWidget
     * @param   {Object}        params
     * @param   {Number}        params.h              - Height of the list
     * @param   {Array}         params.rows           - Array of data objects to display
     * @param   {ListRowWidget} params.types          - The specific type of ListRowWidget for each row
     * @param   {Number}        params.w              - Width of the list
     * @param   {Number}       [params.max]           - Max number of items to display in each row
     * @param   {function}     [params.indexListener] - callback function for selected index change
     * @returns {StaticListWidget}
     */
    StaticListWidget.prototype.init = function( params )
    {
        var i, widget, y = 0, self = this;

        Widget.prototype.init.call( this );
        this._className      = "StaticListWidget";
        this._selectable     = true;
        this._types          = params.types;
        this._indexListener  = params.indexListener;
        this._max            = params.max;
        this._widgets        = [];
        this._rows           = [];
        this._index          = 0;
        this._blocked        = false;
        this._queue          = [];
        this._container      = new Widget().init();
        this._lastIndexAdded = 0;
        this.setW( params.w );
        this.setH( params.h );

        for( i = 0; i < params.rows.length; i++ )
            if( params.rows[i].getEntities().length > 0 )
                this._rows.push( params.rows[i] );
            else
                console.warn( "EMPTY ROW" );

        for( i = 0; i < this._rows.length; i++ )
            if( this._rows[i].getEntities().length > 0 )
            {
                widget = new params.types[i]().init( { w:params.w - Style._safeLeft - Style._safeRight, data:this._rows[i], max:this._max } );
                this._widgets.push( widget );
                this._container.addWidget( widget, Style._safeLeft, y );
                y += widget.getHeightUnfocused();

                if( y > params.h )
                    break;

                this._lastIndexAdded++;
            }

        this._container.setH( y );

        this._scroll = new ScrollWidget().init( { w:params.w, h:params.h, widget:this._container } );
        this.addWidget( this._scroll );

        this.setMouseWheelListener( function( event ) { if( self._blocked === false ) self.processEvent( ( event.deltaY > 0 ) ? Host.KEY_DOWN : Host.KEY_UP, Host.KEY_PRESSED ); } );

        return this;
    };

    StaticListWidget.prototype.getMaxIndex = function()
    {
        return this._rows !== undefined ? this._rows.length : 0;
    };

    StaticListWidget.prototype.getSelectedIndex = function()
    {
        return this._index;
    };

    StaticListWidget.prototype.getSelectedWidget = function()
    {
        return this._widgets[this._index];
    };

    StaticListWidget.prototype.processEvent = function( val, type )
    {
        var retval = true, self = this, onEnd, currY, nextY, duration;

        onEnd = function()
        {
            _x2.requestFocus( self._widgets[self._index] );
            self.processQueue();
        };

        switch( val )
        {
            case Host.KEY_DOWN:
                if( this._blocked === false )
                {
                    if( this._index < this._rows.length - 1 )
                    {
                        if( type === Host.KEY_PRESSED )
                        {
                            if( this._lastIndexAdded < this._rows.length - 1 )
                            {
                                console.log( "Add a new row, last added = " + this._lastIndexAdded );

                                var widget = this._widgets[this._lastIndexAdded++];
                                var w      = this._scroll.getW() - Style._safeLeft - Style._safeRight;
                                var y      = widget.getY() + widget.getH();

                                widget = new this._types[this._lastIndexAdded]().init( { w:w, data:this._rows[this._lastIndexAdded], max:this._max } );
                                this._widgets.push( widget );
                                this._container.addWidget( widget, Style._safeLeft, y );
                                y += widget.getHeightUnfocused();

                                widget.patchWidget();

                                this._scroll.setH( y );
                            }

                            this._index++;
                            this._blocked = true;

                            if( this._indexListener )
                                this._indexListener( this._index );

                            currY    = this._container.getY();
                            nextY    = this._widgets[this._index].getY();
                            duration = (nextY + currY) / StaticListWidget.SCROLL_RATE;

                            this._scroll.setScroll( { y:-nextY, duration:duration, onEnd:onEnd } );
                            _x2._hi.fadeOut( 0 );
                        }
                        else
                            this.processQueue();
                    }
                    else if( this._queue.length > 0 )
                        this.processQueue();
                    else
                        retval = Screen.prototype.processEvent.call( this, val, type );
                }
                else
                    this._queue.push( [ val, type ] );
                break;

            case Host.KEY_UP:
                if( this._blocked === false )
                {
                    if( this._index > 0 )
                    {
                        if( type === Host.KEY_PRESSED )
                        {
                            this._index--;
                            this._blocked = true;

                            if( this._indexListener )
                                this._indexListener( this._index );

                            currY    = this._container.getY();
                            nextY    = this._widgets[this._index].getY();
                            duration = -(nextY + currY) / StaticListWidget.SCROLL_RATE;

                            this._scroll.setScroll( { y:-nextY, duration:duration, onEnd:onEnd } );
                            _x2._hi.fadeOut( 0 );
                        }
                        else
                            this.processQueue();
                    }
                    else if( this._queue.length > 0 )
                        this.processQueue();
                    else
                        retval = Screen.prototype.processEvent.call( this, val, type );
                }
                else
                    this._queue.push( [ val, type ] );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    StaticListWidget.prototype.processQueue = function()
    {
        var key = this._queue.shift(), self = this;

        this._blocked = false;

        if( key !== undefined )
            setTimeout( function() { self.processEvent( key[0], key[1] ); }, 1 );
    };

    StaticListWidget.prototype.setJumpToIndex = function( jumpIdx )
    {
        var i, baseY, maxY, self = this;
        var width  = this.getW() - Style._safeLeft - Style._safeRight;
        var height = this.getH();

        var addWidget = function( idx )
        {
            var y = idx > 0 ? self._widgets[idx-1].getY() + self._widgets[idx-1].getHeightUnfocused() : 0;
            var widget = new self._types[idx]().init( { w: width, data: self._rows[idx] } );
            self._widgets.push( widget );
            self._container.addWidget( widget, Style._safeLeft, y );
            self._lastIndexAdded++;
            widget.patchWidget();

            return widget;
        };

        //add widgets from lastIndexAdded up to and including jumpIdx
        for( i = this._lastIndexAdded + 1; i < jumpIdx+1; i++ )
            addWidget(i);

        //get the Y position of the widget at jumpIdx and set the max Y of the frame
        baseY = this._widgets[jumpIdx].getY();
        maxY  = baseY + height;

        //add widgets starting from jumpIdx+1 as necessary until we fill the frame
        for( i = jumpIdx+1; i < this._rows.length; i++ )
        {
            baseY += ( this._widgets[i] ? this._widgets[i] : addWidget( i ) ).getHeightUnfocused();
            if( baseY >= maxY )
                break;
        }

        this._index = jumpIdx;
        this._container.setH( baseY );
        this._scroll.setScroll( { y:-this._widgets[this._index].getY(), duration:0 } );
    };

    return StaticListWidget;

})();


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TextEntryWidget = ( function()
{
    "use strict";

    TextEntryWidget.prototype = new Widget();

    function TextEntryWidget(){}

    TextEntryWidget.prototype.getInstText = function()
    {
        var retval = "";

        if( this._instStr )
            retval = this._instStr.getText();

        return retval;
    };

    TextEntryWidget.prototype.getText = function()
    {
        return this._str.getText();
    };

    /**
     * Initializer
     * @memberof TextEntryWidget
     * @param   {Object}    params
     * @param   {String}   [params.instStr]  - Instructional text to display when no text has been entered
     * @param   {Number}    params.w         - Width
     * @param   {Function} [params.onChange] - Called on every change caused by onChar
     * @returns {TextEntryWidget}
     */
    TextEntryWidget.prototype.init = function( params )
    {
        var self = this;
        var charsStyle = new Style( { font:"light", color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"pre" } );

        Widget.prototype.init.call( this );
        this._className = "TextEntryWidget";

        if( params.onChange )
            this._onChange = params.onChange;

        this._rect = new RectWidget().init( { w:params.w, h:50, color:"#262626" } );
        this.addWidget( this._rect );

        this._str = new StringWidget().init( { text:"???????????", style:charsStyle } );
        this._str.addReadyCallback( function() { self.layoutTextEntryWidget(); } );
        this._str.setW( params.w - _x2.scaleValInt(16) );
        this._str.setA( 0 );
        this.addWidget( this._str, _x2.scaleValInt(16), _x2.scaleValInt(18) );

        if( params.instStr )
        {
            this._instStr = new StringWidget().init( { text:params.instStr, style:new Style( { font:"light", color:"#a3a3a3", fontSize:_x2.scaleValInt(32) } ) } );
            this.addWidget( this._instStr, this._str.getX(), this._str.getY() );
        }

        this.setW( params.w );

        return this;
    };

    TextEntryWidget.prototype.layoutTextEntryWidget = function()
    {
        this._rect.setH( 2 * _x2.scaleValInt(18) + this._str.getH() );
        this.setH( this._rect.getH() );
        this._str.setText();
        this._str.setA( 1 );

        this.callbackSignalReady();
    };

    TextEntryWidget.prototype.onChar = function( char )
    {
        var str    = this._str.getText();
        var strLen = str.length;

        switch( char )
        {
            case "del":
                this._str.setText( str.substr( 0, str.length - 1 ) );
                break;

            case "sp":
                this._str.setText( this._str.getText() + " " );
                break;

            case "tr":
                this._str.setText();
                break;

            default:
                this._str.setText( this._str.getText() + char );
                break;
        }

        str = this._str.getText();

        if( this._instStr )
        {
            if( strLen > 0 && str.length === 0 )
                this._instStr.animate( { a:1, duration:500 } );
            else if( strLen === 0 && str.length > 0 )
                this._instStr.animate( { a:0, duration:500 } );
        }

        if( this._onChange )
            this._onChange( this._str.getText() );
    };

    TextEntryWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );
        this._rect.setW( val );
        this._str.setW( val - 2 * _x2.scaleValInt(16) );
    };

    return TextEntryWidget;

})();


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Menu with round buttons that auto-hides when not focused
 * @class
 * @see HorizMenuWidget
 * @see HorizPillButtonsWidget
 */
window.TabbedPillButtonsWidget = ( function()
{
    "use strict";

    TabbedPillButtonsWidget.prototype = new Widget();

    function TabbedPillButtonsWidget(){}

    TabbedPillButtonsWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        var focus = this;

        Widget.prototype.gotFocus.call( this, losingFocus );

        if( this._lastFocus === undefined || this._lastFocus === this._buttons )
            focus = _x2.requestFocus( this._buttons, newScreen );
        else if( this._lastFocus === this._options )
            focus = _x2.requestFocus( this._options, newScreen );

        return focus;
    };

    /**
     * Initializer
     * @memberof TabbedPillButtonsWidget
     * @param   {Object}    params
     * @param   {Array}     params.entries  - entries in the menu
     * @param   {Number}   [params.index]   - initial index to receive focus
     * @param   {Widget}   [params.options] - add ability to have an option button in the menu
     * @returns {TabbedPillButtonsWidget}
     */
    TabbedPillButtonsWidget.prototype.init = function( params )
    {
        var self    = this;
        var onReady = function() { self._numReady++; self.layout(); };

        Widget.prototype.init.call( this, params );
        this._className = "TabbedPillButtonsWidget";

        this._numReady   = 0;
        this._bg         = new RectWidget().init( { w:_x2._config._screenW, h:0, color:"#000000" } );
        this._buttons    = new HorizPillButtonsWidget().init( { entries:params.entries, spacing:_x2.scaleValInt(41), index:params.index } );
        this._scrollPane = new ScrollWidget().init( { widget: this._buttons, w: _x2._config._screenW } );


        this._buttons.setSpeechCustomRole( "_filter" );
        this._buttons.addReadyCallback( onReady );

        this.addWidget( this._bg         );
        this.addWidget( this._scrollPane );

        if( _x2._config._cursorEnabled === true )
        {
            var onClick = function()
            {
                if( _x2._focus === self._buttons )
                    self.processEvent( Host.KEY_DOWN, Host.KEY_PRESSED );
                else
                    _x2.requestFocus( self );
            };

            this._tab = new RectWidget().init( { w:200, h:15, color:"#333333" } );
            this._tab.setMouseDownListener( onClick );
            this.addWidget( this._tab, (_x2._config._screenW - this._tab.getW()) / 2 );
        }

        var positionTab = function()
        {
            if( self._tab )
                self._tab.setY( -self.getY() );
        };

        var onGotFocus = function( losingFocus )
        {
            if( losingFocus !== self._buttons && losingFocus !== self._options )
                self.animate( { y:0, duration:500, onInc:positionTab } );
        };

        var onLostFocus = function( gettingFocus )
        {
            self._lastFocus = _x2._focus;

            if( gettingFocus !== self._options && gettingFocus !== self._buttons )
                self.animate( { y:-self.getH(), duration:500, onInc:positionTab } );
        };

        this._buttons.setFocusListeners( onGotFocus, onLostFocus );

        if( params.options )
        {
            this._options = new HorizPillButtonsWidget().init( { entries:[params.options] } );
            this._options.setFocusListeners( onGotFocus, onLostFocus );
            this._options.addReadyCallback( onReady );
            this.addWidget( this._options, Style._safeLeft );
        }

        this.setW( _x2._config._screenW );
        this._selectable = true;

        return this;
    };

    TabbedPillButtonsWidget.prototype.layout = function()
    {
        if( this._numReady === (this._options ? 2 : 1) )
        {
            var x, w;

            if( this._options )
            {
                x = this._options.getW() + 5 * Style._pad;
                w = this._bg.getW() - Style._safeLeft - Style._safeRight - x;

                if( this._buttons.getW() < w )
                {
                    this._scrollPane.setX( Style._safeLeft );
                    this._scrollPane.setW( w + x );
                    this._buttons.setX( (w + x - this._buttons.getW()) / 2 );
                }
                else
                {
                    this._scrollPane.setX( Style._safeLeft + x );
                    this._scrollPane.setW( w );
                    this._buttons._scrollW = w;
                    this._buttons.setX( 0 );
                }
            }
            else
            {
                w = this._bg.getW() - Style._safeLeft - Style._safeRight;

                this._scrollPane.setX( Style._safeLeft );
                this._scrollPane.setW( w );

                if( this._buttons.getW() < w )
                {
                    this._buttons.setX( (w - this._buttons.getW()) / 2 );
                }
                else
                {
                    this._buttons._scrollW = w;
                    this._buttons.setX( 0 );
                }
            }

            this._buttons.setY( (this._bg.getH() - this._buttons.getH()) / 2 );

            if( this._options )
                this._options.setY( this._buttons.getY() );

            this.callbackSignalReady();

            if( _x2._focus !== this._buttons )
                this.setY( -this.getH() );
        }
    };

    TabbedPillButtonsWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_DOWN:
                retval = this._buttons.processEvent( Host.KEY_ENTER, type );
                break;

            case Host.KEY_LEFT:
                if( this._options && _x2._focus === this._buttons && type === Host.KEY_PRESSED )
                {
                    _x2.requestFocus( this._options );
                    retval = true;
                }
                break;

            case Host.KEY_RIGHT:
                if( this._options && _x2._focus === this._options && type === Host.KEY_PRESSED )
                {
                    _x2.requestFocus( this._buttons );
                    retval = true;
                }
                break;
        }

        if( retval === undefined )
            retval = Screen.prototype.processEvent.call( this, val, type );

        return retval;
    };

    TabbedPillButtonsWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        this._bg.setH( val );
        this._scrollPane.setH( val );
//this._tab.setY( val );
        this.layout();
    };

    return TabbedPillButtonsWidget;

})();


/***/ }),
/* 145 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 * @see StringWidget
 */
window.TextBlockWidget = ( function()
{
    "use strict";

    TextBlockWidget.prototype = new Widget();

    function TextBlockWidget(){}

    /**
     * Initializer
     * @memberof TextBlockWidget
     * @param {Object}   params           - Paramaters to define how the string should be displayed
     * @param {String}  [params.name]     - Class name
     * @param {Boolean} [params.ellipsis] - If last line should have ellipsis ("...") displayed if text overflows.
     * @param {String}  [params.text]     - Text to display
     * @param {Style}    params.style     - Alignment, Color, Font Type, Font Size, Whitespace
     * @param {Number}  [params.w]        - Width in pixels
     * @param {Number}  [params.h]        - Height in pixels
     * @returns {TextBlockWidget}
     */
    TextBlockWidget.prototype.init = function( params )
    {
        var file = [ "", "", "thumb_6_6_7_7.png", "thumb_13_13_14_14.png" ][_x2._config._layout]; // TODO: This should be in Style.ThumbFileName
        var w    = params.w;
        var h    = params.h;

        if( this._className === undefined )
            this._className = (params && params.name) ? params.name : "TextBlockWidget";

        Widget.prototype.init.call( this );
        Widget.prototype.setW.call( this, w );
        Widget.prototype.setH.call( this, h );

        this._text          = params.text;
        this._offsetY       = 0; // default to top
        this._style         = params.style; // WebGL needs style for line breaks
        this._hasEllipsis   = params.ellipsis;
        this._ellipsisLines = undefined;

        this._container = new Widget         ().init();
        this._scroll    = new ScrollWidget   ().init( { widget:this._container, w:w, h:h     } );
        this._string    = new StringWidget   ().init( { text:params.text, style:params.style } ); // Note: Sets mandatory overflow:"hidden"
        this._thumb     = new NineSliceWidget().init( { url:_x2._config._imageRoot + file    } );
        this._thumb.setA( 0 );

        this._container.setW( w );
        this._container.setH( h );
        this._container.addWidget( this._string );

        // Disable wrapping so we can query a single line for leading metric
        this._string.setWhiteSpace( "nowrap" );
        this.addWidget( this._scroll );
        this.addWidget( this._thumb, w, 0 );

        return this;
    };

    TextBlockWidget.prototype.getLeadingGL = function()
    {
        var font      = Widget.glFonts[ this._string.getVal( Widget.FONT ) ];
        var size      = this._string._curVal[ Widget.FONT_SIZE ];
        this._leading = font.getLineHeight( size );
    };

    TextBlockWidget.prototype.getText = function()
    {
        return this._text;
    };

    /** Called when text, width, or height has changed */
    TextBlockWidget.prototype.layout = function()
    {
        var g, h, w;
        var ellipsisH, text, end, prev;
        var src, dst;

        if( this._text === undefined )
            return;

        this._string.setWhiteSpace( "normal" );

        if( this._hasEllipsis )
        {
            ellipsisH = this._ellipsisLines * this._leading;
            this._string.setText( this._text ); // force h to be re-calculated
        }

        g = this._scroll.getH();
        h = this._string.getH(); // full height that may extend past scroll
        w = this.getW(); // right edge of wrap width

        if( _x2._config._render === Config.RENDER_DOM )
        {
            this._string.setW( w );

            if( this._hasEllipsis && (h >= ellipsisH) )
            {
                end = 0;

                // grow string to just too long
                do
                {
                    prev = text;
                    end  = this._text.indexOf( " ", ++end );
                    text = this._text.substring( 0, end ) + "&hellip;";
                    if( end < 0 )
                        break;
                    this._string.setText( text );
                    h = this._string.getH();
                } while( h <= ellipsisH );

                if( end < 0 )
                {
                    this._string.setText( this._text );
                    h = this._string.getH();
                    if( h <= ellipsisH )
                        prev = this._text; // Edge case: this._text fits
                }

                this._string.setText( prev );
            }
        }
        else if( _x2._config._render === Config.RENDER_WEBGL )
        {
            /*
                If we have HTML text the container has been split into string ...

                Before:
                    ScrollWidget    this._scroll
                    Widget              _children[0] = this._container
                    StringWidget            _children[0] = this._string
                    Widget                      _container
                    Widget                         _children[0]
                    Widget                         _children[1]

                After:
                    ScrollWidget    this._scroll
                    Widget              _children[0] = this._container
                    StringWidget            _children[0]
                    StringWidget            _children[1]
                    StringWidget            _children[2]
                    :
                    StringWidget            _children[n]

                ... but we still may need to wrap each individual string.
            */
            var prevString    = this._string;
            var prevContainer = this._string._container;

            this._container.removeAllWidgets();

            if( prevString._tags && (prevString._tags.length > 1) )
            {
                var iLine  = 0;
                var nLine  = prevContainer._children.length;
                var y0     = 0;
                var y1     = 0;
                var eLine  = this._ellipsisLines;
                var ooLead = 1 / this._leading;

                for( ; iLine < nLine; iLine++ )
                {
                    src    = prevContainer._children[ iLine ];
                    y1     = this.wrapGL( prevString, src._text, y0, eLine );
                    dst    = this._container._children[ iLine ];
                    eLine -= Math.ceil((y1 - y0) * ooLead);
                    y0     = y1;
                    dst.setVal( Widget.FONT_COLOR, src._curVal[ Widget.FONT_COLOR ] );
                }

                // Note: We reset the ellipsisH so that the line with the ellipsis is visible
                // TODO: Is _leading twice as big?
                ellipsisH = h = y0;
            }
            else
                h = this.wrapGL( this._string, this._text, 0, this._ellipsisLines );

            this._container.resourcesLoad();
        }

        if( this._hasEllipsis )
        {
            g = 0;
            h = ellipsisH;
        }

        // Initial height may have been not specified and thus the scroll height == 0
        if( !g )
        {
            // Inline setH() as we can't call it for ref-low since it calls layout()
            Widget.prototype.setH.call( this, h );
            this._container .setH( h );
            this._scroll    .setH( h );

            g = h; // thumb bar height is 100% and thus not visible
        }

        // Update thumb bar height so it is proportional to visible scroll height / string height
        this._thumbS = Math.max( this._thumbH, g * (g / h) ) | 0;

        // We can't use: this._thumb.setH( this._thumbS );
        // As the thumb bar needs to be inside the total height
        this._thumb.setPosition( { w:0, h:this._thumbS, inner:true } );

        // If entire string is visible, hide thumb slider
        if( !this._hasEllipsis )
            this._thumb.setA( this._offsetY >= ((this._string.getH() - g) | 0) ? 0 : 1 );

        // Keep scrollbar adjacent to textblock
        this._thumb.setX( w+1 );
    };

    /** Scroll the text down by a line
     *  @memberof TextBlockWidget
     */
    TextBlockWidget.prototype.lineDown = function()
    {
        this.setScrollDelta( this._leading );
    };

    /** Scroll the text up by a line
     *  @memberof TextBlockWidget
     */
    TextBlockWidget.prototype.lineUp = function()
    {
        this.setScrollDelta( -this._leading );
    };

    /** Scroll the text down by a page (minus 1 line to keep continuity)
     * @memberof TextBlockWidget
     */
    TextBlockWidget.prototype.pageDown = function()
    {
        this.setScrollDelta( this._scroll.getH() - this._leading );
    };

    /** Scroll the text up by a page (minus 1 line to keep continuity)
     *  @memberof TextBlockWidget
     */
    TextBlockWidget.prototype.pageUp = function()
    {
        this.setScrollDelta( this._leading - this._scroll.getH()  );
    };

    TextBlockWidget.prototype.resourcesLoaded = function()
    {
        Widget.prototype.resourcesLoaded.call( this );

        // guard against being called multiple times
        if( !this._leading )
        {
            this._leading = this._string.getH();

            if( _x2._config._render === Config.RENDER_WEBGL )
                if( !this._leading )
                    this.getLeadingGL();

            if( this._hasEllipsis && this._leading )
                this._ellipsisLines = (this.getH() / this._leading) | 0;
        }

        this._thumbH  = this._thumb.getH();

        this.layout();
        this.callbackSignalReady();
    };

    /**
     * Called by lineDown, lineUp, pageDown, or pageUp
     * @memberof TextBlockWidget
     * @param {Number} dy
     */
    TextBlockWidget.prototype.setScrollDelta = function( dy )
    {
        var s = this._scroll.getH(), t = this._string.getH(), h = t - s;

        this._offsetY += dy;

        if( this._offsetY < 0 )
            this._offsetY = 0;

        if( this._offsetY > h )
            this._offsetY = h;

        // TODO: Config.ANI_TIME_SCROLL ? Based off of Config.ANI_TIME_HORIZ_MENU
        // HACK: Hard-coded scroll animation time
        this._scroll.setScroll( { y: -this._offsetY, duration: 250 } );

        this._thumb.animate( { y: (this._offsetY / h) * (s - this._thumbS), duration: 250 } );
    };

    /** Update text
     * @memberof TextBlockWidget
     * @param {String} str - New text
     */
    TextBlockWidget.prototype.setText = function( str )
    {
        this._text = str ? str : "";

        this._string.setText( str );

        // It is valid for ctor() to have no text
        // The string height is set in layout() but needs an updated leading
        // If we are called multiple times only set the first time since the text style can't change
        if( !this._leading )
        {
            this._string.setWhiteSpace( "nowrap" );
            this._leading = this._string.getH();

            if( _x2._config._render === Config.RENDER_WEBGL )
                if( !this._leading )
                    this.getLeadingGL();

            if( this._hasEllipsis && this._leading )
                this._ellipsisLines = (this.getH() / this._leading) | 0;
        }

        this.layout();
    };

    /** Resize text block
     * @memberof TextBlockWidget
     * @param {Number} val - Width in pixels
     */
    TextBlockWidget.prototype.setW = function( val )
    {
        Widget.prototype.setW.call( this, val );

        this._container.setW( val );
        this._scroll   .setW( val );

        this.layout();
    };

    /** Resize text block
     * @memberof TextBlockWidget
     * @param {Number} val - Height in pixels
     */
    TextBlockWidget.prototype.setH = function( val )
    {
        Widget.prototype.setH.call( this, val );

        this._container.setH( val );
        this._scroll   .setH( val );

        if( this._hasEllipsis && this._leading )
            this._ellipsisLines = (this.getH() / this._leading) | 0;

        if( _x2._config._render === Config.RENDER_WEBGL )
        {
            this.getLeadingGL();

            if( this._hasEllipsis && this._leading )
                this._ellipsisLines = (this.getH() / Math.ceil(this._leading)) | 0;
        }

        this.layout();
    };

    /** Word wrap and if neccessary truncate a long text string block with ellipsis
     *  Will add a new StringWidget to this._container
     *  NOTE: Will update the string height
     *  NOTE: Uses _ellipsisLines to determine which line the ellipsis should be placed on
     * @param {StringWidget} string
     * @param {String}       text
     * @param {String}       y -- initial y offset for all strings that get added
     * @param {Number}       ellipsisLine -- which line to place ellipsis on
     */
    TextBlockWidget.prototype.wrapGL = function( string, text, y, ellipsisLine )
    {
        var w = this.getW(); // right edge of wrap width

        var end;
        var begOfLine = 0;
        var endOfLine = 0;
        var lenOfLine = text.length;

        var params    =
        {
            text    : text,
            offset  : 0,
            length  : lenOfLine,
            fontSize: this._string._curVal[ Widget.FONT_SIZE ]
        };
        var font      = Widget.glFonts[ this._string.getVal( Widget.FONT ) ];
        var width     = font.getLineWidth( params ).width;
        var maxWidth  = this._hasEllipsis ? w : 0; // ellipsis max width
        var strings   = [];
        var idxWrap;
        var idxSoftWrap;
        var idxHardWrap;
        var LF = String.fromCharCode( 10 );

        var x = 0;
        var i, strWidget, align = this._style._object.textAlign;

        while( true )
        {
            // Hard  Soft  Action
            // -1    -1    done line wrapping, need to check from wrap to end-of-string
            // -1     ?    idxWrap = soft position
            //  ?    -1    idxWrap = hard position
            //  ?     ?    idxWrap = min( soft, hard )
            idxHardWrap = text.indexOf( LF , endOfLine );
            idxSoftWrap = text.indexOf( " ", endOfLine );

            if( idxHardWrap < 0 )
            {
                if( idxSoftWrap < 0 )
                    break;
                else
                    idxWrap = idxSoftWrap;
            }
            else if( idxSoftWrap < 0 )
                idxWrap = idxHardWrap;
            else
                idxWrap = (idxHardWrap < idxSoftWrap) ? idxHardWrap : idxSoftWrap;

            params.offset = begOfLine;
            params.length = idxWrap - begOfLine + 1;
            width         = font.getLineWidth( params ).width; // NOTE: params.text set above

            if( (idxHardWrap != -1) && (idxHardWrap < idxSoftWrap) )
            {
                endOfLine = idxHardWrap; // break at the hard wrap
                width     = w;           // intentional fall into soft wrap
            }

            if( (width >= w) && (begOfLine != endOfLine) )
            {
                strings.push( text.substring( begOfLine, endOfLine ) );
                begOfLine = endOfLine;
            }

            endOfLine = idxWrap + 1;
        }

        // Handle edge cases:
        // 1) Never had a hard wrap (LF) or soft wrap (SPACE)
        // 2) End of String from last WRAP
        if( begOfLine < (lenOfLine - 1) )
        {
            params.offset = begOfLine;
            params.length = lenOfLine - begOfLine;
            width         = font.getLineWidth( params ).width;

            if( width >= w ) // right edge of wrap width
            {
                strings.push( text.substring( begOfLine, endOfLine ) );
                strings.push( text.substring( endOfLine, lenOfLine ) );
            }
            else
                strings.push( text.substring( begOfLine, lenOfLine ) );
        }

        for( i = 0; i < strings.length; i++ )
        {
            text = strings[i];

            if( this._hasEllipsis && (i === (ellipsisLine-1)) ) // on last visible line?
            {
                if( strings.length !== ellipsisLine )
                {
                    params.offset = 0;
                    end           = text.length;

                    // Edge case 1: entire string fits? Nothing to do, handled above
                    // Edge case 2: "bar_..."     fits?
                    // Edge case 3: "foo_bar..."  fits?
                    // Repeat until we can fit most of the line
                    do
                    {
                        end           = strings[i].lastIndexOf( " ", end-1 );
                        params.text   = strings[i].substring( 0, end ) + "...";
                        params.length = params.text.length;
                        text          = params.text;
                        width         = font.getLineWidth( params ).width;
                    } while( width > maxWidth );
                }
            } // "..."

            strWidget = new StringWidget().init( { text:text, style:this._style } );

            x = 0;
            if( align === "right" || align === "center" )
            {
                params.text   = strings[i];
                params.offset = 0;
                params.length = params.text.length;
                x = w - font.getLineWidth( params ).width;
            }

            if( align === "center" )
                x *= 0.5;

            this._container.addWidget( strWidget, x, y );
            y += this._leading;

            if( this._hasEllipsis && end ) // don't show extra lines
                break;
        } // for

        this._string.setH( y ); // need full height for scrolling

        return y;
    };

    return TextBlockWidget;

})();



/***/ }),
/* 146 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TimeCellWidget = ( function()
{
    "use strict";

    TimeCellWidget.prototype = new ListRowWidget();

    function TimeCellWidget(){}

    TimeCellWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 291 );
    };

    TimeCellWidget.prototype.gotFocus = function()
    {
        return this;
    };

    TimeCellWidget.prototype.init = function( params )
    {
        var self = this;

        params.sep = false;

        ListRowWidget.prototype.init.call( this, params );
        this._className  = "TimeCellWidget";
        this._selectable = false;

        var style = new Style( { color:"#8c8c8c", font:"medium", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", colorHi:"#e8e8e8" } );

        this._str = new StringWidget().init( { style:style } );
        this._str.addReadyCallback( function() { self.layout() } );
        this.addWidget( this._str, Style._pad );

        this.setA( 0 );
        this.setW( this.getHeightUnfocused() );
        this.setH( params.h );

        return this;
    };

    TimeCellWidget.prototype.layout = function()
    {
        this._str.setY( (this.getH() - this._str.getH()) / 2 );
    };

    TimeCellWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._data = data;
            this._str.setText( data );
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return TimeCellWidget;

})();


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TomatoWidget = (function()
{
    "use strict";

    TomatoWidget.prototype = new Widget();

    function TomatoWidget(){}

    TomatoWidget.prototype.getSpeechStr = function()
    {
        return "Rotten Tomatoes. Critics Rating " + this._criticScore + " percent. Audience Rating " + this._userScore + " percent. ";
    };

    TomatoWidget.prototype.init = function( params )
    {
        Widget.prototype.init.call( this, params );
        this._className = "TomatoWidget";
        this._numLoaded = 0;

        var self       = this;
        var noTitle    = params ? params.noTitle : undefined;
        var style      = params ? params.style   : undefined;
        var titleStyle = new Style( { font: "regular", color: "#8b8b8b", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );
        var valueStyle = style ? style : new Style( { font: "regular", color: "#e8e8e8", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );
        var onLoad     = function() { self._numLoaded++; self.layout(); };

        this.setA( 0 );

        this._criticIcon        = new ImageWidget().init ( { url:_x2._config._imageRoot + "rating_fresh.png"  , onLoad:onLoad } );
        this._userIcon          = new ImageWidget().init ( { url:_x2._config._imageRoot + "rating_popcorn.png", onLoad:onLoad } );
        this._criticScoreString = new StringWidget().init( { style: valueStyle } );
        this._userScoreString   = new StringWidget().init( { style: valueStyle } );

        this._userScoreString.addReadyCallback( onLoad );

        if( ! noTitle )
        {
            this._titleSting = new StringWidget().init( { style: titleStyle, text:"Rotten Tomatoes " + String.fromCharCode( 0x2122 ) } );
            this.addWidget( this._titleSting );
        }

        this.addWidget( this._criticIcon );
        this.addWidget( this._criticScoreString );
        this.addWidget( this._userIcon );
        this.addWidget( this._userScoreString );

        return this;
    };

    TomatoWidget.prototype.layout = function()
    {
        if( this._numLoaded === 3 )
        {
            var titleW, lowerW;
            var lowerY = this._titleSting ? this._titleSting.getH() : 0;
            var maxH   = this._criticIcon.getH();

            if( this._criticScoreString.getH() > maxH )
                maxH = this._criticScoreString.getH();

            if( this._userIcon.getH() > maxH )
                maxH = this._userIcon.getH();

            this._criticIcon.setY( lowerY + (maxH - this._criticIcon.getH()) / 2 );
            this._criticScoreString.setY( lowerY + (maxH - this._criticScoreString.getH()) / 2 );
            this._userIcon.setY( lowerY + (maxH - this._userIcon.getH()) / 2 );
            this._userScoreString.setY( this._criticScoreString.getY() );

            this._criticScoreString.setX( this._criticIcon.getX() + this._criticIcon.getW() + Style._pad/2 );

            if( this._criticScore <= 0 )
            {
                this._userIcon.setX( 0 );
                this._userScoreString.setX( this._userIcon.getX() + this._userIcon.getW() + Style._pad/2 );
                this._criticIcon.setA( 0 );
                this._criticScoreString.setA( 0 );
            }
            else
            {
                this._userIcon.setX( this._criticScoreString.getX() + this._criticScoreString.getW() + Style._pad );
                this._userScoreString.setX( this._userIcon.getX() + this._userIcon.getW() + Style._pad/2 );
                this._criticIcon.setA( 1 );
                this._criticScoreString.setA( 1 );
            }

            if( this._userScore <= 0 )
            {
                this._userIcon.setA( 0 );
                this._userScoreString.setA( 0 );
            }
            else
            {
                this._userIcon.setA( 1 );
                this._userScoreString.setA( 1 );
            }

            titleW = this._titleSting ? this._titleSting.getW() : 0;
            lowerW = this._userScoreString.getX() + this._userScoreString.getW();

            this.setW( titleW < lowerW ? lowerW : titleW );
            this.setH( lowerY + maxH );

            this.callbackSignalReady();
        }
    };

    TomatoWidget.prototype.setData = function( review )
    {
        this.setA( 0 );
        this._userScore   = review.getFanSummaryScore();
        this._criticScore = review.getCriticSummaryScore();

        var userIco   = review.getFanSummaryRotten()    ? "rating_spilled.png" : "rating_popcorn.png";
        var criticIco = review.getCriticSummaryRotten() ? "rating_splat.png"   : "rating_fresh.png";

        this._userIcon.setUrl( _x2._config._imageRoot + userIco );
        this._criticIcon.setUrl( _x2._config._imageRoot + criticIco );
        this._userScoreString.setText( this._userScore + "%" );
        this._criticScoreString.setText( this._criticScore + "%" );

        this.layout();
    };

    return TomatoWidget;

})();


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.UpcomingRowWidget = ( function()
{
    "use strict";

    UpcomingRowWidget.prototype = new ListRowWidget();

    function UpcomingRowWidget(){}

    UpcomingRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt(120);
    };

    UpcomingRowWidget.prototype.gotFocus = function( losingFocus, newScreen )
    {
        ListRowWidget.prototype.gotFocus.call( this );
        this._line1.gotFocus();

        this._line1.setSpeechParams( this._line2.getText() + ". Press OK to select.", undefined, this, newScreen );

        return this;
    };

    UpcomingRowWidget.prototype.init = function( params )
    {
        ListRowWidget.prototype.init.call( this, params );
        this._className = "UpcomingRowWidget";

        var line1Style = new Style( { color:"#e8e8e8", font:"light", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#2ea0dd" } );
        var line2Style = new Style( { color:"#b8b8b8", font:"light", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );

        this._line1 = new StringWidget().init( {style:line1Style});
        this._line2 = new StringWidget().init( {style:line2Style});

        this.addWidget( this._line1, 0, _x2.scaleValInt(20) );
        this.addWidget( this._line2, 0, _x2.scaleValInt(65) );

        return this;
    };

    UpcomingRowWidget.prototype.lostFocus = function()
    {
        ListRowWidget.prototype.lostFocus.call( this );
        this._line1.lostFocus();
    };

    UpcomingRowWidget.prototype.processEvent = function( val, type )
    {
        var retval = false;

        if( val === Host.KEY_ENTER && type === Host.KEY_PRESSED )
        {
            if( this._entity.getType() === XtvApi.EntityType.EPISODE )
                _x2.pushScreen( new EpisodeScreen().init( { entity: this._entity } ) );
            else
                _x2.pushScreen( new EntityScreen().init( { entity: this._entity } ) );

            retval = true;
        }

        return retval;
    };

    UpcomingRowWidget.prototype.setData = function( data )
    {
        if( data !== undefined )
        {
            this._entity = data;

            var season, episode;

            var line1 = "", line2 = "";

            var epTitle = data.getTitle();
            var start   = data.getStartTime();
            var end     = data.getEndTime();
            var program = data.getProgram();
            var channel = data.getChannel ? data.getChannel() : undefined;

            if( program )
            {
                season  = program.getSeasonNumber();
                episode = program.getEpisodeNumber();

                if(season)
                    line1 = "S" + season + " ";

                if(episode)
                    line1 += "Ep" + episode + " ";
            }

            if(epTitle)
                line1 += epTitle;

            if( start )
                line2 = _x2.createTimeStr( new Date(start));

            if( start && end )
                line2 += " - ";

            if( end )
                line2 += _x2.createTimeStr( new Date(end));

            if( channel )
                line2 += " on " + channel.getNumber() + " " + channel.getCallSign();

            this._line1.setText( line1 );
            this._line2.setText( line2 );

            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return UpcomingRowWidget;

})();


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodGridRowWidget = (function()
{
    "use strict";

    VodGridRowWidget.prototype = new ListRowWidget();

    function VodGridRowWidget(){}

    VodGridRowWidget.prototype.gotFocus = function( lastFocus, newScreen )
    {
        if( lastFocus && lastFocus.getIndex )
            this._selectedIndex = lastFocus.getIndex();

        if( this._data )
        {
            if( this._selectedIndex >= this._data.length - 1 )
                this._selectedIndex = this._data.length - 1;
        }

        return _x2.requestFocus( this._cells[this._selectedIndex], newScreen );
    };

    VodGridRowWidget.prototype.init = function( params )
    {
        params.sep = false;
        ListRowWidget.prototype.init.call( this, params );
        this._className = "VodGridRowWidget";

        this.initCells( params, XtvApi.EntityRenderStyle.POSTER );
        this.setA( 0 );

        return this;
    };

    VodGridRowWidget.prototype.initCells = function( params, style )
    {
        this._columns       = params.obj.getColumnCount();
        this._cells         = [];
        this._cellW         = Math.floor( (_x2._config._screenW - Style._safeLeft - Style._safeRight) / this._columns );
        this._selectedIndex = 0;

        for( var i = 0; i < this._columns; i++ )
        {
            var cell = new GalleryCellWidget().init( { sep:false, style:style, collectionType:'grid' } );
            this._cells.push( cell );
            this.addWidget( cell, i * this._cellW, 0 );
        }
    };

    VodGridRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 616 );
    };

    VodGridRowWidget.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                    _x2.pushScreen( VodEntityScreen().init( { entity: this._cells[this._selectedIndex] } ) );
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._selectedIndex > 0 )
                    {
                        this._selectedIndex--;
                        if( this._cells[this._selectedIndex] )
                            _x2.requestFocus( this._cells[this._selectedIndex] );
                    }
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._selectedIndex < this._columns - 1 && this._selectedIndex < this._data.length - 1 )
                    {
                        this._selectedIndex++;
                        if( this._cells[this._selectedIndex] )
                            _x2.requestFocus( this._cells[this._selectedIndex] );
                    }
                }
                break;

            default:
                retval = ListRowWidget.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    VodGridRowWidget.prototype.setData = function( entities )
    {
        this._data = entities;

        if( entities !== undefined )
        {
            if( entities && entities.length )
            {
                for( var i = 0; i < this._columns; i++ )
                    this._cells[i].setData( entities[i], i );
            }
            this.setA( 1 );
        }
        else
            this.setA( 0 );
    };

    return VodGridRowWidget;

})();


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SixteenNineGridRowWidget = (function()
{
    "use strict";

    SixteenNineGridRowWidget.prototype = new VodGridRowWidget();

    function SixteenNineGridRowWidget(){}

    SixteenNineGridRowWidget.prototype.init = function( params )
    {
        params.sep = false;
        ListRowWidget.prototype.init.call( this, params );
        this._className = "SixteenNineGridRowWidget";

        this.initCells( params, XtvApi.EntityRenderStyle["16X9_PROGRAM"] );
        this.setA( 0 );

        return this;
    };

    SixteenNineGridRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 380 );
    };

    return SixteenNineGridRowWidget;

})();


/***/ }),
/* 151 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @function Callback
 */

function onLoad()
{
    window.onerror = function( message, url, line, col, error )
    {
        var retval;

        if( error && error.stack )
            retval = error.stack;
        else
            retval = message + " at " + line + ":" + col + " of " + url;

        if( _x2._splunk )
            _x2._splunk.sendGeneralError( retval, "TVAPP-00100" );
    };
    window.contentLoadTime = new Date().getTime();
    console.log("Actual app script loaded in", (window.contentLoadTime - window.appStartTime)/1000, " secs");
    window._x2 = new X2();
    //Since we have load all libraries file using vendor.js in index.html, there is no need of these call
    if (!window['secclient-js-coam']) {
        _x2.loadExternalLibraries( function() { _x2.init(); _x2.begin(); } );
    } else {
        _x2.init();
        _x2.begin();
        if( _x2._splunk === undefined )
        {
            _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);
            _x2._metricsSocket   = new MetricsSocket();
            _x2._splunk          = new Splunk();
        }
    }// if vendor.js is not loaded from cache server, then application will not load forever
}

window.onLoad = onLoad;

/**
 * Application singleton
 * @class
 */
window.X2 = (function()
{
    "use strict";

    X2.LocalyticsDimension = Object.freeze
    ({
        LOGGED_IN     :  0,
        CONNECTION    :  2,
        UNIVERSITY    :  7,
        X1_USER_TYPE  :  8,
        ACCOUNT_STATUS: 13,
        DEVICE_MODEL  : 15,
        APP_VERSION   : 16
    });

    X2.LocalyticsAccountState = Object.freeze
    ({
        "active"           : "Active",
        "preactive"        : "Pre-active",
        "preactive-timeout": "Limited"
    });

    X2.LocalyticsInHome = Object.freeze
    ({
        "in-home"    : "In Home",
        "out-of-home": "Out Of Home"
    });

    X2.LocalyticsUserType = Object.freeze
    ({
        "churned"   : "Churn",
        "default"   : "Default",
        "smb"       : "SMB",
        "stream"    : "Stream",
        "university": "University"
    });

    X2.prototype = new Widget();

    function X2(){}

    X2.prototype.authorize = function()
    {
        var self               = this;
        var onHasSession       = function() { self.sessionCreated(); };
        var onNeedsCredentials = function( params ) { self.sessionNeedsCredentials( onHasSession, params ); };

        if( this._data === undefined )
            switch( this._config._mode )
            {
                case Config.MODE_UHD:
                    this._data = new ThePlatformApi( this._config._thePlatformRoot );
                    break;

                default:
                    this._data = new XtvApi( this._config._xtvApiRoot );
                    break;
            }

        switch( self._config._authMode )
        {
            case Config.AUTH_CIMA:
                self._authService = new Cima( onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_CISCO_SAML:
                self._authService = new CiscoSaml(  onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_NONE:
                setTimeout( onHasSession, 1 );
                break;

            case Config.AUTH_OAUTH:
                self._authService = new Oauth( onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_XTV:
                self._authService = new XtvAuth( onHasSession, onNeedsCredentials );
                break;

            default:
                console.error( "ERROR -> unknown auth mode = " + self._config._authMode );
                break;
        }

    };

    X2.prototype.begin = function()
    {
        var self = this, onHostInit, onRenderReady, onRenderError;

        onRenderReady = function()
        {
            var shadowFile = [ "", "", "cellShadow_40_40_0_0.png", "cellShadow_61_61_0_0.png" ][_x2._config._layout];

            self._screenRoot  = new StackScreen().init( { name:"ScreenRoot" }  );
            self._overlayRoot = new StackScreen().init( { name:"OverlayRoot", hasBg:true } );
            self._hi          = new SelectionWidget().init( { url:_x2._config._imageRoot + "selection_0_0_5_5.png", w:50, h:50 } );
            self._shadow      = new NineSliceWidget().init( { url:_x2._config._imageRoot + shadowFile, w:50, h:50, pma:false } );

            self._hi.addWidget( self._shadow );
            self._shadow.setPosition( { x:0 , y:0 } );

            self._hi.setA( 0 );
            self._shadow.setA( 0 );

            self.addWidget( self._screenRoot  );
            self.addWidget( self._overlayRoot );
            self.addWidget( self._hi          );
            window.renderStartTime = new Date().getTime();
            console.log("Content start loaded in ", (window.renderStartTime - window.contentLoadTime)/1000 , " secs");

            var onGotFocus = function()
            {
                var top = self._screenRoot.getTop();

                _x2._timeDatum         = Date.now() - _x2._lastStep;
                _x2._minuteTimerDatum -= 60000;

                if( top.refreshCheck )
                    top.refreshCheck();
            };

            window.addEventListener( "focus" , onGotFocus );  // update the time datum after app has been in backround

            self._div = document.body;
            self.patchWidget();

            if( self._screenRoot._div )
                self._screenRoot._div.style.overflow = "hidden";
            
            self._nextFrameFunction = self.getNextFrameFunction();
            self._nextFrameFunction.call( window, self.nextFrame );

            onHostInit = function()
            {
                var onSuccess, onError;

                onSuccess = function( data )
                {
                    var onConfig = function()
                    {
                        if( _x2._config._xtvStage === true ) {
                            _x2._config._xtvApiRoot = "https://xtvapi-staging.cloudtv.comcast.net/";
                            _x2._config._xcalEndPoints = {
                                authenticationActivationUrl: 'https://xacs-activation-stage.cs.xcal.tv',
                                authenticationRenewalUrl: 'https://xacs-renewal-stage.cs.xcal.tv',
                                deviceProvisionUrl: 'https://xacsa-stage.ccp.xcal.tv',
                                licenseAcquisitionUrl: 'https://mds-stage.ccp.xcal.tv'
                            };
                            _x2._config._licenseServer = _x2._config._xcalEndPoints.licenseAcquisitionUrl;
                            _x2._config._provHost = _x2._config._xcalEndPoints.deviceProvisionUrl;
                        }//Change the license server and device provision url to staging

                        if (_x2._config._stageEnv == 'stage2') {
                            _x2._config._xtvApiRoot = "https://xtvapi-aws-us-east-1-staging-2-active.r53.aae.comcast.net/";
                        }
                        self.authorize();
                    };

                    _x2._st = data;
                    self._config.load( onConfig );
                };

                onError = function( error )
                {
                    if( error.data )
                    {
                        console.log( "ERROR -> unable to load selected language, defaulting to English: " + error.error.status );
                        onSuccess( error.data );
                    }
                    else
                        console.log( "ERROR -> unable to load any language: " + error.error.status );
                };

//                self.setScreen( new LoadingScreen().init() );
                new Strings().load( Strings.Language.ENGLISH ).then( onSuccess ).catch( onError );
            };

            self.setScreen( new LoadingScreen().init() );
            self._config._host.init( onHostInit );
        };

        onRenderError = function( e )
        {
            if( e ) // WebGL.init() returns undefined if DOM was specified
                console.error( e );

            if( Widget.glCanvas )
                Widget.glCanvas.parentNode.removeChild( Widget.glCanvas );

            Widget.gl = undefined;

            self._config._render = Config.RENDER_DOM;
            onRenderReady();
        };

        this._moneyTrace = new MoneyTrace();
        this._network    = new Network();

        // Add global Features object
        this._features = new Features();

        // Localytics
        var key       = this._config._localyticsKey;

        window.LocalyticsGlobal = 'll';
        window.ll = function()
        {
            //(window.ll.q = window.ll.q || []).push(arguments);
            return false;
        };// remove localytics, since it was not in used
        window.ll.t = Date.now();

        /*var script     = document.createElement('script');
        script.type    = 'text/javascript';
        script.src     = 'https://web.localytics.com/v3/localytics.min.js';
        script.onerror = function()  // Localytics does not check if the load fails which causes ll() to consume unbounded memory
        {
            if( environment.ENV !== 'prod' )
                console.log( 'INFO -> Failed to load Localytics' );
            window.ll = function() {};
            window.ll.q = []; // NOTE: .t is not used
        };

        var nodes = document.getElementsByTagName('script')[0];
        nodes.parentNode.insertBefore( script, nodes );
        window.ll( 'init', key, {} );*/

        this._config.debugAddClass( Config.CLASS_LOCALYTICS, 0 );

        /*
        NOTE:
            The unminified code above is the manually cleaned up version of
            the original Localytics minified code below from
                https://docs.localytics.com/dev/web.html#integrate-web

        var loadLocalytics = function( l, y, t, i, c, s )
        {
            l['LocalyticsGlobal'] = i;
            l[i] = function() {
                (l[i].q = l[i].q || []).push(arguments)
            };
            l[i].t = +new Date;
            (s = y.createElement(t)).type = 'text/javascript';
            s.src = 'http://web.localytics.com/v3/localytics.min.js';
            (c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);

            ll( 'init', key, {} );
        };

        loadLocalytics( window, document, 'script', 'll' );
        */

        _x2.localyticsLogout();

        _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);

        // hacky way to preload the fonts

        var preloads =
        [
            new StringWidget().init( { text:"?", style:new Style( { font:"bold"   , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"medium" , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"thin"   , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } )
        ];

        for( var i = 0; i < preloads.length; i++ )
            this.addWidget( preloads[i] );

        var removeTempString = function()
        {
            for( var i = 0; i < preloads.length; i++ )
                self.removeWidget( preloads[i] );
        };

        setTimeout( removeTempString, 1 );

        // set up the UI layers

        this._videoRoot                       = document.createElement( 'div' );
        this._videoRoot.id                    = "VideoRoot";
        this._videoRoot.style.position        = "absolute";
        this._videoRoot.style.left            = "0px";
        this._videoRoot.style.top             = "0px";
        this._videoRoot.style.width           = this._config._screenW + "px";
        this._videoRoot.style.height          = this._config._screenH + "px";
        this._videoRoot.style.overflow        = "hidden";
        this._videoRoot.style.backgroundColor = "#000000";
        document.body.appendChild( this._videoRoot );

        Widget.glInit().then( onRenderReady ).catch( onRenderError );

        if( this._config._ja )
        {
            var onClose = function( event )
            {
                console.log( "Joshalytics socket CLOSED" );
                console.log( event );

                switch( event.code )
                {
                    case 1000:
                        console.log( "CLEAN CLOSE" );
                        break;

                    case 1005:
                        self._ja = new Joshalytics( params );
                        break;

                    case 1006:
                        setTimeout( function() { self._ja = new Joshalytics( params ); }, 5000 );
                        break;

                    default:
                        console.error( "Unsupported socket close event." );
                        break;
                }
            };

            var onError = function( obj )
            {
                console.log( obj );
            };

            var onMessage = function( obj )
            {
                var val;

                console.log( obj );

                switch( obj.type )
                {
                    case Joshalytics.Type.KEY_PRESS:
                        val = Host.mapKeyVal( Host.mapKeyStr( obj.data ) );

                        if( val !== undefined )
                        {
                            _x2.routeKey( val, Host.KEY_PRESSED );
                            _x2.routeKey( val, Host.KEY_RELEASED );
                        }
                        break;
                }
            };

            var onOpen = function( obj )
            {
                console.log( obj );
            };

            var params = {};

            params.server    = "ws://" + this._config._ja;
            params.onClose   = onClose;
            params.onError   = onError;
            params.onMessage = onMessage;
            params.onOpen    = onOpen;

            this._ja = new Joshalytics( params );
        }
    };

    X2.prototype.createTimeRange = function( startDate, stopDate )
    {
        var retval, raw, hours, mins;

        hours  = startDate.getHours() % 12;
        mins   = startDate.getMinutes();

        retval = (hours === 0 ? 12 : hours) + ":" + (mins < 10 ? "0" + mins : mins);

        raw    = stopDate.getHours();
        hours  = raw % 12;
        mins   = stopDate.getMinutes();

        if( raw === 0 && mins === 0 )
            retval += "p";
        if( raw === 12 && mins === 0 )
            retval += "a";

        retval += " - " + (hours === 0 ? 12 : hours) + ":" + (mins < 10 ? "0" + mins : mins) + (raw > 11 ? "p" : "a");

        return retval;
    };

    X2.prototype.createTimeSpeechStr = function( str )
    {
        var retval = str;

        retval = retval.replace( ":00", "" );
        retval = retval.replace( ":30", " thirty" );
        retval = retval.replace( "a", " am. " );
        retval = retval.replace( "p", " pm. " );
        retval = retval.replace( " - ", " to " );

        return retval;
    };

    /**
     * Utility
     * @memberof X2
     * @param {Date} date
     * @returns {String}
     */
    X2.prototype.createTimeStr = function( date )
    {
        if( date === undefined )
            date = _x2._config._host.getCurrentDateTime();

        var hour    = date.getHours();
        var mins    = date.getMinutes();
        var dayPart = (hour > 11) ? "p" : "a";

        hour = hour % 12;

        if( hour === 0 )
            hour = 12;

        mins = ((mins < 10) ? "0" : "") + mins;

        return hour + ":" + mins + dayPart;
    };

    /**
     * Create a "Expires in..." string
     * @memberof X2
     * @param {Date} date
     * @returns {String}
     */
    X2.prototype.createExpiresString = function( date )
    {
        var expiresString, now = Date.now();

        if( date > now )
        {
            var expiresInMinutes = Math.floor((date - now) / 60000);
            var expiresInHours   = Math.floor(expiresInMinutes / 60);
            var expiresInDays    = Math.floor(expiresInHours   / 24);
            var expireElements   = [];

            if( expiresInDays > 0 )
                expireElements.push( expiresInDays + ( expiresInDays > 1 ? " days" : " day" ) );

            if( expiresInHours % 24 > 0 )
                expireElements.push( expiresInHours % 24 + ( ( expiresInHours % 24 ) > 1 ? " hrs" : " hr") );

            if( expiresInDays === 0) //only show minutes when < 24 hours.
                expireElements.push( expiresInMinutes % 60 + ( ( expiresInMinutes % 60 ) > 1 ? " mins" : " min") );

            if( expireElements.length > 0 )
                expiresString = "Expires in " + expireElements.join(", ");
        }
        else
            expiresString = "Expired";

        return expiresString
    };

    /**
     * Create a "Expires in..." string for speech
     * @param {Date} date
     * @return {string}
     */
    X2.prototype.createExpiresSpeechString = function( date )
    {
        return this.createExpiresString( date )
            .replace("mins", "minutes")
            .replace("min" , "minute" )
            .replace("hrs" , "hours"  )
            .replace("hr"  , "hour"   );
    };

    /**
     * Create a short date string where using 'today' and 'yesterday' for recent dates.
     * @param date
     * @param {boolean} [on] - show 'on' when date is not 'Today' or 'Yesterday'
     * @returns {String}
     */
    X2.prototype.createDateStr = function( date, on )
    {
        var result, now = new Date();

        if( now.getMonth() === date.getMonth() && now.getYear() === date.getYear() )
        {
            if( now.getDate() === date.getDate() )
                result = "Today ";
            else if( now.getDate() - 1 === date.getDate() )
                result = "Yesterday "
        }

        if( result === undefined )
            result = ( on ? " on " : "" ) + ( date.getMonth() + 1 ) + '/' + date.getDate() + " ";

        return result;
    };

    /**
     * Create a short date/time string where using 'today' and 'yesterday' for recent dates.
     * @param date
     * @returns {String}
     */
    X2.prototype.createDateTimeStr = function( date )
    {
        return this.createDateStr( date ) + this.createTimeStr( date );
    };

    /**
     * Walk the screen root chain looking for the specific screen type
     * @param {Widget} type - screen type to find. i.e. VideoScreen
     * @returns undefined if screen not found else the screen object
     */
    X2.prototype.findScreen = function( type )
    {
        var retval, i, n;

        if( this._screenRoot )
        {
            n = this._screenRoot._children.length;

            for( i = 0; i < n; i++ )
                if( this._screenRoot._children[ i ] instanceof type )
                {
                    retval = this._screenRoot._children[ i ];
                    break;
                }
        }

        return retval;
    };

    X2.prototype.fetchChannelCollection = function()
    {
        var self = this;

        if( this._channelCollection === undefined )
        {
            var resolver = function( resolve, reject )
            {
                var onGotChannels = function( cc )
                {
                    self._channelCollection = cc;
                    resolve();
                };
                self._data.getChannelCollection().then( onGotChannels ).catch( reject );
            };
            return new Promise(resolver);
        }
        else
            return Promise.resolve( this._channelCollection );
    };

    X2.prototype.getBrowseFilterString = function()
    {
        var retval, vals = _x2._settings.getValue( Settings.Key.FILTERS );

        if( vals )
            for( var key in vals )
                if( vals[key] === true )
                {
                    key    = (key    === "cc"     ) ? "closedcaption" : key;
                    retval = (retval === undefined) ? key             : retval + "," + key;
                }

        return retval;
    };

    X2.prototype.getNextFrameFunction = function()
    {
        return  window.requestAnimationFrame       ||
                window.mozRequestAnimationFrame    ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame     ||
                window.oRequestAnimationFrame      ||
                function( callback ) { window.setTimeout( function() { callback( (new Date()).getTime() ); }, 1000/30 ); };
    };

    X2.prototype.getOverlayRootLastFocus = function()
    {
        return this._overlayRoot._children[0]._lastFocus;
    };

    X2.prototype.getScript = function( url, onSuccess, onError )
    {
        var script;

        script         = document.createElement( "script" );
        script.type    = "text/javascript";
        script.onload  = onSuccess;
        script.onerror = onError;
        script.src     = url;
        script.async   = true;
        document.getElementsByTagName('head')[0].appendChild( script );
    };

    X2.prototype.getTopScreen = function()
    {
        return this._screenRoot.getTop();
    };

    X2.prototype.loadExternalLibraries = function( onLoaded )
    {
        var libs =
        [
            "lib/base64_js.js",
            "lib/base64url.js",
            "lib/bn_js.js",
            "lib/elliptic.js",
            "lib/fast_sha256.js",
            "lib/lodash.js",
            "lib/randombytes.js",
            "lib/url_join.js",
            "lib/url.js",
            "lib/money-trace.js",
            "lib/secclient-js-coam.js",
            "lib/PlayerPlatformAPI.js"
        ];

        var index = 0;

        var onError = function( e )
        {
            var msg = "Unable to load Javascript file = " + e.target.src;

            console.error( msg );

            if( _x2._splunk === undefined )
            {
                _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);
                _x2._metricsSocket   = new MetricsSocket();
                _x2._splunk          = new Splunk();
            }

            if( _x2._splunk !== undefined )
                _x2._splunk.sendGeneralError( msg, "TVAPP-00100" );
        };

        var loadNextLibrary = function()
        {
            var url = libs[index++];

            if( url )
                _x2.getScript( url, loadNextLibrary, onError );
            else
                onLoaded();
        };

        loadNextLibrary();
    };

    X2.prototype.init = function()
    {
        Widget.prototype.init.call( this );
        this._className = "X2";

        var self   = this;
        var index  = document.URL.indexOf( '?' );
        var params = {};
        this.keyEventHistory = [];

        window.onkeydown = function( event ) { self.onKeyDown( event ); };
        window.onkeyup   = function( event ) { self.onKeyUp  ( event ); };
        window.onunload  = function( event ) { self.onUnload ( event ); };

        this._repeat = false;

        // create a new default config

        this._config = new Config( true );
        this._config.debugAddClass( Config.CLASS_GRID, 1 );
        this._config.debugAddClass( Config.CLASS_X2, 0 );
//      this._config.debugAddClass( Config.CLASS_WEBGL, 0 ); // WebGL Widget Inspector
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( document.URL ) : Config.NOP();

        // pull parameters from the app URL

        if( index !== -1 )
        {
            var nameVal, pairs;

            pairs = document.URL.substring( index + 1, document.URL.length ).split( '&' );

            for( var i = 0; i < pairs.length; i++ )
            {
                nameVal = pairs[i].split('=');
                params[nameVal[0]] = nameVal[1];
            }
        }

        this._config.log( Config.CLASS_X2, 5 ) ? console.log( params ) : Config.NOP();

        if( this.parseBoolean( params["enabledCursor"] ) === true ) {
            document.addEventListener('cursorStateChange', self.cursorVisibilityChange, false);
        }
        if( params["size"] )
            this._config.setSize( params["size"] );

        if( params["ja"] )
            this._config._ja = params["ja"];

        if( params["testVid"] )
            this._config._testVideo = params["testVid"];

        this._config._startTime    = parseInt( params["time"] );
        this._config._cvpConf      = this.parseCvpParams( params["gw" ] );
        this._config._mac          = params["mac"];
        this._config._platform     = params["platform"];
        this._config._mode         = params["mode"];
        this._config._password     = params["p"];
        this._config._username     = params["u"];
        this._config._configServer = params["config"];
        this._config._cursorEnabled = this.parseBoolean( params["enabledCursor"] );
        this._config._text         = params["text"] ? params["text"] : 1;
        this._config._skipProv         = this.parseBoolean( params["skipProv"] );
        this._config._skipInHome   = this.parseBoolean( params["skipInHome"] );
        this._config._itv          = this.parseBoolean( params["itv"] );
        this._config._speech       = params["speech"] ? this.parseBoolean( params["speech"] ) : true;
        this._config._ppLog        = this.parseBoolean( params["ppLog"] );
        this._config._altVid       = this.parseBoolean( params["altVid"] );
        this._config._minDraw      = params["minDraw"] ? this.parseBoolean( params["minDraw"] ) : true;
        this._frameTime            = params["fps"] ? 1000 / parseInt( params["fps"] ) : 1;
        this._config._partner      = params["partner"] ? params["partner"] : "Comcast";
        this._config._allowPurch   = params["purchases"] ? this.parseBoolean( params["purchases"] ) : false;
        this._config._previewRoot  = this.parseBoolean( params["previewRoot"] );
        this._config._xtvStage     = this.parseBoolean( params["xtvStage"] );
        this._config._stageEnv     = params["stageEnv"];
        this._config._loadConfigId = params["loadConfigId"] || null;
        this._config._loadWebcrypto     = this.parseBoolean( params["loadWebcrypto"] ); //load ecdh crypto type in LG TV for dev url
        this._config._showResumePoint = this.parseBoolean( params["showResumePoint"] );

        this._config._secClientV2Var = 'secclient-js-coam'; //this contains secClient version 2.0.2

        this._config._render = ( params["webgl"] === undefined )
                             ? Config.RENDER_DOM
                             : ( this.parseBoolean( params["webgl"] ) === true)
                               ? Config.RENDER_WEBGL
                               : Config.RENDER_DOM;
        this._config._smartHubEntityId = params['smartHubEntityId'] ? params['smartHubEntityId'] : null;
        this._config._appendHeaders = params['appendHeaders'] ? decodeURIComponent(params['appendHeaders']) : null; 

        if( location.pathname.indexOf( "x2app" )       !== -1 || this._config._mode === "cloud" )
            this._config.setAppMode( Config.MODE_CLOUD );
        else if( location.pathname.indexOf( "x2rui" )  !== -1 || this._config._mode === "rui" )
            this._config.setAppMode( Config.MODE_RUI, params["partner"] );
        else if( location.pathname.indexOf( "x2test" ) !== -1 || this._config._mode === "test" )
            this._config.setAppMode( Config.MODE_TEST );
        else if( location.pathname.indexOf( "x2uhd" )  !== -1 || this._config._mode === "uhd" )
            this._config.setAppMode( Config.MODE_UHD );
        else
            this._config.setAppMode( Config.MODE_CLOUD, params["partner"] );

        // determine what platform running

        var agent = navigator.userAgent;

        console.log( agent );
        console.log( window.location.href );
        console.log( "Version = " +  AboutOverlay.version );
        console.log( "SecClient Version = " + window[ _x2._config._secClientV2Var ].SecClient.getVersion() );

        // LG    2017   Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/38.0.2125.122 Safari/537.36 WebAppManager
        // LG    2018   Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 WebAppManager
        // Tizen 2017   Mozilla/5.0 (SMART-TV; LINUX; Tizen 3.0) AppleWebKit/538.1 (KHTML, like Gecko) Version/3.0 TV Safari/538.1
        // Tizen 2018   Mozilla/5.0 (SMART-TV; LINUX; Tizen 4.0) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 TV Safari/537.36

        if( agent.indexOf( "Tizen" ) !== -1 )
            this._config._host = new Tizen();
        else if( agent.indexOf( "Web0S" ) !== -1 )
            this._config._host = new Lg();
        else if( agent.indexOf( "Android" ) !== -1 ) // can't reference global 'android'
            this._config._host = new Android();
        else
            this._config._host = new Host();

        Style.initClassVariables( this._config._layout );

        //For each key input event, browser emit two events keyup(KEY_RELEASED) and keypress(KEY_PRESSED)
        //In web simulator, only one event is get trigger(especially after mouse click) that is KEY_RELEASED
        //So we need to trigger KEY_PRESSED manually before the KEY_RELEASED Event
        this._config.isTizenSimulator = this.parseBoolean( params["tizenSimulator"] );
        this._config.isWebOsSimulator = this.parseBoolean( params["webOsSimulator"] );

        //in tv channels section, program name are listed empty for some of the timezone, so skip those check for testing purpose
        this._config.skipBlockTimeCheck = this.parseBoolean( params["skipBlockTimeCheck"] );

        //this will used  javascript date object instead of tizen.time object for debugging purpose
        this._config.useJSTime     = this.parseBoolean( params["useJSTime"] );

        return this;
    };

    /* Initialize Localytics Custom Dimensions
     */
    X2.prototype.localyticsLogout = function( sendLogout )
    {
        _x2._localyticsDimensions =
        [
            "No"         , // 0: Logged In
            undefined    , // 1: Connection Type
            "Out Of Home", // 2: Connection
            undefined    , // 3: Parental Controls
            undefined    , // 4: Screen Reader
            undefined    , // 5: Switch Accessibility
            undefined    , // 6: NPS Score
            null         , // 7: University -> Partner Id
            null         , // 8: X1 User Type
            undefined    , // 9: NPS Group
            undefined    , //10: OOH Filter Enabled
            undefined    , //11: Language
            undefined    , //12: SSID
            "None"       , //13: Account Status
            undefined    , //14: Analytics Group
            undefined    , //15: Device Model
            undefined      //16: App Version
        ];

        this.localyticsSendCustomDimensions();

        if( window.ll && sendLogout )
            window.ll( "tagEvent", "Sign Out" );
    };

    X2.prototype.localyticsSetCustomDimension = function( key, val )
    {
        _x2._localyticsDimensions[ key ] = val; // DEBUG

        if( window.ll )
            window.ll( 'setCustomDimension', key, val );
    };

    X2.prototype.localyticsSetAppVersionAndDeviceModel = function( ) 
    {
        var makeModel  = _x2._config._host._make ? (_x2._config._host._make + " " + _x2._config._host._product) : _x2._config._host._product;
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.DEVICE_MODEL  , makeModel );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.APP_VERSION   , AboutOverlay.version );
    };

    X2.prototype.localyticsSendCustomDimensions = function()
    {
        if( window.ll && _x2._localyticsDimensions )
            for( var key = 0; key < _x2._localyticsDimensions.length; key++ )
                if( _x2._localyticsDimensions[ key ] !== undefined )
                    window.ll( 'setCustomDimension', key, _x2._localyticsDimensions[ key ] );
    };

    /**
     * Localytics: Send `Favorite Entity` or `Favorite Entity Viewed`
     * @param {DataObject} entity - Entity, or SportsTeam
     * @param {String}     action - "Add" or "Remove" to send "Favorite Entity"; or "Viewed" to send "Favorite Entity Viewed"
     */
    X2.prototype.localyticsSendFavoriteEntityOrViewed = function( entity, action )
    {
        var metrics =
        {
            "Type"       : "Unknown",
            "Entity Name": entity && entity.getTitle()
        };

        var type = entity instanceof SportsTeam ? XtvApi.EntityType.OTHER : entity && entity.getType && entity.getType();

        switch( type )
        {
            case XtvApi.EntityType.SERIES : metrics.Type = "TV Show"    ; break;
            case XtvApi.EntityType.MOVIE  : metrics.Type = "Movie"      ; break;
            case XtvApi.EntityType.EPISODE: metrics      = null         ; break; // Don't send
            case XtvApi.EntityType.OTHER  : metrics.Type = "Sports Team"; break; // XtvApi.EntityType missing dedicated SPORTS
            default                       : metrics      = null         ;
                console.error( "Unhandled Favorite Entity type: " + type );
                break;
        }

        if( metrics )
        {
            if( action !== "Viewed" ) // Add/Remove
            {
                metrics["Action"] = action;

                _x2._config.log( Config.CLASS_LOCALYTICS, 3 ) ? console.log( "Localytics: " + action + " Favorites: %o", metrics ) : Config.NOP();
                window.ll( "tagEvent", "Favorite Entity", metrics );
            }
            else if( (_x2._screenRoot._children.length > 0) && (_x2._screenRoot._children[ 1 ] && _x2._screenRoot._children[ 1 ]._termStr === "Favorites") ) // Only allowed for: Saved / Favorites
            {
                _x2._config.log( Config.CLASS_LOCALYTICS, 3 ) ? console.log( "Localytics: Favorite Entity Viewed: %o", metrics ) : Config.NOP();
                window.ll( "tagEvent", "Favorite Entity Viewed", metrics );
console.log( "Favorite Entity Viewed: " + metrics["Entity Name"] + ", Type: " + metrics.Type );
            }
        }
    };

    X2.prototype.localyticsSendSplashPageAndProvisioning = function()
    {
        var type    = _x2._config._host.getType();
        var metrics =
        {
            version                : AboutOverlay.version,
            platform               : _x2._config._host.getPlatformString(),
            oemName                : "unknown",
            oemModel               : _x2._config._host._product ? _x2._config._host._product : "development",
            browser                : navigator ? navigator.userAgent : "unknown",
            deviceName             : "unknown",
            deviceModel            : "unknown",
//          deviceId               : "0", // REMOVED: PII
//          xboAccountId           : "0", // REMOVED: PII
            firstAuthentication    : _x2._metricsFirstAuthentication ? "yes" : "no",
            entitlements           : "",
            isCDVREntitled         : "no",
            isCloudServiceAvailable: "no",
            isLinearEntitled       : "no",
            isVODEntitled          : "no",
            analyticsId            : "0"
        };

        var tokenXsct = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
        if( tokenXsct )
        {
            var tokenSummary = tokenXsct.tokenSummary;

            metrics.isCDVREntitled          = tokenSummary.isCDVREntitled          ? "yes" : "no";
            metrics.isCloudServiceAvailable = tokenSummary.isCloudServiceAvailable ? "yes" : "no";
            metrics.isLinearEntitled        = tokenSummary.isLinearEntitled        ? "yes" : "no";
            metrics.isVODEntitled           = tokenSummary.isVODEntitled           ? "yes" : "no";
//          metrics.xboAccountId            = tokenSummary.xboAccountId; // REMOVED: PII
            metrics.entitlements            = tokenSummary.entitlements.join(",");
//          metrics.deviceId                = tokenSummary.deviceId; // REMOVED: PII
            metrics.analyticsId             = tokenSummary.analyticsId; // non-PII replacement for deviceId and xboAccountId. See wiki: Analytics+Tracking+ID

            if( _x2._metricsDeviceInfo )
            {
                metrics.deviceName  = _x2._metricsDeviceInfo.deviceName;
                metrics.deviceModel = _x2._metricsDeviceInfo.deviceModel;
            }
        }

        // Convert oemName into human readable string
        // Localytics 2.1.1
        // Localytics 2.2.1
        switch( type )
        {
            case Host.Type.ANDROID: metrics.oemName = "Android"; break;
            case Host.Type.LG     : metrics.oemName = "LG"     ; break;
            case Host.Type.TIZEN  : metrics.oemName = "Samsung"; break;
            case Host.Type.PC     : metrics.oemName = "Desktop"; break;
        }

        window.ll( 'tagEvent', "Splash page transition", metrics ); // Localytics 2.1.1
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Splash Page event: %o", metrics ) : Config.NOP();

        // When we provisioned we couldn't send telemetry since it is not created until after we acquired the XsctToken
        if( _x2._metricsFirstAuthentication )
            _x2._telemetry.sendProvisioning( _x2._metricsTimerAuthentication, "NA" );
        else
            _x2._telemetry.sendProvisioning( 0, "NA" );
    };

    X2.prototype.nextFrame = function( step )
    {
        var date, gl;

        if( _x2._lastStep === undefined )
        {
            date                  = new Date();
            _x2._lastStep         = step - _x2._frameTime - 1; //34;
            _x2._timeDatum        = date.getTime();
            _x2._minuteTimerDatum = step - date.getSeconds() * 1000 - date.getMilliseconds() + 3000;
        }

        if( (step - _x2._lastStep) >= _x2._frameTime )
        {
            if( (step - _x2._minuteTimerDatum) > 60000 )
            {
                _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( "TICK TICK TICK TICK - " + (step - _x2._minuteTimerDatum) ) : Config.NOP();
                _x2.callbackSignalChange();

                do
                {
                    _x2._minuteTimerDatum += 60000;
                }
                while( (step - _x2._minuteTimerDatum) > 60000 );
            }

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                gl = Widget.gl;

    //          if( !X2.SingleStep ) // DEBUG Time Step
                    gl.clear( gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT );
    /*
                if( _x2._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
                    Widget.glDebugIdx = 0;
    // */
            }

    //      if( !X2.SingleStep ) // DEBUG Time Step
            {
                _x2._lastStep = step;
                _x2._time     = _x2._timeDatum + step;
                _x2.update( step );
                _x2._nextFrameFunction.call( window, _x2.nextFrame );
            }

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
    //          if( !X2.SingleStep ) // DEBUG Time Step
                {
                    _x2.glRender( 1 );
                    gl.flush();
                }
    /*
                if( _x2._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
                {
                    if( Widget.glWidgetCapture )
                        Widget.glWidgetCapture = undefined;

                    if( Widget.glDebugOutline )
                        for( var i = 0; i < 4; i++ )
                            Widget.glDebugOutline[i].update( 0, 1 );
                }
    // */
            }
        }
        else
            _x2._nextFrameFunction.call( window, _x2.nextFrame );
    };

    X2.prototype.onKeyDown = function( event )
    {
        var retval = false, val, type;
        if( this._config.isTizenSimulator || this._config.isWebOsSimulator ) {
            window.setTimeout( function(){
                this.pushIntoKeyEventHistory( event );
            }, 0);
        }
        this._config.log( Config.CLASS_X2, 8 ) ? console.log( "Key DOWN " + event.keyCode + ", " + event.key +  ", shift = " + event.shiftKey + ", control = " + event.ctrlKey + ", alt = " + event.altKey + ", meta = " + event.metaKey ) : Config.NOP();
        if( event.ctrlKey === false && event.altKey === false && event.metaKey === false )
        {
            val  = this._config._host.mapKey( event );
            type = Host.KEY_PRESSED;

            if( this._lastKey === val )
                type = Host.KEY_REPEAT;

            // handle global key press, else pass to widget with focus, bubble back up

            if( val > 0 && this._repeat === false )
            {
                if( this.routeKey( val, type ) === true )
                {
                    event.preventDefault();
                    event.stopPropagation();
                    retval = true;
                }
            }
            else
            {
                event.preventDefault();
                event.stopPropagation();
                retval = true;
            }

            if( type === Host.KEY_REPEAT )
                this._repeat = true;

            this._lastKey = val;
        }

        return retval;
    };

    X2.prototype.onKeyUp = function( event )
    {
        this._config.log( Config.CLASS_X2, 9 ) ? console.log( "Key UP " + event.keyCode +  ", shift = " + event.shiftKey + ", control = " + event.ctrlKey + ", alt = " + event.altKey + ", meta = " + event.metaKey ) : Config.NOP();
        if( this._config.isTizenSimulator || this._config.isWebOsSimulator ) {
            window.setTimeout( function() {
                this.pushIntoKeyEventHistory( event );
            }.bind(this), 0);
        }
        if( event.ctrlKey === false && event.altKey === false && event.metaKey === false )
        {
            this._repeat  = false;
            this._lastKey = undefined;
            var type = (window.onkeydown && window.onkeydown.toString().indexOf('onKeyDown') > -1 ) ? Host.KEY_RELEASED : Host.KEY_PRESSED; //if samsung smarthub, onkeydown was null so we need change the event type to KEY_PRESSED
            this.routeKey( this._config._host.mapKey( event ), type );
        }
/*
        if( this._config.log( Config.CLASS_X2, 2 ) ) // DEBUG Time Step
        {
            // ms = 1000/Hz
            if( event.keyCode === Host.KEY_TAB ) // TAB = Advance one frame
            {
                var gl = Widget.gl;
                if( gl )
                    gl.clear( gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT );

                _x2._lastStep += (X2.msTimeStep || 25); // Default 25 ms = 1000ms/s / 25ms = 40 Hz
                _x2.update( _x2._lastStep, 1 );

                if( gl )
                    gl.flush();
            }

            if( event.keyCode === 190 ) // '.' = Toggle Paused/Run frames
            {
                if( !X2.SingleStepDiv )
                {
                    var div0 = document.createElement( 'div' );
                    var div1 = document.createElement( 'div' );

                    div0.id = "DebugPauseContainer";
                    div1.id = "DebugPauseInnerText";

                    // style="display:flex; align-items:center; justify-content:center;"
                    div0.style.alignItems     = "center"; // Vertical
                    div0.style.display        = "flex";
                    div0.style.height         = _x2._config._screenH + 'px';
                    div0.style.justifyContent = "center"; // Horizontal
                    div0.style.left           = "0px";
                    div0.style.position       = "absolute";
                    div0.style.top            = "0px";
                    div0.style.width          = _x2._config._screenW + 'px';

                    div1.innerHTML        = "PAUSED";
                    div1.style.color      = "#FF0000";
                    div1.style.fontFamily = "sans-serif";
                    div1.style.fontSize   = "192px";
                    div1.style.margin     = "0";
                    div1.style.opacity    = "0.25";
                    div1.style.padding    = "0";
                    div1.style.transform  = "rotate(-33deg)";
                    div1.style.zIndex     = "1";

                    div0.appendChild( div1 );
                    document.body.appendChild( div0 );

                    X2.SingleStepDiv = div0;
                }

                X2.SingleStep                  = 1 - (X2.SingleStep | 0);
                X2.SingleStepDiv.style.opacity = X2.SingleStep;

                if( !X2.SingleStep ) // Resume main loop
                    _x2._nextFrameFunction.call( window, _x2.nextFrame );
            }
        }

        if( this._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
        {
            if( event.keyCode === Host.KEY_BRACKET_LEFT )
            {
                Widget.glDebugInspect--;
                if( Widget.glDebugInspect < 0 )
                    Widget.glDebugInspect = 0;
                Widget.glDebug();
            }
            else if( event.keyCode === Host.KEY_BRACKET_RIGHT )
            {
                if( Widget.glWidgetsRendered.length > 0 )
                {
                    Widget.glDebugInspect++;
                    if( Widget.glDebugInspect > Widget.glWidgetsRendered.length-1 )
                        Widget.glDebugInspect = Widget.glWidgetsRendered.length-1;
                    Widget.glDebug();
                }
            }
            else if( event.key === "Alt" )
            {
                Widget.glWidgetCapture = true;
                Widget.glDebugInspect  = 0;
                if( !Widget.glDebugOutline )
                {
                    Widget.glDebugOutline =
                    [
                        new RectWidget().init( { w:1, h:1, color:"#FF0000", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#00FF00", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#0000FF", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#FFFFFF", a:0.8 } ),
                    ];
                    for( var i = 0; i < 4; i++ )
                        Widget.glDebugOutline[i].resourcesLoad();
                }
                Widget.glWidgetsRendered = [];
                Widget.glDebug = function()
                {
                    console.log( "Widget: [%d/%d]: %o", Widget.glDebugInspect, Widget.glWidgetsRendered.length-1, Widget.glWidgetsRendered[ Widget.glDebugInspect ] );
                };
            }
        }
// */
    };

    X2.prototype.onUnload = function()
    {
    };

    /**
     * Utility
     * <p>
     * Gets boolean value of string.
     * <p>
     * NOTE: Returns `undefined` if not a valid boolean.
     * @memberof X2
     * @param {String} str
     * <table class="params">
     * <thead><tr><th>Text</th><th>Returned value</th></tr></thead>
     * <tr><td>"true"<br>"yes"<br>"1"</td><td>true</td></tr>
     * <tr><td>"false"<br>"no"<br>"0"</td><td>false</td></tr>
     * </table>
     * @returns {True|False}
     */
    X2.prototype.parseBoolean = function( str )
    {
        var retval;
        if( str != undefined )
        {
            switch( str.toLowerCase() )
            {
                case "true":
                case "yes":
                case "1":
                    retval = true;
                    break;

                case "false":
                case "no":
                case "0":
                default:
                    retval = false;
                    break;
            }
        } else {
            retval = false;
        }

        return retval;
    };

    X2.prototype.parseCvpParams = function( str )
    {
        var retval;

        if( str )
            retval = JSON.parse( decodeURIComponent( str ) );

        return retval;
    };

    X2.prototype.popOverlay = function( overlay, onPopped )
    {
        return this._overlayRoot.pop( overlay, onPopped );
    };

    X2.prototype.popScreen = function( screen, onPopped )
    {
        return this._screenRoot.pop( screen, onPopped );
    };

    X2.prototype.provision = function()
    {
        var retval, executor, secClientConfig, partnerId, self = this;
        var token = decodeURIComponent( "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" );

        executor = function( resolve, reject )
        {
            var onLoad, onLoadError, onXact, onXactError;

            onXact = function( result )
            {
                var obj = {}, onProvision, onProvisionError, saml;

                console.log( result );

                if( result && (result.status === undefined || result.message === undefined ))
                {
                    _x2._config._host.setLocalStorage( "XactToken", JSON.stringify( result ) );

                    onProvision = function( data )
                    {
                        console.log( data );
                        _x2._data.createDrmSession( result.deviceToken, partnerId ).then( resolve, reject );
                    };

                    onProvisionError = function( e )
                    {
                        var apiError;
                        console.error( e );
                        _x2._splunk.sendProvisionError( e.status, _x2._secClientMoneyTrace );

                        if( e instanceof ApiError )
                             apiError = e;
                         else
                             apiError = new ApiError().init( { flash:e } );

                        reject( apiError );
                    };

                    saml = JSON.parse( Host.getLocalStorage( "XtvAuthToken" ) );
                    console.log( saml );

                    partnerId = saml.partnerId;

                    if( partnerId === "comcast" )
                    {
                        console.log( "Provision Comcast" );
                        obj.serviceHostUrl             = self._config._provHost;
                        obj.deviceAuthenticationResult = result;
                        obj.accountToken               = saml.samlResponse;
                        obj.requestMetadata            = { "X-MoneyTrace": _x2._moneyTrace.createTraceMessage() };

                        console.log( obj );

                        _x2._config._secClientV2.provisionDevice( obj ).then( onProvision, onProvisionError );
                    }
                    else
                    {
                        console.log( "Provision Partner" );

                        _x2._config._xocPartner = partnerId;
                        _x2._data.provisionPartnerDevice( result.deviceToken, encodeURIComponent( saml.samlResponse ), partnerId ).then( onProvision, onProvisionError );
                    }
                }
                else
                {
                    console.error( result? result.status + " " + result.message : "Secclient not loaded.");

                    // TODO display error and exit application
                }
            };

            onXactError = function( e )
            {
                console.log(e);
                _x2._splunk.sendProvisionError( e.status, _x2._secClientMoneyTrace );
                var apiError = new ApiError().init( { flash: e } ); //TODO: SecClient errors should be distinguished from PP errors. Example error {status:403}
                _x2.pushOverlay( new ErrorOverlay().init( { error:apiError, context:ErrorOverlay.Context.COMMON } ) )
            };

            onLoad = function()
            {
                console.log( "Sec Client LOADED" );

                _x2._secClientMoneyTrace = { "X-MoneyTrace": _x2._moneyTrace.createTraceMessage() };

                console.log( _x2._secClientMoneyTrace );
                var params = { 
                    serviceHostUrl : self._config._authHost,
                    requestMetadata: _x2._secClientMoneyTrace 
                };
                var xactToken = Host.getLocalStorage( "XactToken" ) && JSON.parse( Host.getLocalStorage( "XactToken" ) );
                if( xactToken ) {
                    params.deviceAuthenticationResult = xactToken;
                }
                return _x2._config._secClientV2.authenticateDevice( params );
            };

            onLoadError = function( e )
            {
                console.error( e );
                _x2._splunk.sendProvisionError( e.status, secClientConfig);
            };
            window.sessionStartCreatingAt = new Date().getTime();
            console.log("Creating the DRM Session at ", new Date());
            _x2._config._secClientV2 = new window[ _x2._config._secClientV2Var ].SecClient();
            _x2._config._secClientV2.load( secClientConfig ).then( onLoad, onLoadError ).then( onXact, onXactError );
        };
        if( this._config._skipProv === true )
        {
            console.log( "Provision default with canned XACT token" );
            window.sessionStartCreatingAt = new Date().getTime();
            console.log("Creating the DRM Session at ", new Date());
            var tokenFromLocalStorage        = Host.getLocalStorage( "tv-tokens-u" ); //If we update the token from xfintity-stream, then it will take that token instead of from code.
            tokenFromLocalStorage        = (tokenFromLocalStorage && JSON.parse( tokenFromLocalStorage )) || {};    
            token = ( tokenFromLocalStorage.xact )? tokenFromLocalStorage.xact : token;
            retval = _x2._data.createDrmSession( token, "comcast" );
        }
        else
        {
            var cryptoType = _x2._config._host.getCryptoType();
            var deviceType = _x2._config._host.getSecClientDeviceType();

            secClientConfig =
            {
                crypto:
                {
                    type: cryptoType
                },
                timeout: 15000
            };

            if( deviceType )
                secClientConfig.deviceType = deviceType;

            retval = new Promise( executor );
        }

        return retval;
    };

    X2.prototype.pushOverlay = function( overlay )
    {
        this._overlayRoot.push( overlay );
    };

    X2.prototype.pushScreen = function( screen )
    {
        this._screenRoot.push( screen, (screen instanceof VideoScreen) ? 1 : undefined );
    };

    X2.prototype.requestFocus = function( widget, newScreen )
    {
        var retval;

        if( widget && widget._selectable === true )
        {
            this._lastWidgetFocus = this._focus;            
            if( this._focus )
                this._focus.lostFocus( widget );

            this._focus = widget;
            retval = this._focus.gotFocus( this._lastWidgetFocus, newScreen );
        }

        return retval;
    };

    X2.prototype.popTopOfstack = function()
    {
        var self = this, onConfirm, overlay;

        if( this.popOverlay() === false )
            if( this.popScreen() === false )
            {
                var top = this._screenRoot.getTop();

                if( top instanceof WelcomeScreen === false && top instanceof MainMenuScreen === false && top instanceof NotEntitledScreen === false && top instanceof DeviceNameScreen === false && top instanceof TermsScreen === false && top instanceof ChurnedMainMenuScreen === false )
                {
                    this.setScreen( new MainMenuScreen().init() );
                }
                else if( this._config._host.exitApp )
                {
                    onConfirm = function()
                    {
                        if( _x2.logoutOnExit === true )
                        {
                            _x2._authService.logout();
                            _x2.localyticsLogout( true );
                        }

                        _x2.popOverlay( overlay );
                        self._config._host.exitApp( false );
                    };

                    overlay = new ExitAppOverlay().init( { onEnter:onConfirm } );
                    _x2.pushOverlay( overlay );
                }
            }
    };

    X2.prototype.refreshResumePoints = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var success = function( data )
        {
            _x2._resume = data;
        };

        var fail = function( error )
        {
            console.log( "Resume api fails", error.toString() );
        };

        return _x2._data.getResumePoints(null, cancelOnDemand ).then( success ).catch( fail );
    };
    /**
     * set resume point for media in cache
     */
    X2.prototype.setResumePointInCache = function( mediaId, lastResumePoint)
    {
        var i;

        if( _x2._resume && _x2._resume.length )
        {
            for( i = 0; i < _x2._resume.length; i++ )
            {
                if( mediaId === _x2._resume[i].getMediaId() )
                {
                    _x2._resume[i].setPosition( lastResumePoint );
                    break;
                }
            }
        }
    };

    X2.prototype.refreshFavorites = function()
    {
        var success = function( obj )
        {
            _x2._favorites = obj
        };

        var fail = function( error )
        {
            console.log( error.toString() );
        };

        return _x2._data.getFavorites().then( success ).catch( fail );
    };

    X2.prototype.routeKey = function( val, type )
    {
        var self = this, onConfirm, overlay;

//        if( ! this._keysBlocked )
        {
            var retval = true;  // stop propagation of the key press event

            switch( val )
            {
                case Host.KEY_QUIT_NOW:
                    retval = false;
                    break;

                default:
                    if( this._focus )
                    {
                        if( this._focus.processEvent )
                        {
                            // bubble key press from the widget that has focus through its parents until handled

                            var handled = false;
                            var widget  = this._focus;

                            while( widget != undefined && handled === false )
                            {
                                handled = widget.processEvent( val, type );
                                widget  = widget._parent;
                            }

                            // if key press was not consumed, then execute default handler

                            if( handled === false )
                            {
                                this._config.log( Config.CLASS_X2, 7 ) ? console.log( "Key press not handled by widget in focus, val = " + val ) : Config.NOP();

                                switch( val )
                                {
                                    case Host.KEY_LAST:
                                        if( type === Host.KEY_PRESSED )
                                            this.popTopOfstack();
                                        break;

                                    case Host.KEY_QUIT:
                                        if( type === Host.KEY_PRESSED )
                                            if( this._config._host.exitApp )
                                            {
                                                onConfirm = function()
                                                {
                                                    if( _x2.logoutOnExit === true )
                                                    {
                                                        _x2._authService.logout();
                                                        _x2.localyticsLogout( true );
                                                    }

                                                    _x2.popOverlay( overlay );
                                                    self._config._host.exitApp( true );
                                                };

                                                overlay = new ExitAppOverlay().init( { onEnter:onConfirm } );
                                                _x2.pushOverlay( overlay );
                                            }
                                        break;
                                }
                            }
                        }
                        else
                            console.log( "ERROR -> widget currently in focus does not have a processEvent method" );
                    }
                    else
                        console.log( "ERROR -> no widget currently in focus" );
                    break;
            }

            return retval;
        }
    };

    /**
     * Utility
     * <p>
     * Returns the height specified at 1080 resolution scaled down for other resolutions
     * @memberof X2
     * @param {Number} val
     * @returns {Number}
     */
    X2.prototype.scaleVal = function( val )
    {
        return ( val !== undefined ) ? val * this._config._screenH / 1080 : undefined;
    };

    /**
     * Utility
     * <p>
     * Returns the height specified at 1080 resolution scaled down for other resolutions
     * @memberof X2
     * @param {Number} val
     * @returns {Number}
     */
    X2.prototype.scaleValInt = function( val )
    {
        return ( val !== undefined ) ? parseInt( val * this._config._screenH / 1080 ) : undefined;
    };

    X2.prototype.sessionCreated = function()
    {
        this._config.log( Config.CLASS_X2, 3 ) ? console.log( "X2.sessionCreated: loading services" ) : Config.NOP();

        var self = this, ready, setPc, setCc, onCcError, setResume, setFavorites, onFavoriteError, 
                setVod, onPcError, onResumeError, onVodError, token, summary, entitlements, 
                setDevicesList, onDeviceError;

        setCc = function( cc )
        {
            self._channelCollection = cc;
        };

        onCcError = function( error )
        {
            console.log( "ERROR -> unable to load channel collection" );
            //TODO: log error to telemetry?
            //TODO: retry logic?
        };

        setPc = function( pc )
        {
            self._pc = pc;
        };

        onPcError = function( error )
        {
            console.log( "ERROR -> unable to load parental controls" );
            self._pcError = error;
        };

        setFavorites = function( obj )
        {
            self._favorites = obj;
        };

        onFavoriteError = function( error )
        {
            self._favorites = new Favorites();
            console.log( error.toString() );
        };

        setResume = function( rp )
        {
            _x2._resume = rp;
        };

        onResumeError = function( error )
        {
            console.log(  "Resume api fails", error.toString() );
        };

        setVod = function( root )
        {
            self._vodRoot = root;
        };

        onVodError = function( error )
        {
            console.log( "ERROR -> unable to load VOD" );
            console.log( error );

            self._vodRootError = error;
        };

        setDevicesList = function(response) {
            console.log("Device API loaded");
            _x2._devicesList = new DevicesList(response);
        }

        onDeviceError = function() {
            //NOTE: If the getAllDevicesList query fails, we'll only fail to capture a value for _x2._metricsDeviceInfo. This is only used downstream for logging. Just carry on.
            console.log("Device API fails");
            _x2._devicesList = new DevicesList(null);//we should not block user with name device screen, we should still allow user to login into app.
        }

        ready = function()
        {
            console.log( "Intial api finish loaded in", ( new Date().getTime() - window.contentLoadTime)/ 1000);
            _x2._config._purchases = ( _x2._config._allowPurch === true && _x2._features.getFeature( "transactions" ) === "true" ) ? true : false;
            _x2._config._isSmbUser = _x2._features.getUserType() === "smb";

            if( self._pcError )
            {
                console.log( self._pcError );

                var onDismiss = function()
                {
                    self.sessionCreated();
                };

                _x2.pushOverlay( new ErrorOverlay().init( { error:self._pcError, context:ErrorOverlay.Context.COMMON, onDismiss:onDismiss } ) )
            }
            else if( _x2._showTerms !== true )
            {
                var currentDevice = _x2._devicesList && _x2._devicesList.getCurrentDevice();
                if( currentDevice ) {
                    _x2._metricsDeviceInfo = currentDevice;
                }
                if( _x2._devicesList && _x2._devicesList.isDataLoaded() === true && currentDevice === null ) {
                    console.log("Device is not associated with current user");//Logged to trace the workflow
                    _x2.setScreen( new DeviceNameScreen().init( { hideCancel:true, onChange:function() { _x2.setDefaultScreen(); } } ) );
                }
                else {
                    _x2.setDefaultScreen();
                }

            }
            else
                _x2.setScreen( new TermsScreen().init() );
        };

        // check device is in home and determine entitlements

        token        = Host.getLocalStorage( "XsctToken" );
        token        = token && JSON.parse( token );
        summary      = token.tokenSummary;
        entitlements = summary.entitlements;

        _x2._metricsSocket = new MetricsSocket( token );
        _x2._telemetry     = new Telemetry( token.tokenSummary.inHomeStatus );
        _x2._splunk        = new Splunk( token );

        console.log( "Device Id: " +_x2._metricsSocket._deviceId );
        console.log( "Intial api start loaded in", ( new Date().getTime() - window.contentLoadTime)/ 1000);
        document.querySelector('.initial-loading').style.display = 'none'; //hide initial loading div
        var university = summary.userType === "university" ? summary.partnerId : "None";
        var makeModel  = _x2._config._host._make ? (_x2._config._host._make + " " + _x2._config._host._product) : _x2._config._host._product;
        var userType   = _x2._features.getUserType() === "smb" ? "smb" : summary.userType;
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.LOGGED_IN     , "Yes"                                             ); // Localytics
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.CONNECTION    , X2.LocalyticsInHome      [ summary.inHomeStatus ] );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.UNIVERSITY    , university                                        );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.X1_USER_TYPE  , X2.LocalyticsUserType    [ userType             ] );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.ACCOUNT_STATUS, X2.LocalyticsAccountState[ summary.accountState ] || "None" );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.DEVICE_MODEL  , makeModel                                         );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.APP_VERSION   , AboutOverlay.version                              );

        if( window.ll )
            window.ll( "setCustomerId", summary.analyticsId );

        this._config.log( Config.CLASS_X2, 7 ) ? console.log( summary                             ) : Config.NOP();
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IN HOME = " + summary.inHomeStatus ) : Config.NOP();

        var cdvr, est, clinear, cvod;

        // Features is the primary source of entitlements and session token is the fallback
        if( this._features.isDefined() )
        {
            est     = this._features.hasEntitlement( Features.Entitlement.EST      );
            cdvr    = this._features.hasEntitlement( Features.Entitlement.C_DVR    );
            clinear = this._features.hasEntitlement( Features.Entitlement.C_LINEAR );
            cvod    = this._features.hasEntitlement( Features.Entitlement.C_VOD    );
        }
        else if( entitlements )
        {
            for( var i = 0; i < entitlements.length; i++ )
            {
                switch( entitlements[i] )
                {
                    case "cdvr":
                        cdvr = true;
                        break;
                    case "clinear":
                        clinear = true;
                        break;
                    case "cvod":
                        cvod = true;
                        break;
                    case "est":
                        est = true;
                        break;
                }
            }
        }

        _x2._config._isCdvr    = cdvr;
        _x2._config._isEst     = est;
        _x2._config._isChurned = ( est && !cdvr && !clinear && !cvod );

        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IS CDVR = " + _x2._config._isCdvr ) : Config.NOP();
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IS EST  = " + _x2._config._isEst  ) : Config.NOP();

        // load all services if allowed to proceed
        this._data._getCcPromise = undefined;
        if( _x2._config._isChurned )
        {
            console.log( "SKIPPING IN HOME SINCE CHURNED USER" );

            this._settings = new Settings();

            if( this._settings.getValue( Settings.Key.TERMS ) < Settings.TERMS_VERSION )
            {
                this._showTerms = true;
                this._settings.setValue( Settings.Key.TERMS, Settings.TERMS_VERSION );
            }

            var p = [];
            p.push( this._data.getParentalControls(true).then( setPc ).catch( onPcError ) );
            p.push( this._data.getResumePoints( null, true).then( setResume ).catch( onResumeError ) );
            p.push( this._data.getAllDeviceList(true).then( setDevicesList, onDeviceError ).catch( onDeviceError ) );
            Promise.all(p).then( ready );
        }
        else if( summary.inHomeStatus === "in-home" || this._config._skipInHome === true )
        {
            if( summary.isLinearEntitled && summary.isVODEntitled )
            {
                this._settings = new Settings();

                if( this._settings.getValue( Settings.Key.TERMS ) < Settings.TERMS_VERSION )
                {
                    this._showTerms = true;
                    this._settings.setValue( Settings.Key.TERMS, Settings.TERMS_VERSION );
                }

                var filters = _x2.getBrowseFilterString();

                var p = [];
                p.push( this._data.getParentalControls(true).then( setPc ).catch( onPcError ) );
                p.push( this._data.getResumePoints( null, true).then( setResume ).catch( onResumeError ) );
                p.push( this._data.getFavorites(true).then( setFavorites ).catch( onFavoriteError ) );
                p.push( this._data.getVodRoot(1,0,filters, true).then( setVod ).catch( onVodError ) );
                p.push( this._data.getChannelCollection(true).then( setCc ).catch( onCcError ) );
                p.push( this._data.getAllDeviceList(true).then( setDevicesList, onDeviceError ).catch( onDeviceError ) );
                Promise.all(p).then( ready );
            }
            else
                _x2.setScreen( new NotEntitledScreen().init() );
        }
        else
        {
            _x2._config._isSmbUser = _x2._features.getUserType() === "smb";
            _x2.pushOverlay( new InHomeFailOverlay().init() );
        }
    };

    X2.prototype.sessionNeedsCredentials = function( onAuth, params )  // TODO replace with login screens
    {
        var self = this;

        switch( this._config._authMode )
        {
            case Config.AUTH_CIMA:
                this._authService.sendCredentials( "Hawkins2015", "Comcast2015", onAuth );
                break;

            case Config.AUTH_CISCO_SAML:
                this._authService.sendCredentials( "sean.cox1", "c0xnetpass", onAuth );
                break;

            case Config.AUTH_OAUTH:
            case Config.AUTH_XTV:
                this.setScreen( new WelcomeScreen().init( onAuth, params ) );
                break;

            default:
                console.error( "ERROR -> unknown auth mode = " + self._config._authMode );
                break;
        }
    };

    X2.prototype.setDefaultScreen = function()
    {
        var screen, onEntity;
        var defaultScreen = this._config._initialScreen;

        if( this._tempDefaultScreen )
        {
            defaultScreen = this._tempDefaultScreen;
            this._tempDefaultScreen = undefined;
        }
        switch( defaultScreen )
        {
            case "browse":
                screen = new VodRootScreen().init();
                break;

            case "live":
                screen = new GuideScreen().init();
                break;

            case "mainMenu":
                if( _x2._config._isChurned === true )
                    screen = new ChurnedMainMenuScreen().init();
                else if( (this._config._purchases === true) && this._features.hasEntitlement( Features.Entitlement.EST ) && (_x2._settings.getValue( Settings.Key.PURCHASES ) !== true) )
                    screen = new PurchasesFtueScreen().init();
                else if( _x2._config._smartHubEntityId ) { //for debugging purpose
                    screen = new TransitionScreen().init( { entityId:  _x2._config._smartHubEntityId } ) ;
                } else
                    screen = new MainMenuScreen().init();
                break;

            case "saved":
                screen = new SavedScreen().init();
                break;

            case "search":
                screen = new SearchScreen().init();
                break;

            case "settings":
                screen = new SettingsScreen().init();
                break;

            case "test":
                screen = new TestScreen().init();
                break;

            default:
                _x2.setScreen( new TransitionScreen().init( { entityId:defaultScreen } ) );
                break;
        }

        if( screen )
            this.setScreen( screen );
    };

    X2.prototype.setOverlayRootLastFocus = function( widget )
    {
        this._overlayRoot._children[0]._lastFocus = widget;
    };

    X2.prototype.setScreen = function( screen )
    {
        console.log( screen._className, " loaded in " , (new Date().getTime() - window.contentLoadTime)/1000, " secs");
        this._overlayRoot.clear();
        this._screenRoot.set( screen );
    };

    /**
     * Check if the entity should be locked by PC and callback when validated (not PC'd or correct PIN entered)
     * @param entity
     * @return {Promise}
     */
    X2.prototype.checkParentalControls = function( showing, entity, channel, silent, speechStr )
    {
        var resolver = function( resolve )
        {
            var series, id, rating;

            if( showing )
            {
                id     = showing.getEntityId();
                rating = showing.getRating ? showing.getRating() : showing.getProgram().getRating();
            }

            var locked = _x2._pc.isRatingLocked( rating );

            if( ! locked )
                locked = _x2._pc.isTitleLocked( id );

            if( ! locked )
            {
                if( entity && entity.getSeries )
                {
                    series = entity.getSeries();
                    if( series )
                        locked = _x2._pc.isTitleLocked( series.getEntityId() );
                }
            }

            if( !locked && channel )
                locked = _x2._pc.isChannelLocked( channel.getId() );

            if( locked )
            {
                if( silent != true )
                {
                    var overlay, newOverlay, params = {};

                    var onValidatePin = function( validatePinStr )
                    {
                        if( _x2._pc.checkPin( validatePinStr ) === true )
                        {
                            _x2.popOverlay( overlay, resolve );
                        }
                        else
                        {
                            params.type      = PinOverlay.Type.PC_VALIDATE_FAIL;
                            params.speechStr = undefined;
                            _x2.pushOverlay( newOverlay = new PinOverlay().init( params ) );
                            _x2.popOverlay( overlay );
                            overlay = newOverlay;
                        }
                    };

                    params.type      = PinOverlay.Type.PC_VALIDATE;
                    params.onCapture = onValidatePin;
                    params.speechStr = speechStr;
                    _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                }
                else
                    resolve( true );
            }
            else
                resolve( false );
        };

        return new Promise( resolver );
    };

    /*
    *It will save last 10 key press or key down event in the array.
    *It will run only in tizen or webOS simulator.
    *If keyup is triggered before the key down event, then we will trigger the key down event manually */
    X2.prototype.pushIntoKeyEventHistory = function( event ) {
        var prevKeyEvent = this.keyEventHistory[0];//take previous key event, before insert
        if( this.keyEventHistory.length > 9 ) {
            this.keyEventHistory.pop();//Remove the last element
        }
        this.keyEventHistory.unshift({ 'keyEvent': event.actualEventType || event.type, 
        'keyCode': event.keyCode,
        'parentKeyType': event.parentType });
        if( !event.parentType && ( !prevKeyEvent ||
            ( event.type == 'keyup' && (prevKeyEvent.keyEvent == 'keyup' || prevKeyEvent.parentKeyType == 'keyup') ) )) {
                event.actualEventType = 'keydown';
                event.parentType = 'keyup';
                this.onKeyDown( event );
            }//if there is no key pressed and only key released event, then we need to triggered key_pressed event.
    }
    //it indicate whether cursor appear on TV or not
    X2.prototype.cursorVisibilityChange = function(event) {
        var visibility = event.detail.visibility;
        if( visibility ){
            console.log("Cursor appeared");
            _x2._config._cursorEnabled = true;
            _x2.enableAllClickEvents();
        }
        else{
            console.log("Cursor disappeared");
            _x2._config._cursorEnabled = false;
            _x2.disableAllClickEvents();
        }
      }

      X2.prototype.enableAllClickEvents = function() {
        var allElements = document.querySelectorAll('.customClickEvent') || [];
        allElements.forEach( function(element) {
            if( element.id.indexOf('OverlayRoot') > -1 ) {
                element.style.pointerEvents = 'none';
            }
            if( element.customClickEvent) {
                element.addEventListener('mousedown', element.customClickEvent);
            }
        });
      }

      X2.prototype.disableAllClickEvents = function() {
        var allElements = document.querySelectorAll('.customClickEvent') || [];
        allElements.forEach( function(element) {
            if( element.id.indexOf('OverlayRoot') > -1 ) {
                element.style.pointerEvents = 'auto';
            }
            if( element.customClickEvent ) {
                element.removeEventListener('mousedown', element.customClickEvent);
            }
        });
      }

    return X2;

})();


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.Overlay = ( function()
{
    "use strict";

    Overlay.prototype = new Widget();

    function Overlay(){}

    /**
     * Initializer
     * @memberof Overlay
     * @param   {Object}    params
     * @param   {Boolean}  [params.hideExitStr]
     * @param   {Function} [params.onDismiss] - Optional callback that will be called when the overlay is dismissed
     * @returns {Overlay}
     */
    Overlay.prototype.init = function( params )
    {
        var self      = this, insetX, insetY;
        var backStyle = new Style( { font:"medium" , color:"#8c8c8c", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );

        if( params )
            this._onDismiss = params.onDismiss;

        Widget.prototype.init.call( this );
        this._className    = "Overlay";
        this._selectable   = true;
        this._suppressBack = !!(params && params.hideExitStr);

        insetX = _x2.scaleValInt( 170 );
        insetY = _x2.scaleValInt( 155 );

        this._bg = new RectWidget().init( { w:_x2._config._screenW - 2 * insetX, h:_x2._config._screenH - 2 * insetY, color:"#000000" } );
        this.addWidget( this._bg, insetX, insetY );

        this._backStr = new StringWidget().init( { text:"Press [Back] to exit", style:backStyle } );
        this._backStr.addReadyCallback( function() { self._backStr.setX( self._bg.getW() - self._backStr.getW() - _x2.scaleValInt(34) ); } );
        this._bg.addWidget( this._backStr, 0, _x2.scaleValInt(34) );

        if( this._suppressBack )
            this._backStr.setA( 0 );

        this._speakTarget = new StringWidget().init( { style:backStyle } );
        this._speakTarget.setA( 0 );
        this._bg.addWidget( this._speakTarget );

        this.setW( _x2._config._screenW );
        this.setH( _x2._config._screenH );
        this.setMouseDownListener( function() {  _x2.popOverlay( self, self._onDismiss ); } );

        return this;
    };

    Overlay.prototype.processEvent = function( val, type )
    {
        if( (val === Host.KEY_LAST || val === Host.KEY_ENTER) && type === Host.KEY_PRESSED && this.getA() > 0 )
            if( this._suppressBack === false )
                _x2.popOverlay( this, this._onDismiss );

        return true;
    };

    Overlay.prototype.setBgSize = function( w, h )
    {
        this._bg.setW( w );
        this._bg.setH( h );
        this._bg.setX( (this.getW() - w)/2 );
        this._bg.setY( (this.getH() - h)/2 );
        this._backStr.setX( this._bg.getW() - this._backStr.getW() - _x2.scaleValInt(34) );
    };

    return Overlay;

})();


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.AboutOverlay = ( function()
{
    "use strict";

    AboutOverlay.prototype = new Overlay();
    AboutOverlay.version   = environment.version;

    function AboutOverlay(){}

    AboutOverlay.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();

        this._speakTarget.setText( this._version.getText() + ". " + this._made.getText().replace( Strings.Glyphs.HEART, "love" ) );
        this._speakTarget.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    AboutOverlay.prototype.init = function()
    {
        var self         = this, layout;
        var versionStyle = new Style( { font:"regular" , color:"#a3a3a3", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );
        var madeStyle    = new Style( { font:"regular" , color:"#757575", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );

        Overlay.prototype.init.call( this );
        this._className  = "AboutOverlay";

        layout = function()
        {
            var vGap = _x2.scaleValInt( 18 );
            var y    = ( self._bg.getH() - self._version.getH() - vGap - self._made.getH() - vGap - self._deviceId.getH() ) / 2;
            var dy   = self._version.getH() + vGap;
            self._version.setY( y );
            self._deviceId.setY( y + dy );
            self._made.setY( y + 2*dy );
        };

        this._version = new StringWidget().init( { text:"Version: " + AboutOverlay.version, style:versionStyle } );
        this._version.setW( this._bg.getW() );
        this._bg.addWidget( this._version );

        this._deviceId = new StringWidget().init( { text:"Device Id: <b>" + (_x2._metricsSocket && _x2._metricsSocket._deviceId ? _x2._metricsSocket._deviceId : "Unknown") + "</b>", style:madeStyle } );
        this._deviceId.setW( this._bg.getW() );
        this._bg.addWidget( this._deviceId );

        this._made = new StringWidget().init( { text:"Made with <font color='#c90318'>" + Strings.Glyphs.HEART + "</font> in Philadelphia", style:madeStyle } );
        this._made.setW( this._bg.getW() );
        this._made.addReadyCallback( layout );
        this._bg.addWidget( this._made );

        return this;
    };

    return AboutOverlay;

})();


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DeleteConfirmOverlay = ( function()
{
    "use strict";

    DeleteConfirmOverlay.prototype = new Overlay();

    function DeleteConfirmOverlay(){}

    DeleteConfirmOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons, true );
        this._speakTarget.setText( this._title.getText() + ". " + this._body.getText() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press right or left to review options. Press back to dismiss.", focus._speakRole, this, false );
    };

    /**
     * Init
     * @param params
     * @param params.title   {string}
     * @param params.message {string}
     * @param params.confirm {function}
     * @param params.cancel  {function}
     * @return {DeleteConfirmOverlay}
     */
    DeleteConfirmOverlay.prototype.init = function(params)
    {
        Overlay.prototype.init.call( this );
        this._className  = "DeleteConfirmOverlay";

        var self        = this, confirm, cancel;
        var titleStyle  = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap", textAlign:"center" } );
        var bodyStyle   = new Style( { font:"light"  , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), textAlign:"center"  } );
        var buttonStyle = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var w           = this._bg.getW();
        var inset       = _x2.scaleValInt( 80 );
        var buttons     = [];

        confirm = function()
        {
            self._buttons.setDisabled( true );

            if( params.confirm )
                params.confirm( self );
        };

        cancel = function()
        {
            _x2.popOverlay( self );
        };

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.setW( this._bg.getW() );
        this._bg.addWidget( this._title );

        this._body = new TextBlockWidget().init( { text:params.message, style:bodyStyle, w:w - 2 * inset } );
        this._bg.addWidget( this._body, inset );

        buttons.push( new StringWidget().init( { text:"Yes", style:buttonStyle, onEnter:confirm } ) );
        buttons.push( new StringWidget().init( { text:"No", style:buttonStyle, onEnter:cancel } ) );

        this._buttons = new HorizPillButtonsWidget().init( {entries:buttons, spacing:_x2.scaleValInt(41)});
        this._buttons.addReadyCallback(function() { self.layout(); } );
        this._bg.addWidget( this._buttons );

        return this;
    };

    DeleteConfirmOverlay.prototype.layout = function()
    {
        var totalH      = this._title.getH() + this._body.getH() + this._buttons.getH();
        var vGapBody    = _x2.scaleValInt( 40 );
        var vGapButtons = _x2.scaleValInt( 50 );
        var y           = (this._bg.getH() - totalH - vGapBody - vGapButtons) / 2;

        this._title.setY( y );
        y += this._title.getH() + vGapBody;
        this._body.setY( y );
        y += this._body.getH() + vGapButtons;
        this._buttons.setY( y );

        this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
    };

    return DeleteConfirmOverlay;

})();


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.AlertOverlay = ( function()
{
    "use strict";

    AlertOverlay.prototype = new Overlay();

    function AlertOverlay(){}

    AlertOverlay.prototype.gotFocus = function()
    {
        this._speakTarget.setText( this._title.getText() + ". " + this._body.getText() );
        this._speakTarget.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    /**
     * Initializer
     * @memberof AlertOverlay
     * @param   {Object}        params
     * @param   {String}        params.message - Message
     * @param   {String}        params.title   - Title
     * @returns {AlertOverlay}
     */
    AlertOverlay.prototype.init = function( params )
    {
        var self        = this;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), textAlign:"center", whiteSpace:"nowrap" } );
        var bodyStyle   = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), textAlign:"center"                      } );
        var onReady     = function() { self._numLoaded++; self.layoutAlertOverlay(); };

        Overlay.prototype.init.call( this, params );
        this._className  = "AlertOverlay";

        var hPad = Math.floor( this._bg.getW() / 10 );

        this._numLoaded = 0;

        this._title = new StringWidget().init( { text:params.title, style:titleStyle } );
        this._title.setW( this._bg.getW() );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title, 0, _x2.scaleVal( 243 ) );

        this._body = new TextBlockWidget().init( { text:params.message, style:bodyStyle, w:this._bg.getW() - 2 * hPad } );
        this._body.addReadyCallback( onReady );
        this._bg.addWidget( this._body, hPad );

        return this;
    };

    AlertOverlay.prototype.layoutAlertOverlay = function()
    {
        if( this._numLoaded === 2 )
        {
            var hPad = _x2.scaleVal( 40 );

            this._title.setY( (this._bg.getH() - this._title.getH() - hPad - this._body.getH()) / 2 );
            this._body.setY( this._title.getY() + this._title.getH() + hPad );
        }
    };

    return AlertOverlay;

})();


/***/ }),
/* 156 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DeleteDownloadsOverlay = ( function()
{
    "use strict";

    DeleteDownloadsOverlay.prototype = new Overlay();

    function DeleteDownloadsOverlay(){}

    DeleteDownloadsOverlay.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._buttons );
    };

    /**
     * Initializer
     * @memberof DeleteDownloadsOverlay
     * @param   {Object}   params
     * @param   {Function} params.onEnter - Function called when remove is selected
     * @returns {DeleteDownloadsOverlay}
     */
    DeleteDownloadsOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className = "DeleteDownloadsOverlay";
        this._numReady  = 0;

        var self        = this, onReady, reset, cancel;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle   = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var w           = this._bg.getW();
        var title       = "Are you sure?";
        var desc        = "All downloaded content will be removed from this device.";

        onReady = function() { self._numReady++; self.layoutDeleteDownloadsOverlay() };
        reset   = new StringWidget().init( { text:"Yes, remove", style:buttonStyle, onEnter:params.onEnter   } );
        cancel  = new StringWidget().init( { text:"Cancel" , style:buttonStyle, onEnter:function() { _x2.popOverlay(); } } );

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w/2 } );
        this._bg.addWidget( this._desc, w/4 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[cancel,reset], spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( onReady );
        this._bg.addWidget( this._buttons );

        return this;
    };

    DeleteDownloadsOverlay.prototype.layoutDeleteDownloadsOverlay = function()
    {
        if( this._numReady === 2 )
        {
            var titleH   = this._title.getH();
            var descH    = this._desc.getH();
            var buttonsH = this._buttons.getH();
            var offset   = (this._bg.getH() - titleH - descH - buttonsH - 7 * Style._pad) / 2;

            this._title.setY ( offset );
            this._desc.setY( this._title.getY() + titleH + 3 * Style._pad );
            this._buttons.setY( this._desc.getY() + descH + 4 * Style._pad );
            this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
        }
    };

    return DeleteDownloadsOverlay;

})();


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DepreciationNoticeOverlay = (function () {
    "use strict";

    DepreciationNoticeOverlay.prototype = new Overlay();

    function DepreciationNoticeOverlay() { }

    DepreciationNoticeOverlay.prototype.gotFocus = function () {
        var focus = _x2.requestFocus(this._buttons, true);
        var str = this._title.getText();

        this._speakTarget.setText(str + ". " + focus._speakStr + ". ");
        this._speakTarget.setSpeechParams("Press OK to dismiss.", focus._speakRole, this, false);
    };

    DepreciationNoticeOverlay.prototype.init = function (params) {
        var accept;
        var self = this;
        params = params || {};
        if (params.onClosed) {
            this.onClosed = params.onClosed;
        }
        var titleStyle = new Style({ font: "light", color: "#e8e8e8", fontSize: _x2.scaleValInt(48), textAlign: "center" });
        var buttonStyle = new Style({ font: "regular", color: "#e8e8e8", fontSize: _x2.scaleValInt(32), whiteSpace: "nowrap", colorHi: "#000000" });

        Overlay.prototype.init.call(this, { onDismiss: this.onClosed });
        this._className = "DepreciationNoticeOverlay";

        this._title = new StringWidget().init({
            text: "Soon Xfinity Stream will no longer be available on this TV.\n Learn more at xfin.tv/streamontv",
            style: titleStyle
        });
        this._title.setW(this._bg.getW());
        this._bg.addWidget(this._title, 0, _x2.scaleVal(243));
        accept = new StringWidget().init({ text: "OK", style: buttonStyle, onEnter: self.dismiss.bind(self) });

        this._buttons = new HorizPillButtonsWidget().init({ entries: [accept], spacing: _x2.scaleValInt(40) });
        this._buttons.addReadyCallback(function () { self.layoutDepreciationNoticeOverlay(); });
        this._bg.addWidget(this._buttons);

        return this;
    };
    DepreciationNoticeOverlay.prototype.dismiss = function () {
        _x2.popOverlay(this);
        if (this.onClosed)
            this.onClosed()
    };
    DepreciationNoticeOverlay.prototype.layoutDepreciationNoticeOverlay = function () {
        var gap = _x2.scaleVal(50);
        var h = this._title.getH() + gap + this._buttons.getH();
        var y = (this._bg.getH() - h) / 2;

        this._title.setY(y);
        this._buttons.setY(y + this._title.getH() + gap);
        this._buttons.setX((this._bg.getW() - this._buttons.getW()) / 2);
    };

    return DepreciationNoticeOverlay;

})();


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DistractorOverlay = (function()
{
    "use strict";

    DistractorOverlay.prototype = new Overlay();

    function DistractorOverlay(){}

    DistractorOverlay.prototype.init = function()
    {
        Overlay.prototype.init.call( this, { hideExitStr:true } );
        this._className = "DistractorOverlay";

        var self = this;

        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function()
        {
            self._distractor.centerOnWidget( self._bg );
            self._distractor.show();
        } );

        this._bg.addWidget( this._distractor );

        return this;
    };

    return DistractorOverlay;

})();


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ExitAppOverlay = ( function()
{
    "use strict";

    ExitAppOverlay.prototype = new Overlay();

    function ExitAppOverlay(){}

    ExitAppOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons );
        this._speakTarget.setText( this._title.getText() + ". " + this._desc.getText() + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to review items. Press OK to select.", focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof ExitAppOverlay
     * @param   {Object}    params
     * @param   {Function} [params.onEnter] - Function called when reset is selected
     * @returns {ExitAppOverlay}
     */

    ExitAppOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init. call( this );
        this._className  = "ExitAppOverlay";

        var self        = this, onReady, reset, cancel;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle   = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var w           = this._bg.getW();
        var title       = "Exit Application";
        var desc        = "Do you really want to exit the application?";

        this._numReady = 0;

        onReady = function() { self._numReady++; self.layoutExitAppOverlay() };
        reset   = new StringWidget().init( { text:"Confirm", style:buttonStyle, onEnter:params.onEnter   } );
        cancel  = new StringWidget().init( { text:"Cancel" , style:buttonStyle, onEnter:function() { _x2.logoutOnExit = false; _x2.popOverlay(); } } );

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w/2 } );
        this._bg.addWidget( this._desc, w/4 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[reset,cancel], spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( onReady );
        this._bg.addWidget( this._buttons );

        return this;
    };

    ExitAppOverlay.prototype.layoutExitAppOverlay = function()
    {
        if( this._numReady === 2 )
        {
            var y0     = 0;
            var y1     = y0 + this._title.getH();
            var y2     = y1 + ((this._desc === undefined) ? 0 : this._desc.getH());
            var offset = (this._bg.getH() - y2 - _x2.scaleValInt( 24 ) - this._buttons.getH()) / 2;

            this._title.setY ( y0 + offset );

            if( this._desc !== undefined )
                this._desc.setY( y1 + offset );

            this._buttons.setY( y2 + offset + _x2.scaleValInt( 24 ) );
            this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
        }
    };

    return ExitAppOverlay;

})();


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ErrorOverlay = ( function()
{
    "use strict";

    ErrorOverlay.prototype = new Overlay();

    function ErrorOverlay(){}

    /**
     * Initializer
     * @memberof ErrorOverlay
     * @param   {Object} params
     * @param   {ApiError} [params.error]  - Error object that triggered the error.
     * @param   {string}   [params.reason] - Display string instead of error object
     * @param   {string}   [params.context] - Where this error originated
     * @returns {ErrorOverlay}
     */

    ErrorOverlay.Context = {
        COMMON        : 'common',
        LINEAR        : 'linear',
        DVR           : 'dvr',
        VOD           : 'vod',
        GUIDE         : 'guide',
        BROWSE_SEARCH : 'browse_search',
        ENTITY        : 'entity',
        SAVED         : 'saved',
        TRANSACT      : 'transact'
    };

    /* Three dimensions to the error: (1) where you are in the app (context), (2) what API was called and (3) http response from that call.
       There are three error formats that we need to map:
       (1) flash major.minor       i.e. '3329.501'
       (2) api.http_response       i.e. 'updateResumePoint.503'
       (3) xtvapi status.subStatus i.e. '403.111'
       Mappings base on classes of errors defined here:
       * https://etwiki.sys.comcast.net/display/AAE/Error+Format
       Player Platform Errors documented here:
       * http://release.player.xcal.tv/js/latest/docs/#/errors

       The first mapped value is the error code, that second is the mapping for the error messages.
    */
    ErrorOverlay.errorMatrix = Object.freeze({
        'common' : {
            'DEFAULT'                              :  100,
            '3329.401'                             : [107, 'ERR_19'],
            '3329.500'                             : [102, 'ERR_19'],
            '3329.501'                             : [103, 'ERR_19'],
            '3329.502'                             : [104, 'ERR_19'],
            '3329.503'                             : [105, 'ERR_19'],
            '3329.504'                             : [106, 'ERR_19'],
            '3329.12005'                           : [108, 'ERR_14'],
            '3329.12007'                           : [101, 'ERR_15'],
            '412.401'                              : [107, 'ERR_19'],
            '412.500'                              : [102, 'ERR_19'],
            '412.501'                              : [103, 'ERR_19'],
            '412.502'                              : [104, 'ERR_19'],
            '412.503'                              : [105, 'ERR_19'],
            '412.504'                              : [106, 'ERR_19'],
            '412.12005'                            : [108, 'ERR_14'],
            '412.12007'                            : [101, 'ERR_15'],
            '401.101'                              :  120,
            '403.108'                              :  111,
            '403.112'                              :  110,
            '403.203'                              :  113,
            'createDrmSession.500'                 :  113,
            'createDrmSession.503'                 :  113,
            'provisionAndCreateSession.500'        :  114,
            'acceptTOS.500'                        :  118,
            'inHomeCheck.503'                      :  119,
            'getSamlToken.404'                     :  121,
            'acceptTOS.503'                        :  122,
            'getResumePoints.503'                  :  123,
            'getDeviceList.503'                    :  130,
            'getDeviceList.500'                    :  130,
            'getAllDevicesList.503'                :  131,
            'deleteDevice.500'                     :  132,
            'deleteDevice.503'                     :  132,
            'getParentalControlsNetworkMap.500'    : [135, 'ERR_6'],
            'getParentalControlsNetworkMap.503'    : [135, 'ERR_6'],
            'getParentalControls2Settings.500'     : [136, 'ERR_6'],
            'getParentalControls2Settings.503'     : [136, 'ERR_6'],
            'getParentalControls2Descriptions.503' : [137, 'ERR_6'],
            'updateParentalControls2Settings.500'  : [138, 'ERR_5'],
            'updateParentalControls2Settings.503'  : [138, 'ERR_5']
        },
        'linear' : {
            'DEFAULT'                          : [200, 'ERR_19'],
            '3329.12011'                       : [202, 'ERR_18'],
            '3329.12012'                       : [203, 'ERR_16'],
            '3329.12017'                       : [204, 'ERR_17'],
            '3329.12400'                       : [205, 'ERR_19'],
            '3329.12000'                       : [209, 'ERR_19'],
            '412.12011'                        : [202, 'ERR_18'],
            '412.12012'                        : [203, 'ERR_16'],
            '412.12017'                        : [204, 'ERR_17'],
            '412.12400'                        : [205, 'ERR_19'],
            '412.12000'                        : [209, 'ERR_19'],
            // Player Platform Errors
            '1.0'                              : [206, 'ERR_19'],
            '1.1'                              : [206, 'ERR_19'],
            '1.2'                              : [206, 'ERR_19'],
            '1.4'                              : [206, 'ERR_19'],
            '1.5'                              : [206, 'ERR_19'],
            '1.6'                              : [206, 'ERR_19'],
            '1.7'                              : [206, 'ERR_19'],
            '1.8'                              : [206, 'ERR_19'],
            '1.9'                              : [206, 'ERR_19'],
            '2.1'                              : [259, 'ERR_19'],
            '3.2'                              : [270, 'ERR_19'],
            '3.3'                              : [270, 'ERR_19'],
            '3.6'                              : [270, 'ERR_19'],
            '3.8'                              : [270, 'ERR_19'],
            '4.0'                              : [271, 'ERR_19'],
            '5.0'                              : [272, 'ERR_19'],
            '6.1'                              : [273, 'ERR_19'],
            '6.2'                              : [273, 'ERR_19'],
            '6.3'                              : [273, 'ERR_19'],
            '6.4'                              : [273, 'ERR_19'],
            '6.5'                              : [273, 'ERR_19'],
            '8.1'                              : [275, 'ERR_19'],
            '9.1'                              : [276, 'ERR_19'],
            '9.2'                              : [276, 'ERR_19'],
            '10.1'                             : [277, 'ERR_19'],
            '10.2'                             : [277, 'ERR_19'],
            '10.3'                             : [277, 'ERR_19'],
            '10.4'                             : [277, 'ERR_19'],
            '10.5'                             : [277, 'ERR_19'],
            '10.6'                             : [277, 'ERR_19'],
            '11.0'                             : [278, 'ERR_19'],
            '11.1'                             : [278, 'ERR_19'],
            '11.2'                             : [278, 'ERR_19'],
            '11.3'                             : [278, 'ERR_19'],
            '11.4'                             : [278, 'ERR_19'],
            '11.5'                             : [278, 'ERR_19'],
            '11.6'                             : [278, 'ERR_19'],
            '11.7'                             : [278, 'ERR_19'],
            '11.8'                             : [278, 'ERR_19'],
            '11.9'                             : [278, 'ERR_19'],
            '12.0'                             : [279, 'ERR_19'],
            '12.1'                             : [278, 'ERR_19'],
            '14.0'                             : [281, 'ERR_19'],
            '14.1'                             : [281, 'ERR_19'],
            '14.2'                             : [281, 'ERR_19'],
            '14.3'                             : [281, 'ERR_19'],
            '15.0'                             : [282, 'ERR_19'],

            'tveLinearStreamHeartbeat.503'     : [212, 'ERR_18'],
            'linearStreamHeartbeat.503'        : [213, 'ERR_18'],
            'stopWatchingLinearStreamTve.503'  : [214, 'ERR_19'],
            'stopWatchingLinearStream.503'     : [215, 'ERR_19'],
            'stopWatchingLinearStream.400'     : [215, 'ERR_19'],
            'startExternalTveLinearStream.500' : [216, 'ERR_19'],
            'startExternalTveLinearStream.403' : [217, 'ERR_16'],
            'linearStreamHeartbeat.403'        : [220, 'ERR_18'],
            'updateResumePoint.503'            : [221, 'ERR_19'],
            'getResumePoints.500'              : [222, 'ERR_19']
        },
        'dvr' : {
            'DEFAULT'                  :  300,
            '3329.12001'               : [301, 'ERR_19'],
            '3329.12002'               : [302, 'ERR_19'],
            '3329.12003'               : [303, 'ERR_19'],
            '3329.12004'               : [304, 'ERR_19'],
            '3329.12009'               : [305, 'ERR_19'],
            '3329.12000'               : [309, 'ERR_19'],
            '3329.12010'               : [310, 'ERR_13'],
            '412.12001'                : [301, 'ERR_19'],
            '412.12002'                : [302, 'ERR_19'],
            '412.12003'                : [303, 'ERR_19'],
            '412.12004'                : [304, 'ERR_19'],
            '412.12009'                : [305, 'ERR_19'],
            '412.12000'                : [309, 'ERR_19'],
            '412.12010'                : [310, 'ERR_13'],
            // Player Platform Errors
            '1.0'                      : [306, 'ERR_19'],
            '1.1'                      : [306, 'ERR_19'],
            '1.2'                      : [306, 'ERR_19'],
            '1.4'                      : [306, 'ERR_19'],
            '1.5'                      : [306, 'ERR_19'],
            '1.6'                      : [306, 'ERR_19'],
            '1.7'                      : [306, 'ERR_19'],
            '1.8'                      : [306, 'ERR_19'],
            '1.9'                      : [306, 'ERR_19'],
            '2.1'                      : [359, 'ERR_19'],
            '3.2'                      : [370, 'ERR_19'],
            '3.3'                      : [370, 'ERR_19'],
            '3.6'                      : [370, 'ERR_19'],
            '3.8'                      : [370, 'ERR_19'],
            '3.9'                      : [370, 'ERR_19'],
            '4.0'                      : [371, 'ERR_19'],
            '5.0'                      : [372, 'ERR_19'],
            '6.1'                      : [373, 'ERR_19'],
            '6.2'                      : [373, 'ERR_19'],
            '6.3'                      : [373, 'ERR_19'],
            '6.4'                      : [373, 'ERR_19'],
            '6.5'                      : [373, 'ERR_19'],
            '8.1'                      : [375, 'ERR_19'],
            '9.1'                      : [376, 'ERR_19'],
            '9.2'                      : [376, 'ERR_19'],
            '10.1'                     : [377, 'ERR_19'],
            '10.2'                     : [377, 'ERR_19'],
            '10.3'                     : [377, 'ERR_19'],
            '10.4'                     : [377, 'ERR_19'],
            '10.5'                     : [377, 'ERR_19'],
            '10.6'                     : [377, 'ERR_19'],
            '11.0'                     : [378, 'ERR_19'],
            '11.1'                     : [378, 'ERR_19'],
            '11.2'                     : [378, 'ERR_19'],
            '11.3'                     : [378, 'ERR_19'],
            '11.4'                     : [378, 'ERR_19'],
            '11.5'                     : [378, 'ERR_19'],
            '11.6'                     : [378, 'ERR_19'],
            '11.7'                     : [378, 'ERR_19'],
            '11.8'                     : [378, 'ERR_19'],
            '11.9'                     : [378, 'ERR_19'],
            '12.0'                     : [379, 'ERR_19'],
            '12.1'                     : [379, 'ERR_19'],
            '14.0'                     : [381, 'ERR_19'],
            '14.1'                     : [381, 'ERR_19'],
            '14.2'                     : [381, 'ERR_19'],
            '14.3'                     : [381, 'ERR_19'],
            '15.0'                     : [382, 'ERR_19'],

            'recordingHeartbeat.503'   : [313, 'ERR_19'],
            'stopWatchingRecording.503': [315, 'ERR_19'],
            'stopWatchingRecording.403': [316, 'ERR_19'],
            'updateResumePoint.503'    : [321, 'ERR_19'],
            'getResumePoints.500'      : [322, 'ERR_19']
        },
        'vod' : {
            'DEFAULT'                       :  400,
            '3329.12013'                    : [401, 'ERR_16'],
            '3329.12002'                    : [402, 'ERR_19'],
            '3329.12014'                    : [403, 'ERR_19'],
            '3329.12015'                    : [404, 'ERR_19'],
            '3329.12016'                    : [405, 'ERR_14'],
            '3329.12000'                    : [409, 'ERR_19'],
            '3329.12010'                    : [410, 'ERR_13'],
            '412.12013'                     : [401, 'ERR_16'],
            '412.12002'                     : [402, 'ERR_19'],
            '412.12014'                     : [403, 'ERR_19'],
            '412.12015'                     : [404, 'ERR_19'],
            '412.12016'                     : [405, 'ERR_14'],
            '412.12000'                     : [409, 'ERR_19'],
            '412.12010'                     : [410, 'ERR_13'],
            '403.102'                       : [420, 'ERR_19'],
            // Player Platform Errors
            '1.0'                           : [406, 'ERR_19'],
            '1.1'                           : [406, 'ERR_19'],
            '1.2'                           : [406, 'ERR_19'],
            '1.4'                           : [406, 'ERR_19'],
            '1.5'                           : [406, 'ERR_19'],
            '1.6'                           : [406, 'ERR_19'],
            '1.7'                           : [406, 'ERR_19'],
            '1.8'                           : [406, 'ERR_19'],
            '1.9'                           : [406, 'ERR_19'],
            '2.1'                           : [459, 'ERR_19'],
            '3.2'                           : [470, 'ERR_19'],
            '3.3'                           : [470, 'ERR_19'],
            '3.6'                           : [470, 'ERR_19'],
            '3.8'                           : [470, 'ERR_19'],
            '3.9'                           : [470, 'ERR_19'],
            '4.0'                           : [471, 'ERR_19'],
            '5.0'                           : [472, 'ERR_19'],
            '6.1'                           : [473, 'ERR_19'],
            '6.2'                           : [473, 'ERR_19'],
            '6.3'                           : [473, 'ERR_19'],
            '6.4'                           : [473, 'ERR_19'],
            '6.5'                           : [473, 'ERR_19'],
            '8.1'                           : [475, 'ERR_19'],
            '9.1'                           : [476, 'ERR_19'],
            '9.2'                           : [476, 'ERR_19'],
            '10.1'                          : [477, 'ERR_19'],
            '10.2'                          : [477, 'ERR_19'],
            '10.3'                          : [477, 'ERR_19'],
            '10.4'                          : [477, 'ERR_19'],
            '10.5'                          : [477, 'ERR_19'],
            '10.6'                          : [477, 'ERR_19'],
            '11.0'                          : [478, 'ERR_19'],
            '11.1'                          : [478, 'ERR_19'],
            '11.2'                          : [478, 'ERR_19'],
            '11.3'                          : [478, 'ERR_19'],
            '11.4'                          : [478, 'ERR_19'],
            '11.5'                          : [478, 'ERR_19'],
            '11.6'                          : [478, 'ERR_19'],
            '11.7'                          : [478, 'ERR_19'],
            '11.8'                          : [478, 'ERR_19'],
            '11.9'                          : [478, 'ERR_19'],
            '12.0'                          : [479, 'ERR_19'],
            '12.1'                          : [479, 'ERR_19'],
            '14.0'                          : [481, 'ERR_19'],
            '14.1'                          : [481, 'ERR_19'],
            '14.2'                          : [481, 'ERR_19'],
            '14.3'                          : [481, 'ERR_19'],
            '15.0'                          : [482, 'ERR_19'],

            'tveVodStreamHeartbeat.503'     : [412, 'ERR_19'],
            'vodStreamHeartbeat.503'        : [413, 'ERR_18'],
            'stopWatchingTveVod.503'        : [414, 'ERR_19'],
            'stopWatchingVod.503'           : [415, 'ERR_19'],
            'startExternalTveVodStream.403' :  416,
            'vodStreamHeartbeat.403'        : [417, 'ERR_19'],
            'finishWatchingTveVod.503'      : [418, 'ERR_19'],
            'finishWatchingVod.503'         : [419, 'ERR_19'],
            'updateResumePoint.503'         : [421, 'ERR_19'],
            'getResumePoints.500'           : [422, 'ERR_19']
        },
        'guide' : {
            'DEFAULT'                :  500,
            'getTvGridChunk.503'     : [501, 'ERR_11'],
            'getTvGridChunk.500'     : [501, 'ERR_11'],
            'getTvGridChunk.400'     : [501, 'ERR_11'],
            'getChannelMap.503'      : [502, 'ERR_3'],
            'getChannelMap.500'      : [502, 'ERR_3'],
            'getTvListingDetail.503' : [503, 'ERR_19'],
            'getTvListingDetail.404' : [503, 'ERR_19'],
            'getTvListingDetail.500' : [503, 'ERR_19']
        },
        'browse_search' : {
            'DEFAULT'               :  600,
            'browseNode.503'        : [601, 'ERR_2'],
            'browseNode.404'        : [601, 'ERR_2'],
            'browseNode.500'        : [601, 'ERR_2'],
            'browseNode.400'        : [601, 'ERR_2'],
            'searchByTerm.500'      : [602, 'ERR_12'],
            'searchByTerm.503'      : [602, 'ERR_12'],
            'searchByEntity.500'    :  603,
            'searchByEntity.503'    :  603,
            'browseVodTvSeries.500' :  606,
            'browseVodTvSeries.503' :  606,
            'browseNodeByAlias.503' : [607, 'ERR_2'],
            'browseNodeByAlias.400' : [607, 'ERR_2'],
            'browseNodeByAlias.404' : [607, 'ERR_2'],
            'browseProgramMenu.404' : [608, 'ERR_2'],
            'browseProgramMenu.500' : [608, 'ERR_2'],
            'browseProgramMenu.503' : [608, 'ERR_2'],
            'getBrowseRoot.503'     :  611
        },
        'entity' : {
            'DEFAULT'                       :  700,
            'getProgramEntityDetail.503'    : [701, 'ERR_7'],
            'getProgramEntityDetail.404'    : [701, 'ERR_7'],
            'getEntityRecordings.503'       :  702,
            'getEntityRecordings.500'       :  702,
            'getWatchOptionsForProgram.503' :  703,
            'getWatchOptionsForProgram.500' :  703,
            'getWatchOptionsForProgram.404' :  703
        },
        'saved' : {
            'DEFAULT'                                :  800,
            'getAllFavorites.503'                    :  801,
            'getAllFavorites.500'                    :  801,
            'getAllFavorites.404'                    :  801,
            'browseFavorites.503'                    : [802, 'ERR_1'],
            'addFavoriteItems.503'                   :  803,
            'getRecentlyWatched.503'                 :  805,
            'getRecentlyWatched.500'                 :  805,
            'getRecentlyWatched.404'                 :  805,
            'getVodWatched.503'                      :  806,
            'getVodWatched.500'                      :  806,
            'getWatchedPrograms.503'                 :  807,
            'getForYouMenu.503'                      :  810,
            'getForYouMenu.500'                      :  810,
            'getForYouFeaturedMenu.503'              :  811,
            'getForYouFeaturedMenu.500'              :  811,
            'getRecordings.503'                      : [815, 'ERR_9'],
            'getScheduledRecordingsWithEntities.503' : [816, 'ERR_10'],
            'getScheduledRecordingsWithEntities.500' : [816, 'ERR_10'],
            'recentRecordings.503'                   :  817,
            'recentRecordings.500'                   :  817,
            'getRecorderSummary.503'                 :  818,
            'getDeletedRecordings.503'               : [819, 'ERR_4'],
            'getPurchases.503'                       : [825, 'ERR_8']

        },
        'transact' : {
            'DEFAULT' :  900,
            '500.102' : [903, 'ERR_20'],
            '500.103' : [904, 'ERR_21'],
            '500.104' : [905, 'ERR_22'],
            '500.105' : [906, 'ERR_23'],
            '500.106' : [907, 'ERR_24'],
        }
    });

    // https://www.stg.xfinity.com/stream/demo/errors/index.html
    ErrorOverlay.errorTVAPP = Object.freeze({
    //   code              title                                                                                  message
        'ERR_1'  : [ "Well that didn’t go as planned..."                                        , "Please try again in a few minutes. Haven’t added any yet? Start by selecting “Add to Favorites” on the Info screen of any show, movie or team." ],
        'ERR_2'  : [ "Sorry, we're having some trouble"                                         , "Please check back later." ],
        'ERR_3'  : [ "Unable to Find Listings"                                                  , "There was a problem retrieving the TV Listings. Apologies for any inconvenience." ],
        'ERR_4'  : [ "Unable to Retrieve Deleted Recordings"                                    , "There was a problem retrieving your deleted recordings. Please try again. Apologies for any inconvenience." ],
        'ERR_5'  : [ "Unable to Update Parental Controls."                                      , "There was a problem updating your parental controls. Please try again." ],
        'ERR_6'  : [ "Unable to Retrieve Parental Controls."                                    , "There was a problem retrieving your parental controls. Please try again." ],
        'ERR_7'  : [ "Sorry, we're having some trouble"                                         , "Xfinity Stream is not available at the moment. Please try back soon." ],
        'ERR_8'  : [ "Unable to Retrieve Purchases"                                             , "There was a problem retrieving your purchases. Please try again. Apologies for any inconvenience." ],
        'ERR_9'  : [ "Unable to Retrieve Recordings"                                            , "There was a problem retrieving your recordings. Please try again. Apologies for any inconvenience." ],
        'ERR_10' : [ "Unable to Retrieve Scheduled Recordings"                                  , "There was a problem retrieving your scheduled recordings. Please try again. Apologies for any inconvenience." ],
        'ERR_11' : [ "Unable to Find Listings"                                                  , "There was a problem retrieving the TV Listings. Apologies for any inconvenience." ],
        'ERR_12' : [ "Your Search Was Interrupted"                                              , "A problem occurred during your search. Please try again. Apologies for any inconvenience." ],
        'ERR_13' : [ "Something's not right here"                                               , "We are having trouble adding this device to your account. Please call 1-800-xfinity and mention error 11700." ],
        'ERR_14' : [ "Maximum Concurrent Streams Reached"                                       , "You've reached the maximum concurrent streaming limit. To stream on this device, you'll have to stop streaming on another." ],
        'ERR_15' : [ ""                                                                         , "NOW AIRING ON Watch Now Not the show you expected?" ],
        'ERR_16' : [ "Subscription to This Channel Required"                                    , "A subscription is required to watch this channel. Please call 1-800-xfinity to add it to your service." ],
        'ERR_17' : [ "Sorry, this game is currently blacked out due to league restrictions."    , "You may be able to find the game on another channel.Please check All Listings." ],
        'ERR_18' : [ "Heartbeat Error"                                                          , "Please try resuming your video to continue where you left off." ],
        'ERR_19' : [ "This Video Cannot Be Played"                                              , "We've run into a problem while streaming %%entity%%." ],

        'ERR_20' : [ "We need some help with your account"                                      , "To watch this program, please visit <i>xfin.tv/payment</i>" ],
        'ERR_21' : [ "You've purchased this already!"                                           , "" ], //TODO: we need to insert logic here? (purchase vs watch)
        'ERR_22' : [ "This isn't available right now"                                           , "Check back soon as programming is updated frequently." ],
        'ERR_23' : [ "Sorry, we're having some trouble"                                         , "Please try again." ],
        'ERR_24' : [ "Sorry, we're having some trouble"                                         , "This program is not available to watch at the moment. Please try again in a few minutes." ],
    });

    /* Get the TVAPP-##### string via 2 different combinations of parameters
     *    context, api, major
     *    context, major, minor
     * Note: Static function since Telemetry needs access
     * @param {ErrorOverlay.Context}  context -
     * @param {String}                prefix  - major number or if API then a description such as "searchByTerm"
     * @param {String}               [suffix] - minor number or if API then major number
     * @return {Number|Array}                 - the ErrorOverlay.errorMatrix entry
     */
    ErrorOverlay.getTVAPP = function( context, prefix, suffix )
    {
        var matrixKey, err;

        if( suffix === undefined )
            suffix = "0";

        if( prefix !== undefined )
            matrixKey = "" + prefix + "." + suffix;
        else
            console.log( "ErrorOverlay.getTVAPP - WARNING: invalid error key parameter combination.");

        //try to find a matching error key in the given context
        err = ErrorOverlay.errorMatrix[context][matrixKey];

        //next, try to find this error key in the COMMON context
        if( err === undefined )
            err = ErrorOverlay.errorMatrix[ErrorOverlay.Context.COMMON][matrixKey];

        //finally, default to the default error for this context
        if( err === undefined )
            err = ErrorOverlay.errorMatrix[context]['DEFAULT'];


        //LOG something that we did not find.
        return err;
    };

    ErrorOverlay.prototype.dismiss = function()
    {
        _x2.popOverlay( this );

        if( this._onDismiss )
            this._onDismiss()
    };

    ErrorOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons, true );
        this._speakTarget.setText( this._title.getText() + ". " + this._desc.getText() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press OK to select. Press back to dismiss. " + this._messageStr.getText() + ". ", focus._speakRole, this, false );
    };

    /**
     * Initialize the error overlay
     * @param {*}              params
     * @param {ApiError|*}     [params.error]   - ApiError object
     * @param {string}         [params.reason]  - text description of error (if error obj not provided)
     * @param {*}              [params.context] - error context determines message (member of ErrorOverlay.Context)
     * @param {function}       [params.onRetry] - callback when user selects "Try Again"
     * @param {Showing|Entity} [params.entity]  - entity in play when error occurred
     * @param {boolean}        [params.noRetry] - present 'Close' button instead of 'Try Again' //TODO: this should derived from whether we have a onRetry parameter, but it will end up changing many buttons across the UI. Needs a deeper look.
     * @return {ErrorOverlay}
     */
    ErrorOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init. call( this, params );
        this._className  = "ErrorOverlay";

        var onReady, buttons, messageKey, textKey, api, major, minor, entry, message = "", tvapp;

        var error   = params.error;
        var reason  = params.reason;
        var context = params.context ? params.context : ErrorOverlay.Context.COMMON;
        var onRetry = params.onRetry;

        var self         = this;
        var titleStyle   = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle    = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var messageStyle = new Style( { font:"medium", color:"#8c8c8c", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );

        var w      = this._bg.getW();
        var title  = "Sorry, something went wrong";
        var desc   = "Please try again";
        var entity = "";

        console.log( "Error in " + context, error ); //Trace error in splunk log, if there is something went wrong

        if( params.entity && params.entity.getTitle )
            entity = params.entity.getTitle();

        var close = function()
        {
            _x2.popOverlay( self );
        };

        var retry = function()
        {
            _x2.popOverlay( self );

            if( onRetry )
                onRetry();
        };

        if( error )
        {
            if( error instanceof ApiError )
            {
                api   = error.getApi();
                major = error.getMajor();
                minor = error.getMinor();

                if( minor !== undefined )
                    tvapp = ErrorOverlay.getTVAPP( context, major, minor );
                else if( api !== undefined )
                    tvapp = ErrorOverlay.getTVAPP( context, api, major );
                else
                    tvapp = ErrorOverlay.getTVAPP( context, major );

                if( Array.isArray(tvapp) )
                {
                    messageKey  = tvapp[0];
                    textKey     = tvapp[1];
                }
                else
                    messageKey = tvapp;

                message = "(Error TVAPP-00" + messageKey + ")";

                if( textKey !== undefined )
                    entry = ErrorOverlay.errorTVAPP[ textKey ]; // Do we have a more detailed error title/description available?

                if( entry )
                {
                    if( entry[0] )
                        title = entry[0];
                    if( entry[1] )
                        desc  = entry[1].replace( "%%entity%%", entity );
                }
            }
            else
            {
                message = "(Internal Error)";

                if( reason === undefined && params.error && params.error.stack )
                    reason = params.error.stack;

                if( _x2._splunk && reason )
                    _x2._splunk.sendGeneralError( reason, "TVAPP-00100" );
            }
        }
        else if( reason )
            message = reason;

        this._numReady = 0;

        buttons = [];

        if( params.noRetry === true )
            buttons.push( new StringWidget().init( { text:"Close", style:buttonStyle, onEnter:close } ) );
        else
            buttons.push( new StringWidget().init( { text:"Try Again", style:buttonStyle, onEnter:retry } ) );

        onReady = function() { self._numReady++; self.layoutErrorOverlay() };

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w/2 } );
        this._bg.addWidget( this._desc, w/4 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:buttons, spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( onReady );
        this._bg.addWidget( this._buttons );

        this._messageStr = new StringWidget().init( { text:message, style:messageStyle } );
        this._messageStr.addReadyCallback( onReady );
        this._bg.addWidget( this._messageStr );

        this._bg.setA(0);

        return this;
    };

    ErrorOverlay.prototype.layoutErrorOverlay = function()
    {
        if( this._numReady === 3 )
        {
            var y0     = 0;
            var y1     = y0 + this._title.getH();
            var y2     = y1 + ((this._desc === undefined) ? 0 : this._desc.getH());
            var offset = (this._bg.getH() - y2 - _x2.scaleValInt( 24 ) - this._buttons.getH()) / 2;

            this._title.setY ( y0 + offset );

            if( this._desc !== undefined )
                this._desc.setY( y1 + offset );

            this._buttons.setY( y2 + offset + _x2.scaleValInt( 24 ) );
            this._buttons.setX( ( this._bg.getW() - this._buttons.getW()) / 2 );

            this._messageStr.setX( this._bg.getW() - this._messageStr.getW() - _x2.scaleValInt(34) );
            this._messageStr.setY( this._bg.getH() - this._messageStr.getH() - _x2.scaleValInt(34) );

            this._bg.setA(1);
        }
    };

    return ErrorOverlay;

})();


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.FilterChannelsOverlay = ( function()
{
    "use strict";

    FilterChannelsOverlay.prototype = new Overlay();

    FilterChannelsOverlay.FilterStrs = Object.freeze
    ({
        hd  : "HD",
        cc  : "CC",
        sap : "SAP",
        dvs : "VDS"
    });

    function FilterChannelsOverlay(){}

    FilterChannelsOverlay.prototype.createTitle = function()
    {
        var str, result = "Filtered by: <font color='#2ea0dd'>", first = true;

        this._str = "Filtered by: ";

        for( var i = 0; i < this._rows.length; i++ )
        {
            var key = this._rows[i].key;

            if( this._rows[i].selected === true )
            {
                str = FilterChannelsOverlay.FilterStrs[key];

                if( str )
                {
                    if( first !== true )
                    {
                        result    += ", ";
                        this._str += ", ";
                    }
                    else
                        first = false;

                    result += str;

                    this._str += this._rows[i].title;
                }
            }
        }

        this._str += ". ";
        this._title.setText( result + "</font>" );
    };

    FilterChannelsOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className = "FilterChannelsOverlay";

        var self       = this;
        var listParams = {};
        var filters    = _x2._settings.getValue( params.which );
        var pathStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );
        var hPad       = _x2.scaleValInt(78);
        var vPad       = _x2.scaleValInt(80);

        var layout     = function()
        {
            self._numReady++;

            if( self._numReady === 2 )
            {
                self._title.setY( self._path.getY() + self._path.getH() + 5 * Style._pad );

                var y = self._title.getY() + self._title.getH() + _x2.scaleValInt(46);

                self._sep.setY( y );
                self._list.setY( y );
                self._buttons.setY( y + self._list.getH() + 5 * Style._pad );
                self._buttons.setX( (self._bg.getW() - self._buttons.getW()) / 2 );
                self._ready = true;

                self.setBgSize( self._bg.getW(), self._buttons.getY() + self._buttons.getH() + 6 * Style._pad );

                if( _x2._focus === self )
                    self.speak( _x2.requestFocus( self._list ) );
            }
        };

        var save = function()
        {
            var saved   = _x2._settings.getValue( params.which );
            var current = self._rows;
            var changed = false;

            for( var i = 0; i < current.length; i++ )
            {
                var key = current[i].key;

                if( current[i].selected !== saved[key] )
                {
                    changed    = true;
                    saved[key] = current[i].selected;

                    if( current[i].selected )
                        window.ll( "tagEvent", "Filtered", { Type: current[i].localytics } );
                }
            }

            if( changed === true )
            {
                _x2._settings.setValue( params.which, saved );
                params.screen.filtersChanged();
            }
            else
                cancel();
        };

        var cancel = function()
        {
            _x2.popOverlay( self );
        };

        this._numReady = 0;
        this._rows     =
        [
            { title:"High Definition"        , selected:filters.hd , key:"hd" , glyph:Strings.Glyphs.HD , localytics: "HD"  },
            { title:"Closed Captioning"      , selected:filters.cc , key:"cc" , glyph:Strings.Glyphs.CC , localytics: "CC"  },
            { title:"Secondary Audio Program", selected:filters.sap, key:"sap", glyph:Strings.Glyphs.SAP, localytics: "SAP" },
            { title:"Video Description"      , selected:filters.dvs, key:"dvs", glyph:Strings.Glyphs.DV , localytics: "DVS" }
        ];

        this._path = new StringWidget().init( { text:"Options", style:pathStyle } );
        this._bg.addWidget( this._path, hPad, vPad );

        this._title = new StringWidget().init( { style:titleStyle } );
        this._title.addReadyCallback( layout );
        this._bg.addWidget( this._title, hPad, vPad );

        this._sep = new RectWidget().init( { w:this._bg.getW() - 2 * hPad, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this._bg.addWidget( this._sep, hPad );

        listParams.w        = this._bg.getW() - 2 * hPad;
        listParams.h        = 4 * new CheckBoxRowWidget().getHeightUnfocused();
        listParams.maxIndex = 3;
        listParams.rows     = this._rows;
        listParams.type     = CheckBoxRowWidget;

        this._list = new ListWidget().init( listParams );
        this._bg.addWidget( this._list, hPad );

        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var confirmStr  = new StringWidget().init( { text:"Confirm", style:buttonStyle, onEnter:save   } );
        var cancelStr   = new StringWidget().init( { text:"Cancel" , style:buttonStyle, onEnter:cancel } );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[confirmStr,cancelStr], spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( layout );
        this._bg.addWidget( this._buttons );

        this.createTitle();

        return this;
    };

    FilterChannelsOverlay.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED && _x2._focus !== this._buttons )
                    _x2.requestFocus( this._buttons, false );
                break;

            case Host.KEY_ENTER:
                if( type === Host.KEY_RELEASED )
                    this.createTitle();
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && _x2._focus !== this._list )
                    _x2.requestFocus( this._list, false );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    FilterChannelsOverlay.prototype.speak = function( focus )
    {
        this._speakTarget.setText( this._str + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Pres OK to select. Press back to dismiss. ", focus._speakRole, this, false );
    };

    return FilterChannelsOverlay;

})();


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.FindChannelOverlay = ( function()
{
    "use strict";

    FindChannelOverlay.prototype = new Overlay();

    function FindChannelOverlay(){}

    FindChannelOverlay.prototype.executeSearch = function( str )
    {
        var results  = [], chNum, callsign, company, voiceHint, i;
        var channels = this._cc.getChannels();

        for( i = 0; i < channels.length; i++ )
        {
            chNum     = channels[i].getNumber().toString();
            callsign  = channels[i].getCallSign();
            company   = channels[i].getCompany();
            voiceHint = channels[i].getVoiceHint();

            if( company )
                company = company.toUpperCase();

            if( voiceHint )
                voiceHint = voiceHint.toUpperCase();

            if( (chNum && chNum.startsWith( str ) === true) || (callsign && callsign.startsWith( str ) === true) || (company && company.startsWith( str ) === true) || (voiceHint && voiceHint.startsWith( str ) === true) )
                results.push( channels[i] );
        }

// console.log( "=====================================================================" );
//
// for( i = 0; i < results.length; i++ )
//     console.log( results[i].getNumber() + " " + results[i].getCallSign() + " " + results[i].getCompany() );
//
// console.log( "---------------------------------------------------------------------" );
// console.log( "Total: " + results.length );

        this._numResults = results.length;
        this._list.setData( results );

        if( this._numResults > 0 )
        {
            this._sep.setA( 1 );
            this._icon.setA( 0 );
            this._noResultsStr.setA( 0 );
        }
        else
        {
            this._sep.setA( 0 );

            if( str.length === 0 )
            {
                this._icon.setA( 1 );
                this._noResultsStr.setA( 0 );
            }
            else
            {
                window.ll( "tagEvent", "Live TV Find Channel Results", { title:this._searchStr } ); // Localytics 2.3.8
                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localtyics: Live TV: Find Channel no results: " + this._searchStr ) : Config.NOP();

                this._icon.setA( 0 );
                this._noResultsStr.setA( 1 );
            }
        }
    };

    FindChannelOverlay.prototype.init = function( params )
    {
        var self           = this, x, y, h, date, onChannelsLoaded, onChannelsFailed;
        var keyboardParams = {}, listParams = {}, layout;
        var onLoad         = function() { self._numReady++; layout(); };
        var hPad           = _x2.scaleValInt(78);
        var vPad           = _x2.scaleValInt(80);

        Overlay.prototype.init.call( this );
        this._className  = "FindChannelOverlay";
        this._numReady   = 0;

        layout = function()
        {
            if( self._numReady === 3 )
            {
                self._keyboard.setY( self._text.getY() + self._text.getH() + _x2.scaleValInt( 30 ) );

                self._icon.setX( self._list.getX() + (self._list.getW() - self._icon.getW()) / 2 );
                self._icon.setY( (self._bg.getH() - self._icon.getH()) / 2 );

                self._noResultsStr.setX( self._list.getX() + (self._list.getW() - self._noResultsStr.getW()) / 2 );
                self._noResultsStr.setY( (self._bg.getH() - self._noResultsStr.getH()) / 2 );

                if( _x2._focus === self )
                    self.speak( _x2.requestFocus( self._keyboard, true ) );

                 // get the list of channels

                date = new Date();
                date.setMilliseconds( 0 );
                date.setSeconds( 0 );
                date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

                _x2._channelCollection.fetch().then( onChannelsLoaded, onChannelsFailed );
            }
        };

        onChannelsLoaded = function()
        {
            var chanColl = _x2._channelCollection;

            self._dataReady = true;
            self._cc        = chanColl;

            if( self._searchStr )
                self.executeSearch( self._searchStr );
        };

        onChannelsFailed = function( error )
        {
            var onDismiss = function()
            {
                _x2.popOverlay( self );
            };

            var onRetry = function()
            {
                var retry = function()
                {
                    _x2._channelCollection.fetch().then( onChannelsLoaded, onChannelsFailed );
                };

                _x2.popOverlay( self._errorOverlay, retry );
            };

            self._errorOverlay = _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.GUIDE, onDismiss:onDismiss, onRetry:onRetry } ) );
        };

        this._icon  = new ImageWidget().init( { url:_x2._config._imageRoot + "ChannelFinder.png", onLoad:onLoad } );
        this._bg.addWidget( this._icon );

        var noResultStyle = new Style( { font:"regular" , color:"#a3a3a3", fontSize:_x2.scaleValInt(32) } );

        this._noResultsStr = new StringWidget().init( { text:"Sorry, there's no results", style:noResultStyle } );
        this._noResultsStr.setA( 0 );
        this._bg.addWidget( this._noResultsStr );

        keyboardParams.onReady = onLoad;
        keyboardParams.onEnter = function( char ) { self._text.onChar( char ); };

        this._keyboard = new KeyboardWidget().init( keyboardParams );
        this._bg.addWidget( this._keyboard, hPad );

        this._text = new TextEntryWidget().init( { w:300, instStr:"Search for Networks and Channels", onChange:function( text ) { self.onTextChanged( text ); } } );
        this._text.setW( this._keyboard.getW() );
        this._text.addReadyCallback( onLoad );
        this._bg.addWidget( this._text, hPad, vPad );

        x = this._keyboard.getX() + this._keyboard.getW() + _x2.scaleValInt( 60 );
        y = this._text.getY() + ListRowWidget.DIVIDER_H;
        h = new FindChannelRowWidget().getHeightUnfocused();
        h = Math.floor((this._bg.getH() - y) / h) * h;

        listParams.w        = this._bg.getW() - x - hPad;
        listParams.h        = h;
        listParams.maxIndex = 1;
        listParams.type     = FindChannelRowWidget;
        listParams.obj      = params.screen;

        this._list = new ListWidget().init( listParams );
        this._bg.addWidget( this._list, x, y );

        this._sep = new RectWidget().init( { w:listParams.w, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this._sep.setA( 0 );
        this._bg.addWidget( this._sep, x, y - ListRowWidget.DIVIDER_H );

        this._timestampPageView = new Date(); // Localytics: 2.3.8

        return this;
    };

    FindChannelOverlay.prototype.onTextChanged = function( str )
    {
        console.log( ">" + str + "<" );

        this._searchStr = str;

        // The list initially defaults to empty
        // If user clears the search string empty the list
        if( str.length < 1 )
        {
            this._numResults = 0;
            this._list.setData( [] );
            this._sep.setA( 0 );
            this._icon.setA( 1 );
            this._noResultsStr.setA( 0 );
        }
        else if( this._dataReady === true )
            this.executeSearch( str );
    };

    FindChannelOverlay.prototype.processEvent = function( val, type )
    {
        var retval = false;

        switch( val )
        {
            case Host.KEY_LAST:
                // NOTE: retval is NOT set as we must var _x2.popOverlay() process
                this._durationPageView = new Date() - this._timestampPageView;
                window.ll( "tagEvent", "Back Button Find Channel Overlay", { "Duration": this._durationPageView } ); // Localytics 2.3.8
                _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Back Button: Find Channel Overlay, duration: " + this._durationPageView ) : Config.NOP();
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    this.speak( _x2.requestFocus( this._keyboard, false ) );
                    retval = true;
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._numResults )
                    {
                        this.speak( _x2.requestFocus( this._list, false ) );
                        retval = true;
                    }
                }
                break;
        }

        return retval;
    };

    FindChannelOverlay.prototype.speak = function( focus )
    {
        if( focus === this._keyboard )
        {
            this._speakTarget.setText( "Find Channels. " + this._text.getInstText() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Go right for search results. Press back to dismiss.", focus._speakRole, this, false );
        }
    };

    return FindChannelOverlay;

})();


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GuideOptionsOverlay = ( function()
{
    "use strict";

    GuideOptionsOverlay.prototype = new Overlay();

    function GuideOptionsOverlay(){}

    GuideOptionsOverlay.prototype.gotFocus = function()
    {
         Overlay.prototype.gotFocus.call( this );

         if( this._ready === true )
            this.speak( _x2.requestFocus( this._list ) );
    };

    GuideOptionsOverlay.prototype.init = function( params )
    {
        var self       = this, layout, listParams = {}, rows, onFilterChannels, onFindChannel;
        var hPad       = _x2.scaleValInt(79);
        var vPad       = _x2.scaleValInt(80);
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        Overlay.prototype.init.call( this );
        this._className  = "GuideOptionsOverlay";

        layout = function()
        {
            var y = self._title.getY() + self._title.getH() + _x2.scaleValInt(46);

            self._sep.setY( y );
            self._list.setY( y );
            self._bg.animate( { a:1, duration:500 } );
            self._ready = true;

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._list ) );
        };

        this._bg.setA( 0 );

        this._title = new StringWidget().init( { text:"Options", style:titleStyle } );
        this._title.addReadyCallback( layout );
        this._bg.addWidget( this._title, hPad, vPad );

        this._sep = new RectWidget().init( { w:this._bg.getW() - 2 * hPad, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this._bg.addWidget( this._sep, hPad );

        onFilterChannels = function()  // TODO needs Localytics
        {
            var overlay = new FilterChannelsOverlay().init( { screen:params.screen, which:Settings.Key.FILTERS } );

            if( params.screen )
                params.screen.setToPop( overlay );

            _x2.pushOverlay( overlay );
        };

        onFindChannel = function()
        {
            window.ll( "tagEvent", "Live TV Find Channel Button" ); // Localytics 2.3.8
            _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Find Channel button" ) : Config.NOP();

            var overlay = new FindChannelOverlay().init( { screen:params.screen } );

            if( params.screen )
                params.screen.setToPop( overlay );

            _x2.pushOverlay( overlay );
        };

        rows =
        [
            { title:"Find Channels"     , onEnter:onFindChannel    },
            { title:"Filter Preferences", onEnter:onFilterChannels }
        ];

        listParams.w        = this._bg.getW() - 2 * hPad;
        listParams.h        = this._bg.getH() - 2 * vPad;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = MenuRowWidget;

        this._list = new ListWidget().init( listParams );
        this._bg.addWidget( this._list, hPad );

        return this;
    };

    GuideOptionsOverlay.prototype.speak = function( focus )
    {
        this._speakTarget.setText( "Options. " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Pres OK to select. Press back to dismiss.", focus._speakRole, this, false );
    };

    return GuideOptionsOverlay;

})();


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.HelpOverlay = ( function()
{
    "use strict";

    HelpOverlay.prototype = new Overlay();

    function HelpOverlay(){}

    HelpOverlay.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();

        var str = "";

        for( var i = 0; i < this._strings.length; i++ )
            str += this._strings[i].getText() + ". ";

        str = str.replace( /xfinity/gi, "x_finity" );

        this._speakTarget.setText( str );
        this._speakTarget.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    HelpOverlay.prototype.init = function( showNotEntitled )
    {
        Overlay.prototype.init.call( this, { hideExitStr:showNotEntitled } );
        this._className = "HelpOverlay";
        this._numLoaded = 0;
        this._strings   = [];

        var i;
        var self   = this;
        var onLoad = function() { self._numLoaded++; self.layoutHelpOverlay() };
        var styles =
        [
            new Style( { font:"medium" , color:"#a3a3a3", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } ),
            new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", textAlign:"center" } )
        ];
        var texts =
        [
            "To learn more about the Xfinity Stream Beta, please visit",
            "xfinity.com/xfinitystreambeta",
            _x2._config._isSmbUser === true ? "To get help & support, please visit" : "For the latest announcements and to submit feedback, please visit",
            _x2._config._isSmbUser === true ? "https://business.comcast.com/help-and-support/tv/" : "forums.xfinity.com/betafeedback"
        ];

        if( showNotEntitled === true )
            texts.unshift( "To learn more about Xfinity Instant TV, please visit", "xfinity.com/learn/instant-tv" );

        for( i = 0; i < texts.length; i++ )
        {
            this._strings[i] = new StringWidget().init( { text:texts[i], style: styles[i & 1] } );
            this._strings[i].addReadyCallback( onLoad );
            this._bg.addWidget( this._strings[i] );
        }

        this._image = new ImageWidget().init( { url:_x2._config._imageRoot + "helpIcon.png", onLoad:onLoad } );
        this._bg.addWidget( this._image );

        if( showNotEntitled !== true )
        {
            window.ll( "tagScreen", "Help" );
            _x2._telemetry.sendScreenViewed( "Help" );
        }

        return this;
    };

    HelpOverlay.prototype.layoutHelpOverlay = function()
    {
        if( this._numLoaded === this._strings.length + 1 )
        {
            var i, y;
            var maxStringW = 0;
            var n          = this._strings.length;
            var h          = 0;

            for( i = 0; i < n; i++ )
                if( this._strings[i].getW() > maxStringW )
                    maxStringW = this._strings[i].getW();

            var bgW = this._bg.getW();
            var bgH = this._bg.getH();
            var imW = this._image.getW();
            var imX = (bgW - imW - maxStringW) / 3;
            var imY = (bgH   - this._image.getH()) / 2;
            var w   = bgW - imX - imW;
            var x   = imX + imW;
            var pad = _x2.scaleValInt(52);

            this._image.setX( imX );
            this._image.setY( imY );

            for( i = 0; i < n; i++ )
            {
                this._strings[i].setW( w );
                this._strings[i].setX( x );

                h += this._strings[i].getH();
            }

            h += pad;
            y = (this._bg.getH() - h) * 0.5;

            for( i = 0; i < n; i++ )
            {
                this._strings[i].setY( y );
                y += this._strings[i].getH();

                if( i % 2 === 1 )
                    y += pad;
            }
        }
    };

    return HelpOverlay;

})();


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.InHomeFailOverlay = ( function()
{
    "use strict";

    InHomeFailOverlay.prototype = new Overlay();

    function InHomeFailOverlay(){}

    InHomeFailOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons );
        this._speakTarget.setText( this._title.getText() + ". " + this._desc.getText().replace( /xfinity/gi, "x finity" ) + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( undefined, focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof InHomeFailOverlay
     * @returns {InHomeFailOverlay}
     */
    InHomeFailOverlay.prototype.init = function()
    {
        Overlay.prototype.init. call( this );
        this._className  = "InHomeFailOverlay";

        var self        = this, onReady, exit, desc;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle   = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var w           = this._bg.getW();
        var title       = "Welcome!";

        if( _x2._config._isSmbUser === true )
            desc = "This device can only access XFINITY Stream on your Comcast Business WiFi. Use the app on your smartphone, tablet or laptop to watch on the go, anytime you like";
        else
            desc = "This device can only access Xfinity Stream on your in-home Xfinity network. Use the app on your smartphone, tablet, or laptop to watch on the go, any time you like.";

        this._numReady = 0;

        onReady = function() { self._numReady++; self.layoutInHomeFailOverlay() };
        exit   = new StringWidget().init( { text:"Exit App", style:buttonStyle, onEnter:function() { _x2._authService.logout(); _x2._config._host.exitApp( true ); } } );

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w*3/4 } );
        this._bg.addWidget( this._desc, w/8 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[exit], spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( onReady );
        this._bg.addWidget( this._buttons );

        _x2.localyticsLogout( true );

        return this;
    };

    InHomeFailOverlay.prototype.layoutInHomeFailOverlay = function()
    {
        if( this._numReady === 2 )
        {
            var titleH  = this._title.getH();
            var descH   = this._desc.getH();
            var buttonH = this._buttons.getH();
            var offset  = ( this._bg.getH() - titleH - descH - buttonH - 7 * Style._pad ) / 2;

            this._title.setY ( offset );
            this._desc.setY( this._title.getY() + titleH + 3 * Style._pad );
            this._buttons.setY( this._desc.getY() + descH + 4 * Style._pad );
            this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
        }
    };

    InHomeFailOverlay.prototype.processEvent = function( val, type )
    {
        if( val === Host.KEY_LAST  ) { //If user press enter or back button
           _x2.setScreen( new TransitionScreen().init( { signOut:true } ) );
        } else if( val === Host.KEY_ENTER ) {
            _x2._authService.logout(); 
            _x2._config._host.exitApp( true );
        }
        return true;
    };

    return InHomeFailOverlay;

})();


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MessageOverlay = (function()
{
    "use strict";

    MessageOverlay.prototype = new Overlay();

    function MessageOverlay(){}

    MessageOverlay.prototype.gotFocus = function()
    {
        this._speakTarget.setText( this._msg + ". " );
        this._speakTarget.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    MessageOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this, params );
        this._className = "MessageOverlay";
        this._msg       = params.message;

        var self       = this, onIconLoaded, msg, icon;
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42) } );

        onIconLoaded = function()
        {
            var x, w, h, tPad, bPad, lPad, rPad, textW, onTextReady;

            tPad  = bPad = lPad = rPad = _x2.scaleValInt( 80 );
            w     = _x2.scaleValInt( 1000 );
            x     = lPad + _x2.scaleValInt( 90 );
            textW = w - rPad - x;

            icon.setX( lPad );

            onTextReady = function()
            {
                h = tPad + msg.getH() + bPad;
                icon.setY( (h - icon.getH() + tPad - bPad) / 2 );
                msg.setY( tPad );
                self.setBgSize( w, h );
            };

            msg = new TextBlockWidget().init( { text:params.message, style:titleStyle, w:textW } );
            msg.addReadyCallback( onTextReady );
            self._bg.addWidget( msg, x );
            msg.patchWidget();
        };

        icon  = new ImageWidget().init( { url:_x2._config._imageRoot + "circleCheck.png", onLoad:onIconLoaded } );
        this._bg.addWidget( icon );

        return this;
    };

    return MessageOverlay;

})();


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.OnOffOverlay = ( function()
{
    "use strict";

    OnOffOverlay.prototype = new Overlay();

    function OnOffOverlay(){}

    OnOffOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( "On/Off Options. " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    OnOffOverlay.prototype.init = function( params )
    {
        var listParams = {}, onOn, onOff;

        Overlay.prototype.init.call( this );
        this._className  = "OnOffOverlay";

        onOn = function()
        {
            _x2.popOverlay();

            if( params.onEnter )
                params.onEnter( true );
        };

        onOff = function()
        {
            _x2.popOverlay();

            if( params.onEnter )
                params.onEnter( false );
        };

        listParams.w        = this._bg.getW() - Style._safeLeft - Style._safeRight;
        listParams.h        = new MenuRowWidget().getHeightUnfocused() * 2;
        listParams.maxIndex = 1;
        listParams.rows     = [ { title:"On", onEnter:onOn, selected:params.isOn===true, rowIndex: 0 }, { title:"Off", onEnter:onOff, selected:params.isOn===false, rowIndex: 1 } ];
        listParams.type     = ChoiceRowWidget;

        this._list = new ListWidget().init( listParams );
        this._bg.addWidget( this._list, Style._safeLeft, (this._bg.getH() - this._list.getH()) / 2 );

        this._sep = new RectWidget().init( { w:listParams.w, h:ListRowWidget.DIVIDER_H, color:"#262626" } );
        this._bg.addWidget( this._sep, Style._safeLeft, this._list.getY() - this._sep.getVal( Widget.H ) );

        return this;
    };

    return OnOffOverlay;

})();


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PinOverlay = ( function()
{
    "use strict";

    PinOverlay.prototype = new Overlay();

    PinOverlay.Type = Object.freeze
    ({
        PC_CONFIRM         : 0,
        PC_CREATE          : 1,
        PC_VALIDATE        : 2,
        PC_VALIDATE_FAIL   : 3,
        PC_VERIFY_FAIL     : 4,
        PURC_CONFIRM       : 5,
        PURC_CREATE        : 6,
        PURC_VALIDATE      : 7,
        PURC_VALIDATE_FAIL : 8,
        PURC_VERIFY_FAIL   : 9
    });

    PinOverlay.FlowType = Object.freeze
    ({
        PARENTAL_CONTROL : 0,
        PURCHASE         : 1,
    });

    function PinOverlay(){}

    PinOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._pinPad );
        var str   = this._speechStr ? this._speechStr : "";

        str += this._title.getText() + ". ";

        if( this._desc )
            str += this._desc.getText() + ". ";

        str = str.replace( /xfinity/gi, "x finity" );

        this._speakTarget.setText( str + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( undefined, focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof PinOverlay
     * @param {Object}          [params]
     * @param {String}          [params.speechStr]         - String to read before reading the the Pin overlay text
     * @param {PinOverlay.Type} [params.type]              - Which version of the overlay to display
     * @param {Number}          [params.attemptsRemaining] - Number of remaining purchase attempts
     * @returns {PinOverlay}
     */

    PinOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this, params );
        this._className  = "PinOverlay";

        var self       = this, title, desc, onReady;
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle  = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var w          = this._bg.getW();

        this._numReady  = 0;
        this._speechStr = params.speechStr;

        onReady = function() { self._numReady++; self.layoutPinOverlay() };

        switch( params.type )
        {
            case PinOverlay.Type.PC_CONFIRM:
                title = "Confirm a Parental Control PIN";
                break;

            case PinOverlay.Type.PC_CREATE:
                title = "Create a Parental Control PIN";
                desc  = "Set a Parental Control PIN that will be required to access content based on rating, channel, title, and more.";
                break;

            case PinOverlay.Type.PC_VALIDATE:
                title = "Please Enter Your Parental Control PIN";
                break;

            case PinOverlay.Type.PC_VALIDATE_FAIL:
                title = "Please Enter Your Parental Control PIN";
                desc  = "Incorrect PIN. Please try again.";
                break;

            case PinOverlay.Type.PC_VERIFY_FAIL:
                title = "Please Verify Your New PIN";
                desc  = "The numbers you entered did not match, please try again.";
                break;

            case PinOverlay.Type.PURC_CONFIRM:
                title = "Verify Your PIN";
                break;

            case PinOverlay.Type.PURC_CREATE:
                title = "Create Your Purchase PIN";
                desc  = "This PIN will protect your account across all Xfinity Stream apps.";
                break;

            case PinOverlay.Type.PURC_VALIDATE:
                title = "Please Enter Your Purchase PIN";
                break;

            case PinOverlay.Type.PURC_VALIDATE_FAIL:
                title = "Please Enter Your Purchase PIN";
                desc  = "The PIN you entered was incorrect. You may try " + params.attemptsRemaining + " more " + ( params.attemptsRemaining > 1 ?  "times." : "time." );
                break;

            case PinOverlay.Type.PURC_VERIFY_FAIL:
                title = "Create Your Purchase PIN";
                desc  = "Let's try that again. The numbers you've entered don't match.";
                break;

            default:
                console.error( "ERROR -> unknown PIN overlay type = " + params.type );
                break;
        }

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        if( desc !== undefined )
        {
            this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w/2 } );
            this._bg.addWidget( this._desc, w/4 );
        }

        this._pinPad = new PinPadWidget().init( params );
        this._pinPad.addReadyCallback( onReady );
        this._bg.addWidget( this._pinPad );

        return this;
    };

    PinOverlay.prototype.layoutPinOverlay = function()
    {
        if( this._numReady === 2 )
        {
            var y0     = 0;
            var y1     = y0 + this._title.getH();
            var y2     = y1 + ((this._desc === undefined) ? 0 : this._desc.getH());
            var offset = (this._bg.getH() - y2 - _x2.scaleValInt( 24 ) - this._pinPad.getH()) / 2;

            this._title.setY ( y0 + offset );

            if( this._desc !== undefined )
                this._desc.setY( y1 + offset );

            this._pinPad.setY( y2 + offset + _x2.scaleValInt( 24 ) );
            this._pinPad.setX( (this._bg.getW() - this._pinPad.getW()) / 2 );
        }
    };

    PinOverlay.setPinFlow = function( type, onFlowComplete, isModify, pin, onDismiss )
    {
        var params = {}, firstOverlay, secondOverlay, thirdOverlay;

        var onGotPin = function( data )
        {
            if( data )
            {
                if( type === PinOverlay.FlowType.PARENTAL_CONTROL )
                {
                    if( data )
                        _x2._pc = data;
                }

                if( data.isEnabled() === false || isModify === true )
                {
                    var onSetPin = function( setPinStr )
                    {
                        var onConfirmPin = function( confirmPinStr )
                        {
                            if( setPinStr === confirmPinStr )
                            {
                                if( type === PinOverlay.FlowType.PARENTAL_CONTROL )
                                {
                                    _x2.popOverlay( secondOverlay, function(){ _x2._hi.fadeOut( 300 ); _x2.pushOverlay( new PinSetOverlay().init( { text:"Your Parental Control PIN is set" } ) ) } );

                                    _x2._pc.setEnabled( true );
                                    _x2._pc.setPin( setPinStr );
                                    _x2._data.setParentalControlsSettings( _x2._pc );
                                }
                                else
                                {
                                    var onGotPin = function( obj )
                                    {
                                        _x2.popOverlay( secondOverlay, function(){ _x2._hi.fadeOut( 300 ); _x2.pushOverlay( new PinSetOverlay().init( { onDismiss:function() { onFlowComplete( obj, setPinStr ); }, text:"Your Purchase PIN is set" } ) ) } );
                                    };

                                    var onGotPinError = function( e )
                                    {
                                        console.error( e );
                                    };

                                    data.setPin( pin, setPinStr ). then( function() { _x2._data.getPurchasePin().then( onGotPin ); }, onGotPinError );
                                }
                            }
                            else
                            {
                                params.type      = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_VERIFY_FAIL : PinOverlay.Type.PURC_VERIFY_FAIL;
                                params.onCapture = onConfirmPin;
                                params.onDismiss = onDismiss;
                                thirdOverlay     = new PinOverlay().init( params );

                                _x2.pushOverlay( thirdOverlay );
                                _x2.popOverlay( secondOverlay );

                                secondOverlay = thirdOverlay;
                            }
                        };

                        if( type === PinOverlay.Type.PC_CREATE && setPinStr === "0000" )
                        {
                            firstOverlay._desc.setText( "This PIN is reserved and cannot be used. Please try a different PIN." );
                            firstOverlay._pinPad.clear();

                            firstOverlay._speakTarget.setText( firstOverlay._desc.getText() );
                            firstOverlay._speakTarget.setSpeechParams( undefined, undefined, firstOverlay, false );
                        }
                        else
                        {
                            params.type      = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_CONFIRM : PinOverlay.Type.PURC_CONFIRM;
                            params.onCapture = onConfirmPin;
                            params.onDismiss = onDismiss;
                            secondOverlay    = new PinOverlay().init( params );

                            _x2.pushOverlay( secondOverlay );
                            _x2.popOverlay( firstOverlay );
                        }
                    };

                    params.type      = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_CREATE : PinOverlay.Type.PURC_CREATE;
                    params.onCapture = onSetPin;
                    params.onDismiss = onDismiss;
                    firstOverlay     = new PinOverlay().init( params );

                    _x2.pushOverlay( firstOverlay );
                }
                else
                {
                    var overlay, lastOverlay;

                    var onValidatePin = function( validatePinStr )
                    {
                        if( type === PinOverlay.FlowType.PARENTAL_CONTROL && _x2._pc.checkPin( validatePinStr ) === true )
                        {
                            _x2.popOverlay( overlay, onFlowComplete );
                        }
                        else if( type === PinOverlay.FlowType.PURCHASE && data.isEnabled() === true )
                        {
                            var onPinValid = function()
                            {
                                _x2.popOverlay( overlay, function() { onFlowComplete( data, validatePinStr ); } );
                            };

                            var onPinError = function( e )
                            {
                                console.log( "PIN not valid" );
                                console.log( e );

                                var remaining;

                                try
                                {
                                    remaining = JSON.parse( e.getDescription() ).attemptsLeft;

                                    console.log( remaining );
                                }
                                catch( error )
                                {
                                    remaining = "?";
                                }

                                if( remaining === "0" )
                                {
                                    _x2.pushOverlay( new AlertOverlay().init( { title:"Your Purchase PIN is locked.", message:"Your Purchase PIN was entered incorrectly five times. You must wait 60 minutes to try again or visit xfin.tv/pin to reset it." } ) );
                                    _x2.popOverlay( overlay );
                                }
                                else
                                {
                                    params.type              = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_VALIDATE_FAIL : PinOverlay.Type.PURC_VALIDATE_FAIL;
                                    params.attemptsRemaining = remaining;
                                    lastOverlay              = overlay;
                                    _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                                    _x2.popOverlay( lastOverlay );
                                }
                            };

                            data.verifyPin( validatePinStr ).then( onPinValid, onPinError );
                        }
                        else
                        {
                            params.type = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_VALIDATE_FAIL : PinOverlay.Type.PURC_VALIDATE_FAIL;
                            lastOverlay = overlay;
                            _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                            _x2.popOverlay( lastOverlay );
                        }
                    };

                    params.type      = ( type === PinOverlay.FlowType.PARENTAL_CONTROL ) ? PinOverlay.Type.PC_VALIDATE : PinOverlay.Type.PURC_VALIDATE;
                    params.onCapture = onValidatePin;
                    params.onDismiss = onDismiss;

                    _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                }
            }
        };

        _x2.requestFocus( new KeyEater().init( _x2._focus ) );

        if( type === PinOverlay.FlowType.PARENTAL_CONTROL )
            _x2._data.getParentalControls().then( onGotPin ).catch( onGotPin );
        else if( type === PinOverlay.FlowType.PURCHASE )
            _x2._data.getPurchasePin().then( onGotPin ).catch( onGotPin );
        else
            console.error( "Unsupported pin flow = " + type );
    };

    return PinOverlay;

})();


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PinSetOverlay = ( function()
{
    "use strict";

    PinSetOverlay.prototype = new Overlay();

    function PinSetOverlay(){}

    PinSetOverlay.prototype.gotFocus = function()
    {
        this._str.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    PinSetOverlay.prototype.init = function( params )
    {
        var self     = this, onLoad;
        var strStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );

        Overlay.prototype.init.call( this, params );
        this._className  = "PinSetOverlay";
        this._numLoaded  = 0;

        onLoad = function() { self._numLoaded++; self.layoutPinSetOverlay(); };

        this._str = new StringWidget().init( { text:params.text, style:strStyle } );
        this._str.addReadyCallback( onLoad );
        this._bg.addWidget( this._str );

        this._icon = new ImageWidget().init( { url: _x2._config._imageRoot + "circleCheck.png", onLoad:onLoad } );
        this._bg.addWidget( this._icon );

        return this;
    };

    PinSetOverlay.prototype.layoutPinSetOverlay = function()
    {
        var spacing = _x2.scaleValInt( 32 );
        var pad     = _x2.scaleValInt( 80 );

        if( this._numLoaded === 2 )
        {
            this.setBgSize( 2 * pad + this._icon.getW() + spacing + this._str.getW(), 2 * pad + this._icon.getH() );

            this._icon.setX( pad );
            this._icon.setY( (this._bg.getH() - this._icon.getH()) / 2 );
            this._str.setX( this._icon.getX() + this._icon.getW() + spacing );
            this._str.setY( (this._bg.getH() - this._str.getH()) / 2 );
        }
    };

    return PinSetOverlay;

})();


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchaseOverlay = (function()
{
    "use strict";

    PurchaseOverlay.prototype = new Overlay();

    function PurchaseOverlay(){}

    PurchaseOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className  = "PurchaseOverlay";

        var offer             = params.offer;
        var entity            = params.entity;
        var optionsOverlay    = params.optionsOverlay;
        var onBuy             = params.onBuy;
        var confirmOverlay    = undefined;
        var metrics           = offer.getLocalyticsCommonTransactional( entity.getType() );
        var distractorOverlay = new DistractorOverlay().init();

        var metricsTransactionalConfirmClicked =
        {
            "Option"      : metrics.option,
            "Final Action": metrics.finalAction
        };

        var self = this;

        var titleStyle    = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var subTitleStyle = new Style( { font:"light"  , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var footerStyle   = new Style( { font:"light"  , color:"#bababa", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var infoStyle     = new Style( { font: "medium", color:"#a3a3a3", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );

        var onBuyPress = function()
        {
            var onTransactionComplete = function( purchasedResponse )
            {
                self._distractor.hide();

                var onWatch = function()
                {
                    var onResolveShowing = function( response )
                    {
                        self._distractor.hide();

                        var showing = new VodShowing().init( JSON.parse( response.data ) );

                        var playVideo = function()
                        {
                            var obj =
                                    {
                                        mode       :VideoScreen.Mode.VOD,
                                        entity     :showing,
                                        url        :showing.getStreamUrl(),
                                        mediaId    :showing.getMediaId(),
                                        programId  :showing.getProgramId(),
                                        paid       :showing.getPaid(),
                                        hasSap     :showing.isSap(),
                                        assetId    :showing.getAssetId(),
                                        providerId :showing.getProviderId(),
                                        mediaGuid  :showing.getMediaGuid()
                                    };

                            //triggers refresh of watch options in EntityActionButtonsWidget on EntityScreen.
                            if( onBuy )
                                onBuy( true );

                            _x2.popOverlay( distractorOverlay );
                            _x2.popOverlay( confirmOverlay, function() { _x2.pushScreen( new VideoScreen().init( obj ) ) } );
                        };

                        if( _x2._pc.isEnabled() === true )
                            _x2.checkParentalControls( showing, entity ).then( playVideo );
                        else
                            playVideo();
                    };

                    var metricsTransactionalWatchNowClicked =
                    {
                        "Option": metrics.option
                    };

                    window.ll( "tagEvent", "Transactional Watch Now Clicked", metricsTransactionalWatchNowClicked );

                    self._distractor.show();
                    offer.getLinkObject("featureAsset").resolve().then( onResolveShowing );
                };

                var onClose = function()
                {
                    if( onBuy )
                        onBuy( false );

                    _x2.popOverlay( distractorOverlay );
                    _x2.popOverlay( confirmOverlay );
                };

                var params = {};
                params.entity  = entity;
                params.offer   = offer;
                params.onWatch = onWatch;
                params.onClose = onClose;

                var metricsTransactionalSuccess =
                {
                    "Option"  : metrics.option,
                    "PIN Used": self._pinRequired ? "Yes" : "No"
                };

                window.ll( "tagEvent", "Transactional Success", metricsTransactionalSuccess );

                if( _x2._splunk )
                    _x2._splunk.sendTransact( true, entity, offer, purchasedResponse );

                confirmOverlay = new PurchaseConfirmOverlay().init( params );

                _x2.popOverlay( self );
                _x2.pushOverlay( confirmOverlay );
            };

            var onTransactionError = function( error )
            {
                self._distractor.hide();

                var major = error.getMajor();
                var minor = error.getMinor();

                if( major === "500" && minor === "100" )  // 500.100 signals pin required; 500.101 signals a failed pin
                {
                    self._transactionInProgress = false;
                    buyNow( true );
                }
                else
                {
                    if( _x2._splunk )
                        _x2._splunk.sendTransact( false, entity, offer, error );

                    _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.TRANSACT, noRetry:true } ) );
                    _x2.popOverlay( distractorOverlay );
                    _x2.popOverlay( self );
                }
            };

            var doTransaction = function( pinObj, pin )
            {
                if( self._transactionInProgress !== true )
                {
                    self._distractor.show();
                    self._menu.setDisabled();
                    self._transactionInProgress = true;
                    offer.executeTransaction( pin ).then( onTransactionComplete ).catch( onTransactionError );
                }
            };

            var buyNow = function( pinChallenge )
            {
                self._pinRequired = pinChallenge;

                window.ll( "tagEvent", "Transactional Confirm Clicked", metricsTransactionalConfirmClicked );

                if( pinChallenge === true )
                {
                    window.ll( "tagEvent", "Transactional PIN", {} );
                    PinOverlay.setPinFlow( PinOverlay.FlowType.PURCHASE, doTransaction, undefined, undefined, function(){ _x2.popOverlay( distractorOverlay ) } );
                }
                else
                    doTransaction();
            };

            _x2.pushOverlay( distractorOverlay );
            _x2.popOverlay( self );
            _x2.popOverlay( optionsOverlay );  // cannot back out to options once buy is pressed, so pop it

            buyNow();  // try to execute without a pin. challenge will come from the API response.
        };

        var onCancel = function()
        {
            metricsTransactionalConfirmClicked[ "Final Action" ] = "[Unfinished]";
//console.log( "LOCALYTICS: Transactional Confirm Clicked: %o", metricsTransactionalConfirmClicked );
            window.ll( "tagEvent", "Transactional Confirm Clicked", metricsTransactionalConfirmClicked );

            _x2.popOverlay( self );
        };

        var onGotPinSettings = function( pinObj )
        {
            self._pinMsg.setA( pinObj.isEnabled() ? 1 : 0);
            self._ready = true;

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._menu ) );
        };

        var onGotPinSettingsError = function( e )
        {
            console.error( e );
            self._ready = true;

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._menu ) );
        };

        var url    = entity.getImageLink( 303, 404 );
        var title  = entity.getTitle();
        var season = offer.isSeasonBundle() ? " Season " : " ";
        var meta   = offer.getPurchaseType() + season + "$" + offer.getPrice() + " " + offer.getVideoQuality();
        var label  = offer.getPurchaseType() + " Now";
        var footer = "Access anytime in the Purchases menu on your favorite devices. View terms at xfinity.com/BuyTerms. Buy to agree.";

        var buttonStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var buy    = new StringWidget().init( { text:label   , style:buttonStyle, onEnter:onBuyPress } );
        var cancel = new StringWidget().init( { text:"Cancel", style:buttonStyle, onEnter:onCancel } );
        var image  = new ImageWidget().init( { url:url, w:_x2.scaleValInt(303), h:_x2.scaleValInt(404) } );

        if( entity && entity.getSeries && offer.isSeasonBundle() === true )
        {
            var series = entity.getSeries();

            if( series )
                title = series.getTitle();
        }

        this._menu   = new HorizPillButtonsWidget().init( { entries:[buy,cancel], spacing:_x2.scaleValInt(41) } );
        this._title  = new StringWidget().init( { style:titleStyle   , text:title  } );
        this._meta   = new StringWidget().init( { style:subTitleStyle, text:meta   } );
        this._footer = new StringWidget().init( { style:footerStyle  , text:footer } );
        this._pinMsg = new StringWidget().init({ style:infoStyle, text: Strings.Glyphs.LOCKED + " Purchase PIN is required" } );
        this._pinMsg.setA(0);

        var xCoords = [ _x2.scaleValInt(80), _x2.scaleValInt(433) ];
        var yCoords = [ _x2.scaleValInt(80), _x2.scaleValInt(142), _x2.scaleValInt(396), _x2.scaleValInt(586), _x2.scaleValInt(630) ];

        this._bg.addWidget( image        , xCoords[0], yCoords[0] );
        this._bg.addWidget( this._title  , xCoords[1], yCoords[0] );
        this._bg.addWidget( this._meta   , xCoords[1], yCoords[1] );
        this._bg.addWidget( this._menu   , xCoords[1], yCoords[2] );
        this._bg.addWidget( this._pinMsg , xCoords[0], yCoords[3] );
        this._bg.addWidget( this._footer , xCoords[0], yCoords[4] );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ) } );
        this.addWidget(this._distractor);

        _x2._data.getPurchasePin().then( onGotPinSettings, onGotPinSettingsError );

        return this;
    };

    PurchaseOverlay.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
        this.speak( this._ready ? _x2.requestFocus( this._menu ) : undefined );
    };

    PurchaseOverlay.prototype.speak = function( focus )
    {
        if( focus )
        {
            var str = this._pinMsg.getText().replace( /xfinity/gi, "x finity" );

            this._speakTarget.setText( "Confirm purchase. " + this._title.getText() + ". " + this._meta.getText() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( (this._pinMsg.getA() === 1 ? str + ". " : "") + this._footer.getText().replace( /xfinity/gi, "x finity" ) + ". Press left or right to review options. Press OK to select. Press back to exit. ", focus._speakRole, this, false );
        }
        else
        {
            this._speakTarget.setText( "Loading, please wait. " );
            this._speakTarget.setSpeechParams( undefined, undefined, this, false );
        }
    };

    return PurchaseOverlay;

})();


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchaseOptionsOverlay = ( function()
{
    "use strict";

    PurchaseOptionsOverlay.prototype = new Overlay();

    function PurchaseOptionsOverlay(){}

    PurchaseOptionsOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( "Purchase Options for " + this._title.getText() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select. Press back to exit. ", focus._speakRole, this, false );
    };

    PurchaseOptionsOverlay.prototype.init = function( entity, onBuy )
    {
        Overlay.prototype.init.call( this );
        this._className = "PurchaseOptionsOverlay";

        this._entity  = entity;
        this._options = entity.getEntityOptions().getTransactionOffers();

        var title, series;
        var listParams = {};
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var infoStyle  = new Style( { font: "medium" , color: "#a3a3a3", fontSize: _x2.scaleValInt( 24 ), whiteSpace: "nowrap" } );

        listParams.w        = this._bg.getW() - Style._safeLeft - Style._safeRight;
        listParams.h        = this._bg.getH() - Style._safeBottom - _x2.scaleValInt(120);
        listParams.maxIndex = 1;
        listParams.obj      = { entity:entity, overlay:this, onBuy:onBuy };
        listParams.rows     = this._options;
        listParams.type     = PurchaseOfferRowWidget;

        title = entity.getTitle();

        if( entity && entity.getSeries )
        {
            series = entity.getSeries();

            if( series )
                title = series.getTitle();
        }

        this._title         = new StringWidget().init({text:title, style:titleStyle});
        this._list          = new ListWidget().init( listParams );
        this._divider       = new RectWidget().init( { w:listParams.w, h:ListRowWidget.DIVIDER_H, color:"#262626" } );

        this._infoString    = new StringWidget().init( { text:"", style: infoStyle } );

        this._bg.addWidget( this._title     , Style._safeLeft, Style._safeTop                        );
        this._bg.addWidget( this._infoString, Style._safeLeft, Style._safeTop + _x2.scaleValInt( 60) );
        this._bg.addWidget( this._list      , Style._safeLeft, Style._safeTop + _x2.scaleValInt(110) );
        this._bg.addWidget( this._divider   , Style._safeLeft, Style._safeTop + _x2.scaleValInt(110) );

        return this;
    };

    PurchaseOptionsOverlay.prototype.setInfo = function( str )
    {
        this._infoString.setText( str );
    };

    return PurchaseOptionsOverlay;

})();


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchaseConfirmOverlay = (function()
{
    "use strict";

    PurchaseConfirmOverlay.prototype = new Overlay();

    function PurchaseConfirmOverlay(){}

    PurchaseConfirmOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons );
        var str   = this._titleString.getText() + ". ";

        if( this._subTitleString )
            str += this._subTitleString.getText() + ". ";

        this._speakTarget.setText( str + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to review options. Press OK to select. Press back to dismiss.", focus._speakRole, this, false );
    };

    PurchaseConfirmOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className = "PurchaseConfirmOverlay";

        var entity  = params.entity;
        var offer   = params.offer;
        var onWatch = params.onWatch;
        this._onClose = params.onClose;

        var self = this;

        var titleStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap", textAlign:"center" } );
        var subTitleStyle = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle   = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000"  } );

        var title = "Enjoy",
            subTitle,
            entityTitle,
            buttons = [];

        if( offer.getOfferType() === "SeasonBundle" )
        {
            entityTitle = offer.getTitle();

            if( entityTitle.indexOf("Buy ") === 0 )
                entityTitle = entityTitle.replace( "Buy ", "");
        }
        else
        {
            var series = entity.getSeries();

            if( series && series.getTitle() )
                entityTitle = series.getTitle() + " - " + entity.getTitle();
            else
                entityTitle = entity.getTitle();

            buttons.push( new StringWidget().init( { text:"Watch Now", style:buttonStyle, onEnter:onWatch } ) );
        }

        buttons.push( new StringWidget().init( { text:"Dismiss"  , style:buttonStyle, onEnter:self._onClose } ) );

        if( offer.getPurchaseType() === "Buy" )
            subTitle = entityTitle + " has been purchased for $" + offer.getPrice() + ". Access anytime from Saved > Purchases.";
        else
            subTitle = entityTitle + " has been rented for $" + offer.getPrice() + ". You have " + offer.getRentalWindowInHours() + " hours to watch. Access your rental from Saved > For You.";

        var w = this._bg.getW() - Style._safeLeft - Style._safeRight;
        var h = _x2.scaleValInt( 80 );

        this._titleString    = new StringWidget().init({text:title, style:titleStyle});
        this._subTitleString = new TextBlockWidget().init( { w:w, h:h, text:subTitle, style:subTitleStyle, ellipsis:true } );
        this._buttons        = new HorizPillButtonsWidget().init( { entries:buttons, spacing:_x2.scaleValInt(41) } );

        this._bg.addWidget(this._titleString   , 0, Style._safeTop + _x2.scaleValInt(163) );
        this._bg.addWidget(this._subTitleString, 0, Style._safeTop + _x2.scaleValInt(245) );
        this._bg.addWidget(this._buttons       , 0, Style._safeTop + _x2.scaleValInt(420) );

        this._buttons.addReadyCallback(function(){self.layout()});

        return this;
    };

    PurchaseConfirmOverlay.prototype.layout = function()
    {
        var center = this._bg.getW() / 2;

        this._buttons.setX( center - this._buttons.getW() / 2 );
        this._titleString.setX( center - this._titleString.getW() / 2 );
        this._subTitleString.setX( center - this._subTitleString.getW() / 2 );
    };

    PurchaseConfirmOverlay.prototype.processEvent = function( val, type )
    {
        //intercept KEY_LAST and fire onClose. NOTE: onClose will pop this overlay, so don't allow Overlay to handle it.
        if( type === Host.KEY_PRESSED && val === Host.KEY_LAST )
        {
            if( this._onClose )
                this._onClose();
        }
        else
            Overlay.prototype.processEvent.call( this, val, type );
    };

    return PurchaseConfirmOverlay;

})();


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RecordingOptionsOverlay = ( function()
{
    "use strict";

    RecordingOptionsOverlay.prototype = new Overlay();

    function RecordingOptionsOverlay(){}

    RecordingOptionsOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons, true );
        this._speakTarget.setText( "Record Options. " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press right or left to review options. Press OK to select. Press down to review recording options. Press back to dismiss.", focus._speakRole, this, false );
    };

    /**
     * Initialize RecordingOptionsOverlay
     * @param params
     * @param params.entity   {Entity}   - the entity
     * @param params.form     {Form}     - the recording form to use where
     * @param params.callback {function} - callback function to call after updating recording
     */
    RecordingOptionsOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className = "RecordingOptionsOverlay";
        this._rows = [];

        var self = this,
            title,
            thumbUrl,
            thumbFallbackUrl,
            entity;

        if( params.entity.getType() === XtvApi.EntityType.EPISODE )
            entity = params.entity.getSeries();

        if( entity === undefined )
            entity = params.entity;

        title            = entity.getTitle();
        thumbUrl         = entity.getImageLink(303,404);
        thumbFallbackUrl = entity.getFallbackImageLink(303,404);

        var onOptionChange = function( obj, form )
        {
            form.setFieldValue( obj.f.getName(), obj.o.getName() )
        };

        var onConfirm = function( form )
        {
            self._distractor.show();
            params.callback( form, self );
        };

        var onPosterError = function()
        {
            if( thumbFallbackUrl )
            {
                if( posterImage.getUrl() === thumbFallbackUrl )
                    posterImage.setA(0);
                else
                    posterImage.setUrl(thumbFallbackUrl)
            }
            else
                posterImage.setA(0);
        };

        var onPosterLoaded = function()
        {
            posterImage.setA(1);
        };

        var form   = params.form;
        var fields = form.getFields();

        var titleStyle     = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var subTitleStyle  = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000"  } );

        this._titleString  = new StringWidget().init({text:title, style:titleStyle});
        var subTitleString = new StringWidget().init({text:"Record Options", style:subTitleStyle});
        var posterImage    = new ImageWidget().init({url:thumbUrl, w:_x2.scaleValInt(303), h:_x2.scaleValInt(404), onError:onPosterError, onLoad:onPosterLoaded });

        var btnConfirm     = new StringWidget().init( { text:"Confirm", style:buttonStyle, onEnter:function(){ onConfirm(form) } } );
        var btnClose       = new StringWidget().init( { text:"Close" , style:buttonStyle, onEnter:function() { _x2.popOverlay(); } } );
        this._buttons      = new HorizPillButtonsWidget().init( { entries:[btnConfirm,btnClose], spacing:_x2.scaleValInt(41) } );

        posterImage.setA( 0 );

        this._bg.addWidget(this._titleString, Style._safeLeft, Style._safeTop );
        this._bg.addWidget(subTitleString, Style._safeLeft, Style._safeTop + _x2.scaleValInt(60) );
        this._bg.addWidget(posterImage   , Style._safeLeft, Style._safeTop + _x2.scaleValInt(120) );
        this._bg.addWidget(this._buttons , _x2.scaleValInt(500), Style._safeTop );

        this._buttons.addReadyCallback(function(){self.layout()});

        //configure and add the recording options UI
        var label, opt, opts, keys, val;

        var w0 = _x2.scaleValInt(450);
        var h0 = _x2.scaleValInt(90);
        var x1 = _x2.scaleValInt(303) + Style._safeLeft + _x2.scaleValInt(52);
        var x0 = this._bg.getW() - w0 - Style._safeLeft;
        var w1 = this._bg.getW() - x1 - Style._safeRight;
        var y0 = Style._safeTop + _x2.scaleValInt(120);
        var labelCenter = h0/2 - _x2.scaleValInt(30)/2;

        this._fields = [];
        this._fieldIdx = -1;

        //for each option, add a new HorizSelectionWidget with form field options as entries
        for( var i=0; i<fields.length; i++ )
        {
            if( fields[i].getType() !== 'HIDDEN' )
            {
                keys = [];
                opts = fields[i].getOptions();
                val  = fields[i].getValue();

                for( var q=0; q<opts.length; q++ )
                    keys.push( { obj:{ f:fields[i], o:opts[q] }, key:opts[q].getName(), label:opts[q].getLabel() } )

                label = new StringWidget().init( { style:subTitleStyle, text:fields[i].getLabel() } );
                opt   = new HorizSelectionWidget().init( { width:w0, height:h0, entries:keys, defaultValue:val, onChange:function(obj){ onOptionChange(obj, form) } } );

                this._rows.push( label );
                this._fields.push(opt);

                this._bg.addWidget( new RectWidget().init({w:w1, h:1, color:'#363636'}), x1, y0 );
                this._bg.addWidget( label, x1, y0 + labelCenter  );
                this._bg.addWidget( opt  , x0, y0 );

                y0 += h0;
            }
        }

        this._bg.addWidget(new RectWidget().init({w:w1, h:1, color:'#363636'}), x1, y0);

        //enlarge and recenter overlay _bg in case the options exceed the bounds of _bg
        if( y0 > ( this._bg.getH() - Style._safeBottom ) )
        {
            var offsetHeight = ( y0 - this._bg.getH() + Style._safeBottom ) / 2;
            this._bg.setH( y0 + Style._safeBottom);
            this._bg.setY( this._bg.getY() - offsetHeight);
        }

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ) } );
        this.addWidget(this._distractor);

        return this;
    };

    RecordingOptionsOverlay.prototype.layout = function()
    {
        var buttonX = this._bg.getW() - this._buttons.getW() - Style._safeRight;
        var titleW  = buttonX - Style._safeLeft - Style._pad;

        this._buttons.setX( buttonX );
        this._titleString.setW( titleW );
    };

    RecordingOptionsOverlay.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._fieldIdx >= 0 )
                        this._fieldIdx--;

                    if( this._fieldIdx < 0 )
                        _x2.requestFocus( this._buttons );
                    else
                        this.speakFields( _x2.requestFocus( this._fields[this._fieldIdx] ), this._fieldIdx );
                }
                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._fieldIdx < this._fields.length - 1)
                    {
                        this._fieldIdx++;
                        this.speakFields( _x2.requestFocus( this._fields[this._fieldIdx], true ), this._fieldIdx );
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    RecordingOptionsOverlay.prototype.speakFields = function( focus, index )
    {
        this._speakTarget.setText( this._rows[index].getText() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to review items. ", focus._speakRole, this, false );
    };

    return RecordingOptionsOverlay;

})();


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ResetParentalOverlay = ( function()
{
    "use strict";

    ResetParentalOverlay.prototype = new Overlay();

    function ResetParentalOverlay(){}

    ResetParentalOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons );
        this._speakTarget.setText( this._title.getText() + ". " + this._desc.getText() + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press right or left to review options. Press OK to select.", focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof ResetParentalOverlay
     * @param   {Object}    params
     * @param   {Function} [params.onEnter] - Function called when reset is selected
     * @returns {ResetParentalOverlay}
     */

    ResetParentalOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init. call( this );
        this._className  = "ResetParentalOverlay";

        var self        = this, onReady, reset, cancel;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(45), whiteSpace:"nowrap", textAlign:"center" } );
        var descStyle   = new Style( { font:"light" , color:"#9b9b9b", fontSize:_x2.scaleValInt(27), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );
        var w           = this._bg.getW();
        var title       = "Reset Parental Controls";
        var desc        = "Resetting parental control will remove all restrictions currently set on this device.";

        this._numReady = 0;

        onReady = function() { self._numReady++; self.layoutResetParentalOverlay() };
        reset   = new StringWidget().init( { text:"Reset" , style:buttonStyle, onEnter:params.onEnter   } );
        cancel  = new StringWidget().init( { text:"Cancel", style:buttonStyle, onEnter:function() { _x2.popOverlay(); } } );

        this._title = new StringWidget().init( { text:title, style:titleStyle } );
        this._title.setW( w );
        this._title.addReadyCallback( onReady );
        this._bg.addWidget( this._title );

        this._desc = new TextBlockWidget().init( { text:desc, style:descStyle, w:w/2 } );
        this._bg.addWidget( this._desc, w/4 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[reset,cancel], spacing:_x2.scaleValInt(41) } );
        this._buttons.addReadyCallback( onReady );
        this._bg.addWidget( this._buttons );

        return this;
    };

    ResetParentalOverlay.prototype.layoutResetParentalOverlay = function()
    {
        if( this._numReady === 2 )
        {
            var y0     = 0;
            var y1     = y0 + this._title.getH();
            var y2     = y1 + ((this._desc === undefined) ? 0 : this._desc.getH());
            var offset = (this._bg.getH() - y2 - _x2.scaleValInt( 24 ) - this._buttons.getH()) / 2;

            this._title.setY ( y0 + offset );

            if( this._desc !== undefined )
                this._desc.setY( y1 + offset );

            this._buttons.setY( y2 + offset + _x2.scaleValInt( 24 ) );
            this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
        }
    };

    return ResetParentalOverlay;

})();


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SignOutOverlay = ( function()
{
    "use strict";

    SignOutOverlay.prototype = new Overlay();

    function SignOutOverlay(){}

    SignOutOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons, true );
        var str   = this._title.getText().replace( /xfinity/gi, "x finity" );

        this._speakTarget.setText( str + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press right or left to review options. Press OK to select.", focus._speakRole, this, false );
    };

    SignOutOverlay.prototype.init = function()
    {
        var onCancel, onSignOut, cancel, signOut;
        var self        = this;
        var titleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle = new Style( { font:"regular" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000" } );

        Overlay.prototype.init.call( this );
        this._className  = "SignOutOverlay";

        this._title = new StringWidget().init( { text:"Are you sure that you want to Sign Out?", style:titleStyle } );
        this._title.setW( this._bg.getW() );
        this._bg.addWidget( this._title, 0, _x2.scaleVal( 243 ) );

        onCancel = function()
        {
            _x2.popOverlay();
        };

        onSignOut = function()
        {
            ll( "tagEvent", "Session Ended" ); // TODO: minutes?

            _x2.setScreen( new TransitionScreen().init( { signOut:true } ) );
        };

        cancel  = new StringWidget().init( { text:"No" , style:buttonStyle, onEnter:onCancel  } );
        signOut = new StringWidget().init( { text:"Yes", style:buttonStyle, onEnter:onSignOut } );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[cancel, signOut], spacing:_x2.scaleValInt(40) } );
        this._buttons.addReadyCallback( function() { self.layoutSignOutOverlay(); } );
        this._bg.addWidget( this._buttons );

        return this;
    };

    SignOutOverlay.prototype.layoutSignOutOverlay = function()
    {
        var gap = _x2.scaleVal( 50 );
        var h   = this._title.getH() + gap + this._buttons.getH();
        var y   = (this._bg.getH() - h) / 2;

        this._title.setY( y );
        this._buttons.setY( y + this._title.getH() + gap );
        this._buttons.setX( (this._bg.getW() - this._buttons.getW()) / 2 );
    };

    return SignOutOverlay;

})();


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SubscribeOverlay = (function()
{
    "use strict";

    SubscribeOverlay.prototype = new Overlay();

    function SubscribeOverlay(){}

    /**
     * Init overlay
     * @param {TransactionOffer} offer
     * @return {SubscribeOverlay}
     */
    SubscribeOverlay.prototype.init = function( offer )
    {
        Overlay.prototype.init.call( this );
        this._className  = "SubscribeOverlay";

        var self = this;

        var close = function()
        {
            _x2.popOverlay( self );
        };

        var xCoords = [ _x2.scaleValInt(80), _x2.scaleValInt(433) ];
        var yCoords = [ _x2.scaleValInt(80), _x2.scaleValInt(126), _x2.scaleValInt(196), _x2.scaleValInt(400), _x2.scaleValInt(630) ];

        var infoStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var titleStyle   = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var messageStyle = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var footerStyle  = new Style( { font:"medium", color:"#bababa", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var buttonStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );

        var imgW = _x2.scaleValInt(303);
        var imgH = _x2.scaleValInt(404);

        var textBlockW = this._bg.getW() - _x2.scaleValInt(513);
        var textBlockH = yCoords[3] - yCoords[2];

        var alphas   = [ { opacity:100    , location:0 }, { opacity:100    , location:100 } ];
        var colors   = [ { color:"#1C262F", location:0 }, { color:"#130917", location:100 } ];
        var imageBg  = new GradientWidget().init( { alphas:alphas, angle:-135, colors:colors, w:imgW, h:imgH, type:GradientWidget.Type.Linear } );
        var imageUrl = offer.getContentProvider().getLogoUrl( 303, 404 );
        var subUrl   = ( _x2._features.getUserType() === "stream" ? "xfin.tv/add" : "xfin.tv/subscribe" );

        var imageLoaded = function()
        {
            var maxW   = Math.round(imgH * 0.5);
            var maxH   = Math.round(imgW * 0.5);
            var aspect = maxW / maxH;

            if( aspect > self._image.getW() / self._image.getH() )
                self._image.setH( maxH );
            else
                self._image.setW( maxW );

            self._image.setX( xCoords[0] + (imgW - self._image.getW()) / 2 );
            self._image.setY( yCoords[0] + (imgH - self._image.getH()) / 2 );
            self._image.setA( 1 );
        };

        this._info    = new StringWidget().init( { style:infoStyle   , text:"This Requires an Upgrade" } );
        this._title   = new StringWidget().init( { style:titleStyle  , text:offer.getTitle() } );
        this._footer  = new StringWidget().init( { style:footerStyle , text: Strings.Glyphs.LOCKED + " Purchase PIN can be added in Settings" } );
        this._message = new TextBlockWidget().init( { style:messageStyle, w:textBlockW, h:textBlockH, text:"To watch this channel you'll need to upgrade your channel package. Go to <font color='#f3f3f3'><b>" + subUrl + "</b></font> to select what channels you'd like to add to your lineup." } );
        this._image   = new ImageWidget().init( { url:imageUrl, onLoad:imageLoaded } );

        this._image.setA(0);

        var button  = new StringWidget().init( { text:"Back", style:buttonStyle, onEnter:close } );
        this._menu  = new HorizPillButtonsWidget().init( { entries:[button], spacing:_x2.scaleValInt(41) } );

        this._bg.addWidget( imageBg       , xCoords[0], yCoords[0] );
        this._bg.addWidget( this._image   , xCoords[0], yCoords[0] );
        this._bg.addWidget( this._info    , xCoords[1], yCoords[0] );
        this._bg.addWidget( this._title   , xCoords[1], yCoords[1] );
        this._bg.addWidget( this._message , xCoords[1], yCoords[2] );
        this._bg.addWidget( this._menu    , xCoords[1], yCoords[3] );
        this._bg.addWidget( this._footer  , xCoords[0], yCoords[4] );

        return this;
    };

    SubscribeOverlay.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
        this.speak( _x2.requestFocus( this._menu ) );
    };

    SubscribeOverlay.prototype.speak = function( focus )
    {
        this._speakTarget.setText( this._info.getText() + ". " + this._title.getText() + ". " + this._message.getText().replace( /xfinity/gi, "x finity" ) + this._footer.getText().replace( Strings.Glyphs.LOCKED, "" ) + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press OK to dismiss. ", focus._speakRole, this, false );
    };

    return SubscribeOverlay;

})();


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PolicyLinksOverlay = ( function()
{
    "use strict";

    var sectionMap = {
      terms: function(descStyle, urlStyle) {
        return [
          [
            {
              text: 'To read Xfinity Stream\'s License Agreement go to',
              style: descStyle
            },
            {
              text: _x2._config._isSmbUser === true ? 'https://business.comcast.com/terms-conditions-smb' : 'my.xfinity.com/terms',
              style: urlStyle
            }
          ]
        ];
      },

      ccpaTerms: function(descStyle, urlStyle) {
        return [
          [
            {
              text: 'To read Xfinity Stream\'s License Agreement go to',
              style: descStyle
            },
            {
              text: _x2._config._isSmbUser === true ? 'https://business.comcast.com/terms-conditions-smb' : 'my.xfinity.com/terms',
              style: urlStyle
            }
          ]
        ];
      },

      privacy: function(descStyle, urlStyle) {
        return [
          [
            {
              text: 'Visit these links to learn more about Comcast Privacy:',
              style: descStyle
            }
          ],
          [
            {
              text: 'Privacy Center',
              style: descStyle
            },
            {
              text: 'www.xfinity.com/privacy',
              style: urlStyle
            }
          ],
          [
            {
              text: 'Privacy Policy',
              style: descStyle
            },
            {
              text: _x2._config._isSmbUser === true ? 'https://business.comcast.com/privacy-statement' : 'www.xfinity.com/privacy/policy',
              style: urlStyle
            }
          ],
          [
            {
              text: 'Cal. Civ. Code §1798.135: Do Not Sell My Info',
              style: descStyle
            },
            {
              text: 'www.xfinity.com/privacy/manage-preference',
              style: urlStyle
            }
          ]
        ];
      }
    };

    PolicyLinksOverlay.prototype = new Overlay();

    function PolicyLinksOverlay(){}

    PolicyLinksOverlay.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();

        var str = this._sections.map(function(section) {
          return section.map(function(line) {
            return line.element.getText();
          }).join(' ') + '.';
        }).join(' ');

        str = str.replace( /xfinity/gi, "x_finity" );

        this._speakTarget.setText( str );
        this._speakTarget.setSpeechParams( "Press back to dismiss.", undefined, this, false );
    };

    PolicyLinksOverlay.prototype.init = function(options)
    {
        Overlay.prototype.init.call( this );
        this._className  = "PolicyLinksOverlay";

        var self      = this;
        var descStyle = new Style( { font:"regular", color:"#a3a3a3", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } );
        var urlStyle  = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", textAlign:"center" } );
        var onLoad    = function() { self._numLoaded++; self.layoutPolicyLinksOverlay() };

        this._numLoaded = 0;

        this._sections = sectionMap[options.type](descStyle, urlStyle);

        this._sections.forEach(function(section) {
          section.forEach(function(line) {
            line.element = new StringWidget().init(line);
            this._bg.addWidget(line.element);
          }.bind(this));
        }.bind(this));

        var lastSection = this._sections[this._sections.length - 1];
        this._lastLine = lastSection[lastSection.length - 1];

        this._lastLine.element.addReadyCallback(onLoad);
        
        var iconImage = (options.type == 'privacy')? 'settingsTermsPolicyIcon.png' : 'termsIcon.png';
        this._image = new ImageWidget().init( { url:_x2._config._imageRoot + iconImage, onLoad:onLoad } );
        this._bg.addWidget( this._image );

        return this;
    };

    PolicyLinksOverlay.prototype.layoutPolicyLinksOverlay = function()
    {
        if( this._numLoaded === 2 )
        {
          var sectionSpacing = _x2.scaleValInt(54);

          this._sections.reduce(function(posY, section) {
            return sectionSpacing + section.reduce(function(posY, line) {
              line.w = line.element.getW();
              line.h = line.element.getH();
              line.y = posY;

              return posY + line.h;
            }, posY);
          }, 0);

          var textW = this._sections.reduce(function(memo, section) {
            return section.reduce(function(memo, line) {
              return Math.max(memo, line.w);
            }, memo);
          }, 0);
          var textH = this._lastLine.y + this._lastLine.h;
          var bgW = this._bg.getW();
          var bgH = this._bg.getH();
          var imW = this._image.getW();
          var imH = this._image.getH();
          var imX = (bgW - imW - textW) / 3;
          var imY = (bgH - imH) / 2;
          var w = bgW - imX - imW;
          var x = imX + imW;

          this._image.setX(imX);
          this._image.setY(imY);

          var textOffset = (bgH - textH) / 2;
          this._sections.forEach(function(section) {
            section.forEach(function(line) {
              line.element.setW(w);
              line.element.setX(x);
              line.element.setY(line.y + textOffset);
            });
          });
        }
    };

    return PolicyLinksOverlay;

})();


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TwoOptionsOverlay = (function()
{
    "use strict";

    TwoOptionsOverlay.prototype = new Overlay();

    function TwoOptionsOverlay(){}

    TwoOptionsOverlay.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._buttons );
        var str   = this._titleString.getText() + ". ";

        if( this._subTitleString )
            str += this._subTitleString.getText() + ". ";

        this._speakTarget.setText( str + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to review options. Press OK to select. Press back to dismiss.", focus._speakRole, this, false );
    };

    /**
     * Initialize TwoOptionsOverlay
     * @param params
     * @param params.title {string}
     * @param params.subTitle {string}
     * @param params.callback {function}
     * @param params.button1 {Object}
     * @param params.button2 {Object}
     */
    TwoOptionsOverlay.prototype.init = function( params )
    {
        Overlay.prototype.init.call( this );
        this._className = "TwoOptionsOverlay";

        var self    = this;
        var buttonY = _x2.scaleValInt(260);

        var titleStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap", textAlign:"center" } );
        var subTitleStyle = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"center" } );
        var buttonStyle   = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000"  } );

        var buttons = [
            new StringWidget().init( { text:params.button1.text, style:buttonStyle, onEnter:function(){ onSubmit(params.button1.key) } } ),
            new StringWidget().init( { text:params.button2.text, style:buttonStyle, onEnter:function(){ onSubmit(params.button2.key) } } )
        ];

        var onSubmit = function( choice )
        {
            params.callback( choice );
        };

        this._titleString = new StringWidget().init({text:params.title, style:titleStyle});
        this._bg.addWidget(this._titleString, Style._safeLeft, Style._safeTop + _x2.scaleValInt(163) );

        if( params.subTitle && params.subTitle.length )
        {
            var w = this._bg.getW() - Style._safeLeft - Style._safeRight;
            var h = _x2.scaleValInt( 80 );

            this._subTitleString = new TextBlockWidget().init( { w:w, h:h, text:params.subTitle, style:subTitleStyle, ellipsis:true } );
            this._bg.addWidget(this._subTitleString, Style._safeLeft, Style._safeTop + _x2.scaleValInt(245) );

            buttonY =_x2.scaleValInt( 360 );
        }

        this._buttons = new HorizPillButtonsWidget().init( { entries:buttons, spacing:_x2.scaleValInt(41) } );
        this._bg.addWidget(this._buttons, Style._safeLeft, Style._safeTop + buttonY );

        this._buttons.addReadyCallback(function(){self.layout()});

        return this;
    };

    TwoOptionsOverlay.prototype.layout = function()
    {
        var center = this._bg.getW() / 2;

        this._buttons.setX( center - this._buttons.getW() / 2 );
        this._titleString.setX( center - this._titleString.getW() / 2 );

        if( this._subTitleString )
            this._subTitleString.setX( center - this._subTitleString.getW() / 2 );
    };

    return TwoOptionsOverlay;

})();


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * Base for all screens
 * @class
 */
window.Screen = ( function()
{
    "use strict";

    Screen.prototype = new Widget();

    function Screen(){}

    Screen.prototype.destroy = function()
    {
        _x2.removeChangeCallback( this._timeCallback );

        Widget.prototype.destroy.call( this );
    };

    Screen.prototype.getBgImage = function()
    {
        return this._image;
    };

    Screen.prototype.getBreadCrumb = function()
    {
        var base   = this._bcBase.getText();
        var term   = this._bcTerm.getText();
        var retval = base ? base : "";

        if( term )
            retval += term;

        return retval;
    };

    /**
     * @memberof Screen
     * @returns {StringWidget}
     */
    Screen.prototype.getBreadCrumbsTermStr = function()
    {
        return this._termStr;
    };

    /**
     * Gets the y value of the bottom of the header
     * @memberof Screen
     * @returns {Number}
     */
    Screen.prototype.getHeaderBottom = function()
    {
        return (this._time) ? this._time.getY() + this._time.getH() + 3 * Style._pad : this._headerY;
    };

    Screen.prototype.hideDistractor = function()
    {
        this._distractorCount--;

        if( this._distractorCount === 0 )
            this._distractor.hide();
    };

    Screen.prototype.setHeaderFilters = function( filters )
    {
        this._filters = filters;
        this.setTimeStr();
    };

    Screen.prototype.setTimeStr = function()
    {
        var str, filters = this._filters;

        if( filters )
        {
            for( var key in filters )
                if( filters[key] === true )
                {
                    key = FilterChannelsOverlay.FilterStrs[key];

                    if( key )
                        str = (str === undefined) ? "Filtered by: <font color='#2B9CD8'>" + key : str + ", " + key;
                    else
                        console.error( "Unknown filter = " + key );
                }

            if( str )
                str += "</font> | ";
        }

        this._time.setText( str ? str + _x2.createTimeStr() : _x2.createTimeStr() );
    };

    Screen.prototype.showDistractor = function()
    {
        var self = this;

        if( ! this._distractor )
        {
            this._distractorCount = 0;

            this._distractor = new DistractorWidget().init();
            this._distractor.addReadyCallback( function() { self._distractor.centerOnScreen() } );
            this.addWidget( this._distractor );
            this._distractor.patchWidget();
        }

        this._distractorCount++;

        if( this._distractorCount === 1 )
            this._distractor.show();
    };

    /**
     * Initializer
     * <p>
     * Optional breadcrumb is displayed as: "<path> / <folder>"
     * @memberof Screen
     * @param {Object } [params]
     * @param {String } [params.baseStr       ] - "path" name
     * @param {String } [params.termStr       ] - "folder" name
     * @param {Boolean} [params.noHeader=false] - Hide breadcrumb header in top left along with time
     * @param {Boolean} [params.noBg=false    ] - Hide the solid background color
     * @param {Boolean} [params.noSep=false   ] - Hide the solid background color
     * @param {String } [params.image         ] - Load the specified image in front of the background
     * @param {String } [params.imageAlpha    ] - Set the alpha value of the image
     */
    Screen.prototype.init = function( params )
    {
        var timeStyle, bcStyle, touchW, headerY, bgParams, self = this;

//         if( this._className === undefined )
//             this._className = (params && params.name) ? params.name : "Screen";

        Widget.prototype.init.call( this );
        this._className = "Screen";

        if( !params || !params.noBg )
        {
            bgParams  = {
                            w     : _x2._config._screenW,
                            h     : _x2._config._screenH,
                            color : "#000000"
                        };

            this._bg = new RectWidget().init( bgParams );
//            this._bg.setVal( Widget.ALPHA, 0.8 );
            this.addWidget( this._bg );
        }

        if( params && params.image )
        {
            this._imageAlpha = params.imageAlpha !== undefined ? params.imageAlpha : 1;

            this._image = new ImageWidget().init( { url:params.image, onLoad:function() { self._image.animate( { a:self._imageAlpha, duration:500 } ); } } );
            this._image.setA( 0 );
            this.addWidget( this._image );
        }

        headerY = [ 31, 35, 47, 70 ][_x2._config._layout];

        if( !params || !params.noHeader )
        {
            bcStyle   = new Style( { font:"light", color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"pre" } );
            timeStyle = new Style( { font:"light", color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", textAlign:"right" } );
            touchW    = Math.floor( Style._safeLeft * 2 / 3 );


            this._bcBase = new StringWidget().init( { style:bcStyle } );
            this._bcTerm = new StringWidget().init( { style:bcStyle } );
            this._time   = new StringWidget().init( { text:_x2.createTimeStr(), style:timeStyle } );
            this._moreLeft  = new MoreTargetWidget().init( { dir:MoreTargetWidget.Dir.LEFT, size:MoreTargetWidget.Size.SMALL, h:100, w:touchW } );
            this._moreLeft.setA( 0 );
            this._moreLeft.setMouseDownListener ( function() { console.log( "BACK BACK BACK" ); _x2.popTopOfstack() } );

            this._bcTerm.setVal( Widget.FONT_COLOR, "#2ea0dd" );
            this._bcBase.addReadyCallback( function() { self.screenLayout(); } );
            this._time.setW( _x2._config._screenW/2 );

            this.addWidget( this._bcBase, Style._safeLeft, headerY );
            this.addWidget( this._bcTerm, Style._safeLeft, headerY );
            this.addWidget( this._time , _x2._config._screenW / 2 - Style._safeRight, headerY );
            this.addWidget( this._moreLeft, Style._safeLeft - touchW );

            if( params )
                this.setBreadCrumbs( params.baseStr, params.termStr );

            this._timeCallback = function() { self.setTimeStr(); };

            _x2.addChangeCallback( this._timeCallback );
        }
        else
            this._headerY = headerY;

        if( !params || !params.noSep )
        {
            this._sep = new RectWidget().init( { w:_x2._config._screenW - Style._safeLeft - Style._safeRight, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
            this.addWidget( this._sep, Style._safeLeft );
        }

        if( this instanceof StackScreen === false )
        {
            this._speakTarget = new StringWidget().init( { style:timeStyle } );
            this._speakTarget.setA( 0 );
            this.addWidget( this._speakTarget );
        }

        this.setW( _x2._config._screenW );
        this.setH( _x2._config._screenH );
        this.setMouseDownListener( Config.NOP );

        this._selectable = true;

        return this;
    };

    Screen.prototype.screenLayout = function()
    {
        if( this._termStr )
            this._bcTerm.setX( this._baseStr ? Style._safeLeft + this._bcBase.getW() : Style._safeLeft );

        if( this._sep )
            this._sep.setY( this.getHeaderBottom() - this._sep.getH() );

        this._moreLeft.setH( 2 * this._time.getH() );
        this._moreLeft.setY( this._time.getY() - this._time.getH()/2 );
        this._moreLeft.setArrowH( this._time.getH() );
        this._moreLeft.animate( { a:1, duration:500 } );

        this.callbackSignalReady();
    };

    /**
     * @memberof Screen
     * @param {String|undefined} [baseStr] - "path" name
     * @param {String|undefined} [termStr] - "folder" name
     */
    Screen.prototype.setBreadCrumbs = function( baseStr, termStr )
    {
        this._baseStr = baseStr;
        this._termStr = termStr;

        this._bcBase.setText( (this._termStr && this._baseStr) ? this._baseStr + " / " : this._baseStr );
        this._bcTerm.setText( this._termStr );

        if( this._termStr )
            this._bcTerm.setX( this._baseStr ? Style._safeLeft + this._bcBase.getW() : Style._safeLeft );
    };

    return Screen;

})();


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.AccessibilityScreen = ( function()
{
    "use strict";

    AccessibilityScreen.prototype = new Screen();

    function AccessibilityScreen(){}

    AccessibilityScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list, true );
        this._speakTarget.setText( "Accessibility. " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review settings. Press OK to select.", focus._speakRole, this, false );
    };

    AccessibilityScreen.prototype.init = function()
    {
        var i, listParams = {}, onCaptions, captionsStr, onDescription, descriptionStr, onCaptionOptions, rows, entries;

        Screen.prototype.init.call( this );
        this._className     = "AccessibilityScreen";
        this._telemetryName = "Accessibility";
        this.setBreadCrumbs( "Settings", "Accessibility" );


        onCaptions = function( widget )
        {
            var onEnter = function( on )
            {
                _x2._settings.setValue( Settings.Key.CC_ENABLED, on );
                widget.setValue( captionsStr() );
            };

            _x2.pushOverlay( new OnOffOverlay().init( { onEnter:onEnter, isOn:_x2._settings.getValue( Settings.Key.CC_ENABLED ) } ) );
        };

        captionsStr = function()
        {
            return _x2._settings.getValue( Settings.Key.CC_ENABLED ) === true ? "On" : "Off";
        };

        onCaptionOptions = function()
        {
            _x2.pushScreen( new CaptionsScreen().init() );
        };

        onDescription = function( widget )
        {
            var onEnter = function( on )
            {
                _x2._settings.setValue( Settings.Key.DV_ENABLED, on );
                widget.setValue( descriptionStr() );
            };

            _x2.pushOverlay( new OnOffOverlay().init( { onEnter:onEnter, isOn:_x2._settings.getValue( Settings.Key.DV_ENABLED ) } ) );
        };

        descriptionStr = function()
        {
            return _x2._settings.getValue( Settings.Key.DV_ENABLED ) === true ? "On" : "Off";
        };

        rows    = [];
        entries = _x2._config._accessibilityMenu;

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "captions":
                    rows.push( { title:"Caption Settings:", value:captionsStr(), onEnter:onCaptions } );
                    break;

                case "captionOptions":
                    rows.push( { title:"Closed Captioning Options", showIcon:true, onEnter:onCaptionOptions } );
                    break;

                case "videoDesc":
                    rows.push( { title:"Video Description:", value:descriptionStr(), onEnter:onDescription } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = MenuRowWidget;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        window.ll( "tagScreen", "Accessibility" );
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    AccessibilityScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return AccessibilityScreen;

})();


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.AuthCodeScreen = ( function()
{
    "use strict";

    AuthCodeScreen.prototype = new Screen();

    function AuthCodeScreen(){}

    AuthCodeScreen.prototype.getNewCode = function()
    {
        var self = this;

        for( var i = 0; i < this._chars.length; i++ )
            this._chars[i].setText( "" );

        this._getNewCodeFunc( function( params ) { self.setCode( params ); } );
    };

    AuthCodeScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._button );

        this._speakTarget.setText( this._titleStr.getText() + ", " + this._instructions + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press OK to select. Press left to repeat code. Press right to reread instructions. ", focus._speakRole, this, false );
    };

    AuthCodeScreen.prototype.setCode = function( params )
    {
        this._code = "";

        for( var i = 0; i < this._chars.length; i++ )
        {
            this._chars[i].setText( params.code.substr( i, 1 ) );
            this._code += this._chars[i].getText() + ". ";
        }

        this._speakTarget.setText( this._code );
        this._speakTarget.setSpeechParams( "", undefined, this, false );

        params.pollFunc( this._onSuccess, this._onError );
    };

    AuthCodeScreen.prototype.init = function( onAuth, params )
    {
        Screen.prototype.init.call( this, { noHeader:true, noSep:true } );
        this._className     = "AuthCodeScreen";

        this._getNewCodeFunc  = params.getNewCodeFunc;
        this._cells           = new Array( params.code.length );
        this._chars           = new Array( params.code.length );
        this._numImagesLoaded = 0;
        this._numImagesNeeded = params.code.length + 1;

        var i, self = this;
        var onLoad      = function() { self.layout(); };
        var titleStyle  = new Style( { font:"thin"   , color:"#e8e8e8", fontSize:_x2.scaleValInt(100), whiteSpace:"nowrap" } );
        var stepStyle   = new Style( { font:"bold"   , color:"#d1d1d1", fontSize:_x2.scaleValInt( 24), whiteSpace:"nowrap" } );
        var textStyle   = new Style( { font:"regular", color:"#8c8c8c", fontSize:_x2.scaleValInt( 30), whiteSpace:"nowrap" } );
        var codeStyle   = new Style( { font:"bold"   , color:"#000000", fontSize:_x2.scaleValInt( 70), whiteSpace:"nowrap", textAlign :"center" } );
        var buttonStyle = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt( 32), whiteSpace:"nowrap", colorHi:"#000000" } );
        var url         = (params.url === "https://login.comcast.net/oauth/device/activate") ? "http://bit.ly/2cp8Ft4" : params.url;
        var button      = new StringWidget().init( { text:"Need a New Code?", style:buttonStyle, onEnter:function() { self.getNewCode() } } );

        this.addWidget( new ImageWidget().init( { url:_x2._config._imageRootMso + "activationBg.jpg", onLoad:onLoad } ) );

        this._container = new Widget().init();
        this._titleStr  = new StringWidget().init( { text:"Let's get started!", style:titleStyle } );
        this._step1Str  = new StringWidget().init( { text:"STEP 1", style:stepStyle } );
        this._text1Str  = new TextBlockWidget().init( { text:"Go to <font color='#e8e8e8'>" + url + "</font> on your computer or mobile device.", style:textStyle, w:_x2._config._screenW - _x2.scaleValInt(768) - Style._safeRight } );
        this._step2Str  = new StringWidget().init( { text:"STEP 2", style:stepStyle } );
        this._text2Str  = new StringWidget().init( { text:"Enter the following code:", style:textStyle } );

        this._code = "";

        for( i = 0; i < this._cells.length; i++ )
        {
            this._cells[i] = new ImageWidget().init( { url:_x2._config._imageRoot+"codeCell.png", onLoad:onLoad } );
            this._chars[i] = new StringWidget().init( { text:params.code.substr( i, 1 ), style:codeStyle } );
            this._container.addWidget( this._cells[i] );
            this._container.addWidget( this._chars[i] );
            this._code += this._chars[i].getText() + ". ";
        }

        this._button = new HorizPillButtonsWidget().init( { entries:[button], spacing:_x2.scaleValInt(60) } );

        this._container.setA( 0 );

        this.addWidget( this._container );
        this._container.addWidget( this._titleStr  );
        this._container.addWidget( this._step1Str  );
        this._container.addWidget( this._text1Str  );
        this._container.addWidget( this._step2Str  );
        this._container.addWidget( this._text2Str  );
        this._container.addWidget( this._button    );

        this._onSuccess = function()
        {
            _x2.pushScreen( new ProvisioningScreen().init( onAuth ) );
        };

        this._onError = function()
        {
            console.log( "ERROR -> AUTH TOKEN FAILED" );  // TODO need some sort of error overlay?

            for( var i = 0; i < self._chars.length; i++ )
                self._chars[i].setText( "" );
        };

        params.pollFunc( this._onSuccess, this._onError );

        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Activation Code screen" ) : Config.NOP();
        window.ll( "tagScreen", "Activation Code" ); // Localytics 2.1.1

        this._instructions = this._step1Str.getText() + ". " + this._text1Str.getText().replace( /xfinity/gi, "x finity" ) + " " +
                             this._step2Str.getText() + ". " + this._text2Str.getText() + " " + this._code;

        return this;
    };

    AuthCodeScreen.prototype.layout = function()
    {
        if( ++this._numImagesLoaded === this._numImagesNeeded )
        {
            var xx, yy, i, w;

            var x = _x2.scaleValInt(768);
            var y = _x2.scaleValInt(231);
            this._titleStr.setX( x );
            this._titleStr.setY( y );

            y += this._titleStr.getH() + _x2.scaleValInt(40);
            this._step1Str.setX( x );
            this._step1Str.setY( y );

            y += this._step1Str.getH() + _x2.scaleValInt(14);
            this._text1Str.setX( x );
            this._text1Str.setY( y );

            y += this._text1Str.getH() + _x2.scaleValInt(50);
            this._step2Str.setX( x );
            this._step2Str.setY( y );

            y += this._step2Str.getH() + _x2.scaleValInt(14);
            this._text2Str.setX( x );
            this._text2Str.setY( y );

            xx  = x;
            y  += this._text2Str.getH() + _x2.scaleValInt(30);
            yy  = y + (this._cells[0].getH() - this._chars[0].getH()) / 2;
            w   = this._cells[0].getW();

            for( i = 0; i < this._cells.length; i++ )
            {
                this._cells[i].setX( xx );
                this._cells[i].setY( y  );
                this._chars[i].setX( xx );
                this._chars[i].setY( yy );
                this._chars[i].setW( w  );
                xx += this._cells[i].getW() + _x2.scaleValInt(12);
            }

            y += this._cells[0].getH() + _x2.scaleValInt(60);
            this._button.setX( x );
            this._button.setY( y );

            this._container.animate( { a:1, duration:500 } );
        }
    };

    AuthCodeScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( val === Host.KEY_LAST || val === Host.KEY_QUIT )
            retval = false;
        else if( type === Host.KEY_PRESSED && _x2._focus !== this._button )
            _x2.requestFocus( this._button );

        switch( val )
        {
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    this._speakTarget.setText( this._code );
                    this._speakTarget.setSpeechParams( "", undefined, this, false );
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    this._speakTarget.setText( this._instructions );
                    this._speakTarget.setSpeechParams( "", undefined, this, false );
                }
                break;
        }

        return retval;
    };

    return AuthCodeScreen;

})();


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.CaptionsScreen = ( function()
{
    "use strict";

    CaptionsScreen.prototype = new Screen();

    function CaptionsScreen(){}

    CaptionsScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list, true );
        this._speakTarget.setText( "Closed Captioning Options. " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review settings. Press OK for options. ", focus._speakRole, this, false );
    };

/*
bottomInset
fontStyle
penItalicized
penSize
penUnderline
textBackgroundColor
textBackgroundOpacity
textEdgeColor
textEdgeStyle
textForegroundColor
textForegroundOpacity
windowBorderEdgeColor
windowBorderEdgeStyle
windowFillColor
windowFillOpacity
*/

/**
 * Closed Caption Colors. Legal values include "0x000000" - "0xFFFFFF" | "red" | "green" | "blue" |
 *     "cyan" | "magenta" | "yellow" | "white" | "black".
 * @typedef {string} ClosedCaptionColor
 */
/**
 * Closed Caption Edges. Legal values include "none" | "raised" | "depressed" | "uniform" |
 *     "drop_shadow_left" | "drop_shadow_right".
 * @typedef {string} ClosedCaptionEdge
 */
/**
 * Closed Caption Font Style. Legal values include "default" | "monospaced_serif" | "proportional_serif" |
 *     "monospaced_sanserif" | "proportional_sanserif" | "casual" | "cursive" | "smallcaps".
 * @typedef {string} ClosedCaptionFontStyle
 */
/**
 * Closed Caption Opacity. Legal values include "solid" | "flash" | "translucent" | "transparent".
 * @typedef {string} ClosedCaptionOpacity
 */
/**
 * Closed Caption Pen Size. Legal values include "small" | "standard" | "large".
 * @typedef {string} ClosedCaptionPenSize
 */


    CaptionsScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this );
        this._className     = "CaptionsScreen";
        this._telemetryName = "Caption Settings";
        this.setBreadCrumbs( "Settings / Accessibility", "Closed Captioning Options" );

        var listParams    = {}, self = this, rows;
        var styling       = _x2._settings.getValue( Settings.Key.CC_STYLING );
        var colors        = [ "white"           , "black"            , "red"               , "green"              , "blue"                 , "yellow"           , "magenta"           , "cyan"            ];
        var colorStrs     = [ _x2._st.colorWhite, _x2._st.colorBlack , _x2._st.colorRed    , _x2._st.colorGreen   , _x2._st.colorBlue      , _x2._st.colorYellow, _x2._st.colorMagenta, _x2._st.colorCyan ];
        var fontStyles    = [ "default"         , "monospaced_serif" , "proportional_serif", "monospaced_sanserif", "proportional_sanserif", "casual"           , "cursive"                               ];
        var fontStyleStrs = [ _x2._st.default   , _x2._st.monoSerif  , _x2._st.propSerif   , _x2._st.monoSans     , _x2._st.propSans       , _x2._st.casual     , _x2._st.cursive                         ];
        var edgeStyles    = [ "none"            , "raised"           , "depressed"         , "uniform"            , "drop_shadow_left"     , "drop_shadow_right"                                          ];
        var edgeStyleStrs = [ _x2._st.none      , _x2._st.raised     , _x2._st.depressed   , _x2._st.uniform      , _x2._st.leftDrop       , _x2._st.rightDrop                                            ];
        var opacities     = [ "solid"           , "translucent"      , "transparent"                                                                                                                      ];
        var opacityStrs   = [ _x2._st.solid     , _x2._st.translucent, _x2._st.transparent                                                                                                                ];
        var sizes         = [ "small"           , "standard"         , "large"                                                                                                                            ];
        var sizeStrs      = [ _x2._st.small     , _x2._st.medium     , _x2._st.large                                                                                                                      ];

//         var reset = function()
//         {
//             styling =
//             {
//                 bgColor      : "black",
//                 bgOpacity    : "solid",
//                 color        : "white",
//                 edgeColor    : "white",
//                 edgeStyle    : "none",
//                 fontOpacity  : "solid",
//                 fontStyle    : "default",
//                 size         : "small",
//                 windowColor  : "black",
//                 windowOpacity: "transparent"
//             };
//
//             _x2._settings.setValue( Settings.Key.CC_STYLING, styling );
//             _x2.popScreen();
//         };

//         if( styling === undefined )  // set the default values
//             reset();

        console.log( styling );

        var onEnter = function( widget, key, choices, strs )
        {
            var selected  = 0;
            var onEnter = function( index )
            {
                styling[key] = choices[index];
                _x2._settings.setValue( Settings.Key.CC_STYLING, styling );
                widget.setValue( valueStr( key ) );
            };

            for( var i = 0; i < rows.length; i++ )
                if( styling[key] === choices[i] )
                {
                    selected = i;
                    break;
                }

            var bcName = widget.getTitle();
            var index  = bcName.lastIndexOf( ":" );

            if( index > -1 )
                bcName = bcName.slice( 0, index );

            _x2.pushScreen( new ChoiceScreen().init( { rows:strs, selectedIndex:selected, onEnter:onEnter, bcPath:self.getBreadCrumb(), bcScreen:bcName } ) );
        };

        var valueStr = function( key )
        {
            var index = 0, choices, strs;
            var val   = styling[key];

            switch ( key )
            {
                case "textBackgroundColor":
                case "textForegroundColor":
                case "textEdgeColor":
                case "windowColor":
                    choices = colors;
                    strs    = colorStrs;
                    break;

                case "textEdgeStyle":
                    choices = edgeStyles;
                    strs    = edgeStyleStrs;
                    break;

                case "textForegroundOpacity":
                case "textBackgroundOpacity":
                case "windowOpacity":
                    choices = opacities;
                    strs    = opacityStrs;
                    break;

                case "fontStyle":
                    choices = fontStyles;
                    strs    = fontStyleStrs;
                    break;

                case "penSize":
                    choices = sizes;
                    strs    = sizeStrs;
                    break;
            }

            for( var i = 0; i < choices.length; i++ )
                if( choices[i] === val )
                {
                    index = i;
                    break;
                }

            return strs[index];
        };

        rows =
        [
            { title:"Font Size: "         , showIcon:true , value:valueStr( "penSize"               ), onEnter:function( widget ) { onEnter( widget, "penSize"              , sizes     , sizeStrs      ); }, rowIndex:0 },
            { title:"Font Style: "        , showIcon:true , value:valueStr( "fontStyle"             ), onEnter:function( widget ) { onEnter( widget, "fontStyle"            , fontStyles, fontStyleStrs ); }, rowIndex:1 },
            { title:"Font Edge Style: "   , showIcon:true , value:valueStr( "textEdgeStyle"         ), onEnter:function( widget ) { onEnter( widget, "textEdgeStyle"        , edgeStyles, edgeStyleStrs ); }, rowIndex:2 },
            { title:"Font Opacity: "      , showIcon:true , value:valueStr( "textForegroundOpacity" ), onEnter:function( widget ) { onEnter( widget, "textForegroundOpacity", opacities , opacityStrs   ); }, rowIndex:3 },
            { title:"Font Color: "        , showIcon:true , value:valueStr( "textForegroundColor"   ), onEnter:function( widget ) { onEnter( widget, "textForegroundColor"  , colors    , colorStrs     ); }, rowIndex:4 },
            { title:"Font Edge Color: "   , showIcon:true , value:valueStr( "textEdgeColor"         ), onEnter:function( widget ) { onEnter( widget, "textEdgeColor"        , colors    , colorStrs     ); }, rowIndex:5 },
            { title:"Background Color: "  , showIcon:true , value:valueStr( "textBackgroundColor"   ), onEnter:function( widget ) { onEnter( widget, "textBackgroundColor"  , colors    , colorStrs     ); }, rowIndex:6 },
            { title:"Background Opacity: ", showIcon:true , value:valueStr( "textBackgroundOpacity" ), onEnter:function( widget ) { onEnter( widget, "textBackgroundOpacity", opacities , opacityStrs   ); }, rowIndex:7 }
//             { title:"Window Color: "      , showIcon:true , value:valueStr( "windowColor"   ), onEnter:function( widget ) { onEnter( widget, "windowColor"  , colors    , colorStrs     ); } },
//             { title:"Window Opacity: "    , showIcon:true , value:valueStr( "windowOpacity" ), onEnter:function( widget ) { onEnter( widget, "windowOpacity", opacities , opacityStrs   ); } },
//            { title:"Reset Style"         , showIcon:false, onEnter:reset }
        ];

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = MenuRowWidget;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        return this;
    };

    CaptionsScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return CaptionsScreen;

})();


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChannelCollectionScreen = (function()
{
    "use strict";

    ChannelCollectionScreen.prototype = new Screen();

    var infoStr = "Press up or down to review programs on other channels. Press OK to watch.";

    function ChannelCollectionScreen(){}

    ChannelCollectionScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut(0);

        if( this._ready )
        {
            var focus = _x2.requestFocus( this._list, true );

            this._speakTarget.setText(  this.getBreadCrumb() + "." + focus._speakStr + "." );
            this._speakTarget.setSpeechParams( infoStr, focus._speakRole, this, false );
        }
    };

    /**
     * @memberOf ChannelCollectionScreen
     * @param {Organization} org
     * @return {ChannelCollectionScreen}
     */
    ChannelCollectionScreen.prototype.init = function( org )
    {
        Screen.prototype.init.call( this );
        this._className     = "ChannelCollectionScreen";
        this._telemetryName = "Channel Collection";

        var self       = this, sep, layout, onDataReady, numEntries;
        var listParams = {};
        var listW      = _x2._config._screenW - Style._safeRight - Style._safeLeft;
        var listH      = _x2._config._screenH - Style._safeTop - Style._safeBottom;
        var style      = new Style( { color:"#a3a3a3", font:"medium" , fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"right" } );

        listParams.w        = listW;
        listParams.h        = listH;
        listParams.maxIndex = 1;
        listParams.type     = ChannelRowWidget;

        layout = function()
        {
            var y = self.getHeaderBottom() + _x2.scaleValInt( 42 );
            numEntries.setY( y );
            y += numEntries.getH() + _x2.scaleValInt( 30 );
            sep.setY( y );
            y += sep.getH();
            self._list.setY( y );
            self._list.setH( _x2._config._screenH - y );
        };

        onDataReady = function()
        {
            var channels = self._organization.getChannels();

            if( self._distractor )
                self._distractor.hide();

            numEntries.setText( channels.length + " Results" );

            self._list.setData( channels );
            self._ready = true;

            if( _x2._focus === self )
            {
                var focus = _x2.requestFocus( self._list );
                self._speakTarget.setText(  self.getBreadCrumb() + "." + focus._speakStr + "." );
                self._speakTarget.setSpeechParams( infoStr, focus._speakRole, self, false );
            }
        };

        numEntries = new StringWidget().init({ text:"Results", style:style });
        numEntries.setW( _x2._config._screenW / 4 );
        this.addWidget( numEntries, 3 * _x2._config._screenW / 4 - Style._safeRight );

        sep = new RectWidget().init( { w:listW, h:ListRowWidget.DIVIDER_H, color:"#262626" } );
        this.addWidget( sep, Style._safeLeft );

        this._list  = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft, 0);

        //load the org data
        this._organization = org;
        org.loadData().then( onDataReady );

        this.setBreadCrumbs( "Search", org.getTitle() + " Channels" );
        this.addReadyCallback( layout );

        return this;
    };

    return ChannelCollectionScreen;

})();


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChoiceScreen = ( function()
{
    "use strict";

    ChoiceScreen.prototype = new Screen();

    function ChoiceScreen(){}

    ChoiceScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( this.getBreadCrumbsTermStr() + ". " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    /**
     * @memberof ChoiceScreen
     * @param   {Object}   params
     * @param   {String}   params.bcPath        - path to use for bread crumb
     * @param   {String}   params.bcScreen      - screen name to use for bread crumb
     * @param   {Function} params.onEnter       - function to execute on enter, will receive the index of the selected row
     * @param   {Array}    params.rows          - data object for each entry to display
     * @param   {Number}   params.selectedIndex - index if the currently active entry
     * @returns {ChoiceScreen}
     */
    ChoiceScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this );
        this._className     = "ChoiceScreen";
        this._telemetryName = "Choice";
        this.setBreadCrumbs( params.bcPath, params.bcScreen );

        var self = this, listParams = {}, rows = [];

        for( var i = 0; i < params.rows.length; i++ )
            rows[i] = { title:params.rows[i], rowIndex:i, selected:(i === params.selectedIndex), onEnter:function() { params.onEnter( self._list.getCurrentAndMaxIndex().current ); _x2.popScreen(); } };

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = ChoiceRowWidget;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        return this;
    };

    ChoiceScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return ChoiceScreen;

})();


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ChurnedMainMenuScreen = ( function()
{
    "use strict";

    ChurnedMainMenuScreen.prototype = new Screen();

    function ChurnedMainMenuScreen(){}

    ChurnedMainMenuScreen.prototype.gotFocus = function()
    {
        if( this._dataReady === true )
            this.speak( _x2.requestFocus( self._purchases, true ) );
        else
            this.speak();
    };

    ChurnedMainMenuScreen.prototype.init = function()
    {
        var self        = this;
        var buttonStyle = new Style( { font: "medium", color: "#e8e8e8", fontSize: _x2.scaleValInt(32), whiteSpace: "nowrap", colorHi: "#000000" } );

        Screen.prototype.init.call( this );
        this._className     = "ChurnedMainMenuScreen";
        this._telemetryName = "Churned Main Menu";

        var layout = function()
        {
            var y = self.getHeaderBottom();
            var h = _x2._config._screenH - y;

            self._purchases.setY( y );
            self._purchases.setH( h );

            self._options.setX( (_x2._config._screenW - self._options.getW()) / 2 );
            self._options.setY( y - self._options.getH() - 2 * Style._pad );

            self._purchases.setA( 1 );
        };

        var onReady = function()
        {
            self._dataReady = true;

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._purchases, true ) );
        };

        this.setBreadCrumbs( undefined, "Purchases" );

        this._purchases = new PurchasesWidget().init( { path: "Purchases. " } );
        this._purchases.addReadyCallback( onReady );
        this._purchases.setA( 0 );
        this.addWidget( this._purchases );
        this._purchases.loadData();

        var onEnter = function()
        {
            _x2.pushScreen( new SettingsScreen().init( { path:"Purchases" } ) );
        };

        this._options = new HorizPillButtonsWidget().init( { entries:[ new StringWidget().init( { text:"Settings", style:buttonStyle, onEnter:onEnter } ) ] } );
        this.addWidget( this._options );

        this._options.addReadyCallback( layout );

        _x2.localyticsSendSplashPageAndProvisioning();

        return this;
    };

    ChurnedMainMenuScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    if( _x2._focus === this._options )
                        _x2.requestFocus( this._purchases );
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                    if( _x2._focus !== this._options )
                        _x2.requestFocus( this._options );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    ChurnedMainMenuScreen.prototype.speak = function( focus )
    {
        if( focus )
        {
            this._speakTarget.setText( "Purchases. " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press up to change settings. Press left, right, or down to browse content. Press OK to select. ", focus._speakRole, this, false );
        }
        else
        {
            this._speakTarget.setText( "Loading purchases, please wait. " );
            this._speakTarget.setSpeechParams( undefined, undefined, this, false );
        }
    };

    return ChurnedMainMenuScreen;

})();


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DeviceNameScreen = ( function()
{
    "use strict";

    DeviceNameScreen.prototype = new Screen();

    function DeviceNameScreen(){}

    DeviceNameScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
        var focus = _x2.requestFocus( this._keyboard, true );
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( undefined, focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof DeviceNameScreen
     * @param   {Object}    params
     * @param   {Boolean}  [params.hideCancel] - Determines whether cancel button is shown
     * @param   {Function} [params.onChange  ] - Callback when name change has been confirmed
     * @param   {String}   [params.path      ] - Path to put in the header
     * @returns {DeviceNameScreen}
     */
    DeviceNameScreen.prototype.init = function( params )
    {
        var self        = this, keyboardParams = {}, onConfirm, onCancel, accept, decline, entries;
        var layout      = function() { self._numReady++; self.layout(); };
        var buttonStyle = new Style( { font:"light", color:"#e8e8e8", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000" } );

        Screen.prototype.init.call( this );
        this._className     = "DeviceNameScreen";
        this._telemetryName = "Name Device";
        this._numReady      = 0;
        this.setBreadCrumbs( ((params && params.path) ? params.path : undefined), "Please Name Your Device" );

        keyboardParams.w       = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        keyboardParams.onReady = layout;
        keyboardParams.onEnter = function( char ) { self._text.onChar( char ); };

        this._keyboard = new KeyboardWidget().init( keyboardParams );
        this.addWidget( this._keyboard, Style._safeLeft );

        this._text = new TextEntryWidget().init( { w:this._keyboard.getW() } );
        this._text.addReadyCallback( layout );
        this.addWidget( this._text, Style._safeLeft );

        onConfirm = function()
        {
            self._buttons.setDisabled( true );

            var onError = function( obj )
            {
                console.log( obj );
                _x2.pushOverlay( new AlertOverlay().init( { title:"Not a Valid Device Name", message:"Please try again. The device name must contain at least one character." } ) );
                self._buttons.setDisabled( false );
            };

            var onSuccess = function()
            {
                if( params.onChange )
                    params.onChange();

                _x2.popScreen();
            };

            _x2._data.setDeviceName( self._text.getText() ).then( onSuccess, onError );
        };

        onCancel = function()
        {
            _x2.popScreen();
        };

        accept  = new StringWidget().init( { text:"Confirm", style:buttonStyle, onEnter:onConfirm } );
        decline = new StringWidget().init( { text:"Cancel" , style:buttonStyle, onEnter:onCancel  } );
        entries = ((params && params.hideCancel === true) ? [accept] : [accept,decline]);

        this._buttons  = new HorizPillButtonsWidget().init( { entries:entries, spacing:_x2.scaleValInt(60) } );
        this._buttons.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._buttons );

        this._onConfirm = onConfirm;

        window.ll( "tagScreen", "Name Device screen" ); // Localytics 2.1.1
        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Name Device screen" ) : Config.NOP();

        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    DeviceNameScreen.prototype.layout = function()
    {
        if( this._numReady === 2 )
        {
            this._text.setY( this.getHeaderBottom() + _x2.scaleValInt( 42 ) );
            this._keyboard.setY( this._text.getY() + this._text.getH() + _x2.scaleValInt( 30 ) );
            this._buttons.setX( _x2._config._screenW - Style._safeLeft - this._buttons.getW() );
            this._buttons.setY( this._text.getY() );
        }
    };

    DeviceNameScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED && _x2._focus === this._buttons )
                    _x2.requestFocus( this._keyboard );
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED && _x2._focus === this._keyboard )
                    _x2.requestFocus( this._buttons );
                break;

            case Host.KEY_SOFT_A:
                if( type === Host.KEY_PRESSED )
                    this._onConfirm();
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return DeviceNameScreen;

})();


/***/ }),
/* 187 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DeletedRecordingsScreen = ( function()
{
    "use strict";

    DeletedRecordingsScreen.prototype = new Screen();

    function DeletedRecordingsScreen(){}

    DeletedRecordingsScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut(0);
    };

    DeletedRecordingsScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this );
        this._className     = "DeletedRecordingsScreen";
        this._telemetryName = "Deleted Recordings";

        var self = this;
        var messageStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), textAlign:"center", whiteSpace:"nowrap" } );

        var listParams      = {};
        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.axis     = ListWidget.Axis.Y;
        listParams.type     = RecordingRowWidget;
        listParams.obj      = this;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        this.setBreadCrumbs( "Deleted Recordings" );
        this.addReadyCallback( function(){ self.layout(); } );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self._list ); self._distractor.show(); } );
        this._list.addWidget( this._distractor );

        this._emptyMessage = new StringWidget().init( { style:messageStyle, text:"There are no deleted recordings" } );
        this._emptyMessage.setA(0);
        this.addWidget( this._emptyMessage );

        this.setData();

        return this;
    };

    DeletedRecordingsScreen.prototype.setData = function( refresh )
    {
        var success, fail, self = this;

        success = function( recordings )
        {

            if( recordings.length > 0 )
            {
                self._list.setA( 1 );
                self._list.setData( recordings );

                //NOTE: on refresh (refreshCheck() called after deleting a recording) _focus will be a KeyEater. Bypass _focus === self check in that case.
                if( _x2._focus === self || refresh )
                    self.speak( _x2.requestFocus( self._list, true ) );

                self._emptyMessage.setA( 0 );
            }
            else
            {
                _x2._hi.fadeOut( 0 );
                self._list.setA( 0 );
                self._emptyMessage.setA( 1 );
            }

            self._distractor.hide();
        };

        fail = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.SAVED } ) );
        };

        this._distractor.show();
        _x2._data.getDeletedRecordings().then( success ).catch( fail );
    };

    DeletedRecordingsScreen.prototype.speak = function( focus )
    {
        if( focus === this )
        {
            this._speakTarget.setText( this._emptyMessage.getText() + ". " );
            this._speakTarget.setSpeechParams( undefined, undefined, this, false );
        }
        else
        {
            this._speakTarget.setText( this.getBreadCrumb() + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press up or down to review items. Press OK for options. ", focus._speakRole, this, false );
        }
    };

    DeletedRecordingsScreen.prototype.refreshCheck = function()
    {
        _x2._hi.fadeOut(0);
        this.setData( true );
    };

    DeletedRecordingsScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom() - 2;
        this._list.setY(y);

        var mw = this._emptyMessage.getW();
        var mh = this._emptyMessage.getH();
        this._emptyMessage.setX( _x2._config._screenW/2 - mw/2);
        this._emptyMessage.setY( _x2._config._screenH/2 - mh );
    };

    return DeletedRecordingsScreen;

})();


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.DownloadDevicesScreen = ( function()
{
    "use strict";

    DownloadDevicesScreen.prototype = new Screen();

    function DownloadDevicesScreen(){}

    DownloadDevicesScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
//       _x2.requestFocus( this._list );
    };

    /**
     * Initializer
     * @memberof DownloadDevicesScreen
     * @param   {Object} params
     * @param   {String} params.path - breadcrumb path
     * @returns {DownloadDevicesScreen}
     */
    DownloadDevicesScreen.prototype.init = function( params )
    {
        var onSuccess;
        var self       = this, listParams = {};
        var w          = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var bodyStyle  = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var noStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(54), whiteSpace:"nowrap", textAlign:"center" } );
        var descStr    = "Remove watched content so it can be downloaded to another device.";
        var onLoad     = function() { self._numLoaded++; self.layout(); };

        var onEnter    = function( data )
        {
            return function()
            {
                var onDeleteSuccess = function()
                {
                    _x2._data.getAllDeviceList().then( onSuccess );
                };

                var onDeleteError = function( e )
                {
                    console.log( e );
                };

                var executeDelete = function()
                {
                    self._distractor.show();
                    self._list.setData();
                    _x2.popOverlay( confirmOverlay );
                    _x2._data.checkInDownloadsForDevice( data.deviceId ).then( onDeleteSuccess, onDeleteError );
                };

                var confirmOverlay = new DeleteDownloadsOverlay().init( { onEnter:executeDelete } );

                _x2.pushOverlay( confirmOverlay );
            };
        };

        Screen.prototype.init.call( this );
        this._className     = "DownloadDevicesScreen";
        this._telemetryName = "Download Devices";
        this.setBreadCrumbs( params.path, "Devices with Downloads" );

        this._numLoaded = 0;

        this._title = new StringWidget().init( { text:"Devices with Downloads", style:titleStyle } );
        this.addWidget( this._title, Style._safeLeft );

        this._desc = new TextBlockWidget().init( { text:descStr , style:bodyStyle, w:w } );
        this.addWidget( this._desc, Style._safeLeft );

        this._lowerSep = new RectWidget().init( { w:w, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this.addWidget( this._lowerSep, Style._safeLeft );

        this._noStream = new StringWidget().init( { text:"There are no devices with downloads.", style:noStyle } );
        this._noStream.setW( _x2._config._screenW );
        this._noStream.setA( 0 );
        this._noStream.addReadyCallback( onLoad );
        this.addWidget( this._noStream );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( onLoad );
        this.addWidget( this._distractor );

        listParams.w        = w;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.type     = DevicesRowWidget;
        listParams.obj      = this;

        this._list = new ListWidget().init( listParams );
        this._list.setA( 0 );
        this.addWidget( this._list, Style._safeLeft );

        /**
         * @param {Object[]} data
         * @param {Boolean}  data[].purchasedVodCheckoutCount -
         * @param {Boolean}  data[].recordingCheckoutCount    -
         * @param {Boolean}  data[].tveCheckoutCount          -
         */
        onSuccess = function( data )
        {
            var results = [], subTitle, purchases, recordings, tvGo;

            self._distractor.hide();
            self._loaded = true;

            if( data && data.length > 0 )
            {
                for( var i = 0; i < data.length; i++ )
                {
                    purchases  = data[i].purchasedVodCheckoutCount;
                    recordings = data[i].recordingCheckoutCount;
                    tvGo       = data[i].tveCheckoutCount;

                    if( purchases > 0 || recordings > 0 || tvGo > 0 )
                    {
//                        console.log( data[i].deviceName + ", " + purchases + " Purchases, " + purchases + " Recordings, " + tvGo + " TV Go" );

                        if( purchases === 1 )
                            subTitle = "1 Purchase";
                        else if( purchases > 1 )
                            subTitle = purchases + " Purchases";
                        else
                            subTitle = "";

                        if( recordings > 0 )
                        {
                            if( subTitle.length > 0 )
                                subTitle += " | ";

                            if( recordings === 1 )
                                subTitle += "1 Recording";
                            else if( recordings > 1 )
                                subTitle += recordings + " Recordings";
                        }

                        if( tvGo > 0 )
                        {
                            if( subTitle.length > 0 )
                                subTitle += " | ";

                            subTitle += tvGo + " TV Go";
                        }

                        results.push( { title:data[i].deviceName, subTitle:subTitle, showIcon:false, onEnter:onEnter( data[i] ) } );
                    }
                }

                if( results.length > 0 )
                {
                    self._list.setData( results );
                    self._list.animate( { a:1, duration:500 } );

                    if( _x2._focus === self )
                        _x2.requestFocus( self._list );
                }
                else
                    self._noStream.animate( { a:1, duration:500 } );
            }
        };

        _x2._data.getAllDeviceList().then( onSuccess );

        return this;
    };

    DownloadDevicesScreen.prototype.layout = function()
    {
        if( this._numLoaded === 2 )
        {
            Screen.prototype.resourcesLoaded.call( this );

            this._title.setY( this.getHeaderBottom() + _x2.scaleValInt(50) );
            this._desc.setY( this._title.getY() + this._title.getH() );
            this._lowerSep.setY( this._desc.getY() + this._desc.getH() + _x2.scaleValInt(50) );

            var top = this._lowerSep.getY() + this._lowerSep.getH();
            var h   = _x2._config._screenH - Style._safeBottom - top;

            this._noStream.setY( top + (h - this._noStream.getH()) / 2 );

            this._distractor.setX( (_x2._config._screenW - this._distractor.getW() ) / 2 );
            this._distractor.setY(  top + (h - this._distractor.getH()) / 2 );

            if( this._loaded !== true )
                this._distractor.show();

            this._list.setH( h + Style._safeBottom );
            this._list.setY( top );
        }
    };

    DownloadDevicesScreen.prototype.onRowLostFocus = function()
    {
        _x2.requestFocus( this._list );
    };

    return DownloadDevicesScreen;

})();


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.EpisodesScreen = (function()
{
    "use strict";

    EpisodesScreen.prototype = new Screen();

    function EpisodesScreen(){}

    /**
     * memberof EpisodesScreen
     * @param {Object} params
     * @param {Entity|RecordingGroup|PurchaseGroup} params.entity - entity to display
     * @returns {EpisodesScreen}
     */
    EpisodesScreen.prototype.init = function( params )
    {
        var xDims,
            yDims,
            seasonParams = {},
            episodeParams = {},
            onPosterError,
            onSeasonExpanded,
            episodeStepListener,
            setEpisodeListData,
            expandedSeason,
            page,
            perPage = EntityOptions.programsPerPage,
            self = this;

        Screen.prototype.init.call( this );
        this._className     = "EpisodesScreen";
        this._telemetryName = "Entity Episodes";

        //setup dims
        xDims = [Style._safeLeft, _x2.scaleValInt( 303 ), _x2.scaleValInt( 52 ), Style._safeRight];
        yDims = [ _x2.scaleValInt( 150 ), _x2.scaleValInt( 404 )]; // First Y is absolute position; NOTE: Can't use 'y = {Screen.}getHeaderBottom() - 2 + 42;' due to _time.getH() returning undefined -> NaN

        onPosterError = function()
        {
            var fallback = self._entity.getFallbackImageLink( 303, 404 );

            if( !fallback || ( self._poster.getUrl() === fallback ) ) //hide if no fallback or fallback == current
                self._poster.setA( 0 );
            else
                self._poster.setUrl( fallback );
        };

        //add poster
        this._poster = new ImageWidget().init( { w: xDims[1], h: yDims[1], onError:onPosterError } );
        this.addWidget( this._poster, Style._safeLeft, yDims[0] );
        this._poster.setA(0);

        setEpisodeListData = function()
        {
            var episodes = expandedSeason.getEpisodes( page - 1 );

            self._distractor.hide();

            if( page > 1 )
                self._episodesList.appendData( episodes );
            else
                self._episodesList.setData( episodes );

            self._episodesList.setBlockingOnData( false );
        };

        episodeStepListener = function( val )
        {
            if( Math.floor( Math.round( val ) ) > ( page * perPage ) - self._episodesListRowCount )
            {
                if( expandedSeason.getEpisodeCount() > ( page * perPage ) )
                {
                    page++;
                    self._distractor.show();
                    self._episodesList.setBlockingOnData( true );
                    expandedSeason.fetchEpisodes( page, perPage ).then( setEpisodeListData );
                }
            }
        };

        onSeasonExpanded = function( rowObject )
        {
            //if the list row data contains a Season object this is dynamic & paged data. ignore or other cases.
            if( rowObject.season )
            {
                page           = 1;
                expandedSeason = rowObject.season;

                //if the season has data then set it, otherwise fetch it first
                if( expandedSeason.getEpisodes().length > 0 )
                    setEpisodeListData();
                else
                {
                    self._distractor.show();
                    self._episodesList.setData([]);
                    expandedSeason.fetchEpisodes( page, perPage ).then( setEpisodeListData );
                }
            }
        };

        //setup episode list
        episodeParams.w            = _x2._config._screenW - xDims.reduce( function( a, b ){return a + b} );
        episodeParams.h            = _x2._config._screenH - yDims[0] - Style._safeBottom;
        episodeParams.maxIndex     = 1;
        episodeParams.type         = EpisodeRowWidget;
        episodeParams.stepListener = episodeStepListener;
        this._episodesList         = new ListWidget().init( episodeParams );
        this._episodesListRowCount = this._episodesList.getVisibleRowCount();

        //setup season list
        seasonParams.w        = episodeParams.w;
        seasonParams.h        = episodeParams.h;
        seasonParams.maxIndex = 0;
        seasonParams.type     = ExpandingListRowWidget;
        seasonParams.obj      = { list:this._episodesList, baseWidget:this, onExpand:onSeasonExpanded };
        this._seasonList      = new ListWidget().init( seasonParams );

        this.addWidget( this._seasonList, xDims[0] + xDims[1] + xDims[2], yDims[0] );
        this._seasonList.addWidget( this._episodesList );

        this._topSep = new RectWidget().init( { w:episodeParams.w, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this.addWidget( this._topSep, this._seasonList.getX() );

        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function()
        {
            self._distractor.centerOnWidget( self );
        });
        this.addWidget( this._distractor );

        window.ll( "tagScreen", "Entity Episodes" );
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        setTimeout( function() { self.loadData( params.entity ) }, 1 );

        if( params.entity && params.entity instanceof RecordingGroup )
        {
            var setPoster = function( program )
            {
                self._poster.setUrl( program.getImageLink( 303, 404 ) );
                self._poster.setA(1);
            };

            params.entity.getProgram().then( setPoster )
        }

        this.addReadyCallback( function(){ self.layout(); } );

        return this;
    };

    EpisodesScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom() + _x2.scaleValInt( 42 );

        this._poster.setY( y );
        this._seasonList.setY( y );
        this._topSep.setY( y - ListRowWidget.DIVIDER_H );
        this._ready = true;

        if( _x2._focus === this && this._seasonList.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._seasonList, true ) );
    };

    EpisodesScreen.prototype.gotFocus = function()
    {
        if( this._jumpToIndex !== undefined )
        {
            if( this._jumpToIndex !== -1 )
            {
                this._episodesList.setJumpToIndex( this._jumpToIndex );
                this.speak( _x2.requestFocus( this._episodesList, true ) );
            }
            else
            {
                this._seasonList._expanded = false; //TODO: _expanded should probably be set to false in ListWidget.setData()
                this.speak( _x2.requestFocus( this._seasonList, true ) );
            }
        }
    };

    EpisodesScreen.prototype.loadData = function( data )
    {
        if( data )
            this._entity = data;

        if( this._distractor )
            this._distractor.hide();

        var i, seasonNumber, episodes, seasons, count, self = this;
        var title = this._entity.getTitle ? this._entity.getTitle() : this._entity.getName();

        if( this._entity instanceof Entity )
        {
            episodes = this._entity.getEntityOptions().getEpisodes();

            if( episodes.length === 0 )
                seasons = this._entity.getEntityOptions().getSeasons();
        }
        else if( this._entity instanceof RecordingGroup )
            episodes = this._entity.getRecordings();
        else if( this._entity instanceof PurchaseGroup )
            episodes = this._entity.getPurchases();
        else
            episodes = this._entity.getEpisodes();

        this.setBreadCrumbs( title );

        if( this._entity.getImageLink )
        {
            this._poster.setUrl( this._entity.getImageLink( 303, 404 ) );
            this._poster.setA(1);
        }

        //set the season/episode data
        this._seasons = [];

        if( seasons && seasons.length > 0 )
        {
            for( i=0; i<seasons.length; i++ )
            {
                seasonNumber = seasons[i].getNumber();

                count = seasons[i].getEpisodeCount();
                title = ( seasonNumber ? "Season " + seasonNumber: "Other Episodes" ) + " (" + count + ")";
                this._seasons.push( { season:seasons[i], number:seasonNumber, title:title, entityCount:count } );
            }
        }
        else
        {
            for( i=0; i<episodes.length; i++ )
            {
                var entity  = episodes[i];
                var episode = episodes[i];

                if( episode instanceof Showing )
                {
                    if( episode.getEntity() )
                        entity = episode.getEntity();
                }

                seasonNumber = entity.getSeasonNumber() ? parseInt(entity.getSeasonNumber()) : 0;

                title = seasonNumber ? "Season " + seasonNumber: "Other Episodes";

                if(!this._seasons[seasonNumber])
                    this._seasons[seasonNumber] = { number:seasonNumber, title:title, entries:[] };

                if( ! episode._deleteListener ) //don't set the listener twice.
                    episode._deleteListener = function(episode){ self.removeRecording( episode ); return false };

                this._seasons[seasonNumber].entries.push(episodes[i]);
            }

            //clean up and sort the season array
            for( i=0; i<this._seasons.length; i++ )
            {
                if( this._seasons[i] && this._seasons[i].entries.length > 0 )
                {
                    this._seasons[i].title += " (" + this._seasons[i].entries.length + ")";
                    this._seasons[i].entries.sort( function( a, b ){ return ( b.getEpisodeSortNumber() - a.getEpisodeSortNumber()) });
                }
                else
                {
                    this._seasons.splice(i,1);
                    i--;
                }
            }
        }

        if( this._seasons.length > 1 )
            this._seasons.sort( function( a, b ){ return ( b.number - a.number ) } );

        this._seasonList.setData( this._seasons );

        if( _x2._focus === this && this._ready )
            this.speak( _x2.requestFocus( this._seasonList, true ) );
    };

    EpisodesScreen.prototype.removeRecording = function( episode )
    {
        var i, j, spliced, doBreak, id = episode.getId();

        for( i = 0; i < this._seasons.length; i++ )
        {
            var episodes = this._seasons[i].entries;

            for( j = 0; j < episodes.length; j++ )
            {
                if( id === episodes[j].getId() )
                {
                    this._entity.removeRecording( episode );

                    episodes.splice( j, 1 );

                    if( episodes.length === 0 )
                    {
                        this._seasons.splice( i, 1 );
                        spliced = true;
                    }

                    if( this._seasons.length > 0 )
                    {
                        //hijack focus so we get the gotFocus call (not the now-deleted row)
                        this._lastFocus = this;
                        if( this._seasons.length > 1 || spliced )
                        {
                            //hide the episode list if there is more than one season, or we just deleted the selected season
                            this._jumpToIndex = -1;
                            this._episodesList.setA(0);
                        }
                        else
                        {
                            this._jumpToIndex = ( j > 0 ? j-1 : 0 );
                            this._episodesList.setData( episodes );
                        }

                        this.loadData();
                    }
                    else
                        _x2.popScreen( this );

                    doBreak = true;
                    break;
                }
            }
            if( doBreak )
                break;
        }
    };

    EpisodesScreen.prototype.speak = function( focus )
    {
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review seasons. Press OK to reviews episodes in a season. ", focus._speakRole, this, false );
    };

    return EpisodesScreen;

})();


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.FormatScreen = ( function()
{
    "use strict";

    FormatScreen.prototype = new Screen();

    function FormatScreen(){}

    FormatScreen.prototype.entrySelected = function( key )
    {
        _x2._settings.setValue( Settings.Key.FORMAT, key );
    };

    FormatScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );

        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    FormatScreen.prototype.init = function()
    {
        var params = {}, self = this;

        Screen.prototype.init.call( this );
        this._className     = "FormatScreen";
        this._telemetryName = "Format";
        this.setBreadCrumbs( "Settings", "Format" );

        var rows =
        [
            { title:"HD Preferred"         , key:"hd"  },
            { title:"All Available Formats", key:"all" }
        ];

        params.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        params.h        = _x2._config._screenH;
        params.maxIndex = 1;
        params.rows     = rows;
        params.type     = RadioButtonRowWidget;
        params.obj      = new RadioButtonController( _x2._settings.getValue( Settings.Key.FORMAT ), function( key ) { self.entrySelected( key ) } );

        this._list = new ListWidget().init( params );
        this.addWidget( this._list, Style._safeLeft );

        window.ll( "tagScreen", "Format" );
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    FormatScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return FormatScreen;

})();


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GuideScreen = ( function()
{
    "use strict";

    GuideScreen.prototype = new Screen();

    function GuideScreen(){}

    GuideScreen.prototype.filtersChanged = function()
    {
        var self = this, onPopped;

        console.log( ">>>>>>>>>>>>>>>>>>>> FILTER HAVE CHANGED <<<<<<<<<<<<<<<<<<<<<" );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        onPopped = function()
        {
            _x2.popOverlay( self._toPop );
            self._gridListings.filtersChanged();
            self._favListings.filtersChanged();
        };

//         window.ll( "tagEvent", "Live TV: Find Channel Jump button", { channel: channel.getCallSign() } ); // Localytics 2.3.8
//         _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Find Channel Jump button: " + channel.getCallSign() ) : Config.NOP();

        _x2.popOverlay( this._overlay, onPopped );
    };

    GuideScreen.prototype.gotFocus = function()
    {
        if( this._ready === true )
            this.speak( _x2.requestFocus( this._menu, true ) );
    };

    GuideScreen.prototype.init = function()
    {
        var menuItems, i, str, body, onEnter, onGotFocus, makeOnEnter, makeOnGotFocus, widget, entries = [], self = this;
        var buttonStyle = new Style( { font:"regular" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000" } );
        var localytics;

        Screen.prototype.init.call( this, { noSep:true } );
        this._className     = "GuideScreen";
        this._telemetryName = "Guide";
        this._bodyWidgets   = [];

        makeOnEnter = function( which, localytics )
        {
            return function()
            {
                window.ll( "tagScreen", localytics ); // OK or DOWN
                _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: " + localytics + " tab" ) : Config.NOP();

                _x2._config.log( Config.CLASS_TELEMETRY , 2 ) ? console.info( "Telmetry: Screen Viewed: " + localytics ) : Config.NOP();
                _x2._telemetry.sendScreenViewed( localytics ); // NOTE: Same as Localytics

                if( which.startViewTimestamp )
                    which.startViewTimestamp(); // Localytics
                _x2.requestFocus( which );
            };
        };

        makeOnGotFocus = function( which, bc, telemetry )
        {
            return function()
            {
                if( self._activeWidget !== which )
                {
                    self.setBreadCrumbs( "Live TV", bc );

                    _x2._config.log( Config.CLASS_TELEMETRY, 1 ) ?  console.log( "Telemetry: Watch Button:" + telemetry ) : Config.NOP();

                     _x2._telemetry.watchPathReset();
                     _x2._telemetry.watchPathPush( telemetry ); // setWatchButton
                     _x2._telemetry.setWatchButton();

                    if( self._activeWidget )
                        self._activeWidget.animate( { a:0, duration:500 } );

                    self._activeWidget = which;

                    which.animate( { a:1, duration:500 } );

                    if( which instanceof GuideViewFilterWidget ) // other tabs loaded when focus switched
                        self._distractor.show();
                    else
                        self._distractor.hide();

                    if( which.loadData && !( which instanceof GridListingsWidget) ) {
                        if( which._list ) {
                            which.addWidget( which._list, Style._safeLeft );
                            which._list.patchWidget();//add widget dynamically
                            window.setTimeout( function() {
                                which.loadData();
                            }, 200);
                        } else {
                            which.loadData();
                        }
                    } else {
                        which.refresh();
                    }
                }
            };
        };
        _x2._data.cancelAllPendingRequests();//cancel the pending request, which make delay in displaying the rows
        
        this._distractor = new DistractorWidget().init();

        menuItems = _x2._config._guideMenu;
        for( i = 0; i < menuItems.length; i++ )
        {
            switch( menuItems[i] )
            {
                case "all":
                    str                = "All Channels";
                    body               = new GridListingsWidget().init();
                    localytics         = "Live TV: All Channels"; // GuideScreen, GridWidget, and GridRowWidget
                    this._gridListings = body;
                    break;

                case "favs":
                    str               = "Favorite Channels";
                    body              = new GridListingsFavoritesWidget().init();
                    localytics        = "Live TV: Favorites";
                    this._favListings = body;
                    break;

                case "kids":
                    str        = "Kids";
                    body       = new GuideViewFilterWidget().init( { filter:GuideViewFilterWidget.Filter.KIDS, distractor:this._distractor } );
                    localytics = "Live TV: Kids";
                    break;

                case "movies":
                    str        = "Movies";
                    body       = new GuideViewFilterWidget().init( { filter:GuideViewFilterWidget.Filter.MOVIE, distractor:this._distractor } );
                    localytics = "Live TV: Movies";
                    break;

                case "sports":
                    str        = "Sports";
                    body       = new GuideViewFilterWidget().init( { filter:GuideViewFilterWidget.Filter.SPORTS, distractor:this._distractor } );
                    localytics = "Live TV: Sports";
                    break;

                default:
                    str        = undefined;
                    body       = undefined;
                    localytics = "???";
                    console.error( "ERROR -> unknown menu entry = " + menuItems[i] );
                    break;
            }

            onEnter     = makeOnEnter( body, localytics );
            onGotFocus  = makeOnGotFocus( body, str,  localytics );

            widget = new StringWidget().init( { text:str, style:buttonStyle, onEnter:onEnter, focusTime:300 } );
            widget.setFocusListeners( onGotFocus );
            entries.push( widget );

            body.setA( 0 );
            this.addWidget( body );
            this._bodyWidgets.push( body );
        }

        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ); } );
        this.addWidget( this._distractor );

        var onOptions = function()
        {
            window.ll( "tagEvent", "Live TV Options Button" ); // Localytics 2.3.7
            _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Options Button" ) : Config.NOP();

            self._overlay = new GuideOptionsOverlay().init( { screen:self } );
            _x2.pushOverlay( self._overlay );
        };

        var onFocus = function()
        {
            if( self._url && self._schedule )
            {
                var ready = function()
                {
                    _x2.pushScreen( new VideoScreen().init( { url:self._url, mode:VideoScreen.Mode.LIVE, entity:self._schedule, streamId:self._streamId } ) );
                    self._distractor.hide();
                    self._url      = undefined;
                    self._schedule = undefined;
                };

                self._distractor.show();
                self._schedule.getDetail().then( ready );
            }
        };

        var options = new StringWidget().init( { text:"Options", style:buttonStyle, onEnter:onOptions } );
        options.setFocusListeners( onFocus );

        this._menu = new TabbedPillButtonsWidget().init( { entries:entries, options:options } );
        this._menu.setA( 0 );
        this._menu.addReadyCallback( function() { self.layoutMenu(); } );
        this.addWidget( this._menu );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        this._timePageViewStart = new Date(); // Localytics "All Channels" Page View duration

        return this;
    };

    GuideScreen.prototype.layoutMenu = function()
    {
        var y = this.getHeaderBottom();
        y = isNaN(y)? _x2.scaleValInt( 137 ) : y ;//if there is no header, then set default height

        var h = _x2._config._screenH - y;

        this._menu.setH( y );
        this._menu.setA( 1 );

        for( var i = 0; i < this._bodyWidgets.length; i++ )
        {
            this._bodyWidgets[i].setY( y );
            this._bodyWidgets[i].setH( h );
        }

        if( _x2._focus === this )
            this.speak( _x2.requestFocus( this._menu, true ) );

        this._ready = true;
    };

    GuideScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LAST:
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {

                    if( this._menu.containsWidget( _x2._focus ) === false )
                    {
                        if( this._activeWidget.stopViewTimestamp )
                            this._activeWidget.stopViewTimestamp(); // Localytics

                        _x2.requestFocus( this._menu );
                    }
                    else
                    {
                        // Localytics Back Button and total time user viewed LiveTV: All
                        // Focus can be on:
                        //   GridListingsWidget    -- All channels
                        //   GuideViewFilterWidget -- Kids, Sports, or Movies
                        if( this._timePageLoadStart && this._activeWidget instanceof GridListingsWidget )
                        {
                            var millisecondsViewDuration = new Date() - this._timePageViewStart;
                            window.ll( 'tagEvent', 'Back Button LiveTV', { "Duration": millisecondsViewDuration } );
                            _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics Back Button, LiveTV: All view, duration: " + millisecondsViewDuration  + " (ms)" ) : Config.NOP();
                        }

                        retval = Screen.prototype.processEvent.call( this, val, type );
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    GuideScreen.prototype.refreshCheck = function()
    {
        if( this._activeWidget.refresh )
            this._activeWidget.refresh( this );
    };

    GuideScreen.prototype.setJumpToChannel = function( channel )
    {
        var self = this, onPopped;

        onPopped = function()
        {
            _x2._telemetry.lastChannel = channel.getNumber();
            _x2.popOverlay( self._toPop );
            self._gridListings.setJumpToChannel( channel );
            self._favListings.setJumpToChannel( channel );
        };

        window.ll( "tagEvent", "Live TV: Find Channel Jump button", { channel: channel.getCallSign() } ); // Localytics 2.3.8
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Find Channel Jump button: " + channel.getCallSign() ) : Config.NOP();

        _x2.popOverlay( this._overlay, onPopped );
    };

    GuideScreen.prototype.setToPop = function( overlay )
    {
        this._toPop = overlay;
    };

    GuideScreen.prototype.setTuneToChannel = function( channel )
    {
        var self = this, onPopped;

        onPopped = function()
        {
            var schedules = channel.getSchedules();
            var now       = new Date().getTime();

            for( var i = 0; i < schedules.length; i++ )
            {
                if( now >= schedules[i].getStartTime() && now < schedules[i].getEndTime() )
                {
                    self._schedule = schedules[i];
                    _x2._config.log( Config.CLASS_TELEMETRY, 1 ) ?  console.log( "Telemetry: Previous Watch Source:" + _x2._telemetry.getWatchButtonSource() ) : Config.NOP();
                    _x2._telemetry.setWatchButton( "Channel Finder" ); // NOTE: Keep in sync with GuideScreen and GridRowWidget
                    break;
                }
            }

            self._url      = channel.getStreamUrl();
            self._streamId = channel.getStreamId();

            _x2._telemetry.lastChannel = channel.getNumber();
            _x2.popOverlay( self._toPop );
        };

        window.ll( "tagEvent", "Live TV: Find Channel Play button", { channel: channel.getCallSign() } ); // Localytics 2.3.8
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Find Channel Play button: " + channel.getCallSign() ) : Config.NOP();

        _x2.popOverlay( this._overlay, onPopped );
    };

    GuideScreen.prototype.speak = function( focus )
    {
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to change filters. Go all the way left for options. Press up or down to review channels. ", focus._speakRole, this, false );
    };

    return GuideScreen;

})();


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.LoadingScreen = ( function()
{
    "use strict";

    LoadingScreen.prototype = new Screen();

    function LoadingScreen(){}

    LoadingScreen.prototype.gotFocus = function()
    {
        this._speakTarget.setText( "Loading X Finity Stream." );
        this._speakTarget.setSpeechParams( undefined, undefined, this, false );
    };

    LoadingScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this, { noBg:true, noHeader:true, noSep:true } );
        this._className     = "LoadingScreen";
        this._telemetryName = "Loading";

        var params    = {
                            name : "SplashScreen",
                            url  : _x2._config._imageRootMso + "splashScreen.jpg"
                        };

        this.addWidget( new ImageWidget().init( params ) );

        return this;
    };

    return LoadingScreen;

})();


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MainMenuScreen = ( function()
{
    "use strict";

    MainMenuScreen.prototype = new Screen();

    function MainMenuScreen(){}

    MainMenuScreen.prototype.getBgInfo = function()
    {
        // morning    4:00 am - 11:59 am
        // afternoon 12:00 pm -  6:00 pm
        // evening    6:00 pm -  3:59 am

        var retval;
        var now    = new Date();
        var mins   = now.getHours() * 60 + now.getMinutes();

        if( mins >= 0 && mins < 240 )
            retval = _x2._config._imageRoot + "mainMenu/evening.jpg";
        else if( mins >= 240 && mins < 720 )
            retval = _x2._config._imageRoot + "mainMenu/morning.jpg";
        else if( mins >= 720 && mins < 1080 )
            retval = _x2._config._imageRoot + "mainMenu/afternoon.jpg";
        else if( mins >= 1080 && mins < 1440 )
            retval = _x2._config._imageRoot + "mainMenu/evening.jpg";

        return retval;
    };

    MainMenuScreen.prototype.gotFocus = function( losingFocus, newScreen )
    {
        _x2._hi.fadeOut();

        if( newScreen !== false )
        {
            this._speakTarget.setText( "Main Menu. " + this._entries[this._index].getText() + ". " );
            this._speakTarget.setSpeechParams( "Press right or left to review options. Press down for content options. Press OK to select.", "button", this, false );
        }

        if( this._ready === true && this._inTransition === false ) {
            this.setHighlighted( true, newScreen !== false );
            window.setTimeout( function() {
                _x2._hi.fadeOut();
            }, 300);//sometimes, highlight widget is not hide when come back from Live TV
        }

        _x2._telemetry.setWatchButton(); // intentional undefined param
        _x2._telemetry.watchPathReset();
    };

    MainMenuScreen.prototype.init = function()
    {
        this._inTransition = false;
        this._numLoaded    = 0;
        this._numNeeded    = 1;
        this._vertIndex    = 0;
        this._entries      = [];
        this._buttons      = [];
        this._scrollRate   = _x2.scaleVal( 1.8 ); // px / msec
        this._wrapperTop   = _x2.scaleValInt( 180 );

        var self        = this, menuItems, i, icons = [];
        var style       = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );
        var dayPartData = this.getBgInfo();
        var guide       = function() { _x2.pushScreen( new GuideScreen   ().init() ); };
        var saved       = function() { _x2.pushScreen( new SavedScreen   ().init() ); };
        var search      = function() { _x2.pushScreen( new SearchScreen  ().init() ); };
        var settings    = function() { _x2.pushScreen( new SettingsScreen().init() ); };
        var onDemand    = function()
        {
            if( _x2._vodRoot )
                _x2.pushScreen( new VodRootScreen ().init() );
            else
            {
                console.error( "NO VOD ROOT" );
                console.error( _x2._vodRootError );
                _x2.pushOverlay( new ErrorOverlay().init( { error:_x2._vodRootError, context:ErrorOverlay.Context.VOD } ) );

                var setVod = function( root )
                {
                    _x2._vodRoot = root;
                };

                var onVodError = function( error )
                {
                    console.log( "ERROR -> unable to load VOD" );
                    console.log( error );

                    _x2._vodRootError = error;
                };

                _x2._data.getVodRoot(1,0).then( setVod ).catch( onVodError );
            }
        };
        window.setTimeout( function() {
            var screenName = 'Heads-Up Message for 2017 Models';
            _x2._splunk.sendScreenViewedEvent(screenName);
            _x2._telemetry.sendScreenViewed(screenName);
            _x2.pushOverlay( new DepreciationNoticeOverlay().init() );
        }.bind(this), 0);

        var layout = function()
        {
            if( ++self._numLoaded === self._numNeeded )
            {
                var imW     = self._buttons[0].getW();
                var imH     = self._buttons[0].getH();
                var x       = (_x2._config._screenW - self._buttons.length * imW) / 2;
                var y       = _x2.scaleValInt( 220 );
                var offset  = _x2.scaleValInt( 114 );

                for( var i = 0; i < self._buttons.length; i++ )
                {
                    self._buttons[i].setX( x );
                    self._entries[i].setW( imW );
                    self._entries[i].setY( offset );

                    icons[i].setX( (imW - icons[i].getW()) / 2 );
                    icons[i].setY( 0.21875 * imH );

                    self._buttons[i].setA(1);
                    x += self._buttons[i].getW();
                }

                self._vertOffsets = [ 0 ];
                self._rowsOffset = y + self._menuContainer.getH() + _x2.scaleValInt( 40 );
                self._lastWatched.setY( _x2._config._screenH );
                self._featured.setY( _x2._config._screenH );
                self._ready = true;
                self._brand.animate( { alpha:1, duration:400, start:400 } );

                if( _x2._focus === self )
                    self.setHighlighted( true, true );

                self._container.animate( { a:1, duration:1000 } );

                _x2.addChangeCallback( function() { self.tick(); } );

                self.setMouseWheelListener( function( event ) { self.processEvent( ( event.deltaY > 0 ) ? Host.KEY_DOWN : Host.KEY_UP, Host.KEY_PRESSED ); } );
            }
        };

        Screen.prototype.init.call( this, { noBg:false, noHeader:false, noSep:true, image:dayPartData } );
        this._className     = "MainMenuScreen";
        this._telemetryName = "Main Menu";

        this._brand = new ImageWidget().init( { url:_x2._config._imageRootMso + "msoLogo.png", onLoad:layout } );
        this._brand.setA( 0 );
        this.addWidget( this._brand, Style._safeLeft, Style._safeTop );

        this._menuContainer = new Widget().init();
        this._menuContainer.setA( 0 );
        
        this._container = new Widget().init();
        this._container.setA( 0 );

        // Adding the wrapper container with position as relative and overflow as hidden, 
        // so that animation on widget container will not overlapped the app logo or header.
        this._wrapperContainer = new Widget().init();
        this._wrapperContainer.setA( 1 );
        this._wrapperContainer.setY( this._wrapperTop );
        this._wrapperContainer.setH( _x2._config._screenH );
        this.addWidget( this._wrapperContainer );
        
        this._wrapperContainer.addWidget( this._menuContainer );
        this._wrapperContainer.addWidget( this._container );

        menuItems = _x2._config._mainMenu;

        for( i = 0; i < menuItems.length; i++ )
        {
            switch( menuItems[i] )
            {
                case "guide":
                    this._numNeeded += 2;
                    this._entries.push( new StringWidget().init( { text:"Live TV", style:style } ) );
                    this._buttons.push( new DualImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/button.png", urlHi:_x2._config._imageRoot + "mainMenu/buttonHi.png", onEnter:guide, focusTime:300, lostFocusScale:0.94 } ) );
                    icons.push(  new ImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/live.png", onLoad:layout } ) );
                    this._buttons[this._buttons.length-1].addWidget( icons[icons.length-1] );
                    break;

                case "onDemand":
                    this._numNeeded += 2;
                    this._entries.push( new StringWidget().init( { text:"Browse", style:style } ) );
                    this._buttons.push( new DualImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/button.png", urlHi:_x2._config._imageRoot + "mainMenu/buttonHi.png", onEnter:onDemand, focusTime:300, lostFocusScale:0.94 } ) );
                    icons.push(  new ImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/browse.png", onLoad:layout } ) );
                    this._buttons[this._buttons.length-1].addWidget( icons[icons.length-1] );
                    break;

                case "saved":
                    this._numNeeded += 2;
                    this._entries.push( new StringWidget().init( { text:"Saved", style:style } ) );
                    this._buttons.push( new DualImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/button.png", urlHi:_x2._config._imageRoot + "mainMenu/buttonHi.png", onEnter:saved, focusTime:300, lostFocusScale:0.94 } ) );
                    icons.push(  new ImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/saved.png", onLoad:layout } ) );
                    this._buttons[this._buttons.length-1].addWidget( icons[icons.length-1] );
                    break;

                case "search":
                    this._numNeeded += 2;
                    this._entries.push( new StringWidget().init( { text:"Search", style:style } ) );
                    this._buttons.push( new DualImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/button.png", urlHi:_x2._config._imageRoot + "mainMenu/buttonHi.png", onEnter:search, focusTime:300, lostFocusScale:0.94 } ) );
                    icons.push(  new ImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/search.png", onLoad:layout } ) );
                    this._buttons[this._buttons.length-1].addWidget( icons[icons.length-1] );
                    break;

                case "settings":
                    this._numNeeded += 2;
                    this._entries.push( new StringWidget().init( { text:"Settings", style:style } ) );
                    this._buttons.push( new DualImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/button.png", urlHi:_x2._config._imageRoot + "mainMenu/buttonHi.png", onEnter:settings, focusTime:300, lostFocusScale:0.94 } ) );
                    icons.push(  new ImageWidget().init( { url:_x2._config._imageRoot + "mainMenu/settings.png", onLoad:layout } ) );
                    this._buttons[this._buttons.length-1].addWidget( icons[icons.length-1] );
                    break;

                default:
                    console.error( "ERROR -> unknown main menu entry = " + menuItems[i] );
                    break;
            }
        }

        for( i = 0; i < this._buttons.length; i++ )
        {
            this._buttons[i].addReadyCallback( layout );
            this._buttons[i].addWidget( this._entries[i] );
            this._menuContainer.addWidget( this._buttons[i], 0, self._wrapperTop );
            this._buttons[i].setA(0);
        }
        this._wrapperContainer.setY(self._wrapperTop);
        this._menuContainer.setY(-self._wrapperTop);
        this._index = 0;

        this._lastWatched = new LastWatchedRowWidget().init( { w:_x2._config._screenW - Style._safeLeft - Style._safeRight, sep:false, obj:this } );
        this._lastWatched.setA( 0 );
        this._container.addWidget( this._lastWatched, Style._safeLeft );

        this._featured = new SmallPromoRowWidget().init( { w:_x2._config._screenW - Style._safeLeft - Style._safeRight, sep:false } );
        this._featured.setA( 0 );
        this._container.addWidget( this._featured, Style._safeLeft );

        this.refreshCheck();

        window.ll( "tagScreen", "Main Menu" ); // Localytics 2.1.1
        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Main Menu screen" ) : Config.NOP();

        _x2.localyticsSendSplashPageAndProvisioning();

        return this;
    };

    MainMenuScreen.prototype.lostFocus = function()
    {
       this.setHighlighted( false );
    };

    MainMenuScreen.prototype.play = function( params )
    {
        _x2.pushScreen( new VideoScreen().init( params ) );
    };

    MainMenuScreen.prototype.processEvent = function( val, type )
    {
        var retval = true, self = this, duration, i;

        var setWatchSource = function( name )
        {
            _x2._telemetry.watchPathReset();
            _x2._telemetry.watchPathPush( name );
            _x2._telemetry.setWatchButton();
        };

        var onTransitionEnd = function()
        {
            self._inTransition = false;
            if( self._vertIndex === 0 )
            {
                self._index = (self._index)? self._index : 0;
                _x2.requestFocus( self._buttons[self._index] );
                self.setHighlighted( true, true );
            }
            else if( self._vertIndex === 1 )
            {
                
                self.setHighlighted( false, true );
                if( self._hasLastWatched === true )
                {
                    setWatchSource( "Player: Last Watched" );
                    _x2.requestFocus( self._lastWatched );
                }
                else
                {
                    setWatchSource( "Featured" );
                    _x2.requestFocus( self._featured );
                }
            }
            else if( self._vertIndex === 2 )
            {
                setWatchSource( "Featured" );
                _x2.requestFocus( self._featured );
            }
        };
        var overlayScreen = _x2._overlayRoot.getTop(); 
        var hasOverlay = ( overlayScreen instanceof ExitAppOverlay );
        if( hasOverlay ) {
            _x2.requestFocus( overlayScreen._buttons );
        }
        if( this._inTransition === false && !hasOverlay )
            switch( val )
            {
                case Host.KEY_DOWN:
                    if( type === Host.KEY_PRESSED && this._inTransition === false )
                    {
                        if( this._vertIndex < this._vertOffsets.length - 1 )
                        {
                            _x2._hi.fadeOut();
                            _x2._hi.setA(0);
                            duration = (this._vertOffsets[this._vertIndex] - this._vertOffsets[this._vertIndex + 1]) / this._scrollRate;
                            this._inTransition = true;

                            if( this._vertIndex === 0 )
                            {
                                this._menuContainer.animate( { a:0, duration:duration } );
                            }

                            this._vertIndex++;
                            this._container.animate( { y:this._vertOffsets[this._vertIndex], duration:duration, onEnd:onTransitionEnd } );
                        }
                    }
                    break;

                case Host.KEY_ENTER:
                    if( type === Host.KEY_PRESSED && this._inTransition === false )
                         this._buttons[this._index].onEnter();
                    break;

                case Host.KEY_LEFT:
                    if( type === Host.KEY_PRESSED && this._inTransition === false )
                    {
                        if( this._index > 0 )
                        {
                            this.setHighlighted( false );
                            this._index--;
                            this.setHighlighted( true );
                        }
                    }
                    break;

                case Host.KEY_RIGHT:
                    if( type === Host.KEY_PRESSED && this._inTransition === false )
                    {
                        if( this._index < this._buttons.length - 1 )
                        {
                            this.setHighlighted( false );
                            this._index++;
                            this.setHighlighted( true );
                        }
                    }
                    break;

                case Host.KEY_UP:
                    if( type === Host.KEY_PRESSED && this._inTransition === false )
                    {
                        if( this._vertIndex > 0 )
                        {
                            _x2._hi.fadeOut();
                            _x2._hi.setA( 0 );
                            duration = (this._vertOffsets[this._vertIndex - 1] - this._vertOffsets[this._vertIndex]) / this._scrollRate;
                            this._inTransition = true;

                            if( this._vertIndex === 1 )
                            {
                                this._menuContainer.animate( { a:1, duration:duration } );
                            }
                            this._vertIndex--;
                            this._container.setY(this._vertOffsets[this._vertIndex]);
                            onTransitionEnd();
                        }
                    }
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    MainMenuScreen.prototype.refreshCheck = function()
    {
        var self = this;

        var onFeatured = function( data )
        {
            self._hasFeatured = data.getTotalEntityCount() > 0;
            self._featured.setData( data );
        };

        var onFeaturedFailed = function( error )
        {
            console.error( error );
        };

        var onLastWatched = function( data )
        {
            self._hasLastWatched = data.length > 0;
            self._lastWatched.setData( self._hasLastWatched ? { getTitle: function() { return "Last Watched"; }, getEntities: function() { return data; } } : undefined );
        };

        var onLastWatchedFailed = function( error )
        {
            console.error( error );
        };

        var onRowsReady = function()
        {
            var y       = self._rowsOffset;
            var offsets = [ 0 ];
            var inset   = self._brand.getY() + self._brand.getH();
            var offset  = inset - y;

            self._wrapperContainer._div.style.position = 'relative';
            self._wrapperContainer._div.style.overflow = 'hidden';

            var onEnd = function()
            {
                self._vertOffsets = offsets;
            };

            if( self._hasLastWatched )
            {
                self._lastWatched.animate( { y:y, duration:750, onEnd:self._hasFeatured === true ? undefined : onEnd } );
                y += self._lastWatched.getH();
                offsets.push( offset - self._wrapperTop );
                offset = inset - y;
            }

            if( self._hasFeatured )
            {
                self._featured.animate( { y:y, duration:750, onEnd:onEnd } );
                offsets.push( offset - self._wrapperTop );
            }
        };

        if( self._lastWatched.containsWidget( _x2._focus ) === true || self._featured.containsWidget( _x2._focus ) === true )
            _x2.requestFocus( this );

        _x2._hi.fadeOut();
        this._lastFocus   = this;
        this._vertIndex   = 0;
        this._vertOffsets = [ 0 ];
        this._container.setY( 0 );
        this._lastWatched.setY( _x2._config._screenH );
        this._featured.setY( _x2._config._screenH );

        if( self._menuContainer.getA() == 0 ) {
            this._menuContainer.animate( { a:1, duration: 750 } );
        }//animate only when menu container not visible
        
        var lastWatched = new LastWatched().getEntries().then( onLastWatched, onLastWatchedFailed );
        var featured    = _x2._data.getForYouFeaturedMenu(true).then( onFeatured   , onFeaturedFailed    );

        Promise.all( [ lastWatched, featured ] ).then( onRowsReady );
    };

    MainMenuScreen.prototype.setHighlighted = function( bool, newScreen )
    {
        if( bool === true )
        {
            _x2.requestFocus( this._buttons[this._index] );
            if( newScreen !== true )
                this._entries[this._index].setSpeechParams( undefined, "button", this, false );
        }
        else
            this._buttons[this._index].lostFocus();
    };

    MainMenuScreen.prototype.tick = function()
    {
        var shouldUrl = this.getBgInfo();
        var image     = this.getBgImage();
        var isUrl     = image.getUrl();

        if( isUrl !== shouldUrl )  // don't fade all the way to 0 since the tick may occur while screen is invisible, this ensures update when visible
            image.animate( { a:0.01, duration:500, onEnd: function() { image.setUrl( shouldUrl ); image.animate( { a:1, duration:500 } ); } } );
    };

    return MainMenuScreen;

})();


/***/ }),
/* 194 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ManageDevicesScreen = ( function()
{
    "use strict";

    ManageDevicesScreen.prototype = new Screen();

    function ManageDevicesScreen(){}

    ManageDevicesScreen.prototype.gotFocus = function()
    {
       _x2.requestFocus( this._list );
    };

    ManageDevicesScreen.prototype.init = function()
    {
        var i, listParams = {}, rows, entries, nameStr, onDownloads, onName, onStreams, self = this;

        Screen.prototype.init.call( this );
        this._className     = "ManageDevicesScreen";
        this._telemetryName = "Manage Devices"; // TODO: Is this correct?
        this.setBreadCrumbs( "Settings", "Manage Devices" );

        nameStr = function()
        {
            var onGotList;

            /**
             * @param {Object[]} data
             * @param {Boolean}  data[].isCurrent - indicates that this is device on which the application is currently running
             */
            onGotList = function( data )
            {
                var name;

                if( data && data.length )
                {
                    for( i = 0; i < data.length; i++ )
                        console.log( "Device" + (i+1) + ":" + JSON.stringify(data[i]) );

                    for( i = 0; i < data.length; i++ )
                        if( data[i].isCurrent === true )
                        {
                            name = data[i].deviceName;
                            break;
                        }
                }

                self._nameRowData.value = ( name === undefined ) ? "No Device Name" : name;
                self._list.refreshCells();
            };

            _x2._data.getAllDeviceList().then( onGotList );

            return "...";
        };

        onDownloads = function()
        {
            _x2.pushScreen( new DownloadDevicesScreen().init( { path:"Settings / Manage Devices" } ) );
        };

        onName = function()
        {
            _x2.pushScreen( new DeviceNameScreen().init( { path:"Settings / Manage Devices", onChange:nameStr } ) );
        };

        onStreams = function()
        {
            _x2.pushScreen( new StreamingDevicesScreen().init( { path:"Settings / Manage Devices" } ) );
        };

        rows    = [];
        entries = _x2._config._manageDevicesMenu;

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "deviceName":
                    this._nameRowData = { title:"Device Name:", showIcon:true, onEnter:onName, value:nameStr() };
                    rows.push( this._nameRowData );
                    break;

                case "deviceDownloads":
                    rows.push( { title:"Devices with Downloads", showIcon:true, onEnter:onDownloads } );
                    break;

                case "deviceStreams":
                    rows.push( { title:"Devices Currently Streaming", showIcon:true, onEnter:onStreams } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = MenuRowWidget;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

         _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Manage Devices screen" ) : Config.NOP();
        window.ll( "tagScreen", "Manage Devices screen" ); // Localytics ?.?.?

        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    ManageDevicesScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return ManageDevicesScreen;

})();


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.MiniGuideScreen = ( function()
{
    "use strict";

    MiniGuideScreen.prototype = new Screen();

    function MiniGuideScreen(){}

    MiniGuideScreen.prototype.destroy = function()
    {
        _x2.removeChangeCallback( this._tickCallback );
        Screen.prototype.destroy.call( this );

        _x2._videoRoot.style.transform = "scale( 1, 1 )";
        _x2._videoRoot.style.left      = "0px";
        _x2._videoRoot.style.top       = "0px";
    };

    MiniGuideScreen.prototype.gotFocus = function()
    {
        if( this._dataReady === true )
            this.speak( _x2.requestFocus( this._list, true ) );
    };

    /**
     * @memberof MiniGuideScreen
     * @param   {Object}      params
     * @param   {Number}      params.selectedIndex - index if the currently active entry
     * @param   {VideoScreen} params.videoScreen - instance of VideoScreen that launched this screen
     * @returns {MiniGuideScreen}
     */
    MiniGuideScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this, { noBg:true, noHeader:true, noSep:true } );
        this._className     = "MiniGuideScreen";
        this._telemetryName = "Mini Guide";
        this._videoScreen   = params.videoScreen;
        this._numLoaded     = 0;

        var self       = this, listParams = {}, topParams, rightParams, layout, onBottomFadeLoaded, date;
        var titleStyle = new Style( { font:"light"  , color:"#8c8c8c", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var backStyle  = new Style( { font:"medium" , color:"#8c8c8c", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var timeStyle  = new Style( { font:"light"  , color:"#8c8c8c", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
        var progStyle  = new Style( { font:"regular", color:"#8c8c8c", fontSize:_x2.scaleValInt(40), whiteSpace:"nowrap", overflow:"hidden" } );

        topParams =
        {
            w     : _x2._config._screenW,
            h     : _x2.scaleValInt( 141 ),
            color : "#000000"
        };

        rightParams  =
        {
            w     : _x2.scaleValInt( 640 ),
            h     : _x2._config._screenH,
            color : "#000000"
        };

        layout = function()
        {
            if( ++self._numLoaded === 2 )
            {
                self._backStr.setX( _x2._config._screenW - self._backStr.getW() - Style._safeRight );
                self._backStr.setY( Style._safeTop + (self._title.getH() - self._backStr.getH()) / 2 );
                self._progTitle.setY( _x2._config._screenH - Style._safeBottom - self._progTitle.getH() );
                self._fade.setX( self._progTitle.getX() + self._progTitle.getW() - self._fade.getW() );
                self._fade.setY( self._progTitle.getY() );
                self._fade.setW( self._fade.getW() );
                self._fade.setH( self._progTitle.getH() );
            }
        };

        onBottomFadeLoaded = function()
        {
            self._bottomFade.setX( self._right.getX() );
            self._bottomFade.setY( _x2._config._screenH - self._bottomFade.getH() );
            self._bottomFade.setH( self._bottomFade.getH() );
            self._bottomFade.setW( self._right.getW() );
        };

        this._top = new RectWidget().init( topParams );
        this.addWidget( this._top );

        this._bottom = new RectWidget().init( topParams );
        this._bottom.setH( _x2.scaleValInt( 220 ) );
        this.addWidget( this._bottom, 0, _x2._config._screenH - this._bottom.getH() );

        this._right = new RectWidget().init( rightParams );
        this.addWidget( this._right, _x2._config._screenW - rightParams.w );

        this._title = new StringWidget().init( { text:"Mini Guide", style:titleStyle } );
        this.addWidget( this._title, _x2._config._screenW - rightParams.w + 3 * Style._pad, Style._safeTop );

        this._backStr = new StringWidget().init( { text:"Press [Back] to exit", style:backStyle } );
        this._backStr.addReadyCallback( layout );
        this.addWidget( this._backStr, 0, Style._safeTop );

        this._time = new StringWidget().init( { text:_x2.createTimeStr(), style:timeStyle } );
        this.addWidget( this._time, Style._safeLeft, Style._safeTop );

        this._progTitle = new StringWidget().init( { text:"Now Playing: ", style:progStyle } );
        this._progTitle.setW( this._right.getX() - Style._safeLeft );
        this.addWidget( this._progTitle, Style._safeLeft );

        this._fade = new ImageWidget().init( { url:_x2._config._imageRoot + "textFade2.png", onLoad:layout } );
        this.addWidget( this._fade );

        listParams.w        = this._right.getW() - 3 * Style._pad;
        listParams.h        = _x2._config._screenH - this._top.getH();
        listParams.maxIndex = 3;
        listParams.type     = MiniGridRowWidget;
        listParams.obj      = this;
        listParams.stepTime = 150;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, _x2._config._screenW - this._right.getW() + 3 * Style._pad, this._top.getH() );

        this._bottomFade = new ImageWidget().init( { url:_x2._config._imageRoot + "bottomFade.png", onLoad:onBottomFadeLoaded } );
        this.addWidget( this._bottomFade );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self._right ); self._distractor.show(); } );
        this._right.addWidget( this._distractor );

        this._tickCallback = function()
        {
            self._time.setText( _x2.createTimeStr() );

            // TODO update programs every minute

//             var index = this._list.getCurrentAndMaxIndex().current;
//
//             this._list.setJumpToIndex( index );
        };

        _x2.addChangeCallback( this._tickCallback );

        // get the list of channels

        date = new Date();
        date.setMilliseconds( 0 );
        date.setSeconds( 0 );
        date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

        this.setNowPlaying( true );

        return this;
    };

    MiniGuideScreen.prototype.loadData = function()
    {
        var self = this;

        var onChannelsLoaded = function()
        {
            var chanColl = _x2._channelCollection;
            var channels = chanColl.getChannels();
            self._dataReady = true;
            self._cc        = chanColl;
            self._list.setData( channels );

            var lastChannel = _x2._settings.getValue( Settings.Key.LAST_CHAN );

            if( lastChannel )
                for( var i = 0; i < channels.length; i++ )
                    if( channels[i].getStationId() === lastChannel.id && channels[i].getNumber() === lastChannel.num )
                    {
                        self._list.setJumpToIndex( i );
                        break;
                    }

            self._distractor.hide();

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._list, true ) );
        };

        var onChannelsFailed = function( error )
        {
            var onDismiss = function()
            {
                _x2.popScreen( self );
            };

            var onRetry = function()
            {
                var retry = function()
                {
                    _x2._channelCollection.fetch().then( onChannelsLoaded, onChannelsFailed );
                };

                _x2.popOverlay( self._errorOverlay, retry );
            };

            self._errorOverlay = _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.GUIDE, onDismiss:onDismiss, onRetry:onRetry } ) );
        };

        var date = new Date();
        date.setMilliseconds( 0 );
        date.setSeconds( 0 );
        date.setMinutes( (date.getMinutes() < 30) ? 0 : 30 );

        _x2._channelCollection.fetch().then( onChannelsLoaded, onChannelsFailed );

        this.setNowPlaying( false );

        return this;
    };

    MiniGuideScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LAST:
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    this.sendMiniGuideLocalytics( "Dismiss" );
                    _x2.popScreen( this );
                }
                break;


            case Host.KEY_SOFT_D:
                if( type === Host.KEY_PRESSED )
                    this.setNowPlaying( false );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval
    };

    MiniGuideScreen.prototype.pushComplete = function()
    {
        console.log( "PUSH COMPLETE" );

        var w     = this._right.getW();
        var scale = (_x2._config._screenW - w) / _x2._config._screenW;

        _x2._videoRoot.style.transform = "scale( " + scale + ", " + scale +  " )";
        _x2._videoRoot.style.left      = "-" + w / 2 + "px";
        _x2._videoRoot.style.top       = "-" + (this._bottom.getH() - this._top.getH()) / 2 + "px";

        this.loadData();
    };

    /**
     * @param {String}                      action - "Dismiss", "Info", or "Watch"
     * @param {LinearShowing|ProgramEntity} showing
     */
    MiniGuideScreen.prototype.sendMiniGuideLocalytics = function( action, showing )
    {
        var entity  = showing ? showing : this._videoScreen._entity;
        var channel = entity && entity.getChannel ? entity.getChannel() : undefined;
        var metrics =
        {
            "Action" : action,
            "Name"   : entity  ? entity .getTitle()    : "NA",
            "Station": channel ? channel.getCallSign() : "NA"
        };

        window.ll( "tagEvent", "Mini-Guide", metrics );
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Mini-Guide: " + metrics ) : Config.NOP();
    };

    MiniGuideScreen.prototype.setNowPlaying = function( isSetSpeech )
    {
        var str = this._videoScreen._title.getText();
        var sub = this._videoScreen._subTitleSpeak || this._videoScreen._subTitle.getText();

        if( sub )
            str += " - " + sub;

        this._progTitle.setText( "Now Playing: " + str );

        // if( userPressedInfo )
        //    this.sendMiniGuideLocalytics( "Info" );
    };

    MiniGuideScreen.prototype.setTuneToChannel = function( channel, sched )
    {
        var self = this, onPopped;

        onPopped = function()
        {
            var onReady = function()
            {
                var url      = channel.getStreamUrl();
                var streamId = channel.getStreamId();

                // Handle switching from "Last Watched" back to Linear
                _x2._telemetry.watchPathReset();
                _x2._telemetry.setWatchButton( "Player: Mini-Guide" ); // Technically "Live TV: All Channels" but want to keep track of player source

                self.sendMiniGuideLocalytics( "Watch", sched );
                //Set last channel when tune channel in miniguide
                _x2._settings.setValue( Settings.Key.LAST_CHAN, { id: channel.getStationId(), num: channel.getNumber() } );
                self._videoScreen.play( { url:url, mode:VideoScreen.Mode.LIVE, entity:sched, streamId:streamId } );
            };

            var onError = function()
            {
                console.error( "Unable to get program detail." );
                self._videoScreen.hideDistractor();
            };

            sched.getDetail().then( onReady, onError );
        };

        this._videoScreen.showDistractor( true );
        _x2.popScreen( this, onPopped );
    };

    MiniGuideScreen.prototype.speak = function( focus )
    {
        var speechText = this._progTitle.getText() || "Mini Guide. " + focus._speakStr + ". ";
        this._speakTarget.setText( speechText );
        this._speakTarget.setSpeechParams( " Press up or down to review channels. Press OK to tune. Press back to dismiss. ", focus._speakRole, this, false );
    };

    return MiniGuideScreen;

})();


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.NotEntitledScreen = ( function()
{
    "use strict";

    NotEntitledScreen.prototype = new Screen();

    function NotEntitledScreen(){}

    NotEntitledScreen.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._help );
    };

    NotEntitledScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this, { noBg:false, noHeader:true, noSep:true } );
        this._className     = "NotEntitledScreen";
        this._telemetryName = "Not Entitled";

        this._help = new HelpOverlay().init( true );
        this.addWidget( this._help );

        _x2._config._host.removeAllTokenLocalStorage();
        _x2._config._host.removeLocalStorage( "features"     );

        return this;
    };

    NotEntitledScreen.prototype.processEvent = function( val, type )
    {
        if( val === Host.KEY_LAST && type === Host.KEY_PRESSED && this._sentAuthorize !== true )
        {
            this._sentAuthorize = true;
            _x2.authorize();
        }

        return true;
    };

    return NotEntitledScreen;

})();


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ParentalControlsScreen = ( function()
{
    "use strict";

    ParentalControlsScreen.prototype = new Screen();

    function ParentalControlsScreen(){}

    ParentalControlsScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( "Parental Controls. " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    ParentalControlsScreen.prototype.init = function()
    {
        var entries, i, params = {}, onPinOnOff, onOffStr, onSafeBrowse, safeBrowseStr, onReset, onModifyPin, self = this;

        Screen.prototype.init.call( this );
        this._className     = "ParentalControlsScreen";
        this._telemetryName = "Parental Controls";
        this.setBreadCrumbs( "Settings", "Parental Controls" );

        onModifyPin = function()
        {
            PinOverlay.setPinFlow( PinOverlay.FlowType.PARENTAL_CONTROL, undefined, true );
        };

        onPinOnOff = function( widget )
        {
            var onEnter = function( val )
            {
                _x2._pc.setEnabled( val );
                _x2._data.setParentalControlsSettings( _x2._pc );
                widget.setValue( onOffStr() );
            };

            _x2.pushOverlay( new OnOffOverlay().init( { onEnter:onEnter, isOn:_x2._pc.isEnabled() } ) );
        };

        onOffStr = function()
        {
            return _x2._pc.isEnabled() ? "On" : "Off";
        };

        onReset = function()
        {
            var onEnter = function()
            {
                _x2._pc.setSafeBrowse     ( ParentalControls.SafeBrowse.OFF           );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.ADULT, false );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.NC17 , false );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.R    , false );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.PG13 , false );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.PG   , false );
                _x2._pc.setMovieRatingLock( ParentalControls.MpaaRatings.G    , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TVMA   , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TV14   , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TVPG   , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TVG    , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TVY7   , false );
                _x2._pc.setTvRatingLocks  ( ParentalControls.TvRatings.TVY    , false );

                _x2._data.setParentalControlsSettings( _x2._pc );
                _x2._data.setParentalControlsRatings ( _x2._pc );

                self._list.setEntry( "title", "Safe Browse:", { title:"Safe Browse:", value:safeBrowseStr(), showIcon:true, onEnter:onSafeBrowse } );

                _x2.popOverlay();
            };

            _x2.pushOverlay( new ResetParentalOverlay().init( { onEnter:onEnter } ) );
        };

        onSafeBrowse = function( widget )
        {
            var onEnter = function()
            {
                widget.setValue( safeBrowseStr() );
                _x2.popScreen();
            };

            _x2.pushScreen( new SafeBrowseScreen().init( { onEnter:onEnter } ) );
        };

        safeBrowseStr = function()
        {
            var str = "????????";

            switch( _x2._pc.getSafeBrowse() )
            {
                case "OFF":
                    str = "Off";
                    break;

                case "MEDIUM":
                    str = "Medium Safety";
                    break;

                case "HIGH":
                    str = "High Safety";
                    break;
            }

            return str;
        };

        this._rows = [];
        entries    = _x2._config._parentalControlsMenu;

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "enable":
                    this._rows.push( { title:"Parental Control PIN:", value:onOffStr(), showIcon:true, onEnter:onPinOnOff } );
                    break;

                case "modify":
                    this._rows.push( { title:"Modify Parental Control PIN", showIcon:true, onEnter:onModifyPin } );
                    break;

                case "safeBrowse":
                    this._rows.push( { title:"Safe Browse:", value:safeBrowseStr(), showIcon:true, onEnter:onSafeBrowse } );
                    break;

                case "movieRatings":
                    this._rows.push( { title:"Movie Ratings", showIcon:true, onEnter:function() { _x2.pushScreen( new RatingsScreen().init( { type:RatingsScreen.Type.MOVIE } ) ); } } );
                    break;

                case "tvRatings":
                    this._rows.push( { title:"TV Ratings", showIcon:true, onEnter:function() { _x2.pushScreen( new RatingsScreen().init( { type:RatingsScreen.Type.TV } ) ); } } );
                    break;

                case "reset":
                    this._rows.push( { title:"Reset Parental Controls Restrictions", showIcon:false, onEnter:onReset } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        params.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        params.h        = _x2._config._screenH;
        params.maxIndex = 1;
        params.rows     = this._rows;
        params.type     = MenuRowWidget;

        this._list = new ListWidget().init( params );
        this.addWidget( this._list, Style._safeLeft );

        window.ll( "tagScreen", "Parental Controls" );

        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    ParentalControlsScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return ParentalControlsScreen;

})();


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ProvisioningScreen = ( function()
{
    "use strict";

    ProvisioningScreen.prototype = new Screen();

    function ProvisioningScreen(){}

    ProvisioningScreen.prototype.gotFocus = function()
    {
        if( this._startOver === true )
        {
            this._startOver = false;
            _x2.authorize();
        }

        this._text.setSpeechParams( "Loading, please wait. ", undefined, this, false );
    };

    ProvisioningScreen.prototype.init = function( onAuth )
    {
        var self   = this;
        var style  = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap", textAlign:"center" } );
        var onLoad = function() { self._numLoaded++; self.layout(); };

        Screen.prototype.init.call( this, { noHeader:true, noSep:true } );
        this._className     = "ProvisioningScreen";
        this._onAuth        = onAuth;
        this._numLoaded     = 0;

        this._brand = new ImageWidget().init( { url:_x2._config._imageRootMso + "msoLogo.png", onLoad:onLoad } );
        this._brand.setA( 0 );
        this.addWidget( this._brand );

        this._text = new StringWidget().init( { text:"Now connecting to your entertainment experience", style:style } );
        this._text.setW( _x2._config._screenW );
        this._text.addReadyCallback( onLoad );
        this.addWidget( this._text );

        this._distractor = new DistractorWidget().init( { hideBg:true } );
        this._distractor.addReadyCallback( onLoad );
        this.addWidget(this._distractor);

        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Provisioning screen" ) : Config.NOP();
        window.ll( "tagScreen", "Provisioning" ); // Localytics

        _x2._metricsStartAuthentication = Date.now(); // telemetry.sendProvisioning()

        return this;
    };

    ProvisioningScreen.prototype.layout = function()
    {
        if( this._numLoaded === 3 )
        {
            var onSession, onSessionError, self = this;

            this._brand.setX( (_x2._config._screenW - this._brand.getW()) / 2 );
            this._brand.setY( (_x2._config._screenH - this._brand.getH()) / 2 );
            this._brand.animate( { a:1, duration:500 } );

            this._text.setY( this._brand.getY() + this._brand.getH() + _x2.scaleValInt(14) );
            this._text.animate( { a:1, duration:500 } );

            this._distractor.setX( (_x2._config._screenW - this._distractor.getW()) / 2 );
            this._distractor.setY( this._text.getY() + this._text.getH() + _x2.scaleValInt(20) );
            this._distractor.show();

            // determine the platform and execute the correct provisioning flow

            onSession = function( data )
            {
                console.log( data );

                _x2._config._host.setLocalStorage( "XsctToken", data );
                _x2._data.setAuthHeader( Config.AUTH_XTV );

                //setup cache busting if the user logged out in the last 15 minutes.
                var logoutTimestamp = Host.getLocalStorage( "logoutTimestamp" );
                if( logoutTimestamp )
                {
                    if( parseInt(logoutTimestamp) > Date.now() - 900000 )
                        _x2._network.resetGlobalCache();
                }

                _x2._showTerms = true;
                _x2._metricsFirstAuthentication = true; // Localytics: XC-15494 XC-15534
                _x2._metricsTimerAuthentication = ((Date.now() - _x2._metricsStartAuthentication) / 1000) | 0; // telemetry.sendProvisioning()
                _x2.localyticsSetAppVersionAndDeviceModel();
                window.ll( "tagEvent", "Provision Completed", { "Succeeded": "Yes", "Duration": _x2._metricsTimerAuthentication } ); // seconds
                self._onAuth();
            };

            onSessionError = function( error )
            {
                var popScreen = function()
                {
                    _x2.popScreen( self );
                };
                _x2.localyticsSetAppVersionAndDeviceModel();
                window.ll( "tagEvent", "Provision Completed", { "Succeeded": "No", "Duration": "" } );

                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON, onDismiss:popScreen, onRetry:popScreen } ) );

                console.error( "ERROR -> unable to create a DRM session" );
                console.error( error );
                _x2._splunk.sendProvisionError(error.statusCode, error);
                if( error )
                    console.error( error.toString() );

                
                _x2._config._host.removeAllTokenLocalStorage( );
                _x2._config._host.removeLocalStorage( "XtvAuthToken" );
                _x2._config._host.removeLocalStorage( "features"     );
                _x2._data = undefined;
                self._startOver = true;
                _x2._metricsStartAuthentication = Date.now();
            };

            _x2.provision().then( onSession, onSessionError );
        }
    };

    return ProvisioningScreen;

})();


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchasePinScreen = ( function()
{
    "use strict";

    PurchasePinScreen.prototype = new Screen();

    function PurchasePinScreen(){}

    PurchasePinScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( "X finity Purchase PIN. " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    PurchasePinScreen.prototype.init = function( params )
    {
        var entries, i, onPinOnOff, onOffStr, onModifyPin;

        Screen.prototype.init.call( this );
        this._className     = "PurchasePinScreen";
        this._telemetryName = "Purchase Pin";
        this.setBreadCrumbs( "Settings", "Purchase PIN" );

        onModifyPin = function()
        {
            var onFlowComplete = function( obj, pin )
            {
                params.pin = pin;
            };

            PinOverlay.setPinFlow( PinOverlay.FlowType.PURCHASE, onFlowComplete, true, params.pin );
        };

        onPinOnOff = function( widget )
        {
            var onEnter = function( val )
            {
                var onGotPin = function( obj )
                {
                    params.pinObj = obj;
                    widget.setValue( onOffStr() );
                };

                var onSetPin = function()
                {
                    _x2._data.getPurchasePin().then( onGotPin );
                };

                if( val === true )
                    params.pinObj.setPin( undefined, params.pin ).then( onSetPin );
                else
                    params.pinObj.disablePin( params.pin ).then( onSetPin );
            };

            _x2.pushOverlay( new OnOffOverlay().init( { onEnter:onEnter, isOn:params.pinObj.isEnabled() } ) );
        };

        onOffStr = function()
        {
            return params.pinObj.isEnabled() ? "On" : "Off";
        };

        this._rows = [];
        entries    = _x2._config._purchasePinMenu;

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "enable":
                    this._rows.push( { title:"Purchase PIN:", value:onOffStr(), showIcon:true, onEnter:onPinOnOff } );
                    break;

                case "modify":
                    this._rows.push( { title:"Modify Purchase PIN", showIcon:true, onEnter:onModifyPin } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        params.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        params.h        = _x2._config._screenH;
        params.maxIndex = 1;
        params.rows     = this._rows;
        params.type     = MenuRowWidget;

        this._list = new ListWidget().init( params );
        this.addWidget( this._list, Style._safeLeft );

//        window.ll( "tagScreen", "Parental Controls" );
//        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    PurchasePinScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return PurchasePinScreen;

})();


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// Copyright (C) 2019 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PurchasesFtueScreen = ( function()
{
    "use strict";

    PurchasesFtueScreen.prototype = new Screen();

    function PurchasesFtueScreen(){}

    PurchasesFtueScreen.prototype.gotFocus = function( losingFocus, newScreen )
    {
        _x2._hi.fadeOut();

        if( this._isReady === true )
            this.speak( _x2.requestFocus( this._buttons, newScreen ) );
    };

    PurchasesFtueScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this, { noBg:false, noHeader:true, noSep:true, image:_x2._config._imageRoot + "/purchaseFtue.jpg", imageAlpha:1.0 } );
        this._className     = "PurchasesFtueScreen";
        this._telemetryName = "Main Menu";

        var self        = this, numReady = 0;
        var titleStyle  = new Style( { font:"light", color:"#000000", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var bodyStyle   = new Style( { font:"light", color:"#000000", fontSize:_x2.scaleValInt(30)                      } );
        var buttonStyle = new Style( { font:"light", color:"#000000", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap", colorHi:"#000000"  } );

        var onGotIt = function()
        {
            _x2._settings.setValue( Settings.Key.PURCHASES, true );
            _x2.setDefaultScreen();
        };

        var onSetPin = function()
        {
            PinOverlay.setPinFlow( PinOverlay.FlowType.PURCHASE, onGotIt );
        };

        var gotIt  = new StringWidget().init( { text:"Got It"          , style:buttonStyle, onEnter:onGotIt  } );
        var setPin = new StringWidget().init( { text:"Set Purchase PIN", style:buttonStyle, onEnter:onSetPin } );

        var layout = function()
        {
            if( ++numReady === 2 )
            {
                self._body.setY( self._title.getY() + self._title.getH() + _x2.scaleValInt(30) );
                self._buttons.setY( self._body.getY() + self._body.getH() + _x2.scaleValInt(50) );
            }
        };

        this._title = new StringWidget().init( { text:"Make Purchases Here", style:titleStyle } );
        this.addWidget( this._title, Style._safeLeft, _x2.scaleValInt(375) );

        this._body = new TextBlockWidget().init( { text:"Now you can rent and buy in the app.<br> Watch here, in our mobile apps, or on the web.", style:bodyStyle, w:_x2.scaleValInt(600) } );
        this._body.addReadyCallback( layout );
        this.addWidget( this._body, Style._safeLeft );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[gotIt], spacing:_x2.scaleValInt(82) } );
        this._buttons.addReadyCallback( layout );
        this.addWidget( this._buttons, Style._safeLeft );

        var onIsPinEnabled = function( obj )
        {
            self._isReady = true;

            if( obj.isEnabled() === false )
                self._buttons.setButtons( [gotIt, setPin] );

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._buttons, true ) );
        };

        _x2._data.getPurchasePin().then( onIsPinEnabled ).catch( onIsPinEnabled );

//         window.ll( "tagScreen", "Main Menu" ); // Localytics 2.1.1
//         _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Main Menu screen" ) : Config.NOP();
//         _x2.localyticsSendSplashPageAndProvisioning();

        return this;
    };

    PurchasesFtueScreen.prototype.speak = function( focus, newScreen )
    {
        if( newScreen !== false )
        {
            this._speakTarget.setText( this._title.getText() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( this._body.getText() + "Press right or left to review options. Press OK to select.", focus._speakRole, this, false );
        }
    };

    return PurchasesFtueScreen;

})();


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.RatingsScreen = ( function()
{
    "use strict";

    RatingsScreen.prototype = new Screen();

    RatingsScreen.Type = Object.freeze
    ({
        MOVIE : 0,
        TV    : 1
    });

    function RatingsScreen(){}

    RatingsScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( this.getBreadCrumbsTermStr() + ". " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof RatingsScreen
     * @param   {Object}             params
     * @param   {RatingsScreen.Type} params.type - type of screen to create
     * @returns {RatingsScreen}
     */

    RatingsScreen.prototype.init = function( params )
    {
        var listParams = {}, className, breadCrumb, rows, rowType;

        if( params.type === RatingsScreen.Type.MOVIE )
        {
            className           = "MovieRatingsScreen";
            this._telemetryName = "Movie Ratings";
            breadCrumb          = "Movie Ratings";
            rowType             = RatingsRowWidget.Type.MOVIE;
            rows                =
            [
                { title:"Adult", type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.ADULT },
                { title:"NC-17", type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.NC17  },
                { title:"R"    , type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.R     },
                { title:"PG-13", type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.PG13  },
                { title:"PG"   , type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.PG    },
                { title:"G"    , type:RatingsRowWidget.Type.MOVIE, rating:ParentalControls.MpaaRatings.G     }
            ];
        }
        else if( params.type === RatingsScreen.Type.TV )
        {
            className  = "TvRatingsScreen";
            breadCrumb = "TV Ratings";
            rowType    = RatingsRowWidget.Type.TV;
            rows       =
            [
                { title:"TV-MA", type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TVMA },
                { title:"TV-14", type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TV14 },
                { title:"TV-PG", type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TVPG },
                { title:"TV-G" , type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TVG  },
                { title:"TV-Y7", type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TVY7 },
                { title:"TV-Y" , type:RatingsRowWidget.Type.TV, rating:ParentalControls.TvRatings.TVY  }
            ];
        }

        Screen.prototype.init.call( this );
        this._className = className;
        this.setBreadCrumbs( "Settings / Parental Controls", breadCrumb );

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = RatingsRowWidget;
        listParams.obj      = new RatingsController( rowType );

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        return this;
    };

    RatingsScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return RatingsScreen;

})();


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SafeBrowseScreen = ( function()
{
    "use strict";

    SafeBrowseScreen.prototype = new Screen();

    function SafeBrowseScreen(){}

    SafeBrowseScreen.prototype.entrySelected = function( key )
    {
        _x2._pc.setSafeBrowse( ParentalControls.SafeBrowse[key] );
        _x2._data.setParentalControlsSettings( _x2._pc );

        if( this._onEnter )
            this._onEnter( ParentalControls.SafeBrowse[key] );
    };

    SafeBrowseScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select. ", focus._speakRole, this, false );
    };

    /**
     * memberof SafeBrowseScreen
     * @param {Object} params
     * @param {Function} params.onEnter - function to execute on enter
     * @returns {SafeBrowseScreen}
     */
    SafeBrowseScreen.prototype.init = function( params )
    {
        var listParams = {}, self = this;

        Screen.prototype.init.call( this );
        this._className     = "SafeBrowseScreen";
        this._telemetryName = "Safe Browse";
        this.setBreadCrumbs( "Settings / Parental Controls", "Safe Browse" );

        this._onEnter = params.onEnter;

        var rows = [ { title:"Off", key:"OFF" }, { title:"Medium Safety", key:"MEDIUM" }, { title:"High Safety", key:"HIGH" } ];

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = RadioButtonRowWidget;
        listParams.obj      = new RadioButtonController( _x2._pc.getSafeBrowse(), function( key ) { self.entrySelected( key ) } );

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        return this;
    };

    SafeBrowseScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return SafeBrowseScreen;

})();


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SapLanguageScreen = ( function()
{
    "use strict";

    SapLanguageScreen.prototype = new Screen();

    function SapLanguageScreen(){}

    SapLanguageScreen.prototype.entrySelected = function( key )
    {
        _x2._settings.setValue( Settings.Key.SAP_LANG, key );
    };

    SapLanguageScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list );

        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + "." );
        this._speakTarget.setSpeechParams( "Press up or down to review options. Press OK to select.", focus._speakRole, this, false );
    };

    SapLanguageScreen.prototype.init = function()
    {
        var entries, i, params = {}, self = this;

        Screen.prototype.init.call( this );
        this._className     = "SapLanguageScreen";
        this._telemetryName = "Languages"; // TODO: "Languages" or "Sap Language" ?
        this.setBreadCrumbs( "Settings", "Language" );

        this._rows = [];
        entries    = _x2._config._sapLanguages;

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "cafrench":
                    this._rows.push( { title:"Canadian French", key:entries[i], rowIndex:i } );
                    break;

                case "en":
                    this._rows.push( { title:"English", key:entries[i], rowIndex:i } );
                    break;

                case "es":
                    this._rows.push( { title:"Spanish", key:entries[i], rowIndex:i } );
                    break;

                case "french":
                    this._rows.push( { title:"French", key:entries[i], rowIndex:i } );
                    break;

                case "german":
                    this._rows.push( { title:"German", key:entries[i], rowIndex:i } );
                    break;

                case "italian":
                    this._rows.push( { title:"Italian", key:entries[i], rowIndex:i } );
                    break;

                case "portuguese":
                    this._rows.push( { title:"Portuguese", key:entries[i], rowIndex:i } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        params.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        params.h        = _x2._config._screenH;
        params.maxIndex = 1;
        params.rows     = this._rows;
        params.type     = RadioButtonRowWidget;
        params.obj      = new RadioButtonController( _x2._settings.getValue( Settings.Key.SAP_LANG ), function( key ) { self.entrySelected( key ) } );

        this._list = new ListWidget().init( params );
        this.addWidget( this._list, Style._safeLeft );

        window.ll( "tagScreen", "Languages" );

        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    SapLanguageScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return SapLanguageScreen;

})();


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SavedScreen = ( function()
{
    "use strict";

    SavedScreen.prototype = new Screen();

    function SavedScreen(){}

    SavedScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._menu, true );

        this._speakTarget.setText( "Saved. " + focus._speakStr );
        this._speakTarget.setSpeechParams( "Press left or right to change filters. Press up or down to review categories.", focus._speakRole, this, false );
    };

    SavedScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this );
        this._className     = "SavedScreen";
        this._telemetryName = "Saved";

        var localytics, telemetry, str, i, obj, onEnter, onGotFocus;
        var self        = this;
        var menuItems   = _x2._config._savedMenu;
        var entries     = [];
        var buttonStyle = new Style( { font:"regular" , color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000" } );
        var index       = 0;

        this._widgets = [];
        this._labels  = [];

        onEnter    = function( idx, telemetry ) { return function() { _x2._telemetry.setWatchButton( telemetry ); _x2.requestFocus( self._widgets[idx] ); }; };
        onGotFocus = function( idx            ) { return function() { self.swapContent( idx ); }; };

        for( i = 0; i < menuItems.length; i++ )
        {
            str = undefined;

            switch( menuItems[i] )
            {
                case "forYou":
                    str        = "For You";
                    obj        = new ForYouWidget().init( { path: "Saved. " + str } );
                    localytics = "For You";
                    telemetry  = "For You"; // NOTE: Recently watched also will set "Player: Last Watched";
                    break;

                case "recordings":
                    if( _x2._config._isCdvr === true )
                    {
                        str        = "Recordings";
                        obj        = new RecordingsWidget().init( { path: "Saved. " + str }  );
                        localytics = "Recordings";
                        telemetry  = "Recordings";

                    }
                    break;
                case "scheduled":
                    if( _x2._config._isCdvr === true )
                    {
                        str        = "Scheduled";
                        obj        = new ScheduledWidget().init( { path: "Saved. " + str } );
                        localytics = "Scheduled";
                        telemetry  = "Scheduled";
                    }
                    break;

                case "favorites":
                    str        = "Favorites";
                    obj        = new FavoritesWidget().init( { path: "Saved. " + str } );
                    localytics = "Favorites";
                    telemetry  = "Favorites";
                    break;

                case "purchases":
                    if( _x2._config._isEst === true )
                    {
                        str        = "Purchases";
                        obj        = new PurchasesWidget().init( { path: "Saved. " + str } );
                        localytics = "Purchases";
                        telemetry  = "Purchases";
                    }
                    break;

                default:
                    console.error( "Error -> Unexpected menu item in SavedScreen: " + menuItems[i] );
            }

            if( str )
            {
                entries[index] = new StringWidget().init( { text:str, style:buttonStyle, focusTime:300 } );
                entries[index].onEnter = onEnter( index, telemetry );
                entries[index].setFocusListeners( onGotFocus( index ) );

                index++;

                this._widgets.push( obj );
                this._labels.push( str );
                this.addWidget( obj, _x2._config._screenW );
            }
        }

        this._menu = new TabbedPillButtonsWidget().init( { entries:entries } );
        this.addWidget( this._menu );

        this.setBreadCrumbs( undefined, "Saved" );
        this.addReadyCallback( function() { self.layout(); } );

        return this;
    };

    SavedScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom();
        var h = _x2._config._screenH - y;

        this._menu.setH( y );

        for( var i = 0; i < this._widgets.length; i++ )
        {
            this._widgets[i].setY( y );
            this._widgets[i].setH( h );

            if( i > 0 )
                this._widgets[i].setA( 0 );
            else
                this._widgets[i].setX( 0 );
        }
    };

    SavedScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LAST:
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._menu.containsWidget( _x2._focus ) === false )
                        _x2.requestFocus( this._menu );
                    else
                        retval = Screen.prototype.processEvent.call( this, val, type );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    SavedScreen.prototype.refreshCheck = function()
    {
        if( this._activeWidget.refresh )
            this._activeWidget.refresh( this );
    };

    SavedScreen.prototype.swapContent = function( index )
    {
        var widget = this._activeWidget;

        if( this._activeWidget !== this._widgets[index] )
        {
            if( this._activeWidget )
                this._activeWidget.animate( { a:0, duration:500, onEnd:function() { widget.setX( _x2._config._screenW ); } } );

            var whichTab = this._labels[index] ;
            this._activeWidget = this._widgets[index];
            this.setBreadCrumbs( "Saved", whichTab );

            _x2._config.log( Config.CLASS_TELEMETRY, 2 ) ? console.warn( "Telemetry: Screen Viewed: " + whichTab ) : Config.NOP();
            _x2._telemetry.sendScreenViewed( whichTab );

            if( this._activeWidget.loadData )
                this._activeWidget.loadData();

            this._activeWidget.setX( 0 );
            this._activeWidget.animate( { a:1, duration:500 } );
        }
    };

    return SavedScreen;

})();


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SearchScreen = ( function()
{
    "use strict";

    SearchScreen.prototype = new Screen();

    var LOCAL_STORAGE_KEY = "recentSearches";

    function SearchScreen(){}

    SearchScreen.prototype.getRecentSearches = function()
    {
        var retval = [], json = localStorage[LOCAL_STORAGE_KEY];

        if( json !== undefined )
        {
            var objs = JSON.parse(json);

            for( var i = 0; i < objs.length; i++ )
                retval.push( new SearchEntity().init( objs[i] ) );
        }

        return retval;
    };

    SearchScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._keyboard, true );
        this._speakTarget.setText( this.getBreadCrumb() + ". Search for TV Shows, Movies, Channels and more. " + focus._speakStr );
        this._speakTarget.setSpeechParams( undefined, focus._speakRole, this, false );
    };

    SearchScreen.prototype.init = function()
    {
        var self            = this, keyboardParams = {}, resultsParams = {}, recents;
        var onLoad          = function() { self.layout(); };
        var iconsTitleStyle = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", textAlign:"center" } );
        var listTitleStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var noRecentsStyle  = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap", textAlign:"center" } );

        Screen.prototype.init.call( this );
        this._className     = "SearchScreen";
        this._telemetryName = "Search";
        this._numReady      = 0;
        this.setBreadCrumbs( undefined, "Search" );

        keyboardParams.w       = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        keyboardParams.onReady = onLoad;
        keyboardParams.onEnter = function( char ) { self._text.onChar( char ); };

        this._container = new Widget().init();
        this._container.setA( 0 );

        this._scrollPane = new ScrollWidget().init( { widget: this._container, w: _x2._config._screenW, h:_x2._config._screenH  } );
        this.addWidget( this._scrollPane );

        this._keyboard = new KeyboardWidget().init( keyboardParams );
        this._container.addWidget( this._keyboard, Style._safeLeft );

        this._text = new TextEntryWidget().init( { w:300, instStr:"Search for TV Shows, Movies, Channels and more.", onChange:function( text ) { self.onTextChanged( text ); } } );
        this._text.setW( this._keyboard.getW() );
        this._text.addReadyCallback( onLoad );
        this._container.addWidget( this._text, Style._safeLeft );

        this._iconsTitle = new StringWidget().init( { text:"Enter one of the following...", style:iconsTitleStyle } );
        this._container.addWidget( this._iconsTitle );

        this._icons = new ImageWidget().init( { url:_x2._config._imageRoot + "searchIcons.png", onLoad:onLoad } );
        this._container.addWidget( this._icons );

        this._listTitle = new StringWidget().init( { text:"Recent Searches", style:listTitleStyle } );
        this._listTitle.setA( 0 );
        this._container.addWidget( this._listTitle, Style._safeLeft );

        this._noRecents = new StringWidget().init( { text:"No recent searches history.", style:noRecentsStyle } );
        this._noRecents.setW( _x2._config._screenW );
        this._container.addWidget( this._noRecents );

        resultsParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        resultsParams.h        = _x2.scaleValInt(510);
        resultsParams.maxIndex = 1;
        resultsParams.axis     = ListWidget.Axis.X;
        resultsParams.type     = GalleryCellWidget;
        resultsParams.obj      = this;
        resultsParams.touchH   = new GalleryCellWidget().getTouchDim();
        resultsParams.touchW   = Math.floor( Style._safeLeft * 2 / 3 );

        this._resultsList = new ListWidget().init( resultsParams );
        this._resultsList.setA( 0 );
        this._container.addWidget( this._resultsList, Style._safeLeft );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( onLoad );
        this._resultsList.addWidget( this._distractor );

        recents = this.getRecentSearches();

        if( recents.length > 0 )
        {
            this._widgetShowing = true;
            this._resultsList.setData( recents );
            this._resultsList.animate( { a:1, duration:500 } );
            this._listTitle.animate( { a:1, duration:500 } );
            this._noRecents.animate( { a:0, duration:500 } );
        }

        window.ll( "tagScreen", "Search" );
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        _x2._telemetry.watchPathPush( "Search" ); // Default for Channel collection

        return this;
    };

    SearchScreen.prototype.layout = function()
    {
        var self = this, onMouseWheel;

        if( ++this._numReady === 4 )
        {
            var keyboardR = this._keyboard.getX() + this._keyboard.getW();

            this._scrollPane.setY( this.getHeaderBottom() );
            this._scrollPane.setH( _x2._config._screenH - this.getHeaderBottom() );
            this._text.setY( _x2.scaleValInt( 42 ) ); // XC-13188, space between Breadcrumb line separator
            this._keyboard.setY( this._text.getY() + this._text.getH() + _x2.scaleValInt( 30 ) );
            this._iconsTitle.setW( _x2._config._screenW - Style._safeRight - keyboardR );
            this._iconsTitle.setX( keyboardR );
            this._iconsTitle.setY( _x2.scaleValInt( 42 ) );
            this._icons.setX( keyboardR + _x2.scaleValInt( 52 ) );
            this._icons.setY( this._iconsTitle.getY() + this._iconsTitle.getH() + _x2.scaleValInt( 33 ) );
            this._listTitle.setY( this._keyboard.getY() + this._keyboard.getH() + _x2.scaleValInt( 41 ) );
            this._noRecents.setY( this._keyboard.getY() + this._keyboard.getH() + _x2.scaleValInt( 235 ) );
            this._resultsList.setY( this._listTitle.getY() + this._listTitle.getH() + _x2.scaleValInt( 8 ) );
            this._yOffset = -this._keyboard.getY() - this._keyboard.getH();

            this._distractor.centerOnWidget( this._resultsList );

            onMouseWheel = function( evt )
            {
                if( evt.deltaY > 0 )
                    self.shiftUp();
                else if( evt.deltaY < 0 )
                    self.shiftDown();
            };

            this.setMouseWheelListener( onMouseWheel );
            this._container.animate( { a:1, duration:500 } );
        }
    };

    SearchScreen.prototype.onSelected = function( entity )
    {
        var obj     = [];
        var recents = this.getRecentSearches();
        var id      = entity.getEntityId();
        var pos     = this._resultsList ? this._resultsList.getCurrentAndMaxIndex() : { current: "NA" };

        for( var i = 0; i < recents.length; i++ )
            if( id !== recents[i].getEntityId() )
                obj.push( recents[i]._data );

        var metrics =
        {
            "Position"     : pos.current,
            "Results"      : "Yes",
            "Search Term"  : this._text.getText(),
            "Selected ID"  : id,
            "Selected Name": entity.getTitle(),
            "Type"         : entity._localyticsSearchType ? entity._localyticsSearchType : "UNDEFINED"
        };
        window.ll( "tagEvent", "Search", metrics ); // Localytics: Search.2

        obj.unshift( entity._data );
        localStorage.setItem( LOCAL_STORAGE_KEY, JSON.stringify(obj) );
    };

    SearchScreen.prototype.onTextChanged = function( str )
    {
        var self = this, onSuccess, onError, recents, metrics;

//        console.log( "Search String ==> " + str + " <" );

        onSuccess = function( result )
        {
            if( str === self._text.getText() )
            {
                self._distractor.hide();

//                 console.log( "========== " + result.length + " results for: " + str + " ==========" );
//
//                 for( var i = 0; i < result.length; i++ )
//                 {
//                     console.log( "=> " + result[i].getTitle() + " -> " + result[i].getSubtitle() );
//                     console.log( result[i] );
//                 }

                self._listTitle.setText( "Showing " + result.length + " results for \"" + str + "\"" );
                self._resultsList.setData( result );

                if( self._readSpeechHint !== true )
                {
                    self._readSpeechHint = true;
                    self._listTitle.setSpeechParams( "Use down arrow to navigate to the results below the keyboard. " , undefined, self, false );
                }
                else
                    self._listTitle.setSpeechParams( undefined, undefined, self, false );

                if( result.length < 1 )
                {
                    metrics =
                    {
                        "Position"     : "",
                        "Results"      : "No",
                        "Search Term"  : str,
                        "Selected ID"  : "",
                        "Selected Name": "",
                        "Type"         : "UNDEFINED"
                    };
                    window.ll( "tagEvent", "Search", metrics ); // Localytics: Search.1
                }
            }
            else
                console.log( "IGNORED SEARCH RETURN FOR " + str );
        };

        onError = function( error )
        {
            console.log( error.toString() );
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.BROWSE_SEARCH } ) );
        };

        if( str.length > 0 )
        {
            this._resultsList.setData();

            if( this._widgetShowing !== true )
            {
                this._widgetShowing = true;
                this._resultsList.animate( { a:1, duration:500 } );
                this._listTitle.animate( { a:1, duration:500 } );
                this._noRecents.animate( { a:0, duration:500 } );
            }

            this._listTitle.setText( "Searching ..." );
            this._distractor.show();
            _x2._data.search( str, 100 ).then( onSuccess ).catch( onError );
        }
        else
        {
            recents = this.getRecentSearches();

            if( recents.length === 0 )
            {
                this._widgetShowing = false;
                this._resultsList.animate( { a:0, duration:500 } );
                this._listTitle.animate( { a:0, duration:500 } );
                this._noRecents.animate( { a:1, duration:500 } );
            }
            else
            {
                this._widgetShowing = true;
                this._resultsList.setData( recents );
                this._listTitle.setText( "Recent Searches" );
                this._resultsList.animate( { a:1, duration:500 } );
                this._listTitle.animate( { a:1, duration:500 } );
                this._noRecents.animate( { a:0, duration:500 } );
            }
        }
    };

    SearchScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    this.shiftUp();
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                    this.shiftDown();
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    SearchScreen.prototype.shiftDown = function()
    {
        if( this._container.isAnimating( Widget.Axis.Y ) === false && this._resultsList.containsWidget( _x2._focus ) === true )
        {
            this._scrollPane.setScroll( { y:0, duration:300 } );
            _x2.requestFocus( this._keyboard );
        }
    };

    SearchScreen.prototype.shiftUp = function()
    {
        var onEnd, focus, self = this;

        if( this._resultsList.getMaxIndex() > 0 && this._container.isAnimating( Widget.Axis.Y ) === false && this._widgetShowing === true && this._resultsList.containsWidget( _x2._focus ) === false )
        {
            onEnd = function()
            {
                if( _x2._focus === self._keyboard )
                {
                    focus = _x2.requestFocus( self._resultsList, true );
                    self._listTitle.setSpeechParams( focus._speakStr + "Press left or right to review items. Press OK to select.", focus._speakRole, this, false );
                }
            };

            this._scrollPane.setScroll( { y:this._yOffset, duration:300, onEnd:onEnd } );
        }
    };

    return SearchScreen;

})();


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SettingsScreen = ( function()
{
    "use strict";

    SettingsScreen.prototype = new Screen();

    function SettingsScreen(){}

    SettingsScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._list, true );
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr );
        this._speakTarget.setSpeechParams( "Press up or down to review settings. Press OK for options. ", focus._speakRole, this, false );
    };

    SettingsScreen.prototype.init = function( params )
    {
        var entries, i, listParams = {}, onParentalControl, onPurchase;

        Screen.prototype.init.call( this );
        this._className     = "SettingsScreen";
        this._telemetryName = "Settings";
        this.setBreadCrumbs( params && params.path, "Settings" );

        onParentalControl = function()
        {
            console.log( "??????????????????? PARENTAL CONTROLS ???????????????????" );
            console.log( _x2._pc );

            var onGotIt = function()
            {
                _x2.pushScreen( new ParentalControlsScreen().init() );
            };

            PinOverlay.setPinFlow( PinOverlay.FlowType.PARENTAL_CONTROL, onGotIt );
        };

        onPurchase = function()
        {
            var onGotIt = function( pinObj, pin )
            {
                _x2.pushScreen( new PurchasePinScreen().init( { pinObj:pinObj, pin:pin } ) );
            };

            PinOverlay.setPinFlow( PinOverlay.FlowType.PURCHASE, onGotIt );
        };

        this._rows = [];
        entries    = _x2._config._settingsMenu.slice();  // make a copy so as not to persist splice across logout/login

        if( _x2._config._purchases === true && _x2._features.hasEntitlement( Features.Entitlement.EST ) && entries[2] !== "purchase" )
            entries.splice( 2, 0, "purchase" );

        for( i = 0; i < entries.length; i++ )
        {
            switch( entries[i] )
            {
                case "about":
                    this._rows.push( { title:_x2._st.about, onEnter: function() { _x2.pushOverlay( new AboutOverlay().init() ); } } );
                    break;

                case "accessibility":
                    this._rows.push( { title:"Accessibility", showIcon:true, onEnter:function() { _x2.pushScreen( new AccessibilityScreen().init() ); } } );
                    break;

                case "account":
                    this._rows.push( { title:"My Account" } );
                    break;

                case "device":
                    this._rows.push( { title:"Device Settings" } ); // TODO:  ll( "tagScreen", "Manage Devices" );
                    break;

                case "format":
                    this._rows.push( { title:"Format", showIcon:true, onEnter:function() { _x2.pushScreen( new FormatScreen().init() ); } } );
                    break;

                case "help":
                    this._rows.push( { title:"Help", onEnter: function() { _x2.pushOverlay( new HelpOverlay().init() ); } } );
                    break;

                case "language":
                    this._rows.push( { title:"Language", showIcon:true, onEnter: function() { _x2.pushScreen( new SapLanguageScreen().init() ); } } );
                    break;

                case "manage":
                    this._rows.push( { title:"Manage Devices", showIcon:true, onEnter:function() { _x2.pushScreen( new ManageDevicesScreen().init() ); } } );
                    break;

                case "parental":
                    this._rows.push( { title:"Parental Controls", showIcon:true, onEnter:onParentalControl } );
                    break;

                case "preferences":
                    this._rows.push( { title:"Preferences" } );
                    break;

                case "signOut":
                    this._rows.push( { title:"Sign Out", onEnter: function() { _x2.pushOverlay( new SignOutOverlay().init() ); } } );
                    break;

                case "terms":
                    this._rows.push( { title:"Terms & Policies", onEnter: function() { _x2.pushOverlay( new PolicyLinksOverlay().init({ type: 'terms' }) ); } } );
                    break;

                case "privacy":
                    this._rows.push( { title:"Privacy", onEnter: function() { _x2.pushOverlay( new PolicyLinksOverlay().init({ type: 'privacy' }) ); } } );
                    break;

                case "purchase":
                    this._rows.push( { title:"Purchase PIN", showIcon:true, onEnter:onPurchase } );
                    break;

                default:
                    console.error( "ERROR -> unknown menu entry = " + entries[i] );
                    break;
            }
        }

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.rows     = this._rows;
        listParams.type     = MenuRowWidget;

        this._list = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft );

        window.ll( "tagScreen", "Settings" );
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    SettingsScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._list.setY( this.getHeaderBottom() );
        this._list.setH( _x2._config._screenH - this._list.getY() );
    };

    return SettingsScreen;

})();


/***/ }),
/* 207 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.ShowingsScreen = (function()
{
    "use strict";

    ShowingsScreen.prototype = new Screen();

    function ShowingsScreen(){}

    ShowingsScreen.prototype.gotFocus = function()
    {
        if( this._ready === true )
            this.speak( _x2.requestFocus( this._list ) );
    };

    /**
     * Initializer
     * @memberof ShowingsScreen
     * @param   {Object} params
     * @param   {Entity} params.entity
     * @returns {ShowingsScreen}
     */
    ShowingsScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this );
        this._className     = "ShowingsScreen";
        this._telemetryName = "Showings";

        var self     = this;
        var entity   = params.entity;
        var url      = entity.getImageLink( 303, 404 );
        var options  = entity.getEntityOptions();

        //we should always have the showing data since the showings are embedded in the ProgramEntity and we should not get here without having the ProgramEntity
        //extract the showings into an array and set the list data
        //this widget contains:
        //1. ProgramPoster
        //2. Showings List

        var titleStyle = new Style( { color:"#e8e8e8", colorHi:"#000000", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        //dimensions
        var posterDims = { w: _x2.scaleValInt( 303 ), h: _x2.scaleValInt( 404 ) };
        var xOffsets   = [ _x2.scaleValInt(355) ];
        var yOffsets   = [ 0,  _x2.scaleValInt(18),  _x2.scaleValInt(80),  _x2.scaleValInt(82) ];

        //font styles
        var posterError = function()
        {
            self._posterImage.setA(0);
        };

        var listW    = _x2._config._screenW -  xOffsets[0] - Style._safeLeft - Style._safeRight;
        var listH    = _x2._config._screenH -  yOffsets[1] - Style._safeBottom - Style._safeTop;
        var rows     = [];

        var showings = options.getVodShowings();
        showings = showings.concat( options.getOnNowListings() );
        showings = showings.concat( options.getRecordings() );

        // if( entity.getEpisodeRecording )
        // {
        //     var recording = entity.getEpisodeRecording();
        //     if( recording )
        //         showings = showings.concat( recording );
        // }

        for( var i = 0; i < showings.length; i++ )
            rows[i] = { entity:entity, showing:showings[i] } ;

        var listParams = {};
        listParams.w        = listW;
        listParams.h        = listH;
        listParams.maxIndex = 1;
        listParams.rows     = rows;
        listParams.type     = ShowingRowWidget;

        var title = "";
        if( entity.getType() === XtvApi.EntityType.EPISODE )
        {
            // var program = entity.getEntity();
            if( entity.getSeasonNumber() && entity.getEpisodeNumber() )
            {
                title = 'S' + entity.getSeasonNumber();
                title += ' - Ep' + entity.getEpisodeNumber();
                title += ' - ';
            }
        }
        title += entity.getTitle();

        this._list          = new ListWidget().init( listParams );
        this._title         = new StringWidget().init({style:titleStyle, text:title});
        this._posterImage   = new ImageWidget().init( { url:url, w:posterDims.w, h:posterDims.h, onError:posterError } );
        this._divider       = new RectWidget().init( { w:listW, h:ListRowWidget.DIVIDER_H, color:"#262626" } );

        this._container = new Widget().init();
        this._container.addWidget( this._posterImage, 0          , yOffsets[0] );
        this._container.addWidget( this._title      , xOffsets[0], yOffsets[0] ); // intentional y[0]
        this._container.addWidget( this._divider    , xOffsets[0], yOffsets[2] );
        this._container.addWidget( this._list       , xOffsets[0], yOffsets[2] + ListRowWidget.DIVIDER_H );

        this.addWidget( this._container, Style._safeLeft, 0 );
        this.addReadyCallback( function(){ self.layout(); } );

        this.setBreadCrumbs( entity.getTitle() );

        return this;
    };

    ShowingsScreen.prototype.layout = function()
    {
        this._container.setY( this.getHeaderBottom() + _x2.scaleValInt( 42 ) );

        this._ready = true;

        if( _x2._focus === this && this._list.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._list, true ) );
    }

    ShowingsScreen.prototype.speak = function( focus )
    {
        if( focus )
        {
            this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press up or down to review items. Press OK to play. ", focus._speakRole, this, false );
        }
    }

    return ShowingsScreen;

})();


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.StackScreen = ( function()
{
    "use strict";

    StackScreen.prototype = new Screen();
    StackScreen.ANI_TIME  = 500;

    var keyEater;

    function StackScreen(){}

    StackScreen.prototype.clear = function()
    {
        var start = 0;

        if( this._bg )
        {
            this._bg.stopAnimation( Widget.ALPHA, false );
            this._bg.animate( { a:0, duration:StackScreen.ANI_TIME } );
            start = 1;
        }

        for( var i = start; i < this._children.length; i++ )
        {
            this._div.removeChild( this._children[i]._div );
            this._children[i].destroy();
        }

        this._children.splice( start );
    };

    StackScreen.prototype.getTop = function()
    {
        return this._children[this._children.length - 1];
    };

    /**
     * @param {Object}   params
     * @param {Boolean} [params.hasBg] - has background rectangle
     * @param {String}  [params.name ] - name to appear in DOM
     */
    StackScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this, { noBg:true, noHeader:true, noSep:true } );
        this._className = (params && params.name) ? params.name : "StackScreen";

        if( params.hasBg === true )
        {
            this._bg = new RectWidget().init( { name: "Dimming", w:_x2._config._screenW, h:_x2._config._screenH, color:"#303030" } );
            this._bg.setVal( Widget.ALPHA, 0 );
            this.addWidget( this._bg );
        }

        this.enableMouseDownListener( false );

        if( keyEater === undefined )
            keyEater = new KeyEater().init();

        return this;
    };

    StackScreen.prototype.pop = function( screen, onPopped )
    {
        var retval = false, currScreen, nextScreen, screenCount, self = this, lastFocus;
        var onEnd  = function()
        {
            lastFocus = nextScreen._lastFocus;

            if( lastFocus )
            {
                if( lastFocus instanceof KeyEater )
                {
                    var focus = lastFocus.getFocus();

                    if( focus )
                        lastFocus = focus;
                }

                _x2.requestFocus( lastFocus );
            }
            else
                _x2.requestFocus( nextScreen );
        };

        if( screen === undefined )
            screen = this._children[this._children.length - 1];

        screen._hasBeenPopped = true;
        screenCount = this._children.length;

        for( var i = 0; i < screenCount; i++ )
        {
            if( screen === this._children[i] )
            {
                currScreen = this._children[i];

                if( i < screenCount - 1 )  // not on top
                {
                    currScreen.forceUpdate( true );
                    currScreen.animate( { a:0, duration:StackScreen.ANI_TIME, onEnd:function() { self.removeWidget( currScreen ); if( onPopped ) onPopped(); } } );
                }
                else // on top
                {
                    if( screenCount > 1 )
                    {
                        var duration = currScreen instanceof VideoScreen ? 10 : StackScreen.ANI_TIME;

                        retval     = true;
                        currScreen = this._children[screenCount - 1];
                        nextScreen = this._children[screenCount - 2];

                        // in a push/pop scenario the nextScreen may be fading out, but not yet removed from _children. in that case try to go back one screen.
                        if( nextScreen._hasBeenPopped === true )
                        {
                            if( screenCount > 2 )
                            {
                                nextScreen = this._children[screenCount - 3];
                                screenCount--; //decrement the screen count to ensure the _bg will fade out and onEnd will fire (below) when screenCount==2.
                            }
                        }

                        currScreen.animate( { a:0, duration:duration, onEnd:function() { self.removeWidget( currScreen ); if( onPopped ) onPopped(); } } );

                        _x2.requestFocus( keyEater );

                        if( nextScreen !== this._bg )
                        {
                            if( nextScreen.refreshCheck )
                                nextScreen.refreshCheck();

                            nextScreen.animate( { a:1, duration:duration, onEnd:onEnd } );

                            if( _x2._telemetry && nextScreen instanceof Screen )
                                _x2._telemetry.sendActiveSession( nextScreen );
                        }
                    }
                }

                if( this._bg && screenCount === 2 )
                    this._bg.animate( { a:0, duration:StackScreen.ANI_TIME, easing:Widget.Easing.QUAD_IN, onEnd:onEnd } );

                break;
            }
        }

        return retval;
    };

    StackScreen.prototype.push = function( screen, duration )
    {
        var currentScreen = this._children[this._children.length - 1];

        duration = ( duration === undefined ) ? StackScreen.ANI_TIME : duration;

        if( this._bg )// && this._children.length === 1 )
        {
            this._bg.stopAnimation( Widget.ALPHA, false );
            this._bg.animate( { a:0.8, duration:StackScreen.ANI_TIME } );
        }

        currentScreen._lastFocus = _x2._focus;

        screen.setA( 0 );
        this.addWidget( screen );
        screen.resourcesLoad();
        screen.getVal( Widget.W );  // trigger reflow in DOM
        screen.resourcesLoaded();
        screen.animate( { a:1, duration:duration, onEnd:function() { if( screen.pushComplete ) screen.pushComplete() } } );

        if( currentScreen !== this._bg )
        {
            currentScreen.stopAnimation( Widget.ALPHA, true );
            currentScreen.animate( { a:0, duration:duration } );
        }

        _x2.requestFocus( screen );

        if( screen instanceof Screen )
        {
            if( _x2._telemetry )
                _x2._telemetry.sendActiveSession( screen );

            if( window.ll && screen._telemetryName )
                window.ll( "tagEvent", "Screen Viewed", { "Screen": screen._telemetryName } ); // Localytics
        }
    };

    StackScreen.prototype.set = function( screen )
    {
        var remove, toRemove, self = this;

        remove = function()
        {
            if( _x2._config._render === Config.RENDER_DOM )
            {
                if( self._div )
                    for( var i = 0; i < toRemove.length; i++ )
                    {
                        self._div.removeChild( toRemove[i]._div );
                        toRemove[i].destroy();
                    }
            }
        };

        screen.setA( 0 );
        this.addWidget( screen );
        screen.resourcesLoad();
        screen.getVal( Widget.W );  // trigger reflow in DOM
        screen.resourcesLoaded();

        toRemove = this._children.splice( 0, this._children.length - 1 );
        screen.animate( { a:1, duration:StackScreen.ANI_TIME, onEnd:remove } );

        _x2.requestFocus( screen );

        if( screen instanceof Screen )
        {
            if( _x2._telemetry )
                _x2._telemetry.sendActiveSession( screen );

            if( window.ll && screen._telemetryName )
                window.ll( "tagEvent", "Screen Viewed", { "Screen": screen._telemetryName } ); // Localytics
        }
    };
    /**
     * Clear splash screen, when we play video screen
     */
    StackScreen.prototype.clearSplashScreen = function() 
    {
        for( var i = 0; i < this._div.children.length; i++ )
        {
            if( this._div.children[i].id == 'LoadingScreen' ) {
                this._div.removeChild( this._div.children[i] );
                break;
            }
        }
    }//sometimes, it remove from children properties, but it still there in the div html children

    return StackScreen;

})();

window.KeyEater = ( function()
{
    "use strict";

    KeyEater.prototype = new Widget();

    function KeyEater(){}

    KeyEater.prototype.getFocus = function()
    {
        return this._inFocus;
    };

    KeyEater.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
        _x2._hi.setA( 0 );//fadeout still showing highlight while moving between screen
    };

    KeyEater.prototype.init = function( widgetInFocus )
    {
        Widget.prototype.init.call( this );
        this._className  = "KeyEater";
        this._selectable = true;
        this._inFocus    = widgetInFocus;

        return this;
    };

    KeyEater.prototype.processEvent = function()
    {
        return true;
    };

    return KeyEater;

})();


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SportsTeamScreen = (function()
{
    "use strict";

    SportsTeamScreen.prototype = new Screen();

    function SportsTeamScreen(){}

    SportsTeamScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
    };

    /**
     * Init the widget
     * @param {BrowseEntity} entity
     * @return {SportsTeamScreen}
     */
    SportsTeamScreen.prototype.init = function( entity )
    {
        Screen.prototype.init.call( this );
        this._className     = "SportsTeamScreen";
        this._telemetryName = "Sports Team";
        this._browseEntity  = entity;

        var self = this;
        var team = new SportsTeam().init( { entityId:entity.getEntityId() } );

        var y = 0; // XC-13188: Can't use 'y = {Screen}.getHeaderBottom()'
        var x = Style._safeLeft;

        var yOffsets = [ y, y + _x2.scaleValInt( 80 ) , y + _x2.scaleValInt( 130 ), y + _x2.scaleValInt( 320 )];
        var xOffsets = [ x, x + _x2.scaleValInt( 340 ), x + _x2.scaleValInt( 840 ) ];

        var onPosterError = function()
        {
            var fallback = self._entity.getFallbackImageLink( 303, 404 );

            if( !fallback || ( self._posterImg.getUrl() === fallback ) ) //hide if no fallback or fallback == current
                self._posterImg.setA(0);
            else
                self._posterImg.setUrl (fallback );
        };

        var titleStyle = new Style( { font: "light"  , color: "#e8e8e8", fontSize: _x2.scaleValInt( 48 ), whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis" } );
        var textStyle  = new Style( { font: "regular", color: "#a3a3a3", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );

        //add poster
        this._titleStr  = new StringWidget().init( { style: titleStyle } );
        this._posterImg = new ImageWidget().init( { w:_x2.scaleValInt( 303 ), h:_x2.scaleValInt( 404 ), onError:onPosterError } );
        this._posterImg.setA(0);

        //add coach/venue/location/conference
        this._s1 = new StringWidget().init( { style: textStyle } );
        this._s2 = new StringWidget().init( { style: textStyle } );
        this._s3 = new StringWidget().init( { style: textStyle } );
        this._s4 = new StringWidget().init( { style: textStyle } );

        this._menu = new Widget().init();
        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function()
        {
            self._distractor.centerOnWidget( self );
            self._distractor.show();
        } );

        this.addWidget( this._titleStr , xOffsets[1], yOffsets[0] );
        this.addWidget( this._s1       , xOffsets[1], yOffsets[1] );
        this.addWidget( this._s2       , xOffsets[1], yOffsets[2] );
        this.addWidget( this._s3       , xOffsets[2], yOffsets[1] );
        this.addWidget( this._s4       , xOffsets[2], yOffsets[2] );
        this.addWidget( this._menu     , xOffsets[1], yOffsets[3] );
        this.addWidget( this._posterImg, xOffsets[0], yOffsets[0] );
        this.addWidget( this._distractor );

        var error = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.ENTITY } ) );
            console.log( error.toString() );
        };

        var setDetail = function( team )
        {
            var y      = self.getHeaderBottom() + _x2.scaleValInt( 42 ); // XC-13188 space between Breadcrumb line separator
            var league = team.getLeague() ? " (" + team.getLeague() + ")" : "";

            self.setBreadCrumbs( team.getName() );

            self._titleStr.setText( team.getName() + league );
            self._posterImg.setUrl( team.getImageLink(180,240) );

            self._s1.setY( y + yOffsets[1] );
            self._s2.setY( y + yOffsets[2] );
            self._s3.setY( y + yOffsets[1] );
            self._s4.setY( y + yOffsets[2] );

            self._s1.setText( "Coach: "      + ( team.getCoach()      ? team.getCoach()      : "NA" ) );
            self._s2.setText( "Venue: "      + ( team.getVenue()      ? team.getVenue()      : "NA" ) );
            self._s3.setText( "Location: "   + ( team.getLocation()   ? team.getLocation()   : "NA" ) );
            self._s4.setText( "Conference: " + ( team.getConference() ? team.getConference() : "NA" ) );

            self._speechStr = self._titleStr.getText() + ". " + self._s1.getText() + ". " + self._s2.getText() + ". " + self._s3.getText() + ". " + self._s4.getText() + ". ";

            self._posterImg.setA(1);

            self._entity = team;

            self.setActionButtons( _x2._favorites.isFavorite( team ) );

            self._distractor.hide();
        };

        team.getDetail().then(setDetail).catch(error);

        this.addReadyCallback( function(){ self.layout(); } );

        return this;
    };

    SportsTeamScreen.prototype.setActionButtons = function( isFavorite )
    {
        var buttonWidget, buttons = [];
        var self        = this;
        var team        = this._entity;
        var buttonStyle = new Style( { font: "light", color: "#e8e8e8", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap", colorHi:"#000000" } );

        var selectReplays = function()
        {
            _x2._telemetry.setWatchButton( "Entity Replays" );
            if( self._entity )
                _x2.pushScreen( new EpisodesScreen().init( { entity:self._entity } ) );
        };

        var selectGames = function()
        {
            _x2._telemetry.setWatchButton( "Entity Games" );
            if( self._entity )
                _x2.pushScreen( new UpcomingScreen().init( { entity:self._entity, listings:team.getGames() } ) );
        };

        var selectUpcoming = function()
        {
            _x2._telemetry.setWatchButton( "Entity Upcoming" );
            if( self._entity )
                _x2.pushScreen( new UpcomingScreen().init( { entity:self._entity, listings:team.getUpcomingListings() } ) );
        };

        var onFavoriteError = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON } ) );
        };

        var setFavorite = function()
        {
            self._distractor.show();
            _x2._favorites.addFavorite( self._entity ).then(
                function()
                {
                    self._distractor.hide();
                    self.setActionButtons( true );
                    _x2.localyticsSendFavoriteEntityOrViewed( self._entity, "Add" );
                    _x2.refreshFavorites();
                }
            ).catch( onFavoriteError );
        };

        var removeFavorite = function()
        {
            self._distractor.show();
            _x2._favorites.removeFavorite( self._entity ).then(
                function()
                {
                    self._distractor.hide();
                    self.setActionButtons( false );
                    _x2.localyticsSendFavoriteEntityOrViewed( self._entity, "Remove" );
                    _x2.refreshFavorites();

                    if( self._browseEntity._changeCallback )
                        self._browseEntity._changeCallback();
                }
            ).catch( onFavoriteError );
        };

        if( team.getGames().length )
            buttons.push( new StringWidget().init( { text:"Games", style:buttonStyle, onEnter:selectGames } ) );

        if( team.getEpisodes().length )
            buttons.push( new StringWidget().init( { text:"Replays", style:buttonStyle, onEnter:selectReplays } ) );

        if( isFavorite )
        {
            if( !_x2._telemetry._watchButtonPath.length && !this._sentViewed ) // Any location aside from favorites will have an first entry "Browse: TV", "Search", etc.
            {
                _x2.localyticsSendFavoriteEntityOrViewed( this._entity, "Viewed" );
                this._sentViewed = true;
            }

            buttons.push( new StringWidget().init( { text:"Remove Favorite", style:buttonStyle, onEnter:removeFavorite } ) );
        }
        else
            buttons.push( new StringWidget().init( { text:"Favorite", style:buttonStyle, onEnter:setFavorite } ) );

        buttonWidget = new HorizPillButtonsWidget().init( { entries:buttons, spacing:_x2.scaleValInt( 60 ) } );

        this._menu.removeAllWidgets();
        this._menu.addWidget( buttonWidget );
        this._menu.patchWidget();

        if( _x2._focus === this || _x2._focus === this._buttonWidget )
        {
            var focus = _x2.requestFocus( buttonWidget, true );
            this._speakTarget.setText( this._speechStr + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press left or right to review options. Press OK to select. ", focus._speakRole, this, false );
        }

        this._buttonWidget = buttonWidget;
    };

    SportsTeamScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom() + _x2.scaleValInt( 42 ); // XC-13188 space between Breadcrumb line separator

        this._titleStr .setY( y );
        this._menu     .setY( this._menu     .getY() + y );
        this._posterImg.setY( this._posterImg.getY() + y );
    };

    return SportsTeamScreen;

})();


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.StreamingDevicesScreen = ( function()
{
    "use strict";

    StreamingDevicesScreen.prototype = new Screen();

    function StreamingDevicesScreen(){}

    StreamingDevicesScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
//       _x2.requestFocus( this._list );
    };

    /**
     * Initializer
     * @memberof StreamingDevicesScreen
     * @param   {Object} params
     * @param   {String} params.path - breadcrumb path
     * @returns {StreamingDevicesScreen}
     */
    StreamingDevicesScreen.prototype.init = function( params )
    {
        var onSuccess;
        var self       = this, listParams = {};
        var w          = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var titleStyle = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), whiteSpace:"nowrap" } );
        var bodyStyle  = new Style( { font:"light" , color:"#a3a3a3", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap" } );
        var noStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(54), whiteSpace:"nowrap", textAlign:"center" } );
        var descStr    = "If you've reached your streaming limit, you'll need to stop playback on one device before you can start streaming on another.";
        var onLoad     = function() { self._numLoaded++; self.layout(); };

        Screen.prototype.init.call( this );
        this._className     = "StreamingDevicesScreen";
        this._telemetryName = "Streaming Devices";
        this.setBreadCrumbs( params.path, "Devices Currently Streaming" );

        this._numLoaded = 0;

        this._title = new StringWidget().init( { text:"Devices Currently Streaming", style:titleStyle } );
        this.addWidget( this._title, Style._safeLeft );

        this._desc = new TextBlockWidget().init( { text:descStr , style:bodyStyle, w:w } );
        this.addWidget( this._desc, Style._safeLeft );

        this._lowerSep = new RectWidget().init( { w:w, h:ListRowWidget.DIVIDER_H, color:"#303030" } );
        this.addWidget( this._lowerSep, Style._safeLeft );

        this._noStream = new StringWidget().init( { text:"No devices currently streaming.", style:noStyle } );
        this._noStream.setW( _x2._config._screenW );
        this._noStream.setA( 0 );
        this._noStream.addReadyCallback( onLoad );
        this.addWidget( this._noStream );

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( onLoad );
        this.addWidget( this._distractor );

        listParams.w        = w;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.type     = DevicesRowWidget;

        this._list = new ListWidget().init( listParams );
        this._list.setA( 0 );
        this.addWidget( this._list, Style._safeLeft );

            /**
             * @param {Object[]} data
             * @param {Boolean}  data[].isStreaming - indicates that the specified device is currently streaming
             * @param {String}   data[].streamType  - indicates the type of the stream
             */
            onSuccess = function( data )
            {
                var results = [], subTitle;

                console.log( "Devices Currently Streaming" );
                console.log( data );

                self._distractor.hide();
                self._loaded = true;

                if( data && data.length > 0 )
                {
                    for( var i = 0; i < data.length; i++ )
                        if( data[i].isStreaming === true )
                        {
                            switch( data[i].streamType )
                            {
                                case "DVR":
                                    subTitle = "Recording";
                                    break;

                                case "LINEAR":
                                case "TVE_LINEAR":
                                    subTitle = "Live TV";
                                    break;

                                case "PURCHASED_VOD":
                                    subTitle = "Purchase";
                                    break;

                                case "TVE_VOD":
                                    subTitle = "TV GO";
                                    break;

                                case "VOD":
                                    subTitle = "On Demand";
                                    break;
                            }

                            console.log( data[i] );
                            results.push( { title:data[i].deviceName, subTitle:subTitle, showIcon:false } );
                        }

                    console.log( results );

                    if( results.length > 0 )
                    {
                        self._list.setData( results );
                        self._list.animate( { a:1, duration:500 } );

                        if( _x2._focus === self )
                            _x2.requestFocus( self._list );
                    }
                    else
                        self._noStream.animate( { a:1, duration:500 } );
                }
            };

            _x2._data.getAllDeviceList().then( onSuccess );

        return this;
    };

    StreamingDevicesScreen.prototype.layout = function()
    {
        if( this._numLoaded === 2 )
        {
            Screen.prototype.resourcesLoaded.call( this );

            this._title.setY( this.getHeaderBottom() + _x2.scaleValInt(50) );
            this._desc.setY( this._title.getY() + this._title.getH() );
            this._lowerSep.setY( this._desc.getY() + this._desc.getH() + _x2.scaleValInt(50) );

            var top = this._lowerSep.getY() + this._lowerSep.getH();
            var h   = _x2._config._screenH - Style._safeBottom - top;

            this._noStream.setY( top + (h - this._noStream.getH()) / 2 );

            this._distractor.setX( (_x2._config._screenW - this._distractor.getW() ) / 2 );
            this._distractor.setY(  top + (h - this._distractor.getH()) / 2 );

            if( this._loaded !== true )
                this._distractor.show();

            this._list.setH( h + Style._safeBottom );
            this._list.setY( top );
        }
    };

    return StreamingDevicesScreen;

})();


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TermsScreen = ( function()
{
    "use strict";

    TermsScreen.prototype = new Screen();

    function TermsScreen(){}

    TermsScreen.prototype.gotFocus = function()
    {
        if( this._ready === true )
            this.speak( _x2.requestFocus( this._buttons ) );
        else
            this.speak();
    };

    TermsScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this, { noHeader:true, noSep:true } );
        this._className     = "TermsScreen";
        this._telemetryName = "Terms & Policies"; // TODO: "Terms & Policies" or "Terms Acceptance" ?

        var self = this, onAccept, onDecline, hPad, welcomeStr, welcomeBodyStr, titleStr, termsBodyStr, titleStyle, bodyStyle, buttonStyle, accept, decline;

        onAccept = function()
        {
            window.ll( "tagEvent" , "Terms Of Activation", { Response: "Accepted", Viewed: "Yes" } );
            _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Terms: Accepted" ) : Config.NOP();

            self._buttons.setDisabled( true );
            _x2._showTerms = false;
            _x2.sessionCreated();
        };

        onDecline = function()
        {
            window.ll( "tagEvent" , "Terms Of Activation", { Response: "Rejecting", Viewed: "Yes" } );
            _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Terms: Rejecting" ) : Config.NOP();

            
            _x2._config._host.removeAllTokenLocalStorage();
            _x2._config._host.removeLocalStorage( "XtvAuthToken" );
            _x2._config._host.removeLocalStorage( "features"     );
            _x2._data = undefined;
            _x2.authorize();
        };

        hPad           = _x2.scaleValInt( 250 );
        welcomeStr     = "Welcome to the Xfinity Stream App Beta Trial!";
        welcomeBodyStr = "If during the trial you use this device as your primary TV box (i.e., no other Xfinity TV box is on your account) you either will see a credit on your account for Customer Owned Equipment, or will not be charged separately for Xfinity equipment, depending upon the market. Otherwise, during the trial, no fees will be charged by Comcast for your using this device with your Xfinity TV service as a non-primary TV box. On the conclusion of the trial, you will be informed of any other charges that will apply and will have the opportunity to opt in." + "<br><br>By activating you acknowledge that Comcast may, at its discretion, provide complimentary access to Live TV networks for periods of time and those networks may air programming with an R or TV-MA rating.  You can always restrict access to programming using the Parental Control settings in the Xfinity Stream beta channel.";
        titleStr       = "Terms of Activation";
        termsBodyStr   = "By activating, you agree that you want to enable cloud DVR technology to access your Xfinity TV subscription on additional supported devices like computers and tablets, as well as the TV connected to your set-top DVR via Comcast’s network. If subscribed to X1 DVR with cloud technology, your acceptance also confirms that when you record programs on your set-top DVR you also want to save and store them automatically in Comcast’s network in several formats to (1) enable you to play them back (and navigate within them) on additional supported devices like computers and tablets, as well as the TV connected to your set-top DVR, and (2) optimize the video and audio quality of your viewing experience during playback.";
        titleStyle     = new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(48), textAlign :"center", whiteSpace:"nowrap" } );
        bodyStyle      = new Style( { font:"regular", color:"#a3a3a3", fontSize:_x2.scaleValInt(30) } );
        buttonStyle    = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(32), whiteSpace:"nowrap", colorHi:"#000000" } );
        accept         = new StringWidget().init( { text:"Yes" , style:buttonStyle, onEnter:onAccept  } );
        decline        = new StringWidget().init( { text:"No Thanks", style:buttonStyle, onEnter:onDecline } );

        this._offset    = 0;
        this._step      = _x2.scaleValInt( 40 );
        this._stepWheel = _x2.scaleValInt( 15 );

        this._container = new Widget().init();
        this._container.setW( _x2._config._screenW - 2 * hPad );

        this._welcomeTitle = new StringWidget().init( { text:welcomeStr, style:titleStyle } );
        this._welcomeTitle.setW( this._container.getW() );
        this.addWidget( this._welcomeTitle, hPad, _x2.scaleValInt( 248 ) );

        this._welcomeBody = new TextBlockWidget().init( { text:welcomeBodyStr , style:bodyStyle, w:this._container.getW() } );
        this._container.addWidget( this._welcomeBody );

        if( _x2._config._isCdvr === true )
        {
            this._termsTitle = new StringWidget().init( { text:titleStr, style:titleStyle } );
            this._termsTitle.setW( this._container.getW() );
            this._container.addWidget( this._termsTitle );

            this._termsBody = new TextBlockWidget().init( { text:termsBodyStr , style:bodyStyle, w:this._container.getW() } );
            this._container.addWidget( this._termsBody );
        }

        this._scrollPane = new ScrollWidget().init( { widget: this._container, w: this._container.getW(), h:parseInt( _x2._config._screenW/4 )  } );
        this.addWidget( this._scrollPane, hPad, 0 );

        this._buttons = new HorizPillButtonsWidget().init( { entries:[accept,decline], spacing:_x2.scaleValInt(60) } );
        this._buttons.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._buttons );

        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Terms of Activation screen" ) : Config.NOP();
        window.ll( "tagScreen", "Terms of Activation" ); // Localytics 2.1.1: "Terms of Activation"; NOTE: other platforms: "Terms & Policies"

        // NOTE: Can't send SCREEN_VIEWED until _x2._telemetry has been instantiated

        return this;
    };

    TermsScreen.prototype.scroll = function( step, duration )
    {
        console.log( step );

        if( step > 0 )
        {
            var max = this._scrollPane.getH() - this._container.getH();

            this._offset = this._offset - step;

            if( this._offset < max )
            {
                this._offset = max;

                if( _x2._focus !== this._buttons )
                    this.speak( _x2.requestFocus( this._buttons ), true );
            }
        }
        else
        {
            this._offset = this._offset - step;

            if( this._offset > 0 )
                this._offset = 0;
        }

        this._scrollPane.setScroll( { y:this._offset, duration:duration } );
    };

    TermsScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
            case Host.KEY_CH_DOWN:
            case Host.KEY_PAGE_DN:
                if( type === Host.KEY_PRESSED )
                    this.scroll( (val === Host.KEY_CH_DOWN || val === Host.KEY_PAGE_DN) ? 5000 : this._step, 300 );
                break;

            case Host.KEY_LAST:
                if( type === Host.KEY_PRESSED )
                {
                    _x2.logoutOnExit = true;
                    retval = false;
                }
                break;

            case Host.KEY_UP:
            case Host.KEY_CH_UP:
            case Host.KEY_PAGE_UP:
                if( type === Host.KEY_PRESSED )
                    this.scroll( (val === Host.KEY_CH_UP || val === Host.KEY_PAGE_UP) ? -5000 : -this._step, 300 );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    TermsScreen.prototype.layout = function()
    {
        if( _x2._config._isCdvr === true )
        {
            this._termsTitle.setY( this._welcomeBody.getH() + _x2.scaleValInt( 50 ) );
            this._termsBody.setY( this._termsTitle.getY() + this._termsTitle.getH() + _x2.scaleValInt( 40 ) );
            this._container.setH( this._termsBody.getY() + this._termsBody.getH() );
        }
        else
            this._container.setH( this._welcomeBody.getY() + this._welcomeBody.getH() );

        this._buttons.setX( (_x2._config._screenW - this._buttons.getW()) / 2 );
        this._buttons.setY( _x2._config._screenH - _x2.scaleValInt( 231 ) - this._buttons.getH() );
        this._scrollPane.setY( this._welcomeTitle.getY() + this._welcomeTitle.getH() + _x2.scaleValInt( 40 ) );

        var self = this;
        var h1   = this._buttons.getY  () - this._scrollPane.getY() - _x2.scaleValInt( 50 );
        var h2   = this._container.getH();
        var h    = h1 < h2 ? h1 : h2;

        this._scrollPane.setH( h );

        if( this._container.getH() <= this._scrollPane.getH() && _x2._focus === this )
        {
            this.speak( _x2.requestFocus( this._buttons ) );
            this._ready = true;
        }

        this.setMouseWheelListener( function( event ) { self.scroll( event.deltaY > 0 ? self._stepWheel : -self._stepWheel ); } );
    };

    TermsScreen.prototype.speak = function( focus, skipTerms )
    {
        var str = this._welcomeTitle.getText() + ". " + this._welcomeBody.getText();

        if( this._termsTitle )
            str += this._termsTitle.getText() + ". " + this._termsBody.getText();

        str = str.replace( /xfinity/gi, "x finity" );

        if( focus )
        {
            this._speakTarget.setText( (skipTerms === true ? "" : str) + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press right or left to review options. Press OK to select. ", focus._speakRole, this, false );
        }
        else
        {
            this._speakTarget.setText( str );
            this._speakTarget.setSpeechParams( "Press down to continue reading. ", undefined, this, false );
        }
    };

    return TermsScreen;

})();


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.TransitionScreen = ( function()
{
    "use strict";

    TransitionScreen.prototype = new Screen();

    function TransitionScreen(){}

    TransitionScreen.prototype.gotFocus = function()
    {
        if( this._error === true )
            _x2.setDefaultScreen();

        this._speakTarget.setText( "Loading, please stand by. " );
        this._speakTarget.setSpeechParams( undefined, undefined, this, false );
    };

    /**
     * @param {Object}   params
     * @param {String}  [params.entityId] - entityID to use for transition to entity screen
     * @param {Boolean} [params.signOut ] - execute the sign out process
     */
    TransitionScreen.prototype.init = function( params )
    {
        var self = this, onEntity, onError, onCollection;

        Screen.prototype.init.call( this, { noHeader:true, noSep:true } );
        this._className     = "TransitionScreen";
        this._telemetryName = "Transition";
        this._blockKeys     = true;

        this._distractor = new DistractorWidget().init();
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ); self._distractor.show(); } );
        this.addWidget( this._distractor );

        var entity, molt, p=[];
        console.log("Is params has entityId", params.entityId , JSON.stringify( params ) );
        if( params.entityId )
        {
            onError = function( error )
            {
                self._error = true;
                self._distractor.hide();
                console.error( error.toString() );
                _x2.pushOverlay( new ErrorOverlay().init( { error:error } ) );
            };

            if( params.entityId.indexOf("https://") !== -1 )
            {
                onCollection = function( folder )
                {
                    var metrics =
                            {
                                entityId   : params.entityId,
                                entityTitle: folder.getTitle(),
                                entityType : "Collection"
                            };

                    window.ll( 'tagEvent', "Hub Preview", metrics ); // Localytics 1.3.6

                    folder.setMeta({deepLink:true});
                    _x2.setScreen( new VodBranchScreen().init( folder ) );
                };

                var tokens  = params.entityId.split('/');
                var alias   = tokens[tokens.length-1];
                var filters = _x2.getBrowseFilterString();
                _x2._data.getNodeByAlias( alias, filters ).then( onCollection ).catch( onError );
            }
            else
            {
                onEntity = function()
                {
                    // Movie or TV Show
                    var type        = entity.getType        && entity.getType();
                    var programType = entity.getProgramType && entity.getProgramType();
                    var entityType  = undefined;

                    switch( type )
                    {
                        case "Movie":
                        case "s:Movie":
                            entityType = "Movie";
                            break;

                        case "Episode":
                        case "s:TvSeries":
                        case "SeriesMaster":
                            entityType = "TV Show";
                            break;

                        default:
                            if( programType === "Movie" )
                                entityType = "Movie"
                            else
                                entityType = "TV Show";
                            break;
                    }

                    var metrics =
                            {
                                entityId   : params.entityId,
                                entityTitle: entity.getTitle(),
                                entityType : entityType
                            };

                    window.ll( 'tagEvent', "Hub Preview", metrics ); // Localytics 1.3.6

                    console.log( "Hub Preview Type: " + entityType );

                    entity.fetchEntityOptions().then(function() {
                        _x2.setScreen( new EntityScreen().init( { entity:entity, molt:molt } ) );
                    })

                };
                if( _x2._data ) {
                    p.push( _x2._data.getProgram( params.entityId ).then( function( data ) { entity = data } ) );
                    // p.push( _x2._data.getProgramEntity( params.entityId ).then( function( data ) { entity = data } ) ); //TODO: we need to get entity options
                    p.push( _x2._data.getMoreLikeThis ( params.entityId ).then( function( data ) { molt   = data } ) );
                    Promise.all( p ).then( onEntity ).catch( onError );
                } else {
                    console.log("Data was not ready for smart hub preview" );
                }
                
            }
        }
        else if( params.signOut )
        {
            _x2._authService.logout();
            _x2._data = undefined;
            setTimeout( function() { _x2.authorize(); }, 1000 );
        }

        return this;
    };

    TransitionScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( this._blockKeys !== true )
            retval = Screen.prototype.processEvent.call( this, val, type );

        return retval;
    };

    return TransitionScreen;

})();


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VideoScreen = ( function()
{
    "use strict";

    VideoScreen.prototype = new Screen();

    VideoScreen.Mode = Object.freeze
    ({
        DVR  : 0,
        LIVE : 1,
        VOD  : 2
    });

    VideoScreen.SpeedMode = Object.freeze
    ({
        DYNAMIC : 0,
        STATIC  : 1
    });

    VideoScreen.State = Object.freeze
    ({
        PAUSED : 0,
        PLAY   : 1
    });

    var videoPlayer;
    var rawImW  = 102;
    var rawImH  = 136;
    var typeStr = [ "DVR", "Live", "On Demand" ];

    function VideoScreen(){}

    function createClockTimeStr( msec )
    {
        var date  = new Date( msec );
        var hours = date.getHours() % 12;
        var mins  = date.getMinutes();

        return (hours === 0 ? 12 : hours) + ":" + (mins < 10 ? "0" + mins : mins);
    }

    VideoScreen.prototype.createLabelStr = function( which, val, doSet )
    {
        var retval;

        switch( which )
        {
            case "cc":
                retval = "Closed Captioning: <font color='#2B9CD8'>" + val + "</font>";
                if( doSet === true )
                    this._cc.setLabel( retval );
                break;

            case "dv":
                retval = "Video Description: <font color='#2B9CD8'>" + val + "</font>";
                if( doSet === true )
                    this._dv.setLabel( retval );
                break;

            case "sap":
                retval = "Secondary Audio: <font color='#2B9CD8'>" + val + "</font>";
                if( doSet === true )
                    this._sap.setLabel( retval );
                break;
        }

        return retval;
    };

    VideoScreen.prototype.createTimeStr = function( msec )
    {
        var time, secs, mins;

        time = Math.floor( msec / 1000 );
        secs = time % 60;
        time = Math.floor( time / 60 );
        mins = time % 60;
        time = Math.floor( time / 60 );

        return time + ":" + (mins < 10 ? "0" + mins : mins) + ":" + (secs < 10 ? "0" + secs : secs);
    };

    VideoScreen.prototype.destroy = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 1 ) ? console.log( ">>>>>>>>>> DESTROY VIDEO SCREEN <<<<<<<<<<, current = " + this._current + ", attempts = " + this._attempts ) : Config.NOP();
        _x2.removeChangeCallback( this._tickWrapper );
        _x2._hi.setA(0);

        if( this._retryTimer )
        {
            clearTimeout( this._retryTimer );
            this._attempts = undefined;
        }

        if( videoPlayer )
            this.sendVideoPlayedLocalytics();

        if( ! this._mediaEnded )
        {
            switch( this._mode )
            {
                case VideoScreen.Mode.DVR:
                    _x2._data.playbackRecordingStopWatching( this._recordingId );
                    break;

                case VideoScreen.Mode.VOD:
                    _x2._data.playbackVodStopWatching( this._paid );
                    break;

                case VideoScreen.Mode.LIVE:
                    _x2._data.playbackLinearStopWatching( this._streamId );
                    break;
            }
        }

        if( videoPlayer )
        {
            _x2._telemetry.sendVideoEnd( this.getTelemetryVideoType(), videoPlayer.getVersion() );
            _x2._telemetry.setVideoType( Telemetry.VideoType.NONE ); // ACTIVE_SESSION sends this but if video is not playing we need to send "Non Player"

            videoPlayer.stop();
        }

        if( this._timeout )
            clearTimeout( this._timeout );

        Screen.prototype.destroy.call( this );
    };

    VideoScreen.prototype.fastForwardIncrease = function()
    {
        if( this._speedIndex < this._speeds.length - 1 && this._mode !== VideoScreen.Mode.LIVE )
        {
            this._speedIndex++;

            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 5 ) ? console.log( "FAST FORWARD INCREASE -> " + this._speedIndex + ", " + this._speeds[this._speedIndex] + ", " + this._speedModes[this._speedIndex] ) : Config.NOP();

            if( this._speedModes[this._speedIndex] === VideoScreen.SpeedMode.STATIC )
            {
                if( this._scrubBase === undefined )
                    this._scrubBase = videoPlayer.getCurrentPosition();

                if( this._speedIndex === this._speeds.indexOf( 1 ) )
                {
                    videoPlayer.setSpeed( 1 );
                    videoPlayer.setPosition( this._scrubBase );
                    videoPlayer.play();
                    this._scrubBase = undefined;
                }
                else if( videoPlayer._playerPlatform.getPlayerStatus() === "playing" )
                    videoPlayer.pause();
            }
            else if( this._speedModes[this._speedIndex] === VideoScreen.SpeedMode.DYNAMIC )
                videoPlayer.setSpeed( this._speeds[this._speedIndex] );

            this.setIndicator();
            this.speakSpeed();
        }
    };

    VideoScreen.prototype.getCurrentEntity = function()
    {
        return this._entity;
    };

    VideoScreen.prototype.getTelemetryVideoType = function()
    {
        var retval;

        switch( this._mode )
        {
            case VideoScreen.Mode.DVR:
                retval = Telemetry.VideoType.RECORDING;
                break;

            case VideoScreen.Mode.LIVE:
                retval = Telemetry.VideoType.T6_LINEAR;
                break;

            case VideoScreen.Mode.VOD:
                retval = Telemetry.VideoType.T6_VOD;
                break;
        }

        return retval;
    };

    VideoScreen.prototype.gotFocus = function()
    {
        this.speak( _x2.requestFocus( this._cursor, true ) );
    };

    VideoScreen.prototype.hideLastWatched = function( params )
    {
        console.log( "HIDE LAST" );
        console.log( params );

        this._lastWatched.hide();

        if( this._showing === true )
        {
            this._touch = true;
            _x2.requestFocus( this._targets[this._index] );
        }
        else
            _x2.requestFocus( this );
    };

    /**
     * Initializer
     * @memberof VideoScreen
     * @param   {Object}    params
     * @param   {Object}    [params.entity   ] - Entity to be played.
     * @param   {Object}    [params.mediaId  ] - Media ID of asset.
     * @param   {number}    [params.mode     ] - VideoScreen.Mode of video associated with the URL.
     * @param   {Object}    [params.programId] - Program ID of asset.
     * @param   {String}    [params.url      ] - URL of video to play.
     * @returns {VideoScreen}
     */
    VideoScreen.prototype.init = function( params )
    {
        var self          = this, complement, channel, pref;
        var timeStyle     = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } );
        var timeStyleR    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt(24), textAlign:"right" } );
        var onLoad        = function() { self._numLoaded++; self.layout(); };
        var onButtonFocus = function() { _x2._hi.fadeOut(); };

        Screen.prototype.init.call( this, { noBg:true, noHeader:true, noSep:true } );
        this._className     = "VideoScreen";
        this._telemetryName = "Player";
        this._numLoaded     = 0;
        this._progress      = undefined;
        this._mediaId       = params.mediaId;
        this._programId     = params.programId;
        this._hasDvs        = params.hasDvs;
        this._streamId      = params.streamId;
        this._assetId       = params.assetId;
        this._providerId    = params.providerId;
        this._mediaGuid     = params.mediaGuid;
        this._entity        = params.entity;  //TODO: we init with an entity, then call setData with a showing?
        this._paid          = params.paid;
        this._recordingId   = params.recordingId;
        this._url           = params.url; // Localytics Error.Playback
        this._initResume    = params.resume;
        this._errorContexts = {};
        this._onUrlError    = function( e )
        {
            console.log( e );
            console.log( "ATTEMPT = " + self._attempts );

            if( self._attempts !== undefined )
            {
                self._attempts++;

                if( self._attempts < 6 )
                    self._retryTimer = setTimeout( function() { self.patchUrl( params.url, params.mode ).then( function( url ) { self.onGotUrl( url, params.resume ); }, self._onUrlError ); }, 1500 );
                else
                    _x2.pushOverlay( new ErrorOverlay().init( { error:e, context:self._errorContexts[self._mode], entity:self._entity } ) );
            }
        };

        _x2._config.debugAddClass( Config.CLASS_VIDEO_SCREEN, 7 );

        this._errorContexts[VideoScreen.Mode.DVR ] = ErrorOverlay.Context.DVR;
        this._errorContexts[VideoScreen.Mode.LIVE] = ErrorOverlay.Context.LINEAR;
        this._errorContexts[VideoScreen.Mode.VOD ] = ErrorOverlay.Context.VOD;

        if( params && params.url )
        {
            channel = this._entity.getChannel && this._entity.getChannel();
            pref    = _x2._settings.getValue( Settings.Key.FORMAT );
            if( pref === "hd" && this._entity.isAutoTune === true && this._entity._sdChannel ) {
                channel = this._entity._sdChannel;
            }//If channel was autotune in previous watch, then it should stream url from hd complement
            if( channel ) {
                console.log("Playing channel number", channel.getNumber(), 
                "Is HD channel?", channel.isHD(),
                "As HD complement?", channel.getHdComplement() );
            }
            if( pref === "hd" && channel && channel.isHD() === false && (complement = channel.getHdComplement()) )
            {
                params.url     = complement.getStreamUrl();
                this._streamId = complement.getStreamId();
                console.log("Sd channel ", channel.getNumber() ," was auto tuned to HD channel ", complement.getNumber() );
                if( this._entity.setChannel ) {
                    this._entity.setChannel( complement ); //set the channel so that onPlay() will assign the correct 'LAST_CHAN' to settings.
                    this._entity.isAutoTune = true;
                    this._entity._sdChannel = channel;
                }
            }

            this._attempts = 1;
            this.patchUrl( params.url, params.mode ).then( function( url ) { self.onGotUrl( url, params.resume ); }, this._onUrlError );
        }

        // params will drive the screen UI with a showing

        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 1 ) ? console.log( "MODE = " + params.mode ) : Config.NOP();

        this._mode    = params.mode;
        this._showing = true;
        _x2._screenRoot.clearSplashScreen();
        
        this._container = new Widget().init();
        this._container.setW( _x2._config._screenW );
        this._container.setH( _x2._config._screenH );
        this._container.setA( 0 );
        this._container._deepHide = true;  // this is a hack to help PP platform on LG, they need every cycle of CPU
        this.addWidget( this._container );

        this._topBg  = new ImageWidget().init( { url: _x2._config._imageRoot + "videoTopFade.png"   , onLoad:onLoad } );
        this._botBg  = new ImageWidget().init( { url: _x2._config._imageRoot + "videoBottomFade.png", onLoad:onLoad } );

        this._container.addWidget( this._topBg  );
        this._container.addWidget( this._botBg  );

        this._rightRect = new RectWidget().init( { w:400, h:Style._pad, color:"#333333" } );
        this._leftRect  = new RectWidget().init( { w:400, h:Style._pad, color:"#2ea0dd" } );

        this._container.addWidget( this._rightRect );
        this._container.addWidget( this._leftRect  );

        this._currStr  = new StringWidget().init( { text:"0:00:00", style:timeStyleR } );
        this._stopStr  = new StringWidget().init( { text:"0:00:00", style:timeStyle  } );

        this._container.addWidget( this._currStr  );
        this._container.addWidget( this._stopStr  );

        this._cursor = new ImageWidget().init( { url: _x2._config._imageRoot + "videoCursor.png", onLoad:onLoad, onFocus:onButtonFocus } );
        this._cursor._selectable = true;
        this._container.addWidget( this._cursor );

        this._pause = new DualImageWidget().init( { url:_x2._config._imageRoot + "pause.png", urlHi:_x2._config._imageRoot + "pauseHi.png", onFocus:onButtonFocus, onEnter:function() { self.togglePlayPause(); }, speechName:"Pause" } );
        this._pause.setA( 0 );
        this._pause.addReadyCallback( onLoad );
        this._container.addWidget( this._pause );

        this._play = new DualImageWidget().init( { url:_x2._config._imageRoot + "play.png", urlHi:_x2._config._imageRoot + "playHi.png", onFocus:onButtonFocus, onEnter:function() { self.togglePlayPause(); }, speechName:"Play" } );
        this._play.setA( 0 );
        this._play.addReadyCallback( onLoad );
        this._container.addWidget( this._play );

        this._ff = new DualImageWidget().init( { url:_x2._config._imageRoot + "fastForward.png", urlHi:_x2._config._imageRoot + "fastForwardHi.png", onFocus:onButtonFocus, onEnter:function() { self.fastForwardIncrease(); }, speechName:"Fast Forward" } );
        this._ff.setA( 0 );
        this._ff.addReadyCallback( onLoad );
        this._container.addWidget( this._ff );

        this._rew = new DualImageWidget().init( { url:_x2._config._imageRoot + "rewind.png", urlHi:_x2._config._imageRoot + "rewindHi.png", onFocus:onButtonFocus, onEnter:function() { self.rewindIncrease(); }, speechName:"Rewind" } );
        this._rew.setA( 0 );
        this._rew.addReadyCallback( onLoad );
        this._container.addWidget( this._rew );

        this._last = new DualImageWidget().init( { url:_x2._config._imageRoot + "lastWatched.png", urlHi:_x2._config._imageRoot + "lastWatchedHi.png", onFocus:onButtonFocus, onEnter:function() { self.showLastWatched(); }, speechName:"Last Watched" } );
        this._last.addReadyCallback( onLoad );
        this._container.addWidget( this._last );

        var onMiniGuidePressed = function()
        {
            self._showing = false;
            self._container.stopAnimation( Widget.ALPHA );
            self._container.animate( { a:0, duration:1 } );
            _x2.pushScreen( new MiniGuideScreen().init( { videoScreen:self } ) );
        };

        if( _x2._config._isChurned !== true )
        {
            this._mini = new DualImageWidget().init( { url:_x2._config._imageRoot + "miniGuide.png", urlHi:_x2._config._imageRoot + "miniGuideHi.png", speechName:"MiniGuide", onEnter:onMiniGuidePressed } );
            this._mini.addReadyCallback( onLoad );
            this._container.addWidget( this._mini );
        }

        var ccState  = _x2._settings.getValue( Settings.Key.CC_ENABLED );
        var ccParams =
        {
            initial:ccState === true ? 1 : 0,
            onEnter:function() { self.toggleCaptions(); },
            label  :this.createLabelStr( "cc", (ccState === true ? "On" : "Off"), false ),
            images :[ _x2._config._imageRoot + "cc.png", _x2._config._imageRoot + "ccHi.png", _x2._config._imageRoot + "ccSelected.png", _x2._config._imageRoot + "ccSelectedHi.png" ]
        };

        var dvState  = _x2._settings.getValue( Settings.Key.DV_ENABLED );
        var dvParams =
        {
            initial:dvState === true ? 1 : 0,
            onEnter:function() { self.toggleDv(); },
            label  :this.createLabelStr( "dv", (dvState === true ? "On" : "Off"), false ),
            images :[ _x2._config._imageRoot + "dv.png", _x2._config._imageRoot + "dvHi.png", _x2._config._imageRoot + "dvSelected.png", _x2._config._imageRoot + "dvSelectedHi.png" ]
        };

        var sapState  = _x2._settings.getValue( Settings.Key.SAP_ENABLED );
        var sapParams =
        {
            initial:sapState === true ? 1 : 0,
            onEnter:function() { self.toggleSap(); },
            label  :this.createLabelStr( "sap", (sapState === true ? "On" : "Off"), false ),
            images :[ _x2._config._imageRoot + "sap.png", _x2._config._imageRoot + "sapHi.png", _x2._config._imageRoot + "sapSelected.png", _x2._config._imageRoot + "sapSelectedHi.png" ]
        };

        this._cc = new MultiStateButtonWidget().init( ccParams );
        this._cc.addReadyCallback( onLoad );
        this._container.addWidget( this._cc );

        this._dv = new MultiStateButtonWidget().init( dvParams );
        this._dv.addReadyCallback( onLoad );
        this._container.addWidget( this._dv );

        this._sap = new MultiStateButtonWidget().init( sapParams );
        this._sap.addReadyCallback( onLoad );
        this._container.addWidget( this._sap );

//        this._index   = this._pp = 2;
//        this._targets = [ this._last, this._rew, this._pause, this._ff, this._cc, this._sap, this._dv ];
//        this._index   = this._pp = 1;

        if( this._mode !== VideoScreen.Mode.LIVE )
        {
            this._targets = [ this._last, this._rew, this._pause, this._ff, this._dv, this._sap, this._cc ];
            this._index   = this._pp = 2;

            if( this._mini )
                this._targets.splice( 4, 0, this._mini )
        }
        else
        {
            this._targets = [ this._last, this._dv, this._sap, this._cc ];
            this._index   = this._pp = 1;

            if( this._mini )
                this._targets.splice( 1, 0, this._mini )
        }

        this._stopStr.addReadyCallback( onLoad );

this._bitRate = new StringWidget().init( { style:timeStyle, text:"Bit Rate = " } );
this._bitRate.setA( 0 );
this._container.addWidget( this._bitRate );

this._playRate = new StringWidget().init( { style:timeStyle, text:"Play Rate = 1" } );
this._playRate.setA( 0 );
this._container.addWidget( this._playRate );

        this._distractor = new DistractorWidget().init( { hideBg:true } );
        this._distractor.setA( 0 );
        this._distractor.addReadyCallback( onLoad );
        this.addWidget( this._distractor, _x2._config._screenW, _x2._config._screenH );

        var imW           = _x2.scaleValInt( rawImW );
        var imH           = _x2.scaleValInt( rawImH );
        var textGapX      = _x2.scaleValInt( 30 );
        var typeStyle     = new Style( { color:"#b8b8b8", font:"regular", fontSize:_x2.scaleValInt(24), whiteSpace:"nowrap" } );
        var titleStyle    = new Style( { color:"#e8e8e8", font:"regular", fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
        var subTitleStyle = new Style( { color:"#e8e8e8", font:"thin"   , fontSize:_x2.scaleValInt(30), whiteSpace:"nowrap" } );
        var textX         = Style._safeLeft + imW + textGapX;
        var entity        = params.entity;

        this._image = new ImageWidget().init( { w:imW, h:imH, onLoad:function(){ self._image.setA( 1 ) } } );
        this._image.setA( 0 );
        this._container.addWidget( this._image, Style._safeLeft, Style._safeLeft );

        this._type = new StringWidget().init({ style:typeStyle, text:typeStr[params.mode] });
        this._container.addWidget( this._type, textX, Style._safeTop );

        this._title = new StringWidget().init({ style:titleStyle });
        this._container.addWidget( this._title, textX );

        this._subTitle = new StringWidget().init({ style:subTitleStyle });
        this._container.addWidget( this._subTitle, textX );

        this._lastWatched = new LastWatchedWidget().init( { params:params, videoScreen:this, onHide:function( params ) { self.hideLastWatched( params ); } } );
        this.addWidget( this._lastWatched );

        var onIndicatorsLoaded = function()
        {
            self._numIndicatorsLoaded++;

            if( self._numIndicatorsLoaded === 7 )
            {
                var x = (_x2._config._screenW - self._fwdIndicators[0].getW()) / 2;
                var y = (_x2._config._screenH - self._fwdIndicators[0].getH()) / 2;

                for( var i = 0; i < self._fwdIndicators.length; i++ )
                {
                    self._fwdIndicators[i].setX( x );
                    self._rewIndicators[i].setX( x );
                    self._fwdIndicators[i].setY( y );
                    self._rewIndicators[i].setY( y );
                }
            }
        };

        this._numIndicatorsLoaded = 0;
        this._lastIndicator = 0;
        this._indicators    = [];

        this._fwdIndicators =
        [
            new ImageWidget().init( { url:_x2._config._imageRoot + "1x-FF.png", onLoad:onIndicatorsLoaded } ),
            new ImageWidget().init( { url:_x2._config._imageRoot + "2x-FF.png", onLoad:onIndicatorsLoaded } ),
            new ImageWidget().init( { url:_x2._config._imageRoot + "3x-FF.png", onLoad:onIndicatorsLoaded } ),
            new ImageWidget().init( { url:_x2._config._imageRoot + "4x.png"   , onLoad:onIndicatorsLoaded } )
        ];

        this._rewIndicators =
        [
            new ImageWidget().init( { url:_x2._config._imageRoot + "1x-RWD.png", onLoad:onIndicatorsLoaded } ),
            new ImageWidget().init( { url:_x2._config._imageRoot + "2x-RWD.png", onLoad:onIndicatorsLoaded } ),
            new ImageWidget().init( { url:_x2._config._imageRoot + "3x-RWD.png", onLoad:onIndicatorsLoaded } ),
            this._fwdIndicators[3]
        ];

        for( var i = 0; i < this._fwdIndicators.length; i++ )
        {
            this._fwdIndicators[i].setA( 0 );
            this.addWidget( this._fwdIndicators[i] );
            this._rewIndicators[i].setA( 0 );
            this.addWidget( this._rewIndicators[i] );
        }

console.log( "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" );
console.log( entity );

//        this._distractor.show();

        var onIconLoaded = function()
        {
            self._netIconImage.setY( -(self._netIconImage.getH() + 4 * Style._pad) );
            self._netIconImage.setX( (self._distractor.getW() - self._netIconImage.getW()) / 2 );
            self._netIconImage.setA( 1 );
        };

        this._netIconW     = _x2.scaleValInt( 248 );
        this._netIconH     = this._netIconW * 3 / 4;
        this._netIconImage = new ImageWidget().init( { onChange:onIconLoaded, onError:function(){ self._netIconImage.setA(0) } } );
        this._netIconImage.setA( 0 );
        this._distractor.addWidget( this._netIconImage );

        var outOfWindow = false;

        if( entity instanceof LinearShowing )
            if( entity.getStartTime() > Date.now() || entity.getEndTime() < Date.now() )
                outOfWindow = true;

        if( outOfWindow )
            this.tick();
        else
            this.setData( entity );

        this._telemetryRewindTimestamp = 0;
        this._tickWrapper = function() { self.tick(); };
        _x2.addChangeCallback( this._tickWrapper );

        return this;
    };

    VideoScreen.prototype.layout = function()
    {
        var progressY;
        var numNeeded = this._mini ? 14 : 13;

        if( this._numLoaded === numNeeded )
        {
            this._botBg.setY( _x2._config._screenH - this._botBg.getH() );

            progressY = _x2._config._screenH - _x2.scaleValInt(253);

            this._currStr.setW( undefined );
            this._currStr.setX( Style._safeLeft );
            this._currStr.setY( progressY + (this._leftRect.getH() - this._stopStr.getH()) / 2 );
            this._stopStr.setX( _x2._config._screenW - Style._safeRight - this._stopStr.getW() );
            this._stopStr.setY( this._currStr.getY() );
            this._startX    = this._currStr.getX() + this._currStr.getW() + 2 * Style._pad;
            this._stopX     = this._stopStr.getX() - 2 * Style._pad;
            this._progressW = this._stopX - this._startX;

            this._currStr.setW( this._startX - 2 * Style._pad );
            this._currStr.setX( 0 );

            this._leftRect.setX( this._startX );
            this._leftRect.setY( progressY );
            this._rightRect.setX( this._startX );
            this._rightRect.setY( progressY );

            this._cursorOffsetX = -Math.floor( this._cursor.getW() / 2 );

            var y = progressY + _x2.scaleValInt( 66 );

            this._pause.setX( (_x2._config._screenW - this._pause.getW()) / 2 );
            this._pause.setY( y );

            this._play.setX( this._pause.getX() );
            this._play.setY( y );

            this._ff.setX( this._pause.getX() + this._pause.getW() + 3 * Style._pad );
            this._ff.setY( y );

            this._rew.setX( this._pause.getX() - this._rew.getW() - 3 * Style._pad );
            this._rew.setY( y );

            this._last.setX( this._startX );
            this._last.setY( y );

            this._cc.setX( this._stopX - this._cc.getW() );
            this._cc.setY( y );

            this._sap.setX( this._cc.getX() - this._sap.getW() - 3 * Style._pad );
            this._sap.setY( y );

            this._dv.setX( this._sap.getX() - this._dv.getW() - 3 * Style._pad );
            this._dv.setY( y );

            if( this._mini )
            {
                this._mini.setX( this._dv.getX() - this._mini.getW() - 3 * Style._pad );
                this._mini.setY( y );
            }

            this._distractor.setX( (_x2._config._screenW - this._distractor.getW()                 ) / 2 );
            this._distractor.setY( (_x2._config._screenH - this._distractor.getH() + this._netIconH) / 2 );

            var iconW = this._netIconImage.getW();

            if( iconW )
                this._netIconImage.setX( (this._distractor.getW() - iconW) / 2 );

            this._cursor.setX( this._startX + this._cursorOffsetX );
            this._cursor.setY( this._leftRect.getY() + (this._leftRect.getH() - this._cursor.getH()) / 2 );

            switch( this._mode )
            {
                case VideoScreen.Mode.DVR:
                    this._leftRect.setW( this._progressW );
                    this._rightRect.setW( this._progressW );
                    break;

                case VideoScreen.Mode.LIVE:
                    this._leftRect.setW( 0 );
                    this._rightRect.setW( this._progressW );
                    break;

                case VideoScreen.Mode.VOD:
                    this._leftRect.setW( this._progressW );
                    this._rightRect.setW( this._progressW );
//                     this._cursor.setX( this._startX + this._cursorOffsetX );
//                     this._cursor.setY( this._leftRect.getY() + (this._leftRect.getH() - this._cursor.getH()) / 2 );
                    break;

                default:
                    console.error( "ERROR => unknown mode = " + this._mode );
                    break;
            }

this._playRate.setY( this._bitRate.getY() + this._bitRate.getH() );

            this._type.setY( (this._image.getH() - this._type.getH() - this._title.getH() - this._subTitle.getH()) / 2 + this._image.getY() );
            this._title.setY( this._type.getY() + this._type.getH() );
            this._subTitle.setY( this._title.getY() + this._title.getH() );
            this._currStr.setText();
            this._stopStr.setText();

            if( this._mode === VideoScreen.Mode.LIVE )
            {
                this.setTimes();
            }
            else
            {
                var duration;

                if( this._entity.getDurationMs )
                    duration = this._entity.getDurationMs();
                else if( this._entity.getDuration )
                    duration = this._entity.getDuration() * 60000;

                this.setTimes( this._initResume, 0, duration );
            }

            this._touch   = true;
            this._showing = true;
            this._container.stopAnimation( Widget.Axis.A );
            this._container.setA( 1 );
        }
    };

    VideoScreen.prototype.onBitRateChanged = function( bitRate )
    {
        var mbps = bitRate / (1024 * 1024);
        var str  = "Bit Rate = " + (( mbps > 1 ) ? mbps.toFixed(3) + " mpbs" : Math.floor(bitRate / 1024) + " kpbs");

        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 5 ) ? console.log( "BIT RATE CHANGED = " + str ) : Config.NOP();

        this._bitRate.setText( str );
    };

    VideoScreen.prototype.onBufferComplete = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON BUFFER COMPLETE <<<<<<<<<<" ) : Config.NOP();
        this._distractor.hide();

        _x2._telemetry.sendVideoBufferComplete( this.getTelemetryVideoType(), false, this._current > 0, false );
    };

    VideoScreen.prototype.onBufferStart = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON BUFFER START <<<<<<<<<<" ) : Config.NOP();
        this._distractor.show( true );

        _x2._telemetry.sendVideoBufferStart( this.getTelemetryVideoType(), false, this._current > 0, false );

        console.log( this._current + " of " + this._progress + ", total = " + this._stop );

        if( this._current !== undefined && this._stop !== undefined && (this._stop - this._current) < 8000 )  // HACK in case run out of fragments at the very end
            this.onMediaEnded();
    };


    VideoScreen.prototype.onEmergencyAlertComplete = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON EMERGENCY ALERT COMPLETE <<<<<<<<<<" ) : Config.NOP();
        this._easLocked = false;
    };

    VideoScreen.prototype.onEmergencyAlertStarted = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON EMERGENCY ALERT STARTED <<<<<<<<<<" ) : Config.NOP();

        var self  = this;
        this._easLocked = true;
        setTimeout( function() { self._easLocked = false; }, 180000 );
    };

    VideoScreen.prototype.onError = function( event )
    {
console.error( event );
//         var params = {};
//
//         params.message = "Please try again later.";
//         params.title   = "Video Playback Error";
//
//         if( this._errorShown !== true )
//         {
//             this._errorShown = true;
//             _x2.pushOverlay( new AlertOverlay().init( params ) );
//         }

//        _x2._telemetry.sendVideoError( event.error.major, event.error.minor, event.error.description, this.getTelemetryVideoType(), true );
    };

    VideoScreen.prototype.onGotUrl = function( url, resume )
    {
        if( this._attempts !== undefined )
        {
            if( (resume === undefined || resume === 0) && this._mode === VideoScreen.Mode.DVR )  // Hack: PP is not starting in-flight recordings from the beginning
                resume = 1;

            if (resume && resume > this._entity.getDurationMs() ) {
                resume = this._mode === VideoScreen.Mode.DVR ? 1 : 0;
            }// resume is more than movie duration, then we need to reset the resumepoint to 0

            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 1 ) ? console.log( "#############################################################################################################################" ) : Config.NOP();
            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 1 ) ? console.log( "PLAY: " + url + ", resume = " + resume )                                                                                         : Config.NOP();
            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 1 ) ? console.log( "#############################################################################################################################" ) : Config.NOP();

            var lang, onVideoNotStarting, self = this;
    //         var newUrl = url.replace( /http:/g, "https:" );  // convert to https since using a secure production host
    //
    //         if( newUrl && _x2._config._host.getType() !== Host.Type.PC )  // the test content is http only, don't convert
    //             url = newUrl;

            var obj  =
            {
                recordingId: this._recordingId,
                streamId   : this._streamId,
                assetId    : this._assetId,
                providerId : this._providerId,
                mediaGuid  : this._mediaGuid
            };

            if( url )
            {
                var entity = this._entity, provider, networkLogoUrl, entityOptions;

                if( entity instanceof Entity )
                {
                    entityOptions = data.getEntityOptions();
                    provider = entityOptions && entityOptions.getContentProvider();
                }
                else
                {
                    if( entity instanceof Showing )
                        provider = entity.getContentProvider();

                    if( entity instanceof LinearShowing || entity instanceof Recording )
                        provider = entity.getChannel();
                }

                if( provider )
                {
                    networkLogoUrl = provider.getLogoUrl( this._netIconW, this._netIconH );

                    if( networkLogoUrl )
                    {
                        networkLogoUrl = networkLogoUrl.replace( /&extent=true/, "" );
                        networkLogoUrl = networkLogoUrl.replace( /&gravity/, "" );
                        this._netIconImage.setUrl( networkLogoUrl );
                    }
                }

                this._distractor.show( true );
            }

            if( _x2._settings.getValue( Settings.Key.DV_ENABLED ) === true && this._hasDvs === true )
                lang = "es";  // HACK since always coming through as Spanish at this point
            else if( _x2._settings.getValue( Settings.Key.SAP_ENABLED ) === true && this._hasDvs === false )
                lang = _x2._settings.getValue( Settings.Key.SAP_LANG );
            else
                lang = "en";

            if( videoPlayer === undefined )
            {
                var videoEas = true;

                if( _x2._config._host instanceof Tizen )  // HACK so broken Samsung TV can support EAS via text
                {
                    var textModels = [ "17_KANTS_FHD", "18_KANTS_FHD" ];

                    if( textModels.indexOf( _x2._config._host._model ) > -1 )
                        videoEas = false;
                }

                videoPlayer = (_x2._config._altVid === true) ? new CirrusVideo( url, this, resume, lang, obj, true ) : new ViperPlayerPlatform( url, this, resume, lang, obj, videoEas );
            }
            else if( url )
            {
                this._telemetryRewindTimestamp = 0;
                videoPlayer.stop();
                this._current = undefined;
                this._stop    = undefined;
                videoPlayer.setLanguage( lang );
                videoPlayer.play( url, this, resume, obj );
            }

            onVideoNotStarting = function()
            {
                var type = ErrorOverlay.Context.COMMON;

                switch( self._mode )
                {
                   case VideoScreen.Mode.LIVE:
                       type = ErrorOverlay.Context.LINEAR;
                       break;

                   case VideoScreen.Mode.DVR:
                       type = ErrorOverlay.Context.DVR;
                       break;

                   case VideoScreen.Mode.VOD:
                       type = ErrorOverlay.Context.VOD;
                       break;
                }
                var lastScreen = _x2._screenRoot.getTop();
                if( self._checkPlayStarted === true && self._checkInErrorState === false  && 
                    lastScreen instanceof VideoScreen )
                {
                    self._checkInErrorState = true;
                    _x2._splunk.sendVideoAttempt( self._entity, self._mode, self._url, videoPlayer.getVersion(), undefined, videoPlayer.getDuration() );
                    _x2._splunk.sendVideoError( self._entity, 'TVAPP-00148', 'Video playback has not started within 30 seconds.', undefined, undefined, self._mode, self._url, videoPlayer.getVersion(), videoPlayer.getDuration() );
                    _x2.pushOverlay( new ErrorOverlay().init( { reason:"(Error TVAPP-00148)" } ) ); //NOTE: TVAPP-00148 maps to playback start timeout. Set it directly as we're detecting it here (no mapping to external error).
                }
            };

            self._timeout = setTimeout( onVideoNotStarting, 35000 ); //onMediaFailed callback called at 32-33 seconds. Give that a chance to push a more specific message

            this._videoLatencyStart = Date.now(); // NOTE: We can't send the video attempt due the PlayerPlayer not having the player version available (yet)
            this._checkPlayStarted  = true;
            this._checkInErrorState = false;
            this._isMidStream       = resume > 0;
        }
    };

    VideoScreen.prototype.onInitialized = function( speeds )
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 3 ) ? console.log( speeds ) : Config.NOP();

        this._speeds     = [ -128, -16, -8, -4, 1, 4, 8, 16, 128 ];
        this._speedModes = [];
        this._speedIndex = this._speeds.indexOf( 1 );

        for( var i = 0; i < this._speeds.length; i++ )
        {
//             if( speeds.includes( this._speeds[i] ) )
//                 this._speedModes[i] = VideoScreen.SpeedMode.DYNAMIC;
//             else
                this._speedModes[i] = VideoScreen.SpeedMode.STATIC;

            var which = this._speedIndex - i;

            if( which < 0 )
                this._indicators[i] = this._fwdIndicators[-which - 1];
            else if( which > 0 )
                this._indicators[i] = this._rewIndicators[ which - 1];
        }

if( _x2._config._host.getType() === Host.Type.PC )
    videoPlayer.mute();

        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 3 ) ? console.log( this._speedModes ) : Config.NOP();
    };

    VideoScreen.prototype.onMediaOpened = function()
    {
        var videoType     = this.getTelemetryVideoType();
        var playerVersion = videoPlayer.getVersion();
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON MEDIA OPENED <<<<<<<<<<" ) : Config.NOP();

        _x2._telemetry.sendVideoAttempt( videoType, playerVersion ); // See note in onGotUrl
        _x2._splunk.sendVideoAttempt( this._entity, this._mode, this._url, playerVersion, videoPlayer.getDuration() );

        // set the sap button

        var langs = videoPlayer.getLanguages();

console.log( langs );
console.log( "--------> HAS DVS = " + this._hasDvs );

        if( _x2._settings.getValue( Settings.Key.SAP_ENABLED ) === true )
            this.createLabelStr( "sap", "On" , true );
        else
            this.createLabelStr( "sap", "Off", true );

        // set the dvs button

        var available = langs.length > 1 && this._hasDvs;

        if( _x2._settings.getValue( Settings.Key.DV_ENABLED ) === true )
            this.createLabelStr( "dv", available === true ? "On" : "Not Available", true );
        else
            this.createLabelStr( "dv", available === true ? "Off" : "Not Available", true );

        // turn on closed captions if enabled

        var captions = videoPlayer.getCaptions();

        if( captions.length > 0 )
        {
            if( _x2._settings.getValue( Settings.Key.CC_ENABLED ) === true )
            {
                _x2._config.log( Config.CLASS_VIDEO_SCREEN, 5 ) ? console.log( ">>>>>>>>>> CAPTIONS TURNED ON <<<<<<<<<<" ) : Config.NOP();
                _x2._config.log( Config.CLASS_VIDEO_SCREEN, 5 ) ? console.log( captions                                   ) : Config.NOP();

                videoPlayer.setCaption( captions[0] );
            }

            if( captions.length > 1 )
                console.warn( "more than one CC track available, do something with it" );

            videoPlayer._playerPlatform.setClosedCaptionsStyle( _x2._settings.getValue( Settings.Key.CC_STYLING ) );
        }

        // XC-18729: Video Playback - Playback is cut off when adjusting aspect ratio
        // guidance by LG in the #ext-tvpp-lg channel by dusik.oh @ Monday, December 9th, 6:52 PM
        // Issue 2) Part of screen is cropped when the resolution is set to 16:9 during the play of SD video.
        // -> LG provided Comcast with a solution that can be solved in the application. The issue is that both side are just cut off when switching to 16:9.
        // Please investigate our solution.
        // solution : document.getElementsByTagName ('video') [0] .style.objectFit = "fill" in the Video Tag.
        //
        // NOTES ON IMPLEMENTAION:
        // 1. We should not have to _explicitly_ set the *object-fit* CSS setting, since the initial value for the object-fit CSS is fill
        //    and since we do not set it, it is the default value:
        //    Please see official specification: https://www.w3.org/TR/css-images-3/#the-object-fit and https://drafts.csswg.org/css-cascade/#initial-values
        // 2. Make sure SD channels are available for testing.  Change the preferred format to *All Available Formats* from *HD Preferred*.
        // 3. Seems to only work for 16:9 aspect ratio display setting for SD channels.  *original* aspect ratio setting does not work for all LG TVs for SD channels.
        // 4. Even for HD channels, LG 2018 models appears to not behave correctly to explicit CSS object-fit: fill setting.
        //
        // Isolating this change to cirruscoam and to only LG hosts once the HTML5 video tag is created.
        if ( _x2._config._host.getType() === Host.Type.LG )
        {
            document.getElementsByTagName('video')[0].style.objectFit = "fill";
        }
    };

    VideoScreen.prototype.onMediaEnded = function()
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 3 ) ? console.log( ">>>>>>>>>> ON MEDIA ENDED <<<<<<<<<<" ) : Config.NOP();

        var self = this;
        this._mediaEnded = true;


        switch( this._mode )
        {
            case VideoScreen.Mode.DVR:
                this._resume = 0;
                this.storeResumePoint();

                _x2._data.playbackRecordingFinishWatching( this._recordingId );

                var optCallback = function( key, overlay )
                {
                    if( key === 1 )
                    {
                        var delCallback = function()
                        {
                            self._distractor.hide();
                            _x2.popScreen();
                        };

                        _x2.popOverlay( overlay );
                        self._distractor.show();
                        self._entity.delete().then( delCallback );
                    }
                    else
                    {
                        _x2.popOverlay( overlay, function() { _x2.popScreen() } );
                    }
                };

                var optParams = {
                    title    : "Delete Recording?",
                    subTitle : "You appear to have completed watching " + self._entity.getTitle() + "; would you like to delete it?",
                    button1  : { text:"Delete Now",   key:1 },
                    button2  : { text:"Don't Delete", key:0 },
                    callback : function( key ){ optCallback( key, optOverlay ) }
                };

                var optOverlay = new TwoOptionsOverlay().init( optParams );
                _x2.pushOverlay( optOverlay );

                break;

            case VideoScreen.Mode.LIVE:
                console.error( "Should never get a media ended event for live TV." );
                break;

            case VideoScreen.Mode.VOD:
                this._resume = 0;
                this.storeResumePoint();

                _x2._data.playbackVodFinishWatching( this._paid );

                _x2.popScreen();
                break;
        }
    };

    VideoScreen.prototype.onMediaFailed = function( event )
    {
        var context, mediaError;

        if( this._timeout )
            clearTimeout( this._timeout );

        switch( this._mode )
        {
            case VideoScreen.Mode.DVR:
                context = ErrorOverlay.Context.DVR;
                break;
            case VideoScreen.Mode.LIVE:
                context = ErrorOverlay.Context.LINEAR;
                break;
            case VideoScreen.Mode.VOD:
                context = ErrorOverlay.Context.VOD;
                break;
        }

        var playerVersion = videoPlayer.getVersion();
        var code  = ErrorOverlay.getTVAPP( context, event.error.major, event.error.minor );
        var err   = (Array.isArray(code) ? code[0] : code );
        var tvapp = "TVAPP-00" + err;
        _x2._telemetry.sendVideoError( err, "NA", event.error.description, this.getTelemetryVideoType(), true ); // always user facing

        if( !this._telemetrySentVASP )
        {
            this._telemetrySentVASP = true;
            _x2._telemetry.sendVideoAttemptSuccess( false, this.getTelemetryVideoType() ); // only denominator

            var duration = videoPlayer.getDuration();
            var metrics =
            {
                "Error Domain" : "Video Playback",
                "Error Code"   : event.error.major,
                "Error Subcode": event.error.minor,
                "Display Code" : tvapp,
                "URL"          : window.location.href,
                "Resource Info": this._entity.getTitle(),
                "Resource Link": this._url
            };
//console.log( metrics );
            window.ll( "tagEvent", "Error.Playback", metrics );

            _x2._splunk.sendVideoAttempt( this._entity, this._mode, this._url, playerVersion, duration );
            _x2._splunk.sendVideoError( this._entity, tvapp, event.error.description, event.error.major, event.error.minor, this._mode, this._url, playerVersion, duration );
        }

        _x2._telemetry.setVideoType( Telemetry.VideoType.NONE ); // ACTIVE_SESSION sends this but if video is not playing we need to send "Non Player"
        var lastScreen = _x2._screenRoot.getTop();
        if( this._checkInErrorState === false && lastScreen instanceof VideoScreen ) //don't push multiple errors (race with onVideoNotStarting callback)
        {
            this._checkInErrorState = true;
            mediaError = new ApiError().init( { flash:event.error } );
            _x2.pushOverlay( new ErrorOverlay().init( { context:context, error:mediaError, entity:this._entity } ) );
        }
    };

    VideoScreen.prototype.onMediaProgress = function( current, start, stop )
    {
        var now = Date.now();
        var nextHeartbeat = this._nextHeartbeat ? this._nextHeartbeat : now;

        if( nextHeartbeat <= now )
        {
            switch( this._mode )
            {
                case VideoScreen.Mode.LIVE:
                    _x2._data.playbackLinearHeartbeat( this._streamId );
                    break;

                case VideoScreen.Mode.DVR:
                    _x2._data.playbackRecordingHeartbeat( this._recordingId );
                    break;

                case VideoScreen.Mode.VOD:
                    _x2._data.playbackVodHeartbeat( this._paid );
                    break;
            }

            this._nextHeartbeat = now + 120000; //two minutes
        }

        if( current < this._current )
        {
            // HACK: Work-around player bug getting a current position before _current when no rewind has been pressed
            if( (Date.now() - this._telemetryRewindTimestamp) < 60000 )
                _x2._telemetry.sendVideoJumpback( this.getTelemetryVideoType(), false, current > start, true, (current <= start) );
        }

        this._current = current;
        this.setTimes( current, start, stop );
    };

    VideoScreen.prototype.onPaused = function()
    {
        if( _x2._focus === this._pause )
            _x2.requestFocus( this._play );

        if( this._mode !== VideoScreen.Mode.LIVE )
        {
            this._targets[this._pp] = this._play;
            this._play.setA( 1 );
            this._pause.setA( 0 );
        }
    };

    VideoScreen.prototype.onPlay = function()
    {
        var videoType, playerVersion, latency, watchSource;

        this._distractor.hide();

        if( this._checkPlayStarted === true )
        {
            this._checkPlayStarted = false;

            videoType     = this.getTelemetryVideoType();
            playerVersion = videoPlayer.getVersion();
            latency       = Date.now() - this._videoLatencyStart; // milliseconds
            watchSource   = _x2._telemetry.getWatchButtonFullPath();

            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( ">>>>>>>>>> ON PLAY <<<<<<<<<<" ) : Config.NOP();
            _x2._config.log( Config.CLASS_TELEMETRY   , 3 ) ? console.warn( "videoType: "   + videoType    ) : Config.NOP();
            _x2._config.log( Config.CLASS_TELEMETRY   , 3 ) ? console.warn( "watchSource: " + watchSource  ) : Config.NOP();

            videoPlayer.setPcBlock( false );//if player was blocked previously and not unblock, we should unblock while playing again

            this._localyticsOnPlayStartTime = Date.now();

            console.log( "Watch Source: " + watchSource );
            if( this._entity.getChannel ) {
                console.log( "Watch source's channel no : ", + this._entity.getChannel().getNumber() )
            }
            _x2._telemetry.sendWatchButtonClicked( watchSource, videoType, playerVersion ); // NOTE: must have already called getTelemetryVideoType()
            _x2._telemetry.sendVideoLatency( latency, videoType, playerVersion );

            // Q. Do we need to gaurd against the edge case of getting an error and playing is re-tried?
            // A. Yes, since VASP is to be sent only once per streaming session
            if( !this._telemetrySentVASP  )
            {
                this._telemetrySentVASP = true;
                _x2._telemetry.sendVideoAttemptSuccess( false, videoType ); // both denominator
                _x2._telemetry.sendVideoAttemptSuccess( true , videoType ); // both numerator
            }

            _x2._telemetry.sendVideoStart( videoType, playerVersion );
            _x2._splunk.sendVideoStart( this._entity, this._mode, this._url, playerVersion, latency, videoPlayer.getDuration() );

            // XC-18060: Exception
            // If we are:
            //     * watching a currently airing program, and
            //     * recording it (i.e. it hasn't finished recording)
            // then DON'T send these metrics as they don't make sense. (The total time is not finalised.)
            var recordingDuration = this._entity.getDurationMs && this._entity.getDurationMs();
            if( recordingDuration )
            {
                recordingDuration /= 1000;
                var manifestDuration = Math.floor( videoPlayer._playerPlatform.getDuration() / 1000 );

                if( this._recordingManagerId && this._mode !== VideoScreen.Mode.LIVE && this._entity.getRecordingStatus() !== "STARTED" ) // VPAP recordings
                {
//                  console.log( "Duration: " + manifestDuration );
//                  console.log( this._entity._telemetryMetaDataDuration );

                    _x2._telemetry.sendVideoPlaybackAvailableBucket ( videoType, manifestDuration, recordingDuration, this._recordingManagerId );
                    _x2._telemetry.sendVideoPlaybackAvailablePercent( true     , manifestDuration, recordingDuration, videoType, this._recordingManagerId );
                }
                else if( this._mode === VideoScreen.Mode.VOD ) // VPAP VOD
                {
                    _x2._telemetry.sendVideoPlaybackAvailableBucket ( videoType, manifestDuration, recordingDuration, "NA" );
                    _x2._telemetry.sendVideoPlaybackAvailablePercent( true     , manifestDuration, recordingDuration, videoType, "NA" );
                }
            }

            if( this._mode === VideoScreen.Mode.LIVE )
            {
                if( this._entity.getChannel )
                {
                    var channel = this._entity.getChannel();

                    if( channel )
                        _x2._settings.setValue( Settings.Key.LAST_CHAN, { id:channel.getStationId(), num:channel.getNumber() } );
                    else
                        console.error( "No channel object found in the entity." );
                } else {
                    console.log("Last channel was not set:", this._entity.getTitle(), ' - ', this._entity._type, ' ', this._mode );
                }
            } else {
                console.log("Last entity's channel was not set:", this._entity.getTitle(), ' - ', this._entity._type, ' ', this._mode );
            }
        }

        if( _x2._focus === this._play )
            _x2.requestFocus( this._pause );

        if( this._mode !== VideoScreen.Mode.LIVE )
        {
            this._targets[this._pp] = this._pause;
            this._rew.setA( 1 );
            this._ff.setA( 1 );
            this._pause.setA( 1 );
            this._play.setA( 0 );
        }
        else
        {
            this._rew.setA( 0 );
            this._play.setA( 0 );
            this._pause.setA( 0 );
            this._ff.setA( 0 );
        }
    };

    VideoScreen.prototype.onPlaybackSpeedChanged = function( speed )
    {
        _x2._config.log( Config.CLASS_VIDEO_SCREEN, 7 ) ? console.log( "PLAY RATE = " + speed ) : Config.NOP();
        this._playRate.setText( "Play Rate = " + speed );
    };

    VideoScreen.prototype.patchUrl = function( url, mode )
    {
        var retval, parts;
        var newUrl   = url;
        var resolver = function( resolve )
        {
            resolve( newUrl );
        };

        console.log( "=================================================================================================" );
        console.log( "=================================================================================================" );
        console.log( url );

        if( url.indexOf( ".m3u8" ) !== -1 )
        {
            console.log( "Converting HLS to DASH, mode = " + mode );

            newUrl = url.replace( /.m3u8/g, ".mpd" );

            console.log( newUrl );

            newUrl = _x2._config._testVideo ? _x2._config._testVideo : newUrl;

            this._recordingManagerId = undefined;

            if( mode === VideoScreen.Mode.DVR )
            {
                console.log( "SWAPPING CDVR HOST" );

                parts             = newUrl.match( /.*\/recording\/(.*)\/.*/ );  // HACK: extract the recording ID
                this._recordingId = parts[1];

                var id = newUrl === undefined ? "NA" : newUrl.split("recorderManager=")[1];
                var n  = id.indexOf( '&' );
                if( n >= 0 )
                    id = id.substr( 0, n );

                this._recordingManagerId = id;

                if( _x2._config._host.getType() === Host.Type.PC || _x2._config._host.getType() === Host.Type.ANDROID )
                {
                    newUrl = _x2._config._testVideo ? _x2._config._testVideo : "http://assets.player.xcal.tv/super8sapcc/index.mpd";
                    retval = new Promise( resolver );
                }
                else
//                    retval = new Promise( resolver );
                    retval = _x2._data.getRecordingRedirect( parts[1] );
            }
            else if( mode === VideoScreen.Mode.LIVE )
            {
                console.log( "SWAPPING LINEAR HOST" );

                if( _x2._config._host.getType() === Host.Type.PC || _x2._config._host.getType() === Host.Type.ANDROID )
                    newUrl = _x2._config._testVideo ? _x2._config._testVideo : "http://assets.player.xcal.tv/super8sapcc/index.mpd";  // Ides of March - SAP CC
//                    newUrl = "http://rdmedia.bbc.co.uk/dash/ondemand/bbb/2/client_manifest-common_init.mpd";

//newUrl = "http://assets.player.xcal.tv/super8sapcc/index.mpd";  // Ides of March - SAP CC
//newUrl = "https://ccr.linear-cent-co-pil-red.xcr.comcast.net/NBCSH_HD_CENTdCO_15201_0_7619126265308348163.mpd?redirect=true";

                retval = new Promise( resolver );
            }
            else if( mode === VideoScreen.Mode.VOD )
            {
                console.log( "SWAPPING VOD HOST" );

//                newUrl = newUrl.replace( /http:/g, "https:" );

                if( _x2._config._host.getType() === Host.Type.PC || _x2._config._host.getType() === Host.Type.ANDROID )
                    newUrl = _x2._config._testVideo ? _x2._config._testVideo : "http://assets.player.xcal.tv/super8sapcc/index.mpd";  // Ides of March - SAP CC
//                    newUrl = "http://rdmedia.bbc.co.uk/dash/ondemand/bbb/2/client_manifest-common_init.mpd";

//newUrl = "http://69.252.103.216/cog_backup/html/dash/c2/1371826319012/1371826319012.mpd";
//newUrl = "http://69.252.103.207/CNN_HD.mpd";
//newUrl = "http://assets.player.xcal.tv/super8sapcc/index.mpd";  // Ides of March - SAP CC

                retval = new Promise( resolver );
            }
        }

        return retval;
    };

    VideoScreen.prototype.play = function( params )
    {
        console.log( params );

        if( this._lastWatched.containsWidget( _x2._focus ) === true )
        {
            this._lastWatched.hide();
            _x2.requestFocus( this );
        }

        this._lastWatched.addEntry( params );

        this._progress      = undefined;
        this._mediaId       = params.mediaId;
        this._programId     = params.programId;
        this._hasDvs        = params.hasDvs;
        this._streamId      = params.streamId;
        this._assetId       = params.assetId;
        this._providerId    = params.providerId;
        this._mediaGuid     = params.mediaGuid;
        this._entity        = params.entity;
        this._paid          = params.paid;
        this._recordingId   = params.recordingId;
        this._url           = params.url;
        this._mode          = params.mode;
        this._initResume    = params.resume;

        if( params && params.url )
        {
            var channel = this._entity.getChannel && this._entity.getChannel(), complement, self = this;
            var pref    = _x2._settings.getValue( Settings.Key.FORMAT );

            if( pref === "hd" && channel && channel.isHD() === false && (complement = channel.getHdComplement()) )
            {
                params.url     = complement.getStreamUrl();
                this._streamId = complement.getStreamId();

                if( this._entity.setChannel )
                    this._entity.setChannel( complement );
            }

            this._attempts = 1;
            this.patchUrl( params.url, params.mode ).then( function( url ) { self.onGotUrl( url, params.resume ); }, this._onUrlError );
        }

        this.setData( params.entity );

        if( this._mode !== VideoScreen.Mode.LIVE )
        {
            this._targets = [ this._last, this._rew, this._pause, this._ff, this._dv, this._sap, this._cc ];
            this._index   = this._pp = 2;

            if( this._mini )
                this._targets.splice( 4, 0, this._mini );
        }
        else
        {
            this._targets = [ this._last, this._dv, this._sap, this._cc ];
            this._index   = this._pp = 1;
            this._pause.setA( 0 );
            this._play.setA( 0 );
            this._ff.setA( 0 );
            this._rew.setA( 0 );

            if( this._mini )
                this._targets.splice( 1, 0, this._mini );
        }
    };

    VideoScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( this._easLocked !== true )
        {
            if( type === Host.KEY_PRESSED )
            {
                this._touch = true;

                if( this._showing === false && val !== Host.KEY_LAST && val !== Host.KEY_UP )
                {
                    this._showing = true;
                    this._container.stopAnimation( Widget.Axis.A );
                    this._container.animate( { a:1, duration:500 } );
                }
            }

            switch( val )
            {
                case Host.KEY_DOWN:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( this._showing === false )
                        {
                            this._showing = true;
                            this._container.stopAnimation( Widget.Axis.A );
                            this._container.animate( { a:1, duration:500 } );

                            if( _x2._focus === this._cursor )
                                _x2.requestFocus( this._targets[this._index] );
                        }
                        else
                             _x2.requestFocus( this._targets[this._index] );
                    }
                    break;

                case Host.KEY_ENTER:
                    if( type === Host.KEY_PRESSED )
                        this.togglePlayPause();
                    break;

                case Host.KEY_FF:
                    if( type === Host.KEY_PRESSED )
                        this.fastForwardIncrease();
                    break;

                case Host.KEY_LAST:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( this._showing === true )
                        {
                            this._showing = false;
    //                        this.stopAnimation( Widget.Axis.A );
                            this._container.stopAnimation( Widget.ALPHA );
                            this._container.animate( { a:0, duration:500 } );
                            this.storeResumePoint();
                        }
                        else
                        {
                            this.storeResumePoint();
                            retval = Screen.prototype.processEvent.call( this, val, type );
                        }
                    }
                    break;

                case Host.KEY_LEFT:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( _x2._focus === this._cursor )
                            this.rewindIncrease();
                        else if( this._index > 0 )
                             _x2.requestFocus( this._targets[--this._index] );
                    }
                    break;

                case Host.KEY_MUTE:
                    if( type === Host.KEY_PRESSED )
                        videoPlayer.mute();
                    break;

                case Host.KEY_PAUSE:
                case Host.KEY_PLAY:
                    if( type === Host.KEY_PRESSED )
                        this.togglePlayPause();
                    break;

                case Host.KEY_RIGHT:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( _x2._focus === this._cursor )
                            this.fastForwardIncrease();
                        else if( this._index < this._targets.length - 1 )
                            _x2.requestFocus( this._targets[++this._index] );
                    }
                    break;

                case Host.KEY_RW:
                    if( type === Host.KEY_PRESSED )
                    {
                        this._telemetryRewindTimestamp = Date.now(); // VIDEO_JUMPBACK
                        this.rewindIncrease();
                    }
                    break;

                case Host.KEY_SOFT_D:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( this._bitRate.getA() === 0 )
                        {
                            this._bitRate.setA( 1 );
                            this._playRate.setA( 1 );
                        }
                        else
                        {
                            this._bitRate.setA( 0 );
                            this._playRate.setA( 0 );
                        }
                    }
                    break;

                case Host.KEY_UP:
                    if( type === Host.KEY_PRESSED )
                    {
                        if( this._showing === true )
                        {
                            if( _x2._focus === this._cursor )
                            {
                                this._showing = false;
                                this._touch   = false;
                                this._container.stopAnimation( Widget.Axis.A );
                                this._container.animate( { a:0, duration:500 } );
                            }
                            else
                            {
                                _x2.requestFocus( this._cursor );
                            }
                        }
                        else
                        {
                            this._showing = true;
                            this._container.stopAnimation( Widget.Axis.A );
                            this._container.animate( { a:1, duration:500 } );
                        }
                    }
                    break;

                case Host.KEY_VOL_DOWN:
                    if( type === Host.KEY_PRESSED )
                        videoPlayer.volumeDown();
                    break;

                case Host.KEY_VOL_UP:
                    if( type === Host.KEY_PRESSED )
                        videoPlayer.volumeUp();
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }
        }

        return retval;
    };

    VideoScreen.prototype.rewindIncrease = function()
    {
        if( this._speedIndex > 0 && this._mode !== VideoScreen.Mode.LIVE )
        {
            this._speedIndex--;

            _x2._config.log( Config.CLASS_VIDEO_SCREEN, 5 ) ? console.log( "REWIND INCREASE -> " + this._speedIndex + ", " + this._speeds[this._speedIndex] + ", " + this._speedModes[this._speedIndex] ) : Config.NOP();

            if( this._speedModes[this._speedIndex] === VideoScreen.SpeedMode.STATIC )
            {
                if( this._scrubBase === undefined )
                    this._scrubBase = videoPlayer.getCurrentPosition();

                if( this._speedIndex === this._speeds.indexOf( 1 ) )
                {
                    videoPlayer.setSpeed( 1 );
                    videoPlayer.setPosition( this._scrubBase );
                    this._telemetryRewindTimestamp = 0;
                    videoPlayer.play();
                    this._scrubBase = undefined;
                }
                else
                    videoPlayer.pause();
            }
            else
                videoPlayer.setSpeed( this._speeds[this._speedIndex] );

            this.setIndicator();
            this.speakSpeed();
        }
    };

    VideoScreen.prototype.sendVideoPlayedLocalytics = function()
    {
        var type, programType  = "", program = this._entity.getProgram && this._entity.getProgram(), rating, csmr, seconds, minutes, percent;

        switch( this._mode )
        {
            case VideoScreen.Mode.DVR : type = "DVR"      ; break; // VOD can't be recorded, can only record T6 Linear
            case VideoScreen.Mode.LIVE: type = "Live"     ; break;
            case VideoScreen.Mode.VOD : type = "On-Demand"; break; // On-Demand, Purchase, Rental
        }

        if( this._entity instanceof Purchase )
            type = "Purchase";
        else if( this._entity instanceof Rental )
            type = "Rental";

        switch( this._entity.getType() )
        {
//          case "???"         : programType = "Sports Event"; break;
            case "TVListing"   : programType = "TV Episode"  ; break; // Browse > Sports > PGA Tour
            case "Episode"     : programType = "TV Episode"  ; break;
            case "Movie"       : programType = "Movie"       ; break;
            case "SeriesMaster": programType = "TV Series"   ; break;
            case "Other"       : programType = "unknown"     ; break; // Browse > Black Film & TV, HCBU Experience, Music Playlists
            default            : programType = "unknown"     ; break;
        }

        var reviews      = this._entity.getReviews && this._entity.getReviews();
        var now          = Date.now();
        var channel      = (this._entity.getChannel && this._entity.getChannel());
        var metrics      =
        {
            "Captions Utilized"             : _x2._settings.getValue( Settings.Key.CC_ENABLED ) ? "Yes" : "No",
            "Common Sense Media Rating"     : "NA",
            "Downloaded"                    : "No",
            "Entity"                        : this._entity.getEntityId(),
            "Is HD"                         : this._entity.isHD && this._entity.isHD() ? "Yes" : "No",
            "Name"                          : this._entity.getTitle(),
            "Picture in Picture"            : "No",
            "Program Type"                  : programType,
            "Rights Type"                   : "T6", // Alt.: this._entity.getChannel().isTve()
            "Rotten Tomatoes Critics Score" : "NA",
            "Rotten Tomatoes Audience Score": "NA",
            "SAP Audio Utilized"            : _x2._settings.getValue( Settings.Key.SAP_ENABLED ) ? "Yes" : "No",
            "Type"                          : type
        };
        var duration = this._entity.getDurationMs && this._entity.getDurationMs();

        if( duration )
        {
            duration /= 1000;
            seconds   = (duration % 60);
            minutes   = (duration / 60) | 0;

            metrics["Duration (secs)"] = ( seconds < 0 )? 0 : seconds;
            metrics["Duration (mins)"] = ( minutes < 0 )? 0 : minutes;

            if( this._mode !== VideoScreen.Mode.LIVE )
            {
                percent   = (100 * this._localyticsViewedPercent) | 0;
                duration *= this._localyticsViewedPercent;
                duration |= 0;
                seconds   = (duration % 60);
                minutes   = (duration / 60) | 0;

                metrics["Viewed %"     ] = ( percent < 0 )? 0 : percent;
                metrics["Viewed (secs)"] =  ( seconds < 0 )? 0 : seconds;
                metrics["Viewed (mins)"] = ( minutes < 0 )? 0 : minutes;
            }
        }

        if( program )
        {
            csmr   = program.getCommonSenseMediaReview && program.getCommonSenseMediaReview();
            rating = csmr && csmr.getCommonSenseMediaScore();
            if( rating  )
                metrics[ "Common Sense Media Rating" ] = rating;

            if( !reviews )
                reviews = program.getReviews && program.getReviews();

            var season  = program.getSeasonNumber  && program.getSeasonNumber();
            var episode = program.getEpisodeNumber && program.getEpisodeNumber();

            if( season )
                metrics["Season" ] = season;
            if( episode )
                metrics["Episode"] = episode;
        }

        if( reviews && Array.isArray(reviews) && (reviews.length > 0) )
        {
            rating = reviews[0].getCommonSenseMediaScore && reviews[0].getCommonSenseMediaScore(); if( rating ) metrics["Common Sense Media Rating"     ] = "" + rating;
            rating = reviews[0].getCriticSummaryRotten   && reviews[0].getCriticSummaryScore()   ; if( rating ) metrics["Rotten Tomatoes Critics Score" ] = "" + rating;
            rating = reviews[0].getFanSummaryRotten      && reviews[0].getFanSummaryScore()      ; if( rating ) metrics["Rotten Tomatoes Audience Score"] = "" + rating;
        }

        if( this._mode === VideoScreen.Mode.DVR || this._mode === VideoScreen.Mode.LIVE ) // Linear or Recordings (Always Linear)
        {
            if( channel )
            {
                metrics.Station           = channel.getCallSign();
                metrics["Linear Company"] = channel.getCompany() ? channel.getCompany() : ""; // Recording: UEFA Champions League Soccer - Juventus @ Red Devils
            }
        }
        else if( this._mode === VideoScreen.Mode.VOD ) // On-Demand, Purchase, Rental
        {
            if( this._entity.getContentProvider )
                metrics.Provider = this._entity.getContentProvider().getName();
        }

        if( this._localyticsVideoPlayedEntity !== this._entity )
        {
            this._localyticsVideoPlayedEntity = this._entity;
console.log( "Localytics: Video Played: ", metrics.Name );
            window.ll( "tagEvent", "Video Played", metrics ); // Localytics
        }

        this._localyticsOnPlayStartTime = now;
    };

    VideoScreen.prototype.setData = function( showing )
    {
        var titleString, episodeTitle, seriesTitle, series, subTitle = "";
        var isEpisode = showing.getType && showing.getType() === XtvApi.EntityType.EPISODE;
        var program   = showing.getProgram ? showing.getProgram() : showing; //TODO: not sure about this, I think this should be an entity always
        var metrics   =
        {
            "Entity"                 : this._entity.getEntityId(),
            "Episode"                : "NA",
            "Name"                   : this._entity.getTitle(),
            "Program Type"           : this._entity.getType(),
            "Season"                 : "NA",
            "To FF Restricted"       : this._mode === VideoScreen.Mode.LIVE ? "NA" : "No",
            "To HD"                  : showing && showing.isHD && showing.isHD() ? "Yes" : "No",
            "To Rights Type"         : "T6", // VOD can't be recorded, can only record T6 Linear
            "To Video Type"          : "NA",
            "Translated Resume Point": "NA"
        };

        this._subTitleSpeak = undefined;

        if( isEpisode === true )
        {
            metrics["Program Type"] = "Series"; // Re-map "Episode" -> "Series"

            if( showing.getSeries )
                series = showing.getSeries();

            if( series === undefined && ( program && program.getSeries ) )
                series = program.getSeries();

            if( series )
                seriesTitle = series.getTitle();

            episodeTitle = showing.getTitle();

            if( seriesTitle && episodeTitle )
            {
                var s  = program.getSeasonNumber();
                var ep = program.getEpisodeNumber();

                titleString = seriesTitle;

                if( s && ep )
                {
                    var epTitle = (seriesTitle !== episodeTitle) ? " - " + episodeTitle : "";
                    subTitle = "S" + s + " Ep" + ep + epTitle;
                    this._subTitleSpeak = "Season " + s + ". Episode " + ep + ". " + epTitle + ". ";

                    metrics["Season" ] = s;
                    metrics["Episode"] = ep;
                }
                else if( seriesTitle !== episodeTitle )
                {
                    subTitle = episodeTitle;
                    this._subTitleSpeak = episodeTitle;
                }
            }
            else
                titleString = showing.getTitle();
        }
        else
        {
            titleString = showing.getTitle();
            if( metrics["Program Type"] !== "Movie" )
                metrics["Program Type"] = "Other";
            else
            {
                // Movie: showing can be ProgramEntity (VOD) or LinearShowing (Linear)
                var i, showings = showing.getVodShowings && showing.getVodShowings();

                if( showings && !showing.isHD )
                {
                    for( i = 0; i < showings.length; i++ )
                    {
                        if( showings[ i ].getMediaId() === this._mediaId )
                        {
                            metrics["To HD"] = showings[ i ].isHD() ? "Yes" : "No";
                            break;
                        }
                    }
                }
            }
        }

        this._title.setText( titleString );
        this._subTitle.setText( subTitle );
        this._type.setText( typeStr[this._mode] );
        this._image.setUrl( showing.getImageLink( rawImW, rawImH ) );

        switch( this._mode )
        {
            case VideoScreen.Mode.DVR : metrics["To Video Type"] = "DVR"      ; break;
            case VideoScreen.Mode.LIVE: metrics["To Video Type"] = "Linear"   ; break;
            case VideoScreen.Mode.VOD : metrics["To Video Type"] = "VOD"      ; break;
        }

        if( showing instanceof Purchase )
            metrics["To Video Type"] = "Purchase";
        else if( showing instanceof Rental )
            metrics["To Video Type"] = "Rental";

//console.log( "Best Option Chosen: %o", metrics );
        window.ll( "tagEvent", "Best Option Chosen", metrics );
    };

    VideoScreen.prototype.setIndicator = function()
    {
        var which = this._indicators[this._lastIndicator];

        if( which )
            which.setA( 0 );

        this._lastIndicator = this._speedIndex;
        which               = this._indicators[this._speedIndex];

        if( which )
            which.setA( 1 );
    };

    VideoScreen.prototype.setTimes = function( current, start, stop )
    {
        switch( this._mode )
        {
            case VideoScreen.Mode.LIVE:
                var time = _x2._time;

                if( this._start === undefined || time > (this._start + 5400000) )
                {
                    this._start = Math.floor( time / 1800000 ) * 1800000;
                    this._currStr.setText( createClockTimeStr( this._start ) );

                    this._stop = this._start + 5400000;
                    this._stopStr.setText( createClockTimeStr( this._stop ) );
                }

                this._cursor.setX( this._startX + this._cursorOffsetX + (time - this._start) / (this._stop - this._start) * this._progressW );
                break;

            case VideoScreen.Mode.DVR:
            case VideoScreen.Mode.VOD:
                if( this._entity instanceof Recording && this._entity.getRecordingStatus() === "STARTED" )
                {
                    this._progress = stop;
                    stop           = this._entity.getDurationMs();
                    this._leftRect.setW( this._progress / stop * (this._stopX - this._startX) );
                }

                var fract  = current / (stop - start);
                var offset = fract * this._progressW;

                this._localyticsViewedPercent = (fract < 0) ? 0 : fract;
                this._currStr.setText( this.createTimeStr( current !== undefined ? current : 0 ) );

                if( this._start !== start )
                    this._start = start;

                if( this._stop !== stop )
                {
                    this._stop = stop;
                    this._stopStr.setText( this.createTimeStr( stop ) );
                }

                this._cursor.setX( this._startX + this._cursorOffsetX + offset );
                break;

            default:
                console.error( "ERROR => unknown mode = " + this._mode );
                break;
        }
    };

    VideoScreen.prototype.showDistractor = function( isStatic )
    {
        this._netIconImage.setA(0);
        this._distractor.show( isStatic );
    };

    VideoScreen.prototype.showLastWatched = function()
    {
        console.log( "LAST" );

        this._lastWatched.show();
        _x2.requestFocus( this._lastWatched );
    };

    VideoScreen.prototype.speak = function( silent )
    {
        var channel, str = "", title = this._title.getText();

        if( this._entity.getChannel )
        {
            channel = this._entity.getChannel();

            if( channel )
                str = "Channel " + channel.getNumber() + ". ";
            else
                console.error( "No channel object found in the entity." );
        }

        if( title )
            str += title + ". ";

        if( this._subTitleSpeak )
            str += this._subTitleSpeak;

        this._speakTarget.setText( "Now Playing. " + str + ". " );

        if( silent !== true )
            this._speakTarget.setSpeechParams( "Press down to review options. Loading, please wait. ", undefined, this, false );

        return this._speakTarget.getText();
    };

    VideoScreen.prototype.speakSpeed = function()
    {
        var str, val = this._speedIndex - this._speeds.indexOf( 1 );

        if( val > 0 )
            str = "Fast Forward " + val + ". ";
        else if( val < 0 )
            str = "Rewind " + (-1 * val) + ". ";
        else
            str = "Play. ";

        this._speakTarget.setText( str );
        this._speakTarget.setSpeechParams( undefined, undefined, this, false );
    };

    VideoScreen.prototype.storeResumePoint = function()
    {
        if( this._mode === VideoScreen.Mode.VOD || this._mode === VideoScreen.Mode.DVR )
        {
            var resume = (this._resume !== undefined) ? this._resume : this._current;
            if( resume !== undefined ) {
                _x2.setResumePointInCache( this._mediaId, resume );
                _x2._data.setResumePoint( this._mediaId, this._programId, resume );
            }
        }
    };

    VideoScreen.prototype.tick = function()
    {
        var self = this;

        console.log( "VIDEO SCREEN TICK, isLinear = " + (this._mode === VideoScreen.Mode.LIVE) + ', ticked at ', new Date() );
        var lastScreen = _x2._screenRoot.getTop();
        if( this._mode === VideoScreen.Mode.LIVE && lastScreen instanceof VideoScreen  )
        {
            var displayCurrentlyAiring = function( showing )
            {
                if( self._entity.getProgramId() !== showing.getProgramId() || 
                    self._entity.getStartTime() !== showing.getStartTime() )
                {
                    self.sendVideoPlayedLocalytics();
                    console.log("Last entity - ", self._entity.getTitle(), 
                                ", duration -", new Date( self._entity.getStartTime() ) ,' : ' , new Date( self._entity.getEndTime() ) );
                    self._entity = showing;
                    console.log( "NEW ENTITY NEW ENTITY NEW ENTITY" );
                    console.log("New entity - ", self._entity.getTitle(), 
                                ", duration -", new Date( self._entity.getStartTime() ) ,' : ' , new Date( self._entity.getEndTime() ) );
                    
                    self.setData( showing );
//                    self.layout();

                    var onLockCheck = function( isLocked )
                    {
                        console.log( "LOCKED = " + isLocked );

                        if( isLocked )
                        {
                            videoPlayer.setPcBlock( true );

                            var onUnlockChannel = function()
                            {
                                console.log( "START SHOWING VIDEO" );
                                videoPlayer.setPcBlock( false );
                            };

                            _x2.checkParentalControls( showing, showing.getProgram(), showing._channel, false, self.speak() ).then( onUnlockChannel, onLockCheckFailed );
                        }
                        else
                            self.speak();
                    };

                    var onLockCheckFailed = function( error )
                    {
                        console.error( error );
                    };

                    _x2.checkParentalControls( showing, showing.getProgram(), showing._channel, true ).then( onLockCheck, onLockCheckFailed );
                }
                else
                    console.log( "NO CHANGE NO CHANGE" );
            };

            var currentlyAiringLookupFailed = function( error )
            {
                console.error( error );
            };

            if( this._entity.getChannel )
            {
                var channel = this._entity.getChannel();

                if( channel ) {
                    var currentPlaying = channel._onNow;
                    var canFetchNextProgram = false;
                    if( !currentPlaying ) {
                        canFetchNextProgram =  Date.now() >= this._entity.getEndTime();
                        console.log("Currently playing entity - ", this._entity.getTitle(),
                        ", end at", new Date(this._entity.getEndTime()) );
                    } else {
                        canFetchNextProgram = (this._entity.getProgramId() !== currentPlaying.getProgramId() ||
                            this._entity.getStartTime() !== currentPlaying.getStartTime());
                        console.log("Currently playing entity - ", currentPlaying.getTitle(), 
                            ", end at", new Date(currentPlaying.getEndTime()) );
                    }
                    // Fetch get airing, if the current program get ends within time or program id got changed.
                    if (canFetchNextProgram) {
                        channel.getCurrentlyAiring().then( displayCurrentlyAiring ).catch( currentlyAiringLookupFailed );
                    } else {
                        console.log("No change in currently playing program");
                    }
                }
                else
                    currentlyAiringLookupFailed( "No channel object found in the entity." );
            }
        }
    };

    VideoScreen.prototype.toggleCaptions = function()
    {
        this._touch = true;

        if( _x2._settings.getValue( Settings.Key.CC_ENABLED ) === true )
        {
            this.createLabelStr( "cc", "Off", true );
            _x2._settings.setValue( Settings.Key.CC_ENABLED, false );
            videoPlayer.setCaptionsEnabled( false );
        }
        else
        {
            this.createLabelStr( "cc", "On", true );
            _x2._settings.setValue( Settings.Key.CC_ENABLED, true );
            videoPlayer.setCaptionsEnabled( true );
        }
    };

    VideoScreen.prototype.toggleDv = function()
    {
        this._touch = true;

        var langs     = videoPlayer.getLanguages();
        var available = langs.length > 1 && this._hasDvs;

console.log( langs );
console.log( "=> HAS DVS = " + this._hasDvs );

        if( _x2._settings.getValue( Settings.Key.DV_ENABLED ) === true )
        {
            this.createLabelStr( "dv", available === true ? "Off" : "Not Available", true );
            _x2._settings.setValue( Settings.Key.DV_ENABLED, false );

            if( available === true )
            {
                console.log( ">>>>>>>>>>>>>>>>>>>> SET LANGUAGE TO 'en'" );
                videoPlayer.setLanguage( "en" );
            }
        }
        else
        {
            this.createLabelStr( "dv", available === true ? "On" : "Not Available", true );
            _x2._settings.setValue( Settings.Key.DV_ENABLED, true );

            if( available === true )
            {
                console.log( ">>>>>>>>>>>>>>>>>>>> SET LANGUAGE TO 'es'" );
                videoPlayer.setLanguage( "es" );  // HACK since always coming through as Spanish at this point
            }
        }
    };

    VideoScreen.prototype.togglePlayPause = function()
    {
        if( this._mode !== VideoScreen.Mode.LIVE )
        {
            var state = videoPlayer.getState();

            if( state === VideoScreen.State.PAUSED )
            {
                if( this._scrubBase !== undefined )
                {
                    this._speedIndex = this._speeds.indexOf( 1 );
                    videoPlayer.setSpeed( 1 );
                    videoPlayer.setPosition( this._scrubBase );
                    this._scrubBase = undefined;
                }

                this._telemetryRewindTimestamp = 0;
                videoPlayer.play();
            }
            else if( state === VideoScreen.State.PLAY )
            {
                if( videoPlayer.getPlaySpeed() !== 1 )
                {
                    this._speedIndex = this._speeds.indexOf( 1 );
                    videoPlayer.setSpeed( 1 );
                }
                else
                    videoPlayer.pause();
            }

            this.setIndicator();
        }
    };

    VideoScreen.prototype.toggleSap = function()
    {
        this._touch = true;

        var langs = videoPlayer.getLanguages();

console.log( langs );
console.log( _x2._settings.getValue( Settings.Key.DV_ENABLED ) + "  " + _x2._settings.getValue( Settings.Key.SAP_ENABLED ) + " " + this._hasDvs );

        if( _x2._settings.getValue( Settings.Key.SAP_ENABLED ) === true )
        {
            this.createLabelStr( "sap", "Off", true );
            _x2._settings.setValue( Settings.Key.SAP_ENABLED, false );

            if( this._hasDvs === false )
            {
                console.log( ">>>>>>>>>>>>>>>>>>>> SET LANGUAGE TO en" );
                videoPlayer.setLanguage( "en" );
            }
        }
        else
        {
            this.createLabelStr( "sap", "On", true );
            _x2._settings.setValue( Settings.Key.SAP_ENABLED, true );

            if( this._hasDvs === false )
            {
                console.log( ">>>>>>>>>>>>>>>>>>>> SET LANGUAGE TO " + _x2._settings.getValue( Settings.Key.SAP_LANG ) );
                videoPlayer.setLanguage( _x2._settings.getValue( Settings.Key.SAP_LANG ) );
            }
        }
    };

    VideoScreen.prototype.update = function( step, alphaParent )
    {
        Screen.prototype.update.call( this, step, alphaParent );

        if( this._scrubBase !== undefined )
        {
            var stop = this._progress === undefined ? this._stop : this._progress;

            this._touch      = true;
            this._scrubBase += (step - this._lastStep) * this._speeds[this._speedIndex];

            if( this._scrubBase <= this._start )
            {
                this._scrubBase = this._start;
                this.onMediaProgress( this._scrubBase, this._start, stop );
                this.togglePlayPause();
            }
            else if( this._speeds[this._speedIndex] > 0 && this._scrubBase > (stop - 15000) )
            {
                this._scrubBase = stop - 15000;
                this.onMediaProgress( this._scrubBase, this._start, stop );
                this.togglePlayPause();
            }
            else
                this.onMediaProgress( this._scrubBase, this._start, stop );
        }

        this._lastStep = step;

        if( this._touch === true )
        {
            this._touch     = false;
            this._lastTouch = step;
        }

        if( this._showing === true && step > this._lastTouch + 5000 )
        {
            this._showing = false;
            this._container.stopAnimation( Widget.Axis.A );
            this._container.animate( { a:0, duration:500 } );

            if( this.containsWidget( _x2._focus ) === true && this._lastWatched.containsWidget( _x2._focus ) === false )
                _x2.requestFocus( this._cursor );
        }
    };

    return VideoScreen;

})();


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodBranchScreen = (function()
{
    "use strict";

    VodBranchScreen.prototype = new Screen();

    function VodBranchScreen(){}

    VodBranchScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._gallery, true );

        if( focus )
        {
            this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press up or down to review categories. ", focus._speakRole, this, false );
        }
        else
        {
            this._speakTarget.setText( this.getBreadCrumb() );
            this._speakTarget.setSpeechParams( "Press up or down to review categories. Loading. ", undefined, this, false );
        }
    };

    /**
     * @memberof VodBranchScreen
     * @param {BrowseCollection} folder
     * @param {String          } path
     * @returns {VodBranchScreen}
     */
    VodBranchScreen.prototype.init = function( folder, path )
    {
        Screen.prototype.init.call( this );
        this._className     = "VodBranchScreen";
        this._telemetryName = "Vod Branch";

        this._gallery = new VodBrowseWidget().init( folder );
        this.addWidget( this._gallery, 0, _x2.scaleValInt( 120 ) );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        this._gallery.activate();

        this.setBreadCrumbs( path, folder.getTitle() );

        return this;
    };

    return VodBranchScreen;

})();


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.EntityScreen = (function()
{
    "use strict";

    EntityScreen.prototype = new Screen();

    function EntityScreen(){}

    /**
     * @param {Object} params
     * @param {BrowseEntity, SearchEntity, Recording, Entity, Purchase} params.entity
     * @param {BrowseEntity} [params.molt]
     */
    EntityScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this );
        this._className     = "EntityScreen";
        this._telemetryName = "Entity Info";

        var self   = this;
        var entity = this._entity = params.entity;
        this._molt = params.molt;

        var y = _x2.scaleValInt( 42 ); // XC-13188 // NOTE: Can't use 'y = {Screen.}getHeaderBottom()' due to _time.getH() returning undefined -> NaN

        var yOffsets = [ y, _x2.scaleValInt( y+285 ), _x2.scaleValInt( y+449 ), _x2.scaleValInt( y+461 )]; // [3] = 560 was used for???
        var xOffsets = [_x2.scaleValInt( 355 )];
        var maxW     = _x2._config._screenW - Style._safeLeft - Style._safeRight;

        var scrollW = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var scrollH = _x2._config._screenH;

        var onRefresh = function( updatedEntity )
        {
            if( updatedEntity )
                self._entityDetail.setData( updatedEntity );

            if( entity._changeCallback )
                entity._changeCallback();
        };

        this._yOffsets      = yOffsets;
        this._entityTitle   = (entity.getSeriesTitle && entity.getSeriesTitle()) ? entity.getSeriesTitle() : entity.getTitle();

        this._entityDetail  = new EntityInfoWidget().init();
        this._moltWidget    = new GalleryRowWidget().init( { w: maxW, sep: false } );
        this._scrollWidget  = new Widget().init();
        this._actionButtons = new EntityActionButtonsWidget().init( undefined, scrollW - xOffsets[0] );
        this._moltRectSep   = new RectWidget().init( { w:_x2._config._screenW - Style._safeLeft - Style._safeRight, h:ListRowWidget.DIVIDER_H, color:"#303030" } );

        this._actionButtons.setRefreshListener( onRefresh );

        this._scrollWidget.addWidget( this._entityDetail ,           0,0 );
        this._scrollWidget.addWidget( this._actionButtons, xOffsets[0], yOffsets[1] );
        this._scrollWidget.addWidget( this._moltRectSep  ,           0, yOffsets[2] );
        this._scrollWidget.addWidget( this._moltWidget   ,           0, yOffsets[3] );

        this._scrollPane = new ScrollWidget().init( { widget: this._scrollWidget, w: scrollW, h: scrollH } );
        this.addWidget( this._scrollPane, Style._safeLeft, yOffsets[0] );

        this._entityDetail.setW( maxW );
        this._entityDetail.setH( _x2._config._screenH - Style._safeBottom - yOffsets[0] );

        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function() { self._distractor.centerOnWidget( self ); } );
        this.addWidget( this._distractor );

        this.setBreadCrumbs( undefined, this._entityTitle );

        window.ll( "tagScreen", "Entity Info" ); // TODO: Which one? Docs say "Entity Info" but XTV has "Entity " + entity name
        _x2._telemetry.sendScreenViewed( this._telemetryName );

        this.addReadyCallback( function(){ self.layout(); } );

        return this;
    };

    EntityScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();

        if( this._popScreen === true )
            _x2.popScreen( self );
        else if( this._actionButtonsReady )
            this.speak( _x2.requestFocus( this._actionButtons ) );
        else
            this.speak();
    };

    EntityScreen.prototype.layout = function()
    {
        var self = this;
        var dy   = this.getHeaderBottom();
        var i    = 0, n = this._yOffsets.length;

        for( ; i < n; i++ )
            this._yOffsets[i] += dy;

        this._scrollPane   .setY( this._yOffsets[0] );
        this._actionButtons.setY( this._yOffsets[1] );
        this._moltRectSep  .setY( this._yOffsets[2] );
        this._moltWidget   .setY( this._yOffsets[3] );

        // HACK: put in a delay before setting the data to fix a problem with LG2017 speech engine

        setTimeout( function() { self.setData(); }, 200 );
    };

    EntityScreen.prototype.processEvent = function( val, type )
    {
        var retval, self = this;

        switch( val )
        {
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._moltWidget.containsWidget( _x2._focus )  )
                    {
                        this._scrollPane.setScroll( { y: 0, duration: 300 } );
                        _x2.requestFocus( this._actionButtons );
                    }
                }
                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    if( this._molt && this._molt.length && this._moltWidget.containsWidget( _x2._focus ) === false )
                        this._scrollPane.setScroll( { y:-this._yOffsets[3] - _x2.scaleValInt( 50 ), duration: 300, onEnd: function(){ _x2.requestFocus( self._moltWidget ) } } ); // HACK: +50 because CollectionRowWidget top offset
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    EntityScreen.prototype.setData = function()
    {
        var self   = this;
        var entity = this._entity;

        /**
         * Push an error overaly on failure.
         * @param error
         */
        var fail = function( error )
        {
            self._popScreen = true;
            self._distractor.hide();

            if( self._alerted !== true ) // don't push multiple overlays if there is more than one error.
            {
                self._alerted = true;
                _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.ENTITY } ) );
            }
        };

        /**
         * Callback when entity options loaded
         */
        var onEntityOptionsLoaded = function()
        {
            self._distractor.hide();
            self._entityDetail.setData( self._entity ); //call setData on EntityInfoWidget again to fill in add'l (i.e. recording) data
            self._actionButtons.setData( { entity:self._entity, infoButton:self._infoButton } );
            self._actionButtonsReady = true;

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._actionButtons ) );
        };

        /**
         * Set the breadcrumb string by inspecting the entity (i.e. set series/episode if available)
         * @param {Entity} entity
         */
        var setBreadcrumbString = function( entity )
        {
            var breadcrumbString;

            if( self._entityTitle === undefined ) //no title was set on init, default to entity title
                self._entityTitle = breadcrumbString = entity.getTitle();

            if( entity.getType() === XtvApi.EntityType.EPISODE ) //display season and episode in breadcrumbs
            {
                self._entityTitle = breadcrumbString = entity.getTitle();

                var series = entity.getSeries();
                if( series)
                {
                    var seriesTitle   = series.getTitle();
                    var seasonNumber  = entity.getSeasonNumber();
                    var episodeNumber = entity.getEpisodeNumber();

                    if( seriesTitle )
                        breadcrumbString = seriesTitle;

                    if( seasonNumber && episodeNumber )
                    {
                        if( seriesTitle )
                            breadcrumbString += " / ";

                        breadcrumbString += "Season " + seasonNumber + " / Episode " + episodeNumber;
                    }
                }
            }

            if( breadcrumbString !== undefined )
                self.setBreadCrumbs( undefined, breadcrumbString );
        };

        /**
         * Callback when entity loaded
         */
        var onEntityLoaded = function()
        {
            setBreadcrumbString( self._entity );

            if( self._entity.getType() === XtvApi.EntityType.SPORTS )
            {
                //For sporting events show home/away team in place of MoLT.
                var teams = [];
                var home  = self._entity.getHomeTeam();
                var away  = self._entity.getAwayTeam();

                if( home )
                    teams.push(home);

                if( away )
                    teams.push(away);

                if( teams.length )
                {
                    var collection = new Collection().init( teams, "Teams", XtvApi.EntityRenderStyle.POSTER );
                    self._molt = teams;
                    self._moltWidget.setData( collection );
                }
            }

            self._distractor.show();
            self._entityDetail.setData( self._entity );

            var p = [];
            p.push( self._entity.fetchEntityOptions() );

            if( self._entity.getType() === XtvApi.EntityType.SERIES )
                p.push( self._entity.fetchEntityRecording() );

            Promise.all( p ).then( onEntityOptionsLoaded ).catch( fail )
        };

        /**
         * Callback when More Like This data loaded
         * @param molt
         */
        var onMoltLoaded = function( molt )
        {
            if( molt && molt.length )
            {
                var collection = new Collection().init( molt, "People Are Watching", XtvApi.EntityRenderStyle.POSTER );
                self._molt = molt;
                self._moltWidget.setData( collection );
            }
        };

        var onLinearShowingDetail = function( showingDetail )
        {
            self._entity = showingDetail;
            self._entityDetail.setData( showingDetail );
            self._actionButtons.setData( { entity: showingDetail, infoButton:true } );
            self._actionButtonsReady = true;
            self._distractor.hide();

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._actionButtons ) );
        };

        if( entity instanceof ThumbnailEntity ) //BROWSE, SEARCH
        {
            this._distractor.show();

            var getMolt     = true;
            var id          = entity.getEntityId();
            var programType = entity.getProgramType();

            if( programType === 'MusicVideo' || programType === 'SportingEvent' )
                getMolt = false;
            else if( programType === 'Episode' )
            {
                id = entity.getSeriesId();
                getMolt = false;
            }

            var p = [];
            p.push( _x2.refreshResumePoints() );
            p.push( _x2._data.getProgram( id ).then( function( data ) { self._entity = data } ) );
            Promise.all(p).then( onEntityLoaded ).catch( fail );

            if( getMolt )
                _x2._data.getMoreLikeThis( id ).then( onMoltLoaded );
        }
        else if( entity instanceof Entity ) //SAVED > PURCHASES >> (SERIES/MOVIE/MORE) INFO
        {
            this._distractor.show();
            _x2._data.getMoreLikeThis( entity.getEntityId() ).then( onMoltLoaded );

            onEntityLoaded();
        }
        else if( entity instanceof Showing )
        {
            if( entity.getEntity() )
                setBreadcrumbString( entity.getEntity() );

            if( entity instanceof Recording ) //SAVED > RECORDINGS, SCHEDULED
            {
                var setRecording = function()
                {
                    self._entityDetail.setData( entity );
                    self._actionButtons.setData( { entity:entity, infoButton:true } );
                    self._actionButtonsReady = true;

                    if( _x2._focus === self )
                        self.speak( _x2.requestFocus( self._actionButtons ) );
                };

                if( ! entity.getProgram() ) //NOTE: some recordings do not have embedded encodesCreativeWork (i.e. news programs)
                    entity.fetchProgram().then( setRecording ).catch( fail );
                else
                    setRecording()
            }
            else if( entity instanceof LinearShowing ) //LIVE TV > KIDS, SPORTS, MOVIES
            {
                this._infoButton = true;
                this._distractor.show();
                entity.getDetail().then( onLinearShowingDetail );
            }
            else if( entity instanceof VodShowing )
            {
                this._entityDetail.setData( entity );
                this._actionButtons.setData( { entity: entity, infoButton:true } );
                self._actionButtonsReady = true;

                if( _x2._focus === this )
                    this.speak( _x2.requestFocus( this._actionButtons ) );
            }
        }
        else
            console.log( "EntityScreen.setData -> Unexpected type");

        if( this._molt )
            onMoltLoaded( this._molt );
    };

    EntityScreen.prototype.speak = function( focus )
    {
        if( focus )
        {
            this._speakTarget.setText( this._entityTitle + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( this._entityDetail.getSpeechStr() + "Press right or left to review program options. Press OK to select. ", focus._speakRole, this, false );
        }
        else
        {
            this._speakTarget.setText( "Loading, please wait. " );
            this._speakTarget.setSpeechParams( undefined, undefined, this, false );
        }
    };

    return EntityScreen;

})();


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.EpisodeScreen = (function()
{
    "use strict";

    EpisodeScreen.prototype = new Screen();

    function EpisodeScreen(){}

    EpisodeScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();

        if( this._dataReady )
            this.speak( _x2.requestFocus( this._actionButtons ) );
    };

    /**
     * memberof EpisodeScreen
     * @param {Object} params
     * @param {BrowseEntity, Recording} params.entity     = entity to display
     * @param {BrowseEntity} params.infoButton - show the info button
     * @returns {EpisodeScreen}
     */
    EpisodeScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this );
        this._className     = "EpisodeScreen";
        this._telemetryName = "Entity Episode";

        var self = this;
        var episode = ( params.entity instanceof Entity ? params.entity : params.entity.getEntity() );
        var infoButton = params.infoButton || params.entity instanceof Recording || params.entity instanceof Purchase || params.entity instanceof Purchase;
        var p = [];

        var w = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        var h = _x2._config._screenH - Style._safeBottom - 200;

        var onRefresh = function( updatedEntity )
        {
            if( updatedEntity )
                self._entityDetail.setData( updatedEntity );
        };

        // XC-13472
        if( episode && episode.getSeries )
        {
            var sNumber  = episode.getSeasonNumber();
            var epNumber = episode.getEpisodeNumber();
            var series   = episode.getSeries();
            var path     = series ? series.getTitle() : episode.getTitle();

            if( sNumber !== undefined || epNumber !== undefined )
            {
                path += " / Episodes";

                if( sNumber !== undefined )
                    path += " / Season " + sNumber;

                if( epNumber !== undefined )
                    path += " / Episode " + epNumber;
            }
            else
            {
                if( path === undefined && episode.getAirDateAsString )
                    path = "Airdate: " + episode.getAirDateAsString();
            }

            this.setBreadCrumbs( path );
        }
        else
            this.setBreadCrumbs( episode ? episode.getSeriesTitle() : params.entity.getTitle() ); //getTitle() or getSeriesTitle() ?

        this.addReadyCallback( function(){ self.layout(); } );

        this._entityDetail = new EntityInfoWidget().init( {} );
        this._entityDetail.setW( w );
        this._entityDetail.setH( h );
        this.addWidget( this._entityDetail, Style._safeLeft, 100 );

        this._actionButtons = new EntityActionButtonsWidget().init();
        this._actionButtons.setRefreshListener( onRefresh );
        this.addWidget( this._actionButtons, Style._safeLeft + _x2.scaleValInt( 350 ), 350 );

        this._distractor = new DistractorWidget().init( {} );
        this._distractor.addReadyCallback( function()
        {
            self._distractor.centerOnWidget( self );
            self._distractor.show();
        } );
        this.addWidget( this._distractor );

        var ready = function()
        {
            self.setData(params.entity, infoButton);
        };

        p.push(_x2.refreshResumePoints());

        //note: if we get a showing without a embedded entity, resolve the entity link (encodesCreativeWork) and patch the entity data
        if( episode === undefined )
        {
            var entityLink = params.entity.getLinkObject("encodesCreativeWork");
            if( entityLink )
            {
                var resolver = function( resolve, reject )
                {
                    var patchEntity = function( result )
                    {
                        params.entity.addPath( ["_embedded","encodesCreativeWork"], JSON.parse( result.data ) );
                        resolve()
                    };
                    entityLink.resolve().then(patchEntity).catch(reject);
                };
                p.push(new Promise(resolver));
            }
        }

        Promise.all(p).then(ready).catch(ready);

        return this;
    };

    EpisodeScreen.prototype.setData = function( episode, infoButton )
    {
        var onReady, onError, self = this;
        this._entityDetail.setData( episode );

        onReady = function()
        {
            self._actionButtons.setData( { entity:episode, infoButton:infoButton } );
            self._entityDetail.setData( episode );
            self._distractor.hide();

            if( _x2._focus === self )
                self.speak( _x2.requestFocus( self._actionButtons ) );

            self._dataReady = true;
        };

        onError = function( error )
        {
            self._distractor.hide();
            _x2.pushOverlay( new ErrorOverlay().init( { error:error, context:ErrorOverlay.Context.COMMON } ) )
        };

        if( episode instanceof Entity )
            episode.fetchEntityOptions().then( onReady ).catch( onError );
        else if( episode instanceof LinearShowing )
            episode.fetchEpisodeRecording().then( onReady ).catch( onError );
        else
            onReady();

        if( _x2._telemetry.watchPathDepth() > 1 ) // Don't reset if we don't have a path (Saved/For You/Featured)
            _x2._telemetry.setWatchButton( "Entity Info" );
    };

    EpisodeScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom() + _x2.scaleValInt( 42 ); // XC-13188 space between Breadcrumb line separator

        this._entityDetail.setY( y );
        this._actionButtons.setY( y + _x2.scaleValInt( 490 ) ); // Same as VodEntityScreen ?
    };

    EpisodeScreen.prototype.speak = function( focus )
    {
        console.log( focus );

        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( this._entityDetail.getSpeechStr() + "Press right or left to review program options. Press OK to select. ", focus._speakRole, this, false );
    };

    return EpisodeScreen;

})();


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.UpcomingScreen = (function()
{
    "use strict";

    UpcomingScreen.prototype = new Screen();

    function UpcomingScreen(){}

    UpcomingScreen.prototype.gotFocus = function()
    {
        if( this._list.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._list, true ) );
    };

    /**
     * Initializer
     * @memberof UpcomingScreen
     * @param   {Object} params
     * @param   {Object} params.entity   -
     * @param   {Array } params.listings -
     * @returns {UpcomingScreen}
     */
    UpcomingScreen.prototype.init = function( params )
    {
        var entity, listings, self = this, listParams = {}, entityListParams = {};

        Screen.prototype.init.call( this );
        this._className     = "UpcomingScreen";
        this._telemetryName = "Entity Upcoming";

        entity = params.entity;

        if( params.listings )
            listings = params.listings;
        else
            listings = entity.getEntityOptions().getUpcomingListings();

        //add poster
        var imageW  = _x2.scaleValInt(303);
        var imageH  = _x2.scaleValInt(404);
        var listPad = _x2.scaleValInt( 80); // Style._pad * 6;
        var listW   = _x2._config._screenW - Style._safeLeft - imageW - listPad - Style._safeRight;

        var imageError = function()
        {
            var fallback = entity.getFallbackImageLink( 303, 404 );
            if( self._image.getUrl() === fallback )
                self._image.setA( 0 ); //fallback already tried. hide image.
            else
                self._image.setUrl( fallback );

            // AAECH-59
            // 3. Search, LifeLock Protection, Upcoming
            // self._image.setUrl( self._image._url + "&default=force" );
        };

        this._image = new ImageWidget().init( { url:entity.getImageLink(303,404), w:imageW, h:imageH, onError:imageError } );
        this.addWidget(this._image);

        //add list
        entityListParams.w        = listW;
        entityListParams.h        = _x2._config._screenH;
        entityListParams.maxIndex = 1;
        entityListParams.type     = UpcomingRowWidget;
        this._entityList          = new ListWidget().init( entityListParams );

        listParams.w        = listW;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 0;
        listParams.type     = ExpandingListRowWidget;
        listParams.obj      = { list:this._entityList, baseWidget:this };
        this._list          = new ListWidget().init( listParams );

        this.addWidget( this._list );
        this._list.addWidget( this._entityList );

        this.addReadyCallback( function(){ self.layout( _x2.scaleValInt(52) ); } );

        this.setBreadCrumbs( entity.getTitle() );

        setTimeout( function(){ self.loadData( listings ) }, 1);

        return this;
    };

    UpcomingScreen.prototype.layout = function( listPad )
    {
        var top = this.getHeaderBottom() + _x2.scaleValInt( 42 );

        this._image.setX(Style._safeLeft);
        this._image.setY(top);

        this._list.setX(Style._safeLeft + this._image.getW() + listPad);
        this._list.setY(top);
        this._ready = true;

        if( _x2._focus === this && this._list.getMaxIndex() > 0 )
            this.speak( _x2.requestFocus( this._list, true ) );
    };

    UpcomingScreen.prototype.loadData = function( listings )
    {
        var date, key, title, i, entries = [], index = 0;

        this._entries = [];

        if( listings && listings.length )
        {
            for( i=0; i<listings.length; i++ )
            {
                date = new Date(listings[i].getStartTime());
                date.setMilliseconds( 0 );
                date.setSeconds( 0 );
                date.setMinutes( 0 );
                date.setHours( 0 );

                key = date.getTime();

                if( entries[key] === undefined )
                {
                    title = ScheduledWidget.DAYS[date.getDay()] + ", " + ScheduledWidget.MONTHS[date.getMonth()] + " " + date.getDate();
                    this._entries[index++] = entries[key] = { title:title, entries:[] };
                }

                entries[key].entries.push( listings[i] );
            }

            this._list.setData( this._entries );

            if( _x2._focus === this && this._ready === true )
                this.speak( _x2.requestFocus( this._list, true ) );
        }
    };

    UpcomingScreen.prototype.speak = function( focus )
    {
        this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press up or down to review days with showings. Press OK to select. ", focus._speakRole, this, false );
    };

    return UpcomingScreen;

})();


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodLeafScreen = (function()
{
    "use strict";

    VodLeafScreen.prototype = new Screen();

    function VodLeafScreen(){}

    VodLeafScreen.prototype.gotFocus = function()
    {
        if( this._ready === true )
            this.speak( _x2.requestFocus( this._grid ) );
    };

    /**
     * @param {Object}           params
     * @param {BrowseCollection} params.folder - data folder to display
     * @param {String}           params.path   - root path to this screen
     */

    VodLeafScreen.prototype.init = function( params )
    {
        var self = this;

        Screen.prototype.init.call( this );
        this._className     = "VodLeafScreen";
        this._telemetryName = "Browse";

        this._grid = new VodGridWidget().init( params.folder );
        this.addWidget( this._grid, Style._safeLeft );

        this.setBreadCrumbs( params.path, params.folder.getTitle() );
        this.addReadyCallback( function(){ self.layout(); } );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        return this;
    };

    VodLeafScreen.prototype.layout = function()
    {
        this._grid.setY( this.getHeaderBottom() + _x2.scaleValInt( 42 ) );

        this._ready = true;

        if( _x2._focus === this )
            this.speak( _x2.requestFocus( this._grid ) );
    };

    VodLeafScreen.prototype.speak = function( focus )
    {
        if( focus )
        {
            this._speakTarget.setText( this.getBreadCrumb() + ". " + focus._speakStr + ". " );
            this._speakTarget.setSpeechParams( "Press up, down, left or right to review programs. Press OK to select. ", focus._speakRole, this, false );
        }
    };

    VodLeafScreen.prototype.refreshCheck = function()
    {
        if( this._grid && this._grid.refresh )
            this._grid.refresh();
    };

    return VodLeafScreen;

})();


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.VodRootScreen = (function()
{
    "use strict";

    VodRootScreen.prototype = new Screen();

    function VodRootScreen(){}

    VodRootScreen.prototype.filtersChanged = function()
    {
        var self = this, onPopped;

        console.log( ">>>>>>>>>>>>>>>>>>>> VOD FILTERS HAVE CHANGED <<<<<<<<<<<<<<<<<<<<<" );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        onPopped = function()
        {
            console.log( "#################### APPLY FILTERS ####################" );

            if( self._activeWidget )
                self._activeWidget.deactivate();

            self._activeWidget = undefined;
            self.swapContent( 0 );
        };

//         window.ll( "tagEvent", "Live TV: Find Channel Jump button", { channel: channel.getCallSign() } ); // Localytics 2.3.8
//         _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Find Channel Jump button: " + channel.getCallSign() ) : Config.NOP();

        _x2.popOverlay( this._overlay, onPopped );
    };

    VodRootScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._menu, true );

        this._speakTarget.setText( "Browse. " + focus._speakStr + ". " );
        this._speakTarget.setSpeechParams( "Press left or right to change filters. Press up or down to review categories. ", focus._speakRole, this, false );
    };

    /**
     * Initializer
     * @memberof VodRootScreen
     * @param {Object} [params]
     * @param {String} [params.intialItem] - Name of menu item to get focus
     * @returns {VodRootScreen}
     */
    VodRootScreen.prototype.init = function( params )
    {
        Screen.prototype.init.call( this );
        this._className     = "VodRootScreen";
        this._telemetryName = "Browse";

        var obj, i, onEnter, onGotFocus, index;
        var self        = this;
        var folders     = _x2._vodRoot.getEmbeddedBrowseItems();
        var entries     = [];
        var buttonStyle = new Style( { font: "regular", color: "#e8e8e8", fontSize: _x2.scaleValInt(32), whiteSpace: "nowrap", colorHi: "#000000" } );

        this._widgets = [];

        var doOnEnter = function( idx )
        {
            var focus     = _x2.requestFocus( self._widgets[idx], true );
            var path      = self.getBreadCrumb();
            var telemetry = path.split( " /" ).join( ":" ); // "Browse / ___" -> "Browse: ___"

            _x2._config.log( Config.CLASS_TELEMETRY, 1 ) ? console.log( "Telemetry Tab: " + telemetry ) : Config.NOP();
            _x2._telemetry.setWatchButton( telemetry );
            self._speakTarget.setText( path + "." );

            if( focus )
                self._speakTarget.setSpeechParams( focus._speakStr, focus._speakRole, self, false );
            else
                self._speakTarget.setSpeechParams( "Loading, please wait. ", undefined, self, false );
        };

        onGotFocus = function( idx ) { return function() { self.setBreadCrumbs( "Browse", entries[idx].getText() ); self.swapContent( idx ); }; };
        onEnter    = function( idx ) { return function() { doOnEnter( idx ); }; };

        for( i = 0; i < folders.length; i++ )
        {
            switch( folders[i].getCollectionRenderStyle() )
            {
                case XtvApi.CollectionRenderStyle.NETWORK_ENTITY:
                case XtvApi.CollectionRenderStyle.GALLERY_ROWS:
                    obj = new VodBrowseWidget().init( folders[i] );
                    break;

                default :
                    console.error( "Error -> Unexpected collection render style = " + folders[i] );
                    break;
            }

            if( obj )
            {
                //NOTE: for speed's sake, we're pulling a depth=1 for the main menu. Therefore we don't know if each entry has
                //children. If we need to defend against bad data to filter menu items at the root, we'll need to pull a depth=2 query.

                entries[i] = new StringWidget().init( { text: folders[i].getTitle(), style: buttonStyle, focusTime: 500 } );
                entries[i].onEnter = onEnter( i );
                entries[i].setFocusListeners( onGotFocus( i ) );

                this._widgets.push( obj );
                this.addWidget( obj, 0, 100 );
            }
        }

        var onOptions = function()
        {
            console.log( "SHOW OPTIONS OVERLAY" );

//             window.ll( "tagEvent", "Live TV Options Button" ); // Localytics 2.3.7
//             _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Live TV: Options Button" ) : Config.NOP();

            self._overlay = new FilterChannelsOverlay().init( { screen:self, which:Settings.Key.FILTERS } );
            _x2.pushOverlay( self._overlay );
        };

        var options = new StringWidget().init( { text:"Options", style:buttonStyle, onEnter:onOptions } );

        // add menu widget for top level vod categories

        if( params && params.intialItem )
            for( i = 0; i < entries.length; i++ )
            {
                if( params.intialItem === entries[i].getText() )
                {
                    index = i;
                    break;
                }
            }

        this._menu = new TabbedPillButtonsWidget().init( { entries: entries, options:options, index:index } );
        this.addWidget( this._menu );

        this.setBreadCrumbs( "Browse" );
        this.addReadyCallback( function(){ self.layout(); } );

        this.setHeaderFilters( _x2._settings.getValue( Settings.Key.FILTERS ) );

        window.ll( "tagScreen", "On Demand" );

        _x2._telemetry.sendScreenViewed( this._telemetryName );

        return this;
    };

    VodRootScreen.prototype.layout = function()
    {
        var i, x, y;

        x = 0; //Style._safeLeft;
        y = this.getHeaderBottom();

        this._menu.setH( y );

        for( i = 0; i < this._widgets.length; i++ )
        {
            this._widgets[i].setX( x );
            this._widgets[i].setY( y );
        }
    };

    VodRootScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LAST:
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._menu.containsWidget( _x2._focus ) === false )
                        _x2.requestFocus( this._menu );
                    else
                        retval = Screen.prototype.processEvent.call( this, val, type );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    VodRootScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        if( this._menu )
            this._menu.setY( this.getHeaderBottom() );
    };

    VodRootScreen.prototype.swapContent = function( index )
    {
        if( this._activeWidget !== this._widgets[index] )
        {
            if( this._activeWidget )
                this._activeWidget.deactivate();

            this._activeWidget = this._widgets[index];
            this._activeWidget.activate();
        }
    };

    return VodRootScreen;
})();


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.WelcomeScreen = ( function()
{
    "use strict";

    WelcomeScreen.prototype = new Screen();

    function WelcomeScreen(){}

    WelcomeScreen.prototype.gotFocus = function()
    {
        var focus = _x2.requestFocus( this._button, true );

        this._speakTarget.setText( this._a11yText + ' ' + focus._speakStr );
        this._speakTarget.setSpeechParams( "Press OK to select.", focus._speakRole, this, false );
    };

    WelcomeScreen.prototype.init = function( onAuth, params )
    {
        var self = this;

        Screen.prototype.init.call( this, { noHeader:true, noSep:true, image:_x2._config._imageRoot + "welcomeBg.jpg" } );
        this._className     = "WelcomeScreen";
        this._numLoaded     = 0;

        var layout      = function() { self.layout(); };
        var rectW       = _x2.scaleValInt(74);
        var titleStyle  = new Style( { font:"thin" , color:"#e8e8e8", fontSize:_x2.scaleValInt(100), textAlign :"center" } );
        var subStyle    = new Style( { font:"light" , color:"#e8e8e8", fontSize:_x2.scaleValInt( 42), textAlign :"center" } );
        var buttonStyle = new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt( 32), whiteSpace:"nowrap", colorHi:"#000000" } );
        var titleStr    = _x2._st.welcomeTitle;
        var sub1Str     = _x2._st.welcomeBody1;
        var sub2Str     = [
          _x2._st.welcomeBody2,
          _x2._config._host.getType() === Host.Type.LG && _x2._st.welcomeBodyLG
        ].filter(Boolean).join(' ');
        var button      = new StringWidget().init( { text:_x2._st.welcomeButton, style:buttonStyle, onEnter:function() { _x2.pushScreen( new AuthCodeScreen().init( onAuth, params ) ); } } );

        this._a11yText = [
          titleStr.replace(/xfinity/gi, 'x finity'),
          sub1Str,
          sub2Str
        ].join(' ');

        this._container = new Widget().init();
        this._titleStr  = new StringWidget().init( { text:titleStr, style:titleStyle } );
        this._rect      = new RectWidget().init( { w:rectW, h:2, color:"#e8e8e8" } );
        this._sub1Str   = new StringWidget().init( { text:sub1Str, style:subStyle } );  // TODO text block
        this._sub2Str   = new StringWidget().init( { text:sub2Str, style:subStyle } );  // TODO text block
        this._button    = new HorizPillButtonsWidget().init( { entries:[button], spacing:_x2.scaleValInt(60) } );

        this._container.setA( 0 );
        this._titleStr.setW( _x2._config._screenW );
        this._sub1Str.setW ( _x2._config._screenW );
        this._sub2Str.setW ( _x2._config._screenW );
        this._sub2Str.addReadyCallback( layout );

        this.addWidget( this._container );
        this._container.addWidget( this._titleStr );
        this._container.addWidget( this._rect, (_x2._config._screenW - rectW) / 2, Style._safeTop );
        this._container.addWidget( this._sub1Str );
        this._container.addWidget( this._sub2Str );
        this._container.addWidget( this._button  );
        this._button.addReadyCallback( layout );

        _x2._config.log( Config.CLASS_LOCALYTICS, 1 ) ? console.log( "Localytics: Non-authenticated device: Welcome screen" ) : Config.NOP();
        window.ll( "tagScreen", "Welcome Screen" ); // Localytics 2.1.1

        // NOTE: Can't send Telemetry SCREEN_VIEWED -- don't have token to open WebSocket

        return this;
    };

    WelcomeScreen.prototype.layout = function()
    {
        if( ++this._numLoaded === 2 )
        {
            var y = _x2.scaleValInt(507);
            this._titleStr.setY( y );

            y += this._titleStr.getH() + _x2.scaleValInt(21);
            this._rect.setY( y );

            y += this._rect.getH() + _x2.scaleValInt(30);
            this._sub1Str.setY( y );

            y += this._sub1Str.getH() + _x2.scaleValInt(15);
            this._sub2Str.setY( y );

            y+= this._sub2Str.getH() + _x2.scaleValInt(51);
            this._button.setY( y );

            this._button.setX( (_x2._config._screenW - this._button.getW()) / 2 );

            this._container.animate( { a:1, duration:500 } );
        }
    };

    return WelcomeScreen;

})();


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.AniTestScreen = ( function()
{
    "use strict";

    AniTestScreen.prototype = new Screen();

    function AniTestScreen(){}

    AniTestScreen.prototype.init = function()
    {
        this._className = "AniTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._numEasing = Object.keys( Widget.Easing ).length;

        this._rects = new Array( this._numEasing );
        this._texts = new Array( this._numEasing );
        this._endx  = _x2._config._screenW/2;
        var p = 2; // padding
        var s = ((_x2._config._screenH - Style._safeTop - Style._safeBottom - p*this._numEasing) / this._numEasing)|0;
        var w = s; // 15
        var h = s; // 15

        var types =
        [
             Widget.Easing.QUAD_IN
            ,Widget.Easing.CUBIC_IN
            ,Widget.Easing.QUART_IN
            ,Widget.Easing.QUINT_IN
            ,Widget.Easing.SEXTIC_IN
            ,Widget.Easing.SEPTIC_IN
            ,Widget.Easing.OCTIC_IN

            ,Widget.Easing.BACK_IN
            ,Widget.Easing.BOUNCE_IN
            ,Widget.Easing.CIRC_IN
            ,Widget.Easing.ELASTIC_IN
            ,Widget.Easing.EXPO_IN
            ,Widget.Easing.SINE_IN

            ,Widget.Easing.LINEAR

            ,Widget.Easing.QUAD_IN_OUT
            ,Widget.Easing.CUBIC_IN_OUT
            ,Widget.Easing.QUART_IN_OUT
            ,Widget.Easing.QUINT_IN_OUT
            ,Widget.Easing.SEPTIC_IN_OUT
            ,Widget.Easing.SEXTIC_IN_OUT
            ,Widget.Easing.OCTIC_IN_OUT

            ,Widget.Easing.BACK_IN_OUT
            ,Widget.Easing.BOUNCE_IN_OUT
            ,Widget.Easing.CIRC_IN_OUT
            ,Widget.Easing.ELASTIC_IN_OUT
            ,Widget.Easing.EXPO_IN_OUT
            ,Widget.Easing.SINE_IN_OUT

            ,Widget.Easing.QUAD_OUT
            ,Widget.Easing.CUBIC_OUT
            ,Widget.Easing.QUART_OUT
            ,Widget.Easing.QUINT_OUT
            ,Widget.Easing.SEPTIC_OUT
            ,Widget.Easing.SEXTIC_OUT
            ,Widget.Easing.OCTIC_OUT

            ,Widget.Easing.BACK_OUT
            ,Widget.Easing.BOUNCE_OUT
            ,Widget.Easing.CIRC_OUT
            ,Widget.Easing.ELASTIC_OUT
            ,Widget.Easing.EXPO_OUT
            ,Widget.Easing.SINE_OUT
        ];
        this._types = types;

        var names =
        [
             "In Quadratic        "
            ,"In Cubic            "
            ,"In Quartic          "
            ,"In Quintic          "
            ,"In Sextic           "
            ,"In Septic           "
            ,"In Octic            "

            ,"In Back             "
            ,"In Bounce           "
            ,"In Circle           "
            ,"In Elastic          "
            ,"In Exponential 2    "
            ,"In Sine             "

            ,"Linear"

            ,"In/Out Cubic        "
            ,"In/Out Quadratic    "
            ,"In/Out Quartic      "
            ,"In/Out Quintic      "
            ,"In/Out Sextic       "
            ,"In/Out Septic       "
            ,"In/Out Octic        "

            ,"In/Out Back         "
            ,"In/Out Bounce       "
            ,"In/Out Circle       "
            ,"In/Out Elastic      "
            ,"In/Out Exponential 2"
            ,"In/Out Sine         "

            ,"Out Cubic           "
            ,"Out Quadratic       "
            ,"Out Quartic         "
            ,"Out Quintic         "
            ,"Out Sextic          "
            ,"Out Septic          "
            ,"Out Octic           "

            ,"Out Back            "
            ,"Out Bounce          "
            ,"Out Circle          "
            ,"Out Elastic         "
            ,"Out Exponential 2   "
            ,"Out Sine            "
        ];

        var colors = [ "#F00", "#FF0", "#0F0", "#0FF", "#00F", "#F0F", "#777", "#FFF" ];
        for( var i = 0; i < this._rects.length; i++ )
        {
            var color;

            if( types[i] === Widget.Easing.QUAD_IN     ) color = colors[ 0 ];
            if( types[i] === Widget.Easing.QUAD_IN_OUT ) color = colors[ 2 ];
            if( types[i] === Widget.Easing.QUAD_OUT    ) color = colors[ 4 ];

            if( types[i] === Widget.Easing.BACK_IN     ) color = colors[ 1 ];
            if( types[i] === Widget.Easing.BACK_IN_OUT ) color = colors[ 3 ];
            if( types[i] === Widget.Easing.BACK_OUT    ) color = colors[ 5 ];

            if( types[i] === Widget.Easing.LINEAR      ) color = colors[ 7 ];

            var style = new Style( { color:color, font:"medium", fontSize:h, whiteSpace:"nowrap" } );

            this._rects[i] = new RectWidget().init( { w:w, h:h, color:color } );
            this._texts[i] = new StringWidget().init( { text: names[i], style: style } );
            var y = Style._safeTop + i * (w + p); // 15 -> 20;

            this.addWidget( this._rects[i], Style._safeLeft, y );
            this.addWidget( this._texts[i], this._endx + 2*w, y );
        }

        var lineStyle = { w:1, h: _x2._config._screenH, color:"#404040" };
        this._left    = new RectWidget().init( lineStyle );
        this._right   = new RectWidget().init( lineStyle );
        this._mid     = new RectWidget().init( lineStyle );
        this.addWidget( this._left , Style._safeLeft - 1, 0 );
        this.addWidget( this._right, this._endx      + w, 0 );
        this.addWidget( this._mid  ,(Style._safeLeft+this._endx+w)/2,0);

        return this;
    };

    AniTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true, i;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    for( i = 0; i < this._numEasing; i++ )
                        this._rects[i].animate( {  duration:2000, x:this._endx, easing:this._types[i] } );
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                    for( i = 0; i < this._numEasing; i++ )
                        this._rects[i].animate( {  duration:2000, x:Style._safeLeft, easing:this._types[i] } );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return AniTestScreen;

})();


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.HorizPillButtonTestScreen = ( function()
{
    "use strict";

    HorizPillButtonTestScreen.prototype = new Screen();

    function HorizPillButtonTestScreen(){}

    HorizPillButtonTestScreen.prototype.init = function()
    {
        var self = this;
        this._className = "HorizPillButtonTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var onEnter = function()
        {
            _x2.requestFocus( self );
        };

        var style   = new Style( { color:"#e5e5e5", colorHi:"#000000", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );
        var string1 = new StringWidget().init( { text: "ABC", style: style, onEnter: onEnter } );
        var string2 = new StringWidget().init( { text: "123", style: style, onEnter: onEnter } );
        var string3 = new StringWidget().init( { text: "abc", style: style, onEnter: onEnter } );

        string1._selectable = true;
        string2._selectable = true;
        string3._selectable = true;

        var entries =
        [
            string1,
            string2,
            string3
        ];
        this._entries = entries;

        this._menu = new HorizPillButtonsWidget().init( { entries:entries, spacing:_x2.scaleValInt(60) } );
        this._menu.addReadyCallback ( function() { self.layout(); self._buttonsReady = true; } );

        var onGotFocus = function()
        {
//            self.animate( { y:0, duration:500 } );
        };
        var onLostFocus = function()
        {
//            self.animate( { y:-self.getH(), duration:500 } );
        };

        this._menu.setFocusListeners( onGotFocus, onLostFocus );
        this.addWidget( this._menu, Style._safeLeft, Style._safeTop );

        this._rectHasFocus = new RectWidget().init( { w: 300, h: 400, color: "#22AA22" } );
        this._rectNotFocus = new RectWidget().init( { w: 300, h: 400, color: "#AA2222" } );
        this._rectHasFocus.setA( 0 );
        this._rectNotFocus.setA( 0 );

        this._item = new Widget().init();
        this._item._selectable  = true;
        this._item._onGotFocus  = function() { self._rectHasFocus.setA( 1 ); self._rectNotFocus.setA( 0 ); };
        this._item._onLostFocus = function() { self._rectHasFocus.setA( 0 ); self._rectNotFocus.setA( 1 ); };
        this._item.addWidget( this._rectHasFocus );
        this._item.addWidget( this._rectNotFocus );
        this.addWidget( this._item, Style._safeLeft, Style._safeTop*3 );

        return this;
    };

    HorizPillButtonTestScreen.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._item );
    };

    HorizPillButtonTestScreen.prototype.layout = function()
    {
        var y = this.getHeaderBottom();
        this._menu.setH( y );
        this._item.setY( y );

        _x2.requestFocus( this._item );
    };

    HorizPillButtonTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._menu.containsWidget( _x2._focus ) === false )
                        _x2.requestFocus( this._menu );
                    else
                        _x2.requestFocus( this._item );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return HorizPillButtonTestScreen;

})();



/***/ }),
/* 223 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.HorizSelectionTestScreen = ( function()
{
    "use strict";

    HorizSelectionTestScreen.prototype = new Screen();

    function HorizSelectionTestScreen(){}

    HorizSelectionTestScreen.prototype.init = function()
    {
        this._className = "HorizSelectionTestScreen";

        Screen.prototype.init.call( this );

        this.addWidget( new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } ) );

        var onChange = function( val )
        {
            console.log( val + " selected");
        };
        
        var e1 = [
            { key:'a', label:"All Episodes"  },
            { key:'r', label:"Just Repeats"  },
            { key:'n', label:"Just New Episodes" }];

        var e2 = [
            { key:0, label:"Cats" },
            { key:1, label:"Dogs" },
            { key:2, label:"Fish" }];

        //NOTE: set an 'obj' when the callback function needs more information or context.
        var e3 = [
            { obj: {type:'sport', subType:'b'}, key:'b', label:"Baseball" },
            { obj: {type:'sport', subType:'f'}, key:'f', label:"Football" },
            { obj: {type:'sport', subType:'g'}, key:'g', label:"Golf", selected:true }];

        this._hsw1 = new HorizSelectionWidget().init( { width:300, entries:e1, defaultValue:'r', onChange:onChange } );
        this._hsw2 = new HorizSelectionWidget().init( { width:300, entries:e2, defaultIndex:1,   onChange:onChange } );
        this._hsw3 = new HorizSelectionWidget().init( { width:300, entries:e3,                   onChange:onChange } );

        this.addWidget( this._hsw1, Style._safeLeft, Style._safeTop );
        this.addWidget( this._hsw2, Style._safeLeft, Style._safeTop + 100 );
        this.addWidget( this._hsw3, Style._safeLeft, Style._safeTop + 200 );

        this._index = 0;
        
        return this;
    };

    HorizSelectionTestScreen.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._hsw1 );
    };

    HorizSelectionTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    switch (this._index)
                    {
                        case 1:
                            _x2.requestFocus(this._hsw1);
                            this._index--;
                            break;
                        case 2:
                            _x2.requestFocus(this._hsw2);
                            this._index--;
                            break;
                        default:
                            retval = Screen.prototype.processEvent.call( this, val, type );
                            break;
                    }
                }
                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                {
                    switch (this._index)
                    {
                        case 0:
                            _x2.requestFocus(this._hsw2);
                            this._index++;
                            break;
                        case 1:
                            _x2.requestFocus(this._hsw3);
                            this._index++;
                            break;
                        default:
                            retval = Screen.prototype.processEvent.call( this, val, type );
                            break;
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return HorizSelectionTestScreen;

})();



/***/ }),
/* 224 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.FontScaleTestScreen = ( function()
{
    "use strict";

    FontScaleTestScreen.prototype = new Screen();

    function FontScaleTestScreen(){}

    FontScaleTestScreen.prototype.init = function()
    {
        var width, height;
        var headStyle, bodyStyle;
        var fontSize   = 28;
        var fontWeight = "light"; // "bold", "medium", "light"

        this._className = "FontScaleTestScreen";
        Screen.prototype.init.call( this );

        this._size    = fontSize;
        this._strings = [];
        this._lines   = [];

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._scale        = 224 / fontSize; // 224/28pt font = 8x scaling
        this._leadingScale = 1.0;
        this.buildFontStrings( fontWeight, fontSize * this._scale, Style._safeLeft*0.5, Style._safeTop ); // native 28 pt

        this._selectable = true;

        return this;
    };

    FontScaleTestScreen.prototype.buildFontStrings = function( fontWeight, fontSize, x, y )
    {
        var i, lines = [], label = [], rect, string;
        var styleBlue  = "#2ea0dd";
        var styleWhite = "#ffffff";
        var a_ring     = String.fromCharCode( 0xC5 );
        var para       = String.fromCharCode( 0xB6 );
        var o_acute    = String.fromCharCode( 0xD3 );

        label.push( para + a_ring + "g" + " @ " );
        lines.push( "" + fontSize + " " + a_ring );

        // NOTE: These strings
        //   Silicon Valley
        //   Pill
        // are specifically chosen to stress test 16 px sub-pixel accuracy
        label.push( o_acute + "Silicon Valley" ); // "" + (fontSize) );
        lines.push( "/O " + a_ring );

        label.push( "Pilldgy" );
        lines.push( "@? " + a_ring );

        var keyStyle  = [
            new Style( { font:fontWeight, color:"#FFFF00", fontSize:fontSize, overflow:"hidden" } ), // yellow
            new Style( { font:fontWeight, color:styleBlue, fontSize:fontSize, overflow:"hidden" } ), // blue
            new Style( { font:fontWeight, color:"#FF0000", fontSize:fontSize, overflow:"hidden" } )  // red
        ];
        var valStyle  = [
            new Style( { font:fontWeight, color:styleWhite, fontSize:fontSize, overflow:"hidden" } ), // white
            new Style( { font:fontWeight, color:"#8000FF" , fontSize:fontSize, overflow:"hidden" } ), // purple
            new Style( { font:fontWeight, color:"#00FF00" , fontSize:fontSize, overflow:"hidden" } )  // green
        ];

        var w = _x2._config._screenW;
        for( i = 0; i < lines.length; ++i )
        {
            string = new StringWidget().init( { text: label[i], style: keyStyle[ i % keyStyle.length ] } );
            this._strings.push( string );
            this.addWidget( string, x, y );

            if( i === 0 )
            {
                rect = new RectWidget().init( { w: w, h: 1, color: "#FFFFFF" } );
                this._lines.push( rect );
                this.addWidget( rect, 0, y );
            }

            rect = new RectWidget().init( { w: w, h: 1, color: i % 2 === 0 ? "#FF0000" : "#00FF00" } );
            this._lines.push( rect );
            this.addWidget( rect, 0, y + fontSize );

            string = new StringWidget().init( { text: lines[i], style: valStyle[ i % valStyle.length ] } );
            this._strings.push( string );
            this.addWidget( string, w*0.5, y );

            y += this._leadingScale*fontSize;
        }
        return y;
    };

    FontScaleTestScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
    };

    FontScaleTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true, size, ds, i, n;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                case Host.KEY_LEFT:
                    this.resize( 16 );
                    break;

                case Host.KEY_RIGHT:
                    this.resize( 224 );
                    break;

                case Host.KEY_UP:
                    size = this._strings[0].getVal( Widget.FONT_SIZE );
                    ds   = (size / 10) | 0;
                    if((size +  ds) <= 224)
                        size += ds;
                    this.resize( size );
                    break;

                case Host.KEY_DOWN:
                    size = this._strings[0].getVal( Widget.FONT_SIZE );
                    ds   = (size / 10) | 0;
                    if((size - ds) >= 10)
                        size -= ds;
                    this.resize( size );
                    break;

                case Host.KEY_PAGE_DN:
                case Host.KEY_CH_DOWN:
                    n = this._strings.length;
                    for( i = 0; i < n; i++ )
                        this._strings[i].setVal( Widget.FONT_COLOR, "#FFFFFF" );
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    FontScaleTestScreen.prototype.resize = function( fontSize )
    {
        var i, n = this._strings.length, top = Style._safeTop, y, dy = this._leadingScale*fontSize;
        var a_ring = String.fromCharCode( 0xC5 );

        y = top;
        for( i = 0; i < n; i++ )
        {
            this._strings[i].setVal( Widget.FONT_SIZE, fontSize );
            this._strings[i].setY( y );

            if( (i > 0) && ((i & 1) === 1) )
                y += dy;
        }

        this._strings[1].setText( "" + fontSize  + " " + a_ring );
        //this._strings[2].setText( "" + fontSize );

        y = top + dy;
        for( i = 1; i < this._lines.length; i++ )
        {
            this._lines[ i ].setY( y );
            this._lines[ i ].setA( 0.25 + 0.75*fontSize/256 );
            y += dy;
        }
    };

    return FontScaleTestScreen;

})();



/***/ }),
/* 225 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.FontGlyphTestScreen = ( function()
{
    "use strict";

    FontGlyphTestScreen.prototype = new Screen();

    function FontGlyphTestScreen(){}

    FontGlyphTestScreen.prototype.init = function()
    {
        var aColors  = [ "#F00", "#FF0"  , "#0F0"   , "#0FF" , "#00F" ];
        var aWeights = [ "bold", "medium", "regular", "light", "thin" ];
        var aStrings = [];
        var iWeight;
        var nWeight  = aWeights.length;
        var fontSize = 225; // _x2._config._screenW / nWeight;
        var x = 0;
        var y = Style._safeTop;
        var h = 40;

        this._className = "FontGlyphTestScreen";
        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        for( iWeight = 0; iWeight < nWeight; iWeight++ )
        {
            var color  = aColors[iWeight];
            var weight = aWeights[ iWeight ]; 
            var style  = new Style( { font:weight, color:color, fontSize:_x2.scaleValInt( fontSize ) } ); // , whiteSpace:"nowrap", textAlign :"left" } );
            aStrings.push( new StringWidget().init( { text: " ", style: style } ) );

            var rect = new RectWidget().init( {w:fontSize, h:fontSize, color:"#000", borderThickness:1, borderColor:color } );
            this.addWidget( rect, x, y - 1 );
            rect.setA( 0.5 );

            this.addWidget( aStrings[ iWeight ], x + 1, y );

            var title = new Style( { font:weight, color:"#FFFFFF", fontSize:_x2.scaleValInt( h ) } );
            var label = new StringWidget().init( { text:weight, style:title } );
            this.addWidget( label, x, y + fontSize + 2 );

            x += fontSize + 2;
        }

        this._char       = 0x21;
        this._glyph      = new StringWidget().init( { text:this._char, style:title } ); // intentional title style
        this._aColors    = aColors;
        this._aStrings   = aStrings;
        this._selectable = true;

        this.addWidget( this._glyph, _x2._config._screenW*0.5, y + fontSize + 2*h );

        this.delta( 0 );

        return this;
    };

    FontGlyphTestScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
    };

    FontGlyphTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                case Host.KEY_LEFT:
                    this.delta( -1 );
                    break;

                case Host.KEY_RIGHT:
                    this.delta( +1 );
                    break;

                case Host.KEY_UP:
                    this.delta( -32 );
                    break;

                case Host.KEY_DOWN:
                    this.delta( +32 );
                    break;

                case Host.KEY_PAGE_DN:
                case Host.KEY_CH_DOWN:
                    this._char = 0xFF;
                    this.delta( 0 );
                    break;

                case Host.KEY_PAGE_UP:
                case Host.KEY_CH_UP:
                    this._char = 0x21;
                    this.delta( 0 );
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    FontGlyphTestScreen.prototype.delta = function( delta )
    {
        this._char += delta;

        if( this._char <  32 )
            this._char =  32;
        if( this._char > 0xFF)
            this._char = 0xFF;

        this._text = String.fromCharCode( this._char );
        this._glyph.setText( this._char ); 

        for( var i = 0; i < this._aStrings.length; i++ )
            this._aStrings[i].setText( this._text );
    };

    return FontGlyphTestScreen;

})();




/***/ }),
/* 226 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.Gradient2TestScreen = ( function()
{
    "use strict";

    Gradient2TestScreen.prototype = new Screen();

    function Gradient2TestScreen(){}

    Gradient2TestScreen.prototype.init = function()
    {
        var angle, delta;
        var alphas, colors;
        var alpha2, color2;
        var linear, radial;
        var params, gradient;

        var i;
        var x, y;
        var col, row;
        var w = 4/3 * 200, h = 200;

        Screen.prototype.init.call( this );
        this._className = "Gradient2TestScreen";

        //this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        //this.addWidget( this._bg );
        this.addWidget( new ImageWidget().init( { url: _x2._config._imageRoot + "welcomeBg.jpg" } ) );

        this._grads = [];

        alphas =
        [
            {
                opacity : 100,
                location:   0
            },
            {
                opacity :  50,
                location: 100
            }
        ];

        colors =
        [
            {
                color   : "#FF0000",
                location: 0
            },
            {
                color   : "#0000FF",
                location: 100
            }
        ];

        // reverse only alphas/colors, keep locations
        alpha2 = JSON.parse(JSON.stringify(alphas)).reverse(); // deep copy [] & {}
        alpha2[0].location = 0;
        alpha2[1].location = 85;

        color2 = JSON.parse(JSON.stringify(colors)).reverse(); // deep copy [] & {}
        color2[0].location = 0; // colors[0].location;
        color2[1].location = 85; // colors[1].location;

        linear =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 0,
            alphas: alphas,
            colors: colors
        };

        radial =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Radial,
            alphas: alpha2,
            colors: color2
        };

        x = Style._safeLeft;
        y = Style._safeTop;

        angle = 0;
        delta = 45;

        for( i = 0; i < 9; i++ )
        {
            col = i % 3;
            row =(i / 3) | 0;

            if( col === 0 )
            {
                switch( row )
                {
                    case 0: angle = 135; delta = -45; break;
                    case 1: angle = 180; delta =  90; break;
                    case 2: angle = 225; delta = +45; break;
                }
            }

            if( i !== 4 )
            {
                params = Object.assign( {}, linear );
                params.angle = angle;
            }
            else
            {
                params = Object.assign( {}, radial );
            }

            gradient = new GradientWidget().init( params );

            this._grads.push( gradient );
            this.addWidget( gradient, x, y );

//console.log( "(" + i + ") %o", params );

            x += w;
            angle += delta;

            if( col === 2)
            {
                x = Style._safeLeft;
                y += h;
            }
        }

        this._selectable = true;

        return this;
    };

    return Gradient2TestScreen;

})();


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.Gradient3TestScreen = ( function()
{
    "use strict";

    Gradient3TestScreen.prototype = new Screen();

    function Gradient3TestScreen(){}

    Gradient3TestScreen.prototype.init = function()
    {
        var angle, delta;
        var alphas, colors;
        var alpha2, color2;
        var linear, radial;
        var params, gradient;

        var i;
        var x, y;
        var col, row;
        var w = 4/3 * 200, h = 200;

        Screen.prototype.init.call( this );
        this._className = "Gradient3TestScreen";

        //this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        //this.addWidget( this._bg );
        this.addWidget( new ImageWidget().init( { url: _x2._config._imageRoot + "welcomeBg.jpg" } ) );

        this._grads = [];

        alphas =
        [
            {
                opacity : 100,
                location: 50
            },
            {
                opacity : 50,
                location: 100
            }
        ];

        colors =
        [
            {
                color   : "#FF0000",
                location: 0
            },
            {
                color   : "#00FF00",
                location: 50
            },
            {
                color   : "#0000FF",
                location: 100
            }
        ];

        // reverse only alphas/colors, keep locations
        alpha2 = JSON.parse(JSON.stringify(alphas)).reverse(); // deep copy [] & {}
        for( i = 0; i < alphas.length; i++ )
            alpha2[ i ].location = 100 - alpha2[ i ].location;

        color2 = JSON.parse(JSON.stringify(colors)).reverse(); // deep copy [] & {}
        for( i = 0; i < colors.length; i++ )
            color2[ i ].location = 100 - color2[ i ].location;

        // TODO: Stress-Test bad radial: blue, green (circle), red outside
        //    alpha2[0].location = 0;
        //    color2[0].location = 0; // colors[0].location;

        linear =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 0,
            alphas: alphas,
            colors: colors
        };

        radial =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Radial,
            alphas: alpha2,
            colors: color2
        };

        x = Style._safeLeft;
        y = Style._safeTop;

        angle = 0;
        delta = 45;

        for( i = 0; i < 9; i++ )
        {
            col = i % 3;
            row =(i / 3) | 0;

            if( col === 0 )
            {
                switch( row )
                {
                    case 0: angle = 135; delta = -45; break;
                    case 1: angle = 180; delta =  90; break;
                    case 2: angle = 225; delta = +45; break;
                }
            }

            if( i !== 4 )
            {
                params = Object.assign( {}, linear );
                params.angle = angle;
            }
            else
            {
                params = Object.assign( {}, radial );
            }

            gradient = new GradientWidget().init( params );

            this._grads.push( gradient );
            this.addWidget( gradient, x, y );

//console.log( "(" + i + ") %o", params );

            x += w;
            angle += delta;

            if( col === 2)
            {
                x = Style._safeLeft;
                y += h;
            }
        }

        this._selectable = true;

        return this;
    };

    return Gradient3TestScreen;

})();


/***/ }),
/* 228 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.Gradient4TestScreen = ( function()
{
    "use strict";

    Gradient4TestScreen.prototype = new Screen();

    function Gradient4TestScreen(){}

    Gradient4TestScreen.prototype.init = function()
    {
        var angle, delta;
        var alphas, colors;
        var alpha2, color2;
        var linear, radial;
        var params, gradient;
        var MONOCHROME = 0;

        var i;
        var x, y;
        var col, row;
        var ar = 4/3; // AspectRatio = width/height
        var h = 200;
        var w = h*ar;

        Screen.prototype.init.call( this );
        this._className = "Gradient4TestScreen";

        //this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        //this.addWidget( this._bg );
        this.addWidget( new ImageWidget().init( { url: _x2._config._imageRoot + "welcomeBg.jpg" } ) );

        this._grads = [];

        if( MONOCHROME ) // DEBUG grayscale
        {
            alphas =
            [
                {
                    opacity : 100,
                    location:   0
                },
                {
                    opacity : 100,
                    location: 100
                }
            ];
            colors =
            [
                {
                    color   : "#000000",
                    location: 0
                },
                {
                    color   : "#555555",
                    location: 100*1/3
                },
                {
                    color   : "#AAAAAA",
                    location: 100*2/3
                },
                {
                    color   : "#FFFFFF",
                    location: 100
                }
            ];
        }
        else
        {
            alphas =
            [
                {
                    opacity : 100,
                    location:   0
                },
                {
                    opacity :  50,
                    location: 100
                }
            ];
            colors =
            [
                {
                    color   : "#FF0000",
                    location: 0
                },
                {
                    color   : "#00FF00",
                    location: 100*1/3
                },
                {
                    color   : "#0000FF",
                    location: 100*2/3
                },
                {
                    color   : "#FFFFFF",
                    location: 100
                }
            ];
        }

        linear =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 0,
            alphas: alphas,
            colors: colors
        };

        radial =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Radial,
            alphas: alphas,
            colors: colors
        };

        x = Style._safeLeft;
        y = Style._safeTop;

        angle = 0;
        delta = 45;

        for( i = 0; i < 9; i++ )
        {
            col = i % 3;
            row =(i / 3) | 0;

            if( col === 0 )
            {
                switch( row )
                {
                    case 0: angle = 135; delta = -45; break;
                    case 1: angle = 180; delta =  90; break;
                    case 2: angle = 225; delta = +45; break;
                }
            }

            if( i !== 4 )
            {
                params = Object.assign( {}, linear );
                params.angle = angle;
            }
            else
            {
                params = Object.assign( {}, radial );
            }

            gradient = new GradientWidget().init( params );

            this._grads.push( gradient );
            this.addWidget( gradient, x, y );

//console.log( "(" + i + ") %o", params );

            x += w;
            angle += delta;

            if( col === 2)
            {
                x = Style._safeLeft;
                y += h;
            }
        }

        this._selectable = true;

        return this;
    };

    return Gradient4TestScreen;

})();


/***/ }),
/* 229 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

// AA = Animate Angle
// AR = Aspect Ratio
// GH = Gradient Hue
window.GradientAAARGHTestScreen = ( function()
{
    "use strict";

    GradientAAARGHTestScreen.prototype = new Screen();

    function GradientAAARGHTestScreen(){}

    GradientAAARGHTestScreen.prototype.init = function()
    {
        var angle, delta;
        var alphaC, colorC, linearC, paramsC, gradientC;
        var alphaG, colorG, linearG, paramsG, gradientG;

        var dim = 200;
        var ar = 1.0; // Aspect Ration = width/height
        var h = dim; // h = w / ar
        var w = dim; // w = h * ar

        var i;
        var x0 = Style._safeLeft;
        var x = x0 + dim + (dim*1.25) + (dim*1.5) + (dim*1.75) - (dim*0.5) - (dim*0.75), y = Style._safeTop;
        var col, row;

        Screen.prototype.init.call( this );
        this._className = "GradientAAARGHTestScreen";

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000033" } );
        this.addWidget( this._bg );

        this._gradsC = [];
        this._gradsG = [];

        alphaC = // Color / Chromatic
        [
            {
                opacity : 100,
                location:   0
            },
            {
                opacity :  50,
                location: 100
            }
        ];
        colorC =
        [
            {
                color   : "#FF0000",
                location: 0
            },
            {
                color   : "#00FF00",
                location: 100*1/3
            },
            {
                color   : "#0000FF",
                location: 100*2/3
            },
            {
                color   : "#FFFFFF",
                location: 100
            }
        ];

        alphaG = // Monochrome / Greyscale
        [
            {
                opacity : 100,
                location:   0,
            },
            {
                opacity : 100,
                location: 100
            }
        ];
        colorG =
        [
            {
                color   : "#000000",
                location: 0
            },
            {
                color   : "#555555",
                location: 100*1/3
            },
            {
                color   : "#AAAAAA",
                location: 100*2/3
            },
            {
                color   : "#FFFFFF",
                location: 100
            }
        ];

        linearC =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 45,
            alphas: alphaC,
            colors: colorC
        };
        linearG =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 45,
            alphas: alphaG,
            colors: colorG
        };

        var dim2      = 256;
        angle         = 0;
        this._angle   = angle;

        paramsC       = Object.assign( {}, linearC );
        paramsC.angle = angle;
        paramsC.w     = dim2;
        paramsC.h     = dim2;

        paramsG       = Object.assign( {}, linearG );
        paramsG.angle = angle;
        paramsG.w     = dim2;
        paramsG.h     = dim2;

        gradientC     = new GradientWidget().init( paramsC );
        gradientG     = new GradientWidget().init( paramsG );

        gradientC.setA( 1 );
        gradientG.setA( 0 );

        this._gradC  = gradientC;
        this._gradG  = gradientG;

        this.addWidget( gradientC, x0, y );
        this.addWidget( gradientG, x0, y );

        var fontSize = 36;
        var align    = "left";
        var color    = "#e5e500";
        var style    = new Style( { color:color, font:"light", fontSize:fontSize, whiteSpace:"nowrap", textAlign: align } );
        this._text   = new StringWidget().init( { text:"" + this._angle, style: style } );
        this.addWidget( this._text, x0 + dim2, y );

        /*
            i  AR    Row Col
            2  0.5   1   2
            3  0.75  1   3
            4  1.0   2   0
            5  1.25  2   1
            6  1.5   2   2
            7  1.75  2   3
            8  2.0   4   0
        */
        for( i = 2; i <= 8; i++ )
        {
            ar = i / 4; // 2 0
            w  = h * ar;

            paramsC = Object.assign( {}, linearC );
            paramsG = Object.assign( {}, linearG );

            paramsC.w = w;
            paramsG.w = w;

            gradientC = new GradientWidget().init( paramsC );
            gradientG = new GradientWidget().init( paramsG );

            gradientC.setA( 1 );
            gradientG.setA( 0 );

            this._gradsC.push( gradientC );
            this._gradsG.push( gradientG );

            this.addWidget( gradientC, x, y );
            this.addWidget( gradientG, x, y );

//console.log( "(" + i + ") %o", params );

            x += w;

            if( i === 3 )
            {
                x = x0;
               y += dim2;
            }
            if( i === 7 ) // CR at AR =1 .0
            {
                x = x0;
                y += h;
            }
        }

        // Angle Controller in Gradians, 0 = 0.0, 0.25 = 90, 0.50 = 180, 0.75 = 270, 1.0 = 360
        this._anim = new Widget().init();

        this._selectable = true;

        return this;
    };

    GradientAAARGHTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true, i;

        switch( val )
        {
            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                    this.updateAngle( -5.0 );
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                    this.updateAngle( +5.0 );
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                    this.updateAngle( +45.0 );
                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    this.updateAngle( -this._angle ); // force to zero
                break;

            case Host.KEY_ENTER: // Enter = Toggle Color / Monochrome
                if( type === Host.KEY_PRESSED )
                {
                    var alphaC = 1 - this._gradC.getA();
                    var alphaG = 1 - alphaC;

                    this._gradC.setA( alphaC );
                    this._gradG.setA( alphaG );

                    for( i = 0; i < this._gradsC.length; i++ )
                    {
                        this._gradsC[ i ].setA( alphaC );
                        this._gradsG[ i ].setA( alphaG );
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    GradientAAARGHTestScreen.prototype.updateAngle = function( delta )
    {
        var angle = this._angle + delta;

        if( angle <    0.0)
            angle += 360.0;

        if( angle >= 360.0)
            angle -= 360.0;

        this._angle = angle;
        this._text.setText( "" + this._angle );

        this._gradC.setAngle( angle );
        this._gradG.setAngle( angle );

        for( var i = 0; i < this._gradsC.length; i++ )
        {
            this._gradsC[ i ].setAngle( angle );
            this._gradsG[ i ].setAngle( angle );
        }
    };

    return GradientAAARGHTestScreen;

})();



/***/ }),
/* 230 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.HTMLStringTestScreen = ( function()
{
    "use strict";

    HTMLStringTestScreen.prototype = new Screen();

    function HTMLStringTestScreen(){}

    HTMLStringTestScreen.prototype.init = function()
    {
        var fontSize   = 60; // 28;
        var fontWeight = "light"; // "bold", "medium", "light"

        this._className = "HTMLStringTestScreen";
        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var style = new Style( { font:fontWeight, color:"#FFFF00", fontSize:fontSize, overflow:"hidden" } ); // yellow
        var text = "Test <font color='#80F'>Bar</font><br>"
                 + "<font color='#F00'>Hello World &lt; Normal</font><br>"
                 + "<font color='#0F0'><b>Hello World &lt; Bold</b></font><br>"
                 + "<font color='#00F'><i>Hello World &lt; Italic</i></font><br>"
                 + "<font color='#FFF'><b><i>Hello World &lt; Bold Italic</i></b></font><br>"
                 + "A <b>A</b> <i>A</i> <b><i>A</b></i>";
        this._htmlstring = new StringWidget().init( { text: text, style: style } );

        this.addWidget( this._htmlstring, Style._safeLeft, Style._safeTop );

        return this;
    };

    HTMLStringTestScreen.prototype.gotFocus = function()
    {
        _x2._hi.fadeOut();
    };

    HTMLStringTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    return HTMLStringTestScreen;

})();



/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



window.ImageTestScreen = ( function()
{
    ImageTestScreen.prototype = new Screen();

    function ImageTestScreen(){}

    ImageTestScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this, { noHeader:true } );
        this._className = "ImageTestScreen";

        var self  = this, staticOnLoad;
        var image = _x2._config._imageRootMso + "msoLogo.png";
        var stepX = (_x2._config._screenW - Style._safeLeft - Style._safeRight) / 5;
        var stepY = _x2._config._screenW / 10;
        var x0    = Style._safeLeft;
        var x1    = x0 + stepX;
        var x2    = x1 + stepX;
        var x3    = x2 + stepX;
        var x4    = x3 + stepX;
        var y0    = Style._safeTop;
        var y1    = y0 + stepY;
        var y2    = y1 + stepY;
        var y3    = y2 + stepY;
        var y4    = y3 + stepY;

        staticOnLoad = function()
        {
            var w  = self._imageW = self._naturalIm.getW();
            var h  = self._imageH = self._naturalIm.getH();

            self._h0.setX( x2 );
            self._h0.setY( y2 + h/2 );
            self._h1.setX( x2 );
            self._h1.setY( y2 + h/4 );
            self._h2.setX( x2 );
            self._h2.setY( y2 + h/4*3 );
            self._h3.setX( x2 );
            self._h3.setY( y2 - h/2 );
            self._h4.setX( x2 );
            self._h4.setY( y2 + h/2*3 );

            self._v0.setX( x2 + w/2 );
            self._v0.setY( y2 );
            self._v1.setX( x2 + w/4 );
            self._v1.setY( y2 );
            self._v2.setX( x2 + w/4*3 );
            self._v2.setY( y2 );
            self._v3.setX( x2 - w/2 );
            self._v3.setY( y2 );
            self._v4.setX( x2 + w/2*3 );
            self._v4.setY( y2 );
        };

        this._width0  = _x2.scaleVal( 150 );
        this._width1  = _x2.scaleVal( 400 );
        this._height0 = _x2.scaleVal(  75 );
        this._height1 = _x2.scaleVal( 150 );

        this._naturalIm = new ImageWidget().init( { url:image, name:"Natural", onLoad:staticOnLoad } );
        this._widthIm0  = new ImageWidget().init( { url:image, name:"Width" ,                  w:this._width0 } );
        this._widthIm1  = new ImageWidget().init( { url:image, name:"Width" ,                  w:this._width1 } );
        this._heightIm0 = new ImageWidget().init( { url:image, name:"Height", h:this._height0                 } );
        this._heightIm1 = new ImageWidget().init( { url:image, name:"Height", h:this._height1                 } );
        this._bothIm0   = new ImageWidget().init( { url:image, name:"Both0" , h:this._height0, w:this._width0 } );
        this._bothIm1   = new ImageWidget().init( { url:image, name:"Both1" , h:this._height1, w:this._width1 } );

        this._noScaleIm = new ImageWidget().init( { url:image, name:"No Scale" } );
        this._wScaleIm1 = new ImageWidget().init( { url:image, name:"wScale", xScale:0.5 } );
        this._hScaleIm1 = new ImageWidget().init( { url:image, name:"hScale", yScale:0.5 } );
        this._wScaleIm2 = new ImageWidget().init( { url:image, name:"wScale", xScale:2.0 } );
        this._hScaleIm2 = new ImageWidget().init( { url:image, name:"hScale", yScale:2.0 } );

        this._hLine0    = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#333333" } );
        this._hLine1    = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#333333" } );
        this._vLine0    = new RectWidget().init( { w:2, h:_x2._config._screenH, color: "#333333" } );
        this._vLine1    = new RectWidget().init( { w:2, h:_x2._config._screenH, color: "#333333" } );

        this._h0        = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#333333" } );
        this._h1        = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#333333" } );
        this._h2        = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#333333" } );
        this._h3        = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#666666" } );
        this._h4        = new RectWidget().init( { w:_x2._config._screenW, h:2, color: "#666666" } );

        this._v0        = new RectWidget().init( { h:_x2._config._screenH, w:2, color: "#333333" } );
        this._v1        = new RectWidget().init( { h:_x2._config._screenH, w:2, color: "#333333" } );
        this._v2        = new RectWidget().init( { h:_x2._config._screenH, w:2, color: "#333333" } );
        this._v3        = new RectWidget().init( { h:_x2._config._screenH, w:2, color: "#666666" } );
        this._v4        = new RectWidget().init( { h:_x2._config._screenH, w:2, color: "#666666" } );

        this._naturalIm.setA( 0.3  );
        this._bothIm1.setA  ( 0.15 );

        this.addWidget( this._hLine0, 0, y0 + this._height0 );
        this.addWidget( this._hLine1, 0, y0 + this._height1 );
        this.addWidget( this._vLine0, x0 + this._width0, 0 );
        this.addWidget( this._vLine1, x0 + this._width1, 0 );

        this.addWidget( this._h0 );
        this.addWidget( this._h1 );
        this.addWidget( this._h2 );
        this.addWidget( this._h3 );
        this.addWidget( this._h4 );

        this.addWidget( this._v0 );
        this.addWidget( this._v1 );
        this.addWidget( this._v2 );
        this.addWidget( this._v3 );
        this.addWidget( this._v4 );

        this.addWidget( this._naturalIm, x0, y0 );
        this.addWidget( this._widthIm0 , x0, y1 );
        this.addWidget( this._widthIm1 , x0, y2 );
        this.addWidget( this._heightIm0, x2, y0 );
        this.addWidget( this._heightIm1, x3, y0 );
        this.addWidget( this._bothIm0  , x0, y0 );
        this.addWidget( this._bothIm1  , x0, y0 );

        this.addWidget( this._noScaleIm, x2, y2 );
        this.addWidget( this._wScaleIm1, x2, y3 );
        this.addWidget( this._hScaleIm1, x3, y2 );
        this.addWidget( this._wScaleIm2, x2, y4 );
        this.addWidget( this._hScaleIm2, x4, y2 );

        return this;
    };

    ImageTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_SOFT_A:
                if( type === Host.KEY_PRESSED )
                {
                    this._widthIm0.setW ( undefined );
                    this._widthIm1.setW ( undefined );
                    this._heightIm0.setH( undefined );
                    this._heightIm1.setH( undefined );
                    this._bothIm0.setW  ( this._imageW );
                    this._bothIm0.setH  ( this._imageH );
                    this._bothIm1.setW  ( this._imageW );
                    this._bothIm1.setH  ( this._imageH );


                    this._wScaleIm1.setScaleX( 1 );
                    this._hScaleIm1.setScaleY( 1 );
                    this._wScaleIm2.setScaleX( 1 );
                    this._hScaleIm2.setScaleY( 1 );
                }
                break;

            case Host.KEY_SOFT_B:
                if( type === Host.KEY_PRESSED )
                {
                    this._widthIm0.setW ( this._width0  );
                    this._widthIm1.setW ( this._width1  );
                    this._heightIm0.setH( this._height0 );
                    this._heightIm1.setH( this._height1 );
                    this._bothIm0.setW  ( this._width0  );
                    this._bothIm0.setH  ( this._height0 );
                    this._bothIm1.setW  ( this._width1  );
                    this._bothIm1.setH  ( this._height1 );

                    this._wScaleIm1.setScaleX( 0.5 );
                    this._hScaleIm1.setScaleY( 0.5 );
                    this._wScaleIm2.setScaleX( 2.0 );
                    this._hScaleIm2.setScaleY( 2.0 );
                }
                break;

            case Host.KEY_SOFT_C:
                if( type === Host.KEY_PRESSED )
                {
                    this._widthIm0.animate ( { duration:2000, w:this._imageW } );
                    this._widthIm1.animate ( { duration:2000, w:this._imageW } );
                    this._heightIm0.animate( { duration:2000, h:this._imageH } );
                    this._heightIm1.animate( { duration:2000, h:this._imageH } );
                    this._bothIm0.animate  ( { duration:2000, h:this._imageH, w:this._imageW } );
                    this._bothIm1.animate  ( { duration:2000, h:this._imageH, w:this._imageW } );

                    this._wScaleIm1.animate( { duration:2000, xScale:1, yScale:1 } );
                    this._hScaleIm1.animate( { duration:2000, xScale:1, yScale:1 } );
                    this._wScaleIm2.animate( { duration:2000, xScale:1, yScale:1 } );
                    this._hScaleIm2.animate( { duration:2000, xScale:1, yScale:1 } );
                }
                break;

            case Host.KEY_SOFT_D:
                if( type === Host.KEY_PRESSED )
                {
                    this._widthIm0.animate ( { duration:2000, w:this._width0 } );
                    this._widthIm1.animate ( { duration:2000, w:this._width1  } );
                    this._heightIm0.animate( { duration:2000, h:this._height0 } );
                    this._heightIm1.animate( { duration:2000, h:this._height1 } );
                    this._bothIm0.animate  ( { duration:2000, h:this._height0, w:this._width0 } );
                    this._bothIm1.animate  ( { duration:2000, h:this._height1, w:this._width1 } );

                    this._wScaleIm1.animate( { duration:2000, xScale:0.5 } );
                    this._hScaleIm1.animate( { duration:2000, yScale:0.5 } );
                    this._wScaleIm2.animate( { duration:2000, xScale:2.0 } );
                    this._hScaleIm2.animate( { duration:2000, yScale:2.0 } );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return ImageTestScreen;

})();


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.ListAnimTestScreen = ( function()
{
    "use strict";

    ListAnimTestScreen.prototype = new Screen();

    function ListAnimTestScreen(){}

    ListAnimTestScreen.prototype.init = function()
    {
        var listParams = {};

        this._className = "ListAnimTestScreen";

        Screen.prototype.init.call( this );

        this.setW( _x2._config._screenW );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        listParams.w        = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        listParams.h        = _x2._config._screenH;
        listParams.maxIndex = 1;
        listParams.type     = RecordingRowWidget;
        this._list          = new ListWidget().init( listParams );
        this.addWidget( this._list, Style._safeLeft, Style._safeTop );

        this._data       = false;
        this._selectable = true;

        return this;
    };

    ListAnimTestScreen.prototype.gotFocus = function()
    {
        this.loadData();
        _x2.requestFocus( this._list );
    };

    ListAnimTestScreen.prototype.loadData = function()
    {
        if( !this._groups )
        {
            this._data = true;

            var r1 = new Recording().init( { name: 'Foo_1', derivedTitle: 'Foo' } );
            var r2 = new Recording().init( { name: 'Bar_2', derivedTitle: 'Bar' } );
            var r3 = new Recording().init( { name: 'Qux_3', derivedTitle: 'Qux' } );

            var g1 = new RecordingGroup().init( { name: 'Foo', numRecordings: 1 } );
            var g2 = new RecordingGroup().init( { name: 'Bar', numRecordings: 2 } );
            var g3 = new RecordingGroup().init( { name: 'Qux', numRecordings: 3 } );

            g1.addRecording( r1 );
            g2.addRecording( r2 );
            g3.addRecording( r3 );
            this._groups = [ g1, g2, g3 ];

            this._list.setData( this._groups );
        }
    };

    ListAnimTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    return ListAnimTestScreen;

})();



/***/ }),
/* 233 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.ListTestScreen = ( function()
{
    "use strict";

    ListTestScreen.prototype = new Screen();

    function ListTestScreen(){}

    ListTestScreen.prototype.gotFocus = function( lostFocus )
    {
        _x2.requestFocus( this._list );
    };

    ListTestScreen.prototype.init = function()
    {
        this._className = "ListTestScreen";

        Screen.prototype.init.call( this );

        this._bg   = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this._list = new ListWidget().init( { w:_x2._config._screenW/2                                        } );

        this.addWidget( this._bg                           );
        this.addWidget( this._list, _x2._config._screenW/4 );

        return this;
    };

    return ListTestScreen;

})();


/***/ }),
/* 234 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.LruCacheTestScreen = ( function()
{
    "use strict";

    LruCacheTestScreen.prototype = new Screen();

    function LruCacheTestScreen(){}

    LruCacheTestScreen.prototype.init = function()
    {
        this._className = "LruCacheTestScreen";

        Screen.prototype.init.call( this );

        this._cache = new LruCache( 5 );

//         this._cache.put( "one", "ONE" );
//         this._cache.dump();
//
//         this._cache.remove( "one" );
//         this._cache.dump();
//
//         this._cache.put( "one", "ONE" );
//         this._cache.put( "two", "TWO" );
//         this._cache.dump();
//
//         this._cache.put( "three", "THREE" );
//         this._cache.dump();

        return this;
    };

    LruCacheTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_1:
                if( type === Host.KEY_PRESSED )
                    this._cache.put( "one", "ONE", 1 );
                break;

            case Host.KEY_2:
                if( type === Host.KEY_PRESSED )
                    this._cache.put( "two", "TWO", 2 );
                break;

            case Host.KEY_3:
                if( type === Host.KEY_PRESSED )
                    this._cache.put( "three", "THREE", 1 );
                break;

            case Host.KEY_4:
                if( type === Host.KEY_PRESSED )
                    this._cache.put( "four", "FOUR", 2 );
                break;

            case Host.KEY_5:
                if( type === Host.KEY_PRESSED )
                    this._cache.put( "five", "FIVE", 1 );
                break;

            case Host.KEY_6:
                if( type === Host.KEY_PRESSED )
                    this._cache.remove( "one" );
                break;

            case Host.KEY_7:
                if( type === Host.KEY_PRESSED )
                    this._cache.remove( "two" );
                break;

            case Host.KEY_8:
                if( type === Host.KEY_PRESSED )
                    this._cache.remove( "three" );
                break;

            case Host.KEY_9:
                if( type === Host.KEY_PRESSED )
                    this._cache.remove( "four" );
                break;

            case Host.KEY_0:
                if( type === Host.KEY_PRESSED )
                    this._cache.remove( "five" );
                break;

            case Host.KEY_Q:
                if( type === Host.KEY_PRESSED )
                {
                    console.log( "GETTING ONE" );
                    console.log( "one = " + this._cache.get( "one" ) );
                }
                break;

            case Host.KEY_SOFT_D:
                if( type === Host.KEY_PRESSED )
                    this._cache.dump();
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return LruCacheTestScreen;

})();


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.MetricsTestScreen = ( function()
{
    "use strict";

    MetricsTestScreen.prototype = new Screen();

    function MetricsTestScreen(){}

    MetricsTestScreen.prototype.init = function()
    {
        var x = Style._safeLeft;
        var y = Style._safeTop;

        Screen.prototype.init.call( this );
        this._className = "MetricsTestScreen";

        this._queuedNow = 0;
        this._queuedOld = 0;

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var fontSize = 36;
        var align    = "left";
        var color1   = "#e5e500";
        var color2   = "#e5e5e5";
        var color3   = "#e50000";
        var style1   = new Style( { color:color1, font:"light", fontSize:fontSize, whiteSpace:"nowrap", textAlign: align } );
        var style2   = new Style( { color:color2, font:"light", fontSize:fontSize, whiteSpace:"nowrap", textAlign: align } );
        var style3   = new Style( { color:color3, font:"light", fontSize:fontSize, whiteSpace:"nowrap", textAlign: align } );

        this._label  = new StringWidget().init( { text:"Queued:", style: style1 } );
        this.addWidget( this._label, x, y );

        x = _x2._config._screenW * 0.2;
        this._text   = new StringWidget().init( { text:"?", style: style2 } );
        this.addWidget( this._text, x, y );

        x  = Style._safeLeft;
        y += fontSize;
        this._error  = new StringWidget().init( { text:"Error sending", style: style3 } );
        this._error.setA( 0 );
        this.addWidget( this._error, x, y );

        return this;
    };

    MetricsTestScreen.prototype.layout = function()
    {
        this._ready = true;
    };

    MetricsTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                    this.queueChange( 'tagScreen', 'Search' );
                break;

            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                    this.queueChange( 'tagScreen', 'Help' );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    MetricsTestScreen.prototype.queueChange = function( key, val )
    {
        var before, after;

        before = ll.q.length;
        ll( key, val );
        after  = ll.q.length;

        this._queuedOld = this._queuedNow;
        this._queuedNow = after;

        if( (after - before) > 0)
            this._error.setA( 0 );
        else
            this._error.setA( 1 );

        this._text.setText( this._queuedNow );
    }

    MetricsTestScreen.prototype.update = function( step, alphaParent )
    {
        var now = ll.q.length;

        if( now != this._queuedNow )
        {
            this._text.setText( '' + now + ' ( ' + this._queuedNow + ' )' );
            this._queuedNow = now;
        }

        Screen.prototype.update.call( this, step, alphaParent );
    };

    return MetricsTestScreen;

})();



/***/ }),
/* 236 */
/***/ (function(module, exports) {

// Copyright (C) 2018 Comcast Corporation, All Rights Reserved

window.MultiStateButtonTestScreen = ( function()
{
    "use strict";

    MultiStateButtonTestScreen.prototype = new Screen();

    function MultiStateButtonTestScreen(){}

    MultiStateButtonTestScreen.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._buttons[this._index] );
    };

    MultiStateButtonTestScreen.prototype.init = function()
    {
        Screen.prototype.init.call( this );
        this._className = "MultiStateButtonTestScreen";

        this._index   = 0;
        this._buttons = [];

        var onEnter = function( state )
        {
            console.log( "==============> STATE = " + state );
        };

        var buttonData =
        [
            {
                initial:0,
                onEnter:onEnter,
                label  :"Closed Captioning: ",
                images :[
                            _x2._config._imageRoot + "cc.png",
                            _x2._config._imageRoot + "ccHi.png",
                            _x2._config._imageRoot + "ccSelected.png",
                            _x2._config._imageRoot + "ccSelectedHi.png"
                        ]
            },
            {
                initial:1,
                label  :"Video Description: ",
                images :[
                            _x2._config._imageRoot + "dv.png",
                            _x2._config._imageRoot + "dvHi.png",
                            _x2._config._imageRoot + "dvSelected.png",
                            _x2._config._imageRoot + "dvSelectedHi.png"

                        ]
            },
            {
                initial:0,
                label  :"Secondary Audio: ",
                images :[
                            _x2._config._imageRoot + "sap.png",
                            _x2._config._imageRoot + "sapHi.png",
                            _x2._config._imageRoot + "sapSelected.png",
                            _x2._config._imageRoot + "sapSelectedHi.png"
                        ]
            }
        ];

        for( var i = 0; i < buttonData.length; i++ )
        {
            this._buttons[i] = new MultiStateButtonWidget().init( buttonData[i] );

            this.addWidget( this._buttons[i], Style._safeLeft + i * 75, _x2._config._screenH / 4 );
        }

        return this;
    };

//     MultiStateButtonTestScreen.prototype.layout = function()
//     {
//         this._ring.setX( (this.getW() - this._ring.getW()) / 2 );
//         this._ring.setY( (this.getH() - this._ring.getH()) / 2 );
//
//         this._ready = true;
//     };

    MultiStateButtonTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index > 0 )
                        _x2.requestFocus( this._buttons[--this._index] );
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._index < this._buttons.length - 1 )
                        _x2.requestFocus( this._buttons[++this._index] );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return MultiStateButtonTestScreen;

})();


/***/ }),
/* 237 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.NineSliceTestScreen = ( function()
{
    "use strict";

    NineSliceTestScreen.prototype = new Screen();

    function NineSliceTestScreen(){}

    NineSliceTestScreen.prototype.init = function()
    {
        var self = this;
        this._className = "NineSliceTestScreen";

        Screen.prototype.init.call( this );

        var inner2Str = [ "playProgressFilled_3_3_3_3.png", "playProgressFilled_3_3_3_3.png", "playProgressFilled_3_3_3_3.png", "playProgressFilled_5_5_5_5.png" ][_x2._config._layout];

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        // test inner positioning

        this._topInner = new RectWidget().init( { w:200, h:50, color:"#003333" } );
        this._botInner = new RectWidget().init( { w:200, h:50, color:"#003333" } );
        this._inner    = new NineSliceWidget().init( { url:_x2._config._imageRoot + "selection_0_0_5_5.png", w:100, h:50 } );

        this.addWidget( this._topInner, Style._safeLeft, Style._safeTop       );
        this.addWidget( this._botInner, Style._safeLeft, Style._safeTop + 100 );
        this.addWidget( this._inner                                           );

        this._inner.setPosition( { x:Style._safeLeft + 50, y:Style._safeTop + 50, w:100, h:50, inner:true } );

        // test outer positioning

        this._midOuter = new RectWidget().init( { w:200, h:50, color:"#003333" } );
        this._outer    = new NineSliceWidget().init( { url:_x2._config._imageRoot + "selection_0_0_5_5.png", w:100, h:50 } );

        this.addWidget( this._midOuter, Style._safeLeft + 200, Style._safeTop + 50 );
        this.addWidget( this._outer                                                );

        this._outer.setPosition( { x:Style._safeLeft + 250, y:Style._safeTop + 50, w:100, h:50, inner:false } );

        //

        this._leftInner2  = new RectWidget().init( { w:50, h:150, color:"#003333" } );
        this._rightInner2 = new RectWidget().init( { w:50, h:150, color:"#003333" } );
        this._inner2      = new NineSliceWidget().init( { url:_x2._config._imageRoot + inner2Str, w:100, h:50 } );
        this._topInner2   = new RectWidget().init( { w:50, h: 50, color:"#003333" } );
        this._botInner2   = new RectWidget().init( { w:50, h: 50, color:"#003333" } );

        this.addWidget( this._leftInner2 , Style._safeLeft      , Style._safeTop + 200 );
        this.addWidget( this._rightInner2, Style._safeLeft + 150, Style._safeTop + 200 );
        this.addWidget( this._inner2     , Style._safeLeft +  50, Style._safeTop + 250 );
        this.addWidget( this._topInner2  , Style._safeLeft +  75, Style._safeTop + 200 );
        this.addWidget( this._botInner2  , Style._safeLeft +  75, Style._safeTop + 300 );

        this._inner2.setPosition( { x:Style._safeLeft + 50, y:Style._safeTop + 250, w:100, h:50, inner:true } );

        //

        this._outer2  = new NineSliceWidget().init( { url:_x2._config._imageRoot + inner2Str, w:100, h:50 } );
        this._midOver = new RectWidget().init( { w:100, h:50, color:"#000055" } );

        this.addWidget( this._outer2  );
        this.addWidget( this._midOver, Style._safeLeft + 250, Style._safeTop + 250 );

        this._outer2.setPosition( { x:Style._safeLeft + 250, y:Style._safeTop + 250, w:100, h:50, inner:false } );

        var file = [ "", "", "thumb_6_6_7_7.png", "thumb_13_13_14_14" ][_x2._config._layout];

        var x = _x2._config._screenW * 0.5;
        var y = Style._safeTop;

        // Test Static setH()
        this._thumb = new NineSliceWidget().init( { url:_x2._config._imageRoot + file } );
        this.addWidget( this._thumb, x, y );
        this._thumb.setH( 200 );
        this._thumb.name = "setH200";

        // Test Dynamic setPosition()
        this._pos = new NineSliceWidget().init( { url:_x2._config._imageRoot + file } );
        this.addWidget( this._pos, x + 50, y );
        this._pos.name = "setPos200";

        //  HorizPillButton
        this._pill = new NineSliceWidget().init( { url:_x2._config._imageRoot + Style._pillFile } );
        this.addWidget( this._pill, x + 100, y );

        this._resize = new NineSliceWidget().init( { url:_x2._config._imageRoot + Style._pillHiFile } );
        this._resize.addReadyCallback( function() { self.queryNineSlice(); } );
        this.addWidget( this._resize, x + 160, y );

        this._selectable = true;

        return this;
    };

    NineSliceTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
             case Host.KEY_1:
                if( type === Host.KEY_PRESSED )
                    if( this._inner.getVal( Widget.ALPHA ) === 0 )
                    {
                        this._inner.setVal ( Widget.ALPHA, 1 );
                        this._outer.setVal ( Widget.ALPHA, 1 );
                        this._inner2.setVal( Widget.ALPHA, 1 );
                        this._outer2.setVal( Widget.ALPHA, 1 );
                    }
                    else
                    {
                        this._inner.setVal ( Widget.ALPHA, 0 );
                        this._outer.setVal ( Widget.ALPHA, 0 );
                        this._inner2.setVal( Widget.ALPHA, 0 );
                        this._outer2.setVal( Widget.ALPHA, 0 );
                    }
                break;

        // Dynamic Height
            case Host.KEY_CH_UP:
            case Host.KEY_EQUAL:
                if( type === Host.KEY_PRESSED )
                    this._pos.setPosition( { w:this._posW, h:this._posH, inner:true } );
                break;

            case Host.KEY_CH_DOWN:
            case Host.KEY_MINUS:
                if( type === Host.KEY_PRESSED )
                    this._pos.setPosition( { w:0, h:200, inner:true } );
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    NineSliceTestScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        this._posW = this._pos.getW();
        this._posH = this._pos.getH();

//console.log( "Static.setH()   : " + this._thumb.getW() + " x " + this._thumb.getH() );
//console.log( "Dynamic.setPos(): " + this._posW + " x " + this._posH );

        this._resize.callbackSignalReady();
    };

    NineSliceTestScreen.prototype.queryNineSlice = function()
    {
        var w1 = this._resize.getW();
        this._resize.setW( w1*2 );

        var w2 = this._resize.getW();

console.log( "Resized: " + w1 + " -> " + w1*2 );
console.log( "Actual.w = " + w2 );
        var fail = (w1*2) === w2;
        if( fail )
        {
            var border = this._resize.getInsetX();
            console.error( "ERROR: getW() is not accurate. Should be: " + 2*(w1+border) );
        }
    };

    return NineSliceTestScreen;

})();


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.NineSliceShadowTestScreen = ( function()
{
    "use strict";

    NineSliceShadowTestScreen.prototype = new Screen();

    function NineSliceShadowTestScreen(){}

    NineSliceShadowTestScreen.prototype.init = function()
    {
        var i, x = Style._safeLeft, obj, colorGrad0, colorGrad1;

        Screen.prototype.init.call( this );
        this._className = "NineSliceShadowTestScreen";

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        // GalleryCellWidget
        var params = {};
        this._imageX = params.bgX = _x2.scaleValInt( 18 );
        this._imageW = params.bgW = _x2.scaleValInt( 270 );
        this._imageH = params.bgH = _x2.scaleValInt( 360 );
        this._scale  = params.bgScale = (this._imageW + 2 * this._imageX) / this._imageW;
        this._imageY = params.bgY = (this._scale - 1) * this._imageH / 2;

        // CollectionCellWidget
        var gradientParams    = {};
        gradientParams.w      = params.bgW;
        gradientParams.h      = params.bgH;
        gradientParams.type   = GradientWidget.Type.Linear;
        gradientParams.angle  = -224;
        gradientParams.alphas = [{ location: 0, opacity: 100 }, { location: 100, opacity: 75 }];
        gradientParams.colors = [{ color: '#202A33', location: 0 }, { color: '#160A1A', location: 100 }];

        this._focusObj = { inner:false, duration:ListWidget.SCROLL_TIME_STEP, w:params.bgW, h:params.bgH, easing:Widget.Easing.LINEAR };
        this._objs     = [];

        for( i = 0; i < 7; i++ )
        {
            if( (i >= 3) && (i < 7) )
            {
                if (i === 3) { colorGrad0 = '#800'; colorGrad1 = '#F00'; }
                if (i === 4) { colorGrad0 = '#080'; colorGrad1 = '#0F0'; }
                if (i === 5) { colorGrad0 = '#008'; colorGrad1 = '#00F'; }
                if (i === 6) { colorGrad0 = '#888'; colorGrad1 = '#FFF'; }
                gradientParams.colors = [{ color: colorGrad0, location: 0 }, { color: colorGrad1, location: 100 }];
            }

            if( i === 0 )
                obj = new ImageWidget().init( { url:_x2._config._imageRoot + "view_all_tile.png", w:params.bgW, h:params.bgH } );
            else
                obj = new GradientWidget().init( gradientParams );

            this._objs.push( obj );
            this.addWidget( obj, x, Style._safeTop );

            x +=  params.bgW + Style._pad;
        }

        this._col = 0;

        this._selectable = true;

        return this;
    };

    NineSliceShadowTestScreen.prototype.gotFocus = function()
    {
        _x2._shadow.animate( { alpha:1, duration:ListWidget.SCROLL_TIME_STEP } );
        this.updateHighlight( false );
    };

    NineSliceShadowTestScreen.prototype.lostFocus = function()
    {
        _x2._shadow.stopAnimation( Widget.ALPHA );
        _x2._shadow.setA( 0 );
    };

    NineSliceShadowTestScreen.prototype.processEvent = function( val, type )
    {
        var retval;

        switch( val )
        {
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._col > 0 )
                        this._col--;

                    this.updateHighlight( true );
                }
                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._col < (this._objs.length - 1) )
                        this._col++;
                    this.updateHighlight( true );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    NineSliceShadowTestScreen.prototype.updateHighlight = function( animate )
    {
        var xy       = this._objs[ this._col ].getGlobalPos();
        var focusObj = this._focusObj; // NOTE: Isn't deep copy ...
            focusObj.x        = xy.x;
            focusObj.y        = xy.y;
            focusObj.duration = animate ? ListWidget.SCROLL_TIME_STEP : 0;

        _x2._hi.stopAnimation( Widget.X );
        _x2._hi.stopAnimation( Widget.Y );

        if( animate )
            _x2._hi.animate( focusObj );
        else
            _x2._hi.setPosition( focusObj ); // ... (re)sets duration to zero if not specified
    };

    return NineSliceShadowTestScreen;

})();


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.RectColorTestScreen = ( function()
{
    "use strict";

    RectColorTestScreen.prototype = new Screen();

    function RectColorTestScreen(){}

    RectColorTestScreen.prototype.init = function()
    {
        var w = _x2._config._screenW / 4;
        var h = _x2._config._screenH / 4;

        var inside = "#444444";
        var skirt  = "#006666";

        this._className = "RectColorTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        // Inside only
        this._rect = new RectWidget().init( { w:_x2._config._screenW / 4, h:_x2._config._screenH / 4, color:skirt } );
        this._rect.setVal( Widget.ALPHA, 0.5 );
        this.addWidget( this._rect, Style._safeLeft, Style._safeTop );

        // Inside + Uniform border thickness
        this._borderRect = new RectWidget().init( { w:w - 6, h:h - 6, color:inside, borderColor:skirt, borderThickness:3 } );
        this.addWidget( this._borderRect, Style._safeLeft, Style._safeTop + h + 10 );

        // Inside + Varying border thickness
        this._borderRect2 = new RectWidget().init( { w:w - 18, h:h - 12, color:inside, borderColor:skirt, borderThickness:[ 3, 6, 9, 12] } );
        this.addWidget( this._borderRect2, Style._safeLeft, Style._safeTop + 2*h + 20 );

        // Border only
        this._borderOnly = new RectWidget().init( { w:w - 18, h:h - 12, borderColor:"#00FF00", borderThickness:[ 3, 6, 9, 12] } );
        this.addWidget( this._borderOnly, Style._safeLeft + 0.5*w, Style._safeTop + 0.5*h );

        return this;
    };

    RectColorTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return RectColorTestScreen;

})();


/***/ }),
/* 240 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.RectAnimTestScreen = ( function()
{
    "use strict";

    RectAnimTestScreen.prototype = new Screen();

    function RectAnimTestScreen(){}

    RectAnimTestScreen.prototype.init = function()
    {
        var self = this;
        var i, colorStr;
        var paramW, paramH;
        var top, bot, left, right;
        var narrow, short;
        var border = 3;

        this._className = "RectAnimTestScreen";
        this._border    = border;

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._aniRect = new RectWidget().init( { w:_x2._config._screenW / 4 - 2*border, h:_x2._config._screenH / 4 - 2*border, color:"#222222", borderColor:"#963", borderThickness:border } );
        this.addWidget( this._aniRect, Style._safeLeft + _x2._config._screenW / 4 + 30, Style._safeTop );

        // Boundary Borders for animation
        paramW = { h:1, w:_x2._config._screenW, color:"#4444FF" };
        paramH = { w:1, h:_x2._config._screenH, color:"#44FF44" };

        this._grid = [];
        this._grid[0] = new RectWidget().init( paramW ); // top
        this._grid[1] = new RectWidget().init( paramW ); // bot
        this._grid[2] = new RectWidget().init( paramH ); // left
        this._grid[3] = new RectWidget().init( paramH ); // right

        top   = Style._safeTop;
        bot   = top  + (_x2._config._screenH / 2) - 2*this._border;
        left  = (Style._safeLeft + _x2._config._screenW / 4 + 30);
        right = left + (_x2._config._screenW / 2) - 2*this._border;

        this.addWidget( this._grid[0],         0, top - 1 );
        this.addWidget( this._grid[1],         0, bot + 0 );
        this.addWidget( this._grid[2], left  - 1,       0 );
        this.addWidget( this._grid[3], right + 0,       0 );

        narrow = _x2._config._screenW / 4 - 2*this._border;
        short  = _x2._config._screenH / 4 - 2*this._border;

        this._grid[4] = new RectWidget().init( { h:1, w:_x2._config._screenW, color:"#111144" } ); // center x
        this._grid[5] = new RectWidget().init( { w:1, h:_x2._config._screenH, color:"#114411" } ); // center y

        this.addWidget( this._grid[4],                         0, top + short + 2*border );
        this.addWidget( this._grid[5], left + narrow +  2*border,                      0 );

        // Axis Toggle
        var style = new Style( { color:"#e5e5e5", font:"light", fontSize:14, whiteSpace:"nowrap", textAlign:"center" } );
        var labels = [ 'A', 'X', 'Y', 'W', 'H' ];
        var str, key, box;
        var y = _x2._config._screenH - Style._safeBottom - 16;

        this._labels = [];
        for( i = 0; i < 10; ++i )
        {
            colorStr = (i < 5)
                ? "#880000" // off
                : "#00FF00";// on
            this._labels[ i ] = new RectWidget().init( { w:15, h:15, color: colorStr } );
            this._labels[ i ].setA( 0 );

            var x = Style._safeLeft + ((i % 5) * 16);

            this.addWidget( this._labels[ i ], x, y );

            if( i % 2 === 0 )
            {
                var j = (i/2)|0;
                x = Style._safeLeft + (j * 16);

                str = new StringWidget().init( { text:labels[j], style:style } );
                str.setW( 16 );
                this.addWidget( str, x, y - 16 );

                key = new StringWidget().init( { text:'' + (j+1), style:style } );
                key.setW( 16 );
                this.addWidget( key, x, y + 16 + 2 );

                box = new RectWidget().init( { w: 13, h: 13, borderColor: "#cccccc", borderThickness:1 } );
                this.addWidget( box, x, y + 16 + 3 );
            }
        }

        this._animAllOn = function()
        {
            self._animA = 1;
            self._animX = 1;
            self._animY = 1;
            self._animW = 1;
            self._animH = 1;
            self.layout();
        };

        this._animAllOn();

        return this;
    };

    RectAnimTestScreen.prototype.layout = function()
    {
        var state =
        [
            this._animA | 0,
            this._animX | 0,
            this._animY | 0,
            this._animW | 0,
            this._animH | 0
        ];

        var i, a;
        for( i = 0; i < state.length; ++i )
        {
            a = state[ i ];
            this._labels[ i   ].setA( 1-a ); // state=0 -> alpha=0
            this._labels[ i+5 ].setA(   a ); // state=1 -> alpha=1
        }
    };

    RectAnimTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        var top    = Style._safeTop;
        var bot    = top + (_x2._config._screenH / 2) - 2*this._border;
        var left   = Style._safeLeft + _x2._config._screenW / 4 + 30;
        var right  = left + (_x2._config._screenW / 2) - 2*this._border;

        var narrow = _x2._config._screenW / 4 - 2*this._border;
        var wide   = 2 * narrow;
        var short  = _x2._config._screenH / 4 - 2*this._border;
        var tall   = 2 * short;

        var alpha, i;
        var self   = this;

        var onEndX = function()
        {
            if( self._animX )
                if( self._aniRect.getVal( Widget.X ) === right )
                    self._aniRect.animate( aniLeft );
                else if( self._aniRect.getVal( Widget.X ) === left )
                    self._aniRect.animate( aniRight );
        };

        var onEndY = function()
        {
            if( self._animY )
                if( self._aniRect.getVal( Widget.Y ) === bot )
                    self._aniRect.animate( aniUp );
                else if( self._aniRect.getVal( Widget.Y ) === top )
                    self._aniRect.animate( aniDown );
        };

        var onEndW = function()
        {
            if( self._animW )
                if( self._aniRect.getVal( Widget.W ) === (wide - 2*self._border) )
                    self._aniRect.animate( aniNarrow );
                else //if( self._aniRect.getVal( Widget.W ) === narrow )
                    self._aniRect.animate( aniWide );
        };

        var onEndH = function()
        {
            if( self._animH )
                if( self._aniRect.getVal( Widget.H ) === (tall -2*self._border) )
                    self._aniRect.animate( aniShort );
                else //if( self._aniRect.getVal( Widget.H ) === short )
                    self._aniRect.animate( aniTall );
        };

        var onEndA = function()
        {
            if( self._animA )
                if( self._aniRect.getVal( Widget.ALPHA ) === 1.0 )
                    self._aniRect.animate( aniFade );
                else if( self._aniRect.getVal( Widget.ALPHA ) === 0.3 )
                    self._aniRect.animate( aniOpaque );
        };

        var aniDown   = { duration:1000, y:bot    , onEnd:onEndY, onEndAxis:Widget.Y     };
        var aniUp     = { duration:1000, y:top    , onEnd:onEndY, onEndAxis:Widget.Y     };
        var aniRight  = { duration:4000, x:right  , onEnd:onEndX, onEndAxis:Widget.X     };
        var aniLeft   = { duration:4000, x:left   , onEnd:onEndX, onEndAxis:Widget.X     };
        var aniWide   = { duration:3000, w:wide   , onEnd:onEndW, onEndAxis:Widget.W     };
        var aniNarrow = { duration:3000, w:narrow , onEnd:onEndW, onEndAxis:Widget.W     };
        var aniTall   = { duration:1500, h:tall   , onEnd:onEndH, onEndAxis:Widget.H     };
        var aniShort  = { duration:1500, h:short  , onEnd:onEndH, onEndAxis:Widget.H     };
        var aniFade   = { duration:5000, alpha:0.3, onEnd:onEndA, onEndAxis:Widget.ALPHA };
        var aniOpaque = { duration:5000, alpha:1.0, onEnd:onEndA, onEndAxis:Widget.ALPHA };

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._animY ) this._aniRect.animate( aniDown  );
                    if( this._animX ) this._aniRect.animate( aniRight );
                    if( this._animW ) this._aniRect.animate( aniWide  );
                    if( this._animH ) this._aniRect.animate( aniTall  );
                    if( this._animA ) this._aniRect.animate( aniFade  );
                }
                break;

            case Host.KEY_0:
                if( type === Host.KEY_PRESSED )
                {
                    this._aniRect.setY( top     );
                    this._aniRect.setX( left    );
                    this._aniRect.setW( narrow  );
                    this._aniRect.setH( short   );
                    this._aniRect.setA( 1       );

                    this._animA = 0;
                    this._animX = 0;
                    this._animY = 0;
                    this._animW = 0;
                    this._animH = 0;
                    this.layout();

                    this._aniRect.stopAnimation( Widget.Y     );
                    this._aniRect.stopAnimation( Widget.X     );
                    this._aniRect.stopAnimation( Widget.W     );
                    this._aniRect.stopAnimation( Widget.H     );
                    this._aniRect.stopAnimation( Widget.ALPHA );
                }
                break;

            case Host.KEY_1:
                if( type === Host.KEY_PRESSED )
                {
                    this._animA = !this._animA;
                    if( this._animA ) this._aniRect.animate( aniFade  );
                    this.layout();
                }
                break;

            case Host.KEY_2:
                if( type === Host.KEY_PRESSED )
                {
                    this._animX = !this._animX;
                    if( this._animX ) this._aniRect.animate( aniRight );
                    this.layout();
                }
                break;

            case Host.KEY_3:
                if( type === Host.KEY_PRESSED )
                {
                    this._animY = !this._animY;
                    if( this._animY ) this._aniRect.animate( aniDown  );
                    this.layout();
                }
                break;

            case Host.KEY_4:
                if( type === Host.KEY_PRESSED )
                {
                    this._animW = !this._animW;
                    if( this._animW ) this._aniRect.animate( aniWide  );
                    this.layout();
                }
                break;

            case Host.KEY_5:
                if( type === Host.KEY_PRESSED )
                {
                    this._animH = !this._animH;
                    if( this._animH ) this._aniRect.animate( aniTall  );
                    this.layout();
                }
                break;

            case Host.KEY_6:
                if( type === Host.KEY_PRESSED )
                {
                    alpha = 1 - this._grid[0].getA();

                    for( i = 0; i < this._grid.length; i++ )
                        this._grid[ i ].setA( alpha );
                }
                break;

            case Host.KEY_8:
                if( type === Host.KEY_PRESSED )
                {
                    this._aniRect.setY( top     );
                    this._aniRect.setX( left    );
                    this._aniRect.setW( narrow  );
                    this._aniRect.setH( short   );
                    this._aniRect.setA( 1       );
                }
                break;

            case Host.KEY_9:
                if( type === Host.KEY_PRESSED )
                    this._animAllOn();
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return RectAnimTestScreen;

})();


/***/ }),
/* 241 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.RingDistractorTestScreen = ( function()
{
    "use strict";

    RingDistractorTestScreen.prototype = new Screen();

    function RingDistractorTestScreen(){}

    RingDistractorTestScreen.prototype.init = function()
    {
        var self = this;
        this._className = "RingDistractorTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._ring = new RingDistractorWidget().init( {period:2000} );
        this._ring.addReadyCallback( function() { self.layout(); } );
        this.addWidget( this._ring );

        return this;
    };

    RingDistractorTestScreen.prototype.layout = function()
    {
        this._ring.setX( (this.getW() - this._ring.getW()) / 2 );
        this._ring.setY( (this.getH() - this._ring.getH()) / 2 );

        this._ready = true;
    };

    RingDistractorTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._ring.isAnimating() )
                        this._ring.clear();
                    else
                    {
                        this._ring.clear();
                        this._ring.spin();
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return RingDistractorTestScreen;

})();



/***/ }),
/* 242 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.ScrollTestScreen = ( function()
{
    "use strict";

    ScrollTestScreen.prototype = new Screen();

    function ScrollTestScreen(){}

    ScrollTestScreen.prototype.init = function()
    {
        this._className = "ScrollTestScreen";

        Screen.prototype.init.call( this );

        var w = _x2._config._screenW;
        var h = _x2._config._screenH;

        this._bg = new RectWidget().init( { w:w, h:h, color:"#000000" } );
        this.addWidget( this._bg );

        var x1 = 100, y1 = 100;
        var w1 = w - 2*(Style._safeLeft + Style._safeRight ) - x1;
        var h1 = h - 2*(Style._safeTop  + Style._safeBottom) - y1;

        var x2 = Style._safeLeft, y2 = -y1 + 2*Style._safeLeft;
        var w2 = w1;
        var h2 = h1;

        var x3 = 2*Style._safeLeft, y3 = 4*Style._safeTop;
        var w3 = w2*0.75;
        var h3 = h2*0.75;

        this._contain = new Widget().init();

        this._rect1   = new RectWidget().init( { w:w1  , h:h1  , color:"#400000", borderThickness:2, borderColor:"#FF8080" } );
        this._rect2   = new RectWidget().init( { w:w2  , h:h2  , color:"#004000", borderThickness:2, borderColor:"#80FF80" } );
        this._rect3   = new RectWidget().init( { w:w3-4, h:h3-4, color:"#000040", borderThickness:2, borderColor:"#0000FF" } );
        this._rect1.setA( 0.5 );
        this._rect2.setA( 0.5 );
        this._rect3.setA( 0.5 );

        var path1 = { url: _x2._config._imageRoot    + "welcomeBg.jpg"    };
        //  path2 = { url: _x2._config._imageRootMso + "splashScreen.jpg" };
        this._image1 = new ImageWidget().init( path1 );
        this._contain.addWidget( this._image1 );

        this.         addWidget( this._rect2, x1+x2-2, y1+y2-2 );
        this.         addWidget( this._rect1, x1   -2, y1   -2 );

        // width, height, containerWidget, safeLeft, safeRight, safeTop, safeBottom, callback, onProgress
        this._scroll3 = new ScrollWidget().init( {w:w3, h:h3, widget:this._contain } );
        this._scroll2 = new ScrollWidget().init( {w:w2, h:h1, widget:this._scroll3 } );
        this._scroll1 = new ScrollWidget().init( {w:w1, h:h1, widget:this._scroll2 } );

        this._scroll3.addWidget( this._rect3,       0,       0 );

        this.addWidget( this._scroll1, x1, y1 );
        this._contain.setW( w2 );
        this._contain.setH( w3 );
        this._scroll3.setX( x3 );
        this._scroll3.setY( y3 );
        this._scroll2.setX( x2 );
        this._scroll2.setY( y2 );

        // Labels
        var fontSize = 16;

        var headStyle = new Style( { font:"light", color:"#007FFF", fontSize:fontSize, whiteSpace:"nowrap", overflow:"hidden" } );
        var bodyStyle = new Style( { font:"light", color:"#ffffff", fontSize:fontSize, whiteSpace:"nowrap", overflow:"hidden" } );
        var descStyle = new Style( { font:"light", color:"#FFFF00", fontSize:fontSize, whiteSpace:"nowrap", overflow:"hidden" } );

        this._string1 = new StringWidget().init( { style:headStyle } );
        this._string2 = new StringWidget().init( { style:headStyle } );
        this._string3 = new StringWidget().init( { style:headStyle } );
        this._string0 = new StringWidget().init( { style:bodyStyle } );

        this._desc1   = new StringWidget().init( { style:bodyStyle, text:"3 nested scroll panes" } );
        this._desc2   = new StringWidget().init( { style:bodyStyle, text:"Move Scroll Location:" } );
        this._desc3   = new StringWidget().init( { style:bodyStyle, text:"Move Scroll Contents:" } );

        this._keys2   = new StringWidget().init( { style:descStyle, text:"Up, Down, Left, Right" } );
        this._keys3   = new StringWidget().init( { style:descStyle, text:"1, 2, 3, 4"            } );

        this.addWidget( this._scroll1, x1, y1 );
        this.addWidget( this._string1, Style._safeLeft, Style._safeTop            );
        this.addWidget( this._string2, Style._safeLeft, Style._safeTop + fontSize );
        this.addWidget( this._string3, w*0.35         , Style._safeTop            );
        this.addWidget( this._string0, w*0.35         , Style._safeTop + fontSize );

        this.addWidget( this._desc1  , w*0.60         , Style._safeTop + fontSize*0 );
        this.addWidget( this._desc2  , w*0.60         , Style._safeTop + fontSize*1 );
        this.addWidget( this._desc3  , w*0.60         , Style._safeTop + fontSize*2 );

        this.addWidget( this._keys2  , w*0.75         , Style._safeTop + fontSize*1 );
        this.addWidget( this._keys3  , w*0.75         , Style._safeTop + fontSize*2 );

        this._x       = 0;
        this._y       = 0;

        this._offsetX = 0;
        this._offsetY = 0;

        this._selectable = true;

        return this;
    };

    ScrollTestScreen.prototype.layout = function()
    {
        var w = this._contain.getW();
        var h = this._contain.getH();

        this._string1.setText( "Scroll 1  @ " + Math.floor( this._scroll1.getX() ) + "," + Math.floor( this._scroll1.getY() ) );
        this._string2.setText( "Scroll 2  @ " + Math.floor( this._scroll2.getX() ) + "," + Math.floor( this._scroll2.getY() ) );
        this._string3.setText( "Scroll 3  @ " + Math.floor( this._scroll3.getX() ) + "," + Math.floor( this._scroll3.getY() ) );
        this._string0.setText( "Container @ " + Math.floor( this._contain.getX() ) + "," + Math.floor( this._contain.getY() ) + "  WxH: " + w + "x" + h );

        var x  = this._desc1.getX();
        var w1 = this._desc1.getW();
        var w2 = this._desc2.getW();
        var w3 = this._desc3.getW();

        w = w1;
        if( w2 > w ) w = w2;
        if( w3 > w ) w = w3;

        x += Style._pad + w;

        this._keys2.setX( x );
        this._keys3.setX( x );
    };

    ScrollTestScreen.prototype.processEvent = function( val, type )
    {
        var self   = this;
        var retval = true, w, h;

        var onEnd = function()
        {
            self.layout();
        };

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                // Toggle Alpha of nested scroll widget
                // WebGL verify stencil is being turned on/off for appropiate widgets
                case Host.KEY_ENTER:
                    var a = this._scroll2.getA();
                    this._scroll2.setA( 1 - a );
                    break;

                // scroll contents
                case Host.KEY_1:
                case Host.KEY_9:
                    w = this._contain.getW();
                    this._offsetX -= 25;
                    if( this._offsetX < -w )
                        this._offsetX = -w;

                    this.layout();
                    this._scroll3.setScroll( { x: this._offsetX, duration: 200, onEnd: onEnd } );
                    break;

                case Host.KEY_2:
                case Host.KEY_PAGE_DN:
                case Host.KEY_CH_DOWN:
                    h = this._contain.getH();
                    this._offsetY += 25;
                    if( this._offsetY > h )
                        this._offsetY = h;

                    this.layout();
                    this._scroll3.setScroll( { y: this._offsetY, duration: 200, onEnd: onEnd } );

                    break;

                case Host.KEY_3:
                case Host.KEY_PAGE_UP:
                case Host.KEY_CH_UP:
                    h = this._contain.getH();
                    this._offsetY -= 25;
                    if( this._offsetY < -h )
                        this._offsetY = -h;

                    this.layout();
                    this._scroll3.setScroll( { y: this._offsetY, duration: 200, onEnd: onEnd } );
                    break;

                case Host.KEY_4:
                case Host.KEY_0:
                    w = this._contain.getW();
                    this._offsetX += 25;
                    if( this._offsetX > w )
                        this._offsetX = w;

                    this.layout();
                    this._scroll3.setScroll( { x: this._offsetX, duration: 200, onEnd: onEnd } );
                    break;

                // move vertical scroll 2 left/right
                case Host.KEY_LEFT:
                    w = this._contain.getW() * 0.5;
                    this._x -= 75;
                    if( this._x < -w )
                        this._x = -w;

                    this.layout();
                    this._scroll2.setScroll( { x:this._x, duration: 200, onEnd: onEnd } );
                    break;

                case Host.KEY_RIGHT:
                    w = this._contain.getW() * 0.5;
                    this._x += 75;
                    if( this._x > w )
                        this._x = w;

                    this.layout();
                    this._scroll2.setScroll( { x: this._x, duration: 200, onEnd: onEnd } );
                    break;

                // move horizontal scroll 3 up/down
                case Host.KEY_UP:
                    h = this._contain.getH();
                    this._y -= 25;
                    if( this._y < -h )
                        this._y = -h;

                    this.layout();
                    this._scroll2.setScroll( { y: this._y, duration: 200, onEnd: onEnd } );
                    break;

                case Host.KEY_DOWN:
                    h = this._contain.getH();
                    this._y += 25;
                    if( this._y > h )
                        this._y = h;

                    this.layout();
                    this._scroll2.setScroll( { y: this._y, duration: 200, onEnd: onEnd } );
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
            }

        return retval;
    };

    ScrollTestScreen.prototype.resourcesLoaded = function()
    {
        this.layout();
    };

    return ScrollTestScreen;

})();


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.StringTestScreen = ( function()
{
    "use strict";

    StringTestScreen.prototype = new Screen();

    function StringTestScreen(){}

    StringTestScreen.prototype.init = function()
    {
        this._className = "StringTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var style = new Style( { color:"#e5e5e5", font:"light", fontSize:36, whiteSpace:"nowrap" } );

        this._hello = new StringWidget().init( { text:"Hello", style:style } );
        this.addWidget( this._hello, Style._safeLeft, Style._safeTop );

        this._helloStatic = new StringWidget().init( { text:"Hello Static", style:style } );
        this.addWidget( this._helloStatic, Style._safeLeft, Style._safeTop );

        this._helloDynamic = new StringWidget().init( { text:"Hello Dynamic", style:style } );
        this.addWidget( this._helloDynamic, Style._safeLeft, Style._safeTop );

        return this;
    };

    StringTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    StringTestScreen.prototype.resourcesLoad = function()
    {
        Screen.prototype.resourcesLoad.call( this );

        var self = this;

        this._helloStatic.setVal( Widget.X, Style._safeLeft + this._hello.getVal( Widget.W ) + 30 );
        this._helloStatic.setVal( Widget.FONT_COLOR, "#2ea0dd" );
        this._helloStatic.setVal( Widget.FONT_SIZE, 48 );

        var onEnd = function()
                    {
                        if( self._helloDynamic.getVal( Widget.Y ) === 500 )
                            self._helloDynamic.animate( { duration:1000, y:100, color:"#363636", fontSize:36, onEnd:onEnd, onEndAxis:Widget.Y } );

                        if( self._helloDynamic.getVal( Widget.Y ) === 100 )
                            self._helloDynamic.animate( { duration:1000, y:500, color:"#2ea0dd", fontSize:24, onEnd:onEnd, onEndAxis:Widget.Y } );
                    };

        this._helloDynamic.setVal( Widget.X, this._helloStatic.getVal( Widget.X ) + this._helloStatic.getVal( Widget.W ) + 30 );
        this._helloDynamic.animate( { duration:1000, y:500, color:"#2ea0dd", fontSize:24, onEnd:onEnd, onEndAxis:Widget.Y } );
    };

    return StringTestScreen;

})();


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.StringAlignTestScreen = ( function()
{
    "use strict";

    StringAlignTestScreen.prototype = new Screen();

    function StringAlignTestScreen(){}

    StringAlignTestScreen.prototype.init = function()
    {
        var self = this;
        this._className = "StringAlignTestScreen";

        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var w         = _x2._config._screenW*0.5;
        var fontSize  = 36;
        var makeStyle = function( align, color )
        {
            if( !color )
                color = "#e5e5e5";
            return new Style( { color:color, font:"light", fontSize:fontSize, whiteSpace:"nowrap", textAlign: align } );
        };

        this._divider = new RectWidget().init( { color:"#777777", w: 1, h:_x2._config._screenH } );
        this._header1 = new StringWidget().init( { text: "Width = 1/2 Screen", style:makeStyle( "left", "#0AF" ) } );
        this._header2 = new StringWidget().init( { text: "Width = undefined ", style:makeStyle( "left", "#0AF" ) } );
        this._left    = new StringWidget().init( { text:"Left"               , style:makeStyle( "left"         ) } );
        this._center  = new StringWidget().init( { text:"Center"             , style:makeStyle( "center"       ) } );
        this._right   = new StringWidget().init( { text:"Right"              , style:makeStyle( "right"        ) } );
        this._center2 = new StringWidget().init( { text:"Center"             , style:makeStyle( "center"       ) } );
        this._center3 = new StringWidget().init( { text:"Center layout:width", style:makeStyle( "center"       ) } );

        this._left  .setW( w );
        this._center.setW( w );
        this._right .setW( w );
        // center2 does NOT have a width specified
        this._center3.addReadyCallback( function() { self.layout(); } );

        var h = _x2._config._screenW * 0.5;
        var x = 0; // Style._safeLeft;
        var y = Style._safeTop;

        this.addWidget( this._header1, x, y ); y += 1.5*fontSize;
        this.addWidget( this._left   , x, y ); y += 1.5*fontSize;
        this.addWidget( this._center , x, y ); y += 1.5*fontSize;
        this.addWidget( this._right  , x, y ); y += 2  *fontSize;

        this.addWidget( this._header2, x, y ); y += 1.5*fontSize;
        this.addWidget( this._center2, h, y ); y += 1.5*fontSize;
        this.addWidget( this._center3, h, y );

        this.addWidget( this._divider, h, 0 );

// Add Bounding Box Rects ?

        return this;
    };

    StringAlignTestScreen.prototype.layout = function()
    {
        this._center3.setW( _x2._config._screenW * 0.5 );
    };

    return StringAlignTestScreen;

})();


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.StringEllipsisTestScreen = ( function()
{
    "use strict";

    StringEllipsisTestScreen.prototype = new Screen();

    function StringEllipsisTestScreen(){}

    StringEllipsisTestScreen.prototype.init = function()
    {
        var self = this;

        Screen.prototype.init.call( this );
        this._className = "StringEllipsisTestScreen";

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var w         = _x2._config._screenW*0.5,
            h         = _x2._config._screenH,
            fontSize  = 36,
            makeStyle = function( params )
            {
                var style = { color:"#e5e5e5", font:"light", fontSize:fontSize, overflow:"hidden", textAlign:"left", textOverflow:"ellipsis", whiteSpace: "nowrap" };
                if( params && params.color )
                    style.color = params.color;

                if( params && params.textAlign )
                    style.textAlign = params.textAlign;

                return new Style( style );
            },
            wrap      = "Spider-Man fights a new villain called Electro, and romances his high-school sweetheart Gwen Stacy. Meanwhile, his childhood friend Harry Osborn is named the CEO of Oscorp, a nefarious company connected to the disappearance of Peter Parker's parents.";

        this._divider = new RectWidget().init( { color:"#777777", w: 1, h:h } );
        this._edge    = new RectWidget().init( { color:"#8000FF", w: 1, h:1.5*3*fontSize } );
        this._header1 = new StringWidget().init( { text: "Width = 1/2 Screen"   , style:makeStyle( { color:"#0AF"       } ) } );
        this._header2 = new StringWidget().init( { text: "Width = undefined "   , style:makeStyle( { color:"#0AF"       } ) } );
        this._left    = new StringWidget().init( { text:wrap                    , style:makeStyle( { textAlign:"left"   } ) } );
        this._center  = new StringWidget().init( { text:wrap                    , style:makeStyle( { textAlign:"center" } ) } );
        this._right   = new StringWidget().init( { text:wrap                    , style:makeStyle( { textAlign:"right"  } ) } );
        this._center2 = new StringWidget().init( { text:wrap                    , style:makeStyle(                        ) } );
        this._center3 = new StringWidget().init( { text:"Ellipsis layout:width" , style:makeStyle(                        ) } );
        this._width   = w;

        this._left  .setW( w );
        this._center.setW( w );
        this._right .setW( w );
/*
        this._left  .setH( fontSize );
        this._center.setH( fontSize );
        this._right .setH( fontSize );
*/
        // center2 does NOT have a width specified
        this._center3.addReadyCallback( function() { self.layout(); } );

        var x = 0; // Style._safeLeft;
        var y = Style._safeTop;
        var t = y + 1.5*fontSize;

        this.addWidget( this._header1, x, y ); y += 1.5*fontSize;
        this.addWidget( this._left   , x, y ); y += 1.5*fontSize;
        this.addWidget( this._center , x, y ); y += 1.5*fontSize;
        this.addWidget( this._right  , x, y ); y += 2  *fontSize;

        this.addWidget( this._header2, w, y ); y += 1.5*fontSize;
        this.addWidget( this._center2, w, y ); y += 1.5*fontSize;
        this.addWidget( this._center3, w, y );

        this.addWidget( this._divider, w, 0 );
        this.addWidget( this._edge   , w, t );

// Add Bounding Box Rects ?

        return this;
    };

    StringEllipsisTestScreen.prototype.layout = function()
    {
        this._center3.setW( _x2._config._screenW * 0.5 );

        this.updateWidth( 0 );
    };


    StringEllipsisTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED )
                    this.updateWidth( -1 );

                break;

            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                    this.updateWidth( +1 );

                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                    this.updateWidth( -10 );

                break;

            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED )
                    this.updateWidth( +10 );

                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
        }

        return retval;
    };

    StringEllipsisTestScreen.prototype.updateWidth = function( deltaWidth )
    {
        this._width += deltaWidth;
        if( this._width < 0 )
            this._width = 0;

        if( this._width > _x2._config._screenW * 0.5 )
            this._width = _x2._config._screenW * 0.5;

        this._left  .setW( this._width );
        this._center.setW( this._width );
        this._right .setW( this._width );

        this._edge.setX( this._width );

        this._header1.setText( "Width = 1/2 Screen ( <font color='#FFFF00'>" + this._width + "</font> )" );
    };

    return StringEllipsisTestScreen;

})();


/***/ }),
/* 246 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TabbedPillButtonTestScreen = ( function()
{
    "use strict";

    TabbedPillButtonTestScreen.prototype = new Screen();

    function TabbedPillButtonTestScreen(){}

    // Testing for: Menu item with focus has white text instead of colored text -- test String.gotFocus() fontSize: this._selectSize === undefined
    TabbedPillButtonTestScreen.prototype.init = function()
    {
        var self = this;
        this._className = "TabbedPillButtonTestScreen";

        Screen.prototype.init.call( this );

        var onEnter = function()
        {
//console.log( "Focus = %o", _x2._focus );
            _x2.requestFocus( self._item );
        };

        var buttonStyle = new Style( { color:"#e5e5e5", colorHi:"#1199FF", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );

        var string1 = new StringWidget().init( { text: "ABC", style: buttonStyle, onEnter: onEnter, focusTime:300  } );
        var string2 = new StringWidget().init( { text: "123", style: buttonStyle, onEnter: onEnter, focusTime:300  } );

        var entries =
        [
            string1,
            string2
        ];
        this._entries = entries;

// SavedScreen does: widget.setFocusListeners( onGotFocus, onLostFocus );
//    for( var i = 0; i < this._entries.length; i++ )
//        entries[ i ].setFocusListeners( onGotFocus, onLostFocus );

        this._menu = new TabbedPillButtonsWidget().init( { entries:entries, spacing:_x2.scaleValInt(60) } );
        this._menu.addReadyCallback ( function() { self.layoutMenu(); self._buttonsReady = true; } );

//this._menu.setFocusListeners( onGotFocus, onLostFocus );

        this.addWidget( this._menu, Style._safeLeft, Style._safeTop*2 );
        this.addReadyCallback( function() { self.layoutMenu(); } );

        this._rectHasFocus = new RectWidget().init( { w: 300, h: 400, color: "#22AA22" } );
        this._rectNotFocus = new RectWidget().init( { w: 300, h: 400, color: "#AA2222" } );

        this._rectHasFocus.setA( 0 );
        this._rectNotFocus.setA( 1 );

        this._item = new Widget().init();
        this._item._selectable  = true;
        this._item._onGotFocus  = function() { self._rectHasFocus.setA( 1 ); self._rectNotFocus.setA( 0 ); };
        this._item._onLostFocus = function() { self._rectHasFocus.setA( 0 ); self._rectNotFocus.setA( 1 ); };
        this._item.addWidget( this._rectHasFocus );
        this._item.addWidget( this._rectNotFocus );
        this.addWidget( this._item, Style._safeLeft, Style._safeTop );

        string1._id            = 1;
        string2._id            = 2;
        this._menu._id         = 3;
        this._rectHasFocus._id = 4;
        this._rectNotFocus._id = 5;

        return this;
    };

    TabbedPillButtonTestScreen.prototype.layoutMenu = function()
    {
        var y = this.getHeaderBottom();
        this._menu.setH( y );

        this._item.setY( y );
        _x2.requestFocus( this._item );
    };

    TabbedPillButtonTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._menu.containsWidget( _x2._focus ) === false )
                        _x2.requestFocus( this._menu );
                    else
                        _x2.requestFocus( this._item );
                }
                break;

            case Host.KEY_LAST:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._menu.containsWidget( _x2._focus ) === false )
                        _x2.requestFocus( this._menu );
                    else
                        retval = Screen.prototype.processEvent.call( this, val, type );
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    return TabbedPillButtonTestScreen;

})();



/***/ }),
/* 247 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TestScreen = ( function()
{
    "use strict";

    TestScreen.prototype = new Screen();

    function TestScreen(){}

    TestScreen.prototype.gotFocus = function()
    {
        this.setHighlight();
    };

    TestScreen.prototype.init = function()
    {
        var self       = this, i;
        var style      = new Style( { color:"#e5e5e5", font:"light", fontSize:_x2.scaleValInt(42), whiteSpace:"nowrap" } );
        var renderType = "Tests - ";

        if( _x2._config._render === Config.RENDER_DOM   ) renderType += "DOM";
        if( _x2._config._render === Config.RENDER_WEBGL ) renderType += "WebGL";

        Screen.prototype.init.call( this, { baseStr:renderType } );
        this._className = "TestScreen";

        var onMainMenu = function()
        {
            self._lastCol = 0;
            self._col     = self._row + 1;
            self._row     = 0;

            self._activeMenu = self._menus[ self._col ];
            self.selectMenu();
        };

        var makeOnEnter = function( screen )
        {
            return function() { _x2._hi.fadeOut(); _x2.pushScreen( new screen().init() ); };
        };

        var onGradMenu = function()
        {
            self._lastCol    = self._col;
            self._activeMenu = self._grads[0];

            self._col  =  0;
            self._row  =  0;
            self._sub  =  1;
            self.selectMenu();
        };

        var onStringsMenu = function()
        {
            self._lastCol    = self._col;
            self._activeMenu = self._strings[0];

            self._col  =  0;
            self._row  =  0;
            self._sub  =  1;
            self.selectMenu();
        };

        this._tests =
        [
            new StringWidget().init( { text:"Core"             , style:style, onEnter:onMainMenu } ),
            new StringWidget().init( { text:"Component"        , style:style, onEnter:onMainMenu } ),
            new StringWidget().init( { text:"Application"      , style:style, onEnter:onMainMenu } )
        ];

        this._menuCore =
        [
            new StringWidget().init( { text:"Animation"        , style:style, onEnter:makeOnEnter( AniTestScreen              ) } ),
            new StringWidget().init( { text:"Rectangle Color"  , style:style, onEnter:makeOnEnter( RectColorTestScreen        ) } ),
            new StringWidget().init( { text:"Rect Anim Widget" , style:style, onEnter:makeOnEnter( RectAnimTestScreen         ) } ),
            new StringWidget().init( { text:"Font Glyph"       , style:style, onEnter:makeOnEnter( FontGlyphTestScreen        ) } ),
            new StringWidget().init( { text:"Font Scale"       , style:style, onEnter:makeOnEnter( FontScaleTestScreen        ) } ),
            new StringWidget().init( { text:"Gradients ..."    , style:style, onEnter:onGradMenu                                } ),
            new StringWidget().init( { text:"Image Widget"     , style:style, onEnter:makeOnEnter( ImageTestScreen            ) } ),
            new StringWidget().init( { text:"Nine Slice Widget", style:style, onEnter:makeOnEnter( NineSliceTestScreen        ) } ),
            new StringWidget().init( { text:"Nine Slice Shadow", style:style, onEnter:makeOnEnter( NineSliceShadowTestScreen  ) } ),
            new StringWidget().init( { text:"Scroll Pane"      , style:style, onEnter:makeOnEnter( ScrollTestScreen           ) } ),
            new StringWidget().init( { text:"Strings ..."      , style:style, onEnter:onStringsMenu                             } )
        ];

        this._menuCoreStrings =
        [
            new StringWidget().init( { text:"String Widget"    , style:style, onEnter:makeOnEnter( StringTestScreen           ) } ),
            new StringWidget().init( { text:"String Alignment" , style:style, onEnter:makeOnEnter( StringAlignTestScreen      ) } ),
            new StringWidget().init( { text:"String Ellipsis"  , style:style, onEnter:makeOnEnter( StringEllipsisTestScreen   ) } )
        ];

        this._menuCoreGrad =
        [
            new StringWidget().init( { text:"Gradient 2 Widget", style:style, onEnter:makeOnEnter( Gradient2TestScreen        ) } ),
            new StringWidget().init( { text:"Gradient 3 Widget", style:style, onEnter:makeOnEnter( Gradient3TestScreen        ) } ),
            new StringWidget().init( { text:"Gradient 4 Widget", style:style, onEnter:makeOnEnter( Gradient4TestScreen        ) } ),
            new StringWidget().init( { text:"Gradient AA AR GH", style:style, onEnter:makeOnEnter( GradientAAARGHTestScreen   ) } )
        ];

        this._menuComp =
        [
            new StringWidget().init( { text:"MultiStateButton" , style:style, onEnter:makeOnEnter( MultiStateButtonTestScreen ) } ),
            new StringWidget().init( { text:"Ring Distractor"  , style:style, onEnter:makeOnEnter( RingDistractorTestScreen   ) } ),
            new StringWidget().init( { text:"Horz Pill"        , style:style, onEnter:makeOnEnter( HorizPillButtonTestScreen  ) } ),
            new StringWidget().init( { text:"Horz Selection"   , style:style, onEnter:makeOnEnter( HorizSelectionTestScreen   ) } ),
            new StringWidget().init( { text:"Tabbed Pill"      , style:style, onEnter:makeOnEnter( TabbedPillButtonTestScreen ) } ),
            new StringWidget().init( { text:"Text Block Widget", style:style, onEnter:makeOnEnter( TextBlockTestScreen        ) } ),
            new StringWidget().init( { text:"Text Block 2"     , style:style, onEnter:makeOnEnter( TextBlockTestScreen2       ) } ),
            new StringWidget().init( { text:"Text Block Ellip" , style:style, onEnter:makeOnEnter( TextBlockEllipsisTestScreen) } ),
            new StringWidget().init( { text:"Text Block Trunc" , style:style, onEnter:makeOnEnter( TextBlockTruncatedTestScreen)} ),
            new StringWidget().init( { text:"Text HTML"        , style:style, onEnter:makeOnEnter( HTMLStringTestScreen       ) } ),
            new StringWidget().init( { text:"Text Leading"     , style:style, onEnter:makeOnEnter( TextLeadingTestScreen      ) } )
        ];

        this._menuApp  =
        [
            new StringWidget().init( { text:"List Widget"      , style:style, onEnter:makeOnEnter( ListTestScreen             ) } ),
            new StringWidget().init( { text:"List Animation"   , style:style, onEnter:makeOnEnter( ListAnimTestScreen         ) } ),
            new StringWidget().init( { text:"LRU Cache"        , style:style, onEnter:makeOnEnter( LruCacheTestScreen         ) } ),
            new StringWidget().init( { text:"Metrics"          , style:style, onEnter:makeOnEnter( MetricsTestScreen          ) } )
        ];

        this._menus =
        [
            this._tests   ,
            this._menuCore,
            this._menuComp,
            this._menuApp
        ];

        this._row        = 0;
        this._col        = 0;

        this._lastRow    = [ 0, 0, 0 ];
        this._lastCol    = 0;

        this._activeMenu =  this._menus[ this._col ];

        this._sub        = 0;
        this._grads      =
        [
            this._menuCoreGrad
        ];
        this._menuCore[4]._subMenu = this._menuCoreGrad; // Gradients ...

        this._strings =
        [
            this._menuCoreStrings
        ];
        this._menuCore[9]._subMenu = this._menuCoreStrings; // Strings ...

        this._entries = this._tests.concat( this._menuCore ).concat( this._menuComp ).concat( this._menuApp ).concat( this._menuCoreGrad ).concat( this._menuCoreStrings );

        for( i = 0; i < this._entries.length; i++ )
            this.addWidget( this._entries[i], Style._safeLeft );

        return this;
    };

    TestScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        var i, j, obj;
        var y = this.getHeaderBottom(), y2;

        var subX = 0;
        var subY = [];

        var pad  = 3 * Style._pad;
        var cols = this._menus.length, rows;

        var w    = 0;
        var h    = this._menus[0][0].getH() + pad;

        for( i = 0; i < cols; i++ )
        {
            y2   = y + ((i > 0) ? h*(i-1) : 0);
            rows = this._menus[ i ].length;

            for( j = 0; j < rows; j++ )
            {
                obj = this._menus[i][j];
                obj.setY( y2 );

                if( obj._subMenu ) // i == 1 && j == 4 // Gradients...
                {
                    subY.push( y2 );
                    subX = w;
                }

                if( i > 0 )
                {
                    obj.setX( Style._safeLeft + w + pad );
                    if( subX < (w + obj.getW() + pad) )
                        subX = (w + obj.getW() + pad);
                }
                else
                    if( w < obj.getW() )
                        w = obj.getW();

                y2 += obj.getH() + pad;
            }
        }

        y2 = subY[ 0 ];
        for( i = 0; i < this._grads[0].length; i++ )
        {
            obj = this._grads[0][ i ];
            obj.setX( Style._safeLeft + subX +  pad );
            obj.setY( y2 );

            y2 += obj.getH() + pad;
        }

        y2 = subY[ 1 ];
        for( i = 0; i < this._strings[0].length; i++ )
        {
            obj = this._strings[0][ i ];
            obj.setX( Style._safeLeft + subX +  pad );
            obj.setY( y2 );

            y2 += obj.getH() + pad;
        }

        this.selectMenu();
    };

    TestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED && (this._row < (this._activeMenu.length - 1)) )
                {
                    this._row++;
                    this.setHighlight();
                }
                break;

            case Host.KEY_ENTER:
            case Host.KEY_RIGHT:
                if( type === Host.KEY_PRESSED )
                {
                    this._lastRow[ this._col ] = this._row;
                    this._activeMenu[this._row].onEnter();
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && (this._row > 0 ) )
                {
                    this._row--;
                    this.setHighlight();
                }
                break;

            case Host.KEY_LAST:
            case Host.KEY_LEFT:
                if( type === Host.KEY_PRESSED && ((this._col > 0 ) || this._sub) )
                {
                    if( this._sub )
                        this._col = this._lastCol;
                    else
                        if( this._col > 0 )
                            this._col = 0;

                    this._sub        = 0;
                    this._activeMenu = this._menus  [ this._col ];
                    this._row        = this._lastRow[ this._col ];
                    this.selectMenu();
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    TestScreen.prototype.selectMenu = function()
    {
        var col  = this._sub ? this._lastCol : this._col, alpha;
        var i, n = this._entries.length, rows = this._menus[col].length, main = this._menus[0].length;

        for( i = 0; i < n; i++ )
            this._entries[i].setA( 0 );

        // Dim 1st col
        if( this._col > 0 || this._sub )
            for( i = 0; i < main; i++ )
                this._menus[0][i].setA( 1/3 );

        // Dim 2nd col
        for( i = 0; i < rows; i++ )
            this._menus[col][i].setA( this._sub ? 1/2 : 1 );

        // Dim 3rd col
        alpha = this._activeMenu === this._grads[0] ? 1 : 0;
        for( i = 0; i < this._grads[0].length; i++ )
            this._grads[0][i].setA( alpha );

        alpha = this._activeMenu === this._strings[0] ? 1 : 0;
        for( i = 0; i < this._strings[0].length; i++ )
            this._strings[0][i].setA( alpha );

        this.setHighlight();
    };

    TestScreen.prototype.setHighlight = function()
    {
        var obj  = this.getGlobalPos();
        var menu = this._activeMenu[ this._row ];

        obj.x       += menu.getX();
        obj.y       += menu.getY();
        obj.w        = menu.getW();
        obj.h        = menu.getH();
        obj.inner    = false;
        obj.duration = 300;

        _x2._hi.setPosition( obj );
    };

    return TestScreen;

})();


/***/ }),
/* 248 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TextBlockTestScreen = ( function()
{
    "use strict";

    TextBlockTestScreen.prototype = new Screen();

    function TextBlockTestScreen(){}

    TextBlockTestScreen.prototype.init = function()
    {
        var x, y, cx, dy;
        var width, height;
        var headStyle, bodyStyle;
        var fontSize;

        this._className = "TextBlockTestScreen";

        Screen.prototype.init.call( this );

        fontSize = 36;
        this._size = fontSize;

        cx = _x2._config._screenW*0.5;
        dy = fontSize + 2;

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._text1 = "Eddie Murphy plays a womanizer who gets his comeuppance from a colleague (Robin Givens). Angela: Halle Berry. Gerard: David Alan Grier. Tyler: Martin Lawrence. Strange: Grace Jones. Lady Eloise: Eartha Kitt. Nelson: Geoffrey Holder. Bony T: Chris Rock. Directed by Reginald Hudlin.";
        this._text2 = "Mitzi Gaynor and Rossano Brazzi team in this colorful adaptation of the Rodgers and Hammerstein classic. Billis: Ray Walston. Lt. Cable: John Kerr. Bloody Mary: Juanita Hall. Liat: France Nuyen. The songs include ''Bali Ha'i,'' ''Some Enchanted Evening,'' ''A Wonderful Guy,'' ''There Is Nothing like a Dame,'' ''Bloody Mary,'' ''I'm Gonna Wash That Man Right Outta My Hair,'' ''Carefully Taught,'' ''A Cockeyed Optimist,'' ''Younger than Springtime,'' ''Happy Talk'' and ''This Nearly Was Mine.'' Joshua Logan directed.";

        headStyle = new Style( { color:"#2ea0dd", font:"light", fontSize:fontSize-6, whiteSpace:"nowrap" } );
        bodyStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:fontSize-6                      } );

        width  = Math.min( cx - Style._safeLeft - Style._safeRight, 500 );
        height = 150;
        this._h = height;

        this._colorFAIL = "#FF0000";
        this._colorPASS = "#00FF00";
        this._colorSIZE = "#0000FF";

        this._rectF1 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorFAIL } );
        this._rectF3 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorFAIL } );
        this._rectP1 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorPASS } );
        this._rectP3 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorPASS } );

        this._rectS2 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorSIZE } );
        this._rectS4 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorSIZE } );

        this._rectF1.setA( 0 );
        this._rectF3.setA( 0 );
        this._rectP1.setA( 0 );
        this._rectP3.setA( 0 );

        this._title1 = new StringWidget().init( { text: "Fix W, Fix H"                      , style: headStyle } );
        this._title2 = new StringWidget().init( { text: "Fix W, Var H  Kyes: 1,2"           , style: headStyle } );
        this._title3 = new StringWidget().init( { text: "Var W, Fix H  Keys: 3-6"           , style: headStyle } );
        this._title4 = new StringWidget().init( { text: "Var W, Var H  Keys: 7-0,arrows,-,+", style: headStyle } );

        this._block1 = new TextBlockWidget().init( { text: this._text1, style:bodyStyle , w:width, h:height    } );
        this._block2 = new TextBlockWidget().init( { text: this._text1, style:bodyStyle , w:width, h:undefined } );
        this._block3 = new TextBlockWidget().init( { text: this._text2, style:bodyStyle , w:width, h:height    } );
        this._block4 = new TextBlockWidget().init( { text: this._text2, style:bodyStyle , w:width, h:undefined } );

        x = Style._safeLeft;
        y = Style._safeTop;

        this.addWidget( this._title1, x, y ); y += dy;
        this.addWidget( this._rectF1, x, y );
        this.addWidget( this._rectP1, x, y );
        this.addWidget( this._block1, x, y ); y += dy + height;

        this.addWidget( this._title2, x, y ); y += dy;
        this.addWidget( this._rectS2, x, y );
        this.addWidget( this._block2, x, y );

        x = cx + Style._safeLeft;
        y = Style._safeTop;
        this.addWidget( this._title3, x, y ); y += dy;
        this.addWidget( this._rectF3, x, y );
        this.addWidget( this._rectP3, x, y );
        this.addWidget( this._block3, x, y ); y += dy + height;

        this.addWidget( this._title4, x, y ); y += dy;
        this.addWidget( this._rectS4, x, y );
        this.addWidget( this._block4, x, y );

        this._selectable = true;

        return this;
    };

    TextBlockTestScreen.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._block4 );
    };

    TextBlockTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;
        var w,h;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                case Host.KEY_EQUAL:
                    this._block3.pageDown();
                    break;

                case Host.KEY_MINUS:
                    this._block3.pageUp();
                    break;

                case Host.KEY_1:
                    w = this._block2.getW();
                    w -= this._size;
                    if( w < 0 )
                        w = 0;
                    this._rectP3.setH( h ) // TODO: intentional h === undefined ???
console.log( "W2: " + w );

                    this._block2.setW( w );
                    this._rectS2.setW( w );

                    h = this._block2.getH();
                    this._rectS2.setH( h );

                    break;

                case Host.KEY_2:
                    w = this._block2.getW( Widget.W );
                    w += this._size;
                    if( w > _x2._config._screenW )
                        w = _x2._config._screenW;
console.log( "W2: " + w );

                    this._block2.setW( w );
                    this._rectS2.setW( w );

                    h = this._block2.getH();
                    this._rectS2.setH( h );

                    break;

// Text Block 3

                case Host.KEY_3:
                    h = this._block3.getH();
                    h -= this._size;
                    h = Math.floor( h );
                    if( h < 0 )
                        h = 0;
console.log( "H3: " + h );
                    this._block3.setH( h );
                    this._rectP3.setH( h );
                    break;

                case Host.KEY_4:
                    h = this._block3.getH();
                    h += this._size;
                    h = Math.floor( h );
                    if( h > _x2._config._screenH )
                        h = _x2._config._screenH;
console.log( "H3: " + h );
                    this._block3.setH( h );
                    this._rectP3.setH( h );
                    break;

                case Host.KEY_5:
                    this._block3.pageDown();
                    break;

                case Host.KEY_6:
                    this._block3.pageUp();
                    break;

// Text Block 4

                case Host.KEY_7:
                    h = this._block4.getH();
                    h -= this._size;
                    h = Math.floor( h );
                    if( h < 0 )
                        h = 0;
console.log( "H4: " + h );

                    this._block4.setH( h );
                    this._rectS4.setH( h );
                    break;

                case Host.KEY_8:
                    h = this._block4.getH();
                    h += this._size;
                    h = Math.floor( h );
                    if( h > _x2._config._screenH )
                        h = _x2._config._screenH;
console.log( "H4: " + h );

                    this._block4.setH( h );
                    this._rectS4.setH( h );
                    break;

                case Host.KEY_LEFT:
                case Host.KEY_9:
                    w = this._block4.getW();
                    w -= this._size;
                    w = Math.floor( w );
                    if( w < 0 )
                        w = 0;
console.log( "W4: " + w );

                    this._block4.setW( w );
                    this._rectS4.setW( w );

                    break;

                case Host.KEY_RIGHT:
                case Host.KEY_0:
                    w = this._block4.getW();
                    w += this._size;
                    w = Math.floor( w );
                    if( w > _x2._config._screenW )
                        w = _x2._config._screenW;
console.log( "W4: " + w );

                    this._block4.setW( w );
                    this._rectS4.setW( w );

                    break;

                case Host.KEY_PAGE_DN:
                case Host.KEY_CH_DOWN:
                    this._block4.pageDown();
                    break;

                case Host.KEY_PAGE_UP:
                case Host.KEY_CH_UP:
                    this._block4.pageUp();
                    break;

                case Host.KEY_UP:
                    this._block4.lineUp();
                    break;

                case Host.KEY_DOWN:
                    this._block4.lineDown();
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;

// TODO: Need to set focus on one of the text widgets
            }

        return retval;
    };

    TextBlockTestScreen.prototype.resourcesLoaded = function()
    {
        var a1, a3;
        var h = [];

        Widget.prototype.resourcesLoaded.call( this );

        h[1] = this._block1.getH();
        h[3] = this._block3.getH();

        a1 = (h[1] === this._h) ? 1 : 0;
        a3 = (h[3] === this._h) ? 1 : 0;

        this._rectF1.setA( 1 - a1 );
        this._rectP1.setA(     a1 );

        this._rectF3.setA( 1 - a3 );
        this._rectP3.setA(     a3 );

        h[2] = this._block2.getH();
        h[4] = this._block4.getH();

        this._rectS2.setH( h[2] );
        this._rectS4.setH( h[4] );

    };

    return TextBlockTestScreen;

})();



/***/ }),
/* 249 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TextBlockTestScreen2 = ( function()
{
    "use strict";

    TextBlockTestScreen2.prototype = new Screen();

    function TextBlockTestScreen2(){}

    TextBlockTestScreen2.prototype.init = function()
    {
        var x, y;
        var width, height;
        var headStyle, bodyStyle;
        var fontSize = 36, dy = fontSize + 2;

        this._className = "TextBlockTestScreen2";

        Screen.prototype.init.call( this );

        this._size = fontSize;

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        this._text1 = undefined;
        this._text2 = "A prequel to the classic Robert Louis Stevenson novel \"Treasure Island,\" \"Black Sails\" is a pirate adventure that centers on the tales of Captain Flint, who has a reputation throughout the West Indies as being the most brilliant, most feared of all the Golden Age pirates. It's 1715, and as Flint fights for the survival of New Providence Island -- a debauched paradise teeming with pirates, prostitutes, thieves and fortune seekers -- in the wake of threats from British and Spanish forces, he aligns himself with Eleanor Guthrie, daughter of the local kingpin, to hunt the ultimate prize and ensure his people's survival. But standing in the way are rival captains, Eleanor's intrusive father, and perhaps the bigger obstacle of all: John Silver, a young, fast-talking, authority-flouting sailor recently added to Flint's crew.";

        headStyle = new Style( { color:"#2ea0dd", font:"light", fontSize:fontSize-6, whiteSpace:"nowrap" } );
//      bodyStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:fontSize-6                      } );
        bodyStyle = new Style( { font: "light", color: "#e8e8e8", fontSize: _x2.scaleValInt( 30 ), whiteSpace: "nowrap" } );

        this._descriptionDims = { w: _x2.scaleValInt( 968 ), h: _x2.scaleValInt( 310 ) };

        width  = this._descriptionDims.w;
        height = this._descriptionDims.h;
        this._h = height;

        this._colorFAIL = "#FF0000";
        this._colorPASS = "#00FF00";
        this._colorSIZE = "#0000FF";

        this._rectF1 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorFAIL } );
        this._rectP1 = new RectWidget().init( { w:width, h:height, color:"#000000", borderThickness:1, borderColor:this._colorPASS } );

        this._rectF1.setA( 0 );
        this._rectP1.setA( 0 );

        this._title1 = new StringWidget().init( { text: "Fix W, Fix H, no text" , style: headStyle } );

//      this._block1 = new TextBlockWidget().init( { text: this._text1, style:bodyStyle , w:width, h:height    } );
        this._block1 = new TextBlockWidget().init( { style: bodyStyle, w: this._descriptionDims.w, h: this._descriptionDims.h } );

        x = Style._safeLeft;
        y = Style._safeTop;

        this.addWidget( this._title1, x, y ); y += dy;
        this.addWidget( this._rectF1, x, y );
        this.addWidget( this._rectP1, x, y );
        this.addWidget( this._block1, x, y ); // y += dy + height;

        this._timer = new Widget().init();
        this.addWidget( this._timer );

        this._selectable = true;

        return this;
    };

    TextBlockTestScreen2.prototype.gotFocus = function()
    {
        _x2.requestFocus( this._block1 );
        this.startTimer();
    };

    TextBlockTestScreen2.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                case Host.KEY_EQUAL:
                case Host.KEY_PAGE_DN:
                case Host.KEY_CH_DOWN:
                    this._block1.pageDown();
                    break;

                case Host.KEY_MINUS:
                case Host.KEY_PAGE_UP:
                case Host.KEY_CH_UP:
                    this._block1.pageUp();
                    break;

                case Host.KEY_UP:
                    this._block1.lineUp();
                    break;

                case Host.KEY_DOWN:
                    this._block1.lineDown();
                    break;

                case Host.KEY_1:
                    this._block1.setText();
                    break;

                case Host.KEY_2:
                    this.startTimer();
                    break;

                case Host.KEY_3:
                    this._block1.setText( "Lorem ipsum dolor sit amet" );
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    TextBlockTestScreen2.prototype.resourcesLoaded = function()
    {
        var a, h;

        Widget.prototype.resourcesLoaded.call( this );

        h = this._block1.getH();
        a = (h === this._h) ? 1 : 0;

        this._rectF1.setA( 1 - a );
        this._rectP1.setA(     a );
    };

    TextBlockTestScreen2.prototype.startTimer = function()
    {
        var self      = this;
        var onAnimEnd = function()
        {
            self._block1.setText( self._text2 );
            self._block1.resourcesLoaded();
        };

        this._block1.setText();
        this._timer.animate( { duration:2000, a:1.0, easing:Widget.Easing.LINEAR, onEnd:onAnimEnd, onEndAxis:Widget.ALPHA } );
    };

    return TextBlockTestScreen2;

})();



/***/ }),
/* 250 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TextBlockEllipsisTestScreen = ( function()
{
    "use strict";

    TextBlockEllipsisTestScreen.prototype = new Screen();

    function TextBlockEllipsisTestScreen(){}

    TextBlockEllipsisTestScreen.prototype.init = function()
    {
        this._className = "TextBlockEllipsisTestScreen";
        Screen.prototype.init.call( this );

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        var descStyle = new Style( { font: "light"  , color: "#e8e8e8", fontSize: _x2.scaleValInt( 27 ), overflow:"hidden", textOverflow:"ellipsis" } );
        this._width   = 667; // w: divX - titleX - _x2.scaleValInt( 32 )
        this._text    = new TextBlockWidget().init( { style:descStyle, w:this._width, h:100, ellipsis:true } );
        this.addWidget( this._text, Style._safeLeft, Style._safeTop );

        this._selectable = true;

        return this;    
    };

    TextBlockEllipsisTestScreen.prototype.layout = function()
    {
        this._text.setY( 94 );
        this._text.setH( 175 );
        this._text.setText( "<font color='#a3a3a3'>Peter Dinklage, Nikolaj Coster-Waldau, Lena Headey</font><br>(2011-) George R.R. Martin's best-selling book series \"A Song of Ice and Fire\" is brought to the screen as HBO sinks its considerable storytelling teeth into the medieval fantasy epic. It's the depiction of two powerful families -- kings and queens, knights and renegades, liars and honest men -- playing a deadly game for control of the Seven Kingdoms of Westeros, and to sit atop the Iron Throne. Martin is credited as a co-executive producer and one of the writers for the series, whose shooting locations include Northern Ireland, Malta, Croatia and Spain." );
    };
    
    TextBlockEllipsisTestScreen.prototype.resourcesLoaded = function()
    {
        Widget.prototype.resourcesLoaded.call( this );

        this.layout();
    };

    TextBlockEllipsisTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = Screen.prototype.processEvent.call( this, val, type );

        return retval;
    };

    TextBlockEllipsisTestScreen.prototype.updateWidth = function()
    {
    };

    return TextBlockEllipsisTestScreen;

})();



/***/ }),
/* 251 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TextBlockTruncatedTestScreen = ( function()
{
    "use strict";

    TextBlockTruncatedTestScreen.prototype = new Screen();

    function TextBlockTruncatedTestScreen(){}

    TextBlockTruncatedTestScreen.prototype.init = function()
    {
        var headStyle, bodyStyle, textStyle;
        var text, widget;
        var borderWidth = 2;

        this._className = "TextBlockTruncatedTestScreen";
        Screen.prototype.init.call( this );

        this._deltaW      = 20;
        this._width       = 400;
        this._minWidth    = 50;
        this._maxWidth    = _x2._config._screenW - Style._safeLeft - Style._safeRight;
        this._textWidgets = [];

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        headStyle = new Style( { color:"#2ea0dd", font:"medium", fontSize:_x2.scaleValInt(30), overflow:"hidden", whiteSpace:"nowrap" } );
        bodyStyle = new Style( { color:"#b8b8b8", font:"light" , fontSize:_x2.scaleValInt(41), overflow:"hidden"   } );
        textStyle = new Style( { color:"#00FF00", font:"medium", fontSize:_x2.scaleValInt(30), overflow:"hidden"   } );

        text   = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent magna tortor, tincidunt ac tristique sit amet, condimentum ut erat. Mauris sem mi, ultrices et hendrerit vitae, hendrerit non tortor. Aliquam erat volutpat. Morbi eget leo lorem, ut placerat nisl. Aenean auctor volutpat condimentum. Morbi adipiscing leo et felis faucibus suscipit nec at odio. Pellentesque convallis turpis non sapien facilisis quis volutpat magna venenatis. Etiam nisi metus, imperdiet vitae lobortis sit amet, pharetra ut leo.";
        widget = new TextBlockWidget().init( { text:text, style:bodyStyle, w:this._width, h:40*4, ellipsis:true } ); // lines: 4
        this._textWidgets.push( widget );
        this.addWidget( widget, Style._safeLeft );
        
        text   = "Spider-Man fights a new villain called Electro, and romances his high-school sweetheart Gwen Stacy. Meanwhile, his childhood friend Harry Osborn is named the CEO of Oscorp, a nefarious company connected to the disappearance of Peter Parker's parents.";
        widget = new TextBlockWidget().init( { text:text, style:bodyStyle, w:this._width, h:40*3, ellipsis:true } ); // lines: 3
        this._textWidgets.push( widget );
        
        text   = "Mitzi Gaynor and Rossano Brazzi team in this colorful adaptation of the Rodgers and Hammerstein classic. Billis: Ray Walston. Lt. Cable: John Kerr. Bloody Mary: Juanita Hall. Liat: France Nuyen. The songs include ''Bali Ha'i,'' ''Some Enchanted Evening,'' ''A Wonderful Guy,'' ''There Is Nothing like a Dame,'' ''Bloody Mary,'' ''I'm Gonna Wash That Man Right Outta My Hair,'' ''Carefully Taught,'' ''A Cockeyed Optimist,'' ''Younger than Springtime,'' ''Happy Talk'' and ''This Nearly Was Mine.'' Joshua Logan directed.";
        widget = new TextBlockWidget().init( { text:text, style:bodyStyle, w:this._width, h:40*2, ellipsis:true } ); // lines: 2
        this._textWidgets.push( widget );
        
        text   = "Eddie Murphy plays a womanizer who gets his comeuppance from a colleague (Robin Givens). Angela: Halle Berry. Gerard: David Alan Grier. Tyler: Martin Lawrence. Strange: Grace Jones. Lady Eloise: Eartha Kitt. Nelson: Geoffrey Holder. Bony T: Chris Rock. Directed by Reginald Hudlin.";
        widget = new TextBlockWidget().init( { text: text, style:bodyStyle, w:this._width, h:40*1, ellipsis:true } ); // lines: 1
        this._textWidgets.push( widget );
        
        textStyle._object.textOverflow = "ellipsis"; // add ellipsis style so text is clipped if unable to even display one word per line
        textStyle._object.overflow     = "hidden";

        text = "Cait is invited to her first all-girl sleepover by Candis; and she visits a support group for families with trans kids. Also: Kim and Khloé are critical of the comments Cait made about their mother in the Vanity Fair article.";
        text = unescape(escape(text)); // UTF-8 to Unicode
        widget = new TextBlockWidget().init( { text: text, style:textStyle, w:this._width, h:35*2, ellipsis:true } ); // width = 560, lines: 2
        this._textWidgets.push( widget );

        text = "Conclusion. Cait is challenged to break down her walls and get personal on her road trip with her new friends.";
        widget = new TextBlockWidget().init( { text: text, style:textStyle, w:this._width, h:35*2, ellipsis:true } ); // width = 560, lines: 2
        this._textWidgets.push( widget );

        text = "Manual 1 line / 2 lines";
        widget = new TextBlockWidget().init( { text: text, style:textStyle, w:this._width, h:35*2, ellipsis:true } ); // lines: 2
        this._textWidgets.push( widget );

        this._rects = new Array( this._textWidgets.length );

        for( var i = 0; i < this._rects.length; i++ )
        {
            this._rects[i] = new RectWidget().init( { w:this._width, h: 10, color:"#000", borderThickness:borderWidth, borderColor: "#007777" } );
            this.addWidget( this._rects[i]      , Style._safeLeft                 );
            this.addWidget( this._textWidgets[i], Style._safeLeft + 2+borderWidth );
        }
 
        text = "" + this._width;
        this._stringWidth = new StringWidget().init( { text:text, style:headStyle } );
        this.addWidget( this._stringWidth, Style._safeLeft );
      
        this._selectable = true;

        return this;    
    };

    TextBlockTruncatedTestScreen.prototype.layout = function()
    {
        var y = Style._safeTop/1.8, h;
    
        for( var i = 0; i < this._textWidgets.length; i++ )
        {
            this._textWidgets[i].setVal( Widget.Y, y );
            this._rects      [i].setVal( Widget.Y, y );
        
            h = this._textWidgets[i].getVal( Widget.H );
        
            this._rects[i].setVal( Widget.H, h );
            
            y += h + 4 * Style._pad;
        }

        this._stringWidth.setVal( Widget.Y, y );
    };
    
    TextBlockTruncatedTestScreen.prototype.resourcesLoaded = function()
    {
        Widget.prototype.resourcesLoaded.call( this );

        this.layout();
    };

    TextBlockTruncatedTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                case Host.KEY_LEFT:
                    this._width -= 1;
                    this.updateWidth();
                    break;

                case Host.KEY_RIGHT:
                    this._width += 1;
                    this.updateWidth();
                    break;

                case Host.KEY_UP:
                    this._width -= this._deltaW;
                    this.updateWidth();
                    break;
                    
                case Host.KEY_DOWN:
                    this._width += this._deltaW;
                    this.updateWidth();
                    break;

                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    TextBlockTruncatedTestScreen.prototype.updateWidth = function()
    {
        if( this._width < this._minWidth )
            this._width = this._minWidth;
        else
        if( this._width > this._maxWidth )
            this._width = this._maxWidth;

        for( var i = 0; i < this._textWidgets.length; i++ )
        {
            this._rects      [i].setW( this._width );
            this._textWidgets[i].setW( this._width );
        }

        this._stringWidth.setText( "" + this._width );
    };

    return TextBlockTruncatedTestScreen;

})();



/***/ }),
/* 252 */
/***/ (function(module, exports) {

// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

window.TextLeadingTestScreen = ( function()
{
    "use strict";

    TextLeadingTestScreen.prototype = new Screen();

    function TextLeadingTestScreen(){}

    TextLeadingTestScreen.prototype.init = function()
    {
        var x, y, cx, dy;
        var headStyle, bodyStyle, infoStyle, descStyle;
        var fontSize;

        this._className = "TextLeadingTestScreen";
        Screen.prototype.init.call( this );

        fontSize = 27;
        this._size = fontSize;

        cx = _x2._config._screenW*0.5;
        dy = fontSize + 2;

        this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        this.addWidget( this._bg );

        headStyle = new Style( { font: "light", color: "#22AAFF", fontSize: _x2.scaleValInt( fontSize), whiteSpace:"nowrap" } );
        bodyStyle = new Style( { font: "light", color: "#e8e8e8", fontSize: _x2.scaleValInt( fontSize), whiteSpace:"nowrap" } );
        infoStyle = new Style( { font: "light", color: "#FFFF00", fontSize: _x2.scaleValInt( fontSize)                      } );

        this._text1 = new StringWidget().init( { text: "Abc...xyz", style: bodyStyle } ); // Requires whiteSpace: "nowrap" to measure
        this._text2 = new StringWidget().init( { text: "Abc...xyz", style: bodyStyle } );
        this._text3 = new StringWidget().init( { text: "Abc...xyz", style: bodyStyle } );

        this._head1 = new StringWidget().init( { text: "Font Size: ", style: headStyle } );
        this._head2 = new StringWidget().init( { text: "Leading..: ", style: headStyle } );
        this._head3 = new StringWidget().init( { text: "Width....: ", style: headStyle } );

        this._info1 = new StringWidget().init( { text: "?", style: infoStyle } );
        this._info2 = new StringWidget().init( { text: "?", style: infoStyle } );
        this._info3 = new StringWidget().init( { text: "?", style: infoStyle } );

        this._bbox1 = new RectWidget().init( { w:200, h:fontSize, color:"#222", borderThickness:1, borderColor: "#00FF00" } );



        x = Style._safeLeft;
        y = Style._safeTop;

        this.addWidget( this._bbox1, x, y );
        this.addWidget( this._text1, x, y ); y += dy;
        this.addWidget( this._text2, x, y ); y += dy;
        this.addWidget( this._text3, x, y );

        x = cx;
        y = Style._safeTop;
        this.addWidget( this._head1, x, y ); this.addWidget( this._info1, x, y ); y += dy;
        this.addWidget( this._head2, x, y ); this.addWidget( this._info2, x, y ); y += dy;
        this.addWidget( this._head3, x, y ); this.addWidget( this._info3, x, y );

        this._selectable = true;

        return this;
    };

    TextLeadingTestScreen.prototype.gotFocus = function()
    {
    };

    TextLeadingTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        if( type === Host.KEY_PRESSED )
            switch( val )
            {
                default:
                    retval = Screen.prototype.processEvent.call( this, val, type );
                    break;
            }

        return retval;
    };

    TextLeadingTestScreen.prototype.resourcesLoaded = function()
    {
        Widget.prototype.resourcesLoaded.call( this );

        var w, h;
        w = this._text1.getW(); this._bbox1.setW( w );
        h = this._text1.getH(); this._bbox1.setH( h );

        this._info1.setText( this._size );
        this._info2.setText( h );
        this._info3.setText( w );

        w = this._head1.getW(); this._head1.setX( this._head1.getX() - w - 2 );
        w = this._head2.getW(); this._head2.setX( this._head2.getX() - w - 2 );
        w = this._head3.getW(); this._head3.setX( this._head3.getX() - w - 2 );
    };

    return TextLeadingTestScreen;

})();



/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright (C) 2016 Comcast Corporation, All Rights Reserved



window.XtvDataTestScreen = ( function()
{
    XtvDataTestScreen.prototype = new Screen();

    function XtvDataTestScreen(){}

    XtvDataTestScreen.prototype.clearScreen = function ()
    {
        this._message.setVal(Widget.ALPHA, 0);

        for( var i=0; i<this._strings.length; i++ )
            this._strings[i].setText("");

        this._page = 0;
        this._allStrings = [];
    };

    XtvDataTestScreen.prototype.gotFocus = function()
    {
        this.setHighlight();
    };

    XtvDataTestScreen.prototype.init = function()
    {
        var i;
        var self = this;
        var menuStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:_x2.scaleValInt(33), whiteSpace:"nowrap" } );
        var outputStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:_x2.scaleValInt(33), whiteSpace:"nowrap" } );

        this._className = "XtvDataTestScreen";

        Screen.prototype.init.call( this );

        this._tests = [];
        this._tests.push( new StringWidget().init( { text:"Parental Controls",    style:menuStyle, onEnter:function(){ self.getParentalControls()     } } ) );
        this._tests.push( new StringWidget().init( { text:"Set PC Rating",        style:menuStyle, onEnter:function(){ self.setPcRating()             } } ) );
        this._tests.push( new StringWidget().init( { text:"Set PC Setting",       style:menuStyle, onEnter:function(){ self.setPcSetting()            } } ) );

        this._tests.push( new StringWidget().init( { text:"Resume Points",        style:menuStyle, onEnter:function(){ self.getResumePoints(30)       } } ) );
        this._tests.push( new StringWidget().init( { text:"VOD Root",             style:menuStyle, onEnter:function(){ self.getVod()                  } } ) );
        this._tests.push( new StringWidget().init( { text:"VOD Watched",          style:menuStyle, onEnter:function(){ self.getVodWatched()           } } ) );
        this._tests.push( new StringWidget().init( { text:"Recently Watched",     style:menuStyle, onEnter:function(){ self.getRecentlyWatched()      } } ) );
        this._tests.push( new StringWidget().init( { text:"Purchases",            style:menuStyle, onEnter:function(){ self.getPurchases()            } } ) );

        this._tests.push( new StringWidget().init( { text:"Recent Recordings",    style:menuStyle, onEnter:function(){ self.getRecentRecordings()     } } ) );
        this._tests.push( new StringWidget().init( { text:"Scheduled Recordings", style:menuStyle, onEnter:function(){ self.getScheduledRecordings()  } } ) );
        this._tests.push( new StringWidget().init( { text:"All Recordings ",      style:menuStyle, onEnter:function(){ self.getRecordingsByGroup()    } } ) );

        this._tests.push( new StringWidget().init( { text:"Get Channels",         style:menuStyle, onEnter:function(){ self.getChannels()             } } ) );
        this._tests.push( new StringWidget().init( { text:"Get Schedule Block",   style:menuStyle, onEnter:function(){ self.getScheduleBlock()        } } ) );

        this._tests.push( new StringWidget().init( { text:"Search",               style:menuStyle, onEnter:function(){ self.getSearchResult('ab')     } } ) );

        this._tests.push( new StringWidget().init( { text:"Get Entity",           style:menuStyle, onEnter:function(){ self.getEntity()               } } ) );
        this._tests.push( new StringWidget().init( { text:"MOLT",                 style:menuStyle, onEnter:function(){ self.getMolt()                 } } ) );

        this._tests.push( new StringWidget().init( { text:"Settings",             style:menuStyle, onEnter:function(){ self.testSettings()            } } ) );
        this._tests.push( new StringWidget().init( { text:"XACT to XSCT",         style:menuStyle, onEnter:function(){ self.xactToXsct()              } } ) );

        for( i = 0; i < this._tests.length; i++ )
            this.addWidget( this._tests[i], Style._safeLeft );

        //If I wanted to know how many lines I could fit on the screen? I need to add here, but can only measure in resourcesLoaded?

        this._allStrings = [];
        this._strings = [];
        for( i=0; i<20; i++ )
        {
            this._strings[i] = new StringWidget().init( {style:outputStyle, text:"Init"} );
            this.addWidget( this._strings[i], _x2._config._screenW * 0.30 );
        }

        this._index = 0;
        this._page = 0;

        this._message = new StringWidget().init({style:outputStyle, text:"Next [page dn] Prev [page up]"});
        this._message.setVal( Widget.ALPHA, 0);
        this.addWidget( this._message, _x2._config._screenW * 0.30, Style._pad * 5 );

        return this;
    };

    XtvDataTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED && (this._index < this._tests.length - 1) )
                {
                    this._index++;
                    this.setHighlight();
                    this.clearScreen();
                }
                break;

            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    this._tests[this._index].onEnter();
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && (this._index > 0 ) )
                {
                    this._index--;
                    this.setHighlight();
                    this.clearScreen();
                }
                break;

            case Host.KEY_PAGE_DN:
                if( type === Host.KEY_PRESSED )
                {
                    this._page ++ ;
                    this.setStrings();
                }
                break;

            case Host.KEY_PAGE_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._page > 0 )
                    {
                        this._page -- ;
                        this.setStrings();
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    XtvDataTestScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        var y = this.getHeaderBottom(), i;

        for( i = 0; i < this._tests.length; i++ )
        {
            this._tests[i].setVal( Widget.Y, y );
            y += this._tests[i].getVal( Widget.H ) + Style._pad;
        }

        y = this.getHeaderBottom();

        for( i = 0; i < this._strings.length; i++ )
        {
            this._strings[i].setVal( Widget.Y, y );
            y += this._strings[i].getVal( Widget.H ) + Style._pad;

            this._strings[i].setText("");
        }
    };

    XtvDataTestScreen.prototype.setHighlight = function()
    {
        var obj = this.getGlobalPos();

        obj.x       += this._tests[this._index].getVal( Widget.X );
        obj.y       += this._tests[this._index].getVal( Widget.Y );
        obj.w        = this._tests[this._index].getVal( Widget.W );
        obj.h        = this._tests[this._index].getVal( Widget.H );
        obj.inner    = false;
        obj.duration = 300;

        _x2._hi.setPosition( obj );
    };

    XtvDataTestScreen.prototype.setStrings = function ()
    {
        var start =  this._page      * this._strings.length;
        var end   = (this._page + 1) * this._strings.length - 1;
        var i;

        //clear all
        for( i=0; i<this._strings.length; i++ )
            this._strings[i].setText("");

        //set string widgets to display _allStrings[start] to _allStrings[end]
        for( i=0;i<this._strings.length; i++ )
        {
            this._strings[i].setText( this._allStrings[start] );
            start ++;
            if( start > end )
                break;
        }

        this._message.setVal(Widget.ALPHA, 1);
    };


    /** Test Methods **/

    XtvDataTestScreen.prototype.getChannels = function ()
    {
        var self = this;

        this._strings[0].setText("Getting channels...");

        var success = function()
        {
            var collection = _x2._channelCollection;
            self._channelCollection = collection;
            var channels = collection.getChannels();
            self.printChannels( channels );
        };

        var error = function(error )
        {
            console.log(error);
        };

        this._scheduleStart = Date.now();
        _x2._channelCollection.fetch( this._scheduleStart ).then( success ).catch( error );
    };

    XtvDataTestScreen.prototype.getEntity = function ()
    {
        var self = this;

        this._strings[0].setText("Getting entity...");

        _x2._data.getProgramEntity({programId:"5992010106256768112"}).then(
            function (entity)
            {
                self._allStrings.push(entity.getProgram().getTitle());
                self._allStrings.push(entity.getProgram().getDescription());
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getMolt = function()
    {
        var self = this;

        this._strings[0].setText("Getting MOLT...");

        _x2._data.getMoreLikeThis("5992010106256768112").then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getName() );
                }
                else
                    self._allStrings.push( "No MOLT found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getParentalControls = function ()
    {
        var self = this;

        this._strings[0].setText("Getting parental controls...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc = pc._data;
                for (var property in pc)
                {
                    if (pc.hasOwnProperty(property))
                        self._allStrings.push( property + ":" + pc[property] );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };


    XtvDataTestScreen.prototype.getPurchases = function()
    {
        var self = this;

        this._strings[0].setText("Getting Purchases...");

        _x2._data.getPurchases().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No purchases found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecentlyWatched = function()
    {
        var self = this;

        this._strings[0].setText("Getting Recently Watched...");

        _x2._data.getRecentlyWatched().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No recently watched found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecentRecordings = function ()
    {
        var self = this;

        this._strings[0].setText("Getting recent recordings...");

        _x2._data.getRecentRecordings().then(
            function (recordings)
            {
                for( var i=0; i<recordings.length; i++ )
                {
                    var props = [];
                    props.push(recordings[i].getChannel().getNumber() );
                    props.push(recordings[i].getTitle());
                    props.push(recordings[i].getRecordedOnDate());
                    self._allStrings.push( props.join(' - ') );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecordingsByGroup = function ()
    {
        var self = this;

        this._strings[0].setText("Getting grouped recordings...");

        _x2._data.getRecordingsByGroup().then(
            function (groups)
            {
                for( var i=0; i<groups.length; i++ )
                {
                    var groupName = groups[i].getName();
                    var recordings = groups[i].getRecordings();

                    if( recordings && recordings.length )
                    {
                        self._allStrings.push( groupName );

                        for( var q=0; q<recordings.length; q++ )
                        {
                            var props = [];
                            props.push(recordings[q].getChannel().getNumber() );
                            props.push(recordings[q].getTitle());
                            props.push(recordings[q].getRecordedOnDate());
                            self._allStrings.push( props.join(' - ') );
                        }
                    }
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getResumePoints = function( daysOld )
    {
        var self = this;

        this._strings[0].setText( "Getting resume points..." );

        _x2._data.getResumePoints( daysOld ).then(
            function( resumePoints )
            {
                for( var rp in resumePoints )
                {
                    if( resumePoints.hasOwnProperty( rp ) )
                        self._allStrings.push( resumePoints[rp].getPosition() + " - " + resumePoints[rp].getMediaId() );
                }
                self.setStrings( 0 );
            }
        ).catch(
            function( error )
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getListingDetail = function ()
    {
        var self = this;

        this._strings[0].setText("Getting listing detail...");

        _x2._data.getScheduleBlock(Date.now(),1).then(
            function (channels)
            {
                //get a random schedule from the grid
                var listing = channels[55].getListings()[0];

                _x2._data.getListingDetail(listing).then(
                    function (listing)
                    {
                        var listingData = listing._data
                        for (var property in listingData)
                        {
                            if (listingData.hasOwnProperty(property))
                                self._allStrings.push( property + ":" + listingData[property]);
                        }
                        self.setStrings(0);
                    }
                ).catch(
                    function (error)
                    {
                        self._strings[0].setText( error );
                    }
                )
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );

            }
        )
    };

    XtvDataTestScreen.prototype.setRecording = function ()
    {
        var self = this;

        this._strings[0].setText("Setting recording...");

        _x2._data.getScheduleBlock(Date.now(),1).then(
            function (channels)
            {
                //get a random schedule from the grid
                var listing = channels[55].getListings()[0];

                _x2._data.getListingDetail(listing).then(
                    function (listing)
                    {
                        _x2._data.setRecording( listing, false, {} ).then(
                            function (resp)
                            {
                                self._strings[0].setText( "Recording set!");
                            }
                        ).catch(
                            function (error)
                            {
                                self._strings[0].setText( "Error:" + error );
                            }
                        )
                    }
                ).catch(
                    function (error)
                    {
                        self._strings[0].setText( error );
                    }
                )
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );

            }
        )
    };

    XtvDataTestScreen.prototype.getScheduleBlock = function ()
    {
        var self = this;

        this._strings[0].setText("Getting schedule block...");

        //move start forward by 1 hour on each press
        this._scheduleStart += ( 240 * 60 * 1000 );

        var success = function( obj )
        {
            var startTime = obj.startTime;
            var channels = obj.channels;
            self.printChannels( channels );
        };

        var error = function( error )
        {
            console.log( error );
        };

        _x2._channelCollection.fetch( this._scheduleStart, this._scheduleStart + ( 180 * 60 * 1000), 0 ).then( success ).catch( error );
    };

    XtvDataTestScreen.prototype.printChannels = function( channels )
    {
        for( var i=0; i<channels.length; i++ )
        {
            var channel = channels[i];

            var props = [];
            props.push( "------" );
            props.push( channel.getNumber() );
            props.push( channel.getCallSign() );
            props.push( channel.getCompany() );
            props.push( "------" );
            this._allStrings.push( props.join( '-' ) );

            var schedules = channel.getSchedules();
            if( schedules )
            {
                for( var q=0; q<schedules.length; q++ )
                {
                    var lProps = [];
                    lProps.push( schedules[q].getTitle() );
                    lProps.push( "-" ) ;
                    lProps.push( schedules[q].getEntityId() );
                    lProps.push( ( new Date(schedules[q].getStartTime()).toLocaleTimeString() ) );
                    lProps.push( "-" ) ;
                    lProps.push( ( new Date(schedules[q].getEndTime()).toLocaleTimeString()) ) ;
                    this._allStrings.push( lProps.join(' ') );
                }
            }
        }
        this.setStrings(0);
    };

    XtvDataTestScreen.prototype.getScheduledRecordings = function()
    {
        var self = this;

        this._strings[0].setText("Getting Scheduled...");

        _x2._data.getScheduledRecordings().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No scheduled programs found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getSearchResult = function (string)
    {
        var self = this;

        this.clearScreen();
        this._strings[0].setText("Search...");

        _x2._data.search(string, 10).then(
            function (entities)
            {
                for( var i=0; i<entities.length; i++ )
                {
                    var props = [];
                    props.push( entities[i].getName() );
                    props.push( entities[i].getSubtitle() );
                    self._allStrings.push( props.join(' ') );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getVod = function ()
    {
        var self = this;

        this.clearScreen();
        this._strings[0].setText("Getting VOD...");

        _x2._data.getVodRoot().then(
            function (data)
            {
                var i, items = data.getEmbeddedBrowseItems();

                self._allStrings.push( items.length + " Items: ");

                for( i=0; i<items.length; i++ )
                    self._allStrings.push( items[i].getTitle() );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getVodWatched = function()
    {
        var self = this;

        this._strings[0].setText("Getting Watched...");

        _x2._data.getVodWatched().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No watched found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.setPcRating = function()
    {
        var self = this;

        this._strings[0].setText("Setting PC Rating...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc.setMovieRatingLock( ParentalControls.MpaaRatings.NC17, true ) ;

                _x2._data.setParentalControlsRatings( pc )
                   .then( function () { self._strings[0].setText( "Set NC-17 locked to true." ); } )
                   .catch( function (error) { self._strings[0].setText( "Error:" +  error ); } );
            }
        ).catch(function (error) { self._strings[0].setText( "Error:" +  error ); } );
    };

    XtvDataTestScreen.prototype.setPcSetting = function()
    {
        var self = this;

        this._strings[0].setText("Setting PC Setting...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc.setSafeBrowse( ParentalControls.SafeBrowse.HIGH );

                _x2._data.setParentalControlsSettings( pc )
                   .then( function () { self._strings[0].setText( "Set Safe Browse to HIGH" ); } )
                   .catch( function (error) { self._strings[0].setText( "Error:" +  error ); } );
            }
        ).catch(function (error) { self._strings[0].setText( "Error:" +  error ); } );
    };

    XtvDataTestScreen.prototype.testSettings = function()
    {
        //set random darkness level between 1 and 5, then get and display.
        var darkness = Math.floor(Math.random() * 5) + 1;
        _x2._settings.setValue(Settings.BG_DARKNESS, darkness);

        this._strings[0].setText("BG Darkness: " + _x2._settings.getValue(Settings.BG_DARKNESS));
    };

    XtvDataTestScreen.prototype.xactToXsct = function ()
    {
        var self = this;
        this._strings[0].setText("Getting XSCT Token...");

        var xact = "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxuczI6eGNhbC1hdXRoLW1lc3NhZ2UgeG1sbnM6bnMyPSJ1cm46Y2NwOmRldmlkOmRybSIgdmVyc2lvbj0iMyI%2BPGF0dHJpYnV0ZSBrZXk9Im1lc3NhZ2U6cHJvdGVjdGlvbiI%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%2BeGFjczwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6bG9jYXRpb25JcCI%2BODcuNjcuNS40NDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6Zmxhc2hBY2Nlc3M6bG9jYXRpb25JcCI%2BODcuNjcuNS40NDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJsb2NhdGlvbjpuZXQtaXAiPjg3LjY3LjUuNDQ8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0ibWVzc2FnZTppZCI%2BdHJhY2UtaWQ9ZGUxY2MyMjYtNzg2Ni00Y2I2LTkyN2MtNjY0N2VjYTM1N2ZjO3BhcmVudC1pZD0zMDg1NTIxNzIwOTg3MDQ3MTMwO3NwYW4taWQ9MzA4NTUyMTcyMDk4NzA0NzEzMDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6aWQiPjFXSzlLRkRNRkEwNDdDQjZCRDVSPC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImRldmljZTpmbGFzaEFjY2VzczppZCI%2BMVdLOUtGRE1GQTA0N0NCNkJENVI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZHJtOmZsYXNoQWNjZXNzOmRldmljZS1pZCI%2BMVdLOUtGRE1GQTA0N0NCNkJENVI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmNsYXNzIj5wY01hYzwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJzZXJ2aWNlOnhjYWw6cHJvZHVjdCI%2BY2R2cjwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJ4Y2FsOnByb2R1Y3QiPmNkdnI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iY2xpZW50OnNlc3Npb25LZXkiPlFqQ0NBUjhNQVRJWERURTJNVEF5TlRBNU1qVXdOMW9NQVRRRUVKWWx1WkoxQ1JVeVVvSDU2MW10RnFNTUFUVUVGQkltUmptZWp1a3hOcTNIajVWTjlzK3FpbE5hREFFMkJJR2RNSUdhREFFeERCQXhWMHRXVFUxVFJ6bE5NbE5VVUVSRERBRXlEQmxIWlc1bGNtRjBaV1JFWlhacFkyVkpaRlpsY25OcGIyNHhEQUV6REJReFYwczVTMFpFVFVaQk1EUTNRMEkyUWtRMVVnd0JOQXdGY0dOTllXTU1BVFVNQ21odFlXTlRhR0V5TlRZTUFUWUVNSGE2RkxzSld1SUlRQW9oUDNzclc5OTJvVWFDUlBRZXZnc0VqRDFtUVk4bFVJYitNY1g5UzVlZk1lMzNma0cxV2d3Qk53d1pZMjl0WTJGemRDMXdNREV0ZUdGamN5MHdNamN0WVcxMGJRd0JPQXdaWTI5dFkyRnpkQzF3TURFdGVHRmpjeTB3TWpZdFlXMTBaUT09PC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImFjY291bnQ6eGNhbDp0b2tlbklkIj56WFFmRlFyMU1Td1JSbndsN0Y5TWVkTll1WGs9PC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9InNlcnZpY2U6cHJvdmlkZXIiPnhjYWw8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0ic2VydmljZTpwcm92aWRlcnMiPnhjYWw8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmZsYXNoQWNjZXNzOmRldmljZS10eXBlIj5QQzwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6bW9kZWwiPlBDPC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImRldmljZTp0eXBlIj5JcENvYW08L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmNhdGVnb3J5Ij5NYWM8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOnByb3ZpZGVycyI%2BZmxhc2hBY2Nlc3M8L2F0dHJpYnV0ZT48L25zMjp4Y2FsLWF1dGgtbWVzc2FnZT4NCg%3D%3D";

        _x2._data.createDrmSession(xact).then(
            function (data)
            {
                var drmObj = JSON.parse(data);
                self._strings[0].setText(drmObj.xsct);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText(error);
            }
        )
    };

    return XtvDataTestScreen;

})();



/***/ })
/******/ ]);